import "./repo.c3fd958e.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire42de"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire42de"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cnCXJ", function(module, exports) {

$parcel$export(module.exports, "esc", () => $9035db219678c7c5$export$a1a11b095f88289a);
// Shared HTML-escape helper.
//
// Use esc() on EVERY user-supplied value that gets injected into the DOM via a
// template literal + innerHTML / insertAdjacentHTML. It is safe in both text
// content and quoted attribute values because it also escapes " and '.
//
// The browser decodes these entities back to the original characters when it
// parses the markup, so values later read via .value, .dataset, or FormData
// round-trip unchanged (e.g. a category named `A & B` stored as `A &amp; B`
// reads back as `A & B`). That means escaping never corrupts the stored data -
// it only neutralises markup so a malicious name like `<img onerror=...>` can
// never execute. This is stored-XSS defense: the same Supabase rows are also
// rendered by the admin panel, so an un-escaped name is a cross-surface risk.
const $9035db219678c7c5$export$a1a11b095f88289a = (v)=>String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
var $9035db219678c7c5$export$2e2bcd8739ae039 = $9035db219678c7c5$export$a1a11b095f88289a;

});

parcelRegister("coRoT", function(module, exports) {

$parcel$export(module.exports, "currencyForCountry", () => $9071262ce0caebc8$export$10bb3cc54ee85f4c);
$parcel$export(module.exports, "formatMoney", () => $9071262ce0caebc8$export$a17b3c2052469c69);
$parcel$export(module.exports, "formatMoneyCompact", () => $9071262ce0caebc8$export$bf4f1105535af5ca);
$parcel$export(module.exports, "currencySymbol", () => $9071262ce0caebc8$export$9068818d4d1af46a);
// Currency formatting, derived from the business's registered country (or an
// explicit override). Prices are stored as plain numbers everywhere - this is the
// single place that turns a number into a localized money string, so a US business
// shows "$1,250.00" and a PH business shows "₱1,250.00" off the same data.
//
// Resolution order for the active currency: explicit override
// (localStorage `pointbunny_currency`, set from businesses.settings.currency) ->
// else derived from the business country (`pointbunny_business_country`). Reading
// from localStorage means popups (KDS/CFD) and the main app all agree without
// threading state through every call site - same pattern as orderTypeLabel.
// Country -> ISO 4217 currency code. Keep in sync with COUNTRY_NAMES in
// countries.js and the onboarding country <select>.
const $9071262ce0caebc8$var$COUNTRY_CURRENCY = {
    US: 'USD',
    CA: 'CAD',
    GB: 'GBP',
    AU: 'AUD',
    NZ: 'NZD',
    PH: 'PHP',
    SG: 'SGD',
    MY: 'MYR',
    ID: 'IDR',
    TH: 'THB',
    VN: 'VND',
    IN: 'INR',
    JP: 'JPY',
    KR: 'KRW',
    CN: 'CNY',
    HK: 'HKD',
    TW: 'TWD',
    AE: 'AED',
    SA: 'SAR',
    NG: 'NGN',
    GH: 'GHS',
    KE: 'KES',
    ZA: 'ZAR',
    MX: 'MXN',
    BR: 'BRL',
    AR: 'ARS',
    CO: 'COP',
    DE: 'EUR',
    FR: 'EUR',
    ES: 'EUR',
    IT: 'EUR',
    NL: 'EUR',
    SE: 'SEK',
    NO: 'NOK',
    DK: 'DKK'
};
function $9071262ce0caebc8$export$10bb3cc54ee85f4c(country) {
    return $9071262ce0caebc8$var$COUNTRY_CURRENCY[String(country || '').toUpperCase()] || 'USD';
}
function $9071262ce0caebc8$export$72564c1d43fe4a6f() {
    let override = null, country = '';
    try {
        override = localStorage.getItem('pointbunny_currency');
        country = localStorage.getItem('pointbunny_business_country') || '';
    } catch (_) {}
    return override || $9071262ce0caebc8$export$10bb3cc54ee85f4c(country);
}
// Cache of Intl formatters keyed by currency code (cheap reuse).
const $9071262ce0caebc8$var$_fmtCache = {};
function $9071262ce0caebc8$var$_intl(code) {
    if (!$9071262ce0caebc8$var$_fmtCache[code]) // en-US locale gives comma grouping + symbol-first, matching our markets
    // (US/PH/UK/AU/NZ/CA). `currency` drives the symbol + correct decimal count
    // (e.g. JPY/KRW = 0 decimals) automatically.
    $9071262ce0caebc8$var$_fmtCache[code] = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: code
    });
    return $9071262ce0caebc8$var$_fmtCache[code];
}
// How many fraction digits this currency uses (2 for USD/PHP, 0 for JPY, etc.).
function $9071262ce0caebc8$var$_decimals(code) {
    try {
        return $9071262ce0caebc8$var$_intl(code).resolvedOptions().maximumFractionDigits;
    } catch (_) {
        return 2;
    }
}
function $9071262ce0caebc8$export$a17b3c2052469c69(n, { code: code = $9071262ce0caebc8$export$72564c1d43fe4a6f(), ascii: ascii = false } = {}) {
    const value = Number(n) || 0;
    if (ascii) {
        const d = $9071262ce0caebc8$var$_decimals(code);
        const num = value.toLocaleString('en-US', {
            minimumFractionDigits: d,
            maximumFractionDigits: d
        });
        return `${code} ${num}`;
    }
    try {
        return $9071262ce0caebc8$var$_intl(code).format(value);
    } catch (_) {
        return '$' + value.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
}
function $9071262ce0caebc8$export$bf4f1105535af5ca(n, { code: code = $9071262ce0caebc8$export$72564c1d43fe4a6f() } = {}) {
    const value = Number(n) || 0;
    if (Math.abs(value) < 100000) return $9071262ce0caebc8$export$a17b3c2052469c69(value, {
        code: code
    });
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: code,
            notation: 'compact',
            maximumFractionDigits: 2
        }).format(value);
    } catch (_) {
        return $9071262ce0caebc8$export$a17b3c2052469c69(value, {
            code: code
        });
    }
}
function $9071262ce0caebc8$export$9068818d4d1af46a(code = $9071262ce0caebc8$export$72564c1d43fe4a6f()) {
    try {
        const part = $9071262ce0caebc8$var$_intl(code).formatToParts(0).find((p)=>p.type === 'currency');
        return part?.value || '$';
    } catch (_) {
        return '$';
    }
}

});

parcelRegister("asfCf", function(module, exports) {

$parcel$export(module.exports, "supabaseUrl", () => $79c8a1e5ed0c7218$export$f20dac375bb4e5e);
$parcel$export(module.exports, "supabaseAnonKey", () => $79c8a1e5ed0c7218$export$58b38f264695747d);
$parcel$export(module.exports, "supabase", () => $79c8a1e5ed0c7218$export$a0b632a28672d3c0);

var $dNnfS = parcelRequire("dNnfS");
const $79c8a1e5ed0c7218$export$f20dac375bb4e5e = "https://xrbuqwwgqwuelnqapdvj.supabase.co";
const $79c8a1e5ed0c7218$export$58b38f264695747d = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhyYnVxd3dncXd1ZWxucWFwZHZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc3Njk2ODYsImV4cCI6MjA5MzM0NTY4Nn0.VNtnvGu8TGDx2P2rXmIuBZ8Xz3gFP0ct_64FWEaKioU";
const $79c8a1e5ed0c7218$export$a0b632a28672d3c0 = (0, $dNnfS.createClient)($79c8a1e5ed0c7218$export$f20dac375bb4e5e, $79c8a1e5ed0c7218$export$58b38f264695747d); // NOTE: password reset no longer runs through this client / the main app. It has its
 // own standalone page (reset.html) backed by the PKCE `resetClient` (see
 // Javascript/resetClient.js + Javascript/reset.js). That removed the five recovery
 // workarounds that used to live here and in controller.js / authView.js.

});

parcelRegister("1tYOa", function(module, exports) {

$parcel$export(module.exports, "resetClient", () => $1147ab19b4479f5e$export$e1bcf2402520f587);

var $dNnfS = parcelRequire("dNnfS");
const $1147ab19b4479f5e$export$e1bcf2402520f587 = (0, $dNnfS.createClient)("https://xrbuqwwgqwuelnqapdvj.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhyYnVxd3dncXd1ZWxucWFwZHZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc3Njk2ODYsImV4cCI6MjA5MzM0NTY4Nn0.VNtnvGu8TGDx2P2rXmIuBZ8Xz3gFP0ct_64FWEaKioU", {
    auth: {
        flowType: 'pkce',
        storageKey: 'pb-reset-auth',
        detectSessionInUrl: true,
        persistSession: true,
        autoRefreshToken: false
    }
});

});

parcelRegister("dv0h8", function(module, exports) {

$parcel$export(module.exports, "stripNonDigits", () => $9d3e6246d048f6a8$export$df49c36bf437e512);
$parcel$export(module.exports, "stripNonNameChars", () => $9d3e6246d048f6a8$export$59954b40cbbb2714);
$parcel$export(module.exports, "stripNonEmailChars", () => $9d3e6246d048f6a8$export$600d703287dc0317);
$parcel$export(module.exports, "normalizePhone", () => $9d3e6246d048f6a8$export$e9b617754cf28d84);
$parcel$export(module.exports, "formatPhone", () => $9d3e6246d048f6a8$export$10c09b2cff9813eb);
$parcel$export(module.exports, "computeStreak", () => $9d3e6246d048f6a8$export$d4ff4379a6fd6350);
$parcel$export(module.exports, "computeAllStreaks", () => $9d3e6246d048f6a8$export$a091f94b00640c8e);
$parcel$export(module.exports, "formatBirthday", () => $9d3e6246d048f6a8$export$c8f5f1b0904755a8);
$parcel$export(module.exports, "isBirthdayToday", () => $9d3e6246d048f6a8$export$109465919cfc0345);
$parcel$export(module.exports, "redeemedRewardLineIds", () => $9d3e6246d048f6a8$export$f3b731d48114bbf3);
// Loyalty helpers - pure functions only (no DOM, no Supabase) so both the
// controller and any future popup/test code can import them.
// Input sanitizers shared by the panel form and the checkout fields.
// Phone fields accept digits ONLY; name fields accept letters (any language,
// incl. accents) plus spaces, hyphens, apostrophes, and periods - no digits
// or other symbols.
const $9d3e6246d048f6a8$export$df49c36bf437e512 = (s)=>String(s ?? "").replace(/\D/g, "");
const $9d3e6246d048f6a8$export$59954b40cbbb2714 = (s)=>String(s ?? "").replace(/[^\p{L}\p{M}\s'.-]/gu, "");
const $9d3e6246d048f6a8$export$600d703287dc0317 = (s)=>String(s ?? "").replace(/[^A-Za-z0-9@._%+-]/g, "");
const $9d3e6246d048f6a8$export$e9b617754cf28d84 = function(raw) {
    const digits = String(raw ?? "").replace(/\D/g, "");
    if (digits.length < 7 || digits.length > 15) return null;
    return digits;
};
const $9d3e6246d048f6a8$export$10c09b2cff9813eb = function(digits) {
    const d = String(digits ?? "");
    if (d.length === 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
    if (d.length === 11 && d.startsWith("1")) return `+1 (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
    return d;
};
const $9d3e6246d048f6a8$export$1b9ec68858580e07 = function(isoTs, tz) {
    return new Intl.DateTimeFormat("sv-SE", {
        timeZone: tz
    }).format(new Date(isoTs));
};
const $9d3e6246d048f6a8$export$1c909ebeb219bebc = function(dateKey) {
    const [y, m, d] = dateKey.split("-").map(Number);
    const date = new Date(Date.UTC(y, m - 1, d));
    const dayNum = date.getUTCDay() || 7; // Mon=1 ... Sun=7
    date.setUTCDate(date.getUTCDate() + 4 - dayNum); // nearest Thursday
    const isoYear = date.getUTCFullYear();
    const yearStart = new Date(Date.UTC(isoYear, 0, 1));
    const week = Math.ceil(((date - yearStart) / 86400000 + 1) / 7);
    return `${isoYear}-W${String(week).padStart(2, "0")}`;
};
const $9d3e6246d048f6a8$export$fbc33432e385d43a = function(dateKey) {
    return dateKey.slice(0, 7);
};
// Step a "YYYY-MM-DD" date key back one day (UTC math on the key itself, so
// timezone conversion happens exactly once, in localDateKey).
const $9d3e6246d048f6a8$var$_prevDayKey = function(dateKey) {
    const [y, m, d] = dateKey.split("-").map(Number);
    const date = new Date(Date.UTC(y, m - 1, d));
    date.setUTCDate(date.getUTCDate() - 1);
    return date.toISOString().slice(0, 10);
};
// Step an ISO-week key back one week.
const $9d3e6246d048f6a8$var$_prevWeekKey = function(wk) {
    const [y, w] = wk.split("-W").map(Number);
    // Convert back to a date inside that week (Thursday of week w) and subtract 7 days.
    const jan4 = new Date(Date.UTC(y, 0, 4));
    const jan4Day = jan4.getUTCDay() || 7;
    const week1Monday = new Date(jan4);
    week1Monday.setUTCDate(jan4.getUTCDate() - jan4Day + 1);
    const thursday = new Date(week1Monday);
    thursday.setUTCDate(week1Monday.getUTCDate() + (w - 1) * 7 + 3);
    thursday.setUTCDate(thursday.getUTCDate() - 7);
    return $9d3e6246d048f6a8$export$1c909ebeb219bebc(thursday.toISOString().slice(0, 10));
};
// Step a "YYYY-MM" month key back one month.
const $9d3e6246d048f6a8$var$_prevMonthKey = function(mk) {
    const [y, m] = mk.split("-").map(Number);
    const prevY = m === 1 ? y - 1 : y;
    const prevM = m === 1 ? 12 : m - 1;
    return `${prevY}-${String(prevM).padStart(2, "0")}`;
};
const $9d3e6246d048f6a8$export$d4ff4379a6fd6350 = function(saleDates, unit = "day", tz, now = new Date()) {
    const timeZone = tz || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const dayKeys = [
        ...new Set((saleDates ?? []).map((ts)=>$9d3e6246d048f6a8$export$1b9ec68858580e07(ts, timeZone)))
    ].sort().reverse();
    if (dayKeys.length === 0) return {
        current: 0,
        best: 0,
        lastKey: null,
        dateKeys: []
    };
    const toUnit = unit === "week" ? $9d3e6246d048f6a8$export$1c909ebeb219bebc : unit === "month" ? $9d3e6246d048f6a8$export$fbc33432e385d43a : (k)=>k;
    const prevUnit = unit === "week" ? $9d3e6246d048f6a8$var$_prevWeekKey : unit === "month" ? $9d3e6246d048f6a8$var$_prevMonthKey : $9d3e6246d048f6a8$var$_prevDayKey;
    const unitKeys = [
        ...new Set(dayKeys.map(toUnit))
    ]; // newest first (dayKeys already sorted)
    // Walk all runs of consecutive units to find the best streak, tracking the
    // newest run separately.
    let best = 1;
    let run = 1;
    let newestRun = 1;
    for(let i = 1; i < unitKeys.length; i++){
        if (unitKeys[i] === prevUnit(unitKeys[i - 1])) run += 1;
        else run = 1;
        if (run > best) best = run;
        if (run === i + 1) newestRun = run; // still contiguous from the newest unit
    }
    const nowUnit = toUnit($9d3e6246d048f6a8$export$1b9ec68858580e07(now.toISOString(), timeZone));
    const alive = unitKeys[0] === nowUnit || unitKeys[0] === prevUnit(nowUnit);
    return {
        current: alive ? newestRun : 0,
        best: best,
        lastKey: unitKeys[0],
        dateKeys: dayKeys
    };
};
const $9d3e6246d048f6a8$export$a091f94b00640c8e = function(saleDates, tz, now = new Date()) {
    return {
        day: $9d3e6246d048f6a8$export$d4ff4379a6fd6350(saleDates, "day", tz, now),
        week: $9d3e6246d048f6a8$export$d4ff4379a6fd6350(saleDates, "week", tz, now),
        month: $9d3e6246d048f6a8$export$d4ff4379a6fd6350(saleDates, "month", tz, now)
    };
};
const $9d3e6246d048f6a8$var$MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $9d3e6246d048f6a8$export$c8f5f1b0904755a8 = function(month, day) {
    if (!month || !day) return null;
    return `${$9d3e6246d048f6a8$var$MONTH_NAMES[month - 1]} ${day}`;
};
const $9d3e6246d048f6a8$export$109465919cfc0345 = function(month, day, tz, now = new Date()) {
    if (!month || !day) return false;
    const timeZone = tz || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [, m, d] = $9d3e6246d048f6a8$export$1b9ec68858580e07(now.toISOString(), timeZone).split("-").map(Number);
    return m === month && d === day;
};
const $9d3e6246d048f6a8$export$f3b731d48114bbf3 = function(adjustments) {
    return new Set((adjustments ?? []).filter((a)=>!a.removed && a.source === "loyalty_reward").map((a)=>a.cartItemLineId));
};

});

parcelRegister("5ni8Y", function(module, exports) {

$parcel$export(module.exports, "loadKitchenQueue", () => $3e9d2cb58dbc21e5$export$f0cecc109ae5f267);
$parcel$export(module.exports, "ticketToQueueItem", () => $3e9d2cb58dbc21e5$export$47c77f2842283436);
$parcel$export(module.exports, "setQueueItemState", () => $3e9d2cb58dbc21e5$export$d7a5a19b62c11de1);
// The active order queue (2026-10-22): today's unprepared sales plus kitchen
// tickets sent from open table tabs. Shared by the main app (model.js) and the
// Queue Screen popup (kds-display.js), so both load and update it the same way.
// Ticket queue ids are "kt-<uuid>" so any window can tell a ticket from a sale
// by its id alone (broadcasts carry only ids).

var $lDSCx = parcelRequire("lDSCx");
const $3e9d2cb58dbc21e5$export$2ace7bd2682bae8 = 'kt-';
const $3e9d2cb58dbc21e5$export$cebc43bed1573d05 = (id)=>typeof id === 'string' && id.startsWith($3e9d2cb58dbc21e5$export$2ace7bd2682bae8);
// "Today" on the BUSINESS's calendar. The main app passes its timezone and
// caches it for the Queue Screen popup, which reads it back from localStorage.
const $3e9d2cb58dbc21e5$var$TZ_KEY = 'pointbunny_business_tz';
const $3e9d2cb58dbc21e5$var$todayBounds = (tz)=>{
    if (tz) try {
        localStorage.setItem($3e9d2cb58dbc21e5$var$TZ_KEY, tz);
    } catch  {}
    let zone = tz;
    if (!zone) try {
        zone = localStorage.getItem($3e9d2cb58dbc21e5$var$TZ_KEY);
    } catch  {
        zone = null;
    }
    zone = zone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const day = (0, $lDSCx.todayIn)(zone);
    return {
        start: (0, $lDSCx.zonedToDate)(day, '00:00', zone).toISOString(),
        end: new Date((0, $lDSCx.zonedToDate)((0, $lDSCx.addDays)(day, 1), '00:00', zone).getTime() - 1).toISOString()
    };
};
const $3e9d2cb58dbc21e5$export$f0cecc109ae5f267 = async function(supabase, businessId, tz = null) {
    const { start: start, end: end } = $3e9d2cb58dbc21e5$var$todayBounds(tz);
    const [sales, tickets] = await Promise.all([
        supabase.from('sales').select('id, sale_date, items, total_price, order_type, ticket_number, ready_at, table_name').eq('user_id', businessId).gte('sale_date', start).lte('sale_date', end).is('prepared_at', null).is('voided_at', null).order('sale_date', {
            ascending: true
        }),
        // Tolerates the tables migration not being run yet (no table = no tickets).
        supabase.from('kitchen_tickets').select('id, tab_id, sent_at, items, table_name, ready_at').eq('business_id', businessId).gte('sent_at', start).is('prepared_at', null).order('sent_at', {
            ascending: true
        })
    ]);
    if (sales.error) throw sales.error;
    const fromSales = sales.data.map((row)=>({
            id: row.id,
            saleDate: row.sale_date,
            items: row.items,
            startedAt: new Date(row.sale_date).getTime(),
            totalPrice: Number(row.total_price),
            orderType: row.order_type ?? 'dine-in',
            ticketNumber: row.ticket_number ?? null,
            tableName: row.table_name ?? null,
            readyAt: row.ready_at ? new Date(row.ready_at).getTime() : null
        }));
    const fromTickets = (tickets.error ? [] : tickets.data).map($3e9d2cb58dbc21e5$export$47c77f2842283436);
    return [
        ...fromSales,
        ...fromTickets
    ].sort((a, b)=>a.startedAt - b.startedAt);
};
const $3e9d2cb58dbc21e5$export$47c77f2842283436 = (row)=>({
        id: $3e9d2cb58dbc21e5$export$2ace7bd2682bae8 + row.id,
        saleDate: row.sent_at,
        items: row.items ?? [],
        startedAt: new Date(row.sent_at).getTime(),
        totalPrice: 0,
        orderType: 'dine-in',
        ticketNumber: null,
        tableName: row.table_name ?? null,
        fromTab: true,
        tabId: row.tab_id ?? null,
        readyAt: row.ready_at ? new Date(row.ready_at).getTime() : null
    });
const $3e9d2cb58dbc21e5$export$d7a5a19b62c11de1 = async function(supabase, businessId, id, patch) {
    const q = $3e9d2cb58dbc21e5$export$cebc43bed1573d05(id) ? supabase.from('kitchen_tickets').update(patch).eq('id', id.slice($3e9d2cb58dbc21e5$export$2ace7bd2682bae8.length)).eq('business_id', businessId) : supabase.from('sales').update(patch).eq('id', id).eq('user_id', businessId);
    const { error: error } = await q;
    if (error) throw error;
};

});
parcelRegister("lDSCx", function(module, exports) {

$parcel$export(module.exports, "zonedParts", () => $fc179c06d563947e$export$30a795a5426c3ea3);
$parcel$export(module.exports, "zonedToDate", () => $fc179c06d563947e$export$83aac07b4c37b25);
$parcel$export(module.exports, "addDays", () => $fc179c06d563947e$export$dd412b56f1e4d8aa);
$parcel$export(module.exports, "weekdayIndex", () => $fc179c06d563947e$export$32ef541cbd1ebdda);
$parcel$export(module.exports, "mondayOf", () => $fc179c06d563947e$export$7687f1454b49eb41);
$parcel$export(module.exports, "todayIn", () => $fc179c06d563947e$export$900e9be76d954029);
$parcel$export(module.exports, "WEEKDAYS", () => $fc179c06d563947e$export$ecc24ef5795d74f8);
$parcel$export(module.exports, "dayNum", () => $fc179c06d563947e$export$2d24217f744cffb0);
$parcel$export(module.exports, "weekLabel", () => $fc179c06d563947e$export$304d353c7b75a1a4);
$parcel$export(module.exports, "dayLabel", () => $fc179c06d563947e$export$fed04f446fd15195);
$parcel$export(module.exports, "shortTime", () => $fc179c06d563947e$export$3e5eb6a50dd39398);
$parcel$export(module.exports, "hoursBetween", () => $fc179c06d563947e$export$bedc2b5a8ca274fa);
$parcel$export(module.exports, "fmtHours", () => $fc179c06d563947e$export$46189e829713bfe6);
$parcel$export(module.exports, "clockShort", () => $fc179c06d563947e$export$ebcd0a594916d7ea);
$parcel$export(module.exports, "fitsWindow", () => $fc179c06d563947e$export$1a05770a0144a7d7);
$parcel$export(module.exports, "setBusinessZone", () => $fc179c06d563947e$export$d1dc431e16d2617f);
$parcel$export(module.exports, "businessToday", () => $fc179c06d563947e$export$ebbe2b1f48ccb4e8);
$parcel$export(module.exports, "bizFormat", () => $fc179c06d563947e$export$545ba92854106f31);
// Shift-schedule time helpers (2026-10-15). A schedule is planned in the
// BUSINESS's timezone (state.businessTimezone), whatever the device's own zone,
// so "Mon 6:30a" means 6:30 at the cafe. Shifts are stored as timestamptz.
// Calendar days here are plain "YYYY-MM-DD" strings (never `new Date(str)`,
// which would be midnight UTC - see CLAUDE.md "Calendar dates vs timestamps").
// Shared by the POS (controller / scheduleView) and the Time Clock.
const $fc179c06d563947e$var$pad = (n)=>String(n).padStart(2, "0");
function $fc179c06d563947e$export$30a795a5426c3ea3(date, tz) {
    const parts = {};
    new Intl.DateTimeFormat("en-US", {
        timeZone: tz,
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        weekday: "short"
    }).formatToParts(date).forEach((p)=>{
        parts[p.type] = p.value;
    });
    return {
        y: +parts.year,
        m: +parts.month,
        d: +parts.day,
        h: +parts.hour,
        mi: +parts.minute,
        dateStr: `${parts.year}-${parts.month}-${parts.day}`,
        timeStr: `${parts.hour}:${parts.minute}`
    };
}
const $fc179c06d563947e$var$offsetMs = (utcMs, tz)=>{
    const p = $fc179c06d563947e$export$30a795a5426c3ea3(new Date(utcMs), tz);
    return Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi) - Math.floor(utcMs / 60000) * 60000;
};
function $fc179c06d563947e$export$83aac07b4c37b25(dateStr, timeStr, tz) {
    const [y, m, d] = dateStr.split("-").map(Number);
    const [h, mi] = timeStr.split(":").map(Number);
    const guess = Date.UTC(y, m - 1, d, h, mi);
    let ms = guess - $fc179c06d563947e$var$offsetMs(guess, tz);
    ms = guess - $fc179c06d563947e$var$offsetMs(ms, tz); // second pass lands on the right side of a DST change
    return new Date(ms);
}
function $fc179c06d563947e$export$dd412b56f1e4d8aa(dateStr, n) {
    const [y, m, d] = dateStr.split("-").map(Number);
    const dt = new Date(Date.UTC(y, m - 1, d + n));
    return `${dt.getUTCFullYear()}-${$fc179c06d563947e$var$pad(dt.getUTCMonth() + 1)}-${$fc179c06d563947e$var$pad(dt.getUTCDate())}`;
}
function $fc179c06d563947e$export$32ef541cbd1ebdda(dateStr) {
    const [y, m, d] = dateStr.split("-").map(Number);
    return (new Date(Date.UTC(y, m - 1, d)).getUTCDay() + 6) % 7;
}
function $fc179c06d563947e$export$7687f1454b49eb41(dateStr) {
    return $fc179c06d563947e$export$dd412b56f1e4d8aa(dateStr, -$fc179c06d563947e$export$32ef541cbd1ebdda(dateStr));
}
function $fc179c06d563947e$export$900e9be76d954029(tz) {
    return $fc179c06d563947e$export$30a795a5426c3ea3(new Date(), tz).dateStr;
}
const $fc179c06d563947e$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $fc179c06d563947e$export$ecc24ef5795d74f8 = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
function $fc179c06d563947e$export$2d24217f744cffb0(dateStr) {
    return +dateStr.slice(8, 10);
}
function $fc179c06d563947e$export$304d353c7b75a1a4(monday) {
    const sunday = $fc179c06d563947e$export$dd412b56f1e4d8aa(monday, 6);
    const [, m1] = monday.split("-").map(Number);
    const [, m2] = sunday.split("-").map(Number);
    return m1 === m2 ? `${$fc179c06d563947e$var$MONTHS[m1 - 1]} ${$fc179c06d563947e$export$2d24217f744cffb0(monday)} \u{2013} ${$fc179c06d563947e$export$2d24217f744cffb0(sunday)}` : `${$fc179c06d563947e$var$MONTHS[m1 - 1]} ${$fc179c06d563947e$export$2d24217f744cffb0(monday)} \u{2013} ${$fc179c06d563947e$var$MONTHS[m2 - 1]} ${$fc179c06d563947e$export$2d24217f744cffb0(sunday)}`;
}
function $fc179c06d563947e$export$fed04f446fd15195(dateStr) {
    return `${$fc179c06d563947e$export$ecc24ef5795d74f8[$fc179c06d563947e$export$32ef541cbd1ebdda(dateStr)]} ${$fc179c06d563947e$var$MONTHS[+dateStr.slice(5, 7) - 1]} ${$fc179c06d563947e$export$2d24217f744cffb0(dateStr)}`;
}
function $fc179c06d563947e$export$3e5eb6a50dd39398(date, tz) {
    const { h: h, mi: mi } = $fc179c06d563947e$export$30a795a5426c3ea3(date, tz);
    const suffix = h < 12 ? "a" : "p";
    const h12 = h % 12 || 12;
    return mi ? `${h12}:${$fc179c06d563947e$var$pad(mi)}${suffix}` : `${h12}${suffix}`;
}
function $fc179c06d563947e$export$bedc2b5a8ca274fa(start, end) {
    return (new Date(end) - new Date(start)) / 3600000;
}
function $fc179c06d563947e$export$46189e829713bfe6(h) {
    const r = Math.round(h * 100) / 100;
    return `${Number.isInteger(r) ? r : r.toFixed(r * 10 % 1 ? 2 : 1)}h`;
}
// ── Wall-clock "HH:MM" times (availability windows, 2026-10-17) ──
const $fc179c06d563947e$var$toMin = (t)=>{
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m;
};
function $fc179c06d563947e$export$ebcd0a594916d7ea(t) {
    const m = $fc179c06d563947e$var$toMin(t), h = Math.floor(m / 60) % 24, mi = m % 60;
    return `${h % 12 || 12}${mi ? `:${$fc179c06d563947e$var$pad(mi)}` : ""}${h < 12 ? "a" : "p"}`;
}
function $fc179c06d563947e$export$1a05770a0144a7d7(winStart, winEnd, start, end) {
    const ws = $fc179c06d563947e$var$toMin(winStart), we = $fc179c06d563947e$var$toMin(winEnd) + ($fc179c06d563947e$var$toMin(winEnd) <= ws ? 1440 : 0);
    const s = $fc179c06d563947e$var$toMin(start), e = $fc179c06d563947e$var$toMin(end) + ($fc179c06d563947e$var$toMin(end) <= s ? 1440 : 0);
    return s >= ws && e <= we || s + 1440 >= ws && e + 1440 <= we;
}
// The business's zone for views that can't ask the model (2026-10-25). The controller sets it
// at login (setBusinessZone(model.businessTz())); until then the device's zone is used.
// Use these instead of `new Date()` local parts when a screen means "the cafe's today".
let $fc179c06d563947e$var$_businessZone = null;
function $fc179c06d563947e$export$d1dc431e16d2617f(tz) {
    $fc179c06d563947e$var$_businessZone = tz || null;
}
function $fc179c06d563947e$export$b9b41b4887916e49() {
    return $fc179c06d563947e$var$_businessZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function $fc179c06d563947e$export$ebbe2b1f48ccb4e8() {
    return $fc179c06d563947e$export$900e9be76d954029($fc179c06d563947e$export$b9b41b4887916e49());
}
function $fc179c06d563947e$export$545ba92854106f31(date, opts) {
    return new Date(date).toLocaleString("en-US", {
        ...opts,
        timeZone: $fc179c06d563947e$export$b9b41b4887916e49()
    });
}

});


parcelRegister("jx1FN", function(module, exports) {
// App-wide live input character filtering. Self-initializes on import (same
// pattern as tooltip.js / modalBackdrop.js): ONE delegated document listener,
// so dynamically injected forms (staff invite, loyalty modals, auth panels)
// are covered automatically. Disallowed characters are stripped as they're
// typed or pasted, with the caret kept where the user expects it.
//
// What gets filtered:
// - input[type="tel"]   -> digits only. EXCEPT inputs inside an intl-tel-input
//   wrapper (.iti) - that widget formats with +, spaces and dashes itself
//   (business phone in Settings, onboarding phone).
// - input[type="email"] -> the practical email charset (letters, digits,
//   @ . _ % + -).
// - Person-name fields (known ids below, or any input with
//   data-filter="name") -> letters in any language plus spaces, hyphens,
//   apostrophes, and periods. Deliberately NOT applied to business/item/role
//   names - those legitimately contain digits ("7-Eleven", "Size 12").

var $dv0h8 = parcelRequire("dv0h8");
const $e382659e8788c510$var$NAME_FIELD_IDS = new Set([
    "settingsProfileFirstName",
    "settingsProfileLastName",
    "signUpFirstName",
    "signUpLastName",
    "inviteFirstName",
    "inviteLastName"
]);
const $e382659e8788c510$var$_stripFor = function(el) {
    if (el.dataset?.filter === "name" || $e382659e8788c510$var$NAME_FIELD_IDS.has(el.id)) return 0, $dv0h8.stripNonNameChars;
    if (el.type === "tel" && !el.closest(".iti")) return 0, $dv0h8.stripNonDigits;
    if (el.type === "email") return 0, $dv0h8.stripNonEmailChars;
    return null;
};
document.addEventListener("input", (e)=>{
    const el = e.target;
    if (!(el instanceof HTMLInputElement)) return;
    const strip = $e382659e8788c510$var$_stripFor(el);
    if (!strip) return;
    const clean = strip(el.value);
    if (clean === el.value) return;
    // Caret position = how many kept characters precede it (selectionStart is
    // null on some input types - fall back to end-of-value).
    const caretKept = strip(el.value.slice(0, el.selectionStart ?? el.value.length)).length;
    el.value = clean;
    try {
        el.setSelectionRange(caretKept, caretKept);
    } catch  {} // unsupported on some types
});

});

parcelRegister("3kKUy", function(module, exports) {

$parcel$export(module.exports, "captchaEnabled", () => $26d7a0f3316320e2$export$f4e0ccd8d39e9019);
$parcel$export(module.exports, "renderCaptcha", () => $26d7a0f3316320e2$export$b3907d9379744981);
$parcel$export(module.exports, "getToken", () => $26d7a0f3316320e2$export$257b2d10b709d8ef);
$parcel$export(module.exports, "resetCaptcha", () => $26d7a0f3316320e2$export$2b8fcaee65c058ce);
$parcel$export(module.exports, "getTokenInteractive", () => $26d7a0f3316320e2$export$fb9c4d9ba2c9db2a);
// Cloudflare Turnstile — anti-bot CAPTCHA for the UNAUTHENTICATED auth forms only
// (sign up, forgot password, and sign in). It guards the email-sending surfaces so a
// bot flood can't burn our Resend quota or get the pointbunny.com sending domain flagged.
//
// The token is verified SERVER-SIDE by Supabase Auth (we pass `options.captchaToken`
// to signUp / signInWithPassword / resetPasswordForEmail). A client-only check would be
// trivially bypassable, so Supabase's native CAPTCHA support is the real gate - this
// module only renders the widget and hands the token to the controller.
//
// Config: the PUBLIC site key comes from `process.env.TURNSTILE_SITE_KEY` (Parcel inlines
// it at build time, same as the Supabase keys). The matching SECRET key is pasted into
// Supabase -> Authentication -> Settings, NEVER shipped to the client.
//
// Graceful no-op when unconfigured: if the site key is blank (Kelly hasn't created the
// Cloudflare keys yet), `captchaEnabled()` is false, no widget renders, no script loads,
// and the auth forms work exactly as before. Turn it on by setting TURNSTILE_SITE_KEY
// AND enabling CAPTCHA in Supabase at the same time (otherwise the two sides disagree).
//
// Cloudflare test keys (always pass / always block) for local dev:
//   site `1x00000000000000000000AA` + secret `1x0000000000000000000000000000000AA` => always passes
//   site `2x00000000000000000000AB` + secret `2x0000000000000000000000000000000AA` => always blocks
const $26d7a0f3316320e2$var$SITE_KEY = "0x4AAAAAADsVcnzkssEFQ1oB";
const $26d7a0f3316320e2$var$SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let $26d7a0f3316320e2$var$_scriptPromise = null;
const $26d7a0f3316320e2$var$_widgets = new Map(); // containerId -> Turnstile widget id
const $26d7a0f3316320e2$export$f4e0ccd8d39e9019 = ()=>Boolean($26d7a0f3316320e2$var$SITE_KEY);
function $26d7a0f3316320e2$var$_loadScript() {
    if (!$26d7a0f3316320e2$var$SITE_KEY) return Promise.resolve(false);
    if ($26d7a0f3316320e2$var$_scriptPromise) return $26d7a0f3316320e2$var$_scriptPromise;
    $26d7a0f3316320e2$var$_scriptPromise = new Promise((resolve)=>{
        if (window.turnstile) {
            resolve(true);
            return;
        }
        const s = document.createElement('script');
        s.src = $26d7a0f3316320e2$var$SCRIPT_SRC;
        s.async = true;
        s.defer = true;
        s.onload = ()=>resolve(true);
        s.onerror = ()=>resolve(false);
        document.head.appendChild(s);
    });
    return $26d7a0f3316320e2$var$_scriptPromise;
}
// Collapse the widget once it holds a valid token, or re-show it when the token is
// gone. This is PURELY VISUAL - getResponse() still returns the token from a hidden
// widget, so the anti-bot protection is unaffected. The invariant we must keep: the
// widget is hidden ONLY while a valid token exists, so a re-challenge (after reset /
// expiry / error) is always visible and can never silently block the user.
function $26d7a0f3316320e2$var$_setSolvedUI(containerId, solved) {
    const el = document.getElementById(containerId);
    if (el) el.classList.toggle('auth-captcha--solved', solved);
}
async function $26d7a0f3316320e2$export$b3907d9379744981(containerId) {
    if (!$26d7a0f3316320e2$var$SITE_KEY) return;
    const ok = await $26d7a0f3316320e2$var$_loadScript();
    if (!ok || !window.turnstile) return;
    const el = document.getElementById(containerId);
    if (!el || $26d7a0f3316320e2$var$_widgets.has(containerId)) return;
    try {
        const id = window.turnstile.render(el, {
            sitekey: $26d7a0f3316320e2$var$SITE_KEY,
            theme: 'auto',
            size: 'flexible',
            // Hide once solved (after a brief beat so the "Success" tick is seen); re-show
            // whenever the token is lost so any re-challenge stays visible.
            callback: ()=>setTimeout(()=>$26d7a0f3316320e2$var$_setSolvedUI(containerId, true), 600),
            'expired-callback': ()=>$26d7a0f3316320e2$var$_setSolvedUI(containerId, false),
            'error-callback': ()=>$26d7a0f3316320e2$var$_setSolvedUI(containerId, false)
        });
        $26d7a0f3316320e2$var$_widgets.set(containerId, id);
    } catch  {
    // Already rendered or a transient render error - leave the form usable.
    }
}
function $26d7a0f3316320e2$export$257b2d10b709d8ef(containerId) {
    if (!$26d7a0f3316320e2$var$SITE_KEY || !window.turnstile) return undefined;
    const id = $26d7a0f3316320e2$var$_widgets.get(containerId);
    if (id === undefined) return undefined;
    return window.turnstile.getResponse(id) || undefined;
}
function $26d7a0f3316320e2$export$2b8fcaee65c058ce(containerId) {
    if (!$26d7a0f3316320e2$var$SITE_KEY || !window.turnstile) return;
    const id = $26d7a0f3316320e2$var$_widgets.get(containerId);
    if (id !== undefined) {
        try {
            window.turnstile.reset(id);
        } catch  {}
        // Reset clears the token, so re-show the widget; a fresh solve re-hides it.
        $26d7a0f3316320e2$var$_setSolvedUI(containerId, false);
    }
}
async function $26d7a0f3316320e2$export$fb9c4d9ba2c9db2a() {
    if (!$26d7a0f3316320e2$var$SITE_KEY) return undefined;
    const ok = await $26d7a0f3316320e2$var$_loadScript();
    if (!ok || !window.turnstile) return undefined;
    return new Promise((resolve)=>{
        const holder = document.createElement('div');
        holder.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:2147483000;';
        document.body.appendChild(holder);
        let settled = false;
        let wid;
        const cleanup = (token)=>{
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            try {
                if (wid !== undefined) window.turnstile.remove(wid);
            } catch  {}
            holder.remove();
            resolve(token || undefined);
        };
        const timer = setTimeout(()=>cleanup(undefined), 60000);
        try {
            wid = window.turnstile.render(holder, {
                sitekey: $26d7a0f3316320e2$var$SITE_KEY,
                theme: 'auto',
                size: 'normal',
                callback: (token)=>cleanup(token),
                'error-callback': ()=>cleanup(undefined),
                'timeout-callback': ()=>cleanup(undefined)
            });
        } catch  {
            cleanup(undefined);
        }
    });
}

});

parcelRegister("cggJi", function(module, exports) {

$parcel$export(module.exports, "takeoutLabel", () => $8ed3f4ccd65fc46b$export$7551ab312208238e);
$parcel$export(module.exports, "orderTypeLabel", () => $8ed3f4ccd65fc46b$export$ec35e0fd5ce61a17);
// Localizes the order-type labels shown across the POS, receipt, KDS, and CFD.
// The stored value is always 'dine-in' / 'takeout' - only the DISPLAY label changes.
// Commonwealth markets say "Takeaway" instead of the US/PH "Takeout".
const $8ed3f4ccd65fc46b$var$TAKEAWAY_COUNTRIES = new Set([
    'GB',
    'AU',
    'NZ',
    'IE'
]);
// Country comes from the explicit arg when available, else the value stashed in
// localStorage at login (so popup windows can localize too).
const $8ed3f4ccd65fc46b$var$_country = (country)=>(country ?? (typeof localStorage !== 'undefined' ? localStorage.getItem('pointbunny_business_country') : '') ?? '').toUpperCase();
const $8ed3f4ccd65fc46b$export$7551ab312208238e = (country)=>$8ed3f4ccd65fc46b$var$TAKEAWAY_COUNTRIES.has($8ed3f4ccd65fc46b$var$_country(country)) ? 'Takeaway' : 'Takeout';
const $8ed3f4ccd65fc46b$export$ec35e0fd5ce61a17 = (orderType, country, { upper: upper = false } = {})=>{
    const label = orderType === 'takeout' ? $8ed3f4ccd65fc46b$export$7551ab312208238e(country) : 'Dine In';
    return upper ? label.toUpperCase() : label;
};

});

parcelRegister("abGsl", function(module, exports) {

$parcel$export(module.exports, "roundCents", () => $76abdd5b9dc01178$export$88a0f6be7eaca430);
$parcel$export(module.exports, "tipFromPercent", () => $76abdd5b9dc01178$export$eebe11ff2a18c479);
$parcel$export(module.exports, "computeTipPool", () => $76abdd5b9dc01178$export$2ac686822abed0bd);
$parcel$export(module.exports, "tipAmountFor", () => $76abdd5b9dc01178$export$bfeb295835626508);
// Tip math shared by checkout, the controller and the customer display, so a
// "18%" tap shows the same amount on every screen. Tips are a percentage of
// the sale total (after discounts, fees and tax) and are never taxed - the
// server stores them in sales.tip_amount, outside total_price.
const $76abdd5b9dc01178$export$88a0f6be7eaca430 = (n)=>Math.round((Number(n) || 0) * 100) / 100;
const $76abdd5b9dc01178$export$eebe11ff2a18c479 = (total, percent)=>$76abdd5b9dc01178$export$88a0f6be7eaca430(Math.max(0, Number(total) || 0) * (Number(percent) || 0) / 100);
const $76abdd5b9dc01178$export$eb60ad3f642bfc46 = (d)=>{
    const x = new Date(d);
    return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`;
};
const $76abdd5b9dc01178$export$2a7ecb298b3eaec1 = (shift)=>{
    if (!shift.clockedOutAt) return {};
    let segs = [
        [
            new Date(shift.clockedInAt).getTime(),
            new Date(shift.clockedOutAt).getTime()
        ]
    ];
    for (const b of shift.breaks ?? []){
        if (!b.endedAt) continue;
        const bs = new Date(b.startedAt).getTime();
        const be = new Date(b.endedAt).getTime();
        segs = segs.flatMap(([s, e])=>{
            if (be <= s || bs >= e) return [
                [
                    s,
                    e
                ]
            ];
            return [
                [
                    s,
                    Math.max(s, bs)
                ],
                [
                    Math.min(e, be),
                    e
                ]
            ].filter(([a, z])=>z > a);
        });
    }
    const out = {};
    for (let [s, e] of segs)while(s < e){
        const next = new Date(s);
        next.setHours(24, 0, 0, 0);
        const end = Math.min(e, next.getTime());
        const key = $76abdd5b9dc01178$export$eb60ad3f642bfc46(s);
        out[key] = (out[key] ?? 0) + (end - s) / 60000;
        s = end;
    }
    return out;
};
// Split `cents` by weights so the parts always add back up exactly (largest
// remainder: whole cents first, then the leftover cents to the biggest
// fractions).
const $76abdd5b9dc01178$var$splitCents = (cents, weights)=>{
    const total = weights.reduce((a, w)=>a + w, 0);
    if (total <= 0) return weights.map(()=>0);
    const raw = weights.map((w)=>cents * w / total);
    const out = raw.map(Math.floor);
    let left = cents - out.reduce((a, n)=>a + n, 0);
    raw.map((r, i)=>[
            r - out[i],
            i
        ]).sort((a, b)=>b[0] - a[0] || a[1] - b[1]).forEach(([, i])=>{
        if (left > 0) {
            out[i]++;
            left--;
        }
    });
    return out;
};
const $76abdd5b9dc01178$export$2ac686822abed0bd = ({ tips: tips, shifts: shifts, inPool: inPool })=>{
    const tipCents = new Map();
    for (const t of tips){
        const c = Math.round((Number(t.amount) || 0) * 100);
        if (c <= 0) continue;
        const key = $76abdd5b9dc01178$export$eb60ad3f642bfc46(t.date);
        tipCents.set(key, (tipCents.get(key) ?? 0) + c);
    }
    const minutes = new Map(); // day -> Map(staffId -> minutes)
    for (const sh of shifts){
        if (!inPool(sh)) continue;
        for (const [day, m] of Object.entries($76abdd5b9dc01178$export$2a7ecb298b3eaec1(sh))){
            if (!minutes.has(day)) minutes.set(day, new Map());
            const byStaff = minutes.get(day);
            byStaff.set(sh.staffId, (byStaff.get(sh.staffId) ?? 0) + m);
        }
    }
    const days = [];
    const people = new Map();
    let unassigned = 0;
    for (const [day, cents] of tipCents){
        const byStaff = [
            ...minutes.get(day) ?? new Map()
        ].filter(([, m])=>m > 0);
        const dayMinutes = byStaff.reduce((a, [, m])=>a + m, 0);
        if (!byStaff.length) {
            unassigned += cents;
            days.push({
                day: day,
                tips: cents / 100,
                minutes: 0,
                shares: []
            });
            continue;
        }
        const parts = $76abdd5b9dc01178$var$splitCents(cents, byStaff.map(([, m])=>m));
        const shares = byStaff.map(([staffId, m], i)=>({
                staffId: staffId,
                minutes: m,
                amount: parts[i] / 100
            }));
        for (const sh of shares){
            const p = people.get(sh.staffId) ?? {
                staffId: sh.staffId,
                minutes: 0,
                cents: 0,
                days: 0
            };
            p.minutes += sh.minutes;
            p.cents += Math.round(sh.amount * 100);
            p.days += 1;
            people.set(sh.staffId, p);
        }
        days.push({
            day: day,
            tips: cents / 100,
            minutes: dayMinutes,
            shares: shares.sort((a, b)=>b.amount - a.amount)
        });
    }
    days.sort((a, b)=>a.day < b.day ? 1 : -1);
    const totalCents = [
        ...tipCents.values()
    ].reduce((a, c)=>a + c, 0);
    return {
        days: days,
        people: [
            ...people.values()
        ].map((p)=>({
                staffId: p.staffId,
                minutes: p.minutes,
                amount: p.cents / 100,
                days: p.days
            })).sort((a, b)=>b.amount - a.amount),
        totalTips: totalCents / 100,
        pooledTips: (totalCents - unassigned) / 100,
        unassigned: unassigned / 100,
        pooledMinutes: [
            ...people.values()
        ].reduce((a, p)=>a + p.minutes, 0)
    };
};
const $76abdd5b9dc01178$export$bfeb295835626508 = (tip, total)=>{
    if (!tip) return 0;
    if (tip.mode === 'percent') return $76abdd5b9dc01178$export$eebe11ff2a18c479(total, tip.percent);
    if (tip.mode === 'custom') return $76abdd5b9dc01178$export$88a0f6be7eaca430(Math.max(0, Number(tip.amount) || 0));
    return 0;
};

});

parcelRegister("boau7", function(module, exports) {

$parcel$export(module.exports, "default", () => $84aa11ad3214c6ed$export$2e2bcd8739ae039);
$parcel$export(module.exports, "MSG", () => $84aa11ad3214c6ed$export$f99154f7a7b0135d);

var $asfCf = parcelRequire("asfCf");
const $84aa11ad3214c6ed$var$BROADCAST_EVENT = 'msg';
// IMPORTANT: the channel is partitioned PER BUSINESS so KDS / customer-display
// broadcasts never cross tenants. The channel names embed the business id, so a
// business only ever receives its own orders/carts. Nothing is broadcast until
// init(businessId) is called - the main app calls it in initApp, and each popup
// (KDS / CFD) calls it at startup with pointbunny_business_id from localStorage.
class $84aa11ad3214c6ed$var$PointbunnyChannel {
    constructor(){
        this._handler = null;
        this._bc = null;
        this._ch = null;
        this._businessId = null;
        this._readyResolve = null;
        // Resolves once the channel is bound to a business and SUBSCRIBED.
        this.ready = new Promise((resolve)=>{
            this._readyResolve = resolve;
        });
        // Private channels authorize against the user's JWT, so keep Realtime's token
        // in sync when the session refreshes - otherwise the join silently drops later.
        (0, $asfCf.supabase).auth.onAuthStateChange((_event, session)=>{
            if (session?.access_token) (0, $asfCf.supabase).realtime.setAuth(session.access_token);
        });
    }
    // Bind the broadcast channel to one business. Idempotent for the same id;
    // rebinds (and tears down the old channel) on a business switch in the same tab.
    init(businessId) {
        if (!businessId || businessId === this._businessId) return;
        this._teardown();
        this._businessId = businessId;
        this._bind(businessId);
    }
    async _bind(businessId) {
        // PRIVATE channel: Realtime must be authenticated with the user's access token
        // BEFORE subscribing, or the authorized join is denied (this is what broke sync
        // last time - the popups never set it). Works in every window because they all
        // share the same Supabase session from localStorage.
        const { data: { session: session } } = await (0, $asfCf.supabase).auth.getSession();
        // AWAIT setAuth so the token is applied to the socket BEFORE we subscribe -
        // otherwise the private-channel join races ahead with no auth and is denied.
        if (session?.access_token) await (0, $asfCf.supabase).realtime.setAuth(session.access_token);
        if (businessId !== this._businessId) return; // a newer init() superseded this one
        // Native BroadcastChannel: synchronous, zero-network, same-browser windows only.
        // Used alongside Supabase Realtime so messages survive brief connection drops.
        if (typeof BroadcastChannel !== 'undefined') {
            this._bc = new BroadcastChannel(`pointbunny-local-${businessId}`);
            this._bc.onmessage = ({ data: data })=>{
                if (this._handler) this._handler({
                    data: data
                });
            };
        }
        // private:true enforces Realtime Authorization - a client can only join this
        // topic if the realtime.messages RLS policy says they belong to this business.
        // Even knowing the business id isn't enough to eavesdrop; you must be a member.
        this._ch = (0, $asfCf.supabase).channel(`pointbunny-displays-${businessId}`, {
            config: {
                private: true,
                broadcast: {
                    self: false
                }
            }
        });
        this._ch.on('broadcast', {
            event: $84aa11ad3214c6ed$var$BROADCAST_EVENT
        }, ({ payload: payload })=>{
            if (this._handler) this._handler({
                data: payload
            });
        });
        this._ch.subscribe((status, err)=>{
            if (status === 'SUBSCRIBED') {
                console.info('[pointbunny] display channel SUBSCRIBED:', `pointbunny-displays-${businessId}`);
                if (this._readyResolve) {
                    this._readyResolve();
                    this._readyResolve = null;
                }
            } else if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT' || status === 'CLOSED') // CHANNEL_ERROR here almost always = the private-channel authorization was
            // denied (no/old auth token, or the realtime.messages RLS policy didn't match).
            console.error('[pointbunny] display channel join failed:', status, err ?? '');
        });
    }
    _teardown() {
        if (this._ch) {
            (0, $asfCf.supabase).removeChannel(this._ch);
            this._ch = null;
        }
        if (this._bc) {
            this._bc.close();
            this._bc = null;
        }
    }
    postMessage(data) {
        if (!this._ch) return; // not bound to a business yet - drop rather than leak globally
        this._ch.send({
            type: 'broadcast',
            event: $84aa11ad3214c6ed$var$BROADCAST_EVENT,
            payload: data
        });
        this._bc?.postMessage(data);
    }
    set onmessage(fn) {
        this._handler = fn;
    }
}
const $84aa11ad3214c6ed$var$channel = new $84aa11ad3214c6ed$var$PointbunnyChannel();
var $84aa11ad3214c6ed$export$2e2bcd8739ae039 = $84aa11ad3214c6ed$var$channel;
const $84aa11ad3214c6ed$export$f99154f7a7b0135d = {
    // KDS: cashier → kitchen
    KDS_QUEUE_SYNC: 'KDS_QUEUE_SYNC',
    // KDS: kitchen → cashier
    KDS_REQUEST_SYNC: 'KDS_REQUEST_SYNC',
    KDS_ORDER_DONE: 'KDS_ORDER_DONE',
    KDS_ORDER_READY: 'KDS_ORDER_READY',
    KDS_ORDER_VOIDED: 'KDS_ORDER_VOIDED',
    // Terminal → terminals: a sale was recorded, so revenue views (today's cards,
    // an open Cashflow panel) refetch. { id }. Displays ignore it.
    SALE_RECORDED: 'SALE_RECORDED',
    // CFD: cashier → customer display
    CFD_CART_UPDATE: 'CFD_CART_UPDATE',
    CFD_SALE_COMPLETE: 'CFD_SALE_COMPLETE',
    CFD_SHOW_QR: 'CFD_SHOW_QR',
    CFD_TIP_REQUEST: 'CFD_TIP_REQUEST',
    // CFD: customer display → cashier
    CFD_REQUEST_SYNC: 'CFD_REQUEST_SYNC',
    CFD_TIP_SELECTED: 'CFD_TIP_SELECTED',
    // Time clock → POS: somebody clocked in/out or started/ended a break, so the
    // home "on shift now" bubble refreshes immediately instead of on the next poll.
    // NOTE: timeclock.js hardcodes this string (the kiosk stays standalone and
    // doesn't import this module) - keep the two in sync.
    SHIFT_SYNC: 'SHIFT_SYNC',
    // Inventory: a terminal changed stock (sale, void, restock, link edit).
    // No payload - receivers refetch (stock is tiny; refetching avoids drift).
    INVENTORY_SYNC: 'INVENTORY_SYNC',
    // Tables: a terminal seated, ordered, paid or edited tables. No payload -
    // receivers refetch the floor (tables, open tabs, bookings, waitlist).
    TABLES_SYNC: 'TABLES_SYNC'
};

});

parcelRegister("hHoOP", function(module, exports) {
module.exports = import("grHmr").then(()=>parcelRequire('2RVy2'));

});

class $081656bd50f85abd$export$2e2bcd8739ae039 {
    _data;
    render(data) {
        this._data = data;
        const markup = this._generateMarkUp();
        this._clear();
        this._parentElement.innerHTML = markup;
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
    _showSuccess(note = null) {
        const markup = `
    <div class="modal-overlay success-overlay">
      <div class="modal-content success-modal">
        <button class="modal-close">&times;</button>
        <div class="success-body">
          <div class="success-icon">
            <svg class="success-svg" viewBox="0 0 52 52" aria-hidden="true">
              <path class="success-check" fill="none" stroke="#fff" stroke-width="5"
                stroke-linecap="round" stroke-linejoin="round" d="M14 27 l9 9 16-18"/>
            </svg>
          </div>
          <h2 class="success-title">Success</h2>
          ${note ? `<p class="success-note">${note}</p>` : ''}
        </div>
      </div>
    </div>
  `;
        this._parentElement.insertAdjacentHTML("beforeend", markup);
        // Close button functionality
        const overlay = this._parentElement.querySelector(".success-overlay");
        const closeBtn = overlay.querySelector(".modal-close");
        closeBtn.addEventListener("click", ()=>{
            overlay.remove(); // removes modal from DOM
        });
    }
    _hideSuccess() {
        const overlay = document.querySelector(".success-overlay");
        if (overlay) overlay.remove();
    }
    showConfirmModal({ message: message, note: note, confirmLabel: confirmLabel = 'Discard & close', cancelLabel: cancelLabel = 'Keep editing', onConfirm: onConfirm, onCancel: onCancel }) {
        if (document.querySelector('.confirm-overlay')) return;
        const el = document.createElement('div');
        el.className = 'confirm-overlay';
        el.innerHTML = `
      <div class="confirm-card">
        <p class="confirm-msg">${message}</p>
        ${note ? `<p class="confirm-note">${note}</p>` : ''}
        <div class="confirm-actions">
          <button class="btn confirm-cancel-btn" type="button">${cancelLabel}</button>
          <button class="btn primary confirm-ok-btn" type="button">${confirmLabel}</button>
        </div>
      </div>
    `;
        document.body.appendChild(el);
        el.querySelector('.confirm-ok-btn').addEventListener('click', ()=>{
            el.remove();
            onConfirm?.();
        });
        el.querySelector('.confirm-cancel-btn').addEventListener('click', ()=>{
            el.remove();
            onCancel?.();
        });
        el.addEventListener('click', (e)=>{
            if (e.target === el) {
                el.remove();
                onCancel?.();
            }
        });
    }
}



var $cnCXJ = parcelRequire("cnCXJ");

var $cnCXJ = parcelRequire("cnCXJ");
// Single neutral default thumbnail for any item with no uploaded image.
// Inline SVG data URI so it renders instantly on every surface (catalogue,
// new-order grid, item picker, edit form) with zero network requests and stays
// crisp at any size. Deliberately generic - an "add a photo" frame that suits a
// cafe, a retail shop, or a service business equally (no food/utensil imagery).
//
// Stored value stays NULL in the DB; this default is applied at render time
// only, so no item row ever carries this string (no DB bloat).
const $bfffb7fa3c34031e$var$svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'>
  <rect width='120' height='120' rx='18' fill='#f0fdf4'/>
  <g fill='none' stroke='#34d399' stroke-width='4.5' stroke-linecap='round' stroke-linejoin='round'>
    <rect x='30' y='34' width='60' height='52' rx='9'/>
    <circle cx='47' cy='51' r='5.5'/>
    <path d='M33 80 L54 60 L66 71 L77 62 L87 71'/>
  </g>
</svg>`;
const $bfffb7fa3c34031e$export$305f51b7beb9067 = `data:image/svg+xml,${encodeURIComponent($bfffb7fa3c34031e$var$svg)}`;


const $69bdae3851aa6802$export$3eab5618e62baa45 = "\uD83D\uDCE6";
const $69bdae3851aa6802$export$56b52f8eeffda3e5 = function(item, { emojiOnly: emojiOnly = false } = {}) {
    if (emojiOnly) return $69bdae3851aa6802$var$emojiTileDataUri(item?.iconEmoji || $69bdae3851aa6802$export$3eab5618e62baa45);
    return item?.imageURL || (0, $bfffb7fa3c34031e$export$305f51b7beb9067);
};
const $69bdae3851aa6802$var$emojiTileDataUri = function(emoji) {
    // Untrusted (user-typed/pasted) text going into markup - esc() per
    // CLAUDE.md "Output Escaping (XSS)", even though <img src="data:..."> already
    // disables SVG script execution: defense in depth, and this SVG string is
    // itself the kind of stored value a future consumer (e.g. the admin panel)
    // could render differently.
    const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'>
  <rect width='120' height='120' rx='18' fill='#f0fdf4'/>
  <text x='60' y='66' font-size='58' text-anchor='middle' dominant-baseline='central'>${(0, $cnCXJ.esc)(emoji)}</text>
</svg>`;
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};



var $coRoT = parcelRequire("coRoT");
// Device-level display preference (like theme) - which image style the New
// Order grid shows. Emoji is the default: a faster, more playful read for
// staff running the register, with photos available for anyone who prefers
// real product shots. Never synced to businesses.settings - purely local.
const $472fec5536166250$var$VISUAL_MODE_KEY = "pointbunny_pos_visual_mode";
class $472fec5536166250$var$NewOrderView extends (0, $081656bd50f85abd$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".modal-parent");
    _openBtn = document.getElementById("newOrderBtn");
    // Set while adding items to an open table tab (2026-10-22): { tableName,
    // tabTotal }. The cart then holds only the new items, and Checkout becomes
    // "Send to kitchen" with "Save to tab" beside it.
    _tabOrder = null;
    _getVisualMode() {
        return localStorage.getItem($472fec5536166250$var$VISUAL_MODE_KEY) === "photo" ? "photo" : "emoji";
    }
    _generateMarkUp() {
        const cap = (s)=>s[0].toUpperCase() + s.slice(1);
        const { menuItems: menuItems, menuCategories: menuCategories, cart: cart } = this._data;
        const cartCount = cart.length;
        const cartTotal = cart.reduce((acc, item)=>acc + item.totalPrice, 0);
        const userCategories = menuCategories.filter((c)=>c !== "uncategorized");
        const statuses = this._stockStatuses();
        this._stockStatusCache = statuses; // popover content lookup on chip click
        const visualMode = this._getVisualMode();
        const renderCard = (item)=>{
            const unavailable = item.status === "unavailable";
            // Stock never blocks a sale - an alert chip only, card stays clickable.
            // When an item is BOTH unavailable and low/out, unavailable wins (it
            // already blocks clicks and has its own badge).
            const st = !unavailable ? statuses.get(item._id) : null;
            const src = (0, $69bdae3851aa6802$export$56b52f8eeffda3e5)(item, {
                emojiOnly: visualMode === "emoji"
            });
            const imgMarkup = `<img src="${(0, $cnCXJ.esc)(src)}" alt="${(0, $cnCXJ.esc)(item.itemName)}" class="pos-item-img" loading="lazy" onerror="this.alt='';this.className='pos-item-img pos-item-img--ph';this.removeAttribute('src')">`;
            return `
        <div class="pos-item-card${unavailable ? " pos-item-card--unavailable" : ""}" data-id="${item._id}">
          ${imgMarkup}
          ${unavailable ? '<span class="pos-item-badge">Unavailable</span>' : ""}
          ${st ? this._stockChipHtml(st) : ""}
          <div class="pos-item-info">
            <div class="pos-item-name">${(0, $cnCXJ.esc)(item.itemName)}</div>
            <div class="pos-item-price">${(0, $coRoT.formatMoney)(item.price)}</div>
          </div>
        </div>`;
        };
        const activeCategories = userCategories.filter((cat)=>menuItems.some((i)=>i.category === cat && i.status !== "inactive"));
        const uncategorizedItems = menuItems.filter((i)=>i.status !== "inactive" && (!i.category || i.category === "uncategorized" || !menuCategories.includes(i.category)));
        const tabs = [
            `<button class="pos-cat-tab pos-cat-tab--active" data-cat="all">All Items</button>`,
            ...activeCategories.map((cat)=>`<button class="pos-cat-tab" data-cat="${(0, $cnCXJ.esc)(cat)}">${(0, $cnCXJ.esc)(cap(cat))}</button>`),
            uncategorizedItems.length ? `<button class="pos-cat-tab" data-cat="uncategorized">Uncategorized</button>` : ""
        ].join("");
        // "All Items" is a single flat grid (no category headers); category sections
        // start hidden and are revealed by their tab.
        const allActiveItems = menuItems.filter((i)=>i.status !== "inactive");
        const allItemsGroup = `
      <div class="pos-cat-section" data-section="__all">
        <div class="pos-items-grid">${allActiveItems.map(renderCard).join("")}</div>
      </div>`;
        const categoryGroups = activeCategories.map((cat)=>{
            const items = menuItems.filter((i)=>i.category === cat && i.status !== "inactive");
            if (!items.length) return "";
            return `
          <div class="pos-cat-section hidden" data-section="${(0, $cnCXJ.esc)(cat)}">
            <p class="pos-cat-label">${(0, $cnCXJ.esc)(cap(cat))}</p>
            <div class="pos-items-grid">${items.map(renderCard).join("")}</div>
          </div>`;
        }).join("");
        const uncatGroup = uncategorizedItems.length ? `
        <div class="pos-cat-section hidden" data-section="uncategorized">
          <p class="pos-cat-label pos-cat-label--muted">Uncategorized</p>
          <div class="pos-items-grid">${uncategorizedItems.map(renderCard).join("")}</div>
        </div>` : "";
        const cartMarkup = this._cartRowsMarkup(cart);
        return `
      <div class="pos-screen" id="newOrderModal">
        <div class="pos-header">
          <button class="modal-close pos-close-btn" aria-label="Close">\xd7</button>
          <div class="pos-visual-toggle" data-mode="${visualMode}" role="group" aria-label="Item image style">
            <span class="pos-visual-toggle-thumb" aria-hidden="true"></span>
            <button type="button" class="pos-visual-toggle-btn${visualMode === "emoji" ? " pos-visual-toggle-btn--active" : ""}" data-mode="emoji" title="Show emoji" aria-pressed="${visualMode === "emoji"}"><span aria-hidden="true">\u{1F60A}</span><span class="pos-visual-toggle-label">Emoji</span></button>
            <button type="button" class="pos-visual-toggle-btn${visualMode === "photo" ? " pos-visual-toggle-btn--active" : ""}" data-mode="photo" title="Show photos" aria-pressed="${visualMode === "photo"}"><span aria-hidden="true">\u{1F5BC}\u{FE0F}</span><span class="pos-visual-toggle-label">Photos</span></button>
          </div>
          <h2 class="pos-title">${this._tabOrder ? `Table ${(0, $cnCXJ.esc)(this._tabOrder.tableName)} \xb7 add items` : "New Order"}</h2>
          <button class="btn-checkout pos-cart-fab">
            Cart${cartCount > 0 ? ` <span class="pos-cart-count">${cartCount}</span>` : ""} \xb7 ${(0, $coRoT.formatMoney)(cartTotal)}
          </button>
        </div>
        <div class="pos-body">
          ${menuItems.length > 0 ? `<div class="pos-cat-sidebar">${tabs}</div>` : ""}
          <div class="pos-menu">
            ${menuItems.length === 0 ? `<div class="pos-empty">
                    <span class="pos-empty-emoji" aria-hidden="true">\u{1F4E6}</span>
                    <p class="pos-empty-title">No items yet</p>
                    <p class="pos-empty-sub">Add your items to start taking orders.</p>
                    <button class="btn primary pos-empty-add" type="button">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
                      Add Items
                    </button>
                  </div>` : `<div class="pos-items-area" id="posItemsArea">
                  ${allItemsGroup}${categoryGroups}${uncatGroup}
                </div>`}
          </div>
          <div class="pos-cart-sidebar">
            <h3 class="pos-cart-title">${this._tabOrder ? `New for table ${(0, $cnCXJ.esc)(this._tabOrder.tableName)}` : "Cart"}</h3>
            ${this._tabOrder ? `<p class="pos-tab-note">Already on the tab: ${(0, $coRoT.formatMoney)(this._tabOrder.tabTotal)}</p>` : ""}
            <div class="pos-cart-list" id="cartItems">
              ${cartMarkup || '<p class="pos-cart-empty">No items yet.</p>'}
            </div>
            <div class="pos-cart-footer">
              <div class="pos-cart-total">
                <span>Total</span>
                <span>${(0, $coRoT.formatMoney)(cartTotal)}</span>
              </div>
              ${this._tabOrder ? `<div class="pos-tab-actions"><button class="pos-tab-save-btn" type="button">Save to tab</button><button class="btn-checkout pos-checkout-btn">Send to kitchen</button></div>` : `<button class="btn-checkout pos-checkout-btn">Checkout</button>`}
            </div>
          </div>
        </div>
      </div>`;
    }
    _cartRowsMarkup(cart) {
        return cart.map((item, i)=>{
            const variants = item.selectedVariants.map((v)=>v.variantName).join(", ");
            return `
          <div class="pos-cart-item cart-item-row">
            <div class="pos-cart-item-info">
              <span class="pos-cart-item-name">${(0, $cnCXJ.esc)(item.itemName)} \xd7${item.quantity}</span>
              ${variants ? `<span class="pos-cart-item-variants">${(0, $cnCXJ.esc)(variants)}</span>` : ""}
            </div>
            <div class="pos-cart-item-right">
              <span class="pos-cart-item-price">${(0, $coRoT.formatMoney)(item.totalPrice)}</span>
              <button class="cart-item-delete-btn pos-cart-delete" data-cart-index="${i}" type="button">\xd7</button>
            </div>
          </div>`;
        }).join("");
    }
    // Surgical cart update: patches ONLY the cart list, total, and header pill.
    // The item grid + category tabs are untouched, so cart changes no longer
    // re-render (and "blink") the whole POS screen or reset the active tab.
    // Returns false if the POS screen isn't in the DOM (caller falls back to render).
    updateCart({ added: added = false } = {}) {
        const screen = this._parentElement.querySelector("#newOrderModal");
        if (!screen || !this._data) return false;
        const { cart: cart } = this._data;
        const total = cart.reduce((acc, item)=>acc + item.totalPrice, 0);
        const list = screen.querySelector("#cartItems");
        if (list) list.innerHTML = this._cartRowsMarkup(cart) || '<p class="pos-cart-empty">No items yet.</p>';
        const totalEl = screen.querySelector(".pos-cart-total span:last-child");
        if (totalEl) totalEl.textContent = (0, $coRoT.formatMoney)(total);
        const fab = screen.querySelector(".pos-cart-fab");
        if (fab) fab.innerHTML = `Cart${cart.length > 0 ? ` <span class="pos-cart-count">${cart.length}</span>` : ""} \xb7 ${(0, $coRoT.formatMoney)(total)}`;
        if (added && list) {
            list.scrollTop = list.scrollHeight;
            const last = list.querySelector(".cart-item-row:last-child");
            if (last) last.classList.add("cart-item--new", "cart-item--added");
        }
        return true;
    }
    _stockStatusCache = new Map();
    // Per-product stock status computed from the state slices passed into
    // render(): which linked inventory items are out (qty <= 0) and which are
    // low (at/below their alert threshold). Mirrors model.productStockStatus.
    _stockStatuses() {
        const { inventoryItems: inventoryItems = [], inventoryLinks: inventoryLinks = [] } = this._data ?? {};
        const map = new Map();
        inventoryLinks.forEach((l)=>{
            if (!(Number(l.qty) > 0)) return; // a "None" (qty 0) override never drives alerts
            const inv = inventoryItems.find((i)=>i.id === l.inventoryItemId);
            if (!inv) return;
            const isOut = inv.quantity <= 0;
            const isLow = !isOut && inv.lowStockThreshold != null && inv.quantity <= inv.lowStockThreshold;
            if (!isOut && !isLow) return;
            const st = map.get(l.menuItemId) ?? {
                out: [],
                low: []
            };
            const bucket = isOut ? st.out : st.low;
            if (!bucket.includes(inv.name)) bucket.push(inv.name);
            map.set(l.menuItemId, st);
        });
        map.forEach((st)=>{
            st.state = st.out.length ? "out" : "low";
        });
        return map;
    }
    // Compact alert chip: "● 1 OUT · ● 1 LOW ›". Tapping it opens the
    // per-item alerts popover; the chip is a button so it never triggers the
    // card's open-item click (guarded in newOrderItemView).
    _stockChipHtml(st) {
        const seg = [];
        if (st.out.length) seg.push(`<span class="pos-chip-dot pos-chip-dot--out"></span>${st.out.length} OUT`);
        if (st.low.length) seg.push(`<span class="pos-chip-dot pos-chip-dot--low"></span>${st.low.length} LOW`);
        return `
      <button type="button" class="pos-stock-chip" aria-label="Inventory alerts">
        ${seg.join('<span class="pos-chip-sep">\xb7</span>')}
        <span class="pos-chip-caret">&rsaquo;</span>
      </button>`;
    }
    // One shared popover on <body> (cards clip overflow, tooltip.js pattern).
    _stockPop = null;
    _ensureStockPop() {
        if (this._stockPop) return this._stockPop;
        const pop = document.createElement("div");
        pop.className = "pos-stock-pop hidden";
        document.body.appendChild(pop);
        document.addEventListener("click", (e)=>{
            if (!e.target.closest(".pos-stock-pop") && !e.target.closest(".pos-stock-chip")) pop.classList.add("hidden");
        });
        this._stockPop = pop;
        return pop;
    }
    _openStockPop(chip, st) {
        const pop = this._ensureStockPop();
        const row = (name, state)=>`
      <div class="pos-stock-pop-row">
        <span class="pos-stock-pop-name">${(0, $cnCXJ.esc)(name)}</span>
        <span class="pos-stock-pop-pill pos-stock-pop-pill--${state}">${state === "out" ? "Out of stock" : "Low stock"}</span>
      </div>`;
        pop.innerHTML = `
      <p class="pos-stock-pop-title">Inventory alerts</p>
      ${st.out.map((n)=>row(n, "out")).join("")}
      ${st.low.map((n)=>row(n, "low")).join("")}`;
        pop.classList.remove("hidden");
        // Position under the chip, viewport-clamped.
        const r = chip.getBoundingClientRect();
        const w = pop.offsetWidth;
        let left = r.left + r.width / 2 - w / 2;
        left = Math.max(8, Math.min(left, window.innerWidth - w - 8));
        let top = r.bottom + 6;
        if (top + pop.offsetHeight > window.innerHeight - 8) top = r.top - pop.offsetHeight - 6;
        pop.style.left = `${left}px`;
        pop.style.top = `${top}px`;
    }
    // Chip clicks (delegated on the persistent parent, survives re-renders).
    _addHandlerStockChip() {
        this._parentElement.addEventListener("click", (e)=>{
            const chip = e.target.closest(".pos-stock-chip");
            if (!chip) return;
            e.stopPropagation();
            const pop = this._ensureStockPop();
            if (!pop.classList.contains("hidden") && this._popChip === chip) {
                pop.classList.add("hidden");
                return;
            }
            this._popChip = chip;
            const id = chip.closest(".pos-item-card")?.dataset.id;
            const st = this._stockStatusCache.get(id);
            if (st) this._openStockPop(chip, st);
        });
    }
    // Surgical chip patch after stock changes (sale, void, restock, sync from
    // another terminal). Takes the Map from model.productStockStatuses(). No-op
    // when the order screen isn't rendered - never a full re-render (no-blink).
    updateStockBadges(statuses) {
        this._stockStatusCache = statuses;
        this._stockPop?.classList.add("hidden"); // content may be stale
        const screen = this._parentElement.querySelector("#newOrderModal");
        if (!screen) return;
        screen.querySelectorAll(".pos-item-card").forEach((card)=>{
            const unavailable = card.classList.contains("pos-item-card--unavailable");
            const st = !unavailable ? statuses.get(card.dataset.id) : null;
            card.querySelector(".pos-stock-chip")?.remove();
            if (st) card.querySelector(".pos-item-img")?.insertAdjacentHTML("afterend", this._stockChipHtml(st));
        });
    }
    // Slide a cart row out before it's deleted; resolves when the exit animation
    // has played (immediately if the row isn't found).
    animateCartRowOut(index) {
        return new Promise((resolve)=>{
            const row = this._parentElement.querySelectorAll("#cartItems .cart-item-row")[index];
            if (!row) {
                resolve();
                return;
            }
            row.classList.add("cart-item--removing");
            setTimeout(resolve, 180);
        });
    }
    _addHandlerCategoryTabs() {
        this._parentElement.addEventListener("click", (e)=>{
            const tab = e.target.closest(".pos-cat-tab");
            if (!tab) return;
            this._parentElement.querySelectorAll(".pos-cat-tab").forEach((t)=>t.classList.remove("pos-cat-tab--active"));
            tab.classList.add("pos-cat-tab--active");
            const cat = tab.dataset.cat;
            this._parentElement.querySelectorAll(".pos-cat-section").forEach((s)=>{
                const show = cat === "all" ? s.dataset.section === "__all" : s.dataset.section === cat;
                s.classList.toggle("hidden", !show);
            });
            const itemsArea = this._parentElement.querySelector(".pos-items-area");
            if (itemsArea) itemsArea.scrollTop = 0;
        });
    }
    // Emoji/Photo display toggle - surgically patches image srcs in place
    // (like updateCart/updateStockBadges) rather than a full render(), so
    // switching modes never replays the screen's entrance animation.
    _addHandlerToggleVisualMode() {
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".pos-visual-toggle-btn");
            if (!btn) return;
            const mode = btn.dataset.mode;
            if (mode === this._getVisualMode()) return;
            localStorage.setItem($472fec5536166250$var$VISUAL_MODE_KEY, mode);
            this._applyVisualMode(mode);
        });
    }
    _applyVisualMode(mode) {
        const screen = this._parentElement.querySelector("#newOrderModal");
        if (!screen) return;
        screen.querySelector(".pos-visual-toggle")?.setAttribute("data-mode", mode);
        screen.querySelectorAll(".pos-visual-toggle-btn").forEach((b)=>{
            const active = b.dataset.mode === mode;
            b.classList.toggle("pos-visual-toggle-btn--active", active);
            b.setAttribute("aria-pressed", String(active));
        });
        const menuItems = this._data?.menuItems ?? [];
        screen.querySelectorAll(".pos-item-card").forEach((card)=>{
            const item = menuItems.find((i)=>i._id === card.dataset.id);
            const img = card.querySelector(".pos-item-img");
            if (!item || !img) return;
            img.src = (0, $69bdae3851aa6802$export$56b52f8eeffda3e5)(item, {
                emojiOnly: mode === "emoji"
            });
        });
    }
    _addHandlerDeleteCartItem(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".cart-item-delete-btn");
            if (!btn) return;
            handler(Number(btn.dataset.cartIndex));
        });
    }
    _addHandlerShowMenuModal(handler) {
        this._openBtn.addEventListener("click", function(e) {
            e.preventDefault();
            handler();
        });
    }
    // "Add Items" button in the empty-catalogue state of the New Order screen.
    // Delegated on the persistent parent so it works each time the modal re-renders.
    // Heads-up shown when an out-of-stock product lands in the cart. Purely
    // informational - the item is already added and the sale is never blocked;
    // Continue (or a backdrop click via modalBackdrop.js) just dismisses.
    showStockNotice(names) {
        const modal = document.getElementById("stockNoticeModal");
        const msg = document.getElementById("stockNoticeMsg");
        if (!modal || !msg || !names?.length) return;
        const list = names.length > 1 ? `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}` : names[0];
        msg.innerHTML = `<strong>${(0, $cnCXJ.esc)(list)}</strong> ${names.length > 1 ? "are" : "is"} currently out of stock.`;
        if (!this._stockNoticeWired) {
            this._stockNoticeWired = true;
            document.getElementById("stockNoticeContinue")?.addEventListener("click", ()=>modal.classList.add("hidden"));
        }
        modal.classList.remove("hidden");
    }
    _addHandlerEmptyAddItems(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (!e.target.closest(".pos-empty-add")) return;
            handler();
        });
    }
    _addHandlerSaveToTab(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (e.target.closest(".pos-tab-save-btn")) handler();
        });
    }
    // Closes the order screen without the discard prompt (after a tab send).
    closeNow() {
        const screen = this._parentElement.querySelector(".pos-screen");
        if (screen) screen.classList.add("modal-exiting");
        setTimeout(()=>{
            this._parentElement.innerHTML = "";
        }, 220);
    }
    _addHandlerCloseModal(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".modal-close");
            if (!btn || !btn.closest("#newOrderModal")) return;
            const screen = this._parentElement.querySelector(".pos-screen");
            handler(()=>{
                if (screen) screen.classList.add("modal-exiting");
                setTimeout(()=>{
                    this._parentElement.innerHTML = "";
                }, 220);
            });
        });
    }
}
var $472fec5536166250$export$2e2bcd8739ae039 = new $472fec5536166250$var$NewOrderView();



var $dNnfS = parcelRequire("dNnfS");

var $asfCf = parcelRequire("asfCf");

var $1tYOa = parcelRequire("1tYOa");
// Centralized image guard for every upload (menu items, CFD ad, merchant QR,
// support-ticket attachments). Validates type, hard-rejects absurd files, and
// downscales/compresses large photos client-side BEFORE they hit Supabase
// Storage - so a huge phone photo still uploads, just smaller. Run every upload
// through prepareImageForUpload() so a giant file can never waste Storage
// (a billed resource) or slow the POS/CFD render.
// Target ceiling for what actually gets uploaded (after any downscale).
const $d1ef11f17812d23e$export$ad100638cfc43086 = 5242880; // 5 MB
// Refuse to even decode anything past this (avoids hanging the tab on a 50 MB file).
const $d1ef11f17812d23e$var$HARD_REJECT_BYTES = 26214400; // 25 MB
// Longest edge after downscale - keeps the full-screen CFD ad crisp on 1080p
// displays while still shrinking giant phone photos. QR codes are small and
// stay untouched (they never exceed this).
const $d1ef11f17812d23e$var$MAX_EDGE = 1920;
const $d1ef11f17812d23e$var$JPEG_QUALITY = 0.85;
const $d1ef11f17812d23e$var$fmtMB = (bytes)=>`${(bytes / 1048576).toFixed(1)} MB`;
const $d1ef11f17812d23e$var$loadImage = (file)=>new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = ()=>resolve({
                img: img,
                width: img.naturalWidth,
                height: img.naturalHeight,
                url: url
            });
        img.onerror = ()=>{
            URL.revokeObjectURL(url);
            reject(new Error("decode failed"));
        };
        img.src = url;
    });
const $d1ef11f17812d23e$export$b63de8e31affef62 = async function(file) {
    if (!file || file.size === 0) return file;
    if (!file.type.startsWith("image/")) throw new Error("That file is not an image. Please upload a PNG or JPG.");
    if (file.size > $d1ef11f17812d23e$var$HARD_REJECT_BYTES) throw new Error(`That image is too large (${$d1ef11f17812d23e$var$fmtMB(file.size)}). Please choose one under ${$d1ef11f17812d23e$var$fmtMB($d1ef11f17812d23e$var$HARD_REJECT_BYTES)}.`);
    let loaded;
    try {
        loaded = await $d1ef11f17812d23e$var$loadImage(file);
    } catch  {
        throw new Error("Could not read that image - it may be corrupted. Try another file.");
    }
    const { img: img, width: width, height: height, url: url } = loaded;
    const longest = Math.max(width, height);
    const needsResize = longest > $d1ef11f17812d23e$var$MAX_EDGE;
    const needsCompress = file.size > $d1ef11f17812d23e$export$ad100638cfc43086;
    // Already within dimensions and under the ceiling: upload as-is. This keeps
    // small PNG logos / QR codes pixel-perfect (no needless re-encode).
    if (!needsResize && !needsCompress) {
        URL.revokeObjectURL(url);
        return file;
    }
    const scale = needsResize ? $d1ef11f17812d23e$var$MAX_EDGE / longest : 1;
    const w = Math.round(width * scale);
    const h = Math.round(height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    canvas.getContext("2d").drawImage(img, 0, 0, w, h);
    URL.revokeObjectURL(url);
    // Preserve PNG (keeps transparency for logos / QR); re-encode everything else
    // as JPEG, which is dramatically smaller for photos.
    const outType = file.type === "image/png" ? "image/png" : "image/jpeg";
    const blob = await new Promise((res)=>canvas.toBlob(res, outType, $d1ef11f17812d23e$var$JPEG_QUALITY));
    if (!blob) return file; // canvas unavailable - fall back to the original
    if (blob.size > $d1ef11f17812d23e$export$ad100638cfc43086) throw new Error(`That image is still too large after compression (${$d1ef11f17812d23e$var$fmtMB(blob.size)}). Please use a smaller one.`);
    const baseName = file.name.replace(/\.[^.]+$/, "");
    const ext = outType === "image/png" ? "png" : "jpg";
    return new File([
        blob
    ], `${baseName}.${ext}`, {
        type: outType
    });
};




var $dv0h8 = parcelRequire("dv0h8");
// Tax-inclusive (VAT-inclusive) pricing helper.
//
// Some businesses (PH, UK/EU, AU/NZ) set item prices that ALREADY contain the
// tax. In that mode the total the customer pays does NOT change - we only need
// to EXTRACT and show how much of that total was tax, for receipt compliance.
//
// Compliant extraction (what BIR / HMRC / ATO require):
//   tax = gross * r / (1 + r)      net = gross - tax
// NOT the naive `gross * r` (that would tax the net at the wrong effective rate).
//   e.g. 100 incl. 12%  ->  tax 10.71, net 89.29  (not 12 / 88)
//
// This is opt-in and separate from Auto Adjustments (which ADD tax on top).
const $ff150a18d4a6f5bb$export$b07c8f45d340b388 = function(gross, ratePercent) {
    const g = Number(gross);
    const rate = Number(ratePercent);
    if (!g || g <= 0 || !rate || rate <= 0) return null;
    const r = rate / 100;
    const tax = g * r / (1 + r);
    return {
        net: g - tax,
        tax: tax,
        rate: rate
    };
};
const $ff150a18d4a6f5bb$export$fdde01ab91d59417 = function(country) {
    const c = (country || localStorage.getItem('pointbunny_business_country') || '').toUpperCase();
    if (c === 'US') return 'Sales Tax';
    if ([
        'AU',
        'NZ'
    ].includes(c)) return 'GST';
    const VAT = [
        'PH',
        'GB',
        'UK',
        'IE',
        'DE',
        'FR',
        'ES',
        'IT',
        'NL',
        'BE',
        'PT',
        'AT',
        'FI',
        'SE',
        'DK',
        'PL',
        'GR',
        'CZ',
        'RO',
        'HU',
        'SK',
        'BG',
        'HR',
        'LT',
        'LV',
        'EE',
        'SI',
        'LU',
        'CY',
        'MT'
    ];
    if (VAT.includes(c)) return 'VAT';
    return 'Tax';
};
const $ff150a18d4a6f5bb$export$87dc5d93d28d020f = [
    'VAT',
    'GST',
    'Sales Tax',
    'Tax',
    'HST',
    'PST',
    'IVA',
    'TVA',
    'MwSt',
    'SST',
    'Consumption Tax'
];
const $ff150a18d4a6f5bb$export$c829991a0e9a63 = function(country) {
    const override = (localStorage.getItem('pointbunny_tax_label') || '').trim();
    return $ff150a18d4a6f5bb$export$87dc5d93d28d020f.includes(override) ? override : $ff150a18d4a6f5bb$export$fdde01ab91d59417(country);
};
const $ff150a18d4a6f5bb$export$1a11748b971a7a75 = function(items, isExempt) {
    let taxableGross = 0;
    let exemptGross = 0;
    (items ?? []).forEach((it)=>{
        const g = Number(it.totalPrice) || 0;
        if (isExempt(it)) exemptGross += g;
        else taxableGross += g;
    });
    return {
        taxableGross: taxableGross,
        exemptGross: exemptGross
    };
};
const $ff150a18d4a6f5bb$export$fcb742c279568cce = [
    'Tax-Exempt',
    'Zero-Rated',
    'GST-Free',
    'Exempt',
    'Non-Taxable'
];
const $ff150a18d4a6f5bb$export$d9b10f19e66f377b = function(country) {
    const override = (localStorage.getItem('pointbunny_tax_exempt_label') || '').trim();
    return $ff150a18d4a6f5bb$export$fcb742c279568cce.includes(override) ? override : $ff150a18d4a6f5bb$export$c7585a5a8da068e5(country);
};
const $ff150a18d4a6f5bb$export$c7585a5a8da068e5 = function(country) {
    const c = (country || localStorage.getItem('pointbunny_business_country') || '').toUpperCase();
    if ([
        'AU',
        'NZ'
    ].includes(c)) return 'GST-Free';
    const VAT = [
        'PH',
        'GB',
        'UK',
        'IE',
        'DE',
        'FR',
        'ES',
        'IT',
        'NL',
        'BE',
        'PT',
        'AT',
        'FI',
        'SE',
        'DK',
        'PL',
        'GR',
        'CZ',
        'RO',
        'HU',
        'SK',
        'BG',
        'HR',
        'LT',
        'LV',
        'EE',
        'SI',
        'LU',
        'CY',
        'MT'
    ];
    if (VAT.includes(c)) return 'Zero-Rated';
    return 'Tax-Exempt';
};


// Acquisition-channel attribution: capture ?source=<slug> off a tracking link (generated
// in the admin panel), persist it across the pre-auth signup funnel, and stamp it onto the
// new business at registration. Pure localStorage/sessionStorage helper - no Supabase calls
// here, per the MVC rule that only model.js talks to Supabase (see logRegistrationEvent there).
//
// Latest-channel attribution (2026-10-12, was first-touch): a new ?source= replaces the
// stored one, so a 9-day-old button click can't steal credit from today's outreach email.
// One exception: a marketing-site button slug (site-*) never replaces a real channel
// source - the site already forwards the channel when it knows it, so a site-* arriving
// on top of a stored channel means the visitor came back later without a tracking link.
//
// Backup copy: pointbunny.com also writes the source to a pb_source cookie on
// .pointbunny.com (shared with this subdomain), so the source survives even if the
// ?source= never makes it through to this page's URL.
const $924b6f34e17f8cba$var$VISITOR_KEY = "pointbunny_visitor_id";
const $924b6f34e17f8cba$var$SOURCE_KEY = "pointbunny_source"; // JSON: { source, capturedAt }
const $924b6f34e17f8cba$var$SOURCE_COOKIE = "pb_source"; // set by the marketing site, Domain=.pointbunny.com
const $924b6f34e17f8cba$var$SOURCE_TTL_MS = 2592000000; // 30 days
const $924b6f34e17f8cba$var$FIRED_PREFIX = "pointbunny_src_evt_"; // sessionStorage, one flag per funnel stage
const $924b6f34e17f8cba$var$isExpired = (capturedAt)=>!capturedAt || Date.now() - capturedAt > $924b6f34e17f8cba$var$SOURCE_TTL_MS;
const $924b6f34e17f8cba$var$isButtonSlug = (source)=>/^site-/.test(source);
const $924b6f34e17f8cba$var$readSourceCookie = function() {
    try {
        const match = document.cookie.match(/(?:^|;\s*)pb_source=([^;]*)/);
        return match ? decodeURIComponent(match[1]) || null : null;
    } catch (_) {
        return null;
    }
};
const $924b6f34e17f8cba$var$clearSourceCookie = function() {
    try {
        const domain = window.location.hostname.endsWith("pointbunny.com") ? "; domain=.pointbunny.com" : "";
        document.cookie = `${$924b6f34e17f8cba$var$SOURCE_COOKIE}=; max-age=0; path=/${domain}`;
    } catch (_) {
    // best-effort
    }
};
const $924b6f34e17f8cba$export$d7660cd936a72b71 = function() {
    try {
        let id = localStorage.getItem($924b6f34e17f8cba$var$VISITOR_KEY);
        if (!id) {
            id = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
            localStorage.setItem($924b6f34e17f8cba$var$VISITOR_KEY, id);
        }
        return id;
    } catch (_) {
        return null;
    }
};
const $924b6f34e17f8cba$export$fc9166d79258e815 = function() {
    try {
        const raw = localStorage.getItem($924b6f34e17f8cba$var$SOURCE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if ($924b6f34e17f8cba$var$isExpired(parsed.capturedAt)) {
            localStorage.removeItem($924b6f34e17f8cba$var$SOURCE_KEY);
            return null;
        }
        return parsed;
    } catch (_) {
        return null;
    }
};
const $924b6f34e17f8cba$export$b2a6af0fab9e714e = function() {
    try {
        localStorage.removeItem($924b6f34e17f8cba$var$SOURCE_KEY);
    } catch (_) {
    // best-effort
    }
    $924b6f34e17f8cba$var$clearSourceCookie();
};
const $924b6f34e17f8cba$var$storeSource = function(source) {
    const existing = $924b6f34e17f8cba$export$fc9166d79258e815();
    if (existing?.source === source) return;
    if (existing && $924b6f34e17f8cba$var$isButtonSlug(source) && !$924b6f34e17f8cba$var$isButtonSlug(existing.source)) return;
    localStorage.setItem($924b6f34e17f8cba$var$SOURCE_KEY, JSON.stringify({
        source: source,
        capturedAt: Date.now()
    }));
};
const $924b6f34e17f8cba$export$12d7f2ec382a9c4f = function() {
    try {
        const urlSource = new URLSearchParams(window.location.search).get("source");
        const source = urlSource || $924b6f34e17f8cba$var$readSourceCookie();
        if (source) $924b6f34e17f8cba$var$storeSource(source);
        return urlSource;
    } catch (_) {
        return null;
    }
};
const $924b6f34e17f8cba$export$1b4002943059c46 = function(type) {
    try {
        return sessionStorage.getItem($924b6f34e17f8cba$var$FIRED_PREFIX + type) === "1";
    } catch (_) {
        return false;
    }
};
const $924b6f34e17f8cba$export$9d8e583f7a5c46b6 = function(type) {
    try {
        sessionStorage.setItem($924b6f34e17f8cba$var$FIRED_PREFIX + type, "1");
    } catch (_) {
    // best-effort
    }
};


// What shows on the home screen (2026-10-22). Every feature stays available to
// every business; this only decides which shortcuts the Manage menu and the
// Screens menu show, and which checkout steps are on. Shared by onboarding,
// Settings > Home screen and the Manage menu's Customize mode, so all three
// agree on the list and on what each type of place starts with.
// Type of place, asked in onboarding step 2. Food kinds store
// business_type 'food_beverage' (same value as before, for the admin panel)
// and the kind itself as business_industry.
const $aa52f24595bb637d$export$4ee9af756839e9a2 = [
    {
        id: 'cafe',
        label: "Coffee shop / caf\xe9",
        hint: 'Coffee, tea, light food'
    },
    {
        id: 'restaurant',
        label: 'Restaurant',
        hint: 'Sit-down meals'
    },
    {
        id: 'bakery',
        label: 'Bakery / dessert',
        hint: 'Bread, pastries, sweets'
    },
    {
        id: 'food_truck',
        label: 'Food truck / stall',
        hint: 'Order and go'
    },
    {
        id: 'bar',
        label: 'Bar / juice bar',
        hint: 'Drinks first'
    },
    {
        id: 'other',
        label: 'Something else',
        hint: 'Shops, services, more'
    }
];
const $aa52f24595bb637d$export$eceaf1f7147b66ff = (id)=>$aa52f24595bb637d$export$4ee9af756839e9a2.find((p)=>p.id === id)?.label ?? null;
const $aa52f24595bb637d$export$c9ab7a41fee2db9f = [
    {
        id: 'retail',
        label: 'A shop (products)'
    },
    {
        id: 'service',
        label: 'Services (salon, repair, classes)'
    },
    {
        id: 'other',
        label: 'Something else'
    }
];
const $aa52f24595bb637d$export$72137d7bdce4e014 = [
    {
        key: 'tables',
        group: 'manage',
        label: 'Tables'
    },
    {
        key: 'receipt',
        group: 'manage',
        label: 'Receipt & Tax'
    },
    {
        key: 'promos',
        group: 'manage',
        label: 'Promos'
    },
    {
        key: 'inventory',
        group: 'manage',
        label: 'Inventory',
        pro: true
    },
    {
        key: 'staff',
        group: 'manage',
        label: 'Staff'
    },
    {
        key: 'timesheets',
        group: 'manage',
        label: 'Timesheets',
        pro: true
    },
    {
        key: 'schedule',
        group: 'manage',
        label: 'Schedule'
    },
    {
        key: 'timeclock',
        group: 'manage',
        label: 'Time Clock'
    },
    {
        key: 'reports',
        group: 'manage',
        label: 'Reports',
        pro: true
    },
    {
        key: 'loyalty',
        group: 'manage',
        label: 'Loyalty',
        pro: true
    },
    {
        key: 'kds',
        group: 'screens',
        label: 'Queue Screen',
        hint: 'Orders for the kitchen'
    },
    {
        key: 'cfd',
        group: 'screens',
        label: 'Customer Screen',
        hint: 'Faces the customer at the counter'
    },
    {
        key: 'pickup',
        group: 'screens',
        label: 'Pickup Screen',
        hint: '"Your order is ready" board'
    }
];
const $aa52f24595bb637d$export$5e14f249708a7895 = [
    'off',
    'numbers',
    'full'
];
// The suggested setup for each type of place. `hidden` lists HOME_ITEMS keys
// left off the menus. The Tables shortcut also needs table service on.
const $aa52f24595bb637d$var$SUGGESTED = {
    cafe: {
        orderType: true,
        tips: true,
        tables: 'numbers',
        waitlist: false,
        reservations: false,
        hidden: [
            'inventory'
        ]
    },
    restaurant: {
        orderType: true,
        tips: true,
        tables: 'full',
        waitlist: true,
        reservations: true,
        hidden: [
            'pickup'
        ]
    },
    bakery: {
        orderType: true,
        tips: true,
        tables: 'off',
        waitlist: false,
        reservations: false,
        hidden: []
    },
    food_truck: {
        orderType: false,
        tips: true,
        tables: 'off',
        waitlist: false,
        reservations: false,
        hidden: [
            'inventory'
        ]
    },
    bar: {
        orderType: true,
        tips: true,
        tables: 'numbers',
        waitlist: false,
        reservations: false,
        hidden: [
            'inventory'
        ]
    },
    other: {
        orderType: false,
        tips: false,
        tables: 'off',
        waitlist: false,
        reservations: false,
        hidden: [
            'kds',
            'pickup'
        ]
    }
};
const $aa52f24595bb637d$export$1df807e10c721ac1 = (placeType)=>{
    const s = $aa52f24595bb637d$var$SUGGESTED[placeType] ?? $aa52f24595bb637d$var$SUGGESTED.other;
    return {
        orderTypeEnabled: s.orderType,
        tipsEnabled: s.tips,
        tableService: s.tables,
        waitlistEnabled: s.waitlist,
        reservationsEnabled: s.reservations,
        homeHidden: [
            ...s.hidden
        ]
    };
};
const $aa52f24595bb637d$export$828e33864f81b452 = (list)=>{
    const known = new Set($aa52f24595bb637d$export$72137d7bdce4e014.map((i)=>i.key));
    return [
        ...new Set((Array.isArray(list) ? list : []).filter((k)=>known.has(k)))
    ];
};



var $5ni8Y = parcelRequire("5ni8Y");
// Booking rules + waitlist quote buttons (Kelly, 2026-10-24). Business
// settings, owner-only (migration-2026-10-24-booking-rules.sql). Defaults keep
// the old fixed behaviour (7am-10pm every day, 30-minute slots, 90-minute
// hold, 5-45 minute quotes) until the owner changes them in Settings > Home
// screen. The forms still take any time, party size or wait as a one-off.
const $3c9e88a543a9da6a$export$32c1f2e7a501558d = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];
const $3c9e88a543a9da6a$export$cf623d56a0c35766 = [
    15,
    30,
    60
];
const $3c9e88a543a9da6a$export$6514d0358cc584b6 = [
    45,
    60,
    90,
    120,
    150,
    180
];
const $3c9e88a543a9da6a$export$e3a3683ed7186e9b = {
    hours: $3c9e88a543a9da6a$export$32c1f2e7a501558d.map(()=>({
            on: true,
            from: '07:00',
            to: '22:00'
        })),
    slotMin: 30,
    holdMin: 90,
    bigPartySize: null,
    bigPartyHoldMin: 120
};
const $3c9e88a543a9da6a$export$78a2a13284d3c159 = [
    5,
    10,
    15,
    20,
    30,
    45
];
const $3c9e88a543a9da6a$export$7d3dcc20d590cb17 = [
    1,
    2,
    3,
    4,
    5,
    6,
    8,
    10
];
const $3c9e88a543a9da6a$var$clampInt = (v, lo, hi, def)=>{
    const n = Math.round(Number(v));
    return Number.isFinite(n) && n >= lo && n <= hi ? n : def;
};
const $3c9e88a543a9da6a$var$cleanTime = (v, def)=>/^([01]\d|2[0-3]):[0-5]\d$/.test(String(v ?? '')) ? String(v) : def;
const $3c9e88a543a9da6a$export$4a79f0068700788b = (hhmm)=>{
    const [h, m] = String(hhmm).split(':').map(Number);
    return h * 60 + (m || 0);
};
const $3c9e88a543a9da6a$export$2573b0584d6d05ea = (mins)=>`${String(Math.floor(mins / 60)).padStart(2, '0')}:${String(mins % 60).padStart(2, '0')}`;
function $3c9e88a543a9da6a$export$563b887d60cfe137(v) {
    let raw = v;
    if (typeof v === 'string') try {
        raw = JSON.parse(v);
    } catch  {
        raw = null;
    }
    const d = $3c9e88a543a9da6a$export$e3a3683ed7186e9b;
    if (!raw || typeof raw !== 'object') return structuredClone(d);
    const hours = $3c9e88a543a9da6a$export$32c1f2e7a501558d.map((_, i)=>{
        const h = Array.isArray(raw.hours) ? raw.hours[i] : null;
        return {
            on: h?.on !== false,
            from: $3c9e88a543a9da6a$var$cleanTime(h?.from, d.hours[i].from),
            to: $3c9e88a543a9da6a$var$cleanTime(h?.to, d.hours[i].to)
        };
    });
    const big = raw.bigPartySize == null ? null : $3c9e88a543a9da6a$var$clampInt(raw.bigPartySize, 2, 99, null);
    return {
        hours: hours,
        slotMin: $3c9e88a543a9da6a$export$cf623d56a0c35766.includes(Number(raw.slotMin)) ? Number(raw.slotMin) : d.slotMin,
        holdMin: $3c9e88a543a9da6a$var$clampInt(raw.holdMin, 15, 600, d.holdMin),
        bigPartySize: big,
        bigPartyHoldMin: $3c9e88a543a9da6a$var$clampInt(raw.bigPartyHoldMin, 15, 600, d.bigPartyHoldMin)
    };
}
function $3c9e88a543a9da6a$export$9fda4dae54e434b4(v) {
    const list = (Array.isArray(v) ? v : String(v ?? '').split(',')).map((n)=>Math.round(Number(n))).filter((n)=>Number.isFinite(n) && n >= 1 && n <= 600);
    const unique = [
        ...new Set(list)
    ].sort((a, b)=>a - b).slice(0, 8);
    return unique.length ? unique : [
        ...$3c9e88a543a9da6a$export$78a2a13284d3c159
    ];
}
function $3c9e88a543a9da6a$export$e9b1c15965e391ae(rules, weekday) {
    const day = rules.hours[weekday];
    if (!day?.on) return [];
    const from = $3c9e88a543a9da6a$export$4a79f0068700788b(day.from), to = $3c9e88a543a9da6a$export$4a79f0068700788b(day.to);
    const out = [];
    for(let m = from; m <= to; m += rules.slotMin)out.push(`${Math.floor(m / 60)}:${m % 60}`);
    return out;
}
const $3c9e88a543a9da6a$export$505ac917808ea098 = (rules, partySize)=>rules.bigPartySize && partySize >= rules.bigPartySize ? rules.bigPartyHoldMin : rules.holdMin;
const $3c9e88a543a9da6a$export$6983ec1528bb4f57 = (mins)=>{
    const h = Math.floor(mins / 60), m = mins % 60;
    if (!h) return `${m} min`;
    return m ? `${h} hr ${m} min` : `${h} hr${h > 1 ? 's' : ''}`;
};



var $lDSCx = parcelRequire("lDSCx");
// The business timezone from its address (2026-10-24). The timezone used to
// come only from the owner's device at first login, so an account created on
// a browser running in UTC (a test machine, a cloud browser) planned the whole
// day in UTC: in Portland, "today" flipped to tomorrow at 5pm. A US address
// now decides the zone; the device is only a fallback, and UTC never sticks.
// States that span two zones use the zone most of the state lives in; the
// owner can still pick the exact one in Settings > Business.
const $3c92721278bd64e4$var$STATE_TZ = {
    AL: 'America/Chicago',
    AK: 'America/Anchorage',
    AZ: 'America/Phoenix',
    AR: 'America/Chicago',
    CA: 'America/Los_Angeles',
    CO: 'America/Denver',
    CT: 'America/New_York',
    DE: 'America/New_York',
    DC: 'America/New_York',
    FL: 'America/New_York',
    GA: 'America/New_York',
    HI: 'Pacific/Honolulu',
    ID: 'America/Boise',
    IL: 'America/Chicago',
    IN: 'America/Indiana/Indianapolis',
    IA: 'America/Chicago',
    KS: 'America/Chicago',
    KY: 'America/New_York',
    LA: 'America/Chicago',
    ME: 'America/New_York',
    MD: 'America/New_York',
    MA: 'America/New_York',
    MI: 'America/Detroit',
    MN: 'America/Chicago',
    MS: 'America/Chicago',
    MO: 'America/Chicago',
    MT: 'America/Denver',
    NE: 'America/Chicago',
    NV: 'America/Los_Angeles',
    NH: 'America/New_York',
    NJ: 'America/New_York',
    NM: 'America/Denver',
    NY: 'America/New_York',
    NC: 'America/New_York',
    ND: 'America/Chicago',
    OH: 'America/New_York',
    OK: 'America/Chicago',
    OR: 'America/Los_Angeles',
    PA: 'America/New_York',
    RI: 'America/New_York',
    SC: 'America/New_York',
    SD: 'America/Chicago',
    TN: 'America/Chicago',
    TX: 'America/Chicago',
    UT: 'America/Denver',
    VT: 'America/New_York',
    VA: 'America/New_York',
    WA: 'America/Los_Angeles',
    WV: 'America/New_York',
    WI: 'America/Chicago',
    WY: 'America/Denver',
    PR: 'America/Puerto_Rico',
    GU: 'Pacific/Guam',
    VI: 'America/St_Thomas',
    AS: 'Pacific/Pago_Pago',
    MP: 'Pacific/Saipan'
};
const $3c92721278bd64e4$var$NAME_TO_CODE = {
    alabama: 'AL',
    alaska: 'AK',
    arizona: 'AZ',
    arkansas: 'AR',
    california: 'CA',
    colorado: 'CO',
    connecticut: 'CT',
    delaware: 'DE',
    'district of columbia': 'DC',
    florida: 'FL',
    georgia: 'GA',
    hawaii: 'HI',
    idaho: 'ID',
    illinois: 'IL',
    indiana: 'IN',
    iowa: 'IA',
    kansas: 'KS',
    kentucky: 'KY',
    louisiana: 'LA',
    maine: 'ME',
    maryland: 'MD',
    massachusetts: 'MA',
    michigan: 'MI',
    minnesota: 'MN',
    mississippi: 'MS',
    missouri: 'MO',
    montana: 'MT',
    nebraska: 'NE',
    nevada: 'NV',
    'new hampshire': 'NH',
    'new jersey': 'NJ',
    'new mexico': 'NM',
    'new york': 'NY',
    'north carolina': 'NC',
    'north dakota': 'ND',
    ohio: 'OH',
    oklahoma: 'OK',
    oregon: 'OR',
    pennsylvania: 'PA',
    'rhode island': 'RI',
    'south carolina': 'SC',
    'south dakota': 'SD',
    tennessee: 'TN',
    texas: 'TX',
    utah: 'UT',
    vermont: 'VT',
    virginia: 'VA',
    washington: 'WA',
    'west virginia': 'WV',
    wisconsin: 'WI',
    wyoming: 'WY',
    'puerto rico': 'PR',
    guam: 'GU'
};
const $3c92721278bd64e4$export$2c148b0cc193b767 = (tz)=>/^(etc\/)?(utc|gmt|uct|zulu|universal)(\+0|-0|0)?$/i.test(String(tz || ''));
function $3c92721278bd64e4$export$ca7e9b4e79cae562(country, province) {
    const c = String(country || '').trim().toUpperCase();
    if (c && c !== 'US' && c !== 'USA' && c !== 'UNITED STATES') return null;
    const p = String(province || '').trim();
    if (!p) return null;
    const code = p.length === 2 ? p.toUpperCase() : $3c92721278bd64e4$var$NAME_TO_CODE[p.toLowerCase()];
    return $3c92721278bd64e4$var$STATE_TZ[code] ?? null;
}
// Minutes from UTC for a zone right now (-420 for Los Angeles in summer), or null.
const $3c92721278bd64e4$var$offsetMinutes = (tz, at = new Date())=>{
    try {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            hourCycle: 'h23',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        }).formatToParts(at);
        const v = Object.fromEntries(parts.map((p)=>[
                p.type,
                Number(p.value)
            ]));
        return Math.round((Date.UTC(v.year, v.month - 1, v.day, v.hour, v.minute) - at.getTime()) / 60000);
    } catch  {
        return null;
    }
};
function $3c92721278bd64e4$export$81ce5941ae3d1849(savedTz, addressTz) {
    if (!savedTz || !addressTz || savedTz === addressTz) return true;
    if ($3c92721278bd64e4$export$2c148b0cc193b767(savedTz)) return false;
    const a = $3c92721278bd64e4$var$offsetMinutes(savedTz);
    const b = $3c92721278bd64e4$var$offsetMinutes(addressTz);
    if (a == null) return false; // not a real zone name
    return b == null || Math.abs(a - b) <= 60;
}


// Legacy "no image" rows stored a path that never resolves in production; treat
// them (and NULL) as "no image" so the view applies DEFAULT_ITEM_IMAGE instead.
const $1e7ab04ca7920cff$var$isMissingImage = (url)=>!url || url.includes("default image.png");
let $1e7ab04ca7920cff$var$adjCounter = 0;
const $1e7ab04ca7920cff$var$safeParse = (str, fallback)=>{
    if (str == null) return fallback;
    try {
        return JSON.parse(str);
    } catch  {
        return fallback;
    }
};
const $1e7ab04ca7920cff$var$generateAdjustmentId = function() {
    $1e7ab04ca7920cff$var$adjCounter += 1;
    return `adj_${Date.now()}-${$1e7ab04ca7920cff$var$adjCounter}`;
};
const $1e7ab04ca7920cff$export$b7d7c1ca35c782a2 = [
    15,
    18,
    20
];
function $1e7ab04ca7920cff$export$8d14d72645a70eef(v) {
    const list = (Array.isArray(v) ? v : String(v ?? '').split(',')).map((n)=>Math.round(Number(n))).filter((n)=>Number.isFinite(n) && n >= 1 && n <= 100).slice(0, 3);
    return list.length ? list : [
        ...$1e7ab04ca7920cff$export$b7d7c1ca35c782a2
    ];
}
function $1e7ab04ca7920cff$export$a6bf297b0d9b5f16(v) {
    return (0, $aa52f24595bb637d$export$828e33864f81b452)(Array.isArray(v) ? v : String(v ?? '').split(','));
}
function $1e7ab04ca7920cff$export$6cbb1b50f2e190a5(v) {
    return (0, $aa52f24595bb637d$export$5e14f249708a7895).includes(v) ? v : 'off';
}
const $1e7ab04ca7920cff$export$ca000e230c0caa3e = {
    userId: null,
    businessId: null,
    businessName: null,
    businessEmail: null,
    businessPhone: null,
    businessTimezone: null,
    username: "Wowa",
    role: null,
    permissions: null,
    subscriptionStatus: 'free',
    subscriptionPortalUrl: null,
    subscriptionRenewsAt: null,
    trialEndsAt: null,
    trialGrantedBy: null,
    currentStaff: null,
    currentCashier: null,
    staff: [],
    roles: [],
    menuItems: [],
    deletedItems: [],
    menuCategories: [],
    scheduleStations: [],
    scheduledShifts: [],
    scheduleSeries: [],
    staffAvailability: [],
    scheduleLeave: [],
    shiftRequests: [],
    inventoryItems: [],
    inventoryLinks: [],
    inventoryAdjustments: [],
    suppliers: [],
    itemSuppliers: [],
    purchaseOrders: [],
    employees: [],
    cart: [],
    orderQueue: [],
    salesBasket: [],
    cashflowSales: [],
    voidedSales: [],
    tickets: [],
    reportsSales: [],
    expenses: [],
    discountCodes: [],
    loyaltyRewards: [],
    currentPromoCode: null,
    currentLoyaltyCustomer: null,
    currentLoyaltyRedemption: null,
    // Tables (2026-10-22): floor plan, open tabs, today's bookings, waitlist.
    diningTables: [],
    openTabs: [],
    reservations: [],
    waitlist: [],
    shifts: [],
    shiftEditRequests: [],
    currentShift: null,
    settings: {
        adjustments: [],
        showRemovedAdjustments: true,
        printingEnabled: localStorage.getItem('pointbunny_printing_enabled') !== 'false',
        confirmPrint: localStorage.getItem('pointbunny_confirm_print') !== 'false',
        kdsYellowThreshold: parseInt(localStorage.getItem('pointbunny_kds_yellow') || '600'),
        kdsRedThreshold: parseInt(localStorage.getItem('pointbunny_kds_red') || '900'),
        kdsAutoCompleteThreshold: parseInt(localStorage.getItem('pointbunny_kds_auto') || '3600'),
        kdsWindowSize: $1e7ab04ca7920cff$var$safeParse(localStorage.getItem('pointbunny_kds_window_size'), {
            width: 1920,
            height: 1080
        }),
        cfdWindowSize: $1e7ab04ca7920cff$var$safeParse(localStorage.getItem('pointbunny_cfd_window_size'), {
            width: 1920,
            height: 1080
        }),
        orderTypeEnabled: localStorage.getItem('pointbunny_order_type_enabled') !== 'false',
        showCashierName: localStorage.getItem('pointbunny_show_cashier') !== 'false',
        showInvoiceNumber: localStorage.getItem('pointbunny_show_invoice_number') !== 'false',
        showTicketNumber: localStorage.getItem('pointbunny_show_ticket_number') !== 'false',
        showBusinessPhone: localStorage.getItem('pointbunny_show_business_phone') !== 'false',
        receiptFooter: localStorage.getItem('pointbunny_receipt_footer') || '',
        receiptQrUrl: localStorage.getItem('pointbunny_receipt_qr_url') || '',
        // taxMode is the source of truth ('none'|'exclusive'|'inclusive'); taxInclusive
        // is kept in sync (== taxMode === 'inclusive') purely so the many existing
        // consumers that already check the boolean don't need to change. Default is
        // 'none' - safest assumption for a business that hasn't configured tax at all.
        taxMode: localStorage.getItem('pointbunny_tax_mode') || 'none',
        taxInclusive: localStorage.getItem('pointbunny_tax_inclusive') === 'true',
        taxInclusiveRate: parseFloat(localStorage.getItem('pointbunny_tax_inclusive_rate')) || 12,
        taxInclusiveLabel: localStorage.getItem('pointbunny_tax_label') || null,
        taxExemptLabel: localStorage.getItem('pointbunny_tax_exempt_label') || null,
        cfdAdUrl: localStorage.getItem('pointbunny_cfd_ad') || null,
        cfdQrUrl: localStorage.getItem('pointbunny_cfd_qr') || null,
        pickupAdUrl: localStorage.getItem('pointbunny_pickup_ad') || null,
        tipsEnabled: localStorage.getItem('pointbunny_tips_enabled') === 'true',
        tipPresets: $1e7ab04ca7920cff$export$8d14d72645a70eef(localStorage.getItem('pointbunny_tip_presets')),
        tipQrUrl: localStorage.getItem('pointbunny_tip_qr') || null,
        tipPoolRoleIds: (()=>{
            const v = localStorage.getItem('pointbunny_tip_pool_roles');
            return v == null ? null : v === '' ? [] : v.split(',');
        })(),
        hideStatsFromStaff: localStorage.getItem('pointbunny_hide_stats_staff') === 'true',
        gettingStartedDismissed: localStorage.getItem('pointbunny_checklist_dismissed') === 'true',
        gettingStartedCompleted: localStorage.getItem('pointbunny_checklist_completed') === 'true',
        receiptSetupSeen: localStorage.getItem('pointbunny_receipt_setup_seen') === 'true',
        taxSetupSeen: localStorage.getItem('pointbunny_tax_setup_seen') === 'true',
        teamSetupSeen: localStorage.getItem('pointbunny_team_setup_seen') === 'true',
        inventorySetupSeen: localStorage.getItem('pointbunny_inventory_setup_seen') === 'true',
        loyaltyEnabled: localStorage.getItem('pointbunny_loyalty_enabled') === 'true',
        loyaltyEarnRate: parseFloat(localStorage.getItem('pointbunny_loyalty_earn_rate')) || 0.1,
        loyaltyEarnAmount: parseFloat(localStorage.getItem('pointbunny_loyalty_earn_amount')) || 1,
        loyaltyRedeemPoints: parseInt(localStorage.getItem('pointbunny_loyalty_redeem_points')) || 100,
        loyaltyRedeemValue: parseFloat(localStorage.getItem('pointbunny_loyalty_redeem_value')) || 5,
        inventoryEnabled: localStorage.getItem('pointbunny_inventory_enabled') !== 'false',
        placeType: localStorage.getItem('pointbunny_place_type') || null,
        homeHidden: $1e7ab04ca7920cff$export$a6bf297b0d9b5f16(localStorage.getItem('pointbunny_home_hidden')),
        tableService: $1e7ab04ca7920cff$export$6cbb1b50f2e190a5(localStorage.getItem('pointbunny_table_service')),
        waitlistEnabled: localStorage.getItem('pointbunny_waitlist_enabled') === 'true',
        reservationsEnabled: localStorage.getItem('pointbunny_reservations_enabled') === 'true',
        bookingRules: (0, $3c9e88a543a9da6a$export$563b887d60cfe137)(localStorage.getItem('pointbunny_booking_rules')),
        waitlistQuotes: (0, $3c9e88a543a9da6a$export$9fda4dae54e434b4)(localStorage.getItem('pointbunny_waitlist_quotes'))
    },
    currentReceiptAdjustments: [],
    needsOnboarding: false,
    businessType: null,
    businessIndustry: null,
    businessAddressStreet: null,
    businessAddressCity: null,
    businessAddressProvince: null,
    businessAddressZip: null,
    businessAddressCountry: null
};
const $1e7ab04ca7920cff$export$e41c6d066ef1eec8 = [
    'use_timeclock',
    'take_orders',
    'view_catalogue',
    'apply_receipt_adjustment',
    'use_loyalty',
    'manage_menu',
    'manage_inventory',
    'manage_adjustments',
    'manage_discounts',
    'manage_loyalty',
    'void_sale',
    'manage_cashflow',
    'view_reports',
    'view_activity_log',
    'manage_pay',
    'manage_schedule',
    'manage_staff',
    'reset_staff_mfa',
    'manage_roles',
    'manage_business'
];
const $1e7ab04ca7920cff$export$b2b8d7ade24d9564 = {
    use_timeclock: 'Clock in & out',
    take_orders: 'Take orders & checkout',
    view_catalogue: 'Browse menu',
    apply_receipt_adjustment: 'Apply one-off receipt adjustments',
    use_loyalty: 'Use loyalty at checkout',
    manage_menu: 'Manage menu & categories',
    manage_inventory: 'Manage inventory & stock',
    manage_adjustments: 'Manage fees & adjustments',
    manage_discounts: 'Manage discount codes',
    manage_loyalty: 'Manage loyalty program',
    void_sale: 'Void & refund sales',
    manage_cashflow: 'View cashflow & expenses',
    view_reports: 'View reports',
    view_activity_log: 'View activity log',
    manage_pay: 'Manage shifts & pay rates',
    manage_schedule: 'Build & publish the schedule',
    manage_staff: 'Manage staff',
    reset_staff_mfa: 'Remove staff 2FA',
    manage_roles: 'Manage roles & access',
    manage_business: 'Manage business settings'
};
const $1e7ab04ca7920cff$export$62f846a6201d7c64 = {
    use_timeclock: 'Clock in and out for shifts on the time clock.',
    take_orders: 'Create new orders and take payment at checkout.',
    view_catalogue: 'Browse the menu while taking orders.',
    apply_receipt_adjustment: 'Add or remove a one-off fee or discount on a single receipt at checkout.',
    use_loyalty: 'Enroll customers in the loyalty program and redeem their points at checkout.',
    manage_menu: 'Add, edit, and remove menu items and categories.',
    manage_inventory: 'Track stock levels, restock items, and link products to inventory.',
    manage_adjustments: 'Set up taxes, service fees, and auto-applied receipt adjustments.',
    manage_discounts: 'Create, pause, edit, and delete promo / discount codes.',
    manage_loyalty: 'Configure the loyalty program and view the customer list.',
    void_sale: 'Void or refund completed sales.',
    manage_cashflow: 'Open the activity panel and record expenses.',
    view_reports: 'View the reports and analytics dashboard.',
    view_activity_log: 'See the home page activity feed of recent sales, shifts, and stock events.',
    manage_pay: 'Edit staff shifts and hourly pay rates.',
    manage_schedule: 'Plan the week, add and edit scheduled shifts, manage stations, and publish the schedule to staff.',
    manage_staff: 'Invite, edit, and remove staff members.',
    reset_staff_mfa: "Turn off a staff member's two-factor authentication when they've lost their authenticator and recovery codes. Done from the Staff panel, so the role also needs Manage staff.",
    manage_roles: 'Create roles and choose what each one can access.',
    manage_business: 'Change business details and settings.'
};
const $1e7ab04ca7920cff$export$40d95c19a7e19d13 = [
    {
        label: 'Time Clock',
        keys: [
            'use_timeclock'
        ]
    },
    {
        label: 'Sales & Checkout',
        keys: [
            'take_orders',
            'view_catalogue',
            'apply_receipt_adjustment',
            'use_loyalty',
            'void_sale'
        ]
    },
    {
        label: 'Menu & Promotions',
        keys: [
            'manage_menu',
            'manage_inventory',
            'manage_adjustments',
            'manage_discounts',
            'manage_loyalty'
        ]
    },
    {
        label: 'Reports & Money',
        keys: [
            'view_reports',
            'manage_cashflow',
            'view_activity_log'
        ]
    },
    {
        label: 'Team & Business',
        keys: [
            'manage_pay',
            'manage_schedule',
            'manage_staff',
            'reset_staff_mfa',
            'manage_roles',
            'manage_business'
        ]
    }
];
const $1e7ab04ca7920cff$export$56b2c64857920c31 = {
    Staff: [
        'use_timeclock'
    ],
    Cashier: [
        'use_timeclock',
        'take_orders',
        'view_catalogue',
        'apply_receipt_adjustment',
        'use_loyalty'
    ],
    Manager: [
        'use_timeclock',
        'take_orders',
        'view_catalogue',
        'apply_receipt_adjustment',
        'use_loyalty',
        'manage_menu',
        'manage_inventory',
        'manage_adjustments',
        'manage_discounts',
        'manage_loyalty',
        'void_sale',
        'manage_cashflow',
        'view_reports',
        'manage_schedule'
    ],
    Admin: [
        ...$1e7ab04ca7920cff$export$e41c6d066ef1eec8
    ]
};
const $1e7ab04ca7920cff$export$8cd565f5f8a26955 = 'Admin';
const $1e7ab04ca7920cff$export$f92875a0bb941a70 = (caps)=>Object.fromEntries((caps ?? []).map((k)=>[
            k,
            true
        ]));
const $1e7ab04ca7920cff$export$94cfe010e61a30ec = function(roleName, permissionsJson) {
    const obj = permissionsJson && typeof permissionsJson === 'object' ? permissionsJson : {};
    if (roleName === $1e7ab04ca7920cff$export$8cd565f5f8a26955) return new Set($1e7ab04ca7920cff$export$e41c6d066ef1eec8);
    const stored = $1e7ab04ca7920cff$export$e41c6d066ef1eec8.filter((k)=>obj[k] === true);
    if (stored.length > 0) return new Set(stored);
    return new Set($1e7ab04ca7920cff$export$56b2c64857920c31[roleName] ?? []);
};
const $1e7ab04ca7920cff$export$b325ec6732b039cf = function(key) {
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.userId && $1e7ab04ca7920cff$export$ca000e230c0caa3e.userId === $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId) return true;
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.permissions instanceof Set ? $1e7ab04ca7920cff$export$ca000e230c0caa3e.permissions.has(key) : false;
};
const $1e7ab04ca7920cff$export$c49d59850b41914f = {
    inventory: {
        title: 'Inventory',
        blurb: 'Track stock levels, get low-stock alerts, and manage suppliers & purchase orders.',
        bullets: [
            'Real-time stock tracking',
            'Low & out-of-stock alerts',
            'Suppliers & purchase orders',
            'Stock counts'
        ]
    },
    timesheets: {
        title: 'Timesheets',
        blurb: 'Review staff shifts, hours, and time-off requests in one place.',
        bullets: [
            'Shift & hours history',
            'Time-clock device management',
            'Shift correction inbox',
            'Leave requests'
        ]
    },
    loyalty: {
        title: 'Loyalty',
        blurb: 'Reward repeat customers with a points program and free-item rewards.',
        bullets: [
            'Points on every sale',
            'Free-item reward catalog',
            'Customer purchase streaks',
            'Member lookup at checkout'
        ]
    },
    reports: {
        title: 'Reports',
        blurb: 'Full sales, traffic, and kitchen analytics - beyond today\'s at-a-glance numbers.',
        bullets: [
            'Multi-day & custom date ranges',
            'Compare period vs. period',
            'Top items, categories & staff',
            'Peak hours & serving-time trends'
        ]
    }
};
const $1e7ab04ca7920cff$export$8e5b3aa3ef378964 = function() {
    return Boolean($1e7ab04ca7920cff$export$ca000e230c0caa3e.trialEndsAt) && new Date($1e7ab04ca7920cff$export$ca000e230c0caa3e.trialEndsAt) > new Date();
};
const $1e7ab04ca7920cff$export$9e608bbc985290d4 = function() {
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.subscriptionStatus === 'paid' || $1e7ab04ca7920cff$export$8e5b3aa3ef378964();
};
const $1e7ab04ca7920cff$export$57b484963858c9a0 = function(feature) {
    return !$1e7ab04ca7920cff$export$9e608bbc985290d4();
};
let $1e7ab04ca7920cff$var$_planChangeChannel = null;
const $1e7ab04ca7920cff$export$fc852ad46d64cd99 = function(businessId, onChange) {
    if ($1e7ab04ca7920cff$var$_planChangeChannel) return;
    $1e7ab04ca7920cff$var$_planChangeChannel = (0, $asfCf.supabase).channel('business-subscription-' + businessId).on('postgres_changes', {
        event: 'UPDATE',
        schema: 'public',
        table: 'businesses',
        filter: `id=eq.${businessId}`
    }, ({ new: updated })=>{
        const wasPaid = $1e7ab04ca7920cff$export$ca000e230c0caa3e.subscriptionStatus === 'paid';
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.subscriptionStatus = updated.subscription_status === 'paid' ? 'paid' : 'free';
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.subscriptionPortalUrl = updated.ls_customer_portal_url ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.subscriptionRenewsAt = updated.ls_renews_at ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.trialEndsAt = updated.trial_ends_at ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.trialGrantedBy = updated.trial_granted_by ?? null;
        onChange?.({
            becamePaid: !wasPaid && $1e7ab04ca7920cff$export$ca000e230c0caa3e.subscriptionStatus === 'paid'
        });
    }).subscribe();
};
const $1e7ab04ca7920cff$export$fe2712503435365b = function() {
    if (!$1e7ab04ca7920cff$var$_planChangeChannel) return;
    (0, $asfCf.supabase).removeChannel($1e7ab04ca7920cff$var$_planChangeChannel);
    $1e7ab04ca7920cff$var$_planChangeChannel = null;
};
// ── Concurrent session tracking (no cap on any plan) ───────────────────────────
// 2026-10-15 (Kelly): every plan, Free included, gets unlimited concurrent
// sessions - growth over upsell for now (migration-2026-10-15-free-unlimited-
// sessions.sql). Before that, Free was capped at 1 and Pro/trial was unlimited
// (2026-09-19). A "session" is one browser tab holding a real auth session -
// the main POS app and the time-clock kiosk; KDS/CFD/Pickup popups never
// authenticate. Sessions are still claimed + heartbeated so active_sessions
// stays a live "who's online" list, and the block path below is kept in case a
// cap ever comes back. claim_session() is the source of truth and today never
// returns { ok:false }.
// One id per browser TAB (sessionStorage, not localStorage) so two tabs on the
// same device count as two sessions, matching "concurrent session" intent. Reused
// across a reload of the same tab so re-claiming updates the existing row instead
// of counting twice.
const $1e7ab04ca7920cff$var$_sessionDeviceId = function() {
    let id = sessionStorage.getItem('pointbunny_session_device_id');
    if (!id) {
        id = typeof crypto?.randomUUID === 'function' ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        sessionStorage.setItem('pointbunny_session_device_id', id);
    }
    return id;
};
let $1e7ab04ca7920cff$var$_heartbeatHandle = null;
// Cached opportunistically (after claim + every heartbeat) so a pagehide
// listener can fire a release without awaiting an async getSession() call
// during unload, when a promise isn't reliably given time to resolve.
let $1e7ab04ca7920cff$var$_cachedAccessToken = null;
const $1e7ab04ca7920cff$var$_refreshCachedToken = async function() {
    try {
        const { data: data } = await (0, $asfCf.supabase).auth.getSession();
        $1e7ab04ca7920cff$var$_cachedAccessToken = data?.session?.access_token ?? null;
    } catch (_) {}
};
// Builds the blocked-sign-in message from the RPC's { blocked_by, cap }.
// Unreachable today (no plan has a cap) - defensive fallback only.
const $1e7ab04ca7920cff$var$_sessionLimitMessage = function(data) {
    const who = data?.blocked_by || 'Someone';
    const cap = data?.cap ?? 1;
    return `You've reached the limit of ${cap} signed-in session${cap === 1 ? '' : 's'} (${who} is one of them). Sign out on another device and try again.`;
};
const $1e7ab04ca7920cff$export$71e40b4acba264d1 = async function(businessId, displayName, source) {
    try {
        const { data: data, error: error } = await (0, $asfCf.supabase).rpc('claim_session', {
            p_business_id: businessId,
            p_device_id: $1e7ab04ca7920cff$var$_sessionDeviceId(),
            p_display_name: displayName,
            p_source: source
        });
        if (error) {
            console.warn('claimSession RPC error (allowing sign-in):', error);
            return;
        }
        if (data && data.ok === false) {
            const err = new Error($1e7ab04ca7920cff$var$_sessionLimitMessage(data));
            err.code = 'SESSION_LIMIT_REACHED';
            throw err;
        }
        $1e7ab04ca7920cff$var$_refreshCachedToken();
    } catch (err) {
        if (err.code === 'SESSION_LIMIT_REACHED') throw err;
        console.warn('claimSession failed (allowing sign-in):', err);
    }
};
const $1e7ab04ca7920cff$export$abf150cd98793bd7 = function(businessId) {
    $1e7ab04ca7920cff$export$98a9f4e27691a820();
    $1e7ab04ca7920cff$var$_heartbeatHandle = setInterval(async ()=>{
        // supabase.rpc(...) returns a PostgrestFilterBuilder, not a plain Promise -
        // it has no .catch() method, so chaining .catch() directly threw a
        // TypeError on every tick (silently killing the heartbeat entirely - found
        // 2026-09-19 when sessions kept expiring exactly 3 minutes after claiming
        // regardless of activity, since last_seen_at was never actually refreshed).
        try {
            await (0, $asfCf.supabase).rpc('touch_session', {
                p_business_id: businessId,
                p_device_id: $1e7ab04ca7920cff$var$_sessionDeviceId()
            });
        } catch (_) {}
        $1e7ab04ca7920cff$var$_refreshCachedToken();
    }, 90000);
};
const $1e7ab04ca7920cff$export$98a9f4e27691a820 = function() {
    if ($1e7ab04ca7920cff$var$_heartbeatHandle) {
        clearInterval($1e7ab04ca7920cff$var$_heartbeatHandle);
        $1e7ab04ca7920cff$var$_heartbeatHandle = null;
    }
};
const $1e7ab04ca7920cff$export$e0703741ca0737e0 = async function(businessId) {
    $1e7ab04ca7920cff$export$98a9f4e27691a820();
    $1e7ab04ca7920cff$var$_cachedAccessToken = null; // the auth token is about to be revoked by sign-out
    try {
        await (0, $asfCf.supabase).rpc('release_session', {
            p_business_id: businessId,
            p_device_id: $1e7ab04ca7920cff$var$_sessionDeviceId()
        });
    } catch (_) {}
};
const $1e7ab04ca7920cff$export$7573d0868ee8d901 = function(businessId) {
    window.addEventListener('pagehide', ()=>{
        if (!$1e7ab04ca7920cff$var$_cachedAccessToken) return;
        try {
            fetch(`${(0, $asfCf.supabaseUrl)}/rest/v1/rpc/release_session`, {
                method: 'POST',
                keepalive: true,
                headers: {
                    'Content-Type': 'application/json',
                    apikey: (0, $asfCf.supabaseAnonKey),
                    Authorization: `Bearer ${$1e7ab04ca7920cff$var$_cachedAccessToken}`
                },
                body: JSON.stringify({
                    p_business_id: businessId,
                    p_device_id: $1e7ab04ca7920cff$var$_sessionDeviceId()
                })
            });
        } catch (_) {}
    });
};
const $1e7ab04ca7920cff$export$bfea9f214c7ec36 = async function(eventType, { sourceId: sourceId, sessionId: sessionId, businessId: businessId = null } = {}) {
    if (!sourceId || !sessionId) return;
    try {
        await (0, $asfCf.supabase).from('registration_events').insert({
            source_id: sourceId,
            event_type: eventType,
            session_id: sessionId,
            business_id: businessId
        });
    } catch (_) {
    // best-effort only
    }
};
// ── Business context (runs on every login) ────────────────────────────────────
const $1e7ab04ca7920cff$var$_initBusiness = async function(user) {
    const displayName = user.user_metadata?.display_name ?? user.user_metadata?.full_name ?? user.user_metadata?.name ?? '';
    const firstName = user.user_metadata?.first_name || displayName.split(' ')[0] || '';
    const lastName = user.user_metadata?.last_name || displayName.split(' ').slice(1).join(' ') || '';
    const businessName = user.user_metadata?.business_name || `${firstName} ${lastName}`.trim() || user.email || 'My Business';
    const phone = user.user_metadata?.phone ?? null;
    // Acquisition source captured at sign-up (Javascript/sourceTracking.js), carried through
    // via auth user_metadata so it survives even if email confirmation happens on another
    // device (localStorage alone wouldn't). Google sign-up can't carry custom metadata, so it
    // falls back to this browser's stored source - safe because _initBusiness only runs for a
    // brand-new owner. Null for an organic signup with no tracking link.
    const sourceId = user.user_metadata?.source ?? (0, $924b6f34e17f8cba$export$fc9166d79258e815)()?.source ?? null;
    // No-card-required trial: every brand-new business gets 7 days of full Pro
    // access with zero Lemon Squeezy involvement. trial_granted_by stays NULL here
    // (vs. an admin's email when granted manually from the admin panel) so the two
    // sources stay distinguishable later. See CLAUDE.md "Free vs. Paid Plan Gating".
    const trialEndsAt = new Date(Date.now() + 604800000).toISOString();
    let { error: bizError } = await (0, $asfCf.supabase).from('businesses').upsert({
        id: user.id,
        name: businessName,
        email: user.email,
        phone: null,
        source_id: sourceId,
        subscription_status: 'free',
        trial_ends_at: trialEndsAt
    }, {
        ignoreDuplicates: true
    });
    if (bizError) {
        // Retry without trial_ends_at - a schema hiccup on that one column must never
        // block brand-new signups from creating their business at all (see the login
        // incident on loadBusinessContext above; same defensive posture here). The
        // trial can be granted later once the column resolves, or manually from admin.
        console.warn('businesses upsert with trial_ends_at failed, retrying without it:', bizError.message);
        ({ error: bizError } = await (0, $asfCf.supabase).from('businesses').upsert({
            id: user.id,
            name: businessName,
            email: user.email,
            phone: null,
            source_id: sourceId,
            subscription_status: 'free'
        }, {
            ignoreDuplicates: true
        }));
    }
    if (bizError) throw new Error(`businesses upsert failed: ${bizError.message}`);
    const { data: existingRole } = await (0, $asfCf.supabase).from('roles').select('id').eq('business_id', user.id).eq('name', 'Admin').maybeSingle();
    let adminRoleId = existingRole?.id;
    if (!adminRoleId) {
        const { data: insertedRoles, error: roleError } = await (0, $asfCf.supabase).from('roles').insert([
            {
                business_id: user.id,
                name: 'Admin',
                permissions: $1e7ab04ca7920cff$export$f92875a0bb941a70($1e7ab04ca7920cff$export$56b2c64857920c31.Admin)
            },
            {
                business_id: user.id,
                name: 'Manager',
                permissions: $1e7ab04ca7920cff$export$f92875a0bb941a70($1e7ab04ca7920cff$export$56b2c64857920c31.Manager)
            },
            {
                business_id: user.id,
                name: 'Cashier',
                permissions: $1e7ab04ca7920cff$export$f92875a0bb941a70($1e7ab04ca7920cff$export$56b2c64857920c31.Cashier)
            },
            {
                business_id: user.id,
                name: 'Staff',
                permissions: $1e7ab04ca7920cff$export$f92875a0bb941a70($1e7ab04ca7920cff$export$56b2c64857920c31.Staff)
            }
        ]).select('id, name');
        if (roleError) throw new Error(`roles insert failed: ${roleError.message}`);
        adminRoleId = insertedRoles.find((r)=>r.name === 'Admin')?.id;
    }
    const { data: existingStaff } = await (0, $asfCf.supabase).from('staff').select('id, first_name, last_name, email').eq('user_id', user.id).maybeSingle();
    let staffRow = existingStaff;
    if (!staffRow) {
        const { data: newStaff, error: staffError } = await (0, $asfCf.supabase).from('staff').insert({
            business_id: user.id,
            user_id: user.id,
            role_id: adminRoleId,
            first_name: firstName,
            last_name: lastName,
            email: user.email,
            joined_at: new Date().toISOString()
        }).select('id, first_name, last_name, email').single();
        if (staffError) throw new Error(`staff insert failed: ${staffError.message}`);
        staffRow = newStaff;
    }
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff = {
        id: staffRow.id,
        firstName: staffRow.first_name,
        lastName: staffRow.last_name,
        email: staffRow.email,
        role: 'Admin'
    };
    if (sourceId) await $1e7ab04ca7920cff$export$bfea9f214c7ec36('registered', {
        sourceId: sourceId,
        sessionId: (0, $924b6f34e17f8cba$export$d7660cd936a72b71)(),
        businessId: user.id
    });
    (0, $924b6f34e17f8cba$export$b2a6af0fab9e714e)();
};
const $1e7ab04ca7920cff$export$321bb7db07b616e1 = async function(user, { isInviteAcceptance: isInviteAcceptance = false } = {}) {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.userId = user.id;
    // A person's account can be tied to more than one staff row: at most one ACTIVE row
    // (their current business) plus any number of soft-deleted historical rows from
    // businesses they were removed from. We pick the active one. .maybeSingle() can't be
    // used here - it errors when an old deactivated row coexists with a new active row
    // (which happens after someone is removed from one business and joins another).
    const { data: ownRows } = await (0, $asfCf.supabase).from('staff').select('id, business_id, first_name, last_name, email, pin, is_active, role_id, roles(name, permissions)').eq('user_id', user.id);
    let staffRow = (ownRows ?? []).find((r)=>r.is_active) ?? null;
    // True when the account has only deactivated rows: removed from every business they
    // joined. This is a genuine lockout UNLESS a fresh pending invite is waiting (handled
    // in the else branch below, which takes precedence so a removed staffer can re-join).
    const removedFromAll = !staffRow && (ownRows ?? []).length > 0;
    // Only claim a pending invite row when the user explicitly came through the invite link.
    // Skipping this for normal sign-in/sign-up prevents a person who owns their own business
    // from being silently enrolled as staff at another business that invited their email.
    if (!staffRow && isInviteAcceptance) {
        // A person can hold pending invites from more than one business at once. Per the
        // single-membership rule they join the first business that invited them; any other
        // pending invites for their email are discarded so they cannot pile up (those
        // businesses can only re-invite after this person is removed from their team).
        // Note: we fetch all matches and pick one rather than using .maybeSingle(), which
        // errors out when more than one pending row matches and leaves the user unclaimed.
        const { data: pendingRows } = await (0, $asfCf.supabase).from('staff').select('id, business_id, first_name, last_name, email, pin, role_id, roles(name)').eq('email', user.email).is('user_id', null).eq('is_active', true).order('invited_at', {
            ascending: true
        });
        if (pendingRows && pendingRows.length) {
            const claim = pendingRows[0];
            await (0, $asfCf.supabase).from('staff').update({
                user_id: user.id,
                joined_at: new Date().toISOString()
            }).eq('id', claim.id);
            const duplicates = pendingRows.slice(1).map((r)=>r.id);
            if (duplicates.length) await (0, $asfCf.supabase).from('staff').delete().in('id', duplicates);
            staffRow = claim;
        }
    }
    if (staffRow) {
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId = staffRow.business_id;
        // Fail SAFE, not loud: if the role join can't be read (e.g. an RLS hiccup on the
        // roles table) we must not silently escalate a staff member to Admin. The owner
        // (their auth id == the business id) is the only account that defaults to Admin;
        // any other unreadable role drops to least-privilege so access is never granted
        // by accident. A null role name here is also a signal the roles RLS is misbehaving.
        const _isOwnerAccount = user.id === staffRow.business_id;
        if (!staffRow.roles?.name) console.warn('[pointbunny] staff role name could not be read; defaulting role. Check roles RLS / get_my_business_id().');
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.role = staffRow.roles?.name ?? (_isOwnerAccount ? 'Admin' : 'Cashier');
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.permissions = _isOwnerAccount ? new Set($1e7ab04ca7920cff$export$e41c6d066ef1eec8) : $1e7ab04ca7920cff$export$94cfe010e61a30ec($1e7ab04ca7920cff$export$ca000e230c0caa3e.role, staffRow.roles?.permissions);
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff = {
            id: staffRow.id,
            firstName: staffRow.first_name,
            lastName: staffRow.last_name,
            email: staffRow.email,
            role: $1e7ab04ca7920cff$export$ca000e230c0caa3e.role,
            roleId: staffRow.role_id ?? null,
            hasPin: !!staffRow.pin
        };
    } else {
        // An existing account (signed up on their own, or joined a business then left) can't
        // be re-invited by email - Supabase won't send an invite to an email that already has
        // an account. So on a normal login, if a business has a pending invite for this email,
        // offer it behind a consent step instead of dead-ending. We never silently enroll:
        // the user must accept. Owners creating their own business (role 'owner') skip this.
        if (!isInviteAcceptance && user.user_metadata?.role !== 'owner') {
            const { data: invites } = await (0, $asfCf.supabase).from('staff').select('id, business_id, first_name, last_name, roles(name)').eq('email', user.email).is('user_id', null).eq('is_active', true).order('invited_at', {
                ascending: true
            });
            if (invites && invites.length) {
                // Business name is best-effort: RLS may hide the businesses row from a non-member,
                // in which case the consent prompt falls back to a generic label.
                const ids = [
                    ...new Set(invites.map((i)=>i.business_id))
                ];
                const { data: bizRows } = await (0, $asfCf.supabase).from('businesses').select('id, name').in('id', ids);
                const nameById = Object.fromEntries((bizRows ?? []).map((b)=>[
                        b.id,
                        b.name
                    ]));
                $1e7ab04ca7920cff$export$ca000e230c0caa3e.pendingInvites = invites.map((i)=>({
                        staffId: i.id,
                        businessId: i.business_id,
                        businessName: nameById[i.business_id] ?? null,
                        firstName: i.first_name,
                        role: i.roles?.name ?? 'Staff'
                    }));
                const err = new Error('PENDING_INVITE_CONSENT');
                err.code = 'PENDING_INVITE_CONSENT';
                throw err;
            }
        }
        // No active membership and no pending invite to accept. If the account previously
        // belonged to a business and was removed/deactivated, that is a genuine lockout - do
        // not fall through to _initBusiness (which would spawn a ghost business for them).
        if (removedFromAll) {
            const err = new Error('Your account has been deactivated. Please contact your business owner.');
            err.code = 'STAFF_DEACTIVATED';
            throw err;
        }
        if (user.user_metadata?.role === 'staff') throw new Error('Staff account setup incomplete. Please contact your manager or try accepting your invite link again.');
        // Admin panel accounts must never spawn a POS business via _initBusiness
        const { data: adminRow } = await (0, $asfCf.supabase).from('admins').select('email').eq('email', user.email).maybeSingle();
        if (adminRow) {
            const err = new Error('This is an admin account. Please sign in at the admin panel instead.');
            err.code = 'ADMIN_ACCOUNT';
            throw err;
        }
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId = user.id;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.role = 'Admin';
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.permissions = new Set($1e7ab04ca7920cff$export$e41c6d066ef1eec8);
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff = null;
        await $1e7ab04ca7920cff$var$_initBusiness(user);
    }
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff;
    const { data: bizData, error: bizDataError } = await (0, $asfCf.supabase).from('businesses').select('name, timezone, phone, address_street, address_city, address_province, address_zip, address_country, business_type, business_industry, settings, subscription_status, ls_customer_portal_url, ls_renews_at').eq('id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).single();
    // A failed/unexpected-empty query here must never fall through silently - the
    // caller previously ignored `error`, so a transient failure left every business
    // field at its null default, which made owner logins misread as "onboarding
    // never completed" and show the setup flow to real, fully-onboarded accounts
    // (incident 2026-09-03). Surface it instead of guessing.
    if (bizDataError) throw new Error(`Failed to load business data: ${bizDataError.message}`);
    if (bizData) {
        // `?? {}`: a brand-new business has settings = NULL; passing the empty
        // object makes applyBusinessSettings reset every key to its default
        // instead of leaving this device's cache (possibly another account's
        // values) in place.
        $1e7ab04ca7920cff$export$3a30189b4816777e(bizData.settings ?? {});
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessName = bizData.name ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessTimezone = bizData.timezone ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessPhone = bizData.phone ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressStreet = bizData.address_street ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCity = bizData.address_city ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressProvince = bizData.address_province ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressZip = bizData.address_zip ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCountry = bizData.address_country ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessType = bizData.business_type ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessIndustry = bizData.business_industry ?? null;
        // Fail safe: unknown/NULL subscription_status (pre-Stripe businesses, or an
        // unreadable row) always reads as 'free', never silently unlocks paid features.
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.subscriptionStatus = bizData.subscription_status === 'paid' ? 'paid' : 'free';
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.subscriptionPortalUrl = bizData.ls_customer_portal_url ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.subscriptionRenewsAt = bizData.ls_renews_at ?? null;
    }
    // Trial fields fetched as a SEPARATE, best-effort query so a schema hiccup on
    // these two columns specifically can never again take the whole login down
    // with it (see the incident note above) - worst case, the trial silently
    // doesn't show for a login or two instead of blocking access entirely.
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.trialEndsAt = null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.trialGrantedBy = null;
    try {
        const { data: trialData, error: trialError } = await (0, $asfCf.supabase).from('businesses').select('trial_ends_at, trial_granted_by').eq('id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).single();
        if (trialError) throw trialError;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.trialEndsAt = trialData?.trial_ends_at ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.trialGrantedBy = trialData?.trial_granted_by ?? null;
    } catch (trialFetchError) {
        console.warn('Trial fields unavailable this login, defaulting to none:', trialFetchError);
    }
    // Recompute from scratch each login - never inherit a stale `true` from a prior
    // in-page session (e.g. an owner/admin login whose error path signed out without a
    // page reload), which would otherwise flash onboarding at the next staff login.
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.needsOnboarding = false;
    if (user.user_metadata?.role === 'owner' || !user.user_metadata?.role && $1e7ab04ca7920cff$export$ca000e230c0caa3e.userId === $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId) {
        const onboardingComplete = $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessName && $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessType && $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessIndustry && $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessPhone && $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressStreet && $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCity && $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressProvince && $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressZip && $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCountry;
        if (!onboardingComplete) $1e7ab04ca7920cff$export$ca000e230c0caa3e.needsOnboarding = true;
    }
    // Set the timezone if the owner hasn't (or if a device in UTC set it):
    // from the US address first, else this device. Only the owner writes it -
    // staff logins leave it untouched. See usTimezones.js.
    $1e7ab04ca7920cff$var$_fillBusinessTimezone();
};
const $1e7ab04ca7920cff$export$74881ed03683ce30 = function() {
    const saved = $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessTimezone;
    const fromAddress = (0, $3c92721278bd64e4$export$ca7e9b4e79cae562)($1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCountry, $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressProvince);
    if (saved && !(0, $3c92721278bd64e4$export$2c148b0cc193b767)(saved) && (0, $3c92721278bd64e4$export$81ce5941ae3d1849)(saved, fromAddress)) return saved;
    return fromAddress || saved || Intl.DateTimeFormat().resolvedOptions().timeZone;
};
const $1e7ab04ca7920cff$var$_fillBusinessTimezone = function() {
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.userId !== $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId) return;
    const current = $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessTimezone;
    const fromAddress = (0, $3c92721278bd64e4$export$ca7e9b4e79cae562)($1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCountry, $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressProvince);
    if (current && !(0, $3c92721278bd64e4$export$2c148b0cc193b767)(current) && (0, $3c92721278bd64e4$export$81ce5941ae3d1849)(current, fromAddress)) return;
    const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const tz = fromAddress || (detected && !(0, $3c92721278bd64e4$export$2c148b0cc193b767)(detected) ? detected : null);
    if (!tz || tz === current) return;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessTimezone = tz;
    (0, $asfCf.supabase).from('businesses').update({
        timezone: tz
    }).eq('id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).then(()=>{}); // fire-and-forget, non-blocking
};
const $1e7ab04ca7920cff$export$55344c3a5ee790ee = async function() {
    const { data: data } = await (0, $asfCf.supabase).from('businesses').select('name, email, phone, timezone, address_street, address_city, address_province, address_zip').eq('id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).single();
    if (data) {
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessName = data.name ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessEmail = data.email ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessPhone = data.phone ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessTimezone = data.timezone ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressStreet = data.address_street ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCity = data.address_city ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressProvince = data.address_province ?? null;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressZip = data.address_zip ?? null;
    }
};
const $1e7ab04ca7920cff$export$e2fc50026c086c51 = async function({ name: name, email: email, phone: phone, timezone: timezone, addressStreet: addressStreet, addressCity: addressCity, addressProvince: addressProvince, addressZip: addressZip }) {
    const { error: error } = await (0, $asfCf.supabase).from('businesses').update({
        name: name,
        email: email || null,
        phone: phone || null,
        timezone: timezone || null,
        address_street: addressStreet || null,
        address_city: addressCity || null,
        address_province: addressProvince || null,
        address_zip: addressZip || null
    }).eq('id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessName = name;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessEmail = email || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessPhone = phone || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessTimezone = timezone || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressStreet = addressStreet || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCity = addressCity || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressProvince = addressProvince || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressZip = addressZip || null;
};
const $1e7ab04ca7920cff$export$ac06a0bc59be6d27 = async function({ businessType: businessType, industry: industry }) {
    const { error: error } = await (0, $asfCf.supabase).from('businesses').update({
        business_type: businessType || null,
        business_industry: industry || null
    }).eq('id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessType = businessType || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessIndustry = industry || null;
};
const $1e7ab04ca7920cff$export$fb32ac73157105c7 = async function({ businessName: businessName, businessType: businessType, industry: industry, phone: phone, street: street, city: city, province: province, zip: zip, country: country }) {
    const { data: updated, error: error } = await (0, $asfCf.supabase).from('businesses').update({
        name: businessName,
        business_type: businessType || null,
        business_industry: industry || null,
        phone: phone || null,
        address_street: street || null,
        address_city: city || null,
        address_province: province || null,
        address_zip: zip || null,
        address_country: country || null
    }).eq('id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).select('id');
    if (error) throw new Error(error.message);
    if (!updated?.length) throw new Error(`Business record not found (id: ${$1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId}). Please refresh and try again.`);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessName = businessName;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessType = businessType || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessIndustry = industry || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessPhone = phone || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressStreet = street || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCity = city || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressProvince = province || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressZip = zip || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCountry = country || null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.needsOnboarding = false;
    // The address is known now: a timezone guessed from the device (or UTC)
    // gives way to the one for the business's state.
    $1e7ab04ca7920cff$var$_fillBusinessTimezone();
};
// ── DB ↔ app shape mapping ────────────────────────────────────────────────────
const $1e7ab04ca7920cff$var$dbToItem = (row)=>({
        _id: row.id,
        itemName: row.item_name,
        price: Number(row.price),
        category: row.category,
        imageURL: $1e7ab04ca7920cff$var$isMissingImage(row.image_url) ? null : row.image_url,
        iconEmoji: row.icon_emoji || null,
        _stock: row.stock ?? "0",
        hasVariants: row.has_variants,
        variants: row.variants ?? [],
        description: row.description ?? "",
        status: row.status ?? "active",
        taxClass: row.tax_class ?? "standard"
    });
// ── DB ↔ app shape mapping (employees) ───────────────────────────────────────
const $1e7ab04ca7920cff$var$dbToEmployee = (row)=>({
        id: row.id,
        name: row.name,
        role: row.role ?? "",
        systemRole: row.system_role ?? ""
    });
// ── DB ↔ app shape mapping (expenses) ────────────────────────────────────────
const $1e7ab04ca7920cff$var$dbToExpense = (row)=>({
        id: row.id,
        amount: Number(row.amount),
        description: row.description,
        category: row.category ?? "",
        expenseDate: row.expense_date,
        createdAt: row.created_at,
        createdBy: row.created_by
    });
const $1e7ab04ca7920cff$export$e36954363574ccbc = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("employees").select("*").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at");
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.employees = data.map($1e7ab04ca7920cff$var$dbToEmployee);
};
const $1e7ab04ca7920cff$export$88b1d98240dfcff5 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("menu_items").select("*").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at");
    if (error) throw error;
    // Soft delete reuses the existing free-text status column (status = 'deleted')
    // - no schema change. Deleted items are kept out of the sellable catalogue but
    // remembered so Reports can tag them "(deleted)".
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems = data.filter((r)=>r.status !== "deleted").map($1e7ab04ca7920cff$var$dbToItem);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.deletedItems = data.filter((r)=>r.status === "deleted").map((r)=>({
            id: r.id,
            name: r.item_name
        }));
};
const $1e7ab04ca7920cff$export$d79f3d7dd8af2e54 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("menu_categories").select("name").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at");
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories = data.map((r)=>r.name);
};
// ── Menu item CRUD ────────────────────────────────────────────────────────────
const $1e7ab04ca7920cff$var$uploadImage = async function(file, existingUrl = null) {
    // No new file: keep whatever was there (a real URL preserves; "no image"
    // stays null so the DB never stores a default/placeholder string).
    if (!file || file.size === 0) return $1e7ab04ca7920cff$var$isMissingImage(existingUrl) ? null : existingUrl;
    // Validate + downscale/compress before upload (throws a friendly error on a
    // non-image or an image too large to process).
    file = await (0, $d1ef11f17812d23e$export$b63de8e31affef62)(file);
    const ext = file.name.split(".").pop();
    const path = `${$1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId}/${Date.now()}.${ext}`;
    const { error: error } = await (0, $asfCf.supabase).storage.from("item-images").upload(path, file);
    if (error) throw error;
    const { data: data } = (0, $asfCf.supabase).storage.from("item-images").getPublicUrl(path);
    return data.publicUrl;
};
const $1e7ab04ca7920cff$export$42fa452647465c30 = async function(newItem) {
    const variants = newItem.variants ?? [];
    // Photo and emoji are mutually exclusive - whichever mode was active on
    // submit wins, so switching tabs never leaves stale data from the other.
    const useEmoji = newItem.imageMode === "emoji" && !!newItem.iconEmoji;
    const imageURL = useEmoji ? null : await $1e7ab04ca7920cff$var$uploadImage(newItem.image);
    const { data: data, error: error } = await (0, $asfCf.supabase).from("menu_items").insert({
        user_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        item_name: newItem.name,
        // No price entered -> default to 0 (free / price-on-variant items).
        price: Number(newItem.price) || 0,
        category: newItem.category,
        image_url: imageURL,
        icon_emoji: useEmoji ? newItem.iconEmoji : null,
        stock: "0",
        has_variants: variants.length > 0,
        variants: variants,
        description: "This is a sample description of the menu item. You can add more details here.",
        status: "active",
        tax_class: "standard"
    }).select().single();
    if (error) throw error;
    const created = $1e7ab04ca7920cff$var$dbToItem(data);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.push(created);
    // Returned so the add form can attach inventory tracking to the new item's id.
    return created;
};
const $1e7ab04ca7920cff$export$7c4266df864b51c1 = async function(id) {
    return $1e7ab04ca7920cff$export$690ddbe1f36836([
        id
    ]);
};
// A bulk write can fail on the first hit after the access token has gone stale
// (the request races the auto-refresh); retrying once after a beat sails through.
// These writes are idempotent, so a retry can't double-apply.
const $1e7ab04ca7920cff$var$_retryWrite = async function(fn, retries = 1) {
    try {
        const res = await fn();
        if (res?.error) throw res.error;
        return res;
    } catch (e) {
        if (retries > 0) {
            await new Promise((r)=>setTimeout(r, 250));
            return $1e7ab04ca7920cff$var$_retryWrite(fn, retries - 1);
        }
        throw e;
    }
};
const $1e7ab04ca7920cff$export$690ddbe1f36836 = async function(ids) {
    if (!ids?.length) return;
    await $1e7ab04ca7920cff$var$_retryWrite(()=>(0, $asfCf.supabase).from("menu_items").update({
            status: "deleted"
        }).in("id", ids).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId));
    const removed = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.filter((i)=>ids.includes(i._id));
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.deletedItems.push(...removed.map((i)=>({
            id: i._id,
            name: i.itemName
        })));
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.filter((i)=>!ids.includes(i._id));
    // A soft-deleted product must stop consuming stock and its auto "simple count"
    // item must leave the Stock list. Best effort - a failure here never blocks the delete.
    $1e7ab04ca7920cff$export$b141fb4fb433d40a(ids).catch(()=>{});
};
const $1e7ab04ca7920cff$export$85569b4184b1a334 = async function(ids, status) {
    if (!ids?.length) return;
    await $1e7ab04ca7920cff$var$_retryWrite(()=>(0, $asfCf.supabase).from("menu_items").update({
            status: status
        }).in("id", ids).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId));
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.forEach((i)=>{
        if (ids.includes(i._id)) i.status = status;
    });
};
const $1e7ab04ca7920cff$export$fbe83f1638aa6a6 = async function(ids, taxClass) {
    if (!ids?.length) return;
    await $1e7ab04ca7920cff$var$_retryWrite(()=>(0, $asfCf.supabase).from("menu_items").update({
            tax_class: taxClass
        }).in("id", ids).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId));
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.forEach((i)=>{
        if (ids.includes(i._id)) i.taxClass = taxClass;
    });
};
const $1e7ab04ca7920cff$export$2895598b9aab0df3 = async function(items, newCategories = []) {
    if (!items?.length) return {
        added: 0
    };
    // 1. Create any missing categories first (deduped against current state).
    const toCreate = [
        ...new Set(newCategories.map((c)=>c.trim().toLowerCase()).filter(Boolean))
    ].filter((c)=>!$1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories.includes(c));
    if (toCreate.length) {
        await $1e7ab04ca7920cff$var$_retryWrite(()=>(0, $asfCf.supabase).from("menu_categories").insert(toCreate.map((name)=>({
                    user_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
                    name: name
                }))));
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories.push(...toCreate);
    }
    // 2. Batched insert of the items. Category is stored lowercase to match how
    // the add form / category list store it; a blank category lands in
    // "uncategorized" (loadMenuItems groups it there).
    const rows = items.map((it)=>({
            user_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
            item_name: it.itemName,
            price: Number(it.price) || 0,
            category: it.category ? it.category.trim().toLowerCase() : "uncategorized",
            image_url: null,
            stock: "0",
            has_variants: Boolean(it.hasVariants),
            variants: it.variants ?? [],
            description: "",
            status: "active",
            tax_class: "standard"
        }));
    const { data: data } = await $1e7ab04ca7920cff$var$_retryWrite(()=>(0, $asfCf.supabase).from("menu_items").insert(rows).select());
    const inserted = (data ?? []).map($1e7ab04ca7920cff$var$dbToItem);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.push(...inserted);
    return {
        added: inserted.length
    };
};
const $1e7ab04ca7920cff$export$bda304d41bed1943 = function(index) {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.splice(index, 1);
};
const $1e7ab04ca7920cff$export$1b26cd8f03c7cf23 = async function(id, rawData) {
    const item = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.find((item)=>item._id === id);
    if (!item) throw new Error("Item not found");
    const prevName = item.itemName;
    const hasVariants = rawData.hasVariants === "on";
    const variants = hasVariants ? $1e7ab04ca7920cff$var$parseVariants(rawData) : [];
    // Photo and emoji are mutually exclusive - whichever mode was active on
    // submit wins, clearing the other so a switch never leaves stale data.
    const useEmoji = rawData.imageMode === "emoji" && !!rawData.iconEmoji;
    const newImageURL = useEmoji ? null : await $1e7ab04ca7920cff$var$uploadImage(rawData.image, item.imageURL);
    const newIconEmoji = useEmoji ? rawData.iconEmoji : null;
    const { error: error } = await (0, $asfCf.supabase).from("menu_items").update({
        item_name: rawData.itemName || "",
        price: Number(rawData.price) || 0,
        category: rawData.category || "",
        stock: rawData.stock || "0",
        description: rawData.description || "",
        has_variants: hasVariants,
        variants: variants,
        status: rawData.status?.toLowerCase() || "active",
        // The dropdown only renders when tax-inclusive is on, so rawData.taxClass
        // is undefined whenever it's off - keep the item's existing class rather
        // than silently reverting an already-exempt item to standard.
        tax_class: rawData.taxClass === undefined ? item.taxClass : rawData.taxClass === "exempt" ? "exempt" : "standard",
        image_url: newImageURL,
        icon_emoji: newIconEmoji
    }).eq("id", id).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    item.itemName = rawData.itemName || "";
    item.price = Number(rawData.price) || 0;
    item.category = rawData.category || "";
    item._stock = rawData.stock || "0";
    item.description = rawData.description || "";
    item.hasVariants = hasVariants;
    item.variants = variants;
    item.status = rawData.status?.toLowerCase() || "active";
    item.taxClass = rawData.taxClass === undefined ? item.taxClass : rawData.taxClass === "exempt" ? "exempt" : "standard";
    item.imageURL = newImageURL;
    item.iconEmoji = newIconEmoji;
    // Keep the auto-created "simple count" inventory item's name in sync so the
    // Stock list stays readable. Best effort - never blocks the item save.
    if (item.itemName && item.itemName !== prevName) $1e7ab04ca7920cff$export$3b64e37d12259fc3(id, item.itemName).catch(()=>{});
};
const $1e7ab04ca7920cff$export$83f9fbc1f115c860 = function(itemId) {
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.find((i)=>i._id === itemId)?.taxClass ?? "standard";
};
// ── Inventory ─────────────────────────────────────────────────────────────────
// Stock tracking connected to products. One ledger (inventory_items); products
// consume from it via inventory_links (base row per inventory item + optional
// per-variant override rows). "Simple count" mode is sugar: an auto-created
// inventory item (linked_menu_item_id set) with a single base link of qty 1.
// ALL quantity changes go through SECURITY DEFINER RPCs (atomic + logged in
// inventory_adjustments); direct table writes are for non-quantity fields only.
const $1e7ab04ca7920cff$var$dbToInventoryItem = (row)=>({
        id: row.id,
        name: row.name,
        unit: row.unit ?? "unit",
        quantity: Number(row.quantity ?? 0),
        lowStockThreshold: row.low_stock_threshold == null ? null : Number(row.low_stock_threshold),
        linkedMenuItemId: row.linked_menu_item_id ?? null,
        sku: row.sku ?? null,
        category: row.category ?? null,
        unitCost: row.unit_cost == null ? null : Number(row.unit_cost),
        supplierId: row.supplier_id ?? null,
        createdAt: row.created_at,
        updatedAt: row.updated_at
    });
const $1e7ab04ca7920cff$var$dbToInventoryLink = (row)=>({
        id: row.id,
        menuItemId: row.menu_item_id,
        inventoryItemId: row.inventory_item_id,
        qty: Number(row.qty ?? 0),
        variantLabel: row.variant_label ?? null,
        variantOption: row.variant_option ?? null
    });
// The acting person's display name for the adjustment log - the switched-in
// cashier if one is active, else the logged-in staff member.
const $1e7ab04ca7920cff$var$_inventoryActorName = function() {
    const who = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier ?? $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff;
    return [
        who?.firstName,
        who?.lastName
    ].filter(Boolean).join(" ") || null;
};
const $1e7ab04ca7920cff$var$dbToItemSupplier = (row)=>({
        id: row.id,
        inventoryItemId: row.inventory_item_id,
        supplierId: row.supplier_id,
        unitCost: row.unit_cost == null ? null : Number(row.unit_cost),
        preferred: !!row.preferred
    });
const $1e7ab04ca7920cff$export$45aba0c57314d190 = async function() {
    const [itemsRes, linksRes, itemSupRes] = await Promise.all([
        (0, $asfCf.supabase).from("inventory_items").select("*").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("name"),
        (0, $asfCf.supabase).from("inventory_links").select("*").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at"),
        // Tolerant of a not-yet-migrated DB: the price list just stays empty.
        (0, $asfCf.supabase).from("inventory_item_suppliers").select("*").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at").then((res)=>res, ()=>({
                data: []
            }))
    ]);
    if (itemsRes.error) throw itemsRes.error;
    if (linksRes.error) throw linksRes.error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems = (itemsRes.data ?? []).map($1e7ab04ca7920cff$var$dbToInventoryItem);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks = (linksRes.data ?? []).map($1e7ab04ca7920cff$var$dbToInventoryLink);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers = (itemSupRes.error ? [] : itemSupRes.data ?? []).map($1e7ab04ca7920cff$var$dbToItemSupplier);
};
// ── Item <-> supplier price list ─────────────────────────────────────────────
// One item can be bought from several suppliers, each with their own price;
// exactly one is PREFERRED (DB-enforced partial unique index). The item's
// inventory_items.supplier_id mirrors the preferred row so every existing
// display/reorder site keeps working.
const $1e7ab04ca7920cff$var$_syncPreferredSupplier = async function(itemId) {
    const pref = $1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers.find((r)=>r.inventoryItemId === itemId && r.preferred) ?? null;
    const supplierId = pref?.supplierId ?? null;
    const { error: error } = await (0, $asfCf.supabase).from("inventory_items").update({
        supplier_id: supplierId
    }).eq("id", itemId).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const item = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.find((i)=>i.id === itemId);
    if (item) item.supplierId = supplierId;
};
const $1e7ab04ca7920cff$export$9fc09e523947782f = async function(itemId, supplierId, unitCost) {
    const first = !$1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers.some((r)=>r.inventoryItemId === itemId);
    const { data: data, error: error } = await (0, $asfCf.supabase).from("inventory_item_suppliers").insert({
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        inventory_item_id: itemId,
        supplier_id: supplierId,
        unit_cost: unitCost == null || unitCost === "" || isNaN(Number(unitCost)) ? null : Number(unitCost),
        preferred: first
    }).select().single();
    if (error) {
        if (error.code === "23505") throw new Error("That supplier is already linked to this item");
        throw error;
    }
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers.push($1e7ab04ca7920cff$var$dbToItemSupplier(data));
    if (first) await $1e7ab04ca7920cff$var$_syncPreferredSupplier(itemId);
    return data;
};
const $1e7ab04ca7920cff$export$27c16f7c55c179b8 = async function(rowId) {
    const row = $1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers.find((r)=>r.id === rowId);
    if (!row || row.preferred) return;
    // Clear the current preferred first (the partial unique index allows one).
    const { error: clearError } = await (0, $asfCf.supabase).from("inventory_item_suppliers").update({
        preferred: false
    }).eq("inventory_item_id", row.inventoryItemId).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq("preferred", true);
    if (clearError) throw clearError;
    const { error: error } = await (0, $asfCf.supabase).from("inventory_item_suppliers").update({
        preferred: true
    }).eq("id", rowId).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers.forEach((r)=>{
        if (r.inventoryItemId === row.inventoryItemId) r.preferred = r.id === rowId;
    });
    await $1e7ab04ca7920cff$var$_syncPreferredSupplier(row.inventoryItemId);
};
const $1e7ab04ca7920cff$export$79948de40748f795 = async function(rowId, unitCost) {
    const cost = unitCost == null || unitCost === "" || isNaN(Number(unitCost)) ? null : Number(unitCost);
    const { error: error } = await (0, $asfCf.supabase).from("inventory_item_suppliers").update({
        unit_cost: cost
    }).eq("id", rowId).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const row = $1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers.find((r)=>r.id === rowId);
    if (row) row.unitCost = cost;
};
const $1e7ab04ca7920cff$export$c9cb699daae954f0 = async function(rowId) {
    const row = $1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers.find((r)=>r.id === rowId);
    if (!row) return;
    const { error: error } = await (0, $asfCf.supabase).from("inventory_item_suppliers").delete().eq("id", rowId).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers = $1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers.filter((r)=>r.id !== rowId);
    if (row.preferred) {
        // Promote the next remaining supplier (if any) so the item keeps a default.
        const next = $1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers.find((r)=>r.inventoryItemId === row.inventoryItemId);
        if (next) {
            const { error: promoteError } = await (0, $asfCf.supabase).from("inventory_item_suppliers").update({
                preferred: true
            }).eq("id", next.id).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
            if (!promoteError) next.preferred = true;
        }
        await $1e7ab04ca7920cff$var$_syncPreferredSupplier(row.inventoryItemId);
    }
};
const $1e7ab04ca7920cff$export$2e183382b4951272 = async function(itemId = null, limit = 500) {
    // The embedded sales row lets History label sale/void rows with the invoice
    // number via formatInvoiceNumber(receipt_number, sale_date).
    let query = (0, $asfCf.supabase).from("inventory_adjustments").select("*, sales(receipt_number, sale_date)").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at", {
        ascending: false
    }).limit(limit);
    if (itemId) query = query.eq("inventory_item_id", itemId);
    const { data: data, error: error } = await query;
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryAdjustments = (data ?? []).map((row)=>({
            id: row.id,
            inventoryItemId: row.inventory_item_id,
            delta: Number(row.delta),
            kind: row.kind,
            note: row.note ?? null,
            saleId: row.sale_id ?? null,
            receiptNumber: row.sales?.receipt_number ?? null,
            saleDate: row.sales?.sale_date ?? null,
            staffName: row.staff_name ?? null,
            createdAt: row.created_at
        }));
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryAdjustments;
};
// Optional profile fields shared by create + update. Empty strings become NULL.
const $1e7ab04ca7920cff$var$_inventoryItemExtras = function({ sku: sku, category: category, unitCost: unitCost, supplierId: supplierId } = {}) {
    const out = {};
    if (sku !== undefined) out.sku = (sku ?? "").trim() || null;
    if (category !== undefined) out.category = (category ?? "").trim() || null;
    if (unitCost !== undefined) out.unit_cost = unitCost == null || unitCost === "" || isNaN(Number(unitCost)) ? null : Number(unitCost);
    if (supplierId !== undefined) out.supplier_id = supplierId || null;
    return out;
};
const $1e7ab04ca7920cff$export$9bccf79e85d1f187 = async function({ name: name, unit: unit, quantity: quantity = 0, lowStockThreshold: lowStockThreshold = null, ...extras }) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("inventory_items").insert({
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        name: name.trim(),
        unit: (unit || "unit").trim(),
        quantity: Number(quantity) || 0,
        low_stock_threshold: lowStockThreshold == null || lowStockThreshold === "" ? null : Number(lowStockThreshold),
        ...$1e7ab04ca7920cff$var$_inventoryItemExtras(extras)
    }).select().single();
    if (error) throw error;
    const item = $1e7ab04ca7920cff$var$dbToInventoryItem(data);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.push(item);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.sort((a, b)=>a.name.localeCompare(b.name));
    return item;
};
const $1e7ab04ca7920cff$export$3047042a7e84a73f = async function(id, { name: name, unit: unit, lowStockThreshold: lowStockThreshold, ...extras }) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("inventory_items").update({
        name: name.trim(),
        unit: (unit || "unit").trim(),
        low_stock_threshold: lowStockThreshold == null || lowStockThreshold === "" ? null : Number(lowStockThreshold),
        ...$1e7ab04ca7920cff$var$_inventoryItemExtras(extras),
        updated_at: new Date().toISOString()
    }).eq("id", id).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).select().single();
    if (error) throw error;
    const idx = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.findIndex((i)=>i.id === id);
    if (idx !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems[idx] = $1e7ab04ca7920cff$var$dbToInventoryItem(data);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.sort((a, b)=>a.name.localeCompare(b.name));
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems[idx];
};
const $1e7ab04ca7920cff$export$be780bf73aedfa4e = async function(id) {
    const { error: error } = await (0, $asfCf.supabase).from("inventory_items").delete().eq("id", id).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.filter((i)=>i.id !== id);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks.filter((l)=>l.inventoryItemId !== id);
};
const $1e7ab04ca7920cff$export$e4498848cc4f0958 = async function(itemId, delta, note) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc("adjust_inventory", {
        p_item_id: itemId,
        p_delta: delta,
        p_note: note || null,
        p_staff_name: $1e7ab04ca7920cff$var$_inventoryActorName()
    });
    if (error) throw error;
    const item = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.find((i)=>i.id === itemId);
    if (item && data != null) item.quantity = Number(data);
    return item;
};
const $1e7ab04ca7920cff$export$af015f07d23b3a4b = async function(menuItemId, cfg) {
    const autoItem = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.find((i)=>i.linkedMenuItemId === menuItemId);
    const product = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.find((i)=>i._id === menuItemId);
    const deleteAllLinks = async ()=>{
        const { error: error } = await (0, $asfCf.supabase).from("inventory_links").delete().eq("menu_item_id", menuItemId).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
        if (error) throw error;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks.filter((l)=>l.menuItemId !== menuItemId);
    };
    const deleteAutoItem = async ()=>{
        if (!autoItem) return;
        await $1e7ab04ca7920cff$export$be780bf73aedfa4e(autoItem.id);
    };
    if (cfg.mode === "none") {
        await deleteAllLinks();
        await deleteAutoItem();
        return;
    }
    if (cfg.mode === "simple") {
        const onHand = Number(cfg.onHand) || 0;
        let item = autoItem;
        if (!item) {
            // Fresh simple tracking: create the backing item at the given count.
            // History starts at the first adjustment (initial qty is not logged).
            const { data: data, error: error } = await (0, $asfCf.supabase).from("inventory_items").insert({
                business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
                name: product?.itemName || "Untitled item",
                unit: "unit",
                quantity: onHand,
                linked_menu_item_id: menuItemId
            }).select().single();
            if (error) throw error;
            item = $1e7ab04ca7920cff$var$dbToInventoryItem(data);
            $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.push(item);
            $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.sort((a, b)=>a.name.localeCompare(b.name));
        } else if (onHand !== item.quantity) // Count edited in the product editor - go through the RPC so it's logged.
        await $1e7ab04ca7920cff$export$e4498848cc4f0958(item.id, onHand - item.quantity, "Set from product editor");
        // Exactly one base link (qty 1) and nothing else.
        await deleteAllLinks();
        const { data: linkData, error: linkError } = await (0, $asfCf.supabase).from("inventory_links").insert({
            business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
            menu_item_id: menuItemId,
            inventory_item_id: item.id,
            qty: 1
        }).select().single();
        if (linkError) throw linkError;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks.push($1e7ab04ca7920cff$var$dbToInventoryLink(linkData));
        return;
    }
    // mode === 'ingredients': switching away from simple removes the auto item;
    // links are replace-all (delete + batch insert).
    await deleteAllLinks();
    await deleteAutoItem();
    // qty 0 is valid ONLY on a variant row: it means "None" - that option uses
    // none of this item (overrides the base down to zero). A base row needs a
    // positive qty to exist at all.
    const rows = (cfg.links ?? []).filter((l)=>l.inventoryItemId && (Number(l.qty) > 0 || l.variantLabel != null && Number(l.qty) === 0)).map((l)=>({
            business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
            menu_item_id: menuItemId,
            inventory_item_id: l.inventoryItemId,
            qty: Number(l.qty),
            variant_label: l.variantLabel ?? null,
            variant_option: l.variantOption ?? null
        }));
    if (rows.length) {
        const { data: data, error: error } = await (0, $asfCf.supabase).from("inventory_links").insert(rows).select();
        if (error) throw error;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks.push(...(data ?? []).map($1e7ab04ca7920cff$var$dbToInventoryLink));
    }
};
const $1e7ab04ca7920cff$export$3b64e37d12259fc3 = async function(menuItemId, newName) {
    const { error: error } = await (0, $asfCf.supabase).from("inventory_items").update({
        name: newName,
        updated_at: new Date().toISOString()
    }).eq("linked_menu_item_id", menuItemId).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const item = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.find((i)=>i.linkedMenuItemId === menuItemId);
    if (item) item.name = newName;
};
const $1e7ab04ca7920cff$export$b141fb4fb433d40a = async function(menuItemIds) {
    if (!menuItemIds?.length) return;
    await (0, $asfCf.supabase).from("inventory_links").delete().in("menu_item_id", menuItemIds).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    await (0, $asfCf.supabase).from("inventory_items").delete().in("linked_menu_item_id", menuItemIds).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks.filter((l)=>!menuItemIds.includes(l.menuItemId));
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.filter((i)=>!i.linkedMenuItemId || !menuItemIds.includes(i.linkedMenuItemId));
};
// ── Consumption resolution (pure - no network) ────────────────────────────────
// For one cart line, what does each linked inventory item lose? Per inventory
// item: the base row's qty, unless one or more variant override rows MATCH the
// line's selected options - then the SUM of matching overrides replaces base.
// A matching qty-0 override ("None" in the editor) therefore zeroes out the
// base for that option: it counts as matched, contributes 0 to the sum, and
// the perUnit > 0 guard below drops the item entirely when the sum is 0.
// A row only matches if its (variantLabel, variantOption) still exists in the
// product's CURRENT variants JSONB - renamed/removed options never match, so
// orphaned overrides silently fall back to base (surfaced for cleanup in the
// item editor, not here).
const $1e7ab04ca7920cff$var$_resolveLineConsumption = function(line) {
    const links = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks.filter((l)=>l.menuItemId === line.id);
    if (!links.length) return [];
    const menuItem = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.find((i)=>i._id === line.id);
    const validPairs = new Set();
    (menuItem?.variants ?? []).forEach((group)=>{
        (group.options ?? []).forEach((opt)=>{
            validPairs.add(`${group.optionLabel}\u{2225}${opt.optionName}`);
        });
    });
    const selectedNames = new Set((line.selectedVariants ?? []).map((v)=>v.variantName));
    const byItem = new Map();
    links.forEach((l)=>{
        if (!byItem.has(l.inventoryItemId)) byItem.set(l.inventoryItemId, []);
        byItem.get(l.inventoryItemId).push(l);
    });
    const out = [];
    const lineQty = Number(line.quantity) || 1;
    byItem.forEach((rows, inventoryItemId)=>{
        const base = rows.find((r)=>r.variantLabel == null);
        const matched = rows.filter((r)=>r.variantLabel != null && selectedNames.has(r.variantOption) && validPairs.has(`${r.variantLabel}\u{2225}${r.variantOption}`));
        const perUnit = matched.length ? matched.reduce((sum, r)=>sum + r.qty, 0) : base?.qty ?? 0;
        if (perUnit > 0) out.push({
            inventory_item_id: inventoryItemId,
            qty: perUnit * lineQty
        });
    });
    return out;
};
const $1e7ab04ca7920cff$export$3dc5f05489d7fdb1 = function(cartLines) {
    const totals = new Map();
    (cartLines ?? []).forEach((line)=>{
        $1e7ab04ca7920cff$var$_resolveLineConsumption(line).forEach(({ inventory_item_id: inventory_item_id, qty: qty })=>{
            totals.set(inventory_item_id, (totals.get(inventory_item_id) ?? 0) + qty);
        });
    });
    return [
        ...totals.entries()
    ].map(([inventory_item_id, qty])=>({
            inventory_item_id: inventory_item_id,
            qty: qty
        }));
};
const $1e7ab04ca7920cff$export$d8155182f70d6438 = function(menuItemId) {
    const out = [];
    const low = [];
    // Inventory tracking OFF = no alerts anywhere (order-screen chips, the
    // out-of-stock heads-up, KDS). Data stays intact; this only mutes signals.
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.inventoryEnabled === false) return {
        state: 'ok',
        out: out,
        low: low
    };
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks.forEach((l)=>{
        if (l.menuItemId !== menuItemId) return;
        if (!(Number(l.qty) > 0)) return; // a "None" (qty 0) override never drives alerts
        const inv = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.find((i)=>i.id === l.inventoryItemId);
        if (!inv) return;
        if (inv.quantity <= 0) {
            if (!out.includes(inv.name)) out.push(inv.name);
        } else if (inv.lowStockThreshold != null && inv.quantity <= inv.lowStockThreshold) {
            if (!low.includes(inv.name)) low.push(inv.name);
        }
    });
    return {
        state: out.length ? 'out' : low.length ? 'low' : 'ok',
        out: out,
        low: low
    };
};
const $1e7ab04ca7920cff$export$af2ccc42c9ca6b18 = function(menuItemId) {
    return $1e7ab04ca7920cff$export$d8155182f70d6438(menuItemId).state === 'out';
};
const $1e7ab04ca7920cff$export$916349a6610ebe78 = function() {
    const map = new Map();
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.inventoryEnabled === false) return map;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.forEach((i)=>{
        const st = $1e7ab04ca7920cff$export$d8155182f70d6438(i._id);
        if (st.state !== 'ok') map.set(i._id, st);
    });
    return map;
};
const $1e7ab04ca7920cff$export$1435266333031a63 = function(lines, sign = -1) {
    (lines ?? []).forEach(({ inventory_item_id: inventory_item_id, qty: qty })=>{
        const item = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.find((i)=>i.id === inventory_item_id);
        if (item) item.quantity = Math.max(0, item.quantity + sign * qty);
    });
};
const $1e7ab04ca7920cff$export$48ee852592997bc7 = async function(saleId, lines, staffName) {
    const { error: error } = await (0, $asfCf.supabase).rpc("apply_inventory_consumption", {
        p_sale_id: saleId,
        p_lines: lines,
        p_staff_name: staffName || $1e7ab04ca7920cff$var$_inventoryActorName()
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$d49903b08baa44e3 = async function(saleId, staffName) {
    const { error: error } = await (0, $asfCf.supabase).rpc("reverse_inventory_consumption", {
        p_sale_id: saleId,
        p_staff_name: staffName || $1e7ab04ca7920cff$var$_inventoryActorName()
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$9ce3becf58294930 = async function(menuItemId, inventoryItemId, qty, overrides = []) {
    const rows = [
        {
            business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
            menu_item_id: menuItemId,
            inventory_item_id: inventoryItemId,
            qty: Number(qty),
            variant_label: null,
            variant_option: null
        },
        ...overrides.filter((o)=>o.variantLabel && o.variantOption && Number.isFinite(Number(o.qty)) && Number(o.qty) >= 0).map((o)=>({
                business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
                menu_item_id: menuItemId,
                inventory_item_id: inventoryItemId,
                qty: Number(o.qty),
                variant_label: o.variantLabel,
                variant_option: o.variantOption
            }))
    ];
    const { data: data, error: error } = await (0, $asfCf.supabase).from("inventory_links").insert(rows).select();
    if (error) {
        if (error.code === "23505") throw new Error("That product is already linked to this item");
        throw error;
    }
    const links = (data ?? []).map($1e7ab04ca7920cff$var$dbToInventoryLink);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks.push(...links);
    return links[0];
};
const $1e7ab04ca7920cff$export$45217375fd184b3b = async function(linkId, qty) {
    const { error: error } = await (0, $asfCf.supabase).from("inventory_links").update({
        qty: Number(qty)
    }).eq("id", linkId).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const link = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks.find((l)=>l.id === linkId);
    if (link) link.qty = Number(qty);
    return link;
};
const $1e7ab04ca7920cff$export$f2e9359823a750d0 = async function(linkId) {
    const { error: error } = await (0, $asfCf.supabase).from("inventory_links").delete().eq("id", linkId).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks.filter((l)=>l.id !== linkId);
};
// ── Suppliers (STRICTLY optional - nothing anywhere requires one) ────────────
const $1e7ab04ca7920cff$var$dbToSupplier = (row)=>({
        id: row.id,
        name: row.name,
        category: row.category ?? null,
        contactName: row.contact_name ?? null,
        phone: row.phone ?? null,
        email: row.email ?? null,
        address: row.address ?? null,
        leadTimeDays: row.lead_time_days == null ? null : Number(row.lead_time_days),
        paymentTerms: row.payment_terms ?? null,
        minOrder: row.min_order ?? null,
        status: row.status ?? "active",
        notes: row.notes ?? null,
        createdAt: row.created_at
    });
const $1e7ab04ca7920cff$var$_supplierFields = (data)=>({
        name: data.name.trim(),
        category: (data.category ?? "").trim() || null,
        contact_name: (data.contactName ?? "").trim() || null,
        phone: (data.phone ?? "").trim() || null,
        email: (data.email ?? "").trim() || null,
        address: (data.address ?? "").trim() || null,
        lead_time_days: data.leadTimeDays == null || data.leadTimeDays === "" || isNaN(Number(data.leadTimeDays)) ? null : Math.max(0, Math.round(Number(data.leadTimeDays))),
        payment_terms: (data.paymentTerms ?? "").trim() || null,
        min_order: (data.minOrder ?? "").trim() || null,
        status: [
            "active",
            "preferred",
            "on_hold"
        ].includes(data.status) ? data.status : "active",
        notes: (data.notes ?? "").trim() || null
    });
const $1e7ab04ca7920cff$export$9299725340e97fc6 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("suppliers").select("*").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("name");
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.suppliers = (data ?? []).map($1e7ab04ca7920cff$var$dbToSupplier);
};
const $1e7ab04ca7920cff$export$34282235f203c059 = async function(data) {
    const { data: row, error: error } = await (0, $asfCf.supabase).from("suppliers").insert({
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        ...$1e7ab04ca7920cff$var$_supplierFields(data)
    }).select().single();
    if (error) throw error;
    const supplier = $1e7ab04ca7920cff$var$dbToSupplier(row);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.suppliers.push(supplier);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.suppliers.sort((a, b)=>a.name.localeCompare(b.name));
    return supplier;
};
const $1e7ab04ca7920cff$export$34a6a6061705c148 = async function(id, data) {
    const { data: row, error: error } = await (0, $asfCf.supabase).from("suppliers").update({
        ...$1e7ab04ca7920cff$var$_supplierFields(data),
        updated_at: new Date().toISOString()
    }).eq("id", id).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).select().single();
    if (error) throw error;
    const idx = $1e7ab04ca7920cff$export$ca000e230c0caa3e.suppliers.findIndex((s)=>s.id === id);
    if (idx !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.suppliers[idx] = $1e7ab04ca7920cff$var$dbToSupplier(row);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.suppliers.sort((a, b)=>a.name.localeCompare(b.name));
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.suppliers[idx];
};
const $1e7ab04ca7920cff$export$a722dd3aa9fcbcf9 = async function(id) {
    const { error: error } = await (0, $asfCf.supabase).from("suppliers").delete().eq("id", id).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.suppliers = $1e7ab04ca7920cff$export$ca000e230c0caa3e.suppliers.filter((s)=>s.id !== id);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.forEach((i)=>{
        if (i.supplierId === id) i.supplierId = null;
    });
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders.forEach((po)=>{
        if (po.supplierId === id) po.supplierId = null;
    });
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers = $1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers.filter((r)=>r.supplierId !== id); // FK cascades server-side
};
// ── Purchase orders ──────────────────────────────────────────────────────────
// Line totals are always COMPUTED (qty x unitCost); only flat shipping + tax
// are stored. po_number is assigned by a DB trigger (gapless per business).
// "Overdue" is derived display state (sent + expected_date past), never stored.
const $1e7ab04ca7920cff$var$dbToPoLine = (row)=>({
        id: row.id,
        inventoryItemId: row.inventory_item_id ?? null,
        itemName: row.item_name,
        unit: row.unit ?? "unit",
        qty: Number(row.qty ?? 0),
        unitCost: row.unit_cost == null ? null : Number(row.unit_cost),
        createdAt: row.created_at
    });
const $1e7ab04ca7920cff$var$dbToPurchaseOrder = (row)=>({
        id: row.id,
        poNumber: row.po_number,
        supplierId: row.supplier_id ?? null,
        supplierName: row.supplier_name ?? null,
        status: row.status,
        expectedDate: row.expected_date ?? null,
        notes: row.notes ?? null,
        shipping: row.shipping == null ? null : Number(row.shipping),
        tax: row.tax == null ? null : Number(row.tax),
        createdByName: row.created_by_name ?? null,
        receiptUrl: row.receipt_url ?? null,
        createdAt: row.created_at,
        sentAt: row.sent_at ?? null,
        receivedAt: row.received_at ?? null,
        cancelledAt: row.cancelled_at ?? null,
        lines: (row.purchase_order_items ?? []).map($1e7ab04ca7920cff$var$dbToPoLine).sort((a, b)=>new Date(a.createdAt) - new Date(b.createdAt))
    });
const $1e7ab04ca7920cff$export$4faf3f9b9ffc9853 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("purchase_orders").select("*, purchase_order_items(*)").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at", {
        ascending: false
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders = (data ?? []).map($1e7ab04ca7920cff$var$dbToPurchaseOrder);
};
const $1e7ab04ca7920cff$var$_poHeaderFields = (data)=>({
        supplier_id: data.supplierId || null,
        supplier_name: data.supplierId ? $1e7ab04ca7920cff$export$ca000e230c0caa3e.suppliers.find((s)=>s.id === data.supplierId)?.name ?? null : null,
        expected_date: data.expectedDate || null,
        notes: (data.notes ?? "").trim() || null,
        shipping: data.shipping == null || data.shipping === "" ? null : Number(data.shipping) || 0,
        tax: data.tax == null || data.tax === "" ? null : Number(data.tax) || 0,
        // Only written when the caller resolved an upload (undefined = leave as is).
        ...data.receiptUrl !== undefined ? {
            receipt_url: data.receiptUrl || null
        } : {}
    });
const $1e7ab04ca7920cff$export$e1b5b8709c4dd3ea = async function(file) {
    return $1e7ab04ca7920cff$var$uploadImage(file);
};
const $1e7ab04ca7920cff$var$_poLineRows = (poId, lines)=>(lines ?? []).filter((l)=>l.inventoryItemId && Number(l.qty) > 0).map((l)=>{
        const item = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.find((i)=>i.id === l.inventoryItemId);
        return {
            business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
            po_id: poId,
            inventory_item_id: l.inventoryItemId,
            item_name: item?.name ?? l.itemName ?? "Item",
            unit: item?.unit ?? l.unit ?? "unit",
            qty: Number(l.qty),
            unit_cost: l.unitCost == null || l.unitCost === "" ? null : Number(l.unitCost)
        };
    });
const $1e7ab04ca7920cff$export$64c098ad61acc713 = async function(data) {
    const { data: row, error: error } = await (0, $asfCf.supabase).from("purchase_orders").insert({
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        ...$1e7ab04ca7920cff$var$_poHeaderFields(data),
        created_by_name: $1e7ab04ca7920cff$var$_inventoryActorName()
    }).select().single();
    if (error) throw error;
    const lineRows = $1e7ab04ca7920cff$var$_poLineRows(row.id, data.lines);
    let lineData = [];
    if (lineRows.length) {
        const { data: inserted, error: lineError } = await (0, $asfCf.supabase).from("purchase_order_items").insert(lineRows).select();
        if (lineError) throw lineError;
        lineData = inserted ?? [];
    }
    const po = $1e7ab04ca7920cff$var$dbToPurchaseOrder({
        ...row,
        purchase_order_items: lineData
    });
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders.unshift(po);
    return po;
};
const $1e7ab04ca7920cff$export$3f84ff93b90500e1 = async function(id, data) {
    const existing = $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders.find((p)=>p.id === id);
    if (!existing || existing.status !== "draft") throw new Error("Only draft purchase orders can be edited");
    const { data: row, error: error } = await (0, $asfCf.supabase).from("purchase_orders").update({
        ...$1e7ab04ca7920cff$var$_poHeaderFields(data),
        updated_at: new Date().toISOString()
    }).eq("id", id).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).select().single();
    if (error) throw error;
    const { error: delError } = await (0, $asfCf.supabase).from("purchase_order_items").delete().eq("po_id", id).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (delError) throw delError;
    const lineRows = $1e7ab04ca7920cff$var$_poLineRows(id, data.lines);
    let lineData = [];
    if (lineRows.length) {
        const { data: inserted, error: lineError } = await (0, $asfCf.supabase).from("purchase_order_items").insert(lineRows).select();
        if (lineError) throw lineError;
        lineData = inserted ?? [];
    }
    const idx = $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders.findIndex((p)=>p.id === id);
    if (idx !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders[idx] = $1e7ab04ca7920cff$var$dbToPurchaseOrder({
        ...row,
        purchase_order_items: lineData
    });
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders[idx];
};
const $1e7ab04ca7920cff$export$8f7ddc9b24ef771e = async function(id, status) {
    const stamp = status === "sent" ? {
        sent_at: new Date().toISOString()
    } : status === "cancelled" ? {
        cancelled_at: new Date().toISOString()
    } : {};
    const { data: row, error: error } = await (0, $asfCf.supabase).from("purchase_orders").update({
        status: status,
        ...stamp,
        updated_at: new Date().toISOString()
    }).eq("id", id).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).select("*, purchase_order_items(*)").single();
    if (error) throw error;
    const idx = $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders.findIndex((p)=>p.id === id);
    if (idx !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders[idx] = $1e7ab04ca7920cff$var$dbToPurchaseOrder(row);
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders[idx];
};
const $1e7ab04ca7920cff$export$172252b276419be8 = async function(id) {
    const { error: error } = await (0, $asfCf.supabase).rpc("receive_purchase_order", {
        p_po_id: id,
        p_staff_name: $1e7ab04ca7920cff$var$_inventoryActorName()
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$67926c1266cf291c = async function(lines) {
    const { error: error } = await (0, $asfCf.supabase).rpc("apply_stock_count", {
        p_lines: lines,
        p_staff_name: $1e7ab04ca7920cff$var$_inventoryActorName()
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$33005c1ca00aaa85 = async function(name) {
    const normalized = name.trim().toLowerCase();
    if (!normalized) throw new Error("Category name cannot be empty");
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories.includes(normalized)) throw new Error("Category already exists");
    const { error: error } = await (0, $asfCf.supabase).from("menu_categories").insert({
        user_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        name: normalized
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories.push(normalized);
};
const $1e7ab04ca7920cff$export$c0a90379dccf4f2f = async function(name) {
    const affected = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.filter((i)=>i.category === name);
    if (affected.length) {
        const { error: updateError } = await (0, $asfCf.supabase).from("menu_items").update({
            category: "uncategorized"
        }).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq("category", name);
        if (updateError) throw updateError;
        affected.forEach((i)=>{
            i.category = "uncategorized";
        });
    }
    const { error: error } = await (0, $asfCf.supabase).from("menu_categories").delete().eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq("name", name);
    if (error) throw error;
    const index = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories.indexOf(name);
    if (index !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories.splice(index, 1);
};
// ── Settings: adjustment CRUD ─────────────────────────────────────────────────
const $1e7ab04ca7920cff$var$dbToAdjustment = (row)=>({
        id: row.id,
        name: row.name,
        type: row.type,
        calculation: row.calculation,
        value: Number(row.value),
        enabled: row.enabled
    });
const $1e7ab04ca7920cff$export$2b6317b6fe55adc = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("adjustments").select("*").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at");
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.adjustments = data.map($1e7ab04ca7920cff$var$dbToAdjustment);
};
const $1e7ab04ca7920cff$export$1cbf40eefc54bd16 = async function(data) {
    const { data: row, error: error } = await (0, $asfCf.supabase).from("adjustments").insert({
        user_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        name: data.name,
        type: data.type,
        calculation: data.calculation,
        value: Number(data.value) || 0,
        enabled: true
    }).select().single();
    if (error) throw error;
    const adjustment = $1e7ab04ca7920cff$var$dbToAdjustment(row);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.adjustments.push(adjustment);
    return adjustment;
};
const $1e7ab04ca7920cff$export$df7cef76f1f98a4d = async function(id, data) {
    const { error: error } = await (0, $asfCf.supabase).from("adjustments").update({
        name: data.name,
        type: data.type,
        calculation: data.calculation,
        value: Number(data.value) || 0
    }).eq("id", id).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const adj = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.adjustments.find((a)=>a.id === id);
    if (adj) {
        adj.name = data.name;
        adj.type = data.type;
        adj.calculation = data.calculation;
        adj.value = Number(data.value) || 0;
    }
};
const $1e7ab04ca7920cff$export$d38a9df9a4968bac = async function(id) {
    const { error: error } = await (0, $asfCf.supabase).from("adjustments").delete().eq("id", id).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const index = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.adjustments.findIndex((a)=>a.id === id);
    if (index !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.adjustments.splice(index, 1);
};
const $1e7ab04ca7920cff$export$4b286ed06cf9768 = async function(id) {
    const adj = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.adjustments.find((a)=>a.id === id);
    if (!adj) throw new Error("Adjustment not found");
    const newEnabled = !adj.enabled;
    const { error: error } = await (0, $asfCf.supabase).from("adjustments").update({
        enabled: newEnabled
    }).eq("id", id).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    adj.enabled = newEnabled;
};
const $1e7ab04ca7920cff$export$aadd592960d1dd11 = function() {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentPromoCode = null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyCustomer = null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyRedemption = null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.adjustments.filter((a)=>a.enabled).map((a)=>({
            id: a.id,
            name: a.name,
            type: a.type,
            calculation: a.calculation,
            value: a.value,
            appliedValue: a.value,
            removed: false,
            source: "auto"
        }));
};
const $1e7ab04ca7920cff$export$4f757b03a3544c72 = function(id, newValue) {
    const adj = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.find((a)=>a.id === id);
    if (!adj) throw new Error("Receipt adjustment not found");
    adj.appliedValue = Number(newValue) || 0;
};
const $1e7ab04ca7920cff$export$f2cecf21ffa2f3f3 = function(id) {
    const adj = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.find((a)=>a.id === id);
    if (!adj) throw new Error("Receipt adjustment not found");
    adj.removed = true;
};
const $1e7ab04ca7920cff$export$907cf8608154bbcb = function(data) {
    const adjustment = {
        id: $1e7ab04ca7920cff$var$generateAdjustmentId(),
        name: data.name,
        type: data.type,
        calculation: data.calculation,
        value: Number(data.value) || 0,
        appliedValue: Number(data.value) || 0,
        removed: false,
        source: "manual",
        // When a cashier without apply_receipt_adjustment adds this via a manager
        // override, record who authorized it (persists into the sale's adjustments).
        approvedBy: data.approvedBy ?? null
    };
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.push(adjustment);
    return adjustment;
};
const $1e7ab04ca7920cff$export$34e40abced25fa5e = function() {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments = [];
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentPromoCode = null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyCustomer = null;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyRedemption = null;
};
const $1e7ab04ca7920cff$export$4ebaf9892475ce49 = function() {
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings;
    const rate = Number(s.taxInclusiveRate);
    if (s.taxMode !== "exclusive" || !(rate > 0)) return null;
    return {
        name: (0, $ff150a18d4a6f5bb$export$c829991a0e9a63)(),
        rate: rate
    };
};
const $1e7ab04ca7920cff$export$1e7528f2cdbb9715 = function(subtotal, adjustments, items = [], tax = $1e7ab04ca7920cff$export$4ebaf9892475ce49()) {
    const active = adjustments.filter((a)=>!a.removed);
    const discounts = active.filter((a)=>a.type === "discount");
    const fees = active.filter((a)=>a.type === "fee");
    const isExempt = (it)=>(it.taxClass ?? $1e7ab04ca7920cff$export$83f9fbc1f115c860(it.id)) === "exempt";
    const lineExempt = new Map(items.map((it)=>[
            it.lineId,
            isExempt(it)
        ]));
    const taxableGross = items.reduce((acc, it)=>acc + (isExempt(it) ? 0 : Number(it.totalPrice) || 0), 0);
    const taxableShare = subtotal > 0 ? taxableGross / subtotal : 0;
    let runningTotal = subtotal;
    let taxableBase = taxableGross;
    const lineItems = [];
    discounts.forEach((adj)=>{
        const amount = adj.calculation === "percentage" ? subtotal * (adj.appliedValue / 100) : adj.appliedValue;
        lineItems.push({
            ...adj,
            computedAmount: -amount
        });
        runningTotal -= amount;
        // A free-item reward comps one specific line, so it only lowers the
        // taxable base if that line is taxable; every other discount is spread
        // across the cart in proportion.
        taxableBase -= adj.source === "loyalty_reward" ? lineExempt.get(adj.cartItemLineId) ? 0 : amount : amount * taxableShare;
    });
    fees.forEach((adj)=>{
        const amount = adj.calculation === "percentage" ? runningTotal * (adj.appliedValue / 100) : adj.appliedValue;
        lineItems.push({
            ...adj,
            computedAmount: amount
        });
        runningTotal += amount;
        taxableBase += amount;
    });
    let taxAmount = 0;
    if (tax) {
        taxAmount = Math.max(0, taxableBase) * (tax.rate / 100);
        lineItems.push({
            id: "sales-tax",
            name: tax.name,
            type: "fee",
            calculation: "percentage",
            value: tax.rate,
            appliedValue: tax.rate,
            removed: false,
            source: "tax",
            isTax: true,
            computedAmount: taxAmount
        });
    }
    return {
        subtotal: subtotal,
        lineItems: lineItems,
        finalTotal: Math.max(0, runningTotal + taxAmount)
    };
};
// ── Today's sales total ───────────────────────────────────────────────────────
// The business's calendar day (its timezone, not the device's) as [start, end].
// A register whose clock is set to another zone must still count the cafe's
// "today" (team test 2026-10-24: a device ahead of Portland showed tomorrow).
const $1e7ab04ca7920cff$var$_bizDay = (offset = 0)=>{
    const tz = $1e7ab04ca7920cff$export$74881ed03683ce30();
    const day = (0, $lDSCx.addDays)((0, $lDSCx.todayIn)(tz), offset);
    return [
        (0, $lDSCx.zonedToDate)(day, '00:00', tz),
        new Date((0, $lDSCx.zonedToDate)((0, $lDSCx.addDays)(day, 1), '00:00', tz).getTime() - 1)
    ];
};
const $1e7ab04ca7920cff$export$ec944a5e9be9dae8 = async function() {
    const [start, end] = $1e7ab04ca7920cff$var$_bizDay(0);
    const { data: data, error: error } = await (0, $asfCf.supabase).from("sales").select("total_price").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte("sale_date", start.toISOString()).lte("sale_date", end.toISOString()).is("voided_at", null);
    if (error) throw error;
    return data.reduce((sum, r)=>sum + Number(r.total_price), 0);
};
const $1e7ab04ca7920cff$export$d26986fd4f5259c1 = async function() {
    const [start, end] = $1e7ab04ca7920cff$var$_bizDay(0);
    const { data: data, error: error } = await (0, $asfCf.supabase).from("expenses").select("amount").gte("expense_date", start.toISOString()).lte("expense_date", end.toISOString());
    if (error) throw error;
    return (data ?? []).reduce((sum, r)=>sum + Number(r.amount ?? 0), 0);
};
const $1e7ab04ca7920cff$export$f25734b7deb6ab90 = async function(startISO, endISO) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("sales").select("items, tip_amount").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte("sale_date", startISO).lte("sale_date", endISO).is("voided_at", null);
    if (error) throw error;
    let tips = 0, tipped = 0, itemsSold = 0;
    const counts = new Map();
    for (const r of data ?? []){
        const tip = Number(r.tip_amount ?? 0);
        tips += tip;
        if (tip > 0) tipped++;
        for (const it of r.items ?? []){
            const q = Number(it.quantity ?? 1);
            itemsSold += q;
            counts.set(it.itemName, (counts.get(it.itemName) ?? 0) + q);
        }
    }
    const top = [
        ...counts
    ].map(([name, quantity])=>({
            name: name,
            quantity: quantity
        })).sort((a, b)=>b.quantity - a.quantity).slice(0, 5);
    return {
        tips: tips,
        tipped: tipped,
        itemsSold: itemsSold,
        top: top
    };
};
const $1e7ab04ca7920cff$export$b3700a60d4c9ee6e = async function(startISO, endISO) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("sales").select("sale_date, total_price").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte("sale_date", startISO).lte("sale_date", endISO).is("voided_at", null);
    if (error) throw error;
    return (data ?? []).map((r)=>({
            at: new Date(r.sale_date).getTime(),
            total: Number(r.total_price) || 0
        }));
};
const $1e7ab04ca7920cff$export$54cb0d704712bfd = async function() {
    const [todayStart, todayEnd] = $1e7ab04ca7920cff$var$_bizDay(0);
    const [yesterdayStart, yesterdayEnd] = $1e7ab04ca7920cff$var$_bizDay(-1);
    const [todayRes, yestRes] = await Promise.all([
        (0, $asfCf.supabase).from('sales').select('id', {
            count: 'exact',
            head: true
        }).eq('user_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte('sale_date', todayStart.toISOString()).lte('sale_date', todayEnd.toISOString()).is('voided_at', null),
        (0, $asfCf.supabase).from('sales').select('id', {
            count: 'exact',
            head: true
        }).eq('user_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte('sale_date', yesterdayStart.toISOString()).lte('sale_date', yesterdayEnd.toISOString()).is('voided_at', null)
    ]);
    return {
        today: todayRes.count ?? 0,
        yesterday: yestRes.count ?? 0
    };
};
const $1e7ab04ca7920cff$export$7274521d86e2ed95 = async function() {
    const { count: count, error: error } = await (0, $asfCf.supabase).from('sales').select('id', {
        count: 'exact',
        head: true
    }).eq('user_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) return false;
    return (count ?? 0) > 0;
};
const $1e7ab04ca7920cff$export$cf49a3abf54dee13 = async function(req) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc("record_sale", {
        p_items: req.items,
        p_adjustment_templates: req.adjustmentTemplates,
        p_manual_adjustments: req.manualAdjustments,
        p_promo_code: req.promoCode,
        p_loyalty_redeem_increments: req.loyaltyRedeemIncrements ?? 0,
        p_loyalty_rewards: req.loyaltyRewards,
        p_customer_id: req.customerId,
        p_order_type: req.orderType,
        p_payment_method: req.paymentMethod,
        p_ticket_number: req.ticketNumber,
        p_customer_payment: req.customerPayment,
        p_customer_change: req.customerChange,
        p_cashier_name: req.cashierName,
        p_logged_in_cashier: req.loggedInCashier,
        p_sale_date: new Date(req.date).toISOString(),
        p_tip_amount: req.tipAmount ?? 0,
        // Table fields (migration-2026-10-22-tables.sql) only travel when used, so
        // a sale without a table matches the older record_sale too.
        ...req.tableId ? {
            p_table_id: req.tableId
        } : {},
        ...req.tableName ? {
            p_table_name: req.tableName
        } : {},
        ...req.tabId ? {
            p_tab_id: req.tabId
        } : {},
        ...req.tabLineIds ? {
            p_tab_line_ids: req.tabLineIds
        } : {}
    });
    if (error) throw error;
    return {
        id: data.id,
        receiptNumber: data.receipt_number,
        subtotal: Number(data.subtotal),
        totalPrice: Number(data.total_price),
        taxInclusiveRate: data.tax_inclusive_rate,
        items: data.items,
        adjustments: data.adjustments,
        customerId: data.customer_id,
        loyaltyEarnedPoints: data.loyalty_earned_points,
        loyaltyRedeemedPoints: data.loyalty_redeemed_points,
        tipAmount: Number(data.tip_amount ?? 0),
        tableName: data.table_name ?? null
    };
};
const $1e7ab04ca7920cff$export$324a1aa31eacd016 = async function() {
    const [start, end] = $1e7ab04ca7920cff$var$_bizDay(-1);
    const { data: data, error: error } = await (0, $asfCf.supabase).from("sales").select("total_price").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte("sale_date", start.toISOString()).lte("sale_date", end.toISOString()).is("voided_at", null);
    if (error) throw error;
    return data.reduce((sum, r)=>sum + Number(r.total_price), 0);
};
const $1e7ab04ca7920cff$export$4f704ada9f12295b = async function(startISO, endISO) {
    const [salesResult, expensesResult, voidedResult] = await Promise.all([
        (0, $asfCf.supabase).from("sales").select("id, total_price, subtotal, customer_payment, customer_change, adjustments, sale_date, items, is_manual, added_by, order_type, payment_method, ticket_number, receipt_number, tax_inclusive_rate, prepared_at, timed_out, tip_amount").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte("sale_date", startISO).lte("sale_date", endISO).is("voided_at", null).order("sale_date", {
            ascending: false
        }),
        (0, $asfCf.supabase).from("expenses").select("*").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte("expense_date", startISO).lte("expense_date", endISO).order("expense_date", {
            ascending: false
        }),
        (0, $asfCf.supabase).from("sales").select("id, total_price, subtotal, customer_payment, customer_change, adjustments, sale_date, items, added_by, order_type, payment_method, ticket_number, receipt_number, tax_inclusive_rate, voided_at, voided_by, tip_amount").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte("sale_date", startISO).lte("sale_date", endISO).not("voided_at", "is", null).order("voided_at", {
            ascending: false
        })
    ]);
    if (salesResult.error) throw salesResult.error;
    if (expensesResult.error) throw expensesResult.error;
    if (voidedResult.error) throw voidedResult.error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.cashflowSales = salesResult.data;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.expenses = expensesResult.data.map($1e7ab04ca7920cff$var$dbToExpense);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.voidedSales = voidedResult.data;
};
// ── Home activity feed ────────────────────────────────────────────────────────
// Derives the "last N updates" from the tables that already record them - no
// activity_log table exists. Six small LIMIT queries run in parallel; each
// source degrades to [] on error (e.g. shifts RLS for a non-owner admin,
// un-migrated inventory tables) so one failure never blanks the feed.
// Low/out-of-stock entries need no query: they come from the already-loaded
// state.inventoryItems, timestamped with the item's updated_at (every stock
// RPC stamps it, so it approximates when the item hit its current level).
// Sale payloads carry the full row (same columns as fetchCashflowData) so a
// feed click can open the sale-receipt modal and reprint with no extra fetch.
// Writes NO state - the caller (controller) caches the returned events.
const $1e7ab04ca7920cff$var$ACTIVITY_SALE_COLUMNS = "id, total_price, subtotal, customer_payment, customer_change, adjustments, sale_date, items, is_manual, added_by, order_type, payment_method, ticket_number, receipt_number, tax_inclusive_rate, prepared_at, timed_out, voided_at, voided_by, tip_amount";
const $1e7ab04ca7920cff$export$967c92ed76f908b6 = async function(limit = 15) {
    const safe = (query)=>query.then((res)=>res.error ? [] : res.data ?? [], ()=>[]);
    const [sales, voids, expenses, clockIns, clockOuts, adjustments, newCustomers, receivedPos] = await Promise.all([
        safe((0, $asfCf.supabase).from("sales").select($1e7ab04ca7920cff$var$ACTIVITY_SALE_COLUMNS).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("sale_date", {
            ascending: false
        }).limit(limit)),
        safe((0, $asfCf.supabase).from("sales").select($1e7ab04ca7920cff$var$ACTIVITY_SALE_COLUMNS).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).not("voided_at", "is", null).order("voided_at", {
            ascending: false
        }).limit(limit)),
        safe((0, $asfCf.supabase).from("expenses").select("*").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at", {
            ascending: false
        }).limit(limit)),
        // source: real time-clock punches only (NULL predates the column = clock).
        // 'manual' (admin-typed, can carry any time incl. future) and 'request'
        // (approved corrections/backfills) are bookkeeping, not "X timed in" events.
        safe((0, $asfCf.supabase).from("shifts").select("id, clocked_in_at, clocked_out_at, staff:staff!shifts_staff_id_fkey(first_name, last_name)").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).is("deleted_at", null).or("source.is.null,source.eq.clock").order("clocked_in_at", {
            ascending: false
        }).limit(limit)),
        safe((0, $asfCf.supabase).from("shifts").select("id, clocked_out_at, staff:staff!shifts_staff_id_fkey(first_name, last_name)").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).is("deleted_at", null).or("source.is.null,source.eq.clock").not("clocked_out_at", "is", null).order("clocked_out_at", {
            ascending: false
        }).limit(limit)),
        // kind='manual' only - 'sale'/'void' rows would duplicate the sale/void events
        safe((0, $asfCf.supabase).from("inventory_adjustments").select("id, delta, note, staff_name, created_at, inventory_item_id, inventory_items(name, unit)").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq("kind", "manual").order("created_at", {
            ascending: false
        }).limit(limit)),
        // New loyalty members. RLS note: a manage_business holder without a
        // loyalty capability just gets 0 rows here - the feed degrades gracefully.
        safe((0, $asfCf.supabase).from("customers").select("id, name, phone, created_at").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at", {
            ascending: false
        }).limit(limit)),
        // Received purchase orders - ONE event per PO (the per-line kind='po'
        // adjustment rows deliberately don't feed here; a 10-line PO is one update).
        safe((0, $asfCf.supabase).from("purchase_orders").select("id, po_number, supplier_name, received_at").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).not("received_at", "is", null).order("received_at", {
            ascending: false
        }).limit(limit))
    ]);
    const shiftName = (r)=>`${r.staff?.first_name ?? ""} ${r.staff?.last_name ?? ""}`.trim() || "Staff";
    const events = [
        // A voided sale keeps its "recorded" event (query 1 has no void filter)
        // AND gains a "voided" event at voided_at - both are real updates.
        ...sales.map((row)=>({
                id: `sale:${row.id}`,
                type: "sale",
                ts: row.sale_date,
                payload: row
            })),
        ...voids.map((row)=>({
                id: `void:${row.id}`,
                type: "void",
                ts: row.voided_at,
                payload: row
            })),
        // created_at, not expense_date: a backdated expense entered just now IS a
        // recent update, and that's what a feed of "what happened" should show.
        ...expenses.map($1e7ab04ca7920cff$var$dbToExpense).map((e)=>({
                id: `exp:${e.id}`,
                type: "expense",
                ts: e.createdAt,
                payload: e
            })),
        ...clockIns.map((r)=>({
                id: `in:${r.id}`,
                type: "clock_in",
                ts: r.clocked_in_at,
                payload: {
                    staffName: shiftName(r)
                }
            })),
        ...clockOuts.map((r)=>({
                id: `out:${r.id}`,
                type: "clock_out",
                ts: r.clocked_out_at,
                payload: {
                    staffName: shiftName(r)
                }
            })),
        ...adjustments.map((row)=>({
                id: `adj:${row.id}`,
                type: "stock_adjust",
                ts: row.created_at,
                payload: {
                    itemName: row.inventory_items?.name ?? "Inventory item",
                    unit: row.inventory_items?.unit ?? "unit",
                    delta: Number(row.delta),
                    note: row.note ?? null,
                    staffName: row.staff_name ?? null
                }
            })),
        ...newCustomers.map((row)=>({
                id: `cust:${row.id}`,
                type: "customer_enrolled",
                ts: row.created_at,
                payload: {
                    name: row.name ?? null,
                    phone: row.phone
                }
            })),
        ...receivedPos.map((row)=>({
                id: `po:${row.id}`,
                type: "po_received",
                ts: row.received_at,
                payload: {
                    poNumber: row.po_number,
                    supplierName: row.supplier_name ?? null
                }
            })),
        // Same rules as productStockStatus: at/below zero = out; else at/below the
        // item's own alert threshold (null threshold = never alerts) = low.
        // Muted entirely while inventory tracking is off.
        ...($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.inventoryEnabled === false ? [] : $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems).flatMap((item)=>{
            const base = {
                payload: {
                    itemName: item.name,
                    unit: item.unit,
                    quantity: item.quantity
                },
                ts: item.updatedAt ?? item.createdAt
            };
            if (item.quantity <= 0) return [
                {
                    id: `oos:${item.id}`,
                    type: "out_of_stock",
                    ...base
                }
            ];
            if (item.lowStockThreshold != null && item.quantity <= item.lowStockThreshold) return [
                {
                    id: `low:${item.id}`,
                    type: "low_stock",
                    ...base
                }
            ];
            return [];
        })
    ];
    return events.filter((e)=>e.ts).sort((a, b)=>new Date(b.ts) - new Date(a.ts)).slice(0, limit);
};
const $1e7ab04ca7920cff$export$14a211d2708579d7 = async function(id, voidedBy, client = (0, $asfCf.supabase)) {
    const now = new Date().toISOString();
    const { error: error } = await client.from('sales').update({
        voided_at: now,
        voided_by: voidedBy
    }).eq('id', id).eq('user_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const wasInQueue = $1e7ab04ca7920cff$export$ca000e230c0caa3e.orderQueue.some((o)=>o.id === id);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.orderQueue = $1e7ab04ca7920cff$export$ca000e230c0caa3e.orderQueue.filter((o)=>o.id !== id);
    const voidedSale = $1e7ab04ca7920cff$export$ca000e230c0caa3e.cashflowSales.find((s)=>s.id === id);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.cashflowSales = $1e7ab04ca7920cff$export$ca000e230c0caa3e.cashflowSales.filter((s)=>s.id !== id);
    if (voidedSale) $1e7ab04ca7920cff$export$ca000e230c0caa3e.voidedSales = [
        {
            ...voidedSale,
            voided_at: now,
            voided_by: voidedBy
        },
        ...$1e7ab04ca7920cff$export$ca000e230c0caa3e.voidedSales
    ];
    return {
        wasInQueue: wasInQueue
    };
};
// A password re-auth on an isolated client lands at aal1. The database refuses aal1
// sessions for accounts with a verified authenticator (migration-2026-10-08-require-mfa),
// so those accounts must also pass their 6-digit code before the temp client can query.
// No code yet -> sign the temp client out and throw MFA_REQUIRED so the UI can ask for it.
const $1e7ab04ca7920cff$var$_elevateTempClient = async function(tempClient, mfaCode) {
    const { data: aal } = await tempClient.auth.mfa.getAuthenticatorAssuranceLevel();
    if (!(aal?.currentLevel === 'aal1' && aal?.nextLevel === 'aal2')) return;
    const { data: factors } = await tempClient.auth.mfa.listFactors();
    const factorId = (factors?.all ?? []).find((f)=>f.factor_type === 'totp' && f.status === 'verified')?.id;
    if (!factorId) return;
    if (!mfaCode) {
        await tempClient.auth.signOut({
            scope: 'local'
        });
        const err = new Error('Enter the 6-digit code from the authenticator app for this account.');
        err.code = 'MFA_REQUIRED';
        throw err;
    }
    const { error: error } = await tempClient.auth.mfa.challengeAndVerify({
        factorId: factorId,
        code: mfaCode
    });
    if (error) {
        await tempClient.auth.signOut({
            scope: 'local'
        });
        const err = new Error('Incorrect or expired code. Try again.');
        err.code = 'MFA_REQUIRED';
        throw err;
    }
};
const $1e7ab04ca7920cff$export$b1d9775b76ee4d04 = async function(email, password, requiredCap = 'void_sale', captchaToken, mfaCode, whileSignedIn) {
    const tempClient = (0, $dNnfS.createClient)((0, $asfCf.supabaseUrl), (0, $asfCf.supabaseAnonKey), {
        auth: {
            persistSession: false,
            autoRefreshToken: false,
            detectSessionInUrl: false
        }
    });
    // CAPTCHA enforcement in Supabase is project-wide, so this re-auth signInWithPassword
    // needs a token too. Without it the call fails - which we must NOT mislabel as a bad
    // password, or a manager will retype correct credentials forever.
    const { data: authData, error: authError } = await tempClient.auth.signInWithPassword({
        email: email,
        password: password,
        options: {
            captchaToken: captchaToken
        }
    });
    if (authError) {
        if (/captcha/i.test(authError.message || '')) throw new Error('Verification check failed. Please try again.');
        throw new Error('Invalid email or password.');
    }
    await $1e7ab04ca7920cff$var$_elevateTempClient(tempClient, mfaCode);
    try {
        const { data: staffData } = await tempClient.from('staff').select('first_name, last_name, roles(name, permissions)').eq('user_id', authData.user.id).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq('is_active', true).maybeSingle();
        if (!staffData) throw new Error('This account is not a staff member at this location.');
        // The overriding account must itself be allowed to void (the owner always can).
        const isOwnerOverride = authData.user.id === $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId;
        const caps = $1e7ab04ca7920cff$export$94cfe010e61a30ec(staffData.roles?.name, staffData.roles?.permissions);
        if (!isOwnerOverride && !caps.has(requiredCap)) throw new Error('This account does not have permission to authorize this action.');
        const approver = [
            staffData.first_name,
            staffData.last_name
        ].filter(Boolean).join(' ') || email;
        if (whileSignedIn) await whileSignedIn(tempClient, approver);
        return approver;
    } finally{
        await tempClient.auth.signOut({
            scope: 'local'
        });
    }
};
const $1e7ab04ca7920cff$export$61f47d989fe77545 = async function(startISO, endISO) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("sales").select("id, total_price, sale_date, items, added_by, order_type, prepared_at, ready_at, payment_method, tip_amount").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte("sale_date", startISO).lte("sale_date", endISO).is("voided_at", null).order("sale_date", {
        ascending: true
    });
    if (error) throw error;
    return data ?? [];
};
const $1e7ab04ca7920cff$export$993437c9947c004b = async function(startISO, endISO) {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.reportsSales = await $1e7ab04ca7920cff$export$61f47d989fe77545(startISO, endISO);
};
const $1e7ab04ca7920cff$export$2614d9fab0c6cda6 = async function(startISO, endISO) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("sales").select("total_price, sale_date, prepared_at, ticket_number").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte("sale_date", startISO).lte("sale_date", endISO).is("voided_at", null);
    if (error) throw error;
    const revenue = data.reduce((s, r)=>s + Number(r.total_price), 0);
    const transactions = data.length;
    let servTotal = 0, servCount = 0;
    // Extra queue stats for the Active Queue's empty state ("Today so far").
    let completed = 0, longest = null, lastDoneAt = null;
    const servingMinutes = [];
    const perHour = new Map();
    for (const r of data){
        const hr = new Date(r.sale_date).getHours();
        perHour.set(hr, (perHour.get(hr) ?? 0) + 1);
        if (!r.prepared_at) continue;
        completed++;
        const doneAt = new Date(r.prepared_at).getTime();
        if (lastDoneAt === null || doneAt > lastDoneAt) lastDoneAt = doneAt;
        const mins = (doneAt - new Date(r.sale_date)) / 60000;
        if (mins < 0) continue;
        // Every done order counts toward the on time / slow / delayed split;
        // only the averages and longest wait drop the >2h outliers.
        servingMinutes.push(mins);
        if (mins > 120) continue;
        servTotal += mins;
        servCount++;
        if (!longest || mins > longest.minutes) longest = {
            minutes: mins,
            ticketNumber: r.ticket_number ?? null
        };
    }
    let busiestHour = null;
    perHour.forEach((n, hr)=>{
        if (n > 1 && (!busiestHour || n > busiestHour.count)) busiestHour = {
            hour: hr,
            count: n
        };
    });
    return {
        revenue: revenue,
        transactions: transactions,
        avgOrder: transactions > 0 ? revenue / transactions : 0,
        avgServingMinutes: servCount > 0 ? servTotal / servCount : null,
        completed: completed,
        longest: longest,
        lastDoneAt: lastDoneAt,
        busiestHour: busiestHour,
        servingMinutes: servingMinutes
    };
};
const $1e7ab04ca7920cff$export$ba65f3bfbeeb19bf = async function(startISO, endISO) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("expenses").select("amount").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte("expense_date", startISO).lte("expense_date", endISO);
    if (error) throw error;
    return data.reduce((s, e)=>s + Number(e.amount), 0);
};
const $1e7ab04ca7920cff$export$6ca62e590a866144 = async function({ amount: amount, description: description, category: category, expense_date: expense_date }) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("expenses").insert({
        user_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        store_name: $1e7ab04ca7920cff$export$ca000e230c0caa3e.username,
        amount: Number(amount),
        description: description,
        category: category || null,
        expense_date: expense_date,
        created_by: $1e7ab04ca7920cff$export$ca000e230c0caa3e.username
    }).select().single();
    if (error) throw error;
    const expense = $1e7ab04ca7920cff$var$dbToExpense(data);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.expenses.unshift(expense);
    return expense;
};
const $1e7ab04ca7920cff$export$f82302593dfecf81 = async function(id) {
    const { error: error } = await (0, $asfCf.supabase).from("expenses").delete().eq("id", id).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const index = $1e7ab04ca7920cff$export$ca000e230c0caa3e.expenses.findIndex((e)=>e.id === id);
    if (index !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.expenses.splice(index, 1);
};
// ── Discount Codes ────────────────────────────────────────────────────────────
const $1e7ab04ca7920cff$var$dbToDiscountCode = (row)=>({
        id: row.id,
        title: row.title,
        code: row.code,
        description: row.description ?? "",
        type: row.type,
        value: Number(row.value),
        usageLimit: row.usage_limit,
        usageCount: row.usage_count,
        status: row.status,
        createdAt: row.created_at
    });
const $1e7ab04ca7920cff$export$99071deb5c3e11b = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("discount_codes").select("*").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at");
    if (error) {
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes = [];
        return;
    }
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes = data.map($1e7ab04ca7920cff$var$dbToDiscountCode);
};
const $1e7ab04ca7920cff$export$213c8a208a34f60d = async function(data) {
    const code = data.code.toUpperCase().trim();
    const { data: row, error: error } = await (0, $asfCf.supabase).from("discount_codes").insert({
        user_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        title: data.title,
        code: code,
        description: data.description || null,
        type: data.type,
        value: Number(data.value),
        usage_limit: data.usageLimit ?? null,
        usage_count: 0,
        status: "active"
    }).select().single();
    if (error) throw error;
    const dc = $1e7ab04ca7920cff$var$dbToDiscountCode(row);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes.push(dc);
    return dc;
};
const $1e7ab04ca7920cff$export$51125fa74adfef58 = async function(id, data) {
    const code = data.code.toUpperCase().trim();
    const { error: error } = await (0, $asfCf.supabase).from("discount_codes").update({
        title: data.title,
        code: code,
        description: data.description || null,
        type: data.type,
        value: Number(data.value),
        usage_limit: data.usageLimit ?? null
    }).eq("id", id).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const dc = $1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes.find((d)=>d.id === id);
    if (dc) {
        dc.title = data.title;
        dc.code = code;
        dc.description = data.description || "";
        dc.type = data.type;
        dc.value = Number(data.value);
        dc.usageLimit = data.usageLimit ?? null;
    }
};
const $1e7ab04ca7920cff$export$8e82bacc77a2ed5 = async function(id) {
    const { error: error } = await (0, $asfCf.supabase).from("discount_codes").delete().eq("id", id).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const index = $1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes.findIndex((d)=>d.id === id);
    if (index !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes.splice(index, 1);
};
const $1e7ab04ca7920cff$export$bd5aeb75f2cd95de = async function(id) {
    const dc = $1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes.find((d)=>d.id === id);
    if (!dc) throw new Error("Code not found");
    const newStatus = dc.status === "active" ? "paused" : "active";
    const { error: error } = await (0, $asfCf.supabase).from("discount_codes").update({
        status: newStatus
    }).eq("id", id).eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    dc.status = newStatus;
};
const $1e7ab04ca7920cff$export$69d9d60ced6371b7 = function(code) {
    const normalized = code.toUpperCase().trim();
    const dc = $1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes.find((d)=>d.code === normalized);
    if (!dc) throw new Error("Invalid promo code");
    if (dc.status !== "active") throw new Error("This code is currently inactive");
    if (dc.usageLimit !== null && dc.usageCount >= dc.usageLimit) throw new Error("This code has reached its usage limit");
    return dc;
};
const $1e7ab04ca7920cff$export$c468eb2bf8375cfd = function(dc) {
    const adj = {
        id: $1e7ab04ca7920cff$var$generateAdjustmentId(),
        name: `Promo (${dc.code})`,
        type: "discount",
        calculation: dc.type === "percentage" ? "percentage" : "fixed",
        value: dc.value,
        appliedValue: dc.value,
        removed: false,
        source: "promo-code"
    };
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.push(adj);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentPromoCode = {
        discountCodeId: dc.id,
        adjId: adj.id,
        code: dc.code,
        title: dc.title,
        type: dc.type,
        value: dc.value
    };
    return adj;
};
const $1e7ab04ca7920cff$export$d994b63208696464 = function() {
    if (!$1e7ab04ca7920cff$export$ca000e230c0caa3e.currentPromoCode) return;
    const { adjId: adjId } = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentPromoCode;
    const index = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.findIndex((a)=>a.id === adjId);
    if (index !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.splice(index, 1);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentPromoCode = null;
};
// ── Loyalty program ───────────────────────────────────────────────────────────
// Customers are identified by phone (digits-only, unique per business). Points
// balance is denormalized on customers; the loyalty_transactions ledger (RPC-
// written only) is the audit truth. A redemption is just a fixed discount line
// in currentReceiptAdjustments (source: "loyalty"), so calculateAdjustments,
// the receipt, and the tax-inclusive split all handle it with zero changes.
const $1e7ab04ca7920cff$var$dbToCustomer = (row)=>({
        id: row.id,
        phone: row.phone,
        name: row.name ?? null,
        email: row.email ?? null,
        birthdayMonth: row.birthday_month ?? null,
        birthdayDay: row.birthday_day ?? null,
        note: row.note ?? null,
        pointsBalance: row.points_balance ?? 0,
        visitCount: row.visit_count ?? 0,
        lastVisitAt: row.last_visit_at ?? null,
        createdAt: row.created_at ?? null
    });
// Normalize the optional profile fields shared by enroll + update. Empty
// strings become NULL so the DB stays clean.
const $1e7ab04ca7920cff$var$_customerExtras = function(extras = {}) {
    const out = {};
    if ('email' in extras) out.email = (extras.email ?? '').trim() || null;
    if ('note' in extras) out.note = (extras.note ?? '').trim() || null;
    if ('birthdayMonth' in extras || 'birthdayDay' in extras) {
        const m = parseInt(extras.birthdayMonth);
        const d = parseInt(extras.birthdayDay);
        // Birthday is stored only when BOTH parts are valid (a month without a
        // day, or vice versa, is meaningless).
        const valid = m >= 1 && m <= 12 && d >= 1 && d <= 31;
        out.birthday_month = valid ? m : null;
        out.birthday_day = valid ? d : null;
    }
    return out;
};
const $1e7ab04ca7920cff$export$6f115fe55d0ffa50 = async function(rawPhone) {
    const phone = (0, $dv0h8.normalizePhone)(rawPhone);
    if (!phone) throw new Error("Please enter a valid phone number");
    const { data: data, error: error } = await (0, $asfCf.supabase).from("customers").select("*").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq("phone", phone).maybeSingle();
    if (error) throw error;
    if (!data) return null;
    const customer = $1e7ab04ca7920cff$var$dbToCustomer(data);
    const { data: saleRows, error: salesError } = await (0, $asfCf.supabase).from("sales").select("sale_date").eq("customer_id", customer.id).is("voided_at", null);
    if (salesError) throw salesError;
    customer.saleDates = (saleRows ?? []).map((r)=>r.sale_date);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyCustomer = customer;
    return customer;
};
const $1e7ab04ca7920cff$export$ff11d013c2c70fac = async function(rawPhone, name, extras = {}, { strict: strict = false } = {}) {
    const phone = (0, $dv0h8.normalizePhone)(rawPhone);
    if (!phone) throw new Error("Please enter a valid phone number");
    const cleanName = (name ?? "").trim() || null;
    const { data: data, error: error } = await (0, $asfCf.supabase).from("customers").insert({
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        phone: phone,
        name: cleanName,
        ...$1e7ab04ca7920cff$var$_customerExtras(extras)
    }).select("*").single();
    if (error) {
        if (error.code === "23505") {
            if (strict) throw new Error("A customer with this phone number already exists.");
            return await $1e7ab04ca7920cff$export$6f115fe55d0ffa50(phone);
        }
        throw error;
    }
    const customer = $1e7ab04ca7920cff$var$dbToCustomer(data);
    customer.saleDates = [];
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyCustomer = customer;
    return customer;
};
const $1e7ab04ca7920cff$export$bef73de7c08bced2 = async function(id, { name: name, ...extras }) {
    const fields = {
        name: (name ?? "").trim() || null,
        ...$1e7ab04ca7920cff$var$_customerExtras(extras)
    };
    const { data: data, error: error } = await (0, $asfCf.supabase).from("customers").update(fields).eq("id", id).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).select("*").single();
    if (error) throw error;
    return $1e7ab04ca7920cff$var$dbToCustomer(data);
};
const $1e7ab04ca7920cff$export$90bd2ffe141ff8ad = function() {
    $1e7ab04ca7920cff$export$8f8f3a01cb0b2825();
    // Strip any free-item reward redemptions too - they're only meaningful
    // while a customer is linked (unlike removeLoyaltyRedemptionFromReceipt,
    // there can be several, one per redemption). Each one minted its own cart
    // line (2026-07-27) - those come out too, otherwise the "free" item
    // reverts to full price the instant its comping discount disappears.
    const rewardLineIds = new Set($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.filter((a)=>a.source === "loyalty_reward").map((a)=>a.cartItemLineId));
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.filter((a)=>a.source !== "loyalty_reward");
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart = $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.filter((it)=>!rewardLineIds.has(it.lineId));
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyCustomer = null;
};
const $1e7ab04ca7920cff$export$96221fd73c9bfdd6 = function(increments) {
    const customer = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyCustomer;
    if (!customer) throw new Error("No loyalty customer linked");
    const n = Math.floor(Number(increments) || 0);
    if (n < 1) throw new Error("Nothing to redeem");
    const points = n * $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.loyaltyRedeemPoints;
    // Subtract only reward-reserved points here - removeLoyaltyRedemptionFromReceipt()
    // runs next, so any EXISTING $-off redemption is about to be replaced, not
    // double-counted against itself.
    const rewardReserved = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.filter((a)=>!a.removed && a.source === "loyalty_reward").reduce((sum, a)=>sum + (a.points || 0), 0);
    if (points > customer.pointsBalance - rewardReserved) throw new Error("Not enough points for that redemption");
    $1e7ab04ca7920cff$export$8f8f3a01cb0b2825();
    const value = n * $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.loyaltyRedeemValue;
    const adj = {
        id: $1e7ab04ca7920cff$var$generateAdjustmentId(),
        name: `Loyalty reward (${points} pts)`,
        type: "discount",
        calculation: "fixed",
        value: value,
        appliedValue: value,
        removed: false,
        source: "loyalty"
    };
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.push(adj);
    // `increments` rides along so the checkout commit can hand the RPC a plain
    // count (validated/recomputed server-side from real settings) instead of
    // back-deriving it from `points`/`value`, which would be fragile if
    // loyaltyRedeemPoints/Value changed mid-checkout.
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyRedemption = {
        adjId: adj.id,
        points: points,
        value: value,
        increments: n
    };
    return adj;
};
const $1e7ab04ca7920cff$export$8f8f3a01cb0b2825 = function() {
    if (!$1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyRedemption) return;
    const { adjId: adjId } = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyRedemption;
    const index = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.findIndex((a)=>a.id === adjId);
    if (index !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.splice(index, 1);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyRedemption = null;
};
const $1e7ab04ca7920cff$export$d91fe4e87b050b41 = async function(saleId, customerId, earnPoints, redeemPoints) {
    const { error: error } = await (0, $asfCf.supabase).rpc("record_loyalty_for_sale", {
        p_sale_id: saleId,
        p_customer_id: customerId,
        p_earn_points: earnPoints,
        p_redeem_points: redeemPoints
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$b2d79cd72ab37b14 = async function(saleId) {
    const { error: error } = await (0, $asfCf.supabase).rpc("record_loyalty_void", {
        p_sale_id: saleId
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$5214e286120564d8 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("customers").select("*").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at", {
        ascending: false
    });
    if (error) throw error;
    return (data ?? []).map($1e7ab04ca7920cff$var$dbToCustomer);
};
const $1e7ab04ca7920cff$export$c246655a1578f63f = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("sales").select("customer_id, sale_date").eq("user_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).not("customer_id", "is", null).is("voided_at", null);
    if (error) throw error;
    const byCustomer = new Map();
    for (const row of data ?? []){
        if (!byCustomer.has(row.customer_id)) byCustomer.set(row.customer_id, []);
        byCustomer.get(row.customer_id).push(row.sale_date);
    }
    return byCustomer;
};
const $1e7ab04ca7920cff$export$977fa7a8d3466b4f = async function(customerId) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("loyalty_transactions").select("id, sale_id, kind, points, created_at").eq("customer_id", customerId).order("created_at", {
        ascending: false
    }).limit(500);
    if (error) throw error;
    return data ?? [];
};
// ── Free-item reward catalog ─────────────────────────────────────────────────
// Owner-configured "spend N points, get this menu item free." Loaded eagerly
// at bootstrap (alongside inventory) since checkout needs it regardless of
// whether the current user can ever open the Loyalty panel (manage_loyalty-
// gated) - checkout only needs use_loyalty, which the RLS select policy allows.
const $1e7ab04ca7920cff$var$dbToReward = (row)=>({
        id: row.id,
        itemId: row.item_id,
        pointsCost: row.points_cost,
        active: row.active
    });
const $1e7ab04ca7920cff$export$326e3b762d83929b = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from("loyalty_rewards").select("*").eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order("created_at");
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.loyaltyRewards = data.map($1e7ab04ca7920cff$var$dbToReward);
};
const $1e7ab04ca7920cff$export$6a18dd8bacc8cba7 = async function(itemId, pointsCost) {
    const { data: row, error: error } = await (0, $asfCf.supabase).from("loyalty_rewards").insert({
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        item_id: itemId,
        points_cost: Math.max(1, Math.floor(Number(pointsCost) || 0)),
        active: true
    }).select().single();
    if (error) throw error;
    const reward = $1e7ab04ca7920cff$var$dbToReward(row);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.loyaltyRewards.push(reward);
    return reward;
};
const $1e7ab04ca7920cff$export$68b2763a19fc97ac = async function(id) {
    const reward = $1e7ab04ca7920cff$export$ca000e230c0caa3e.loyaltyRewards.find((r)=>r.id === id);
    if (!reward) throw new Error("Reward not found");
    const newActive = !reward.active;
    const { error: error } = await (0, $asfCf.supabase).from("loyalty_rewards").update({
        active: newActive
    }).eq("id", id).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    reward.active = newActive;
};
const $1e7ab04ca7920cff$export$ca0ad922ea11f11c = async function(id) {
    const { error: error } = await (0, $asfCf.supabase).from("loyalty_rewards").delete().eq("id", id).eq("business_id", $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const index = $1e7ab04ca7920cff$export$ca000e230c0caa3e.loyaltyRewards.findIndex((r)=>r.id === id);
    if (index !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.loyaltyRewards.splice(index, 1);
};
const $1e7ab04ca7920cff$export$a49edc57bdd065a5 = function() {
    const dollarOff = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyRedemption?.points ?? 0;
    const rewardPts = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.filter((a)=>!a.removed && a.source === "loyalty_reward").reduce((sum, a)=>sum + (a.points || 0), 0);
    return dollarOff + rewardPts;
};
const $1e7ab04ca7920cff$export$4a6125c257304688 = function(rewardId) {
    const customer = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyCustomer;
    if (!customer) throw new Error("No loyalty customer linked");
    const reward = $1e7ab04ca7920cff$export$ca000e230c0caa3e.loyaltyRewards.find((r)=>r.id === rewardId && r.active);
    if (!reward) throw new Error("This reward is no longer available");
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.some((a)=>a.source === "loyalty_reward" && a.rewardId === rewardId && !a.removed)) throw new Error("Already redeemed this reward");
    if (reward.pointsCost > customer.pointsBalance - $1e7ab04ca7920cff$export$a49edc57bdd065a5()) throw new Error("Not enough points for that redemption");
    const item = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.find((i)=>i._id === reward.itemId);
    if (!item) throw new Error("This item is no longer available");
    const cartItemLineId = crypto.randomUUID();
    const cartItem = {
        itemName: item.itemName,
        price: item.price,
        imageURL: item.imageURL,
        selectedVariants: [],
        id: item._id,
        lineId: cartItemLineId,
        date: Date.now(),
        quantity: 1,
        totalPrice: item.price
    };
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.push(cartItem);
    const adj = {
        id: $1e7ab04ca7920cff$var$generateAdjustmentId(),
        name: `Free ${item.itemName} (Reward)`,
        type: "discount",
        calculation: "fixed",
        value: item.price,
        appliedValue: item.price,
        removed: false,
        source: "loyalty_reward",
        points: reward.pointsCost,
        cartItemLineId: cartItemLineId,
        rewardId: reward.id
    };
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.push(adj);
    return {
        cartItem: cartItem,
        adj: adj
    };
};
const $1e7ab04ca7920cff$export$f46e9f68198f57f = function(cartItemLineId) {
    const index = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.findIndex((a)=>a.source === "loyalty_reward" && a.cartItemLineId === cartItemLineId);
    if (index !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.splice(index, 1);
    // The redemption minted its own cart line - remove it too so a removed
    // redemption doesn't leave a stray line behind at full price. No-op if the
    // cart line is already gone (e.g. the caller deleted it before this ran).
    const cartIndex = $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.findIndex((it)=>it.lineId === cartItemLineId);
    if (cartIndex !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.splice(cartIndex, 1);
};
// ── Business-level settings (shared across all of a business's devices) ─────────
// These live in businesses.settings (JSONB) so a laptop and an iPad see the same
// config. localStorage is kept as a per-device cache/fallback (and for the popups
// + offline mode). Device-specific settings (terminal number, theme, window sizes)
// deliberately stay in localStorage only and are NOT listed here.
//
// Each entry maps a state.settings key → its localStorage cache key, how to parse
// the cached string back when hydrating from localStorage, and the DEFAULT the
// key takes when the business's server settings object doesn't contain it.
const $1e7ab04ca7920cff$var$BUSINESS_SETTINGS = {
    printingEnabled: {
        ls: 'pointbunny_printing_enabled',
        parse: (v)=>v !== 'false',
        def: true
    },
    confirmPrint: {
        ls: 'pointbunny_confirm_print',
        parse: (v)=>v !== 'false',
        def: true
    },
    showCashierName: {
        ls: 'pointbunny_show_cashier',
        parse: (v)=>v !== 'false',
        def: true
    },
    showInvoiceNumber: {
        ls: 'pointbunny_show_invoice_number',
        parse: (v)=>v !== 'false',
        def: true
    },
    showTicketNumber: {
        ls: 'pointbunny_show_ticket_number',
        parse: (v)=>v !== 'false',
        def: true
    },
    showBusinessPhone: {
        ls: 'pointbunny_show_business_phone',
        parse: (v)=>v !== 'false',
        def: true
    },
    // Custom line at the bottom of every receipt (manage_business only, max 120
    // chars - set_business_settings enforces both). Empty = "Thank you...".
    receiptFooter: {
        ls: 'pointbunny_receipt_footer',
        parse: (v)=>v || '',
        def: ''
    },
    // Feedback/review link printed as a QR under the footer (https, max 300).
    // Footer + QR only print on paid plans (receiptView / escpos check isFreePlan).
    receiptQrUrl: {
        ls: 'pointbunny_receipt_qr_url',
        parse: (v)=>v || '',
        def: ''
    },
    taxMode: {
        ls: 'pointbunny_tax_mode',
        parse: (v)=>v === 'exclusive' || v === 'inclusive' ? v : 'none',
        def: 'none'
    },
    taxInclusive: {
        ls: 'pointbunny_tax_inclusive',
        parse: (v)=>v === 'true',
        def: false
    },
    taxInclusiveRate: {
        ls: 'pointbunny_tax_inclusive_rate',
        parse: (v)=>parseFloat(v) || 12,
        def: 12
    },
    taxInclusiveLabel: {
        ls: 'pointbunny_tax_label',
        parse: (v)=>v || null,
        def: null
    },
    taxExemptLabel: {
        ls: 'pointbunny_tax_exempt_label',
        parse: (v)=>v || null,
        def: null
    },
    orderTypeEnabled: {
        ls: 'pointbunny_order_type_enabled',
        parse: (v)=>v !== 'false',
        def: true
    },
    kdsYellowThreshold: {
        ls: 'pointbunny_kds_yellow',
        parse: (v)=>parseInt(v),
        def: 600
    },
    kdsRedThreshold: {
        ls: 'pointbunny_kds_red',
        parse: (v)=>parseInt(v),
        def: 900
    },
    kdsAutoCompleteThreshold: {
        ls: 'pointbunny_kds_auto',
        parse: (v)=>parseInt(v),
        def: 3600
    },
    cfdAdUrl: {
        ls: 'pointbunny_cfd_ad',
        parse: (v)=>v || null,
        def: null
    },
    cfdQrUrl: {
        ls: 'pointbunny_cfd_qr',
        parse: (v)=>v || null,
        def: null
    },
    pickupAdUrl: {
        ls: 'pointbunny_pickup_ad',
        parse: (v)=>v || null,
        def: null
    },
    // Tips (2026-10-10, owner / manage_business only - set_business_settings).
    // tipPresets = 1-3 whole percentages; tipQrUrl = optional Venmo/Cash App QR
    // image shown next to the tip buttons on the customer display (those tips
    // are never recorded in Pointbunny).
    tipsEnabled: {
        ls: 'pointbunny_tips_enabled',
        parse: (v)=>v === 'true',
        def: false
    },
    tipPresets: {
        ls: 'pointbunny_tip_presets',
        parse: (v)=>$1e7ab04ca7920cff$export$8d14d72645a70eef(v),
        def: $1e7ab04ca7920cff$export$b7d7c1ca35c782a2
    },
    tipQrUrl: {
        ls: 'pointbunny_tip_qr',
        parse: (v)=>v || null,
        def: null
    },
    // Roles that share the tip pool (manage_pay). null = every role except
    // Admin; [] = nobody. Cached as "id,id" ("" for an empty list).
    tipPoolRoleIds: {
        ls: 'pointbunny_tip_pool_roles',
        parse: (v)=>v == null ? null : v === '' ? [] : v.split(','),
        def: null
    },
    hideStatsFromStaff: {
        ls: 'pointbunny_hide_stats_staff',
        parse: (v)=>v === 'true',
        def: false
    },
    gettingStartedDismissed: {
        ls: 'pointbunny_checklist_dismissed',
        parse: (v)=>v === 'true',
        def: false
    },
    gettingStartedCompleted: {
        ls: 'pointbunny_checklist_completed',
        parse: (v)=>v === 'true',
        def: false
    },
    receiptSetupSeen: {
        ls: 'pointbunny_receipt_setup_seen',
        parse: (v)=>v === 'true',
        def: false
    },
    taxSetupSeen: {
        ls: 'pointbunny_tax_setup_seen',
        parse: (v)=>v === 'true',
        def: false
    },
    teamSetupSeen: {
        ls: 'pointbunny_team_setup_seen',
        parse: (v)=>v === 'true',
        def: false
    },
    inventorySetupSeen: {
        ls: 'pointbunny_inventory_setup_seen',
        parse: (v)=>v === 'true',
        def: false
    },
    loyaltyEnabled: {
        ls: 'pointbunny_loyalty_enabled',
        parse: (v)=>v === 'true',
        def: false
    },
    loyaltyEarnRate: {
        ls: 'pointbunny_loyalty_earn_rate',
        parse: (v)=>parseFloat(v) || 0.1,
        def: 0.1
    },
    loyaltyEarnAmount: {
        ls: 'pointbunny_loyalty_earn_amount',
        parse: (v)=>parseFloat(v) || 1,
        def: 1
    },
    loyaltyRedeemPoints: {
        ls: 'pointbunny_loyalty_redeem_points',
        parse: (v)=>parseInt(v) || 100,
        def: 100
    },
    loyaltyRedeemValue: {
        ls: 'pointbunny_loyalty_redeem_value',
        parse: (v)=>parseFloat(v) || 5,
        def: 5
    },
    inventoryEnabled: {
        ls: 'pointbunny_inventory_enabled',
        parse: (v)=>v !== 'false',
        def: true
    },
    // Home screen (2026-10-22, homeLayout.js): the type of place, the shortcuts
    // left off the Manage / Screens menus, and table service. Every feature stays
    // available; these only pick what shows. homeHidden is cached as "a,b".
    placeType: {
        ls: 'pointbunny_place_type',
        parse: (v)=>v || null,
        def: null
    },
    homeHidden: {
        ls: 'pointbunny_home_hidden',
        parse: (v)=>$1e7ab04ca7920cff$export$a6bf297b0d9b5f16(v),
        clean: $1e7ab04ca7920cff$export$a6bf297b0d9b5f16,
        def: []
    },
    tableService: {
        ls: 'pointbunny_table_service',
        parse: (v)=>$1e7ab04ca7920cff$export$6cbb1b50f2e190a5(v),
        clean: $1e7ab04ca7920cff$export$6cbb1b50f2e190a5,
        def: 'off'
    },
    waitlistEnabled: {
        ls: 'pointbunny_waitlist_enabled',
        parse: (v)=>v === 'true',
        def: false
    },
    reservationsEnabled: {
        ls: 'pointbunny_reservations_enabled',
        parse: (v)=>v === 'true',
        def: false
    },
    // Booking hours / slot length / table hold, and the waitlist quote buttons
    // (2026-10-24, bookingRules.js). bookingRules is cached as JSON.
    bookingRules: {
        ls: 'pointbunny_booking_rules',
        parse: (v)=>(0, $3c9e88a543a9da6a$export$563b887d60cfe137)(v),
        clean: (0, $3c9e88a543a9da6a$export$563b887d60cfe137),
        ser: (v)=>JSON.stringify(v),
        def: (0, $3c9e88a543a9da6a$export$e3a3683ed7186e9b)
    },
    waitlistQuotes: {
        ls: 'pointbunny_waitlist_quotes',
        parse: (v)=>(0, $3c9e88a543a9da6a$export$9fda4dae54e434b4)(v),
        clean: (0, $3c9e88a543a9da6a$export$9fda4dae54e434b4),
        def: (0, $3c9e88a543a9da6a$export$78a2a13284d3c159)
    }
};
// Write one business setting to its localStorage cache (null/undefined → remove).
const $1e7ab04ca7920cff$var$_cacheBusinessSetting = function(key, value) {
    const ls = $1e7ab04ca7920cff$var$BUSINESS_SETTINGS[key]?.ls;
    if (!ls) return;
    if (value === null || value === undefined) localStorage.removeItem(ls);
    else localStorage.setItem(ls, $1e7ab04ca7920cff$var$BUSINESS_SETTINGS[key].ser ? $1e7ab04ca7920cff$var$BUSINESS_SETTINGS[key].ser(value) : String(value));
};
const $1e7ab04ca7920cff$export$3a30189b4816777e = function(obj) {
    if (!obj || typeof obj !== 'object') return;
    for (const key of Object.keys($1e7ab04ca7920cff$var$BUSINESS_SETTINGS)){
        const raw = obj[key] !== undefined ? obj[key] : $1e7ab04ca7920cff$var$BUSINESS_SETTINGS[key].def;
        const val = $1e7ab04ca7920cff$var$BUSINESS_SETTINGS[key].clean ? $1e7ab04ca7920cff$var$BUSINESS_SETTINGS[key].clean(raw) : raw;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings[key] = val;
        $1e7ab04ca7920cff$var$_cacheBusinessSetting(key, val);
    }
};
// Snapshot the business-level settings from state into a plain object.
const $1e7ab04ca7920cff$var$_collectBusinessSettings = function() {
    const obj = {};
    for (const key of Object.keys($1e7ab04ca7920cff$var$BUSINESS_SETTINGS))obj[key] = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings[key];
    return obj;
};
// Real values for settings a tutorial is temporarily faking in state.settings
// (the Inventory practice turns inventoryEnabled on in memory). Every save
// sends the WHOLE settings object, so without this any unrelated save during a
// practice run - a "setup seen" flag, a Settings toggle - would persist the
// pretend value for the real business. Set/cleared by the controller.
let $1e7ab04ca7920cff$var$_persistOverrides = null;
const $1e7ab04ca7920cff$export$f4a68e8bb3666000 = function(overrides) {
    $1e7ab04ca7920cff$var$_persistOverrides = overrides;
};
const $1e7ab04ca7920cff$export$15e1db8a90fc192d = async function() {
    if (!$1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId) return;
    const { error: error } = await (0, $asfCf.supabase).rpc('set_business_settings', {
        p_settings: {
            ...$1e7ab04ca7920cff$var$_collectBusinessSettings(),
            ...$1e7ab04ca7920cff$var$_persistOverrides ?? {}
        }
    });
    if (error) console.error('[pointbunny] failed to persist settings:', error.message);
};
const $1e7ab04ca7920cff$export$680c723e3a62d1c3 = function(key, value) {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings[key] = value;
    $1e7ab04ca7920cff$var$_cacheBusinessSetting(key, value);
    $1e7ab04ca7920cff$export$15e1db8a90fc192d();
};
const $1e7ab04ca7920cff$export$233f02b89678da4f = function(key, value) {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings[key] = value;
    $1e7ab04ca7920cff$var$_cacheBusinessSetting(key, value);
};
const $1e7ab04ca7920cff$export$669c05a58e9cc73a = function() {
    return $1e7ab04ca7920cff$var$_collectBusinessSettings();
};
const $1e7ab04ca7920cff$export$cc098d721f95fe39 = function(snapshot) {
    for (const key of Object.keys(snapshot)){
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings[key] = snapshot[key];
        $1e7ab04ca7920cff$var$_cacheBusinessSetting(key, snapshot[key]);
    }
};
const $1e7ab04ca7920cff$export$6ee9e1291268daa7 = async function(file) {
    return await $1e7ab04ca7920cff$var$uploadImage(file);
};
const $1e7ab04ca7920cff$export$22dc23743dad2d5b = async function(file) {
    return await $1e7ab04ca7920cff$var$uploadImage(file);
};
const $1e7ab04ca7920cff$export$a88c3ce76caa82f4 = async function(file) {
    return await $1e7ab04ca7920cff$var$uploadImage(file);
};
const $1e7ab04ca7920cff$export$b6f89c1e0645de4e = async function(file) {
    return await $1e7ab04ca7920cff$var$uploadImage(file);
};
const $1e7ab04ca7920cff$export$25a663fe967004b4 = async function() {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.orderQueue = await (0, $5ni8Y.loadKitchenQueue)((0, $asfCf.supabase), $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId, $1e7ab04ca7920cff$export$74881ed03683ce30());
};
const $1e7ab04ca7920cff$export$e0bf0609ec0e8d2f = async function(id, timedOut) {
    await (0, $5ni8Y.setQueueItemState)((0, $asfCf.supabase), $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId, id, {
        prepared_at: new Date().toISOString(),
        timed_out: timedOut
    });
};
const $1e7ab04ca7920cff$export$9f42bbb612dd81aa = async function(id) {
    await (0, $5ni8Y.setQueueItemState)((0, $asfCf.supabase), $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId, id, {
        ready_at: new Date().toISOString()
    });
};
const $1e7ab04ca7920cff$export$b53689804608fa5b = async function(id) {
    await (0, $5ni8Y.setQueueItemState)((0, $asfCf.supabase), $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId, id, {
        ready_at: null
    });
};
function $1e7ab04ca7920cff$var$parseVariants(raw) {
    const variantMap = {};
    Object.keys(raw).forEach((key)=>{
        const match = key.match(/variants\[(\d+)\]\[(optionLabel|options)\](?:\[(\d+)\]\[(optionName|optionPrice)\])?/);
        if (!match) return;
        const variantIndex = match[1];
        const field = match[2];
        const optionIndex = match[3];
        const optionField = match[4];
        if (!variantMap[variantIndex]) variantMap[variantIndex] = {
            optionLabel: "",
            options: []
        };
        if (field === "optionLabel") variantMap[variantIndex].optionLabel = raw[key];
        if (field === "options") {
            if (!variantMap[variantIndex].options[optionIndex]) variantMap[variantIndex].options[optionIndex] = {
                optionName: "",
                optionPrice: "0"
            };
            variantMap[variantIndex].options[optionIndex][optionField] = optionField === "optionPrice" ? Number(raw[key]) || 0 : raw[key];
        }
    });
    return Object.values(variantMap).map((variant)=>({
            ...variant,
            options: variant.options.filter((option)=>option.optionName.trim() !== "")
        }));
}
// ── Staff management ──────────────────────────────────────────────────────────
// Live deactivation kick-out: fires the callback the moment this user's staff row
// gets is_active = false (in-app removal or admin panel deactivation). Requires the
// staff table to be in the supabase_realtime publication.
let $1e7ab04ca7920cff$var$_staffWatchChannel = null;
const $1e7ab04ca7920cff$export$2f466d5f5f216986 = function(onDeactivated, onRoleChanged) {
    if (!$1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.id || $1e7ab04ca7920cff$var$_staffWatchChannel) return;
    const channel = (0, $asfCf.supabase).channel(`staff-active-${$1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.id}`).on('postgres_changes', {
        event: 'UPDATE',
        schema: 'public',
        table: 'staff',
        filter: `id=eq.${$1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.id}`
    }, (payload)=>{
        // Deactivation takes precedence - a kicked-out user is signed out, not reloaded.
        if (payload.new?.is_active === false) {
            onDeactivated();
            return;
        }
        // An owner changing this user's role pushes the new role_id here. Compare against
        // the role_id this session loaded with; if it differs, the session is stale.
        if (onRoleChanged && payload.new?.role_id && $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.roleId && payload.new.role_id !== $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.roleId) {
            $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.roleId = payload.new.role_id; // guard against a double-fire
            onRoleChanged();
        }
    });
    // Also reload when the user's OWN role definition is edited (permissions changed by
    // the owner). Without this, an open session keeps its stale capabilities until the
    // next login. Requires `roles` in the supabase_realtime publication.
    if (onRoleChanged && $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.roleId) channel.on('postgres_changes', {
        event: 'UPDATE',
        schema: 'public',
        table: 'roles',
        filter: `id=eq.${$1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.roleId}`
    }, ()=>onRoleChanged());
    $1e7ab04ca7920cff$var$_staffWatchChannel = channel.subscribe();
};
const $1e7ab04ca7920cff$var$dbToStaff = (row)=>({
        id: row.id,
        firstName: row.first_name,
        lastName: row.last_name,
        email: row.email,
        hourlyRate: row.hourly_rate ?? null,
        isActive: row.is_active,
        joinedAt: row.joined_at,
        isPending: !row.user_id,
        role: row.roles?.name ?? 'Staff',
        roleId: row.roles?.id ?? null,
        isSelf: row.user_id === $1e7ab04ca7920cff$export$ca000e230c0caa3e.userId,
        isOwner: !!row.user_id && row.user_id === $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        hasPin: !!row.pin,
        pin: row.pin ?? null
    });
const $1e7ab04ca7920cff$export$34ce29dd271bbc01 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('staff').select('id, first_name, last_name, email, is_active, joined_at, user_id, pin, hourly_rate, roles(id, name)').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq('is_active', true).order('invited_at', {
        ascending: true
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff = data.map($1e7ab04ca7920cff$var$dbToStaff);
};
const $1e7ab04ca7920cff$export$f0ef15b003d69c13 = async function() {
    const { count: count, error: error } = await (0, $asfCf.supabase).from('staff').select('id', {
        count: 'exact',
        head: true
    }).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq('is_active', true);
    if (error || count == null) return 1;
    return Math.max(1, count);
};
const $1e7ab04ca7920cff$export$c0334f52bda8729d = async function() {
    let { data: data, error: error } = await (0, $asfCf.supabase).from('roles').select('id, name, permissions, description, icon').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order('created_at');
    if (error) // description/icon columns not migrated yet - fall back so Staff still loads.
    ({ data: data, error: error } = await (0, $asfCf.supabase).from('roles').select('id, name, permissions').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order('created_at'));
    if (error) throw error;
    // Expose each role's granted-capability list (normalised from the stored JSONB,
    // falling back to built-in defaults for legacy/empty shapes) for the role editor.
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles = data.map((r)=>({
            ...r,
            caps: [
                ...$1e7ab04ca7920cff$export$94cfe010e61a30ec(r.name, r.permissions)
            ],
            locked: r.name === $1e7ab04ca7920cff$export$8cd565f5f8a26955
        }));
};
const $1e7ab04ca7920cff$export$f928650dee510357 = async function({ firstName: firstName, lastName: lastName, email: email, roleId: roleId }) {
    const normalizedEmail = email.toLowerCase().trim();
    const role = $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles.find((r)=>r.id === roleId);
    if (role && !$1e7ab04ca7920cff$export$2b7797bcbce66bd0(role)) throw new Error(role.locked ? 'Only the owner or an Admin can invite someone as Admin.' : "You can't invite someone with access you don't have yourself.");
    // The invite-staff Edge Function does the whole invite server-side (2026-10-08):
    // checks the caller's manage_staff + that they can hand out this role, enforces the
    // single-membership rule, writes (or reactivates) the staff row, then sends the
    // email. Writing the row here in the browser used to fail for non-owners (staff
    // RLS only lets the owner insert) AFTER the email had already gone out.
    const { data: data, error: error } = await (0, $asfCf.supabase).functions.invoke('invite-staff', {
        body: {
            email: normalizedEmail,
            firstName: firstName,
            lastName: lastName,
            businessId: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
            roleId: roleId
        }
    });
    if (error) {
        let detail = error.message;
        try {
            if (error.context instanceof Response) {
                const b = await error.context.json();
                if (b?.error) detail = b.error;
            }
        } catch  {}
        throw new Error(detail);
    }
    if (!data?.staff) throw new Error('Could not send the invite. Please try again.');
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.filter((s)=>s.id !== data.staff.id);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.push($1e7ab04ca7920cff$var$dbToStaff(data.staff));
    return {
        reactivated: !!data.reactivated,
        existingAccount: !!data.existingAccount
    };
};
const $1e7ab04ca7920cff$export$2b7797bcbce66bd0 = function(role) {
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.userId && $1e7ab04ca7920cff$export$ca000e230c0caa3e.userId === $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId) return true;
    if (role.locked || role.name === $1e7ab04ca7920cff$export$8cd565f5f8a26955) return $1e7ab04ca7920cff$export$ca000e230c0caa3e.role === $1e7ab04ca7920cff$export$8cd565f5f8a26955;
    return (role.caps ?? []).every((k)=>$1e7ab04ca7920cff$export$b325ec6732b039cf(k));
};
const $1e7ab04ca7920cff$export$52ce019d07b456a7 = async function(staffId) {
    const { data: { user: user } } = await (0, $asfCf.supabase).auth.getUser();
    const { error: claimError } = await (0, $asfCf.supabase).from('staff').update({
        user_id: user.id,
        joined_at: new Date().toISOString()
    }).eq('id', staffId).is('user_id', null);
    if (claimError) throw claimError;
    const others = ($1e7ab04ca7920cff$export$ca000e230c0caa3e.pendingInvites ?? []).filter((p)=>p.staffId !== staffId).map((p)=>p.staffId);
    if (others.length) await (0, $asfCf.supabase).from('staff').delete().in('id', others);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.pendingInvites = null;
    return user;
};
const $1e7ab04ca7920cff$export$cdd63fa2413668d = function() {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.pendingInvites = null;
};
const $1e7ab04ca7920cff$export$c2e97a27e26e6474 = async function(staffId, roleId) {
    // The business owner can never be demoted out of full access - no role change is
    // allowed on their row, by anyone. Mirrors the owner-removal guard in removeStaff.
    const target = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.find((s)=>s.id === staffId);
    if (target?.isOwner) throw new Error("The business owner's role cannot be changed.");
    const { error: error, count: count } = await (0, $asfCf.supabase).from('staff').update({
        role_id: roleId
    }, {
        count: 'exact'
    }).eq('id', staffId).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    if (count === 0) throw new Error('Permission denied. Check staff RLS update policy.');
    const role = $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles.find((r)=>r.id === roleId);
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.find((s)=>s.id === staffId);
    if (s && role) {
        s.roleId = roleId;
        s.role = role.name;
    }
};
const $1e7ab04ca7920cff$export$feecad064ee6d298 = async function(staffId, pin) {
    const { error: error, count: count } = await (0, $asfCf.supabase).from('staff').update({
        pin: pin || null
    }, {
        count: 'exact'
    }).eq('id', staffId).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    if (count === 0) throw new Error('Permission denied. Check staff RLS update policy.');
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.find((s)=>s.id === staffId);
    if (s) {
        s.pin = pin || null;
        s.hasPin = !!pin;
    }
};
const $1e7ab04ca7920cff$export$979c67ac13627319 = async function(id) {
    const member = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.find((s)=>s.id === id);
    // The business owner can never be removed - not by an Admin-role staff member, not by
    // anyone. Their row anchors the business (user_id === business_id). This guard is the
    // authoritative backstop even though the view hides the Remove button on the owner row.
    if (member?.isOwner) throw new Error('The business owner cannot be removed.');
    if (member?.isPending) {
        // Pending invites have no history - hard delete so the email can be re-invited cleanly.
        const { error: error, count: count } = await (0, $asfCf.supabase).from('staff').delete({
            count: 'exact'
        }).eq('id', id).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
        if (error) throw error;
        if (count === 0) throw new Error('Could not delete staff member. Please try again.');
    } else {
        // Joined staff are soft-deleted so shifts, sales attribution, and payroll history survive.
        const { error: error, count: count } = await (0, $asfCf.supabase).from('staff').update({
            is_active: false
        }, {
            count: 'exact'
        }).eq('id', id).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
        if (error) throw error;
        if (count === 0) throw new Error('Could not remove staff member. Please try again.');
    }
    const idx = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.findIndex((s)=>s.id === id);
    if (idx !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.splice(idx, 1);
};
const $1e7ab04ca7920cff$export$d33e2ce4efa57b9e = async function(staffId) {
    const target = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.find((s)=>s.id === staffId);
    if (target?.isOwner) throw new Error("The business owner's two-factor authentication can only be removed by support.");
    if (target?.isSelf) throw new Error('Use Settings to manage your own two-factor authentication.');
    const { data: data, error: error } = await (0, $asfCf.supabase).functions.invoke('admin-remove-2fa', {
        body: {
            staffId: staffId
        }
    });
    if (error) {
        let detail = error.message;
        try {
            if (error.context instanceof Response) {
                const b = await error.context.json();
                if (b?.error) detail = b.error;
            }
        } catch  {}
        throw new Error(detail);
    }
    return data;
};
// Keeps only valid capability keys, so a malformed list can never widen access.
const $1e7ab04ca7920cff$var$_sanitizeCaps = (caps)=>(caps ?? []).filter((k)=>$1e7ab04ca7920cff$export$e41c6d066ef1eec8.includes(k));
const $1e7ab04ca7920cff$export$987e0c664048adac = async function(name, caps = [], description = null, icon = null) {
    const clean = $1e7ab04ca7920cff$var$_sanitizeCaps(caps);
    const { data: data, error: error } = await (0, $asfCf.supabase).from('roles').insert({
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        name: name.trim(),
        permissions: $1e7ab04ca7920cff$export$f92875a0bb941a70(clean),
        description: description?.trim() || null,
        icon: icon || null
    }).select('id, name, permissions, description, icon').single();
    if (error) throw error;
    const role = {
        ...data,
        caps: clean,
        locked: data.name === $1e7ab04ca7920cff$export$8cd565f5f8a26955
    };
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles.push(role);
    return role;
};
const $1e7ab04ca7920cff$export$68844ec44941e4f = async function(roleId, name) {
    const role = $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles.find((r)=>r.id === roleId);
    if (role?.locked) throw new Error('The Admin role cannot be renamed.');
    const { error: error } = await (0, $asfCf.supabase).from('roles').update({
        name: name.trim()
    }).eq('id', roleId).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    if (role) role.name = name.trim();
};
const $1e7ab04ca7920cff$export$6897c8a16b8636d1 = async function(roleId, { description: description, icon: icon } = {}) {
    const role = $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles.find((r)=>r.id === roleId);
    if (role?.locked) throw new Error('The Admin role cannot be edited.');
    const patch = {
        description: description?.trim() || null,
        icon: icon || null
    };
    const { error: error } = await (0, $asfCf.supabase).from('roles').update(patch).eq('id', roleId).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    if (role) Object.assign(role, patch);
};
const $1e7ab04ca7920cff$export$21ea4d9b2e178e02 = async function(roleId, caps) {
    const role = $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles.find((r)=>r.id === roleId);
    if (role?.locked) throw new Error('The Admin role always has full access and cannot be edited.');
    const clean = $1e7ab04ca7920cff$var$_sanitizeCaps(caps);
    const { error: error } = await (0, $asfCf.supabase).from('roles').update({
        permissions: $1e7ab04ca7920cff$export$f92875a0bb941a70(clean)
    }).eq('id', roleId).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    if (role) {
        role.permissions = $1e7ab04ca7920cff$export$f92875a0bb941a70(clean);
        role.caps = clean;
    }
};
const $1e7ab04ca7920cff$export$a7396bae498de6f1 = async function(roleId) {
    const role = $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles.find((r)=>r.id === roleId);
    if (role?.locked) throw new Error('The Admin role cannot be deleted.');
    // Block if any staff member still holds this role - the owner must reassign first.
    const inUse = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.filter((s)=>s.roleId === roleId).length;
    if (inUse > 0) throw new Error(`This role is assigned to ${inUse} staff member${inUse === 1 ? '' : 's'}. Reassign them to another role before deleting it.`);
    const { error: error } = await (0, $asfCf.supabase).from('roles').delete().eq('id', roleId).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const idx = $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles.findIndex((r)=>r.id === roleId);
    if (idx !== -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles.splice(idx, 1);
};
const $1e7ab04ca7920cff$export$6d18979955267451 = async function() {
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - 7);
    const { data: data, error: error } = await (0, $asfCf.supabase).from('tickets').select('id, category, subject, message, status, has_unread_reply, created_at, solved_at, attachments, rating').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).or(`status.eq.open,and(status.eq.solved,solved_at.gte.${cutoff.toISOString()})`).order('created_at', {
        ascending: false
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets = data;
};
const $1e7ab04ca7920cff$export$4f9d37a936b07b92 = async function(ticketId) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('ticket_replies').select('id, sender_type, message, created_at').eq('ticket_id', ticketId).order('created_at', {
        ascending: true
    });
    if (error) throw error;
    return data;
};
const $1e7ab04ca7920cff$export$21f448eee9ae750e = async function(ticketId) {
    const solvedAt = new Date().toISOString();
    const { error: error } = await (0, $asfCf.supabase).from('tickets').update({
        status: 'solved',
        solved_at: solvedAt
    }).eq('id', ticketId).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const t = $1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets.find((t)=>t.id === ticketId);
    if (t) {
        t.status = 'solved';
        t.solved_at = solvedAt;
    }
};
const $1e7ab04ca7920cff$export$790f38d70663fe33 = async function(ticketId) {
    const { error: error } = await (0, $asfCf.supabase).from('tickets').update({
        has_unread_reply: false
    }).eq('id', ticketId).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const t = $1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets.find((t)=>t.id === ticketId);
    if (t) t.has_unread_reply = false;
};
const $1e7ab04ca7920cff$export$3ed0752aa616e897 = async function() {
    const token = Math.random().toString(36).slice(2, 8).toUpperCase();
    const { error: error } = await (0, $asfCf.supabase).from('businesses').update({
        timeclock_token: token
    }).eq('id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    return token;
};
const $1e7ab04ca7920cff$export$3d90d87a5b17e4b8 = async function(startISO, endISO) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('sales').select('sale_date, tip_amount').eq('user_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte('sale_date', startISO).lte('sale_date', endISO).gt('tip_amount', 0).is('voided_at', null);
    if (error) throw error;
    return (data ?? []).map((r)=>({
            date: r.sale_date,
            amount: Number(r.tip_amount)
        }));
};
const $1e7ab04ca7920cff$export$386807069bdcb35d = async function(startISO, endISO) {
    // staff embed is disambiguated by FK name because shifts now has TWO FKs to staff
    // (staff_id + deleted_by). corrections carry who approved a shift's edit request.
    const { data: data, error: error } = await (0, $asfCf.supabase).from('shifts').select('id, clocked_in_at, clocked_out_at, note, staff_id, source, edited_at, shift_breaks(id, started_at, ended_at), staff:staff!shifts_staff_id_fkey(first_name, last_name, hourly_rate, role_id, user_id), editor:staff!shifts_edited_by_fkey(first_name, last_name), corrections:shift_edit_requests(status, reviewed_at, reviewed_by_name)').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).is('deleted_at', null).gte('clocked_in_at', startISO).lte('clocked_in_at', endISO).order('clocked_in_at', {
        ascending: true
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.shifts = data.map((r)=>{
        // Latest approved correction linked to this shift. reviewed_by_name is the
        // denormalized reviewer name (stamped by the review RPC), so no staff join
        // is needed - it stays readable regardless of staff-row RLS.
        const approved = (r.corrections ?? []).filter((c)=>c.status === 'approved').sort((a, b)=>new Date(b.reviewed_at) - new Date(a.reviewed_at))[0];
        const editorName = r.editor ? `${r.editor.first_name ?? ''} ${r.editor.last_name ?? ''}`.trim() : null;
        return {
            source: r.source ?? 'clock',
            editedBy: editorName,
            id: r.id,
            staffId: r.staff_id,
            staffName: `${r.staff?.first_name ?? ''} ${r.staff?.last_name ?? ''}`.trim(),
            hourlyRate: r.staff?.hourly_rate ?? null,
            // Tip pool eligibility (Timesheets > Tips): the person's role, and whether
            // it's the owner (never in an employee tip pool).
            staffRoleId: r.staff?.role_id ?? null,
            staffIsOwner: !!r.staff?.user_id && r.staff.user_id === $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
            clockedInAt: r.clocked_in_at,
            clockedOutAt: r.clocked_out_at ?? null,
            note: r.note ?? '',
            // Reviewer name from the request itself when linked; else fall back to the
            // edited_by stamp the review RPC writes on approval (source = 'request').
            approvedBy: approved?.reviewed_by_name || (r.source === 'request' ? editorName : null),
            breaks: (r.shift_breaks ?? []).map((b)=>({
                    id: b.id,
                    startedAt: b.started_at,
                    endedAt: b.ended_at ?? null
                }))
        };
    });
};
const $1e7ab04ca7920cff$export$edd624e74df161b3 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('shifts').select('id, clocked_in_at, clocked_out_at, deleted_at, staff:staff!shifts_staff_id_fkey(first_name, last_name), deleter:staff!shifts_deleted_by_fkey(first_name, last_name)').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).not('deleted_at', 'is', null).order('deleted_at', {
        ascending: false
    });
    if (error) throw error;
    return (data ?? []).map((r)=>({
            id: r.id,
            staffName: `${r.staff?.first_name ?? ''} ${r.staff?.last_name ?? ''}`.trim(),
            clockedInAt: r.clocked_in_at,
            clockedOutAt: r.clocked_out_at ?? null,
            deletedAt: r.deleted_at,
            deletedBy: `${r.deleter?.first_name ?? ''} ${r.deleter?.last_name ?? ''}`.trim() || 'Unknown'
        }));
};
const $1e7ab04ca7920cff$export$dc1ed30e5f5c4359 = async function() {
    const { error: error } = await (0, $asfCf.supabase).rpc('purge_deleted_shifts');
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$14aa8954e02d8449 = async function(ids, deleted) {
    const { error: error } = await (0, $asfCf.supabase).rpc('set_shifts_deleted', {
        p_shift_ids: ids,
        p_deleted: deleted
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$b910b0e182c20503 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('shift_edit_requests').select('id, staff_id, shift_id, proposed_clock_in, proposed_clock_out, proposed_breaks, reason, status, created_at, staff:staff_id(first_name, last_name), shift:shift_id(clocked_in_at, clocked_out_at)').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq('status', 'pending').order('created_at', {
        ascending: true
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.shiftEditRequests = (data ?? []).map((r)=>({
            id: r.id,
            staffId: r.staff_id,
            staffName: `${r.staff?.first_name ?? ''} ${r.staff?.last_name ?? ''}`.trim(),
            shiftId: r.shift_id ?? null,
            proposedIn: r.proposed_clock_in ?? null,
            proposedOut: r.proposed_clock_out ?? null,
            proposedBreaks: Array.isArray(r.proposed_breaks) ? r.proposed_breaks : null,
            reason: r.reason ?? '',
            createdAt: r.created_at,
            currentIn: r.shift?.clocked_in_at ?? null,
            currentOut: r.shift?.clocked_out_at ?? null
        }));
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.shiftEditRequests;
};
const $1e7ab04ca7920cff$export$aa47a779ea9a774 = async function(id, decision, { clockIn: clockIn, clockOut: clockOut, breaks: breaks, note: note } = {}) {
    const { error: error } = await (0, $asfCf.supabase).rpc('review_shift_edit_request', {
        p_request_id: id,
        p_decision: decision,
        p_clock_in: clockIn ?? null,
        p_clock_out: clockOut ?? null,
        p_breaks: breaks ?? null,
        p_note: note ?? null
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.shiftEditRequests = $1e7ab04ca7920cff$export$ca000e230c0caa3e.shiftEditRequests.filter((r)=>r.id !== id);
};
const $1e7ab04ca7920cff$export$dd48584891564f37 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('leave_requests').select('id, staff_id, type, start_date, end_date, reason, status, created_at, reviewed_by_name, reviewed_at, review_note, staff:staff_id(first_name, last_name)').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order('created_at', {
        ascending: false
    });
    if (error) throw error;
    return (data ?? []).map((r)=>({
            id: r.id,
            staffId: r.staff_id,
            staffName: `${r.staff?.first_name ?? ''} ${r.staff?.last_name ?? ''}`.trim(),
            type: r.type,
            startDate: r.start_date,
            endDate: r.end_date,
            reason: r.reason ?? '',
            status: r.status,
            createdAt: r.created_at,
            reviewedByName: r.reviewed_by_name ?? null,
            reviewedAt: r.reviewed_at ?? null,
            reviewNote: r.review_note ?? null
        }));
};
const $1e7ab04ca7920cff$export$caf3bff4c0484df1 = async function(id, decision, note) {
    const { error: error } = await (0, $asfCf.supabase).rpc('review_leave_request', {
        p_request_id: id,
        p_decision: decision,
        p_note: note ?? null
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$5dd0c4b97398fddb = async function({ staffId: staffId, clockedInAt: clockedInAt, clockedOutAt: clockedOutAt, note: note }) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('shifts')// source 'manual' = admin-added (vs 'clock' = tracked by the time clock) so
    // timesheets can show shift provenance.
    .insert({
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        staff_id: staffId,
        clocked_in_at: clockedInAt,
        clocked_out_at: clockedOutAt || null,
        note: note || null,
        source: 'manual',
        edited_by: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.id ?? null,
        edited_at: new Date().toISOString()
    }).select('id').single();
    if (error) throw error;
    return data.id;
};
const $1e7ab04ca7920cff$export$b9feece4954201d8 = async function({ id: id, clockedInAt: clockedInAt, clockedOutAt: clockedOutAt, note: note }) {
    const { error: error } = await (0, $asfCf.supabase).from('shifts')// Stamp who edited, so timesheets can show "Edited by X".
    .update({
        clocked_in_at: clockedInAt,
        clocked_out_at: clockedOutAt || null,
        note: note || null,
        edited_by: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.id ?? null,
        edited_at: new Date().toISOString()
    }).eq('id', id).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$b7cc9474dd2513e9 = async function(sinceISO) {
    const staffId = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.id;
    if (!staffId) return [];
    const { data: data, error: error } = await (0, $asfCf.supabase).from('shifts').select('clocked_in_at, clocked_out_at, shift_breaks(started_at, ended_at)').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq('staff_id', staffId).is('deleted_at', null).or(`clocked_out_at.is.null,clocked_out_at.gte.${sinceISO}`).order('clocked_in_at', {
        ascending: true
    });
    if (error) throw error;
    return (data ?? []).map((r)=>({
            clockedInAt: r.clocked_in_at,
            clockedOutAt: r.clocked_out_at ?? null,
            breaks: (r.shift_breaks ?? []).map((b)=>({
                    startedAt: b.started_at,
                    endedAt: b.ended_at ?? null
                }))
        }));
};
const $1e7ab04ca7920cff$export$da55ffa46e74c271 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('get_on_shift_staff');
    if (error) throw error;
    // One row per STAFF MEMBER, not per open shift - a double clock-in (two devices,
    // an unclosed earlier shift) must not list the same person twice. Keep the
    // earliest clock-in; on break if ANY of their open shifts is on break.
    const byStaff = new Map();
    for (const r of data ?? []){
        const prev = byStaff.get(r.staff_id);
        if (!prev) byStaff.set(r.staff_id, {
            staffId: r.staff_id,
            name: `${r.first_name ?? ''} ${r.last_name ?? ''}`.trim(),
            clockedInAt: r.clocked_in_at,
            onBreak: r.on_break === true
        });
        else {
            if (new Date(r.clocked_in_at) < new Date(prev.clockedInAt)) prev.clockedInAt = r.clocked_in_at;
            if (r.on_break === true) prev.onBreak = true;
        }
    }
    return [
        ...byStaff.values()
    ];
};
const $1e7ab04ca7920cff$export$5df1640f4b5631ad = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('timeclock_devices').select('id, label, activated_at, last_seen_at').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order('activated_at', {
        ascending: true
    });
    if (error) throw error;
    return (data ?? []).map((d)=>({
            id: d.id,
            label: d.label || 'Time clock device',
            activatedAt: d.activated_at,
            lastSeenAt: d.last_seen_at
        }));
};
const $1e7ab04ca7920cff$export$f5a99e271127a154 = async function(id) {
    const { error: error } = await (0, $asfCf.supabase).from('timeclock_devices').delete().eq('id', id).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$62c57b495cbdd512 = async function({ email: email, password: password, staffId: staffId, newPin: newPin, captchaToken: captchaToken, mfaCode: mfaCode }) {
    const tempClient = (0, $dNnfS.createClient)((0, $asfCf.supabaseUrl), (0, $asfCf.supabaseAnonKey), {
        auth: {
            persistSession: false,
            autoRefreshToken: false,
            detectSessionInUrl: false
        }
    });
    const { data: authData, error: authError } = await tempClient.auth.signInWithPassword({
        email: email,
        password: password,
        options: {
            captchaToken: captchaToken
        }
    });
    if (authError) {
        if (/captcha/i.test(authError.message || '')) throw new Error('Verification check failed. Please try again.');
        throw new Error('Invalid email or password.');
    }
    await $1e7ab04ca7920cff$var$_elevateTempClient(tempClient, mfaCode);
    try {
        const { data: row } = await tempClient.from('staff').select('id').eq('user_id', authData.user.id).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq('is_active', true).maybeSingle();
        if (!row || row.id !== staffId) throw new Error('These credentials belong to a different staff member.');
        const { error: error } = await tempClient.from('staff').update({
            pin: newPin
        }).eq('id', staffId);
        if (error) throw new Error('Could not update the PIN. Please try again.');
    } finally{
        await tempClient.auth.signOut({
            scope: 'local'
        });
    }
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.find((x)=>x.id === staffId);
    if (s) {
        s.pin = newPin;
        s.hasPin = true;
    }
};
const $1e7ab04ca7920cff$export$3e40a01c47255d05 = async function(staffId, rate) {
    const { error: error } = await (0, $asfCf.supabase).from('staff').update({
        hourly_rate: rate ?? null
    }).eq('id', staffId).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.find((s)=>s.id === staffId);
    if (s) s.hourlyRate = rate ?? null;
};
const $1e7ab04ca7920cff$export$1337d39a272fd051 = async function({ category: category, subject: subject, message: message, files: files }) {
    const attachments = [];
    for (const rawFile of files){
        const file = await (0, $d1ef11f17812d23e$export$b63de8e31affef62)(rawFile);
        const ext = file.name.split('.').pop();
        const path = `${$1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId}/${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`;
        const { error: uploadError } = await (0, $asfCf.supabase).storage.from('ticket-attachments').upload(path, file);
        if (uploadError) throw uploadError;
        const { data: data } = (0, $asfCf.supabase).storage.from('ticket-attachments').getPublicUrl(path);
        attachments.push(data.publicUrl);
    }
    const { error: error } = await (0, $asfCf.supabase).from('tickets').insert({
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        category: category,
        subject: subject,
        message: message,
        attachments: attachments
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$c42add300c9dd96f = async function(ticketId, message) {
    const { error: error } = await (0, $asfCf.supabase).from('ticket_replies').insert({
        ticket_id: ticketId,
        sender_type: 'business',
        message: message
    });
    if (error) throw error;
    const { error: flagError } = await (0, $asfCf.supabase).from('tickets').update({
        has_business_reply: true
    }).eq('id', ticketId).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (flagError) throw flagError;
};
const $1e7ab04ca7920cff$export$5aadd1b5880603ab = async function(ticketId, rating, comment) {
    const { error: error } = await (0, $asfCf.supabase).from('tickets').update({
        rating: rating,
        rating_comment: comment || null,
        rated_at: new Date().toISOString()
    }).eq('id', ticketId).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    const t = $1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets.find((t)=>t.id === ticketId);
    if (t) {
        t.rating = rating;
        t.rating_comment = comment || null;
    }
};
const $1e7ab04ca7920cff$export$ac9a70e2b35d6a5f = async function(email, captchaToken) {
    // Sent via the dedicated PKCE client (resetClient) so the link is single-use and the
    // PKCE code_verifier is written under its own storageKey. The link lands on the
    // standalone reset.html page, which exchanges the ?code= and sets the new password.
    // redirectTo MUST be same-origin as this send (PKCE verifier is origin-scoped in
    // localStorage), so reset.html reads back the verifier it stored here.
    const { error: error } = await (0, $1tYOa.resetClient).auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset`,
        captchaToken: captchaToken
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$8a0192bc90e542c4 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).auth.getUser();
    if (error) throw error;
    return data.user?.user_metadata?.pb_tours ?? null;
};
const $1e7ab04ca7920cff$export$e37b02cc1b8f7cdf = async function(progress) {
    const { error: error } = await (0, $asfCf.supabase).auth.updateUser({
        data: {
            pb_tours: progress
        }
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$e2853351e15b7895 = async function(newPassword) {
    const { error: error } = await (0, $asfCf.supabase).auth.updateUser({
        password: newPassword
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$dd45956530337cf5 = async function(captchaToken) {
    const { data: { user: user } } = await (0, $asfCf.supabase).auth.getUser();
    // CAPTCHA enforcement in Supabase is project-wide, so this OTP-sending call needs a
    // token too, same as signInWithPassword elsewhere (manager override, time clock).
    const { error: error } = await (0, $asfCf.supabase).auth.signInWithOtp({
        email: user.email,
        options: {
            shouldCreateUser: false,
            captchaToken: captchaToken
        }
    });
    if (error) {
        if (/captcha/i.test(error.message || '')) throw new Error('Verification check failed. Please try again.');
        throw error;
    }
    return user.email;
};
const $1e7ab04ca7920cff$export$d0bf361f2f356611 = async function(email, token) {
    const { error: error } = await (0, $asfCf.supabase).auth.verifyOtp({
        email: email,
        token: token,
        type: 'email'
    });
    if (error) throw error;
};
// ── Two-Factor Authentication (TOTP via Supabase MFA) ─────────────────────────
// Opt-in per user. A factor only counts (and is enforced at login) once it has
// been verified with a code. Enrollment hands back a QR + secret; the caller
// must then verify a code before the factor becomes active.
// Remove any half-finished (unverified) TOTP factors so a fresh enroll can't
// trip the "factor already exists" error or leave clutter behind.
const $1e7ab04ca7920cff$var$_cleanupUnverifiedTotp = async function() {
    const { data: data } = await (0, $asfCf.supabase).auth.mfa.listFactors();
    const stale = (data?.all ?? []).filter((f)=>f.factor_type === 'totp' && f.status !== 'verified');
    for (const f of stale)try {
        await (0, $asfCf.supabase).auth.mfa.unenroll({
            factorId: f.id
        });
    } catch  {}
};
const $1e7ab04ca7920cff$export$314505446d7496ac = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).auth.mfa.listFactors();
    if (error) throw error;
    const verified = (data?.all ?? []).find((f)=>f.factor_type === 'totp' && f.status === 'verified');
    return {
        enabled: !!verified,
        factorId: verified?.id ?? null
    };
};
const $1e7ab04ca7920cff$export$da426774c04c0c7b = async function() {
    await $1e7ab04ca7920cff$var$_cleanupUnverifiedTotp();
    const { data: data, error: error } = await (0, $asfCf.supabase).auth.mfa.enroll({
        factorType: 'totp'
    });
    if (error) throw error;
    return {
        factorId: data.id,
        qr: data.totp.qr_code,
        secret: data.totp.secret
    };
};
const $1e7ab04ca7920cff$export$1f3ea161e23a0000 = async function(factorId, code) {
    const { error: error } = await (0, $asfCf.supabase).auth.mfa.challengeAndVerify({
        factorId: factorId,
        code: code
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$c59e4b5a00864db6 = async function(factorId) {
    const { error: error } = await (0, $asfCf.supabase).auth.mfa.unenroll({
        factorId: factorId
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$53fefec4c12ed9da = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).auth.mfa.getAuthenticatorAssuranceLevel();
    if (error) throw error;
    return data;
};
const $1e7ab04ca7920cff$export$71e1a6097078ed6f = async function(factorId, code) {
    const { data: ch, error: chErr } = await (0, $asfCf.supabase).auth.mfa.challenge({
        factorId: factorId
    });
    if (chErr) throw chErr;
    const { error: error } = await (0, $asfCf.supabase).auth.mfa.verify({
        factorId: factorId,
        challengeId: ch.id,
        code: code
    });
    if (error) throw error;
};
// ── 2FA recovery codes ────────────────────────────────────────────────────────
// One-time backup codes shown once at enrollment. Only HASHES are stored (here and
// server-side); the plaintext is shown to the user a single time. Redemption runs
// in the mfa-recovery Edge Function (it needs the service role to remove the factor
// of a locked-out aal1 user).
// Avoids visually ambiguous characters (no I/O/0/1).
const $1e7ab04ca7920cff$var$RECOVERY_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
const $1e7ab04ca7920cff$var$_genRecoveryCode = function() {
    const bytes = crypto.getRandomValues(new Uint8Array(8));
    let s = '';
    for (const b of bytes)s += $1e7ab04ca7920cff$var$RECOVERY_ALPHABET[b % $1e7ab04ca7920cff$var$RECOVERY_ALPHABET.length];
    return `${s.slice(0, 4)}-${s.slice(4, 8)}`;
};
// Match the Edge Function's normalization so a copied "ABCD-EFGH" hashes the same.
const $1e7ab04ca7920cff$var$_normalizeCode = (code)=>String(code ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
const $1e7ab04ca7920cff$var$_sha256Hex = async function(str) {
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
    return [
        ...new Uint8Array(buf)
    ].map((b)=>b.toString(16).padStart(2, '0')).join('');
};
const $1e7ab04ca7920cff$export$f3bcad708b8fc74b = async function() {
    const codes = Array.from({
        length: 10
    }, $1e7ab04ca7920cff$var$_genRecoveryCode);
    const { data: { user: user } } = await (0, $asfCf.supabase).auth.getUser();
    const rows = [];
    for (const c of codes)rows.push({
        user_id: user.id,
        code_hash: await $1e7ab04ca7920cff$var$_sha256Hex($1e7ab04ca7920cff$var$_normalizeCode(c))
    });
    await (0, $asfCf.supabase).from('mfa_recovery_codes').delete().eq('user_id', user.id);
    const { error: error } = await (0, $asfCf.supabase).from('mfa_recovery_codes').insert(rows);
    if (error) throw error;
    return codes;
};
const $1e7ab04ca7920cff$export$51dfe949467852e0 = async function() {
    const { data: { user: user } } = await (0, $asfCf.supabase).auth.getUser();
    await (0, $asfCf.supabase).from('mfa_recovery_codes').delete().eq('user_id', user.id);
};
const $1e7ab04ca7920cff$export$bf9fe75a401bb30a = async function(code) {
    const { data: data, error: error } = await (0, $asfCf.supabase).functions.invoke('mfa-recovery', {
        body: {
            code: code
        }
    });
    if (error) {
        let detail = error.message;
        try {
            if (error.context instanceof Response) {
                const b = await error.context.json();
                if (b?.error) detail = b.error;
            }
        } catch  {}
        throw new Error(detail);
    }
    if (!data?.success) throw new Error('Invalid recovery code');
    return true;
};
const $1e7ab04ca7920cff$export$135c88fe76d8e545 = async function({ firstName: firstName, lastName: lastName }) {
    const { error: error } = await (0, $asfCf.supabase).from('staff').update({
        first_name: firstName,
        last_name: lastName
    }).eq('id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.id);
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.firstName = firstName;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.lastName = lastName;
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier?.id === $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.id) {
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier.firstName = firstName;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier.lastName = lastName;
    }
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.username = `${firstName} ${lastName}`.trim() || $1e7ab04ca7920cff$export$ca000e230c0caa3e.username;
};
const $1e7ab04ca7920cff$export$a4cc38ae0cfe28f6 = [
    {
        name: 'Barista',
        color: '#0FA267'
    },
    {
        name: 'Shift lead',
        color: '#7C3AED'
    },
    {
        name: 'Kitchen',
        color: '#EA580C'
    },
    {
        name: 'Cashier',
        color: '#2563EB'
    }
];
const $1e7ab04ca7920cff$var$toStation = (r)=>({
        id: r.id,
        name: r.name,
        color: r.color,
        sortOrder: r.sort_order,
        archived: !!r.archived_at
    });
const $1e7ab04ca7920cff$var$toScheduledShift = (r)=>({
        id: r.id,
        staffId: r.staff_id,
        stationId: r.station_id,
        startsAt: r.starts_at,
        endsAt: r.ends_at,
        note: r.note ?? '',
        publishedAt: r.published_at,
        seriesId: r.series_id ?? null,
        seriesDate: r.series_date ?? null,
        isException: !!r.is_exception
    });
const $1e7ab04ca7920cff$var$SHIFT_COLS = 'id, staff_id, station_id, starts_at, ends_at, note, published_at, series_id, series_date, is_exception';
// ── Tables (2026-10-22, migration-2026-10-22-tables.sql) ────────────────────
// Floor plan rows are written directly (manage_business, RLS); everything a
// tab does goes through SECURITY DEFINER RPCs so two terminals adding to the
// same tab never overwrite each other.
const $1e7ab04ca7920cff$var$mapDiningTable = (r)=>({
        id: r.id,
        name: r.name,
        seats: r.seats,
        shape: r.shape,
        area: r.area,
        x: Number(r.x),
        y: Number(r.y),
        w: Number(r.w),
        h: Number(r.h),
        canReserve: r.can_reserve,
        needsCleaning: r.needs_cleaning,
        sortOrder: r.sort_order
    });
const $1e7ab04ca7920cff$var$mapTab = (r)=>({
        id: r.id,
        tableId: r.table_id,
        guests: r.guests,
        serverName: r.server_name,
        status: r.status,
        billRequestedAt: r.bill_requested_at,
        openedAt: r.opened_at,
        items: (r.items ?? []).map((l)=>({
                lid: l.lid,
                itemId: l.item_id,
                itemName: l.item_name,
                unitPrice: Number(l.unit_price) || 0,
                quantity: Number(l.quantity) || 1,
                selectedVariants: (l.selected_variants ?? []).map((v)=>({
                        variantName: v.variant_name
                    })),
                note: l.note ?? null,
                sentAt: l.sent_at ?? null,
                paidSaleId: l.paid_sale_id ?? null
            }))
    });
// Keeps state.openTabs in step with one tab row returned by an RPC.
const $1e7ab04ca7920cff$var$_storeTab = (row)=>{
    if (!row?.id) return null;
    const tab = $1e7ab04ca7920cff$var$mapTab(row);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs = $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs.filter((t)=>t.id !== tab.id);
    if (tab.status === 'open') $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs.push(tab);
    return tab;
};
const $1e7ab04ca7920cff$export$1dd25893a10c6b3f = async function() {
    const [tables, tabs] = await Promise.all([
        (0, $asfCf.supabase).from('dining_tables').select('id, name, seats, shape, area, x, y, w, h, can_reserve, needs_cleaning, sort_order').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).is('archived_at', null).order('sort_order', {
            ascending: true
        }),
        (0, $asfCf.supabase).from('table_tabs').select('id, table_id, guests, server_name, status, bill_requested_at, opened_at, items').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq('status', 'open')
    ]);
    if (tables.error) throw tables.error;
    if (tabs.error) throw tabs.error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.diningTables = tables.data.map($1e7ab04ca7920cff$var$mapDiningTable);
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs = tabs.data.map($1e7ab04ca7920cff$var$mapTab);
};
const $1e7ab04ca7920cff$export$93bcd8ea4d83f513 = async function(tables, removedIds = []) {
    const toRow = (t, i)=>({
            business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
            name: String(t.name).trim().slice(0, 12),
            seats: t.seats,
            shape: t.shape,
            area: String(t.area || 'Inside').trim().slice(0, 30),
            x: Math.round(t.x),
            y: Math.round(t.y),
            w: Math.round(t.w),
            h: Math.round(t.h),
            can_reserve: t.canReserve !== false,
            sort_order: i
        });
    const existing = tables.map((t, i)=>[
            t,
            i
        ]).filter(([t])=>t.id);
    const added = tables.map((t, i)=>[
            t,
            i
        ]).filter(([t])=>!t.id);
    const jobs = existing.map(([t, i])=>(0, $asfCf.supabase).from('dining_tables').update(toRow(t, i)).eq('id', t.id).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId));
    if (added.length) jobs.push((0, $asfCf.supabase).from('dining_tables').insert(added.map(([t, i])=>toRow(t, i))));
    if (removedIds.length) jobs.push((0, $asfCf.supabase).from('dining_tables').update({
        archived_at: new Date().toISOString()
    }).in('id', removedIds).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId));
    const results = await Promise.all(jobs);
    const failed = results.find((r)=>r.error);
    if (failed) throw failed.error;
    await $1e7ab04ca7920cff$export$1dd25893a10c6b3f();
};
const $1e7ab04ca7920cff$export$dce0c365d72e5017 = async function(tableId, guests, serverName) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('open_table_tab', {
        p_table: tableId,
        p_guests: guests,
        p_server: serverName ?? null
    });
    if (error) throw error;
    const t = $1e7ab04ca7920cff$export$ca000e230c0caa3e.diningTables.find((x)=>x.id === tableId);
    if (t) t.needsCleaning = false;
    return $1e7ab04ca7920cff$var$_storeTab(data);
};
const $1e7ab04ca7920cff$export$d9bb1d157dd4e9e1 = async function(tabId, cartItems) {
    const lines = cartItems.map((it)=>({
            item_id: it.id,
            quantity: it.quantity,
            selected_variants: (it.selectedVariants ?? []).map((v)=>({
                    variant_name: v.variantName
                })),
            note: it.note ?? null
        }));
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('tab_add_lines', {
        p_tab: tabId,
        p_lines: lines
    });
    if (error) throw error;
    return $1e7ab04ca7920cff$var$_storeTab(data);
};
const $1e7ab04ca7920cff$export$b50b05985e2bcf1e = async function(tabId, lid) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('tab_remove_line', {
        p_tab: tabId,
        p_lid: lid
    });
    if (error) throw error;
    return $1e7ab04ca7920cff$var$_storeTab(data);
};
const $1e7ab04ca7920cff$export$8bd78f925d7fa1dd = async function(tabId, sentBy) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('tab_send', {
        p_tab: tabId,
        p_sent_by: sentBy ?? null
    });
    if (error) throw error;
    await $1e7ab04ca7920cff$export$b975145949a3941(tabId);
    return data?.id ? (0, $5ni8Y.ticketToQueueItem)(data) : null;
};
const $1e7ab04ca7920cff$export$b975145949a3941 = async function(tabId) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('table_tabs').select('id, table_id, guests, server_name, status, bill_requested_at, opened_at, items').eq('id', tabId).maybeSingle();
    if (error) throw error;
    if (!data) {
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs = $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs.filter((t)=>t.id !== tabId);
        return null;
    }
    return $1e7ab04ca7920cff$var$_storeTab(data);
};
const $1e7ab04ca7920cff$export$55a955c15093a2a1 = async function(tabId, { guests: guests = null, serverName: serverName = null, billRequested: billRequested = null } = {}) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('tab_update', {
        p_tab: tabId,
        p_guests: guests,
        p_server: serverName,
        p_bill_requested: billRequested
    });
    if (error) throw error;
    return $1e7ab04ca7920cff$var$_storeTab(data);
};
const $1e7ab04ca7920cff$export$eb5a85854169158b = async function(tabId, tableId) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('tab_move', {
        p_tab: tabId,
        p_table: tableId
    });
    if (error) throw error;
    return $1e7ab04ca7920cff$var$_storeTab(data);
};
const $1e7ab04ca7920cff$export$86903287c9411571 = async function(fromTabId, intoTabId) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('tab_merge', {
        p_from: fromTabId,
        p_into: intoTabId
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs = $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs.filter((t)=>t.id !== fromTabId);
    return $1e7ab04ca7920cff$var$_storeTab(data);
};
const $1e7ab04ca7920cff$export$ca50a360e53500d1 = async function(tabId) {
    const { error: error } = await (0, $asfCf.supabase).rpc('tab_close', {
        p_tab: tabId
    });
    if (error) throw error;
    await $1e7ab04ca7920cff$export$1dd25893a10c6b3f();
};
const $1e7ab04ca7920cff$export$49b2c708e2ed8edd = async function(tableId, needsCleaning) {
    const { error: error } = await (0, $asfCf.supabase).rpc('set_table_clean', {
        p_table: tableId,
        p_needs_cleaning: needsCleaning
    });
    if (error) throw error;
    const t = $1e7ab04ca7920cff$export$ca000e230c0caa3e.diningTables.find((x)=>x.id === tableId);
    if (t) t.needsCleaning = needsCleaning;
};
// Reservations for [from, to) (ISO strings), any status.
const $1e7ab04ca7920cff$var$mapReservation = (r)=>({
        id: r.id,
        name: r.name,
        phone: r.phone,
        partySize: r.party_size,
        startsAt: r.starts_at,
        durationMin: r.duration_min,
        tableId: r.table_id,
        note: r.note,
        status: r.status,
        tabId: r.tab_id
    });
const $1e7ab04ca7920cff$export$968e31c3f3742111 = async function(fromISO, toISO) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('table_reservations').select('id, name, phone, party_size, starts_at, duration_min, table_id, note, status, tab_id').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte('starts_at', fromISO).lt('starts_at', toISO).order('starts_at', {
        ascending: true
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.reservations = data.map($1e7ab04ca7920cff$var$mapReservation);
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.reservations;
};
const $1e7ab04ca7920cff$export$de770b4ae1a17f4c = async function(r) {
    const row = {
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        name: String(r.name).trim().slice(0, 60),
        phone: r.phone ? String(r.phone).trim().slice(0, 30) : null,
        party_size: r.partySize,
        starts_at: r.startsAt,
        duration_min: r.durationMin ?? 90,
        table_id: r.tableId ?? null,
        note: r.note ? String(r.note).trim().slice(0, 200) : null
    };
    const q = r.id ? (0, $asfCf.supabase).from('table_reservations').update(row).eq('id', r.id).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId) : (0, $asfCf.supabase).from('table_reservations').insert(row);
    const { error: error } = await q;
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$50ccea48c85bc751 = async function(id, status, tabId = null) {
    const patch = {
        status: status,
        ...tabId ? {
            tab_id: tabId
        } : {}
    };
    const { error: error } = await (0, $asfCf.supabase).from('table_reservations').update(patch).eq('id', id).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
};
// Waiting parties, plus anyone seated or removed in the last 12 hours (so a
// mistaken Seat / Remove can still be seen).
const $1e7ab04ca7920cff$var$mapWaitlist = (r)=>({
        id: r.id,
        name: r.name,
        phone: r.phone,
        partySize: r.party_size,
        note: r.note,
        quotedMin: r.quoted_min,
        status: r.status,
        tableId: r.table_id,
        addedAt: r.added_at,
        seatedAt: r.seated_at
    });
const $1e7ab04ca7920cff$export$efe8831a8901fd7f = async function() {
    const since = new Date(Date.now() - 43200000).toISOString();
    const { data: data, error: error } = await (0, $asfCf.supabase).from('waitlist_entries').select('id, name, phone, party_size, note, quoted_min, status, table_id, added_at, seated_at').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte('added_at', since).order('added_at', {
        ascending: true
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.waitlist = data.map($1e7ab04ca7920cff$var$mapWaitlist);
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.waitlist;
};
const $1e7ab04ca7920cff$export$d36ad63dc1382c11 = async function(e) {
    const { error: error } = await (0, $asfCf.supabase).from('waitlist_entries').insert({
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        name: String(e.name).trim().slice(0, 60),
        phone: e.phone ? String(e.phone).trim().slice(0, 30) : null,
        party_size: e.partySize,
        note: e.note ? String(e.note).trim().slice(0, 200) : null,
        quoted_min: e.quotedMin ?? null
    });
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$b00468b00729f211 = async function(id, { status: status, tableId: tableId } = {}) {
    const patch = {};
    if (status) patch.status = status;
    if (status === 'seated') patch.seated_at = new Date().toISOString();
    if (tableId !== undefined) patch.table_id = tableId;
    const { error: error } = await (0, $asfCf.supabase).from('waitlist_entries').update(patch).eq('id', id).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
};
const $1e7ab04ca7920cff$export$84a0e7efcf44c962 = async function() {
    const query = ()=>(0, $asfCf.supabase).from('schedule_stations').select('id, name, color, sort_order, archived_at').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).order('sort_order', {
            ascending: true
        }).order('created_at', {
            ascending: true
        });
    let { data: data, error: error } = await query();
    if (error) throw error;
    if (!data.length && $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_schedule')) {
        const rows = $1e7ab04ca7920cff$export$a4cc38ae0cfe28f6.map((s, i)=>({
                business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
                name: s.name,
                color: s.color,
                sort_order: i
            }));
        const { error: seedErr } = await (0, $asfCf.supabase).from('schedule_stations').insert(rows);
        if (seedErr) throw seedErr;
        ({ data: data, error: error } = await query());
        if (error) throw error;
    }
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleStations = data.map($1e7ab04ca7920cff$var$toStation);
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleStations;
};
const $1e7ab04ca7920cff$export$8af991e8865719ed = async function({ name: name, color: color }) {
    const sortOrder = $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleStations.reduce((m, s)=>Math.max(m, s.sortOrder), -1) + 1;
    const { data: data, error: error } = await (0, $asfCf.supabase).from('schedule_stations').insert({
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        name: name.trim(),
        color: color,
        sort_order: sortOrder
    }).select('id, name, color, sort_order, archived_at').single();
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleStations.push($1e7ab04ca7920cff$var$toStation(data));
};
const $1e7ab04ca7920cff$export$c8be5d7f24976a48 = async function(id, { name: name, color: color }) {
    const patch = {};
    if (name !== undefined) patch.name = name.trim();
    if (color !== undefined) patch.color = color;
    const { error: error } = await (0, $asfCf.supabase).from('schedule_stations').update(patch).eq('id', id);
    if (error) throw error;
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleStations.find((x)=>x.id === id);
    if (s) Object.assign(s, patch);
};
const $1e7ab04ca7920cff$export$ccff87b35acb3892 = async function(id) {
    const { error: error } = await (0, $asfCf.supabase).from('schedule_stations').update({
        archived_at: new Date().toISOString()
    }).eq('id', id);
    if (error) throw error;
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleStations.find((x)=>x.id === id);
    if (s) s.archived = true;
};
const $1e7ab04ca7920cff$export$f3f832aa56d8a437 = async function(fromISO, toISO) {
    const [shifts, stations] = await Promise.all([
        // Names and "uses the Time Clock" come with the shift, so the card never
        // depends on state.staff having loaded (it said "Teammate" before).
        (0, $asfCf.supabase).from('scheduled_shifts').select(`${$1e7ab04ca7920cff$var$SHIFT_COLS}, staff(first_name, last_name, roles(permissions))`).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).not('published_at', 'is', null).lt('starts_at', toISO).gt('ends_at', fromISO).order('starts_at', {
            ascending: true
        }),
        (0, $asfCf.supabase).from('schedule_stations').select('id, name, color, sort_order, archived_at').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId)
    ]);
    if (shifts.error) throw shifts.error;
    return {
        shifts: shifts.data.map((r)=>({
                ...$1e7ab04ca7920cff$var$toScheduledShift(r),
                staffName: r.staff ? `${r.staff.first_name ?? ''} ${r.staff.last_name ?? ''}`.trim() : null,
                usesClock: r.staff?.roles?.permissions?.use_timeclock === true
            })),
        stations: (stations.data ?? []).map($1e7ab04ca7920cff$var$toStation)
    };
};
const $1e7ab04ca7920cff$export$145b6d72ee5a6844 = async function(fromISO, toISO) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('scheduled_shifts').select($1e7ab04ca7920cff$var$SHIFT_COLS).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).gte('starts_at', fromISO).lt('starts_at', toISO).order('starts_at', {
        ascending: true
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduledShifts = data.map($1e7ab04ca7920cff$var$toScheduledShift);
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduledShifts;
};
const $1e7ab04ca7920cff$export$e9ee2cce7ad81ff8 = async function({ id: id, staffId: staffId, stationId: stationId, startsAt: startsAt, endsAt: endsAt, note: note, isException: isException }) {
    const row = {
        staff_id: staffId || null,
        station_id: stationId || null,
        starts_at: startsAt,
        ends_at: endsAt,
        note: note?.trim() ? note.trim().slice(0, 200) : null
    };
    if (isException) row.is_exception = true;
    const q = id ? (0, $asfCf.supabase).from('scheduled_shifts').update(row).eq('id', id) : (0, $asfCf.supabase).from('scheduled_shifts').insert({
        ...row,
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId
    });
    const { data: data, error: error } = await q.select($1e7ab04ca7920cff$var$SHIFT_COLS).single();
    if (error) throw error;
    const saved = $1e7ab04ca7920cff$var$toScheduledShift(data);
    const i = $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduledShifts.findIndex((s)=>s.id === saved.id);
    if (i === -1) $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduledShifts.push(saved);
    else $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduledShifts[i] = saved;
    return saved;
};
const $1e7ab04ca7920cff$export$693657b09f3a8cd9 = async function(id) {
    const { error: error } = await (0, $asfCf.supabase).from('scheduled_shifts').delete().eq('id', id);
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduledShifts = $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduledShifts.filter((s)=>s.id !== id);
};
const $1e7ab04ca7920cff$export$59501082074c9b7b = async function(shifts) {
    if (!shifts.length) return 0;
    const rows = shifts.map((s)=>({
            business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
            staff_id: s.staffId || null,
            station_id: s.stationId || null,
            starts_at: s.startsAt,
            ends_at: s.endsAt,
            note: s.note || null
        }));
    const { error: error } = await (0, $asfCf.supabase).from('scheduled_shifts').insert(rows);
    if (error) throw error;
    return rows.length;
};
const $1e7ab04ca7920cff$export$3d3d5096f6870cdc = async function(mondayStr) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('publish_schedule_week', {
        p_business: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        p_week_start: mondayStr,
        p_by_name: $1e7ab04ca7920cff$export$ca000e230c0caa3e.username ?? ''
    });
    if (error) throw error;
    return data ?? 0;
};
const $1e7ab04ca7920cff$export$4d7a10e100aecbb4 = async function(days = 14) {
    const staffId = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.id;
    if (!staffId) return [];
    const now = new Date();
    const { data: data, error: error } = await (0, $asfCf.supabase).from('scheduled_shifts').select(`${$1e7ab04ca7920cff$var$SHIFT_COLS}, schedule_stations(name, color)`).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).eq('staff_id', staffId).not('published_at', 'is', null).gt('ends_at', now.toISOString()).lt('starts_at', new Date(now.getTime() + days * 86400000).toISOString()).order('starts_at', {
        ascending: true
    });
    if (error) throw error;
    return data.map((r)=>({
            ...$1e7ab04ca7920cff$var$toScheduledShift(r),
            stationName: r.schedule_stations?.name ?? '',
            stationColor: r.schedule_stations?.color ?? null
        }));
};
// ── Repeating shifts (2026-10-15) ─────────────────────────────────────────────
// A repeat rule lives in schedule_series; its shifts are real scheduled_shifts
// rows generated a few weeks ahead by extend_schedule_series (and topped up as
// weeks are viewed). Migration: migration-2026-10-15-schedule-repeats.sql.
const $1e7ab04ca7920cff$var$toSeries = (r)=>({
        id: r.id,
        staffId: r.staff_id,
        stationId: r.station_id,
        weekdays: r.weekdays ?? [],
        startTime: (r.start_time ?? '').slice(0, 5),
        endTime: (r.end_time ?? '').slice(0, 5),
        startDate: r.start_date,
        untilDate: r.until_date,
        note: r.note ?? '',
        autoPublish: !!r.auto_publish
    });
const $1e7ab04ca7920cff$export$d50ed07265d34ff4 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('schedule_series').select('id, staff_id, station_id, weekdays, start_time, end_time, start_date, until_date, note, auto_publish').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleSeries = data.map($1e7ab04ca7920cff$var$toSeries);
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleSeries;
};
const $1e7ab04ca7920cff$export$74e3ef02ea17ad1a = async function(def) {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('schedule_series').insert({
        business_id: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        staff_id: def.staffId || null,
        station_id: def.stationId || null,
        weekdays: def.weekdays,
        start_time: def.startTime,
        end_time: def.endTime,
        start_date: def.startDate,
        until_date: def.untilDate || null,
        note: def.note?.trim() ? def.note.trim().slice(0, 200) : null
    }).select('id').single();
    if (error) throw error;
    return data.id;
};
const $1e7ab04ca7920cff$export$a47b2858d875c10d = async function(throughDate) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('extend_schedule_series', {
        p_business: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        p_through: throughDate
    });
    if (error) throw error;
    return data ?? 0;
};
const $1e7ab04ca7920cff$var$seriesDefJson = (def)=>({
        staff_id: def.staffId || '',
        station_id: def.stationId || '',
        weekdays: def.weekdays,
        start_time: def.startTime,
        end_time: def.endTime,
        until_date: def.untilDate || '',
        note: def.note?.trim() ? def.note.trim().slice(0, 200) : ''
    });
const $1e7ab04ca7920cff$export$2d5950d64d542cba = async function(seriesId, fromDate, scope, def, includeEdited) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('edit_schedule_series', {
        p_series: seriesId,
        p_from: fromDate,
        p_scope: scope,
        p_new: $1e7ab04ca7920cff$var$seriesDefJson(def),
        p_include_edited: !!includeEdited
    });
    if (error) throw error;
    return data;
};
const $1e7ab04ca7920cff$export$a9a155f5986d513d = async function(seriesId, date, scope, includeEdited) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('delete_schedule_series', {
        p_series: seriesId,
        p_date: date,
        p_scope: scope,
        p_include_edited: !!includeEdited
    });
    if (error) throw error;
    return data ?? 0;
};
const $1e7ab04ca7920cff$export$d74f48f814b01409 = async function(seriesIds, fromISO) {
    if (!seriesIds.length) return;
    const { error: error } = await (0, $asfCf.supabase).from('schedule_series').update({
        auto_publish: true
    }).in('id', seriesIds);
    if (error) throw error;
    const { error: pubErr } = await (0, $asfCf.supabase).from('scheduled_shifts').update({
        published_at: new Date().toISOString()
    }).in('series_id', seriesIds).is('published_at', null).gte('starts_at', fromISO);
    if (pubErr) throw pubErr;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleSeries.forEach((x)=>{
        if (seriesIds.includes(x.id)) x.autoPublish = true;
    });
};
// ── Availability + leave on the grid (phase 2, 2026-10-17) ────────────────────
// staff_availability: one row per person per weekday they're NOT simply free
// all day ('unavailable', or 'partial' = only between startTime and endTime).
// Writes go through set_staff_availability (staff: their own; schedulers:
// anyone). Leave comes from the schedule_leave RPC, so a scheduler without
// manage_pay still sees who's off. Migration: migration-2026-10-17-schedule-phase2-3.sql.
const $1e7ab04ca7920cff$var$toAvailability = (r)=>({
        staffId: r.staff_id,
        weekday: r.weekday,
        status: r.status,
        startTime: (r.start_time ?? '').slice(0, 5),
        endTime: (r.end_time ?? '').slice(0, 5),
        note: r.note ?? ''
    });
const $1e7ab04ca7920cff$export$73e0853afeef3370 = async function() {
    const { data: data, error: error } = await (0, $asfCf.supabase).from('staff_availability').select('staff_id, weekday, status, start_time, end_time, note').eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.staffAvailability = data.map($1e7ab04ca7920cff$var$toAvailability);
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.staffAvailability;
};
const $1e7ab04ca7920cff$export$9823a39c30c0077 = async function(staffId, days) {
    const { error: error } = await (0, $asfCf.supabase).rpc('set_staff_availability', {
        p_staff: staffId,
        p_days: days.map((d)=>({
                weekday: d.weekday,
                status: d.status,
                start_time: d.startTime || null,
                end_time: d.endTime || null,
                note: d.note || ''
            }))
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.staffAvailability = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staffAvailability.filter((a)=>a.staffId !== staffId).concat(days.filter((d)=>d.status !== 'available' || d.note).map((d)=>({
            staffId: staffId,
            ...d
        })));
};
const $1e7ab04ca7920cff$export$f82428e4c88f3cfb = async function(fromDate, toDate) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('schedule_leave', {
        p_business: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId,
        p_from: fromDate,
        p_to: toDate
    });
    if (error) throw error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleLeave = (data ?? []).map((r)=>({
            id: r.id,
            staffId: r.staff_id,
            type: r.type,
            startDate: r.start_date,
            endDate: r.end_date,
            status: r.status
        }));
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleLeave;
};
// ── Shift swaps + open-shift pickup (phase 3, 2026-10-17) ─────────────────────
// shift_requests is read-only to clients; staff file requests from the Time
// Clock, schedulers decide here through review_shift_request.
const $1e7ab04ca7920cff$var$REQ_SHIFT_COLS = 'id, staff_id, starts_at, ends_at, station_id, published_at';
const $1e7ab04ca7920cff$var$toShiftRequest = (r)=>({
        id: r.id,
        kind: r.kind,
        status: r.status,
        note: r.note ?? '',
        requesterId: r.requester_id,
        requesterName: r.requester_name ?? '',
        targetId: r.target_id,
        targetName: r.target_name ?? '',
        shiftId: r.shift_id,
        targetShiftId: r.target_shift_id,
        shift: r.shift ? {
            id: r.shift.id,
            staffId: r.shift.staff_id,
            startsAt: r.shift.starts_at,
            endsAt: r.shift.ends_at,
            stationId: r.shift.station_id
        } : null,
        targetShift: r.target_shift ? {
            id: r.target_shift.id,
            staffId: r.target_shift.staff_id,
            startsAt: r.target_shift.starts_at,
            endsAt: r.target_shift.ends_at,
            stationId: r.target_shift.station_id
        } : null,
        createdAt: r.created_at,
        respondedAt: r.responded_at,
        reviewedByName: r.reviewed_by_name ?? null,
        reviewedAt: r.reviewed_at ?? null,
        reviewNote: r.review_note ?? null
    });
const $1e7ab04ca7920cff$export$8050acf0b604c9e = async function() {
    const sel = `id, kind, status, note, requester_id, requester_name, target_id, target_name, shift_id, target_shift_id,
    created_at, responded_at, reviewed_by_name, reviewed_at, review_note,
    shift:shift_id(${$1e7ab04ca7920cff$var$REQ_SHIFT_COLS}), target_shift:target_shift_id(${$1e7ab04ca7920cff$var$REQ_SHIFT_COLS})`;
    const [open, closed] = await Promise.all([
        (0, $asfCf.supabase).from('shift_requests').select(sel).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).in('status', [
            'waiting_teammate',
            'pending'
        ]).order('created_at', {
            ascending: true
        }),
        (0, $asfCf.supabase).from('shift_requests').select(sel).eq('business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId).not('status', 'in', '(waiting_teammate,pending)').order('created_at', {
            ascending: false
        }).limit(30)
    ]);
    if (open.error) throw open.error;
    if (closed.error) throw closed.error;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.shiftRequests = [
        ...open.data,
        ...closed.data
    ].map($1e7ab04ca7920cff$var$toShiftRequest);
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.shiftRequests;
};
const $1e7ab04ca7920cff$export$696a4d1ce6cff00e = async function(id, decision, note) {
    const { data: data, error: error } = await (0, $asfCf.supabase).rpc('review_shift_request', {
        p_request: id,
        p_decision: decision,
        p_note: note ?? null,
        p_by_name: $1e7ab04ca7920cff$export$ca000e230c0caa3e.username ?? ''
    });
    if (error) throw error;
    return data;
};
const $1e7ab04ca7920cff$export$87044e927d8b1c21 = async function() {
    const staffId = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.id;
    if (!staffId) return 0;
    const { count: count, error: error } = await (0, $asfCf.supabase).from('shift_requests').select('id', {
        count: 'exact',
        head: true
    }).eq('target_id', staffId).eq('status', 'waiting_teammate');
    if (error) throw error;
    return count ?? 0;
};



var $asfCf = parcelRequire("asfCf");

// One shared, viewport-clamped tooltip for every .pb-tip (i) in the app.
// A CSS-only bubble gets clipped by a modal's overflow (and can spill off-screen
// near an edge), so we position a single fixed element on the <body> instead and
// clamp it to the viewport. Importing this module self-initializes the listeners.
let $b6d851d77d25d258$var$tipEl = null;
let $b6d851d77d25d258$var$activeTarget = null;
const $b6d851d77d25d258$var$ensureEl = ()=>{
    if ($b6d851d77d25d258$var$tipEl) return $b6d851d77d25d258$var$tipEl;
    $b6d851d77d25d258$var$tipEl = document.createElement("div");
    $b6d851d77d25d258$var$tipEl.className = "pb-tooltip";
    $b6d851d77d25d258$var$tipEl.setAttribute("role", "tooltip");
    document.body.appendChild($b6d851d77d25d258$var$tipEl);
    return $b6d851d77d25d258$var$tipEl;
};
const $b6d851d77d25d258$var$position = (target, el)=>{
    const r = target.getBoundingClientRect();
    const margin = 8;
    const gap = 9;
    const tw = el.offsetWidth;
    const th = el.offsetHeight;
    let left = r.left + r.width / 2 - tw / 2;
    left = Math.max(margin, Math.min(left, window.innerWidth - tw - margin));
    let top = r.top - th - gap;
    const below = top < margin;
    if (below) top = r.bottom + gap;
    el.style.left = `${Math.round(left)}px`;
    el.style.top = `${Math.round(top)}px`;
    // Keep the arrow pointing at the icon even after horizontal clamping.
    el.style.setProperty("--arrow-x", `${Math.round(r.left + r.width / 2 - left)}px`);
    el.classList.toggle("pb-tooltip--below", below);
};
const $b6d851d77d25d258$var$show = (target)=>{
    const text = target.getAttribute("data-tip");
    if (!text) return;
    $b6d851d77d25d258$var$activeTarget = target;
    const el = $b6d851d77d25d258$var$ensureEl();
    el.textContent = text;
    $b6d851d77d25d258$var$position(target, el); // measure + place before fading in
    el.classList.add("pb-tooltip--visible");
};
const $b6d851d77d25d258$var$hide = ()=>{
    $b6d851d77d25d258$var$activeTarget = null;
    $b6d851d77d25d258$var$tipEl?.classList.remove("pb-tooltip--visible");
};
const $b6d851d77d25d258$var$tipFrom = (e)=>e.target?.closest?.(".pb-tip[data-tip]");
document.addEventListener("pointerover", (e)=>{
    const t = $b6d851d77d25d258$var$tipFrom(e);
    if (t) $b6d851d77d25d258$var$show(t);
});
document.addEventListener("pointerout", (e)=>{
    const t = $b6d851d77d25d258$var$tipFrom(e);
    if (t && !t.contains(e.relatedTarget)) $b6d851d77d25d258$var$hide();
});
// Keyboard a11y
document.addEventListener("focusin", (e)=>{
    const t = $b6d851d77d25d258$var$tipFrom(e);
    if (t) $b6d851d77d25d258$var$show(t);
});
document.addEventListener("focusout", (e)=>{
    if ($b6d851d77d25d258$var$tipFrom(e)) $b6d851d77d25d258$var$hide();
});
// Touch: a tap toggles; tapping elsewhere dismisses
document.addEventListener("click", (e)=>{
    const t = $b6d851d77d25d258$var$tipFrom(e);
    if (!t) {
        if ($b6d851d77d25d258$var$activeTarget) $b6d851d77d25d258$var$hide();
        return;
    }
    if ($b6d851d77d25d258$var$activeTarget === t) $b6d851d77d25d258$var$hide();
    else $b6d851d77d25d258$var$show(t);
});
// A moving page invalidates the fixed position
window.addEventListener("scroll", $b6d851d77d25d258$var$hide, true);
window.addEventListener("resize", $b6d851d77d25d258$var$hide);
document.addEventListener("keydown", (e)=>{
    if (e.key === "Escape") $b6d851d77d25d258$var$hide();
});


// Click-outside-to-close for every modal. A click that lands directly on a
// modal's backdrop (not on the card inside it) reuses that modal's own close
// button so existing close animations / state cleanup still run. Falls back to
// hiding the overlay if it has no close control.
//
// Opt out per modal with data-no-backdrop-close (used on flows where an
// accidental dismissal would lose something, e.g. one-time recovery codes).
// Importing this module self-initializes the listener.
const $db7a74064a0a5156$var$BACKDROPS = ".modal-backdrop, .modal-overlay, .modal-overlay-form, .item-modal-overlay, .edit-modal-overlay";
const $db7a74064a0a5156$var$CLOSE_CONTROLS = [
    ".modal-close",
    ".modal-close-btn",
    ".edit-modal-close",
    ".item-modal-close",
    ".pos-close-btn",
    ".all-orders-modal-close",
    ".rp-list-modal-close",
    ".sale-receipt-close",
    ".support-topbar-close",
    ".pb-lightbox-close"
].join(", ");
document.addEventListener("click", (e)=>{
    const overlay = e.target;
    // Only a direct hit on the backdrop itself - clicks inside the card have the
    // card (or its children) as the target and are ignored.
    if (!(overlay instanceof HTMLElement) || !overlay.matches($db7a74064a0a5156$var$BACKDROPS)) return;
    if (overlay.hasAttribute("data-no-backdrop-close")) return;
    const closeBtn = overlay.querySelector($db7a74064a0a5156$var$CLOSE_CONTROLS);
    if (closeBtn) closeBtn.click();
    else overlay.classList.add("hidden");
});


parcelRequire("jx1FN");
// Shared double-submit guard.
//
// Wrap an async action so its trigger button can't fire the action again while
// the first run is still in flight. A rapid double-click would otherwise fire
// the handler twice before the first DB write lands, creating duplicate records
// (duplicate sales, invites, expenses, etc.) or firing duplicate side effects.
//
// Re-entry is blocked via a data flag set on the element itself, so it holds
// even when the same button is wired through more than one listener. The button
// is also disabled (and optionally shows busy text) until the promise settles,
// then fully restored to its previous state.
//
// Usage:
//   btn.addEventListener('click', () => withSubmitGuard(btn, () => handler(data), { busyText: 'Saving…' }));
//
// Pass `busyText` only for plain-text buttons. Omit it for buttons whose label
// contains markup (e.g. an SVG icon) - setting textContent would wipe the icon;
// the disable + re-entry flag still protect those.
//
// @param {HTMLElement|null} btn        the element that triggered the action
// @param {() => any} asyncFn           the work to run once (may be async)
// @param {{ busyText?: string }} [opts]
// @returns the asyncFn result, or undefined if a call was already in flight
async function $05116e7677d717d1$export$277a10cf25fc7086(btn, asyncFn, { busyText: busyText } = {}) {
    // No element to guard against - just run the work.
    if (!btn) return asyncFn();
    // A run is already in flight for this button - swallow the extra click.
    if (btn.dataset.submitting === '1') return;
    btn.dataset.submitting = '1';
    const prevText = btn.textContent;
    const wasDisabled = btn.disabled;
    btn.disabled = true;
    if (busyText != null) btn.textContent = busyText;
    try {
        return await asyncFn();
    } finally{
        delete btn.dataset.submitting;
        btn.disabled = wasDisabled;
        if (busyText != null) btn.textContent = prevText;
    }
}



var $3kKUy = parcelRequire("3kKUy");
class $2ca0d4bdc02a1fa2$var$AuthView {
    _overlay = document.getElementById('authOverlay');
    _wrapper = document.getElementById('authFormsWrapper');
    _loginForm = document.getElementById('loginForm');
    _signUpForm = document.getElementById('signUpForm');
    _forgotForm = document.getElementById('forgotForm');
    _resetForm = document.getElementById('resetForm');
    _inviteForm = document.getElementById('inviteForm');
    _emailInput = document.getElementById('loginEmail');
    _passwordInput = document.getElementById('loginPassword');
    _errorEl = document.getElementById('loginError');
    _signUpErrorEl = document.getElementById('signUpError');
    _forgotErrorEl = document.getElementById('forgotError');
    _resetErrorEl = document.getElementById('resetError');
    _inviteErrorEl = document.getElementById('inviteError');
    _signInBtn = document.getElementById('signInBtn');
    _signUpBtn = document.getElementById('signUpBtn');
    _forgotBtn = document.getElementById('forgotBtn');
    _resetBtn = document.getElementById('resetBtn');
    _inviteBtn = document.getElementById('inviteBtn');
    _joinTeamForm = document.getElementById('joinTeamForm');
    _joinTeamList = document.getElementById('joinTeamList');
    _joinTeamErrorEl = document.getElementById('joinTeamError');
    _joinDeclineBtn = document.getElementById('joinTeamDeclineBtn');
    _onSignUp = false;
    // When the page is a password-reset link, the reset form must stay up no matter what
    // other auth events fire (a late SIGNED_IN was dismissing the overlay). Once locked,
    // hide() and the sign-in success animation become no-ops.
    _recoveryLock = false;
    constructor(){
        document.getElementById('showSignUpLink').addEventListener('click', (e)=>{
            e.preventDefault();
            this.showSignUp();
        });
        document.getElementById('showSignInLink').addEventListener('click', (e)=>{
            e.preventDefault();
            if (this._onSignUp) this._slide('back');
        });
        document.getElementById('showForgotLink').addEventListener('click', (e)=>{
            e.preventDefault();
            this._slideTo(this._loginForm, this._forgotForm, 'forward', false);
            (0, $3kKUy.renderCaptcha)('forgotCaptcha');
        });
        document.getElementById('backToLoginFromForgot').addEventListener('click', (e)=>{
            e.preventDefault();
            this._slideTo(this._forgotForm, this._loginForm, 'back', false);
        });
    }
    // ── Public ────────────────────────────────────────────────────────────────
    show() {
        this._overlay.classList.remove('hidden');
        // The opaque overlay now covers the page, so the pre-boot guard that hid
        // the app chrome (anti home-flash, see index.html <head>) can be released.
        document.documentElement.classList.remove('boot-auth');
        // Render the sign-in CAPTCHA once the overlay is visible (Turnstile renders 0-width
        // inside a display:none container). Idempotent + a no-op when CAPTCHA is disabled.
        // Covers every login entry point (fresh load, OAuth error, failed initApp, kick-out).
        (0, $3kKUy.renderCaptcha)('loginCaptcha');
    }
    // Slides to the sign-up panel programmatically (same as clicking "Sign up") - used to
    // auto-open sign-up when a visitor arrives via a tracking link (?source=<slug>).
    showSignUp() {
        if (!this._onSignUp) this._slide('forward');
        // Render lazily on reveal - Turnstile needs a visible (non display:none) container.
        (0, $3kKUy.renderCaptcha)('signUpCaptcha');
    }
    hide() {
        // While a password-reset link is open, ignore stray hide() calls (a late SIGNED_IN
        // fired a popstate that would otherwise dismiss the reset form). The lock is released
        // once the reset completes.
        if (this._recoveryLock) return;
        this._overlay.classList.add('hidden');
        document.documentElement.classList.remove('boot-auth');
    }
    // Pin the auth overlay open for the password-reset flow so no stray auth event can
    // dismiss the reset form. Also clears any leftover inline styles from a prior animation.
    lockForRecovery() {
        this._recoveryLock = true;
        this._overlay.classList.remove('hidden');
        this._overlay.style.cssText = '';
    }
    // Release the lock once the reset is done so the overlay can close normally (e.g. when
    // we walk the freshly-reset user straight into the app).
    releaseRecoveryLock() {
        this._recoveryLock = false;
    }
    showError(msg) {
        this._errorEl.textContent = msg;
    }
    showSignUpError(msg) {
        this._signUpErrorEl.textContent = msg;
    }
    showForgotError(msg) {
        this._forgotErrorEl.textContent = msg;
    }
    showResetError(msg) {
        this._resetErrorEl.textContent = msg;
    }
    clearErrors() {
        this._errorEl.innerHTML = '';
        this._signUpErrorEl.textContent = '';
        this._forgotErrorEl.textContent = '';
        this._resetErrorEl.textContent = '';
        this._inviteErrorEl.textContent = '';
    }
    setLoading(bool) {
        this._signInBtn.disabled = bool;
        if (bool) this._signInBtn.innerHTML = '<span class="btn-spinner"></span>Signing in\u2026';
        else this._signInBtn.textContent = 'Sign In';
    }
    setSignUpLoading(bool) {
        this._signUpBtn.disabled = bool;
        this._signUpBtn.textContent = bool ? "Creating account\u2026" : 'Create Account';
    }
    setForgotLoading(bool) {
        this._forgotBtn.disabled = bool;
        this._forgotBtn.textContent = bool ? "Sending\u2026" : 'Send Reset Link';
    }
    setResetLoading(bool) {
        this._resetBtn.disabled = bool;
        this._resetBtn.textContent = bool ? "Saving\u2026" : 'Set New Password';
    }
    showCheckEmail(email) {
        this._signUpForm.innerHTML = `
      <p style="text-align:center; font-size:1.05rem; font-weight:600; margin:8px 0;">Check your email</p>
      <p class="auth-switch" style="text-align:center; margin-top:8px;">
        A confirmation link was sent to <strong>${email}</strong>.<br/>
        Click it to activate your account, then sign in.
      </p>
      <p class="auth-switch" style="text-align:center; margin-top:10px; font-size:0.8rem;">
        Don't see it? Check your <strong>spam or junk folder</strong>.
      </p>
      <p class="auth-switch" style="margin-top:20px;">
        <a href="#" id="backToSignIn">Back to sign in</a>
      </p>
    `;
        document.getElementById('backToSignIn')?.addEventListener('click', (e)=>{
            e.preventDefault();
            this._slide('back');
        });
    }
    showForgotSent(email) {
        this._forgotForm.innerHTML = `
      <p style="text-align:center; font-size:1.05rem; font-weight:600; margin:8px 0;">Check your email</p>
      <p class="auth-switch" style="text-align:center; margin-top:8px;">
        A password reset link was sent to <strong>${email}</strong>.
      </p>
      <p class="auth-switch" style="text-align:center; margin-top:10px; font-size:0.8rem;">
        Don't see it? Check your <strong>spam or junk folder</strong>.
      </p>
      <p class="auth-switch" style="margin-top:20px;">
        <a href="#" id="backToLoginFromSent">Back to sign in</a>
      </p>
    `;
        document.getElementById('backToLoginFromSent')?.addEventListener('click', (e)=>{
            e.preventDefault();
            this._slideTo(this._forgotForm, this._loginForm, 'back', false);
        });
    }
    showResetPassword() {
        this._loginForm.classList.add('hidden');
        this._signUpForm.classList.add('hidden');
        this._forgotForm.classList.add('hidden');
        this._resetForm.classList.remove('hidden');
    }
    showInviteForm(firstName) {
        this._loginForm.classList.add('hidden');
        this._signUpForm.classList.add('hidden');
        this._forgotForm.classList.add('hidden');
        this._resetForm.classList.add('hidden');
        const greetEl = document.getElementById('inviteGreeting');
        if (greetEl) greetEl.textContent = firstName ? `Welcome, ${firstName}!` : 'Welcome!';
        this._inviteForm.classList.remove('hidden');
    }
    showInviteError(msg) {
        this._inviteErrorEl.textContent = msg;
    }
    setInviteLoading(bool) {
        this._inviteBtn.disabled = bool;
        this._inviteBtn.textContent = bool ? "Setting up\u2026" : 'Set Up Account';
    }
    showResetSuccess() {
        this._resetForm.innerHTML = `
      <p style="text-align:center; font-size:1.05rem; font-weight:600; margin:8px 0;">Password updated</p>
      <p class="auth-switch" style="text-align:center; margin-top:8px;">
        Your password has been changed successfully.
      </p>
      <p class="auth-switch" style="margin-top:20px;">
        <a href="#" id="goToSignInAfterReset">Sign in with your new password</a>
      </p>
    `;
        document.getElementById('goToSignInAfterReset')?.addEventListener('click', (e)=>{
            e.preventDefault();
            window.location.hash = '';
            this._resetForm.classList.add('hidden');
            this._loginForm.classList.remove('hidden');
        });
    }
    // ── Helpers ───────────────────────────────────────────────────────────────
    _validatePassword(password) {
        if (!password || password.length < 8) return 'Password must be at least 8 characters.';
        if (!/[a-z]/.test(password)) return 'Password must include at least one lowercase letter.';
        if (!/[A-Z]/.test(password)) return 'Password must include at least one uppercase letter.';
        if (!/[0-9]/.test(password)) return 'Password must include at least one number.';
        if (!/[^a-zA-Z0-9]/.test(password)) return 'Password must include at least one special character (e.g. !@#$%).';
        return null;
    }
    // ── Handlers ──────────────────────────────────────────────────────────────
    showGoogleInAppError(url) {
        this._errorEl.innerHTML = `Google sign-in requires Safari or Chrome. <a href="${url}" target="_blank" rel="noopener" style="color:var(--brand-1);font-weight:600;text-decoration:underline;">Open in browser</a>`;
    }
    setGoogleLoading(bool) {
        const btn = document.getElementById('googleSignInBtn');
        if (!btn) return;
        btn.disabled = bool;
        btn.innerHTML = bool ? '<span class="btn-spinner"></span>Redirecting\u2026' : `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>Continue with Google`;
    }
    _addHandlerGoogleSignIn(handler) {
        document.getElementById('googleSignInBtn')?.addEventListener('click', handler);
    }
    _addHandlerSignIn(handler) {
        this._loginForm.addEventListener('submit', (e)=>{
            e.preventDefault();
            this._errorEl.textContent = '';
            const token = (0, $3kKUy.getToken)('loginCaptcha');
            if ((0, $3kKUy.captchaEnabled)() && !token) {
                this._errorEl.textContent = 'Please complete the human verification check.';
                return;
            }
            const btn = e.submitter ?? document.getElementById('signInBtn');
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler(this._emailInput.value.trim(), this._passwordInput.value, token).finally(()=>(0, $3kKUy.resetCaptcha)('loginCaptcha')), {
                busyText: "Signing in\u2026"
            });
        });
    }
    // Fires once, on the first keystroke/change anywhere in the sign-up form - used for the
    // source-tracking funnel's form_started stage. Not tied to which field was touched.
    _addHandlerFormStarted(handler) {
        this._signUpForm.addEventListener('input', ()=>handler(), {
            once: true
        });
    }
    _addHandlerSignUp(handler) {
        this._signUpForm.addEventListener('submit', (e)=>{
            e.preventDefault();
            this._signUpErrorEl.textContent = '';
            const firstName = document.getElementById('signUpFirstName')?.value.trim();
            const lastName = document.getElementById('signUpLastName')?.value.trim();
            const email = document.getElementById('signUpEmail')?.value.trim();
            const password = document.getElementById('signUpPassword')?.value;
            const confirm = document.getElementById('signUpConfirm')?.value;
            if (!firstName) {
                this._signUpErrorEl.textContent = 'Please enter your first name.';
                return;
            }
            if (!lastName) {
                this._signUpErrorEl.textContent = 'Please enter your last name.';
                return;
            }
            if (!email) {
                this._signUpErrorEl.textContent = 'Please enter your email.';
                return;
            }
            const pwErr = this._validatePassword(password);
            if (pwErr) {
                this._signUpErrorEl.textContent = pwErr;
                return;
            }
            if (password !== confirm) {
                this._signUpErrorEl.textContent = 'Passwords do not match.';
                return;
            }
            const token = (0, $3kKUy.getToken)('signUpCaptcha');
            if ((0, $3kKUy.captchaEnabled)() && !token) {
                this._signUpErrorEl.textContent = 'Please complete the human verification check.';
                return;
            }
            const btn = e.submitter ?? document.getElementById('signUpBtn');
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler({
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    password: password,
                    captchaToken: token
                }).finally(()=>(0, $3kKUy.resetCaptcha)('signUpCaptcha')), {
                busyText: "Creating\u2026"
            });
        });
    }
    _addHandlerForgotPassword(handler) {
        this._forgotForm.addEventListener('submit', (e)=>{
            e.preventDefault();
            this._forgotErrorEl.textContent = '';
            const email = document.getElementById('forgotEmail')?.value.trim();
            if (!email) {
                this._forgotErrorEl.textContent = 'Please enter your email.';
                return;
            }
            const token = (0, $3kKUy.getToken)('forgotCaptcha');
            if ((0, $3kKUy.captchaEnabled)() && !token) {
                this._forgotErrorEl.textContent = 'Please complete the human verification check.';
                return;
            }
            const btn = e.submitter ?? document.getElementById('forgotBtn');
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler(email, token).finally(()=>(0, $3kKUy.resetCaptcha)('forgotCaptcha')), {
                busyText: "Sending\u2026"
            });
        });
    }
    _addHandlerAcceptInvite(handler) {
        this._inviteForm.addEventListener('submit', (e)=>{
            e.preventDefault();
            this._inviteErrorEl.textContent = '';
            const password = document.getElementById('invitePassword')?.value;
            const confirm = document.getElementById('inviteConfirm')?.value;
            const pin = document.getElementById('invitePin')?.value.trim();
            const pwErr = this._validatePassword(password);
            if (pwErr) {
                this._inviteErrorEl.textContent = pwErr;
                return;
            }
            if (password !== confirm) {
                this._inviteErrorEl.textContent = 'Passwords do not match.';
                return;
            }
            if (!pin || !/^\d{6}$/.test(pin)) {
                this._inviteErrorEl.textContent = 'PIN must be exactly 6 digits.';
                return;
            }
            const btn = e.submitter ?? document.getElementById('inviteBtn');
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler({
                    password: password,
                    pin: pin
                }), {
                busyText: "Setting up\u2026"
            });
        });
    }
    _addHandlerResetPassword(handler) {
        this._resetForm.addEventListener('submit', (e)=>{
            e.preventDefault();
            this._resetErrorEl.textContent = '';
            const password = document.getElementById('resetPassword')?.value;
            const confirm = document.getElementById('resetConfirm')?.value;
            const pwErr = this._validatePassword(password);
            if (pwErr) {
                this._resetErrorEl.textContent = pwErr;
                return;
            }
            if (password !== confirm) {
                this._resetErrorEl.textContent = 'Passwords do not match.';
                return;
            }
            const btn = e.submitter ?? document.getElementById('resetBtn');
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler(password), {
                busyText: "Saving\u2026"
            });
        });
    }
    // ── Join team (pending invite consent) ────────────────────────────────────
    showJoinTeam(invites) {
        this._loginForm.classList.add('hidden');
        this._signUpForm.classList.add('hidden');
        this._forgotForm.classList.add('hidden');
        this._resetForm.classList.add('hidden');
        this._inviteForm.classList.add('hidden');
        this._joinTeamErrorEl.textContent = '';
        this._joinTeamList.innerHTML = (invites ?? []).map((inv)=>{
            const biz = inv.businessName ? this._escape(inv.businessName) : 'A business';
            const role = this._escape(inv.role ?? 'Staff');
            const who = inv.firstName ? this._escape(inv.firstName) : 'you';
            return `
          <div class="join-team-row" style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:12px;border:1px solid var(--muted);border-radius:14px;margin-bottom:10px;">
            <div style="line-height:1.35;">
              <div style="font-weight:600;font-size:0.95rem;">${biz}</div>
              <div style="font-size:0.78rem;color:var(--muted);">invited ${who} as ${role}</div>
            </div>
            <button type="button" class="btn primary join-team-accept" data-staff-id="${inv.staffId}" style="flex:0 0 auto;padding:8px 16px;">Accept</button>
          </div>`;
        }).join('');
        this._joinTeamForm.classList.remove('hidden');
    }
    showJoinError(msg) {
        this._joinTeamErrorEl.textContent = msg;
    }
    setJoinLoading(bool) {
        this._joinTeamList.querySelectorAll('.join-team-accept').forEach((b)=>{
            b.disabled = bool;
        });
        this._joinDeclineBtn.disabled = bool;
    }
    _escape(str) {
        const d = document.createElement('div');
        d.textContent = String(str);
        return d.innerHTML;
    }
    _addHandlerAcceptJoin(handler) {
        this._joinTeamList.addEventListener('click', (e)=>{
            const btn = e.target.closest('.join-team-accept');
            if (!btn) return;
            this._joinTeamErrorEl.textContent = '';
            handler(btn.dataset.staffId);
        });
    }
    _addHandlerDeclineJoin(handler) {
        this._joinDeclineBtn.addEventListener('click', ()=>{
            this._joinTeamErrorEl.textContent = '';
            handler();
        });
    }
    // ── Login-time 2FA prompt ─────────────────────────────────────────────────
    // Shows the 2FA prompt and resolves with { type: 'totp'|'recovery', code }, or
    // null if the user cancels. The user can toggle between entering an authenticator
    // code and a saved recovery code. Listeners are bound per-call and cleaned up on
    // resolve so the controller can re-prompt (with an error) on a wrong code.
    promptMFACode({ error: error, mode: initialMode = 'totp' } = {}) {
        return new Promise((resolve)=>{
            const modal = document.getElementById('mfaLoginModal');
            const input = document.getElementById('mfaLoginInput');
            const errEl = document.getElementById('mfaLoginError');
            const subEl = modal.querySelector('.mfa-login-sub');
            const verifyBtn = document.getElementById('mfaLoginVerifyBtn');
            const cancelBtn = document.getElementById('mfaLoginCancelBtn');
            const toggleBtn = document.getElementById('mfaLoginToggleBtn');
            let mode = initialMode;
            const applyMode = ()=>{
                input.value = '';
                errEl.textContent = '';
                if (mode === 'totp') {
                    subEl.textContent = 'Enter the 6-digit code from your authenticator app to finish signing in.';
                    input.setAttribute('inputmode', 'numeric');
                    input.setAttribute('maxlength', '6');
                    input.setAttribute('placeholder', '000000');
                    toggleBtn.textContent = "Can't access your authenticator?";
                } else {
                    subEl.textContent = 'Enter one of your saved recovery codes.';
                    input.setAttribute('inputmode', 'text');
                    input.setAttribute('maxlength', '9');
                    input.setAttribute('placeholder', 'XXXX-XXXX');
                    toggleBtn.textContent = 'Use your authenticator instead';
                }
                input.focus();
            };
            modal.classList.remove('hidden');
            // Reset the button to its idle state each time the prompt (re)shows - a prior
            // attempt may have left it in the "Verifying…" loading state.
            verifyBtn.disabled = false;
            verifyBtn.textContent = 'Verify';
            applyMode();
            errEl.textContent = error ?? '';
            const cleanup = ()=>{
                verifyBtn.removeEventListener('click', onVerify);
                cancelBtn.removeEventListener('click', onCancel);
                toggleBtn.removeEventListener('click', onToggle);
                input.removeEventListener('keydown', onKey);
            };
            const onVerify = ()=>{
                const raw = input.value.trim();
                if (mode === 'totp') {
                    if (!/^\d{6}$/.test(raw)) {
                        errEl.textContent = 'Enter the 6-digit code.';
                        return;
                    }
                } else if (!raw) {
                    errEl.textContent = 'Enter a recovery code.';
                    return;
                }
                cleanup();
                resolve({
                    type: mode,
                    code: raw
                });
            };
            const onCancel = ()=>{
                cleanup();
                modal.classList.add('hidden');
                resolve(null);
            };
            const onToggle = ()=>{
                mode = mode === 'totp' ? 'recovery' : 'totp';
                applyMode();
            };
            const onKey = (e)=>{
                if (e.key === 'Enter') onVerify();
            };
            verifyBtn.addEventListener('click', onVerify);
            cancelBtn.addEventListener('click', onCancel);
            toggleBtn.addEventListener('click', onToggle);
            input.addEventListener('keydown', onKey);
        });
    }
    hideMFAPrompt() {
        document.getElementById('mfaLoginModal')?.classList.add('hidden');
    }
    // Busy state for the 2FA Verify button while the code is checked in the background
    // (authenticator verify or the recovery-code Edge Function). promptMFACode resets it
    // to idle on the next (re)prompt; a success hides the whole modal.
    setMFALoading(bool) {
        const btn = document.getElementById('mfaLoginVerifyBtn');
        if (!btn) return;
        btn.disabled = bool;
        if (bool) btn.innerHTML = '<span class="btn-spinner"></span>Verifying\u2026';
        else btn.textContent = 'Verify';
    }
    // ── Sign-in success animation ─────────────────────────────────────────────
    playSignInSuccess() {
        if (this._recoveryLock) return Promise.resolve(); // never animate the overlay away mid password-reset
        return new Promise((resolve)=>{
            const card = this._overlay.querySelector('.auth-card');
            card.classList.add('auth-card--animating', 'auth-card--signing-in');
            const sweep = document.createElement('div');
            sweep.className = 'auth-sweep auth-sweep--forward';
            card.appendChild(sweep);
            requestAnimationFrame(()=>requestAnimationFrame(()=>sweep.classList.add('auth-sweep--active')));
            setTimeout(()=>{
                this._overlay.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                this._overlay.style.opacity = '0';
                this._overlay.style.transform = 'scale(0.97)';
                setTimeout(()=>{
                    this._overlay.classList.add('hidden');
                    this._overlay.style.cssText = '';
                    card.classList.remove('auth-card--animating', 'auth-card--signing-in');
                    // This assumed sign-in success always means the overlay stays hidden for
                    // good, so it never removed the sweep bar - but a later failure after
                    // Supabase auth succeeds (SESSION_LIMIT_REACHED, STAFF_DEACTIVATED,
                    // ADMIN_ACCOUNT) re-shows this same overlay, leaving the sweep stuck as a
                    // stale green line at the card's bottom edge. Clean it up unconditionally.
                    sweep.remove();
                    resolve();
                }, 320);
            }, 460);
        });
    }
    // ── Slide animation ───────────────────────────────────────────────────────
    _slideTo(fromEl, toEl, direction, makeWide) {
        const DURATION = 220;
        const forward = direction === 'forward';
        const outX = forward ? '-28px' : '28px';
        const inX = forward ? '28px' : '-28px';
        const card = this._overlay.querySelector('.auth-card');
        this.clearErrors();
        card.classList.add('auth-card--animating');
        setTimeout(()=>card.classList.remove('auth-card--animating'), 700);
        const sweep = document.createElement('div');
        sweep.className = `auth-sweep auth-sweep--${forward ? 'forward' : 'back'}`;
        card.appendChild(sweep);
        requestAnimationFrame(()=>requestAnimationFrame(()=>sweep.classList.add('auth-sweep--active')));
        setTimeout(()=>{
            sweep.style.transition = 'opacity 0.2s ease';
            sweep.style.opacity = '0';
            setTimeout(()=>sweep.remove(), 220);
        }, 460);
        fromEl.style.transition = `opacity ${DURATION}ms ease, transform ${DURATION}ms ease`;
        fromEl.style.opacity = '0';
        fromEl.style.transform = `translateX(${outX})`;
        setTimeout(()=>{
            fromEl.classList.add('hidden');
            fromEl.style.cssText = '';
            if (makeWide) card.classList.add('auth-card--wide');
            else card.classList.remove('auth-card--wide');
            toEl.style.opacity = '0';
            toEl.style.transform = `translateX(${inX})`;
            toEl.classList.remove('hidden');
            requestAnimationFrame(()=>requestAnimationFrame(()=>{
                    toEl.style.transition = `opacity ${DURATION}ms ease, transform ${DURATION}ms ease`;
                    toEl.style.opacity = '1';
                    toEl.style.transform = 'translateX(0)';
                    setTimeout(()=>{
                        toEl.style.cssText = '';
                    }, DURATION + 10);
                }));
        }, DURATION);
    }
    _slide(direction) {
        const forward = direction === 'forward';
        this._slideTo(forward ? this._loginForm : this._signUpForm, forward ? this._signUpForm : this._loginForm, direction, forward);
        setTimeout(()=>{
            this._onSignUp = forward;
        }, 230);
    }
}
var $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039 = new $2ca0d4bdc02a1fa2$var$AuthView();




var $cnCXJ = parcelRequire("cnCXJ");


var $coRoT = parcelRequire("coRoT");
class $7085f2b0e4c3ca9d$var$MenuListView extends (0, $081656bd50f85abd$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".modal-parent");
    _openBtn = document.querySelector("#menu-list");
    // Category manager starts collapsed so the modal opens focused on items.
    // Sticky across re-renders (e.g. deleting a category) so it doesn't snap shut mid-manage.
    _categoriesOpen = false;
    // Bulk select mode
    _selectMode = false;
    _selectedIds = new Set();
    _generateMarkUp() {
        const cap = (s)=>s[0].toUpperCase() + s.slice(1);
        const { menuCategories: categories, menuItems: menuItems } = this._data;
        const userCategories = categories.filter((c)=>c !== 'uncategorized');
        const chips = userCategories.map((cat)=>`
      <span class="menu-cat-chip">
        <span class="menu-cat-chip-name">${(0, $cnCXJ.esc)(cap(cat))}</span>
        <button class="menu-cat-delete" data-category="${(0, $cnCXJ.esc)(cat)}" type="button">\xd7</button>
      </span>`).join('');
        const fmtMoney = (n)=>(0, $coRoT.formatMoney)(n);
        // Variant option prices are additive (+$X), so a variant item's true floor
        // is base + the cheapest option in each group. Show that as "From $X"
        // instead of the misleading base price (often $0 for variant-priced items).
        const priceLabel = (item)=>{
            const base = Number(item.price) || 0;
            if (item.hasVariants && Array.isArray(item.variants) && item.variants.length) {
                const minAddon = item.variants.reduce((sum, g)=>{
                    const prices = (g.options || []).map((o)=>Number(o.optionPrice) || 0);
                    return sum + (prices.length ? Math.min(...prices) : 0);
                }, 0);
                return `From ${fmtMoney(base + minAddon)}`;
            }
            return fmtMoney(base);
        };
        const renderCard = (item)=>{
            // The square is always "the picture" (real photo, or the neutral
            // placeholder) - never an emoji tile, so it never duplicates the emoji
            // badge below. On a broken real image, clear alt too so the
            // placeholder icon shows instead of truncated alt text in a broken box.
            const src = (0, $69bdae3851aa6802$export$56b52f8eeffda3e5)(item);
            const imgMarkup = `<img src="${(0, $cnCXJ.esc)(src)}" alt="${(0, $cnCXJ.esc)(item.itemName)}" loading="lazy" onerror="this.alt='';this.className='pos-item-img--ph';this.removeAttribute('src')">`;
            // A chosen (or default) emoji "pops" as a small corner badge on every
            // card's image tile instead of replacing it, so the square always
            // keeps its picture look and the grid reads consistently regardless
            // of whether a given item happens to have a real photo.
            const emojiBadge = `<span class="ml-item-emoji-badge" aria-hidden="true">${(0, $cnCXJ.esc)(item.iconEmoji || (0, $69bdae3851aa6802$export$3eab5618e62baa45))}</span>`;
            const selected = this._selectedIds.has(item._id);
            const statusBadge = item.status && item.status !== 'active' ? `<span class="card-status card-status--${(0, $cnCXJ.esc)(item.status)}">${(0, $cnCXJ.esc)(cap(item.status))}</span>` : '';
            return `
      <div class="card${selected ? ' card--selected' : ''}" data-id="${item._id}">
        <div class="btn-main">
          <div class="ml-item-visual">${imgMarkup}${emojiBadge}</div>
          <div class="btn-main-text">
            <div class="title">${(0, $cnCXJ.esc)(item.itemName)}${statusBadge}</div>
            <div class="hint">${priceLabel(item)}</div>
          </div>
        </div>
        <span class="card-check" aria-hidden="true"></span>
      </div>`;
        };
        const groups = userCategories.map((cat)=>{
            const items = menuItems.filter((i)=>i.category === cat);
            if (!items.length) return `
        <div class="menu-cat-group">
          <p class="menu-cat-label">${(0, $cnCXJ.esc)(cap(cat))}</p>
          <p class="menu-cat-empty">No items in this category yet.</p>
        </div>`;
            return `
        <div class="menu-cat-group">
          <p class="menu-cat-label">${(0, $cnCXJ.esc)(cap(cat))}</p>
          <div class="menu-items-grid">${items.map(renderCard).join('')}</div>
        </div>`;
        }).join('');
        const uncategorizedItems = menuItems.filter((i)=>!i.category || i.category === 'uncategorized' || !categories.includes(i.category));
        const uncategorizedGroup = uncategorizedItems.length ? `
      <div class="menu-cat-group">
        <p class="menu-cat-label menu-cat-label--muted">Uncategorized</p>
        <div class="menu-items-grid">${uncategorizedItems.map(renderCard).join('')}</div>
      </div>` : '';
        const hasAnyContent = userCategories.length > 0 || uncategorizedItems.length > 0;
        return `
      <div class="modal-overlay" id="menuModal">
        <div class="menu-modal${this._selectMode ? ' menu-modal--selecting' : ''}">
          <div class="menu-modal-header">
            <div class="menu-modal-heading">
              <h2 class="menu-modal-title">Catalogue</h2>
              <p class="menu-modal-subtitle">Add items one by one, or import your whole menu from a CSV.</p>
            </div>
            <div class="menu-header-actions">
              ${hasAnyContent ? `
                <button class="btn menu-select-toggle" id="menuSelectToggle" type="button">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="m9 12 2 2 4-4"/></svg>
                  Select
                </button>
              ` : ''}
              <button class="btn menu-csv-btn" id="menuUploadCsvBtn" type="button">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                Upload CSV
              </button>
              <button class="btn primary" id="openAddModal">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
                Add Item
              </button>
            </div>
            <button class="modal-close" aria-label="Close">&times;</button>
          </div>
          <div class="menu-cat-manage${this._categoriesOpen ? ' menu-cat-manage--open' : ''}">
            <button type="button" class="menu-cat-toggle" id="menuCatToggle" aria-expanded="${this._categoriesOpen}">
              <svg class="menu-cat-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
              <span class="menu-cat-toggle-label">Categories</span>
              <span class="menu-cat-count">${userCategories.length}</span>
              <span class="menu-cat-toggle-hint">Manage</span>
            </button>
            <div class="menu-cat-body">
              <div class="menu-cat-chips">${chips || '<span class="menu-cat-hint">No categories yet.</span>'}</div>
              <div class="menu-cat-add-row">
                <input type="text" id="menuCategoryInput" placeholder="New category name\u{2026}" class="category-input" />
                <button class="btn primary" id="menuAddCategoryBtn" type="button">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
                  Add Category
                </button>
              </div>
            </div>
          </div>
          <div class="menu-items-area">
            ${!hasAnyContent ? '<p class="menu-empty">No items yet. Add a category and your first item above.</p>' : ''}
            ${groups}
            ${uncategorizedGroup}
          </div>
          <div class="menu-select-bar" role="toolbar" aria-label="Bulk actions">
            <div class="menu-select-info">
              <span class="menu-select-count">${this._selectedIds.size}</span> selected
              <button class="menu-select-all" type="button">Select all</button>
            </div>
            <div class="menu-select-actions">
              <button class="menu-select-action" data-bulk-status="active" type="button">Set Active</button>
              <button class="menu-select-action" data-bulk-status="inactive" type="button">Set Inactive</button>
              <button class="menu-select-action" data-bulk-status="unavailable" type="button">Set Unavailable</button>
              <button class="menu-select-action menu-select-delete" data-bulk-delete type="button">Delete</button>
            </div>
            <button class="menu-select-cancel" type="button">Done</button>
          </div>
        </div>
      </div>`;
    }
    _addHandlerShowModal(handler) {
        this._openBtn.addEventListener("click", function(e) {
            e.preventDefault();
            handler();
        });
    }
    // Re-render in place after a data change (item add/edit/delete, bulk ops,
    // category delete). Suppresses the modal's entrance animation and slides the
    // content areas in instead, so updates read as a refresh - not a reopening
    // modal "blink". Falls back to a normal render when the catalogue isn't open.
    refresh(data) {
        const wasOpen = !!this._parentElement.querySelector(".menu-modal");
        this.render(data);
        if (!wasOpen) return;
        this._parentElement.querySelector(".menu-modal")?.classList.add("menu-modal--soft");
    }
    _addHandlerAddCategory(handler) {
        const submit = (input)=>{
            if (!input?.value.trim()) return;
            handler(input.value.trim());
            input.value = '';
        };
        this._parentElement.addEventListener('click', (e)=>{
            if (!e.target.closest('#menuAddCategoryBtn')) return;
            submit(this._parentElement.querySelector('#menuCategoryInput'));
        });
        this._parentElement.addEventListener('keydown', (e)=>{
            if (e.key !== 'Enter' || !e.target.matches('#menuCategoryInput')) return;
            submit(e.target);
        });
    }
    // Surgically update only the chips strip — no full modal re-render flash
    _updateChips(categories, newCategoryName = null) {
        const container = this._parentElement.querySelector('.menu-cat-chips');
        if (!container) return;
        const cap = (s)=>s[0].toUpperCase() + s.slice(1);
        const userCategories = categories.filter((c)=>c !== 'uncategorized');
        const countEl = this._parentElement.querySelector('.menu-cat-count');
        if (countEl) countEl.textContent = userCategories.length;
        container.innerHTML = userCategories.map((cat)=>`
      <span class="menu-cat-chip">
        <span class="menu-cat-chip-name">${(0, $cnCXJ.esc)(cap(cat))}</span>
        <button class="menu-cat-delete" data-category="${(0, $cnCXJ.esc)(cat)}" type="button">\xd7</button>
      </span>`).join('') || '<span class="menu-cat-hint">No categories yet.</span>';
        // Animate only the newly added chip
        if (newCategoryName) {
            const newChip = [
                ...container.querySelectorAll('.menu-cat-chip')
            ].find((el)=>el.querySelector('.menu-cat-chip-name')?.textContent.trim().toLowerCase() === newCategoryName.trim().toLowerCase());
            if (newChip) newChip.classList.add('menu-cat-chip--entering');
        }
    }
    _addHandlerToggleCategories() {
        this._parentElement.addEventListener('click', (e)=>{
            const btn = e.target.closest('#menuCatToggle');
            if (!btn || !btn.closest('#menuModal')) return;
            const manage = btn.closest('.menu-cat-manage');
            this._categoriesOpen = manage.classList.toggle('menu-cat-manage--open');
            btn.setAttribute('aria-expanded', this._categoriesOpen ? 'true' : 'false');
        });
    }
    _addHandlerUploadCsv(handler) {
        this._parentElement.addEventListener('click', (e)=>{
            const btn = e.target.closest('#menuUploadCsvBtn');
            if (!btn || !btn.closest('#menuModal')) return;
            handler();
        });
    }
    // ── Bulk select ──────────────────────────────────────────────
    _enterSelectMode() {
        this._selectMode = true;
        this._parentElement.querySelector('.menu-modal')?.classList.add('menu-modal--selecting');
    }
    _exitSelectMode() {
        this._selectMode = false;
        this._selectedIds.clear();
        const modal = this._parentElement.querySelector('.menu-modal');
        modal?.classList.remove('menu-modal--selecting');
        modal?.querySelectorAll('.card--selected').forEach((c)=>c.classList.remove('card--selected'));
        this._updateSelectBar();
    }
    _updateSelectBar() {
        const countEl = this._parentElement.querySelector('.menu-select-count');
        if (countEl) countEl.textContent = this._selectedIds.size;
    }
    _toggleCard(card) {
        const id = card.dataset.id;
        if (this._selectedIds.has(id)) {
            this._selectedIds.delete(id);
            card.classList.remove('card--selected');
        } else {
            this._selectedIds.add(id);
            card.classList.add('card--selected');
        }
        this._updateSelectBar();
    }
    _selectAll() {
        const cards = [
            ...this._parentElement.querySelectorAll('#menuModal .menu-items-area .card')
        ];
        const allSelected = cards.length > 0 && this._selectedIds.size === cards.length;
        this._selectedIds.clear();
        cards.forEach((c)=>{
            if (allSelected) c.classList.remove('card--selected');
            else {
                this._selectedIds.add(c.dataset.id);
                c.classList.add('card--selected');
            }
        });
        this._updateSelectBar();
    }
    _addHandlerToggleSelectMode() {
        this._parentElement.addEventListener('click', (e)=>{
            if (!e.target.closest('#menuSelectToggle')) return;
            if (this._selectMode) this._exitSelectMode();
            else this._enterSelectMode();
        });
    }
    _addHandlerCardSelect() {
        this._parentElement.addEventListener('click', (e)=>{
            if (!this._selectMode) return;
            const card = e.target.closest('#menuModal .menu-items-area .card');
            if (!card) return;
            this._toggleCard(card);
        });
    }
    _addHandlerSelectBar({ onSetStatus: onSetStatus, onDelete: onDelete }) {
        this._parentElement.addEventListener('click', (e)=>{
            if (!e.target.closest('#menuModal .menu-select-bar')) return;
            if (e.target.closest('.menu-select-cancel')) {
                this._exitSelectMode();
                return;
            }
            if (e.target.closest('.menu-select-all')) {
                this._selectAll();
                return;
            }
            const statusBtn = e.target.closest('[data-bulk-status]');
            if (statusBtn) {
                onSetStatus(statusBtn.dataset.bulkStatus, [
                    ...this._selectedIds
                ]);
                return;
            }
            if (e.target.closest('[data-bulk-delete]')) {
                onDelete([
                    ...this._selectedIds
                ]);
                return;
            }
        });
    }
    _addHandlerDeleteCategory(handler) {
        this._parentElement.addEventListener('click', (e)=>{
            const btn = e.target.closest('.menu-cat-delete');
            if (!btn || !btn.closest('#menuModal')) return;
            handler(btn.dataset.category);
        });
    }
    _addHandlerCloseModal() {
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".modal-close");
            if (!btn || !btn.closest("#menuModal")) return;
            const inner = this._parentElement.querySelector(".menu-modal");
            if (inner) inner.classList.add("modal-exiting");
            setTimeout(()=>{
                if (inner) inner.classList.remove("modal-exiting");
                const overlay = this._parentElement.querySelector("#menuModal");
                if (overlay) overlay.classList.add("hidden");
            }, 220);
            e.preventDefault();
        });
    }
}
var $7085f2b0e4c3ca9d$export$2e2bcd8739ae039 = new $7085f2b0e4c3ca9d$var$MenuListView();


// Bulk CSV menu import modal. Two screens in one overlay:
//   1. Start  - "Download template" + "Upload CSV" (file picker)
//   2. Preview - the assembled items (grouped from the CSV rows) with flags,
//                so the owner sees exactly what will be saved before committing.
//
// Self-contained: builds its own overlay on first open and appends it to <body>.
// Uses the shared .modal-overlay-form + .modal-close so click-outside-to-close
// (modalBackdrop.js) works for free. All free text rendered through esc().

var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");
// Bulk menu CSV import - pure parsing + assembly helpers (no DOM, no Supabase).
//
// The import is a long/tall format: one row per variant option, repeating the
// item name. A simple item is a single row with the variant columns left blank.
// Rows are grouped by name into the app's menu-item shape:
//   { itemName, price, category, variants: [{ optionLabel, options: [{ optionName, optionPrice }] }] }
//
// Canonical columns: name, price, category, variant_group, option, option_price.
// The actual headers are fuzzy-matched (see ALIASES) and can be remapped in the UI.
// Length caps mirror what the single-item add form realistically accepts, so a
// pasted spreadsheet can't smuggle in a 10k-char "name".
const $0e2841316ad9c03a$var$CAP = {
    name: 80,
    category: 40,
    group: 40,
    option: 60
};
const $0e2841316ad9c03a$export$e6909ad44e61103d = [
    "name",
    "price",
    "category",
    "variant_group",
    "option",
    "option_price"
];
// Normalize a header for matching: lowercase, trim, collapse separators to spaces.
const $0e2841316ad9c03a$var$normHeader = (h)=>String(h ?? "").replace(/^﻿/, "").toLowerCase().replace(/[_\-]+/g, " ").replace(/\s+/g, " ").trim();
// Header aliases per canonical field. Exact canonical names win first, so
// "category" never gets stolen by the "group" alias of variant_group.
const $0e2841316ad9c03a$var$ALIASES = {
    name: [
        "name",
        "item",
        "item name",
        "title",
        "product",
        "product name"
    ],
    price: [
        "price",
        "cost",
        "amount",
        "base price",
        "unit price"
    ],
    category: [
        "category",
        "cat",
        "type",
        "section",
        "menu category"
    ],
    variant_group: [
        "variant group",
        "variantgroup",
        "option group",
        "group",
        "group name",
        "modifier",
        "modifier group",
        "variant"
    ],
    option: [
        "option",
        "option name",
        "choice",
        "value",
        "variant option"
    ],
    option_price: [
        "option price",
        "optionprice",
        "variant price",
        "add on",
        "addon",
        "extra",
        "extra price"
    ]
};
const $0e2841316ad9c03a$var$cap = (s, n)=>String(s ?? "").trim().slice(0, n);
// Money cell -> non-negative number. Tolerates "$1,234.50", "P 90", blanks.
const $0e2841316ad9c03a$var$money = (v)=>{
    const n = Number(String(v ?? "").replace(/[^0-9.\-]/g, ""));
    return Number.isFinite(n) ? Math.max(0, n) : 0;
};
function $0e2841316ad9c03a$export$2dc6f8ad0f55f4d8(text) {
    const rows = [];
    let row = [];
    let field = "";
    let inQuotes = false;
    const src = String(text ?? "").replace(/^﻿/, "");
    for(let i = 0; i < src.length; i++){
        const c = src[i];
        if (inQuotes) {
            if (c === '"') {
                if (src[i + 1] === '"') {
                    field += '"';
                    i++;
                } else inQuotes = false;
            } else field += c;
        } else if (c === '"') inQuotes = true;
        else if (c === ",") {
            row.push(field);
            field = "";
        } else if (c === "\r") ;
        else if (c === "\n") {
            row.push(field);
            rows.push(row);
            row = [];
            field = "";
        } else field += c;
    }
    // trailing field/row (file not ending in a newline)
    if (field !== "" || row.length) {
        row.push(field);
        rows.push(row);
    }
    return rows;
}
function $0e2841316ad9c03a$export$b4b539c00bdfeef2(headers) {
    const norm = headers.map($0e2841316ad9c03a$var$normHeader);
    const mapping = {};
    for (const field of $0e2841316ad9c03a$export$e6909ad44e61103d){
        // exact canonical match first
        let idx = norm.indexOf(field.replace(/_/g, " "));
        if (idx === -1) {
            // alias match, skipping columns already claimed by another field
            const taken = new Set(Object.values(mapping).filter((i)=>i >= 0));
            idx = norm.findIndex((h, i)=>!taken.has(i) && $0e2841316ad9c03a$var$ALIASES[field].includes(h));
        }
        mapping[field] = idx;
    }
    return mapping;
}
const $0e2841316ad9c03a$var$cellAt = (row, idx)=>idx >= 0 && idx < row.length ? row[idx] : "";
const $0e2841316ad9c03a$var$isBlankRow = (row)=>row.every((c)=>String(c ?? "").trim() === "");
function $0e2841316ad9c03a$export$52d56fd36b65ccce(rows, mapping, { existingNames: existingNames, existingCategories: existingCategories } = {}) {
    const names = existingNames ?? new Set();
    const cats = existingCategories ?? new Set();
    const order = []; // preserve first-seen order
    const byKey = new Map(); // lowercased name -> item
    const priceEntries = new Map(); // lowercased name -> every non-blank price cell seen
    let skippedEmptyRows = 0;
    let invalidVariantRows = 0;
    let lastKey = null;
    for (const row of rows){
        if ($0e2841316ad9c03a$var$isBlankRow(row)) {
            skippedEmptyRows++;
            continue;
        }
        let rawName = $0e2841316ad9c03a$var$cap($0e2841316ad9c03a$var$cellAt(row, mapping.name), $0e2841316ad9c03a$var$CAP.name);
        let key = rawName.toLowerCase();
        // Blank name on a row = a continuation of the item above it.
        if (!key && lastKey) {
            key = lastKey;
            rawName = byKey.get(key).itemName;
        }
        if (!key) {
            invalidVariantRows++;
            continue;
        } // orphan row, nothing to attach to
        // Track every price the sheet actually entered for this name (blank cells
        // don't count - those are normal continuation rows for a variant option).
        const priceCell = $0e2841316ad9c03a$var$cellAt(row, mapping.price);
        if (mapping.price >= 0 && String(priceCell ?? "").trim() !== "") {
            if (!priceEntries.has(key)) priceEntries.set(key, []);
            priceEntries.get(key).push($0e2841316ad9c03a$var$money(priceCell));
        }
        let item = byKey.get(key);
        if (!item) {
            item = {
                itemName: rawName,
                price: $0e2841316ad9c03a$var$money($0e2841316ad9c03a$var$cellAt(row, mapping.price)),
                category: $0e2841316ad9c03a$var$cap($0e2841316ad9c03a$var$cellAt(row, mapping.category), $0e2841316ad9c03a$var$CAP.category),
                variants: []
            };
            byKey.set(key, item);
            order.push(item);
        } else {
            // fill base fields from the first row that carries them
            if (!item.category) item.category = $0e2841316ad9c03a$var$cap($0e2841316ad9c03a$var$cellAt(row, mapping.category), $0e2841316ad9c03a$var$CAP.category);
            if (!item.price) item.price = $0e2841316ad9c03a$var$money($0e2841316ad9c03a$var$cellAt(row, mapping.price));
        }
        lastKey = key;
        // Variant part of this row (optional).
        const groupName = $0e2841316ad9c03a$var$cap($0e2841316ad9c03a$var$cellAt(row, mapping.variant_group), $0e2841316ad9c03a$var$CAP.group);
        const optionName = $0e2841316ad9c03a$var$cap($0e2841316ad9c03a$var$cellAt(row, mapping.option), $0e2841316ad9c03a$var$CAP.option);
        if (!groupName && !optionName) continue; // simple-item row, done
        if (!groupName || !optionName) {
            invalidVariantRows++;
            continue;
        } // half a variant
        let group = item.variants.find((g)=>g.optionLabel.toLowerCase() === groupName.toLowerCase());
        if (!group) {
            group = {
                optionLabel: groupName,
                options: []
            };
            item.variants.push(group);
        }
        group.options.push({
            optionName: optionName,
            optionPrice: $0e2841316ad9c03a$var$money($0e2841316ad9c03a$var$cellAt(row, mapping.option_price))
        });
    }
    // Classify each assembled item.
    const newCategories = new Set();
    let priceConflicts = 0;
    const items = order.map((it)=>{
        const duplicate = names.has(it.itemName.toLowerCase());
        const categoryNorm = it.category.toLowerCase();
        const newCategory = Boolean(categoryNorm) && !cats.has(categoryNorm);
        if (newCategory && !duplicate) newCategories.add(categoryNorm);
        // Same name entered on multiple rows with different prices - the first
        // one wins as the item's price, but the sheet author should know that.
        const enteredPrices = priceEntries.get(it.itemName.toLowerCase()) ?? [];
        const priceConflict = new Set(enteredPrices).size > 1;
        if (priceConflict && !duplicate) priceConflicts++;
        return {
            ...it,
            hasVariants: it.variants.length > 0,
            duplicate: duplicate,
            newCategory: newCategory,
            priceConflict: priceConflict,
            priceConflictCount: enteredPrices.length
        };
    });
    const willImport = items.filter((i)=>!i.duplicate).length;
    return {
        items: items,
        summary: {
            total: items.length,
            willImport: willImport,
            duplicates: items.length - willImport,
            newCategories: [
                ...newCategories
            ],
            skippedEmptyRows: skippedEmptyRows,
            invalidVariantRows: invalidVariantRows,
            priceConflicts: priceConflicts
        }
    };
}
const $0e2841316ad9c03a$export$2c5baeefc583651c = [
    "name,price,category,variant_group,option,option_price",
    "Espresso,3.50,Coffee,,,",
    "Latte,,Coffee,Size,Small,4",
    "Latte,,Coffee,Size,Medium,5",
    "Latte,,Coffee,Size,Large,6",
    "Latte,,Coffee,Milk,Whole,0",
    "Latte,,Coffee,Milk,Oat,0.75",
    "Croissant,4.00,Pastry,,,",
    ""
].join("\n");
function $0e2841316ad9c03a$export$2738968c94492694(filename = "pointbunny-menu-template.csv") {
    const blob = new Blob([
        $0e2841316ad9c03a$export$2c5baeefc583651c
    ], {
        type: "text/csv;charset=utf-8"
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(()=>URL.revokeObjectURL(url), 1000);
}


class $fed4c07c736ba70c$var$MenuImportView {
    _overlay = null;
    _onConfirm = null;
    _ctx = null;
    _parsed = null;
    // Open the modal on its start screen. ctx carries the current catalogue so the
    // preview can flag duplicates + new categories.
    open(ctx, onConfirm) {
        this._ctx = ctx;
        this._onConfirm = onConfirm;
        this._ensureOverlay();
        this._showStart();
        this._overlay.classList.remove("hidden");
    }
    close() {
        this._overlay?.classList.add("hidden");
        this._parsed = null;
    }
    _ensureOverlay() {
        if (this._overlay) return;
        const el = document.createElement("div");
        el.className = "modal-overlay-form menu-import-overlay hidden";
        el.id = "menuImportOverlay";
        el.innerHTML = `
      <div class="menu-import-modal modal-content">
        <div class="menu-import-header">
          <h2 class="menu-import-title">Import items from CSV</h2>
          <button class="modal-close" aria-label="Close">&times;</button>
        </div>
        <div class="menu-import-body"></div>
      </div>`;
        document.body.appendChild(el);
        this._overlay = el;
        el.querySelector(".modal-close").addEventListener("click", ()=>this.close());
        // One delegated click handler for every button across both screens.
        el.addEventListener("click", (e)=>{
            if (e.target.closest("#menuImportTemplateBtn")) (0, $0e2841316ad9c03a$export$2738968c94492694)();
            else if (e.target.closest("#menuImportPickBtn")) el.querySelector("#menuImportFileInput")?.click();
            else if (e.target.closest("#menuImportBackBtn")) this._showStart();
            else if (e.target.closest("#menuImportConfirmBtn")) this._confirm();
        });
        el.addEventListener("change", (e)=>{
            if (e.target.id === "menuImportFileInput") this._onFile(e.target.files?.[0]);
        });
    }
    _body() {
        return this._overlay.querySelector(".menu-import-body");
    }
    _showStart() {
        this._parsed = null;
        this._body().innerHTML = `
      <div class="menu-import-start">
        <p class="menu-import-intro">
          Add all your items at once from a spreadsheet - the fastest way to get set up.
        </p>
        <ol class="menu-import-steps">
          <li>
            <span class="menu-import-step-num">1</span>
            <div class="menu-import-step-text">
              <b>Download the template</b>
              <span>A ready-made spreadsheet with example rows already filled in.</span>
            </div>
          </li>
          <li>
            <span class="menu-import-step-num">2</span>
            <div class="menu-import-step-text">
              <b>Add your items</b>
              <span>Open it in Excel or Google Sheets and replace the examples with your own.</span>
            </div>
          </li>
          <li>
            <span class="menu-import-step-num">3</span>
            <div class="menu-import-step-text">
              <b>Upload it back here</b>
              <span>You'll get a preview to check before anything is saved.</span>
            </div>
          </li>
        </ol>
        <details class="menu-import-help">
          <summary>How the columns work</summary>
          <ul>
            <li><b>Simple item:</b> fill <b>name</b>, <b>price</b> and <b>category</b>, and leave the option columns blank.</li>
            <li><b>Item with choices</b> (e.g. sizes): add one row per choice and repeat the item's name on each row.</li>
            <li>Items whose name already exists are skipped, and new categories are created automatically.</li>
          </ul>
        </details>
        <div class="menu-import-start-actions">
          <button class="btn" id="menuImportTemplateBtn" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            Download template
          </button>
          <button class="btn primary" id="menuImportPickBtn" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
            Upload CSV
          </button>
        </div>
        <input type="file" accept=".csv,text/csv" id="menuImportFileInput" hidden />
      </div>`;
    }
    async _onFile(file) {
        if (!file) return;
        let text = "";
        try {
            text = await file.text();
        } catch  {
            this._showError("Could not read that file. Please try again.");
            return;
        }
        const rows = (0, $0e2841316ad9c03a$export$2dc6f8ad0f55f4d8)(text);
        if (rows.length < 2) {
            this._showError("That file looks empty. Use the template as a starting point.");
            return;
        }
        const [headers, ...dataRows] = rows;
        const mapping = (0, $0e2841316ad9c03a$export$b4b539c00bdfeef2)(headers);
        if (mapping.name < 0) {
            this._showError("Couldn't find a <b>name</b> column. Check the header row matches the template.");
            return;
        }
        this._parsed = (0, $0e2841316ad9c03a$export$52d56fd36b65ccce)(dataRows, mapping, this._ctx);
        if (!this._parsed.items.length) {
            this._showError("No items found in that file. Check the header row matches the template.");
            return;
        }
        this._showPreview();
        // allow re-picking the same file later
        this._overlay.querySelector("#menuImportFileInput")?.remove();
    }
    _showError(msg) {
        const start = this._body().querySelector(".menu-import-start");
        if (!start) this._showStart();
        let note = this._body().querySelector(".menu-import-error");
        if (!note) {
            note = document.createElement("p");
            note.className = "menu-import-error";
            this._body().querySelector(".menu-import-start")?.prepend(note);
        }
        note.innerHTML = msg; // msg is app-controlled copy, not user input
        // reset the file input so the same file can be retried
        const input = this._overlay.querySelector("#menuImportFileInput");
        if (input) input.value = "";
    }
    _showPreview() {
        const { items: items, summary: summary } = this._parsed;
        const rowsHtml = items.map((it)=>{
            const variantText = it.hasVariants ? it.variants.map((g)=>`${(0, $cnCXJ.esc)(g.optionLabel)} (${g.options.length})`).join(", ") : "<span class=\"menu-import-muted\">-</span>";
            const status = it.duplicate ? `<span class="menu-import-badge menu-import-badge--skip">Skipped - exists</span>` : `<span class="menu-import-badge menu-import-badge--ok">Add</span>`;
            const catBadge = it.newCategory && !it.duplicate ? ` <span class="menu-import-badge menu-import-badge--new">new</span>` : "";
            const priceBadge = it.priceConflict ? ` <span class="menu-import-badge menu-import-badge--warn">${it.priceConflictCount} different prices</span>` : "";
            return `
          <tr class="${it.duplicate ? "menu-import-row--skip" : ""}">
            <td>${status}</td>
            <td>${(0, $cnCXJ.esc)(it.itemName)}</td>
            <td>${it.hasVariants ? "<span class=\"menu-import-muted\">varies</span>" : (0, $cnCXJ.esc)((0, $coRoT.formatMoney)(it.price))}${priceBadge}</td>
            <td>${(0, $cnCXJ.esc)(it.category || "uncategorized")}${catBadge}</td>
            <td>${variantText}</td>
          </tr>`;
        }).join("");
        const newCats = summary.newCategories.length ? ` &middot; ${summary.newCategories.length} new categor${summary.newCategories.length === 1 ? "y" : "ies"}` : "";
        const skipped = summary.duplicates ? ` &middot; ${summary.duplicates} skipped` : "";
        const badRows = summary.invalidVariantRows ? ` &middot; ${summary.invalidVariantRows} incomplete row${summary.invalidVariantRows === 1 ? "" : "s"} ignored` : "";
        const priceConflictNote = summary.priceConflicts ? ` &middot; ${summary.priceConflicts} item${summary.priceConflicts === 1 ? " has" : "s have"} mismatched prices` : "";
        const conflictWarning = summary.priceConflicts ? `<div class="menu-import-warning">
          <b>Heads up - some items were entered with more than one price:</b>
          <ul>
            ${items.filter((it)=>it.priceConflict && !it.duplicate).map((it)=>`<li><b>${(0, $cnCXJ.esc)(it.itemName)}</b> has ${it.priceConflictCount} entries with different prices - using ${(0, $cnCXJ.esc)((0, $coRoT.formatMoney)(it.price))} (the first one) as its price. You can edit it after importing.</li>`).join("")}
          </ul>
        </div>` : "";
        this._body().innerHTML = `
      <div class="menu-import-preview">
        <p class="menu-import-summary">
          <b>${summary.willImport}</b> item${summary.willImport === 1 ? "" : "s"} ready to import${newCats}${skipped}${badRows}${priceConflictNote}.
        </p>
        ${conflictWarning}
        <div class="menu-import-table-wrap">
          <table class="menu-import-table">
            <thead>
              <tr><th>Status</th><th>Name</th><th>Price</th><th>Category</th><th>Variants</th></tr>
            </thead>
            <tbody>${rowsHtml}</tbody>
          </table>
        </div>
        <div class="menu-import-preview-actions">
          <button class="btn" id="menuImportBackBtn" type="button">Back</button>
          <button class="btn primary" id="menuImportConfirmBtn" type="button" ${summary.willImport ? "" : "disabled"}>
            Import ${summary.willImport} item${summary.willImport === 1 ? "" : "s"}
          </button>
        </div>
      </div>`;
    }
    async _confirm() {
        if (!this._parsed) return;
        const items = this._parsed.items.filter((i)=>!i.duplicate);
        if (!items.length) return;
        const newCategories = this._parsed.summary.newCategories;
        const btn = this._overlay.querySelector("#menuImportConfirmBtn");
        if (btn) {
            btn.disabled = true;
            btn.textContent = "Importing\u2026";
        }
        try {
            await this._onConfirm?.(items, newCategories);
            this.close();
        } catch (err) {
            // surface failure but keep the preview so the owner can retry
            if (btn) {
                btn.disabled = false;
                btn.textContent = "Try again";
            }
            const note = document.createElement("p");
            note.className = "menu-import-error";
            note.textContent = err?.message ?? "Import failed. Please try again.";
            this._body().querySelector(".menu-import-preview")?.prepend(note);
        }
    }
}
var $fed4c07c736ba70c$export$2e2bcd8739ae039 = new $fed4c07c736ba70c$var$MenuImportView();





var $cnCXJ = parcelRequire("cnCXJ");

var $cnCXJ = parcelRequire("cnCXJ");
const $41bf135ff605f7f7$export$328baa8f31d44ea9 = [
    {
        id: "food",
        label: "Food",
        icon: "\uD83C\uDF54",
        emojis: [
            "\uD83C\uDF54",
            "\uD83C\uDF55",
            "\uD83C\uDF2D",
            "\uD83C\uDF2E",
            "\uD83C\uDF2F",
            "\uD83C\uDF57",
            "\uD83C\uDF56",
            "\uD83E\uDD6A",
            "\uD83C\uDF5C",
            "\uD83C\uDF72",
            "\uD83C\uDF71",
            "\uD83C\uDF63",
            "\uD83C\uDF64",
            "\uD83E\uDD57",
            "\uD83C\uDF73",
            "\uD83E\uDD5E",
            "\uD83E\uDDC7",
            "\uD83E\uDD53",
            "\uD83E\uDDC0",
            "\uD83C\uDF66",
            "\uD83C\uDF68",
            "\uD83C\uDF69",
            "\uD83C\uDF6A",
            "\uD83C\uDF82",
            "\uD83E\uDDC1",
            "\uD83C\uDF6B",
            "\uD83C\uDF7F",
            "\uD83E\uDD50",
            "\uD83E\uDD6F",
            "\uD83C\uDF4E",
            "\uD83C\uDF4C",
            "\uD83C\uDF47"
        ]
    },
    {
        id: "drinks",
        label: "Drinks",
        icon: "\u2615",
        emojis: [
            "\u2615",
            "\uD83C\uDF75",
            "\uD83E\uDDCB",
            "\uD83E\uDD64",
            "\uD83E\uDDC3",
            "\uD83E\uDDC9",
            "\uD83C\uDF7A",
            "\uD83C\uDF77",
            "\uD83C\uDF78",
            "\uD83C\uDF79",
            "\uD83E\uDD42",
            "\uD83E\uDD5B",
            "\uD83E\uDDCA"
        ]
    },
    {
        id: "shop",
        label: "Shop",
        icon: "\uD83D\uDECD\uFE0F",
        emojis: [
            "\uD83D\uDC55",
            "\uD83D\uDC57",
            "\uD83D\uDC5F",
            "\uD83D\uDC5C",
            "\uD83D\uDC84",
            "\uD83D\uDC87",
            "\u2702\uFE0F",
            "\uD83E\uDDF4",
            "\uD83E\uDDFC",
            "\uD83D\uDD6F\uFE0F",
            "\uD83D\uDCF7",
            "\uD83C\uDFA7",
            "\uD83D\uDCF1",
            "\uD83D\uDCBB",
            "\uD83C\uDF81",
            "\uD83D\uDECD\uFE0F",
            "\uD83E\uDDF8",
            "\uD83D\uDCDA",
            "\uD83D\uDD8A\uFE0F",
            "\uD83D\uDD27",
            "\uD83D\uDD28",
            "\uD83D\uDE97",
            "\uD83E\uDDF9",
            "\uD83D\uDC3E",
            "\uD83C\uDF38",
            "\uD83D\uDC90"
        ]
    },
    {
        id: "other",
        label: "Other",
        icon: "\u2728",
        emojis: [
            "\u2B50",
            "\u2728",
            "\uD83D\uDC8E",
            "\uD83D\uDD25",
            "\u2764\uFE0F",
            "\uD83C\uDF89",
            "\uD83C\uDFC6",
            "\uD83C\uDFAF",
            "\uD83D\uDCE6",
            "\u2705",
            "\uD83C\uDF40",
            "\uD83C\uDF88"
        ]
    }
];
// Search keywords per emoji (lowercase, space-separated). Matching is by word
// prefix or substring, so "cof" finds coffee and "matcha" finds tea.
const $41bf135ff605f7f7$var$EMOJI_NAMES = {
    "\uD83C\uDF54": "burger hamburger",
    "\uD83C\uDF55": "pizza",
    "\uD83C\uDF2D": "hot dog hotdog",
    "\uD83C\uDF2E": "taco",
    "\uD83C\uDF2F": "burrito wrap",
    "\uD83C\uDF57": "chicken drumstick",
    "\uD83C\uDF56": "meat ribs",
    "\uD83E\uDD6A": "sandwich",
    "\uD83C\uDF5C": "noodles ramen pho",
    "\uD83C\uDF72": "soup stew",
    "\uD83C\uDF71": "bento rice meal",
    "\uD83C\uDF63": "sushi",
    "\uD83C\uDF64": "shrimp tempura",
    "\uD83E\uDD57": "salad",
    "\uD83C\uDF73": "egg breakfast",
    "\uD83E\uDD5E": "pancakes",
    "\uD83E\uDDC7": "waffle",
    "\uD83E\uDD53": "bacon",
    "\uD83E\uDDC0": "cheese",
    "\uD83C\uDF66": "ice cream soft serve",
    "\uD83C\uDF68": "ice cream gelato",
    "\uD83C\uDF69": "donut doughnut",
    "\uD83C\uDF6A": "cookie",
    "\uD83C\uDF82": "cake birthday",
    "\uD83E\uDDC1": "cupcake cake muffin",
    "\uD83C\uDF6B": "chocolate",
    "\uD83C\uDF7F": "popcorn",
    "\uD83E\uDD50": "croissant bread pastry",
    "\uD83E\uDD6F": "bagel bread",
    "\uD83C\uDF4E": "apple fruit",
    "\uD83C\uDF4C": "banana fruit",
    "\uD83C\uDF47": "grapes fruit",
    "\u2615": "coffee latte espresso cappuccino americano hot",
    "\uD83C\uDF75": "tea matcha green hot",
    "\uD83E\uDDCB": "boba milk tea bubble",
    "\uD83E\uDD64": "soda cup iced drink smoothie",
    "\uD83E\uDDC3": "juice box",
    "\uD83E\uDDC9": "mate",
    "\uD83C\uDF7A": "beer",
    "\uD83C\uDF77": "wine",
    "\uD83C\uDF78": "cocktail martini",
    "\uD83C\uDF79": "tropical drink cocktail",
    "\uD83E\uDD42": "champagne toast",
    "\uD83E\uDD5B": "milk",
    "\uD83E\uDDCA": "ice iced",
    "\uD83D\uDC55": "shirt tshirt clothes",
    "\uD83D\uDC57": "dress clothes",
    "\uD83D\uDC5F": "shoe sneaker",
    "\uD83D\uDC5C": "bag purse",
    "\uD83D\uDC84": "lipstick makeup beauty",
    "\uD83D\uDC87": "haircut salon hair",
    "\u2702\uFE0F": "scissors cut trim",
    "\uD83E\uDDF4": "lotion bottle skincare",
    "\uD83E\uDDFC": "soap wash",
    "\uD83D\uDD6F\uFE0F": "candle",
    "\uD83D\uDCF7": "camera photo",
    "\uD83C\uDFA7": "headphones audio",
    "\uD83D\uDCF1": "phone mobile",
    "\uD83D\uDCBB": "laptop computer",
    "\uD83C\uDF81": "gift present",
    "\uD83D\uDECD\uFE0F": "shopping bags",
    "\uD83E\uDDF8": "toy teddy",
    "\uD83D\uDCDA": "books",
    "\uD83D\uDD8A\uFE0F": "pen",
    "\uD83D\uDD27": "wrench repair tool",
    "\uD83D\uDD28": "hammer tool",
    "\uD83D\uDE97": "car auto",
    "\uD83E\uDDF9": "broom cleaning",
    "\uD83D\uDC3E": "pet paw",
    "\uD83C\uDF38": "flower blossom",
    "\uD83D\uDC90": "bouquet flowers",
    "\u2B50": "star",
    "\u2728": "sparkles special",
    "\uD83D\uDC8E": "gem diamond",
    "\uD83D\uDD25": "fire hot spicy",
    "\u2764\uFE0F": "heart love",
    "\uD83C\uDF89": "party celebration",
    "\uD83C\uDFC6": "trophy award",
    "\uD83C\uDFAF": "target",
    "\uD83D\uDCE6": "box package",
    "\u2705": "check done",
    "\uD83C\uDF40": "clover luck",
    "\uD83C\uDF88": "balloon"
};
const $41bf135ff605f7f7$var$ALL_EMOJIS = $41bf135ff605f7f7$export$328baa8f31d44ea9.flatMap((g)=>g.emojis);
const $41bf135ff605f7f7$var$findGroup = (emoji)=>$41bf135ff605f7f7$export$328baa8f31d44ea9.find((g)=>g.emojis.includes(emoji))?.id ?? $41bf135ff605f7f7$export$328baa8f31d44ea9[0].id;
const $41bf135ff605f7f7$var$isEmoji = (s)=>/\p{Extended_Pictographic}/u.test(s);
// First user-perceived character (keeps multi-codepoint emoji like 🕯️ whole).
const $41bf135ff605f7f7$var$firstGrapheme = (s)=>{
    if (typeof Intl !== "undefined" && Intl.Segmenter) {
        for (const { segment: segment } of new Intl.Segmenter(undefined, {
            granularity: "grapheme"
        }).segment(s)){
            if ($41bf135ff605f7f7$var$isEmoji(segment)) return segment;
        }
        return "";
    }
    return [
        ...s
    ].find($41bf135ff605f7f7$var$isEmoji) ?? "";
};
const $41bf135ff605f7f7$var$optMarkup = (e, selected)=>`<button type="button" class="item-emoji-opt${e === selected ? " item-emoji-opt--selected" : ""}" data-emoji="${e}" aria-label="${(0, $cnCXJ.esc)($41bf135ff605f7f7$var$EMOJI_NAMES[e]?.split(" ")[0] ?? e)}" title="${(0, $cnCXJ.esc)($41bf135ff605f7f7$var$EMOJI_NAMES[e]?.split(" ")[0] ?? "")}">${e}</button>`;
const $41bf135ff605f7f7$var$TRIGGER_SUB_EMPTY = "Optional \xb7 shown on New Order in Emoji view";
const $41bf135ff605f7f7$var$TRIGGER_SUB_SET = "Tap to change";
const $41bf135ff605f7f7$export$8325cc25308f281 = function({ selectedEmoji: selectedEmoji, extraClass: extraClass = "" } = {}) {
    const activeCat = $41bf135ff605f7f7$var$findGroup(selectedEmoji);
    const has = !!selectedEmoji;
    return `
    <div class="item-emoji-panel${extraClass ? ` ${extraClass}` : ""}">
      <button type="button" class="ivp-trigger" aria-expanded="false" aria-haspopup="true">
        <span class="item-emoji-preview${has ? "" : " item-emoji-preview--empty"}" aria-hidden="true">${has ? (0, $cnCXJ.esc)(selectedEmoji) : "\uD83D\uDE42"}</span>
        <span class="ivp-trigger-text">
          <span class="ivp-trigger-title">Emoji</span>
          <span class="ivp-trigger-sub">${has ? $41bf135ff605f7f7$var$TRIGGER_SUB_SET : $41bf135ff605f7f7$var$TRIGGER_SUB_EMPTY}</span>
        </span>
        <svg class="ivp-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <div class="ivp-pop hidden">
        <input type="text" class="item-emoji-custom-input" maxlength="40" placeholder="Search, or paste any emoji" aria-label="Search emoji" autocomplete="off" />
        <div class="item-emoji-cats" role="tablist">
          ${$41bf135ff605f7f7$export$328baa8f31d44ea9.map((g)=>`<button type="button" class="item-emoji-cat${g.id === activeCat ? " item-emoji-cat--active" : ""}" data-emoji-cat="${g.id}" role="tab" aria-label="${(0, $cnCXJ.esc)(g.label)}" title="${(0, $cnCXJ.esc)(g.label)}">${g.icon}</button>`).join("")}
        </div>
        ${$41bf135ff605f7f7$export$328baa8f31d44ea9.map((g)=>`
          <div class="item-emoji-grid${g.id === activeCat ? "" : " hidden"}" data-emoji-grid="${g.id}">
            ${g.emojis.map((e)=>$41bf135ff605f7f7$var$optMarkup(e, selectedEmoji)).join("")}
          </div>`).join("")}
        <div class="item-emoji-grid hidden" data-emoji-grid="__search"></div>
        <div class="ivp-foot">
          <span class="ivp-hint">Tip: paste any emoji into the search</span>
          <button type="button" class="ivp-clear${has ? "" : " hidden"}">Remove emoji</button>
        </div>
      </div>
    </div>`;
};
const $41bf135ff605f7f7$export$1f40417e4e0c8b3f = function({ mode: mode, selectedEmoji: selectedEmoji }) {
    return `
    <input type="hidden" name="imageMode" class="item-image-mode-input" value="${mode}" />
    <input type="hidden" name="iconEmoji" value="${(0, $cnCXJ.esc)(selectedEmoji || "")}" />`;
};
const $41bf135ff605f7f7$var$setOpen = (panel, open)=>{
    if (!panel) return;
    panel.querySelector(".ivp-pop")?.classList.toggle("hidden", !open);
    panel.querySelector(".ivp-trigger")?.setAttribute("aria-expanded", String(open));
    panel.classList.toggle("item-emoji-panel--open", open);
    if (open) {
        $41bf135ff605f7f7$var$resetSearch(panel);
        // Focus the search on pointer devices only - on a tablet it would pop the
        // keyboard over the grid the user is about to tap.
        if (window.matchMedia?.("(hover: hover)").matches) panel.querySelector(".item-emoji-custom-input")?.focus();
    }
};
const $41bf135ff605f7f7$var$closeAllPickers = (except = null)=>{
    document.querySelectorAll(".item-emoji-panel--open").forEach((p)=>{
        if (p !== except) $41bf135ff605f7f7$var$setOpen(p, false);
    });
};
const $41bf135ff605f7f7$var$showCategory = (panel, cat)=>{
    panel.querySelectorAll(".item-emoji-cat").forEach((b)=>b.classList.toggle("item-emoji-cat--active", b.dataset.emojiCat === cat));
    panel.querySelectorAll("[data-emoji-grid]").forEach((g)=>g.classList.toggle("hidden", g.dataset.emojiGrid !== cat));
};
const $41bf135ff605f7f7$var$resetSearch = (panel)=>{
    const input = panel.querySelector(".item-emoji-custom-input");
    if (input) input.value = "";
    const selected = panel.closest("form")?.querySelector('input[name="iconEmoji"]')?.value;
    $41bf135ff605f7f7$var$showCategory(panel, $41bf135ff605f7f7$var$findGroup(selected));
};
const $41bf135ff605f7f7$var$runSearch = (panel, query)=>{
    const q = query.trim().toLowerCase();
    if (!q) {
        $41bf135ff605f7f7$var$resetSearch(panel);
        return;
    }
    // A pasted/typed emoji is picked straight away (the old "paste any emoji").
    const pasted = $41bf135ff605f7f7$var$firstGrapheme(query);
    if (pasted) {
        $41bf135ff605f7f7$var$selectEmoji(panel, pasted);
        $41bf135ff605f7f7$var$setOpen(panel, false);
        return;
    }
    const selected = panel.closest("form")?.querySelector('input[name="iconEmoji"]')?.value;
    const hits = $41bf135ff605f7f7$var$ALL_EMOJIS.filter((e)=>{
        const words = ($41bf135ff605f7f7$var$EMOJI_NAMES[e] ?? "").split(" ");
        return words.some((w)=>w.startsWith(q)) || ($41bf135ff605f7f7$var$EMOJI_NAMES[e] ?? "").includes(q);
    });
    const grid = panel.querySelector('[data-emoji-grid="__search"]');
    grid.innerHTML = hits.length ? hits.map((e)=>$41bf135ff605f7f7$var$optMarkup(e, selected)).join("") : `<p class="ivp-empty">No match for "${(0, $cnCXJ.esc)(query.trim())}". Paste any emoji instead.</p>`;
    panel.querySelectorAll(".item-emoji-cat").forEach((b)=>b.classList.remove("item-emoji-cat--active"));
    panel.querySelectorAll("[data-emoji-grid]").forEach((g)=>g.classList.toggle("hidden", g !== grid));
};
// Click-outside closes any open picker. One document listener for the app.
let $41bf135ff605f7f7$var$_outsideWired = false;
const $41bf135ff605f7f7$var$wireOutsideClose = ()=>{
    if ($41bf135ff605f7f7$var$_outsideWired) return;
    $41bf135ff605f7f7$var$_outsideWired = true;
    document.addEventListener("click", (e)=>{
        if (e.target.closest(".item-emoji-panel")) return;
        $41bf135ff605f7f7$var$closeAllPickers();
    });
};
const $41bf135ff605f7f7$export$a24135cf33b875fd = function(root) {
    $41bf135ff605f7f7$var$wireOutsideClose();
    root.addEventListener("click", (e)=>{
        const trigger = e.target.closest(".ivp-trigger");
        if (trigger) {
            const panel = trigger.closest(".item-emoji-panel");
            const open = !panel.classList.contains("item-emoji-panel--open");
            $41bf135ff605f7f7$var$closeAllPickers(panel);
            $41bf135ff605f7f7$var$setOpen(panel, open);
            return;
        }
        const catBtn = e.target.closest(".item-emoji-cat");
        if (catBtn) {
            const panel = catBtn.closest(".item-emoji-panel");
            const input = panel.querySelector(".item-emoji-custom-input");
            if (input) input.value = "";
            $41bf135ff605f7f7$var$showCategory(panel, catBtn.dataset.emojiCat);
            return;
        }
        const opt = e.target.closest(".item-emoji-opt");
        if (opt) {
            const panel = opt.closest(".item-emoji-panel");
            $41bf135ff605f7f7$var$selectEmoji(panel, opt.dataset.emoji);
            $41bf135ff605f7f7$var$setOpen(panel, false);
            return;
        }
        const clear = e.target.closest(".ivp-clear");
        if (clear) {
            const panel = clear.closest(".item-emoji-panel");
            $41bf135ff605f7f7$var$selectEmoji(panel, "");
            // Back to Photo so an existing photo on this item is what saves.
            const modeInput = panel.closest("form")?.querySelector('input[name="imageMode"]');
            if (modeInput) modeInput.value = "photo";
            $41bf135ff605f7f7$var$setOpen(panel, false);
        }
    });
    root.addEventListener("input", (e)=>{
        const input = e.target.closest(".item-emoji-custom-input");
        if (!input) return;
        $41bf135ff605f7f7$var$runSearch(input.closest(".item-emoji-panel"), input.value);
    });
    // A successfully chosen photo makes Photo the mode that saves - the mirror
    // of selectEmoji flipping it to "emoji" below. Covers native file-picker
    // selection directly; the Edit form's drag-and-drop handler
    // (menuEditView.js _addPhotoDropZone) dispatches this same change event
    // after assigning `input.files`, so it's covered too.
    root.addEventListener("change", (e)=>{
        const input = e.target.closest('input[type="file"][name="image"]');
        if (!input || !input.files?.[0]) return;
        const modeInput = input.closest("form")?.querySelector('input[name="imageMode"]');
        if (modeInput) modeInput.value = "photo";
    });
    // Enter in the search picks the only/first match instead of submitting the
    // item form; Escape closes the picker (not the whole item modal).
    root.addEventListener("keydown", (e)=>{
        const panel = e.target.closest(".item-emoji-panel");
        if (!panel) return;
        if (e.key === "Escape" && panel.classList.contains("item-emoji-panel--open")) {
            e.preventDefault();
            e.stopPropagation();
            $41bf135ff605f7f7$var$setOpen(panel, false);
            panel.querySelector(".ivp-trigger")?.focus();
            return;
        }
        if (e.key === "Enter" && e.target.closest(".item-emoji-custom-input")) {
            e.preventDefault();
            const first = panel.querySelector('[data-emoji-grid]:not(.hidden) .item-emoji-opt');
            if (first) {
                $41bf135ff605f7f7$var$selectEmoji(panel, first.dataset.emoji);
                $41bf135ff605f7f7$var$setOpen(panel, false);
            }
        }
    });
};
const $41bf135ff605f7f7$var$selectEmoji = function(panel, emoji) {
    if (!panel) return;
    const form = panel.closest("form");
    const emojiInput = form?.querySelector('input[name="iconEmoji"]');
    if (emojiInput) emojiInput.value = emoji;
    if (emoji) {
        const modeInput = form?.querySelector('input[name="imageMode"]');
        if (modeInput) modeInput.value = "emoji";
    }
    const preview = panel.querySelector(".item-emoji-preview");
    if (preview) {
        preview.textContent = emoji || "\uD83D\uDE42";
        preview.classList.toggle("item-emoji-preview--empty", !emoji);
    }
    const sub = panel.querySelector(".ivp-trigger-sub");
    if (sub) sub.textContent = emoji ? $41bf135ff605f7f7$var$TRIGGER_SUB_SET : $41bf135ff605f7f7$var$TRIGGER_SUB_EMPTY;
    panel.querySelector(".ivp-clear")?.classList.toggle("hidden", !emoji);
    panel.querySelectorAll(".item-emoji-opt").forEach((b)=>b.classList.toggle("item-emoji-opt--selected", b.dataset.emoji === emoji));
};
const $41bf135ff605f7f7$export$9715d5280ce9b1dd = function(root) {
    const panel = root.querySelector(".item-emoji-panel");
    if (panel) {
        $41bf135ff605f7f7$var$selectEmoji(panel, "");
        $41bf135ff605f7f7$var$setOpen(panel, false);
    }
    const modeInput = root.querySelector('input[name="imageMode"]');
    if (modeInput) modeInput.value = "photo";
};


const $0540865b060d0b60$var$FILE_UPLOAD_ZONE_MARKUP = `
  <label class="file-upload-label">
    <input type="file" name="image" accept="image/*" />
    <div class="file-upload-zone">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/>
        <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/>
      </svg>
      <span class="file-upload-zone-main">Click to upload</span>
      <span class="file-upload-name">PNG or JPG (optional)</span>
    </div>
  </label>`;
class $0540865b060d0b60$var$NewMenuItemView extends (0, $081656bd50f85abd$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("#addMenuModal");
    _closeBtn = this._parentElement.querySelector(".modal-close");
    _modalDiv = document.querySelector(".modal-parent");
    _formParent = this._parentElement.querySelector(".add-menu-form");
    _selectOptionsElement = document.querySelector(".select-options");
    _visualField = document.getElementById("addItemVisualField");
    //variants
    _variantSection = document.querySelector(".variant-btn-section");
    _variantModal = document.getElementById("addVariantModal");
    _variantCheckBoxElement = document.getElementById("hasVariantsCheckbox");
    _showVariantBtn = document.getElementById("showVariantField");
    _addVariantElement = document.querySelector(".variant-modal");
    _addVariantOptionBtn = document.querySelector(".add-variant-option");
    _variantContainer = document.querySelector(".variant-options-field");
    _addVariantBtn = document.getElementById("addVariantSet");
    _addedVariants = [];
    _editingVariantIndex = null;
    constructor(){
        super();
        this._insertVisualField();
        this._addVariantSet();
        this._showVariantModal();
        this._variantModalHide();
        this._addHandlerVariantActions();
        this._addFileUploadListener();
        (0, $41bf135ff605f7f7$export$a24135cf33b875fd)(this._parentElement);
    }
    // Builds the Photo/Emoji toggle + both panels once, into the static
    // placeholder in index.html - shares markup with the Edit form via
    // itemVisualPicker.js so the two never drift.
    _insertVisualField() {
        this._visualField.insertAdjacentHTML("beforeend", `<div class="item-photo-panel">${$0540865b060d0b60$var$FILE_UPLOAD_ZONE_MARKUP}</div>
      ${(0, $41bf135ff605f7f7$export$8325cc25308f281)({
            selectedEmoji: ""
        })}
      ${(0, $41bf135ff605f7f7$export$1f40417e4e0c8b3f)({
            mode: "photo",
            selectedEmoji: ""
        })}`);
    }
    _toggleModalClose() {
        this._closeBtn.addEventListener("click", (e)=>{
            const overlay = this._parentElement;
            const inner = overlay.querySelector(".modal-content");
            if (inner) inner.classList.add("modal-exiting");
            setTimeout(()=>{
                if (inner) inner.classList.remove("modal-exiting");
                overlay.classList.add("hidden");
                document.getElementById("newCategoryInput").classList.add("hidden");
                document.querySelector(".new-category-button").classList.add("hidden");
                this._formReset();
            }, 220);
        });
    }
    _toggleModalOpen() {
        this._modalDiv.addEventListener("click", function(e) {
            e.preventDefault();
            const btn = e.target.closest("#openAddModal");
            if (!btn) return;
            document.querySelector(".modal-overlay-form").classList.toggle("hidden");
        });
    }
    _uploadItem(handler) {
        this._formParent.addEventListener("submit", (e)=>{
            e.preventDefault();
            //1.) Extract the data from fields
            const dataArr = [
                ...new FormData(this._formParent)
            ];
            const data = Object.fromEntries(dataArr);
            if (!data) return;
            // Guard the submit button: a rapid second submit would otherwise run after
            // _formReset() clears the inputs and upload a blank/garbage menu item.
            const btn = e.submitter ?? this._formParent.querySelector(".submit-btn");
            if (btn?.dataset.submitting === "1") return;
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler(data), {
                busyText: "Adding\u2026"
            });
            //2.) Refactor data to become model object
            //3.) Send data to controller
            //4.) close form modal
            //5.) Show success
            this._formReset();
        });
    }
    // NOTE: inventory tracking deliberately lives in the EDIT form only (owner
    // decision 2026-07-06) - the add form shows a static tip pointing there.
    _formReset() {
        document.querySelectorAll(".variant-options-container-text").forEach((container)=>container.remove());
        const inputs = document.getElementById("addMenuModal").querySelectorAll("input, select, textarea");
        inputs.forEach((input)=>{
            if (input.type === "checkbox" || input.type === "radio") input.checked = false;
            else input.value = "";
        });
        this._selectOptionsElement.value = "";
        document.getElementById("addMenuModal").classList.add("hidden");
        document.querySelector(".new-category-row").classList.add("hidden");
        this._showVariantBtn.classList.add("hidden");
        this._addedVariants = [];
        this._editingVariantIndex = null;
        this._addVariantBtn.textContent = "Add Variant";
        const fileNameSpan = this._parentElement.querySelector(".file-upload-name");
        fileNameSpan.textContent = "PNG or JPG (optional)";
        fileNameSpan.style.color = "";
        (0, $41bf135ff605f7f7$export$9715d5280ce9b1dd)(this._parentElement);
    }
    _newMenuCategory() {
        const row = document.querySelector(".new-category-row");
        document.querySelector(".select-options").addEventListener("change", function() {
            if (this.value === "new-category") {
                row.classList.remove("hidden");
                row.querySelector(".new-category-field").focus();
            } else row.classList.add("hidden");
        });
    }
    _addHandlerAddMenuCategory(handler) {
        const row = document.querySelector(".new-category-row");
        const field = document.getElementById("newCategoryInput");
        const submit = ()=>{
            const newCateg = field.value.trim();
            if (!newCateg) {
                alert("Please enter a category name");
                return;
            }
            handler(newCateg);
            field.value = "";
            row.classList.add("hidden");
        };
        document.querySelector(".new-category-button").addEventListener("click", submit);
        field.addEventListener("keydown", (e)=>{
            if (e.key === "Enter") {
                e.preventDefault();
                submit();
            }
        });
    }
    _mapMenuCategoriesMarkUp(data) {
        this._selectOptionsElement.innerHTML = ``;
        this._selectOptionsElement.innerHTML = `
      <option class="hidden" value="Select category" disabled selected>Select category</option>
      <option value="new-category">Add new category</option>
    `;
        const markup = data.map((i)=>`<option value="${i}">${i[0].toUpperCase() + i.slice(1)}</option>
`);
        this._selectOptionsElement.insertAdjacentHTML("afterbegin", markup);
    }
    _itemVariantsToggle() {
        this._variantCheckBoxElement.addEventListener("change", ()=>{
            if (this._variantCheckBoxElement.checked) {
                document.querySelector(".variants-section").classList.remove("hidden");
                this._showVariantBtn.classList.remove("hidden"); // ensure button is visible
            } else document.querySelector(".variants-section").classList.add("hidden");
        });
    }
    _showVariantModal() {
        this._showVariantBtn.addEventListener("click", (e)=>{
            // Opening for a fresh add - clear any leftover values / edit state so the
            // modal never shows a previously edited or cancelled set.
            this._resetVariantFields();
            this._addVariantElement.classList.remove("hidden");
        });
    }
    _variantModalHide() {
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".variant-close");
            if (!btn) return;
            const overlay = document.querySelector(".variant-modal");
            const inner = overlay.querySelector(".variant-content");
            if (inner) inner.classList.add("modal-exiting");
            setTimeout(()=>{
                if (inner) inner.classList.remove("modal-exiting");
                overlay.classList.add("hidden");
            }, 220);
            // Cancel any in-progress edit; the original set stays in the list.
            this._editingVariantIndex = null;
            this._addVariantBtn.textContent = "Add Variant";
        });
    }
    // Clears the variant modal's inputs + any extra option rows.
    _resetVariantFields() {
        document.querySelectorAll(".variant-options-field.added-fields").forEach((el)=>el.remove());
        this._variantModal.querySelectorAll("input").forEach((input)=>input.value = "");
    }
    _addVariantOption() {
        this._addVariantOptionBtn.addEventListener("click", ()=>this._appendOptionRow());
    }
    // Appends one option row to the variant modal, optionally pre-filled (used when
    // editing an existing set). Setting .value via JS avoids attribute escaping.
    _appendOptionRow(name = "", price = "") {
        const markup = `
      <div class="variant-options-field added-fields">
        <label>
          <input type="text" name="option-name" placeholder="e.g. Small, Medium, Large"/>
        </label>
        <label class="price-label">
          <input type="number" name="option-price" placeholder="$0.00" step="0.01" min="0" inputmode="decimal"/>
        </label>
      </div>`;
        this._variantContainer.insertAdjacentHTML("beforeend", markup);
        const rows = document.querySelectorAll(".variant-options-field.added-fields");
        const row = rows[rows.length - 1];
        if (row) {
            row.querySelector('input[name="option-name"]').value = name ?? "";
            row.querySelector('input[name="option-price"]').value = price && price !== "0" ? price : "";
        }
    }
    // Loads an existing set back into the modal so it can be edited.
    _populateVariantModal(variant) {
        this._resetVariantFields();
        document.querySelector('input[name="variant-name"]').value = variant.optionLabel ?? "";
        const opts = variant.options?.length ? variant.options : [
            {
                optionName: "",
                optionPrice: ""
            }
        ];
        const firstName = this._variantContainer.querySelector('input[name="option-name"]');
        const firstPrice = this._variantContainer.querySelector('input[name="option-price"]');
        if (firstName) firstName.value = opts[0].optionName ?? "";
        if (firstPrice) firstPrice.value = opts[0].optionPrice && opts[0].optionPrice !== "0" ? opts[0].optionPrice : "";
        for(let i = 1; i < opts.length; i++)this._appendOptionRow(opts[i].optionName, opts[i].optionPrice);
    }
    _addVariantSet() {
        this._addVariantBtn.addEventListener("click", (e)=>{
            e.preventDefault();
            e.stopImmediatePropagation();
            const optionLabel = document.querySelector('input[name="variant-name"]').value.trim();
            if (!optionLabel) {
                alert("Please insert an option name or label");
                return;
            }
            const optionRows = document.querySelectorAll('input[name="option-name"]');
            const options = Array.from(optionRows).map((optionInput)=>{
                const optionRow = optionInput.closest(".variant-options-field");
                const priceInput = optionRow.querySelector('input[name="option-price"]');
                return {
                    optionName: optionInput.value.trim(),
                    optionPrice: priceInput.value !== "" ? priceInput.value : "0"
                };
            });
            const set = {
                optionLabel: optionLabel,
                options: options
            };
            if (this._editingVariantIndex !== null) this._addedVariants[this._editingVariantIndex] = set; // edit in place
            else this._addedVariants.push(set);
            this._renderAddedVariants();
            // Clear + close the modal, reset edit state.
            this._resetVariantFields();
            this._editingVariantIndex = null;
            this._addVariantBtn.textContent = "Add Variant";
            document.querySelector(".variant-modal").classList.add("hidden");
        });
    }
    // Rebuilds the summary of added variant sets, each with Edit + Remove controls.
    _renderAddedVariants() {
        document.querySelectorAll(".variant-options-container-text").forEach((el)=>el.remove());
        const markup = this._addedVariants.map((variant, idx)=>{
            const optionsHTML = variant.options.map((opt)=>`<div class="option-pair">
                 <span class="option-name">${(0, $cnCXJ.esc)(opt.optionName)}</span>
                 <span class="option-price">${(0, $cnCXJ.esc)(opt.optionPrice)}</span>
               </div>`).join("");
            return `<div class="variant-options-container-text" data-variant-index="${idx}">
            <div class="variant-set-head">
              <div class="option-label">${(0, $cnCXJ.esc)(variant.optionLabel)}</div>
              <div class="variant-set-actions">
                <button type="button" class="variant-edit-btn" data-variant-index="${idx}">Edit</button>
                <button type="button" class="variant-remove-btn" data-variant-index="${idx}" aria-label="Remove variant set">&times;</button>
              </div>
            </div>
            <div class="option-pairs">${optionsHTML}</div>
          </div>`;
        }).join("");
        this._variantSection.insertAdjacentHTML("afterend", markup);
    }
    // Delegated Edit / Remove for each added variant set.
    _addHandlerVariantActions() {
        this._parentElement.addEventListener("click", (e)=>{
            const removeBtn = e.target.closest(".variant-remove-btn");
            if (removeBtn) {
                const idx = Number(removeBtn.dataset.variantIndex);
                this._addedVariants.splice(idx, 1);
                if (this._editingVariantIndex === idx) this._editingVariantIndex = null;
                this._renderAddedVariants();
                return;
            }
            const editBtn = e.target.closest(".variant-edit-btn");
            if (editBtn) {
                const idx = Number(editBtn.dataset.variantIndex);
                const variant = this._addedVariants[idx];
                if (!variant) return;
                this._editingVariantIndex = idx;
                this._populateVariantModal(variant);
                this._addVariantBtn.textContent = "Save Variant";
                this._addVariantElement.classList.remove("hidden");
                return;
            }
        });
    }
    _addFileUploadListener() {
        const fileInput = this._parentElement.querySelector('input[type="file"][name="image"]');
        const fileNameSpan = this._parentElement.querySelector(".file-upload-name");
        fileInput.addEventListener("change", ()=>{
            const file = fileInput.files?.[0];
            const zone = this._parentElement.querySelector(".file-upload-zone");
            if (!file) {
                fileNameSpan.textContent = "PNG or JPG (optional)";
                fileNameSpan.style.color = "";
                zone?.classList.remove("file-upload-zone--selected");
                return;
            }
            if (!file.type.startsWith("image/")) {
                fileInput.value = "";
                fileNameSpan.textContent = "Please select an image file";
                fileNameSpan.style.color = "var(--color-danger, #ef4444)";
                return;
            }
            fileNameSpan.textContent = "\u2713 " + file.name;
            fileNameSpan.style.color = "";
            zone?.classList.add("file-upload-zone--selected");
        });
    }
}
var $0540865b060d0b60$export$2e2bcd8739ae039 = new $0540865b060d0b60$var$NewMenuItemView();




var $cnCXJ = parcelRequire("cnCXJ");


var $coRoT = parcelRequire("coRoT");
class $a8fc36c39779922a$var$NewOrderItemView extends (0, $081656bd50f85abd$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".modal-parent");
    _itemModal = document.querySelector(".item-modal-overlay");
    _itemModalCloseBtn = document.querySelector(".item-modal-close");
    _quantityBtn = document.querySelector(".quantity-buttons");
    _basket;
    _qty = 1;
    _variants;
    _addHandlerShowItemModal(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            e.preventDefault();
            // The stock-alert chip on a card opens its own popover, not the item.
            if (e.target.closest(".pos-stock-chip")) return;
            const item = e.target.closest(".pos-item-card");
            if (!item) return;
            item.classList.remove("pulse");
            item.offsetWidth;
            item.classList.add("pulse");
            handler(item.dataset.id);
            this._itemModal.classList.toggle("hidden");
        });
    }
    _itemModalContentUpdate(item) {
        this._adding = false; // fresh item modal - clear any stale add-in-progress flag
        const variantsSection = this._itemModal.querySelector(".variant-section");
        this._itemModal.querySelector(".title").textContent = item.itemName;
        this._itemModal.querySelector(".item-price").textContent = (0, $coRoT.formatMoney)(item.price);
        const imgEl = this._itemModal.querySelector(".item-image");
        if (imgEl) {
            imgEl.src = (0, $69bdae3851aa6802$export$56b52f8eeffda3e5)(item);
            imgEl.alt = item.itemName;
        }
        const itemVariants = item.hasVariants ? item.variants.map((variant)=>{
            const [...optionsArr] = variant.options;
            return `
          <div class="variant-set">
            <div class="pos-variant-label">${(0, $cnCXJ.esc)(variant.optionLabel)}</div>
            <div class="variant-options">
              ${optionsArr.map((option)=>`
                  <div class="variant-chip" data-value="${(0, $cnCXJ.esc)(option.optionName)}" data-price="${(0, $cnCXJ.esc)(option.optionPrice)}">
                    ${option.optionName !== "" ? (0, $cnCXJ.esc)(option.optionName) : `Unnamed option`}
                    <span>${option.optionPrice === "0" ? "" : `+${(0, $coRoT.formatMoney)(option.optionPrice)}`}</span>
                  </div>
                  `).join("")}
            </div>
          </div>
        `;
        }).join("") : ``;
        variantsSection.innerHTML = "";
        variantsSection.insertAdjacentHTML("afterbegin", itemVariants);
        this._selectMultipleVariantListener();
        this._basket = {
            itemName: item.itemName,
            price: item.price,
            imageURL: (0, $69bdae3851aa6802$export$56b52f8eeffda3e5)(item),
            selectedVariants: [],
            variantsTotalPrice: "",
            category: item.category,
            id: item._id,
            lineId: null,
            date: Date.now(),
            quantity: "",
            totalPrice: "",
            customerPayment: "",
            customerChange: ""
        };
    }
    _closeItemModal() {
        this._itemModalCloseBtn.addEventListener("click", function(e) {
            const overlay = document.querySelector(".item-modal-overlay");
            const inner = overlay.querySelector(".modal-content");
            if (inner) inner.classList.add("modal-exiting");
            setTimeout(()=>{
                if (inner) inner.classList.remove("modal-exiting");
                overlay.classList.add("hidden");
            }, 220);
        });
    }
    _pushToCart(handler) {
        this._itemModal.addEventListener("click", (e)=>{
            e.preventDefault();
            const btn = e.target.closest("#btn-add-to-cart");
            if (!btn) return;
            // The modal stays open for a 220ms close animation after a click. Ignore
            // any extra clicks during that window so a double-click can't add the item
            // twice. (withSubmitGuard can't help here - the add is synchronous and
            // in-memory, so its flag clears before a second physical click lands.)
            if (this._adding) return;
            this._adding = true;
            this._findSelectedVariants();
            handler();
            const overlay = document.querySelector(".item-modal-overlay");
            const inner = overlay.querySelector(".modal-content");
            if (inner) inner.classList.add("modal-exiting");
            setTimeout(()=>{
                if (inner) inner.classList.remove("modal-exiting");
                overlay.classList.add("hidden");
                this._qty = 1;
                document.getElementById("item-qty").textContent = this._qty;
                this._adding = false;
            }, 220);
        });
    }
    _adjustQuantity() {
        this._quantityBtn.addEventListener("click", (e)=>{
            const btn = e.target.closest(".qty-btn");
            if (!btn) return;
            if (btn.dataset.action === "increase") {
                this._qty++;
                document.getElementById("item-qty").textContent = this._qty;
            }
            if (btn.dataset.action === "decrease") {
                this._qty >= 2 ? this._qty-- : this._qty = 1;
                document.getElementById("item-qty").textContent = this._qty;
            }
        });
    }
    _selectMultipleVariantListener() {
        document.querySelector(".variant-section").addEventListener("click", (e)=>{
            e.preventDefault();
            const chip = e.target.closest(".variant-chip");
            if (!chip) return;
            chip.classList.toggle("selected");
            e.stopImmediatePropagation();
        });
    }
    _selectSingleVariantListener() {
        document.querySelectorAll(".variant-set").forEach((set)=>{
            set.addEventListener("click", function(e) {
                const chip = e.target.closest(".variant-chip");
                if (!chip) return;
                const currentlySelected = set.querySelector(".variant-chip.selected");
                if (currentlySelected && currentlySelected !== chip) currentlySelected.classList.remove("selected");
                chip.classList.toggle("selected");
            });
        });
    }
    _findSelectedVariants() {
        this._variants = Array.from(document.querySelector(".variant-section").querySelectorAll(".variant-chip.selected")).map((el)=>{
            return {
                variantName: el.dataset.value,
                variantPrice: el.dataset.price
            };
        });
    }
}
var $a8fc36c39779922a$export$2e2bcd8739ae039 = new $a8fc36c39779922a$var$NewOrderItemView();




var $cggJi = parcelRequire("cggJi");

var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");


var $dv0h8 = parcelRequire("dv0h8");

var $abGsl = parcelRequire("abGsl");
class $6724f76d0010cf48$var$OrderCheckOutView extends (0, $081656bd50f85abd$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".modal-parent");
    _subtotal;
    _adjResult;
    _totalPrice;
    _canUseLoyalty = false;
    _customerPayment;
    _customerChange;
    _orderType = 'dine-in';
    _paymentMethod = 'cash';
    // Tables (2026-10-22). _tables: [{ id, name }] for the "Which table?" picker
    // (shown when table service is on and the order is dine in); _table: the
    // pick ({ id, name } or { name } typed in, null = no table). _tabPay is set
    // when this checkout pays an open tab ({ tableName, split }).
    _tables = [];
    _table = null;
    _tabPay = null;
    // Tip for this checkout (reset by the controller on every new checkout).
    // { mode: 'none' | 'percent' | 'custom' | 'qr', percent?, amount? }
    _tip = {
        mode: 'none'
    };
    _tipAsking = false;
    _tipCustomOpen = false;
    // Checkout layout "Option A" (2026-10-15): Discount / Loyalty / Tip live in a
    // tabbed card under the order summary so the payment column never scrolls.
    // Reset to 'promo' by the controller on every new checkout.
    _extrasTab = 'promo';
    _promoCode = null;
    _loyalty = null;
    // ── Tip ───────────────────────────────────────────────────────────────────────
    tipAmount() {
        return (0, $abGsl.tipAmountFor)(this._tip, this._totalPrice);
    }
    // What the customer actually pays: the sale total plus the tip. The sale
    // total itself (_totalPrice) never includes the tip.
    chargeTotal() {
        return (Number(this._totalPrice) || 0) + this.tipAmount();
    }
    _tipsOn() {
        return this._data?.settings?.tipsEnabled === true;
    }
    _tipSectionMarkup() {
        if (!this._tipsOn()) return '';
        const presets = this._data.settings.tipPresets ?? [];
        const tip = this._tip;
        const amount = this.tipAmount();
        const off = this._tipAsking ? ' disabled' : '';
        const opt = (active, attrs, main, sub = '')=>`
      <button type="button" class="co-tip-opt${active ? ' co-tip-opt--active' : ''}" ${attrs}${off}>
        <span class="co-tip-opt-main">${main}</span>${sub ? `<span class="co-tip-opt-sub">${sub}</span>` : ''}
      </button>`;
        // The percentages are the tiles; No tip + Custom sit underneath as one slim
        // two-part switch (Kelly's pick, "D3", 2026-10-15). No tip is the default,
        // so it gets a quiet check rather than the solid green of a chosen tile.
        const options = presets.map((p)=>opt(tip.mode === 'percent' && Number(tip.percent) === Number(p) && !this._tipCustomOpen, `data-tip-mode="percent" data-tip-percent="${Number(p)}"`, `${Number(p)}%`, (0, $coRoT.formatMoney)((0, $abGsl.tipFromPercent)(this._totalPrice, p)))).join('');
        // While the custom field is open, Custom is the selection being made.
        const noOn = (tip.mode === 'none' || tip.mode === 'qr') && !this._tipCustomOpen;
        const cuOn = tip.mode === 'custom' || this._tipCustomOpen;
        const altRow = `
      <div class="co-tip-alt">
        <button type="button" class="co-tip-alt-btn${noOn ? ' co-tip-alt-btn--active' : ''}" data-tip-mode="none"${off}>
          ${noOn ? '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>' : ''}No tip
        </button>
        <button type="button" class="co-tip-alt-btn co-tip-alt-btn--custom${cuOn ? ' co-tip-alt-btn--active' : ''}" data-tip-mode="custom"${off}>
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>Custom${tip.mode === 'custom' ? ` <span class="co-tip-alt-amt">${(0, $coRoT.formatMoney)(amount)}</span>` : ''}
        </button>
      </div>`;
        const customRow = this._tipCustomOpen && !this._tipAsking ? `
      <div class="co-tip-custom">
        <div class="pos-amount-input">
          <span class="pos-amount-currency" aria-hidden="true">${(0, $coRoT.currencySymbol)()}</span>
          <input type="number" id="coTipCustomInput" min="0" step="0.01" placeholder="Tip amount"
            value="${tip.mode === 'custom' ? amount : ''}" />
        </div>
        <button type="button" class="btn primary" id="coTipCustomApply">Add tip</button>
      </div>` : '';
        const askRow = this._tipAsking ? `
      <div class="co-tip-waiting" role="status">
        <span class="co-tip-waiting-dot" aria-hidden="true"></span>
        <span class="co-tip-waiting-text">Waiting for the customer to choose on the display\u{2026}</span>
        <button type="button" class="co-tip-link" id="coTipCancelAsk">Pick here instead</button>
      </div>` : `
      <button type="button" class="co-tip-ask" id="coTipAskBtn">
        <span class="co-tip-ask-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="12" rx="2"/><path d="M8 20h8M12 16v4"/></svg></span>
        <span class="co-tip-ask-text">Let the customer choose on the display</span>
        <svg class="co-tip-ask-arrow" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>
      </button>`;
        const qrNote = tip.mode === 'qr' ? `<p class="co-tip-note">The customer tipped with your tip QR. Those tips go straight to your account, so they aren't recorded here.</p>` : '';
        // No header: the Tip tab above names the section and shows the amount.
        return `
      <div class="co-tip${this._tipAsking ? ' co-tip--asking' : ''}" id="coTipSection">
        ${presets.length ? `<div class="co-tip-options" style="--tip-presets:${presets.length}">${options}</div>` : ''}
        ${altRow}
        ${customRow}
        ${askRow}
        ${qrNote}
      </div>`;
    }
    // "Sale $11.00 + tip $1.65" under the total, only when there's a tip.
    _tipSplitText() {
        const amount = this.tipAmount();
        if (amount <= 0) return '';
        return `Sale ${(0, $coRoT.formatMoney)(this._totalPrice)} + tip ${(0, $coRoT.formatMoney)(amount)}`;
    }
    // Re-render the tip section + total after the tip (or the total) changed.
    // A changed amount voids any cash amount already entered, same as a total
    // change in _refreshAdjustments.
    refreshTip() {
        const section = this._parentElement.querySelector('#coTipSection');
        if (section) section.outerHTML = this._tipSectionMarkup();
        const totalEl = this._parentElement.querySelector('#cartTotal');
        if (totalEl) totalEl.textContent = (0, $coRoT.formatMoney)(this.chargeTotal());
        const barTotalEl = this._parentElement.querySelector('#coPaybarTotal');
        if (barTotalEl) barTotalEl.textContent = (0, $coRoT.formatMoney)(this.chargeTotal());
        const splitEl = this._parentElement.querySelector('#coTipSplit');
        if (splitEl) splitEl.textContent = this._tipSplitText();
        this._refreshExtrasBadges();
        this._resetPaymentAfterTotalChange();
        if (this._tipCustomOpen) this._parentElement.querySelector('#coTipCustomInput')?.focus();
    }
    setTip(tip) {
        this._tip = tip ?? {
            mode: 'none'
        };
        this.refreshTip();
    }
    setTipAsking(asking) {
        this._tipAsking = asking;
        if (asking) this._tipCustomOpen = false;
        this.refreshTip();
    }
    // Delegated (survives every re-render). onSelect(tip) for a cashier pick,
    // onAsk() / onCancelAsk() for the customer-display prompt.
    _addHandlerTip({ onSelect: onSelect, onAsk: onAsk, onCancelAsk: onCancelAsk }) {
        this._parentElement.addEventListener('click', (e)=>{
            if (e.target.closest('#coTipAskBtn')) {
                onAsk();
                return;
            }
            if (e.target.closest('#coTipCancelAsk')) {
                onCancelAsk();
                return;
            }
            if (e.target.closest('#coTipCustomApply')) {
                const v = parseFloat(this._parentElement.querySelector('#coTipCustomInput')?.value);
                if (isNaN(v) || v < 0) return;
                this._tipCustomOpen = false;
                onSelect(v > 0 ? {
                    mode: 'custom',
                    amount: v
                } : {
                    mode: 'none'
                });
                return;
            }
            const btn = e.target.closest('.co-tip-opt, .co-tip-alt-btn');
            if (!btn || btn.disabled) return;
            const mode = btn.dataset.tipMode;
            if (mode === 'custom') {
                this._tipCustomOpen = true;
                this.refreshTip();
                return;
            }
            this._tipCustomOpen = false;
            onSelect(mode === 'percent' ? {
                mode: 'percent',
                percent: Number(btn.dataset.tipPercent)
            } : {
                mode: 'none'
            });
        });
        this._parentElement.addEventListener('keydown', (e)=>{
            if (e.target.id !== 'coTipCustomInput') return;
            if ([
                '-',
                '+',
                'e',
                'E'
            ].includes(e.key)) e.preventDefault();
            if (e.key === 'Enter') {
                e.preventDefault();
                this._parentElement.querySelector('#coTipCustomApply')?.click();
            }
        });
    }
    // ── Cart items markup ─────────────────────────────────────────────────────────
    _generateCartItemsMarkup(cart, loyaltyCtx = null) {
        return cart.map((item, index)=>{
            const allVariants = item.selectedVariants.map((v)=>v.variantName);
            // Receipt-card row (2026-10-03): quantity badge first, name with its
            // options underneath, then price and the remove button side by side
            // so "remove" sits right next to what it removes.
            return `
          <div class="pos-cart-item cart-item-row co-line">
            <span class="co-line-qty">${item.quantity}\xd7</span>
            <div class="pos-cart-item-info">
              <span class="pos-cart-item-name">${(0, $cnCXJ.esc)(item.itemName)}</span>
              ${allVariants.length ? `<span class="pos-cart-item-variants">${(0, $cnCXJ.esc)(allVariants.join(" \xb7 "))}</span>` : ""}
              ${this._loyaltyRewardPillMarkup(item, loyaltyCtx)}
            </div>
            <div class="pos-cart-item-right">
              <span class="pos-cart-item-price">${(0, $coRoT.formatMoney)(item.totalPrice)}</span>
              <button class="checkout-cart-delete-btn pos-cart-delete" data-cart-index="${index}" type="button" aria-label="Remove ${(0, $cnCXJ.esc)(item.itemName)}" title="Remove">\xd7</button>
            </div>
          </div>`;
        }).join("");
    }
    // Read-only "this line is comped" badge. The actual redeem/remove action now
    // lives in the Redeem modal (loyaltyCtx still gates on canRedeem/customer so
    // the badge never renders for a program-off/no-permission/unlinked cart).
    _loyaltyRewardPillMarkup(item, loyaltyCtx) {
        if (!loyaltyCtx || !loyaltyCtx.canRedeem || !loyaltyCtx.customer) return "";
        if (!loyaltyCtx.redeemedLineIds.has(item.lineId)) return "";
        return `
      <span class="loyalty-reward-pill loyalty-reward-pill--applied">
        <span class="loyalty-reward-pill-text">\u{1F381} Free</span>
      </span>`;
    }
    // Receipt card header/footer: "N items" (by quantity) + items subtotal.
    _cartSummaryMeta(cart) {
        const count = cart.reduce((n, item)=>n + (Number(item.quantity) || 0), 0);
        const subtotal = cart.reduce((sum, item)=>sum + (Number(item.totalPrice) || 0), 0);
        return {
            countText: `${count} item${count === 1 ? "" : "s"}`,
            subtotalText: (0, $coRoT.formatMoney)(subtotal)
        };
    }
    _refreshCartItems(cart, loyaltyCtx = null) {
        const el = this._parentElement.querySelector("#cartItems");
        if (el) el.innerHTML = this._generateCartItemsMarkup(cart, loyaltyCtx);
        const { countText: countText, subtotalText: subtotalText } = this._cartSummaryMeta(cart);
        const countEl = this._parentElement.querySelector("#coReceiptCount");
        if (countEl) countEl.textContent = countText;
        const subEl = this._parentElement.querySelector("#coReceiptSubtotal");
        if (subEl) subEl.textContent = subtotalText;
        const headSubEl = this._parentElement.querySelector("#coReceiptHeadSub");
        if (headSubEl) headSubEl.textContent = subtotalText;
    }
    // ── Promo code section ────────────────────────────────────────────────────────
    _generatePromoSection(promoCode, adjResult) {
        if (promoCode) {
            const promoLine = adjResult.lineItems.find((li)=>li.source === "promo-code");
            const amtText = promoLine ? `\u{2212}${(0, $coRoT.formatMoney)(Math.abs(promoLine.computedAmount))}` : promoCode.type === "percentage" ? `${promoCode.value}% off` : `${(0, $coRoT.formatMoney)(promoCode.value)} off`;
            return `
        <div class="promo-code-section promo-code-section--applied">
          <div class="promo-applied-info">
            <span class="promo-code-badge-sm">${(0, $cnCXJ.esc)(promoCode.code)}</span>
            <span class="promo-applied-name">${(0, $cnCXJ.esc)(promoCode.title)}</span>
            <span class="promo-applied-amount">${amtText}</span>
          </div>
          <button type="button" class="promo-remove-btn" id="removePromoBtn">Remove</button>
        </div>
      `;
        }
        return `
      <div class="promo-code-section">
        <div class="promo-input-row">
          <input type="text" id="promoCodeInput" placeholder="Enter promo code"
            autocomplete="off" spellcheck="false" style="text-transform:uppercase;" />
          <button type="button" id="applyPromoBtn">Apply</button>
        </div>
      </div>
    `;
    }
    // ── Loyalty section ───────────────────────────────────────────────────────────
    // Renders below the promo section inside #receiptAdjSection, so every
    // _refreshAdjustments re-render keeps it in sync with the current total.
    // loyalty = { customer, redemption, rewardRedemptions } from model state
    // (threaded by the controller like promoCode). Nothing renders when the
    // program is off. Once a customer is linked, this is just a summary +
    // a "Redeem" button - the actual redeem/remove flow lives in the modal
    // (showRedeemModal) so both redemption types are managed in one place.
    _generateLoyaltySection(loyalty, adjResult) {
        const settings = this._data?.settings ?? {};
        if (!settings.loyaltyEnabled || !this._canUseLoyalty) return "";
        const customer = loyalty?.customer ?? null;
        const redemption = loyalty?.redemption ?? null;
        const rewardRedemptions = loyalty?.rewardRedemptions ?? [];
        if (!customer) return `
        <div class="loyalty-section" id="loyaltySection">
          <div class="pos-section-head"><span class="pos-section-emoji" aria-hidden="true">\u{2B50}</span>Loyalty</div>
          <div class="loyalty-input-row">
            <input type="tel" id="loyaltyPhoneInput" placeholder="Customer phone (optional)"
              autocomplete="off" inputmode="numeric" maxlength="15" />
            <button type="button" id="loyaltyLookupBtn">Find</button>
          </div>
        </div>
      `;
        // The compact checkout badge shows the DAILY streak (the panel detail
        // shows daily, weekly, and monthly side by side).
        const streak = (0, $dv0h8.computeStreak)(customer.saleDates ?? [], "day", this._data?.businessTimezone ?? undefined);
        const streakBadge = streak.current > 1 ? `<span class="loyalty-streak-badge" title="Purchase streak">\u{1F525} ${streak.current}-day streak</span>` : "";
        const appliedRows = [
            redemption ? `<div class="loyalty-applied-row">
             <span class="loyalty-applied-text">\u{1F4B5} ${redemption.points} pts \xb7 \u{2212}${(0, $coRoT.formatMoney)(redemption.value)}</span>
             <button type="button" class="loyalty-applied-remove loyalty-remove-redeem-btn" aria-label="Remove points discount">\xd7</button>
           </div>` : "",
            ...rewardRedemptions.map((r)=>`
           <div class="loyalty-applied-row">
             <span class="loyalty-applied-text">\u{1F381} ${(0, $cnCXJ.esc)(r.name)}</span>
             <button type="button" class="loyalty-applied-remove loyalty-reward-remove-btn" data-cart-line-id="${(0, $cnCXJ.esc)(r.cartItemLineId)}" aria-label="Remove free item redemption">\xd7</button>
           </div>`)
        ].filter(Boolean).join("");
        return `
      <div class="loyalty-section loyalty-section--linked" id="loyaltySection">
        <div class="pos-section-head"><span class="pos-section-emoji" aria-hidden="true">\u{2B50}</span>Loyalty</div>
        <div class="loyalty-customer-chip">
          <div class="loyalty-customer-info">
            <span class="loyalty-customer-name">${(0, $cnCXJ.esc)(customer.name || (0, $dv0h8.formatPhone)(customer.phone))}</span>
            <span class="loyalty-customer-meta">${customer.pointsBalance} pts${streakBadge ? " \xb7 " : ""}${streakBadge}</span>
          </div>
          <button type="button" class="promo-remove-btn" id="loyaltyUnlinkBtn" title="Remove customer from this sale">\xd7</button>
        </div>
        ${appliedRows ? `<div class="loyalty-applied-list">${appliedRows}</div>` : ""}
        <button type="button" class="loyalty-redeem-open-btn" id="loyaltyRedeemOpenBtn">
          \u{1F381} Redeem Rewards
        </button>
      </div>
    `;
    }
    // ── Redeem modal (checkout) ──────────────────────────────────────────────────
    // Single place to see the linked customer's points/birthday/streak and
    // manage BOTH redemption types (free item + points-off); they stack, so
    // both sections are always shown together rather than picking one.
    _redeemModal = document.querySelector("#loyaltyRedeemModal");
    isRedeemModalOpen() {
        return !this._redeemModal.classList.contains("hidden");
    }
    closeRedeemModal() {
        this._redeemModal.classList.add("hidden");
    }
    // payload = { customer, streak (daily), rewards, redemptionByRewardId,
    //   reservedPoints, redeemPoints, redeemValue, redemption, finalTotal, tz }
    showRedeemModal(payload) {
        const { customer: customer, streak: streak, rewards: rewards, redemptionByRewardId: redemptionByRewardId, reservedPoints: reservedPoints, redeemPoints: redeemPoints, redeemValue: redeemValue, redemption: redemption, finalTotal: finalTotal, tz: tz } = payload;
        const birthday = (0, $dv0h8.formatBirthday)(customer.birthdayMonth, customer.birthdayDay);
        const birthdayToday = (0, $dv0h8.isBirthdayToday)(customer.birthdayMonth, customer.birthdayDay, tz);
        const statChips = [
            `<div class="loyalty-redeem-stat"><span class="loyalty-redeem-stat-value">${customer.pointsBalance}</span><span class="loyalty-redeem-stat-label">Points</span></div>`,
            birthday ? `<div class="loyalty-redeem-stat"><span class="loyalty-redeem-stat-value">\u{1F382} ${(0, $cnCXJ.esc)(birthday)}</span><span class="loyalty-redeem-stat-label">Birthday</span></div>` : "",
            streak.current > 1 ? `<div class="loyalty-redeem-stat"><span class="loyalty-redeem-stat-value">\u{1F525} ${streak.current}</span><span class="loyalty-redeem-stat-label">Day streak</span></div>` : ""
        ].filter(Boolean).join("");
        // Shows the WHOLE reward catalog (not just items already in the cart) -
        // redeeming adds the item free rather than requiring it be rung up
        // first. Rows the customer can't afford yet are greyed out, not hidden.
        const itemRowsHtml = rewards.length ? rewards.map((r)=>{
            const redeemedLineId = redemptionByRewardId.get(r.id);
            const applied = Boolean(redeemedLineId);
            const affordable = r.pointsCost <= customer.pointsBalance - reservedPoints;
            const actionHtml = applied ? `<button type="button" class="loyalty-reward-remove-btn" data-cart-line-id="${(0, $cnCXJ.esc)(redeemedLineId)}">Remove</button>` : affordable ? `<button type="button" class="loyalty-reward-redeem-btn" data-reward-id="${(0, $cnCXJ.esc)(r.id)}">Redeem (${r.pointsCost} pts)</button>` : `<span class="loyalty-redeem-item-locked">${r.pointsCost} pts needed</span>`;
            return `
            <div class="loyalty-redeem-item-row${!applied && !affordable ? " loyalty-redeem-item-row--locked" : ""}">
              <span class="loyalty-redeem-item-name">${(0, $cnCXJ.esc)(r.itemName)}${applied ? ' <em class="loyalty-redeem-item-tag">\uD83C\uDF81 Free</em>' : ""}</span>
              ${actionHtml}
            </div>`;
        }).join("") : `<p class="loyalty-redeem-empty">No rewards configured yet.</p>`;
        let pointsOffHtml;
        if (redemption) pointsOffHtml = `
        <div class="loyalty-redeem-item-row">
          <span class="loyalty-redeem-item-name">Redeeming ${redemption.points} pts \xb7 \u{2212}${(0, $coRoT.formatMoney)(redemption.value)}</span>
          <button type="button" class="btn loyalty-remove-redeem-btn">Remove</button>
        </div>`;
        else {
            const maxByBalance = Math.floor((customer.pointsBalance - reservedPoints) / redeemPoints);
            const maxByTotal = Math.ceil(finalTotal / redeemValue);
            const max = Math.min(maxByBalance, maxByTotal);
            if (max >= 1) pointsOffHtml = `
          <div class="loyalty-points-off-card" data-redeem-points="${redeemPoints}" data-redeem-value="${redeemValue}">
            <div class="loyalty-points-off-preview" id="loyaltyRedeemPreview">
              <span class="loyalty-points-off-pts">${redeemPoints} pts</span>
              <span class="loyalty-points-off-arrow">\u{2192}</span>
              <span class="loyalty-points-off-value">\u{2212}${(0, $coRoT.formatMoney)(redeemValue)}</span>
            </div>
            <div class="loyalty-points-off-controls">
              <div class="loyalty-stepper" data-max="${max}">
                <button type="button" class="loyalty-step-btn" id="loyaltyRedeemMinus" aria-label="Less">\u{2212}</button>
                <span class="loyalty-step-count" id="loyaltyRedeemCount">1</span>
                <button type="button" class="loyalty-step-btn" id="loyaltyRedeemPlus" aria-label="More">+</button>
              </div>
              <button type="button" class="btn primary" id="loyaltyApplyRedeemBtn">Redeem</button>
            </div>
          </div>`;
            else if (maxByBalance < 1) {
                const short = redeemPoints - (customer.pointsBalance - reservedPoints);
                pointsOffHtml = `<p class="loyalty-redeem-hint">${short} more point${short === 1 ? "" : "s"} to unlock ${(0, $coRoT.formatMoney)(redeemValue)} off</p>`;
            } else pointsOffHtml = `<p class="loyalty-redeem-hint">Total is too small to redeem ${redeemPoints} pts (${(0, $coRoT.formatMoney)(redeemValue)} off)</p>`;
        }
        this._redeemModal.querySelector("#loyaltyRedeemBody").innerHTML = `
      <button class="modal-close-btn" id="loyaltyRedeemCloseBtn" type="button">&times;</button>
      <div class="loyalty-redeem-head">
        <span class="loyalty-row-avatar loyalty-redeem-avatar" aria-hidden="true">${(0, $cnCXJ.esc)((customer.name || customer.phone).charAt(0).toUpperCase())}</span>
        <div class="loyalty-redeem-titles">
          <h2 class="edit-form-title">${(0, $cnCXJ.esc)(customer.name || (0, $dv0h8.formatPhone)(customer.phone))}</h2>
          <p class="loyalty-detail-sub">${(0, $cnCXJ.esc)((0, $dv0h8.formatPhone)(customer.phone))}</p>
        </div>
      </div>
      ${birthdayToday ? `<div class="loyalty-birthday-banner">\u{1F389} It's their birthday today!</div>` : ""}
      <div class="loyalty-redeem-stats">${statChips}</div>
      <p class="loyalty-program-section-label">Free Item</p>
      <div class="loyalty-redeem-item-list">${itemRowsHtml}</div>
      <p class="loyalty-program-section-label">Points Off</p>
      ${pointsOffHtml}
      <div class="loyalty-redeem-footer">
        <button type="button" class="btn" id="loyaltyRedeemDoneBtn">Done</button>
      </div>
    `;
        this._redeemModal.classList.remove("hidden");
        this._redeemModal.querySelector("#loyaltyRedeemCloseBtn").addEventListener("click", ()=>this.closeRedeemModal());
        this._redeemModal.querySelector("#loyaltyRedeemDoneBtn").addEventListener("click", ()=>this.closeRedeemModal());
    }
    // Swap the idle loyalty section into the inline enroll form after a lookup
    // miss. View-transient state: a later full refresh returns to idle, which is
    // fine (enrolling is a one-shot moment).
    showLoyaltyEnroll(phone) {
        const section = this._parentElement.querySelector("#loyaltySection");
        if (!section) return;
        section.innerHTML = `
      <div class="pos-section-head"><span class="pos-section-emoji" aria-hidden="true">\u{2B50}</span>Loyalty</div>
      <p class="loyalty-enroll-note">New customer \xb7 joins the rewards program</p>
      <div class="loyalty-input-row">
        <input type="tel" id="loyaltyEnrollPhone" value="${(0, $cnCXJ.esc)(phone)}" readonly />
      </div>
      <div class="loyalty-input-row">
        <input type="text" id="loyaltyEnrollName" placeholder="Name (optional)" autocomplete="off" />
        <button type="button" id="loyaltyEnrollBtn">Enroll</button>
        <button type="button" class="loyalty-cancel-btn" id="loyaltyEnrollCancelBtn">Cancel</button>
      </div>
    `;
        section.querySelector("#loyaltyEnrollName")?.focus();
    }
    // ── Adj section markup (reused by both initial render and in-place refresh) ──
    // Right-column bill (#receiptAdjSection): subtotal, then every line that
    // moves the total. Fees/taxes/manual adjustments keep their Edit / × controls
    // here; the promo and points-discount lines are read-only (they're added and
    // removed in the Discount / Loyalty tabs). Free-item reward redemptions still
    // render as a pill on their own cart line.
    _generateBillMarkup(subtotal, allAdj, adjResult, showRemoved) {
        const activeLines = adjResult.lineItems;
        const removedLines = allAdj.filter((a)=>a.removed);
        const nonPromoLines = activeLines.filter((li)=>li.source !== "promo-code" && li.source !== "loyalty" && li.source !== "loyalty_reward");
        const discountLines = activeLines.filter((li)=>li.source === "promo-code" || li.source === "loyalty");
        const discountHtml = discountLines.map((li)=>`
        <div class="receipt-adj-item receipt-adj-item--readonly">
          <div class="receipt-adj-info">
            <span>${(0, $cnCXJ.esc)(li.name)}</span>
            <span class="receipt-adj-amount ${li.type}">
              ${li.computedAmount >= 0 ? "+" : "-"}${(0, $coRoT.formatMoney)(Math.abs(li.computedAmount))}
            </span>
          </div>
        </div>
      `).join("");
        const activeHtml = nonPromoLines.map((adj)=>`
        <div class="receipt-adj-item" data-adj-id="${adj.id}">
          <div class="receipt-adj-info">
            <span>${(0, $cnCXJ.esc)(adj.name)}${adj.calculation === "percentage" ? ` (${adj.appliedValue}%)` : ""}</span>
            <span class="receipt-adj-amount ${adj.type}">
              ${adj.computedAmount >= 0 ? "+" : "-"}${(0, $coRoT.formatMoney)(Math.abs(adj.computedAmount))}
            </span>
          </div>
          ${adj.source === 'tax' ? '' : `<div class="receipt-adj-controls">
            ${adj.source === 'manual' ? `<button class="receipt-adj-edit-btn" data-adj-id="${adj.id}" type="button">Edit</button>` : ''}
            <button class="receipt-adj-remove-btn" data-adj-id="${adj.id}" type="button">&times;</button>
          </div>`}
        </div>
      `).join("");
        const removedHtml = showRemoved ? removedLines.map((adj)=>`
          <div class="receipt-adj-item receipt-adj-item--removed">
            <div class="receipt-adj-info">
              <span>${(0, $cnCXJ.esc)(adj.name)}${adj.calculation === "percentage" ? ` (${adj.appliedValue}%)` : ""} <em>(removed)</em></span>
              <span>${(0, $coRoT.formatMoney)(0)}</span>
            </div>
          </div>
        `).join("") : "";
        const lines = discountHtml + activeHtml + removedHtml;
        // "Add adjustment" lives with the bill it changes (Kelly, 2026-10-15), as a
        // compact link so the laptop column still fits without scrolling.
        const addBtn = `
      <button class="receipt-add-adj-btn co-bill-add" type="button" title="Apply a tax, fee, or discount to this receipt">
        <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>Add adjustment
      </button>`;
        if (!lines) return addBtn;
        return `
      <div class="cart-subtotal">
        <span>Subtotal</span>
        <span>${(0, $coRoT.formatMoney)(subtotal)}</span>
      </div>
      <div class="receipt-adj-list">${lines}</div>
      ${addBtn}
    `;
    }
    // Discount tab: the promo code field. ("Add adjustment" sits with the bill.)
    _generateDiscountPaneMarkup(promoCode, adjResult) {
        return this._generatePromoSection(promoCode, adjResult);
    }
    // ── Extras card (Discount / Loyalty / Tip tabs, under the order summary) ─────
    _extrasTabs() {
        const tabs = [
            {
                key: "promo",
                emoji: "\uD83C\uDFF7\uFE0F",
                label: "Discount"
            }
        ];
        if (this._data?.settings?.loyaltyEnabled && this._canUseLoyalty) tabs.push({
            key: "loyalty",
            emoji: "\u2B50",
            label: "Loyalty"
        });
        if (this._tipsOn()) tabs.push({
            key: "tip",
            emoji: "\uD83D\uDC9D",
            label: "Tip"
        });
        return tabs;
    }
    // What each tab has applied, shown on the tab so nothing hides behind it.
    _extrasBadge(key) {
        if (key === "promo") {
            const line = (this._adjResult?.lineItems ?? []).find((li)=>li.source === "promo-code");
            return line ? `\u{2212}${(0, $coRoT.formatMoney)(Math.abs(line.computedAmount))}` : this._promoCode ? (0, $cnCXJ.esc)(this._promoCode.code) : "";
        }
        if (key === "loyalty") {
            const c = this._loyalty?.customer;
            if (!c) return "";
            return (0, $cnCXJ.esc)((c.name || "").trim().split(/\s+/)[0] || (0, $dv0h8.formatPhone)(c.phone));
        }
        if (key === "tip") {
            const amount = this.tipAmount();
            return amount > 0 ? `+${(0, $coRoT.formatMoney)(amount)}` : "";
        }
        return "";
    }
    _generateExtrasMarkup(adjResult) {
        const tabs = this._extrasTabs();
        if (!tabs.some((t)=>t.key === this._extrasTab)) this._extrasTab = "promo";
        const active = this._extrasTab;
        const tabHtml = tabs.map((t)=>{
            const badge = this._extrasBadge(t.key);
            return `
        <button type="button" class="co-extras-tab${t.key === active ? " co-extras-tab--active" : ""}" role="tab"
          id="coExtrasTab-${t.key}" data-extras-tab="${t.key}" aria-selected="${t.key === active}" aria-controls="coExtrasPane-${t.key}">
          <span class="co-extras-tab-name"><span class="pos-section-emoji" aria-hidden="true">${t.emoji}</span>${t.label}</span>
          <span class="co-extras-badge" id="coExtrasBadge-${t.key}"${badge ? "" : " hidden"}>${badge}</span>
        </button>`;
        }).join("");
        const pane = (key, inner)=>`
      <div class="co-extras-pane" id="coExtrasPane-${key}" role="tabpanel" aria-labelledby="coExtrasTab-${key}"${key === active ? "" : " hidden"}>${inner}</div>`;
        return `
      <div class="co-extras" id="coExtras">
        <div class="co-extras-tabs" role="tablist" aria-label="Discount, loyalty and tip">${tabHtml}</div>
        ${pane("promo", `<div id="coPromoPane">${this._generateDiscountPaneMarkup(this._promoCode, adjResult)}</div>`)}
        ${tabs.some((t)=>t.key === "loyalty") ? pane("loyalty", `<div id="coLoyaltyPane">${this._generateLoyaltySection(this._loyalty, adjResult)}</div>`) : ""}
        ${tabs.some((t)=>t.key === "tip") ? pane("tip", this._tipSectionMarkup()) : ""}
      </div>`;
    }
    _refreshExtrasBadges() {
        for (const t of this._extrasTabs()){
            const el = this._parentElement.querySelector(`#coExtrasBadge-${t.key}`);
            if (!el) continue;
            const badge = this._extrasBadge(t.key);
            el.innerHTML = badge;
            el.hidden = !badge;
        }
    }
    // Switch tabs in place (no re-render - that would reset an entered cash amount).
    _selectExtrasTab(key) {
        this._extrasTab = key;
        this._parentElement.querySelectorAll(".co-extras-tab").forEach((b)=>{
            const on = b.dataset.extrasTab === key;
            b.classList.toggle("co-extras-tab--active", on);
            b.setAttribute("aria-selected", String(on));
        });
        this._parentElement.querySelectorAll(".co-extras-pane").forEach((p)=>{
            p.hidden = p.id !== `coExtrasPane-${key}`;
        });
    }
    // ── Table picker ──────────────────────────────────────────────────────────────
    _tablePickerShown() {
        if (this._tabPay || (this._data?.settings?.tableService ?? 'off') === 'off') return false;
        return !this._data.settings.orderTypeEnabled || this._orderType === 'dine-in';
    }
    _tablePickerMarkup() {
        if (this._tabPay || (this._data?.settings?.tableService ?? 'off') === 'off') return '';
        const picked = this._table;
        const chips = this._tables.map((t)=>{
            const on = picked?.id === t.id;
            return `<button type="button" class="co-table-chip${on ? ' co-table-chip--on' : ''}${t.busy ? ' co-table-chip--busy' : ''}" data-table-id="${t.id}" aria-pressed="${on}">${(0, $cnCXJ.esc)(t.name)}</button>`;
        }).join('');
        const typed = picked && !picked.id ? picked.name : '';
        return `
      <div class="co-table${this._tablePickerShown() ? '' : ' hidden'}" id="coTablePicker">
        <div class="co-table-head"><span class="co-table-title">Which table?</span><span class="co-table-hint">So staff can bring it over</span></div>
        ${chips ? `<div class="co-table-chips" role="group" aria-label="Table">${chips}</div>` : ''}
        <div class="co-table-row">
          <input type="text" class="co-table-input" id="coTableInput" maxlength="12" placeholder="${chips ? 'Or type a table / tent #' : 'Table or tent #'}" value="${(0, $cnCXJ.esc)(typed)}" aria-label="Table or tent number" />
          <button type="button" class="co-table-skip${picked ? '' : ' co-table-skip--on'}" data-table-skip="1">No table</button>
        </div>
      </div>`;
    }
    _syncTablePicker() {
        const box = this._parentElement.querySelector('#coTablePicker');
        if (!box) return;
        box.classList.toggle('hidden', !this._tablePickerShown());
        box.querySelectorAll('.co-table-chip').forEach((b)=>{
            const on = this._table?.id === b.dataset.tableId;
            b.classList.toggle('co-table-chip--on', on);
            b.setAttribute('aria-pressed', String(on));
        });
        box.querySelector('.co-table-skip')?.classList.toggle('co-table-skip--on', !this._table);
    }
    // The table this sale goes to, or null (none picked, takeout, or no tables).
    pickedTable() {
        return this._tablePickerShown() ? this._table : null;
    }
    _wireTablePicker() {
        this._parentElement.addEventListener('click', (e)=>{
            const chip = e.target.closest('.co-table-chip');
            if (chip) {
                const t = this._tables.find((x)=>x.id === chip.dataset.tableId);
                this._table = this._table?.id === t?.id ? null : t ? {
                    id: t.id,
                    name: t.name
                } : null;
                const input = this._parentElement.querySelector('#coTableInput');
                if (input) input.value = '';
                this._syncTablePicker();
                return;
            }
            if (e.target.closest('[data-table-skip]')) {
                this._table = null;
                const input = this._parentElement.querySelector('#coTableInput');
                if (input) input.value = '';
                this._syncTablePicker();
            }
        });
        this._parentElement.addEventListener('input', (e)=>{
            if (e.target.id !== 'coTableInput') return;
            const v = e.target.value.trim();
            this._table = v ? {
                name: v
            } : null;
            this._syncTablePicker();
        });
    }
    // ── Main markup ───────────────────────────────────────────────────────────────
    _generateMarkUp() {
        const allAdj = this._data.currentReceiptAdjustments ?? [];
        const adjResult = this._adjResult ?? {
            lineItems: [],
            finalTotal: this._totalPrice
        };
        const showRemoved = this._data.settings?.showRemovedAdjustments ?? true;
        const subtotal = this._subtotal ?? this._totalPrice;
        const printingOn = this._data.settings?.printingEnabled ?? true;
        return `
<div class="pos-screen" id="newOrderModal">
  <div class="pos-header">
    <button class="checkout-back-btn pos-back-btn" type="button" title="Back to order">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6"/>
      </svg>
      Back
    </button>
    <h2 class="pos-title">Checkout</h2>
    <button class="modal-close pos-close-btn" aria-label="Close">&times;</button>
  </div>

  <div class="pos-checkout-body">
    <div class="pos-checkout-cart">
      <div class="co-receipt" id="coReceipt">
        <div class="co-receipt-head" id="coReceiptHead">
          <h3 class="pos-checkout-section-title">Order Summary</h3>
          <span class="co-receipt-count" id="coReceiptCount">${this._cartSummaryMeta(this._data.cart).countText}</span>
          <!-- Phone only: the summary folds to this one line; tap to show the items. -->
          <b class="co-receipt-head-sub" id="coReceiptHeadSub">${this._cartSummaryMeta(this._data.cart).subtotalText}</b>
          <button type="button" class="co-receipt-toggle" id="coReceiptToggle" aria-expanded="false" aria-controls="cartItems" aria-label="Show items">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
          </button>
        </div>
        <div id="cartItems" class="pos-checkout-cart-list">
          ${this._generateCartItemsMarkup(this._data.cart)}
        </div>
        <div class="co-receipt-foot">
          <span>Items subtotal</span>
          <b id="coReceiptSubtotal">${this._cartSummaryMeta(this._data.cart).subtotalText}</b>
        </div>
      </div>
      ${this._generateExtrasMarkup(adjResult)}
    </div>

    <div class="pos-checkout-payment">
      ${this._tabPay ? `<div class="co-tab-pay"><span class="co-tab-pay-badge">${(0, $cnCXJ.esc)(this._tabPay.tableName ?? '')}</span><span>${this._tabPay.split ? 'Paying part of the tab' : 'Paying the tab'}</span></div>` : ''}
      ${!this._tabPay && this._data.settings.orderTypeEnabled ? `<div class="order-type-toggle">
        <button class="order-type-btn${this._orderType === 'dine-in' ? ' order-type-btn--active' : ''}" data-order-type="dine-in" type="button"><span class="pos-btn-emoji" aria-hidden="true">\u{1F37D}\u{FE0F}</span>Dine In</button>
        <button class="order-type-btn${this._orderType === 'takeout' ? ' order-type-btn--active' : ''}" data-order-type="takeout" type="button"><span class="pos-btn-emoji" aria-hidden="true">\u{1F961}</span>${(0, $cggJi.takeoutLabel)()}</button>
      </div>` : ''}
      ${this._tablePickerMarkup()}
      <div id="receiptAdjSection">
        ${this._generateBillMarkup(subtotal, allAdj, adjResult, showRemoved)}
      </div>

      <div class="cart-total pos-checkout-total">
        <span class="pos-total-label"><span class="pos-section-emoji" aria-hidden="true">\u{1F6D2}</span>Total</span>
        <span class="pos-total-amount" id="cartTotal">${(0, $coRoT.formatMoney)(this.chargeTotal())}</span>
      </div>
      <p class="co-tip-split" id="coTipSplit">${this._tipSplitText()}</p>
      <p class="pos-tax-incl-line" id="taxInclLine">${this._taxInclLineHtml()}</p>

      <div class="pos-pay-panel">
        <div class="pos-section-head"><span class="pos-section-emoji" aria-hidden="true">\u{1F4B3}</span>Payment Method</div>
        <div class="payment-method-toggle" id="paymentMethodToggle">
          <button class="payment-method-btn${this._paymentMethod === 'cash' ? ' payment-method-btn--active' : ''}" data-payment-method="cash" type="button"><span class="pos-btn-emoji" aria-hidden="true">\u{1F4B5}</span>Cash</button>
          <button class="payment-method-btn${this._paymentMethod === 'card' ? ' payment-method-btn--active' : ''}" data-payment-method="card" type="button"><span class="pos-btn-emoji" aria-hidden="true">\u{1F4B3}</span>Card</button>
          <button class="payment-method-btn${this._paymentMethod === 'qr' ? ' payment-method-btn--active' : ''}" data-payment-method="qr" type="button"><span class="pos-btn-emoji" aria-hidden="true">\u{1F4F1}</span>QR</button>
        </div>

        <div id="cashPaymentFields" class="pos-cash-fields${this._paymentMethod === 'cash' ? '' : ' hidden'}">
          <div class="receive-container">
            <label for="customerPayment">Amount Received</label>
            <div class="pos-payment-row">
              <div class="pos-amount-input">
                <span class="pos-amount-currency" aria-hidden="true">${(0, $coRoT.currencySymbol)()}</span>
                <input type="number" id="customerPayment" placeholder="Enter amount received" min="0" step="0.01" />
              </div>
              <button id="enterPaymentBtn">Enter</button>
            </div>
          </div>

          <div class="pos-change-row">
            <span class="pos-change-caption"><span class="pos-section-emoji" aria-hidden="true">\u{1F4B5}</span>Change Due</span>
            <div id="changeAmount" class="change-box">${(0, $coRoT.formatMoney)(0)}</div>
          </div>
        </div>

        <p class="payment-paid-note hidden" id="paidInFullNote">Marked as paid in full \xb7 no change due</p>
      </div>

      <p class="pos-tip${this._paymentMethod === 'card' ? ' hidden' : ''}" id="paymentTip"><span class="pos-tip-emoji" aria-hidden="true">\u{1F4A1}</span><span id="paymentTipText">${this._tipText(this._paymentMethod)}</span></p>

      <!-- On phones this bar pins to the bottom with the total, so the sale can
           always be finished without scrolling. On wider screens it's just the button. -->
      <div class="co-paybar">
        <div class="co-paybar-total"><span>Total</span><b id="coPaybarTotal">${(0, $coRoT.formatMoney)(this.chargeTotal())}</b></div>
        <button class="print-receipt-btn${printingOn ? '' : ' print-receipt-btn--off'} hidden" id="printReceiptBtn">
          ${printingOn ? 'Print Receipt' : 'Record Sale<span class="print-off-note">Printing is off \xb7 Enable in Settings</span>'}
        </button>
      </div>
    </div>
  </div>
</div>
    `;
    }
    // ── In-place refresh (does not reset the payment input) ───────────────────────
    _refreshAdjustments(subtotal, allAdj, adjResult, showRemoved, promoCode = null, loyalty = null) {
        this._subtotal = subtotal;
        this._adjResult = adjResult;
        this._totalPrice = adjResult.finalTotal;
        this._promoCode = promoCode;
        this._loyalty = loyalty;
        const section = this._parentElement.querySelector("#receiptAdjSection");
        if (section) section.innerHTML = this._generateBillMarkup(subtotal, allAdj, adjResult, showRemoved);
        const promoPane = this._parentElement.querySelector("#coPromoPane");
        if (promoPane) promoPane.innerHTML = this._generateDiscountPaneMarkup(promoCode, adjResult);
        const loyaltyPane = this._parentElement.querySelector("#coLoyaltyPane");
        if (loyaltyPane) loyaltyPane.innerHTML = this._generateLoyaltySection(loyalty, adjResult);
        const taxLineEl = this._parentElement.querySelector("#taxInclLine");
        if (taxLineEl) taxLineEl.innerHTML = this._taxInclLineHtml();
        // Total + a percentage tip follow the new sale total; resets payment.
        this.refreshTip();
    }
    // Total (or tip) changed — reset payment validation state
    _resetPaymentAfterTotalChange() {
        const changeBox = this._parentElement.querySelector("#changeAmount");
        if (changeBox) {
            changeBox.textContent = (0, $coRoT.formatMoney)(0);
            changeBox.classList.remove("ok", "change-box--error");
        }
        this._parentElement.querySelector(".print-receipt-btn")?.classList.add("hidden");
        this._customerChange = undefined;
        // Non-cash methods are paid-in-full at the new total, so re-stamp and
        // re-enable the record button (cash still requires a fresh amount entry).
        if (this._paymentMethod && this._paymentMethod !== "cash") this._applyPaymentMethodUI(this._paymentMethod);
    }
    // ── Inline forms ──────────────────────────────────────────────────────────────
    _showReceiptEditForm(adj) {
        this._removeReceiptForms();
        const item = this._parentElement.querySelector(`.receipt-adj-item[data-adj-id="${adj.id}"]`);
        if (!item) return;
        const html = `
      <div class="receipt-edit-form" id="receiptEditForm">
        <label class="adj-form-sublabel">
          New value (${adj.calculation === "percentage" ? "%" : (0, $coRoT.currencySymbol)()})
        </label>
        <input type="number" id="receiptEditValue" value="${adj.appliedValue}" min="0" step="0.01" />
        <div class="adj-form-actions" style="margin-top:6px;">
          <button class="btn" id="receiptEditCancelBtn" type="button">Cancel</button>
          <button class="btn primary" id="receiptEditSaveBtn" data-adj-id="${adj.id}" type="button">Save</button>
        </div>
      </div>
    `;
        item.insertAdjacentHTML("afterend", html);
        document.getElementById("receiptEditCancelBtn").addEventListener("click", ()=>this._removeReceiptForms());
        document.getElementById("receiptEditValue").focus();
    }
    _showReceiptAddManualForm() {
        this._removeReceiptForms();
        const modal = this._parentElement.querySelector(".pos-screen");
        if (!modal) return;
        const html = `
      <div class="receipt-manual-overlay" id="receiptManualForm">
      <div class="adj-form receipt-manual-card">
        <h4 class="adj-form-title">Add One-off Adjustment</h4>

        <div class="edit-field">
          <label for="receiptManualName">Name</label>
          <input type="text" id="receiptManualName" placeholder="e.g. Discount, Delivery fee" />
        </div>

        <p class="adj-form-sublabel">Type</p>
        <div class="adj-selector" id="receiptManualTypeSelector">
          <button type="button" class="adj-selector-btn active" data-value="fee">Fee</button>
          <button type="button" class="adj-selector-btn" data-value="discount">Discount</button>
        </div>
        <input type="hidden" id="receiptManualType" value="fee" />

        <p class="adj-form-sublabel">Calculation</p>
        <div class="adj-selector" id="receiptManualCalcSelector">
          <button type="button" class="adj-selector-btn active" data-value="fixed">Fixed ($)</button>
          <button type="button" class="adj-selector-btn" data-value="percentage">
            Percentage (%)
            <span class="pb-tip" tabindex="0" role="img" aria-label="More info" data-tip="% of the running subtotal at the time this adjustment is applied">i</span>
          </button>
        </div>
        <input type="hidden" id="receiptManualCalc" value="fixed" />

        <div class="edit-field">
          <label id="receiptManualValueLabel">Value ($)</label>
          <input type="number" id="receiptManualValue" min="0" step="0.01" placeholder="0" />
        </div>

        <div class="adj-form-actions">
          <button type="button" class="btn" id="receiptManualCancelBtn">Cancel</button>
          <button type="button" class="btn primary" id="receiptManualSaveBtn">Add</button>
        </div>
      </div>
      </div>
    `;
        modal.insertAdjacentHTML("beforeend", html);
        document.querySelectorAll("#receiptManualTypeSelector, #receiptManualCalcSelector").forEach((group)=>{
            group.addEventListener("click", (e)=>{
                const btn = e.target.closest(".adj-selector-btn");
                if (!btn) return;
                group.querySelectorAll(".adj-selector-btn").forEach((b)=>b.classList.remove("active"));
                btn.classList.add("active");
                if (group.id === "receiptManualCalcSelector") {
                    document.getElementById("receiptManualCalc").value = btn.dataset.value;
                    document.getElementById("receiptManualValueLabel").textContent = btn.dataset.value === "percentage" ? "Value (%)" : "Value ($)";
                } else document.getElementById("receiptManualType").value = btn.dataset.value;
            });
        });
        document.getElementById("receiptManualCancelBtn").addEventListener("click", ()=>this._removeReceiptForms());
        document.getElementById("receiptManualName").focus();
    }
    _removeReceiptForms() {
        document.getElementById("receiptEditForm")?.remove();
        document.getElementById("receiptManualForm")?.remove();
    }
    // ── Handlers ──────────────────────────────────────────────────────────────────
    // Discount / Loyalty / Tip tabs, and the phone-only fold on the order summary.
    // Both switch in place, so an amount already typed into the payment stays put.
    _wireExtras() {
        this._parentElement.addEventListener('click', (e)=>{
            const tab = e.target.closest('.co-extras-tab');
            if (tab) {
                this._selectExtrasTab(tab.dataset.extrasTab);
                return;
            }
            const head = e.target.closest('#coReceiptHead');
            if (!head || !window.matchMedia('(max-width: 768px)').matches) return;
            const receipt = this._parentElement.querySelector('#coReceipt');
            const open = !receipt.classList.contains('co-receipt--open');
            receipt.classList.toggle('co-receipt--open', open);
            const toggle = this._parentElement.querySelector('#coReceiptToggle');
            toggle?.setAttribute('aria-expanded', String(open));
            toggle?.setAttribute('aria-label', open ? 'Hide items' : 'Show items');
        });
    }
    _wireOrderType() {
        this._parentElement.addEventListener('click', (e)=>{
            const btn = e.target.closest('.order-type-btn');
            if (!btn) return;
            this._orderType = btn.dataset.orderType;
            this._parentElement.querySelectorAll('.order-type-btn').forEach((b)=>b.classList.toggle('order-type-btn--active', b === btn));
            this._syncTablePicker();
        });
        this._wireTablePicker();
    }
    // Small "Includes VAT (12%) $X" note under the total when the business runs
    // tax-inclusive pricing. Empty string (hidden via :empty) otherwise.
    //
    // Per-item exemption (2026-07-07): cart items aren't stamped with a tax class
    // yet (that happens at _buildSale, once the sale is recorded) - render(modelState)
    // already hands the WHOLE model state to this view as this._data, so
    // this._data.menuItems is available here without calling model.* directly
    // (views never call model functions - CLAUDE.md). The cart's taxable/exempt
    // RATIO is applied to this._totalPrice (which may include on-top adjustments)
    // so a cart with no exempt items produces the exact same output as before
    // (ratio = 1) - only a mixed cart's line actually changes.
    _taxInclLineHtml() {
        const s = this._data?.settings;
        if (!s?.taxInclusive) return '';
        const cart = this._data?.cart ?? [];
        const menuItems = this._data?.menuItems ?? [];
        const isExempt = (it)=>menuItems.find((m)=>m._id === it.id)?.taxClass === 'exempt';
        const { taxableGross: cartTaxable, exemptGross: cartExempt } = (0, $ff150a18d4a6f5bb$export$1a11748b971a7a75)(cart, isExempt);
        const cartTotal = cartTaxable + cartExempt;
        if (cartTotal <= 0) return '';
        const ratio = cartTaxable / cartTotal;
        const taxablePortion = this._totalPrice * ratio;
        const exemptPortion = this._totalPrice - taxablePortion;
        const vat = (0, $ff150a18d4a6f5bb$export$b07c8f45d340b388)(taxablePortion, s.taxInclusiveRate);
        const vatLine = vat ? `Includes ${(0, $cnCXJ.esc)((0, $ff150a18d4a6f5bb$export$c829991a0e9a63)())} (${vat.rate}%) ${(0, $coRoT.formatMoney)(vat.tax)}` : '';
        const exemptLine = cartExempt > 0 ? `${(0, $ff150a18d4a6f5bb$export$d9b10f19e66f377b)()} items: ${(0, $coRoT.formatMoney)(exemptPortion)} (not taxed)` : '';
        return [
            vatLine,
            exemptLine
        ].filter(Boolean).join('<br>');
    }
    // Helper text under the payment panel. Cash explains the change math; QR tells
    // the cashier the merchant QR is now up on the customer display; Card shows none.
    _tipText(method) {
        if (method === 'qr') return 'The payment QR is now showing on the customer display for the customer to scan.';
        return 'Enter the amount the customer gives you to automatically calculate the change.';
    }
    // Cash keeps the amount-received → change flow. Card / QR have no change, so
    // we hide that step, stamp the exact total as paid in full, and let the cashier
    // record immediately. Called both on a button click and after the total changes.
    _applyPaymentMethodUI(method) {
        this._paymentMethod = method;
        this._parentElement.querySelectorAll('.payment-method-btn').forEach((b)=>b.classList.toggle('payment-method-btn--active', b.dataset.paymentMethod === method));
        const cashFields = this._parentElement.querySelector('#cashPaymentFields');
        const paidNote = this._parentElement.querySelector('#paidInFullNote');
        const recordBtn = this._parentElement.querySelector('.print-receipt-btn');
        const changeBox = this._parentElement.querySelector('#changeAmount');
        const tip = this._parentElement.querySelector('#paymentTip');
        const tipText = this._parentElement.querySelector('#paymentTipText');
        // Tip shows for cash + qr (each with its own copy), hidden for card.
        if (tipText) tipText.textContent = this._tipText(method);
        tip?.classList.toggle('hidden', method === 'card');
        if (method === 'cash') {
            cashFields?.classList.remove('hidden');
            paidNote?.classList.add('hidden');
            // Require the cashier to enter the amount received before recording.
            this._customerPayment = undefined;
            this._customerChange = undefined;
            if (changeBox) {
                changeBox.textContent = (0, $coRoT.formatMoney)(0);
                changeBox.classList.remove('ok', 'change-box--error');
            }
            recordBtn?.classList.add('hidden');
        } else {
            // Card / QR: exact total, no change.
            cashFields?.classList.add('hidden');
            paidNote?.classList.remove('hidden');
            this._customerPayment = this.chargeTotal();
            this._customerChange = 0;
            recordBtn?.classList.remove('hidden');
        }
    }
    _addHandlerPaymentMethod(handler) {
        this._parentElement.addEventListener('click', (e)=>{
            const btn = e.target.closest('.payment-method-btn');
            if (!btn) return;
            const method = btn.dataset.paymentMethod;
            this._applyPaymentMethodUI(method);
            handler(method);
        });
    }
    _addHandlerShowCheckout(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn-checkout");
            if (!btn) return;
            handler();
        });
    }
    _subtractChange() {
        // Block -, +, e, E from being typed into the payment field
        this._parentElement.addEventListener("keydown", (e)=>{
            if (e.target.id !== "customerPayment") return;
            if ([
                "-",
                "+",
                "e",
                "E"
            ].includes(e.key)) e.preventDefault();
        });
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest("#enterPaymentBtn");
            if (!btn) return;
            const changeBox = document.querySelector(".change-box");
            const raw = this._parentElement.querySelector("#customerPayment").value;
            const payment = parseFloat(raw);
            if (!raw || isNaN(payment) || payment <= 0) {
                changeBox.classList.remove("ok");
                changeBox.classList.add("change-box--error");
                changeBox.textContent = "Enter a valid payment amount";
                return;
            }
            this._customerPayment = payment;
            const due = this.chargeTotal();
            if (payment < due) {
                changeBox.classList.remove("ok");
                changeBox.classList.add("change-box--error");
                changeBox.textContent = this.tipAmount() > 0 ? `Payment must be at least the total with tip` : `Payment must be at least the order total`;
            } else {
                const change = payment - due;
                changeBox.classList.add("ok");
                changeBox.classList.remove("change-box--error");
                changeBox.textContent = (0, $coRoT.formatMoney)(change);
                this._customerChange = change;
                document.querySelector(".print-receipt-btn").classList.toggle("hidden");
            }
        });
    }
    _addHandlerPrintReceipt(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest("#printReceiptBtn");
            if (!btn) return;
            handler();
        });
    }
    _addHandlerReceiptEdit(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".receipt-adj-edit-btn");
            if (!btn) return;
            handler(btn.dataset.adjId);
        });
    }
    _addHandlerReceiptRemove(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".receipt-adj-remove-btn");
            if (!btn) return;
            handler(btn.dataset.adjId);
        });
    }
    _addHandlerReceiptAddManual(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (!e.target.closest(".receipt-add-adj-btn")) return;
            handler();
        });
    }
    _addHandlerReceiptSaveOverride(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest("#receiptEditSaveBtn");
            if (!btn) return;
            const value = parseFloat(document.getElementById("receiptEditValue").value);
            if (isNaN(value) || value < 0) {
                alert("Please enter a valid value.");
                return;
            }
            handler({
                id: btn.dataset.adjId,
                value: value
            });
        });
    }
    _addHandlerReceiptSaveManual(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (!e.target.closest("#receiptManualSaveBtn")) return;
            const name = document.getElementById("receiptManualName")?.value.trim();
            const type = document.getElementById("receiptManualType")?.value;
            const calculation = document.getElementById("receiptManualCalc")?.value;
            const value = parseFloat(document.getElementById("receiptManualValue")?.value);
            if (!name) {
                alert("Please enter a name.");
                return;
            }
            if (isNaN(value) || value < 0) {
                alert("Please enter a valid value.");
                return;
            }
            handler({
                name: name,
                type: type,
                calculation: calculation,
                value: value
            });
            this._removeReceiptForms();
        });
    }
    _addHandlerApplyPromo(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (!e.target.closest("#applyPromoBtn")) return;
            const input = this._parentElement.querySelector("#promoCodeInput");
            const code = input?.value.trim();
            if (!code) return;
            handler(code);
        });
    }
    _addHandlerRemovePromo(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (!e.target.closest("#removePromoBtn")) return;
            handler();
        });
    }
    // ── Loyalty handlers (all delegated on .modal-parent, like the promo ones) ───
    _addHandlerLoyaltyLookup(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (!e.target.closest("#loyaltyLookupBtn")) return;
            const phone = this._parentElement.querySelector("#loyaltyPhoneInput")?.value.trim();
            if (!phone) return;
            handler(phone);
        });
        // Enter in the phone input triggers the lookup too.
        this._parentElement.addEventListener("keydown", (e)=>{
            if (e.key !== "Enter" || e.target.id !== "loyaltyPhoneInput") return;
            e.preventDefault();
            const phone = e.target.value.trim();
            if (phone) handler(phone);
        });
    }
    _addHandlerLoyaltyEnroll(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (!e.target.closest("#loyaltyEnrollBtn")) return;
            const phone = this._parentElement.querySelector("#loyaltyEnrollPhone")?.value.trim();
            const name = this._parentElement.querySelector("#loyaltyEnrollName")?.value.trim();
            if (!phone) return;
            handler(phone, name);
        });
    }
    _addHandlerLoyaltyEnrollCancel(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (!e.target.closest("#loyaltyEnrollCancelBtn")) return;
            handler();
        });
    }
    // Live character filtering for the checkout loyalty fields (delegated, so it
    // survives every section re-render): phone = digits only, enroll name =
    // letters/spaces/'-. only. Mirrors the panel form's sanitizers.
    _wireLoyaltyInputs() {
        this._parentElement.addEventListener("input", (e)=>{
            const el = e.target;
            const strip = el.id === "loyaltyPhoneInput" ? (0, $dv0h8.stripNonDigits) : el.id === "loyaltyEnrollName" ? (0, $dv0h8.stripNonNameChars) : null;
            if (!strip) return;
            const caretKept = strip(el.value.slice(0, el.selectionStart ?? el.value.length)).length;
            const clean = strip(el.value);
            if (clean !== el.value) {
                el.value = clean;
                try {
                    el.setSelectionRange(caretKept, caretKept);
                } catch  {}
            }
        });
    }
    _addHandlerLoyaltyRedeemOpen(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (!e.target.closest("#loyaltyRedeemOpenBtn")) return;
            handler();
        });
    }
    // Stepper +/- are a pure view concern: adjust the count within [1, max] and
    // update the live "pts = −$X" preview. Only Redeem hands off to the controller.
    // Delegated on document (not .modal-parent) because the stepper now only
    // ever lives inside the top-level Redeem modal, which sits outside .modal-parent.
    _wireLoyaltyStepper() {
        document.addEventListener("click", (e)=>{
            const btn = e.target.closest("#loyaltyRedeemMinus, #loyaltyRedeemPlus");
            if (!btn) return;
            const card = btn.closest(".loyalty-points-off-card");
            const stepper = card?.querySelector(".loyalty-stepper");
            const countEl = card?.querySelector("#loyaltyRedeemCount");
            if (!stepper || !countEl) return;
            const max = parseInt(stepper.dataset.max) || 1;
            const delta = btn.id === "loyaltyRedeemPlus" ? 1 : -1;
            const next = Math.min(max, Math.max(1, (parseInt(countEl.textContent) || 1) + delta));
            countEl.textContent = String(next);
            const pts = next * (parseInt(card.dataset.redeemPoints) || 0);
            const val = next * (parseFloat(card.dataset.redeemValue) || 0);
            const ptsEl = card.querySelector(".loyalty-points-off-pts");
            const valEl = card.querySelector(".loyalty-points-off-value");
            if (ptsEl) ptsEl.textContent = `${pts} pts`;
            if (valEl) valEl.textContent = `\u{2212}${(0, $coRoT.formatMoney)(val)}`;
        });
    }
    _addHandlerLoyaltyRedeem(handler) {
        document.addEventListener("click", (e)=>{
            if (!e.target.closest("#loyaltyApplyRedeemBtn")) return;
            const count = parseInt(document.querySelector("#loyaltyRedeemCount")?.textContent) || 1;
            handler(count);
        });
    }
    // .loyalty-remove-redeem-btn can appear in the checkout section's applied-list
    // summary AND inside the Redeem modal at once - a class (not an id, which
    // would duplicate in the DOM) delegated on document to cover both.
    _addHandlerLoyaltyRemoveRedeem(handler) {
        document.addEventListener("click", (e)=>{
            if (!e.target.closest(".loyalty-remove-redeem-btn")) return;
            handler();
        });
    }
    _addHandlerLoyaltyUnlink(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (!e.target.closest("#loyaltyUnlinkBtn")) return;
            handler();
        });
    }
    _addHandlerBack(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (!e.target.closest(".checkout-back-btn")) return;
            handler();
        });
    }
    _addHandlerDeleteCartItem(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".checkout-cart-delete-btn");
            if (!btn) return;
            handler(Number(btn.dataset.cartIndex));
        });
    }
    // Only ever rendered inside the Redeem modal now (outside .modal-parent).
    _addHandlerLoyaltyRewardRedeem(handler) {
        document.addEventListener("click", (e)=>{
            const btn = e.target.closest(".loyalty-reward-redeem-btn");
            if (!btn) return;
            handler(btn.dataset.rewardId);
        });
    }
    // .loyalty-reward-remove-btn appears both in the section's applied-list
    // summary AND inside the Redeem modal - document-delegated to cover both.
    _addHandlerLoyaltyRewardRemove(handler) {
        document.addEventListener("click", (e)=>{
            const btn = e.target.closest(".loyalty-reward-remove-btn");
            if (!btn) return;
            handler(btn.dataset.cartLineId);
        });
    }
    _hideModal() {
        this._parentElement.innerHTML = "";
    }
    // Pre-commit receipt preview: shows the exact receipt (in an iframe) that will
    // print, with Go Back / Confirm. Nothing is recorded until Confirm. Reuses the
    // `.confirm-overlay` shell so it stacks/behaves like the other confirm modals.
    showReceiptPreview({ html: html, confirmLabel: confirmLabel = 'Confirm & Print', title: title = 'Record this sale?', note: note, onConfirm: onConfirm, onCancel: onCancel }) {
        if (document.querySelector('.confirm-overlay')) return;
        const el = document.createElement('div');
        el.className = 'confirm-overlay receipt-preview-overlay';
        el.innerHTML = `
      <div class="confirm-card confirm-card--receipt">
        <p class="confirm-msg">${title}</p>
        <div class="receipt-preview-frame-wrap">
          <iframe class="receipt-preview-frame" title="Receipt preview"></iframe>
        </div>
        ${note ? `<p class="confirm-note">${note}</p>` : ''}
        <div class="confirm-actions">
          <button class="btn confirm-cancel-btn" type="button">Go Back</button>
          <button class="btn primary confirm-ok-btn" type="button">${confirmLabel}</button>
        </div>
      </div>
    `;
        document.body.appendChild(el);
        // Set srcdoc via property (avoids HTML-attribute escaping of the receipt markup).
        el.querySelector('.receipt-preview-frame').srcdoc = html;
        el.querySelector('.confirm-ok-btn').addEventListener('click', ()=>{
            el.remove();
            onConfirm?.();
        });
        el.querySelector('.confirm-cancel-btn').addEventListener('click', ()=>{
            el.remove();
            onCancel?.();
        });
        el.addEventListener('click', (e)=>{
            if (e.target === el) {
                el.remove();
                onCancel?.();
            }
        });
    }
}
var $6724f76d0010cf48$export$2e2bcd8739ae039 = new $6724f76d0010cf48$var$OrderCheckOutView();




var $cnCXJ = parcelRequire("cnCXJ");


var $coRoT = parcelRequire("coRoT");

const $24a84838d36102df$var$TRASH_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="14" height="14" aria-hidden="true">
  <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
</svg>`;
class $24a84838d36102df$var$MenuEditView extends (0, $081656bd50f85abd$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".modal-parent");
    _formDiv = document.querySelector(".edit-form-parent");
    _submitHandler = null;
    _currentItemId = null;
    _invCtx = null;
    _showEditMenuForm(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            e.preventDefault();
            const card = e.target.closest(".card");
            if (!card) return;
            // In the catalogue's bulk-select mode, a card click toggles selection
            // (handled by menuListView) - don't open the edit modal.
            if (card.closest(".menu-modal--selecting")) return;
            card.classList.remove("pulse");
            card.offsetWidth;
            card.classList.add("pulse");
            handler(card.dataset.id);
        });
    }
    _insertEditMenuMarkup(item, invCtx = null, taxCtx = null) {
        this._currentItemId = item._id;
        this._invCtx = invCtx;
        const visualMode = item.iconEmoji ? "emoji" : "photo";
        const markUp = `
<div class="edit-modal-overlay">
  <div class="edit-modal-card">
    <button class="edit-modal-close" aria-label="Close modal">&#x2715;</button>

    <form class="edit-item-form">
      <h2 class="edit-form-title">Edit Menu Item</h2>

      <!-- Top grid: photo (4\xd72) + Item Name, Category, Price, Status (2\xd71 each) -->
      <div class="edit-top-wrap">
        <!-- Photo column -->
        <div class="edit-photo-col">
          <div class="item-photo-panel">
            <div class="file-upload-preview-wrapper edit-photo-box${item.imageURL ? "" : " edit-photo-box--empty"}">
              <img src="${(0, $cnCXJ.esc)(item.imageURL || (0, $bfffb7fa3c34031e$export$305f51b7beb9067))}" alt="${(0, $cnCXJ.esc)(item.itemName)}" class="edit-image-preview" />
              <input type="file" class="edit-image-input" name="image" accept="image/*" style="display:none;" />
              <span class="edit-image-overlay">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3.5"/></svg>
                <span>${item.imageURL ? "Change photo" : "Add photo"}</span>
              </span>
            </div>
            <p class="edit-photo-hint">Tap or drop an image</p>
          </div>
        </div>
        <!-- Fields: two explicit rows so each row is its own flex context -->
        <div class="edit-fields-col">
          <div class="edit-fields-row">
            <label class="edit-field">
              Item Name
              <input type="text" name="itemName" value="${(0, $cnCXJ.esc)(item.itemName)}" />
            </label>
            <div class="edit-field">
              <span>Category</span>
              <div class="category-wrapper">
                <select class="edit-field-select" name="category"></select>
                <div class="new-category-row hidden">
                  <input type="text" class="new-category-field edit-new-category-input" placeholder="New category name" />
                  <button class="new-category-button" type="button">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="edit-fields-row">
            <label class="edit-field">
              Price
              <div class="edit-price-wrap">
                <span class="edit-price-prefix">${(0, $coRoT.currencySymbol)()}</span>
                <input type="number" name="price" value="${item.price}" min="0" step="0.01" inputmode="decimal" />
              </div>
            </label>
            <label class="edit-field">
              Status
              <select name="status">
                <option value="Active" ${item.status === "active" ? "selected" : ""}>Active</option>
                <option value="Inactive" ${item.status === "inactive" ? "selected" : ""}>Inactive</option>
                <option value="Unavailable" ${item.status === "unavailable" ? "selected" : ""}>Unavailable</option>
              </select>
            </label>
          </div>
        </div>
      </div>

      ${(0, $41bf135ff605f7f7$export$8325cc25308f281)({
            selectedEmoji: item.iconEmoji,
            extraClass: "item-emoji-panel--edit"
        })}
      ${(0, $41bf135ff605f7f7$export$1f40417e4e0c8b3f)({
            mode: visualMode,
            selectedEmoji: item.iconEmoji
        })}

      <!-- Variants -->
      <div class="edit-variants-section">
        <div class="edit-variants-header">
          <div class="edit-toggle-row">
            <h3 class="edit-variants-title">Variants</h3>
            <label class="edit-switch">
              <input type="checkbox" name="hasVariants" ${item.hasVariants ? "checked" : ""} />
              <span class="edit-slider"></span>
            </label>
          </div>
          <button type="button" class="edit-add-variant-btn">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
            Add Variant Group
          </button>
        </div>

        ${item.hasVariants ? item.variants.map((variant, vIndex)=>`
            <div class="edit-variant-group">
              <div class="edit-variant-header">
                <span class="edit-variant-group-title">Variant Group Label</span>
                <button type="button" class="edit-delete-variant-btn">&#x1F5D1; Remove Group</button>
              </div>
              <input type="text" class="edit-variant-label-input" name="variants[${vIndex}][optionLabel]" value="${(0, $cnCXJ.esc)(variant.optionLabel)}" placeholder="e.g. Size, Flavor, Add-ons\u{2026}" />
              <div class="edit-variant-cols-header">
                <span>Option name</span>
                <span>Price <span class="pb-tip" tabindex="0" role="img" aria-label="More info" data-tip="Leave empty or enter 0 if this option has no extra charge">i</span></span>
              </div>
              <div class="edit-variant-options">
                ${variant.options.map((option, oIndex)=>`
                  <div class="edit-variant-row">
                    <input type="text" name="variants[${vIndex}][options][${oIndex}][optionName]" placeholder="Option name" value="${(0, $cnCXJ.esc)(option.optionName)}" />
                    <input type="number" name="variants[${vIndex}][options][${oIndex}][optionPrice]" placeholder="Price" value="${option.optionPrice}" />
                    <button type="button" class="edit-delete-option-btn" aria-label="Remove option">${$24a84838d36102df$var$TRASH_ICON}</button>
                  </div>
                `).join("")}
              </div>
              <button type="button" class="edit-add-option-btn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
                Add Option
              </button>
            </div>
          `).join("") : ""}
      </div>

      ${taxCtx?.enabled ? `
      <div class="edit-tax-section">
        <h3 class="edit-variants-title">Tax
          <span class="pb-tip" tabindex="0" role="img" aria-label="More info" data-tip="Exemptions are managed centrally in Receipt &amp; Tax so you can flag many products at once, by price or category.">i</span>
        </h3>
        <div class="edit-tax-row">
          <span class="edit-tax-badge${item.taxClass === "exempt" ? " edit-tax-badge--exempt" : ""}">${item.taxClass === "exempt" ? (0, $cnCXJ.esc)(taxCtx.exemptLabel) : "Taxable"}</span>
          <button type="button" class="edit-tax-manage-link">Manage in Receipt &amp; Tax &rarr;</button>
        </div>
      </div>` : ""}

      ${invCtx?.canManage ? this._inventorySectionMarkup(item, invCtx) : ""}

      <!-- Actions -->
      <div class="edit-form-actions">
        <button type="submit" class="edit-update-btn">Update Item</button>
        <button type="button" class="edit-delete-btn">${$24a84838d36102df$var$TRASH_ICON} Delete item</button>
      </div>
    </form>
  </div>
</div>
`;
        this._formDiv.innerHTML = "";
        this._formDiv.insertAdjacentHTML("beforeend", markUp);
        this._syncVariantsEmptyState();
        this._syncAllInvRows();
    }
    // ── Inventory (stock tracking) section ──────────────────────────────────────
    // Three modes: Not tracked / Simple count (auto 1:1 item) / Ingredients
    // (linked inventory items with per-sale amounts, optionally per-variant).
    // Inputs here carry NO name attributes so they never leak into the item
    // form's FormData - the controller reads them via getInventoryConfig().
    _inventorySectionMarkup(item, ctx) {
        const mode = ctx.autoItem ? "simple" : ctx.links.length ? "ingredients" : "none";
        const tab = (id, label)=>`<button type="button" class="invm-tab${mode === id ? " invm-tab--active" : ""}" data-invmode="${id}">${label}</button>`;
        // Group this product's links by inventory item: base qty + override rows.
        const byItem = new Map();
        ctx.links.forEach((l)=>{
            if (!byItem.has(l.inventoryItemId)) byItem.set(l.inventoryItemId, {
                base: null,
                overrides: []
            });
            const g = byItem.get(l.inventoryItemId);
            if (l.variantLabel == null) g.base = l;
            else g.overrides.push(l);
        });
        // In simple mode the single auto link is machinery, not an ingredient row.
        if (ctx.autoItem) byItem.delete(ctx.autoItem.id);
        const rows = [
            ...byItem.entries()
        ].map(([invItemId, g])=>this._ingredientRowMarkup(item, ctx, invItemId, g)).join("");
        return `
      <div class="invm-section">
        <h3 class="edit-variants-title">Inventory
          <span class="pb-tip" tabindex="0" role="img" aria-label="More info" data-tip="Track stock for this product: a simple per-unit count, or ingredient amounts used per sale. Stock goes down automatically when the product sells.">i</span>
        </h3>
        <div class="invm-tabs">
          ${tab("none", "Not tracked")}
          ${tab("simple", "Simple count")}
          ${tab("ingredients", "Ingredients")}
        </div>

        <div class="invm-pane${mode === "simple" ? "" : " hidden"}" data-invpane="simple">
          <div class="invx-field">
            <label>On hand</label>
            <input type="number" class="invm-onhand" min="0" step="any" placeholder="0" value="${ctx.autoItem ? ctx.autoItem.quantity : ""}" />
          </div>
          <p class="invm-hint">1 sale = 1 unit. Changing this count is logged as a manual adjustment.</p>
        </div>

        <div class="invm-pane${mode === "ingredients" ? "" : " hidden"}" data-invpane="ingredients">
          <div class="invm-rows">${rows}</div>
          <button type="button" class="invm-add-row">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
            Add ingredient
          </button>
          <p class="invm-hint">Amounts are what ONE sale of this product uses. If a sale picks two options that both set a Custom amount for the same ingredient, those amounts add together.</p>
        </div>
      </div>`;
    }
    _ingredientRowMarkup(item, ctx, selectedId = "", group = {
        base: null,
        overrides: []
    }) {
        // Auto "simple count" items belong to their own product - not pickable here.
        const pickable = ctx.items.filter((i)=>!i.linkedMenuItemId || i.id === selectedId);
        const selected = ctx.items.find((i)=>i.id === selectedId);
        const unit = selected?.unit ?? "";
        const overrideFor = (label, option)=>group.overrides.find((o)=>o.variantLabel === label && o.variantOption === option);
        // Current variant options -> one row each with an explicit three-state
        // control: Base (no override stored), Custom (override with its own qty),
        // None (override stored with qty 0 - that option uses none of this item).
        // The "uses X" caption and the example line are filled by _syncInvRow.
        // Overrides pointing at options that no longer exist render as removable
        // orphan notices.
        const currentPairs = new Set();
        const ovrInputs = (item.variants ?? []).map((g)=>(g.options ?? []).map((opt)=>{
                currentPairs.add(`${g.optionLabel}\u{2225}${opt.optionName}`);
                const ovr = overrideFor(g.optionLabel, opt.optionName);
                const mode = !ovr ? "base" : ovr.qty > 0 ? "custom" : "none";
                const seg = (m, label)=>`<button type="button" class="invm-ovr-seg-btn${mode === m ? " invm-ovr-seg-btn--active" : ""}" data-setmode="${m}">${label}</button>`;
                return `
        <div class="invm-ovr" data-ovrmode="${mode}" data-label="${(0, $cnCXJ.esc)(g.optionLabel)}" data-option="${(0, $cnCXJ.esc)(opt.optionName)}">
          <span class="invm-ovr-name">${(0, $cnCXJ.esc)(g.optionLabel)}: ${(0, $cnCXJ.esc)(opt.optionName)}</span>
          <div class="invm-ovr-seg" role="group" aria-label="Amount used when ${(0, $cnCXJ.esc)(g.optionLabel)}: ${(0, $cnCXJ.esc)(opt.optionName)} is picked">
            ${seg("base", "Base")}${seg("custom", "Custom")}${seg("none", "Not used")}
          </div>
          <span class="invm-ovr-amt${mode === "custom" ? "" : " hidden"}">
            <input type="number" min="0" step="any" placeholder="0" aria-label="Custom amount" value="${mode === "custom" ? ovr.qty : ""}" />
            <span class="invm-ovr-unit">${(0, $cnCXJ.esc)(unit)}</span>
          </span>
          <span class="invm-ovr-resolved${mode === "custom" ? " hidden" : ""}"></span>
        </div>`;
            }).join("")).join("");
        // Live "if sold as ... uses X" preview - one picker per variant group,
        // result computed with the same rules the checkout resolver uses.
        const examplePickers = (item.variants ?? []).filter((g)=>(g.options ?? []).length).map((g)=>`
        <select class="invm-example-pick" data-label="${(0, $cnCXJ.esc)(g.optionLabel)}" aria-label="${(0, $cnCXJ.esc)(g.optionLabel)}">
          ${g.options.map((opt, i)=>`<option value="${(0, $cnCXJ.esc)(opt.optionName)}"${i === 0 ? " selected" : ""}>${(0, $cnCXJ.esc)(opt.optionName)}</option>`).join("")}
        </select>`).join("");
        const exampleRow = examplePickers ? `<div class="invm-example">
           <span class="invm-example-if">A sale with</span>
           ${examplePickers}
           <span class="invm-example-result"></span>
         </div>` : "";
        const orphans = group.overrides.filter((o)=>!currentPairs.has(`${o.variantLabel}\u{2225}${o.variantOption}`)).map((o)=>`
        <div class="invm-ovr invm-ovr--orphan" data-label="${(0, $cnCXJ.esc)(o.variantLabel)}" data-option="${(0, $cnCXJ.esc)(o.variantOption)}" data-qty="${o.qty}">
          <span>&#9888; ${(0, $cnCXJ.esc)(o.variantLabel)}: ${(0, $cnCXJ.esc)(o.variantOption)} (option no longer exists - the base qty is used)</span>
          <button type="button" class="invm-ovr-clear">Remove</button>
        </div>`).join("");
        const hasVariantUi = (item.variants ?? []).length > 0 || orphans;
        return `
      <div class="invm-row">
        <div class="invm-row-main">
          <select class="invm-item-select">
            <option value="">Choose ingredient\u{2026}</option>
            ${pickable.map((i)=>`<option value="${i.id}"${i.id === selectedId ? " selected" : ""}>${(0, $cnCXJ.esc)(i.name)} (${(0, $cnCXJ.esc)(i.unit)})</option>`).join("")}
          </select>
          <input type="number" class="invm-qty" min="0" step="any" placeholder="Base qty" value="${group.base ? group.base.qty : ""}" />
          <span class="invm-unit">${(0, $cnCXJ.esc)(selected?.unit ?? "")}</span>
          <button type="button" class="invm-row-remove" aria-label="Remove ingredient">${$24a84838d36102df$var$TRASH_ICON}</button>
        </div>
        ${hasVariantUi ? `
        <button type="button" class="invm-ovr-toggle">Per-variant amounts <span class="invm-ovr-caret">&#9662;</span></button>
        <div class="invm-ovrs${group.overrides.length ? "" : " hidden"}">
          <p class="invm-hint invm-ovrs-hint"><strong>Choosing Base never adds extra.</strong> Each sale uses the base qty once - picking more options doesn't multiply it. Custom = this option uses a different amount instead of the base. Not used = this option skips this ingredient (e.g. no paper cup when "Serve in: Mug" is picked). Tip: if an ingredient is only needed for certain options (like oat milk), leave the base qty empty and set Custom on just those.</p>
          ${ovrInputs}${orphans}${exampleRow}
        </div>` : ""}
      </div>`;
    }
    _syncAllInvRows() {
        this._formDiv.querySelectorAll(".invm-row").forEach((r)=>this._syncInvRow(r));
    }
    // Fills one ingredient row's live feedback from its current inputs: the
    // muted "uses X" caption on every Base/None option row, and the example
    // line's result. Mirrors model.js _resolveLineConsumption: overrides
    // (Custom/None) matching the picked options are summed and replace the
    // base; a Custom row with an empty input behaves like Base.
    _syncInvRow(row) {
        const unit = row.querySelector(".invm-unit")?.textContent.trim() ?? "";
        const withUnit = (q)=>`${Math.round(q * 1000) / 1000}${unit ? ` ${unit}` : ""}`;
        const baseQty = parseFloat(row.querySelector(".invm-qty")?.value);
        const base = Number.isFinite(baseQty) && baseQty > 0 ? baseQty : 0;
        const ovrs = [
            ...row.querySelectorAll(".invm-ovr:not(.invm-ovr--orphan)")
        ];
        ovrs.forEach((ovr)=>{
            const resolved = ovr.querySelector(".invm-ovr-resolved");
            if (!resolved) return;
            const mode = ovr.dataset.ovrmode;
            if (mode === "none") resolved.textContent = "not used when picked";
            else resolved.textContent = base > 0 ? `uses base: ${withUnit(base)}` : "uses none (no base set)";
        });
        const result = row.querySelector(".invm-example-result");
        if (!result) return;
        const picked = [
            ...row.querySelectorAll(".invm-example-pick")
        ].map((s)=>({
                label: s.dataset.label,
                option: s.value
            }));
        let matchedSum = 0;
        let anyMatched = false;
        ovrs.forEach((ovr)=>{
            if (!picked.some((p)=>p.label === ovr.dataset.label && p.option === ovr.dataset.option)) return;
            const mode = ovr.dataset.ovrmode;
            if (mode === "none") {
                anyMatched = true;
                return;
            }
            if (mode !== "custom") return;
            const v = parseFloat(ovr.querySelector(".invm-ovr-amt input")?.value);
            if (Number.isFinite(v)) {
                anyMatched = true;
                matchedSum += Math.max(v, 0);
            }
        });
        const eff = anyMatched ? matchedSum : base;
        result.innerHTML = eff > 0 ? `uses <b>${(0, $cnCXJ.esc)(withUnit(eff))}</b>` : `uses <b>none</b> of this ingredient`;
    }
    // Delegated interactions for the Inventory section (registered once at init,
    // like the variant handlers).
    _addHandlerInventorySection() {
        this._formDiv.addEventListener("click", (e)=>{
            const tabBtn = e.target.closest(".invm-tab");
            if (tabBtn) {
                const section = tabBtn.closest(".invm-section");
                const current = section.querySelector(".invm-tab--active")?.dataset.invmode;
                const next = tabBtn.dataset.invmode;
                if (current === next) return;
                // Leaving simple mode deletes the auto stock item on save - confirm.
                if (current === "simple" && this._invCtx?.autoItem) {
                    const ok = window.confirm("Stop simple tracking? This product's automatic stock record and its history will be removed when you update the product.");
                    if (!ok) return;
                }
                section.querySelectorAll(".invm-tab").forEach((t)=>t.classList.toggle("invm-tab--active", t === tabBtn));
                section.querySelectorAll(".invm-pane").forEach((p)=>p.classList.toggle("hidden", p.dataset.invpane !== next));
                return;
            }
            const addBtn = e.target.closest(".invm-add-row");
            if (addBtn) {
                const item = {
                    variants: this._invCtx?.itemVariants ?? []
                };
                const rowsEl = addBtn.closest(".invm-pane").querySelector(".invm-rows");
                rowsEl.insertAdjacentHTML("beforeend", this._ingredientRowMarkup(item, this._invCtx));
                this._syncInvRow(rowsEl.lastElementChild);
                return;
            }
            const removeBtn = e.target.closest(".invm-row-remove");
            if (removeBtn) {
                removeBtn.closest(".invm-row").remove();
                return;
            }
            // Base / Custom / None switch on one option row.
            const segBtn = e.target.closest(".invm-ovr-seg-btn");
            if (segBtn) {
                const ovr = segBtn.closest(".invm-ovr");
                const mode = segBtn.dataset.setmode;
                ovr.dataset.ovrmode = mode;
                ovr.querySelectorAll(".invm-ovr-seg-btn").forEach((b)=>b.classList.toggle("invm-ovr-seg-btn--active", b === segBtn));
                ovr.querySelector(".invm-ovr-amt")?.classList.toggle("hidden", mode !== "custom");
                ovr.querySelector(".invm-ovr-resolved")?.classList.toggle("hidden", mode === "custom");
                this._syncInvRow(ovr.closest(".invm-row"));
                if (mode === "custom") ovr.querySelector(".invm-ovr-amt input")?.focus();
                return;
            }
            const ovrToggle = e.target.closest(".invm-ovr-toggle");
            if (ovrToggle) {
                ovrToggle.closest(".invm-row").querySelector(".invm-ovrs")?.classList.toggle("hidden");
                return;
            }
            const orphanClear = e.target.closest(".invm-ovr-clear");
            if (orphanClear) {
                orphanClear.closest(".invm-ovr--orphan").remove();
                return;
            }
        });
        // Picking an inventory item updates the row's unit captions; changing an
        // example picker recomputes that row's preview.
        this._formDiv.addEventListener("change", (e)=>{
            if (e.target.closest(".invm-example-pick")) {
                this._syncInvRow(e.target.closest(".invm-row"));
                return;
            }
            const select = e.target.closest(".invm-item-select");
            if (!select) return;
            const inv = this._invCtx?.items.find((i)=>i.id === select.value);
            const row = select.closest(".invm-row");
            const unitEl = row?.querySelector(".invm-unit");
            if (unitEl) unitEl.textContent = inv?.unit ?? "";
            row?.querySelectorAll(".invm-ovr-unit").forEach((u)=>{
                u.textContent = inv?.unit ?? "";
            });
            if (row) this._syncInvRow(row);
        });
        // Typing in the base amount or a Custom amount live-updates the captions.
        this._formDiv.addEventListener("input", (e)=>{
            if (e.target.closest(".invm-qty") || e.target.closest(".invm-ovr-amt")) {
                const row = e.target.closest(".invm-row");
                if (row) this._syncInvRow(row);
            }
        });
    }
    // Serializes the Inventory section. null = section not rendered (caller
    // lacks manage_inventory) - the controller then skips the inventory save.
    getInventoryConfig() {
        const section = this._formDiv.querySelector(".invm-section");
        if (!section) return null;
        const mode = section.querySelector(".invm-tab--active")?.dataset.invmode ?? "none";
        if (mode === "simple") {
            const onHand = parseFloat(section.querySelector(".invm-onhand")?.value);
            return {
                mode: mode,
                onHand: Number.isFinite(onHand) ? onHand : 0
            };
        }
        if (mode !== "ingredients") return {
            mode: "none"
        };
        const links = [];
        section.querySelectorAll(".invm-row").forEach((row)=>{
            const inventoryItemId = row.querySelector(".invm-item-select")?.value;
            if (!inventoryItemId) return;
            const baseQty = parseFloat(row.querySelector(".invm-qty")?.value);
            const hasBase = Number.isFinite(baseQty) && baseQty > 0;
            const overrideLinks = [];
            row.querySelectorAll(".invm-ovr").forEach((ovr)=>{
                if (ovr.classList.contains("invm-ovr--orphan")) {
                    // Orphans still present are preserved as-is (Remove deletes them).
                    overrideLinks.push({
                        inventoryItemId: inventoryItemId,
                        qty: parseFloat(ovr.dataset.qty),
                        variantLabel: ovr.dataset.label,
                        variantOption: ovr.dataset.option
                    });
                    return;
                }
                const push = (qty)=>overrideLinks.push({
                        inventoryItemId: inventoryItemId,
                        qty: qty,
                        variantLabel: ovr.dataset.label,
                        variantOption: ovr.dataset.option
                    });
                const mode = ovr.dataset.ovrmode;
                if (mode === "none") {
                    // qty 0 = that option uses none of this item. Only meaningful when a
                    // base exists to override; without one it's already "none".
                    if (hasBase) push(0);
                    return;
                }
                if (mode !== "custom") return; // Base = no override row stored
                const v = parseFloat(ovr.querySelector(".invm-ovr-amt input")?.value);
                if (!Number.isFinite(v)) return; // empty Custom behaves like Base
                push(Math.max(v, 0));
            });
            // A row is valid with a base amount, with positive overrides only
            // (variant-only consumption: nothing is used unless one of those options
            // is picked), or both. Skip rows that could never consume anything.
            if (!hasBase && !overrideLinks.some((l)=>l.qty > 0)) return;
            if (hasBase) links.push({
                inventoryItemId: inventoryItemId,
                qty: baseQty,
                variantLabel: null,
                variantOption: null
            });
            links.push(...overrideLinks);
        });
        return {
            mode: mode,
            links: links
        };
    }
    // Show a helpful hint inside the variants box whenever there are no groups, so
    // it never reads as an empty tinted bar.
    _syncVariantsEmptyState() {
        const section = this._formDiv.querySelector(".edit-variants-section");
        if (!section) return;
        const hasGroups = section.querySelector(".edit-variant-group");
        const hint = section.querySelector(".edit-variants-empty");
        if (hasGroups) {
            hint?.remove();
            return;
        }
        if (!hint) section.insertAdjacentHTML("beforeend", `<p class="edit-variants-empty">No variants yet. Add sizes, flavors, or add-ons (e.g. Small / Medium / Large) and the cashier picks one at checkout.</p>`);
    }
    _mapMenuCategoriesMarkUp(categories, selectedCategory) {
        const selectEl = document.querySelector(".edit-field-select");
        // Start fresh
        selectEl.innerHTML = "";
        // Default option (only selected if no category exists)
        selectEl.insertAdjacentHTML("beforeend", `<option value="" disabled ${!selectedCategory ? "selected" : ""}>
       Select category
     </option>`);
        // Add actual categories
        const markup = categories.map((cat)=>`
        <option value="${(0, $cnCXJ.esc)(cat)}" ${cat === selectedCategory ? "selected" : ""}>
          ${(0, $cnCXJ.esc)(cat[0].toUpperCase() + cat.slice(1))}
        </option>
      `).join("");
        selectEl.insertAdjacentHTML("beforeend", markup);
        // Add "new category" option
        selectEl.insertAdjacentHTML("beforeend", `<option value="new-category">Add new category</option>`);
    }
    // Returns the first empty required input inside variant groups, or null if all valid
    _validateVariants(form) {
        const groups = form.querySelectorAll(".edit-variant-group");
        for (const group of groups){
            const labelInput = group.querySelector(".edit-variant-label-input");
            if (labelInput && !labelInput.value.trim()) return labelInput;
            const optionNames = group.querySelectorAll('input[name*="[optionName]"]');
            for (const opt of optionNames){
                if (!opt.value.trim()) return opt;
            }
        }
        return null;
    }
    _updateItemData(handler) {
        if (this._submitHandler) this._formDiv.removeEventListener("submit", this._submitHandler);
        // Clear error highlight as the user types
        this._formDiv.addEventListener("input", (e)=>{
            e.target.closest(".edit-input-error")?.classList.remove("edit-input-error");
        }, {
            once: false
        });
        this._submitHandler = (e)=>{
            e.preventDefault();
            const form = e.target.closest(".edit-item-form");
            if (!form) return;
            // Validate variant fields before saving
            const badInput = this._validateVariants(form);
            if (badInput) {
                badInput.classList.remove("edit-input-error"); // reset so animation re-triggers
                badInput.offsetWidth; // force reflow
                badInput.classList.add("edit-input-error");
                badInput.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                badInput.focus();
                return; // block save
            }
            const formData = new FormData(form);
            const data = {};
            for (let [key, value] of formData.entries())data[key] = value;
            this._formDiv.removeEventListener("submit", this._submitHandler);
            this._submitHandler = null;
            handler(data);
            const overlay = form.closest(".edit-modal-overlay");
            if (overlay) overlay.remove();
        // Success feedback is a toast fired by the controller after the update
        // actually saves (controlShowEditMenu), not a modal here.
        };
        this._formDiv.addEventListener("submit", this._submitHandler);
    }
    _updateImagePreview() {
        // Click image to open file dialog
        this._formDiv.addEventListener("click", (e)=>{
            const wrapper = e.target.closest(".file-upload-preview-wrapper");
            if (!wrapper) return;
            const input = wrapper.querySelector(".edit-image-input");
            if (!input) return;
            input.click();
        });
        // Update preview when file selected
        this._formDiv.addEventListener("change", (e)=>{
            const input = e.target.closest(".edit-image-input");
            if (!input) return;
            const file = input.files[0];
            if (!file) return;
            if (!file.type.startsWith("image/")) {
                input.value = "";
                return;
            }
            const preview = input.closest(".file-upload-preview-wrapper").querySelector(".edit-image-preview");
            const reader = new FileReader();
            reader.onload = (e)=>{
                preview.src = e.target.result;
                input.closest(".edit-photo-box")?.classList.remove("edit-photo-box--empty");
            };
            reader.readAsDataURL(file);
        });
    }
    // Photo/Emoji toggle + emoji picker - shared with the Add form via
    // itemVisualPicker.js, wired once here since _formDiv persists across
    // re-renders (like the other delegated handlers in this file).
    _wireVisualPicker() {
        (0, $41bf135ff605f7f7$export$a24135cf33b875fd)(this._formDiv);
    }
    // Drag-and-drop onto the photo box (in addition to click-to-browse).
    _addPhotoDropZone() {
        const boxFrom = (e)=>e.target.closest(".edit-photo-box");
        this._formDiv.addEventListener("dragover", (e)=>{
            const box = boxFrom(e);
            if (!box) return;
            e.preventDefault();
            box.classList.add("edit-photo-box--dragover");
        });
        this._formDiv.addEventListener("dragleave", (e)=>{
            const box = boxFrom(e);
            if (box && !box.contains(e.relatedTarget)) box.classList.remove("edit-photo-box--dragover");
        });
        this._formDiv.addEventListener("drop", (e)=>{
            const box = boxFrom(e);
            if (!box) return;
            e.preventDefault();
            box.classList.remove("edit-photo-box--dragover");
            const file = e.dataTransfer?.files?.[0];
            if (!file || !file.type.startsWith("image/")) return;
            // Push the dropped file into the hidden input so the form submits it.
            // Assigning .files doesn't fire a native change event, so dispatch one -
            // itemVisualPicker's delegated listener needs it to flip imageMode to
            // "photo" (mirrors what the click-to-browse path gets for free).
            const input = box.querySelector(".edit-image-input");
            const dt = new DataTransfer();
            dt.items.add(file);
            input.files = dt.files;
            input.dispatchEvent(new Event("change", {
                bubbles: true
            }));
            const preview = box.querySelector(".edit-image-preview");
            const reader = new FileReader();
            reader.onload = (ev)=>{
                preview.src = ev.target.result;
                box.classList.remove("edit-photo-box--empty");
            };
            reader.readAsDataURL(file);
        });
    }
    _addVariantGroup() {
        this._formDiv.addEventListener("click", (e)=>{
            const btn = e.target.closest(".edit-add-variant-btn");
            if (!btn) return;
            const variantsSection = btn.closest(".edit-variants-section");
            if (!variantsSection) return;
            // Determine next index
            const currentGroups = variantsSection.querySelectorAll(".edit-variant-group");
            const vIndex = currentGroups.length;
            // Build markup for a new empty variant group
            const markup = `
      <div class="edit-variant-group">
        <div class="edit-variant-header">
          <span class="edit-variant-group-title">Variant Group Label</span>
          <button type="button" class="edit-delete-variant-btn">\u{1F5D1} Remove Group</button>
        </div>
        <input type="text" class="edit-variant-label-input" name="variants[${vIndex}][optionLabel]" value="" placeholder="e.g. Size, Flavor, Add-ons\u{2026}" />
        <div class="edit-variant-cols-header">
          <span>Option name</span>
          <span>Price <span class="pb-tip" tabindex="0" role="img" aria-label="More info" data-tip="Leave empty or enter 0 if this option has no extra charge">i</span></span>
        </div>
        <div class="edit-variant-options">
          <div class="edit-variant-row">
            <input
              type="text"
              name="variants[${vIndex}][options][0][optionName]"
              placeholder="Option name"
            />
            <input
              type="number"
              name="variants[${vIndex}][options][0][optionPrice]"
              placeholder="Price"
            />
            <button type="button" class="edit-delete-option-btn" aria-label="Remove option">${$24a84838d36102df$var$TRASH_ICON}</button>
          </div>
        </div>
        <button type="button" class="edit-add-option-btn">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
          Add Option
        </button>
      </div>
    `;
            // Insert new group at the bottom of variants section
            variantsSection.insertAdjacentHTML("beforeend", markup);
            this._syncVariantsEmptyState(); // drop the empty hint now that a group exists
            // Get the newly added group
            const newGroup = variantsSection.querySelector(".edit-variant-group:last-child");
            // Animate in
            newGroup.classList.add("edit-variant-group--entering");
            // Scroll smoothly to the new group
            newGroup.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            // Focus on the group name input
            const input = newGroup.querySelector("input[name^='variants'][name$='[optionLabel]']");
            if (input) input.focus();
            this._reindexVariants(); // make sure indices stay correct
            // Auto-enable the hasVariants toggle when a group is added
            const checkbox = this._formDiv.querySelector('[name="hasVariants"]');
            if (checkbox && !checkbox.checked) {
                checkbox.checked = true;
                const addBtn = this._formDiv.querySelector(".edit-add-variant-btn");
                if (addBtn) addBtn.style.display = "";
            }
        });
    }
    _addOption() {
        this._formDiv.addEventListener("click", (e)=>{
            const btn = e.target.closest(".edit-add-option-btn");
            if (!btn) return;
            const variantGroup = btn.closest(".edit-variant-group");
            if (!variantGroup) return;
            const optionsContainer = variantGroup.querySelector(".edit-variant-options");
            if (!optionsContainer) return;
            // Determine next option index
            const currentOptions = optionsContainer.querySelectorAll(".edit-variant-row");
            const oIndex = currentOptions.length;
            // Determine vIndex for this variant group
            const groupInput = variantGroup.querySelector("input[name^='variants'][name$='[optionLabel]']");
            const vIndexMatch = groupInput.name.match(/variants\[(\d+)\]/);
            const vIndex = vIndexMatch ? vIndexMatch[1] : 0;
            // Build new option row
            const markup = `
      <div class="edit-variant-row">
        <input
          type="text"
          name="variants[${vIndex}][options][${oIndex}][optionName]"
          placeholder="Option name"
        />
        <input
          type="number"
          name="variants[${vIndex}][options][${oIndex}][optionPrice]"
          placeholder="Price"
        />
        <button type="button" class="edit-delete-option-btn" aria-label="Remove option">${$24a84838d36102df$var$TRASH_ICON}</button>
      </div>
    `;
            optionsContainer.insertAdjacentHTML("beforeend", markup);
            // Scroll to the new option
            const newOption = optionsContainer.querySelector(".edit-variant-row:last-child");
            // Animate in
            newOption.classList.add("edit-variant-row--entering");
            newOption.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            // Focus on the new option name input
            const input = newOption.querySelector("input[name$='[optionName]']");
            if (input) input.focus();
            this._reindexVariants(); // make sure names stay correct
        });
    }
    _deleteVariant() {
        this._formDiv.addEventListener("click", (e)=>{
            const btn = e.target.closest(".edit-delete-variant-btn");
            if (!btn) return;
            const confirmDelete = window.confirm("Delete this variant group?");
            if (!confirmDelete) return;
            const group = btn.closest(".edit-variant-group");
            if (group) group.remove();
            this._reindexVariants();
            this._syncVariantsEmptyState();
            const remaining = this._formDiv.querySelectorAll(".edit-variant-group");
            if (remaining.length === 0) {
                const checkbox = this._formDiv.querySelector('[name="hasVariants"]');
                if (checkbox) checkbox.checked = false;
            }
        });
    }
    _reindexVariants() {
        const groups = this._formDiv.querySelectorAll(".edit-variant-group");
        groups.forEach((group, vIndex)=>{
            // Update variant label input
            const labelInput = group.querySelector('input[name*="[optionLabel]"]');
            labelInput.name = `variants[${vIndex}][optionLabel]`;
            // Update option inputs
            const optionRows = group.querySelectorAll(".edit-variant-row");
            optionRows.forEach((row, oIndex)=>{
                const nameInput = row.querySelector('input[name*="[optionName]"]');
                const priceInput = row.querySelector('input[name*="[optionPrice]"]');
                nameInput.name = `variants[${vIndex}][options][${oIndex}][optionName]`;
                priceInput.name = `variants[${vIndex}][options][${oIndex}][optionPrice]`;
            });
        });
    }
    _deleteOption() {
        this._formDiv.addEventListener("click", (e)=>{
            const btn = e.target.closest(".edit-delete-option-btn");
            if (!btn) return;
            const row = btn.closest(".edit-variant-row");
            if (row) row.remove();
            this._reindexVariants();
        });
    }
    _addHandlerHasVariantsToggle() {
        this._formDiv.addEventListener("change", (e)=>{
            const checkbox = e.target.closest('[name="hasVariants"]');
            if (!checkbox) return;
            const addBtn = this._formDiv.querySelector(".edit-add-variant-btn");
            if (checkbox.checked) {
                if (addBtn) addBtn.style.display = "";
                return;
            }
            const existingGroups = this._formDiv.querySelectorAll(".edit-variant-group");
            if (existingGroups.length === 0) {
                if (addBtn) addBtn.style.display = "none";
                return;
            }
            // Revert toggle until user confirms
            checkbox.checked = true;
            this._showVariantsToggleConfirm(()=>{
                checkbox.checked = false;
                existingGroups.forEach((g)=>g.remove());
                if (addBtn) addBtn.style.display = "none";
                this._syncVariantsEmptyState();
            });
        });
    }
    _showVariantsToggleConfirm(onConfirm) {
        const markup = `
      <div class="edit-confirm-overlay">
        <div class="edit-confirm-dialog">
          <p class="edit-confirm-msg">Toggling this off will remove all existing variants. Do you want to continue?</p>
          <div class="edit-confirm-actions">
            <button type="button" class="edit-confirm-cancel-btn">Cancel</button>
            <button type="button" class="edit-confirm-yes-btn">Continue</button>
          </div>
        </div>
      </div>
    `;
        const container = this._formDiv.querySelector(".edit-modal-card");
        container.insertAdjacentHTML("beforeend", markup);
        const overlay = container.querySelector(".edit-confirm-overlay");
        overlay.querySelector(".edit-confirm-yes-btn").addEventListener("click", ()=>{
            overlay.remove();
            onConfirm();
        });
        overlay.querySelector(".edit-confirm-cancel-btn").addEventListener("click", ()=>{
            overlay.remove();
        });
    }
    _addHandlerDeleteItem(handler) {
        this._formDiv.addEventListener("click", (e)=>{
            const btn = e.target.closest(".edit-delete-btn");
            if (!btn) return;
            const confirmed = window.confirm("Delete this item? This cannot be undone.");
            if (!confirmed) return;
            const overlay = btn.closest(".edit-modal-overlay");
            if (overlay) overlay.remove();
            handler(this._currentItemId);
        });
    }
    // Deep-link out to the Receipt Adjustments panel's centralized exemption picker.
    // Closes this modal first (both live in .modal-parent's stacking chain) so
    // the panel that opens behind it reads cleanly.
    _addHandlerManageTax(handler) {
        this._formDiv.addEventListener("click", (e)=>{
            const btn = e.target.closest(".edit-tax-manage-link");
            if (!btn) return;
            const overlay = btn.closest(".edit-modal-overlay");
            if (overlay) overlay.remove();
            handler(this._currentItemId);
        });
    }
    _closeModal() {
        this._formDiv.addEventListener("click", (e)=>{
            const btn = e.target.closest(".edit-modal-close");
            if (!btn) return;
            const overlay = btn.closest(".edit-modal-overlay");
            if (!overlay) return;
            const card = overlay.querySelector(".edit-modal-card");
            if (card) card.classList.add("modal-exiting");
            setTimeout(()=>overlay.remove(), 220);
        });
    }
    _newEditCategoryToggle(handler) {
        this._formDiv.addEventListener("change", (e)=>{
            const select = e.target.closest(".edit-field-select");
            if (!select) return;
            const row = select.closest(".category-wrapper")?.querySelector(".new-category-row");
            if (!row) return;
            if (select.value === "new-category") {
                row.classList.remove("hidden");
                row.querySelector(".new-category-field").focus();
            } else row.classList.add("hidden");
        });
        this._formDiv.addEventListener("click", (e)=>{
            const btn = e.target.closest(".edit-field .new-category-button");
            if (!btn) return;
            const row = btn.closest(".new-category-row");
            const input = row.querySelector(".new-category-field");
            const name = input.value.trim();
            if (!name) {
                alert("Please enter a category name");
                return;
            }
            handler(name);
            input.value = "";
            row.classList.add("hidden");
        });
        this._formDiv.addEventListener("keydown", (e)=>{
            if (e.key !== "Enter") return;
            const input = e.target.closest(".edit-new-category-input");
            if (!input) return;
            e.preventDefault();
            const row = input.closest(".new-category-row");
            const name = input.value.trim();
            if (!name) {
                alert("Please enter a category name");
                return;
            }
            handler(name);
            input.value = "";
            row.classList.add("hidden");
        });
    }
}
var $24a84838d36102df$export$2e2bcd8739ae039 = new $24a84838d36102df$var$MenuEditView();


// packages/core/src/js/data.ts
var $1b5b6cd373c57766$var$rawCountryData = [
    [
        "af",
        // Afghanistan
        "93",
        0,
        null,
        "0"
    ],
    [
        "ax",
        // Åland Islands (AKA Aland Islands)
        "358",
        1,
        [
            "18",
            "4"
        ],
        // (4 is a mobile range shared with FI)
        // NOTE: https://en.wikipedia.org/wiki/Telephone%20numbers%20in%20%C3%85land says some 4XXX ranges (e.g. 4570) are specific to AX, but LPN doesn't respect this (https://libphonenumber.appspot.com/phonenumberparser?number=%2B3584570123456 says region=FI) so we won't either. Also it's too much of a maintenance burden to keep track of. Keep the 4 area code range here so that if the user selects AX and types this kind of number, we wont change the flag to FI. Whereas if they type a FI-only range then we will.
        "0"
    ],
    [
        "al",
        // Albania
        "355",
        0,
        null,
        "0"
    ],
    [
        "dz",
        // Algeria
        "213",
        0,
        null,
        "0"
    ],
    [
        "as",
        // American Samoa
        "1",
        5,
        [
            "684"
        ],
        "1"
    ],
    [
        "ad",
        // Andorra
        "376"
    ],
    [
        "ao",
        // Angola
        "244"
    ],
    [
        "ai",
        // Anguilla
        "1",
        6,
        [
            "264"
        ],
        "1"
    ],
    [
        "ag",
        // Antigua and Barbuda
        "1",
        7,
        [
            "268"
        ],
        "1"
    ],
    [
        "ar",
        // Argentina
        "54",
        0,
        null,
        "0"
    ],
    [
        "am",
        // Armenia
        "374",
        0,
        null,
        "0"
    ],
    [
        "aw",
        // Aruba
        "297"
    ],
    [
        "ac",
        // Ascension Island
        "247"
    ],
    [
        "au",
        // Australia
        "61",
        0,
        [
            "4"
        ],
        // (mobile range shared with CX and CC)
        "0"
    ],
    [
        "at",
        // Austria
        "43",
        0,
        null,
        "0"
    ],
    [
        "az",
        // Azerbaijan
        "994",
        0,
        null,
        "0"
    ],
    [
        "bs",
        // Bahamas
        "1",
        8,
        [
            "242"
        ],
        "1"
    ],
    [
        "bh",
        // Bahrain
        "973"
    ],
    [
        "bd",
        // Bangladesh
        "880",
        0,
        null,
        "0"
    ],
    [
        "bb",
        // Barbados
        "1",
        9,
        [
            "246"
        ],
        "1"
    ],
    [
        "by",
        // Belarus
        "375",
        0,
        null,
        "8"
    ],
    [
        "be",
        // Belgium
        "32",
        0,
        null,
        "0"
    ],
    [
        "bz",
        // Belize
        "501"
    ],
    [
        "bj",
        // Benin
        "229"
    ],
    [
        "bm",
        // Bermuda
        "1",
        10,
        [
            "441"
        ],
        "1"
    ],
    [
        "bt",
        // Bhutan
        "975"
    ],
    [
        "bo",
        // Bolivia
        "591",
        0,
        null,
        "0"
    ],
    [
        "ba",
        // Bosnia and Herzegovina
        "387",
        0,
        null,
        "0"
    ],
    [
        "bw",
        // Botswana
        "267"
    ],
    [
        "br",
        // Brazil
        "55",
        0,
        null,
        "0"
    ],
    [
        "io",
        // British Indian Ocean Territory
        "246"
    ],
    [
        "vg",
        // British Virgin Islands
        "1",
        11,
        [
            "284"
        ],
        "1"
    ],
    [
        "bn",
        // Brunei
        "673"
    ],
    [
        "bg",
        // Bulgaria
        "359",
        0,
        null,
        "0"
    ],
    [
        "bf",
        // Burkina Faso
        "226"
    ],
    [
        "bi",
        // Burundi
        "257"
    ],
    [
        "kh",
        // Cambodia
        "855",
        0,
        null,
        "0"
    ],
    [
        "cm",
        // Cameroon
        "237"
    ],
    [
        "ca",
        // Canada
        "1",
        1,
        [
            "204",
            "226",
            "236",
            "249",
            "250",
            "257",
            "263",
            "289",
            "306",
            "343",
            "354",
            "365",
            "367",
            "368",
            "382",
            "403",
            "416",
            "418",
            "428",
            "431",
            "437",
            "438",
            "450",
            "468",
            "474",
            "506",
            "514",
            "519",
            "548",
            "579",
            "581",
            "584",
            "587",
            "604",
            "613",
            "639",
            "647",
            "672",
            "683",
            "705",
            "709",
            "742",
            "753",
            "778",
            "780",
            "782",
            "807",
            "819",
            "825",
            "867",
            "873",
            "879",
            "902",
            "905",
            "942"
        ],
        "1"
    ],
    [
        "cv",
        // Cape Verde
        "238"
    ],
    [
        "bq",
        // Caribbean Netherlands
        "599",
        1,
        [
            "3",
            "4",
            "7"
        ]
    ],
    [
        "ky",
        // Cayman Islands
        "1",
        12,
        [
            "345"
        ],
        "1"
    ],
    [
        "cf",
        // Central African Republic
        "236"
    ],
    [
        "td",
        // Chad
        "235"
    ],
    [
        "cl",
        // Chile
        "56"
    ],
    [
        "cn",
        // China
        "86",
        0,
        null,
        "0"
    ],
    [
        "cx",
        // Christmas Island
        "61",
        2,
        [
            "4",
            "89164"
        ],
        // (4 is a mobile range shared with AU and CC)
        "0"
    ],
    [
        "cc",
        // Cocos (Keeling) Islands
        "61",
        1,
        [
            "4",
            "89162"
        ],
        // (4 is a mobile range shared with AU and CX)
        "0"
    ],
    [
        "co",
        // Colombia
        "57",
        0,
        null,
        "0"
    ],
    [
        "km",
        // Comoros
        "269"
    ],
    [
        "cg",
        // Congo (Brazzaville)
        "242"
    ],
    [
        "cd",
        // Congo (Kinshasa)
        "243",
        0,
        null,
        "0"
    ],
    [
        "ck",
        // Cook Islands
        "682"
    ],
    [
        "cr",
        // Costa Rica
        "506"
    ],
    [
        "ci",
        // Côte d'Ivoire
        "225"
    ],
    [
        "hr",
        // Croatia
        "385",
        0,
        null,
        "0"
    ],
    [
        "cu",
        // Cuba
        "53",
        0,
        null,
        "0"
    ],
    [
        "cw",
        // Curaçao
        "599",
        0
    ],
    [
        "cy",
        // Cyprus
        "357"
    ],
    [
        "cz",
        // Czech Republic
        "420"
    ],
    [
        "dk",
        // Denmark
        "45"
    ],
    [
        "dj",
        // Djibouti
        "253"
    ],
    [
        "dm",
        // Dominica
        "1",
        13,
        [
            "767"
        ],
        "1"
    ],
    [
        "do",
        // Dominican Republic
        "1",
        2,
        [
            "809",
            "829",
            "849"
        ],
        "1"
    ],
    [
        "ec",
        // Ecuador
        "593",
        0,
        null,
        "0"
    ],
    [
        "eg",
        // Egypt
        "20",
        0,
        null,
        "0"
    ],
    [
        "sv",
        // El Salvador
        "503"
    ],
    [
        "gq",
        // Equatorial Guinea
        "240"
    ],
    [
        "er",
        // Eritrea
        "291",
        0,
        null,
        "0"
    ],
    [
        "ee",
        // Estonia
        "372"
    ],
    [
        "sz",
        // Eswatini
        "268"
    ],
    [
        "et",
        // Ethiopia
        "251",
        0,
        null,
        "0"
    ],
    [
        "fk",
        // Falkland Islands (Malvinas)
        "500"
    ],
    [
        "fo",
        // Faroe Islands
        "298"
    ],
    [
        "fj",
        // Fiji
        "679"
    ],
    [
        "fi",
        // Finland
        "358",
        0,
        [
            "4"
        ],
        // (mobile range shared with AX)
        "0"
    ],
    [
        "fr",
        // France
        "33",
        0,
        null,
        "0"
    ],
    [
        "gf",
        // French Guiana
        "594",
        0,
        null,
        "0"
    ],
    [
        "pf",
        // French Polynesia
        "689"
    ],
    [
        "ga",
        // Gabon
        "241"
    ],
    [
        "gm",
        // Gambia
        "220"
    ],
    [
        "ge",
        // Georgia
        "995",
        0,
        null,
        "0"
    ],
    [
        "de",
        // Germany
        "49",
        0,
        null,
        "0"
    ],
    [
        "gh",
        // Ghana
        "233",
        0,
        null,
        "0"
    ],
    [
        "gi",
        // Gibraltar
        "350"
    ],
    [
        "gr",
        // Greece
        "30"
    ],
    [
        "gl",
        // Greenland
        "299"
    ],
    [
        "gd",
        // Grenada
        "1",
        14,
        [
            "473"
        ],
        "1"
    ],
    [
        "gp",
        // Guadeloupe
        "590",
        0,
        null,
        "0"
    ],
    [
        "gu",
        // Guam
        "1",
        15,
        [
            "671"
        ],
        "1"
    ],
    [
        "gt",
        // Guatemala
        "502"
    ],
    [
        "gg",
        // Guernsey
        "44",
        1,
        [
            "1481",
            "7781",
            "7839",
            "7911"
        ],
        "0"
    ],
    [
        "gn",
        // Guinea
        "224"
    ],
    [
        "gw",
        // Guinea-Bissau
        "245"
    ],
    [
        "gy",
        // Guyana
        "592"
    ],
    [
        "ht",
        // Haiti
        "509"
    ],
    [
        "hn",
        // Honduras
        "504"
    ],
    [
        "hk",
        // Hong Kong SAR China
        "852"
    ],
    [
        "hu",
        // Hungary
        "36",
        0,
        null,
        "06"
    ],
    [
        "is",
        // Iceland
        "354"
    ],
    [
        "in",
        // India
        "91",
        0,
        null,
        "0"
    ],
    [
        "id",
        // Indonesia
        "62",
        0,
        null,
        "0"
    ],
    [
        "ir",
        // Iran
        "98",
        0,
        null,
        "0"
    ],
    [
        "iq",
        // Iraq
        "964",
        0,
        null,
        "0"
    ],
    [
        "ie",
        // Ireland
        "353",
        0,
        null,
        "0"
    ],
    [
        "im",
        // Isle of Man
        "44",
        2,
        [
            "1624",
            "74576",
            "7524",
            "7624",
            "7924"
        ],
        "0"
    ],
    [
        "il",
        // Israel
        "972",
        0,
        null,
        "0"
    ],
    [
        "it",
        // Italy
        "39",
        0,
        [
            "3"
        ]
    ],
    [
        "jm",
        // Jamaica
        "1",
        4,
        [
            "658",
            "876"
        ],
        "1"
    ],
    [
        "jp",
        // Japan
        "81",
        0,
        null,
        "0"
    ],
    [
        "je",
        // Jersey
        "44",
        3,
        [
            "1534",
            "7509",
            "7700",
            "7797",
            "7829",
            "7937"
        ],
        "0"
    ],
    [
        "jo",
        // Jordan
        "962",
        0,
        null,
        "0"
    ],
    [
        "kz",
        // Kazakhstan
        "7",
        1,
        [
            "33",
            "7"
        ],
        // (33 is shared with RU)
        "8"
    ],
    [
        "ke",
        // Kenya
        "254",
        0,
        null,
        "0"
    ],
    [
        "ki",
        // Kiribati
        "686",
        0,
        null,
        "0"
    ],
    [
        "xk",
        // Kosovo
        "383",
        0,
        null,
        "0"
    ],
    [
        "kw",
        // Kuwait
        "965"
    ],
    [
        "kg",
        // Kyrgyzstan
        "996",
        0,
        null,
        "0"
    ],
    [
        "la",
        // Laos
        "856",
        0,
        null,
        "0"
    ],
    [
        "lv",
        // Latvia
        "371"
    ],
    [
        "lb",
        // Lebanon
        "961",
        0,
        null,
        "0"
    ],
    [
        "ls",
        // Lesotho
        "266"
    ],
    [
        "lr",
        // Liberia
        "231",
        0,
        null,
        "0"
    ],
    [
        "ly",
        // Libya
        "218",
        0,
        null,
        "0"
    ],
    [
        "li",
        // Liechtenstein
        "423",
        0,
        null,
        "0"
    ],
    [
        "lt",
        // Lithuania
        "370",
        0,
        null,
        "0"
    ],
    [
        "lu",
        // Luxembourg
        "352"
    ],
    [
        "mo",
        // Macao SAR China
        "853"
    ],
    [
        "mg",
        // Madagascar
        "261",
        0,
        null,
        "0"
    ],
    [
        "mw",
        // Malawi
        "265",
        0,
        null,
        "0"
    ],
    [
        "my",
        // Malaysia
        "60",
        0,
        null,
        "0"
    ],
    [
        "mv",
        // Maldives
        "960"
    ],
    [
        "ml",
        // Mali
        "223"
    ],
    [
        "mt",
        // Malta
        "356"
    ],
    [
        "mh",
        // Marshall Islands
        "692",
        0,
        null,
        "1"
    ],
    [
        "mq",
        // Martinique
        "596",
        0,
        null,
        "0"
    ],
    [
        "mr",
        // Mauritania
        "222"
    ],
    [
        "mu",
        // Mauritius
        "230"
    ],
    [
        "yt",
        // Mayotte
        "262",
        1,
        [
            "269",
            "639"
        ],
        "0"
    ],
    [
        "mx",
        // Mexico
        "52"
    ],
    [
        "fm",
        // Micronesia
        "691"
    ],
    [
        "md",
        // Moldova
        "373",
        0,
        null,
        "0"
    ],
    [
        "mc",
        // Monaco
        "377",
        0,
        null,
        "0"
    ],
    [
        "mn",
        // Mongolia
        "976",
        0,
        null,
        "0"
    ],
    [
        "me",
        // Montenegro
        "382",
        0,
        null,
        "0"
    ],
    [
        "ms",
        // Montserrat
        "1",
        16,
        [
            "664"
        ],
        "1"
    ],
    [
        "ma",
        // Morocco
        "212",
        0,
        [
            "6",
            "7"
        ],
        // (mobile ranges shared with EH)
        "0"
    ],
    [
        "mz",
        // Mozambique
        "258"
    ],
    [
        "mm",
        // Myanmar (Burma)
        "95",
        0,
        null,
        "0"
    ],
    [
        "na",
        // Namibia
        "264",
        0,
        null,
        "0"
    ],
    [
        "nr",
        // Nauru
        "674"
    ],
    [
        "np",
        // Nepal
        "977",
        0,
        null,
        "0"
    ],
    [
        "nl",
        // Netherlands
        "31",
        0,
        null,
        "0"
    ],
    [
        "nc",
        // New Caledonia
        "687"
    ],
    [
        "nz",
        // New Zealand
        "64",
        0,
        null,
        "0"
    ],
    [
        "ni",
        // Nicaragua
        "505"
    ],
    [
        "ne",
        // Niger
        "227"
    ],
    [
        "ng",
        // Nigeria
        "234",
        0,
        null,
        "0"
    ],
    [
        "nu",
        // Niue
        "683"
    ],
    [
        "nf",
        // Norfolk Island
        "672"
    ],
    [
        "kp",
        // North Korea
        "850",
        0,
        null,
        "0"
    ],
    [
        "mk",
        // North Macedonia
        "389",
        0,
        null,
        "0"
    ],
    [
        "mp",
        // Northern Mariana Islands
        "1",
        17,
        [
            "670"
        ],
        "1"
    ],
    [
        "no",
        // Norway
        "47",
        0,
        [
            "4",
            "9"
        ]
    ],
    [
        "om",
        // Oman
        "968"
    ],
    [
        "pk",
        // Pakistan
        "92",
        0,
        null,
        "0"
    ],
    [
        "pw",
        // Palau
        "680"
    ],
    [
        "ps",
        // Palestinian Territories
        "970",
        0,
        null,
        "0"
    ],
    [
        "pa",
        // Panama
        "507"
    ],
    [
        "pg",
        // Papua New Guinea
        "675"
    ],
    [
        "py",
        // Paraguay
        "595",
        0,
        null,
        "0"
    ],
    [
        "pe",
        // Peru
        "51",
        0,
        null,
        "0"
    ],
    [
        "ph",
        // Philippines
        "63",
        0,
        null,
        "0"
    ],
    [
        "pl",
        // Poland
        "48"
    ],
    [
        "pt",
        // Portugal
        "351"
    ],
    [
        "pr",
        // Puerto Rico
        "1",
        3,
        [
            "787",
            "939"
        ],
        "1"
    ],
    [
        "qa",
        // Qatar
        "974"
    ],
    [
        "re",
        // Réunion
        "262",
        0,
        null,
        "0"
    ],
    [
        "ro",
        // Romania
        "40",
        0,
        null,
        "0"
    ],
    [
        "ru",
        // Russia
        "7",
        0,
        [
            "33"
        ],
        // (shared with KZ)
        "8"
    ],
    [
        "rw",
        // Rwanda
        "250",
        0,
        null,
        "0"
    ],
    [
        "ws",
        // Samoa
        "685"
    ],
    [
        "sm",
        // San Marino
        "378"
    ],
    [
        "st",
        // São Tomé & Príncipe
        "239"
    ],
    [
        "sa",
        // Saudi Arabia
        "966",
        0,
        null,
        "0"
    ],
    [
        "sn",
        // Senegal
        "221"
    ],
    [
        "rs",
        // Serbia
        "381",
        0,
        null,
        "0"
    ],
    [
        "sc",
        // Seychelles
        "248"
    ],
    [
        "sl",
        // Sierra Leone
        "232",
        0,
        null,
        "0"
    ],
    [
        "sg",
        // Singapore
        "65"
    ],
    [
        "sx",
        // Sint Maarten
        "1",
        21,
        [
            "721"
        ],
        "1"
    ],
    [
        "sk",
        // Slovakia
        "421",
        0,
        null,
        "0"
    ],
    [
        "si",
        // Slovenia
        "386",
        0,
        null,
        "0"
    ],
    [
        "sb",
        // Solomon Islands
        "677"
    ],
    [
        "so",
        // Somalia
        "252",
        0,
        null,
        "0"
    ],
    [
        "za",
        // South Africa
        "27",
        0,
        null,
        "0"
    ],
    [
        "kr",
        // South Korea
        "82",
        0,
        null,
        "0"
    ],
    [
        "ss",
        // South Sudan
        "211",
        0,
        null,
        "0"
    ],
    [
        "es",
        // Spain
        "34"
    ],
    [
        "lk",
        // Sri Lanka
        "94",
        0,
        null,
        "0"
    ],
    [
        "bl",
        // St. Barthélemy
        "590",
        1,
        null,
        "0"
    ],
    [
        "sh",
        // St. Helena
        "290"
    ],
    [
        "kn",
        // St. Kitts & Nevis
        "1",
        18,
        [
            "869"
        ],
        "1"
    ],
    [
        "lc",
        // St. Lucia
        "1",
        19,
        [
            "758"
        ],
        "1"
    ],
    [
        "mf",
        // St. Martin
        "590",
        2,
        null,
        "0"
    ],
    [
        "pm",
        // St. Pierre & Miquelon
        "508",
        0,
        null,
        "0"
    ],
    [
        "vc",
        // St. Vincent & Grenadines
        "1",
        20,
        [
            "784"
        ],
        "1"
    ],
    [
        "sd",
        // Sudan
        "249",
        0,
        null,
        "0"
    ],
    [
        "sr",
        // Suriname
        "597"
    ],
    [
        "sj",
        // Svalbard & Jan Mayen
        "47",
        1,
        [
            "4",
            "79",
            "9"
        ]
    ],
    [
        "se",
        // Sweden
        "46",
        0,
        null,
        "0"
    ],
    [
        "ch",
        // Switzerland
        "41",
        0,
        null,
        "0"
    ],
    [
        "sy",
        // Syria
        "963",
        0,
        null,
        "0"
    ],
    [
        "tw",
        // Taiwan
        "886",
        0,
        null,
        "0"
    ],
    [
        "tj",
        // Tajikistan
        "992"
    ],
    [
        "tz",
        // Tanzania
        "255",
        0,
        null,
        "0"
    ],
    [
        "th",
        // Thailand
        "66",
        0,
        null,
        "0"
    ],
    [
        "tl",
        // Timor-Leste
        "670"
    ],
    [
        "tg",
        // Togo
        "228"
    ],
    [
        "tk",
        // Tokelau
        "690"
    ],
    [
        "to",
        // Tonga
        "676"
    ],
    [
        "tt",
        // Trinidad & Tobago
        "1",
        22,
        [
            "868"
        ],
        "1"
    ],
    [
        "tn",
        // Tunisia
        "216"
    ],
    [
        "tr",
        // Turkey
        "90",
        0,
        null,
        "0"
    ],
    [
        "tm",
        // Turkmenistan
        "993",
        0,
        null,
        "8"
    ],
    [
        "tc",
        // Turks & Caicos Islands
        "1",
        23,
        [
            "649"
        ],
        "1"
    ],
    [
        "tv",
        // Tuvalu
        "688"
    ],
    [
        "vi",
        // U.S. Virgin Islands
        "1",
        24,
        [
            "340"
        ],
        "1"
    ],
    [
        "ug",
        // Uganda
        "256",
        0,
        null,
        "0"
    ],
    [
        "ua",
        // Ukraine
        "380",
        0,
        null,
        "0"
    ],
    [
        "ae",
        // United Arab Emirates
        "971",
        0,
        null,
        "0"
    ],
    [
        "gb",
        // United Kingdom
        "44",
        0,
        null,
        "0"
    ],
    [
        "us",
        // United States
        "1",
        0,
        null,
        "1"
    ],
    [
        "uy",
        // Uruguay
        "598",
        0,
        null,
        "0"
    ],
    [
        "uz",
        // Uzbekistan
        "998"
    ],
    [
        "vu",
        // Vanuatu
        "678"
    ],
    [
        "va",
        // Vatican City
        "39",
        1,
        [
            "06698",
            "3"
        ]
    ],
    [
        "ve",
        // Venezuela
        "58",
        0,
        null,
        "0"
    ],
    [
        "vn",
        // Vietnam
        "84",
        0,
        null,
        "0"
    ],
    [
        "wf",
        // Wallis & Futuna
        "681"
    ],
    [
        "eh",
        // Western Sahara
        "212",
        1,
        [
            "5288",
            "5289",
            "6",
            "7"
        ],
        // (6 and 7 are mobile ranges shared with MA)
        "0"
    ],
    [
        "ye",
        // Yemen
        "967",
        0,
        null,
        "0"
    ],
    [
        "zm",
        // Zambia
        "260",
        0,
        null,
        "0"
    ],
    [
        "zw",
        // Zimbabwe
        "263",
        0,
        null,
        "0"
    ]
];
var $1b5b6cd373c57766$var$allCountries = [];
for (const c of $1b5b6cd373c57766$var$rawCountryData)$1b5b6cd373c57766$var$allCountries.push({
    name: "",
    // populated in the core library
    iso2: c[0],
    dialCode: c[1],
    priority: c[2] || 0,
    areaCodes: c[3] || null,
    nationalPrefix: c[4] || null
});
var $1b5b6cd373c57766$var$iso2Set = new Set($1b5b6cd373c57766$var$allCountries.map((c)=>c.iso2));
var $1b5b6cd373c57766$var$isIso2 = (val)=>$1b5b6cd373c57766$var$iso2Set.has(val);
var $1b5b6cd373c57766$var$data_default = $1b5b6cd373c57766$var$allCountries;
// packages/core/src/js/constants.ts
var $1b5b6cd373c57766$var$EVENTS = {
    OPEN_COUNTRY_DROPDOWN: "open:countrydropdown",
    CLOSE_COUNTRY_DROPDOWN: "close:countrydropdown",
    COUNTRY_CHANGE: "countrychange",
    INPUT: "input",
    // used for synthetic input trigger
    STRICT_REJECT: "strict:reject"
};
var $1b5b6cd373c57766$var$CLASSES = {
    HIDE: "iti__hide",
    V_HIDE: "iti__v-hide",
    ARROW_UP: "iti__arrow--up",
    GLOBE: "iti__globe",
    FLAG: "iti__flag",
    LOADING: "iti__loading",
    COUNTRY_ITEM: "iti__country",
    HIGHLIGHT: "iti__highlight",
    STRICT_REJECT_ANIMATION: "iti__strict-reject-animation"
};
var $1b5b6cd373c57766$var$KEYS = {
    ARROW_UP: "ArrowUp",
    ARROW_DOWN: "ArrowDown",
    SPACE: " ",
    ENTER: "Enter",
    ESC: "Escape",
    TAB: "Tab"
};
var $1b5b6cd373c57766$var$INPUT_TYPES = {
    PASTE: "insertFromPaste",
    DELETE_FORWARD: "deleteContentForward"
};
var $1b5b6cd373c57766$var$REGEX = {
    ALPHA_UNICODE: /\p{L}/u,
    // any kind of letter from any language
    NON_PLUS_NUMERIC: /[^+0-9]/,
    // chars that are NOT + or digit
    NON_PLUS_NUMERIC_GLOBAL: /[^+0-9]/g,
    // chars that are NOT + or digit (global)
    HIDDEN_SEARCH_CHAR: /^[a-zA-ZÀ-ÿа-яА-Я ]$/
};
var $1b5b6cd373c57766$var$TIMINGS = {
    SEARCH_DEBOUNCE_MS: 100,
    HIDDEN_SEARCH_RESET_MS: 1e3,
    NEXT_TICK: 0
};
var $1b5b6cd373c57766$var$LAYOUT = {
    NARROW_VIEWPORT_WIDTH: 500,
    // keep in sync with .iti__country-list CSS media query
    FALLBACK_SELECTED_WITH_DIAL_WIDTH: 78,
    // px width fallback when separateDialCode enabled
    FALLBACK_SELECTED_NO_DIAL_WIDTH: 42,
    // px width fallback when no separate dial code
    INPUT_PADDING_EXTRA_LEFT: 6,
    // px gap between selected country container and input text
    DROPDOWN_MARGIN: 3,
    // px margin between dropdown and tel input
    FALLBACK_DROPDOWN_HEIGHT: 200
};
var $1b5b6cd373c57766$var$DIAL_CODE = {
    PLUS: "+",
    NANP: "1"
};
var $1b5b6cd373c57766$var$UK = {
    ISO2: "gb",
    DIAL_CODE: "44",
    // +44 United Kingdom
    MOBILE_PREFIX: "7",
    // UK mobile numbers start with 7 after national trunk (0) or core section
    MOBILE_CORE_LENGTH: 10
};
var $1b5b6cd373c57766$var$US = {
    ISO2: "us",
    DIAL_CODE: "1"
};
var $1b5b6cd373c57766$var$PLACEHOLDER_MODES = {
    AGGRESSIVE: "aggressive",
    POLITE: "polite",
    OFF: "off"
};
var $1b5b6cd373c57766$var$INITIAL_COUNTRY = {
    AUTO: "auto"
};
var $1b5b6cd373c57766$var$NUMBER_FORMATS = [
    "E164",
    "INTERNATIONAL",
    "NATIONAL",
    "RFC3966"
];
var $1b5b6cd373c57766$var$NUMBER_TYPES = [
    "FIXED_LINE",
    "MOBILE",
    "FIXED_LINE_OR_MOBILE",
    "TOLL_FREE",
    "PREMIUM_RATE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL",
    "UNKNOWN"
];
var $1b5b6cd373c57766$var$VALIDATION_ERRORS = [
    "IS_POSSIBLE",
    "INVALID_COUNTRY_CODE",
    "TOO_SHORT",
    "TOO_LONG",
    "IS_POSSIBLE_LOCAL_ONLY",
    "INVALID_LENGTH"
];
var $1b5b6cd373c57766$var$toEnumObject = (arr)=>Object.fromEntries(arr.map((v)=>[
            v,
            v
        ]));
var $1b5b6cd373c57766$var$NUMBER_FORMAT = $1b5b6cd373c57766$var$toEnumObject($1b5b6cd373c57766$var$NUMBER_FORMATS);
var $1b5b6cd373c57766$var$NUMBER_TYPE = $1b5b6cd373c57766$var$toEnumObject($1b5b6cd373c57766$var$NUMBER_TYPES);
var $1b5b6cd373c57766$var$VALIDATION_ERROR = $1b5b6cd373c57766$var$toEnumObject($1b5b6cd373c57766$var$VALIDATION_ERRORS);
var $1b5b6cd373c57766$var$DATA_KEYS = {
    // e.g. <li data-iso2="us"> for country items in dropdown
    ISO2: "iso2",
    DIAL_CODE: "dialCode",
    // e.g. <input data-intl-tel-input-id="0"> on the input element
    INSTANCE_ID: "intlTelInputId"
};
var $1b5b6cd373c57766$var$ARIA = {
    EXPANDED: "aria-expanded",
    LABEL: "aria-label",
    SELECTED: "aria-selected",
    ACTIVE_DESCENDANT: "aria-activedescendant",
    HASPOPUP: "aria-haspopup",
    CONTROLS: "aria-controls",
    HIDDEN: "aria-hidden",
    AUTOCOMPLETE: "aria-autocomplete",
    MODAL: "aria-modal"
};
// packages/core/src/js/i18n/en.ts
var $1b5b6cd373c57766$var$interfaceTranslations = {
    selectedCountryAriaLabel: "Change country for phone number, currently selected ${countryName} (${dialCode})",
    noCountrySelected: "Select country for phone number",
    countryListAriaLabel: "List of countries",
    searchPlaceholder: "Search",
    clearSearchAriaLabel: "Clear search",
    searchEmptyState: "No results found",
    searchSummaryAria (count) {
        if (count === 0) return "No results found";
        if (count === 1) return "1 result found";
        return `${count} results found`;
    }
};
var $1b5b6cd373c57766$var$en_default = $1b5b6cd373c57766$var$interfaceTranslations;
// packages/core/src/js/core/options.ts
var $1b5b6cd373c57766$var$mediaQuery = (q)=>typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(q).matches;
var $1b5b6cd373c57766$var$isNarrowViewport = ()=>$1b5b6cd373c57766$var$mediaQuery(`(max-width: ${$1b5b6cd373c57766$var$LAYOUT.NARROW_VIEWPORT_WIDTH}px)`);
var $1b5b6cd373c57766$var$computeDefaultUseFullscreenPopup = ()=>{
    if (typeof navigator !== "undefined" && typeof window !== "undefined") {
        const isShortViewport = $1b5b6cd373c57766$var$mediaQuery("(max-height: 600px)");
        const isCoarsePointer = $1b5b6cd373c57766$var$mediaQuery("(pointer: coarse)");
        return $1b5b6cd373c57766$var$isNarrowViewport() || isCoarsePointer && isShortViewport;
    }
    return false;
};
var $1b5b6cd373c57766$var$defaults = {
    //* Whether or not to allow the dropdown.
    allowDropdown: true,
    //* The number type to enforce during validation.
    allowedNumberTypes: [
        $1b5b6cd373c57766$var$NUMBER_TYPE.MOBILE,
        $1b5b6cd373c57766$var$NUMBER_TYPE.FIXED_LINE
    ],
    //* Whether or not to allow extensions after the main number.
    allowNumberExtensions: false,
    // Allow alphanumeric "phonewords" (e.g. +1 800 FLOWERS) as valid numbers
    allowPhonewords: false,
    //* Add a placeholder in the input with an example number for the selected country.
    autoPlaceholder: $1b5b6cd373c57766$var$PLACEHOLDER_MODES.POLITE,
    //* Add a custom class to the (injected) container element.
    containerClass: "",
    //* Locale for localising country names via Intl.DisplayNames.
    countryNameLocale: "en",
    //* Override individual country names by iso2 code.
    countryNameOverrides: {},
    //* The order of the countries in the dropdown. Defaults to alphabetical.
    countryOrder: null,
    //* Add a country search input at the top of the dropdown.
    countrySearch: true,
    //* Modify the auto placeholder.
    customPlaceholder: null,
    //* Always show the dropdown
    dropdownAlwaysOpen: false,
    //* Append menu to specified element.
    dropdownContainer: null,
    //* Don't display these countries.
    excludeCountries: null,
    //* Fix the dropdown width to the input width (rather than being as wide as the longest country name).
    fixDropdownWidth: true,
    //* Format the number as the user types
    formatAsYouType: true,
    //* Format the input value during initialisation and on setNumber.
    formatOnDisplay: true,
    //* geoIp lookup function.
    geoIpLookup: null,
    //* Inject a hidden input with the name returned from this function, and on submit, populate it with the result of getNumber.
    hiddenInput: null,
    //* Internationalise the core library text e.g. search input placeholder, country names.
    i18n: {},
    //* Initial country.
    initialCountry: "",
    //* A function to load the utils script.
    loadUtils: null,
    //* National vs international formatting for numbers e.g. placeholders and displaying existing numbers.
    nationalMode: false,
    //* Display only these countries.
    onlyCountries: null,
    //* Number type to use for placeholders.
    placeholderNumberType: $1b5b6cd373c57766$var$NUMBER_TYPE.MOBILE,
    //* Add custom classes to the search input element.
    searchInputClass: "",
    //* Display the international dial code next to the selected flag.
    separateDialCode: true,
    //* When strictMode rejects a key (etc), play a short feedback animation
    strictRejectAnimation: true,
    //* Show flags - for both the selected country, and in the country dropdown
    showFlags: true,
    //* Only allow certain chars e.g. a plus followed by numeric digits, and cap at max valid length.
    strictMode: true,
    //* Use full screen popup instead of dropdown for country list.
    useFullscreenPopup: $1b5b6cd373c57766$var$computeDefaultUseFullscreenPopup()
};
var $1b5b6cd373c57766$var$toString = (val)=>JSON.stringify(val);
var $1b5b6cd373c57766$var$isPlainObject = (val)=>Boolean(val) && typeof val === "object" && !Array.isArray(val);
var $1b5b6cd373c57766$var$isFunction = (val)=>typeof val === "function";
var $1b5b6cd373c57766$var$isElLike = (val)=>{
    if (!val || typeof val !== "object") return false;
    const v = val;
    return v.nodeType === 1 && typeof v.tagName === "string" && typeof v.appendChild === "function";
};
var $1b5b6cd373c57766$var$placeholderModeSet = new Set(Object.values($1b5b6cd373c57766$var$PLACEHOLDER_MODES));
var $1b5b6cd373c57766$var$warn = (message)=>{
    console.warn(`[intl-tel-input] ${message}`);
};
var $1b5b6cd373c57766$var$warnOption = (optionName, expectedType, actualValue)=>{
    $1b5b6cd373c57766$var$warn(`Option '${optionName}' must be ${expectedType}; got ${$1b5b6cd373c57766$var$toString(actualValue)}. Ignoring.`);
};
var $1b5b6cd373c57766$var$validateIso2Array = (key, value)=>{
    const expectedType = "an array of iso2 country code strings";
    if (!Array.isArray(value)) {
        $1b5b6cd373c57766$var$warnOption(key, expectedType, value);
        return false;
    }
    const valid = [];
    for (const v of value){
        if (typeof v !== "string") {
            $1b5b6cd373c57766$var$warnOption(key, expectedType, value);
            return false;
        }
        const lower = v.toLowerCase();
        if (!$1b5b6cd373c57766$var$isIso2(lower)) $1b5b6cd373c57766$var$warn(`Invalid iso2 code in '${key}': '${v}'. Skipping.`);
        else valid.push(v);
    }
    return valid;
};
var $1b5b6cd373c57766$var$validateOptions = (customOptions)=>{
    if (customOptions === void 0) return {};
    if (!$1b5b6cd373c57766$var$isPlainObject(customOptions)) {
        const error = `The second argument must be an options object; got ${$1b5b6cd373c57766$var$toString(customOptions)}. Using defaults.`;
        $1b5b6cd373c57766$var$warn(error);
        return {};
    }
    const validatedOptions = {};
    for (const [key, value] of Object.entries(customOptions)){
        if (!Object.hasOwn($1b5b6cd373c57766$var$defaults, key)) {
            $1b5b6cd373c57766$var$warn(`Unknown option '${key}'. Ignoring.`);
            continue;
        }
        switch(key){
            case "allowDropdown":
            case "allowNumberExtensions":
            case "allowPhonewords":
            case "countrySearch":
            case "dropdownAlwaysOpen":
            case "fixDropdownWidth":
            case "formatAsYouType":
            case "formatOnDisplay":
            case "nationalMode":
            case "showFlags":
            case "separateDialCode":
            case "strictMode":
            case "strictRejectAnimation":
            case "useFullscreenPopup":
                if (typeof value !== "boolean") {
                    $1b5b6cd373c57766$var$warnOption(key, "a boolean", value);
                    break;
                }
                validatedOptions[key] = value;
                break;
            case "autoPlaceholder":
                if (typeof value !== "string" || !$1b5b6cd373c57766$var$placeholderModeSet.has(value)) {
                    const validModes = Array.from($1b5b6cd373c57766$var$placeholderModeSet).join(", ");
                    $1b5b6cd373c57766$var$warnOption("autoPlaceholder", `one of ${validModes}`, value);
                    break;
                }
                validatedOptions[key] = value;
                break;
            case "containerClass":
            case "searchInputClass":
            case "countryNameLocale":
                if (typeof value !== "string") {
                    $1b5b6cd373c57766$var$warnOption(key, "a string", value);
                    break;
                }
                validatedOptions[key] = value;
                break;
            case "countryOrder":
                if (value === null) validatedOptions[key] = value;
                else {
                    const filtered = $1b5b6cd373c57766$var$validateIso2Array(key, value);
                    if (filtered !== false) validatedOptions[key] = filtered;
                }
                break;
            case "customPlaceholder":
            case "geoIpLookup":
            case "hiddenInput":
            case "loadUtils":
                if (value !== null && !$1b5b6cd373c57766$var$isFunction(value)) {
                    $1b5b6cd373c57766$var$warnOption(key, "a function or null", value);
                    break;
                }
                validatedOptions[key] = value;
                break;
            case "dropdownContainer":
                if (value !== null && !$1b5b6cd373c57766$var$isElLike(value)) {
                    $1b5b6cd373c57766$var$warnOption("dropdownContainer", "an HTMLElement or null", value);
                    break;
                }
                validatedOptions[key] = value;
                break;
            case "excludeCountries":
            case "onlyCountries":
                if (value === null) validatedOptions[key] = value;
                else {
                    const filtered = $1b5b6cd373c57766$var$validateIso2Array(key, value);
                    if (filtered !== false) validatedOptions[key] = filtered;
                }
                break;
            case "i18n":
                if (value && !$1b5b6cd373c57766$var$isPlainObject(value)) {
                    $1b5b6cd373c57766$var$warnOption("i18n", "an object", value);
                    break;
                }
                validatedOptions[key] = value;
                break;
            case "countryNameOverrides":
                if (value && !$1b5b6cd373c57766$var$isPlainObject(value)) {
                    $1b5b6cd373c57766$var$warnOption("countryNameOverrides", "an object", value);
                    break;
                }
                validatedOptions[key] = value;
                break;
            case "initialCountry":
                {
                    if (typeof value !== "string") {
                        $1b5b6cd373c57766$var$warnOption("initialCountry", "a string", value);
                        break;
                    }
                    const lower = value.toLowerCase();
                    if (lower && lower !== $1b5b6cd373c57766$var$INITIAL_COUNTRY.AUTO && !$1b5b6cd373c57766$var$isIso2(lower)) {
                        $1b5b6cd373c57766$var$warnOption("initialCountry", "a valid iso2 country code or 'auto'", value);
                        break;
                    }
                    validatedOptions[key] = value;
                    break;
                }
            case "placeholderNumberType":
                if (typeof value !== "string" || !$1b5b6cd373c57766$var$NUMBER_TYPES.includes(value)) {
                    const validTypes = $1b5b6cd373c57766$var$NUMBER_TYPES.join(", ");
                    $1b5b6cd373c57766$var$warnOption("placeholderNumberType", `one of ${validTypes}`, value);
                    break;
                }
                validatedOptions[key] = value;
                break;
            case "allowedNumberTypes":
                if (value !== null) {
                    if (!Array.isArray(value)) {
                        $1b5b6cd373c57766$var$warnOption("allowedNumberTypes", "an array of number types or null", value);
                        break;
                    }
                    let allValid = true;
                    for (const v of value)if (typeof v !== "string" || !$1b5b6cd373c57766$var$NUMBER_TYPES.includes(v)) {
                        const validTypes = $1b5b6cd373c57766$var$NUMBER_TYPES.join(", ");
                        $1b5b6cd373c57766$var$warnOption("allowedNumberTypes", `an array of valid number types (${validTypes})`, v);
                        allValid = false;
                        break;
                    }
                    if (allValid) validatedOptions[key] = value;
                } else validatedOptions[key] = null;
                break;
        }
    }
    return validatedOptions;
};
var $1b5b6cd373c57766$var$normaliseOptions = (o)=>{
    if (o.initialCountry) o.initialCountry = o.initialCountry.toLowerCase();
    if (o.onlyCountries?.length) o.onlyCountries = o.onlyCountries.map((c)=>c.toLowerCase());
    if (o.excludeCountries?.length) o.excludeCountries = o.excludeCountries.map((c)=>c.toLowerCase());
    if (o.countryOrder) o.countryOrder = o.countryOrder.map((c)=>c.toLowerCase());
};
var $1b5b6cd373c57766$var$applyOptionSideEffects = (o)=>{
    if (o.dropdownAlwaysOpen) {
        o.useFullscreenPopup = false;
        o.allowDropdown = true;
    }
    if (o.useFullscreenPopup) o.fixDropdownWidth = false;
    else if ($1b5b6cd373c57766$var$isNarrowViewport()) o.fixDropdownWidth = true;
    if (o.onlyCountries?.length === 1) o.initialCountry = o.onlyCountries[0];
    if (o.separateDialCode) o.nationalMode = false;
    if (o.allowDropdown && !o.showFlags && !o.separateDialCode) o.nationalMode = false;
    if (o.useFullscreenPopup && !o.dropdownContainer) o.dropdownContainer = document.body;
    o.i18n = {
        ...$1b5b6cd373c57766$var$en_default,
        ...o.i18n
    };
};
// packages/core/src/js/helpers/string.ts
var $1b5b6cd373c57766$var$getNumeric = (s)=>s.replace(/\D/g, "");
var $1b5b6cd373c57766$var$normaliseString = (s = "")=>s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
// packages/core/src/js/helpers/dom.ts
var $1b5b6cd373c57766$var$buildClassNames = (flags)=>Object.keys(flags).filter((k)=>Boolean(flags[k])).join(" ");
var $1b5b6cd373c57766$var$createEl = (tagName, attrs, container)=>{
    const el = document.createElement(tagName);
    if (attrs) Object.entries(attrs).forEach(([key, value])=>el.setAttribute(key, value));
    if (container) container.appendChild(el);
    return el;
};
// packages/core/src/js/core/icons.ts
var $1b5b6cd373c57766$var$SVG_NS = "http://www.w3.org/2000/svg";
var $1b5b6cd373c57766$var$buildSvg = ([tag, attrs, children])=>{
    const el = document.createElementNS($1b5b6cd373c57766$var$SVG_NS, tag);
    if (attrs) for(const k in attrs)el.setAttribute(k, String(attrs[k]));
    if (children) for (const c of children)el.appendChild($1b5b6cd373c57766$var$buildSvg(c));
    return el;
};
var $1b5b6cd373c57766$var$buildSearchIcon = ()=>$1b5b6cd373c57766$var$buildSvg([
        "svg",
        {
            class: "iti__search-icon-svg",
            width: 14,
            height: 14,
            viewBox: "0 0 24 24",
            focusable: "false",
            [$1b5b6cd373c57766$var$ARIA.HIDDEN]: "true"
        },
        [
            [
                "circle",
                {
                    cx: 11,
                    cy: 11,
                    r: 7
                }
            ],
            [
                "line",
                {
                    x1: 21,
                    y1: 21,
                    x2: 16.65,
                    y2: 16.65
                }
            ]
        ]
    ]);
var $1b5b6cd373c57766$var$buildClearIcon = (id)=>{
    const maskId = `iti-${id}-clear-mask`;
    return $1b5b6cd373c57766$var$buildSvg([
        "svg",
        {
            class: "iti__search-clear-svg",
            width: 12,
            height: 12,
            viewBox: "0 0 16 16",
            [$1b5b6cd373c57766$var$ARIA.HIDDEN]: "true",
            focusable: "false"
        },
        [
            [
                "mask",
                {
                    id: maskId,
                    maskUnits: "userSpaceOnUse"
                },
                [
                    [
                        "rect",
                        {
                            width: 16,
                            height: 16,
                            fill: "white"
                        }
                    ],
                    [
                        "path",
                        {
                            d: "M5.2 5.2 L10.8 10.8 M10.8 5.2 L5.2 10.8",
                            stroke: "black",
                            "stroke-linecap": "round",
                            class: "iti__search-clear-x"
                        }
                    ]
                ]
            ],
            [
                "circle",
                {
                    cx: 8,
                    cy: 8,
                    r: 8,
                    class: "iti__search-clear-bg",
                    mask: `url(#${maskId})`
                }
            ]
        ]
    ]);
};
var $1b5b6cd373c57766$var$buildCheckIcon = ()=>$1b5b6cd373c57766$var$buildSvg([
        "svg",
        {
            class: "iti__country-check-svg",
            width: 14,
            height: 14,
            viewBox: "0 0 16 16",
            fill: "currentColor",
            focusable: "false",
            [$1b5b6cd373c57766$var$ARIA.HIDDEN]: "true"
        },
        [
            [
                "path",
                {
                    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                }
            ]
        ]
    ]);
var $1b5b6cd373c57766$var$buildGlobeIcon = ()=>$1b5b6cd373c57766$var$buildSvg([
        "svg",
        {
            width: 256,
            height: 256,
            viewBox: "0 0 512 512",
            class: "iti__globe-svg"
        },
        [
            [
                "path",
                {
                    d: "M508 213a240 240 0 0 0-449-87l-2 5-2 5c-8 14-13 30-17 46a65 65 0 0 1 56 4c16-10 35-19 56-27l9-3c-6 23-10 48-10 74h-16l4 6c3 4 5 8 6 13h6c0 22 3 44 8 65l2 10-25-10-4 5 12 18 9 3 6 2 8 3 9 26 1 2 16-7h1l-5-13-1-2c24 6 49 9 75 10v26l11 10 7 7v-30l1-13c22 0 44-3 65-8l10-2-21 48-1 1a317 317 0 0 1-14 23l-21 5h-2c6 16 7 33 1 50a240 240 0 0 0 211-265m-401-56-11 6c19-44 54-79 98-98-11 20-21 44-29 69-21 6-40 15-58 23m154 182v4c-29-1-57-6-81-13-7-25-12-52-13-81h94zm0-109h-94c1-29 6-56 13-81 24-7 52-12 81-13zm0-112c-22 1-44 4-65 8l-10 2 12-30 9-17 1-2a332 332 0 0 1 13-23c13-4 26-6 40-7zm187 69 6 4c4 12 6 25 6 38v1h-68c-1-26-4-51-10-74l48 20 1 1 14 8zm-14-44 10 20c-20-11-43-21-68-29-8-25-18-49-29-69 37 16 67 44 87 78M279 49h1c13 1 27 3 39 7l14 23 1 2a343 343 0 0 1 12 26l2 5 6 16c-23-6-48-9-74-10h-1zm0 87h1c29 1 56 6 81 13 7 24 12 51 12 80v1h-94zm2 207h-2v-94h95c-1 29-6 56-13 81-24 7-51 12-80 13m86 60-20 10c11-20 21-43 29-68 25-8 48-18 68-29-16 37-43 67-77 87m87-115-7 5-16 9-2 1a337 337 0 0 1-47 21c6-24 9-49 10-75h68c0 13-2 27-6 39"
                }
            ],
            [
                "path",
                {
                    d: "m261 428-2-2-22-21a40 40 0 0 0-32-11h-1a37 37 0 0 0-18 8l-1 1-4 2-2 2-5 4c-9-3-36-31-47-44s-32-45-34-55l3-2a151 151 0 0 0 11-9v-1a39 39 0 0 0 5-48l-3-3-11-19-3-4-5-7h-1l-3-3-4-3-5-2a35 35 0 0 0-16-3h-5c-4 1-14 5-24 11l-4 2-4 3-4 2c-9 8-17 17-18 27a380 380 0 0 0 212 259h3c12 0 25-10 36-21l10-12 6-11a39 39 0 0 0-8-40"
                }
            ]
        ]
    ]);
// packages/core/src/js/core/countrySearch.ts
var $1b5b6cd373c57766$var$normaliseName = (s)=>$1b5b6cd373c57766$var$normaliseString(s).replace(/[^\p{L}]+/gu, " ").trim();
var $1b5b6cd373c57766$var$buildSearchTokens = (countries)=>{
    const tokens = /* @__PURE__ */ new Map();
    for (const c of countries){
        const normalisedName = $1b5b6cd373c57766$var$normaliseName(c.name);
        const words = normalisedName.split(" ").filter(Boolean);
        const initials = words.map((w)=>w[0] || "").join("");
        tokens.set(c.iso2, {
            normalisedName: normalisedName,
            words: words,
            initials: initials,
            dialCodePlus: `+${c.dialCode}`
        });
    }
    return tokens;
};
var $1b5b6cd373c57766$var$getMatchedCountries = (countries, searchTokens, query)=>{
    const lowerQuery = $1b5b6cd373c57766$var$normaliseString(query);
    const nameQuery = $1b5b6cd373c57766$var$normaliseName(query);
    const skipNameBuckets = lowerQuery !== "" && nameQuery === "";
    const iso2Matches = [];
    const nameStartsWith = [];
    const nameContains = [];
    const dialCodeMatches = [];
    const dialCodeContains = [];
    const initialsMatches = [];
    const wordMatches = [];
    for (const c of countries){
        const t = searchTokens.get(c.iso2);
        if (c.iso2 === lowerQuery) iso2Matches.push(c);
        else if (!skipNameBuckets && t.normalisedName.startsWith(nameQuery)) nameStartsWith.push(c);
        else if (!skipNameBuckets && t.normalisedName.includes(nameQuery)) nameContains.push(c);
        else if (lowerQuery === c.dialCode || lowerQuery === t.dialCodePlus) dialCodeMatches.push(c);
        else if (t.dialCodePlus.includes(lowerQuery)) dialCodeContains.push(c);
        else if (t.initials.includes(lowerQuery)) initialsMatches.push(c);
    }
    const queryWords = nameQuery.split(" ").filter(Boolean);
    if (queryWords.length > 1 && iso2Matches.length === 0 && nameStartsWith.length === 0 && nameContains.length === 0) {
        const claimed = /* @__PURE__ */ new Set([
            ...dialCodeMatches.map((c)=>c.iso2),
            ...dialCodeContains.map((c)=>c.iso2),
            ...initialsMatches.map((c)=>c.iso2)
        ]);
        for (const c of countries){
            if (claimed.has(c.iso2)) continue;
            const t = searchTokens.get(c.iso2);
            if (queryWords.some((qw)=>t.words.some((sw)=>sw.startsWith(qw)))) wordMatches.push(c);
        }
    }
    const sortByPriority = (a, b)=>a.priority - b.priority;
    return [
        ...iso2Matches,
        ...nameStartsWith,
        ...nameContains,
        // priority sort is only relevant when showing multiple countries with the same dial code (that's what the priority field is used to distinguish between)
        ...dialCodeMatches.sort(sortByPriority),
        ...dialCodeContains.sort(sortByPriority),
        ...initialsMatches,
        ...wordMatches
    ];
};
var $1b5b6cd373c57766$var$findFirstCountryStartingWith = (countries, searchTokens, query)=>{
    const nameQuery = $1b5b6cd373c57766$var$normaliseName(query);
    for (const c of countries){
        const { normalisedName: normalisedName } = searchTokens.get(c.iso2);
        if (normalisedName.startsWith(nameQuery)) return c;
    }
    return null;
};
// packages/core/src/js/core/numerals.ts
var $1b5b6cd373c57766$var$Numerals = class _Numerals {
    #userNumeralSet;
    //* Stateless conversion of any Arabic-Indic / Persian digits to ASCII 0-9.
    //* Use this when you need to normalise digits without affecting any instance's tracked numeral set (e.g. for the country-search query).
    static toAscii(str) {
        if (!str) return "";
        return str.replace(/[٠-٩]/g, (ch)=>String.fromCharCode(48 + (ch.charCodeAt(0) - 1632))).replace(/[۰-۹]/g, (ch)=>String.fromCharCode(48 + (ch.charCodeAt(0) - 1776)));
    }
    constructor(initialValue){
        if (initialValue) this.#updateNumeralSet(initialValue);
    }
    // If any Arabic-Indic digits, then label it as that set. Same for Persian. Otherwise assume ASCII.
    #updateNumeralSet(str) {
        if (/[٠-٩]/.test(str)) this.#userNumeralSet = "arabic-indic";
        else if (/[۰-۹]/.test(str)) this.#userNumeralSet = "persian";
        else this.#userNumeralSet = "ascii";
    }
    // Denormalise ASCII 0-9 to the user's numeral set. If not yet known, return as-is.
    // NOTE: normalise is always called before this, so it should be impossible for the numeral set to be unknown at this point.
    denormalise(str) {
        if (!this.#userNumeralSet || this.#userNumeralSet === "ascii") return str;
        const base = this.#userNumeralSet === "arabic-indic" ? 1632 : 1776;
        return str.replace(/[0-9]/g, (d)=>String.fromCharCode(base + Number(d)));
    }
    // Normalize Eastern Arabic (U+0660-0669) and Persian/Extended Arabic-Indic (U+06F0-06F9) numerals to ASCII 0-9.
    // Tracks the user's numeral set as a side effect so denormalise can mirror it back.
    normalise(str) {
        if (!str) return "";
        this.#updateNumeralSet(str);
        if (this.#userNumeralSet === "ascii") return str;
        return _Numerals.toAscii(str);
    }
    isAscii() {
        return !this.#userNumeralSet || this.#userNumeralSet === "ascii";
    }
};
// packages/core/src/js/core/ui.ts
var $1b5b6cd373c57766$var$UI = class _UI {
    // private
    #options;
    #id;
    #isRTL;
    #originalPaddingLeft = "";
    #countries;
    #searchTokens;
    #searchDebounceTimer = null;
    #inlineDropdownHeight;
    #countryContainerEl;
    #selectedCountryEl;
    #selectedFlagEl;
    #selectedDialCodeEl;
    #dropdownArrowEl;
    #dropdownContentEl;
    #searchIconEl;
    #searchInputEl;
    #searchClearButtonEl;
    #countryListEl;
    #hiddenInputPhoneEl;
    #hiddenInputCountryEl;
    #noResultsMessageEl;
    #searchResultsLiveRegionEl;
    #detachedDropdownEl;
    #selectedListItemEl = null;
    #highlightedListItemEl = null;
    #listItemByIso2 = /* @__PURE__ */ new Map();
    #dropdownAbortController = null;
    #resizeObserver;
    // public
    telInputEl;
    hadInitialPlaceholder;
    constructor(input, options, id){
        input.dataset[$1b5b6cd373c57766$var$DATA_KEYS.INSTANCE_ID] = id.toString();
        this.telInputEl = input;
        this.#options = options;
        this.#id = id;
        this.hadInitialPlaceholder = Boolean(input.getAttribute("placeholder"));
        this.#isRTL = !!this.telInputEl.closest("[dir=rtl]");
        this.#originalPaddingLeft = this.telInputEl.style.paddingLeft;
    }
    // Validate that the provided element is an HTMLInputElement.
    static validateInput(input) {
        const tagName = input?.tagName;
        const isInputEl = Boolean(input) && typeof input === "object" && tagName === "INPUT" && typeof input.setAttribute === "function";
        if (!isInputEl) {
            const type = Object.prototype.toString.call(input);
            throw new TypeError(`The first argument must be an HTMLInputElement, not ${type}`);
        }
    }
    //* Generate all of the markup for the core library: the selected country overlay, and the dropdown.
    buildMarkup(countries, searchTokens) {
        this.#countries = countries;
        this.#searchTokens = searchTokens;
        this.telInputEl.classList.add("iti__tel-input");
        if (!this.telInputEl.hasAttribute("type")) this.telInputEl.setAttribute("type", "tel");
        if (!this.telInputEl.hasAttribute("autocomplete")) this.telInputEl.setAttribute("autocomplete", "tel");
        if (!this.telInputEl.hasAttribute("inputmode")) this.telInputEl.setAttribute("inputmode", "tel");
        const wrapper = this.#createWrapperAndInsert();
        this.#buildCountryContainer(wrapper);
        wrapper.appendChild(this.telInputEl);
        this.#updateInputPaddingAndReveal();
        this.#observeSelectedCountryResize();
        this.#buildHiddenInputs(wrapper);
        this.ensureDropdownWidthSet();
    }
    #createWrapperAndInsert() {
        const { allowDropdown: allowDropdown, showFlags: showFlags, containerClass: containerClass, useFullscreenPopup: useFullscreenPopup } = this.#options;
        const parentClasses = $1b5b6cd373c57766$var$buildClassNames({
            iti: true,
            "iti--input-container": true,
            "iti--allow-dropdown": allowDropdown,
            "iti--show-flags": showFlags,
            "iti--inline-dropdown": !useFullscreenPopup,
            [containerClass]: Boolean(containerClass)
        });
        const wrapper = $1b5b6cd373c57766$var$createEl("div", {
            class: parentClasses
        });
        if (this.#isRTL) wrapper.setAttribute("dir", "ltr");
        this.telInputEl.before(wrapper);
        return wrapper;
    }
    #buildCountryContainer(wrapper) {
        const { allowDropdown: allowDropdown, separateDialCode: separateDialCode, showFlags: showFlags } = this.#options;
        if (!allowDropdown && !showFlags && !separateDialCode) return;
        this.#countryContainerEl = $1b5b6cd373c57766$var$createEl("div", // visibly hidden until we measure its width to set the input padding correctly
        {
            class: `iti__country-container ${$1b5b6cd373c57766$var$CLASSES.V_HIDE}`
        }, wrapper);
        if (allowDropdown) {
            this.#selectedCountryEl = $1b5b6cd373c57766$var$createEl("button", {
                type: "button",
                class: "iti__selected-country",
                [$1b5b6cd373c57766$var$ARIA.EXPANDED]: "false",
                [$1b5b6cd373c57766$var$ARIA.LABEL]: this.#options.i18n.noCountrySelected,
                [$1b5b6cd373c57766$var$ARIA.HASPOPUP]: "dialog",
                [$1b5b6cd373c57766$var$ARIA.CONTROLS]: `iti-${this.#id}__dropdown-content`
            }, this.#countryContainerEl);
            if (this.telInputEl.disabled) this.#selectedCountryEl.setAttribute("disabled", "true");
        } else this.#selectedCountryEl = $1b5b6cd373c57766$var$createEl("div", {
            class: "iti__selected-country"
        }, this.#countryContainerEl);
        const selectedCountryPrimary = $1b5b6cd373c57766$var$createEl("div", {
            class: "iti__selected-country-primary"
        }, this.#selectedCountryEl);
        this.#selectedFlagEl = $1b5b6cd373c57766$var$createEl("div", {
            class: $1b5b6cd373c57766$var$CLASSES.FLAG
        }, selectedCountryPrimary);
        if (allowDropdown) this.#dropdownArrowEl = $1b5b6cd373c57766$var$createEl("div", {
            class: "iti__arrow",
            [$1b5b6cd373c57766$var$ARIA.HIDDEN]: "true"
        }, selectedCountryPrimary);
        if (separateDialCode) this.#selectedDialCodeEl = $1b5b6cd373c57766$var$createEl("div", {
            class: "iti__selected-dial-code"
        }, this.#selectedCountryEl);
        if (allowDropdown) this.#buildDropdownContent();
    }
    ensureDropdownWidthSet() {
        const { fixDropdownWidth: fixDropdownWidth, allowDropdown: allowDropdown } = this.#options;
        if (!allowDropdown || !fixDropdownWidth || this.#dropdownContentEl.style.width) return;
        const inputWidth = this.telInputEl.offsetWidth;
        if (inputWidth > 0) this.#dropdownContentEl.style.width = `${inputWidth}px`;
    }
    #buildDropdownContent() {
        const { fixDropdownWidth: fixDropdownWidth, useFullscreenPopup: useFullscreenPopup, countrySearch: countrySearch, i18n: i18n, dropdownContainer: dropdownContainer, containerClass: containerClass } = this.#options;
        const extraClasses = fixDropdownWidth ? "" : "iti--flexible-dropdown-width";
        this.#dropdownContentEl = $1b5b6cd373c57766$var$createEl("div", {
            id: `iti-${this.#id}__dropdown-content`,
            class: `iti__dropdown-content ${$1b5b6cd373c57766$var$CLASSES.HIDE} ${extraClasses}`,
            role: "dialog",
            [$1b5b6cd373c57766$var$ARIA.MODAL]: "true"
        });
        if (this.#isRTL) this.#dropdownContentEl.setAttribute("dir", "rtl");
        if (countrySearch) this.#buildSearchUI();
        this.#countryListEl = $1b5b6cd373c57766$var$createEl("ul", {
            class: "iti__country-list",
            id: `iti-${this.#id}__country-listbox`,
            role: "listbox",
            [$1b5b6cd373c57766$var$ARIA.LABEL]: i18n.countryListAriaLabel
        }, this.#dropdownContentEl);
        this.#appendListItems();
        if (countrySearch) this.#updateSearchResultsA11yText();
        if (!useFullscreenPopup) {
            this.#inlineDropdownHeight = this.#getHiddenInlineDropdownHeight();
            if (countrySearch) this.#dropdownContentEl.style.height = `${this.#inlineDropdownHeight}px`;
        }
        if (dropdownContainer) {
            const dropdownClasses = $1b5b6cd373c57766$var$buildClassNames({
                iti: true,
                "iti--container": true,
                "iti--fullscreen-popup": useFullscreenPopup,
                "iti--inline-dropdown": !useFullscreenPopup,
                [containerClass]: Boolean(containerClass)
            });
            this.#detachedDropdownEl = $1b5b6cd373c57766$var$createEl("div", {
                class: dropdownClasses
            });
            this.#detachedDropdownEl.appendChild(this.#dropdownContentEl);
        } else this.#countryContainerEl.appendChild(this.#dropdownContentEl);
    }
    #buildSearchUI() {
        const { i18n: i18n, searchInputClass: searchInputClass } = this.#options;
        const searchWrapper = $1b5b6cd373c57766$var$createEl("div", {
            class: "iti__search-input-wrapper"
        }, this.#dropdownContentEl);
        this.#searchIconEl = $1b5b6cd373c57766$var$createEl("span", {
            class: "iti__search-icon",
            [$1b5b6cd373c57766$var$ARIA.HIDDEN]: "true"
        }, searchWrapper);
        this.#searchIconEl.appendChild($1b5b6cd373c57766$var$buildSearchIcon());
        this.#searchInputEl = $1b5b6cd373c57766$var$createEl("input", {
            id: `iti-${this.#id}__search-input`,
            // Chrome says inputs need either a name or an id
            type: "search",
            class: `iti__search-input ${searchInputClass}`,
            placeholder: i18n.searchPlaceholder,
            // role=combobox + aria-autocomplete=list + aria-activedescendant allows maintaining focus on the search input while allowing users to navigate search results with up/down keyboard keys
            role: "combobox",
            [$1b5b6cd373c57766$var$ARIA.EXPANDED]: "true",
            [$1b5b6cd373c57766$var$ARIA.LABEL]: i18n.searchPlaceholder,
            [$1b5b6cd373c57766$var$ARIA.CONTROLS]: `iti-${this.#id}__country-listbox`,
            [$1b5b6cd373c57766$var$ARIA.AUTOCOMPLETE]: "list",
            autocomplete: "off"
        }, searchWrapper);
        this.#searchClearButtonEl = $1b5b6cd373c57766$var$createEl("button", {
            type: "button",
            class: `iti__search-clear ${$1b5b6cd373c57766$var$CLASSES.HIDE}`,
            [$1b5b6cd373c57766$var$ARIA.LABEL]: i18n.clearSearchAriaLabel,
            tabindex: "-1"
        }, searchWrapper);
        this.#searchClearButtonEl.appendChild($1b5b6cd373c57766$var$buildClearIcon(this.#id));
        this.#searchResultsLiveRegionEl = $1b5b6cd373c57766$var$createEl("span", {
            class: "iti__a11y-text"
        }, this.#dropdownContentEl);
        this.#noResultsMessageEl = $1b5b6cd373c57766$var$createEl("div", {
            class: `iti__no-results ${$1b5b6cd373c57766$var$CLASSES.HIDE}`,
            [$1b5b6cd373c57766$var$ARIA.HIDDEN]: "true"
        }, this.#dropdownContentEl);
        this.#noResultsMessageEl.textContent = i18n.searchEmptyState ?? null;
    }
    #updateInputPaddingAndReveal() {
        if (!this.#countryContainerEl) return;
        this.#updateInputPadding();
        this.#countryContainerEl.classList.remove($1b5b6cd373c57766$var$CLASSES.V_HIDE);
    }
    #buildHiddenInputs(wrapper) {
        const { hiddenInput: hiddenInput } = this.#options;
        if (!hiddenInput) return;
        const telInputName = this.telInputEl.getAttribute("name") || "";
        const names = hiddenInput(telInputName);
        if (names.phone) {
            const existingInput = this.telInputEl.form?.querySelector(`input[name="${names.phone}"]`);
            if (existingInput) this.#hiddenInputPhoneEl = existingInput;
            else {
                this.#hiddenInputPhoneEl = $1b5b6cd373c57766$var$createEl("input", {
                    type: "hidden",
                    name: names.phone
                });
                wrapper.appendChild(this.#hiddenInputPhoneEl);
            }
        }
        if (names.country) {
            const existingInput = this.telInputEl.form?.querySelector(`input[name="${names.country}"]`);
            if (existingInput) this.#hiddenInputCountryEl = existingInput;
            else {
                this.#hiddenInputCountryEl = $1b5b6cd373c57766$var$createEl("input", {
                    type: "hidden",
                    name: names.country
                });
                wrapper.appendChild(this.#hiddenInputCountryEl);
            }
        }
    }
    //* For each country: add a country list item <li> to the countryList <ul> container.
    #appendListItems() {
        const frag = document.createDocumentFragment();
        for(let i = 0; i < this.#countries.length; i++){
            const c = this.#countries[i];
            const liClass = $1b5b6cd373c57766$var$buildClassNames({
                [$1b5b6cd373c57766$var$CLASSES.COUNTRY_ITEM]: true
            });
            const listItem = $1b5b6cd373c57766$var$createEl("li", {
                id: `iti-${this.#id}__item-${c.iso2}`,
                class: liClass,
                tabindex: "-1",
                role: "option",
                [$1b5b6cd373c57766$var$ARIA.SELECTED]: "false"
            });
            listItem.dataset[$1b5b6cd373c57766$var$DATA_KEYS.DIAL_CODE] = c.dialCode;
            listItem.dataset[$1b5b6cd373c57766$var$DATA_KEYS.ISO2] = c.iso2;
            this.#listItemByIso2.set(c.iso2, listItem);
            if (this.#options.showFlags) $1b5b6cd373c57766$var$createEl("div", {
                class: `${$1b5b6cd373c57766$var$CLASSES.FLAG} iti__${c.iso2}`
            }, listItem);
            const nameEl = $1b5b6cd373c57766$var$createEl("span", {
                class: "iti__country-name"
            }, listItem);
            nameEl.textContent = `${c.name} `;
            const dialEl = $1b5b6cd373c57766$var$createEl("span", {
                class: "iti__dial-code"
            }, nameEl);
            if (this.#isRTL) dialEl.setAttribute("dir", "ltr");
            dialEl.textContent = `(+${c.dialCode})`;
            frag.appendChild(listItem);
        }
        this.#countryListEl.appendChild(frag);
    }
    //* Update the input padding to make space for (1) the selected country/globe, (2) the arrow, and (3) the separate dial code, all of which are optional, hence handling this in the JS rather than CSS.
    #updateInputPadding() {
        if (this.#selectedCountryEl) {
            const fallbackWidth = this.#options.separateDialCode ? $1b5b6cd373c57766$var$LAYOUT.FALLBACK_SELECTED_WITH_DIAL_WIDTH : $1b5b6cd373c57766$var$LAYOUT.FALLBACK_SELECTED_NO_DIAL_WIDTH;
            const selectedCountryWidth = this.#selectedCountryEl.offsetWidth || this.#getHiddenSelectedCountryWidth() || fallbackWidth;
            const inputPadding = selectedCountryWidth + $1b5b6cd373c57766$var$LAYOUT.INPUT_PADDING_EXTRA_LEFT;
            this.telInputEl.style.paddingLeft = `${inputPadding}px`;
        }
    }
    //* Keep the input padding in sync when the selected country's rendered width changes — e.g. responsive font-size shifts that change the dial code text width. Skip while hidden (offsetWidth === 0) so we don't waste work or clobber the padding using a fallback constant.
    #observeSelectedCountryResize() {
        if (!this.#selectedCountryEl || typeof ResizeObserver === "undefined") return;
        this.#resizeObserver = new ResizeObserver(()=>{
            if (this.#selectedCountryEl?.offsetWidth) this.#updateInputPadding();
        });
        this.#resizeObserver.observe(this.#selectedCountryEl);
    }
    static #getBody() {
        let body;
        try {
            body = window.top.document.body;
        } catch (e) {
            body = document.body;
        }
        return body;
    }
    //* When input is in a hidden container during init, we cannot calculate the selected country width.
    //* Fix: clone the markup, make it invisible, add it to the end of the DOM, and then measure it's width.
    //* To get the right styling to apply, all we need is a shallow clone of the container,
    //* and then to inject a deep clone of the selectedCountryEl element.
    #getHiddenSelectedCountryWidth() {
        if (!this.telInputEl.parentNode) return 0;
        const body = _UI.#getBody();
        const containerClone = this.telInputEl.parentNode.cloneNode(false);
        containerClone.style.visibility = "hidden";
        body.appendChild(containerClone);
        const countryContainerClone = this.#countryContainerEl.cloneNode();
        containerClone.appendChild(countryContainerClone);
        const selectedCountryClone = this.#selectedCountryEl.cloneNode(true);
        countryContainerClone.appendChild(selectedCountryClone);
        const width = selectedCountryClone.offsetWidth;
        body.removeChild(containerClone);
        return width;
    }
    // Get the dropdown height (before it is added to the DOM)
    #getHiddenInlineDropdownHeight() {
        const body = _UI.#getBody();
        this.#dropdownContentEl.classList.remove($1b5b6cd373c57766$var$CLASSES.HIDE);
        const tempContainer = $1b5b6cd373c57766$var$createEl("div", {
            class: "iti iti--inline-dropdown"
        });
        tempContainer.appendChild(this.#dropdownContentEl);
        tempContainer.style.visibility = "hidden";
        body.appendChild(tempContainer);
        const height = this.#dropdownContentEl.offsetHeight;
        body.removeChild(tempContainer);
        tempContainer.style.visibility = "";
        this.#dropdownContentEl.classList.add($1b5b6cd373c57766$var$CLASSES.HIDE);
        return height > 0 ? height : $1b5b6cd373c57766$var$LAYOUT.FALLBACK_DROPDOWN_HEIGHT;
    }
    //* Update search results text (for a11y).
    #updateSearchResultsA11yText() {
        const { i18n: i18n } = this.#options;
        const count = this.#countryListEl.childElementCount;
        this.#searchResultsLiveRegionEl.textContent = i18n.searchSummaryAria(count);
    }
    //* Country search: Filter the countries according to the search query.
    #filterCountriesByQuery(query) {
        let matchedCountries;
        if (query === "") matchedCountries = this.#countries;
        else {
            const normalisedQuery = $1b5b6cd373c57766$var$Numerals.toAscii(query);
            matchedCountries = $1b5b6cd373c57766$var$getMatchedCountries(this.#countries, this.#searchTokens, normalisedQuery);
        }
        this.#showFilteredCountries(matchedCountries);
    }
    //* Pre-fill the search input with "+" and show all countries
    //* (used when user types "+" in the phone input to open the dropdown).
    //* Explicitly focus the search input (openDropdown skips this when
    //* dropdownAlwaysOpen, but here we need focus to redirect subsequent keystrokes).
    prefillSearchWithPlus() {
        this.#searchInputEl.value = "+";
        this.#searchInputEl.focus();
        this.#filterCountriesByQuery("");
    }
    // Search input handlers
    #applySearchFilter() {
        const inputQuery = this.#searchInputEl.value.trim();
        this.#filterCountriesByQuery(inputQuery);
        if (this.#searchInputEl.value) this.#searchClearButtonEl.classList.remove($1b5b6cd373c57766$var$CLASSES.HIDE);
        else this.#searchClearButtonEl.classList.add($1b5b6cd373c57766$var$CLASSES.HIDE);
    }
    #handleSearchChange() {
        if (this.#searchDebounceTimer) clearTimeout(this.#searchDebounceTimer);
        this.#searchDebounceTimer = setTimeout(()=>{
            this.#applySearchFilter();
            this.#searchDebounceTimer = null;
        }, $1b5b6cd373c57766$var$TIMINGS.SEARCH_DEBOUNCE_MS);
    }
    #handleSearchClear() {
        this.#searchInputEl.value = "";
        this.#searchInputEl.focus();
        this.#applySearchFilter();
    }
    //* Check if a country list item element is visible within it's container (the country list), else scroll until it is.
    #scrollCountryListToItem(element) {
        const container = this.#countryListEl;
        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        const offsetTop = elementRect.top - containerRect.top + container.scrollTop;
        if (elementRect.top < containerRect.top) container.scrollTop = offsetTop;
        else if (elementRect.bottom > containerRect.bottom) container.scrollTop = offsetTop - containerRect.height + elementRect.height;
    }
    //* Remove highlighting from the previous list item and highlight the new one.
    #highlightListItem(listItem, doScroll = true) {
        this.#highlightedListItemEl?.classList.remove($1b5b6cd373c57766$var$CLASSES.HIGHLIGHT);
        if (listItem) {
            listItem.classList.add($1b5b6cd373c57766$var$CLASSES.HIGHLIGHT);
            if (this.#options.countrySearch) {
                const activeDescendant = listItem.getAttribute("id") || "";
                this.#searchInputEl.setAttribute($1b5b6cd373c57766$var$ARIA.ACTIVE_DESCENDANT, activeDescendant);
            }
            if (doScroll) this.#scrollCountryListToItem(listItem);
            this.#highlightedListItemEl = listItem;
        } else this.#highlightedListItemEl = null;
    }
    //* Bind a form-submit listener that syncs the hidden inputs with the current phone number
    //* and country iso2. No-op if there are no hidden inputs or the input is not in a form.
    bindHiddenInputSubmitListener(signal, getPhone, getCountryIso2) {
        const form = this.telInputEl.form;
        if (!form || !this.#hiddenInputPhoneEl && !this.#hiddenInputCountryEl) return;
        form.addEventListener("submit", ()=>{
            if (this.#hiddenInputPhoneEl) this.#hiddenInputPhoneEl.value = getPhone();
            if (this.#hiddenInputCountryEl) this.#hiddenInputCountryEl.value = getCountryIso2();
        }, {
            signal: signal
        });
    }
    //* Wire up triggers that open/close the dropdown: label click (focus input or swallow repeat click),
    //* selected-country click (open), and keydown on countryContainer (open on arrow/space/enter, close on tab).
    bindAllInitialDropdownListeners(signal, onOpen, onClose) {
        const label = this.telInputEl.closest("label");
        if (label) label.addEventListener("click", (e)=>{
            if (!this.isDropdownOpen()) this.telInputEl.focus();
            else e.preventDefault();
        }, {
            signal: signal
        });
        this.#selectedCountryEl.addEventListener("click", ()=>{
            if (!this.isDropdownOpen() && !this.telInputEl.disabled && !this.telInputEl.readOnly) onOpen();
        }, {
            signal: signal
        });
        this.#countryContainerEl.addEventListener("keydown", (e)=>{
            const openKeys = [
                $1b5b6cd373c57766$var$KEYS.ARROW_UP,
                $1b5b6cd373c57766$var$KEYS.ARROW_DOWN,
                $1b5b6cd373c57766$var$KEYS.SPACE,
                $1b5b6cd373c57766$var$KEYS.ENTER
            ];
            if (!this.isDropdownOpen() && openKeys.includes(e.key)) {
                e.preventDefault();
                e.stopPropagation();
                onOpen();
            }
            if (e.key === $1b5b6cd373c57766$var$KEYS.TAB) onClose();
        }, {
            signal: signal
        });
    }
    //* Open the dropdown: create a fresh AbortController, do the DOM work, and wire up all
    //* dropdown-open listeners (which invoke the caller's onSelect / onClose callbacks).
    openDropdown(onSelect, onClose) {
        const { countrySearch: countrySearch, dropdownAlwaysOpen: dropdownAlwaysOpen, dropdownContainer: dropdownContainer } = this.#options;
        this.#dropdownAbortController = new AbortController();
        this.ensureDropdownWidthSet();
        if (dropdownContainer) this.#injectAndPositionDetachedDropdown();
        else {
            const positionBelow = this.#shouldPositionInlineDropdownBelowInput();
            const distance = this.telInputEl.offsetHeight + $1b5b6cd373c57766$var$LAYOUT.DROPDOWN_MARGIN;
            if (positionBelow) this.#dropdownContentEl.style.top = `${distance}px`;
            else this.#dropdownContentEl.style.bottom = `${distance}px`;
        }
        this.#dropdownContentEl.classList.remove($1b5b6cd373c57766$var$CLASSES.HIDE);
        this.#selectedCountryEl.setAttribute($1b5b6cd373c57766$var$ARIA.EXPANDED, "true");
        const itemToHighlight = this.#selectedListItemEl ?? this.#countryListEl.firstElementChild;
        if (itemToHighlight) this.#highlightListItem(itemToHighlight);
        if (countrySearch && !dropdownAlwaysOpen) this.#searchInputEl.focus();
        if (this.#options.useFullscreenPopup && this.#detachedDropdownEl && window.visualViewport) window.visualViewport.addEventListener("resize", ()=>{
            this.#adjustFullscreenPopupToViewport();
            if (this.#highlightedListItemEl) this.#scrollCountryListToItem(this.#highlightedListItemEl);
        }, {
            signal: this.#dropdownAbortController.signal
        });
        this.#dropdownArrowEl.classList.add($1b5b6cd373c57766$var$CLASSES.ARROW_UP);
        this.#bindDropdownOpenListeners(onSelect, onClose);
    }
    //* Wire up all listeners needed while the dropdown is open: list-item hover (highlight),
    //* list-item click & enter key (select), click-off & escape (close), search input (filter),
    //* (when countrySearch disabled) typed-char hidden search, and (when dropdown is in an external
    //* container) close on window scroll.
    #bindDropdownOpenListeners(onSelect, onClose) {
        const signal = this.#dropdownAbortController.signal;
        this.#bindListItemHover(signal);
        this.#bindListItemClick(signal, onSelect);
        if (!this.#options.dropdownAlwaysOpen) this.#bindOutsideClickToClose(signal, onClose);
        this.#bindDropdownKeydownListener(signal, onSelect, onClose);
        if (this.#options.countrySearch) this.#bindSearchInputListener(signal);
        if (!this.#options.useFullscreenPopup && this.#options.dropdownContainer) window.addEventListener("scroll", onClose, {
            signal: signal
        });
    }
    //* When mouse over a list item, just highlight that one (so if they hit "enter" we know which to select).
    #bindListItemHover(signal) {
        this.#countryListEl.addEventListener("mouseover", (e)=>{
            const listItem = e.target?.closest(`.${$1b5b6cd373c57766$var$CLASSES.COUNTRY_ITEM}`);
            if (listItem) this.#highlightListItem(listItem, false);
        }, {
            signal: signal
        });
    }
    //* Delegate clicks on the country list to the caller's onSelect callback, passing the clicked list item.
    #bindListItemClick(signal, onSelect) {
        this.#countryListEl.addEventListener("click", (e)=>{
            const listItem = e.target?.closest(`.${$1b5b6cd373c57766$var$CLASSES.COUNTRY_ITEM}`);
            if (listItem) onSelect(listItem);
        }, {
            signal: signal
        });
    }
    //* Invoke onClickOff when the user clicks anywhere outside the dropdown.
    #bindOutsideClickToClose(signal, onClickOff) {
        setTimeout(()=>{
            document.documentElement.addEventListener("click", (e)=>{
                if (!this.#dropdownContentEl.contains(e.target)) onClickOff();
            }, {
                signal: signal
            });
        }, 0);
    }
    //* Keyboard navigation while the dropdown is open: arrow keys navigate, hidden-search keys filter,
    //* and enter/escape invoke the caller's callbacks (which handle country selection / dropdown close).
    //* Uses keydown rather than keypress so non-char keys (arrow, esc) fire and so holding a key repeats.
    #bindDropdownKeydownListener(signal, onEnter, onEscape) {
        let query = "";
        let queryTimer = null;
        const handleKeydown = (e)=>{
            const allowedKeys = [
                $1b5b6cd373c57766$var$KEYS.ARROW_UP,
                $1b5b6cd373c57766$var$KEYS.ARROW_DOWN,
                $1b5b6cd373c57766$var$KEYS.ENTER,
                $1b5b6cd373c57766$var$KEYS.ESC
            ];
            if (allowedKeys.includes(e.key)) {
                e.preventDefault();
                e.stopPropagation();
                if (e.key === $1b5b6cd373c57766$var$KEYS.ARROW_UP || e.key === $1b5b6cd373c57766$var$KEYS.ARROW_DOWN) this.#handleUpDownKey(e.key);
                else if (e.key === $1b5b6cd373c57766$var$KEYS.ENTER && !e.isComposing) onEnter(this.#highlightedListItemEl);
                else if (e.key === $1b5b6cd373c57766$var$KEYS.ESC) {
                    onEscape();
                    this.#selectedCountryEl.focus();
                }
            }
            if (!this.#options.countrySearch && $1b5b6cd373c57766$var$REGEX.HIDDEN_SEARCH_CHAR.test(e.key)) {
                e.stopPropagation();
                if (queryTimer) clearTimeout(queryTimer);
                query += e.key.toLowerCase();
                this.#searchForCountry(query);
                queryTimer = setTimeout(()=>{
                    query = "";
                }, $1b5b6cd373c57766$var$TIMINGS.HIDDEN_SEARCH_RESET_MS);
            }
        };
        this.#selectedCountryEl?.addEventListener("keydown", handleKeydown, {
            signal: signal
        });
        this.#dropdownContentEl?.addEventListener("keydown", handleKeydown, {
            signal: signal
        });
    }
    //* Wire up country search input listener: typing filters the list, the clear button resets it.
    #bindSearchInputListener(signal) {
        this.#searchInputEl.addEventListener("input", ()=>this.#handleSearchChange(), {
            signal: signal
        });
        this.#searchClearButtonEl.addEventListener("click", ()=>this.#handleSearchClear(), {
            signal: signal
        });
    }
    //* Hidden search (countrySearch disabled): jump to the first list item whose name starts with the query.
    #searchForCountry(query) {
        const match = $1b5b6cd373c57766$var$findFirstCountryStartingWith(this.#countries, this.#searchTokens, query);
        if (match) {
            const listItem = this.#listItemByIso2.get(match.iso2);
            this.#highlightListItem(listItem);
        }
    }
    //* Highlight the next/prev item in the list (and ensure it is visible).
    #handleUpDownKey(key) {
        let next = key === $1b5b6cd373c57766$var$KEYS.ARROW_UP ? this.#highlightedListItemEl?.previousElementSibling : this.#highlightedListItemEl?.nextElementSibling;
        if (!next && this.#countryListEl.childElementCount > 1) next = key === $1b5b6cd373c57766$var$KEYS.ARROW_UP ? this.#countryListEl.lastElementChild : this.#countryListEl.firstElementChild;
        if (next) this.#highlightListItem(next);
    }
    // Update the selected list item in the dropdown
    #updateSelectedListItem(iso2) {
        if (this.#selectedListItemEl && this.#selectedListItemEl.dataset[$1b5b6cd373c57766$var$DATA_KEYS.ISO2] !== iso2) {
            this.#selectedListItemEl.setAttribute($1b5b6cd373c57766$var$ARIA.SELECTED, "false");
            this.#selectedListItemEl.querySelector(".iti__country-check")?.remove();
            this.#selectedListItemEl = null;
        }
        if (iso2 && !this.#selectedListItemEl) {
            const newListItem = this.#countryListEl.querySelector(`[data-iso2="${iso2}"]`);
            if (newListItem) {
                newListItem.setAttribute($1b5b6cd373c57766$var$ARIA.SELECTED, "true");
                const checkIcon = $1b5b6cd373c57766$var$createEl("span", {
                    class: "iti__country-check",
                    [$1b5b6cd373c57766$var$ARIA.HIDDEN]: "true"
                }, newListItem);
                checkIcon.appendChild($1b5b6cd373c57766$var$buildCheckIcon());
                this.#selectedListItemEl = newListItem;
                if (this.#options.dropdownAlwaysOpen) this.#highlightListItem(newListItem);
            }
        }
    }
    //* Country search: Filter the country list to the given array of countries.
    #showFilteredCountries(matchedCountries) {
        this.#countryListEl.replaceChildren();
        let noCountriesAddedYet = true;
        for (const c of matchedCountries){
            const listItem = this.#listItemByIso2.get(c.iso2);
            if (listItem) {
                this.#countryListEl.appendChild(listItem);
                if (noCountriesAddedYet) {
                    this.#highlightListItem(listItem, false);
                    noCountriesAddedYet = false;
                }
            }
        }
        if (noCountriesAddedYet) {
            this.#highlightListItem(null);
            if (this.#noResultsMessageEl) this.#noResultsMessageEl.classList.remove($1b5b6cd373c57766$var$CLASSES.HIDE);
        } else if (this.#noResultsMessageEl) this.#noResultsMessageEl.classList.add($1b5b6cd373c57766$var$CLASSES.HIDE);
        this.#countryListEl.scrollTop = 0;
        this.#updateSearchResultsA11yText();
    }
    // UI: Close the dropdown (DOM + abort dropdown-scoped listeners).
    closeDropdown() {
        const { countrySearch: countrySearch, dropdownContainer: dropdownContainer } = this.#options;
        this.#dropdownAbortController.abort();
        this.#dropdownAbortController = null;
        this.#dropdownContentEl.classList.add($1b5b6cd373c57766$var$CLASSES.HIDE);
        this.#selectedCountryEl.setAttribute($1b5b6cd373c57766$var$ARIA.EXPANDED, "false");
        if (countrySearch) {
            this.#searchInputEl.removeAttribute($1b5b6cd373c57766$var$ARIA.ACTIVE_DESCENDANT);
            this.#searchInputEl.value = "";
            this.#applySearchFilter();
            if (this.#highlightedListItemEl) {
                this.#highlightedListItemEl.classList.remove($1b5b6cd373c57766$var$CLASSES.HIGHLIGHT);
                this.#highlightedListItemEl = null;
            }
        }
        this.#dropdownArrowEl.classList.remove($1b5b6cd373c57766$var$CLASSES.ARROW_UP);
        if (dropdownContainer) {
            this.#detachedDropdownEl.remove();
            this.#detachedDropdownEl.style.top = "";
            this.#detachedDropdownEl.style.bottom = "";
            this.#detachedDropdownEl.style.paddingLeft = "";
            this.#detachedDropdownEl.style.paddingRight = "";
        } else {
            this.#dropdownContentEl.style.top = "";
            this.#dropdownContentEl.style.bottom = "";
        }
    }
    #shouldPositionInlineDropdownBelowInput() {
        if (this.#options.dropdownAlwaysOpen) return true;
        const inputPos = this.telInputEl.getBoundingClientRect();
        const spaceAbove = inputPos.top;
        const spaceBelow = window.innerHeight - inputPos.bottom;
        return spaceBelow >= this.#inlineDropdownHeight || spaceBelow >= spaceAbove;
    }
    // inject dropdown into container and apply positioning styles
    #injectAndPositionDetachedDropdown() {
        const { dropdownContainer: dropdownContainer, useFullscreenPopup: useFullscreenPopup } = this.#options;
        if (useFullscreenPopup) {
            if (window.innerWidth >= $1b5b6cd373c57766$var$LAYOUT.NARROW_VIEWPORT_WIDTH) {
                const inputPos = this.telInputEl.getBoundingClientRect();
                this.#detachedDropdownEl.style.paddingLeft = `${inputPos.left}px`;
                this.#detachedDropdownEl.style.paddingRight = `${window.innerWidth - inputPos.right}px`;
            }
        } else {
            const inputPos = this.telInputEl.getBoundingClientRect();
            this.#detachedDropdownEl.style.left = `${inputPos.left}px`;
            const positionBelow = this.#shouldPositionInlineDropdownBelowInput();
            if (positionBelow) this.#detachedDropdownEl.style.top = `${inputPos.bottom + $1b5b6cd373c57766$var$LAYOUT.DROPDOWN_MARGIN}px`;
            else {
                this.#detachedDropdownEl.style.top = "unset";
                this.#detachedDropdownEl.style.bottom = `${window.innerHeight - inputPos.top + $1b5b6cd373c57766$var$LAYOUT.DROPDOWN_MARGIN}px`;
            }
        }
        dropdownContainer.appendChild(this.#detachedDropdownEl);
    }
    // Adjust the fullscreen popup dimensions to match the visual viewport,
    // so it stays above the virtual keyboard on mobile devices.
    #adjustFullscreenPopupToViewport() {
        const vv = window.visualViewport;
        if (!vv || !this.#detachedDropdownEl) return;
        const virtualKeyboardHeight = window.innerHeight - vv.height;
        this.#detachedDropdownEl.style.bottom = `${virtualKeyboardHeight}px`;
    }
    // UI: Whether the dropdown is currently open (visible).
    isDropdownOpen() {
        return !this.#dropdownContentEl.classList.contains($1b5b6cd373c57766$var$CLASSES.HIDE);
    }
    // Toggle the loading spinner on the selected flag (used during auto-country geoIP lookup).
    setLoading(isLoading) {
        this.#selectedFlagEl.classList.toggle($1b5b6cd373c57766$var$CLASSES.LOADING, isLoading);
    }
    //* Play the strict-reject animation (shake, or background-colour flash under prefers-reduced-motion) on the wrapper.
    //* Called when strictMode rejects the whole input (keystroke, or whole paste).
    //* Uses the wrapper (not the input) so any separateDialCode / country button move together with the input.
    playStrictRejectAnimation() {
        if (!this.#options.strictRejectAnimation) return;
        const wrapperEl = this.telInputEl.parentElement;
        if (!wrapperEl) return;
        wrapperEl.classList.remove($1b5b6cd373c57766$var$CLASSES.STRICT_REJECT_ANIMATION);
        wrapperEl.offsetWidth;
        wrapperEl.classList.add($1b5b6cd373c57766$var$CLASSES.STRICT_REJECT_ANIMATION);
        wrapperEl.addEventListener("animationend", ()=>wrapperEl.classList.remove($1b5b6cd373c57766$var$CLASSES.STRICT_REJECT_ANIMATION), {
            once: true
        });
    }
    isLoading() {
        return this.#selectedFlagEl.classList.contains($1b5b6cd373c57766$var$CLASSES.LOADING);
    }
    // Set the disabled state of the input and dropdown.
    setDisabled(disabled) {
        this.telInputEl.disabled = disabled;
        if (this.#selectedCountryEl) {
            if (disabled) this.#selectedCountryEl.setAttribute("disabled", "true");
            else this.#selectedCountryEl.removeAttribute("disabled");
        }
    }
    // Set the readonly state of the input and dropdown.
    setReadonly(readonly) {
        this.telInputEl.readOnly = readonly;
        if (this.#selectedCountryEl) {
            if (readonly) this.#selectedCountryEl.setAttribute("disabled", "true");
            else this.#selectedCountryEl.removeAttribute("disabled");
        }
    }
    setCountry(selectedCountryData) {
        const { allowDropdown: allowDropdown, showFlags: showFlags, separateDialCode: separateDialCode, i18n: i18n } = this.#options;
        const name = selectedCountryData?.name;
        const dialCode = selectedCountryData?.dialCode;
        const iso2 = selectedCountryData?.iso2 ?? "";
        if (allowDropdown) this.#updateSelectedListItem(iso2);
        if (this.#selectedCountryEl) {
            const flagClass = iso2 && showFlags ? `${$1b5b6cd373c57766$var$CLASSES.FLAG} iti__${iso2}` : `${$1b5b6cd373c57766$var$CLASSES.FLAG} ${$1b5b6cd373c57766$var$CLASSES.GLOBE}`;
            let ariaLabel, title;
            let flagContent = null;
            if (iso2) {
                title = name;
                ariaLabel = i18n.selectedCountryAriaLabel.replace("${countryName}", name).replace("${dialCode}", `+${dialCode}`);
                if (!showFlags) flagContent = $1b5b6cd373c57766$var$buildGlobeIcon();
            } else {
                title = i18n.noCountrySelected;
                ariaLabel = i18n.noCountrySelected;
                flagContent = $1b5b6cd373c57766$var$buildGlobeIcon();
            }
            this.#selectedFlagEl.className = flagClass;
            this.#selectedCountryEl.setAttribute("title", title);
            this.#selectedCountryEl.setAttribute($1b5b6cd373c57766$var$ARIA.LABEL, ariaLabel);
            if (flagContent) this.#selectedFlagEl.replaceChildren(flagContent);
            else this.#selectedFlagEl.replaceChildren();
        }
        if (separateDialCode) {
            const fullDialCode = dialCode ? `+${dialCode}` : "";
            this.#selectedDialCodeEl.textContent = fullDialCode;
            this.#updateInputPadding();
        }
    }
    destroy() {
        this.telInputEl.iti = void 0;
        delete this.telInputEl.dataset[$1b5b6cd373c57766$var$DATA_KEYS.INSTANCE_ID];
        this.#resizeObserver?.disconnect();
        this.telInputEl.style.paddingLeft = this.#originalPaddingLeft;
        const wrapper = this.telInputEl.parentNode;
        if (wrapper) {
            wrapper.before(this.telInputEl);
            wrapper.remove();
        }
        this.#listItemByIso2.clear();
    }
};
// packages/core/src/js/data/country-data.ts
var $1b5b6cd373c57766$var$processAllCountries = (options)=>{
    const { onlyCountries: onlyCountries, excludeCountries: excludeCountries } = options;
    if (onlyCountries?.length) return $1b5b6cd373c57766$var$data_default.filter((country)=>onlyCountries.includes(country.iso2));
    else if (excludeCountries?.length) return $1b5b6cd373c57766$var$data_default.filter((country)=>!excludeCountries.includes(country.iso2));
    return [
        ...$1b5b6cd373c57766$var$data_default
    ];
};
var $1b5b6cd373c57766$var$generateCountryNames = (countries, options)=>{
    const { countryNameLocale: countryNameLocale, countryNameOverrides: countryNameOverrides } = options;
    let displayNames;
    try {
        const hasDisplayNames = typeof Intl !== "undefined" && typeof Intl.DisplayNames === "function";
        if (hasDisplayNames) displayNames = new Intl.DisplayNames(countryNameLocale, {
            type: "region"
        });
        else displayNames = null;
    } catch (e) {
        console.error(e);
        displayNames = null;
    }
    for (const c of countries)c.name = countryNameOverrides[c.iso2] || displayNames?.of(c.iso2.toUpperCase()) || "";
};
var $1b5b6cd373c57766$var$processDialCodes = (countries)=>{
    const dialCodes = /* @__PURE__ */ new Set();
    let dialCodeMaxLength = 0;
    const dialCodeToIso2Map = {};
    const addToDialCodeMap = (iso2, dialCode)=>{
        if (!iso2 || !dialCode) return;
        if (dialCode.length > dialCodeMaxLength) dialCodeMaxLength = dialCode.length;
        if (!Object.hasOwn(dialCodeToIso2Map, dialCode)) dialCodeToIso2Map[dialCode] = [];
        const iso2List = dialCodeToIso2Map[dialCode];
        if (iso2List.includes(iso2)) return;
        iso2List.push(iso2);
    };
    const countriesSortedByPriority = [
        ...countries
    ].sort((a, b)=>a.priority - b.priority);
    for (const c of countriesSortedByPriority){
        if (!dialCodes.has(c.dialCode)) dialCodes.add(c.dialCode);
        for(let k = 1; k < c.dialCode.length; k++){
            const partialDialCode = c.dialCode.substring(0, k);
            addToDialCodeMap(c.iso2, partialDialCode);
        }
        addToDialCodeMap(c.iso2, c.dialCode);
        if (c.areaCodes) {
            const rootIso2Code = dialCodeToIso2Map[c.dialCode][0];
            for (const areaCode of c.areaCodes){
                for(let k = 1; k < areaCode.length; k++){
                    const partialAreaCode = areaCode.substring(0, k);
                    const partialDialCode = c.dialCode + partialAreaCode;
                    addToDialCodeMap(rootIso2Code, partialDialCode);
                    addToDialCodeMap(c.iso2, partialDialCode);
                }
                addToDialCodeMap(c.iso2, c.dialCode + areaCode);
            }
        }
    }
    return {
        dialCodes: dialCodes,
        dialCodeMaxLength: dialCodeMaxLength,
        dialCodeToIso2Map: dialCodeToIso2Map
    };
};
var $1b5b6cd373c57766$var$sortCountries = (countries, options)=>{
    const { countryOrder: countryOrder } = options;
    countries.sort((a, b)=>{
        if (countryOrder) {
            const aIndex = countryOrder.indexOf(a.iso2);
            const bIndex = countryOrder.indexOf(b.iso2);
            const aIndexExists = aIndex > -1;
            const bIndexExists = bIndex > -1;
            if (aIndexExists || bIndexExists) {
                if (aIndexExists && bIndexExists) return aIndex - bIndex;
                return aIndexExists ? -1 : 1;
            }
        }
        return a.name.localeCompare(b.name);
    });
};
// packages/core/src/js/data/intl-regionless.ts
var $1b5b6cd373c57766$var$regionlessDialCodes = /* @__PURE__ */ new Set([
    "800",
    "808",
    "870",
    "881",
    "882",
    "883",
    "888",
    "979"
]);
var $1b5b6cd373c57766$var$hasRegionlessDialCode = (number)=>{
    const dialCode = $1b5b6cd373c57766$var$getNumeric(number).slice(0, 3);
    return number.startsWith("+") && $1b5b6cd373c57766$var$regionlessDialCodes.has(dialCode);
};
// packages/core/src/js/format/formatting.ts
var $1b5b6cd373c57766$var$stripSeparateDialCode = (fullNumber, hasValidDialCode, separateDialCode, selectedCountryData)=>{
    if (!separateDialCode || !hasValidDialCode) return fullNumber;
    const dialCode = `+${selectedCountryData.dialCode}`;
    const start = fullNumber[dialCode.length] === " " || fullNumber[dialCode.length] === "-" ? dialCode.length + 1 : dialCode.length;
    return fullNumber.substring(start);
};
var $1b5b6cd373c57766$var$formatNumberAsYouType = (fullNumber, telInputValue, utils, selectedCountryData, separateDialCode)=>{
    const result = utils ? utils.formatNumberAsYouType(fullNumber, selectedCountryData?.iso2) : fullNumber;
    const dialCode = selectedCountryData?.dialCode;
    if (separateDialCode && telInputValue.charAt(0) !== "+" && result.includes(`+${dialCode}`)) {
        const afterDialCode = result.split(`+${dialCode}`)[1] || "";
        return afterDialCode.trim();
    }
    return result;
};
// packages/core/src/js/format/caret.ts
var $1b5b6cd373c57766$var$computeNewCaretPosition = (relevantChars, formattedValue, prevCaretPos, isDeleteForwards)=>{
    if (prevCaretPos === 0 && !isDeleteForwards) return 0;
    let relevantCharCount = 0;
    for(let i = 0; i < formattedValue.length; i++){
        if (/[+0-9]/.test(formattedValue[i])) relevantCharCount++;
        if (relevantCharCount === relevantChars && !isDeleteForwards) return i + 1;
        if (isDeleteForwards && relevantCharCount === relevantChars + 1) return i;
    }
    return formattedValue.length;
};
// packages/core/src/js/data/nanp-regionless.ts
var $1b5b6cd373c57766$var$regionlessNanpAreaCodes = /* @__PURE__ */ new Set([
    "800",
    "822",
    "833",
    "844",
    "855",
    "866",
    "877",
    "880",
    "881",
    "882",
    "883",
    "884",
    "885",
    "886",
    "887",
    "888",
    "889"
]);
var $1b5b6cd373c57766$var$isRegionlessNanp = (number)=>{
    const numeric = $1b5b6cd373c57766$var$getNumeric(number);
    if (numeric.startsWith($1b5b6cd373c57766$var$DIAL_CODE.NANP) && numeric.length >= 4) {
        const areaCode = numeric.substring(1, 4);
        return $1b5b6cd373c57766$var$regionlessNanpAreaCodes.has(areaCode);
    }
    return false;
};
// packages/core/src/js/intlTelInput.ts
var $1b5b6cd373c57766$var$nextId = 0;
var $1b5b6cd373c57766$var$ensureUtils = (methodName)=>{
    if (!$1b5b6cd373c57766$var$intlTelInput.utils) throw new Error(`intlTelInput.utils is required for ${methodName}(). See: https://intl-tel-input.com/docs/utils`);
};
var $1b5b6cd373c57766$var$createDeferred = ()=>{
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
var $1b5b6cd373c57766$var$Iti = class _Iti {
    //* PUBLIC FIELDS - READONLY
    //* Can't be private as it's called from intlTelInput convenience wrapper.
    id;
    // accessed externally via iti.promise.then(...)
    promise;
    //* PRIVATE FIELDS
    #ui;
    #options;
    #isAndroid;
    // country data
    #countries;
    #dialCodeMaxLength;
    #dialCodeToIso2Map;
    #dialCodes;
    #countryByIso2;
    #searchTokens;
    #selectedCountry = null;
    #maxCoreNumberLength = null;
    #fallbackCountryIso2;
    // is this instance still active (not destroyed)
    #isActive = true;
    #abortController;
    #numerals;
    //* Tracks whether the user has typed/pasted their own formatting chars, so AYT-formatting should back off.
    #userOverrideFormatting = false;
    #strictPasteSnapshot = null;
    #autoCountryDeferred;
    #utilsDeferred;
    constructor(input, customOptions = {}){
        this.id = $1b5b6cd373c57766$var$nextId++;
        $1b5b6cd373c57766$var$UI.validateInput(input);
        const validatedOptions = $1b5b6cd373c57766$var$validateOptions(customOptions);
        this.#options = {
            ...$1b5b6cd373c57766$var$defaults,
            ...validatedOptions
        };
        $1b5b6cd373c57766$var$normaliseOptions(this.#options);
        $1b5b6cd373c57766$var$applyOptionSideEffects(this.#options);
        this.#ui = new $1b5b6cd373c57766$var$UI(input, this.#options, this.id);
        this.#isAndroid = typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);
        this.#numerals = new $1b5b6cd373c57766$var$Numerals(input.value);
        this.promise = this.#createInitPromise(this.#options);
        this.#countries = $1b5b6cd373c57766$var$processAllCountries(this.#options);
        const { dialCodes: dialCodes, dialCodeMaxLength: dialCodeMaxLength, dialCodeToIso2Map: dialCodeToIso2Map } = $1b5b6cd373c57766$var$processDialCodes(this.#countries);
        this.#dialCodes = dialCodes;
        this.#dialCodeMaxLength = dialCodeMaxLength;
        this.#dialCodeToIso2Map = dialCodeToIso2Map;
        this.#countryByIso2 = new Map(this.#countries.map((c)=>[
                c.iso2,
                c
            ]));
        this.#init();
    }
    #getTelInputValue() {
        const inputValue = this.#ui.telInputEl.value.trim();
        return this.#numerals.normalise(inputValue);
    }
    #setTelInputValue(asciiValue) {
        this.#ui.telInputEl.value = this.#numerals.denormalise(asciiValue);
    }
    #createInitPromise(options) {
        const { initialCountry: initialCountry, geoIpLookup: geoIpLookup, loadUtils: loadUtils } = options;
        const needsAutoCountryDeferred = initialCountry === $1b5b6cd373c57766$var$INITIAL_COUNTRY.AUTO && Boolean(geoIpLookup);
        const needsUtilsDeferred = Boolean(loadUtils) && !$1b5b6cd373c57766$var$intlTelInput.utils;
        if (needsAutoCountryDeferred) this.#autoCountryDeferred = $1b5b6cd373c57766$var$createDeferred();
        if (needsUtilsDeferred) this.#utilsDeferred = $1b5b6cd373c57766$var$createDeferred();
        return Promise.all([
            this.#autoCountryDeferred?.promise,
            this.#utilsDeferred?.promise
        ]).then(()=>{});
    }
    #init() {
        this.#abortController = new AbortController();
        this.#processCountryData();
        this.#ui.buildMarkup(this.#countries, this.#searchTokens);
        this.#setInitialState();
        this.#initListeners();
        this.#startAsyncLoads();
        if (this.#options.dropdownAlwaysOpen) this.#openDropdown();
    }
    //********************
    //*  PRIVATE METHODS
    //********************
    //* Prepare all of the country data, including onlyCountries, excludeCountries, countryOrder options.
    #processCountryData() {
        $1b5b6cd373c57766$var$generateCountryNames(this.#countries, this.#options);
        $1b5b6cd373c57766$var$sortCountries(this.#countries, this.#options);
        this.#searchTokens = $1b5b6cd373c57766$var$buildSearchTokens(this.#countries);
    }
    //* Set the initial state of the input value and the selected country by:
    //* 1. Extracting a dial code from the given number
    //* 2. Using explicit initialCountry
    #setInitialState(overrideAutoCountry = false) {
        const attributeValueRaw = this.#ui.telInputEl.getAttribute("value");
        const attributeValue = this.#numerals.normalise(attributeValueRaw ?? "");
        const inputValue = this.#getTelInputValue();
        const useAttribute = attributeValue && attributeValue.startsWith("+") && (!inputValue || !inputValue.startsWith("+"));
        const value = useAttribute ? attributeValue : inputValue;
        const dialCode = this.#getDialCode(value);
        const isRegionlessNanpNumber = $1b5b6cd373c57766$var$isRegionlessNanp(value);
        const { initialCountry: initialCountry, geoIpLookup: geoIpLookup } = this.#options;
        const isAutoCountry = initialCountry === $1b5b6cd373c57766$var$INITIAL_COUNTRY.AUTO && geoIpLookup;
        const resolvedInitialCountry = isAutoCountry && $1b5b6cd373c57766$var$intlTelInput.autoCountry ? $1b5b6cd373c57766$var$intlTelInput.autoCountry : initialCountry;
        const doingAutoCountryLookup = isAutoCountry && !overrideAutoCountry && !$1b5b6cd373c57766$var$intlTelInput.autoCountry;
        const isValidInitialCountry = $1b5b6cd373c57766$var$isIso2(resolvedInitialCountry);
        if (dialCode) {
            if (isRegionlessNanpNumber) {
                if (isValidInitialCountry) this.#updateSelectedCountry(resolvedInitialCountry);
                else if (!doingAutoCountryLookup) this.#updateSelectedCountry($1b5b6cd373c57766$var$US.ISO2);
            } else {
                if (isValidInitialCountry) this.#updateSelectedCountry(resolvedInitialCountry);
                this.#updateCountryFromNumber(value);
            }
        } else if (isValidInitialCountry) this.#updateSelectedCountry(resolvedInitialCountry);
        else if (!doingAutoCountryLookup) this.#updateSelectedCountry("");
        if (value) this.#updateValueFromNumber(value);
    }
    //* Initialise the main event listeners: input keyup, and click selected country.
    #initListeners() {
        this.#bindAllTelInputListeners();
        if (this.#options.allowDropdown) this.#ui.bindAllInitialDropdownListeners(this.#abortController.signal, ()=>this.#openDropdown(), ()=>this.#closeDropdown());
        this.#ui.bindHiddenInputSubmitListener(this.#abortController.signal, ()=>this.getNumber(), ()=>this.#selectedCountry?.iso2 || "");
    }
    //* Init requests: utils script / geo ip lookup.
    #startAsyncLoads() {
        if (this.#utilsDeferred) {
            const { loadUtils: loadUtils } = this.#options;
            const doAttachUtils = ()=>{
                $1b5b6cd373c57766$var$intlTelInput.attachUtils(loadUtils).catch(()=>{});
            };
            if ($1b5b6cd373c57766$var$intlTelInput.documentReady()) doAttachUtils();
            else window.addEventListener("load", doAttachUtils, {
                signal: this.#abortController.signal
            });
        }
        if (this.#autoCountryDeferred) {
            if (this.#selectedCountry) this.#autoCountryDeferred.resolve();
            else this.#loadAutoCountry();
        }
    }
    //* Perform the geo ip lookup.
    async #loadAutoCountry() {
        if ($1b5b6cd373c57766$var$intlTelInput.autoCountry) {
            this.#handleAutoCountryLoaded();
            return;
        }
        this.#ui.setLoading(true);
        if ($1b5b6cd373c57766$var$intlTelInput.startedLoadingAutoCountry) return;
        $1b5b6cd373c57766$var$intlTelInput.startedLoadingAutoCountry = true;
        if (typeof this.#options.geoIpLookup === "function") {
            let timeoutId;
            try {
                const iso2 = await Promise.race([
                    this.#options.geoIpLookup(),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>reject(new Error("intl-tel-input: geoIpLookup timed out after 10s")), 1e4);
                    })
                ]);
                const iso2Lower = typeof iso2 === "string" ? iso2.toLowerCase() : "";
                if (!$1b5b6cd373c57766$var$isIso2(iso2Lower)) {
                    $1b5b6cd373c57766$var$intlTelInput.startedLoadingAutoCountry = false;
                    _Iti.forEachInstance("handleAutoCountryFailure");
                    return;
                }
                $1b5b6cd373c57766$var$intlTelInput.autoCountry = iso2Lower;
                setTimeout(()=>_Iti.forEachInstance("handleAutoCountryLoaded"));
            } catch  {
                $1b5b6cd373c57766$var$intlTelInput.startedLoadingAutoCountry = false;
                _Iti.forEachInstance("handleAutoCountryFailure");
            } finally{
                if (timeoutId !== void 0) clearTimeout(timeoutId);
            }
        }
    }
    #openDropdownWithPlus() {
        this.#openDropdown();
        this.#ui.prefillSearchWithPlus();
    }
    //* Delete the character just typed (the one immediately before the caret). Used by Android workarounds where we can't preventDefault on keydown.
    #removeJustTypedChar(inputValue) {
        const currentCaretPos = this.#ui.telInputEl.selectionStart || 0;
        const valueBeforeCaret = inputValue.substring(0, currentCaretPos - 1);
        const valueAfterCaret = inputValue.substring(currentCaretPos);
        this.#setTelInputValue(valueBeforeCaret + valueAfterCaret);
        return currentCaretPos - 1;
    }
    //* Initialize the tel input listeners.
    #bindAllTelInputListeners() {
        this.#bindInputListener();
        this.#bindKeydownListener();
        this.#bindStrictPasteListener();
    }
    //* Android workaround for handling plus when separateDialCode enabled (as impossible to handle with keydown/keyup, for which e.key always returns "Unidentified", see https://stackoverflow.com/q/59584061/217866)
    #handleAndroidPlusKey(inputValue) {
        this.#removeJustTypedChar(inputValue);
        this.#openDropdownWithPlus();
    }
    //* Android strictMode workaround: the keydown-based filter can't block these because e.key is "Unidentified" on Android virtual keyboards, so strip them here on input.
    #handleAndroidStrictReject(inputValue, rejectedInput) {
        const newCaretPos = this.#removeJustTypedChar(inputValue);
        this.#ui.telInputEl.setSelectionRange(newCaretPos, newCaretPos);
        this.#ui.playStrictRejectAnimation();
        this.#dispatchEvent($1b5b6cd373c57766$var$EVENTS.STRICT_REJECT, {
            source: "key",
            rejectedInput: rejectedInput,
            reason: "invalid"
        });
    }
    //* Format the input value using libphonenumber's AYT formatter, preserving caret position (called after an input event).
    #formatAsYouType(inputValue, isDeleteForwards) {
        const currentCaretPos = this.#ui.telInputEl.selectionStart || 0;
        const valueBeforeCaret = inputValue.substring(0, currentCaretPos);
        const relevantCharsBeforeCaret = valueBeforeCaret.replace($1b5b6cd373c57766$var$REGEX.NON_PLUS_NUMERIC_GLOBAL, "").length;
        const fullNumber = this.#getFullNumber();
        const formattedValue = $1b5b6cd373c57766$var$formatNumberAsYouType(fullNumber, inputValue, $1b5b6cd373c57766$var$intlTelInput.utils, this.#selectedCountry, this.#options.separateDialCode);
        const newCaretPos = $1b5b6cd373c57766$var$computeNewCaretPosition(relevantCharsBeforeCaret, formattedValue, currentCaretPos, isDeleteForwards);
        this.#setTelInputValue(formattedValue);
        this.#ui.telInputEl.setSelectionRange(newCaretPos, newCaretPos);
    }
    //* If separateDialCode AND typed dial code (e.g. from paste or autofill, or from typing a dial code when countrySearch disabled), then remove the typed dial code.
    //* Only strip when a full dial code is actually present — otherwise a lone typed "+" (or partial prefix) would get erased.
    #stripTypedDialCode(inputValue) {
        if (inputValue.startsWith("+") && this.#selectedCountry && this.#getDialCode(inputValue)) {
            const cleanNumber = $1b5b6cd373c57766$var$stripSeparateDialCode(inputValue, true, true, this.#selectedCountry);
            this.#setTelInputValue(cleanNumber);
        }
    }
    #bindInputListener() {
        this.#userOverrideFormatting = $1b5b6cd373c57766$var$REGEX.ALPHA_UNICODE.test(this.#getTelInputValue());
        this.#ui.telInputEl.addEventListener("input", this.#handleInputEvent, {
            signal: this.#abortController.signal
        });
    }
    //* On input event: (1) Update selected country, (2) Format-as-you-type.
    //* Note that this fires AFTER the input is updated.
    #handleInputEvent = (e)=>{
        const { strictMode: strictMode, formatAsYouType: formatAsYouType, separateDialCode: separateDialCode, allowDropdown: allowDropdown, countrySearch: countrySearch } = this.#options;
        const detail = e?.detail;
        if (detail?.["isCountryChange"]) return;
        let inputValue = this.#getTelInputValue();
        const isPaste = e?.inputType === $1b5b6cd373c57766$var$INPUT_TYPES.PASTE;
        const isStrictPaste = strictMode && isPaste;
        if (this.#isAndroid && !isPaste && e?.data === "+" && separateDialCode && allowDropdown && countrySearch) {
            this.#handleAndroidPlusKey(inputValue);
            return;
        }
        if (this.#isAndroid && !isPaste && strictMode && (e?.data === " " || e?.data === "-" || e?.data === ".")) {
            this.#handleAndroidStrictReject(inputValue, e.data);
            return;
        }
        if (isStrictPaste) {
            const didRejectPaste = this.#handleStrictPasteInputEvent();
            if (didRejectPaste) return;
            inputValue = this.#getTelInputValue();
        }
        if (this.#updateCountryFromNumber(inputValue)) this.#dispatchCountryChangeEvent();
        const isFormattingChar = !isStrictPaste && e?.data && $1b5b6cd373c57766$var$REGEX.NON_PLUS_NUMERIC.test(e.data);
        const isNonStrictPaste = isPaste && inputValue && !strictMode;
        if (isFormattingChar || isNonStrictPaste) this.#userOverrideFormatting = true;
        else if (!$1b5b6cd373c57766$var$REGEX.NON_PLUS_NUMERIC.test(inputValue)) this.#userOverrideFormatting = false;
        if (formatAsYouType && !this.#userOverrideFormatting && !detail?.["isSetNumber"] && this.#numerals.isAscii()) this.#formatAsYouType(inputValue, e?.inputType === $1b5b6cd373c57766$var$INPUT_TYPES.DELETE_FORWARD);
        if (separateDialCode) this.#stripTypedDialCode(inputValue);
    };
    #bindKeydownListener() {
        const { strictMode: strictMode, separateDialCode: separateDialCode } = this.#options;
        if (!strictMode && !separateDialCode) return;
        this.#ui.telInputEl.addEventListener("keydown", this.#handleKeydownEvent, {
            signal: this.#abortController.signal
        });
    }
    //* On keydown event: (1) if strictMode then prevent invalid characters, (2) if separateDialCode then handle plus key
    //* Note that this fires BEFORE the input is updated.
    #handleKeydownEvent = (e)=>{
        const { strictMode: strictMode, separateDialCode: separateDialCode, allowDropdown: allowDropdown, countrySearch: countrySearch } = this.#options;
        if (!e.key || e.key.length !== 1 || e.altKey || e.ctrlKey || e.metaKey) return;
        if (separateDialCode && allowDropdown && countrySearch && e.key === "+") {
            e.preventDefault();
            this.#openDropdownWithPlus();
            return;
        }
        if (!strictMode) return;
        const inputValue = this.#getTelInputValue();
        const alreadyHasPlus = inputValue.startsWith("+");
        const isInitialPlus = !alreadyHasPlus && this.#ui.telInputEl.selectionStart === 0 && e.key === "+";
        const normalisedKey = this.#numerals.normalise(e.key);
        const isNumeric = /^[0-9]$/.test(normalisedKey);
        const isAllowedChar = separateDialCode ? isNumeric : isInitialPlus || isNumeric;
        const input = this.#ui.telInputEl;
        const selStart = input.selectionStart;
        const selEnd = input.selectionEnd;
        const before = inputValue.slice(0, selStart ?? void 0);
        const after = inputValue.slice(selEnd ?? void 0);
        const newValue = before + normalisedKey + after;
        const newFullNumber = this.#buildFullNumber(newValue);
        let hasExceededMaxLength = false;
        if ($1b5b6cd373c57766$var$intlTelInput.utils && this.#maxCoreNumberLength) {
            const coreNumber = $1b5b6cd373c57766$var$intlTelInput.utils.getCoreNumber(newFullNumber, this.#selectedCountry?.iso2);
            hasExceededMaxLength = coreNumber.length > this.#maxCoreNumberLength;
        }
        const newCountry = this.#resolveCountryChangeFromNumber(newFullNumber);
        const isChangingDialCode = newCountry !== null;
        if (!isAllowedChar || hasExceededMaxLength && !isChangingDialCode && !isInitialPlus) {
            this.#ui.playStrictRejectAnimation();
            this.#dispatchEvent($1b5b6cd373c57766$var$EVENTS.STRICT_REJECT, {
                source: "key",
                rejectedInput: e.key,
                reason: !isAllowedChar ? "invalid" : "max-length"
            });
            e.preventDefault();
        }
    };
    #bindStrictPasteListener() {
        if (!this.#options.strictMode) return;
        this.#ui.telInputEl.addEventListener("paste", this.#handleStrictPasteEvent, {
            signal: this.#abortController.signal
        });
    }
    // In strict mode, remember paste details before the browser inserts the pasted text.
    // The actual sanitisation runs on the following input event so native paste stays enabled.
    #handleStrictPasteEvent = (e)=>{
        const input = this.#ui.telInputEl;
        const inputValue = this.#getTelInputValue();
        this.#strictPasteSnapshot = {
            pastedRaw: e.clipboardData?.getData("text") ?? "",
            value: inputValue,
            selectionStart: input.selectionStart ?? inputValue.length,
            selectionEnd: input.selectionEnd ?? inputValue.length
        };
    };
    // Handle paste input events when strictMode is enabled by sanitising the pasted content after
    // the browser inserts it, and rejecting it entirely if it would result in an invalid number.
    #handleStrictPasteInputEvent() {
        const input = this.#ui.telInputEl;
        const pasteSnapshot = this.#strictPasteSnapshot;
        this.#strictPasteSnapshot = null;
        if (!pasteSnapshot) return false;
        const pastedRaw = pasteSnapshot.pastedRaw;
        const originalValue = pasteSnapshot.value;
        const selStart = pasteSnapshot.selectionStart;
        const selEnd = pasteSnapshot.selectionEnd;
        const before = originalValue.slice(0, selStart);
        const after = originalValue.slice(selEnd);
        const iso2 = this.#selectedCountry?.iso2;
        const pasted = this.#numerals.normalise(pastedRaw);
        const initialCharSelected = selStart === 0 && selEnd > 0;
        const allowLeadingPlus = !originalValue.startsWith("+") || initialCharSelected;
        const allowedChars = pasted.replace($1b5b6cd373c57766$var$REGEX.NON_PLUS_NUMERIC_GLOBAL, "");
        const hasLeadingPlus = allowedChars.startsWith("+");
        const numerics = allowedChars.replace(/\+/g, "");
        const sanitised = hasLeadingPlus && allowLeadingPlus ? `+${numerics}` : numerics;
        let newValue = before + sanitised + after;
        let rejectReason = sanitised !== pasted ? "invalid" : null;
        if (newValue.length > 30) {
            this.#ui.playStrictRejectAnimation();
            this.#dispatchEvent($1b5b6cd373c57766$var$EVENTS.STRICT_REJECT, {
                source: "paste",
                rejectedInput: pastedRaw,
                reason: "max-length"
            });
            this.#restoreValueBeforeStrictPaste(pasteSnapshot);
            return true;
        }
        if (newValue.length > 5 && $1b5b6cd373c57766$var$intlTelInput.utils) {
            let coreNumber = $1b5b6cd373c57766$var$intlTelInput.utils.getCoreNumber(newValue, iso2);
            while(coreNumber.length === 0 && newValue.length > 0){
                newValue = newValue.slice(0, -1);
                coreNumber = $1b5b6cd373c57766$var$intlTelInput.utils.getCoreNumber(newValue, iso2);
            }
            if (!coreNumber) {
                this.#ui.playStrictRejectAnimation();
                this.#dispatchEvent($1b5b6cd373c57766$var$EVENTS.STRICT_REJECT, {
                    source: "paste",
                    rejectedInput: pastedRaw,
                    reason: "max-length"
                });
                this.#restoreValueBeforeStrictPaste(pasteSnapshot);
                return true;
            }
            if (this.#maxCoreNumberLength && coreNumber.length > this.#maxCoreNumberLength) {
                if (selEnd === originalValue.length) {
                    const trimLength = coreNumber.length - this.#maxCoreNumberLength;
                    newValue = newValue.slice(0, newValue.length - trimLength);
                    rejectReason = "max-length";
                } else {
                    this.#ui.playStrictRejectAnimation();
                    this.#dispatchEvent($1b5b6cd373c57766$var$EVENTS.STRICT_REJECT, {
                        source: "paste",
                        rejectedInput: pastedRaw,
                        reason: "max-length"
                    });
                    this.#restoreValueBeforeStrictPaste(pasteSnapshot);
                    return true;
                }
            }
        }
        this.#setTelInputValue(newValue);
        const caretPos = selStart + sanitised.length;
        input.setSelectionRange(caretPos, caretPos);
        if (rejectReason) {
            if (pasted.length > 0 && sanitised.length === 0) this.#ui.playStrictRejectAnimation();
            this.#dispatchEvent($1b5b6cd373c57766$var$EVENTS.STRICT_REJECT, {
                source: "paste",
                rejectedInput: pastedRaw,
                reason: rejectReason
            });
        }
        return false;
    }
    #restoreValueBeforeStrictPaste(pasteSnapshot) {
        this.#setTelInputValue(pasteSnapshot.value);
        this.#ui.telInputEl.setSelectionRange(pasteSnapshot.selectionStart, pasteSnapshot.selectionEnd);
    }
    //* Adhere to the input's maxlength attr.
    #truncateToMaxLength(number) {
        const max = Number(this.#ui.telInputEl.getAttribute("maxlength"));
        return max && number.length > max ? number.substring(0, max) : number;
    }
    //* Trigger a custom event on the input (typed via ItiEventMap).
    #dispatchEvent(name, detailProps = {}) {
        const e = new CustomEvent(name, {
            bubbles: true,
            cancelable: true,
            detail: detailProps
        });
        this.#ui.telInputEl.dispatchEvent(e);
    }
    //* Open the dropdown. Bail if already open — otherwise the existing AbortController gets overwritten
    //* and its listeners leak. Reachable via openDropdownWithPlus when dropdownAlwaysOpen is set
    #openDropdown() {
        if (this.#ui.isDropdownOpen()) return;
        this.#ui.openDropdown((li)=>this.#selectListItem(li), ()=>this.#closeDropdown());
        this.#dispatchEvent($1b5b6cd373c57766$var$EVENTS.OPEN_COUNTRY_DROPDOWN);
    }
    //* Update the input's value to the given number (format first if possible)
    //* NOTE: this is called from setInitialState, handleUtilsLoaded and setNumber.
    #updateValueFromNumber(fullNumber) {
        const { formatOnDisplay: formatOnDisplay, nationalMode: nationalMode, separateDialCode: separateDialCode } = this.#options;
        let number = fullNumber;
        if (formatOnDisplay && $1b5b6cd373c57766$var$intlTelInput.utils && this.#selectedCountry) {
            const isRegionless = $1b5b6cd373c57766$var$hasRegionlessDialCode(fullNumber);
            const useNational = nationalMode && !isRegionless || !number.startsWith("+") && !separateDialCode;
            const format = useNational ? $1b5b6cd373c57766$var$NUMBER_FORMAT.NATIONAL : $1b5b6cd373c57766$var$NUMBER_FORMAT.INTERNATIONAL;
            number = $1b5b6cd373c57766$var$intlTelInput.utils.formatNumber(number, this.#selectedCountry?.iso2, format);
        }
        number = this.#prepareNumberForInput(number);
        this.#setTelInputValue(number);
    }
    //* Check if need to select a new country based on the given number
    //* Note: called from setInitialState, keyup handler, setNumber.
    #updateCountryFromNumber(fullNumber) {
        const iso2 = this.#resolveCountryChangeFromNumber(fullNumber);
        if (iso2 !== null) return this.#updateSelectedCountry(iso2);
        return false;
    }
    // if there is a selected country, and the number doesn't start with a dial code, then add it
    #withDialCodePrefix(number) {
        const dialCode = this.#selectedCountry?.dialCode;
        const nationalPrefix = this.#selectedCountry?.nationalPrefix;
        const alreadyHasPlus = number.startsWith("+");
        if (alreadyHasPlus || !dialCode) return number;
        const hasPrefix = nationalPrefix && number.startsWith(nationalPrefix) && !this.#options.separateDialCode;
        const cleanNumber = hasPrefix ? number.substring(1) : number;
        return `+${dialCode}${cleanNumber}`;
    }
    //* Get the new country iso2 (or "" for empty/globe state) based on the input number, or return null if no change.
    #resolveCountryChangeFromNumber(fullNumber) {
        const plusIndex = fullNumber.indexOf("+");
        let number = plusIndex > 0 ? fullNumber.substring(plusIndex) : fullNumber;
        const selectedIso2 = this.#selectedCountry?.iso2;
        number = this.#withDialCodePrefix(number);
        const dialCodeMatch = this.#getDialCode(number, true);
        const numeric = $1b5b6cd373c57766$var$getNumeric(number);
        if (dialCodeMatch) {
            const dialCodeMatchNumeric = $1b5b6cd373c57766$var$getNumeric(dialCodeMatch);
            const iso2Codes = this.#dialCodeToIso2Map[dialCodeMatchNumeric];
            if (iso2Codes.length === 1) {
                if (iso2Codes[0] === selectedIso2) return null;
                return iso2Codes[0];
            }
            return this.#resolveCountryChangeFromMultiMatch(iso2Codes, dialCodeMatchNumeric, numeric);
        } else if (number.startsWith("+") && numeric.length) {
            const currentDial = this.#selectedCountry?.dialCode || "";
            if (currentDial && currentDial.startsWith(numeric)) return null;
            return "";
        } else if ((!number || number === "+") && !selectedIso2 && this.#fallbackCountryIso2) return this.#fallbackCountryIso2;
        return null;
    }
    //* Resolve the country when multiple countries share the matched dial code.
    #resolveCountryChangeFromMultiMatch(iso2Codes, dialCodeMatchNumeric, numeric) {
        const selectedIso2 = this.#selectedCountry?.iso2;
        const selectedDialCode = this.#selectedCountry?.dialCode;
        if (!selectedIso2 && this.#fallbackCountryIso2 && iso2Codes.includes(this.#fallbackCountryIso2)) return this.#fallbackCountryIso2;
        const isRegionlessNanpNumber = selectedDialCode === $1b5b6cd373c57766$var$DIAL_CODE.NANP && $1b5b6cd373c57766$var$isRegionlessNanp(numeric);
        if (isRegionlessNanpNumber) return null;
        const areaCodes = this.#selectedCountry?.areaCodes;
        const priority = this.#selectedCountry?.priority;
        if (areaCodes) {
            const dialCodeAreaCodes = areaCodes.map((areaCode)=>`${selectedDialCode}${areaCode}`);
            for (const dialCodeAreaCode of dialCodeAreaCodes){
                if (numeric.startsWith(dialCodeAreaCode)) return null;
            }
        }
        const isMainCountry = priority === 0;
        const hasAreaCodesButNoneMatched = areaCodes && !isMainCountry && numeric.length > dialCodeMatchNumeric.length;
        const isValidSelection = selectedIso2 && iso2Codes.includes(selectedIso2) && !hasAreaCodesButNoneMatched;
        const alreadySelected = selectedIso2 === iso2Codes[0];
        if (!isValidSelection && !alreadySelected) return iso2Codes[0];
        return null;
    }
    //* Update the selected country, dial code (if separateDialCode), placeholder, title, and selected list item.
    //* Note: called from setInitialState, updateCountryFromNumber, selectListItem, setCountry.
    #updateSelectedCountry(iso2) {
        const prevIso2 = this.#selectedCountry?.iso2 || "";
        this.#selectedCountry = iso2 ? this.#countryByIso2.get(iso2) : null;
        if (this.#selectedCountry) this.#fallbackCountryIso2 = this.#selectedCountry.iso2;
        this.#ui.setCountry(this.#selectedCountry);
        this.#updatePlaceholder();
        this.#updateMaxCoreNumberLength();
        return prevIso2 !== iso2;
    }
    //* Update the maximum valid number length for the currently selected country.
    #updateMaxCoreNumberLength() {
        const { strictMode: strictMode, placeholderNumberType: placeholderNumberType, allowedNumberTypes: allowedNumberTypes } = this.#options;
        if (!strictMode || !$1b5b6cd373c57766$var$intlTelInput.utils) return;
        const iso2 = this.#selectedCountry?.iso2;
        if (!iso2) {
            this.#maxCoreNumberLength = null;
            return;
        }
        let exampleNumber = $1b5b6cd373c57766$var$intlTelInput.utils.getExampleNumber(iso2, false, placeholderNumberType, true);
        let validNumber = exampleNumber;
        while($1b5b6cd373c57766$var$intlTelInput.utils.isPossibleNumber(exampleNumber, iso2, allowedNumberTypes)){
            validNumber = exampleNumber;
            exampleNumber += "0";
        }
        const coreNumber = $1b5b6cd373c57766$var$intlTelInput.utils.getCoreNumber(validNumber, iso2);
        this.#maxCoreNumberLength = coreNumber.length;
        if (iso2 === "by") this.#maxCoreNumberLength = coreNumber.length + 1;
    }
    //* Update the input placeholder to an example number from the currently selected country.
    #updatePlaceholder() {
        const { autoPlaceholder: autoPlaceholder, placeholderNumberType: placeholderNumberType, nationalMode: nationalMode, customPlaceholder: customPlaceholder } = this.#options;
        const shouldSetPlaceholder = autoPlaceholder === $1b5b6cd373c57766$var$PLACEHOLDER_MODES.AGGRESSIVE || !this.#ui.hadInitialPlaceholder && autoPlaceholder === $1b5b6cd373c57766$var$PLACEHOLDER_MODES.POLITE;
        if (!$1b5b6cd373c57766$var$intlTelInput.utils || !shouldSetPlaceholder) return;
        let placeholder = this.#selectedCountry ? $1b5b6cd373c57766$var$intlTelInput.utils.getExampleNumber(this.#selectedCountry.iso2, nationalMode, placeholderNumberType) : "";
        placeholder = this.#prepareNumberForInput(placeholder);
        if (typeof customPlaceholder === "function") placeholder = customPlaceholder(placeholder, this.#selectedCountry);
        this.#ui.telInputEl.setAttribute("placeholder", placeholder);
    }
    //* Called when the user selects a list item from the dropdown (no-op if listItem is null).
    #selectListItem(listItem) {
        if (!listItem) return;
        const iso2 = listItem.dataset[$1b5b6cd373c57766$var$DATA_KEYS.ISO2];
        const countryChanged = this.#updateSelectedCountry(iso2);
        this.#closeDropdown();
        const dialCode = listItem.dataset[$1b5b6cd373c57766$var$DATA_KEYS.DIAL_CODE];
        this.#updateDialCode(dialCode);
        if (this.#options.formatOnDisplay) {
            const inputValue = this.#getTelInputValue();
            this.#updateValueFromNumber(inputValue);
        }
        this.#ui.telInputEl.focus();
        if (countryChanged) {
            this.#dispatchCountryChangeEvent();
            this.#dispatchEvent($1b5b6cd373c57766$var$EVENTS.INPUT, {
                isCountryChange: true
            });
        }
    }
    //* Close the dropdown and unbind any listeners.
    #closeDropdown(isDestroy) {
        if (!this.#ui.isDropdownOpen() || this.#options.dropdownAlwaysOpen && !isDestroy) return;
        this.#ui.closeDropdown();
        this.#dispatchEvent($1b5b6cd373c57766$var$EVENTS.CLOSE_COUNTRY_DROPDOWN);
    }
    //* Replace any existing dial code with the new one
    //* Note: called from selectListItem and setCountry
    #updateDialCode(newDialCodeDigits) {
        const inputValue = this.#getTelInputValue();
        if (!inputValue.startsWith("+")) return;
        const newDialCode = `+${newDialCodeDigits}`;
        const prevDialCode = this.#getDialCode(inputValue);
        let newNumber;
        if (prevDialCode) newNumber = inputValue.replace(prevDialCode, newDialCode);
        else newNumber = newDialCode;
        this.#setTelInputValue(newNumber);
    }
    //* Try and extract a valid international dial code from a full telephone number.
    //* Note: returns the raw string inc plus character and any whitespace/dots etc.
    #getDialCode(number, includeAreaCode) {
        if (!number.startsWith("+")) return "";
        let dialCode = "";
        let numericChars = "";
        let foundBaseDialCode = false;
        for(let i = 0; i < number.length; i++){
            const c = number.charAt(i);
            if (!/[0-9]/.test(c)) continue;
            numericChars += c;
            const hasMapEntry = Boolean(this.#dialCodeToIso2Map[numericChars]);
            if (!hasMapEntry) break;
            if (this.#dialCodes.has(numericChars)) {
                dialCode = number.substring(0, i + 1);
                foundBaseDialCode = true;
                if (!includeAreaCode) break;
            } else if (includeAreaCode && foundBaseDialCode) dialCode = number.substring(0, i + 1);
            if (numericChars.length === this.#dialCodeMaxLength) break;
        }
        return dialCode;
    }
    //* Build a full number from an already-normalised value, adding the dial code if separateDialCode is enabled.
    #buildFullNumber(value) {
        const dialCode = this.#selectedCountry?.dialCode;
        const numericValue = $1b5b6cd373c57766$var$getNumeric(value);
        const usePrefix = this.#options.separateDialCode && !value.startsWith("+") && dialCode && numericValue;
        return (usePrefix ? `+${dialCode}` : "") + value;
    }
    //* Get the input value as a full number, adding the dial code if separateDialCode is enabled.
    #getFullNumber() {
        const value = this.#getTelInputValue();
        return this.#buildFullNumber(value);
    }
    //* Remove the dial code if separateDialCode is enabled also cap the length if the input has a maxlength attribute
    #prepareNumberForInput(fullNumber) {
        const hasValidDialCode = Boolean(this.#getDialCode(fullNumber));
        const number = $1b5b6cd373c57766$var$stripSeparateDialCode(fullNumber, hasValidDialCode, this.#options.separateDialCode, this.#selectedCountry);
        return this.#truncateToMaxLength(number);
    }
    //* Dispatch the 'countrychange' event.
    #dispatchCountryChangeEvent() {
        this.#dispatchEvent($1b5b6cd373c57766$var$EVENTS.COUNTRY_CHANGE, this.#selectedCountry ?? null);
    }
    //**************************
    //*  INTERNAL METHODS
    //**************************
    //* Called when the geoip call returns.
    #handleAutoCountryLoaded() {
        if (!this.#autoCountryDeferred || !$1b5b6cd373c57766$var$intlTelInput.autoCountry) return;
        if (!this.#isActive) {
            this.#autoCountryDeferred.resolve();
            return;
        }
        if (this.#ui.isLoading()) this.setCountry($1b5b6cd373c57766$var$intlTelInput.autoCountry);
        else this.#fallbackCountryIso2 = $1b5b6cd373c57766$var$intlTelInput.autoCountry;
        this.#ui.setLoading(false);
        this.#autoCountryDeferred.resolve();
    }
    //* Called when the geoip call fails or times out.
    #handleAutoCountryFailure() {
        if (!this.#isActive) {
            this.#autoCountryDeferred?.reject();
            return;
        }
        this.#setInitialState(true);
        this.#ui.setLoading(false);
        this.#autoCountryDeferred?.reject();
    }
    //* Called when the utils request completes.
    #handleUtilsLoaded() {
        if (!this.#isActive) {
            this.#utilsDeferred?.resolve();
            return;
        }
        if (!$1b5b6cd373c57766$var$intlTelInput.utils) {
            this.#utilsDeferred?.resolve();
            return;
        }
        const inputValue = this.#getTelInputValue();
        if (inputValue) this.#updateValueFromNumber(inputValue);
        if (this.#selectedCountry) {
            this.#updatePlaceholder();
            this.#updateMaxCoreNumberLength();
        }
        this.#utilsDeferred?.resolve();
    }
    //* Called when the utils request fails or times out.
    #handleUtilsFailure(error) {
        if (!this.#isActive) {
            this.#utilsDeferred?.reject(error);
            return;
        }
        this.#utilsDeferred?.reject(error);
    }
    //********************
    //*  PUBLIC METHODS
    //********************
    //* Remove core library.
    destroy() {
        if (!this.#isActive) return;
        this.#isActive = false;
        if (this.#options.allowDropdown) this.#closeDropdown(true);
        this.#abortController.abort();
        this.#ui.destroy();
        $1b5b6cd373c57766$var$intlTelInput.instances.delete(String(this.id));
    }
    // check if the instance is still valid (not destroyed)
    isActive() {
        return this.#isActive;
    }
    //* Get the extension from the current number.
    getExtension() {
        if (!this.#isActive) return "";
        $1b5b6cd373c57766$var$ensureUtils("getExtension");
        return $1b5b6cd373c57766$var$intlTelInput.utils.getExtension(this.#getFullNumber(), this.#selectedCountry?.iso2);
    }
    //* Format the number to the given format (defaults to "E164").
    getNumber(format) {
        if (!this.#isActive) return "";
        $1b5b6cd373c57766$var$ensureUtils("getNumber");
        const iso2 = this.#selectedCountry?.iso2;
        const fullNumber = this.#getFullNumber();
        const formattedNumber = $1b5b6cd373c57766$var$intlTelInput.utils.formatNumber(fullNumber, iso2, format);
        return this.#numerals.denormalise(formattedNumber);
    }
    //* Get the type of the entered number e.g. "FIXED_LINE" / "MOBILE", or null if it can't be determined / instance is destroyed.
    getNumberType() {
        if (!this.#isActive) return null;
        $1b5b6cd373c57766$var$ensureUtils("getNumberType");
        return $1b5b6cd373c57766$var$intlTelInput.utils.getNumberType(this.#getFullNumber(), this.#selectedCountry?.iso2);
    }
    //* Get the country data for the currently selected country.
    getSelectedCountryData() {
        return this.#selectedCountry ?? null;
    }
    //* Get the validation error e.g. "TOO_SHORT" / "TOO_LONG", or null if it can't be determined / instance is destroyed.
    getValidationError() {
        if (!this.#isActive) return null;
        $1b5b6cd373c57766$var$ensureUtils("getValidationError");
        const iso2 = this.#selectedCountry?.iso2;
        return $1b5b6cd373c57766$var$intlTelInput.utils.getValidationError(this.#getFullNumber(), iso2);
    }
    //* Validate the input value using number length only
    isValidNumber() {
        if (!this.#isActive) return null;
        $1b5b6cd373c57766$var$ensureUtils("isValidNumber");
        const dialCode = this.#selectedCountry?.dialCode;
        const iso2 = this.#selectedCountry?.iso2;
        const number = this.#getFullNumber();
        const coreNumber = $1b5b6cd373c57766$var$intlTelInput.utils.getCoreNumber(number, iso2);
        if (coreNumber) {
            if (dialCode === $1b5b6cd373c57766$var$UK.DIAL_CODE) {
                if (coreNumber[0] === $1b5b6cd373c57766$var$UK.MOBILE_PREFIX && coreNumber.length !== $1b5b6cd373c57766$var$UK.MOBILE_CORE_LENGTH) return false;
            }
            const hasAlphaChar = $1b5b6cd373c57766$var$REGEX.ALPHA_UNICODE.test(number);
            if (!hasAlphaChar && dialCode) {
                const nationalPortion = number.startsWith("+") ? number.slice(1 + dialCode.length) : number;
                const nationalDigitCount = $1b5b6cd373c57766$var$getNumeric(nationalPortion).length;
                if (coreNumber.length > nationalDigitCount) return false;
            }
        }
        return this.#validateNumber("possible");
    }
    //* Validate the input value with precise validation
    isValidNumberPrecise() {
        if (!this.#isActive) return null;
        $1b5b6cd373c57766$var$ensureUtils("isValidNumberPrecise");
        return this.#validateNumber("precise");
    }
    //* Shared internal validation logic to handle alpha character extension rules.
    #validateNumber(mode) {
        const { allowNumberExtensions: allowNumberExtensions, allowPhonewords: allowPhonewords, allowedNumberTypes: allowedNumberTypes } = this.#options;
        const iso2 = this.#selectedCountry?.iso2;
        const value = this.#getFullNumber();
        if (!this.#selectedCountry && !$1b5b6cd373c57766$var$hasRegionlessDialCode(value)) return false;
        const check = mode === "precise" ? $1b5b6cd373c57766$var$intlTelInput.utils.isValidNumber : $1b5b6cd373c57766$var$intlTelInput.utils.isPossibleNumber;
        if (!check(value, iso2, allowedNumberTypes)) return false;
        if ($1b5b6cd373c57766$var$REGEX.ALPHA_UNICODE.test(value)) {
            const hasExtension = Boolean($1b5b6cd373c57766$var$intlTelInput.utils.getExtension(value, iso2));
            return hasExtension ? allowNumberExtensions : allowPhonewords;
        }
        return true;
    }
    //* Update the selected country, and update the input value accordingly.
    setCountry(iso2) {
        if (!this.#isActive) return;
        const iso2Lower = iso2?.toLowerCase();
        if (!$1b5b6cd373c57766$var$isIso2(iso2Lower)) throw new Error(`Invalid iso2 code: '${iso2Lower}'`);
        const currentCountry = this.#selectedCountry?.iso2;
        const isCountryChange = iso2 && iso2Lower !== currentCountry || !iso2 && currentCountry;
        if (!isCountryChange) return;
        this.#updateSelectedCountry(iso2Lower);
        this.#updateDialCode(this.#selectedCountry?.dialCode || "");
        if (this.#options.formatOnDisplay) {
            const inputValue = this.#getTelInputValue();
            this.#updateValueFromNumber(inputValue);
        }
        this.#dispatchCountryChangeEvent();
        this.#dispatchEvent($1b5b6cd373c57766$var$EVENTS.INPUT, {
            isCountryChange: true
        });
    }
    //* Set the input value and update the country.
    setNumber(number) {
        if (!this.#isActive) return;
        const normalisedNumber = this.#numerals.normalise(number);
        const countryChanged = this.#updateCountryFromNumber(normalisedNumber);
        this.#updateValueFromNumber(normalisedNumber);
        if (countryChanged) this.#dispatchCountryChangeEvent();
        this.#dispatchEvent($1b5b6cd373c57766$var$EVENTS.INPUT, {
            isSetNumber: true
        });
    }
    //* Set the placeholder number type
    setPlaceholderNumberType(type) {
        if (!this.#isActive) return;
        this.#options.placeholderNumberType = type;
        this.#updatePlaceholder();
    }
    // Set the disabled state of the input and dropdown.
    setDisabled(disabled) {
        if (!this.#isActive) return;
        this.#ui.setDisabled(disabled);
    }
    // Set the readonly state of the input and dropdown.
    setReadonly(readonly) {
        if (!this.#isActive) return;
        this.#ui.setReadonly(readonly);
    }
    //********************
    //*  STATIC METHODS
    //********************
    // Internal instance notification used by utils/geoip loaders.
    // Kept public so module-level helpers (e.g. attachUtils) can call it, while still allowing
    // access to private instance methods.
    static forEachInstance(method, ...args) {
        const values = [
            ...$1b5b6cd373c57766$var$intlTelInput.instances.values()
        ];
        const arg = args[0];
        values.forEach((instance)=>{
            if (!(instance instanceof _Iti)) return;
            switch(method){
                case "handleUtilsLoaded":
                    instance.#handleUtilsLoaded();
                    break;
                case "handleUtilsFailure":
                    instance.#handleUtilsFailure(arg);
                    break;
                case "handleAutoCountryLoaded":
                    instance.#handleAutoCountryLoaded();
                    break;
                case "handleAutoCountryFailure":
                    instance.#handleAutoCountryFailure();
                    break;
            }
        });
    }
};
var $1b5b6cd373c57766$var$attachUtils = async (source)=>{
    if ($1b5b6cd373c57766$var$intlTelInput.utils || $1b5b6cd373c57766$var$intlTelInput.startedLoadingUtils) return null;
    if (typeof source !== "function") throw new TypeError(`The argument passed to attachUtils must be a function that returns a promise for the utils module, not ${typeof source}`);
    $1b5b6cd373c57766$var$intlTelInput.startedLoadingUtils = true;
    try {
        const module = await source();
        const utils = module?.default;
        if (!utils || typeof utils !== "object") throw new TypeError("The loader function passed to attachUtils did not resolve to a module object with utils as its default export.");
        $1b5b6cd373c57766$var$intlTelInput.utils = utils;
        $1b5b6cd373c57766$var$Iti.forEachInstance("handleUtilsLoaded");
        return true;
    } catch (error) {
        $1b5b6cd373c57766$var$Iti.forEachInstance("handleUtilsFailure", error);
        throw error;
    }
};
var $1b5b6cd373c57766$var$intlTelInput = Object.assign((input, options)=>{
    const iti = new $1b5b6cd373c57766$var$Iti(input, options);
    $1b5b6cd373c57766$var$intlTelInput.instances.set(String(iti.id), iti);
    input.iti = iti;
    return iti;
}, {
    defaults: $1b5b6cd373c57766$var$defaults,
    //* Using a static var like this allows us to mock it in the tests.
    documentReady: ()=>document.readyState === "complete",
    //* Get the country data object.
    getCountryData: ()=>$1b5b6cd373c57766$var$data_default,
    //* A getter for the core library instance.
    getInstance: (input)=>{
        const id = input.dataset[$1b5b6cd373c57766$var$DATA_KEYS.INSTANCE_ID];
        return id ? $1b5b6cd373c57766$var$intlTelInput.instances.get(id) ?? null : null;
    },
    //* A map from instance ID to instance object.
    instances: /* @__PURE__ */ new Map(),
    attachUtils: $1b5b6cd373c57766$var$attachUtils,
    startedLoadingUtils: false,
    startedLoadingAutoCountry: false,
    version: "28.1.0",
    NUMBER_FORMAT: $1b5b6cd373c57766$var$NUMBER_FORMAT,
    NUMBER_TYPE: $1b5b6cd373c57766$var$NUMBER_TYPE,
    VALIDATION_ERROR: $1b5b6cd373c57766$var$VALIDATION_ERROR
});
var $1b5b6cd373c57766$var$intlTelInput_default = $1b5b6cd373c57766$var$intlTelInput;
// packages/core/dist/js/utils.js
var $1b5b6cd373c57766$var$_scope = {};
(function() {
    var aa = this || self;
    function k(a, b) {
        a = a.split(".");
        var c = aa;
        a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
        for(var d; a.length && (d = a.shift());)a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
    }
    function m(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.na = b.prototype;
        a.prototype = new c();
        a.prototype.constructor = a;
        a.ta = function(d, e, f) {
            for(var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++)g[h - 2] = arguments[h];
            return b.prototype[e].apply(d, g);
        };
    }
    function ba(a) {
        const b = [];
        let c = 0;
        for(const d in a)b[c++] = a[d];
        return b;
    }
    var da = class {
        constructor(a){
            if (ca !== ca) throw Error("SafeUrl is not meant to be built directly");
            this.g = a;
        }
        toString() {
            return this.g.toString();
        }
    }, ca = {};
    new da("about:invalid#zClosurez");
    new da("about:blank");
    const ea = {};
    class fa {
        constructor(){
            if (ea !== ea) throw Error("SafeStyle is not meant to be built directly");
        }
        toString() {
            return "".toString();
        }
    }
    new fa();
    const ha = {};
    class ia {
        constructor(){
            if (ha !== ha) throw Error("SafeStyleSheet is not meant to be built directly");
        }
        toString() {
            return "".toString();
        }
    }
    new ia();
    const ja = {};
    class ka {
        constructor(){
            var a = aa.trustedTypes && aa.trustedTypes.emptyHTML || "";
            if (ja !== ja) throw Error("SafeHtml is not meant to be built directly");
            this.g = a;
        }
        toString() {
            return this.g.toString();
        }
    }
    new ka();
    function la(a, b) {
        this.g = a;
        this.l = !!b.ca;
        this.h = b.i;
        this.u = b.type;
        this.o = false;
        switch(this.h){
            case ma:
            case na:
            case oa:
            case pa:
            case qa:
            case ra:
            case sa:
                this.o = true;
        }
        this.j = b.defaultValue;
    }
    var sa = 1, ra = 2, ma = 3, na = 4, oa = 6, pa = 16, qa = 18;
    function ta(a, b) {
        this.h = a;
        this.g = {};
        for(a = 0; a < b.length; a++){
            var c = b[a];
            this.g[c.g] = c;
        }
    }
    function ua(a) {
        a = ba(a.g);
        a.sort(function(b, c) {
            return b.g - c.g;
        });
        return a;
    }
    function n() {
        this.h = {};
        this.j = this.m().g;
        this.g = this.l = null;
    }
    n.prototype.has = function(a) {
        return p(this, a.g);
    };
    n.prototype.get = function(a, b) {
        return q(this, a.g, b);
    };
    n.prototype.set = function(a, b) {
        r(this, a.g, b);
    };
    n.prototype.add = function(a, b) {
        va(this, a.g, b);
    };
    n.prototype.equals = function(a) {
        if (!a || this.constructor != a.constructor) return false;
        for(var b = ua(this.m()), c = 0; c < b.length; c++){
            var d = b[c], e = d.g;
            if (p(this, e) != p(a, e)) return false;
            if (p(this, e)) {
                var f = d.h == 11 || d.h == 10, g = t(this, e);
                e = t(a, e);
                if (d.l) {
                    if (g.length != e.length) return false;
                    for(d = 0; d < g.length; d++){
                        var h = g[d], l = e[d];
                        if (f ? !h.equals(l) : h != l) return false;
                    }
                } else if (f ? !g.equals(e) : g != e) return false;
            }
        }
        return true;
    };
    function wa(a, b) {
        for(var c = ua(a.m()), d = 0; d < c.length; d++){
            var e = c[d], f = e.g;
            if (p(b, f)) {
                a.g && delete a.g[e.g];
                var g = e.h == 11 || e.h == 10;
                if (e.l) {
                    e = t(b, f) || [];
                    for(var h = 0; h < e.length; h++)va(a, f, g ? e[h].clone() : e[h]);
                } else e = t(b, f), g ? (g = t(a, f)) ? wa(g, e) : r(a, f, e.clone()) : r(a, f, e);
            }
        }
    }
    n.prototype.clone = function() {
        var a = new this.constructor();
        a != this && (a.h = {}, a.g && (a.g = {}), wa(a, this));
        return a;
    };
    function p(a, b) {
        return a.h[b] != null;
    }
    function t(a, b) {
        var c = a.h[b];
        if (c == null) return null;
        if (a.l) {
            if (!(b in a.g)) {
                var d = a.l, e = a.j[b];
                if (c != null) {
                    if (e.l) {
                        for(var f = [], g = 0; g < c.length; g++)f[g] = d.h(e, c[g]);
                        c = f;
                    } else c = d.h(e, c);
                }
                return a.g[b] = c;
            }
            return a.g[b];
        }
        return c;
    }
    function q(a, b, c) {
        var d = t(a, b);
        return a.j[b].l ? d[c || 0] : d;
    }
    function u(a, b) {
        if (p(a, b)) a = q(a, b);
        else a: {
            a = a.j[b];
            if (a.j === void 0) {
                if (b = a.u, b === Boolean) a.j = false;
                else if (b === Number) a.j = 0;
                else if (b === String) a.j = a.o ? "0" : "";
                else {
                    a = new b();
                    break a;
                }
            }
            a = a.j;
        }
        return a;
    }
    function v(a, b) {
        return a.j[b].l ? p(a, b) ? a.h[b].length : 0 : p(a, b) ? 1 : 0;
    }
    function r(a, b, c) {
        a.h[b] = c;
        a.g && (a.g[b] = c);
    }
    function va(a, b, c) {
        a.h[b] || (a.h[b] = []);
        a.h[b].push(c);
        a.g && delete a.g[b];
    }
    function w(a, b) {
        var c = [], d;
        for(d in b)d != 0 && c.push(new la(d, b[d]));
        return new ta(a, c);
    }
    function x() {}
    x.prototype.g = function(a) {
        new a.h();
        throw Error("Unimplemented");
    };
    x.prototype.h = function(a, b) {
        if (a.h == 11 || a.h == 10) return b instanceof n ? b : this.g(a.u.prototype.m(), b);
        if (a.h == 14) return typeof b === "string" && xa.test(b) && (a = Number(b), a > 0) ? a : b;
        if (!a.o) return b;
        a = a.u;
        if (a === String) {
            if (typeof b === "number") return String(b);
        } else if (a === Number && typeof b === "string" && (b === "Infinity" || b === "-Infinity" || b === "NaN" || xa.test(b))) return Number(b);
        return b;
    };
    var xa = /^-?[0-9]+$/;
    function ya() {}
    m(ya, x);
    ya.prototype.g = function(a, b) {
        a = new a.h();
        a.l = this;
        a.h = b;
        a.g = {};
        return a;
    };
    function z() {}
    m(z, ya);
    z.prototype.h = function(a, b) {
        return a.h == 8 ? !!b : x.prototype.h.apply(this, arguments);
    };
    z.prototype.g = function(a, b) {
        return z.na.g.call(this, a, b);
    };
    function A(a, b) {
        a != null && this.g.apply(this, arguments);
    }
    A.prototype.h = "";
    A.prototype.set = function(a) {
        this.h = "" + a;
    };
    A.prototype.g = function(a, b, c) {
        this.h += String(a);
        if (b != null) for(let d = 1; d < arguments.length; d++)this.h += arguments[d];
        return this;
    };
    function B(a) {
        a.h = "";
    }
    A.prototype.toString = function() {
        return this.h;
    };
    function C() {
        n.call(this);
    }
    m(C, n);
    var za = null;
    function D() {
        n.call(this);
    }
    m(D, n);
    var Aa = null;
    function E(a) {
        return t(a, 9) || [];
    }
    function F() {
        n.call(this);
    }
    m(F, n);
    var Ba = null;
    C.prototype.m = function() {
        var a = za;
        a || (za = a = w(C, {
            0: {
                name: "NumberFormat",
                ja: "i18n.phonenumbers.NumberFormat"
            },
            1: {
                name: "pattern",
                required: true,
                i: 9,
                type: String
            },
            2: {
                name: "format",
                required: true,
                i: 9,
                type: String
            },
            3: {
                name: "leading_digits_pattern",
                ca: true,
                i: 9,
                type: String
            },
            4: {
                name: "national_prefix_formatting_rule",
                i: 9,
                type: String
            },
            6: {
                name: "national_prefix_optional_when_formatting",
                i: 8,
                defaultValue: false,
                type: Boolean
            },
            5: {
                name: "domestic_carrier_code_formatting_rule",
                i: 9,
                type: String
            }
        }));
        return a;
    };
    C.m = C.prototype.m;
    D.prototype.m = function() {
        var a = Aa;
        a || (Aa = a = w(D, {
            0: {
                name: "PhoneNumberDesc",
                ja: "i18n.phonenumbers.PhoneNumberDesc"
            },
            2: {
                name: "national_number_pattern",
                i: 9,
                type: String
            },
            9: {
                name: "possible_length",
                ca: true,
                i: 5,
                type: Number
            },
            10: {
                name: "possible_length_local_only",
                ca: true,
                i: 5,
                type: Number
            },
            6: {
                name: "example_number",
                i: 9,
                type: String
            }
        }));
        return a;
    };
    D.m = D.prototype.m;
    F.prototype.m = function() {
        var a = Ba;
        a || (Ba = a = w(F, {
            0: {
                name: "PhoneMetadata",
                ja: "i18n.phonenumbers.PhoneMetadata"
            },
            1: {
                name: "general_desc",
                i: 11,
                type: D
            },
            2: {
                name: "fixed_line",
                i: 11,
                type: D
            },
            3: {
                name: "mobile",
                i: 11,
                type: D
            },
            4: {
                name: "toll_free",
                i: 11,
                type: D
            },
            5: {
                name: "premium_rate",
                i: 11,
                type: D
            },
            6: {
                name: "shared_cost",
                i: 11,
                type: D
            },
            7: {
                name: "personal_number",
                i: 11,
                type: D
            },
            8: {
                name: "voip",
                i: 11,
                type: D
            },
            21: {
                name: "pager",
                i: 11,
                type: D
            },
            25: {
                name: "uan",
                i: 11,
                type: D
            },
            27: {
                name: "emergency",
                i: 11,
                type: D
            },
            28: {
                name: "voicemail",
                i: 11,
                type: D
            },
            29: {
                name: "short_code",
                i: 11,
                type: D
            },
            30: {
                name: "standard_rate",
                i: 11,
                type: D
            },
            31: {
                name: "carrier_specific",
                i: 11,
                type: D
            },
            33: {
                name: "sms_services",
                i: 11,
                type: D
            },
            24: {
                name: "no_international_dialling",
                i: 11,
                type: D
            },
            9: {
                name: "id",
                required: true,
                i: 9,
                type: String
            },
            10: {
                name: "country_code",
                i: 5,
                type: Number
            },
            11: {
                name: "international_prefix",
                i: 9,
                type: String
            },
            17: {
                name: "preferred_international_prefix",
                i: 9,
                type: String
            },
            12: {
                name: "national_prefix",
                i: 9,
                type: String
            },
            13: {
                name: "preferred_extn_prefix",
                i: 9,
                type: String
            },
            15: {
                name: "national_prefix_for_parsing",
                i: 9,
                type: String
            },
            16: {
                name: "national_prefix_transform_rule",
                i: 9,
                type: String
            },
            18: {
                name: "same_mobile_and_fixed_line_pattern",
                i: 8,
                defaultValue: false,
                type: Boolean
            },
            19: {
                name: "number_format",
                ca: true,
                i: 11,
                type: C
            },
            20: {
                name: "intl_number_format",
                ca: true,
                i: 11,
                type: C
            },
            22: {
                name: "main_country_for_code",
                i: 8,
                defaultValue: false,
                type: Boolean
            },
            23: {
                name: "leading_digits",
                i: 9,
                type: String
            }
        }));
        return a;
    };
    F.m = F.prototype.m;
    function G() {
        n.call(this);
    }
    m(G, n);
    var Ca = null, Da = {
        sa: 0,
        ra: 1,
        qa: 5,
        pa: 10,
        oa: 20
    };
    G.prototype.m = function() {
        var a = Ca;
        a || (Ca = a = w(G, {
            0: {
                name: "PhoneNumber",
                ja: "i18n.phonenumbers.PhoneNumber"
            },
            1: {
                name: "country_code",
                required: true,
                i: 5,
                type: Number
            },
            2: {
                name: "national_number",
                required: true,
                i: 4,
                type: Number
            },
            3: {
                name: "extension",
                i: 9,
                type: String
            },
            4: {
                name: "italian_leading_zero",
                i: 8,
                type: Boolean
            },
            8: {
                name: "number_of_leading_zeros",
                i: 5,
                defaultValue: 1,
                type: Number
            },
            5: {
                name: "raw_input",
                i: 9,
                type: String
            },
            6: {
                name: "country_code_source",
                i: 14,
                defaultValue: 0,
                type: Da
            },
            7: {
                name: "preferred_domestic_carrier_code",
                i: 9,
                type: String
            }
        }));
        return a;
    };
    G.ctor = G;
    G.ctor.m = G.prototype.m;
    var H = {
        1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
        7: [
            "RU",
            "KZ"
        ],
        20: [
            "EG"
        ],
        27: [
            "ZA"
        ],
        30: [
            "GR"
        ],
        31: [
            "NL"
        ],
        32: [
            "BE"
        ],
        33: [
            "FR"
        ],
        34: [
            "ES"
        ],
        36: [
            "HU"
        ],
        39: [
            "IT",
            "VA"
        ],
        40: [
            "RO"
        ],
        41: [
            "CH"
        ],
        43: [
            "AT"
        ],
        44: [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        45: [
            "DK"
        ],
        46: [
            "SE"
        ],
        47: [
            "NO",
            "SJ"
        ],
        48: [
            "PL"
        ],
        49: [
            "DE"
        ],
        51: [
            "PE"
        ],
        52: [
            "MX"
        ],
        53: [
            "CU"
        ],
        54: [
            "AR"
        ],
        55: [
            "BR"
        ],
        56: [
            "CL"
        ],
        57: [
            "CO"
        ],
        58: [
            "VE"
        ],
        60: [
            "MY"
        ],
        61: [
            "AU",
            "CC",
            "CX"
        ],
        62: [
            "ID"
        ],
        63: [
            "PH"
        ],
        64: [
            "NZ"
        ],
        65: [
            "SG"
        ],
        66: [
            "TH"
        ],
        81: [
            "JP"
        ],
        82: [
            "KR"
        ],
        84: [
            "VN"
        ],
        86: [
            "CN"
        ],
        90: [
            "TR"
        ],
        91: [
            "IN"
        ],
        92: [
            "PK"
        ],
        93: [
            "AF"
        ],
        94: [
            "LK"
        ],
        95: [
            "MM"
        ],
        98: [
            "IR"
        ],
        211: [
            "SS"
        ],
        212: [
            "MA",
            "EH"
        ],
        213: [
            "DZ"
        ],
        216: [
            "TN"
        ],
        218: [
            "LY"
        ],
        220: [
            "GM"
        ],
        221: [
            "SN"
        ],
        222: [
            "MR"
        ],
        223: [
            "ML"
        ],
        224: [
            "GN"
        ],
        225: [
            "CI"
        ],
        226: [
            "BF"
        ],
        227: [
            "NE"
        ],
        228: [
            "TG"
        ],
        229: [
            "BJ"
        ],
        230: [
            "MU"
        ],
        231: [
            "LR"
        ],
        232: [
            "SL"
        ],
        233: [
            "GH"
        ],
        234: [
            "NG"
        ],
        235: [
            "TD"
        ],
        236: [
            "CF"
        ],
        237: [
            "CM"
        ],
        238: [
            "CV"
        ],
        239: [
            "ST"
        ],
        240: [
            "GQ"
        ],
        241: [
            "GA"
        ],
        242: [
            "CG"
        ],
        243: [
            "CD"
        ],
        244: [
            "AO"
        ],
        245: [
            "GW"
        ],
        246: [
            "IO"
        ],
        247: [
            "AC"
        ],
        248: [
            "SC"
        ],
        249: [
            "SD"
        ],
        250: [
            "RW"
        ],
        251: [
            "ET"
        ],
        252: [
            "SO"
        ],
        253: [
            "DJ"
        ],
        254: [
            "KE"
        ],
        255: [
            "TZ"
        ],
        256: [
            "UG"
        ],
        257: [
            "BI"
        ],
        258: [
            "MZ"
        ],
        260: [
            "ZM"
        ],
        261: [
            "MG"
        ],
        262: [
            "RE",
            "YT"
        ],
        263: [
            "ZW"
        ],
        264: [
            "NA"
        ],
        265: [
            "MW"
        ],
        266: [
            "LS"
        ],
        267: [
            "BW"
        ],
        268: [
            "SZ"
        ],
        269: [
            "KM"
        ],
        290: [
            "SH",
            "TA"
        ],
        291: [
            "ER"
        ],
        297: [
            "AW"
        ],
        298: [
            "FO"
        ],
        299: [
            "GL"
        ],
        350: [
            "GI"
        ],
        351: [
            "PT"
        ],
        352: [
            "LU"
        ],
        353: [
            "IE"
        ],
        354: [
            "IS"
        ],
        355: [
            "AL"
        ],
        356: [
            "MT"
        ],
        357: [
            "CY"
        ],
        358: [
            "FI",
            "AX"
        ],
        359: [
            "BG"
        ],
        370: [
            "LT"
        ],
        371: [
            "LV"
        ],
        372: [
            "EE"
        ],
        373: [
            "MD"
        ],
        374: [
            "AM"
        ],
        375: [
            "BY"
        ],
        376: [
            "AD"
        ],
        377: [
            "MC"
        ],
        378: [
            "SM"
        ],
        380: [
            "UA"
        ],
        381: [
            "RS"
        ],
        382: [
            "ME"
        ],
        383: [
            "XK"
        ],
        385: [
            "HR"
        ],
        386: [
            "SI"
        ],
        387: [
            "BA"
        ],
        389: [
            "MK"
        ],
        420: [
            "CZ"
        ],
        421: [
            "SK"
        ],
        423: [
            "LI"
        ],
        500: [
            "FK"
        ],
        501: [
            "BZ"
        ],
        502: [
            "GT"
        ],
        503: [
            "SV"
        ],
        504: [
            "HN"
        ],
        505: [
            "NI"
        ],
        506: [
            "CR"
        ],
        507: [
            "PA"
        ],
        508: [
            "PM"
        ],
        509: [
            "HT"
        ],
        590: [
            "GP",
            "BL",
            "MF"
        ],
        591: [
            "BO"
        ],
        592: [
            "GY"
        ],
        593: [
            "EC"
        ],
        594: [
            "GF"
        ],
        595: [
            "PY"
        ],
        596: [
            "MQ"
        ],
        597: [
            "SR"
        ],
        598: [
            "UY"
        ],
        599: [
            "CW",
            "BQ"
        ],
        670: [
            "TL"
        ],
        672: [
            "NF"
        ],
        673: [
            "BN"
        ],
        674: [
            "NR"
        ],
        675: [
            "PG"
        ],
        676: [
            "TO"
        ],
        677: [
            "SB"
        ],
        678: [
            "VU"
        ],
        679: [
            "FJ"
        ],
        680: [
            "PW"
        ],
        681: [
            "WF"
        ],
        682: [
            "CK"
        ],
        683: [
            "NU"
        ],
        685: [
            "WS"
        ],
        686: [
            "KI"
        ],
        687: [
            "NC"
        ],
        688: [
            "TV"
        ],
        689: [
            "PF"
        ],
        690: [
            "TK"
        ],
        691: [
            "FM"
        ],
        692: [
            "MH"
        ],
        800: [
            "001"
        ],
        808: [
            "001"
        ],
        850: [
            "KP"
        ],
        852: [
            "HK"
        ],
        853: [
            "MO"
        ],
        855: [
            "KH"
        ],
        856: [
            "LA"
        ],
        870: [
            "001"
        ],
        878: [
            "001"
        ],
        880: [
            "BD"
        ],
        881: [
            "001"
        ],
        882: [
            "001"
        ],
        883: [
            "001"
        ],
        886: [
            "TW"
        ],
        888: [
            "001"
        ],
        960: [
            "MV"
        ],
        961: [
            "LB"
        ],
        962: [
            "JO"
        ],
        963: [
            "SY"
        ],
        964: [
            "IQ"
        ],
        965: [
            "KW"
        ],
        966: [
            "SA"
        ],
        967: [
            "YE"
        ],
        968: [
            "OM"
        ],
        970: [
            "PS"
        ],
        971: [
            "AE"
        ],
        972: [
            "IL"
        ],
        973: [
            "BH"
        ],
        974: [
            "QA"
        ],
        975: [
            "BT"
        ],
        976: [
            "MN"
        ],
        977: [
            "NP"
        ],
        979: [
            "001"
        ],
        992: [
            "TJ"
        ],
        993: [
            "TM"
        ],
        994: [
            "AZ"
        ],
        995: [
            "GE"
        ],
        996: [
            "KG"
        ],
        998: [
            "UZ"
        ]
    }, Ea = {
        AC: [
            ,
            [
                ,
                ,
                "(?:[01589]\\d|[46])\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "6[2-467]\\d{3}",
                ,
                ,
                ,
                "62889",
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                "4\\d{4}",
                ,
                ,
                ,
                "40123",
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "AC",
            247,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:0[1-9]|[1589]\\d)\\d{4}",
                ,
                ,
                ,
                "542011",
                ,
                ,
                [
                    6
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AD: [
            ,
            [
                ,
                ,
                "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "[78]\\d{5}",
                ,
                ,
                ,
                "712345",
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "690\\d{6}|[356]\\d{5}",
                ,
                ,
                ,
                "312345",
                ,
                ,
                [
                    6,
                    9
                ]
            ],
            [
                ,
                ,
                "180[02]\\d{4}",
                ,
                ,
                ,
                "18001234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "[19]\\d{5}",
                ,
                ,
                ,
                "912345",
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "AD",
            376,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "1800\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AE: [
            ,
            [
                ,
                ,
                "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                "[2-4679][2-8]\\d{6}",
                ,
                ,
                ,
                "22345678",
                ,
                ,
                [
                    8
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "5[02-68]\\d{7}",
                ,
                ,
                ,
                "501234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "400\\d{6}|800\\d{2,9}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                "900[02]\\d{5}",
                ,
                ,
                ,
                "900234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "700[05]\\d{5}",
                ,
                ,
                ,
                "700012345",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "AE",
            971,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "600[25]\\d{5}",
                ,
                ,
                ,
                "600212345",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AF: [
            ,
            [
                ,
                ,
                "[2-7]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
                ,
                ,
                ,
                "234567890",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "7\\d{8}",
                ,
                ,
                ,
                "701234567",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "AF",
            93,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AG: [
            ,
            [
                ,
                ,
                "(?:268|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
                ,
                ,
                ,
                "2684601234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",
                ,
                ,
                ,
                "2684641234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                "26848[01]\\d{4}",
                ,
                ,
                ,
                "2684801234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            "AG",
            1,
            "011",
            "1",
            ,
            ,
            "([457]\\d{6})$|1",
            "268$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                "26840[69]\\d{4}",
                ,
                ,
                ,
                "2684061234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            ,
            "268",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AI: [
            ,
            [
                ,
                ,
                "(?:264|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "264(?:292|4(?:6[12]|9[78]))\\d{4}",
                ,
                ,
                ,
                "2644612345",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",
                ,
                ,
                ,
                "2642351234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "AI",
            1,
            "011",
            "1",
            ,
            ,
            "([2457]\\d{6})$|1",
            "264$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                "264724\\d{4}",
                ,
                ,
                ,
                "2647241234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            ,
            "264",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AL: [
            ,
            [
                ,
                ,
                "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9
                ],
                [
                    5
                ]
            ],
            [
                ,
                ,
                "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",
                ,
                ,
                ,
                "22345678",
                ,
                ,
                [
                    8
                ],
                [
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "6(?:[78][2-9]|9\\d)\\d{6}",
                ,
                ,
                ,
                "672123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{4}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "900[1-9]\\d\\d",
                ,
                ,
                ,
                "900123",
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "808[1-9]\\d\\d",
                ,
                ,
                ,
                "808123",
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "700[2-9]\\d{4}",
                ,
                ,
                ,
                "70021234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "AL",
            355,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AM: [
            ,
            [
                ,
                ,
                "(?:[1-489]\\d|55|60|77)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ],
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",
                ,
                ,
                ,
                "10123456",
                ,
                ,
                ,
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",
                ,
                ,
                ,
                "77123456"
            ],
            [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345"
            ],
            [
                ,
                ,
                "90[016]\\d{5}",
                ,
                ,
                ,
                "90012345"
            ],
            [
                ,
                ,
                "80[1-4]\\d{5}",
                ,
                ,
                ,
                "80112345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}",
                ,
                ,
                ,
                "60271234"
            ],
            "AM",
            374,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AO: [
            ,
            [
                ,
                ,
                "[29]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
                ,
                ,
                ,
                "222123456"
            ],
            [
                ,
                ,
                "9[1-79]\\d{7}",
                ,
                ,
                ,
                "923123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "AO",
            244,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AR: [
            ,
            [
                ,
                ,
                "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10,
                    11
                ],
                [
                    6,
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68])))\\d{6}|(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                ,
                ,
                ,
                "1123456789",
                ,
                ,
                [
                    10
                ],
                [
                    6,
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                ,
                ,
                ,
                "91123456789",
                ,
                ,
                ,
                [
                    6,
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "800\\d{7,8}",
                ,
                ,
                ,
                "8001234567"
            ],
            [
                ,
                ,
                "60[04579]\\d{7}",
                ,
                ,
                ,
                "6001234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "AR",
            54,
            "00",
            "0",
            ,
            ,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1",
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})",
                    "$1",
                    [
                        "0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-8]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3-$4",
                    [
                        "91"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3-$4",
                    [
                        "9"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "810\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "810\\d{7}",
                ,
                ,
                ,
                "8101234567",
                ,
                ,
                [
                    10
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AS: [
            ,
            [
                ,
                ,
                "(?:[58]\\d\\d|684|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "684(?:274|6(?:22|33|44|55|77|88|9[19]))\\d{4}",
                ,
                ,
                ,
                "6846221234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "684(?:2(?:48|5[2468]|7[246])|7(?:3[13]|70|82))\\d{4}",
                ,
                ,
                ,
                "6847331234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "AS",
            1,
            "011",
            "1",
            ,
            ,
            "([267]\\d{6})$|1",
            "684$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "684",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AT: [
            ,
            [
                ,
                ,
                "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13
                ],
                [
                    3
                ]
            ],
            [
                ,
                ,
                "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463)\\d{3,10}|648[34]\\d{3,9}|(?:51|66|73)2\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-7]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",
                ,
                ,
                ,
                "1234567890",
                ,
                ,
                ,
                [
                    3
                ]
            ],
            [
                ,
                ,
                "6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}",
                ,
                ,
                ,
                "664123456",
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13
                ]
            ],
            [
                ,
                ,
                "800\\d{6,10}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9,
                    10,
                    11,
                    12,
                    13
                ]
            ],
            [
                ,
                ,
                "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [
                    9,
                    10,
                    11,
                    12,
                    13
                ]
            ],
            [
                ,
                ,
                "8(?:10|2[018])\\d{6,10}|828\\d{5}",
                ,
                ,
                ,
                "810123456",
                ,
                ,
                [
                    8,
                    9,
                    10,
                    11,
                    12,
                    13
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",
                ,
                ,
                ,
                "780123456",
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13
                ]
            ],
            "AT",
            43,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})",
                    "$1",
                    [
                        "14"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{6})",
                    "$1",
                    [
                        "[18]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]",
                        "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]",
                        "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AU: [
            ,
            [
                ,
                ,
                "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    12
                ]
            ],
            [
                ,
                ,
                "(?:(?:241|349)0\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|91(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79]))))\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:55|6[0-8]|[78]\\d|9[02-9]))\\d{6}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                [
                    9
                ],
                [
                    8
                ]
            ],
            [
                ,
                ,
                "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "180(?:0\\d{3}|2)\\d{3}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [
                    7,
                    10
                ]
            ],
            [
                ,
                ,
                "190[0-26]\\d{6}",
                ,
                ,
                ,
                "1900123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                ,
                ,
                ,
                "1300123456",
                ,
                ,
                [
                    6,
                    8,
                    10,
                    12
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                ,
                ,
                ,
                "147101234",
                ,
                ,
                [
                    9
                ]
            ],
            "AU",
            61,
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "0",
            ,
            ,
            "(183[12])|0",
            ,
            "0011",
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "13"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "19"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "180",
                        "1802"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "19"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)",
                    "$CC ($1)"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "130"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)",
                    "$CC ($1)"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            [
                ,
                ,
                "163\\d{2,6}",
                ,
                ,
                ,
                "1631234",
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9
                ]
            ],
            1,
            ,
            [
                ,
                ,
                "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    10,
                    12
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AW: [
            ,
            [
                ,
                ,
                "(?:[25-79]\\d\\d|800)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "5(?:2\\d|8[1-9])\\d{4}",
                ,
                ,
                ,
                "5212345"
            ],
            [
                ,
                ,
                "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",
                ,
                ,
                ,
                "5601234"
            ],
            [
                ,
                ,
                "800\\d{4}",
                ,
                ,
                ,
                "8001234"
            ],
            [
                ,
                ,
                "900\\d{4}",
                ,
                ,
                ,
                "9001234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:28\\d|501)\\d{4}",
                ,
                ,
                ,
                "5011234"
            ],
            "AW",
            297,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AX: [
            ,
            [
                ,
                ,
                "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                "18[1-8]\\d{3,6}",
                ,
                ,
                ,
                "181234567",
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "800\\d{4,6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    7,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "[67]00\\d{5,6}",
                ,
                ,
                ,
                "600123456",
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "AX",
            358,
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "0",
            ,
            ,
            "0",
            ,
            "00",
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "18",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                ,
                ,
                ,
                "10112345"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        AZ: [
            ,
            [
                ,
                ,
                "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}",
                ,
                ,
                ,
                "123123456",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",
                ,
                ,
                ,
                "401234567"
            ],
            [
                ,
                ,
                "88\\d{7}",
                ,
                ,
                ,
                "881234567"
            ],
            [
                ,
                ,
                "900200\\d{3}",
                ,
                ,
                ,
                "900200123"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "AZ",
            994,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BA: [
            ,
            [
                ,
                ,
                "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",
                ,
                ,
                ,
                "30212345",
                ,
                ,
                [
                    8
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",
                ,
                ,
                ,
                "61123456"
            ],
            [
                ,
                ,
                "8[08]\\d{6}",
                ,
                ,
                ,
                "80123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "9[0246]\\d{6}",
                ,
                ,
                ,
                "90123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "8[12]\\d{6}",
                ,
                ,
                ,
                "82123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "BA",
            387,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",
                ,
                ,
                ,
                "70341234",
                ,
                ,
                [
                    8
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BB: [
            ,
            [
                ,
                ,
                "(?:246|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}",
                ,
                ,
                ,
                "2464123456",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}",
                ,
                ,
                ,
                "2462501234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "(?:246976|900[2-9]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "9002123456",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                "24631\\d{5}",
                ,
                ,
                ,
                "2463101234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            "BB",
            1,
            "011",
            "1",
            ,
            ,
            "([2-9]\\d{6})$|1",
            "246$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "246",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
                ,
                ,
                ,
                "2464301234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BD: [
            ,
            [
                ,
                ,
                "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
                ,
                ,
                ,
                "27111234"
            ],
            [
                ,
                ,
                "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",
                ,
                ,
                ,
                "1812345678",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "80[03]\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}",
                ,
                ,
                ,
                "9604123456",
                ,
                ,
                [
                    10
                ]
            ],
            "BD",
            880,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|2[23]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BE: [
            ,
            [
                ,
                ,
                "4\\d{8}|[1-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",
                ,
                ,
                ,
                "12345678",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "4[5-9]\\d{7}",
                ,
                ,
                ,
                "450001234",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800[1-9]\\d{4}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}",
                ,
                ,
                ,
                "90012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "7879\\d{4}",
                ,
                ,
                ,
                "78791234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "BE",
            32,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}",
                ,
                ,
                ,
                "78102345",
                ,
                ,
                [
                    8
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BF: [
            ,
            [
                ,
                ,
                "[024-7]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}",
                ,
                ,
                ,
                "20491234"
            ],
            [
                ,
                ,
                "(?:0[1-7]|4[4-6]|5[0-8]|[67]\\d)\\d{6}",
                ,
                ,
                ,
                "70123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "BF",
            226,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[024-7]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BG: [
            ,
            [
                ,
                ,
                "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    12
                ],
                [
                    4,
                    5
                ]
            ],
            [
                ,
                ,
                "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",
                ,
                ,
                ,
                "2123456",
                ,
                ,
                [
                    6,
                    7,
                    8
                ],
                [
                    4,
                    5
                ]
            ],
            [
                ,
                ,
                "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",
                ,
                ,
                ,
                "43012345",
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "(?:00800\\d\\d|800)\\d{5}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [
                    8,
                    12
                ]
            ],
            [
                ,
                ,
                "90\\d{6}",
                ,
                ,
                ,
                "90123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "700\\d{5}",
                ,
                ,
                ,
                "70012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "BG",
            359,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{6})",
                    "$1",
                    [
                        "1"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BH: [
            ,
            [
                ,
                ,
                "[136-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
                ,
                ,
                ,
                "17001234"
            ],
            [
                ,
                ,
                "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}",
                ,
                ,
                ,
                "36001234"
            ],
            [
                ,
                ,
                "8[02369]\\d{6}",
                ,
                ,
                ,
                "80123456"
            ],
            [
                ,
                ,
                "(?:87|9[0-8])\\d{6}",
                ,
                ,
                ,
                "90123456"
            ],
            [
                ,
                ,
                "84\\d{6}",
                ,
                ,
                ,
                "84123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "BH",
            973,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BI: [
            ,
            [
                ,
                ,
                "(?:[267]\\d|31)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:22|31)\\d{6}",
                ,
                ,
                ,
                "22201234"
            ],
            [
                ,
                ,
                "(?:29|6[1-9]|7[125-9])\\d{6}",
                ,
                ,
                ,
                "79561234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "BI",
            257,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BJ: [
            ,
            [
                ,
                ,
                "(?:01\\d|8)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    10
                ]
            ],
            [
                ,
                ,
                "012\\d{7}",
                ,
                ,
                ,
                "0120211234",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "01(?:2[5-9]|[4-69]\\d)\\d{6}",
                ,
                ,
                ,
                "0195123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "857[58]\\d{4}",
                ,
                ,
                ,
                "85751234",
                ,
                ,
                [
                    8
                ]
            ],
            "BJ",
            229,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "0"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "81\\d{6}",
                ,
                ,
                ,
                "81123456",
                ,
                ,
                [
                    8
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BL: [
            ,
            [
                ,
                ,
                "7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:59(?:0(?:2[7-9]|3[3-7]|5[12]|87)|87\\d)|80[6-9]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "590271234"
            ],
            [
                ,
                ,
                "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}",
                ,
                ,
                ,
                "690001234"
            ],
            [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345"
            ],
            [
                ,
                ,
                "8[129]\\d{7}",
                ,
                ,
                ,
                "810123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}",
                ,
                ,
                ,
                "976012345"
            ],
            "BL",
            590,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BM: [
            ,
            [
                ,
                ,
                "(?:441|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",
                ,
                ,
                ,
                "4414123456",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "441(?:[2378]\\d|5[0-39]|9[02])\\d{5}",
                ,
                ,
                ,
                "4413701234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "BM",
            1,
            "011",
            "1",
            ,
            ,
            "([2-9]\\d{6})$|1",
            "441$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "441",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BN: [
            ,
            [
                ,
                ,
                "[2-578]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",
                ,
                ,
                ,
                "2345678"
            ],
            [
                ,
                ,
                "(?:22[89]|[78]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "7123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "5[34]\\d{5}",
                ,
                ,
                ,
                "5345678"
            ],
            "BN",
            673,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BO: [
            ,
            [
                ,
                ,
                "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [
                    8
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "[67]\\d{7}",
                ,
                ,
                ,
                "71234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "8001[07]\\d{4}",
                ,
                ,
                ,
                "800171234",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "50\\d{6}",
                ,
                ,
                ,
                "50123456",
                ,
                ,
                [
                    8
                ],
                [
                    7
                ]
            ],
            "BO",
            591,
            "00(?:1\\d)?",
            "0",
            ,
            ,
            "0(1\\d)?",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[235]|4[46]"
                    ],
                    ,
                    "0$CC $1"
                ],
                [
                    ,
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ],
                    ,
                    "0$CC $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    ,
                    "0$CC $1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "8001[07]\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BQ: [
            ,
            [
                ,
                ,
                "(?:[34]1|7\\d)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}",
                ,
                ,
                ,
                "7151234"
            ],
            [
                ,
                ,
                "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",
                ,
                ,
                ,
                "3181234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "BQ",
            599,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "[347]",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BR: [
            ,
            [
                ,
                ,
                "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",
                ,
                ,
                ,
                "1123456789",
                ,
                ,
                [
                    10
                ],
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",
                ,
                ,
                ,
                "11961234567",
                ,
                ,
                [
                    10,
                    11
                ],
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{6,7}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "[59]00\\d{6,7}",
                ,
                ,
                ,
                "500123456",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370|864))\\d{4}|300\\d{5}",
                ,
                ,
                ,
                "40041234",
                ,
                ,
                [
                    8,
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "BR",
            55,
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "0",
            ,
            ,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2",
            ,
            ,
            [
                [
                    ,
                    "(\\d{3,6})",
                    "$1",
                    [
                        "1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37|86)",
                        "300|4(?:0(?:0|20)|370|864)"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-57]",
                        "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{5})(\\d{4})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)",
                    "0 $CC ($1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)",
                    "0 $CC ($1)"
                ]
            ],
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37|86)",
                        "300|4(?:0(?:0|20)|370|864)"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)",
                    "0 $CC ($1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)",
                    "0 $CC ($1)"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|864))\\d{4}|800\\d{6,7}|300\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BS: [
            ,
            [
                ,
                ,
                "(?:242|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
                ,
                ,
                ,
                "2423456789",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}",
                ,
                ,
                ,
                "2423591234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "BS",
            1,
            "011",
            "1",
            ,
            ,
            "([3-8]\\d{6})$|1",
            "242$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "242",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "242225\\d{4}",
                ,
                ,
                ,
                "2422250123"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BT: [
            ,
            [
                ,
                ,
                "[178]\\d{7}|[2-8]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",
                ,
                ,
                ,
                "2345678",
                ,
                ,
                [
                    7
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:1[67]|[78]7)\\d{6}",
                ,
                ,
                ,
                "17123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "BT",
            975,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-7]"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-6]|7[246]|8[2-4]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|[78]"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-6]|7[246]|8[2-4]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|[78]"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BW: [
            ,
            [
                ,
                ,
                "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    10
                ]
            ],
            [
                ,
                ,
                "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}",
                ,
                ,
                ,
                "2401234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:321|7(?:[1-8]\\d|9[03]))\\d{5}",
                ,
                ,
                ,
                "71123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:0800|800\\d)\\d{6}",
                ,
                ,
                ,
                "0800012345",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "90\\d{5}",
                ,
                ,
                ,
                "9012345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "79(?:1(?:[0-2]\\d|3[0-8])|2[0-7]\\d)\\d{3}",
                ,
                ,
                ,
                "79101234",
                ,
                ,
                [
                    8
                ]
            ],
            "BW",
            267,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BY: [
            ,
            [
                ,
                ,
                "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10,
                    11
                ],
                [
                    5
                ]
            ],
            [
                ,
                ,
                "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",
                ,
                ,
                ,
                "152450911",
                ,
                ,
                [
                    9
                ],
                [
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
                ,
                ,
                ,
                "294911911",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",
                ,
                ,
                ,
                "8011234567"
            ],
            [
                ,
                ,
                "(?:810|902)\\d{7}",
                ,
                ,
                ,
                "9021234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "249\\d{6}",
                ,
                ,
                ,
                "249123456",
                ,
                ,
                [
                    9
                ]
            ],
            "BY",
            375,
            "810",
            "8",
            ,
            ,
            "0|80?",
            ,
            "8~10",
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        BZ: [
            ,
            [
                ,
                ,
                "(?:0800\\d|[2-8])\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    11
                ]
            ],
            [
                ,
                ,
                "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",
                ,
                ,
                ,
                "2221234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "6[0-35-7]\\d{5}",
                ,
                ,
                ,
                "6221234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "0800\\d{7}",
                ,
                ,
                ,
                "08001234123",
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "BZ",
            501,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CA: [
            ,
            [
                ,
                ,
                "[2-9]\\d{9}|3\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    10
                ]
            ],
            [
                ,
                ,
                "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                ,
                ,
                ,
                "5062345678",
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                ,
                ,
                ,
                "5062345678",
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|3[23]|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                ,
                ,
                ,
                "5219023456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "600[2-9]\\d{6}",
                ,
                ,
                ,
                "6002012345",
                ,
                ,
                [
                    10
                ]
            ],
            "CA",
            1,
            "011",
            "1",
            ,
            ,
            "1",
            ,
            ,
            1,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "310\\d{4}",
                ,
                ,
                ,
                "3101234",
                ,
                ,
                [
                    7
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CC: [
            ,
            [
                ,
                ,
                "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10,
                    12
                ]
            ],
            [
                ,
                ,
                "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                ,
                ,
                ,
                "891621234",
                ,
                ,
                [
                    9
                ],
                [
                    8
                ]
            ],
            [
                ,
                ,
                "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "180(?:0\\d{3}|2)\\d{3}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [
                    7,
                    10
                ]
            ],
            [
                ,
                ,
                "190[0-26]\\d{6}",
                ,
                ,
                ,
                "1900123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                ,
                ,
                ,
                "1300123456",
                ,
                ,
                [
                    6,
                    8,
                    10,
                    12
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                ,
                ,
                ,
                "147101234",
                ,
                ,
                [
                    9
                ]
            ],
            "CC",
            61,
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "0",
            ,
            ,
            "([59]\\d{7})$|0",
            "8$1",
            "0011",
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CD: [
            ,
            [
                ,
                ,
                "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}",
                ,
                ,
                ,
                "1234567"
            ],
            [
                ,
                ,
                "88\\d{5}|(?:8[0-69]|9[016-9])\\d{7}",
                ,
                ,
                ,
                "991234567",
                ,
                ,
                [
                    7,
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "CD",
            243,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CF: [
            ,
            [
                ,
                ,
                "8776\\d{4}|(?:[27]\\d|61)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:2[12]|61)\\d{6}",
                ,
                ,
                ,
                "21612345"
            ],
            [
                ,
                ,
                "7[02-7]\\d{6}",
                ,
                ,
                ,
                "70012345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "8776\\d{4}",
                ,
                ,
                ,
                "87761234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "CF",
            236,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-8]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CG: [
            ,
            [
                ,
                ,
                "222\\d{6}|(?:0\\d|80)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "222[1-589]\\d{5}",
                ,
                ,
                ,
                "222123456"
            ],
            [
                ,
                ,
                "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
                ,
                ,
                ,
                "061234567"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "80[0-2]\\d{6}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "CG",
            242,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CH: [
            ,
            [
                ,
                ,
                "8\\d{11}|[2-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9,
                    12
                ]
            ],
            [
                ,
                ,
                "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:6[89]|7[235-9])\\d{7}",
                ,
                ,
                ,
                "781234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "90[016]\\d{6}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "84[0248]\\d{6}",
                ,
                ,
                ,
                "840123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "878\\d{6}",
                ,
                ,
                ,
                "878123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "CH",
            41,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                "74[0248]\\d{6}",
                ,
                ,
                ,
                "740123456",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "5[18]\\d{7}",
                ,
                ,
                ,
                "581234567",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "860\\d{9}",
                ,
                ,
                ,
                "860123456789",
                ,
                ,
                [
                    12
                ]
            ]
        ],
        CI: [
            ,
            [
                ,
                ,
                "[02]\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",
                ,
                ,
                ,
                "2123456789"
            ],
            [
                ,
                ,
                "0[157]\\d{8}",
                ,
                ,
                ,
                "0123456789"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "CI",
            225,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CK: [
            ,
            [
                ,
                ,
                "[2-578]\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                "(?:2\\d|3[13-7]|4[1-5])\\d{3}",
                ,
                ,
                ,
                "21234"
            ],
            [
                ,
                ,
                "[578]\\d{4}",
                ,
                ,
                ,
                "71234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "CK",
            682,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CL: [
            ,
            [
                ,
                ,
                "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9,
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:(?:[24]\\d|50)\\d|3(?:[034679]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389])|600)|646[59])|(?:600|80[1-9])\\d\\d|9(?:(?:10[0-2]|7[1-9]\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                ,
                ,
                ,
                "600123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:(?:[24]\\d|50)\\d|3(?:[034679]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389])|600)|646[59])|80[1-8]\\d\\d|9(?:(?:10[0-2]|7[1-9]\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                ,
                ,
                ,
                "221234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:123|8)00\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9,
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "600\\d{7,8}",
                ,
                ,
                ,
                "6001234567",
                ,
                ,
                [
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "44\\d{7}",
                ,
                ,
                ,
                "441234567",
                ,
                ,
                [
                    9
                ]
            ],
            "CL",
            56,
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})",
                    "$1",
                    [
                        "1(?:[03-589]|21)|[29]0|78"
                    ]
                ],
                [
                    ,
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "60|809"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9(?:10|[2-9])"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "60|809"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9(?:10|[2-9])"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "600\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CM: [
            ,
            [
                ,
                ,
                "[26]\\d{8}|88\\d{6,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "2(?:22|33)\\d{6}",
                ,
                ,
                ,
                "222123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:24[23]|6(?:[25-9]\\d|4[01]))\\d{6}",
                ,
                ,
                ,
                "671234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "88\\d{6,7}",
                ,
                ,
                ,
                "88012345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "CM",
            237,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CN: [
            ,
            [
                ,
                ,
                "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10,
                    11,
                    12
                ],
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
                ,
                ,
                ,
                "1012345678",
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10,
                    11
                ],
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",
                ,
                ,
                ,
                "13123456789",
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                "(?:(?:10|21)8|8)00\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [
                    10,
                    12
                ]
            ],
            [
                ,
                ,
                "16[08]\\d{5}",
                ,
                ,
                ,
                "16812345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
                ,
                ,
                ,
                "4001234567",
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10,
                    11
                ],
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "CN",
            86,
            "00|1(?:[12]\\d|79)\\d\\d00",
            "0",
            ,
            ,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{5,6})",
                    "$1",
                    [
                        "1(?:00|2[13])|9[56]",
                        "1(?:00|2(?:1|39))|9[56]",
                        "1(?:00|2(?:1|395))|9[56]"
                    ]
                ],
                [
                    ,
                    "(\\d{5,6})",
                    "$1",
                    [
                        "1(?:0|23)|781|[1-9]12",
                        "1(?:0|23)|7812|[1-9]123",
                        "1(?:0|23(?:[0-8]|9[0-46-9]))|78123|[1-9]123"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1",
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]",
                        "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])",
                        "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|[3-9]",
                        "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))",
                        "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:0(?:[0-689]|7[0-79])|1[01459]|2[0-489]|[46]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "16[08]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1",
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]",
                        "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
                        "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
                        "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    "$CC $1",
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    "$CC $1",
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    "$CC $1",
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    "$CC $1",
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    ,
                    1
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1",
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1",
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    "$CC $1",
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    "$CC $1",
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    "$CC $1",
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    "$CC $1",
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    ,
                    1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CO: [
            ,
            [
                ,
                ,
                "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    10,
                    11
                ],
                [
                    4,
                    7
                ]
            ],
            [
                ,
                ,
                "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[18][1-9]|[24-7][2-9]))\\d{6}",
                ,
                ,
                ,
                "6012345678",
                ,
                ,
                [
                    8,
                    10
                ],
                [
                    4,
                    7
                ]
            ],
            [
                ,
                ,
                "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:(?:0[0-5]|1\\d|5[01]|70)\\d|2(?:[0-3]\\d|4[1-9])|3(?:00|3[0-24-9]))|9(?:101|408))\\d{6}",
                ,
                ,
                ,
                "3211234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "1800\\d{7}",
                ,
                ,
                ,
                "18001234567",
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                "(?:19(?:0[01]|4[78])|901)\\d{7}",
                ,
                ,
                ,
                "19001234567",
                ,
                ,
                [
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "CO",
            57,
            "00(?:4(?:[14]4|56)|[579])",
            "0",
            ,
            ,
            "0([3579]|4(?:[14]4|56))?",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)",
                    "0$CC $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|9[14]"
                    ],
                    ,
                    "0$CC $1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)",
                    "0$CC $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|9[14]"
                    ],
                    ,
                    "0$CC $1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CR: [
            ,
            [
                ,
                ,
                "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    10
                ]
            ],
            [
                ,
                ,
                "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
                ,
                ,
                ,
                "83123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "800\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "90[059]\\d{7}",
                ,
                ,
                ,
                "9001234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:210[0-6]|4\\d{3}|5100)\\d{4}",
                ,
                ,
                ,
                "40001234",
                ,
                ,
                [
                    8
                ]
            ],
            "CR",
            506,
            "00",
            ,
            ,
            ,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ],
                    ,
                    "$CC $1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CU: [
            ,
            [
                ,
                ,
                "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    10
                ],
                [
                    4,
                    5
                ]
            ],
            [
                ,
                ,
                "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",
                ,
                ,
                ,
                "71234567",
                ,
                ,
                ,
                [
                    4,
                    5
                ]
            ],
            [
                ,
                ,
                "(?:5\\d|6[2-4])\\d{6}",
                ,
                ,
                ,
                "51234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "800\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "807\\d{7}",
                ,
                ,
                ,
                "8071234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "CU",
            53,
            "119",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CV: [
            ,
            [
                ,
                ,
                "(?:[2-59]\\d\\d|800)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
                ,
                ,
                ,
                "2211234"
            ],
            [
                ,
                ,
                "(?:36|5[1-389]|9\\d)\\d{5}",
                ,
                ,
                ,
                "9911234"
            ],
            [
                ,
                ,
                "800\\d{4}",
                ,
                ,
                ,
                "8001234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:3[3-5]|4[356])\\d{5}",
                ,
                ,
                ,
                "3401234"
            ],
            "CV",
            238,
            "0",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CW: [
            ,
            [
                ,
                ,
                "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
                ,
                ,
                ,
                "94351234"
            ],
            [
                ,
                ,
                "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",
                ,
                ,
                ,
                "95181234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "60[0-2]\\d{4}",
                ,
                ,
                ,
                "6001234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "CW",
            599,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                "955\\d{5}",
                ,
                ,
                ,
                "95581234",
                ,
                ,
                [
                    8
                ]
            ],
            1,
            "[69]",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CX: [
            ,
            [
                ,
                ,
                "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10,
                    12
                ]
            ],
            [
                ,
                ,
                "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                ,
                ,
                ,
                "891641234",
                ,
                ,
                [
                    9
                ],
                [
                    8
                ]
            ],
            [
                ,
                ,
                "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "180(?:0\\d{3}|2)\\d{3}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [
                    7,
                    10
                ]
            ],
            [
                ,
                ,
                "190[0-26]\\d{6}",
                ,
                ,
                ,
                "1900123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                ,
                ,
                ,
                "1300123456",
                ,
                ,
                [
                    6,
                    8,
                    10,
                    12
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                ,
                ,
                ,
                "147101234",
                ,
                ,
                [
                    9
                ]
            ],
            "CX",
            61,
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "0",
            ,
            ,
            "([59]\\d{7})$|0",
            "8$1",
            "0011",
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CY: [
            ,
            [
                ,
                ,
                "(?:[279]\\d|[58]0)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "2[2-6]\\d{6}",
                ,
                ,
                ,
                "22345678"
            ],
            [
                ,
                ,
                "9(?:10|[4-79]\\d)\\d{5}",
                ,
                ,
                ,
                "96123456"
            ],
            [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80001234"
            ],
            [
                ,
                ,
                "90[09]\\d{5}",
                ,
                ,
                ,
                "90012345"
            ],
            [
                ,
                ,
                "80[1-9]\\d{5}",
                ,
                ,
                ,
                "80112345"
            ],
            [
                ,
                ,
                "700\\d{5}",
                ,
                ,
                ,
                "70012345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "CY",
            357,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:50|77)\\d{6}",
                ,
                ,
                ,
                "77123456"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        CZ: [
            ,
            [
                ,
                ,
                "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9,
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "7060\\d{5}|(?:60[1-8]|7(?:0[2-5]|19|[2379]\\d))\\d{6}",
                ,
                ,
                ,
                "601123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "9(?:0[05689]|76)\\d{6}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "8[134]\\d{7}",
                ,
                ,
                ,
                "811234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "70[01]\\d{6}",
                ,
                ,
                ,
                "700123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "9[17]0\\d{6}",
                ,
                ,
                ,
                "910123456",
                ,
                ,
                [
                    9
                ]
            ],
            "CZ",
            420,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9(?:5\\d|7[2-4])\\d{6}",
                ,
                ,
                ,
                "972123456",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "9(?:3\\d{9}|6\\d{7,10})",
                ,
                ,
                ,
                "93123456789"
            ]
        ],
        DE: [
            ,
            [
                ,
                ,
                "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15
                ],
                [
                    2,
                    3
                ]
            ],
            [
                ,
                ,
                "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
                ,
                ,
                ,
                "30123456",
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15
                ],
                [
                    2,
                    3,
                    4
                ]
            ],
            [
                ,
                ,
                "1(?:6[023]|7\\d)\\d{7,8}|15(?:[0-25-9]\\d\\d|3(?:10|33))\\d{6}",
                ,
                ,
                ,
                "15123456789",
                ,
                ,
                [
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                "800\\d{7,12}",
                ,
                ,
                ,
                "8001234567890",
                ,
                ,
                [
                    10,
                    11,
                    12,
                    13,
                    14,
                    15
                ]
            ],
            [
                ,
                ,
                "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",
                ,
                ,
                ,
                "9001234567",
                ,
                ,
                [
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",
                ,
                ,
                ,
                "18012345",
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14
                ]
            ],
            [
                ,
                ,
                "700\\d{8}",
                ,
                ,
                ,
                "70012345678",
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "DE",
            49,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{6})",
                    "$1",
                    [
                        "227",
                        "2277"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|3[13])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|3[13])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                "16(?:4\\d{1,10}|[89]\\d{1,11})",
                ,
                ,
                ,
                "16412345",
                ,
                ,
                [
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "18(?:1\\d{5,11}|[2-9]\\d{8})",
                ,
                ,
                ,
                "18500123456",
                ,
                ,
                [
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
                ,
                ,
                ,
                "177991234567",
                ,
                ,
                [
                    12,
                    13
                ]
            ]
        ],
        DJ: [
            ,
            [
                ,
                ,
                "(?:2\\d|77)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "2(?:1[2-5]|7[45])\\d{5}",
                ,
                ,
                ,
                "21360003"
            ],
            [
                ,
                ,
                "77\\d{6}",
                ,
                ,
                ,
                "77831001"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "DJ",
            253,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        DK: [
            ,
            [
                ,
                ,
                "[2-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}",
                ,
                ,
                ,
                "32123456"
            ],
            [
                ,
                ,
                "(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}",
                ,
                ,
                ,
                "34412345"
            ],
            [
                ,
                ,
                "80\\d{6}",
                ,
                ,
                ,
                "80123456"
            ],
            [
                ,
                ,
                "90\\d{6}",
                ,
                ,
                ,
                "90123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "DK",
            45,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        DM: [
            ,
            [
                ,
                ,
                "(?:[58]\\d\\d|767|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",
                ,
                ,
                ,
                "7674201234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",
                ,
                ,
                ,
                "7672251234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "DM",
            1,
            "011",
            "1",
            ,
            ,
            "([2-7]\\d{6})$|1",
            "767$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "767",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        DO: [
            ,
            [
                ,
                ,
                "(?:[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",
                ,
                ,
                ,
                "8092345678",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8[024]9[2-9]\\d{6}",
                ,
                ,
                ,
                "8092345678",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "800(?:14|[2-9]\\d)\\d{5}|8[024]9[01]\\d{6}|8(?:33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "DO",
            1,
            "011",
            "1",
            ,
            ,
            "1",
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "8001|8[024]9",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        DZ: [
            ,
            [
                ,
                ,
                "(?:[1-4]|[5-79]\\d|80)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}",
                ,
                ,
                ,
                "12345678"
            ],
            [
                ,
                ,
                "(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",
                ,
                ,
                ,
                "551234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "80[3-689]1\\d{5}",
                ,
                ,
                ,
                "808123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "80[12]1\\d{5}",
                ,
                ,
                ,
                "801123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "98[23]\\d{6}",
                ,
                ,
                ,
                "983123456",
                ,
                ,
                [
                    9
                ]
            ],
            "DZ",
            213,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        EC: [
            ,
            [
                ,
                ,
                "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10,
                    11
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "[2-7][2-7]\\d{6}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [
                    8
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",
                ,
                ,
                ,
                "991234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "1800\\d{7}|1[78]00\\d{6}",
                ,
                ,
                ,
                "18001234567",
                ,
                ,
                [
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "[2-7]890\\d{4}",
                ,
                ,
                ,
                "28901234",
                ,
                ,
                [
                    8
                ]
            ],
            "EC",
            593,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-7]"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-7]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        EE: [
            ,
            [
                ,
                ,
                "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    10
                ]
            ],
            [
                ,
                ,
                "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
                ,
                ,
                ,
                "3212345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|[2-79]\\d\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[013-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
                ,
                ,
                ,
                "51234567",
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",
                ,
                ,
                ,
                "80012345"
            ],
            [
                ,
                ,
                "(?:40\\d\\d|900)\\d{4}",
                ,
                ,
                ,
                "9001234",
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "70[0-2]\\d{5}",
                ,
                ,
                ,
                "70012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "EE",
            372,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "800[2-9]\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        EG: [
            ,
            [
                ,
                ,
                "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",
                ,
                ,
                ,
                "234567890",
                ,
                ,
                [
                    8,
                    9
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "1[0-25]\\d{8}",
                ,
                ,
                ,
                "1001234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "800\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "900\\d{7}",
                ,
                ,
                ,
                "9001234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "EG",
            20,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        EH: [
            ,
            [
                ,
                ,
                "[5-8]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "528[89]\\d{5}",
                ,
                ,
                ,
                "528812345"
            ],
            [
                ,
                ,
                "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|5[0-5]))\\d{6}",
                ,
                ,
                ,
                "650123456"
            ],
            [
                ,
                ,
                "80[0-7]\\d{6}",
                ,
                ,
                ,
                "801234567"
            ],
            [
                ,
                ,
                "89\\d{7}",
                ,
                ,
                ,
                "891234567"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "592401234"
            ],
            "EH",
            212,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        ER: [
            ,
            [
                ,
                ,
                "[178]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",
                ,
                ,
                ,
                "8370362",
                ,
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:17[1-3]|7\\d\\d)\\d{4}",
                ,
                ,
                ,
                "7123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "ER",
            291,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        ES: [
            ,
            [
                ,
                ,
                "[5-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
                ,
                ,
                ,
                "810123456"
            ],
            [
                ,
                ,
                "96906(?:09|10)\\d\\d|(?:590(?:10[0-2]|600)|97390\\d)\\d{3}|(?:6\\d|7[1-48])\\d{7}",
                ,
                ,
                ,
                "612345678"
            ],
            [
                ,
                ,
                "[89]00\\d{6}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                "80[367]\\d{6}",
                ,
                ,
                ,
                "803123456"
            ],
            [
                ,
                ,
                "90[12]\\d{6}",
                ,
                ,
                ,
                "901123456"
            ],
            [
                ,
                ,
                "70\\d{7}",
                ,
                ,
                ,
                "701234567"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "ES",
            34,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})",
                    "$1",
                    [
                        "905"
                    ]
                ],
                [
                    ,
                    "(\\d{6})",
                    "$1",
                    [
                        "[79]9"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "51\\d{7}",
                ,
                ,
                ,
                "511234567"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        ET: [
            ,
            [
                ,
                ,
                "(?:11|[2-579]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:11(?:[124]\\d\\d|3(?:[0-79]\\d|8[0-7])|5(?:[02-9]\\d|1[0-57-9])|6(?:[02-79]\\d|1[0-57-9]|8[0-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
                ,
                ,
                ,
                "111112345",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|2[1-35-79]|3\\d|77|86|99)|9\\d\\d)\\d{6}",
                ,
                ,
                ,
                "911234567"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "ET",
            251,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        FI: [
            ,
            [
                ,
                ,
                "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                "1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
                ,
                ,
                ,
                "131234567",
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "800\\d{4,6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    7,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "[67]00\\d{5,6}",
                ,
                ,
                ,
                "600123456",
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "FI",
            358,
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "0",
            ,
            ,
            "0",
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{5})",
                    "$1",
                    [
                        "75[12]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{6})",
                    "$1",
                    [
                        "11"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            1,
            "1[03-79]|[2-9]",
            [
                ,
                ,
                "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"
            ],
            [
                ,
                ,
                "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                ,
                ,
                ,
                "10112345"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        FJ: [
            ,
            [
                ,
                ,
                "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    11
                ]
            ],
            [
                ,
                ,
                "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",
                ,
                ,
                ,
                "3212345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
                ,
                ,
                ,
                "7012345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "0800\\d{7}",
                ,
                ,
                ,
                "08001234567",
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "FJ",
            679,
            "0(?:0|52)",
            ,
            ,
            ,
            ,
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        FK: [
            ,
            [
                ,
                ,
                "[2-7]\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                "[2-47]\\d{4}",
                ,
                ,
                ,
                "31234"
            ],
            [
                ,
                ,
                "[56]\\d{4}",
                ,
                ,
                ,
                "51234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "FK",
            500,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        FM: [
            ,
            [
                ,
                ,
                "(?:[39]\\d\\d|820)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
                ,
                ,
                ,
                "3201234"
            ],
            [
                ,
                ,
                "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",
                ,
                ,
                ,
                "3501234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "FM",
            691,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        FO: [
            ,
            [
                ,
                ,
                "[2-9]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:20|[34]\\d|8[19])\\d{4}",
                ,
                ,
                ,
                "201234"
            ],
            [
                ,
                ,
                "(?:[27][1-9]|5\\d|9[16])\\d{4}",
                ,
                ,
                ,
                "211234"
            ],
            [
                ,
                ,
                "80[257-9]\\d{3}",
                ,
                ,
                ,
                "802123"
            ],
            [
                ,
                ,
                "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
                ,
                ,
                ,
                "901123"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:6[0-36]|88)\\d{4}",
                ,
                ,
                ,
                "601234"
            ],
            "FO",
            298,
            "00",
            ,
            ,
            ,
            "(10(?:01|[12]0|88))",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ],
                    ,
                    "$CC $1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        FR: [
            ,
            [
                ,
                ,
                "[1-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}",
                ,
                ,
                ,
                "123456789"
            ],
            [
                ,
                ,
                "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}",
                ,
                ,
                ,
                "612345678"
            ],
            [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "801234567"
            ],
            [
                ,
                ,
                "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
                ,
                ,
                ,
                "891123456"
            ],
            [
                ,
                ,
                "8(?:1[01]|2[0156]|4[024]|84)\\d{6}",
                ,
                ,
                ,
                "884012345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9\\d{8}",
                ,
                ,
                ,
                "912345678"
            ],
            "FR",
            33,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})",
                    "$1",
                    [
                        "10"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    ,
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    ,
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "80[6-9]\\d{6}",
                ,
                ,
                ,
                "806123456"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GA: [
            ,
            [
                ,
                ,
                "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "[01]1\\d{6}",
                ,
                ,
                ,
                "01441234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",
                ,
                ,
                ,
                "06031234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "GA",
            241,
            "00",
            ,
            ,
            ,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1",
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GB: [
            ,
            [
                ,
                ,
                "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    9,
                    10
                ],
                [
                    4,
                    5,
                    6,
                    8
                ]
            ],
            [
                ,
                ,
                "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-5])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|5[01]))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                ,
                ,
                ,
                "1212345678",
                ,
                ,
                [
                    9,
                    10
                ],
                [
                    4,
                    5,
                    6,
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                ,
                ,
                ,
                "7400123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "80[08]\\d{7}|800\\d{6}|8001111",
                ,
                ,
                ,
                "8001234567"
            ],
            [
                ,
                ,
                "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                ,
                ,
                ,
                "9012345678",
                ,
                ,
                [
                    7,
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "70\\d{8}",
                ,
                ,
                ,
                "7012345678",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "56\\d{8}",
                ,
                ,
                ,
                "5612345678",
                ,
                ,
                [
                    10
                ]
            ],
            "GB",
            44,
            "00",
            "0",
            " x",
            ,
            "0|180020",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                ,
                ,
                ,
                "7640123456",
                ,
                ,
                [
                    10
                ]
            ],
            1,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:3[0347]|55)\\d{8}",
                ,
                ,
                ,
                "5512345678",
                ,
                ,
                [
                    10
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GD: [
            ,
            [
                ,
                ,
                "(?:473|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[59]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
                ,
                ,
                ,
                "4732691234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}",
                ,
                ,
                ,
                "4734031234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "GD",
            1,
            "011",
            "1",
            ,
            ,
            "([2-9]\\d{6})$|1",
            "473$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "473",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GE: [
            ,
            [
                ,
                ,
                "(?:[3-57]\\d\\d|800)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",
                ,
                ,
                ,
                "322123456",
                ,
                ,
                ,
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0(?:1[09]|70)|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|1[12]|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-6])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:(?:[0147-9]\\d|22)\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}",
                ,
                ,
                ,
                "555123456"
            ],
            [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "70[67]\\d{6}",
                ,
                ,
                ,
                "706123456"
            ],
            "GE",
            995,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "70[67]\\d{6}"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GF: [
            ,
            [
                ,
                ,
                "(?:694\\d|7093)\\d{5}|(?:59|[89]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:59(?:4(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)|88\\d)|80[6-9]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "594101234"
            ],
            [
                ,
                ,
                "(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}",
                ,
                ,
                ,
                "694201234"
            ],
            [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345"
            ],
            [
                ,
                ,
                "8[129]\\d{7}",
                ,
                ,
                ,
                "890123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}",
                ,
                ,
                ,
                "976012345"
            ],
            "GF",
            594,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]|80[6-9]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GG: [
            ,
            [
                ,
                ,
                "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    9,
                    10
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "1481[25-9]\\d{5}",
                ,
                ,
                ,
                "1481256789",
                ,
                ,
                [
                    10
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "7(?:(?:781|839)\\d|911[17])\\d{5}",
                ,
                ,
                ,
                "7781123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "80[08]\\d{7}|800\\d{6}|8001111",
                ,
                ,
                ,
                "8001234567"
            ],
            [
                ,
                ,
                "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                ,
                ,
                ,
                "9012345678",
                ,
                ,
                [
                    7,
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "70\\d{8}",
                ,
                ,
                ,
                "7012345678",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "56\\d{8}",
                ,
                ,
                ,
                "5612345678",
                ,
                ,
                [
                    10
                ]
            ],
            "GG",
            44,
            "00",
            "0",
            ,
            ,
            "([25-9]\\d{5})$|0|180020",
            "1481$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                ,
                ,
                ,
                "7640123456",
                ,
                ,
                [
                    10
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:3[0347]|55)\\d{8}",
                ,
                ,
                ,
                "5512345678",
                ,
                ,
                [
                    10
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GH: [
            ,
            [
                ,
                ,
                "[235]\\d{8}|800\\d{5,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",
                ,
                ,
                ,
                "302345678",
                ,
                ,
                [
                    9
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
                ,
                ,
                ,
                "231234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{5,6}",
                ,
                ,
                ,
                "80012345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "GH",
            233,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[237]|8[0-2]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2358]"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2358]"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "800\\d{5,6}"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GI: [
            ,
            [
                ,
                ,
                "(?:[25]\\d|60)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
                ,
                ,
                ,
                "20012345"
            ],
            [
                ,
                ,
                "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}",
                ,
                ,
                ,
                "57123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "GI",
            350,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GL: [
            ,
            [
                ,
                ,
                "(?:19|[2-689]\\d|70)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}",
                ,
                ,
                ,
                "321000"
            ],
            [
                ,
                ,
                "[245]\\d{5}",
                ,
                ,
                ,
                "221234"
            ],
            [
                ,
                ,
                "80\\d{4}",
                ,
                ,
                ,
                "801234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "3[89]\\d{4}",
                ,
                ,
                ,
                "381234"
            ],
            "GL",
            299,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GM: [
            ,
            [
                ,
                ,
                "[2-9]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8[0-589]\\d\\d)\\d{3}",
                ,
                ,
                ,
                "5661234"
            ],
            [
                ,
                ,
                "556\\d{4}|(?:[23679]\\d|4[015]|5[0-489]|8[67])\\d{5}",
                ,
                ,
                ,
                "3012345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "GM",
            220,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GN: [
            ,
            [
                ,
                ,
                "722\\d{6}|(?:3|6\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",
                ,
                ,
                ,
                "30241234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "6[0-356]\\d{7}",
                ,
                ,
                ,
                "601123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "722\\d{6}",
                ,
                ,
                ,
                "722123456",
                ,
                ,
                [
                    9
                ]
            ],
            "GN",
            224,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GP: [
            ,
            [
                ,
                ,
                "7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:59(?:0(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)|87\\d)|80[6-9]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "590201234"
            ],
            [
                ,
                ,
                "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}",
                ,
                ,
                ,
                "690001234"
            ],
            [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345"
            ],
            [
                ,
                ,
                "8[129]\\d{7}",
                ,
                ,
                ,
                "810123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}",
                ,
                ,
                ,
                "976012345"
            ],
            "GP",
            590,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]|80[6-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            1,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GQ: [
            ,
            [
                ,
                ,
                "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",
                ,
                ,
                ,
                "333091234"
            ],
            [
                ,
                ,
                "(?:222|55\\d)\\d{6}",
                ,
                ,
                ,
                "222123456"
            ],
            [
                ,
                ,
                "80\\d[1-9]\\d{5}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                "90\\d[1-9]\\d{5}",
                ,
                ,
                ,
                "900123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "GQ",
            240,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GR: [
            ,
            [
                ,
                ,
                "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
                ,
                ,
                ,
                "2123456789",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "68[57-9]\\d{7}|(?:69|94)\\d{8}",
                ,
                ,
                ,
                "6912345678",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "800\\d{7,9}",
                ,
                ,
                ,
                "8001234567"
            ],
            [
                ,
                ,
                "90[19]\\d{7}",
                ,
                ,
                ,
                "9091234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "8(?:0[16]|12|[27]5|50)\\d{7}",
                ,
                ,
                ,
                "8011234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "70\\d{8}",
                ,
                ,
                ,
                "7012345678",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "GR",
            30,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "5005000\\d{3}",
                ,
                ,
                ,
                "5005000123",
                ,
                ,
                [
                    10
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GT: [
            ,
            [
                ,
                ,
                "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    11
                ]
            ],
            [
                ,
                ,
                "[267][2-9]\\d{6}",
                ,
                ,
                ,
                "22456789",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:[3-5]\\d\\d|80[0-4])\\d{5}",
                ,
                ,
                ,
                "51234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "18[01]\\d{8}",
                ,
                ,
                ,
                "18001112222",
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                "19\\d{9}",
                ,
                ,
                ,
                "19001112222",
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "GT",
            502,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GU: [
            ,
            [
                ,
                ,
                "(?:[58]\\d\\d|671|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[16-9]))\\d{4}",
                ,
                ,
                ,
                "6713001234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[16-9]))\\d{4}",
                ,
                ,
                ,
                "6713001234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "GU",
            1,
            "011",
            "1",
            ,
            ,
            "([2-9]\\d{6})$|1",
            "671$1",
            ,
            1,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "671",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GW: [
            ,
            [
                ,
                ,
                "[49]\\d{8}|4\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    9
                ]
            ],
            [
                ,
                ,
                "443\\d{6}",
                ,
                ,
                ,
                "443201234",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "9(?:5\\d|6[569]|77)\\d{6}",
                ,
                ,
                ,
                "955012345",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "40\\d{5}",
                ,
                ,
                ,
                "4012345",
                ,
                ,
                [
                    7
                ]
            ],
            "GW",
            245,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        GY: [
            ,
            [
                ,
                ,
                "(?:[2-8]\\d{3}|9008)\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
                ,
                ,
                ,
                "2201234"
            ],
            [
                ,
                ,
                "(?:51[01]|6\\d\\d|7(?:[0-5]\\d|6[0-79]|70))\\d{4}",
                ,
                ,
                ,
                "6091234"
            ],
            [
                ,
                ,
                "(?:289|8(?:00|6[28]|88|99))\\d{4}",
                ,
                ,
                ,
                "2891234"
            ],
            [
                ,
                ,
                "9008\\d{3}",
                ,
                ,
                ,
                "9008123"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "515\\d{4}",
                ,
                ,
                ,
                "5151234"
            ],
            "GY",
            592,
            "001",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        HK: [
            ,
            [
                ,
                ,
                "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9,
                    11
                ]
            ],
            [
                ,
                ,
                "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-5]))|58(?:0[1-9]|1[2-9]))\\d{4}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:4(?:(?:09|24)[3-6]|44[0-35-9]|6(?:4[0-57-9]|6[0-6])|7(?:4[0-48]|6[0-5]))|5(?:25[3-7]|35[4-8]|73[0-6]|95[0-8])|6(?:26[013-8]|(?:66|78)[0-5])|70(?:7[1-8]|8[0-8])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-467]|899))\\d{4}|(?:4(?:4[0-35-9]|6[0-357-9]|7[0-35])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
                ,
                ,
                ,
                "51234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "900(?:[0-24-9]\\d{7}|3\\d{1,4})",
                ,
                ,
                ,
                "90012345678",
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",
                ,
                ,
                ,
                "81123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "HK",
            852,
            "00(?:30|5[09]|[126-9]?)",
            ,
            ,
            ,
            ,
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
                ,
                ,
                ,
                "71123456",
                ,
                ,
                [
                    8
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",
                ,
                ,
                ,
                "30161234",
                ,
                ,
                [
                    8
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        HN: [
            ,
            [
                ,
                ,
                "8\\d{10}|[237-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    11
                ]
            ],
            [
                ,
                ,
                "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "[37-9]\\d{7}",
                ,
                ,
                ,
                "91234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "8002\\d{7}",
                ,
                ,
                ,
                "80021234567",
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "HN",
            504,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "8002\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        HR: [
            ,
            [
                ,
                ,
                "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
                ,
                ,
                ,
                "12345678",
                ,
                ,
                [
                    8,
                    9
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}",
                ,
                ,
                ,
                "921234567",
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "80\\d{5,7}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                "6[01459]\\d{6}|6[01]\\d{5}",
                ,
                ,
                ,
                "6001234",
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "7[45]\\d{6}",
                ,
                ,
                ,
                "74123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "HR",
            385,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "62\\d{6,7}|72\\d{6}",
                ,
                ,
                ,
                "62123456",
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        HT: [
            ,
            [
                ,
                ,
                "[2-589]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "2(?:2\\d|5[1-5]|81|9[149])\\d{5}",
                ,
                ,
                ,
                "22453300"
            ],
            [
                ,
                ,
                "(?:[34]\\d|5[568])\\d{6}",
                ,
                ,
                ,
                "34101234"
            ],
            [
                ,
                ,
                "8\\d{7}",
                ,
                ,
                ,
                "80012345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",
                ,
                ,
                ,
                "98901234"
            ],
            "HT",
            509,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        HU: [
            ,
            [
                ,
                ,
                "[235-7]\\d{8}|[1-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",
                ,
                ,
                ,
                "12345678",
                ,
                ,
                [
                    8
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:[257]0|3[01])\\d{7}",
                ,
                ,
                ,
                "201234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:[48]0\\d|680[29])\\d{5}",
                ,
                ,
                ,
                "80123456"
            ],
            [
                ,
                ,
                "9[01]\\d{6}",
                ,
                ,
                ,
                "90123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "21\\d{7}",
                ,
                ,
                ,
                "211234567",
                ,
                ,
                [
                    9
                ]
            ],
            "HU",
            36,
            "00",
            "06",
            ,
            ,
            "06",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "(?:[48]0\\d|680[29])\\d{5}"
            ],
            [
                ,
                ,
                "38\\d{7}",
                ,
                ,
                ,
                "381234567",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        ID: [
            ,
            [
                ,
                ,
                "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17
                ],
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
                ,
                ,
                ,
                "218350123",
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10,
                    11
                ],
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "8[1-35-9]\\d{7,10}",
                ,
                ,
                ,
                "812345678",
                ,
                ,
                [
                    9,
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                "00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17
                ]
            ],
            [
                ,
                ,
                "809\\d{7}",
                ,
                ,
                ,
                "8091234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "804\\d{7}",
                ,
                ,
                ,
                "8041234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "ID",
            62,
            "00[89]",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3 $4",
                    [
                        "001"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "001803\\d{5,11}|(?:007803\\d|8071)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17
                ]
            ],
            [
                ,
                ,
                "(?:1500|8071\\d{3})\\d{3}",
                ,
                ,
                ,
                "8071123456",
                ,
                ,
                [
                    7,
                    10
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        IE: [
            ,
            [
                ,
                ,
                "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10
                ],
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",
                ,
                ,
                ,
                "2212345",
                ,
                ,
                ,
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "8(?:22|[35-9]\\d)\\d{6}",
                ,
                ,
                ,
                "850123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "1800\\d{6}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",
                ,
                ,
                ,
                "1520123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "18[59]0\\d{6}",
                ,
                ,
                ,
                "1850123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "700\\d{6}",
                ,
                ,
                ,
                "700123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "76\\d{7}",
                ,
                ,
                ,
                "761234567",
                ,
                ,
                [
                    9
                ]
            ],
            "IE",
            353,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "18[59]0\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "818\\d{6}",
                ,
                ,
                ,
                "818123456",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",
                ,
                ,
                ,
                "8551234567",
                ,
                ,
                [
                    10
                ]
            ]
        ],
        IL: [
            ,
            [
                ,
                ,
                "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [
                    8,
                    11,
                    12
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "55(?:4(?:0[0-3]|[16]0)|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[3-5]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
                ,
                ,
                ,
                "502345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "1(?:255|80[019]\\d{3})\\d{3}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [
                    7,
                    10
                ]
            ],
            [
                ,
                ,
                "1212\\d{4}|1(?:200|9(?:0[0-2]|19|9\\d))\\d{6}",
                ,
                ,
                ,
                "1919123456",
                ,
                ,
                [
                    8,
                    10
                ]
            ],
            [
                ,
                ,
                "1700\\d{6}",
                ,
                ,
                ,
                "1700123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "7(?:38(?:[05]\\d|8[0138])|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
                ,
                ,
                ,
                "771234567",
                ,
                ,
                [
                    9
                ]
            ],
            "IL",
            972,
            "0(?:0|1[2-9])",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "1700\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "1599\\d{6}",
                ,
                ,
                ,
                "1599123456",
                ,
                ,
                [
                    10
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "151\\d{8,9}",
                ,
                ,
                ,
                "15112340000",
                ,
                ,
                [
                    11,
                    12
                ]
            ]
        ],
        IM: [
            ,
            [
                ,
                ,
                "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "1624(?:230|[5-8]\\d\\d)\\d{3}",
                ,
                ,
                ,
                "1624756789",
                ,
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",
                ,
                ,
                ,
                "7924123456"
            ],
            [
                ,
                ,
                "808162\\d{4}",
                ,
                ,
                ,
                "8081624567"
            ],
            [
                ,
                ,
                "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}",
                ,
                ,
                ,
                "9016247890"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "70\\d{8}",
                ,
                ,
                ,
                "7012345678"
            ],
            [
                ,
                ,
                "56\\d{8}",
                ,
                ,
                ,
                "5612345678"
            ],
            "IM",
            44,
            "00",
            "0",
            ,
            ,
            "([25-8]\\d{5})$|0|180020",
            "1624$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "74576|(?:16|7[56])24",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}",
                ,
                ,
                ,
                "5512345678"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        IN: [
            ,
            [
                ,
                ,
                "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10,
                    11,
                    12,
                    13
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2717(?:[2-7]\\d|95)|6828[235-7]\\d)\\d{4}|(?:170[24]|280[13468]|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:271[0-689]|682[0-79]|782[0-6])[2-7]\\d{5}|(?:2(?:[02][2-79]|90)|3(?:23|80)|683|79[1-7])\\d{7}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[14-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
                ,
                ,
                ,
                "7410410123",
                ,
                ,
                [
                    10
                ],
                [
                    6,
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "(?:6(?:1279|828[01489])|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:160[01]|6(?:(?:12|[2-4]1|5[17]|6[13]|80)[0189]|7(?:1[0189]|86))|7(?:1(?:2[0189]|9[0-5])|3(?:2[5-8]|[34][017-9]|9[016-9])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:731|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578])\\d|7(?:[23569]\\d|4[0189]|8[0-57-9])|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|3(?:2[0-49]|9[2-5])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:[024]\\d|3[05-8]|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}",
                ,
                ,
                ,
                "8123456789",
                ,
                ,
                [
                    10
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "000800\\d{7}|180(?:0\\d{4,9}|3\\d{9})",
                ,
                ,
                ,
                "1800123456"
            ],
            [
                ,
                ,
                "186[12]\\d{9}",
                ,
                ,
                ,
                "1861123456789",
                ,
                ,
                [
                    13
                ]
            ],
            [
                ,
                ,
                "1860\\d{7}",
                ,
                ,
                ,
                "18603451234",
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "IN",
            91,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{7})",
                    "$1",
                    [
                        "575"
                    ]
                ],
                [
                    ,
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31)|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:3171|5[15][2-6]|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|8(?:16|2[014]|3[126]|6[136]|7[78]|83)(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|3[129]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7(?:[23569]|8[0-57-9])|8[1-6])|7(?:1(?:[013-8]|9[6-9])|3(?:17|2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578])\\d|7(?:[23569]\\d|8[0-57-9])|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|3(?:2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "16|[6-9]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "18[06]",
                        "18[06]0"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    ,
                    ,
                    1
                ]
            ],
            [
                [
                    ,
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31)|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:3171|5[15][2-6]|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|8(?:16|2[014]|3[126]|6[136]|7[78]|83)(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|3[129]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7(?:[23569]|8[0-57-9])|8[1-6])|7(?:1(?:[013-8]|9[6-9])|3(?:17|2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578])\\d|7(?:[23569]\\d|8[0-57-9])|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|3(?:2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "16|[6-9]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "18[06]",
                        "18[06]0"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "1800\\d{4,9}|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"
            ],
            [
                ,
                ,
                "140\\d{7}",
                ,
                ,
                ,
                "1409305260",
                ,
                ,
                [
                    10
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        IO: [
            ,
            [
                ,
                ,
                "3\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "37\\d{5}",
                ,
                ,
                ,
                "3709100"
            ],
            [
                ,
                ,
                "38\\d{5}",
                ,
                ,
                ,
                "3801234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "IO",
            246,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        IQ: [
            ,
            [
                ,
                ,
                "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",
                ,
                ,
                ,
                "12345678",
                ,
                ,
                [
                    8,
                    9
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "7[3-9]\\d{8}",
                ,
                ,
                ,
                "7912345678",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "IQ",
            964,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        IR: [
            ,
            [
                ,
                ,
                "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    4,
                    5,
                    6,
                    7,
                    10
                ],
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:[02689]0\\d|121)|4(?:111|40\\d))\\d{4}",
                ,
                ,
                ,
                "2123456789",
                ,
                ,
                [
                    6,
                    7,
                    10
                ],
                [
                    4,
                    5,
                    8
                ]
            ],
            [
                ,
                ,
                "9(?:(?:0[0-5]|[13]\\d|2[0-3])\\d\\d|9(?:[0-46]\\d\\d|5(?:10|5\\d)|8(?:[12]\\d|88)|9(?:[01359]\\d|21|69|77|8[7-9])))\\d{5}",
                ,
                ,
                ,
                "9123456789",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "IR",
            98,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    4,
                    5,
                    10
                ]
            ],
            [
                ,
                ,
                "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
                ,
                ,
                ,
                "9601",
                ,
                ,
                [
                    4,
                    5
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        IS: [
            ,
            [
                ,
                ,
                "(?:38\\d|[4-9])\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    9
                ]
            ],
            [
                ,
                ,
                "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",
                ,
                ,
                ,
                "4101234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}",
                ,
                ,
                ,
                "6111234"
            ],
            [
                ,
                ,
                "80[0-8]\\d{4}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
                ,
                ,
                ,
                "9001234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "49[0-24-79]\\d{4}",
                ,
                ,
                ,
                "4921234",
                ,
                ,
                [
                    7
                ]
            ],
            "IS",
            354,
            "00|1(?:0(?:01|[12]0)|100)",
            ,
            ,
            ,
            ,
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "809\\d{4}",
                ,
                ,
                ,
                "8091234",
                ,
                ,
                [
                    7
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "(?:689|8(?:7[18]|80)|95[48])\\d{4}",
                ,
                ,
                ,
                "6891234",
                ,
                ,
                [
                    7
                ]
            ]
        ],
        IT: [
            ,
            [
                ,
                ,
                "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                "0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                ,
                ,
                ,
                "0212345678"
            ],
            [
                ,
                ,
                "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                ,
                ,
                ,
                "3123456789",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "80(?:0\\d{3}|3)\\d{3}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    6,
                    9
                ]
            ],
            [
                ,
                ,
                "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                ,
                ,
                ,
                "899123456",
                ,
                ,
                [
                    6,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "84(?:[08]\\d{3}|[17])\\d{3}",
                ,
                ,
                ,
                "848123456",
                ,
                ,
                [
                    6,
                    9
                ]
            ],
            [
                ,
                ,
                "1(?:78\\d|99)\\d{6}",
                ,
                ,
                ,
                "1781234567",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "55\\d{8}",
                ,
                ,
                ,
                "5512345678",
                ,
                ,
                [
                    10
                ]
            ],
            "IT",
            39,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4,5})",
                    "$1",
                    [
                        "1(?:0|9[246])",
                        "1(?:0|9(?:2[2-9]|[46]))"
                    ]
                ],
                [
                    ,
                    "(\\d{6})",
                    "$1",
                    [
                        "1(?:1|92)"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[03]"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[03]"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            1,
            ,
            [
                ,
                ,
                "848\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "3[2-8]\\d{9,10}",
                ,
                ,
                ,
                "33101234501",
                ,
                ,
                [
                    11,
                    12
                ]
            ]
        ],
        JE: [
            ,
            [
                ,
                ,
                "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "1534[0-24-8]\\d{5}",
                ,
                ,
                ,
                "1534456789",
                ,
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}",
                ,
                ,
                ,
                "7797712345"
            ],
            [
                ,
                ,
                "80(?:07(?:35|81)|8901)\\d{4}",
                ,
                ,
                ,
                "8007354567"
            ],
            [
                ,
                ,
                "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",
                ,
                ,
                ,
                "9018105678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "701511\\d{4}",
                ,
                ,
                ,
                "7015115678"
            ],
            [
                ,
                ,
                "56\\d{8}",
                ,
                ,
                ,
                "5612345678"
            ],
            "JE",
            44,
            "00",
            "0",
            ,
            ,
            "([0-24-8]\\d{5})$|0|180020",
            "1534$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                ,
                ,
                ,
                "7640123456"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
                ,
                ,
                ,
                "5512345678"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        JM: [
            ,
            [
                ,
                ,
                "(?:[58]\\d\\d|658|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8766060\\d{3}|(?:658(?:2(?:[5-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}",
                ,
                ,
                ,
                "8765230123",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:6582(?:[0-4]\\d|95)|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
                ,
                ,
                ,
                "8762101234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "JM",
            1,
            "011",
            "1",
            ,
            ,
            "1",
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "658|876",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        JO: [
            ,
            [
                ,
                ,
                "(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
                ,
                ,
                ,
                "62001234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:427|7(?:[78][0-25-9]|9\\d))\\d{6}",
                ,
                ,
                ,
                "790123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "80\\d{6}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "9\\d{7}",
                ,
                ,
                ,
                "90012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "85\\d{6}",
                ,
                ,
                ,
                "85012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "70\\d{7}",
                ,
                ,
                ,
                "700123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "JO",
            962,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[47]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                "74(?:66|77)\\d{5}",
                ,
                ,
                ,
                "746612345",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "8(?:10|8\\d)\\d{5}",
                ,
                ,
                ,
                "88101234",
                ,
                ,
                [
                    8
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        JP: [
            ,
            [
                ,
                ,
                "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17
                ]
            ],
            [
                ,
                ,
                "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",
                ,
                ,
                ,
                "312345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:601[0-4]0|[7-9]0[1-9]\\d\\d)\\d{5}",
                ,
                ,
                ,
                "9012345678",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",
                ,
                ,
                ,
                "120123456"
            ],
            [
                ,
                ,
                "990\\d{6}",
                ,
                ,
                ,
                "990123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "60\\d{7}",
                ,
                ,
                ,
                "601234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "50[1-9]\\d{7}",
                ,
                ,
                ,
                "5012345678",
                ,
                ,
                [
                    10
                ]
            ],
            "JP",
            81,
            "010",
            "0",
            ,
            ,
            "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0",
            "$1",
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "007",
                        "0077",
                        "00777",
                        "00777[01]"
                    ]
                ],
                [
                    ,
                    "(\\d{8,10})",
                    "$1",
                    [
                        "000"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "3|4(?:2[09]|7[01])|6[1-9]",
                        "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{2})(\\d{3,4})",
                    "$1-$2-$3",
                    [
                        "007",
                        "0077"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "008"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[25-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1-$2-$3",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{5})(\\d{5,6})",
                    "$1-$2-$3",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{6})(\\d{6,7})",
                    "$1-$2-$3",
                    [
                        "0"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "3|4(?:2[09]|7[01])|6[1-9]",
                        "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[25-9]"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                "20\\d{8}",
                ,
                ,
                ,
                "2012345678",
                ,
                ,
                [
                    10
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"
            ],
            [
                ,
                ,
                "570\\d{6}",
                ,
                ,
                ,
                "570123456",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        KE: [
            ,
            [
                ,
                ,
                "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
                ,
                ,
                ,
                "202012345",
                ,
                ,
                [
                    7,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "(?:1(?:0[0-8]|1\\d|2[014]|30|4[0-3])|7\\d\\d)\\d{6}",
                ,
                ,
                ,
                "712123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800[02-8]\\d{5,6}",
                ,
                ,
                ,
                "800223456",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "900[02-9]\\d{5}",
                ,
                ,
                ,
                "900223456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "KE",
            254,
            "000",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        KG: [
            ,
            [
                ,
                ,
                "8\\d{9}|[235-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9,
                    10
                ],
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",
                ,
                ,
                ,
                "312123456",
                ,
                ,
                [
                    9
                ],
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",
                ,
                ,
                ,
                "700123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{6,7}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "KG",
            996,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        KH: [
            ,
            [
                ,
                ,
                "1\\d{9}|[1-9]\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
                ,
                ,
                ,
                "23756789",
                ,
                ,
                [
                    8,
                    9
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",
                ,
                ,
                ,
                "91234567",
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "1800(?:1\\d|2[019])\\d{4}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "1900(?:1\\d|2[09])\\d{4}",
                ,
                ,
                ,
                "1900123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "KH",
            855,
            "00[14-9]",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        KI: [
            ,
            [
                ,
                ,
                "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    8
                ]
            ],
            [
                ,
                ,
                "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}",
                ,
                ,
                ,
                "31234"
            ],
            [
                ,
                ,
                "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
                ,
                ,
                ,
                "72001234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",
                ,
                ,
                ,
                "30010000",
                ,
                ,
                [
                    8
                ]
            ],
            "KI",
            686,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        KM: [
            ,
            [
                ,
                ,
                "[3478]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ],
                [
                    4
                ]
            ],
            [
                ,
                ,
                "7[4-7]\\d{5}",
                ,
                ,
                ,
                "7712345",
                ,
                ,
                ,
                [
                    4
                ]
            ],
            [
                ,
                ,
                "[34]\\d{6}",
                ,
                ,
                ,
                "3212345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "8\\d{6}",
                ,
                ,
                ,
                "8001234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "KM",
            269,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        KN: [
            ,
            [
                ,
                ,
                "(?:[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",
                ,
                ,
                ,
                "8692361234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",
                ,
                ,
                ,
                "8697652917",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "KN",
            1,
            "011",
            "1",
            ,
            ,
            "([2-7]\\d{6})$|1",
            "869$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "869",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        KP: [
            ,
            [
                ,
                ,
                "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    10
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                ,
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "19[1-3]\\d{7}",
                ,
                ,
                ,
                "1921234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "KP",
            850,
            "00|99",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        KR: [
            ,
            [
                ,
                ,
                "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14
                ],
                [
                    3,
                    4,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [
                    5,
                    6,
                    8,
                    9,
                    10
                ],
                [
                    3,
                    4,
                    7
                ]
            ],
            [
                ,
                ,
                "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
                ,
                ,
                ,
                "1020000000",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}",
                ,
                ,
                ,
                "801234567",
                ,
                ,
                [
                    9,
                    11,
                    12,
                    13,
                    14
                ]
            ],
            [
                ,
                ,
                "60[2-9]\\d{6}",
                ,
                ,
                ,
                "602345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "50\\d{8,9}",
                ,
                ,
                ,
                "5012345678",
                ,
                ,
                [
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                "70\\d{8}",
                ,
                ,
                ,
                "7012345678",
                ,
                ,
                [
                    10
                ]
            ],
            "KR",
            82,
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "0",
            ,
            ,
            "0(8(?:[1-46-8]|5\\d\\d))?",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{5})",
                    "$1",
                    [
                        "1[016-9]1",
                        "1[016-9]11",
                        "1[016-9]114"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1",
                    "0$CC-$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1",
                    "0$CC-$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1",
                    "0$CC-$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1",
                    "0$CC-$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1",
                    "0$CC-$1"
                ],
                [
                    ,
                    "(\\d{5})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "003",
                        "0030"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1",
                    "0$CC-$1"
                ],
                [
                    ,
                    "(\\d{5})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{5})(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1",
                    "0$CC-$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1",
                    "0$CC-$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1",
                    "0$CC-$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1",
                    "0$CC-$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1",
                    "0$CC-$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1",
                    "0$CC-$1"
                ]
            ],
            [
                ,
                ,
                "15\\d{7,8}",
                ,
                ,
                ,
                "1523456789",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    11,
                    12,
                    13,
                    14
                ]
            ],
            [
                ,
                ,
                "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}",
                ,
                ,
                ,
                "15441234",
                ,
                ,
                [
                    8
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        KW: [
            ,
            [
                ,
                ,
                "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",
                ,
                ,
                ,
                "22345678",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:00|1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
                ,
                ,
                ,
                "50012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "18\\d{5}",
                ,
                ,
                ,
                "1801234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "KW",
            965,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        KY: [
            ,
            [
                ,
                ,
                "(?:345|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}",
                ,
                ,
                ,
                "3452221234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "345(?:32[1-9]|4(?:1[2-6]|2[0-4])|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",
                ,
                ,
                ,
                "3453231234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
            ],
            [
                ,
                ,
                "(?:345976|900[2-9]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "9002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "KY",
            1,
            "011",
            "1",
            ,
            ,
            "([2-9]\\d{6})$|1",
            "345$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "345",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        KZ: [
            ,
            [
                ,
                ,
                "8\\d{13}|[78]\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10,
                    14
                ],
                [
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}",
                ,
                ,
                ,
                "7123456789",
                ,
                ,
                [
                    10
                ],
                [
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",
                ,
                ,
                ,
                "7710009998",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "8(?:00|108\\d{3})\\d{7}",
                ,
                ,
                ,
                "8001234567"
            ],
            [
                ,
                ,
                "809\\d{7}",
                ,
                ,
                ,
                "8091234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "808\\d{7}",
                ,
                ,
                ,
                "8081234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "751\\d{7}",
                ,
                ,
                ,
                "7511234567",
                ,
                ,
                [
                    10
                ]
            ],
            "KZ",
            7,
            "810",
            "8",
            ,
            ,
            "8",
            ,
            "8~10",
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "7",
            [
                ,
                ,
                "751\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        LA: [
            ,
            [
                ,
                ,
                "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
                ,
                ,
                ,
                "21212862",
                ,
                ,
                [
                    8
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:20(?:[23579]\\d|8[78])|30[24]\\d)\\d{6}|30\\d{7}",
                ,
                ,
                ,
                "2023123456",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "LA",
            856,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        LB: [
            ,
            [
                ,
                ,
                "[27-9]\\d{7}|[13-9]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "7(?:62|8[0-6]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",
                ,
                ,
                ,
                "1123456"
            ],
            [
                ,
                ,
                "(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[7-9]|9[0-4]))\\d{5}",
                ,
                ,
                ,
                "71123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9[01]\\d{6}",
                ,
                ,
                ,
                "90123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "80\\d{6}",
                ,
                ,
                ,
                "80123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "LB",
            961,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        LC: [
            ,
            [
                ,
                ,
                "(?:[58]\\d\\d|758|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}",
                ,
                ,
                ,
                "7584305678",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",
                ,
                ,
                ,
                "7582845678",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "LC",
            1,
            "011",
            "1",
            ,
            ,
            "([2-8]\\d{6})$|1",
            "758$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "758",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        LI: [
            ,
            [
                ,
                ,
                "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    9
                ]
            ],
            [
                ,
                ,
                "(?:2(?:01|1[27]|2[024]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
                ,
                ,
                ,
                "2345678",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:6(?:(?:4[5-9]|5\\d)\\d|6(?:[024-68]\\d|1[01]|3[7-9]|70))\\d|7(?:[37-9]\\d|42|56))\\d{4}",
                ,
                ,
                ,
                "660234567"
            ],
            [
                ,
                ,
                "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}",
                ,
                ,
                ,
                "8002222"
            ],
            [
                ,
                ,
                "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",
                ,
                ,
                ,
                "9002222",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "LI",
            423,
            "00",
            "0",
            ,
            ,
            "(1001)|0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    ,
                    "$CC $1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "870(?:28|87)\\d\\d",
                ,
                ,
                ,
                "8702812",
                ,
                ,
                [
                    7
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "697(?:42|56|[78]\\d)\\d{4}",
                ,
                ,
                ,
                "697861234",
                ,
                ,
                [
                    9
                ]
            ]
        ],
        LK: [
            ,
            [
                ,
                ,
                "[1-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",
                ,
                ,
                ,
                "112345678",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "7(?:[0-25-8]\\d|4[0-4])\\d{6}",
                ,
                ,
                ,
                "712345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "LK",
            94,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "1973\\d{5}",
                ,
                ,
                ,
                "197312345"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        LR: [
            ,
            [
                ,
                ,
                "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "2\\d{7}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:(?:(?:22|33)0|555|7(?:6[01]|7\\d)|88\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}",
                ,
                ,
                ,
                "770123456",
                ,
                ,
                [
                    7,
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "332(?:02|[34]\\d)\\d{4}",
                ,
                ,
                ,
                "332021234",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "LR",
            231,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        LS: [
            ,
            [
                ,
                ,
                "(?:[256]\\d\\d|800)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "2\\d{7}",
                ,
                ,
                ,
                "22123456"
            ],
            [
                ,
                ,
                "[56]\\d{7}",
                ,
                ,
                ,
                "50123456"
            ],
            [
                ,
                ,
                "800[1256]\\d{4}",
                ,
                ,
                ,
                "80021234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "LS",
            266,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        LT: [
            ,
            [
                ,
                ,
                "(?:[3469]\\d|52|[78]0)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:3[1478]|4[124-6]|52)\\d{6}",
                ,
                ,
                ,
                "31234567"
            ],
            [
                ,
                ,
                "6\\d{7}",
                ,
                ,
                ,
                "61234567"
            ],
            [
                ,
                ,
                "80[02]\\d{5}",
                ,
                ,
                ,
                "80012345"
            ],
            [
                ,
                ,
                "9(?:0[0239]|10)\\d{5}",
                ,
                ,
                ,
                "90012345"
            ],
            [
                ,
                ,
                "808\\d{5}",
                ,
                ,
                ,
                "80812345"
            ],
            [
                ,
                ,
                "70[05]\\d{5}",
                ,
                ,
                ,
                "70012345"
            ],
            [
                ,
                ,
                "[89]01\\d{5}",
                ,
                ,
                ,
                "80123456"
            ],
            "LT",
            370,
            "00",
            "0",
            ,
            ,
            "[08]",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    ,
                    1
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "70[67]\\d{5}",
                ,
                ,
                ,
                "70712345"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        LU: [
            ,
            [
                ,
                ,
                "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
                ,
                ,
                ,
                "27123456"
            ],
            [
                ,
                ,
                "6(?:[26][18]|5[1568]|7[189]|81|9[128])\\d{6}",
                ,
                ,
                ,
                "628123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "90[015]\\d{5}",
                ,
                ,
                ,
                "90012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "801\\d{5}",
                ,
                ,
                ,
                "80112345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "20(?:1\\d{5}|[2-689]\\d{1,7})",
                ,
                ,
                ,
                "20201234",
                ,
                ,
                [
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10
                ]
            ],
            "LU",
            352,
            "00",
            ,
            ,
            ,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    ,
                    "$CC $1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "20"
                    ],
                    ,
                    "$CC $1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        LV: [
            ,
            [
                ,
                ,
                "(?:[268]\\d|78|90)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "6\\d{7}",
                ,
                ,
                ,
                "63123456"
            ],
            [
                ,
                ,
                "2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}",
                ,
                ,
                ,
                "21234567"
            ],
            [
                ,
                ,
                "80\\d{6}",
                ,
                ,
                ,
                "80123456"
            ],
            [
                ,
                ,
                "90\\d{6}",
                ,
                ,
                ,
                "90123456"
            ],
            [
                ,
                ,
                "81\\d{6}",
                ,
                ,
                ,
                "81123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "LV",
            371,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2679]|8[01]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        LY: [
            ,
            [
                ,
                ,
                "[2-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "9[1-6]\\d{7}",
                ,
                ,
                ,
                "912345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "LY",
            218,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MA: [
            ,
            [
                ,
                ,
                "[5-8]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "5(?:(?:18|4[0679]|5[03])\\d|2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-9])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9]))\\d{5}",
                ,
                ,
                ,
                "520123456"
            ],
            [
                ,
                ,
                "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|5[0-5]))\\d{6}",
                ,
                ,
                ,
                "650123456"
            ],
            [
                ,
                ,
                "80[0-7]\\d{6}",
                ,
                ,
                ,
                "801234567"
            ],
            [
                ,
                ,
                "89\\d{7}",
                ,
                ,
                ,
                "891234567"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "592401234"
            ],
            "MA",
            212,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "892"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8(?:0[0-7]|9)"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            1,
            "[5-8]",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MC: [
            ,
            [
                ,
                ,
                "(?:[3489]|[67]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "(?:870|9[2-47-9]\\d)\\d{5}",
                ,
                ,
                ,
                "99123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "4(?:[469]\\d|5[1-9])\\d{5}|(?:3|[67]\\d)\\d{7}",
                ,
                ,
                ,
                "612345678"
            ],
            [
                ,
                ,
                "(?:800|90\\d)\\d{5}",
                ,
                ,
                ,
                "90123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "MC",
            377,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "8[07]0\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MD: [
            ,
            [
                ,
                ,
                "(?:[235-7]\\d|[89]0)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",
                ,
                ,
                ,
                "22212345"
            ],
            [
                ,
                ,
                "562\\d{5}|(?:6\\d|7[16-9])\\d{6}",
                ,
                ,
                ,
                "62112345"
            ],
            [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345"
            ],
            [
                ,
                ,
                "90[056]\\d{5}",
                ,
                ,
                ,
                "90012345"
            ],
            [
                ,
                ,
                "808\\d{5}",
                ,
                ,
                ,
                "80812345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "3[08]\\d{6}",
                ,
                ,
                ,
                "30123456"
            ],
            "MD",
            373,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "803\\d{5}",
                ,
                ,
                ,
                "80312345"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        ME: [
            ,
            [
                ,
                ,
                "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
                ,
                ,
                ,
                "30234567",
                ,
                ,
                [
                    8
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
                ,
                ,
                ,
                "60123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "80(?:[0-2578]|9\\d)\\d{5}",
                ,
                ,
                ,
                "80080002"
            ],
            [
                ,
                ,
                "9(?:4[1568]|5[178])\\d{5}",
                ,
                ,
                ,
                "94515151",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "78[1-49]\\d{5}",
                ,
                ,
                ,
                "78108780",
                ,
                ,
                [
                    8
                ]
            ],
            "ME",
            382,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "77[1-9]\\d{5}",
                ,
                ,
                ,
                "77273012",
                ,
                ,
                [
                    8
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MF: [
            ,
            [
                ,
                ,
                "7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:59(?:0(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)|87\\d)|80[6-9]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "590271234"
            ],
            [
                ,
                ,
                "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}",
                ,
                ,
                ,
                "690001234"
            ],
            [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345"
            ],
            [
                ,
                ,
                "8[129]\\d{7}",
                ,
                ,
                ,
                "810123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}",
                ,
                ,
                ,
                "976012345"
            ],
            "MF",
            590,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MG: [
            ,
            [
                ,
                ,
                "[23]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}",
                ,
                ,
                ,
                "202123456",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "3[2-9]\\d{7}",
                ,
                ,
                ,
                "321234567"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "22\\d{7}",
                ,
                ,
                ,
                "221234567"
            ],
            "MG",
            261,
            "00",
            "0",
            ,
            ,
            "([24-9]\\d{6})$|0",
            "20$1",
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MH: [
            ,
            [
                ,
                ,
                "329\\d{4}|(?:[256]\\d|45)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:247|528|625)\\d{4}",
                ,
                ,
                ,
                "2471234"
            ],
            [
                ,
                ,
                "(?:(?:23|54)5|329|45[35-8])\\d{4}",
                ,
                ,
                ,
                "2351234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "635\\d{4}",
                ,
                ,
                ,
                "6351234"
            ],
            "MH",
            692,
            "011",
            "1",
            ,
            ,
            "1",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MK: [
            ,
            [
                ,
                ,
                "[2-578]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",
                ,
                ,
                ,
                "22012345",
                ,
                ,
                ,
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
                ,
                ,
                ,
                "72345678"
            ],
            [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345"
            ],
            [
                ,
                ,
                "5\\d{7}",
                ,
                ,
                ,
                "50012345"
            ],
            [
                ,
                ,
                "8(?:0[1-9]|[1-9]\\d)\\d{5}",
                ,
                ,
                ,
                "80123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "MK",
            389,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        ML: [
            ,
            [
                ,
                ,
                "[24-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}",
                ,
                ,
                ,
                "20212345"
            ],
            [
                ,
                ,
                "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[0-3]|[679]\\d|8[2-59])\\d{6}",
                ,
                ,
                ,
                "65012345"
            ],
            [
                ,
                ,
                "80\\d{6}",
                ,
                ,
                ,
                "80012345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "ML",
            223,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})",
                    "$1",
                    [
                        "67[057-9]|74[045]",
                        "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "80\\d{6}"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MM: [
            ,
            [
                ,
                ,
                "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10
                ],
                [
                    5
                ]
            ],
            [
                ,
                ,
                "(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|22|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
                ,
                ,
                ,
                "1234567",
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9
                ],
                [
                    5
                ]
            ],
            [
                ,
                ,
                "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",
                ,
                ,
                ,
                "92123456",
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "80080(?:0[1-9]|2\\d)\\d{3}",
                ,
                ,
                ,
                "8008001234",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "1333\\d{4}",
                ,
                ,
                ,
                "13331234",
                ,
                ,
                [
                    8
                ]
            ],
            "MM",
            95,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|452|678|86",
                        "[12]|452|6788|86"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MN: [
            ,
            [
                ,
                ,
                "[12]\\d{7,9}|[5-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10
                ],
                [
                    4,
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "[12](?:2[1-3]|(?:3[2-8]|4[2-68]|5[1-4689])\\d)\\d{5,6}|7(?:0(?:[0-5]\\d|7[078]|80)|128)\\d{4}|[12]27\\d{6}|(?:11|2[16]|5[368])\\d{6}",
                ,
                ,
                ,
                "53123456",
                ,
                ,
                ,
                [
                    4,
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "(?:87[01]|92[0139])\\d{5}|(?:5[05]|6[069]|7[28]|8[0135689]|9[013-9])\\d{6}",
                ,
                ,
                ,
                "88123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "712[0-79]\\d{4}|7(?:1[013-9]|[5-79]\\d)\\d{5}",
                ,
                ,
                ,
                "75123456",
                ,
                ,
                [
                    8
                ]
            ],
            "MN",
            976,
            "001",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[16]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MO: [
            ,
            [
                ,
                ,
                "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
                ,
                ,
                ,
                "28212345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",
                ,
                ,
                ,
                "66123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "0800\\d{3}",
                ,
                ,
                ,
                "0800501",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "MO",
            853,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MP: [
            ,
            [
                ,
                ,
                "[58]\\d{9}|(?:67|90)0\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                ,
                ,
                ,
                "6702345678",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                ,
                ,
                ,
                "6702345678",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "MP",
            1,
            "011",
            "1",
            ,
            ,
            "([2-9]\\d{6})$|1",
            "670$1",
            ,
            1,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "670",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MQ: [
            ,
            [
                ,
                ,
                "7091\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:59(?:6(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|89\\d)|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}",
                ,
                ,
                ,
                "596301234"
            ],
            [
                ,
                ,
                "(?:69[67]\\d\\d|7091[0-3])\\d{4}",
                ,
                ,
                ,
                "696201234"
            ],
            [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345"
            ],
            [
                ,
                ,
                "8[129]\\d{7}",
                ,
                ,
                ,
                "810123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}",
                ,
                ,
                ,
                "976612345"
            ],
            "MQ",
            596,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]|8(?:0[6-9]|[36])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MR: [
            ,
            [
                ,
                ,
                "(?:[2-4]\\d\\d|800)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:25[08]|35\\d|45[1-7])\\d{5}",
                ,
                ,
                ,
                "35123456"
            ],
            [
                ,
                ,
                "[2-4][0-46-9]\\d{6}",
                ,
                ,
                ,
                "22123456"
            ],
            [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "MR",
            222,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MS: [
            ,
            [
                ,
                ,
                "(?:[58]\\d\\d|664|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "6644(?:1[0-3]|91)\\d{4}",
                ,
                ,
                ,
                "6644912345",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",
                ,
                ,
                ,
                "6644923456",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "MS",
            1,
            "011",
            "1",
            ,
            ,
            "([34]\\d{6})$|1",
            "664$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "664",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MT: [
            ,
            [
                ,
                ,
                "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",
                ,
                ,
                ,
                "21001234"
            ],
            [
                ,
                ,
                "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",
                ,
                ,
                ,
                "96961234"
            ],
            [
                ,
                ,
                "800(?:02|[3467]\\d)\\d{3}",
                ,
                ,
                ,
                "80071234"
            ],
            [
                ,
                ,
                "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
                ,
                ,
                ,
                "50037123"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "3550\\d{4}",
                ,
                ,
                ,
                "35501234"
            ],
            "MT",
            356,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                "7117\\d{4}",
                ,
                ,
                ,
                "71171234"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "501\\d{5}",
                ,
                ,
                ,
                "50112345"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MU: [
            ,
            [
                ,
                ,
                "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    10
                ]
            ],
            [
                ,
                ,
                "(?:2(?:[0346-8]\\d|1[0-8])|4(?:[013568]\\d|2[0-24-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",
                ,
                ,
                ,
                "54480123",
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-7]|3[013]))\\d{5}",
                ,
                ,
                ,
                "52512345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "802\\d{7}|80[0-2]\\d{4}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [
                    7,
                    10
                ]
            ],
            [
                ,
                ,
                "30\\d{5}",
                ,
                ,
                ,
                "3012345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "3(?:20|9\\d)\\d{4}",
                ,
                ,
                ,
                "3201234",
                ,
                ,
                [
                    7
                ]
            ],
            "MU",
            230,
            "0(?:0|[24-7]0|3[03])",
            ,
            ,
            ,
            ,
            ,
            "020",
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    ,
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                "219\\d{4}",
                ,
                ,
                ,
                "2190123",
                ,
                ,
                [
                    7
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MV: [
            ,
            [
                ,
                ,
                "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    10
                ]
            ],
            [
                ,
                ,
                "(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
                ,
                ,
                ,
                "6701234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:46[46]|[79]\\d\\d)\\d{4}",
                ,
                ,
                ,
                "7712345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "800\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "900\\d{7}",
                ,
                ,
                ,
                "9001234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "MV",
            960,
            "0(?:0|19)",
            ,
            ,
            ,
            ,
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "4(?:0[01]|50)\\d{4}",
                ,
                ,
                ,
                "4001234",
                ,
                ,
                [
                    7
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MW: [
            ,
            [
                ,
                ,
                "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    9
                ]
            ],
            [
                ,
                ,
                "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
                ,
                ,
                ,
                "1234567"
            ],
            [
                ,
                ,
                "111\\d{6}|(?:31|77|[89][89])\\d{7}",
                ,
                ,
                ,
                "991234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "MW",
            265,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MX: [
            ,
            [
                ,
                ,
                "[2-9]\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
                ,
                ,
                ,
                "2001234567",
                ,
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
                ,
                ,
                ,
                "2221234567",
                ,
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "8(?:00|88)\\d{7}",
                ,
                ,
                ,
                "8001234567"
            ],
            [
                ,
                ,
                "900\\d{7}",
                ,
                ,
                ,
                "9001234567"
            ],
            [
                ,
                ,
                "300\\d{7}",
                ,
                ,
                ,
                "3001234567"
            ],
            [
                ,
                ,
                "500\\d{7}",
                ,
                ,
                ,
                "5001234567"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "MX",
            52,
            "0[09]",
            ,
            ,
            ,
            ,
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{5})",
                    "$1",
                    [
                        "53"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MY: [
            ,
            [
                ,
                ,
                "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "427[01]\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
                ,
                ,
                ,
                "323856789",
                ,
                ,
                [
                    8,
                    9
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "1(?:(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|9\\d{7,8})|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-79]|6[02-4]|8[02-5]))|(?:[26]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
                ,
                ,
                ,
                "123456789",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "1[378]00\\d{6}",
                ,
                ,
                ,
                "1300123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "1600\\d{6}",
                ,
                ,
                ,
                "1600123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
                ,
                ,
                ,
                "1546012345",
                ,
                ,
                [
                    10
                ]
            ],
            "MY",
            60,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        MZ: [
            ,
            [
                ,
                ,
                "(?:2|8\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",
                ,
                ,
                ,
                "21123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "8[2-79]\\d{7}",
                ,
                ,
                ,
                "821234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "MZ",
            258,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        NA: [
            ,
            [
                ,
                ,
                "[68]\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
                ,
                ,
                ,
                "61221234"
            ],
            [
                ,
                ,
                "(?:60|8[1245])\\d{7}",
                ,
                ,
                ,
                "811234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "80\\d{7}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "8701\\d{5}",
                ,
                ,
                ,
                "870123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "8(?:3\\d\\d|86)\\d{5}",
                ,
                ,
                ,
                "88612345"
            ],
            "NA",
            264,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        NC: [
            ,
            [
                ,
                ,
                "(?:050|[2-57-9]\\d\\d)\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",
                ,
                ,
                ,
                "201234"
            ],
            [
                ,
                ,
                "(?:[579]\\d|8[0-79])\\d{4}",
                ,
                ,
                ,
                "751234"
            ],
            [
                ,
                ,
                "050\\d{3}",
                ,
                ,
                ,
                "050012"
            ],
            [
                ,
                ,
                "36\\d{4}",
                ,
                ,
                ,
                "366711"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "NC",
            687,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})",
                    "$1",
                    [
                        "5[6-8]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        NE: [
            ,
            [
                ,
                ,
                "[027-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
                ,
                ,
                ,
                "20201234"
            ],
            [
                ,
                ,
                "(?:23|7[0467]|[89]\\d)\\d{6}",
                ,
                ,
                ,
                "93123456"
            ],
            [
                ,
                ,
                "08\\d{6}",
                ,
                ,
                ,
                "08123456"
            ],
            [
                ,
                ,
                "09\\d{6}",
                ,
                ,
                ,
                "09123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "NE",
            227,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        NF: [
            ,
            [
                ,
                ,
                "[13]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6
                ],
                [
                    5
                ]
            ],
            [
                ,
                ,
                "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",
                ,
                ,
                ,
                "106609",
                ,
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                "(?:14|3[58])\\d{4}",
                ,
                ,
                ,
                "381234",
                ,
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "NF",
            672,
            "00",
            ,
            ,
            ,
            "([0-258]\\d{4})$",
            "3$1",
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        NG: [
            ,
            [
                ,
                ,
                "(?:20|9\\d)\\d{8}|[78]\\d{9,13}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10,
                    11,
                    12,
                    13,
                    14
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])\\d{6}",
                ,
                ,
                ,
                "2033123456",
                ,
                ,
                [
                    10
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}",
                ,
                ,
                ,
                "8021234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "800\\d{7,11}",
                ,
                ,
                ,
                "80017591759"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "NG",
            234,
            "009",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "700\\d{7,11}",
                ,
                ,
                ,
                "7001234567"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        NI: [
            ,
            [
                ,
                ,
                "(?:1800|[25-8]\\d{3})\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "2\\d{7}",
                ,
                ,
                ,
                "21234567"
            ],
            [
                ,
                ,
                "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",
                ,
                ,
                ,
                "81234567"
            ],
            [
                ,
                ,
                "1800\\d{4}",
                ,
                ,
                ,
                "18001234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "NI",
            505,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        NL: [
            ,
            [
                ,
                ,
                "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
                ,
                ,
                ,
                "101234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:6[1-58]|970\\d)\\d{7}",
                ,
                ,
                ,
                "612345678",
                ,
                ,
                [
                    9,
                    11
                ]
            ],
            [
                ,
                ,
                "800\\d{4,7}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "90[069]\\d{4,7}",
                ,
                ,
                ,
                "9061234",
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:85|91)\\d{7}",
                ,
                ,
                ,
                "851234567",
                ,
                ,
                [
                    9
                ]
            ],
            "NL",
            31,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})",
                    "$1",
                    [
                        "1[238]|[34]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "14"
                    ]
                ],
                [
                    ,
                    "(\\d{6})",
                    "$1",
                    [
                        "1"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                "66\\d{7}",
                ,
                ,
                ,
                "662345678",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",
                ,
                ,
                ,
                "14020",
                ,
                ,
                [
                    5,
                    6,
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        NO: [
            ,
            [
                ,
                ,
                "(?:0|[2-9]\\d{3})\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    8
                ]
            ],
            [
                ,
                ,
                "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:4[015-8]|9\\d)\\d{6}",
                ,
                ,
                ,
                "40612345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "80[01]\\d{5}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "82[09]\\d{5}",
                ,
                ,
                ,
                "82012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                ,
                ,
                ,
                "81021234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "880\\d{5}",
                ,
                ,
                ,
                "88012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "85[0-5]\\d{5}",
                ,
                ,
                ,
                "85012345",
                ,
                ,
                [
                    8
                ]
            ],
            "NO",
            47,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            1,
            "[02-689]|7[0-8]",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
                ,
                ,
                ,
                "02000"
            ],
            ,
            ,
            [
                ,
                ,
                "81[23]\\d{5}",
                ,
                ,
                ,
                "81212345",
                ,
                ,
                [
                    8
                ]
            ]
        ],
        NP: [
            ,
            [
                ,
                ,
                "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    10,
                    11
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",
                ,
                ,
                ,
                "14567890",
                ,
                ,
                [
                    8
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "9(?:00|6[0-3]|7[0-24-6]|8[0-24-68])\\d{7}",
                ,
                ,
                ,
                "9841234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "1(?:66001|800\\d\\d)\\d{5}",
                ,
                ,
                ,
                "16600101234",
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "NP",
            977,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{2})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "1"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        NR: [
            ,
            [
                ,
                ,
                "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "444\\d{4}",
                ,
                ,
                ,
                "4441234"
            ],
            [
                ,
                ,
                "(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}",
                ,
                ,
                ,
                "5551234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "NR",
            674,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        NU: [
            ,
            [
                ,
                ,
                "(?:[4-7]|888\\d)\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    4,
                    7
                ]
            ],
            [
                ,
                ,
                "[47]\\d{3}",
                ,
                ,
                ,
                "7012",
                ,
                ,
                [
                    4
                ]
            ],
            [
                ,
                ,
                "(?:[56]|888[1-9])\\d{3}",
                ,
                ,
                ,
                "8884012"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "NU",
            683,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        NZ: [
            ,
            [
                ,
                ,
                "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",
                ,
                ,
                ,
                "32345678",
                ,
                ,
                [
                    8
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",
                ,
                ,
                ,
                "211234567",
                ,
                ,
                [
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "508\\d{6,7}|80\\d{6,8}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "70\\d{7}",
                ,
                ,
                ,
                "701234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "NZ",
            64,
            "0(?:0|161)",
            "0",
            ,
            ,
            "0",
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}",
                ,
                ,
                ,
                "83012378"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        OM: [
            ,
            [
                ,
                ,
                "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "2[1-6]\\d{6}",
                ,
                ,
                ,
                "23123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:1505|90[1-9]\\d)\\d{4}|(?:7[124-9]|9[1-9])\\d{6}",
                ,
                ,
                ,
                "92123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "8007\\d{4,5}|(?:500|800[05])\\d{4}",
                ,
                ,
                ,
                "80071234"
            ],
            [
                ,
                ,
                "900\\d{5}",
                ,
                ,
                ,
                "90012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "OM",
            968,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        PA: [
            ,
            [
                ,
                ,
                "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                "(?:1(?:0\\d|1[0479]|2[37]|3[0137]|4[147]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[0147-9]\\d|[25][0-5]|33|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[4-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
                ,
                ,
                ,
                "2001234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",
                ,
                ,
                ,
                "61234567",
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "800\\d{4,5}|(?:00800|800\\d)\\d{6}",
                ,
                ,
                ,
                "8001234"
            ],
            [
                ,
                ,
                "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",
                ,
                ,
                ,
                "8601234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "PA",
            507,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        PE: [
            ,
            [
                ,
                ,
                "(?:[14-8]|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",
                ,
                ,
                ,
                "11234567",
                ,
                ,
                [
                    8
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "9\\d{8}",
                ,
                ,
                ,
                "912345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "805\\d{5}",
                ,
                ,
                ,
                "80512345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "801\\d{5}",
                ,
                ,
                ,
                "80112345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "80[24]\\d{5}",
                ,
                ,
                ,
                "80212345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "PE",
            51,
            "00|19(?:1[124]|77|90)00",
            "0",
            " Anexo ",
            ,
            "0",
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        PF: [
            ,
            [
                ,
                ,
                "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "4(?:0[4-689]|9[4-68])\\d{5}",
                ,
                ,
                ,
                "40412345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "8[7-9]\\d{6}",
                ,
                ,
                ,
                "87123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "499\\d{5}",
                ,
                ,
                ,
                "49901234",
                ,
                ,
                [
                    8
                ]
            ],
            "PF",
            689,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "44\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "44\\d{4}",
                ,
                ,
                ,
                "440123",
                ,
                ,
                [
                    6
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        PG: [
            ,
            [
                ,
                ,
                "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",
                ,
                ,
                ,
                "3123456",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:7\\d|8[1-48])\\d{6}",
                ,
                ,
                ,
                "70123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "180\\d{4}",
                ,
                ,
                ,
                "1801234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "2(?:0[0-57]|7[568])\\d{4}",
                ,
                ,
                ,
                "2751234",
                ,
                ,
                [
                    7
                ]
            ],
            "PG",
            675,
            "00|140[1-3]",
            ,
            ,
            ,
            ,
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                "27[01]\\d{4}",
                ,
                ,
                ,
                "2700123",
                ,
                ,
                [
                    7
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        PH: [
            ,
            [
                ,
                ,
                "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13
                ],
                [
                    4,
                    5,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
                ,
                ,
                ,
                "232345678",
                ,
                ,
                [
                    6,
                    8,
                    9,
                    10
                ],
                [
                    4,
                    5,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",
                ,
                ,
                ,
                "9051234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "1800\\d{7,9}",
                ,
                ,
                ,
                "180012345678",
                ,
                ,
                [
                    11,
                    12,
                    13
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "PH",
            63,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        PK: [
            ,
            [
                ,
                ,
                "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10,
                    11,
                    12
                ],
                [
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",
                ,
                ,
                ,
                "2123456789",
                ,
                ,
                [
                    9,
                    10
                ],
                [
                    5,
                    6,
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",
                ,
                ,
                ,
                "3012345678",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "800\\d{5}(?:\\d{3})?",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [
                    8,
                    11
                ]
            ],
            [
                ,
                ,
                "900\\d{5}",
                ,
                ,
                ,
                "90012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "122\\d{6}",
                ,
                ,
                ,
                "122044444",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "PK",
            92,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
                ,
                ,
                ,
                "21111825888",
                ,
                ,
                [
                    11,
                    12
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        PL: [
            ,
            [
                ,
                ,
                "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "(?:30|47\\d\\d)\\d{5}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",
                ,
                ,
                ,
                "123456789",
                ,
                ,
                [
                    7,
                    9
                ]
            ],
            [
                ,
                ,
                "21(?:1[013-5]|2\\d|3[1-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
                ,
                ,
                ,
                "512345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{6,7}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "70[01346-8]\\d{6}",
                ,
                ,
                ,
                "701234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "801\\d{6}",
                ,
                ,
                ,
                "801234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "39\\d{7}",
                ,
                ,
                ,
                "391234567",
                ,
                ,
                [
                    9
                ]
            ],
            "PL",
            48,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "30|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "30|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                "64\\d{4,7}",
                ,
                ,
                ,
                "641234567",
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "804\\d{6}",
                ,
                ,
                ,
                "804123456",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        PM: [
            ,
            [
                ,
                ,
                "[78]\\d{8}|[2-9]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    9
                ]
            ],
            [
                ,
                ,
                "80[6-9]\\d{6}|(?:[236-9]\\d|4[1-35-9]|5[0-47-9])\\d{4}",
                ,
                ,
                ,
                "430123"
            ],
            [
                ,
                ,
                "708(?:4[0-5]|5[0-6])\\d{4}|(?:[236-9]\\d|4[02-489]|5[02-9])\\d{4}",
                ,
                ,
                ,
                "551234"
            ],
            [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "8[129]\\d{7}",
                ,
                ,
                ,
                "810123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "PM",
            508,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        PR: [
            ,
            [
                ,
                ,
                "(?:[589]\\d\\d|787)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:787|939)[2-9]\\d{6}",
                ,
                ,
                ,
                "7872345678",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:787|939)[2-9]\\d{6}",
                ,
                ,
                ,
                "7872345678",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "PR",
            1,
            "011",
            "1",
            ,
            ,
            "1",
            ,
            ,
            1,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "787|939",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        PS: [
            ,
            [
                ,
                ,
                "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
                ,
                ,
                ,
                "22234567",
                ,
                ,
                [
                    8
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "5[69]\\d{7}",
                ,
                ,
                ,
                "599123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "1800\\d{6}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "1700\\d{6}",
                ,
                ,
                ,
                "1700123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "PS",
            970,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        PT: [
            ,
            [
                ,
                ,
                "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}",
                ,
                ,
                ,
                "212345678"
            ],
            [
                ,
                ,
                "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",
                ,
                ,
                ,
                "912345678"
            ],
            [
                ,
                ,
                "80[02]\\d{6}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",
                ,
                ,
                ,
                "760123456"
            ],
            [
                ,
                ,
                "80(?:8\\d|9[1579])\\d{5}",
                ,
                ,
                ,
                "808123456"
            ],
            [
                ,
                ,
                "884[0-4689]\\d{5}",
                ,
                ,
                ,
                "884123456"
            ],
            [
                ,
                ,
                "30\\d{7}",
                ,
                ,
                ,
                "301234567"
            ],
            "PT",
            351,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                "6(?:222\\d|89(?:00|88|99))\\d{4}",
                ,
                ,
                ,
                "622212345"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}",
                ,
                ,
                ,
                "707123456"
            ],
            ,
            ,
            [
                ,
                ,
                "600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}",
                ,
                ,
                ,
                "600110000"
            ]
        ],
        PW: [
            ,
            [
                ,
                ,
                "(?:[24-8]\\d\\d|345|900)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",
                ,
                ,
                ,
                "2771234"
            ],
            [
                ,
                ,
                "(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}",
                ,
                ,
                ,
                "6201234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "PW",
            680,
            "01[12]",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        PY: [
            ,
            [
                ,
                ,
                "[36-8]\\d{5,8}|4\\d{6,8}|59\\d{6}|9\\d{5,10}|(?:2\\d|5[0-8])\\d{6,7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10,
                    11
                ],
                [
                    5
                ]
            ],
            [
                ,
                ,
                "(?:3[289]|4[246-8]|61|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:[14-68]\\d|2[4-68]|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:1\\d|3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                [
                    7,
                    8,
                    9
                ],
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}",
                ,
                ,
                ,
                "961456789",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "9800\\d{5,7}",
                ,
                ,
                ,
                "98000123456",
                ,
                ,
                [
                    9,
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "8700[0-4]\\d{4}",
                ,
                ,
                ,
                "870012345",
                ,
                ,
                [
                    9
                ]
            ],
            "PY",
            595,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{6,7})",
                    "$1",
                    [
                        "[125]|4[01]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "3[289]|4[246-8]|61|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "3[289]|4[246-8]|61|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "[245]0\\d{6,7}|[36-9]0\\d{4,7}",
                ,
                ,
                ,
                "201234567",
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        QA: [
            ,
            [
                ,
                ,
                "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9,
                    11
                ]
            ],
            [
                ,
                ,
                "4(?:(?:[014]\\d\\d|999)\\d|2022)\\d{3}",
                ,
                ,
                ,
                "44123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "[35-7]\\d{7}",
                ,
                ,
                ,
                "33123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "800\\d{4}|(?:0080[01]|800)\\d{6}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [
                    7,
                    9,
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "QA",
            974,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[136]|8"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                "2[136]\\d{5}",
                ,
                ,
                ,
                "2123456",
                ,
                ,
                [
                    7
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        RE: [
            ,
            [
                ,
                ,
                "709\\d{6}|(?:26|[689]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "2631[0-6]\\d{4}|26(?:2\\d|30|88)\\d{5}",
                ,
                ,
                ,
                "262161234"
            ],
            [
                ,
                ,
                "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}",
                ,
                ,
                ,
                "692123456"
            ],
            [
                ,
                ,
                "80\\d{7}",
                ,
                ,
                ,
                "801234567"
            ],
            [
                ,
                ,
                "89[1-37-9]\\d{6}",
                ,
                ,
                ,
                "891123456"
            ],
            [
                ,
                ,
                "8(?:1[019]|2[0156]|84|90)\\d{6}",
                ,
                ,
                ,
                "810123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}",
                ,
                ,
                ,
                "939901234"
            ],
            "RE",
            262,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            1,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        RO: [
            ,
            [
                ,
                ,
                "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    9
                ]
            ],
            [
                ,
                ,
                "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
                ,
                ,
                ,
                "211234567"
            ],
            [
                ,
                ,
                "(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",
                ,
                ,
                ,
                "712034567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "90[0136]\\d{6}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "801\\d{6}",
                ,
                ,
                ,
                "801123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "RO",
            40,
            "00",
            "0",
            " int ",
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:37\\d|80[578])\\d{6}",
                ,
                ,
                ,
                "372123456",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        RS: [
            ,
            [
                ,
                ,
                "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12
                ],
                [
                    4,
                    5
                ]
            ],
            [
                ,
                ,
                "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",
                ,
                ,
                ,
                "10234567",
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10,
                    11,
                    12
                ],
                [
                    4,
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "6(?:[0-689]|7\\d)\\d{6,7}",
                ,
                ,
                ,
                "601234567",
                ,
                ,
                [
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "800\\d{3,9}",
                ,
                ,
                ,
                "80012345"
            ],
            [
                ,
                ,
                "(?:78\\d|90[0169])\\d{3,7}",
                ,
                ,
                ,
                "90012345",
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "RS",
            381,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "7[06]\\d{4,10}",
                ,
                ,
                ,
                "700123456"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        RU: [
            ,
            [
                ,
                ,
                "8\\d{13}|[347-9]\\d{9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10,
                    14
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:3(?:0[12]|36|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}",
                ,
                ,
                ,
                "3011234567",
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "9\\d{9}",
                ,
                ,
                ,
                "9123456789",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "8(?:0[04]|108\\d{3})\\d{7}",
                ,
                ,
                ,
                "8001234567"
            ],
            [
                ,
                ,
                "80[39]\\d{7}",
                ,
                ,
                ,
                "8091234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "808\\d{7}",
                ,
                ,
                ,
                "8081234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "RU",
            7,
            "810",
            "8",
            ,
            ,
            "8",
            ,
            "8~10",
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "[0-79]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            [
                [
                    ,
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            1,
            "[3489]",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        RW: [
            ,
            [
                ,
                ,
                "(?:06|[27]\\d\\d|[89]00)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "(?:06|2[23568]\\d)\\d{6}",
                ,
                ,
                ,
                "250123456"
            ],
            [
                ,
                ,
                "7[237-9]\\d{7}",
                ,
                ,
                ,
                "720123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "900\\d{6}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "RW",
            250,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SA: [
            ,
            [
                ,
                ,
                "(?:[15]\\d|800|92)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9,
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",
                ,
                ,
                ,
                "112345678",
                ,
                ,
                [
                    9
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "579[0-8]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
                ,
                ,
                ,
                "512345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{7}",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "925\\d{6}",
                ,
                ,
                ,
                "925012345",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "920\\d{6}",
                ,
                ,
                ,
                "920012345",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "SA",
            966,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SB: [
            ,
            [
                ,
                ,
                "[6-9]\\d{6}|[1-6]\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",
                ,
                ,
                ,
                "40123",
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",
                ,
                ,
                ,
                "7421234"
            ],
            [
                ,
                ,
                "1[38]\\d{3}",
                ,
                ,
                ,
                "18123",
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "5[12]\\d{3}",
                ,
                ,
                ,
                "51123",
                ,
                ,
                [
                    5
                ]
            ],
            "SB",
            677,
            "0[01]",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SC: [
            ,
            [
                ,
                ,
                "(?:[2489]\\d|64)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "4[2-46]\\d{5}",
                ,
                ,
                ,
                "4217123"
            ],
            [
                ,
                ,
                "2[125-8]\\d{5}",
                ,
                ,
                ,
                "2510123"
            ],
            [
                ,
                ,
                "800[08]\\d{3}",
                ,
                ,
                ,
                "8000000"
            ],
            [
                ,
                ,
                "85\\d{5}",
                ,
                ,
                ,
                "8512345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "971\\d{4}|(?:64|95)\\d{5}",
                ,
                ,
                ,
                "6412345"
            ],
            "SC",
            248,
            "010|0[0-2]",
            ,
            ,
            ,
            ,
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SD: [
            ,
            [
                ,
                ,
                "[19]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "1(?:5\\d|8[35-7])\\d{6}",
                ,
                ,
                ,
                "153123456"
            ],
            [
                ,
                ,
                "(?:1[0-2]|9[0-3569])\\d{7}",
                ,
                ,
                ,
                "911231234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "SD",
            249,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SE: [
            ,
            [
                ,
                ,
                "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10,
                    12
                ]
            ],
            [
                ,
                ,
                "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
                ,
                ,
                ,
                "8123456",
                ,
                ,
                [
                    7,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "7[02369]\\d{7}",
                ,
                ,
                ,
                "701234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "20\\d{4,7}",
                ,
                ,
                ,
                "20123456",
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}",
                ,
                ,
                ,
                "9001234567",
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "77[0-7]\\d{6}",
                ,
                ,
                ,
                "771234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "75[1-8]\\d{6}",
                ,
                ,
                ,
                "751234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "SE",
            46,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "20"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "9(?:00|39|44|9)"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9(?:00|39|44)"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "10|7"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]"
                    ]
                ]
            ],
            [
                ,
                ,
                "74[02-9]\\d{6}",
                ,
                ,
                ,
                "740123456",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "10[1-8]\\d{6}",
                ,
                ,
                ,
                "102345678",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "(?:25[245]|67[3-68])\\d{9}",
                ,
                ,
                ,
                "254123456789",
                ,
                ,
                [
                    12
                ]
            ]
        ],
        SG: [
            ,
            [
                ,
                ,
                "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
                ,
                ,
                ,
                "61234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "898[02-9]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-79])|9[0-8]\\d)\\d{5}",
                ,
                ,
                ,
                "81234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:18|8)00\\d{7}",
                ,
                ,
                ,
                "18001234567",
                ,
                ,
                [
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                "1900\\d{7}",
                ,
                ,
                ,
                "19001234567",
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:3[12]\\d|666)\\d{5}",
                ,
                ,
                ,
                "31234567",
                ,
                ,
                [
                    8
                ]
            ],
            "SG",
            65,
            "0[0-3]\\d",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4,5})",
                    "$1",
                    [
                        "1[013-9]|77",
                        "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "7000\\d{7}",
                ,
                ,
                ,
                "70001234567",
                ,
                ,
                [
                    11
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SH: [
            ,
            [
                ,
                ,
                "(?:[256]\\d|8)\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    4,
                    5
                ]
            ],
            [
                ,
                ,
                "2(?:[0-57-9]\\d|6[4-9])\\d\\d",
                ,
                ,
                ,
                "22158"
            ],
            [
                ,
                ,
                "[56]\\d{4}",
                ,
                ,
                ,
                "51234",
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "262\\d\\d",
                ,
                ,
                ,
                "26212",
                ,
                ,
                [
                    5
                ]
            ],
            "SH",
            290,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            1,
            "[256]",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SI: [
            ,
            [
                ,
                ,
                "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "(?:[1-357][2-8]|4[24-8])\\d{6}",
                ,
                ,
                ,
                "12345678",
                ,
                ,
                [
                    8
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",
                ,
                ,
                ,
                "31234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "80\\d{4,6}",
                ,
                ,
                ,
                "80123456",
                ,
                ,
                [
                    6,
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "89[1-3]\\d{2,5}|90\\d{4,6}",
                ,
                ,
                ,
                "90123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",
                ,
                ,
                ,
                "59012345",
                ,
                ,
                [
                    8
                ]
            ],
            "SI",
            386,
            "00|10(?:22|66|88|99)",
            "0",
            ,
            ,
            "0",
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SJ: [
            ,
            [
                ,
                ,
                "0\\d{4}|(?:[489]\\d|79)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    8
                ]
            ],
            [
                ,
                ,
                "79\\d{6}",
                ,
                ,
                ,
                "79123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:4[015-8]|9\\d)\\d{6}",
                ,
                ,
                ,
                "41234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "80[01]\\d{5}",
                ,
                ,
                ,
                "80012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "82[09]\\d{5}",
                ,
                ,
                ,
                "82012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                ,
                ,
                ,
                "81021234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "880\\d{5}",
                ,
                ,
                ,
                "88012345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "85[0-5]\\d{5}",
                ,
                ,
                ,
                "85012345",
                ,
                ,
                [
                    8
                ]
            ],
            "SJ",
            47,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "79",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
                ,
                ,
                ,
                "02000"
            ],
            ,
            ,
            [
                ,
                ,
                "81[23]\\d{5}",
                ,
                ,
                ,
                "81212345",
                ,
                ,
                [
                    8
                ]
            ]
        ],
        SK: [
            ,
            [
                ,
                ,
                "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    9
                ]
            ],
            [
                ,
                ,
                "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",
                ,
                ,
                ,
                "221234567"
            ],
            [
                ,
                ,
                "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",
                ,
                ,
                ,
                "912123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "9(?:00|[78]\\d)\\d{6}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "8[5-9]\\d{7}",
                ,
                ,
                ,
                "850123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "6(?:02|5[0-4]|9[0-6])\\d{6}",
                ,
                ,
                ,
                "690123456",
                ,
                ,
                [
                    9
                ]
            ],
            "SK",
            421,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "909",
                        "9090"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                "9090\\d{3}",
                ,
                ,
                ,
                "9090123",
                ,
                ,
                [
                    7
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    9
                ]
            ],
            [
                ,
                ,
                "96\\d{7}",
                ,
                ,
                ,
                "961234567",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SL: [
            ,
            [
                ,
                ,
                "(?:[237-9]\\d|66)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "22[2-4][2-9]\\d{4}",
                ,
                ,
                ,
                "22221234",
                ,
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:25|3[0-5]|66|7\\d|8[08]|9[09])\\d{6}",
                ,
                ,
                ,
                "25123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "SL",
            232,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SM: [
            ,
            [
                ,
                ,
                "(?:0549|[5-7]\\d)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    10
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "0549(?:8[0157-9]|9\\d)\\d{4}",
                ,
                ,
                ,
                "0549886377",
                ,
                ,
                [
                    10
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "6[16]\\d{6}",
                ,
                ,
                ,
                "66661212",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "7[178]\\d{6}",
                ,
                ,
                ,
                "71123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "5[158]\\d{6}",
                ,
                ,
                ,
                "58001110",
                ,
                ,
                [
                    8
                ]
            ],
            "SM",
            378,
            "00",
            ,
            ,
            ,
            "([89]\\d{5})$",
            "0549$1",
            ,
            ,
            [
                [
                    ,
                    "(\\d{6})",
                    "$1",
                    [
                        "[89]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SN: [
            ,
            [
                ,
                ,
                "(?:[378]\\d|93)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",
                ,
                ,
                ,
                "301012345"
            ],
            [
                ,
                ,
                "7(?:[015-8]\\d|21|90)\\d{6}",
                ,
                ,
                ,
                "701234567"
            ],
            [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                "88[4689]\\d{6}",
                ,
                ,
                ,
                "884123456"
            ],
            [
                ,
                ,
                "81[02468]\\d{6}",
                ,
                ,
                ,
                "810123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",
                ,
                ,
                ,
                "933301234"
            ],
            "SN",
            221,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SO: [
            ,
            [
                ,
                ,
                "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
                ,
                ,
                ,
                "4012345",
                ,
                ,
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",
                ,
                ,
                ,
                "71123456",
                ,
                ,
                [
                    7,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "SO",
            252,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    ,
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|7[67]|9[2-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SR: [
            ,
            [
                ,
                ,
                "(?:[2-5]|[6-9]\\d)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2[1-3]|3[0-7]|4\\d|5[2-578])\\d{4}",
                ,
                ,
                ,
                "211234",
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:6[08]|7[124-7]|8[1-9])\\d{5}",
                ,
                ,
                ,
                "7412345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "80\\d{5}",
                ,
                ,
                ,
                "8012345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "90\\d{5}",
                ,
                ,
                ,
                "9012345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:56|91\\d)\\d{4}",
                ,
                ,
                ,
                "561234"
            ],
            "SR",
            597,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SS: [
            ,
            [
                ,
                ,
                "[19]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "1[89]\\d{7}",
                ,
                ,
                ,
                "181234567"
            ],
            [
                ,
                ,
                "(?:12|9[1257-9])\\d{7}",
                ,
                ,
                ,
                "977123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "SS",
            211,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        ST: [
            ,
            [
                ,
                ,
                "(?:22|9\\d)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "22\\d{5}",
                ,
                ,
                ,
                "2221234"
            ],
            [
                ,
                ,
                "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",
                ,
                ,
                ,
                "9812345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "ST",
            239,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SV: [
            ,
            [
                ,
                ,
                "[25-7]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    11
                ]
            ],
            [
                ,
                ,
                "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "[5-7]\\d{7}",
                ,
                ,
                ,
                "70123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "800\\d{8}|80[01]\\d{4}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [
                    7,
                    11
                ]
            ],
            [
                ,
                ,
                "900\\d{4}(?:\\d{4})?",
                ,
                ,
                ,
                "9001234",
                ,
                ,
                [
                    7,
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "SV",
            503,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-7]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SX: [
            ,
            [
                ,
                ,
                "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "7215(?:4[2-8]|8[39]|9[056])\\d{4}",
                ,
                ,
                ,
                "7215425678",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "7215(?:1[02]|2\\d|5[034679]|8[0-24-8])\\d{4}",
                ,
                ,
                ,
                "7215205678",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "SX",
            1,
            "011",
            "1",
            ,
            ,
            "(5\\d{6})$|1",
            "721$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "721",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SY: [
            ,
            [
                ,
                ,
                "[1-359]\\d{8}|[1-5]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ],
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",
                ,
                ,
                ,
                "112345678",
                ,
                ,
                ,
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:50|9[1-9])\\d{7}",
                ,
                ,
                ,
                "944567890",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "SY",
            963,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-4]|5[1-3]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[59]"
                    ],
                    "0$1",
                    ,
                    1
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        SZ: [
            ,
            [
                ,
                ,
                "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "[23][2-5]\\d{6}",
                ,
                ,
                ,
                "22171234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "7[5-9]\\d{6}",
                ,
                ,
                ,
                "76123456",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "0800\\d{4}",
                ,
                ,
                ,
                "08001234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "900\\d{6}",
                ,
                ,
                ,
                "900012345",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "70\\d{6}",
                ,
                ,
                ,
                "70012345",
                ,
                ,
                [
                    8
                ]
            ],
            "SZ",
            268,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    ,
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "0800\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TA: [
            ,
            [
                ,
                ,
                "8\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    4
                ]
            ],
            [
                ,
                ,
                "8\\d{3}",
                ,
                ,
                ,
                "8999"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "TA",
            290,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "8",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TC: [
            ,
            [
                ,
                ,
                "(?:[58]\\d\\d|649|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "649(?:266|712|9(?:4\\d|50))\\d{4}",
                ,
                ,
                ,
                "6497121234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",
                ,
                ,
                ,
                "6492311234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                "649(?:71[01]|966)\\d{4}",
                ,
                ,
                ,
                "6497101234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            "TC",
            1,
            "011",
            "1",
            ,
            ,
            "([2-479]\\d{6})$|1",
            "649$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "649",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TD: [
            ,
            [
                ,
                ,
                "(?:22|[3689]\\d|77)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "22(?:[37-9]0|5[0-5]|6[89])\\d{4}",
                ,
                ,
                ,
                "22501234"
            ],
            [
                ,
                ,
                "(?:3[01]|[69]\\d|77|8[5-7])\\d{6}",
                ,
                ,
                ,
                "63012345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "TD",
            235,
            "00|16",
            ,
            ,
            ,
            ,
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[236-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TG: [
            ,
            [
                ,
                ,
                "[279]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
                ,
                ,
                ,
                "22212345"
            ],
            [
                ,
                ,
                "(?:7[0-289]|9[0-36-9])\\d{6}",
                ,
                ,
                ,
                "90112345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "TG",
            228,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TH: [
            ,
            [
                ,
                ,
                "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10,
                    13
                ]
            ],
            [
                ,
                ,
                "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:(?:14|[89]\\d)\\d\\d|6(?:[1-6]\\d\\d|7(?:1[0-8]|2[4-7]|3[1-6])))\\d{5}",
                ,
                ,
                ,
                "812345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:001800\\d|1800)\\d{6}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [
                    10,
                    13
                ]
            ],
            [
                ,
                ,
                "1900\\d{6}",
                ,
                ,
                ,
                "1900123456",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "6[08]\\d{7}",
                ,
                ,
                ,
                "601234567",
                ,
                ,
                [
                    9
                ]
            ],
            "TH",
            66,
            "00[1-9]",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TJ: [
            ,
            [
                ,
                ,
                "(?:[0-57-9]\\d|66)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ],
                [
                    3,
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
                ,
                ,
                ,
                "372123456",
                ,
                ,
                ,
                [
                    3,
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|3[08]|40|5[05]|66|7[0157-9]|8[07-9])\\d{7}",
                ,
                ,
                ,
                "917123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "TJ",
            992,
            "810",
            ,
            ,
            ,
            ,
            ,
            "8~10",
            ,
            [
                [
                    ,
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[1245]|3[12])"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "\\d"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TK: [
            ,
            [
                ,
                ,
                "[2-47]\\d{3,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    4,
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2[2-4]|[34]\\d)\\d{2,5}",
                ,
                ,
                ,
                "3101"
            ],
            [
                ,
                ,
                "7[2-4]\\d{2,5}",
                ,
                ,
                ,
                "7290"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "TK",
            690,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TL: [
            ,
            [
                ,
                ,
                "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",
                ,
                ,
                ,
                "2112345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "7[2-8]\\d{6}",
                ,
                ,
                ,
                "77212345",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "80\\d{5}",
                ,
                ,
                ,
                "8012345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "90\\d{5}",
                ,
                ,
                ,
                "9012345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "70\\d{5}",
                ,
                ,
                ,
                "7012345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "TL",
            670,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TM: [
            ,
            [
                ,
                ,
                "(?:[1-6]\\d|71)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",
                ,
                ,
                ,
                "12345678"
            ],
            [
                ,
                ,
                "(?:6\\d|71)\\d{6}",
                ,
                ,
                ,
                "66123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "TM",
            993,
            "810",
            "8",
            ,
            ,
            "8",
            ,
            "8~10",
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    ,
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TN: [
            ,
            [
                ,
                ,
                "[2-57-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",
                ,
                ,
                ,
                "30010123"
            ],
            [
                ,
                ,
                "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
                ,
                ,
                ,
                "20123456"
            ],
            [
                ,
                ,
                "8010\\d{4}",
                ,
                ,
                ,
                "80101234"
            ],
            [
                ,
                ,
                "88\\d{6}",
                ,
                ,
                ,
                "88123456"
            ],
            [
                ,
                ,
                "8[12]10\\d{4}",
                ,
                ,
                ,
                "81101234"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "TN",
            216,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TO: [
            ,
            [
                ,
                ,
                "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",
                ,
                ,
                ,
                "20123",
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
                ,
                ,
                ,
                "7715123",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "0800\\d{3}",
                ,
                ,
                ,
                "0800222",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "55[0-37-9]\\d{4}",
                ,
                ,
                ,
                "5510123",
                ,
                ,
                [
                    7
                ]
            ],
            "TO",
            676,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TR: [
            ,
            [
                ,
                ,
                "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    10,
                    12,
                    13
                ]
            ],
            [
                ,
                ,
                "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
                ,
                ,
                ,
                "2123456789",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "561(?:011|61\\d)\\d{4}|5(?:[03-5]\\d|1[06]|24|7[45]|9[46])\\d{7}",
                ,
                ,
                ,
                "5012345678",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",
                ,
                ,
                ,
                "8001234567",
                ,
                ,
                [
                    10,
                    12,
                    13
                ]
            ],
            [
                ,
                ,
                "(?:8[89]8|900)\\d{7}",
                ,
                ,
                ,
                "9001234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "592(?:21[12]|461)\\d{4}",
                ,
                ,
                ,
                "5922121234",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "850\\d{7}",
                ,
                ,
                ,
                "8500123456",
                ,
                ,
                [
                    10
                ]
            ],
            "TR",
            90,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d)(\\d{3})",
                    "$1 $2 $3",
                    [
                        "444"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-579]|61)",
                        "5(?:[0-579]|61[06])",
                        "5(?:[0-579]|61[06]1)"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    ,
                    1
                ]
            ],
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-579]|61)",
                        "5(?:[0-579]|61[06])",
                        "5(?:[0-579]|61[06]1)"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    ,
                    1
                ]
            ],
            [
                ,
                ,
                "512\\d{7}",
                ,
                ,
                ,
                "5123456789",
                ,
                ,
                [
                    10
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "(?:444|811\\d{3})\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    10
                ]
            ],
            [
                ,
                ,
                "444\\d{4}",
                ,
                ,
                ,
                "4441444",
                ,
                ,
                [
                    7
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TT: [
            ,
            [
                ,
                ,
                "(?:[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",
                ,
                ,
                ,
                "8682211234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
                ,
                ,
                ,
                "8682911234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "868800\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "TT",
            1,
            "011",
            "1",
            ,
            ,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "868",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "868619\\d{4}",
                ,
                ,
                ,
                "8686191234",
                ,
                ,
                ,
                [
                    7
                ]
            ]
        ],
        TV: [
            ,
            [
                ,
                ,
                "(?:2|7\\d\\d|90)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "2[02-9]\\d{3}",
                ,
                ,
                ,
                "20123",
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                "(?:7[01]\\d|90)\\d{4}",
                ,
                ,
                ,
                "901234",
                ,
                ,
                [
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "TV",
            688,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TW: [
            ,
            [
                ,
                ,
                "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
                ,
                ,
                ,
                "221234567",
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",
                ,
                ,
                ,
                "912345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "80[0-79]\\d{6}|800\\d{5}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "20(?:[013-9]\\d\\d|2)\\d{4}",
                ,
                ,
                ,
                "203123456",
                ,
                ,
                [
                    7,
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "99\\d{7}",
                ,
                ,
                ,
                "990123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",
                ,
                ,
                ,
                "7012345678",
                ,
                ,
                [
                    10,
                    11
                ]
            ],
            "TW",
            886,
            "0(?:0[25-79]|19)",
            "0",
            "#",
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "826"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "83"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "82"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[25]0|37|49|8[09]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-478])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-478])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "50[0-46-9]\\d{6}",
                ,
                ,
                ,
                "500123456",
                ,
                ,
                [
                    9
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        TZ: [
            ,
            [
                ,
                ,
                "(?:[25-8]\\d|41|90)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "2[2-8]\\d{7}",
                ,
                ,
                ,
                "222345678"
            ],
            [
                ,
                ,
                "(?:6[1-35-9]|7[013-9])\\d{7}",
                ,
                ,
                ,
                "621234567"
            ],
            [
                ,
                ,
                "80[08]\\d{6}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                "90\\d{7}",
                ,
                ,
                ,
                "900123456"
            ],
            [
                ,
                ,
                "8(?:40|6[01])\\d{6}",
                ,
                ,
                ,
                "840123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "41\\d{7}",
                ,
                ,
                ,
                "412345678"
            ],
            "TZ",
            255,
            "00[056]",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        UA: [
            ,
            [
                ,
                ,
                "[89]\\d{9}|[3-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9,
                    10
                ],
                [
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
                ,
                ,
                ,
                "311234567",
                ,
                ,
                [
                    9
                ],
                [
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}",
                ,
                ,
                ,
                "501234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "800[1-8]\\d{5,6}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                "900[239]\\d{5,6}",
                ,
                ,
                ,
                "900212345"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "89[1-579]\\d{6}",
                ,
                ,
                ,
                "891234567",
                ,
                ,
                [
                    9
                ]
            ],
            "UA",
            380,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            "0~0",
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        UG: [
            ,
            [
                ,
                ,
                "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ],
                [
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
                ,
                ,
                ,
                "312345678",
                ,
                ,
                ,
                [
                    5,
                    6,
                    7
                ]
            ],
            [
                ,
                ,
                "72[48]0\\d{5}|7(?:[014-8]\\d|2[0167]|3[06]|9[0-3589])\\d{6}",
                ,
                ,
                ,
                "712345678"
            ],
            [
                ,
                ,
                "800[1-3]\\d{5}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                "90[1-3]\\d{6}",
                ,
                ,
                ,
                "901123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "UG",
            256,
            "00[057]",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        US: [
            ,
            [
                ,
                ,
                "[2-9]\\d{9}|3\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:274[27]|(?:472|983)[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-2478]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",
                ,
                ,
                ,
                "2015550123",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:274[27]|(?:472|983)[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-2478]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",
                ,
                ,
                ,
                "2015550123",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "US",
            1,
            "011",
            "1",
            ,
            ,
            "1",
            ,
            ,
            1,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[24-9]|3(?:[02-9]|1[1-9])"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    ,
                    ,
                    1
                ]
            ],
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            1,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        UY: [
            ,
            [
                ,
                ,
                "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13
                ]
            ],
            [
                ,
                ,
                "(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}",
                ,
                ,
                ,
                "21231234",
                ,
                ,
                [
                    8
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "9[1-9]\\d{6}",
                ,
                ,
                ,
                "94231234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "0004\\d{2,9}|(?:405|80[05])\\d{4}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13
                ]
            ],
            [
                ,
                ,
                "90[0-8]\\d{4}",
                ,
                ,
                ,
                "9001234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "UY",
            598,
            "0(?:0|1[3-9]\\d)",
            "0",
            " int. ",
            ,
            "0",
            ,
            "00",
            ,
            [
                [
                    ,
                    "(\\d{4,5})",
                    "$1",
                    [
                        "21"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "21\\d{2,3}",
                ,
                ,
                ,
                "21123",
                ,
                ,
                [
                    4,
                    5
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        UZ: [
            ,
            [
                ,
                ,
                "(?:20|33|[5-9]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|[168]\\d\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}",
                ,
                ,
                ,
                "669050123"
            ],
            [
                ,
                ,
                "(?:(?:[25]0|33|8[078]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
                ,
                ,
                ,
                "912345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "UZ",
            998,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        VA: [
            ,
            [
                ,
                ,
                "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                "06698\\d{1,6}",
                ,
                ,
                ,
                "0669812345",
                ,
                ,
                [
                    6,
                    7,
                    8,
                    9,
                    10,
                    11
                ]
            ],
            [
                ,
                ,
                "3[1-9]\\d{8}|3[2-9]\\d{7}",
                ,
                ,
                ,
                "3123456789",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "80(?:0\\d{3}|3)\\d{3}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [
                    6,
                    9
                ]
            ],
            [
                ,
                ,
                "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                ,
                ,
                ,
                "899123456",
                ,
                ,
                [
                    6,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "84(?:[08]\\d{3}|[17])\\d{3}",
                ,
                ,
                ,
                "848123456",
                ,
                ,
                [
                    6,
                    9
                ]
            ],
            [
                ,
                ,
                "1(?:78\\d|99)\\d{6}",
                ,
                ,
                ,
                "1781234567",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "55\\d{8}",
                ,
                ,
                ,
                "5512345678",
                ,
                ,
                [
                    10
                ]
            ],
            "VA",
            39,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "06698",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "3[2-8]\\d{9,10}",
                ,
                ,
                ,
                "33101234501",
                ,
                ,
                [
                    11,
                    12
                ]
            ]
        ],
        VC: [
            ,
            [
                ,
                ,
                "(?:[58]\\d\\d|784|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",
                ,
                ,
                ,
                "7842661234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",
                ,
                ,
                ,
                "7844301234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                "78451[0-2]\\d{4}",
                ,
                ,
                ,
                "7845101234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            "VC",
            1,
            "011",
            "1",
            ,
            ,
            "([2-7]\\d{6})$|1",
            "784$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "784",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        VE: [
            ,
            [
                ,
                ,
                "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",
                ,
                ,
                ,
                "2121234567",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "4(?:1[24-8]|2[246])\\d{7}",
                ,
                ,
                ,
                "4121234567"
            ],
            [
                ,
                ,
                "800\\d{7}",
                ,
                ,
                ,
                "8001234567"
            ],
            [
                ,
                ,
                "90[01]\\d{7}",
                ,
                ,
                ,
                "9001234567"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "VE",
            58,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1",
                    "$CC $1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "501\\d{7}",
                ,
                ,
                ,
                "5010123456",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        VG: [
            ,
            [
                ,
                ,
                "(?:284|[58]\\d\\d|900)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}",
                ,
                ,
                ,
                "2842291234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}",
                ,
                ,
                ,
                "2843001234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "VG",
            1,
            "011",
            "1",
            ,
            ,
            "([2-578]\\d{6})$|1",
            "284$1",
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "284",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        VI: [
            ,
            [
                ,
                ,
                "[58]\\d{9}|(?:34|90)0\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    10
                ],
                [
                    7
                ]
            ],
            [
                ,
                ,
                "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                ,
                ,
                ,
                "3406421234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                ,
                ,
                ,
                "3406421234",
                ,
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
            ],
            [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "VI",
            1,
            "011",
            "1",
            ,
            ,
            "([2-9]\\d{6})$|1",
            "340$1",
            ,
            1,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            "340",
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        VN: [
            ,
            [
                ,
                ,
                "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}",
                ,
                ,
                ,
                "2101234567",
                ,
                ,
                [
                    10
                ]
            ],
            [
                ,
                ,
                "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",
                ,
                ,
                ,
                "912345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "1900\\d{4,6}",
                ,
                ,
                ,
                "1900123456",
                ,
                ,
                [
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "672\\d{6}",
                ,
                ,
                ,
                "672012345",
                ,
                ,
                [
                    9
                ]
            ],
            "VN",
            84,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[17]99"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "69"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    ,
                    1
                ]
            ],
            [
                [
                    ,
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    ,
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    ,
                    1
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    ,
                    1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "[17]99\\d{4}|69\\d{5,6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            [
                ,
                ,
                "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
                ,
                ,
                ,
                "1992000",
                ,
                ,
                [
                    7,
                    8
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        VU: [
            ,
            [
                ,
                ,
                "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    7
                ]
            ],
            [
                ,
                ,
                "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",
                ,
                ,
                ,
                "22123",
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                "(?:[58]\\d|7[0-7])\\d{5}",
                ,
                ,
                ,
                "5912345",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                "81[18]\\d\\d",
                ,
                ,
                ,
                "81123",
                ,
                ,
                [
                    5
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9(?:0[1-9]|1[01])\\d{4}",
                ,
                ,
                ,
                "9010123",
                ,
                ,
                [
                    7
                ]
            ],
            "VU",
            678,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:3[03]|900\\d)\\d{3}",
                ,
                ,
                ,
                "30123"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        WF: [
            ,
            [
                ,
                ,
                "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    6,
                    9
                ]
            ],
            [
                ,
                ,
                "72\\d{4}",
                ,
                ,
                ,
                "721234",
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:72|8[23])\\d{4}",
                ,
                ,
                ,
                "821234",
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "80[0-5]\\d{6}",
                ,
                ,
                ,
                "800012345",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9[23]\\d{4}",
                ,
                ,
                ,
                "921234",
                ,
                ,
                [
                    6
                ]
            ],
            "WF",
            681,
            "00",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[47-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "[48]0\\d{4}",
                ,
                ,
                ,
                "401234",
                ,
                ,
                [
                    6
                ]
            ]
        ],
        WS: [
            ,
            [
                ,
                ,
                "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    7,
                    10
                ]
            ],
            [
                ,
                ,
                "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",
                ,
                ,
                ,
                "22123",
                ,
                ,
                [
                    5,
                    6
                ]
            ],
            [
                ,
                ,
                "(?:7[1-35-8]|8(?:[3-7]|9\\d{3}))\\d{5}",
                ,
                ,
                ,
                "7212345",
                ,
                ,
                [
                    7,
                    10
                ]
            ],
            [
                ,
                ,
                "800\\d{3}",
                ,
                ,
                ,
                "800123",
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "WS",
            685,
            "0",
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        XK: [
            ,
            [
                ,
                ,
                "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                "38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})",
                ,
                ,
                ,
                "28012345"
            ],
            [
                ,
                ,
                "4[3-9]\\d{6}",
                ,
                ,
                ,
                "43201234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "800\\d{5}",
                ,
                ,
                ,
                "80001234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                "900\\d{5}",
                ,
                ,
                ,
                "90001234",
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "XK",
            383,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        YE: [
            ,
            [
                ,
                ,
                "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",
                ,
                ,
                ,
                "1234567",
                ,
                ,
                [
                    7,
                    8
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "7[01378]\\d{7}",
                ,
                ,
                ,
                "712345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "YE",
            967,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        YT: [
            ,
            [
                ,
                ,
                "(?:639\\d|7093)\\d{5}|(?:26|80|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "26(?:89\\d|9(?:0[0-467]|15|5[0-4]|6\\d|[78]0))\\d{4}",
                ,
                ,
                ,
                "269601234"
            ],
            [
                ,
                ,
                "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}",
                ,
                ,
                ,
                "639012345"
            ],
            [
                ,
                ,
                "80\\d{7}",
                ,
                ,
                ,
                "801234567"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "9(?:(?:39|47)8[01]|769\\d)\\d{4}",
                ,
                ,
                ,
                "939801234"
            ],
            "YT",
            262,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        ZA: [
            ,
            [
                ,
                ,
                "[1-79]\\d{8}|8\\d{4,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
                ,
                ,
                ,
                "101234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|[67]\\d\\d)\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
                ,
                ,
                ,
                "711234567",
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9
                ]
            ],
            [
                ,
                ,
                "80\\d{7}",
                ,
                ,
                ,
                "801234567",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "(?:86[2-9]|9[0-2]\\d)\\d{6}",
                ,
                ,
                ,
                "862345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "860\\d{6}",
                ,
                ,
                ,
                "860123456",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
                ,
                ,
                ,
                "871234567",
                ,
                ,
                [
                    9
                ]
            ],
            "ZA",
            27,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "861\\d{6,7}",
                ,
                ,
                ,
                "861123456",
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        ZM: [
            ,
            [
                ,
                ,
                "800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ],
                [
                    6
                ]
            ],
            [
                ,
                ,
                "21[1-8]\\d{6}",
                ,
                ,
                ,
                "211234567",
                ,
                ,
                ,
                [
                    6
                ]
            ],
            [
                ,
                ,
                "(?:[59][5-8]|7[5-9])\\d{7}",
                ,
                ,
                ,
                "955123456"
            ],
            [
                ,
                ,
                "800\\d{6}",
                ,
                ,
                ,
                "800123456"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "63\\d{7}",
                ,
                ,
                ,
                "630123456"
            ],
            "ZM",
            260,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[579]"
                    ],
                    "0$1"
                ]
            ],
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[579]"
                    ],
                    "0$1"
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        ZW: [
            ,
            [
                ,
                ,
                "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    5,
                    6,
                    7,
                    8,
                    9,
                    10
                ],
                [
                    3,
                    4
                ]
            ],
            [
                ,
                ,
                "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
                ,
                ,
                ,
                "1312345",
                ,
                ,
                ,
                [
                    3,
                    4
                ]
            ],
            [
                ,
                ,
                "7(?:[1278]\\d|3[1-9])\\d{6}",
                ,
                ,
                ,
                "712345678",
                ,
                ,
                [
                    9
                ]
            ],
            [
                ,
                ,
                "80(?:[01]\\d|20|8[0-8])\\d{3}",
                ,
                ,
                ,
                "8001234",
                ,
                ,
                [
                    7
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",
                ,
                ,
                ,
                "8686123456",
                ,
                ,
                [
                    10
                ]
            ],
            "ZW",
            263,
            "00",
            "0",
            ,
            ,
            "0",
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    ,
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        800: [
            ,
            [
                ,
                ,
                "(?:00|[1-9]\\d)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:00|[1-9]\\d)\\d{6}",
                ,
                ,
                ,
                "12345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "001",
            800,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            1,
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        808: [
            ,
            [
                ,
                ,
                "[1-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "[1-9]\\d{7}",
                ,
                ,
                ,
                "12345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "001",
            808,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            1,
            [
                [
                    ,
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        870: [
            ,
            [
                ,
                ,
                "7\\d{11}|[235-7]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9,
                    12
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}",
                ,
                ,
                ,
                "301234567"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "2\\d{8}",
                ,
                ,
                ,
                "201234567",
                ,
                ,
                [
                    9
                ]
            ],
            "001",
            870,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        878: [
            ,
            [
                ,
                ,
                "10\\d{10}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    12
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "10\\d{10}",
                ,
                ,
                ,
                "101234567890"
            ],
            "001",
            878,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            1,
            [
                [
                    ,
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        881: [
            ,
            [
                ,
                ,
                "6\\d{9}|[0-36-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9,
                    10
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "6\\d{9}|[0-36-9]\\d{8}",
                ,
                ,
                ,
                "612345678"
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "001",
            881,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    ,
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        882: [
            ,
            [
                ,
                ,
                "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|5(?:0\\d{3}|2[0-2]))\\d{7}",
                ,
                ,
                ,
                "3421234",
                ,
                ,
                [
                    7,
                    8,
                    9,
                    10,
                    12
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}",
                ,
                ,
                ,
                "390123456789"
            ],
            "001",
            882,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            [
                [
                    ,
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|5[12]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    ,
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                "348[57]\\d{7}",
                ,
                ,
                ,
                "34851234567",
                ,
                ,
                [
                    11
                ]
            ]
        ],
        883: [
            ,
            [
                ,
                ,
                "(?:[1-4]\\d|51)\\d{6,10}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    8,
                    9,
                    10,
                    11,
                    12
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
                ,
                ,
                ,
                "510012345"
            ],
            "001",
            883,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            1,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    ,
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        888: [
            ,
            [
                ,
                ,
                "\\d{11}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    11
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "001",
            888,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            1,
            [
                [
                    ,
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "\\d{11}",
                ,
                ,
                ,
                "12345678901"
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ],
        979: [
            ,
            [
                ,
                ,
                "[1359]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    9
                ],
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                "[1359]\\d{8}",
                ,
                ,
                ,
                "123456789",
                ,
                ,
                ,
                [
                    8
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            "001",
            979,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            1,
            [
                [
                    ,
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ],
            ,
            ,
            [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    -1
                ]
            ]
        ]
    };
    function I() {
        this.g = {};
    }
    I.h = void 0;
    I.g = function() {
        return I.h ? I.h : I.h = new I();
    };
    var Fa = {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        "\uFF10": "0",
        "\uFF11": "1",
        "\uFF12": "2",
        "\uFF13": "3",
        "\uFF14": "4",
        "\uFF15": "5",
        "\uFF16": "6",
        "\uFF17": "7",
        "\uFF18": "8",
        "\uFF19": "9",
        "\u0660": "0",
        "\u0661": "1",
        "\u0662": "2",
        "\u0663": "3",
        "\u0664": "4",
        "\u0665": "5",
        "\u0666": "6",
        "\u0667": "7",
        "\u0668": "8",
        "\u0669": "9",
        "\u06F0": "0",
        "\u06F1": "1",
        "\u06F2": "2",
        "\u06F3": "3",
        "\u06F4": "4",
        "\u06F5": "5",
        "\u06F6": "6",
        "\u06F7": "7",
        "\u06F8": "8",
        "\u06F9": "9"
    }, Ga = {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        "+": "+",
        "*": "*",
        "#": "#"
    }, Ha = {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        "\uFF10": "0",
        "\uFF11": "1",
        "\uFF12": "2",
        "\uFF13": "3",
        "\uFF14": "4",
        "\uFF15": "5",
        "\uFF16": "6",
        "\uFF17": "7",
        "\uFF18": "8",
        "\uFF19": "9",
        "\u0660": "0",
        "\u0661": "1",
        "\u0662": "2",
        "\u0663": "3",
        "\u0664": "4",
        "\u0665": "5",
        "\u0666": "6",
        "\u0667": "7",
        "\u0668": "8",
        "\u0669": "9",
        "\u06F0": "0",
        "\u06F1": "1",
        "\u06F2": "2",
        "\u06F3": "3",
        "\u06F4": "4",
        "\u06F5": "5",
        "\u06F6": "6",
        "\u06F7": "7",
        "\u06F8": "8",
        "\u06F9": "9",
        A: "2",
        B: "2",
        C: "2",
        D: "3",
        E: "3",
        F: "3",
        G: "4",
        H: "4",
        I: "4",
        J: "5",
        K: "5",
        L: "5",
        M: "6",
        N: "6",
        O: "6",
        P: "7",
        Q: "7",
        R: "7",
        S: "7",
        T: "8",
        U: "8",
        V: "8",
        W: "9",
        X: "9",
        Y: "9",
        Z: "9"
    }, Ia = RegExp("[+\uFF0B]+"), J = RegExp("^[+\uFF0B]+"), Ja = RegExp("([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9])"), Ka = RegExp("[+\uFF0B0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]"), La = /[\\\/] *x/, Ma = RegExp("[^0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9A-Za-z#]+$"), Na = /(?:.*?[A-Za-z]){3}.*/, Oa = RegExp("^\\+([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]|[\\-\\.\\(\\)]?)*[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]|[\\-\\.\\(\\)]?)*$"), Pa = RegExp("^([A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]+((\\-)*[A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9])*\\.)*[A-Za-z]+((\\-)*[A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9])*\\.?$");
    function K(a) {
        return "([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]{1," + a + "})";
    }
    function Qa() {
        return ";ext=" + K("20") + "|[ \xA0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)[:\\.\uFF0E]?[ \xA0\\t,-]*" + (K("20") + "#?|[ \xA0\\t,]*(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)[:\\.\uFF0E]?[ \xA0\\t,-]*") + (K("9") + "#?|[- ]+") + (K("6") + "#|[ \xA0\\t]*(?:,{2}|;)[:\\.\uFF0E]?[ \xA0\\t,-]*") + (K("15") + "#?|[ \xA0\\t]*(?:,)+[:\\.\uFF0E]?[ \xA0\\t,-]*") + (K("9") + "#?");
    }
    var Ra = new RegExp("(?:" + Qa() + ")$", "i"), Sa = new RegExp("^[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]{2}$|^[+\uFF0B]*(?:[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E*]*[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]){3,}[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E*A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]*(?:" + Qa() + ")?$", "i"), Ta = /(\$\d)/, Ua = /^\(?\$1\)?$/;
    function Va(a) {
        return a.length < 2 ? false : L(Sa, a);
    }
    function Wa(a) {
        return L(Na, a) ? M(a, Ha) : M(a, Fa);
    }
    function Xa(a) {
        var b = Wa(a.toString());
        B(a);
        a.g(b);
    }
    function Ya(a) {
        return a != null && (v(a, 9) != 1 || E(a)[0] != -1);
    }
    function M(a, b) {
        for(var c = new A(), d, e = a.length, f = 0; f < e; ++f)d = a.charAt(f), d = b[d.toUpperCase()], d != null && c.g(d);
        return c.toString();
    }
    function Za(a) {
        return a.length == 0 || Ua.test(a);
    }
    function N(a) {
        return a != null && isNaN(a) && a.toUpperCase() in Ea;
    }
    I.prototype.format = function(a, b) {
        if (q(a, 2) == 0 && p(a, 5)) {
            var c = u(a, 5);
            if (c.length > 0) return c;
        }
        c = u(a, 1);
        var d = O(a);
        if (b == 0) return $a(c, 0, d, "");
        if (!(c in H)) return d;
        var e = P(this, c, Q(c));
        a = p(a, 3) && q(a, 3).length != 0 ? b == 3 ? ";ext=" + q(a, 3) : p(e, 13) ? q(e, 13) + u(a, 3) : " ext. " + u(a, 3) : "";
        a: {
            e = (t(e, 20) || []).length == 0 || b == 2 ? t(e, 19) || [] : t(e, 20) || [];
            for(var f, g = e.length, h = 0; h < g; ++h){
                f = e[h];
                var l = v(f, 3);
                if (l == 0 || d.search(q(f, 3, l - 1)) == 0) {
                    if (l = new RegExp(q(f, 1)), L(l, d)) {
                        e = f;
                        break a;
                    }
                }
            }
            e = null;
        }
        e != null && (g = e, e = u(g, 2), f = new RegExp(q(g, 1)), u(g, 5), g = u(g, 4), d = b == 2 && g != null && g.length > 0 ? d.replace(f, e.replace(Ta, g)) : d.replace(f, e), b == 3 && (d = d.replace(RegExp("^[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]+"), ""), d = d.replace(RegExp("[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]+", "g"), "-")));
        return $a(c, b, d, a);
    };
    function P(a, b, c) {
        return "001" == c ? R(a, "" + b) : R(a, c);
    }
    function O(a) {
        if (!p(a, 2)) return "";
        var b = "" + q(a, 2);
        return p(a, 4) && q(a, 4) && u(a, 8) > 0 ? Array(u(a, 8) + 1).join("0") + b : b;
    }
    function $a(a, b, c, d) {
        switch(b){
            case 0:
                return "+" + a + c + d;
            case 1:
                return "+" + a + " " + c + d;
            case 3:
                return "tel:+" + a + "-" + c + d;
            default:
                return c + d;
        }
    }
    function S(a, b) {
        switch(b){
            case 4:
                return q(a, 5);
            case 3:
                return q(a, 4);
            case 1:
                return q(a, 3);
            case 0:
            case 2:
                return q(a, 2);
            case 5:
                return q(a, 6);
            case 6:
                return q(a, 8);
            case 7:
                return q(a, 7);
            case 8:
                return q(a, 21);
            case 9:
                return q(a, 25);
            case 10:
                return q(a, 28);
            default:
                return q(a, 1);
        }
    }
    function ab(a, b) {
        var c = bb(a, b);
        a = P(a, u(b, 1), c);
        if (a == null) return -1;
        b = O(b);
        return cb(b, a);
    }
    function cb(a, b) {
        return T(a, q(b, 1)) ? T(a, q(b, 5)) ? 4 : T(a, q(b, 4)) ? 3 : T(a, q(b, 6)) ? 5 : T(a, q(b, 8)) ? 6 : T(a, q(b, 7)) ? 7 : T(a, q(b, 21)) ? 8 : T(a, q(b, 25)) ? 9 : T(a, q(b, 28)) ? 10 : T(a, q(b, 2)) ? q(b, 18) || T(a, q(b, 3)) ? 2 : 0 : !q(b, 18) && T(a, q(b, 3)) ? 1 : -1 : -1;
    }
    function R(a, b) {
        if (b == null) return null;
        b = b.toUpperCase();
        var c = a.g[b];
        if (c == null) {
            c = Ea[b];
            if (c == null) return null;
            c = new z().g(F.m(), c);
            a.g[b] = c;
        }
        return c;
    }
    function T(a, b) {
        var c = a.length;
        return v(b, 9) > 0 && E(b).indexOf(c) == -1 ? false : L(u(b, 2), a);
    }
    function db(a, b) {
        var c = bb(a, b);
        var d = u(b, 1);
        var e = P(a, d, c);
        e == null || "001" != c && d != eb(a, c) ? e = false : (a = O(b), e = cb(a, e) != -1);
        return e;
    }
    function bb(a, b) {
        if (b == null) return null;
        var c = u(b, 1);
        c = H[c];
        if (c == null) a = null;
        else if (c.length == 1) a = c[0];
        else a: {
            b = O(b);
            for(var d, e = c.length, f = 0; f < e; f++){
                d = c[f];
                var g = R(a, d);
                if (p(g, 23)) {
                    if (b.search(q(g, 23)) == 0) {
                        a = d;
                        break a;
                    }
                } else if (cb(b, g) != -1) {
                    a = d;
                    break a;
                }
            }
            a = null;
        }
        return a;
    }
    function Q(a) {
        a = H[a];
        return a == null ? "ZZ" : a[0];
    }
    function eb(a, b) {
        a = R(a, b);
        if (a == null) throw Error("Invalid region code: " + b);
        return u(a, 10);
    }
    function U(a, b, c, d) {
        var e = S(c, d), f = v(e, 9) == 0 ? E(q(c, 1)) : E(e);
        e = t(e, 10) || [];
        if (d == 2) {
            if (Ya(S(c, 0))) a = S(c, 1), Ya(a) && (f = f.concat(v(a, 9) == 0 ? E(q(c, 1)) : E(a)), f.sort(), e.length == 0 ? e = t(a, 10) || [] : (e = e.concat(t(a, 10) || []), e.sort()));
            else return U(a, b, c, 1);
        }
        if (f[0] == -1) return 5;
        b = b.length;
        if (e.indexOf(b) > -1) return 4;
        c = f[0];
        return c == b ? 0 : c > b ? 2 : f[f.length - 1] < b ? 3 : f.indexOf(b, 1) > -1 ? 0 : 5;
    }
    function V(a, b, c) {
        var d = O(b);
        b = u(b, 1);
        if (!(b in H)) return 1;
        b = P(a, b, Q(b));
        return U(a, d, b, c);
    }
    function fb(a, b) {
        a = a.toString();
        if (a.length == 0 || a.charAt(0) == "0") return 0;
        for(var c, d = a.length, e = 1; e <= 3 && e <= d; ++e)if (c = parseInt(a.substring(0, e), 10), c in H) return b.g(a.substring(e)), c;
        return 0;
    }
    function gb(a, b, c, d, e, f) {
        if (b.length == 0) return 0;
        b = new A(b);
        var g;
        c != null && (g = q(c, 11));
        g == null && (g = "NonMatch");
        var h = b.toString();
        if (h.length == 0) g = 20;
        else if (J.test(h)) h = h.replace(J, ""), B(b), b.g(Wa(h)), g = 1;
        else {
            h = new RegExp(g);
            Xa(b);
            g = b.toString();
            if (g.search(h) == 0) {
                h = g.match(h)[0].length;
                var l = g.substring(h).match(Ja);
                l && l[1] != null && l[1].length > 0 && M(l[1], Fa) == "0" ? g = false : (B(b), b.g(g.substring(h)), g = true);
            } else g = false;
            g = g ? 5 : 20;
        }
        e && r(f, 6, g);
        if (g != 20) {
            if (b.h.length <= 2) throw Error("Phone number too short after IDD");
            a = fb(b, d);
            if (a != 0) return r(f, 1, a), a;
            throw Error("Invalid country calling code");
        }
        if (c != null && (g = u(c, 10), h = "" + g, l = b.toString(), l.lastIndexOf(h, 0) == 0 && (h = new A(l.substring(h.length)), l = q(c, 1), l = new RegExp(u(l, 2)), hb(h, c, null), h = h.toString(), !L(l, b.toString()) && L(l, h) || U(a, b.toString(), c, -1) == 3))) return d.g(h), e && r(f, 6, 10), r(f, 1, g), g;
        r(f, 1, 0);
        return 0;
    }
    function hb(a, b, c) {
        var d = a.toString(), e = d.length, f = q(b, 15);
        if (e != 0 && f != null && f.length != 0 && (f = new RegExp("^(?:" + f + ")"), e = f.exec(d))) {
            var g = RegExp;
            var h = q(b, 1);
            h = u(h, 2);
            g = new g(h);
            h = L(g, d);
            var l = e.length - 1;
            b = q(b, 16);
            if (b == null || b.length == 0 || e[l] == null || e[l].length == 0) {
                if (!h || L(g, d.substring(e[0].length))) c != null && l > 0 && e[l] != null && c.g(e[1]), a.set(d.substring(e[0].length));
            } else if (d = d.replace(f, b), !h || L(g, d)) c != null && l > 0 && c.g(e[1]), a.set(d);
        }
    }
    function W(a, b, c) {
        if (!N(c) && b.length > 0 && b.charAt(0) != "+") throw Error("Invalid country calling code");
        return ib(a, b, c, true);
    }
    function ib(a, b, c, d) {
        if (b == null) throw Error("The string supplied did not seem to be a phone number");
        if (b.length > 250) throw Error("The string supplied is too long to be a phone number");
        var e = new A();
        var f = b.indexOf(";phone-context=");
        if (f === -1) f = null;
        else if (f += 15, f >= b.length) f = "";
        else {
            var g = b.indexOf(";", f);
            f = g !== -1 ? b.substring(f, g) : b.substring(f);
        }
        var h = f;
        h == null ? g = true : h.length === 0 ? g = false : (g = Oa.exec(h), h = Pa.exec(h), g = g !== null || h !== null);
        if (!g) throw Error("The string supplied did not seem to be a phone number");
        f != null ? (f.charAt(0) === "+" && e.g(f), f = b.indexOf("tel:"), e.g(b.substring(f >= 0 ? f + 4 : 0, b.indexOf(";phone-context=")))) : (f = e.g, g = b ?? "", h = g.search(Ka), h >= 0 ? (g = g.substring(h), g = g.replace(Ma, ""), h = g.search(La), h >= 0 && (g = g.substring(0, h))) : g = "", f.call(e, g));
        f = e.toString();
        g = f.indexOf(";isub=");
        g > 0 && (B(e), e.g(f.substring(0, g)));
        if (!Va(e.toString())) throw Error("The string supplied did not seem to be a phone number");
        f = e.toString();
        if (!(N(c) || f != null && f.length > 0 && J.test(f))) throw Error("Invalid country calling code");
        f = new G();
        d && r(f, 5, b);
        a: {
            b = e.toString();
            g = b.search(Ra);
            if (g >= 0 && Va(b.substring(0, g))) {
                h = b.match(Ra);
                for(var l = h.length, y = 1; y < l; ++y)if (h[y] != null && h[y].length > 0) {
                    B(e);
                    e.g(b.substring(0, g));
                    b = h[y];
                    break a;
                }
            }
            b = "";
        }
        b.length > 0 && r(f, 3, b);
        g = R(a, c);
        b = new A();
        h = 0;
        l = e.toString();
        try {
            h = gb(a, l, g, b, d, f);
        } catch (Y) {
            if (Y.message == "Invalid country calling code" && J.test(l)) {
                if (l = l.replace(J, ""), h = gb(a, l, g, b, d, f), h == 0) throw Y;
            } else throw Y;
        }
        h != 0 ? (e = Q(h), e != c && (g = P(a, h, e))) : (Xa(e), b.g(e.toString()), c != null ? (h = u(g, 10), r(f, 1, h)) : d && (delete f.h[6], f.g && delete f.g[6]));
        if (b.h.length < 2) throw Error("The string supplied is too short to be a phone number");
        g != null && (c = new A(), e = new A(b.toString()), hb(e, g, c), a = U(a, e.toString(), g, -1), a != 2 && a != 4 && a != 5 && (b = e, d && c.toString().length > 0 && r(f, 7, c.toString())));
        d = b.toString();
        a = d.length;
        if (a < 2) throw Error("The string supplied is too short to be a phone number");
        if (a > 17) throw Error("The string supplied is too long to be a phone number");
        if (d.length > 1 && d.charAt(0) == "0") {
            r(f, 4, true);
            for(a = 1; a < d.length - 1 && d.charAt(a) == "0";)a++;
            a != 1 && r(f, 8, a);
        }
        r(f, 2, parseInt(d, 10));
        return f;
    }
    function L(a, b) {
        return (a = b.match(new RegExp("^(?:" + (typeof a == "string" ? a : a.source) + ")$", "i"))) && a[0].length == b.length ? true : false;
    }
    function jb(a) {
        this.ga = RegExp("\u2008");
        this.ka = "";
        this.$ = new A();
        this.ea = "";
        this.u = new A();
        this.da = new A();
        this.v = true;
        this.fa = this.aa = this.ma = false;
        this.ha = I.g();
        this.ba = 0;
        this.h = new A();
        this.ia = false;
        this.o = "";
        this.g = new A();
        this.j = [];
        this.la = a;
        this.l = kb(this, this.la);
    }
    var lb = new F();
    r(lb, 11, "NA");
    var mb = RegExp("^[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*\\$1[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*(\\$\\d[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*)*$"), nb = /[- ]/;
    function kb(a, b) {
        var c = a.ha;
        b = N(b) ? eb(c, b) : 0;
        a = R(a.ha, Q(b));
        return a != null ? a : lb;
    }
    function ob(a) {
        for(var b = a.j.length, c = 0; c < b; ++c){
            var d = a.j[c], e = u(d, 1);
            if (a.ea == e) return false;
            var f = a;
            var g = d, h = u(g, 1);
            B(f.$);
            var l = f;
            g = u(g, 2);
            var y = "999999999999999".match(h)[0];
            y.length < l.g.h.length ? l = "" : (l = y.replace(new RegExp(h, "g"), g), l = l.replace(RegExp("9", "g"), "\u2008"));
            l.length > 0 ? (f.$.g(l), f = true) : f = false;
            if (f) return a.ea = e, a.ia = nb.test(q(d, 4)), a.ba = 0, true;
        }
        return a.v = false;
    }
    function pb(a, b) {
        for(var c = [], d = b.length - 3, e = a.j.length, f = 0; f < e; ++f){
            var g = a.j[f];
            v(g, 3) == 0 ? c.push(a.j[f]) : (g = q(g, 3, Math.min(d, v(g, 3) - 1)), b.search(g) == 0 && c.push(a.j[f]));
        }
        a.j = c;
    }
    function qb(a, b) {
        a.u.g(b);
        var c = b;
        Ja.test(c) || a.u.h.length == 1 && Ia.test(c) ? (b == "+" ? (c = b, a.da.g(b)) : (c = Fa[b], a.da.g(c), a.g.g(c)), b = c) : (a.v = false, a.ma = true);
        if (!a.v) {
            if (!a.ma) {
                if (rb(a)) {
                    if (sb(a)) return tb(a);
                } else if (a.o.length > 0 && (b = a.g.toString(), B(a.g), a.g.g(a.o), a.g.g(b), b = a.h.toString(), c = b.lastIndexOf(a.o), B(a.h), a.h.g(b.substring(0, c))), a.o != ub(a)) return a.h.g(" "), tb(a);
            }
            return a.u.toString();
        }
        switch(a.da.h.length){
            case 0:
            case 1:
            case 2:
                return a.u.toString();
            case 3:
                if (rb(a)) a.fa = true;
                else return a.o = ub(a), vb(a);
            default:
                if (a.fa) return sb(a) && (a.fa = false), a.h.toString() + a.g.toString();
                if (a.j.length > 0) {
                    b = wb(a, b);
                    c = xb(a);
                    if (c.length > 0) return c;
                    pb(a, a.g.toString());
                    return ob(a) ? yb(a) : a.v ? X(a, b) : a.u.toString();
                }
                return vb(a);
        }
    }
    function tb(a) {
        a.v = true;
        a.fa = false;
        a.j = [];
        a.ba = 0;
        B(a.$);
        a.ea = "";
        return vb(a);
    }
    function xb(a) {
        for(var b = a.g.toString(), c = a.j.length, d = 0; d < c; ++d){
            var e = a.j[d], f = u(e, 1);
            if (new RegExp("^(?:" + f + ")$").test(b) && (a.ia = nb.test(q(e, 4)), e = b.replace(new RegExp(f, "g"), q(e, 2)), e = X(a, e), M(e, Ga) == a.da)) return e;
        }
        return "";
    }
    function X(a, b) {
        var c = a.h.h.length;
        return a.ia && c > 0 && a.h.toString().charAt(c - 1) != " " ? a.h + " " + b : a.h + b;
    }
    function vb(a) {
        var b = a.g.toString();
        if (b.length >= 3) {
            for(var c = a.aa && a.o.length == 0 && v(a.l, 20) > 0 ? t(a.l, 20) || [] : t(a.l, 19) || [], d = c.length, e = 0; e < d; ++e){
                var f = c[e];
                a.o.length > 0 && Za(u(f, 4)) && !q(f, 6) && !p(f, 5) || (a.o.length != 0 || a.aa || Za(u(f, 4)) || q(f, 6)) && mb.test(u(f, 2)) && a.j.push(f);
            }
            pb(a, b);
            b = xb(a);
            return b.length > 0 ? b : ob(a) ? yb(a) : a.u.toString();
        }
        return X(a, b);
    }
    function yb(a) {
        var b = a.g.toString(), c = b.length;
        if (c > 0) {
            for(var d = "", e = 0; e < c; e++)d = wb(a, b.charAt(e));
            return a.v ? X(a, d) : a.u.toString();
        }
        return a.h.toString();
    }
    function ub(a) {
        var b = a.g.toString(), c = 0;
        if (q(a.l, 10) != 1) var d = false;
        else d = a.g.toString(), d = d.charAt(0) == "1" && d.charAt(1) != "0" && d.charAt(1) != "1";
        d ? (c = 1, a.h.g("1").g(" "), a.aa = true) : p(a.l, 15) && (d = new RegExp("^(?:" + q(a.l, 15) + ")"), d = b.match(d), d != null && d[0] != null && d[0].length > 0 && (a.aa = true, c = d[0].length, a.h.g(b.substring(0, c))));
        B(a.g);
        a.g.g(b.substring(c));
        return b.substring(0, c);
    }
    function rb(a) {
        var b = a.da.toString(), c = new RegExp("^(?:\\+|" + q(a.l, 11) + ")");
        c = b.match(c);
        return c != null && c[0] != null && c[0].length > 0 ? (a.aa = true, c = c[0].length, B(a.g), a.g.g(b.substring(c)), B(a.h), a.h.g(b.substring(0, c)), b.charAt(0) != "+" && a.h.g(" "), true) : false;
    }
    function sb(a) {
        if (a.g.h.length == 0) return false;
        var b = new A(), c = fb(a.g, b);
        if (c == 0) return false;
        B(a.g);
        a.g.g(b.toString());
        b = Q(c);
        "001" == b ? a.l = R(a.ha, "" + c) : b != a.la && (a.l = kb(a, b));
        a.h.g("" + c).g(" ");
        a.o = "";
        return true;
    }
    function wb(a, b) {
        var c = a.$.toString();
        if (c.substring(a.ba).search(a.ga) >= 0) {
            var d = c.search(a.ga);
            b = c.replace(a.ga, b);
            B(a.$);
            a.$.g(b);
            a.ba = d;
            return b.substring(0, a.ba + 1);
        }
        a.j.length == 1 && (a.v = false);
        a.ea = "";
        return a.u.toString();
    }
    const zb = {};
    [
        "E164",
        "INTERNATIONAL",
        "NATIONAL",
        "RFC3966"
    ].forEach((a, b)=>{
        zb[a] = b;
    });
    const Z = {};
    "FIXED_LINE MOBILE FIXED_LINE_OR_MOBILE TOLL_FREE PREMIUM_RATE SHARED_COST VOIP PERSONAL_NUMBER PAGER UAN VOICEMAIL UNKNOWN".split(" ").forEach((a, b)=>{
        Z[a] = b;
    });
    Z.UNKNOWN = -1;
    const Ab = {};
    "IS_POSSIBLE INVALID_COUNTRY_CODE TOO_SHORT TOO_LONG IS_POSSIBLE_LOCAL_ONLY INVALID_LENGTH".split(" ").forEach((a, b)=>{
        Ab[a] = b;
    });
    const Bb = {};
    Object.keys(Z).forEach((a)=>{
        Bb[Z[a]] = a;
    });
    const Cb = {};
    Object.keys(Ab).forEach((a)=>{
        Cb[Ab[a]] = a;
    });
    const Db = (a)=>{
        const b = [];
        a.includes("FIXED_LINE_OR_MOBILE") ? (a.includes("MOBILE") || b.push("MOBILE"), a.includes("FIXED_LINE") || b.push("FIXED_LINE")) : (a.includes("MOBILE") || a.includes("FIXED_LINE")) && b.push("FIXED_LINE_OR_MOBILE");
        return a.concat(b);
    };
    k("utils", {});
    k("utils.formatNumberAsYouType", (a, b)=>{
        try {
            const c = a.replace(/[^+0-9]/g, ""), d = new jb(b);
            b = "";
            for(let e = 0; e < c.length; e++)d.ka = qb(d, c.charAt(e)), b = d.ka;
            return b;
        } catch  {
            return a;
        }
    });
    k("utils.formatNumber", (a, b, c)=>{
        try {
            const e = I.g(), f = W(e, a, b);
            var d = V(e, f, -1);
            return d == 0 || d == 4 ? e.format(f, typeof c === "undefined" ? 0 : zb[c]) : a;
        } catch  {
            return a;
        }
    });
    k("utils.getExampleNumber", (a, b, c, d)=>{
        try {
            const y = I.g();
            a: {
                var e = y, f = Z[c];
                if (N(a)) {
                    var g = S(R(e, a), f);
                    try {
                        if (p(g, 6)) {
                            var h = q(g, 6);
                            var l = ib(e, h, a, false);
                            break a;
                        }
                    } catch (Y) {}
                }
                l = null;
            }
            return y.format(l, d ? 0 : b ? 2 : 1);
        } catch  {
            return "";
        }
    });
    k("utils.getExtension", (a, b)=>{
        try {
            var c = W(I.g(), a, b);
            return q(c, 3);
        } catch  {
            return "";
        }
    });
    k("utils.getNumberType", (a, b)=>{
        try {
            const c = I.g(), d = W(c, a, b), e = ab(c, d);
            return Bb[e] || null;
        } catch  {
            return null;
        }
    });
    k("utils.getValidationError", (a, b)=>{
        if (!b) return "INVALID_COUNTRY_CODE";
        try {
            const c = I.g(), d = W(c, a, b), e = V(c, d, -1);
            return Cb[e] || null;
        } catch (c) {
            return c.message === "Invalid country calling code" ? "INVALID_COUNTRY_CODE" : a.length <= 3 || c.message === "Phone number too short after IDD" || c.message === "The string supplied is too short to be a phone number" ? "TOO_SHORT" : c.message === "The string supplied is too long to be a phone number" ? "TOO_LONG" : null;
        }
    });
    k("utils.isValidNumber", (a, b, c)=>{
        try {
            const d = I.g(), e = W(d, a, b), f = db(d, e);
            if (c) {
                const g = Db(c).map((h)=>Z[h]);
                return f && g.includes(ab(d, e));
            }
            return f;
        } catch  {
            return false;
        }
    });
    k("utils.isPossibleNumber", (a, b, c)=>{
        try {
            const d = I.g(), e = W(d, a, b);
            if (c) {
                const f = Db(c);
                for (let g of f)if (V(d, e, Z[g]) === 0) return true;
                return false;
            }
            return V(d, e, -1) === 0;
        } catch  {
            return false;
        }
    });
    k("utils.getCoreNumber", (a, b)=>{
        try {
            var c = W(I.g(), a, b);
            return q(c, 2).toString();
        } catch  {
            return "";
        }
    });
}).call($1b5b6cd373c57766$var$_scope);
var $1b5b6cd373c57766$var$utils_default = $1b5b6cd373c57766$var$_scope.utils;
// packages/core/src/js/intlTelInputWithUtils.ts
$1b5b6cd373c57766$var$intlTelInput_default.utils = $1b5b6cd373c57766$var$utils_default;
var $1b5b6cd373c57766$export$2e2bcd8739ae039 = $1b5b6cd373c57766$var$intlTelInput_default;



var $f9a5709ac8e3ae1d$exports = {};
$f9a5709ac8e3ae1d$exports = import.meta.resolve("g2c3Q");


var $422f0f77c9159763$exports = {};
$422f0f77c9159763$exports = import.meta.resolve("hlLTh");


document.documentElement.style.setProperty('--iti-path-flags-1x', `url(${(0, (/*@__PURE__*/$parcel$interopDefault($f9a5709ac8e3ae1d$exports)))})`);
document.documentElement.style.setProperty('--iti-path-flags-2x', `url(${(0, (/*@__PURE__*/$parcel$interopDefault($422f0f77c9159763$exports)))})`);
function $7c8d851372c266f6$export$4ff15454b4105eeb(elementId) {
    const el = document.getElementById(elementId);
    if (!el) return null;
    const iti = (0, $1b5b6cd373c57766$export$2e2bcd8739ae039)(el, {
        initialCountry: 'us',
        separateDialCode: true,
        countrySearch: true,
        formatOnDisplay: true,
        dropdownContainer: document.body
    });
    // CSS alone can lose the z-index race against Parcel's style injection order,
    // so also force it inline whenever the dropdown opens.
    el.addEventListener('open:countrydropdown', ()=>{
        const container = document.querySelector('.iti--container');
        if (container) container.style.setProperty('z-index', '10000', 'important');
    });
    return iti;
}


// Static tax-rate lookup used to auto-suggest a sales-tax / VAT receipt adjustment
// during onboarding. This is intentionally a baked-in table (no external API): it
// gets the business to an approximately-correct rate at zero cost, and the owner
// confirms it and can edit or remove it anytime in Settings.
//
// IMPORTANT - these are SUGGESTIONS, not tax advice:
//  - US values are the STATE BASE rate only. They do NOT include county/city
//    add-ons, so the real combined rate a business owes is often higher. The
//    owner is expected to adjust it. (A future version may integrate a ZIP-level
//    tax API for the exact combined rate.)
//  - Country values are the standard national VAT/GST rate. Reduced/zero-rated
//    categories and surcharges are not modelled.
//  - Rates change. Review periodically.
// 50 states + DC, for the constrained Province/State dropdown shown when Country = US.
const $0dd9374d56731bb4$export$e322f0dbe1d2219b = [
    {
        code: 'AL',
        name: 'Alabama'
    },
    {
        code: 'AK',
        name: 'Alaska'
    },
    {
        code: 'AZ',
        name: 'Arizona'
    },
    {
        code: 'AR',
        name: 'Arkansas'
    },
    {
        code: 'CA',
        name: 'California'
    },
    {
        code: 'CO',
        name: 'Colorado'
    },
    {
        code: 'CT',
        name: 'Connecticut'
    },
    {
        code: 'DE',
        name: 'Delaware'
    },
    {
        code: 'DC',
        name: 'District of Columbia'
    },
    {
        code: 'FL',
        name: 'Florida'
    },
    {
        code: 'GA',
        name: 'Georgia'
    },
    {
        code: 'HI',
        name: 'Hawaii'
    },
    {
        code: 'ID',
        name: 'Idaho'
    },
    {
        code: 'IL',
        name: 'Illinois'
    },
    {
        code: 'IN',
        name: 'Indiana'
    },
    {
        code: 'IA',
        name: 'Iowa'
    },
    {
        code: 'KS',
        name: 'Kansas'
    },
    {
        code: 'KY',
        name: 'Kentucky'
    },
    {
        code: 'LA',
        name: 'Louisiana'
    },
    {
        code: 'ME',
        name: 'Maine'
    },
    {
        code: 'MD',
        name: 'Maryland'
    },
    {
        code: 'MA',
        name: 'Massachusetts'
    },
    {
        code: 'MI',
        name: 'Michigan'
    },
    {
        code: 'MN',
        name: 'Minnesota'
    },
    {
        code: 'MS',
        name: 'Mississippi'
    },
    {
        code: 'MO',
        name: 'Missouri'
    },
    {
        code: 'MT',
        name: 'Montana'
    },
    {
        code: 'NE',
        name: 'Nebraska'
    },
    {
        code: 'NV',
        name: 'Nevada'
    },
    {
        code: 'NH',
        name: 'New Hampshire'
    },
    {
        code: 'NJ',
        name: 'New Jersey'
    },
    {
        code: 'NM',
        name: 'New Mexico'
    },
    {
        code: 'NY',
        name: 'New York'
    },
    {
        code: 'NC',
        name: 'North Carolina'
    },
    {
        code: 'ND',
        name: 'North Dakota'
    },
    {
        code: 'OH',
        name: 'Ohio'
    },
    {
        code: 'OK',
        name: 'Oklahoma'
    },
    {
        code: 'OR',
        name: 'Oregon'
    },
    {
        code: 'PA',
        name: 'Pennsylvania'
    },
    {
        code: 'RI',
        name: 'Rhode Island'
    },
    {
        code: 'SC',
        name: 'South Carolina'
    },
    {
        code: 'SD',
        name: 'South Dakota'
    },
    {
        code: 'TN',
        name: 'Tennessee'
    },
    {
        code: 'TX',
        name: 'Texas'
    },
    {
        code: 'UT',
        name: 'Utah'
    },
    {
        code: 'VT',
        name: 'Vermont'
    },
    {
        code: 'VA',
        name: 'Virginia'
    },
    {
        code: 'WA',
        name: 'Washington'
    },
    {
        code: 'WV',
        name: 'West Virginia'
    },
    {
        code: 'WI',
        name: 'Wisconsin'
    },
    {
        code: 'WY',
        name: 'Wyoming'
    }
];
const $0dd9374d56731bb4$export$ee672b8907403be4 = [
    {
        code: 'AB',
        name: 'Alberta'
    },
    {
        code: 'BC',
        name: 'British Columbia'
    },
    {
        code: 'MB',
        name: 'Manitoba'
    },
    {
        code: 'NB',
        name: 'New Brunswick'
    },
    {
        code: 'NL',
        name: 'Newfoundland and Labrador'
    },
    {
        code: 'NS',
        name: 'Nova Scotia'
    },
    {
        code: 'NT',
        name: 'Northwest Territories'
    },
    {
        code: 'NU',
        name: 'Nunavut'
    },
    {
        code: 'ON',
        name: 'Ontario'
    },
    {
        code: 'PE',
        name: 'Prince Edward Island'
    },
    {
        code: 'QC',
        name: 'Quebec'
    },
    {
        code: 'SK',
        name: 'Saskatchewan'
    },
    {
        code: 'YT',
        name: 'Yukon'
    }
];
// US state base sales-tax rate (%). The five "NOMAD" states with no statewide
// sales tax (AK, DE, MT, NH, OR) are 0 -> no suggestion is offered for them.
const $0dd9374d56731bb4$var$US_STATE_TAX = {
    AL: 4.0,
    AK: 0,
    AZ: 5.6,
    AR: 6.5,
    CA: 7.25,
    CO: 2.9,
    CT: 6.35,
    DE: 0,
    DC: 6.0,
    FL: 6.0,
    GA: 4.0,
    HI: 4.0,
    ID: 6.0,
    IL: 6.25,
    IN: 7.0,
    IA: 6.0,
    KS: 6.5,
    KY: 6.0,
    LA: 5.0,
    ME: 5.5,
    MD: 6.0,
    MA: 6.25,
    MI: 6.0,
    MN: 6.875,
    MS: 7.0,
    MO: 4.225,
    MT: 0,
    NE: 5.5,
    NV: 6.85,
    NH: 0,
    NJ: 6.625,
    NM: 4.875,
    NY: 4.0,
    NC: 4.75,
    ND: 5.0,
    OH: 5.75,
    OK: 4.5,
    OR: 0,
    PA: 6.0,
    RI: 7.0,
    SC: 6.0,
    SD: 4.2,
    TN: 7.0,
    TX: 6.25,
    UT: 6.1,
    VT: 6.0,
    VA: 5.3,
    WA: 6.5,
    WV: 6.0,
    WI: 5.0,
    WY: 4.0
};
// Canadian combined sales-tax rate (%) by province/territory: GST (or HST) plus any
// provincial portion (PST/QST). These are the standard combined rates as a single
// receipt line. Alberta + the territories are GST-only (5%).
const $0dd9374d56731bb4$var$CA_PROVINCE_TAX = {
    AB: 5.0,
    BC: 12.0,
    MB: 12.0,
    NB: 15.0,
    NL: 15.0,
    NS: 14.0,
    NT: 5.0,
    NU: 5.0,
    ON: 13.0,
    PE: 15.0,
    QC: 14.975,
    SK: 11.0,
    YT: 5.0
};
// Countries whose tax rate varies by sub-region -> onboarding shows a constrained
// region dropdown and getTaxSuggestion drills into the region. Everything else uses
// the single national rate in COUNTRY_TAX below.
const $0dd9374d56731bb4$var$SUBREGION_COUNTRIES = {
    US: {
        regions: $0dd9374d56731bb4$export$e322f0dbe1d2219b,
        rates: $0dd9374d56731bb4$var$US_STATE_TAX,
        noun: 'sales tax'
    },
    CA: {
        regions: $0dd9374d56731bb4$export$ee672b8907403be4,
        rates: $0dd9374d56731bb4$var$CA_PROVINCE_TAX,
        noun: 'sales tax'
    }
};
// National VAT/GST standard rate by country (matches the onboarding country list).
// `label` is the local tax name and is used both for the adjustment name and the
// confirmation copy. Countries we don't have a clean single rate for (e.g. Brazil)
// and zero-VAT places (Hong Kong) are omitted -> no suggestion.
const $0dd9374d56731bb4$var$COUNTRY_TAX = {
    GB: {
        rate: 20.0,
        label: 'VAT'
    },
    AU: {
        rate: 10.0,
        label: 'GST'
    },
    NZ: {
        rate: 15.0,
        label: 'GST'
    },
    PH: {
        rate: 12.0,
        label: 'VAT'
    },
    SG: {
        rate: 9.0,
        label: 'GST'
    },
    MY: {
        rate: 6.0,
        label: 'SST'
    },
    ID: {
        rate: 11.0,
        label: 'VAT'
    },
    TH: {
        rate: 7.0,
        label: 'VAT'
    },
    VN: {
        rate: 10.0,
        label: 'VAT'
    },
    IN: {
        rate: 18.0,
        label: 'GST'
    },
    JP: {
        rate: 10.0,
        label: 'Consumption Tax'
    },
    KR: {
        rate: 10.0,
        label: 'VAT'
    },
    CN: {
        rate: 13.0,
        label: 'VAT'
    },
    TW: {
        rate: 5.0,
        label: 'VAT'
    },
    AE: {
        rate: 5.0,
        label: 'VAT'
    },
    SA: {
        rate: 15.0,
        label: 'VAT'
    },
    NG: {
        rate: 7.5,
        label: 'VAT'
    },
    GH: {
        rate: 15.0,
        label: 'VAT'
    },
    KE: {
        rate: 16.0,
        label: 'VAT'
    },
    ZA: {
        rate: 15.0,
        label: 'VAT'
    },
    MX: {
        rate: 16.0,
        label: 'IVA'
    },
    AR: {
        rate: 21.0,
        label: 'IVA'
    },
    CO: {
        rate: 19.0,
        label: 'IVA'
    },
    DE: {
        rate: 19.0,
        label: 'VAT'
    },
    FR: {
        rate: 20.0,
        label: 'VAT'
    },
    ES: {
        rate: 21.0,
        label: 'VAT'
    },
    IT: {
        rate: 22.0,
        label: 'VAT'
    },
    NL: {
        rate: 21.0,
        label: 'VAT'
    },
    SE: {
        rate: 25.0,
        label: 'VAT'
    },
    NO: {
        rate: 25.0,
        label: 'VAT'
    },
    DK: {
        rate: 25.0,
        label: 'VAT'
    }
};
const $0dd9374d56731bb4$export$f92ef939dc69d13b = function(country) {
    const cc = String(country ?? '').toUpperCase();
    return $0dd9374d56731bb4$var$SUBREGION_COUNTRIES[cc]?.regions ?? null;
};
// Resolve a region value (code OR full name) to its code within a region list.
const $0dd9374d56731bb4$var$_resolveRegionCode = function(regions, value) {
    if (!value) return null;
    const v = String(value).trim();
    const upper = v.toUpperCase();
    if (regions.some((r)=>r.code === upper)) return upper; // already a code
    const match = regions.find((r)=>r.name.toLowerCase() === v.toLowerCase());
    return match ? match.code : null;
};
const $0dd9374d56731bb4$export$5fe3d459d71f1719 = function({ country: country, province: province } = {}) {
    if (!country) return null;
    const cc = String(country).toUpperCase();
    const sub = $0dd9374d56731bb4$var$SUBREGION_COUNTRIES[cc];
    if (sub) {
        const code = $0dd9374d56731bb4$var$_resolveRegionCode(sub.regions, province);
        const regionName = sub.regions.find((r)=>r.code === code)?.name;
        if (code && !sub.rates[code]) return {
            mode: 'none',
            label: `Recommended for ${regionName}`
        };
        return {
            mode: 'exclusive',
            label: regionName ? `Recommended for ${regionName}` : 'Recommended'
        };
    }
    if ($0dd9374d56731bb4$var$COUNTRY_TAX[cc]?.rate) return {
        mode: 'inclusive',
        label: 'Recommended'
    };
    return null;
};
const $0dd9374d56731bb4$export$2956ce99ebefe226 = function({ country: country, province: province } = {}) {
    if (!country) return null;
    const cc = String(country).toUpperCase();
    // Countries that vary by sub-region (US states, CA provinces) drill into the region.
    const sub = $0dd9374d56731bb4$var$SUBREGION_COUNTRIES[cc];
    if (sub) {
        const code = $0dd9374d56731bb4$var$_resolveRegionCode(sub.regions, province);
        if (!code) return null;
        const rate = sub.rates[code];
        if (!rate) return null; // 0% / no sub-region tax
        const regionName = sub.regions.find((r)=>r.code === code)?.name ?? code;
        return {
            name: 'Sales Tax',
            label: `${regionName} ${sub.noun}`,
            rate: rate
        };
    }
    const entry = $0dd9374d56731bb4$var$COUNTRY_TAX[cc];
    if (!entry || !entry.rate) return null;
    return {
        name: entry.label,
        label: entry.label,
        rate: entry.rate
    };
};





var $cnCXJ = parcelRequire("cnCXJ");

// Day whose booking hours "Use X's hours every open day" copies: Monday if
// it's open, else the next open day of the week (Sunday last).
const $6e66866c6dedb838$var$copyFrom = (r)=>[
        1,
        2,
        3,
        4,
        5,
        6,
        0
    ].find((i)=>r.hours[i].on) ?? 1;
const $6e66866c6dedb838$var$DEFAULT_RECEIPT_FOOTER = "Thank you for your purchase!";
const $6e66866c6dedb838$var$RECEIPT_QR_HINT = "Don't want a QR code? Just leave this empty. Otherwise paste a link to your review page, feedback form or Instagram (starting with https://).";
// ── US timezone whitelist (IANA IDs) ─────────────────────────────────────────
// Used to filter Intl.supportedValuesOf('timeZone') down to US-relevant entries.
// Intl generates all display labels + live offsets at runtime — no hardcoded strings.
const $6e66866c6dedb838$var$US_TZ_IDS = new Set([
    'Pacific/Pago_Pago',
    'Pacific/Honolulu',
    'America/Adak',
    'America/Anchorage',
    'America/Juneau',
    'America/Sitka',
    'America/Metlakatla',
    'America/Nome',
    'America/Yakutat',
    'America/Los_Angeles',
    'America/Phoenix',
    'America/Denver',
    'America/Boise',
    'America/Chicago',
    'America/Menominee',
    'America/Indiana/Knox',
    'America/Indiana/Tell_City',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/North_Dakota/Beulah',
    'America/New_York',
    'America/Detroit',
    'America/Indiana/Indianapolis',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Vevay',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/Puerto_Rico',
    'America/St_Thomas',
    'Pacific/Guam',
    'Pacific/Saipan'
]);
function $6e66866c6dedb838$var$_buildTzOptions(selectedTz) {
    const now = new Date();
    // Pull every timezone the browser's IANA database knows, keep only US ones.
    // Falls back to the Set itself if supportedValuesOf isn't available (older browsers).
    const allTz = typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone').filter((tz)=>$6e66866c6dedb838$var$US_TZ_IDS.has(tz)) : [
        ...$6e66866c6dedb838$var$US_TZ_IDS
    ];
    const getPart = (tz, opts)=>new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            ...opts
        }).formatToParts(now).find((p)=>p.type === 'timeZoneName')?.value ?? '';
    return allTz.map((tz)=>{
        // Familiar abbreviation: PST, EST, CDT, HST …
        const abbr = getPart(tz, {
            timeZoneName: 'short'
        });
        // Current UTC offset: GMT-8, GMT+10 …
        const offset = getPart(tz, {
            timeZoneName: 'shortOffset'
        });
        // Readable city / region from IANA ID tail
        const city = tz.split('/').pop().replace(/_/g, ' ');
        // Numeric offset (ms) for west→east sort
        const dtStr = new Intl.DateTimeFormat('sv-SE', {
            timeZone: tz,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(now).replace(' ', 'T');
        const offsetMs = now.getTime() - new Date(dtStr + 'Z').getTime();
        return {
            tz: tz,
            label: `${city} (${abbr}, ${offset})`,
            offsetMs: offsetMs,
            selected: tz === selectedTz
        };
    }).sort((a, b)=>a.offsetMs - b.offsetMs);
}
class $6e66866c6dedb838$var$SettingsView {
    _modal = document.getElementById("settingsModal");
    _phoneIti = null;
    _profileOriginal = null;
    _businessOriginal = null;
    _openBtn = document.getElementById("settingsBtn");
    _closeBtn = document.getElementById("settingsCloseBtn");
    _showRemovedToggle = document.getElementById("showRemovedToggle");
    _printingToggle = document.getElementById("printingToggle");
    _confirmPrintToggle = document.getElementById("confirmPrintToggle");
    _showCashierToggle = document.getElementById("showCashierToggle");
    _orderTypeToggle = document.getElementById("orderTypeToggle");
    _invoiceNumberToggle = document.getElementById("invoiceNumberToggle");
    _ticketNumberToggle = document.getElementById("ticketNumberToggle");
    _kdsYellowMin = document.getElementById("kdsYellowMin");
    _kdsYellowSec = document.getElementById("kdsYellowSec");
    _kdsRedMin = document.getElementById("kdsRedMin");
    _kdsRedSec = document.getElementById("kdsRedSec");
    _kdsAutoMin = document.getElementById("kdsAutoMin");
    _kdsAutoSec = document.getElementById("kdsAutoSec");
    _btSection = document.getElementById("btPrinterSection");
    _btPaperWidth = document.getElementById("btPaperWidthToggle");
    _btDisconnectBtn = document.getElementById("btDisconnectBtn");
    _btTestBtn = document.getElementById("btTestBtn");
    _btPairBtn = document.getElementById("btPairBtn");
    _printSetup = document.getElementById("printSetup");
    _printKindList = document.getElementById("printKindList");
    _printPosition = document.getElementById("printPositionToggle");
    _printPositionDetail = document.getElementById("printPositionDetail");
    // ── Tab navigation ────────────────────────────────────────────────────────────
    openWithRole(role) {
        if (role === 'Admin' && !this._phoneIti) this._phoneIti = (0, $7c8d851372c266f6$export$4ff15454b4105eeb)('settingsBusinessPhoneNumber');
        this._switchTab('profile');
        this.showBusinessSaveStatus(false, '');
    }
    _onTabView = null;
    _switchTab(name) {
        document.querySelectorAll('.settings-nav-btn').forEach((btn)=>{
            btn.classList.toggle('active', btn.dataset.settingsTab === name);
        });
        const tabId = `settingsTab${name.charAt(0).toUpperCase() + name.slice(1)}`;
        document.querySelectorAll('.settings-tab').forEach((tab)=>{
            tab.classList.toggle('hidden', tab.id !== tabId);
        });
        this._onTabView?.(name);
    }
    _addHandlerNavTabs() {
        document.querySelector('.settings-nav')?.addEventListener('click', (e)=>{
            const btn = e.target.closest('.settings-nav-btn[data-settings-tab]');
            if (!btn) return;
            this._switchTab(btn.dataset.settingsTab);
            this._closeMobileNav();
        });
    }
    // ── Mobile nav drawer ────────────────────────────────────────────────────────
    // Below the 640px breakpoint the nav is an off-canvas drawer instead of a
    // static sidebar - opened via the hamburger button, closed by the backdrop,
    // the × close button, or picking a tab.
    _openMobileNav() {
        document.getElementById('settingsNav')?.classList.add('settings-nav--open');
        document.getElementById('settingsNavBackdrop')?.classList.add('settings-nav-backdrop--visible');
        document.getElementById('settingsMobileMenuBtn')?.setAttribute('aria-expanded', 'true');
    }
    _closeMobileNav() {
        document.getElementById('settingsNav')?.classList.remove('settings-nav--open');
        document.getElementById('settingsNavBackdrop')?.classList.remove('settings-nav-backdrop--visible');
        document.getElementById('settingsMobileMenuBtn')?.setAttribute('aria-expanded', 'false');
    }
    _addHandlerMobileNav() {
        const btn = document.getElementById('settingsMobileMenuBtn');
        btn?.addEventListener('click', ()=>{
            const open = btn.getAttribute('aria-expanded') === 'true';
            if (open) this._closeMobileNav();
            else this._openMobileNav();
        });
        document.getElementById('settingsNavBackdrop')?.addEventListener('click', ()=>this._closeMobileNav());
    }
    // ── Business info ─────────────────────────────────────────────────────────────
    syncBusinessInfo({ name: name, email: email, phone: phone, timezone: timezone, address: address, city: city, state: state, zip: zip, country: country, isOwner: isOwner }) {
        this._businessCountry = country ?? '';
        const n = document.getElementById('settingsBusinessName');
        const e = document.getElementById('settingsBusinessEmail');
        const a = document.getElementById('settingsBusinessAddress');
        const c = document.getElementById('settingsBusinessCity');
        const st = document.getElementById('settingsBusinessState');
        const z = document.getElementById('settingsBusinessZip');
        if (n) {
            n.value = name ?? '';
            n.setAttribute('readonly', '');
        }
        if (e) {
            e.value = email ?? '';
            e.setAttribute('readonly', '');
        }
        if (a) {
            a.value = address ?? '';
            a.setAttribute('readonly', '');
        }
        if (c) {
            c.value = city ?? '';
            c.setAttribute('readonly', '');
        }
        if (st) {
            st.value = state ?? '';
            st.setAttribute('readonly', '');
        }
        if (z) {
            z.value = zip ?? '';
            z.setAttribute('readonly', '');
        }
        // View (readonly) mode always shows the text field; the dropdown is for editing.
        this._showStateControl(false);
        if (this._phoneIti) {
            this._phoneIti.setNumber(phone ?? '');
            document.getElementById('settingsBusinessPhoneNumber')?.setAttribute('readonly', '');
            document.getElementById('settingsBusinessPhoneNumber')?.closest('.iti')?.classList.add('iti--view');
        }
        document.getElementById('businessSaveRow')?.classList.add('hidden');
        document.getElementById('businessEditBtn')?.classList.remove('hidden');
        document.getElementById('settingsTimezone') && (document.getElementById('settingsTimezone').disabled = true);
        this._businessOriginal = null;
        this._syncFooterIdle();
        // Timezone field — only shown to the business owner
        const tzField = document.getElementById('settingsTimezoneField');
        if (tzField) {
            tzField.classList.toggle('hidden', !isOwner);
            if (isOwner) {
                const tzSel = document.getElementById('settingsTimezone');
                if (tzSel) {
                    // Default to current browser timezone if none saved
                    const activeTz = timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
                    const options = $6e66866c6dedb838$var$_buildTzOptions(activeTz);
                    tzSel.innerHTML = options.map((o)=>`<option value="${o.tz}"${o.selected ? ' selected' : ''}>${o.label}</option>`).join('');
                    // Fallback: if saved tz not in list, prepend it
                    if (!options.some((o)=>o.selected) && activeTz) tzSel.insertAdjacentHTML('afterbegin', `<option value="${activeTz}" selected>${activeTz}</option>`);
                }
            }
        }
    }
    // ── Shared footer state machine ─────────────────────────────────────────────
    // Exactly one of idle / profile / business / settings shows at a time.
    // `_pendingSettingsDirty` tracks an unsaved POS/KDS toggle change made while
    // Profile or Business had priority (a deliberate, already-in-progress edit
    // should never be silently bumped off the footer by an ambient toggle flip);
    // it resurfaces once that edit finishes (saved or discarded).
    _pendingSettingsDirty = false;
    _discardSettingsDraftCallback = null;
    _setFooterState(state) {
        document.getElementById('settingsFooterIdle')?.classList.toggle('hidden', state !== 'idle');
        document.getElementById('profileSaveRow')?.classList.toggle('hidden', state !== 'profile');
        document.getElementById('businessSaveRow')?.classList.toggle('hidden', state !== 'business');
        document.getElementById('settingsDraftRow')?.classList.toggle('hidden', state !== 'settings');
    }
    _currentEditingSection() {
        const p = document.getElementById('profileSaveRow');
        const b = document.getElementById('businessSaveRow');
        if (p && !p.classList.contains('hidden')) return 'profile';
        if (b && !b.classList.contains('hidden')) return 'business';
        return null;
    }
    // Kept for compatibility with call sites that just want to fall back to
    // idle/pending-settings after a Profile or Business edit finishes.
    _syncFooterIdle() {
        if (this._currentEditingSection()) return;
        this._setFooterState(this._pendingSettingsDirty ? 'settings' : 'idle');
    }
    // A POS/KDS toggle or threshold changed. Doesn't steal the footer from an
    // in-progress Profile/Business edit - just remembers the flag.
    showSettingsDirty() {
        this._pendingSettingsDirty = true;
        if (!this._currentEditingSection()) this._setFooterState('settings');
    }
    hideSettingsDirty() {
        this._pendingSettingsDirty = false;
        if (!this._currentEditingSection()) this._setFooterState('idle');
    }
    // Registers the controller callback that reverts a pending settings draft
    // when the modal is force-closed with unsaved toggle changes.
    _addHandlerDiscardSettingsDraftOnClose(handler) {
        this._discardSettingsDraftCallback = handler;
    }
    _addHandlerSaveSettingsDraft(handler) {
        document.getElementById('saveSettingsDraftBtn')?.addEventListener('click', (e)=>{
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(e.currentTarget, ()=>handler(), {
                busyText: "Saving\u2026"
            });
        });
    }
    _addHandlerDiscardSettingsDraft(handler) {
        document.getElementById('discardSettingsDraftBtn')?.addEventListener('click', ()=>handler());
    }
    enterBusinessEditMode() {
        if (!document.getElementById('profileSaveRow')?.classList.contains('hidden')) this.exitProfileEditMode(true);
        const ids = [
            'settingsBusinessName',
            'settingsBusinessAddress',
            'settingsBusinessCity',
            'settingsBusinessState',
            'settingsBusinessZip',
            'settingsBusinessEmail'
        ];
        this._businessOriginal = this._getBusinessFormData();
        ids.forEach((id)=>document.getElementById(id)?.removeAttribute('readonly'));
        document.getElementById('settingsBusinessPhoneNumber')?.removeAttribute('readonly');
        document.getElementById('settingsBusinessPhoneNumber')?.closest('.iti')?.classList.remove('iti--view');
        const tzSel = document.getElementById('settingsTimezone');
        if (tzSel) tzSel.disabled = false;
        this._setFooterState('business');
        document.getElementById('businessEditBtn').classList.add('hidden');
        const statusEl = document.getElementById('businessSaveStatus');
        if (statusEl) {
            statusEl.textContent = 'Unsaved changes';
            statusEl.className = 'settings-save-status';
        }
        // For US/CA, edit the state via a constrained dropdown (like onboarding).
        this._showStateControl(true);
        document.getElementById('settingsBusinessName')?.focus();
    }
    exitBusinessEditMode(restore = false) {
        const ids = [
            'settingsBusinessName',
            'settingsBusinessAddress',
            'settingsBusinessCity',
            'settingsBusinessState',
            'settingsBusinessZip',
            'settingsBusinessEmail'
        ];
        if (restore && this._businessOriginal) {
            const d = this._businessOriginal;
            document.getElementById('settingsBusinessName').value = d.name ?? '';
            document.getElementById('settingsBusinessAddress').value = d.address ?? '';
            document.getElementById('settingsBusinessCity').value = d.city ?? '';
            document.getElementById('settingsBusinessState').value = d.state ?? '';
            document.getElementById('settingsBusinessZip').value = d.zip ?? '';
            document.getElementById('settingsBusinessEmail').value = d.email ?? '';
            if (this._phoneIti) this._phoneIti.setNumber(d.phone ?? '');
        } else {
            // Saved (not cancelled): mirror the chosen dropdown value back into the text
            // field so the readonly view shows the new state after the dropdown is hidden.
            const sel = document.getElementById('settingsBusinessStateSelect');
            if (sel && !sel.classList.contains('hidden') && sel.value) document.getElementById('settingsBusinessState').value = sel.selectedOptions[0].textContent.trim();
        }
        this._showStateControl(false);
        ids.forEach((id)=>document.getElementById(id)?.setAttribute('readonly', ''));
        document.getElementById('settingsBusinessPhoneNumber')?.setAttribute('readonly', '');
        document.getElementById('settingsBusinessPhoneNumber')?.closest('.iti')?.classList.add('iti--view');
        const tzSel = document.getElementById('settingsTimezone');
        if (tzSel) tzSel.disabled = true;
        document.getElementById('businessSaveRow').classList.add('hidden');
        document.getElementById('businessEditBtn').classList.remove('hidden');
        this.showBusinessSaveStatus(false, '');
        this._businessOriginal = null;
        this._syncFooterIdle();
    }
    _getBusinessFormData() {
        const phone = this._phoneIti ? this._phoneIti.getNumber() : '';
        const tzField = document.getElementById('settingsTimezoneField');
        const timezone = !tzField || tzField.classList.contains('hidden') ? null : document.getElementById('settingsTimezone')?.value || null;
        return {
            name: document.getElementById('settingsBusinessName')?.value.trim() ?? '',
            email: document.getElementById('settingsBusinessEmail')?.value.trim() ?? '',
            phone: phone,
            timezone: timezone,
            address: document.getElementById('settingsBusinessAddress')?.value.trim() ?? '',
            city: document.getElementById('settingsBusinessCity')?.value.trim() ?? '',
            state: this._stateValue(),
            zip: document.getElementById('settingsBusinessZip')?.value.trim() ?? ''
        };
    }
    // The state value, reading the dropdown when it's the active control (US/CA) or the
    // free-text field otherwise. Returns the full region name (consistent with onboarding).
    _stateValue() {
        const sel = document.getElementById('settingsBusinessStateSelect');
        if (sel && !sel.classList.contains('hidden')) return sel.value ? sel.selectedOptions[0]?.textContent.trim() ?? '' : '';
        return document.getElementById('settingsBusinessState')?.value.trim() ?? '';
    }
    _populateBusinessRegions(country, regions) {
        const sel = document.getElementById('settingsBusinessStateSelect');
        if (!sel) return;
        const cc = (country ?? '').toUpperCase();
        if (sel.dataset.filledFor === cc) return;
        sel.innerHTML = '<option value="">Select one</option>';
        regions.forEach(({ code: code, name: name })=>{
            const o = document.createElement('option');
            o.value = code;
            o.textContent = name;
            sel.appendChild(o);
        });
        sel.dataset.filledFor = cc;
    }
    // editing=true + a US/CA country -> show the constrained dropdown (preselected to the
    // current state); otherwise show the free-text field. View mode always uses text.
    _showStateControl(editing) {
        const input = document.getElementById('settingsBusinessState');
        const sel = document.getElementById('settingsBusinessStateSelect');
        if (!input || !sel) return;
        const regions = editing ? (0, $0dd9374d56731bb4$export$f92ef939dc69d13b)(this._businessCountry) : null;
        if (regions) {
            this._populateBusinessRegions(this._businessCountry, regions);
            const cur = input.value.trim();
            const match = regions.find((r)=>r.name.toLowerCase() === cur.toLowerCase() || r.code === cur.toUpperCase());
            sel.value = match ? match.code : '';
            sel.classList.remove('hidden');
            input.classList.add('hidden');
        } else {
            sel.classList.add('hidden');
            input.classList.remove('hidden');
        }
    }
    _addHandlerSaveBusinessInfo(handler) {
        document.getElementById('saveBusinessInfoBtn')?.addEventListener('click', (e)=>{
            const btn = e.currentTarget;
            const data = this._getBusinessFormData();
            if (!data.name) {
                this.showBusinessSaveStatus(false, 'Business name is required.');
                return;
            }
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler(data), {
                busyText: "Saving\u2026"
            });
        });
    }
    // Reminder shown after a business address change so the owner reviews their tax rate.
    showTaxReminder(message) {
        const modal = document.getElementById('taxReminderModal');
        const text = document.getElementById('taxReminderText');
        if (text && message) text.textContent = message;
        modal?.classList.remove('hidden');
    }
    _addHandlerTaxReminderClose() {
        const modal = document.getElementById('taxReminderModal');
        document.getElementById('taxReminderCloseBtn')?.addEventListener('click', ()=>{
            modal?.classList.add('hidden');
        });
        modal?.addEventListener('click', (e)=>{
            if (e.target === modal) modal.classList.add('hidden');
        });
    }
    showBusinessSaveStatus(success, msg) {
        const el = document.getElementById('businessSaveStatus');
        if (!el) return;
        el.textContent = msg;
        el.className = `settings-save-status${success ? ' settings-save-status--ok' : msg ? ' settings-save-status--err' : ''}`;
        if (success) setTimeout(()=>{
            el.textContent = '';
            el.className = 'settings-save-status';
        }, 3000);
    }
    // ── Profile info ──────────────────────────────────────────────────────────────
    syncProfileInfo({ firstName: firstName, lastName: lastName, email: email }) {
        const f = document.getElementById('settingsProfileFirstName');
        const l = document.getElementById('settingsProfileLastName');
        const e = document.getElementById('settingsProfileEmail');
        if (f) {
            f.value = firstName ?? '';
            f.setAttribute('readonly', '');
        }
        if (l) {
            l.value = lastName ?? '';
            l.setAttribute('readonly', '');
        }
        if (e) e.value = email ?? '';
         // always readonly - login identity, not editable here
        document.getElementById('profileSaveRow')?.classList.add('hidden');
        document.getElementById('profileEditBtn')?.classList.remove('hidden');
        this._profileOriginal = null;
        this._syncFooterIdle();
    }
    enterProfileEditMode() {
        if (!document.getElementById('businessSaveRow')?.classList.contains('hidden')) this.exitBusinessEditMode(true);
        const f = document.getElementById('settingsProfileFirstName');
        const l = document.getElementById('settingsProfileLastName');
        this._profileOriginal = {
            firstName: f?.value ?? '',
            lastName: l?.value ?? ''
        };
        f?.removeAttribute('readonly');
        l?.removeAttribute('readonly');
        this._setFooterState('profile');
        document.getElementById('profileEditBtn').classList.add('hidden');
        const statusEl = document.getElementById('profileSaveStatus');
        if (statusEl) {
            statusEl.textContent = 'Unsaved changes';
            statusEl.className = 'settings-save-status';
        }
        f?.focus();
    }
    exitProfileEditMode(restore = false) {
        const f = document.getElementById('settingsProfileFirstName');
        const l = document.getElementById('settingsProfileLastName');
        if (restore && this._profileOriginal) {
            if (f) f.value = this._profileOriginal.firstName;
            if (l) l.value = this._profileOriginal.lastName;
        }
        f?.setAttribute('readonly', '');
        l?.setAttribute('readonly', '');
        document.getElementById('profileSaveRow').classList.add('hidden');
        document.getElementById('profileEditBtn').classList.remove('hidden');
        this.showProfileSaveStatus(false, '');
        this._profileOriginal = null;
        this._syncFooterIdle();
    }
    showProfileSaveStatus(success, msg) {
        const el = document.getElementById('profileSaveStatus');
        if (!el) return;
        el.textContent = msg;
        el.className = `settings-save-status${success ? ' settings-save-status--ok' : msg ? ' settings-save-status--err' : ''}`;
        if (success) setTimeout(()=>{
            el.textContent = '';
            el.className = 'settings-save-status';
        }, 3000);
    }
    // ── OTP verification modal ────────────────────────────────────────────────────
    showOTPModal(email) {
        const hint = document.getElementById('settingsOTPHint');
        if (hint) hint.textContent = `A 6-digit code was sent to ${email}.`;
        document.getElementById('settingsOTPError').textContent = '';
        document.getElementById('settingsOTPInput').value = '';
        document.getElementById('settingsOTPVerifyBtn').disabled = false;
        document.getElementById('settingsOTPVerifyBtn').textContent = 'Verify & Save';
        document.getElementById('settingsOTPModal').classList.remove('hidden');
        setTimeout(()=>document.getElementById('settingsOTPInput')?.focus(), 100);
    }
    hideOTPModal() {
        document.getElementById('settingsOTPModal').classList.add('hidden');
    }
    showOTPModalError(msg) {
        document.getElementById('settingsOTPError').textContent = msg;
        const btn = document.getElementById('settingsOTPVerifyBtn');
        if (btn) {
            btn.disabled = false;
            btn.textContent = 'Verify & Save';
        }
    }
    _addHandlerEditProfile(handler) {
        document.getElementById('profileEditBtn')?.addEventListener('click', ()=>handler());
    }
    _addHandlerCancelProfile(handler) {
        document.getElementById('cancelProfileBtn')?.addEventListener('click', ()=>handler());
    }
    _addHandlerEditBusiness(handler) {
        document.getElementById('businessEditBtn')?.addEventListener('click', ()=>handler());
    }
    _addHandlerCancelBusiness(handler) {
        document.getElementById('cancelBusinessBtn')?.addEventListener('click', ()=>handler());
    }
    _addHandlerSaveProfile(handler) {
        document.getElementById('saveProfileBtn')?.addEventListener('click', (e)=>{
            const btn = e.currentTarget;
            const firstName = document.getElementById('settingsProfileFirstName')?.value.trim();
            const lastName = document.getElementById('settingsProfileLastName')?.value.trim();
            if (!firstName) {
                this.showProfileSaveStatus(false, 'First name is required.');
                return;
            }
            if (!lastName) {
                this.showProfileSaveStatus(false, 'Last name is required.');
                return;
            }
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler({
                    firstName: firstName,
                    lastName: lastName
                }), {
                busyText: "Saving\u2026"
            });
        });
    }
    _addHandlerVerifyOTP(handler) {
        document.getElementById('settingsOTPVerifyBtn')?.addEventListener('click', (e)=>{
            const btn = e.currentTarget;
            const token = document.getElementById('settingsOTPInput')?.value.trim();
            if (!token || !/^\d{6}$/.test(token)) {
                document.getElementById('settingsOTPError').textContent = 'Please enter the 6-digit code.';
                return;
            }
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler(token), {
                busyText: "Verifying\u2026"
            });
        });
    }
    _addHandlerCancelOTP(handler) {
        document.getElementById('settingsOTPCancelBtn')?.addEventListener('click', ()=>handler());
    }
    // ── Two-Factor Authentication ────────────────────────────────────────────────
    // Toggle the Security section between the off (enable) and on (disable) states.
    render2FA(enabled) {
        document.getElementById('twoFAStatus')?.replaceChildren(enabled ? 'On' : 'Off');
        document.getElementById('twoFAStatus')?.classList.toggle('settings-2fa-badge--on', !!enabled);
        document.getElementById('twoFAOffView')?.classList.toggle('hidden', !!enabled);
        document.getElementById('twoFAOnView')?.classList.toggle('hidden', !enabled);
    }
    show2FAEnroll({ qr: qr, secret: secret }) {
        const img = document.getElementById('mfaQrImg');
        if (img) img.src = qr;
        const code = document.getElementById('mfaSecret');
        if (code) code.textContent = secret;
        const input = document.getElementById('mfaEnrollInput');
        if (input) input.value = '';
        document.getElementById('mfaEnrollError').textContent = '';
        document.getElementById('mfaEnrollModal')?.classList.remove('hidden');
        input?.focus();
    }
    hide2FAEnroll() {
        document.getElementById('mfaEnrollModal')?.classList.add('hidden');
    }
    set2FAEnrollError(msg) {
        const el = document.getElementById('mfaEnrollError');
        if (el) el.textContent = msg;
    }
    // Keep the enroll modal up with a spinner while recovery codes are generated (a
    // server round-trip after the code verifies) so the user knows setup isn't done
    // and doesn't navigate away before the codes modal appears.
    set2FAEnrollBusy(text) {
        const btn = document.getElementById('mfaEnrollVerifyBtn');
        if (btn) {
            btn.disabled = true;
            btn.innerHTML = `<span class="btn-spinner"></span>${text}`;
        }
        const err = document.getElementById('mfaEnrollError');
        if (err) err.textContent = '';
    }
    _addHandler2FAEnable(handler) {
        document.getElementById('enable2FABtn')?.addEventListener('click', (e)=>(0, $05116e7677d717d1$export$277a10cf25fc7086)(e.currentTarget, ()=>handler(), {
                busyText: "Starting\u2026"
            }));
    }
    _addHandler2FADisable(handler) {
        document.getElementById('disable2FABtn')?.addEventListener('click', (e)=>(0, $05116e7677d717d1$export$277a10cf25fc7086)(e.currentTarget, ()=>handler()));
    }
    _addHandler2FAVerifyEnroll(handler) {
        const verify = (btn)=>{
            const code = document.getElementById('mfaEnrollInput')?.value.trim();
            if (!code || !/^\d{6}$/.test(code)) {
                this.set2FAEnrollError('Enter the 6-digit code.');
                return;
            }
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler(code), {
                busyText: "Verifying\u2026"
            });
        };
        document.getElementById('mfaEnrollVerifyBtn')?.addEventListener('click', (e)=>verify(e.currentTarget));
        document.getElementById('mfaEnrollInput')?.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter') verify(document.getElementById('mfaEnrollVerifyBtn'));
        });
    }
    _addHandler2FACancelEnroll() {
        document.getElementById('mfaEnrollCancelBtn')?.addEventListener('click', ()=>this.hide2FAEnroll());
    }
    // ── Recovery codes (shown once after enrollment) ──────────────────────────────
    showRecoveryCodes(codes) {
        this._recoveryCodes = codes;
        const list = document.getElementById('mfaCodesList');
        if (list) list.innerHTML = codes.map((c)=>`<code>${c}</code>`).join('');
        // Done stays clickable; clicking it without ticking the box shows a reminder
        // toast (a disabled button gave no feedback about why nothing happened).
        const ack = document.getElementById('mfaCodesAck');
        if (ack) ack.checked = false;
        document.getElementById('mfaCodesModal')?.classList.remove('hidden');
    }
    hideRecoveryCodes() {
        document.getElementById('mfaCodesModal')?.classList.add('hidden');
    }
    _addHandler2FACodes(onDone, onUnacked) {
        const codesText = ()=>(this._recoveryCodes ?? []).join('\n');
        document.getElementById('mfaCodesCopyBtn')?.addEventListener('click', (e)=>{
            navigator.clipboard?.writeText(codesText());
            const btn = e.currentTarget;
            const prev = btn.textContent;
            btn.textContent = 'Copied!';
            setTimeout(()=>{
                btn.textContent = prev;
            }, 1500);
        });
        document.getElementById('mfaCodesDownloadBtn')?.addEventListener('click', ()=>{
            const blob = new Blob([
                `Pointbunny two-factor recovery codes\nKeep these somewhere safe. Each works once.\n\n${codesText()}\n`
            ], {
                type: 'text/plain'
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'pointbunny-recovery-codes.txt';
            a.click();
            URL.revokeObjectURL(url);
        });
        document.getElementById('mfaCodesDoneBtn')?.addEventListener('click', ()=>{
            const ack = document.getElementById('mfaCodesAck');
            if (!ack?.checked) {
                onUnacked?.();
                return;
            } // remind, don't proceed
            this.hideRecoveryCodes();
            onDone?.();
        });
    }
    // ── Open / Close ─────────────────────────────────────────────────────────────
    // Reveals the modal. Deep-links (e.g. the Getting Started "Set up your
    // receipt" step) call this + the controller's open handler themselves,
    // since only the gear button's listener used to unhide the modal.
    open() {
        this._modal.classList.remove("hidden");
    }
    _addHandlerOpen(handler) {
        this._openBtn.addEventListener("click", ()=>{
            this.open();
            handler();
        });
    }
    _addHandlerClose() {
        this._closeBtn.addEventListener("click", ()=>this._requestClose());
        this._modal.addEventListener("click", (e)=>{
            if (e.target === this._modal) this._requestClose();
        });
    }
    // onClosed (optional) only fires once the modal actually closes - i.e. not
    // if the user cancels an unsaved-changes prompt. Used by callers that want
    // to open something else right after Settings closes (e.g. "Manage adjustments").
    close(onClosed) {
        this._requestClose(onClosed);
    }
    // True while Profile/Business is mid-edit, or a POS/KDS toggle changed but
    // hasn't been saved or discarded yet.
    _hasUnsavedEdits() {
        return this._currentEditingSection() !== null || this._pendingSettingsDirty;
    }
    // Warn before closing with unsaved edits so a stray backdrop click or the
    // × button can't silently throw away a half-finished name/address change.
    _requestClose(onClosed) {
        if (!this._hasUnsavedEdits()) {
            this._close();
            onClosed?.();
            return;
        }
        this._showConfirm({
            message: 'You have unsaved changes.',
            note: 'If you leave now, your changes will be discarded.',
            confirmLabel: 'Discard & Close',
            cancelLabel: 'Keep Editing',
            onConfirm: ()=>{
                this._close();
                onClosed?.();
            }
        });
    }
    _close() {
        this.hideOTPModal();
        this.exitProfileEditMode(true);
        this.exitBusinessEditMode(true);
        if (this._pendingSettingsDirty) this._discardSettingsDraftCallback?.();
        this._closeMobileNav();
        const inner = this._modal.querySelector(".modal-container");
        if (inner) inner.classList.add("modal-exiting");
        setTimeout(()=>{
            if (inner) inner.classList.remove("modal-exiting");
            this._modal.classList.add("hidden");
        }, 220);
    }
    // ── Handlers ──────────────────────────────────────────────────────────────────
    _addHandlerShowRemoved(handler) {
        this._showRemovedToggle.addEventListener("change", ()=>{
            handler(this._showRemovedToggle.checked);
        });
    }
    syncShowRemovedToggle(value) {
        this._showRemovedToggle.checked = value;
    }
    _addHandlerTogglePrinting(handler) {
        this._printingToggle.addEventListener("change", ()=>{
            this._syncPrintSetupDimmed();
            handler(this._printingToggle.checked);
        });
    }
    syncPrintingToggle(value) {
        this._printingToggle.checked = value;
        this._syncPrintSetupDimmed();
    }
    // Printer setup is moot with printing off - dimmed, but still editable so
    // an owner can set the printer up before turning printing on.
    _syncPrintSetupDimmed() {
        this._printSetup?.classList.toggle('print-setup--off', !this._printingToggle.checked);
    }
    _addHandlerToggleConfirmPrint(handler) {
        this._confirmPrintToggle.addEventListener("change", ()=>{
            handler(this._confirmPrintToggle.checked);
        });
    }
    syncConfirmPrintToggle(value) {
        this._confirmPrintToggle.checked = value;
    }
    _addHandlerToggleShowCashier(handler) {
        this._showCashierToggle.addEventListener("change", ()=>{
            handler(this._showCashierToggle.checked);
        });
    }
    syncShowCashierToggle(value) {
        this._showCashierToggle.checked = value;
    }
    _addHandlerToggleHideStats(handler) {
        document.getElementById("hideStatsToggle")?.addEventListener("change", (e)=>{
            handler(e.target.checked);
        });
    }
    syncHideStatsToggle(value) {
        const el = document.getElementById("hideStatsToggle");
        if (el) el.checked = value === true;
    }
    // ── Receipt printer (kind + paper + position + Bluetooth actions) ─────────
    // "What kind of printer?" cards. A kind is a friendlier name for a
    // method + paper pair (see controlStagePrintKind) - nothing new is stored.
    _addHandlerPrintKind(handler) {
        this._printKindList?.querySelectorAll('.print-kind').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                if (btn.disabled) return;
                handler(btn.dataset.kind);
            });
        });
    }
    _addHandlerPrintPosition(handler) {
        this._printPosition?.querySelectorAll('.bt-paper-toggle-btn').forEach((btn)=>{
            btn.addEventListener('click', ()=>handler(btn.dataset.value));
        });
    }
    _addHandlerBtPair(handler) {
        this._btPairBtn?.addEventListener('click', ()=>handler());
    }
    _addHandlerBtDisconnect(handler) {
        this._btDisconnectBtn?.addEventListener('click', ()=>handler());
    }
    _addHandlerBtTest(handler) {
        this._btTestBtn?.addEventListener('click', ()=>handler());
    }
    // Branded segmented pills (mirrors .pos-visual-toggle) instead of plain
    // <select>s. The caller stages the pick (saved via the shared footer) and
    // re-syncs the whole card through syncPrinter().
    _addHandlerBtPaperWidth(handler) {
        this._btPaperWidth?.querySelectorAll('.bt-paper-toggle-btn').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                if (btn.disabled) return;
                handler(btn.dataset.value);
            });
        });
    }
    // Moves a segmented pill's thumb to the button whose data-value matches.
    _syncSegToggle(toggle, value) {
        if (!toggle) return;
        const btns = [
            ...toggle.querySelectorAll('.bt-paper-toggle-btn')
        ];
        const i = Math.max(0, btns.findIndex((b)=>b.dataset.value === String(value)));
        toggle.style.setProperty('--seg-i', i);
        btns.forEach((b, j)=>b.classList.toggle('bt-paper-toggle-btn--active', j === i));
    }
    // Deliberately does NOT track/display a live Bluetooth "connected" status -
    // Web Bluetooth's own connection reporting proved unreliable to mirror (idle
    // auto-disconnects, hung reconnect probes on Windows). Pair / Disconnect /
    // Test always act and report via toast; print() reconnects on its own.
    syncPrinter({ method: method, suggested: suggested, paper: paper, position: position, btSupported: btSupported }) {
        const isBt = method === 'bluetooth' && btSupported;
        // Full page is only reachable through the system dialog (ESC/POS can't
        // do it), so Bluetooth + a stored 'full' shows - and prints - as 80mm.
        const kind = isBt ? 'bluetooth' : paper === 'full' ? 'sheet' : 'receipt';
        const suggestedKind = suggested === 'bluetooth' ? 'bluetooth' : 'receipt';
        this._printKindList?.querySelectorAll('.print-kind').forEach((btn)=>{
            const k = btn.dataset.kind;
            const selected = k === kind;
            btn.classList.toggle('print-kind--selected', selected);
            btn.setAttribute('aria-checked', String(selected));
            btn.querySelector('.print-kind-badge')?.classList.toggle('hidden', k !== suggestedKind);
            if (k === 'bluetooth') {
                btn.disabled = !btSupported;
                const desc = btn.querySelector('.print-kind-desc');
                desc.textContent = btSupported ? 'Pointbunny connects to a Bluetooth receipt printer itself, with no print dialog. Pair it once and it reconnects on its own.' : "Not available in this browser (iPad, iPhone, Safari and Firefox can't). If your Bluetooth printer is paired in this device's settings, pick Receipt printer.";
            }
        });
        this._syncSegToggle(this._btPaperWidth, paper === 'full' ? 80 : paper);
        this._syncSegToggle(this._printPosition, position);
        if (this._printPositionDetail) this._printPositionDetail.textContent = ({
            default: 'Default: starts at the left edge of the paper. Right for most printers.',
            center: 'Centered: try this if there is a wide blank space on the right.',
            left: 'Shift left: try this if text gets cut off on the right edge.'
        })[position] ?? '';
        // CSS shows/hides each option per kind (roll width: receipt + bluetooth;
        // position: receipt only; Pair/Disconnect: bluetooth only).
        this._btSection?.classList.remove('print-kind-is-receipt', 'print-kind-is-bluetooth', 'print-kind-is-sheet');
        this._btSection?.classList.add(`print-kind-is-${kind}`);
    }
    _addHandlerToggleOrderType(handler) {
        this._orderTypeToggle.addEventListener('change', ()=>handler(this._orderTypeToggle.checked));
    }
    syncOrderTypeToggle(value) {
        this._orderTypeToggle.checked = value;
    }
    // Lightweight confirm dialog. SettingsView does not extend View, so it cannot
    // use View.showConfirmModal - this mirrors the same `.confirm-overlay` markup so
    // styling is identical.
    _showConfirm({ message: message, note: note, confirmLabel: confirmLabel = 'Confirm', cancelLabel: cancelLabel = 'Cancel', onConfirm: onConfirm, onCancel: onCancel }) {
        if (document.querySelector('.confirm-overlay')) return;
        const el = document.createElement('div');
        el.className = 'confirm-overlay';
        el.innerHTML = `
      <div class="confirm-card">
        <p class="confirm-msg">${message}</p>
        ${note ? `<p class="confirm-note">${note}</p>` : ''}
        <div class="confirm-actions">
          <button class="btn confirm-cancel-btn" type="button">${cancelLabel}</button>
          <button class="btn primary confirm-ok-btn" type="button">${confirmLabel}</button>
        </div>
      </div>`;
        document.body.appendChild(el);
        el.querySelector('.confirm-ok-btn').addEventListener('click', ()=>{
            el.remove();
            onConfirm?.();
        });
        el.querySelector('.confirm-cancel-btn').addEventListener('click', ()=>{
            el.remove();
            onCancel?.();
        });
        el.addEventListener('click', (e)=>{
            if (e.target === el) {
                el.remove();
                onCancel?.();
            }
        });
    }
    // Turning the invoice number OFF is allowed, but warn first - many countries
    // legally require a sequential invoice number on receipts. Cancelling the
    // warning reverts the toggle. Turning it back on needs no confirmation.
    _addHandlerToggleInvoiceNumber(handler) {
        this._invoiceNumberToggle.addEventListener('change', ()=>{
            if (this._invoiceNumberToggle.checked) {
                handler(true);
                return;
            }
            this._showConfirm({
                message: 'Hide the invoice number on receipts?',
                note: 'Some countries (VAT/GST regions like the UK, EU, Australia and the Philippines) legally require a sequential invoice number on every receipt. The number is still recorded internally either way - this only hides it from the printed receipt. This is your choice.',
                confirmLabel: 'Yes, hide it',
                cancelLabel: 'Keep it on',
                onConfirm: ()=>handler(false),
                onCancel: ()=>{
                    this._invoiceNumberToggle.checked = true;
                }
            });
        });
    }
    syncInvoiceNumberToggle(value) {
        this._invoiceNumberToggle.checked = value;
    }
    _addHandlerToggleTicketNumber(handler) {
        this._ticketNumberToggle.addEventListener('change', ()=>handler(this._ticketNumberToggle.checked));
    }
    syncTicketNumberToggle(value) {
        this._ticketNumberToggle.checked = value;
    }
    _addHandlerToggleShowPhone(handler) {
        const el = document.getElementById("showPhoneToggle");
        el?.addEventListener("change", ()=>handler(el.checked));
    }
    syncShowPhoneToggle(value) {
        const el = document.getElementById("showPhoneToggle");
        if (el) el.checked = value !== false;
    }
    // ── Receipt footer + feedback QR (Pro) ──────────────────────────────────────
    // Footer text stages on every keystroke; the QR link stages only once it's a
    // valid https link (or cleared), otherwise the hint turns into an error.
    _addHandlerReceiptFooter(onFooter, onQrUrl, isValidUrl) {
        const footer = document.getElementById("receiptFooterInput");
        const qr = document.getElementById("receiptQrInput");
        const hint = document.getElementById("receiptQrHint");
        footer?.addEventListener("input", ()=>onFooter(footer.value.trim()));
        qr?.addEventListener("input", ()=>{
            const v = qr.value.trim();
            const ok = !v || isValidUrl(v);
            hint?.classList.toggle("receipt-footer-hint--error", !ok);
            if (hint) hint.textContent = ok ? $6e66866c6dedb838$var$RECEIPT_QR_HINT : "Enter a full link starting with https://";
            if (ok) onQrUrl(v);
        });
    }
    syncReceiptFooter({ footer: footer, qrUrl: qrUrl, locked: locked }) {
        const card = document.getElementById("receiptFooterCard");
        const footerEl = document.getElementById("receiptFooterInput");
        const qrEl = document.getElementById("receiptQrInput");
        if (!card || !footerEl || !qrEl) return;
        card.classList.toggle("receipt-footer-card--locked", locked);
        footerEl.disabled = locked;
        qrEl.disabled = locked;
        // Starts filled with the default line so owners see what prints today.
        footerEl.value = footer || $6e66866c6dedb838$var$DEFAULT_RECEIPT_FOOTER;
        qrEl.value = qrUrl ?? "";
    }
    // ── Tips ──────────────────────────────────────────────────────────────────────
    // onToggle(bool); onPresets([n, n, n]) fires on every valid edit (1-100,
    // whole numbers - blanks/invalid boxes are skipped until fixed); the tip QR
    // upload/remove reuses the Displays image-card pattern (tipQr* ids).
    _addHandlerTips({ onToggle: onToggle, onPresets: onPresets, onQrUpload: onQrUpload, onQrRemove: onQrRemove }) {
        const toggle = document.getElementById("tipsEnabledToggle");
        toggle?.addEventListener("change", ()=>{
            this._syncTipCard(toggle.checked);
            onToggle(toggle.checked);
        });
        const boxes = [
            1,
            2,
            3
        ].map((n)=>document.getElementById(`tipPreset${n}`)).filter(Boolean);
        boxes.forEach((box)=>box.addEventListener("input", ()=>{
                box.value = box.value.replace(/[^\d]/g, "").slice(0, 3);
                const values = boxes.map((b)=>parseInt(b.value, 10));
                const valid = values.every((v)=>Number.isInteger(v) && v >= 1 && v <= 100);
                boxes.forEach((b, i)=>b.classList.toggle("tip-preset-input--error", b.value !== "" && !(values[i] >= 1 && values[i] <= 100)));
                if (valid) onPresets(values);
            }));
        const input = document.getElementById("tipQrInput");
        input?.addEventListener("change", ()=>{
            const file = input.files[0];
            if (!file) return;
            document.getElementById("tipQrFileName").textContent = file.name;
            onQrUpload(file);
        });
        document.getElementById("tipQrRemoveBtn")?.addEventListener("click", ()=>{
            document.getElementById("tipQrFileName").textContent = "No file chosen";
            input.value = "";
            onQrRemove();
        });
    }
    _syncTipCard(enabled) {
        document.getElementById("tipSettingsCard")?.classList.toggle("tip-settings-card--off", !enabled);
    }
    syncTips({ enabled: enabled, presets: presets, qrUrl: qrUrl }) {
        const toggle = document.getElementById("tipsEnabledToggle");
        if (toggle) toggle.checked = enabled === true;
        this._syncTipCard(enabled === true);
        [
            1,
            2,
            3
        ].forEach((n, i)=>{
            const box = document.getElementById(`tipPreset${n}`);
            if (!box) return;
            box.value = presets?.[i] ?? "";
            box.classList.remove("tip-preset-input--error");
        });
        this._syncImagePreview("tipQr", qrUrl);
        if (!qrUrl) {
            const name = document.getElementById("tipQrFileName");
            if (name) name.textContent = "No file chosen";
        }
    }
    showTipQRPreview(url) {
        this._syncImagePreview("tipQr", url);
    }
    // ── Display window size ───────────────────────────────────────────────────────
    _sizeToOption(size) {
        const key = `${size.width}x${size.height}`;
        return [
            '1024x768',
            '1280x720',
            '1920x1080'
        ].includes(key) ? key : 'custom';
    }
    // Decorative dims label under each screen-size preview thumbnail.
    _updatePreviewDims(id, size) {
        const el = document.getElementById(id);
        if (el) el.textContent = `${size.width}\xd7${size.height}`;
    }
    syncDisplaySizes(kdsSize, cfdSize) {
        const kdsSelect = document.getElementById('kdsWindowSizeSelect');
        const cfdSelect = document.getElementById('cfdWindowSizeSelect');
        const kdsOpt = this._sizeToOption(kdsSize);
        kdsSelect.value = kdsOpt;
        if (kdsOpt === 'custom') {
            document.getElementById('kdsCustomSize').classList.remove('hidden');
            document.getElementById('kdsCustomW').value = kdsSize.width;
            document.getElementById('kdsCustomH').value = kdsSize.height;
        }
        this._updatePreviewDims('kdsPreviewDims', kdsSize);
        const cfdOpt = this._sizeToOption(cfdSize);
        cfdSelect.value = cfdOpt;
        if (cfdOpt === 'custom') {
            document.getElementById('cfdCustomSize').classList.remove('hidden');
            document.getElementById('cfdCustomW').value = cfdSize.width;
            document.getElementById('cfdCustomH').value = cfdSize.height;
        }
        this._updatePreviewDims('cfdPreviewDims', cfdSize);
        // Sync image previews from their last-SAVED value (localStorage cache) -
        // reverts a discarded upload/removal back to what's actually persisted.
        this._syncImagePreview('cfdAd', localStorage.getItem('pointbunny_cfd_ad'));
        this._syncImagePreview('pickupAd', localStorage.getItem('pointbunny_pickup_ad'));
        this._syncImagePreview('cfdQr', localStorage.getItem('pointbunny_cfd_qr'));
    }
    // Shared by the three Displays image cards (CFD ad, pickup-screen ad,
    // payment QR) - `prefix` matches their id naming (cfdAdPreview/Img/RemoveBtn
    // etc). Handles both directions: show a url, or hide when null/falsy -
    // needed so discarding a staged upload actually reverts the preview, not
    // just discarding a staged removal.
    _syncImagePreview(prefix, url) {
        const preview = document.getElementById(`${prefix}Preview`);
        const img = document.getElementById(`${prefix}PreviewImg`);
        const removeBtn = document.getElementById(`${prefix}RemoveBtn`);
        if (!preview || !img || !removeBtn) return;
        if (url) {
            preview.classList.remove('hidden');
            img.src = url;
            removeBtn.classList.remove('hidden');
        } else {
            preview.classList.add('hidden');
            img.src = '';
            removeBtn.classList.add('hidden');
        }
    }
    _addHandlerDisplaySizes(kdsHandler, cfdHandler) {
        const kdsSelect = document.getElementById('kdsWindowSizeSelect');
        const cfdSelect = document.getElementById('cfdWindowSizeSelect');
        const kdsCustom = document.getElementById('kdsCustomSize');
        const cfdCustom = document.getElementById('cfdCustomSize');
        const readSize = (select, customEl)=>{
            if (select.value === 'custom') {
                const w = parseInt(customEl.querySelector('[id$="CustomW"]').value) || 1920;
                const h = parseInt(customEl.querySelector('[id$="CustomH"]').value) || 1080;
                return {
                    width: w,
                    height: h
                };
            }
            const [w, h] = select.value.split('x').map(Number);
            return {
                width: w,
                height: h
            };
        };
        kdsSelect.addEventListener('change', ()=>{
            kdsCustom.classList.toggle('hidden', kdsSelect.value !== 'custom');
            this._updatePreviewDims('kdsPreviewDims', readSize(kdsSelect, kdsCustom));
            if (kdsSelect.value !== 'custom') kdsHandler(readSize(kdsSelect, kdsCustom));
        });
        cfdSelect.addEventListener('change', ()=>{
            cfdCustom.classList.toggle('hidden', cfdSelect.value !== 'custom');
            this._updatePreviewDims('cfdPreviewDims', readSize(cfdSelect, cfdCustom));
            if (cfdSelect.value !== 'custom') cfdHandler(readSize(cfdSelect, cfdCustom));
        });
        [
            document.getElementById('kdsCustomW'),
            document.getElementById('kdsCustomH')
        ].forEach((input)=>{
            input.addEventListener('change', ()=>{
                this._updatePreviewDims('kdsPreviewDims', readSize(kdsSelect, kdsCustom));
                kdsHandler(readSize(kdsSelect, kdsCustom));
            });
        });
        [
            document.getElementById('cfdCustomW'),
            document.getElementById('cfdCustomH')
        ].forEach((input)=>{
            input.addEventListener('change', ()=>{
                this._updatePreviewDims('cfdPreviewDims', readSize(cfdSelect, cfdCustom));
                cfdHandler(readSize(cfdSelect, cfdCustom));
            });
        });
    }
    // ── CFD ad image ──────────────────────────────────────────────────────────────
    _addHandlerCFDAdUpload(handler) {
        const input = document.getElementById('cfdAdInput');
        const fileNameEl = document.getElementById('cfdAdFileName');
        input.addEventListener('change', ()=>{
            const file = input.files[0];
            if (!file) return;
            fileNameEl.textContent = file.name;
            handler(file);
        });
    }
    showCFDAdPreview(url) {
        this._syncImagePreview('cfdAd', url);
    }
    _addHandlerCFDAdRemove(handler) {
        document.getElementById('cfdAdRemoveBtn').addEventListener('click', ()=>{
            document.getElementById('cfdAdFileName').textContent = 'No file chosen';
            document.getElementById('cfdAdInput').value = '';
            handler();
        });
    }
    // ── Pickup screen ad image ──────────────────────────────────────────────────
    _addHandlerPickupAdUpload(handler) {
        const input = document.getElementById('pickupAdInput');
        const fileNameEl = document.getElementById('pickupAdFileName');
        input.addEventListener('change', ()=>{
            const file = input.files[0];
            if (!file) return;
            fileNameEl.textContent = file.name;
            handler(file);
        });
    }
    showPickupAdPreview(url) {
        this._syncImagePreview('pickupAd', url);
    }
    _addHandlerPickupAdRemove(handler) {
        document.getElementById('pickupAdRemoveBtn').addEventListener('click', ()=>{
            document.getElementById('pickupAdFileName').textContent = 'No file chosen';
            document.getElementById('pickupAdInput').value = '';
            handler();
        });
    }
    // ── CFD payment QR image ────────────────────────────────────────────────────
    _addHandlerCFDQRUpload(handler) {
        const input = document.getElementById('cfdQrInput');
        const fileNameEl = document.getElementById('cfdQrFileName');
        input.addEventListener('change', ()=>{
            const file = input.files[0];
            if (!file) return;
            fileNameEl.textContent = file.name;
            handler(file);
        });
    }
    showCFDQRPreview(url) {
        this._syncImagePreview('cfdQr', url);
    }
    _addHandlerCFDQRRemove(handler) {
        document.getElementById('cfdQrRemoveBtn').addEventListener('click', ()=>{
            document.getElementById('cfdQrFileName').textContent = 'No file chosen';
            document.getElementById('cfdQrInput').value = '';
            handler();
        });
    }
    // Thresholds are stored in seconds; the UI shows them as minute : second.
    syncKDSThresholds(yellow, red, auto) {
        const set = (minEl, secEl, total)=>{
            const t = Math.max(0, parseInt(total) || 0);
            if (minEl) minEl.value = Math.floor(t / 60);
            if (secEl) secEl.value = String(t % 60).padStart(2, '0');
        };
        set(this._kdsYellowMin, this._kdsYellowSec, yellow);
        set(this._kdsRedMin, this._kdsRedSec, red);
        set(this._kdsAutoMin, this._kdsAutoSec, auto);
        this._renderKDSLifecycle(yellow, red, auto);
    }
    _formatMinSec(totalSeconds) {
        const t = Math.max(0, parseInt(totalSeconds) || 0);
        return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, '0')}`;
    }
    // Keeps the lifecycle diagram + the colored pills in the Timer settings list
    // in sync with the current threshold values (initial load and live edits).
    _renderKDSLifecycle(yellow, red, auto) {
        const y = this._formatMinSec(yellow);
        const r = this._formatMinSec(red);
        const a = this._formatMinSec(auto);
        const setText = (id, text)=>{
            const el = document.getElementById(id);
            if (el) el.textContent = text;
        };
        setText('kdsLifecycleYellowTime', y);
        setText('kdsLifecycleRedTime', r);
        setText('kdsLifecycleAutoTime', a);
        setText('kdsPillYellow', y);
        setText('kdsPillRed', r);
        setText('kdsPillAuto', a);
    }
    _addHandlerKDSThresholds(handler) {
        // minute:second -> seconds; fall back to the new-business defaults if a pair
        // reads zero/blank so a timer is never accidentally disabled.
        const toSecs = (minEl, secEl, fallback)=>{
            const m = Math.max(0, parseInt(minEl?.value) || 0);
            const s = Math.min(59, Math.max(0, parseInt(secEl?.value) || 0));
            const total = m * 60 + s;
            return total > 0 ? total : fallback;
        };
        [
            this._kdsYellowMin,
            this._kdsYellowSec,
            this._kdsRedMin,
            this._kdsRedSec,
            this._kdsAutoMin,
            this._kdsAutoSec
        ].forEach((input)=>{
            input?.addEventListener('change', ()=>{
                const values = {
                    yellow: toSecs(this._kdsYellowMin, this._kdsYellowSec, 600),
                    red: toSecs(this._kdsRedMin, this._kdsRedSec, 900),
                    auto: toSecs(this._kdsAutoMin, this._kdsAutoSec, 3600)
                };
                this._renderKDSLifecycle(values.yellow, values.red, values.auto);
                handler(values);
            });
        });
    }
    // ── Home screen tab (homeLayout.js) ─────────────────────────────────────────
    // Same deferred save as the POS toggles: every change stages, Save Changes
    // writes. Re-rendered after each change, keeping focus on the used control.
    _homeSwitch(attr, key, on, label) {
        return `
      <label class="switch">
        <input type="checkbox" ${attr}="${key}"${on ? ' checked' : ''} aria-label="${label}" />
        <span class="slider round"></span>
      </label>`;
    }
    _homeRow(name, hint, control, extraClass = '') {
        return `
      <div class="settings-row${extraClass}">
        <div class="settings-row-text">
          <p class="settings-row-label">${name}</p>
          ${hint ? `<p class="settings-row-hint">${hint}</p>` : ''}
        </div>
        ${control}
      </div>`;
    }
    // Home cards on this device (homeCards.js). Not a business setting, so it
    // saves on change instead of staging for Save Changes.
    _homeCardsSection(hc) {
        if (!hc) return '';
        const opts = (list, current)=>list.map((o)=>`<option value="${o.key}"${o.key === current ? ' selected' : ''}${o.disabled ? ' disabled' : ''}>${(0, $cnCXJ.esc)(o.label)}${o.disabled ? ` (${o.tag === 'Pro' ? 'Pro' : o.tag ? 'off' : 'not available'})` : ''}</option>`).join('');
        const grouped = (list, current)=>[
                ...new Set(list.map((o)=>o.group))
            ].map((g)=>`<optgroup label="${(0, $cnCXJ.esc)(g)}">${opts(list.filter((o)=>o.group === g), current)}</optgroup>`).join('');
        const tileOpts = (current)=>grouped(hc.tileOptions, current);
        const select = (slot, label, inner)=>`
      <label class="home-set-card-field">
        <span>${label}</span>
        <select class="settings-select" data-home-card="${slot}">${inner}</select>
      </label>`;
        return `
      <section class="settings-section">
        <h3 class="settings-section-title">Home cards on this device</h3>
        <p class="settings-section-hint">Each register, tablet or phone remembers its own cards. Changes save right away. You can also tap the swap button on a card or tile.</p>
        <div class="home-set-cards">
          ${select('card0', 'Left card', grouped(hc.cardOptions, hc.cards[0]))}
          ${select('card1', 'Right card', grouped(hc.cardOptions, hc.cards[1]))}
        </div>
        <div class="home-set-cards home-set-cards--tiles">
          ${select('tile0', 'First tile', tileOpts(hc.tiles[0]))}
          ${select('tile1', 'Middle tile', tileOpts(hc.tiles[1]))}
          ${select('tile2', 'Last tile', tileOpts(hc.tiles[2]))}
        </div>
        <button type="button" class="btn home-set-suggest" data-home-cards-suggest="1">Use suggested cards</button>
      </section>`;
    }
    // Booking hours, slot length, table hold and waitlist quote buttons
    // (bookingRules.js). Business settings: staged like the rest of this tab.
    _bookingSection({ bookingRules: r, waitlistQuotes: quotes, waitlistEnabled: waitlistEnabled, reservationsEnabled: reservationsEnabled }) {
        if (!r || !reservationsEnabled && !waitlistEnabled) return '';
        const days = (0, $3c9e88a543a9da6a$export$32c1f2e7a501558d).map((name, i)=>{
            const h = r.hours[i];
            return `
        <div class="book-day${h.on ? '' : ' book-day--off'}">
          <label class="switch">
            <input type="checkbox" data-book-day-on="${i}"${h.on ? ' checked' : ''} aria-label="Take bookings on ${name}" />
            <span class="slider round"></span>
          </label>
          <span class="book-day-name">${name}</span>
          ${h.on ? `
            <input type="time" class="settings-input book-time" data-book-from="${i}" value="${h.from}" aria-label="${name} first booking" />
            <span class="book-day-to">to</span>
            <input type="time" class="settings-input book-time" data-book-to="${i}" value="${h.to}" aria-label="${name} last booking" />` : '<span class="book-day-closed">No bookings</span>'}
        </div>`;
        }).join('');
        const reservations = reservationsEnabled ? `
      <section class="settings-section">
        <h3 class="settings-section-title">Booking hours</h3>
        <p class="settings-section-hint">The times staff can pick when booking a table. The last time is the latest a booking can start. Staff can still type another time for a one-off.</p>
        <div class="book-days">${days}</div>
        <button type="button" class="btn book-copy" data-book-copy="1">Use ${(0, $3c9e88a543a9da6a$export$32c1f2e7a501558d)[$6e66866c6dedb838$var$copyFrom(r)]}'s hours every open day</button>
        <div class="settings-row-group book-rules">
          <div class="settings-row">
            <div class="settings-row-text">
              <p class="settings-row-label">Time between bookings</p>
              <p class="settings-row-hint">How far apart the times are.</p>
            </div>
            <div class="home-set-seg" role="radiogroup" aria-label="Time between bookings">
              ${(0, $3c9e88a543a9da6a$export$cf623d56a0c35766).map((m)=>`<button type="button" class="home-set-seg-btn${m === r.slotMin ? ' home-set-seg-btn--on' : ''}" role="radio" aria-checked="${m === r.slotMin}" data-book-slot="${m}">${m} min</button>`).join('')}
            </div>
          </div>
          <div class="settings-row">
            <div class="settings-row-text">
              <p class="settings-row-label">Hold a table for</p>
              <p class="settings-row-hint">How long a booking keeps its table. Staff can change it on each booking.</p>
            </div>
            <label class="book-mins"><input type="number" class="settings-input" min="15" max="600" step="15" data-book-hold="1" value="${r.holdMin}" aria-label="Minutes a table is held" /><span>min</span></label>
          </div>
          <div class="settings-row">
            <div class="settings-row-text">
              <p class="settings-row-label">Longer hold for big parties</p>
              <p class="settings-row-hint">${r.bigPartySize ? `Parties of ${r.bigPartySize} or more keep their table for ${(0, $3c9e88a543a9da6a$export$6983ec1528bb4f57)(r.bigPartyHoldMin)}.` : 'Off: every party gets the same hold.'}</p>
            </div>
            <label class="switch">
              <input type="checkbox" data-book-big-on="1"${r.bigPartySize ? ' checked' : ''} aria-label="Longer hold for big parties" />
              <span class="slider round"></span>
            </label>
          </div>
          ${r.bigPartySize ? `
            <div class="settings-row home-set-sub book-big">
              <label class="book-mins"><span>Parties of</span><input type="number" class="settings-input" min="2" max="99" data-book-big-size="1" value="${r.bigPartySize}" aria-label="Big party size" /><span>or more</span></label>
              <label class="book-mins"><span>hold for</span><input type="number" class="settings-input" min="15" max="600" step="15" data-book-big-hold="1" value="${r.bigPartyHoldMin}" aria-label="Minutes a big party keeps its table" /><span>min</span></label>
            </div>` : ''}
        </div>
      </section>` : '';
        const waitlist = waitlistEnabled ? `
      <section class="settings-section">
        <h3 class="settings-section-title">Waitlist wait times</h3>
        <p class="settings-section-hint">The buttons for "Wait you told them". Up to 8. Staff can still type any number of minutes.</p>
        <div class="book-quotes">
          ${quotes.map((n)=>`<span class="book-quote">${n} min<button type="button" class="book-quote-x" data-quote-remove="${n}" aria-label="Remove ${n} minutes"${quotes.length <= 1 ? ' disabled' : ''}>&times;</button></span>`).join('')}
          ${quotes.length < 8 ? `
            <span class="book-quote-add">
              <input type="number" class="settings-input" min="1" max="600" placeholder="Minutes" data-quote-new="1" aria-label="New wait time in minutes" />
              <button type="button" class="btn" data-quote-add="1">Add</button>
            </span>` : ''}
        </div>
        <button type="button" class="hc-link book-reset" data-quote-reset="1">Back to ${(0, $3c9e88a543a9da6a$export$78a2a13284d3c159).join(', ')} min</button>
      </section>` : '';
        return reservations + waitlist;
    }
    // Turns one booking control into the next bookingRules / waitlistQuotes value.
    _bookingChange(t) {
        const d = this._homeData;
        const r = structuredClone(d.bookingRules);
        const ds = t.dataset;
        if (ds.bookDayOn != null) r.hours[ds.bookDayOn].on = t.checked;
        else if (ds.bookFrom != null || ds.bookTo != null) {
            const i = ds.bookFrom ?? ds.bookTo;
            if (!t.value) return null;
            r.hours[i][ds.bookFrom != null ? 'from' : 'to'] = t.value;
            // A day can't end before it starts: move the other end to match.
            if ((0, $3c9e88a543a9da6a$export$4a79f0068700788b)(r.hours[i].to) < (0, $3c9e88a543a9da6a$export$4a79f0068700788b)(r.hours[i].from)) {
                if (ds.bookFrom != null) r.hours[i].to = r.hours[i].from;
                else r.hours[i].from = r.hours[i].to;
            }
        } else if (ds.bookHold != null) r.holdMin = Math.min(600, Math.max(15, Math.round(Number(t.value)) || r.holdMin));
        else if (ds.bookBigOn != null) r.bigPartySize = t.checked ? r.bigPartySize ?? 6 : null;
        else if (ds.bookBigSize != null) r.bigPartySize = Math.min(99, Math.max(2, Math.round(Number(t.value)) || 6));
        else if (ds.bookBigHold != null) r.bigPartyHoldMin = Math.min(600, Math.max(15, Math.round(Number(t.value)) || r.bigPartyHoldMin));
        else return null;
        return [
            'bookingRules',
            r
        ];
    }
    renderHomeTab({ planLocked: planLocked, placeType: placeType, hidden: hidden, orderTypeEnabled: orderTypeEnabled, tipsEnabled: tipsEnabled, tableService: tableService, waitlistEnabled: waitlistEnabled, reservationsEnabled: reservationsEnabled, homeCards: homeCards, bookingRules: bookingRules, waitlistQuotes: waitlistQuotes }) {
        const body = document.getElementById('settingsHomeBody');
        if (!body) return;
        this._homeData = {
            bookingRules: bookingRules,
            waitlistQuotes: waitlistQuotes
        };
        const focusKey = document.activeElement?.closest?.('#settingsHomeBody') ? [
            'data-home-hide',
            'data-home-set',
            'data-table-level',
            'data-home-place',
            'data-home-suggest',
            'data-home-card',
            'data-home-cards-suggest',
            'data-book-day-on',
            'data-book-from',
            'data-book-to',
            'data-book-slot',
            'data-book-hold',
            'data-book-big-on',
            'data-book-big-size',
            'data-book-big-hold',
            'data-quote-new'
        ].map((a)=>document.activeElement.hasAttribute(a) ? `[${a}="${document.activeElement.getAttribute(a)}"]` : null).find(Boolean) : null;
        const hiddenSet = new Set(hidden);
        const shownRow = (item)=>{
            const pro = item.pro && planLocked ? ' <span class="pb-pro-badge">PRO</span>' : '';
            if (item.key === 'tables' && tableService === 'off') return this._homeRow(`${item.label}`, 'Shows when table service is on (below).', '<span class="home-set-muted">Off</span>');
            return this._homeRow(`${item.label}${pro}`, item.hint ?? '', this._homeSwitch('data-home-hide', item.key, !hiddenSet.has(item.key), `Show ${item.label}`));
        };
        const levels = [
            [
                'off',
                'Off',
                'No table step at checkout.'
            ],
            [
                'numbers',
                'Table numbers',
                'Checkout asks which table so staff can bring the order over.'
            ],
            [
                'full',
                'Full service',
                'Floor plan, open tabs, send to the kitchen, pay at the end. Set it up in Tables.'
            ]
        ];
        const level = levels.find((l)=>l[0] === tableService) ?? levels[0];
        body.innerHTML = `
      <section class="settings-section">
        <h3 class="settings-section-title">Type of place</h3>
        <p class="settings-section-hint">Used for the suggested setup. Changing it doesn't turn anything on or off by itself.</p>
        <div class="home-set-place">
          <select class="settings-select" data-home-place="1" aria-label="Type of place">
            <option value=""${placeType ? '' : ' selected'} disabled>Pick one</option>
            ${(0, $aa52f24595bb637d$export$4ee9af756839e9a2).map((p)=>`<option value="${p.id}"${p.id === placeType ? ' selected' : ''}>${p.label}</option>`).join('')}
          </select>
          <button type="button" class="btn home-set-suggest" data-home-suggest="1"${placeType ? '' : ' disabled'}>Use suggested setup</button>
        </div>
      </section>

      ${this._homeCardsSection(homeCards)}

      <section class="settings-section">
        <h3 class="settings-section-title">Manage menu</h3>
        <p class="settings-section-hint">Shortcuts on the home screen. Catalogue and Help always show. You can also tap Customize menu on the home screen.</p>
        <div class="settings-row-group">${(0, $aa52f24595bb637d$export$72137d7bdce4e014).filter((i)=>i.group === 'manage').map(shownRow).join('')}</div>
      </section>

      <section class="settings-section">
        <h3 class="settings-section-title">Screens menu</h3>
        <p class="settings-section-hint">The extra screens in the top bar.</p>
        <div class="settings-row-group">${(0, $aa52f24595bb637d$export$72137d7bdce4e014).filter((i)=>i.group === 'screens').map(shownRow).join('')}</div>
      </section>

      <section class="settings-section">
        <h3 class="settings-section-title">At checkout</h3>
        <div class="settings-row-group">
          ${this._homeRow('Dine in / Takeout', 'Pick one for every order.', this._homeSwitch('data-home-set', 'orderTypeEnabled', orderTypeEnabled, 'Dine in or Takeout at checkout'))}
          ${this._homeRow('Tips', 'Tip buttons at checkout. Set the amounts in POS settings.', this._homeSwitch('data-home-set', 'tipsEnabled', tipsEnabled, 'Tips at checkout'))}
          <div class="settings-row home-set-tables">
            <div class="settings-row-text">
              <p class="settings-row-label">Tables</p>
              <p class="settings-row-hint">${level[2]}</p>
            </div>
            <div class="home-set-seg" role="radiogroup" aria-label="Table service">
              ${levels.map(([id, name])=>`<button type="button" class="home-set-seg-btn${id === tableService ? ' home-set-seg-btn--on' : ''}" role="radio" aria-checked="${id === tableService}" data-table-level="${id}">${name}</button>`).join('')}
            </div>
          </div>
          ${tableService === 'full' ? `
            ${this._homeRow('Walk-in waitlist', 'For busy hours.', this._homeSwitch('data-home-set', 'waitlistEnabled', waitlistEnabled, 'Walk-in waitlist'), ' home-set-sub')}
            ${this._homeRow('Reservations', 'Book a table for a time.', this._homeSwitch('data-home-set', 'reservationsEnabled', reservationsEnabled, 'Reservations'), ' home-set-sub')}` : ''}
        </div>
      </section>

      ${tableService === 'full' ? this._bookingSection({
            bookingRules: bookingRules,
            waitlistQuotes: waitlistQuotes,
            waitlistEnabled: waitlistEnabled,
            reservationsEnabled: reservationsEnabled
        }) : ''}`;
        if (focusKey) body.querySelector(focusKey)?.focus();
    }
    // handlers: { onShown(key, shown), onSet(key, value), onPlace(id), onSuggested(),
    //             onCardSlot(slot, key), onCardsSuggested() }
    _addHandlerHomeTab(handlers) {
        const body = document.getElementById('settingsHomeBody');
        body?.addEventListener('change', (e)=>{
            const t = e.target;
            if (t.dataset.homeHide) handlers.onShown(t.dataset.homeHide, t.checked);
            else if (t.dataset.homeSet) handlers.onSet(t.dataset.homeSet, t.checked);
            else if (t.dataset.homePlace) handlers.onPlace(t.value);
            else if (t.dataset.homeCard) handlers.onCardSlot(t.dataset.homeCard, t.value);
            else {
                const change = this._bookingChange(t);
                if (change) handlers.onSet(...change);
            }
        });
        const addQuote = ()=>{
            const input = body.querySelector('[data-quote-new]');
            const n = Math.round(Number(input?.value));
            if (!Number.isFinite(n) || n < 1 || n > 600) {
                input?.focus();
                return;
            }
            handlers.onSet('waitlistQuotes', (0, $3c9e88a543a9da6a$export$9fda4dae54e434b4)([
                ...this._homeData.waitlistQuotes,
                n
            ]));
        };
        body?.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' && e.target.matches('[data-quote-new]')) {
                e.preventDefault();
                addQuote();
            }
        });
        body?.addEventListener('click', (e)=>{
            const lvl = e.target.closest('[data-table-level]');
            if (lvl) return handlers.onSet('tableService', lvl.dataset.tableLevel);
            if (e.target.closest('[data-home-cards-suggest]')) return handlers.onCardsSuggested();
            if (e.target.closest('[data-home-suggest]')) return handlers.onSuggested();
            const r = this._homeData?.bookingRules;
            const slot = e.target.closest('[data-book-slot]');
            if (slot) return handlers.onSet('bookingRules', {
                ...structuredClone(r),
                slotMin: Number(slot.dataset.bookSlot)
            });
            if (e.target.closest('[data-book-copy]')) {
                const from = r.hours[$6e66866c6dedb838$var$copyFrom(r)];
                return handlers.onSet('bookingRules', {
                    ...structuredClone(r),
                    hours: r.hours.map((h)=>h.on ? {
                            ...from
                        } : {
                            ...h
                        })
                });
            }
            const rm = e.target.closest('[data-quote-remove]');
            if (rm) return handlers.onSet('waitlistQuotes', (0, $3c9e88a543a9da6a$export$9fda4dae54e434b4)(this._homeData.waitlistQuotes.filter((n)=>n !== Number(rm.dataset.quoteRemove))));
            if (e.target.closest('[data-quote-add]')) return addQuote();
            if (e.target.closest('[data-quote-reset]')) handlers.onSet('waitlistQuotes', [
                ...(0, $3c9e88a543a9da6a$export$78a2a13284d3c159)
            ]);
        });
    }
}
var $6e66866c6dedb838$export$2e2bcd8739ae039 = new $6e66866c6dedb838$var$SettingsView();




var $cggJi = parcelRequire("cggJi");
// Invoice / receipt number formatting.
//
// The raw sequential number lives in `sales.receipt_number` and is assigned
// atomically per business by a DB trigger (see pointbunny-admin-updates.md), so
// it is gapless and race-safe. It starts at 1001 for every business.
//
// The DISPLAYED form is `INV-<year>-<number>`, where the year comes from the
// sale's own date (not "now"), so a historical sale always shows the year it was
// rung up in. The sequence itself is continuous across years - the year is a
// label only, it never resets the count.
function $78df0284a57ee0dd$export$1fa50150e73e75ba(receiptNumber, date) {
    if (receiptNumber == null) return null;
    const d = date ? new Date(date) : new Date();
    const year = isNaN(d.getTime()) ? new Date().getFullYear() : d.getFullYear();
    return `INV-${year}-${receiptNumber}`;
}
// The label printed before the number (e.g. "Invoice No.") - localized to the
// term each market legally expects. The DISPLAYED label changes only; the stored
// number format never does. Default is the universal "Invoice No.".
//   - US    : "Receipt No." (2026-10-10 - what US shoppers expect).
//   - PH    : BIR calls a goods receipt a "Sales Invoice".
//   - AU/NZ : GST law requires the wording "Tax Invoice".
const $78df0284a57ee0dd$var$SALES_INVOICE_COUNTRIES = new Set([
    'PH'
]);
const $78df0284a57ee0dd$var$TAX_INVOICE_COUNTRIES = new Set([
    'AU',
    'NZ'
]);
// Country comes from the explicit arg when available, else the value stashed in
// localStorage at login (so popup windows can localize too).
const $78df0284a57ee0dd$var$_country = (country)=>(country ?? (typeof localStorage !== 'undefined' ? localStorage.getItem('pointbunny_business_country') : '') ?? '').toUpperCase();
function $78df0284a57ee0dd$export$bb60034feb8a6f01(country) {
    const c = $78df0284a57ee0dd$var$_country(country);
    if ($78df0284a57ee0dd$var$SALES_INVOICE_COUNTRIES.has(c)) return 'Sales Invoice No.';
    if ($78df0284a57ee0dd$var$TAX_INVOICE_COUNTRIES.has(c)) return 'Tax Invoice No.';
    if (c === 'US') return 'Receipt No.'; // what US shoppers expect to see (2026-10-10)
    return 'Invoice No.';
}



var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");


var $dv0h8 = parcelRequire("dv0h8");
// Device-level receipt printing preferences (localStorage only - a laptop and an
// iPad in the same business can print through completely different printers).
//
// Two print methods exist, because a web app can only reach a printer two ways:
//   'system'    - the device's own print dialog. Covers USB, Wi-Fi/network and
//                 AirPrint printers, plus any printer with an installed driver.
//   'bluetooth' - raw ESC/POS bytes straight to a BLE thermal printer via Web
//                 Bluetooth (btPrinter.js). Chrome/Edge on Android + desktop only.
// No stored method = "auto" (the pre-2026-10-04 behavior): Bluetooth when a BLE
// printer is connected, otherwise the system dialog.
// Web Bluetooth thermal printer manager (singleton).
//
// Connects to a BLE ESC/POS thermal printer, keeps the handle for the session,
// and writes raw command bytes (from escpos.js) in MTU-sized chunks. It is
// generic: it pairs with `acceptAllDevices` and probes the GATT services for a
// writable characteristic, so it works with most no-name 58/80mm BLE printers
// without hardcoding a model.
//
// PLATFORM NOTE: Web Bluetooth exists only in Chrome/Edge on desktop and Chrome
// on Android. iOS/iPadOS Safari does NOT support it, so `isSupported()` returns
// false there and the app falls back to normal (HTML) printing - by design.
// It also reaches only BLE printers; Classic-Bluetooth-only (SPP) printers are
// invisible to the browser on every platform.
// GATT services commonly exposed by BLE thermal printers. Declared as
// optionalServices so the browser grants access to them after the user pairs.
const $fbad918341d4cd38$var$KNOWN_SERVICES = [
    "000018f0-0000-1000-8000-00805f9b34fb",
    "0000ff00-0000-1000-8000-00805f9b34fb",
    "0000ffe0-0000-1000-8000-00805f9b34fb",
    "0000fff0-0000-1000-8000-00805f9b34fb",
    "49535343-fe7d-4ae5-8fa9-9fafd205e455",
    "e7810a71-73ae-499d-8c15-faa9aef0c3f2"
];
const $fbad918341d4cd38$var$PAPER_WIDTH_KEY = "pointbunny_bt_paper_width";
const $fbad918341d4cd38$var$CHUNK = 180; // bytes per BLE write - safe under the common 512/185 MTU caps
// Windows' BLE stack is known to hang device.gatt.connect() indefinitely on a
// stale/idle-disconnected device instead of erroring - never let a reconnect
// attempt block the "connecting" state forever.
const $fbad918341d4cd38$var$CONNECT_TIMEOUT_MS = 8000;
const $fbad918341d4cd38$var$withTimeout = (promise, ms, message)=>{
    let timer;
    const timeout = new Promise((_, reject)=>{
        timer = setTimeout(()=>reject(new Error(message)), ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).finally(()=>clearTimeout(timer));
};
class $fbad918341d4cd38$var$BtPrinter {
    _device = null;
    _char = null;
    _reconnectPromise = null;
    isSupported() {
        return typeof navigator !== "undefined" && !!navigator.bluetooth;
    }
    isConnected() {
        return !!(this._device?.gatt?.connected && this._char);
    }
    get deviceName() {
        return this._device?.name || "Bluetooth printer";
    }
    // ESC/POS column width (58 or 80). The paper setting itself is owned by
    // printSettings.js; a 'full' (sheet printer) pick has no thermal meaning, so
    // it prints at 80mm here.
    paperWidth() {
        const v = Number(localStorage.getItem($fbad918341d4cd38$var$PAPER_WIDTH_KEY));
        return v === 58 || v === 80 ? v : 80;
    }
    async _findWritable(server) {
        const services = await server.getPrimaryServices();
        for (const svc of services){
            let chars;
            try {
                chars = await svc.getCharacteristics();
            } catch  {
                continue;
            }
            for (const c of chars){
                if (c.properties.write || c.properties.writeWithoutResponse) return c;
            }
        }
        return null;
    }
    async _attach(device) {
        const server = await $fbad918341d4cd38$var$withTimeout(device.gatt.connect(), $fbad918341d4cd38$var$CONNECT_TIMEOUT_MS, "Connection timed out - try Connect printer again.");
        const char = await this._findWritable(server);
        if (!char) {
            try {
                device.gatt.disconnect();
            } catch  {
            /* noop */ }
            throw new Error("No writable characteristic found on this printer.");
        }
        this._device = device;
        this._char = char;
        device.addEventListener("gattserverdisconnected", ()=>{
            this._char = null;
        });
    }
    // Opens the browser device chooser - MUST be called from a user gesture.
    async connect() {
        if (!this.isSupported()) throw new Error("Web Bluetooth is not supported on this browser/device.");
        const device = await navigator.bluetooth.requestDevice({
            acceptAllDevices: true,
            optionalServices: $fbad918341d4cd38$var$KNOWN_SERVICES
        });
        await this._attach(device);
        return this.deviceName;
    }
    // Silent reconnect to an already-permitted device (Chrome's getDevices()).
    // Returns true if (re)connected. Never throws. Concurrent callers (app boot,
    // Settings open, a print() that finds itself disconnected) share ONE in-flight
    // attempt - two overlapping device.gatt.connect() calls on the same device is
    // a likely trigger for the Windows hang the timeout above guards against.
    async reconnect() {
        if (!this.isSupported() || !navigator.bluetooth.getDevices) return false;
        if (this.isConnected()) return true;
        if (this._reconnectPromise) return this._reconnectPromise;
        this._reconnectPromise = (async ()=>{
            try {
                const devices = await navigator.bluetooth.getDevices();
                const device = devices[0];
                if (!device) return false;
                await this._attach(device);
                return true;
            } catch  {
                return false;
            } finally{
                this._reconnectPromise = null;
            }
        })();
        return this._reconnectPromise;
    }
    async disconnect() {
        try {
            this._device?.gatt?.disconnect();
        } catch  {
        /* noop */ }
        this._device = null;
        this._char = null;
    }
    async print(bytes) {
        if (!this.isConnected()) {
            const ok = await this.reconnect();
            if (!ok || !this.isConnected()) throw new Error("Bluetooth printer is not connected.");
        }
        const data = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
        const noResponse = this._char.properties.writeWithoutResponse && typeof this._char.writeValueWithoutResponse === "function";
        for(let i = 0; i < data.length; i += $fbad918341d4cd38$var$CHUNK){
            const slice = data.slice(i, i + $fbad918341d4cd38$var$CHUNK);
            if (noResponse) await this._char.writeValueWithoutResponse(slice);
            else await this._char.writeValue(slice);
            // brief pause so the printer's buffer keeps up with the stream
            await new Promise((r)=>setTimeout(r, 20));
        }
    }
}
var $fbad918341d4cd38$export$2e2bcd8739ae039 = new $fbad918341d4cd38$var$BtPrinter();


const $e289654e8a722fd2$var$METHOD_KEY = "pointbunny_print_method";
// Key kept from the Bluetooth-only era so existing devices keep their width.
const $e289654e8a722fd2$var$PAPER_KEY = "pointbunny_bt_paper_width";
const $e289654e8a722fd2$export$ec79c309e9a44c11 = (v)=>v === "full" ? "full" : Number(v) === 58 ? 58 : 80;
const $e289654e8a722fd2$var$read = (key)=>{
    try {
        return localStorage.getItem(key);
    } catch  {
        return null;
    }
};
const $e289654e8a722fd2$var$write = (key, value)=>{
    try {
        localStorage.setItem(key, value);
    } catch  {}
};
function $e289654e8a722fd2$export$f12273f2d5c5a16b() {
    const v = $e289654e8a722fd2$var$read($e289654e8a722fd2$var$PAPER_KEY);
    return v == null ? 80 : $e289654e8a722fd2$export$ec79c309e9a44c11(v);
}
function $e289654e8a722fd2$export$f68c9870378c39e3(v) {
    $e289654e8a722fd2$var$write($e289654e8a722fd2$var$PAPER_KEY, String($e289654e8a722fd2$export$ec79c309e9a44c11(v)));
}
function $e289654e8a722fd2$export$8793fab959da70d1() {
    const v = $e289654e8a722fd2$var$read($e289654e8a722fd2$var$METHOD_KEY);
    return v === "system" || v === "bluetooth" ? v : null;
}
function $e289654e8a722fd2$export$8c6ecab5174b959(m) {
    if (m === "system" || m === "bluetooth") $e289654e8a722fd2$var$write($e289654e8a722fd2$var$METHOD_KEY, m);
}
function $e289654e8a722fd2$export$bc2db93af29ea4e2(method = $e289654e8a722fd2$export$8793fab959da70d1()) {
    if (method === "bluetooth") return (0, $fbad918341d4cd38$export$2e2bcd8739ae039).isSupported() ? "bluetooth" : "system";
    if (method === "system") return "system";
    return (0, $fbad918341d4cd38$export$2e2bcd8739ae039).isConnected() ? "bluetooth" : "system";
}
async function $e289654e8a722fd2$export$be42772b78d4d1ee() {
    if (!(0, $fbad918341d4cd38$export$2e2bcd8739ae039).isSupported()) return "system";
    if ((0, $fbad918341d4cd38$export$2e2bcd8739ae039).isConnected()) return "bluetooth";
    try {
        const devices = await navigator.bluetooth.getDevices?.();
        return devices?.length ? "bluetooth" : "system";
    } catch  {
        return "system";
    }
}
// Where the receipt sits across the paper roll. Printers don't all feed or
// measure paper the same way (see the 58mm/80mm centering saga in
// pointbunny-app-todos.md), so no single CSS placement is right for every
// printer - the owner picks whichever looks right on a Test print.
//   'default' - flush left (the live-tuned placement every receipt used before)
//   'center'  - auto margins, for printers that leave a wide blank on the right
//   'left'    - nudged left, for printers that cut off the right edge
const $e289654e8a722fd2$var$POSITION_KEY = "pointbunny_receipt_position";
const $e289654e8a722fd2$export$24d4c6cf79ebd2a8 = (v)=>v === "center" || v === "left" ? v : "default";
function $e289654e8a722fd2$export$1690e12b840569b9() {
    return $e289654e8a722fd2$export$24d4c6cf79ebd2a8($e289654e8a722fd2$var$read($e289654e8a722fd2$var$POSITION_KEY));
}
function $e289654e8a722fd2$export$f9b088a47202d605(v) {
    $e289654e8a722fd2$var$write($e289654e8a722fd2$var$POSITION_KEY, $e289654e8a722fd2$export$24d4c6cf79ebd2a8(v));
}


// Feedback QR on receipts (Pro, 2026-10-10). The owner enters a link in
// Settings > POS > Receipt Content (businesses.settings.receiptQrUrl); the
// receipt prints it as a QR code under the custom footer. One matrix feeds
// both renderers: an inline SVG for the HTML receipt (receiptView.js) and a
// raster image for ESC/POS thermal printers (escpos.js).
var $0bb27d30dabfa365$exports = {};
//---------------------------------------------------------------------
//
// QR Code Generator for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//  http://www.opensource.org/licenses/mit-license.php
//
// The word 'QR Code' is registered trademark of
// DENSO WAVE INCORPORATED
//  http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
var $0bb27d30dabfa365$var$qrcode = function() {
    //---------------------------------------------------------------------
    // qrcode
    //---------------------------------------------------------------------
    /**
   * qrcode
   * @param typeNumber 1 to 40
   * @param errorCorrectionLevel 'L','M','Q','H'
   */ var qrcode = function(typeNumber, errorCorrectionLevel) {
        var PAD0 = 0xEC;
        var PAD1 = 0x11;
        var _typeNumber = typeNumber;
        var _errorCorrectionLevel = QRErrorCorrectionLevel[errorCorrectionLevel];
        var _modules = null;
        var _moduleCount = 0;
        var _dataCache = null;
        var _dataList = [];
        var _this = {};
        var makeImpl = function(test, maskPattern) {
            _moduleCount = _typeNumber * 4 + 17;
            _modules = function(moduleCount) {
                var modules = new Array(moduleCount);
                for(var row = 0; row < moduleCount; row += 1){
                    modules[row] = new Array(moduleCount);
                    for(var col = 0; col < moduleCount; col += 1)modules[row][col] = null;
                }
                return modules;
            }(_moduleCount);
            setupPositionProbePattern(0, 0);
            setupPositionProbePattern(_moduleCount - 7, 0);
            setupPositionProbePattern(0, _moduleCount - 7);
            setupPositionAdjustPattern();
            setupTimingPattern();
            setupTypeInfo(test, maskPattern);
            if (_typeNumber >= 7) setupTypeNumber(test);
            if (_dataCache == null) _dataCache = createData(_typeNumber, _errorCorrectionLevel, _dataList);
            mapData(_dataCache, maskPattern);
        };
        var setupPositionProbePattern = function(row, col) {
            for(var r = -1; r <= 7; r += 1){
                if (row + r <= -1 || _moduleCount <= row + r) continue;
                for(var c = -1; c <= 7; c += 1){
                    if (col + c <= -1 || _moduleCount <= col + c) continue;
                    if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) _modules[row + r][col + c] = true;
                    else _modules[row + r][col + c] = false;
                }
            }
        };
        var getBestMaskPattern = function() {
            var minLostPoint = 0;
            var pattern = 0;
            for(var i = 0; i < 8; i += 1){
                makeImpl(true, i);
                var lostPoint = QRUtil.getLostPoint(_this);
                if (i == 0 || minLostPoint > lostPoint) {
                    minLostPoint = lostPoint;
                    pattern = i;
                }
            }
            return pattern;
        };
        var setupTimingPattern = function() {
            for(var r = 8; r < _moduleCount - 8; r += 1){
                if (_modules[r][6] != null) continue;
                _modules[r][6] = r % 2 == 0;
            }
            for(var c = 8; c < _moduleCount - 8; c += 1){
                if (_modules[6][c] != null) continue;
                _modules[6][c] = c % 2 == 0;
            }
        };
        var setupPositionAdjustPattern = function() {
            var pos = QRUtil.getPatternPosition(_typeNumber);
            for(var i = 0; i < pos.length; i += 1)for(var j = 0; j < pos.length; j += 1){
                var row = pos[i];
                var col = pos[j];
                if (_modules[row][col] != null) continue;
                for(var r = -2; r <= 2; r += 1){
                    for(var c = -2; c <= 2; c += 1)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) _modules[row + r][col + c] = true;
                    else _modules[row + r][col + c] = false;
                }
            }
        };
        var setupTypeNumber = function(test) {
            var bits = QRUtil.getBCHTypeNumber(_typeNumber);
            for(var i = 0; i < 18; i += 1){
                var mod = !test && (bits >> i & 1) == 1;
                _modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod;
            }
            for(var i = 0; i < 18; i += 1){
                var mod = !test && (bits >> i & 1) == 1;
                _modules[i % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
            }
        };
        var setupTypeInfo = function(test, maskPattern) {
            var data = _errorCorrectionLevel << 3 | maskPattern;
            var bits = QRUtil.getBCHTypeInfo(data);
            // vertical
            for(var i = 0; i < 15; i += 1){
                var mod = !test && (bits >> i & 1) == 1;
                if (i < 6) _modules[i][8] = mod;
                else if (i < 8) _modules[i + 1][8] = mod;
                else _modules[_moduleCount - 15 + i][8] = mod;
            }
            // horizontal
            for(var i = 0; i < 15; i += 1){
                var mod = !test && (bits >> i & 1) == 1;
                if (i < 8) _modules[8][_moduleCount - i - 1] = mod;
                else if (i < 9) _modules[8][15 - i - 1 + 1] = mod;
                else _modules[8][15 - i - 1] = mod;
            }
            // fixed module
            _modules[_moduleCount - 8][8] = !test;
        };
        var mapData = function(data, maskPattern) {
            var inc = -1;
            var row = _moduleCount - 1;
            var bitIndex = 7;
            var byteIndex = 0;
            var maskFunc = QRUtil.getMaskFunction(maskPattern);
            for(var col = _moduleCount - 1; col > 0; col -= 2){
                if (col == 6) col -= 1;
                while(true){
                    for(var c = 0; c < 2; c += 1)if (_modules[row][col - c] == null) {
                        var dark = false;
                        if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                        var mask = maskFunc(row, col - c);
                        if (mask) dark = !dark;
                        _modules[row][col - c] = dark;
                        bitIndex -= 1;
                        if (bitIndex == -1) {
                            byteIndex += 1;
                            bitIndex = 7;
                        }
                    }
                    row += inc;
                    if (row < 0 || _moduleCount <= row) {
                        row -= inc;
                        inc = -inc;
                        break;
                    }
                }
            }
        };
        var createBytes = function(buffer, rsBlocks) {
            var offset = 0;
            var maxDcCount = 0;
            var maxEcCount = 0;
            var dcdata = new Array(rsBlocks.length);
            var ecdata = new Array(rsBlocks.length);
            for(var r = 0; r < rsBlocks.length; r += 1){
                var dcCount = rsBlocks[r].dataCount;
                var ecCount = rsBlocks[r].totalCount - dcCount;
                maxDcCount = Math.max(maxDcCount, dcCount);
                maxEcCount = Math.max(maxEcCount, ecCount);
                dcdata[r] = new Array(dcCount);
                for(var i = 0; i < dcdata[r].length; i += 1)dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
                offset += dcCount;
                var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
                var rawPoly = qrPolynomial(dcdata[r], rsPoly.getLength() - 1);
                var modPoly = rawPoly.mod(rsPoly);
                ecdata[r] = new Array(rsPoly.getLength() - 1);
                for(var i = 0; i < ecdata[r].length; i += 1){
                    var modIndex = i + modPoly.getLength() - ecdata[r].length;
                    ecdata[r][i] = modIndex >= 0 ? modPoly.getAt(modIndex) : 0;
                }
            }
            var totalCodeCount = 0;
            for(var i = 0; i < rsBlocks.length; i += 1)totalCodeCount += rsBlocks[i].totalCount;
            var data = new Array(totalCodeCount);
            var index = 0;
            for(var i = 0; i < maxDcCount; i += 1){
                for(var r = 0; r < rsBlocks.length; r += 1)if (i < dcdata[r].length) {
                    data[index] = dcdata[r][i];
                    index += 1;
                }
            }
            for(var i = 0; i < maxEcCount; i += 1){
                for(var r = 0; r < rsBlocks.length; r += 1)if (i < ecdata[r].length) {
                    data[index] = ecdata[r][i];
                    index += 1;
                }
            }
            return data;
        };
        var createData = function(typeNumber, errorCorrectionLevel, dataList) {
            var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectionLevel);
            var buffer = qrBitBuffer();
            for(var i = 0; i < dataList.length; i += 1){
                var data = dataList[i];
                buffer.put(data.getMode(), 4);
                buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber));
                data.write(buffer);
            }
            // calc num max data.
            var totalDataCount = 0;
            for(var i = 0; i < rsBlocks.length; i += 1)totalDataCount += rsBlocks[i].dataCount;
            if (buffer.getLengthInBits() > totalDataCount * 8) throw 'code length overflow. (' + buffer.getLengthInBits() + '>' + totalDataCount * 8 + ')';
            // end code
            if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
            // padding
            while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
            // padding
            while(true){
                if (buffer.getLengthInBits() >= totalDataCount * 8) break;
                buffer.put(PAD0, 8);
                if (buffer.getLengthInBits() >= totalDataCount * 8) break;
                buffer.put(PAD1, 8);
            }
            return createBytes(buffer, rsBlocks);
        };
        _this.addData = function(data, mode) {
            mode = mode || 'Byte';
            var newData = null;
            switch(mode){
                case 'Numeric':
                    newData = qrNumber(data);
                    break;
                case 'Alphanumeric':
                    newData = qrAlphaNum(data);
                    break;
                case 'Byte':
                    newData = qr8BitByte(data);
                    break;
                case 'Kanji':
                    newData = qrKanji(data);
                    break;
                default:
                    throw 'mode:' + mode;
            }
            _dataList.push(newData);
            _dataCache = null;
        };
        _this.isDark = function(row, col) {
            if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) throw row + ',' + col;
            return _modules[row][col];
        };
        _this.getModuleCount = function() {
            return _moduleCount;
        };
        _this.make = function() {
            if (_typeNumber < 1) {
                var typeNumber = 1;
                for(; typeNumber < 40; typeNumber++){
                    var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, _errorCorrectionLevel);
                    var buffer = qrBitBuffer();
                    for(var i = 0; i < _dataList.length; i++){
                        var data = _dataList[i];
                        buffer.put(data.getMode(), 4);
                        buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber));
                        data.write(buffer);
                    }
                    var totalDataCount = 0;
                    for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
                    if (buffer.getLengthInBits() <= totalDataCount * 8) break;
                }
                _typeNumber = typeNumber;
            }
            makeImpl(false, getBestMaskPattern());
        };
        _this.createTableTag = function(cellSize, margin) {
            cellSize = cellSize || 2;
            margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
            var qrHtml = '';
            qrHtml += '<table style="';
            qrHtml += ' border-width: 0px; border-style: none;';
            qrHtml += ' border-collapse: collapse;';
            qrHtml += ' padding: 0px; margin: ' + margin + 'px;';
            qrHtml += '">';
            qrHtml += '<tbody>';
            for(var r = 0; r < _this.getModuleCount(); r += 1){
                qrHtml += '<tr>';
                for(var c = 0; c < _this.getModuleCount(); c += 1){
                    qrHtml += '<td style="';
                    qrHtml += ' border-width: 0px; border-style: none;';
                    qrHtml += ' border-collapse: collapse;';
                    qrHtml += ' padding: 0px; margin: 0px;';
                    qrHtml += ' width: ' + cellSize + 'px;';
                    qrHtml += ' height: ' + cellSize + 'px;';
                    qrHtml += ' background-color: ';
                    qrHtml += _this.isDark(r, c) ? '#000000' : '#ffffff';
                    qrHtml += ';';
                    qrHtml += '"/>';
                }
                qrHtml += '</tr>';
            }
            qrHtml += '</tbody>';
            qrHtml += '</table>';
            return qrHtml;
        };
        _this.createSvgTag = function(cellSize, margin, alt, title) {
            var opts = {};
            if (typeof arguments[0] == 'object') {
                // Called by options.
                opts = arguments[0];
                // overwrite cellSize and margin.
                cellSize = opts.cellSize;
                margin = opts.margin;
                alt = opts.alt;
                title = opts.title;
            }
            cellSize = cellSize || 2;
            margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
            // Compose alt property surrogate
            alt = typeof alt === 'string' ? {
                text: alt
            } : alt || {};
            alt.text = alt.text || null;
            alt.id = alt.text ? alt.id || 'qrcode-description' : null;
            // Compose title property surrogate
            title = typeof title === 'string' ? {
                text: title
            } : title || {};
            title.text = title.text || null;
            title.id = title.text ? title.id || 'qrcode-title' : null;
            var size = _this.getModuleCount() * cellSize + margin * 2;
            var c, mc, r, mr, qrSvg = '', rect;
            rect = 'l' + cellSize + ',0 0,' + cellSize + ' -' + cellSize + ',0 0,-' + cellSize + 'z ';
            qrSvg += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"';
            qrSvg += !opts.scalable ? ' width="' + size + 'px" height="' + size + 'px"' : '';
            qrSvg += ' viewBox="0 0 ' + size + ' ' + size + '" ';
            qrSvg += ' preserveAspectRatio="xMinYMin meet"';
            qrSvg += title.text || alt.text ? ' role="img" aria-labelledby="' + escapeXml([
                title.id,
                alt.id
            ].join(' ').trim()) + '"' : '';
            qrSvg += '>';
            qrSvg += title.text ? '<title id="' + escapeXml(title.id) + '">' + escapeXml(title.text) + '</title>' : '';
            qrSvg += alt.text ? '<description id="' + escapeXml(alt.id) + '">' + escapeXml(alt.text) + '</description>' : '';
            qrSvg += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>';
            qrSvg += '<path d="';
            for(r = 0; r < _this.getModuleCount(); r += 1){
                mr = r * cellSize + margin;
                for(c = 0; c < _this.getModuleCount(); c += 1)if (_this.isDark(r, c)) {
                    mc = c * cellSize + margin;
                    qrSvg += 'M' + mc + ',' + mr + rect;
                }
            }
            qrSvg += '" stroke="transparent" fill="black"/>';
            qrSvg += '</svg>';
            return qrSvg;
        };
        _this.createDataURL = function(cellSize, margin) {
            cellSize = cellSize || 2;
            margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
            var size = _this.getModuleCount() * cellSize + margin * 2;
            var min = margin;
            var max = size - margin;
            return createDataURL(size, size, function(x, y) {
                if (min <= x && x < max && min <= y && y < max) {
                    var c = Math.floor((x - min) / cellSize);
                    var r = Math.floor((y - min) / cellSize);
                    return _this.isDark(r, c) ? 0 : 1;
                } else return 1;
            });
        };
        _this.createImgTag = function(cellSize, margin, alt) {
            cellSize = cellSize || 2;
            margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
            var size = _this.getModuleCount() * cellSize + margin * 2;
            var img = '';
            img += '<img';
            img += '\u0020src="';
            img += _this.createDataURL(cellSize, margin);
            img += '"';
            img += '\u0020width="';
            img += size;
            img += '"';
            img += '\u0020height="';
            img += size;
            img += '"';
            if (alt) {
                img += '\u0020alt="';
                img += escapeXml(alt);
                img += '"';
            }
            img += '/>';
            return img;
        };
        var escapeXml = function(s) {
            var escaped = '';
            for(var i = 0; i < s.length; i += 1){
                var c = s.charAt(i);
                switch(c){
                    case '<':
                        escaped += '&lt;';
                        break;
                    case '>':
                        escaped += '&gt;';
                        break;
                    case '&':
                        escaped += '&amp;';
                        break;
                    case '"':
                        escaped += '&quot;';
                        break;
                    default:
                        escaped += c;
                        break;
                }
            }
            return escaped;
        };
        var _createHalfASCII = function(margin) {
            var cellSize = 1;
            margin = typeof margin == 'undefined' ? cellSize * 2 : margin;
            var size = _this.getModuleCount() * cellSize + margin * 2;
            var min = margin;
            var max = size - margin;
            var y, x, r1, r2, p;
            var blocks = {
                "\u2588\u2588": "\u2588",
                "\u2588 ": "\u2580",
                " \u2588": "\u2584",
                '  ': ' '
            };
            var blocksLastLineNoMargin = {
                "\u2588\u2588": "\u2580",
                "\u2588 ": "\u2580",
                " \u2588": ' ',
                '  ': ' '
            };
            var ascii = '';
            for(y = 0; y < size; y += 2){
                r1 = Math.floor((y - min) / cellSize);
                r2 = Math.floor((y + 1 - min) / cellSize);
                for(x = 0; x < size; x += 1){
                    p = "\u2588";
                    if (min <= x && x < max && min <= y && y < max && _this.isDark(r1, Math.floor((x - min) / cellSize))) p = ' ';
                    if (min <= x && x < max && min <= y + 1 && y + 1 < max && _this.isDark(r2, Math.floor((x - min) / cellSize))) p += ' ';
                    else p += "\u2588";
                    // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                    ascii += margin < 1 && y + 1 >= max ? blocksLastLineNoMargin[p] : blocks[p];
                }
                ascii += '\n';
            }
            if (size % 2 && margin > 0) return ascii.substring(0, ascii.length - size - 1) + Array(size + 1).join("\u2580");
            return ascii.substring(0, ascii.length - 1);
        };
        _this.createASCII = function(cellSize, margin) {
            cellSize = cellSize || 1;
            if (cellSize < 2) return _createHalfASCII(margin);
            cellSize -= 1;
            margin = typeof margin == 'undefined' ? cellSize * 2 : margin;
            var size = _this.getModuleCount() * cellSize + margin * 2;
            var min = margin;
            var max = size - margin;
            var y, x, r, p;
            var white = Array(cellSize + 1).join("\u2588\u2588");
            var black = Array(cellSize + 1).join('  ');
            var ascii = '';
            var line = '';
            for(y = 0; y < size; y += 1){
                r = Math.floor((y - min) / cellSize);
                line = '';
                for(x = 0; x < size; x += 1){
                    p = 1;
                    if (min <= x && x < max && min <= y && y < max && _this.isDark(r, Math.floor((x - min) / cellSize))) p = 0;
                    // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                    line += p ? white : black;
                }
                for(r = 0; r < cellSize; r += 1)ascii += line + '\n';
            }
            return ascii.substring(0, ascii.length - 1);
        };
        _this.renderTo2dContext = function(context, cellSize) {
            cellSize = cellSize || 2;
            var length = _this.getModuleCount();
            for(var row = 0; row < length; row++)for(var col = 0; col < length; col++){
                context.fillStyle = _this.isDark(row, col) ? 'black' : 'white';
                context.fillRect(row * cellSize, col * cellSize, cellSize, cellSize);
            }
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // qrcode.stringToBytes
    //---------------------------------------------------------------------
    qrcode.stringToBytesFuncs = {
        'default': function(s) {
            var bytes = [];
            for(var i = 0; i < s.length; i += 1){
                var c = s.charCodeAt(i);
                bytes.push(c & 0xff);
            }
            return bytes;
        }
    };
    qrcode.stringToBytes = qrcode.stringToBytesFuncs['default'];
    //---------------------------------------------------------------------
    // qrcode.createStringToBytes
    //---------------------------------------------------------------------
    /**
   * @param unicodeData base64 string of byte array.
   * [16bit Unicode],[16bit Bytes], ...
   * @param numChars
   */ qrcode.createStringToBytes = function(unicodeData, numChars) {
        // create conversion map.
        var unicodeMap = function() {
            var bin = base64DecodeInputStream(unicodeData);
            var read = function() {
                var b = bin.read();
                if (b == -1) throw 'eof';
                return b;
            };
            var count = 0;
            var unicodeMap = {};
            while(true){
                var b0 = bin.read();
                if (b0 == -1) break;
                var b1 = read();
                var b2 = read();
                var b3 = read();
                var k = String.fromCharCode(b0 << 8 | b1);
                var v = b2 << 8 | b3;
                unicodeMap[k] = v;
                count += 1;
            }
            if (count != numChars) throw count + ' != ' + numChars;
            return unicodeMap;
        }();
        var unknownChar = '?'.charCodeAt(0);
        return function(s) {
            var bytes = [];
            for(var i = 0; i < s.length; i += 1){
                var c = s.charCodeAt(i);
                if (c < 128) bytes.push(c);
                else {
                    var b = unicodeMap[s.charAt(i)];
                    if (typeof b == 'number') {
                        if ((b & 0xff) == b) // 1byte
                        bytes.push(b);
                        else {
                            // 2bytes
                            bytes.push(b >>> 8);
                            bytes.push(b & 0xff);
                        }
                    } else bytes.push(unknownChar);
                }
            }
            return bytes;
        };
    };
    //---------------------------------------------------------------------
    // QRMode
    //---------------------------------------------------------------------
    var QRMode = {
        MODE_NUMBER: 1,
        MODE_ALPHA_NUM: 2,
        MODE_8BIT_BYTE: 4,
        MODE_KANJI: 8
    };
    //---------------------------------------------------------------------
    // QRErrorCorrectionLevel
    //---------------------------------------------------------------------
    var QRErrorCorrectionLevel = {
        L: 1,
        M: 0,
        Q: 3,
        H: 2
    };
    //---------------------------------------------------------------------
    // QRMaskPattern
    //---------------------------------------------------------------------
    var QRMaskPattern = {
        PATTERN000: 0,
        PATTERN001: 1,
        PATTERN010: 2,
        PATTERN011: 3,
        PATTERN100: 4,
        PATTERN101: 5,
        PATTERN110: 6,
        PATTERN111: 7
    };
    //---------------------------------------------------------------------
    // QRUtil
    //---------------------------------------------------------------------
    var QRUtil = function() {
        var PATTERN_POSITION_TABLE = [
            [],
            [
                6,
                18
            ],
            [
                6,
                22
            ],
            [
                6,
                26
            ],
            [
                6,
                30
            ],
            [
                6,
                34
            ],
            [
                6,
                22,
                38
            ],
            [
                6,
                24,
                42
            ],
            [
                6,
                26,
                46
            ],
            [
                6,
                28,
                50
            ],
            [
                6,
                30,
                54
            ],
            [
                6,
                32,
                58
            ],
            [
                6,
                34,
                62
            ],
            [
                6,
                26,
                46,
                66
            ],
            [
                6,
                26,
                48,
                70
            ],
            [
                6,
                26,
                50,
                74
            ],
            [
                6,
                30,
                54,
                78
            ],
            [
                6,
                30,
                56,
                82
            ],
            [
                6,
                30,
                58,
                86
            ],
            [
                6,
                34,
                62,
                90
            ],
            [
                6,
                28,
                50,
                72,
                94
            ],
            [
                6,
                26,
                50,
                74,
                98
            ],
            [
                6,
                30,
                54,
                78,
                102
            ],
            [
                6,
                28,
                54,
                80,
                106
            ],
            [
                6,
                32,
                58,
                84,
                110
            ],
            [
                6,
                30,
                58,
                86,
                114
            ],
            [
                6,
                34,
                62,
                90,
                118
            ],
            [
                6,
                26,
                50,
                74,
                98,
                122
            ],
            [
                6,
                30,
                54,
                78,
                102,
                126
            ],
            [
                6,
                26,
                52,
                78,
                104,
                130
            ],
            [
                6,
                30,
                56,
                82,
                108,
                134
            ],
            [
                6,
                34,
                60,
                86,
                112,
                138
            ],
            [
                6,
                30,
                58,
                86,
                114,
                142
            ],
            [
                6,
                34,
                62,
                90,
                118,
                146
            ],
            [
                6,
                30,
                54,
                78,
                102,
                126,
                150
            ],
            [
                6,
                24,
                50,
                76,
                102,
                128,
                154
            ],
            [
                6,
                28,
                54,
                80,
                106,
                132,
                158
            ],
            [
                6,
                32,
                58,
                84,
                110,
                136,
                162
            ],
            [
                6,
                26,
                54,
                82,
                110,
                138,
                166
            ],
            [
                6,
                30,
                58,
                86,
                114,
                142,
                170
            ]
        ];
        var G15 = 1335;
        var G18 = 7973;
        var G15_MASK = 21522;
        var _this = {};
        var getBCHDigit = function(data) {
            var digit = 0;
            while(data != 0){
                digit += 1;
                data >>>= 1;
            }
            return digit;
        };
        _this.getBCHTypeInfo = function(data) {
            var d = data << 10;
            while(getBCHDigit(d) - getBCHDigit(G15) >= 0)d ^= G15 << getBCHDigit(d) - getBCHDigit(G15);
            return (data << 10 | d) ^ G15_MASK;
        };
        _this.getBCHTypeNumber = function(data) {
            var d = data << 12;
            while(getBCHDigit(d) - getBCHDigit(G18) >= 0)d ^= G18 << getBCHDigit(d) - getBCHDigit(G18);
            return data << 12 | d;
        };
        _this.getPatternPosition = function(typeNumber) {
            return PATTERN_POSITION_TABLE[typeNumber - 1];
        };
        _this.getMaskFunction = function(maskPattern) {
            switch(maskPattern){
                case QRMaskPattern.PATTERN000:
                    return function(i, j) {
                        return (i + j) % 2 == 0;
                    };
                case QRMaskPattern.PATTERN001:
                    return function(i, j) {
                        return i % 2 == 0;
                    };
                case QRMaskPattern.PATTERN010:
                    return function(i, j) {
                        return j % 3 == 0;
                    };
                case QRMaskPattern.PATTERN011:
                    return function(i, j) {
                        return (i + j) % 3 == 0;
                    };
                case QRMaskPattern.PATTERN100:
                    return function(i, j) {
                        return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
                    };
                case QRMaskPattern.PATTERN101:
                    return function(i, j) {
                        return i * j % 2 + i * j % 3 == 0;
                    };
                case QRMaskPattern.PATTERN110:
                    return function(i, j) {
                        return (i * j % 2 + i * j % 3) % 2 == 0;
                    };
                case QRMaskPattern.PATTERN111:
                    return function(i, j) {
                        return (i * j % 3 + (i + j) % 2) % 2 == 0;
                    };
                default:
                    throw 'bad maskPattern:' + maskPattern;
            }
        };
        _this.getErrorCorrectPolynomial = function(errorCorrectLength) {
            var a = qrPolynomial([
                1
            ], 0);
            for(var i = 0; i < errorCorrectLength; i += 1)a = a.multiply(qrPolynomial([
                1,
                QRMath.gexp(i)
            ], 0));
            return a;
        };
        _this.getLengthInBits = function(mode, type) {
            if (1 <= type && type < 10) // 1 - 9
            switch(mode){
                case QRMode.MODE_NUMBER:
                    return 10;
                case QRMode.MODE_ALPHA_NUM:
                    return 9;
                case QRMode.MODE_8BIT_BYTE:
                    return 8;
                case QRMode.MODE_KANJI:
                    return 8;
                default:
                    throw 'mode:' + mode;
            }
            else if (type < 27) // 10 - 26
            switch(mode){
                case QRMode.MODE_NUMBER:
                    return 12;
                case QRMode.MODE_ALPHA_NUM:
                    return 11;
                case QRMode.MODE_8BIT_BYTE:
                    return 16;
                case QRMode.MODE_KANJI:
                    return 10;
                default:
                    throw 'mode:' + mode;
            }
            else if (type < 41) // 27 - 40
            switch(mode){
                case QRMode.MODE_NUMBER:
                    return 14;
                case QRMode.MODE_ALPHA_NUM:
                    return 13;
                case QRMode.MODE_8BIT_BYTE:
                    return 16;
                case QRMode.MODE_KANJI:
                    return 12;
                default:
                    throw 'mode:' + mode;
            }
            else throw 'type:' + type;
        };
        _this.getLostPoint = function(qrcode) {
            var moduleCount = qrcode.getModuleCount();
            var lostPoint = 0;
            // LEVEL1
            for(var row = 0; row < moduleCount; row += 1)for(var col = 0; col < moduleCount; col += 1){
                var sameCount = 0;
                var dark = qrcode.isDark(row, col);
                for(var r = -1; r <= 1; r += 1){
                    if (row + r < 0 || moduleCount <= row + r) continue;
                    for(var c = -1; c <= 1; c += 1){
                        if (col + c < 0 || moduleCount <= col + c) continue;
                        if (r == 0 && c == 0) continue;
                        if (dark == qrcode.isDark(row + r, col + c)) sameCount += 1;
                    }
                }
                if (sameCount > 5) lostPoint += 3 + sameCount - 5;
            }
            // LEVEL2
            for(var row = 0; row < moduleCount - 1; row += 1)for(var col = 0; col < moduleCount - 1; col += 1){
                var count = 0;
                if (qrcode.isDark(row, col)) count += 1;
                if (qrcode.isDark(row + 1, col)) count += 1;
                if (qrcode.isDark(row, col + 1)) count += 1;
                if (qrcode.isDark(row + 1, col + 1)) count += 1;
                if (count == 0 || count == 4) lostPoint += 3;
            }
            // LEVEL3
            for(var row = 0; row < moduleCount; row += 1){
                for(var col = 0; col < moduleCount - 6; col += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row, col + 1) && qrcode.isDark(row, col + 2) && qrcode.isDark(row, col + 3) && qrcode.isDark(row, col + 4) && !qrcode.isDark(row, col + 5) && qrcode.isDark(row, col + 6)) lostPoint += 40;
            }
            for(var col = 0; col < moduleCount; col += 1){
                for(var row = 0; row < moduleCount - 6; row += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row + 1, col) && qrcode.isDark(row + 2, col) && qrcode.isDark(row + 3, col) && qrcode.isDark(row + 4, col) && !qrcode.isDark(row + 5, col) && qrcode.isDark(row + 6, col)) lostPoint += 40;
            }
            // LEVEL4
            var darkCount = 0;
            for(var col = 0; col < moduleCount; col += 1){
                for(var row = 0; row < moduleCount; row += 1)if (qrcode.isDark(row, col)) darkCount += 1;
            }
            var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
            lostPoint += ratio * 10;
            return lostPoint;
        };
        return _this;
    }();
    //---------------------------------------------------------------------
    // QRMath
    //---------------------------------------------------------------------
    var QRMath = function() {
        var EXP_TABLE = new Array(256);
        var LOG_TABLE = new Array(256);
        // initialize tables
        for(var i = 0; i < 8; i += 1)EXP_TABLE[i] = 1 << i;
        for(var i = 8; i < 256; i += 1)EXP_TABLE[i] = EXP_TABLE[i - 4] ^ EXP_TABLE[i - 5] ^ EXP_TABLE[i - 6] ^ EXP_TABLE[i - 8];
        for(var i = 0; i < 255; i += 1)LOG_TABLE[EXP_TABLE[i]] = i;
        var _this = {};
        _this.glog = function(n) {
            if (n < 1) throw 'glog(' + n + ')';
            return LOG_TABLE[n];
        };
        _this.gexp = function(n) {
            while(n < 0)n += 255;
            while(n >= 256)n -= 255;
            return EXP_TABLE[n];
        };
        return _this;
    }();
    //---------------------------------------------------------------------
    // qrPolynomial
    //---------------------------------------------------------------------
    function qrPolynomial(num, shift) {
        if (typeof num.length == 'undefined') throw num.length + '/' + shift;
        var _num = function() {
            var offset = 0;
            while(offset < num.length && num[offset] == 0)offset += 1;
            var _num = new Array(num.length - offset + shift);
            for(var i = 0; i < num.length - offset; i += 1)_num[i] = num[i + offset];
            return _num;
        }();
        var _this = {};
        _this.getAt = function(index) {
            return _num[index];
        };
        _this.getLength = function() {
            return _num.length;
        };
        _this.multiply = function(e) {
            var num = new Array(_this.getLength() + e.getLength() - 1);
            for(var i = 0; i < _this.getLength(); i += 1)for(var j = 0; j < e.getLength(); j += 1)num[i + j] ^= QRMath.gexp(QRMath.glog(_this.getAt(i)) + QRMath.glog(e.getAt(j)));
            return qrPolynomial(num, 0);
        };
        _this.mod = function(e) {
            if (_this.getLength() - e.getLength() < 0) return _this;
            var ratio = QRMath.glog(_this.getAt(0)) - QRMath.glog(e.getAt(0));
            var num = new Array(_this.getLength());
            for(var i = 0; i < _this.getLength(); i += 1)num[i] = _this.getAt(i);
            for(var i = 0; i < e.getLength(); i += 1)num[i] ^= QRMath.gexp(QRMath.glog(e.getAt(i)) + ratio);
            // recursive call
            return qrPolynomial(num, 0).mod(e);
        };
        return _this;
    }
    //---------------------------------------------------------------------
    // QRRSBlock
    //---------------------------------------------------------------------
    var QRRSBlock = function() {
        var RS_BLOCK_TABLE = [
            // L
            // M
            // Q
            // H
            // 1
            [
                1,
                26,
                19
            ],
            [
                1,
                26,
                16
            ],
            [
                1,
                26,
                13
            ],
            [
                1,
                26,
                9
            ],
            // 2
            [
                1,
                44,
                34
            ],
            [
                1,
                44,
                28
            ],
            [
                1,
                44,
                22
            ],
            [
                1,
                44,
                16
            ],
            // 3
            [
                1,
                70,
                55
            ],
            [
                1,
                70,
                44
            ],
            [
                2,
                35,
                17
            ],
            [
                2,
                35,
                13
            ],
            // 4
            [
                1,
                100,
                80
            ],
            [
                2,
                50,
                32
            ],
            [
                2,
                50,
                24
            ],
            [
                4,
                25,
                9
            ],
            // 5
            [
                1,
                134,
                108
            ],
            [
                2,
                67,
                43
            ],
            [
                2,
                33,
                15,
                2,
                34,
                16
            ],
            [
                2,
                33,
                11,
                2,
                34,
                12
            ],
            // 6
            [
                2,
                86,
                68
            ],
            [
                4,
                43,
                27
            ],
            [
                4,
                43,
                19
            ],
            [
                4,
                43,
                15
            ],
            // 7
            [
                2,
                98,
                78
            ],
            [
                4,
                49,
                31
            ],
            [
                2,
                32,
                14,
                4,
                33,
                15
            ],
            [
                4,
                39,
                13,
                1,
                40,
                14
            ],
            // 8
            [
                2,
                121,
                97
            ],
            [
                2,
                60,
                38,
                2,
                61,
                39
            ],
            [
                4,
                40,
                18,
                2,
                41,
                19
            ],
            [
                4,
                40,
                14,
                2,
                41,
                15
            ],
            // 9
            [
                2,
                146,
                116
            ],
            [
                3,
                58,
                36,
                2,
                59,
                37
            ],
            [
                4,
                36,
                16,
                4,
                37,
                17
            ],
            [
                4,
                36,
                12,
                4,
                37,
                13
            ],
            // 10
            [
                2,
                86,
                68,
                2,
                87,
                69
            ],
            [
                4,
                69,
                43,
                1,
                70,
                44
            ],
            [
                6,
                43,
                19,
                2,
                44,
                20
            ],
            [
                6,
                43,
                15,
                2,
                44,
                16
            ],
            // 11
            [
                4,
                101,
                81
            ],
            [
                1,
                80,
                50,
                4,
                81,
                51
            ],
            [
                4,
                50,
                22,
                4,
                51,
                23
            ],
            [
                3,
                36,
                12,
                8,
                37,
                13
            ],
            // 12
            [
                2,
                116,
                92,
                2,
                117,
                93
            ],
            [
                6,
                58,
                36,
                2,
                59,
                37
            ],
            [
                4,
                46,
                20,
                6,
                47,
                21
            ],
            [
                7,
                42,
                14,
                4,
                43,
                15
            ],
            // 13
            [
                4,
                133,
                107
            ],
            [
                8,
                59,
                37,
                1,
                60,
                38
            ],
            [
                8,
                44,
                20,
                4,
                45,
                21
            ],
            [
                12,
                33,
                11,
                4,
                34,
                12
            ],
            // 14
            [
                3,
                145,
                115,
                1,
                146,
                116
            ],
            [
                4,
                64,
                40,
                5,
                65,
                41
            ],
            [
                11,
                36,
                16,
                5,
                37,
                17
            ],
            [
                11,
                36,
                12,
                5,
                37,
                13
            ],
            // 15
            [
                5,
                109,
                87,
                1,
                110,
                88
            ],
            [
                5,
                65,
                41,
                5,
                66,
                42
            ],
            [
                5,
                54,
                24,
                7,
                55,
                25
            ],
            [
                11,
                36,
                12,
                7,
                37,
                13
            ],
            // 16
            [
                5,
                122,
                98,
                1,
                123,
                99
            ],
            [
                7,
                73,
                45,
                3,
                74,
                46
            ],
            [
                15,
                43,
                19,
                2,
                44,
                20
            ],
            [
                3,
                45,
                15,
                13,
                46,
                16
            ],
            // 17
            [
                1,
                135,
                107,
                5,
                136,
                108
            ],
            [
                10,
                74,
                46,
                1,
                75,
                47
            ],
            [
                1,
                50,
                22,
                15,
                51,
                23
            ],
            [
                2,
                42,
                14,
                17,
                43,
                15
            ],
            // 18
            [
                5,
                150,
                120,
                1,
                151,
                121
            ],
            [
                9,
                69,
                43,
                4,
                70,
                44
            ],
            [
                17,
                50,
                22,
                1,
                51,
                23
            ],
            [
                2,
                42,
                14,
                19,
                43,
                15
            ],
            // 19
            [
                3,
                141,
                113,
                4,
                142,
                114
            ],
            [
                3,
                70,
                44,
                11,
                71,
                45
            ],
            [
                17,
                47,
                21,
                4,
                48,
                22
            ],
            [
                9,
                39,
                13,
                16,
                40,
                14
            ],
            // 20
            [
                3,
                135,
                107,
                5,
                136,
                108
            ],
            [
                3,
                67,
                41,
                13,
                68,
                42
            ],
            [
                15,
                54,
                24,
                5,
                55,
                25
            ],
            [
                15,
                43,
                15,
                10,
                44,
                16
            ],
            // 21
            [
                4,
                144,
                116,
                4,
                145,
                117
            ],
            [
                17,
                68,
                42
            ],
            [
                17,
                50,
                22,
                6,
                51,
                23
            ],
            [
                19,
                46,
                16,
                6,
                47,
                17
            ],
            // 22
            [
                2,
                139,
                111,
                7,
                140,
                112
            ],
            [
                17,
                74,
                46
            ],
            [
                7,
                54,
                24,
                16,
                55,
                25
            ],
            [
                34,
                37,
                13
            ],
            // 23
            [
                4,
                151,
                121,
                5,
                152,
                122
            ],
            [
                4,
                75,
                47,
                14,
                76,
                48
            ],
            [
                11,
                54,
                24,
                14,
                55,
                25
            ],
            [
                16,
                45,
                15,
                14,
                46,
                16
            ],
            // 24
            [
                6,
                147,
                117,
                4,
                148,
                118
            ],
            [
                6,
                73,
                45,
                14,
                74,
                46
            ],
            [
                11,
                54,
                24,
                16,
                55,
                25
            ],
            [
                30,
                46,
                16,
                2,
                47,
                17
            ],
            // 25
            [
                8,
                132,
                106,
                4,
                133,
                107
            ],
            [
                8,
                75,
                47,
                13,
                76,
                48
            ],
            [
                7,
                54,
                24,
                22,
                55,
                25
            ],
            [
                22,
                45,
                15,
                13,
                46,
                16
            ],
            // 26
            [
                10,
                142,
                114,
                2,
                143,
                115
            ],
            [
                19,
                74,
                46,
                4,
                75,
                47
            ],
            [
                28,
                50,
                22,
                6,
                51,
                23
            ],
            [
                33,
                46,
                16,
                4,
                47,
                17
            ],
            // 27
            [
                8,
                152,
                122,
                4,
                153,
                123
            ],
            [
                22,
                73,
                45,
                3,
                74,
                46
            ],
            [
                8,
                53,
                23,
                26,
                54,
                24
            ],
            [
                12,
                45,
                15,
                28,
                46,
                16
            ],
            // 28
            [
                3,
                147,
                117,
                10,
                148,
                118
            ],
            [
                3,
                73,
                45,
                23,
                74,
                46
            ],
            [
                4,
                54,
                24,
                31,
                55,
                25
            ],
            [
                11,
                45,
                15,
                31,
                46,
                16
            ],
            // 29
            [
                7,
                146,
                116,
                7,
                147,
                117
            ],
            [
                21,
                73,
                45,
                7,
                74,
                46
            ],
            [
                1,
                53,
                23,
                37,
                54,
                24
            ],
            [
                19,
                45,
                15,
                26,
                46,
                16
            ],
            // 30
            [
                5,
                145,
                115,
                10,
                146,
                116
            ],
            [
                19,
                75,
                47,
                10,
                76,
                48
            ],
            [
                15,
                54,
                24,
                25,
                55,
                25
            ],
            [
                23,
                45,
                15,
                25,
                46,
                16
            ],
            // 31
            [
                13,
                145,
                115,
                3,
                146,
                116
            ],
            [
                2,
                74,
                46,
                29,
                75,
                47
            ],
            [
                42,
                54,
                24,
                1,
                55,
                25
            ],
            [
                23,
                45,
                15,
                28,
                46,
                16
            ],
            // 32
            [
                17,
                145,
                115
            ],
            [
                10,
                74,
                46,
                23,
                75,
                47
            ],
            [
                10,
                54,
                24,
                35,
                55,
                25
            ],
            [
                19,
                45,
                15,
                35,
                46,
                16
            ],
            // 33
            [
                17,
                145,
                115,
                1,
                146,
                116
            ],
            [
                14,
                74,
                46,
                21,
                75,
                47
            ],
            [
                29,
                54,
                24,
                19,
                55,
                25
            ],
            [
                11,
                45,
                15,
                46,
                46,
                16
            ],
            // 34
            [
                13,
                145,
                115,
                6,
                146,
                116
            ],
            [
                14,
                74,
                46,
                23,
                75,
                47
            ],
            [
                44,
                54,
                24,
                7,
                55,
                25
            ],
            [
                59,
                46,
                16,
                1,
                47,
                17
            ],
            // 35
            [
                12,
                151,
                121,
                7,
                152,
                122
            ],
            [
                12,
                75,
                47,
                26,
                76,
                48
            ],
            [
                39,
                54,
                24,
                14,
                55,
                25
            ],
            [
                22,
                45,
                15,
                41,
                46,
                16
            ],
            // 36
            [
                6,
                151,
                121,
                14,
                152,
                122
            ],
            [
                6,
                75,
                47,
                34,
                76,
                48
            ],
            [
                46,
                54,
                24,
                10,
                55,
                25
            ],
            [
                2,
                45,
                15,
                64,
                46,
                16
            ],
            // 37
            [
                17,
                152,
                122,
                4,
                153,
                123
            ],
            [
                29,
                74,
                46,
                14,
                75,
                47
            ],
            [
                49,
                54,
                24,
                10,
                55,
                25
            ],
            [
                24,
                45,
                15,
                46,
                46,
                16
            ],
            // 38
            [
                4,
                152,
                122,
                18,
                153,
                123
            ],
            [
                13,
                74,
                46,
                32,
                75,
                47
            ],
            [
                48,
                54,
                24,
                14,
                55,
                25
            ],
            [
                42,
                45,
                15,
                32,
                46,
                16
            ],
            // 39
            [
                20,
                147,
                117,
                4,
                148,
                118
            ],
            [
                40,
                75,
                47,
                7,
                76,
                48
            ],
            [
                43,
                54,
                24,
                22,
                55,
                25
            ],
            [
                10,
                45,
                15,
                67,
                46,
                16
            ],
            // 40
            [
                19,
                148,
                118,
                6,
                149,
                119
            ],
            [
                18,
                75,
                47,
                31,
                76,
                48
            ],
            [
                34,
                54,
                24,
                34,
                55,
                25
            ],
            [
                20,
                45,
                15,
                61,
                46,
                16
            ]
        ];
        var qrRSBlock = function(totalCount, dataCount) {
            var _this = {};
            _this.totalCount = totalCount;
            _this.dataCount = dataCount;
            return _this;
        };
        var _this = {};
        var getRsBlockTable = function(typeNumber, errorCorrectionLevel) {
            switch(errorCorrectionLevel){
                case QRErrorCorrectionLevel.L:
                    return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
                case QRErrorCorrectionLevel.M:
                    return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
                case QRErrorCorrectionLevel.Q:
                    return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
                case QRErrorCorrectionLevel.H:
                    return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
                default:
                    return undefined;
            }
        };
        _this.getRSBlocks = function(typeNumber, errorCorrectionLevel) {
            var rsBlock = getRsBlockTable(typeNumber, errorCorrectionLevel);
            if (typeof rsBlock == 'undefined') throw 'bad rs block @ typeNumber:' + typeNumber + '/errorCorrectionLevel:' + errorCorrectionLevel;
            var length = rsBlock.length / 3;
            var list = [];
            for(var i = 0; i < length; i += 1){
                var count = rsBlock[i * 3 + 0];
                var totalCount = rsBlock[i * 3 + 1];
                var dataCount = rsBlock[i * 3 + 2];
                for(var j = 0; j < count; j += 1)list.push(qrRSBlock(totalCount, dataCount));
            }
            return list;
        };
        return _this;
    }();
    //---------------------------------------------------------------------
    // qrBitBuffer
    //---------------------------------------------------------------------
    var qrBitBuffer = function() {
        var _buffer = [];
        var _length = 0;
        var _this = {};
        _this.getBuffer = function() {
            return _buffer;
        };
        _this.getAt = function(index) {
            var bufIndex = Math.floor(index / 8);
            return (_buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
        };
        _this.put = function(num, length) {
            for(var i = 0; i < length; i += 1)_this.putBit((num >>> length - i - 1 & 1) == 1);
        };
        _this.getLengthInBits = function() {
            return _length;
        };
        _this.putBit = function(bit) {
            var bufIndex = Math.floor(_length / 8);
            if (_buffer.length <= bufIndex) _buffer.push(0);
            if (bit) _buffer[bufIndex] |= 0x80 >>> _length % 8;
            _length += 1;
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // qrNumber
    //---------------------------------------------------------------------
    var qrNumber = function(data) {
        var _mode = QRMode.MODE_NUMBER;
        var _data = data;
        var _this = {};
        _this.getMode = function() {
            return _mode;
        };
        _this.getLength = function(buffer) {
            return _data.length;
        };
        _this.write = function(buffer) {
            var data = _data;
            var i = 0;
            while(i + 2 < data.length){
                buffer.put(strToNum(data.substring(i, i + 3)), 10);
                i += 3;
            }
            if (i < data.length) {
                if (data.length - i == 1) buffer.put(strToNum(data.substring(i, i + 1)), 4);
                else if (data.length - i == 2) buffer.put(strToNum(data.substring(i, i + 2)), 7);
            }
        };
        var strToNum = function(s) {
            var num = 0;
            for(var i = 0; i < s.length; i += 1)num = num * 10 + chatToNum(s.charAt(i));
            return num;
        };
        var chatToNum = function(c) {
            if ('0' <= c && c <= '9') return c.charCodeAt(0) - '0'.charCodeAt(0);
            throw 'illegal char :' + c;
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // qrAlphaNum
    //---------------------------------------------------------------------
    var qrAlphaNum = function(data) {
        var _mode = QRMode.MODE_ALPHA_NUM;
        var _data = data;
        var _this = {};
        _this.getMode = function() {
            return _mode;
        };
        _this.getLength = function(buffer) {
            return _data.length;
        };
        _this.write = function(buffer) {
            var s = _data;
            var i = 0;
            while(i + 1 < s.length){
                buffer.put(getCode(s.charAt(i)) * 45 + getCode(s.charAt(i + 1)), 11);
                i += 2;
            }
            if (i < s.length) buffer.put(getCode(s.charAt(i)), 6);
        };
        var getCode = function(c) {
            if ('0' <= c && c <= '9') return c.charCodeAt(0) - '0'.charCodeAt(0);
            else if ('A' <= c && c <= 'Z') return c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
            else switch(c){
                case ' ':
                    return 36;
                case '$':
                    return 37;
                case '%':
                    return 38;
                case '*':
                    return 39;
                case '+':
                    return 40;
                case '-':
                    return 41;
                case '.':
                    return 42;
                case '/':
                    return 43;
                case ':':
                    return 44;
                default:
                    throw 'illegal char :' + c;
            }
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // qr8BitByte
    //---------------------------------------------------------------------
    var qr8BitByte = function(data) {
        var _mode = QRMode.MODE_8BIT_BYTE;
        var _data = data;
        var _bytes = qrcode.stringToBytes(data);
        var _this = {};
        _this.getMode = function() {
            return _mode;
        };
        _this.getLength = function(buffer) {
            return _bytes.length;
        };
        _this.write = function(buffer) {
            for(var i = 0; i < _bytes.length; i += 1)buffer.put(_bytes[i], 8);
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // qrKanji
    //---------------------------------------------------------------------
    var qrKanji = function(data) {
        var _mode = QRMode.MODE_KANJI;
        var _data = data;
        var stringToBytes = qrcode.stringToBytesFuncs['SJIS'];
        if (!stringToBytes) throw 'sjis not supported.';
        !function(c, code) {
            // self test for sjis support.
            var test = stringToBytes(c);
            if (test.length != 2 || (test[0] << 8 | test[1]) != code) throw 'sjis not supported.';
        }('\u53cb', 0x9746);
        var _bytes = stringToBytes(data);
        var _this = {};
        _this.getMode = function() {
            return _mode;
        };
        _this.getLength = function(buffer) {
            return ~~(_bytes.length / 2);
        };
        _this.write = function(buffer) {
            var data = _bytes;
            var i = 0;
            while(i + 1 < data.length){
                var c = (0xff & data[i]) << 8 | 0xff & data[i + 1];
                if (0x8140 <= c && c <= 0x9FFC) c -= 0x8140;
                else if (0xE040 <= c && c <= 0xEBBF) c -= 0xC140;
                else throw 'illegal char at ' + (i + 1) + '/' + c;
                c = (c >>> 8 & 0xff) * 0xC0 + (c & 0xff);
                buffer.put(c, 13);
                i += 2;
            }
            if (i < data.length) throw 'illegal char at ' + (i + 1);
        };
        return _this;
    };
    //=====================================================================
    // GIF Support etc.
    //
    //---------------------------------------------------------------------
    // byteArrayOutputStream
    //---------------------------------------------------------------------
    var byteArrayOutputStream = function() {
        var _bytes = [];
        var _this = {};
        _this.writeByte = function(b) {
            _bytes.push(b & 0xff);
        };
        _this.writeShort = function(i) {
            _this.writeByte(i);
            _this.writeByte(i >>> 8);
        };
        _this.writeBytes = function(b, off, len) {
            off = off || 0;
            len = len || b.length;
            for(var i = 0; i < len; i += 1)_this.writeByte(b[i + off]);
        };
        _this.writeString = function(s) {
            for(var i = 0; i < s.length; i += 1)_this.writeByte(s.charCodeAt(i));
        };
        _this.toByteArray = function() {
            return _bytes;
        };
        _this.toString = function() {
            var s = '';
            s += '[';
            for(var i = 0; i < _bytes.length; i += 1){
                if (i > 0) s += ',';
                s += _bytes[i];
            }
            s += ']';
            return s;
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // base64EncodeOutputStream
    //---------------------------------------------------------------------
    var base64EncodeOutputStream = function() {
        var _buffer = 0;
        var _buflen = 0;
        var _length = 0;
        var _base64 = '';
        var _this = {};
        var writeEncoded = function(b) {
            _base64 += String.fromCharCode(encode(b & 0x3f));
        };
        var encode = function(n) {
            if (n < 0) ;
            else if (n < 26) return 0x41 + n;
            else if (n < 52) return 0x61 + (n - 26);
            else if (n < 62) return 0x30 + (n - 52);
            else if (n == 62) return 0x2b;
            else if (n == 63) return 0x2f;
            throw 'n:' + n;
        };
        _this.writeByte = function(n) {
            _buffer = _buffer << 8 | n & 0xff;
            _buflen += 8;
            _length += 1;
            while(_buflen >= 6){
                writeEncoded(_buffer >>> _buflen - 6);
                _buflen -= 6;
            }
        };
        _this.flush = function() {
            if (_buflen > 0) {
                writeEncoded(_buffer << 6 - _buflen);
                _buffer = 0;
                _buflen = 0;
            }
            if (_length % 3 != 0) {
                // padding
                var padlen = 3 - _length % 3;
                for(var i = 0; i < padlen; i += 1)_base64 += '=';
            }
        };
        _this.toString = function() {
            return _base64;
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // base64DecodeInputStream
    //---------------------------------------------------------------------
    var base64DecodeInputStream = function(str) {
        var _str = str;
        var _pos = 0;
        var _buffer = 0;
        var _buflen = 0;
        var _this = {};
        _this.read = function() {
            while(_buflen < 8){
                if (_pos >= _str.length) {
                    if (_buflen == 0) return -1;
                    throw 'unexpected end of file./' + _buflen;
                }
                var c = _str.charAt(_pos);
                _pos += 1;
                if (c == '=') {
                    _buflen = 0;
                    return -1;
                } else if (c.match(/^\s$/)) continue;
                _buffer = _buffer << 6 | decode(c.charCodeAt(0));
                _buflen += 6;
            }
            var n = _buffer >>> _buflen - 8 & 0xff;
            _buflen -= 8;
            return n;
        };
        var decode = function(c) {
            if (0x41 <= c && c <= 0x5a) return c - 0x41;
            else if (0x61 <= c && c <= 0x7a) return c - 0x61 + 26;
            else if (0x30 <= c && c <= 0x39) return c - 0x30 + 52;
            else if (c == 0x2b) return 62;
            else if (c == 0x2f) return 63;
            else throw 'c:' + c;
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // gifImage (B/W)
    //---------------------------------------------------------------------
    var gifImage = function(width, height) {
        var _width = width;
        var _height = height;
        var _data = new Array(width * height);
        var _this = {};
        _this.setPixel = function(x, y, pixel) {
            _data[y * _width + x] = pixel;
        };
        _this.write = function(out) {
            //---------------------------------
            // GIF Signature
            out.writeString('GIF87a');
            //---------------------------------
            // Screen Descriptor
            out.writeShort(_width);
            out.writeShort(_height);
            out.writeByte(0x80); // 2bit
            out.writeByte(0);
            out.writeByte(0);
            //---------------------------------
            // Global Color Map
            // black
            out.writeByte(0x00);
            out.writeByte(0x00);
            out.writeByte(0x00);
            // white
            out.writeByte(0xff);
            out.writeByte(0xff);
            out.writeByte(0xff);
            //---------------------------------
            // Image Descriptor
            out.writeString(',');
            out.writeShort(0);
            out.writeShort(0);
            out.writeShort(_width);
            out.writeShort(_height);
            out.writeByte(0);
            //---------------------------------
            // Local Color Map
            //---------------------------------
            // Raster Data
            var lzwMinCodeSize = 2;
            var raster = getLZWRaster(lzwMinCodeSize);
            out.writeByte(lzwMinCodeSize);
            var offset = 0;
            while(raster.length - offset > 255){
                out.writeByte(255);
                out.writeBytes(raster, offset, 255);
                offset += 255;
            }
            out.writeByte(raster.length - offset);
            out.writeBytes(raster, offset, raster.length - offset);
            out.writeByte(0x00);
            //---------------------------------
            // GIF Terminator
            out.writeString(';');
        };
        var bitOutputStream = function(out) {
            var _out = out;
            var _bitLength = 0;
            var _bitBuffer = 0;
            var _this = {};
            _this.write = function(data, length) {
                if (data >>> length != 0) throw 'length over';
                while(_bitLength + length >= 8){
                    _out.writeByte(0xff & (data << _bitLength | _bitBuffer));
                    length -= 8 - _bitLength;
                    data >>>= 8 - _bitLength;
                    _bitBuffer = 0;
                    _bitLength = 0;
                }
                _bitBuffer = data << _bitLength | _bitBuffer;
                _bitLength = _bitLength + length;
            };
            _this.flush = function() {
                if (_bitLength > 0) _out.writeByte(_bitBuffer);
            };
            return _this;
        };
        var getLZWRaster = function(lzwMinCodeSize) {
            var clearCode = 1 << lzwMinCodeSize;
            var endCode = (1 << lzwMinCodeSize) + 1;
            var bitLength = lzwMinCodeSize + 1;
            // Setup LZWTable
            var table = lzwTable();
            for(var i = 0; i < clearCode; i += 1)table.add(String.fromCharCode(i));
            table.add(String.fromCharCode(clearCode));
            table.add(String.fromCharCode(endCode));
            var byteOut = byteArrayOutputStream();
            var bitOut = bitOutputStream(byteOut);
            // clear code
            bitOut.write(clearCode, bitLength);
            var dataIndex = 0;
            var s = String.fromCharCode(_data[dataIndex]);
            dataIndex += 1;
            while(dataIndex < _data.length){
                var c = String.fromCharCode(_data[dataIndex]);
                dataIndex += 1;
                if (table.contains(s + c)) s = s + c;
                else {
                    bitOut.write(table.indexOf(s), bitLength);
                    if (table.size() < 0xfff) {
                        if (table.size() == 1 << bitLength) bitLength += 1;
                        table.add(s + c);
                    }
                    s = c;
                }
            }
            bitOut.write(table.indexOf(s), bitLength);
            // end code
            bitOut.write(endCode, bitLength);
            bitOut.flush();
            return byteOut.toByteArray();
        };
        var lzwTable = function() {
            var _map = {};
            var _size = 0;
            var _this = {};
            _this.add = function(key) {
                if (_this.contains(key)) throw 'dup key:' + key;
                _map[key] = _size;
                _size += 1;
            };
            _this.size = function() {
                return _size;
            };
            _this.indexOf = function(key) {
                return _map[key];
            };
            _this.contains = function(key) {
                return typeof _map[key] != 'undefined';
            };
            return _this;
        };
        return _this;
    };
    var createDataURL = function(width, height, getPixel) {
        var gif = gifImage(width, height);
        for(var y = 0; y < height; y += 1)for(var x = 0; x < width; x += 1)gif.setPixel(x, y, getPixel(x, y));
        var b = byteArrayOutputStream();
        gif.write(b);
        var base64 = base64EncodeOutputStream();
        var bytes = b.toByteArray();
        for(var i = 0; i < bytes.length; i += 1)base64.writeByte(bytes[i]);
        base64.flush();
        return 'data:image/gif;base64,' + base64;
    };
    //---------------------------------------------------------------------
    // returns qrcode function.
    return qrcode;
}();
// multibyte support
!function() {
    $0bb27d30dabfa365$var$qrcode.stringToBytesFuncs['UTF-8'] = function(s) {
        // http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
        function toUTF8Array(str) {
            var utf8 = [];
            for(var i = 0; i < str.length; i++){
                var charcode = str.charCodeAt(i);
                if (charcode < 0x80) utf8.push(charcode);
                else if (charcode < 0x800) utf8.push(0xc0 | charcode >> 6, 0x80 | charcode & 0x3f);
                else if (charcode < 0xd800 || charcode >= 0xe000) utf8.push(0xe0 | charcode >> 12, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
                else {
                    i++;
                    // UTF-16 encodes 0x10000-0x10FFFF by
                    // subtracting 0x10000 and splitting the
                    // 20 bits of 0x0-0xFFFFF into two halves
                    charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                    utf8.push(0xf0 | charcode >> 18, 0x80 | charcode >> 12 & 0x3f, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
                }
            }
            return utf8;
        }
        return toUTF8Array(s);
    };
}();
(function(factory) {
    if (typeof define === 'function' && define.amd) define([], factory);
    else $0bb27d30dabfa365$exports = factory();
})(function() {
    return $0bb27d30dabfa365$var$qrcode;
});


const $9db03be56d1ffd3b$export$695f1890d710f56 = 300;
const $9db03be56d1ffd3b$export$5a9e70c95c4f2bbb = function(url) {
    const v = String(url ?? "").trim();
    if (!v || v.length > $9db03be56d1ffd3b$export$695f1890d710f56) return false;
    try {
        return new URL(v).protocol === "https:";
    } catch  {
        return false;
    }
};
const $9db03be56d1ffd3b$export$7ec6fdd2f863a10d = function(url) {
    if (!$9db03be56d1ffd3b$export$5a9e70c95c4f2bbb(url)) return null;
    const qr = (0, (/*@__PURE__*/$parcel$interopDefault($0bb27d30dabfa365$exports)))(0, "M");
    qr.addData(String(url).trim());
    qr.make();
    const size = qr.getModuleCount();
    return {
        size: size,
        dark: (r, c)=>qr.isDark(r, c)
    };
};
const $9db03be56d1ffd3b$export$dc1ff443e897fb03 = function(url, mm = 28) {
    const m = $9db03be56d1ffd3b$export$7ec6fdd2f863a10d(url);
    if (!m) return "";
    const q = 4;
    const n = m.size + q * 2;
    let d = "";
    for(let r = 0; r < m.size; r++){
        for(let c = 0; c < m.size; c++)if (m.dark(r, c)) d += `M${c + q} ${r + q}h1v1h-1z`;
    }
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${n} ${n}" width="${mm}mm" height="${mm}mm" shape-rendering="crispEdges" role="img" aria-label="QR code"><rect width="${n}" height="${n}" fill="#fff"/><path d="${d}" fill="#000"/></svg>`;
};


class $9d7a2f48e7d0ba3e$var$ReceiptView extends (0, $081656bd50f85abd$export$2e2bcd8739ae039) {
    // Builds the receipt as separable pieces so it can print either as its own
    // document (popup / iframe) or inside the app page itself (iOS - see
    // _printInPage). `css(root)` scopes every rule under `root` ('body' for the
    // standalone document). `width` is 58 | 80 | 'full' (normal sheet printer:
    // an 80mm-wide receipt centered on whatever page size the printer uses).
    // `position` ('default' | 'center' | 'left', see printSettings.js) defaults
    // to this device's saved choice; Test print passes the staged one.
    _receiptParts(sale, { width: width = 80, position: position = (0, $e289654e8a722fd2$export$1690e12b840569b9)() } = {}) {
        const paper = (0, $e289654e8a722fd2$export$ec79c309e9a44c11)(width);
        const isFull = paper === "full";
        const mm = isFull ? 80 : paper;
        // The printer's actual print pipeline (Windows driver, not our own Web
        // Bluetooth path) renders on a physical page wider than the 58mm we
        // request, leaving the flush-left receipt off-center - live-measured by
        // Kelly, tuned 0.5in -> 0.25in -> 0.125in -> 0. 80mm wasn't reported as
        // needing this.
        const marginLeft = mm === 58 ? "0" : "0";
        // At 80mm the printable area is narrower than the requested page - the
        // right edge of every price line was getting sliced off. Live-measured
        // at ~1/8in cut off, then tuned another 1/8in further (0.25in total).
        const contentWidth = isFull ? "80mm" : mm === 80 ? "calc(80mm - 0.25in)" : `${mm}mm`;
        // Bottom of the receipt gets cut off on real hardware. A -1in top margin
        // was tried to reclaim space by pulling content up, but it overshot and
        // clipped the HEADER (store name/address) off the top instead - reverted.
        // Do not reposition vertically again without a precise measurement from
        // Kelly; the real fix is likely shortening total content height, not
        // shifting position (see pointbunny-app-todos.md for the same lesson
        // learned on horizontal centering).
        const marginTop = "0";
        // Money on the receipt follows the sale's country currency (falls back to the
        // active business currency for older sales without a stored country).
        const m = (n)=>(0, $coRoT.formatMoney)(n, sale.addressCountry ? {
                code: (0, $coRoT.currencyForCountry)(sale.addressCountry)
            } : {});
        const date = new Date(sale.date);
        const dateStr = date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric"
        });
        const timeStr = date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit"
        });
        // Free-item reward redemptions show as $0 on the item's own row instead
        // (see itemsHtml below) - excluded here so the discount isn't listed twice.
        const redeemedLineIds = (0, $dv0h8.redeemedRewardLineIds)(sale.adjustments);
        const activeAdj = (sale.adjustments ?? []).filter((a)=>!a.removed && a.computedAmount !== undefined && a.source !== "loyalty_reward");
        const removedAdj = sale.showRemovedAdjustments ? sale.removedAdjustments ?? [] : [];
        const storeName = (0, $cnCXJ.esc)(sale.storeName?.includes("@") ? "POINTBUNNY POS" : sale.storeName ?? "POINTBUNNY POS");
        const paymentMethod = sale.paymentMethod ?? "cash";
        const paymentLabel = {
            cash: "Cash",
            card: "Card",
            qr: "QR"
        }[paymentMethod] ?? "Cash";
        // Tax-inclusive breakdown: when the prices already include tax, show the
        // extracted VAT/GST portion (total is unchanged). Nothing when not inclusive.
        // Per-item exemption (2026-07-07): tax is extracted only from the taxable
        // portion; exempt items get their own gross line instead. Gated on the sale
        // actually being tax-inclusive (not on taxableGross > 0) so a sale that's
        // ENTIRELY exempt items still shows its exempt-sales line, just no VAT rows.
        const isInclusiveSale = Number(sale.taxInclusiveRate) > 0;
        const { taxableGross: taxableGross, exemptGross: exemptGross } = (0, $ff150a18d4a6f5bb$export$1a11748b971a7a75)(sale.items, (it)=>it.taxClass === "exempt");
        const vat = isInclusiveSale ? (0, $ff150a18d4a6f5bb$export$b07c8f45d340b388)(taxableGross, sale.taxInclusiveRate) : null;
        const vatLbl = (0, $cnCXJ.esc)((0, $ff150a18d4a6f5bb$export$c829991a0e9a63)(sale.addressCountry));
        const vatRows = vat ? `
    <tr>
      <td style="font-size:11px;padding:2px 4px 1px 0;">${vatLbl}able Sales</td>
      <td style="font-size:11px;text-align:right;">${m(vat.net)}</td>
    </tr>
    <tr>
      <td style="font-size:11px;padding:1px 4px 2px 0;">${vatLbl} (${vat.rate}%)</td>
      <td style="font-size:11px;text-align:right;">${m(vat.tax)}</td>
    </tr>` : "";
        // Tax added at checkout: a sale with a tax line also lists its exempt sales.
        const hasAddedTax = (sale.adjustments ?? []).some((a)=>a.isTax && !a.removed);
        const exemptRow = (isInclusiveSale || hasAddedTax) && exemptGross > 0 ? `
    <tr>
      <td style="font-size:11px;padding:1px 4px 2px 0;">${(0, $ff150a18d4a6f5bb$export$d9b10f19e66f377b)(sale.addressCountry)} Sales</td>
      <td style="font-size:11px;text-align:right;">${m(exemptGross)}</td>
    </tr>` : "";
        const itemsHtml = sale.items.map((item)=>{
            const variants = (0, $cnCXJ.esc)(item.selectedVariants?.map((v)=>v.variantName).join(", ") ?? "");
            const isFreeReward = redeemedLineIds.has(item.lineId);
            const priceHtml = isFreeReward ? `<span style="text-decoration:line-through;color:#888;">${m(item.totalPrice)}</span> ${m(0)}` : m(item.totalPrice);
            return `
        <tr>
          <td style="padding:2px 4px 2px 0;vertical-align:top;">${(0, $cnCXJ.esc)(item.itemName)} x${item.quantity}</td>
          <td style="padding:2px 0;text-align:right;vertical-align:top;white-space:nowrap;">${priceHtml}</td>
        </tr>
        ${variants ? `<tr><td colspan="2" style="font-size:10px;color:#555;padding:0 0 4px 0;">${variants}</td></tr>` : ""}
      `;
        }).join("");
        const hasAdj = activeAdj.length > 0 || removedAdj.length > 0;
        const adjSection = hasAdj ? `
      <hr class="divider">
      <table>
        <tr>
          <td style="padding:2px 4px 2px 0;font-size:11px;">Subtotal</td>
          <td style="text-align:right;font-size:11px;">${m(sale.subtotal ?? sale.totalPrice)}</td>
        </tr>
        ${activeAdj.map((adj)=>`
          <tr>
            <td style="padding:1px 4px 1px 0;font-size:11px;">${(0, $cnCXJ.esc)(adj.name)}${adj.calculation === "percentage" ? ` (${adj.appliedValue}%)` : ""}</td>
            <td style="text-align:right;font-size:11px;">${adj.computedAmount >= 0 ? "+" : "-"}${m(Math.abs(adj.computedAmount))}</td>
          </tr>
        `).join("")}
        ${removedAdj.map((adj)=>`
          <tr style="text-decoration:line-through;opacity:0.5;">
            <td style="padding:1px 4px 1px 0;font-size:11px;">${(0, $cnCXJ.esc)(adj.name)}${adj.calculation === "percentage" ? ` (${adj.appliedValue}%)` : ""} (removed)</td>
            <td style="text-align:right;font-size:11px;">--</td>
          </tr>
        `).join("")}
      </table>
    ` : "";
        // Full page always centers the receipt column. Thermal widths follow the
        // owner's Receipt position pick - "default" is the live-tuned flush-left
        // placement above. Auto-centering is a choice, not the default, because it
        // overshot on Kelly's printer (see pointbunny-app-todos.md); "left" pulls
        // the column 3mm into its own 4mm side padding, so no text is clipped.
        const pos = (0, $e289654e8a722fd2$export$24d4c6cf79ebd2a8)(position);
        const hMargin = isFull || pos === "center" ? "margin-left:auto; margin-right:auto;" : pos === "left" ? "margin-left:-3mm;" : `margin-left:${marginLeft};`;
        const css = (root)=>{
            const p = root === "body" ? "" : `${root} `;
            const all = root === "body" ? "*" : `${root}, ${root} *`;
            return `
  ${all} { margin:0; padding:0; box-sizing:border-box; }
  ${root} { font-family:'Courier New',Courier,monospace; font-size:12px; width:${contentWidth}; ${hMargin} margin-top:${marginTop}; padding:6mm 4mm; color:#000; }
  ${p}table { width:100%; border-collapse:collapse; }
  ${p}.center { text-align:center; }
  ${p}.divider { border:none; border-top:1px dashed #000; margin:6px 0; }
  ${p}.brand { font-size:15px; font-weight:bold; letter-spacing:1px; }
  ${p}.free-plan-badge { margin:10px auto 0; max-width:46mm; padding:7px 8px 6px; border:1px solid #000; border-radius:8px; color:#000; }
  ${p}.free-plan-name { font-size:11px; font-weight:bold; letter-spacing:2px; }
  ${p}.free-plan-slogan { margin-top:3px; font-size:10px; line-height:1.35; }
  ${p}.free-plan-cta { margin-top:4px; font-size:10px; font-weight:bold; }`;
        };
        const page = isFull ? "@page { margin:12mm; }" : `@page { size:${mm}mm auto; margin:0; }`;
        // Custom footer + feedback QR are Pro-only (the free plan keeps the default
        // thank-you line and the Pointbunny badge).
        const feedbackQr = sale.isFreePlan ? "" : (0, $9db03be56d1ffd3b$export$dc1ff443e897fb03)(sale.receiptQrUrl);
        // Tip sits outside the sale total (never taxed); printed under TOTAL.
        const tip = Number(sale.tipAmount) || 0;
        const body = `
  <div class="center brand">${storeName}</div>
  ${sale.addressStreet ? `
  <div class="center" style="font-size:9px;color:#555;margin:2px 0 0;line-height:1.35;">
    <div>${(0, $cnCXJ.esc)(sale.addressStreet)}</div>
    ${(()=>{
            // Country is intentionally omitted: the street/city/province/zip already
            // identify the business and the customer is local (the thermal/ESC-POS
            // receipt omits it too). addressCountry is still used for localized labels.
            const locality = [
                sale.addressCity,
                sale.addressProvince
            ].filter(Boolean).join(', ');
            const localityZip = [
                locality,
                sale.addressZip
            ].filter(Boolean).join(' ');
            return localityZip ? `<div>${(0, $cnCXJ.esc)(localityZip)}</div>` : '';
        })()}
  </div>` : ''}
  ${sale.businessPhone && sale.showBusinessPhone !== false ? `<div class="center" style="font-size:9px;color:#555;margin:1px 0 0;">${(0, $cnCXJ.esc)(sale.businessPhone)}</div>` : ''}
  <div class="center" style="margin:4px 0 2px;font-size:11px;">${dateStr} &nbsp; ${timeStr}</div>
  ${sale.showInvoiceNumber !== false && sale.receiptNumber != null ? `<div class="center" style="font-size:11px;font-weight:bold;letter-spacing:0.04em;margin:0 0 2px;">${(0, $78df0284a57ee0dd$export$bb60034feb8a6f01)(sale.addressCountry)} ${(0, $cnCXJ.esc)((0, $78df0284a57ee0dd$export$1fa50150e73e75ba)(sale.receiptNumber, sale.date))}</div>` : ''}
  ${sale.cashierName && sale.showCashier !== false ? `<div class="center" style="font-size:10px;color:#555;margin:0 0 2px;">Cashier: ${(0, $cnCXJ.esc)(sale.cashierName)}</div>` : ''}
  ${sale.orderType ? `<div class="center" style="font-size:11px;font-weight:bold;letter-spacing:0.05em;margin:0 0 4px;">${(0, $cggJi.orderTypeLabel)(sale.orderType, sale.addressCountry, {
            upper: true
        })}</div>` : ''}
  ${sale.tableName ? `<div class="center" style="font-size:13px;font-weight:bold;margin:0 0 4px;">TABLE ${(0, $cnCXJ.esc)(sale.tableName)}</div>` : ''}
  ${sale.showTicketNumber !== false && sale.ticketNumber != null ? `
  <div class="center" style="margin:6px 0;padding:6px 0;border-top:2px dashed #000;border-bottom:2px dashed #000;">
    <div style="font-size:11px;letter-spacing:0.08em;">TICKET</div>
    <div style="font-size:32px;font-weight:bold;line-height:1.1;">#${sale.ticketNumber}</div>
  </div>` : ''}
  <hr class="divider">

  <table>${itemsHtml}</table>

  ${adjSection}

  <hr class="divider">
  <table>
    <tr>
      <td style="font-weight:bold;font-size:13px;padding:3px 4px 3px 0;">TOTAL</td>
      <td style="font-weight:bold;font-size:13px;text-align:right;">${m(sale.totalPrice)}</td>
    </tr>
    ${vatRows}
    ${exemptRow}
    ${tip > 0 ? `
    <tr>
      <td style="font-size:11px;padding:3px 4px 1px 0;">Tip</td>
      <td style="font-size:11px;text-align:right;">${m(tip)}</td>
    </tr>
    <tr>
      <td style="font-weight:bold;font-size:12px;padding:1px 4px 3px 0;">TOTAL WITH TIP</td>
      <td style="font-weight:bold;font-size:12px;text-align:right;">${m(Number(sale.totalPrice) + tip)}</td>
    </tr>` : ''}
    <tr>
      <td style="font-size:11px;padding:3px 4px 2px 0;">Payment</td>
      <td style="font-size:11px;text-align:right;">${paymentLabel}</td>
    </tr>
    ${paymentMethod === "cash" ? `
    <tr>
      <td style="font-size:11px;padding:1px 4px 2px 0;">Cash Tendered</td>
      <td style="font-size:11px;text-align:right;">${m(sale.customerPayment)}</td>
    </tr>
    <tr>
      <td style="font-size:11px;font-weight:bold;padding:2px 4px 2px 0;">Change</td>
      <td style="font-size:11px;font-weight:bold;text-align:right;">${m(sale.customerChange)}</td>
    </tr>` : `
    <tr>
      <td style="font-size:11px;font-weight:bold;padding:2px 4px 2px 0;">Paid in full</td>
      <td style="font-size:11px;font-weight:bold;text-align:right;">${m(Number(sale.totalPrice) + tip)}</td>
    </tr>`}
  </table>
  <hr class="divider">
  <div class="center" style="font-size:10px;color:#555;margin-top:4px;">
    <p>${!sale.isFreePlan && sale.receiptFooter ? (0, $cnCXJ.esc)(sale.receiptFooter) : 'Thank you for your purchase!'}</p>
    ${feedbackQr ? `<div style="margin:6px auto 2px;width:28mm;">${feedbackQr}</div>` : ''}
    ${sale.isFreePlan ? `
    <div class="free-plan-badge">
      <div class="free-plan-name">POINTBUNNY POS</div>
      <div class="free-plan-slogan">The all-in-one POS<br>to run your shop</div>
      <div class="free-plan-cta">pointbunny.com</div>
    </div>` : `
    <p style="margin-top:2px;font-weight:bold;">Powered by Pointbunny POS</p>`}
  </div>`;
        return {
            css: css,
            page: page,
            contentWidth: contentWidth,
            body: body
        };
    }
    _generateReceiptHTML(sale, opts) {
        const { css: css, page: page, contentWidth: contentWidth, body: body } = this._receiptParts(sale, opts);
        return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<title>Receipt</title>
<style>${css("body")}
  @media print { body { width:${contentWidth}; } ${page} }
</style>
<script>
  window.addEventListener('afterprint', function() {
    if (window.opener) window.opener.postMessage('pointbunny-afterprint', window.location.origin);
    setTimeout(function() { window.close(); }, 150);
  });
</script>
</head>
<body>${body}
</body>
</html>`;
    }
    // Same HTML that prints - used for the pre-commit preview in an iframe so the
    // preview matches the printout exactly. (Invoice/ticket numbers are assigned on
    // record, so a pre-record preview sale simply omits those lines.)
    previewMarkup(sale, opts) {
        return this._generateReceiptHTML(sale, opts);
    }
    // Android Chrome / Samsung Internet / Firefox-mobile block or mishandle the
    // window.open print popup - especially when it is opened after an await (the
    // sale is recorded before printing), which takes it outside the user-gesture
    // stack. iOS Safari and desktop handle the popup reliably, so only those stay
    // on the popup path; every other mobile browser prints via a hidden iframe,
    // which needs no popup permission. Any platform also falls back to the iframe
    // if the popup turns out to be blocked.
    _isIOS() {
        const ua = navigator.userAgent || "";
        return /iPad|iPhone|iPod/.test(ua) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    }
    _preferIframePrint() {
        const isMobile = /Mobi|Android/i.test(navigator.userAgent || "");
        return isMobile && !this._isIOS();
    }
    print(sale, opts) {
        // iOS/iPadOS: neither child-window route is reliable. The popup is blocked
        // when it opens after the sale's await, and the iframe fallback's
        // contentWindow.print() prints the PARENT page on WebKit - which is how an
        // iPad ended up printing the whole Checkout screen (2026-10-04). Printing
        // inside the app page with print-only CSS has no child window to lose.
        if (this._isIOS()) return this._printInPage(this._receiptParts(sale, opts));
        const html = this._generateReceiptHTML(sale, opts);
        if (this._preferIframePrint()) return this._printViaIframe(html);
        let win = null;
        try {
            win = window.open("", "_blank", "width=380,height=600,scrollbars=no,toolbar=no,menubar=no,location=no");
        } catch  {
            win = null;
        }
        // Popup blocked (common when opened outside a user gesture) - fall back to
        // the same-document iframe so the receipt still prints.
        if (!win) return this._printViaIframe(html);
        win.document.write(html);
        win.document.close();
        win.focus();
        setTimeout(()=>win.print(), 300);
        return new Promise((resolve)=>{
            const cleanup = ()=>{
                window.removeEventListener("message", handler);
                clearTimeout(fallback);
                // Close the receipt window from this side too (the popup self-closes on
                // afterprint, but that doesn't fire on every browser / when the print
                // dialog is dismissed) and bring focus back so the confirm prompt is on
                // top instead of sitting behind the receipt window.
                try {
                    if (win && !win.closed) win.close();
                } catch  {}
                try {
                    window.focus();
                } catch  {}
                resolve();
            };
            const handler = (e)=>{
                if (e.data === "pointbunny-afterprint") cleanup();
            };
            const fallback = setTimeout(cleanup, 60000);
            window.addEventListener("message", handler);
        });
    }
    // Print by writing the receipt into a hidden, same-origin iframe and calling
    // its own print(). No popup window is opened, so popup blockers and the
    // after-await gesture restriction never apply - this is the reliable path on
    // Android Chrome and other mobile browsers.
    _printViaIframe(html) {
        return new Promise((resolve)=>{
            const iframe = document.createElement("iframe");
            iframe.setAttribute("aria-hidden", "true");
            iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
            let settled = false;
            const finish = ()=>{
                if (settled) return;
                settled = true;
                clearTimeout(fallback);
                // Remove on a delay so the print job is not torn down mid-render.
                setTimeout(()=>{
                    try {
                        iframe.remove();
                    } catch  {}
                }, 1000);
                try {
                    window.focus();
                } catch  {}
                resolve();
            };
            const fallback = setTimeout(finish, 60000);
            document.body.appendChild(iframe);
            iframe.onload = ()=>{
                const cw = iframe.contentWindow;
                try {
                    cw.addEventListener("afterprint", finish, {
                        once: true
                    });
                    cw.focus();
                    cw.print();
                } catch  {
                    finish();
                }
            };
            // srcdoc fires a reliable load event across browsers (more so than a
            // document.write into a blank iframe).
            iframe.srcdoc = html;
        });
    }
    // Prints the receipt as part of the app's own document: a hidden #pbPrintRoot
    // holds the receipt, and print-only CSS hides every other top-level element.
    // The app never shows on paper, and no popup or iframe is involved.
    _printInPage({ css: css, page: page, body: body }) {
        document.getElementById("pbPrintRoot")?.remove();
        document.getElementById("pbPrintStyle")?.remove();
        const style = document.createElement("style");
        style.id = "pbPrintStyle";
        style.textContent = `
@media screen { #pbPrintRoot { display:none !important; } }
@media print {
  html, body { height:auto !important; min-height:0 !important; overflow:visible !important; background:#fff !important; }
  body::before, body::after { display:none !important; }
  body > *:not(#pbPrintRoot) { display:none !important; }
  #pbPrintRoot { display:block !important; }
  ${css("#pbPrintRoot")}
}
${page}`;
        const root = document.createElement("div");
        root.id = "pbPrintRoot";
        root.setAttribute("aria-hidden", "true");
        root.innerHTML = body;
        document.head.appendChild(style);
        document.body.appendChild(root);
        // The receipt is deliberately NOT removed on afterprint: the iOS print sheet
        // re-renders its preview when the paper size changes, and WebKit's
        // afterprint timing is not a reliable "sheet closed" signal - removing it
        // early would print the app again. It is invisible on screen and gets
        // replaced at the top of the next _printInPage call.
        return new Promise((resolve)=>{
            let settled = false;
            const finish = ()=>{
                if (settled) return;
                settled = true;
                clearTimeout(fallback);
                window.removeEventListener("afterprint", finish);
                resolve();
            };
            const fallback = setTimeout(finish, 60000);
            window.addEventListener("afterprint", finish);
            try {
                window.print();
            } catch  {
                finish();
            }
        });
    }
}
var $9d7a2f48e7d0ba3e$export$2e2bcd8739ae039 = new $9d7a2f48e7d0ba3e$var$ReceiptView();




var $cggJi = parcelRequire("cggJi");



var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");


var $dv0h8 = parcelRequire("dv0h8");

var $lDSCx = parcelRequire("lDSCx");
const $1d1221278b545f23$var$fmt = (n)=>(0, $coRoT.formatMoney)(n);
// Shown in the business timezone, whatever zone this device is set to (2026-10-25).
const $1d1221278b545f23$var$fmtDateTime = (iso)=>(0, $lDSCx.bizFormat)(iso, {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit"
    });
const $1d1221278b545f23$var$pad = (n)=>String(n).padStart(2, "0");
// Inline serving-time text for the cashflow row list
const $1d1221278b545f23$var$fmtServing = (sale)=>{
    if (sale.timed_out) {
        // Timed-out orders: show duration in red regardless of length, or just the label if no timestamp
        if (!sale.prepared_at) return ` \xb7 <span class="cf-timeout-tag">\u{23F1}\u{FE0F} Timed out</span>`;
        const mins = (new Date(sale.prepared_at) - new Date(sale.sale_date)) / 60000;
        if (mins < 0) return ` \xb7 <span class="cf-timeout-tag">\u{23F1}\u{FE0F} Timed out</span>`;
        const m = Math.floor(mins);
        const s = Math.round((mins - m) * 60);
        const dur = m > 0 ? `${m}m ${s}s` : `${s}s`;
        return ` \xb7 <span class="cf-timeout-tag">\u{23F1}\u{FE0F} ${dur} (timed out)</span>`;
    }
    // Normal orders: only show if prepared_at is set and within sanity range
    if (!sale.prepared_at) return "";
    const mins = (new Date(sale.prepared_at) - new Date(sale.sale_date)) / 60000;
    if (mins < 0 || mins > 120) return "";
    const m = Math.floor(mins);
    const s = Math.round((mins - m) * 60);
    return ` \xb7 \u{1F373} ${m > 0 ? `${m}m ${s}s` : `${s}s`}`;
};
// Block-level serving-time line for the receipt modal (never included in printing)
const $1d1221278b545f23$var$_servingLine = (sale)=>{
    if (sale.timed_out) {
        if (!sale.prepared_at) return `<p class="sr-serving sr-serving--timeout">\u{23F1}\u{FE0F} Timed out</p>`;
        const mins = (new Date(sale.prepared_at) - new Date(sale.sale_date)) / 60000;
        if (mins < 0) return `<p class="sr-serving sr-serving--timeout">\u{23F1}\u{FE0F} Timed out</p>`;
        const m = Math.floor(mins);
        const s = Math.round((mins - m) * 60);
        const dur = m > 0 ? `${m}m ${s}s` : `${s}s`;
        return `<p class="sr-serving sr-serving--timeout">\u{23F1}\u{FE0F} ${dur} (timed out)</p>`;
    }
    if (!sale.prepared_at) return '';
    const mins = (new Date(sale.prepared_at) - new Date(sale.sale_date)) / 60000;
    if (mins < 0 || mins > 120) return '';
    const m = Math.floor(mins);
    const s = Math.round((mins - m) * 60);
    return `<p class="sr-serving">\u{1F373} Served in ${m > 0 ? `${m}m ${s}s` : `${s}s`}</p>`;
};
class $1d1221278b545f23$var$CashflowView extends (0, $081656bd50f85abd$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("#cashflowPanel");
    _expenseModal = document.querySelector("#addExpenseModal");
    _form = document.querySelector("#addExpenseForm");
    _overrideModal = document.querySelector("#cashflowOverrideModal");
    _overrideForm = document.querySelector("#cashflowOverrideForm");
    _activeTab = "sales";
    _setActiveTab(tab) {
        this._activeTab = tab;
        this._parentElement.querySelectorAll(".cashflow-tab").forEach((btn)=>{
            btn.classList.toggle("cashflow-tab--active", btn.dataset.tab === tab);
        });
        document.getElementById("cashflowSalesList").classList.toggle("hidden", tab !== "sales");
        document.getElementById("cashflowExpensesList").classList.toggle("hidden", tab !== "expenses");
        document.getElementById("cashflowVoidedList").classList.toggle("hidden", tab !== "voided");
    }
    open(canEdit) {
        this._parentElement.classList.remove("hidden", "cashflow-exiting");
        this._parentElement.querySelectorAll(".period-btn").forEach((btn)=>{
            btn.classList.toggle("active", btn.dataset.period === "today");
        });
        document.querySelector("#cashflowCustomRange").classList.add("hidden");
        document.getElementById("addExpenseBtn").classList.toggle("hidden", !canEdit);
        this._setActiveTab("sales");
    }
    close() {
        this._parentElement.classList.add("cashflow-exiting");
        setTimeout(()=>{
            this._parentElement.classList.add("hidden");
            this._parentElement.classList.remove("cashflow-exiting");
        }, 220);
    }
    setPeriodLabel(label) {
        document.querySelector("#cashflowPeriodLabel").textContent = label;
    }
    // ‹ › arrows + "Today" chip around the period label. Arrows hide for Custom;
    // › is disabled on the current period (no future); "Today" shows once the
    // user has stepped away from it.
    setStepper(period, offset = 0) {
        const el = document.querySelector("#cashflowStepper");
        if (!el) return;
        el.classList.toggle("period-stepper--static", period === "custom");
        const next = el.querySelector('[data-step="1"]');
        if (next) next.disabled = offset >= 0;
        el.querySelector(".period-step-today")?.classList.toggle("hidden", period === "custom" || offset === 0);
    }
    _addHandlerStep(handler) {
        document.querySelector("#cashflowStepper")?.addEventListener("click", (e)=>{
            const btn = e.target.closest("[data-step]");
            if (!btn || btn.disabled) return;
            handler(Number(btn.dataset.step));
        });
    }
    setActivePeriod(period) {
        this._parentElement.querySelectorAll(".period-btn").forEach((btn)=>{
            btn.classList.toggle("active", btn.dataset.period === period);
        });
        document.querySelector("#cashflowCustomRange").classList.toggle("hidden", period !== "custom");
    }
    renderLoading() {
        // Skeleton rows that mirror the real .cashflow-row layout (desc + date on the
        // left, amount on the right) so content appears to "fill in" rather than spin.
        const widths = [
            [
                "55%",
                "40%"
            ],
            [
                "48%",
                "33%"
            ],
            [
                "62%",
                "30%"
            ],
            [
                "44%",
                "37%"
            ],
            [
                "52%",
                "28%"
            ]
        ];
        const skeleton = `
      <div class="cashflow-skel" aria-hidden="true">
        ${widths.map(([w1, w2])=>`
          <div class="cashflow-row cashflow-row--skel">
            <div class="cashflow-row-main">
              <span class="skel skel-line" style="width:${w1}"></span>
              <span class="skel skel-line skel-line--sm" style="width:${w2}"></span>
            </div>
            <div class="cashflow-row-right">
              <span class="skel skel-line cashflow-skel-amount"></span>
            </div>
          </div>`).join("")}
      </div>`;
        document.querySelector(".cashflow-summary")?.classList.add("cashflow-summary--loading");
        document.querySelector("#cashflowSalesList").innerHTML = skeleton;
        document.querySelector("#cashflowExpensesList").innerHTML = skeleton;
        document.querySelector("#cashflowVoidedList").innerHTML = skeleton;
    }
    // Count-up from fromVal to toVal. A newer call cancels the one still running on
    // the same element, and a hidden tab (where browsers pause requestAnimationFrame,
    // freezing the total mid-count - e.g. $0.74 of a $3.25 sale) or reduced motion
    // just sets the final value (2026-10-15).
    _animateAmount(el, fromVal, toVal) {
        const token = el._countToken = (el._countToken ?? 0) + 1;
        if (document.hidden || window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
            el.textContent = $1d1221278b545f23$var$fmt(toVal);
            return;
        }
        const duration = 700;
        const start = performance.now();
        const easeOut = (t)=>1 - Math.pow(1 - t, 3);
        const step = (now)=>{
            if (el._countToken !== token) return;
            const t = Math.min((now - start) / duration, 1);
            el.textContent = $1d1221278b545f23$var$fmt(fromVal + (toVal - fromVal) * easeOut(t));
            if (t < 1) requestAnimationFrame(step);
            else el.textContent = $1d1221278b545f23$var$fmt(toVal);
        };
        requestAnimationFrame(step);
    }
    renderSummary({ gross: gross, expenses: expenses, net: net, tips: tips = 0, showTips: showTips = false }) {
        document.querySelector(".cashflow-summary")?.classList.remove("cashflow-summary--loading");
        document.querySelector(".cashflow-summary")?.classList.toggle("cashflow-summary--tips", showTips);
        const tipsCard = document.querySelector("#cashflowTipsCard");
        if (tipsCard) tipsCard.hidden = !showTips;
        const tipsEl = document.querySelector("#cashflowTips");
        if (tipsEl) tipsEl.textContent = $1d1221278b545f23$var$fmt(tips);
        const grossEl = document.querySelector("#cashflowGross");
        const netEl = document.querySelector("#cashflowNet");
        const fromGross = parseFloat(grossEl.textContent.replace(/[$,]/g, "")) || 0;
        const fromNet = parseFloat(netEl.textContent.replace(/[$,]/g, "")) || 0;
        this._animateAmount(grossEl, fromGross, gross);
        document.querySelector("#cashflowExpensesTotal").textContent = $1d1221278b545f23$var$fmt(expenses);
        this._animateAmount(netEl, fromNet, net);
        netEl.classList.toggle("summary-amount--positive", net >= 0);
        netEl.classList.toggle("summary-amount--negative", net < 0);
    }
    renderSalesList(sales, canEdit) {
        const el = document.querySelector("#cashflowSalesList");
        if (!sales.length) {
            el.innerHTML = `<p class="cashflow-empty">No sales for this period.</p>`;
            return;
        }
        el.innerHTML = sales.map((sale)=>{
            const items = sale.items ?? [];
            const first = (0, $cnCXJ.esc)(items[0]?.itemName ?? "Sale");
            const label = items.length > 1 ? `${first} & ${items.length - 1} more` : first;
            const ticketStr = sale.ticket_number != null ? `<span class="cashflow-ticket-badge">#${sale.ticket_number}</span>` : "";
            const invoiceStr = sale.receipt_number != null ? `${(0, $cnCXJ.esc)((0, $78df0284a57ee0dd$export$1fa50150e73e75ba)(sale.receipt_number, sale.sale_date))} \xb7 ` : "";
            return `
        <div class="cashflow-row cashflow-row--clickable" data-sale-id="${sale.id}">
          <div class="cashflow-row-main">
            <span class="cashflow-row-desc">
              ${ticketStr}${label}
              ${sale.is_manual ? `<span class="cashflow-manual-badge">Manual</span>` : ""}
            </span>
            <span class="cashflow-row-date">${invoiceStr}${$1d1221278b545f23$var$fmtDateTime(sale.sale_date)}${sale.order_type ? ` \xb7 ${(0, $cggJi.orderTypeLabel)(sale.order_type)}` : ''}${sale.added_by ? ` \xb7 ${sale.is_manual ? 'Added by' : 'Cashier:'} ${(0, $cnCXJ.esc)(sale.added_by)}` : ""}${$1d1221278b545f23$var$fmtServing(sale)}</span>
          </div>
          <div class="cashflow-row-right">
            ${Number(sale.tip_amount) > 0 ? `
            <span class="cashflow-row-amounts">
              <span class="cashflow-row-amount cashflow-row-amount--sale">${$1d1221278b545f23$var$fmt(sale.total_price)}</span>
              <span class="cashflow-row-tip" title="Tip (not part of the sale)">+${$1d1221278b545f23$var$fmt(sale.tip_amount)} tip</span>
            </span>` : `<span class="cashflow-row-amount cashflow-row-amount--sale">${$1d1221278b545f23$var$fmt(sale.total_price)}</span>`}
            <button class="cashflow-void-btn" data-sale-id="${sale.id}" type="button" title="Void transaction">Void</button>
            <span class="cashflow-row-expand" aria-hidden="true">\u{203A}</span>
          </div>
        </div>`;
        }).join("");
    }
    renderExpensesList(expenses, canEdit) {
        const el = document.querySelector("#cashflowExpensesList");
        if (!expenses.length) {
            el.innerHTML = `<p class="cashflow-empty">No expenses for this period.</p>`;
            return;
        }
        el.innerHTML = expenses.map((exp)=>`
        <div class="cashflow-row" data-expense-id="${exp.id}">
          <div class="cashflow-row-main">
            <span class="cashflow-row-desc">${(0, $cnCXJ.esc)(exp.description)}</span>
            ${exp.category ? `<span class="cashflow-category-badge">${(0, $cnCXJ.esc)(exp.category)}</span>` : ""}
            <span class="cashflow-row-date">${$1d1221278b545f23$var$fmtDateTime(exp.expenseDate)} \xb7 Added by ${(0, $cnCXJ.esc)(exp.createdBy)}</span>
          </div>
          <div class="cashflow-row-right">
            <span class="cashflow-row-amount cashflow-row-amount--expense">\u{2212}${$1d1221278b545f23$var$fmt(exp.amount)}</span>
            ${canEdit ? `<button class="cashflow-delete-btn" data-id="${exp.id}" aria-label="Delete expense" title="Delete">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" width="15" height="15">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                <path d="M10 11v6M14 11v6"/>
                <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
              </svg>
            </button>` : ""}
          </div>
        </div>`).join("");
    }
    renderVoidedList(voidedSales, canEdit) {
        const el = document.querySelector("#cashflowVoidedList");
        if (!voidedSales.length) {
            el.innerHTML = `<p class="cashflow-empty">No voided transactions for this period.</p>`;
            return;
        }
        el.innerHTML = voidedSales.map((sale)=>{
            const items = sale.items ?? [];
            const first = (0, $cnCXJ.esc)(items[0]?.itemName ?? "Sale");
            const label = items.length > 1 ? `${first} & ${items.length - 1} more` : first;
            const ticketStr = sale.ticket_number != null ? `<span class="cashflow-ticket-badge">#${sale.ticket_number}</span>` : "";
            const invoiceStr = sale.receipt_number != null ? `${(0, $cnCXJ.esc)((0, $78df0284a57ee0dd$export$1fa50150e73e75ba)(sale.receipt_number, sale.sale_date))} \xb7 ` : "";
            const voidedStr = sale.voided_by ? `Voided by ${(0, $cnCXJ.esc)(sale.voided_by)} \xb7 ${$1d1221278b545f23$var$fmtDateTime(sale.voided_at)}` : `Voided \xb7 ${$1d1221278b545f23$var$fmtDateTime(sale.voided_at)}`;
            return `
        <div class="cashflow-row cashflow-row--voided" data-sale-id="${sale.id}" role="button" tabindex="0" title="View receipt">
          <div class="cashflow-row-main">
            <span class="cashflow-row-desc">${ticketStr}${label}</span>
            <span class="cashflow-row-date">${invoiceStr}${$1d1221278b545f23$var$fmtDateTime(sale.sale_date)}${sale.order_type ? ` \xb7 ${(0, $cggJi.orderTypeLabel)(sale.order_type)}` : ''}${sale.added_by ? ` \xb7 Cashier: ${(0, $cnCXJ.esc)(sale.added_by)}` : ""}</span>
            <span class="cashflow-voided-by">${voidedStr}</span>
          </div>
          <div class="cashflow-row-right">
            <span class="cashflow-row-amount cashflow-row-amount--voided">${$1d1221278b545f23$var$fmt(sale.total_price)}</span>
          </div>
        </div>`;
        }).join("");
    }
    showExpenseModal() {
        this._expenseModal.classList.remove("hidden");
    }
    hideExpenseModal() {
        this._expenseModal.classList.add("hidden");
        this._form.reset();
        this._setExpenseError(null);
    }
    showOverrideModal(onSubmit) {
        this._overrideModal.classList.remove("hidden");
        document.getElementById("overrideEmail").value = "";
        document.getElementById("overridePassword").value = "";
        document.getElementById("overrideMfaCode").value = "";
        document.getElementById("overrideMfaField").classList.add("hidden");
        this.setOverrideError("");
        document.getElementById("overrideEmail").focus();
        this._overrideSubmitHandler = onSubmit;
    }
    // The approving account has 2FA on: reveal the code field and focus it.
    showOverrideMfa() {
        document.getElementById("overrideMfaField").classList.remove("hidden");
        document.getElementById("overrideMfaCode").focus();
    }
    hideOverrideModal() {
        this._overrideModal.classList.add("hidden");
        this._overrideForm?.reset();
        document.getElementById("overrideMfaField").classList.add("hidden");
        this.setOverrideError("");
        this._overrideSubmitHandler = null;
    }
    setOverrideError(msg) {
        const el = document.getElementById("overrideError");
        if (!el) return;
        el.textContent = msg;
        el.classList.toggle("hidden", !msg);
    }
    setLoading(on) {
        this._parentElement.querySelectorAll(".period-btn, #applyRangeBtn, #addExpenseBtn, #exportCsvBtn").forEach((el)=>{
            el.disabled = on;
        });
        this._parentElement.querySelector(".cashflow-back").disabled = on;
        this._parentElement.querySelectorAll(".cashflow-tab").forEach((btn)=>{
            btn.disabled = on;
        });
    }
    setHeavyLoadNotice(on) {
        const existing = this._parentElement.querySelector('.cf-heavy-notice');
        if (on && !existing) {
            const el = document.createElement('p');
            el.className = 'cf-heavy-notice';
            el.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        Loading a full year of data. This may take a few seconds\u{2026}`;
            this._parentElement.querySelector('.cashflow-period-bar')?.insertAdjacentElement('afterend', el);
        } else if (!on && existing) existing.remove();
    }
    setSubmitting(on) {
        const btn = document.querySelector("#expenseSubmitBtn");
        btn.disabled = on;
        btn.textContent = on ? "Adding\u2026" : "Add Expense";
    }
    setOverrideSubmitting(on) {
        const btn = document.getElementById("overrideSubmitBtn");
        if (!btn) return;
        btn.disabled = on;
        btn.textContent = on ? "Verifying\u2026" : "Authorize";
    }
    scrollExpensesToTop() {
        document.querySelector("#cashflowExpensesList").scrollTop = 0;
    }
    showSaleReceipt(sale, onReprint) {
        document.querySelector("#saleReceiptModal")?.remove();
        const items = sale.items ?? [];
        // Free-item reward redemptions show as $0 on the item's own row instead
        // (see itemsMarkup below) - excluded here so the discount isn't listed twice.
        const redeemedLineIds = (0, $dv0h8.redeemedRewardLineIds)(sale.adjustments);
        const adjs = (sale.adjustments ?? []).filter((a)=>!a.removed && a.source !== "loyalty_reward");
        const itemsMarkup = items.map((item)=>{
            const variants = (item.selectedVariants ?? []).map((v)=>{
                const name = v.variantName ?? v.optionName ?? v.name ?? "";
                const price = Number(v.variantPrice ?? v.optionPrice ?? 0);
                if (!name) return "";
                return `<span class="sr-variant">${(0, $cnCXJ.esc)(name)}${price > 0 ? ` (+${$1d1221278b545f23$var$fmt(price)})` : ""}</span>`;
            }).filter(Boolean).join("");
            const isFreeReward = redeemedLineIds.has(item.lineId);
            const priceHtml = isFreeReward ? `<span class="sr-item-price-struck">${$1d1221278b545f23$var$fmt(item.totalPrice)}</span>${$1d1221278b545f23$var$fmt(0)}` : $1d1221278b545f23$var$fmt(item.totalPrice);
            return `
          <div class="sr-item">
            <div class="sr-item-info">
              <span class="sr-item-name">${(0, $cnCXJ.esc)(item.itemName)}</span>
              ${variants ? `<div class="sr-item-variants">${variants}</div>` : ""}
            </div>
            <span class="sr-item-qty">\xd7${item.quantity}</span>
            <span class="sr-item-price">${priceHtml}</span>
          </div>`;
        }).join("");
        const adjMarkup = adjs.map((a)=>{
            const raw = a.computedAmount ?? a.computed_amount;
            const amount = typeof raw === "number" && !isNaN(raw) ? raw : 0;
            const approver = a.approvedBy ?? a.approved_by;
            return `
        <div class="sr-line sr-adj ${a.type}">
          <span>${(0, $cnCXJ.esc)(a.name)}${approver ? `<span class="sr-adj-approver">Approved by ${(0, $cnCXJ.esc)(approver)}</span>` : ""}</span>
          <span>${amount < 0 ? "\u2212" : "+"}${$1d1221278b545f23$var$fmt(Math.abs(amount))}</span>
        </div>`;
        }).join("");
        const isVoided = !!sale.voided_at;
        const voidedBanner = isVoided ? `
      <div class="sr-voided-banner">
        <span class="sr-voided-label">VOIDED</span>
        <span class="sr-voided-meta">
          ${sale.voided_by ? `by ${(0, $cnCXJ.esc)(sale.voided_by)} \xb7 ` : ''}${$1d1221278b545f23$var$fmtDateTime(sale.voided_at)}
        </span>
      </div>` : '';
        const el = document.createElement("div");
        el.id = "saleReceiptModal";
        el.className = "sale-receipt-overlay";
        el.innerHTML = `
      <div class="sale-receipt-card${isVoided ? ' sale-receipt-card--voided' : ''}">
        <div class="sale-receipt-header">
          <h3 class="sale-receipt-title">Order Receipt</h3>
          <button class="sale-receipt-close" aria-label="Close">&times;</button>
        </div>
        ${voidedBanner}
        ${sale.receipt_number != null ? `<p class="sale-receipt-invoice">${(0, $78df0284a57ee0dd$export$bb60034feb8a6f01)()} ${(0, $cnCXJ.esc)((0, $78df0284a57ee0dd$export$1fa50150e73e75ba)(sale.receipt_number, sale.sale_date))}</p>` : ""}
        <p class="sale-receipt-date">
          ${$1d1221278b545f23$var$fmtDateTime(sale.sale_date)}
          ${sale.is_manual ? `<span class="sr-manual-badge">Manually added${sale.added_by ? ` by ${(0, $cnCXJ.esc)(sale.added_by)}` : ""}</span>` : ""}
        </p>
        ${!sale.is_manual && sale.added_by ? `<p class="sale-receipt-cashier">Cashier: ${(0, $cnCXJ.esc)(sale.added_by)}</p>` : ""}
        ${$1d1221278b545f23$var$_servingLine(sale)}
        <div class="sr-items">${itemsMarkup}</div>
        <div class="sr-divider"></div>
        <div class="sr-summary">
          ${sale.subtotal != null && sale.subtotal !== sale.total_price ? `
          <div class="sr-line">
            <span>Subtotal</span><span>${$1d1221278b545f23$var$fmt(sale.subtotal)}</span>
          </div>` : ""}
          ${adjMarkup}
          <div class="sr-line sr-total">
            <span>Total</span><span>${$1d1221278b545f23$var$fmt(sale.total_price)}</span>
          </div>
          ${(()=>{
            // Per-item exemption (2026-07-07): tax extracted only from the
            // taxable portion; gated on the sale actually being tax-inclusive
            // so an all-exempt sale still shows its exempt-sales line.
            const isInclusiveSale = Number(sale.tax_inclusive_rate) > 0;
            if (!isInclusiveSale) return "";
            const { taxableGross: taxableGross, exemptGross: exemptGross } = (0, $ff150a18d4a6f5bb$export$1a11748b971a7a75)(sale.items, (it)=>it.taxClass === "exempt");
            const vat = (0, $ff150a18d4a6f5bb$export$b07c8f45d340b388)(taxableGross, sale.tax_inclusive_rate);
            const lbl = (0, $cnCXJ.esc)((0, $ff150a18d4a6f5bb$export$c829991a0e9a63)());
            const vatRows = vat ? `
          <div class="sr-line sr-line--muted">
            <span>${lbl}able Sales</span><span>${$1d1221278b545f23$var$fmt(vat.net)}</span>
          </div>
          <div class="sr-line sr-line--muted">
            <span>${lbl} (${vat.rate}%)</span><span>${$1d1221278b545f23$var$fmt(vat.tax)}</span>
          </div>` : "";
            const exemptRow = exemptGross > 0 ? `
          <div class="sr-line sr-line--muted">
            <span>${(0, $ff150a18d4a6f5bb$export$d9b10f19e66f377b)()} Sales</span><span>${$1d1221278b545f23$var$fmt(exemptGross)}</span>
          </div>` : "";
            return vatRows + exemptRow;
        })()}
        </div>
        <div class="sr-divider"></div>
        <div class="sr-payment">
          <div class="sr-line">
            <span>Method</span><span>${({
            cash: "Cash",
            card: "Card",
            qr: "QR"
        })[sale.payment_method] ?? "Cash"}</span>
          </div>
          ${(sale.payment_method ?? "cash") === "cash" ? `
          <div class="sr-line">
            <span>Cash Tendered</span><span>${$1d1221278b545f23$var$fmt(sale.customer_payment)}</span>
          </div>
          <div class="sr-line">
            <span>Change</span><span>${$1d1221278b545f23$var$fmt(sale.customer_change)}</span>
          </div>` : `
          <div class="sr-line">
            <span>Paid in full</span><span>${$1d1221278b545f23$var$fmt(sale.total_price)}</span>
          </div>`}
        </div>
        ${onReprint && !isVoided ? `<div class="sr-reprint"><button class="btn sr-reprint-btn">Reprint Receipt</button></div>` : ''}
      </div>`;
        // Appended to <body>, not the cashflow panel, so the activity feed can open
        // it while the panel is closed (the panel is display:none when hidden).
        document.body.appendChild(el);
        el.querySelector(".sale-receipt-close").addEventListener("click", ()=>el.remove());
        el.addEventListener("click", (e)=>{
            if (e.target === el) el.remove();
        });
        el.querySelector(".sr-reprint-btn")?.addEventListener("click", ()=>{
            el.remove();
            onReprint?.();
        });
    }
    // ── Handlers ─────────────────────────────────────────────────────────────────
    _addHandlerOpen(handler) {
        document.addEventListener("click", (e)=>{
            if (e.target.closest("[data-action='cash-flow']")) handler();
        });
    }
    _addHandlerClose(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (e.target.closest(".cashflow-back")) handler();
        });
    }
    _addHandlerPeriodChange(handler) {
        this._parentElement.querySelector(".cashflow-period-bar").addEventListener("click", (e)=>{
            const btn = e.target.closest(".period-btn");
            if (!btn) return;
            const period = btn.dataset.period;
            this.setActivePeriod(period);
            if (period !== "custom") handler({
                period: period
            });
        });
    }
    _addHandlerCustomRange(handler) {
        const fromEl = document.querySelector("#cashflowFrom");
        const toEl = document.querySelector("#cashflowTo");
        fromEl.addEventListener("change", ()=>{
            if (toEl.value && toEl.value < fromEl.value) toEl.value = fromEl.value;
            toEl.min = fromEl.value;
        });
        document.querySelector("#applyRangeBtn").addEventListener("click", ()=>{
            const from = fromEl.value;
            const to = toEl.value;
            if (!from || !to) return;
            if (to < from) {
                toEl.value = from;
                return;
            }
            handler({
                period: "custom",
                from: from,
                to: to
            });
        });
    }
    _addHandlerExport(handler) {
        document.querySelector("#exportCsvBtn").addEventListener("click", handler);
    }
    _addHandlerOpenAddExpense() {
        document.querySelector("#addExpenseBtn").addEventListener("click", ()=>this.showExpenseModal());
        document.querySelector("#expenseModalCloseBtn").addEventListener("click", ()=>this.hideExpenseModal());
        this._expenseModal.addEventListener("click", (e)=>{
            if (e.target === this._expenseModal) this.hideExpenseModal();
        });
    }
    // Inline message under the Add Expense fields; null clears it.
    _setExpenseError(message, field = null) {
        let el = this._form.querySelector(".expense-form-error");
        if (!el) {
            el = document.createElement("p");
            el.className = "expense-form-error";
            el.setAttribute("role", "alert");
            this._form.querySelector(".expense-form-fields")?.after(el);
        }
        el.textContent = message ?? "";
        el.hidden = !message;
        this._form.querySelectorAll("#expenseAmount, #expenseDescription").forEach((f)=>f.removeAttribute("aria-invalid"));
        if (field) {
            field.setAttribute("aria-invalid", "true");
            field.focus();
        }
    }
    _addHandlerSubmitExpense(handler) {
        // Empty or zero amounts and a blank description are caught here with a plain message,
        // instead of reaching the database and showing its raw check error (2026-10-25).
        this._form.addEventListener("input", (e)=>{
            if (e.target.matches("#expenseAmount, #expenseDescription")) this._setExpenseError(null);
        });
        this._form.addEventListener("submit", (e)=>{
            e.preventDefault();
            const amountEl = document.querySelector("#expenseAmount");
            const descEl = document.querySelector("#expenseDescription");
            const amount = Number(amountEl.value);
            if (!amountEl.value.trim() || !Number.isFinite(amount) || amount <= 0) {
                this._setExpenseError("Enter an amount greater than 0.", amountEl);
                return;
            }
            if (!descEl.value.trim()) {
                this._setExpenseError("Add a short description, like Supplier payment.", descEl);
                return;
            }
            const data = {
                amount: amountEl.value,
                description: descEl.value.trim(),
                category: document.querySelector("#expenseCategory").value.trim(),
                expense_date: new Date().toISOString()
            };
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(document.querySelector("#expenseSubmitBtn"), ()=>handler(data), {
                busyText: "Adding\u2026"
            });
        });
    }
    _addHandlerOpenSaleReceipt(handler) {
        // Sales list
        document.querySelector("#cashflowSalesList").addEventListener("click", (e)=>{
            if (e.target.closest(".cashflow-void-btn")) return;
            const row = e.target.closest(".cashflow-row[data-sale-id]");
            if (!row) return;
            handler(row.dataset.saleId);
        });
        // Voided list — click row to view receipt
        document.querySelector("#cashflowVoidedList").addEventListener("click", (e)=>{
            const row = e.target.closest(".cashflow-row[data-sale-id]");
            if (!row) return;
            handler(row.dataset.saleId);
        });
    }
    _addHandlerDeleteExpense(handler) {
        document.querySelector("#cashflowExpensesList").addEventListener("click", (e)=>{
            const btn = e.target.closest(".cashflow-delete-btn");
            if (!btn) return;
            this.showConfirmModal({
                message: "Delete this expense? This cannot be undone.",
                confirmLabel: "Delete",
                cancelLabel: "Cancel",
                onConfirm: ()=>handler(btn.dataset.id)
            });
        });
    }
    _addHandlerVoid(handler) {
        document.querySelector("#cashflowSalesList").addEventListener("click", (e)=>{
            const btn = e.target.closest(".cashflow-void-btn");
            if (!btn) return;
            e.stopPropagation();
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler(btn.dataset.saleId));
        });
    }
    _addHandlerTabChange() {
        this._parentElement.querySelector(".cashflow-tabs").addEventListener("click", (e)=>{
            const btn = e.target.closest(".cashflow-tab");
            if (!btn) return;
            this._setActiveTab(btn.dataset.tab);
        });
    }
    _addHandlerOverrideModal() {
        document.getElementById("overrideCancelBtn").addEventListener("click", ()=>this.hideOverrideModal());
        this._overrideModal.addEventListener("click", (e)=>{
            if (e.target === this._overrideModal) this.hideOverrideModal();
        });
        this._overrideForm.addEventListener("submit", async (e)=>{
            e.preventDefault();
            if (!this._overrideSubmitHandler) return;
            const email = document.getElementById("overrideEmail").value.trim();
            const password = document.getElementById("overridePassword").value;
            const mfaCode = document.getElementById("overrideMfaCode").value.trim() || undefined;
            this.setOverrideSubmitting(true);
            this.setOverrideError("");
            await this._overrideSubmitHandler(email, password, mfaCode);
            this.setOverrideSubmitting(false);
        });
    }
}
var $1d1221278b545f23$export$2e2bcd8739ae039 = new $1d1221278b545f23$var$CashflowView();




var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");

const $c3680931ad48d154$var$STAR_ICON = `<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"/></svg>`;
// Receipt & Tax panel (named "Receipt Adjustments" until 2026-10-10): Tax
// Settings (+ Tax-Exempt Products summary) and Automatic Receipt Adjustments
// (fees + discounts only - tax lives in Tax Settings), stacked in one section - no sidebar/tabs and
// no Loyalty placeholder (both removed 2026-07-08). Promo codes moved to their
// own top-level panel (promoView.js) on 2026-07-06.
class $c3680931ad48d154$var$DiscountView extends (0, $081656bd50f85abd$export$2e2bcd8739ae039) {
    _panel = document.querySelector("#discountPanel");
    _adjList = document.querySelector("#adjPanelList");
    _adjSection = document.querySelector("#adjPanelSection");
    _adjModal = document.querySelector("#adjPanelModal");
    _adjForm = document.querySelector("#adjPanelForm");
    _taxSettingsOptions = document.querySelector("#taxSettingsOptions");
    _taxNoneExample = document.querySelector("#taxNoneExample");
    _taxExcludeExample = document.querySelector("#taxExcludeExample");
    _taxIncludeExample = document.querySelector("#taxIncludeExample");
    _taxRateRecommend = document.querySelector("#taxRateRecommend");
    _taxInclusiveRateRow = document.querySelector("#taxInclusiveRateRow");
    _taxInclusiveRateInput = document.querySelector("#taxInclusiveRateInput");
    _taxLabelInput = document.querySelector("#taxLabelInput");
    _taxExemptLabelInput = document.querySelector("#taxExemptLabelInput");
    _taxExampleEl = document.querySelector("#taxRateExample");
    _taxFormulaBody = document.querySelector("#taxFormulaBody");
    _taxSettingsFooter = document.querySelector("#taxSettingsFooter");
    _adjustments = [];
    _taxExemptDivider = document.querySelector("#taxExemptDivider");
    _taxExemptSummary = document.querySelector("#taxExemptSummary");
    _taxExemptSummaryCount = document.querySelector("#taxExemptSummaryCount");
    _taxExemptSummarySub = document.querySelector("#taxExemptSummarySub");
    _taxExemptPreview = document.querySelector("#taxExemptPreview");
    _taxExemptManageBtn = document.querySelector("#taxExemptManageBtn");
    _taxExemptModal = document.querySelector("#taxExemptModal");
    _taxExemptModalHint = document.querySelector("#taxExemptModalHint");
    _taxExemptMethods = document.querySelector("#taxExemptMethods");
    _taxExemptList = document.querySelector("#taxExemptList");
    _taxExemptSearch = document.querySelector("#taxExemptSearch");
    _taxExemptSearchResults = document.querySelector("#taxExemptSearchResults");
    _taxExemptThreshold = document.querySelector("#taxExemptThreshold");
    _taxExemptCurrencyPrefix = document.querySelector("#taxExemptCurrencyPrefix");
    _taxExemptCategorySelect = document.querySelector("#taxExemptCategorySelect");
    _taxExemptCount = document.querySelector("#taxExemptCount");
    _taxExemptClearBtn = document.querySelector("#taxExemptClearBtn");
    _taxExemptCancelBtn = document.querySelector("#taxExemptCancelBtn");
    _exemptMenuItems = [];
    _exemptCategories = [];
    _exemptSelectedIds = new Set();
    // ── Open / Close ─────────────────────────────────────────────────────────────
    open() {
        this._panel.classList.remove("hidden", "cashflow-exiting");
    }
    close() {
        this._panel.classList.add("cashflow-exiting");
        setTimeout(()=>{
            this._panel.classList.add("hidden");
            this._panel.classList.remove("cashflow-exiting");
        }, 220);
    }
    // ── Auto Adjustments ─────────────────────────────────────────────────────────
    renderAdjustments(adjustments) {
        if (!this._adjList) return;
        this._adjustments = adjustments ?? [];
        if (!adjustments || adjustments.length === 0) {
            this._adjList.innerHTML = `
        <li class="adjustment-empty-state">
          <span class="pos-empty-emoji" aria-hidden="true">\u{1F9EE}</span>
          <p class="pos-empty-title">No adjustments yet</p>
          <p class="pos-empty-sub">Add service fees or discounts<br/>that apply to every receipt.</p>
          <button class="btn primary pos-empty-add adj-empty-add" type="button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
            Add Adjustment
          </button>
        </li>`;
            return;
        }
        this._adjList.innerHTML = adjustments.map((adj)=>`
        <li class="adjustment-item${adj.enabled ? "" : " adjustment-item--off"}" data-id="${adj.id}">
          <div class="adjustment-item-head">
            <div class="adjustment-item-name">${(0, $cnCXJ.esc)(adj.name)}</div>
            <label class="switch">
              <input type="checkbox" class="adj-toggle" ${adj.enabled ? "checked" : ""} />
              <span class="slider round"></span>
            </label>
          </div>
          <div class="adjustment-item-detail">
            <span class="adjustment-item-detail-left">
              <span class="adjustment-type-badge adjustment-type-badge--${adj.type === "fee" ? "fee" : "discount"}">${adj.type === "fee" ? "Fee" : "Discount"}</span>
              ${adj.calculation === "fixed" ? "Fixed amount" : "Percentage"}
            </span>
            <span class="adjustment-item-value adjustment-item-value--${adj.type === "fee" ? "fee" : "discount"}">${adj.type === "fee" ? "+" : "\u2212"}${adj.calculation === "fixed" ? (0, $coRoT.formatMoney)(adj.value) : adj.value + "%"}</span>
          </div>
          <p class="adjustment-item-subtext">Applies automatically to every receipt</p>
          <div class="adjustment-item-controls">
            <button class="adjustment-edit-btn adj-panel-edit-btn" data-id="${adj.id}" type="button">Edit</button>
            <div class="adj-more">
              <button class="adj-more-btn" data-action="more" type="button" aria-label="More actions">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
              </button>
              <div class="adj-more-menu hidden">
                <button class="adj-more-item adj-panel-delete-btn" data-id="${adj.id}" type="button">Delete</button>
              </div>
            </div>
          </div>
        </li>
      `).join("");
    }
    showAdjustmentForm(adjustment = null) {
        const isEdit = adjustment !== null;
        this._adjForm.innerHTML = `
      <button class="modal-close-btn" id="adjPanelCloseBtn" type="button">&times;</button>
      <h2 class="edit-form-title">${isEdit ? "Edit Adjustment" : "New Adjustment"}</h2>

      <div class="edit-field">
        <label for="adjName">Name</label>
        <input type="text" id="adjName" placeholder="e.g. Service Charge, Staff Discount"
          value="${isEdit ? (0, $cnCXJ.esc)(adjustment.name) : ""}" />
      </div>

      <p class="adj-form-sublabel">Type</p>
      <div class="adj-selector" id="adjTypeSelector">
        <button type="button" class="adj-selector-btn ${!isEdit || adjustment.type === "fee" ? "active" : ""}" data-value="fee">Fee</button>
        <button type="button" class="adj-selector-btn ${isEdit && adjustment.type === "discount" ? "active" : ""}" data-value="discount">Discount</button>
      </div>
      <input type="hidden" id="adjType" value="${isEdit ? adjustment.type : "fee"}" />

      <p class="adj-form-sublabel">Calculation</p>
      <div class="adj-selector" id="adjCalcSelector">
        <button type="button" class="adj-selector-btn ${!isEdit || adjustment.calculation === "fixed" ? "active" : ""}" data-value="fixed">Fixed (${(0, $coRoT.currencySymbol)()})</button>
        <button type="button" class="adj-selector-btn ${isEdit && adjustment.calculation === "percentage" ? "active" : ""}" data-value="percentage">
          Percentage (%)
          <span class="pb-tip" tabindex="0" role="img" aria-label="More info" data-tip="% of the running subtotal at the time this adjustment is applied">i</span>
        </button>
      </div>
      <input type="hidden" id="adjCalc" value="${isEdit ? adjustment.calculation : "fixed"}" />

      <div class="edit-field">
        <label for="adjValue" id="adjValueLabel">
          ${isEdit && adjustment.calculation === "percentage" ? "Value (%)" : `Value (${(0, $coRoT.currencySymbol)()})`}
        </label>
        <input type="number" id="adjValue" min="0" step="0.01" placeholder="0"
          value="${isEdit ? adjustment.value : ""}" />
      </div>

      <div class="adj-form-actions">
        <button type="button" class="btn" id="adjPanelCancelBtn">Cancel</button>
        <button type="button" class="btn primary" id="adjSaveBtn"
          data-edit-id="${isEdit ? adjustment.id : ""}">
          ${isEdit ? "Update" : "Add"}
        </button>
      </div>
    `;
        this._wireAdjForm();
        this._adjModal.classList.remove("hidden");
        document.getElementById("adjName")?.focus();
    }
    _wireAdjForm() {
        // Type selector
        const typeSelector = document.getElementById("adjTypeSelector");
        typeSelector?.addEventListener("click", (e)=>{
            const btn = e.target.closest(".adj-selector-btn");
            if (!btn) return;
            typeSelector.querySelectorAll(".adj-selector-btn").forEach((b)=>b.classList.remove("active"));
            btn.classList.add("active");
            document.getElementById("adjType").value = btn.dataset.value;
        });
        // Calc selector
        const calcSelector = document.getElementById("adjCalcSelector");
        calcSelector?.addEventListener("click", (e)=>{
            const btn = e.target.closest(".adj-selector-btn");
            if (!btn) return;
            calcSelector.querySelectorAll(".adj-selector-btn").forEach((b)=>b.classList.remove("active"));
            btn.classList.add("active");
            document.getElementById("adjCalc").value = btn.dataset.value;
            const lbl = document.getElementById("adjValueLabel");
            if (lbl) lbl.textContent = btn.dataset.value === "percentage" ? "Value (%)" : `Value (${(0, $coRoT.currencySymbol)()})`;
        });
        document.getElementById("adjPanelCloseBtn")?.addEventListener("click", ()=>this.closeAdjForm());
        document.getElementById("adjPanelCancelBtn")?.addEventListener("click", ()=>this.closeAdjForm());
    }
    closeAdjForm() {
        this._adjModal.classList.add("hidden");
        this._adjForm.innerHTML = "";
    }
    _getAdjFormData() {
        return {
            id: document.getElementById("adjSaveBtn")?.dataset.editId || null,
            name: document.getElementById("adjName")?.value.trim(),
            type: document.getElementById("adjType")?.value,
            calculation: document.getElementById("adjCalc")?.value,
            value: parseFloat(document.getElementById("adjValue")?.value)
        };
    }
    // ── Handlers — open / close ───────────────────────────────────────────────────
    _addHandlerOpen(handler) {
        document.addEventListener("click", (e)=>{
            const btn = e.target.closest("[data-action='discounts']");
            if (!btn) return;
            handler();
        });
    }
    _addHandlerClose(handler) {
        this._panel.querySelector(".discount-back").addEventListener("click", ()=>handler());
        // Close adj form on backdrop click
        this._adjModal.addEventListener("click", (e)=>{
            if (e.target === this._adjModal) this.closeAdjForm();
        });
    }
    // ── Handlers — tax mode ───────────────────────────────────────────────────────
    // Three mutually-exclusive option-cards (2026-07-08 redesign, replacing the old
    // toggle switch; "No tax" added same day) - "No tax" / "Tax added at checkout" /
    // "Tax is already included". Only the last maps to taxInclusive=true.
    _setTaxModeSelected(mode) {
        this._taxSettingsOptions?.querySelectorAll(".tax-settings-option").forEach((opt)=>{
            opt.classList.toggle("tax-settings-option--selected", opt.dataset.taxMode === mode);
        });
        const inclusive = mode === "inclusive";
        // Exemptions matter in both tax modes: "included" skips extracting tax
        // from exempt products, "added at checkout" skips charging it on them.
        const taxed = inclusive || mode === "exclusive";
        this._taxMode = mode;
        this._taxInclusiveRateRow?.classList.toggle("hidden", !taxed);
        this._taxExemptDivider?.classList.toggle("hidden", !taxed);
        this._taxExemptSummary?.classList.toggle("hidden", !taxed);
        this._renderExemptCopy();
        this._renderTaxExample(this._taxInclusiveRateInput?.value);
    }
    // Shown by the controller when picking a mode auto-fills the recommended rate.
    setTaxRate(rate) {
        if (!this._taxInclusiveRateInput) return;
        this._taxInclusiveRateInput.value = rate;
        this._renderTaxExample(rate);
    }
    // "Recommended" pill on the option that fits the business location
    // (taxRates.js getRecommendedTaxMode). Label is app-built, but escaped anyway
    // since it contains the stored state name.
    _renderRecommendedBadge(recommended) {
        this._recommended = recommended;
        this._taxSettingsOptions?.querySelectorAll(".tax-settings-option-rec").forEach((el)=>el.remove());
        if (!recommended) return;
        const head = this._taxSettingsOptions?.querySelector(`.tax-settings-option[data-tax-mode="${recommended.mode}"] .tax-settings-option-head`);
        head?.insertAdjacentHTML("beforeend", `<span class="tax-settings-option-rec">${$c3680931ad48d154$var$STAR_ICON}${(0, $cnCXJ.esc)(recommended.label)}</span>`);
    }
    // Recommended-rate chip above the rate field, for the recommended mode only
    // (e.g. "Recommended for Alabama: 4%"), with a one-tap "Use 4%" when the
    // current rate differs. US rates are the STATE base only, hence the note.
    _renderRateRecommendation() {
        const el = this._taxRateRecommend;
        if (!el) return;
        const rec = this._recommended;
        if (!rec?.rate || rec.mode !== this._taxMode) {
            el.classList.add("hidden");
            el.innerHTML = "";
            return;
        }
        const current = parseFloat(this._taxInclusiveRateInput?.value);
        el.classList.remove("hidden");
        el.innerHTML = `
      <div class="tax-rec-chip-row">
        <span class="tax-rec-chip">${$c3680931ad48d154$var$STAR_ICON}${(0, $cnCXJ.esc)(rec.label)}: ${rec.rate}%</span>
        ${current === rec.rate ? "" : `<button type="button" class="btn tax-rec-use" data-use-rate="${rec.rate}">Use ${rec.rate}%</button>`}
      </div>
      ${rec.note ? `<p class="tax-rec-note">${(0, $cnCXJ.esc)(rec.note)}</p>` : ""}`;
    }
    _renderExemptCopy() {
        const added = this._taxMode === "exclusive";
        if (this._taxExemptModalHint) this._taxExemptModalHint.textContent = added ? "Choose products that should not be charged tax at checkout." : `Choose products that should not have ${(0, $ff150a18d4a6f5bb$export$c829991a0e9a63)()} extracted from their listed price.`;
        if (this._taxExemptSummarySub) this._taxExemptSummarySub.textContent = added ? "Tax won't be added to these products at checkout." : `${(0, $ff150a18d4a6f5bb$export$c829991a0e9a63)()} will not be extracted from the listed price of these products.`;
    }
    // One-tap "Use 4%" on the recommended-rate chip feeds the normal rate
    // handler (same validation + staging as typing it).
    _addHandlerUseRecommendedRate(handler) {
        this._taxRateRecommend?.addEventListener("click", (e)=>{
            const btn = e.target.closest("[data-use-rate]");
            if (!btn) return;
            const rate = parseFloat(btn.dataset.useRate);
            this.setTaxRate(rate);
            handler(rate);
        });
    }
    _addHandlerSelectTaxMode(handler) {
        this._taxSettingsOptions?.addEventListener("click", (e)=>{
            const opt = e.target.closest(".tax-settings-option");
            if (!opt) return;
            const mode = opt.dataset.taxMode;
            if (opt.classList.contains("tax-settings-option--selected")) return;
            this._setTaxModeSelected(mode);
            handler(mode);
        });
    }
    // Mode, rate, and name all feed ONE staged draft now (2026-07-09) - same
    // deferred pattern as the Settings modal's POS/KDS toggles: the change
    // applies locally right away (live example, mode-dependent rows) but the
    // Supabase write waits for the sticky footer's Save Tax Settings. Rate
    // still validates before it's allowed to stage (a bad value shouldn't even
    // look "pending" - the earlier bug this guarded against was auto-SAVING
    // garbage on blur, not staging it, but the range check is worth keeping
    // regardless since nothing else validates it before Save).
    _addHandlerSetTaxRate(handler) {
        if (!this._taxInclusiveRateInput) return;
        this._taxInclusiveRateInput.addEventListener("input", ()=>{
            this._hideTaxError();
            this._renderTaxExample(this._taxInclusiveRateInput.value);
        });
        this._taxInclusiveRateInput.addEventListener("change", ()=>{
            const val = parseFloat(this._taxInclusiveRateInput.value);
            if (!Number.isFinite(val) || val <= 0 || val > 50) {
                this._showTaxError("Enter a tax rate between 0.01% and 50%.");
                return;
            }
            this._hideTaxError();
            const rounded = Math.round(val * 100) / 100;
            this._taxInclusiveRateInput.value = rounded;
            handler(rounded);
        });
    }
    _addHandlerSetTaxLabel(handler) {
        if (!this._taxLabelInput) return;
        this._taxLabelInput.addEventListener("change", ()=>{
            this._renderTaxExample(this._taxInclusiveRateInput?.value);
            handler(this._taxLabelInput.value);
        });
    }
    _addHandlerSetExemptLabel(handler) {
        if (!this._taxExemptLabelInput) return;
        this._taxExemptLabelInput.addEventListener("change", ()=>{
            handler(this._taxExemptLabelInput.value);
        });
    }
    // Fill both dropdowns from the canonical lists (once). The names are a fixed
    // vocabulary - free text on a legal receipt line was an XSS + compliance risk.
    _populateTaxLabelSelects() {
        if (this._taxLabelInput && !this._taxLabelInput.options.length) this._taxLabelInput.innerHTML = (0, $ff150a18d4a6f5bb$export$87dc5d93d28d020f).map((l)=>`<option value="${l}">${l}</option>`).join("");
        if (this._taxExemptLabelInput && !this._taxExemptLabelInput.options.length) this._taxExemptLabelInput.innerHTML = (0, $ff150a18d4a6f5bb$export$fcb742c279568cce).map((l)=>`<option value="${l}">${l}</option>`).join("");
    }
    showTaxSettingsDirty() {
        this._taxSettingsFooter?.classList.remove("hidden");
    }
    hideTaxSettingsDirty() {
        this._taxSettingsFooter?.classList.add("hidden");
    }
    _addHandlerSaveTaxSettings(handler) {
        document.getElementById("saveTaxSettingsBtn")?.addEventListener("click", ()=>handler());
    }
    _addHandlerDiscardTaxSettings(handler) {
        document.getElementById("discardTaxSettingsBtn")?.addEventListener("click", ()=>handler());
    }
    _showTaxError(msg) {
        const el = document.getElementById("taxRateError");
        if (el) {
            el.textContent = msg;
            el.classList.remove("hidden");
        }
    }
    _hideTaxError() {
        document.getElementById("taxRateError")?.classList.add("hidden");
    }
    // Live worked examples on the option-cards - same rate feeds "added at
    // checkout", so the contrast between add-on-top and stays-the-same is
    // obvious side by side. "No tax" and "already included" both land on
    // "$100 stays $100" arithmetically, so their trailing clause is what
    // actually distinguishes them (no tax line at all vs. broken out on the
    // receipt) - otherwise they'd read as identical.
    _renderTaxModeExamples(rate) {
        const r = parseFloat(rate);
        if (this._taxNoneExample) this._taxNoneExample.textContent = `Example: ${(0, $coRoT.formatMoney)(100)} stays ${(0, $coRoT.formatMoney)(100)} - no tax line on the receipt.`;
        if (this._taxExcludeExample) this._taxExcludeExample.textContent = Number.isFinite(r) && r > 0 ? `Example: ${(0, $coRoT.formatMoney)(100)} + ${(0, $coRoT.formatMoney)(100 * (r / 100))} tax = ${(0, $coRoT.formatMoney)(100 + 100 * (r / 100))}` : "";
        if (this._taxIncludeExample) this._taxIncludeExample.textContent = `Example: ${(0, $coRoT.formatMoney)(100)} stays ${(0, $coRoT.formatMoney)(100)} - tax is broken out on the receipt.`;
    }
    // Breakdown card (what the customer pays, front and center) + a compact
    // formula behind the disclosure. Deliberately does NOT frame "add X% on
    // top" as wrong - that's the separate Automatic Receipt Adjustments feature
    // (service charges, fees, discounts, or tax added ON TOP of the total), so
    // the closing line points there instead of arguing against it.
    _renderTaxExample(rate) {
        this._renderTaxModeExamples(rate);
        this._renderRateRecommendation();
        const r = parseFloat(rate);
        // Prefer the dropdown's current pick (live), else the saved/country label.
        const lbl = this._taxLabelInput?.value || (0, $ff150a18d4a6f5bb$export$c829991a0e9a63)();
        if (this._taxMode === "exclusive") {
            const ok = Number.isFinite(r) && r > 0;
            const tax = ok ? 100 * (r / 100) : 0;
            if (this._taxExampleEl) this._taxExampleEl.innerHTML = ok ? `
          <p class="tax-rate-example-lead">Your prices are before tax, so Pointbunny <strong>adds ${(0, $cnCXJ.esc)(lbl)} at checkout</strong>, only on taxable products (and on fees like a service charge). It's shown as its own line on the receipt.</p>
          <div class="tax-rate-example-breakdown">
            <p class="tax-rate-example-heading">${(0, $coRoT.formatMoney)(100)} sale with ${r}% ${(0, $cnCXJ.esc)(lbl)}</p>
            <div class="tax-rate-example-row"><span>Price before tax</span><span>${(0, $coRoT.formatMoney)(100)}</span></div>
            <div class="tax-rate-example-row"><span>${(0, $cnCXJ.esc)(lbl)} (${r}%)</span><span>+${(0, $coRoT.formatMoney)(tax)}</span></div>
            <div class="tax-rate-example-row tax-rate-example-row--total"><span>Customer pays</span><span>${(0, $coRoT.formatMoney)(100 + tax)}</span></div>
          </div>` : "";
            if (this._taxFormulaBody) this._taxFormulaBody.innerHTML = ok ? `
          <div class="tax-formula-eq">
            <div class="tax-formula-line"><span class="tax-formula-k">${(0, $cnCXJ.esc)(lbl)}</span><span>= (Taxable products + fees \u{2212} discounts) \xd7 Rate</span></div>
            <div class="tax-formula-line"><span class="tax-formula-k"></span><span>= ${(0, $coRoT.formatMoney)(100)} \xd7 ${r}% = <strong>${(0, $coRoT.formatMoney)(tax)}</strong></span></div>
          </div>
          <p class="tax-formula-note">Tax-exempt products below are left out. Tax is always added last, so no fee is ever charged on the tax.</p>` : "";
            return;
        }
        const vat = (0, $ff150a18d4a6f5bb$export$b07c8f45d340b388)(100, r);
        if (this._taxExampleEl) this._taxExampleEl.innerHTML = vat ? `
        <p class="tax-rate-example-lead">Your listed price already includes ${(0, $cnCXJ.esc)(lbl)}, so PointBunny <strong>does not add ${(0, $cnCXJ.esc)(lbl)} on top</strong>. Instead, it works out the ${(0, $cnCXJ.esc)(lbl)} portion already inside the price and shows it separately on the receipt - the normal way to calculate tax that's already included in a price.</p>
        <div class="tax-rate-example-breakdown">
          <p class="tax-rate-example-heading">${(0, $coRoT.formatMoney)(100)} price with ${r}% included ${(0, $cnCXJ.esc)(lbl)}</p>
          <div class="tax-rate-example-row"><span>Price before tax</span><span>${(0, $coRoT.formatMoney)(vat.net)}</span></div>
          <div class="tax-rate-example-row"><span>Included ${(0, $cnCXJ.esc)(lbl)}</span><span>${(0, $coRoT.formatMoney)(vat.tax)}</span></div>
          <div class="tax-rate-example-row tax-rate-example-row--total"><span>Customer pays</span><span>${(0, $coRoT.formatMoney)(100)}</span></div>
        </div>` : "";
        if (this._taxFormulaBody) {
            if (!vat) this._taxFormulaBody.innerHTML = "";
            else {
                const onTop = 100 * (r / 100); // what an on-top Adjustment at the same rate would add instead
                this._taxFormulaBody.innerHTML = `
          <div class="tax-formula-eq">
            <div class="tax-formula-line"><span class="tax-formula-k">${(0, $cnCXJ.esc)(lbl)}</span><span>= Price \xd7 Rate \xf7 (100 + Rate)</span></div>
            <div class="tax-formula-line"><span class="tax-formula-k"></span><span>= ${(0, $coRoT.formatMoney)(100)} \xd7 ${r} \xf7 ${100 + r} = <strong>${(0, $coRoT.formatMoney)(vat.tax)}</strong></span></div>
          </div>
          <p class="tax-formula-note">Need tax added on top of your prices instead? Choose "Tax added at checkout" above. For example, adding ${r}% on top of a ${(0, $coRoT.formatMoney)(100)} sale would make the total ${(0, $coRoT.formatMoney)(100 + onTop)}.</p>`;
            }
        }
    }
    syncTaxMode(mode, rate, label, exLabel, recommended = null) {
        if (!this._taxSettingsOptions) return;
        this._renderRecommendedBadge(recommended);
        this._taxInclusiveRateInput.value = rate ?? 12;
        this._setTaxModeSelected(mode);
        this._populateTaxLabelSelects();
        if (this._taxLabelInput) // Stored pick if it's canonical, else the country default (a legacy
        // free-text value from when this was a text input falls back too).
        this._taxLabelInput.value = (0, $ff150a18d4a6f5bb$export$87dc5d93d28d020f).includes(label) ? label : (0, $ff150a18d4a6f5bb$export$fdde01ab91d59417)();
        if (this._taxExemptLabelInput) this._taxExemptLabelInput.value = (0, $ff150a18d4a6f5bb$export$fcb742c279568cce).includes(exLabel) ? exLabel : (0, $ff150a18d4a6f5bb$export$c7585a5a8da068e5)();
        this._renderTaxExample(rate ?? 12);
    }
    // ── Tax-Exempt Products (centralized exemption picker) ──────────────────────
    // Product selection here is the ONLY place tax_class is edited now - the Edit
    // Item modal shows a read-only label + a deep link into this panel.
    //
    // Model: a "build a list" picker, not a giant checkbox wall. The right column
    // is the staged selection (chips, removable); the left column offers three
    // ADDITIVE ways to add to it (search-and-pick one at a time, by price, by
    // category). Nothing hits the DB until Save - Cancel reverts to last-saved.
    renderExemptProducts(menuItems = [], categories = []) {
        if (!this._taxExemptList) return;
        this._exemptMenuItems = menuItems;
        this._exemptCategories = categories;
        this._exemptSelectedIds = new Set(menuItems.filter((i)=>i.taxClass === "exempt").map((i)=>i._id));
        if (this._taxExemptCurrencyPrefix) this._taxExemptCurrencyPrefix.textContent = (0, $coRoT.currencySymbol)();
        this._renderExemptCopy();
        if (this._taxExemptCategorySelect) this._taxExemptCategorySelect.innerHTML = `<option value="" disabled selected>Select category</option>` + categories.map((c)=>`<option value="${(0, $cnCXJ.esc)(c)}">${(0, $cnCXJ.esc)(c.charAt(0).toUpperCase() + c.slice(1))}</option>`).join("");
        this._collapseExemptMethods();
        if (this._taxExemptSearch) this._taxExemptSearch.value = "";
        this._renderExemptSearchResults("");
        this._renderExemptSelectedList();
        this._renderExemptSummary();
    }
    // The compact summary card (outside the modal) - always reflects SAVED
    // truth (item.taxClass), never the modal's in-progress staged selection,
    // so it can't flicker to show an unsaved pending state.
    _renderExemptSummary() {
        const exempt = this._exemptMenuItems.filter((i)=>i.taxClass === "exempt");
        if (this._taxExemptSummaryCount) this._taxExemptSummaryCount.textContent = `${exempt.length} selected`;
        if (this._taxExemptPreview) {
            if (!exempt.length) this._taxExemptPreview.textContent = "No products marked exempt yet.";
            else {
                const shown = exempt.slice(0, 3).map((i)=>i.itemName);
                const extra = exempt.length - shown.length;
                this._taxExemptPreview.textContent = shown.join(" \xb7 ") + (extra > 0 ? ` \xb7 +${extra} more` : "");
            }
        }
    }
    _renderExemptSelectedList() {
        if (!this._taxExemptList) return;
        const items = this._exemptMenuItems.filter((i)=>this._exemptSelectedIds.has(i._id));
        if (!items.length) this._taxExemptList.innerHTML = `
        <li class="tax-exempt-empty-state">
          <p class="pos-empty-sub">No exempt products yet.<br/>Add some from the left.</p>
        </li>`;
        else this._taxExemptList.innerHTML = items.map((item)=>`
        <li class="tax-exempt-chip" data-id="${item._id}">
          <span class="tax-exempt-chip-text">
            <span class="tax-exempt-chip-name">${(0, $cnCXJ.esc)(item.itemName)}</span>
            <span class="tax-exempt-chip-meta">${(0, $cnCXJ.esc)(item.category || "Uncategorized")} \xb7 ${(0, $coRoT.formatMoney)(item.price)}</span>
          </span>
          <button type="button" class="tax-exempt-chip-remove" aria-label="Remove ${(0, $cnCXJ.esc)(item.itemName)}">&times;</button>
        </li>`).join("");
        if (this._taxExemptCount) this._taxExemptCount.textContent = `${items.length} selected`;
        this._taxExemptClearBtn?.classList.toggle("hidden", !items.length);
    }
    // Search results exclude anything already staged - it's already visible (and
    // removable) in the right column, so showing it again here would be a
    // confusing duplicate "add" affordance.
    _renderExemptSearchResults(query) {
        if (!this._taxExemptSearchResults) return;
        const q = query.trim().toLowerCase();
        if (!q) {
            this._taxExemptSearchResults.innerHTML = `<li class="tax-exempt-search-hint">Type to search products\u{2026}</li>`;
            return;
        }
        const matches = this._exemptMenuItems.filter((i)=>!this._exemptSelectedIds.has(i._id) && i.itemName.toLowerCase().includes(q)).slice(0, 20);
        if (!matches.length) {
            this._taxExemptSearchResults.innerHTML = `<li class="tax-exempt-search-hint">No matching products.</li>`;
            return;
        }
        this._taxExemptSearchResults.innerHTML = matches.map((item)=>`
      <li class="tax-exempt-search-row" data-id="${item._id}">
        <span class="tax-exempt-chip-name">${(0, $cnCXJ.esc)(item.itemName)}</span>
        <span class="tax-exempt-chip-meta">${(0, $cnCXJ.esc)(item.category || "Uncategorized")} \xb7 ${(0, $coRoT.formatMoney)(item.price)}</span>
      </li>`).join("");
    }
    // Only one Add-method panel is expanded at a time; the other two dim (never
    // fully hide, so their icon/label stay legible as a hint of what's available).
    _collapseExemptMethods() {
        this._taxExemptMethods?.querySelectorAll(".tax-exempt-method").forEach((m)=>{
            m.classList.remove("tax-exempt-method--active", "tax-exempt-method--dim");
            m.querySelector(".tax-exempt-method-body")?.classList.add("hidden");
        });
    }
    _openExemptMethod(method) {
        if (!method) return;
        this._collapseExemptMethods();
        this._taxExemptMethods?.querySelectorAll(".tax-exempt-method").forEach((m)=>{
            if (m !== method) m.classList.add("tax-exempt-method--dim");
        });
        method.classList.add("tax-exempt-method--active");
        method.querySelector(".tax-exempt-method-body")?.classList.remove("hidden");
    }
    // ── Modal (2026-07-08: the picker now lives in a modal, opened from the
    // Tax Settings card's summary; the summary is what stays inline) ──────────
    openExemptModal() {
        this._taxExemptModal?.classList.remove("hidden");
    }
    closeExemptModal() {
        this._taxExemptModal?.classList.add("hidden");
    }
    _addHandlerOpenExemptModal() {
        this._taxExemptManageBtn?.addEventListener("click", ()=>this.openExemptModal());
    }
    // × button and Cancel both discard any unsaved staging and close.
    _addHandlerCloseExemptModal() {
        const revertAndClose = ()=>{
            this.renderExemptProducts(this._exemptMenuItems, this._exemptCategories);
            this.closeExemptModal();
        };
        document.getElementById("taxExemptModalCloseBtn")?.addEventListener("click", revertAndClose);
        this._taxExemptCancelBtn?.addEventListener("click", revertAndClose);
    }
    // Scrolls to + briefly flashes a specific product's row - used when arriving
    // via the Edit Item modal's "Manage in Receipt Adjustments" link. If the item isn't
    // exempt yet, opens the search method pre-filled with its name instead, so
    // the owner can add it in one click.
    focusExemptProduct(itemId) {
        const item = this._exemptMenuItems.find((i)=>i._id === itemId);
        if (!item) return;
        this.openExemptModal();
        if (this._exemptSelectedIds.has(itemId)) {
            requestAnimationFrame(()=>{
                const chip = this._taxExemptList?.querySelector(`.tax-exempt-chip[data-id="${itemId}"]`);
                if (!chip) return;
                chip.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                chip.classList.add("tax-exempt-chip--flash");
                setTimeout(()=>chip.classList.remove("tax-exempt-chip--flash"), 1600);
            });
            return;
        }
        const searchMethod = this._taxExemptMethods?.querySelector('.tax-exempt-method[data-method="search"]');
        this._openExemptMethod(searchMethod);
        if (this._taxExemptSearch) {
            this._taxExemptSearch.value = item.itemName;
            this._taxExemptSearch.focus();
        }
        this._renderExemptSearchResults(item.itemName);
        searchMethod?.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }
    _addHandlerExemptMethodToggle() {
        this._taxExemptMethods?.addEventListener("click", (e)=>{
            const head = e.target.closest(".tax-exempt-method-head");
            if (!head) return;
            const method = head.closest(".tax-exempt-method");
            const wasActive = method.classList.contains("tax-exempt-method--active");
            this._collapseExemptMethods();
            if (wasActive) return; // clicking the open one again just closes everything
            this._openExemptMethod(method);
            method.querySelector("input, select")?.focus();
        });
    }
    _addHandlerExemptSearch() {
        this._taxExemptSearch?.addEventListener("input", ()=>{
            this._renderExemptSearchResults(this._taxExemptSearch.value);
        });
    }
    _addHandlerExemptSearchPick() {
        this._taxExemptSearchResults?.addEventListener("click", (e)=>{
            const row = e.target.closest(".tax-exempt-search-row");
            if (!row) return;
            this._exemptSelectedIds.add(row.dataset.id);
            this._renderExemptSelectedList();
            this._renderExemptSearchResults(this._taxExemptSearch?.value ?? "");
        });
    }
    // Both bulk helpers below are ADDITIVE (add more candidates, never remove) -
    // they're suggestions the owner reviews in the right column before Save.
    _addHandlerExemptAutoSelect() {
        document.getElementById("taxExemptAutoBtn")?.addEventListener("click", ()=>{
            const threshold = parseFloat(this._taxExemptThreshold?.value);
            if (!Number.isFinite(threshold) || threshold <= 0) {
                this._taxExemptThreshold?.focus();
                return;
            }
            this._exemptMenuItems.forEach((i)=>{
                if (i.price < threshold) this._exemptSelectedIds.add(i._id);
            });
            this._renderExemptSelectedList();
            this._renderExemptSearchResults(this._taxExemptSearch?.value ?? "");
        });
    }
    _addHandlerExemptCategorySelect() {
        document.getElementById("taxExemptCategoryBtn")?.addEventListener("click", ()=>{
            const category = this._taxExemptCategorySelect?.value;
            if (!category) return;
            this._exemptMenuItems.forEach((i)=>{
                if (i.category === category) this._exemptSelectedIds.add(i._id);
            });
            this._renderExemptSelectedList();
            this._renderExemptSearchResults(this._taxExemptSearch?.value ?? "");
        });
    }
    _addHandlerExemptRemove() {
        this._taxExemptList?.addEventListener("click", (e)=>{
            const btn = e.target.closest(".tax-exempt-chip-remove");
            if (!btn) return;
            const id = btn.closest(".tax-exempt-chip")?.dataset.id;
            if (!id) return;
            this._exemptSelectedIds.delete(id);
            this._renderExemptSelectedList();
            this._renderExemptSearchResults(this._taxExemptSearch?.value ?? "");
        });
    }
    _addHandlerExemptClear() {
        this._taxExemptClearBtn?.addEventListener("click", ()=>{
            if (!this._exemptSelectedIds.size) return;
            if (!window.confirm("Remove all products from the tax-exempt list? This won't save until you click Save changes.")) return;
            this._exemptSelectedIds.clear();
            this._renderExemptSelectedList();
            this._renderExemptSearchResults(this._taxExemptSearch?.value ?? "");
        });
    }
    _addHandlerExemptSave(handler) {
        document.getElementById("taxExemptSaveBtn")?.addEventListener("click", ()=>{
            handler([
                ...this._exemptSelectedIds
            ]);
            this.closeExemptModal();
        });
    }
    // ── Handlers — auto adjustments ───────────────────────────────────────────────
    _addHandlerAdjAdd() {
        this._panel.querySelector("#adjPanelAddBtn")?.addEventListener("click", ()=>this.showAdjustmentForm());
        // Delegated: the centered empty-state Add button (re-rendered on each render)
        this._adjList?.addEventListener("click", (e)=>{
            if (e.target.closest(".adj-empty-add")) this.showAdjustmentForm();
        });
    }
    _addHandlerAdjSave(handler) {
        this._adjModal.addEventListener("click", (e)=>{
            if (!e.target.closest("#adjSaveBtn")) return;
            const data = this._getAdjFormData();
            if (!data.name) {
                alert("Please enter a name.");
                return;
            }
            if (isNaN(data.value) || data.value < 0) {
                alert("Please enter a valid value.");
                return;
            }
            handler(data);
            this.closeAdjForm();
        });
    }
    _addHandlerAdjEdit(handler) {
        this._adjList.addEventListener("click", (e)=>{
            const btn = e.target.closest(".adj-panel-edit-btn");
            if (!btn) return;
            handler(btn.dataset.id);
        });
    }
    _addHandlerAdjDelete(handler) {
        this._adjList.addEventListener("click", (e)=>{
            const btn = e.target.closest(".adj-panel-delete-btn");
            if (!btn) return;
            handler(btn.dataset.id);
        });
    }
    _addHandlerAdjToggle(handler) {
        this._adjList.addEventListener("change", (e)=>{
            const toggle = e.target.closest(".adj-toggle");
            if (!toggle) return;
            const id = toggle.closest(".adjustment-item").dataset.id;
            handler(id);
        });
    }
    // Kebab "more" menu (Delete lives here now) - mirrors staffView's .staff-more
    // pattern: opening one closes any other open menu; clicking outside closes it.
    _addHandlerAdjMoreToggle() {
        this._adjList.addEventListener("click", (e)=>{
            const btn = e.target.closest(".adj-more-btn");
            if (!btn) return;
            const menu = btn.closest(".adj-more")?.querySelector(".adj-more-menu");
            this._adjList.querySelectorAll(".adj-more-menu").forEach((m)=>{
                if (m !== menu) m.classList.add("hidden");
            });
            menu?.classList.toggle("hidden");
        });
        document.addEventListener("click", (e)=>{
            if (e.target.closest(".adj-more")) return;
            this._adjList?.querySelectorAll(".adj-more-menu").forEach((m)=>m.classList.add("hidden"));
        });
    }
}
var $c3680931ad48d154$export$2e2bcd8739ae039 = new $c3680931ad48d154$var$DiscountView();




var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");
// Top-level Promos panel (extracted from the Receipt Adjustments panel
// 2026-07-06): stat tiles + a card grid of the business's promo codes, plus
// the create/edit form modal. Codes themselves still live in
// state.discountCodes / the discount_codes table - only the UI moved.
class $066a3d689044816f$var$PromoView {
    _panel = document.querySelector("#promoPanel");
    _stats = document.querySelector("#promoStats");
    _grid = document.querySelector("#promoGrid");
    _formModal = document.querySelector("#discountCodeModal");
    // ── Open / Close ─────────────────────────────────────────────────────────────
    open() {
        this._panel.classList.remove("hidden", "cashflow-exiting");
    }
    close() {
        this._panel.classList.add("cashflow-exiting");
        setTimeout(()=>{
            this._panel.classList.add("hidden");
            this._panel.classList.remove("cashflow-exiting");
        }, 220);
    }
    // ── Rendering ────────────────────────────────────────────────────────────────
    // A code is "used up" when its limited redemptions are exhausted - still
    // status 'active' in the DB, but no longer redeemable at checkout.
    _codeState(dc) {
        if (dc.status === "paused") return "paused";
        if (dc.usageLimit !== null && dc.usageCount >= dc.usageLimit) return "usedup";
        return "active";
    }
    render(codes) {
        this._renderStats(codes);
        this._grid.innerHTML = codes.length ? codes.map((dc)=>this._cardMarkup(dc)).join("") : this._emptyMarkup();
    }
    _renderStats(codes) {
        this._stats.classList.toggle("hidden", codes.length === 0);
        if (!codes.length) return;
        const active = codes.filter((c)=>this._codeState(c) === "active").length;
        const paused = codes.filter((c)=>this._codeState(c) !== "active").length;
        const redeems = codes.reduce((s, c)=>s + (c.usageCount ?? 0), 0);
        const tile = (mod, icon, value, label)=>`
      <div class="promo-stat promo-stat--${mod}">
        <span class="promo-stat-icon" aria-hidden="true">${icon}</span>
        <span class="promo-stat-text">
          <span class="promo-stat-value">${value}</span>
          <span class="promo-stat-label">${label}</span>
        </span>
      </div>`;
        this._stats.innerHTML = `
      ${tile("active", `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="19" height="19"><path d="M2 9a3 3 0 0 1 0 6v3a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3a3 3 0 0 1 0-6V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2"/><path d="M13 17v2"/><path d="M13 11v2"/></svg>`, active, `Active code${active === 1 ? "" : "s"}`)}
      ${tile("paused", `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="19" height="19"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>`, paused, "Paused or used up")}
      ${tile("redeems", `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="19" height="19"><polyline points="20 6 9 17 4 12"/></svg>`, redeems, `Redemption${redeems === 1 ? "" : "s"}`)}`;
    }
    _cardMarkup(dc) {
        const state = this._codeState(dc);
        const pillText = {
            active: "Active",
            paused: "Paused",
            usedup: "Used up"
        }[state];
        const valueText = dc.type === "percentage" ? `${dc.value}% off` : `${(0, $coRoT.formatMoney)(dc.value)} off`;
        let usageHtml;
        if (dc.usageLimit === null) usageHtml = `<span class="promo-usage-text">${dc.usageCount} redeemed &middot; no limit</span>`;
        else {
            const pct = Math.min(100, dc.usageCount / dc.usageLimit * 100);
            usageHtml = `
        <div class="promo-usage-bar"><span class="promo-usage-fill" style="width:${pct}%"></span></div>
        <span class="promo-usage-text">${dc.usageCount} of ${dc.usageLimit} redeemed</span>`;
        }
        return `
      <article class="promo-card promo-card--${state}" data-id="${dc.id}">
        <div class="promo-card-top">
          <span class="promo-code-chip">${(0, $cnCXJ.esc)(dc.code)}</span>
          <span class="promo-pill promo-pill--${state}"><span class="promo-pill-dot" aria-hidden="true"></span>${pillText}</span>
        </div>
        <div class="promo-card-mid">
          <span class="promo-value">${valueText}</span>
          <span class="promo-title">${(0, $cnCXJ.esc)(dc.title)}</span>
          ${dc.description ? `<p class="promo-desc">${(0, $cnCXJ.esc)(dc.description)}</p>` : ""}
        </div>
        <div class="promo-usage">${usageHtml}</div>
        <div class="promo-card-foot">
          <button class="promo-act promo-act-toggle" data-id="${dc.id}" type="button">${state === "paused" ? "Activate" : "Pause"}</button>
          <button class="promo-act promo-act-edit" data-id="${dc.id}" type="button">Edit</button>
          <button class="promo-act promo-act--delete promo-act-delete" data-id="${dc.id}" type="button" aria-label="Delete code">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="15" height="15"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
          </button>
        </div>
      </article>`;
    }
    _emptyMarkup() {
        return `
      <div class="promo-empty">
        <span class="pos-empty-emoji" aria-hidden="true">\u{1F39F}\u{FE0F}</span>
        <p class="pos-empty-title">No promo codes yet</p>
        <p class="pos-empty-sub">Create discount codes like SUMMER20 that<br/>customers can apply at checkout.</p>
        <button class="btn primary pos-empty-add promo-empty-add" type="button">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
          New Code
        </button>
      </div>`;
    }
    // ── Create / edit form modal ─────────────────────────────────────────────────
    showForm(code = null) {
        const isEdit = code !== null;
        let usageType = "unlimited";
        let usageCustom = "";
        if (code) {
            if (code.usageLimit === null) usageType = "unlimited";
            else if (code.usageLimit === 1) usageType = "one-time";
            else {
                usageType = "custom";
                usageCustom = code.usageLimit;
            }
        }
        const formEl = this._formModal.querySelector("#discountCodeForm");
        formEl.innerHTML = `
      <button class="modal-close-btn" id="dcFormCloseBtn" type="button">&times;</button>
      <h2 class="edit-form-title">${isEdit ? "Edit Code" : "New Promo Code"}</h2>

      <div class="edit-field">
        <label for="dcTitle">Title</label>
        <input type="text" id="dcTitle" placeholder="e.g. Summer Sale" value="${isEdit ? (0, $cnCXJ.esc)(code.title) : ""}" />
      </div>

      <div class="edit-field">
        <label for="dcCode">Code</label>
        <input type="text" id="dcCode" placeholder="e.g. SUMMER20"
          value="${isEdit ? (0, $cnCXJ.esc)(code.code) : ""}" autocomplete="off" spellcheck="false" />
      </div>

      <div class="edit-field">
        <label for="dcDesc">
          Description
          <span class="field-optional">(optional)</span>
        </label>
        <input type="text" id="dcDesc" placeholder="e.g. Valid for dine-in orders"
          value="${isEdit ? (0, $cnCXJ.esc)(code.description) : ""}" />
      </div>

      <p class="adj-form-sublabel">Discount Type</p>
      <div class="adj-selector" id="dcTypeSelector">
        <button type="button" class="adj-selector-btn ${!isEdit || code.type === "percentage" ? "active" : ""}"
          data-value="percentage">Percentage (%)</button>
        <button type="button" class="adj-selector-btn ${isEdit && code.type === "fixed" ? "active" : ""}"
          data-value="fixed">Fixed (${(0, $coRoT.currencySymbol)()})</button>
      </div>
      <input type="hidden" id="dcType" value="${isEdit ? code.type : "percentage"}" />

      <div class="edit-field">
        <label for="dcValue" id="dcValueLabel">
          ${isEdit && code.type === "fixed" ? `Amount (${(0, $coRoT.currencySymbol)()})` : "Amount (%)"}
        </label>
        <input type="number" id="dcValue" min="0"
          step="${isEdit && code.type === "fixed" ? "0.01" : "1"}"
          placeholder="0" value="${isEdit ? code.value : ""}" />
      </div>

      <p class="adj-form-sublabel">Usage Limit</p>
      <div class="adj-selector" id="dcUsageSelector">
        <button type="button" class="adj-selector-btn ${usageType === "unlimited" ? "active" : ""}"
          data-value="unlimited">Unlimited</button>
        <button type="button" class="adj-selector-btn ${usageType === "one-time" ? "active" : ""}"
          data-value="one-time">One-time</button>
        <button type="button" class="adj-selector-btn ${usageType === "custom" ? "active" : ""}"
          data-value="custom">Custom</button>
      </div>
      <input type="hidden" id="dcUsageType" value="${usageType}" />

      <div class="edit-field" id="dcCustomUsageField" style="${usageType === "custom" ? "" : "display:none;"}">
        <label for="dcUsageLimit">Max uses</label>
        <input type="number" id="dcUsageLimit" min="2" step="1" placeholder="e.g. 100"
          value="${usageCustom}" />
      </div>

      <div class="adj-form-actions">
        <button type="button" class="btn" id="dcCancelBtn">Cancel</button>
        <button type="button" class="btn primary" id="dcSaveBtn"
          data-edit-id="${isEdit ? code.id : ""}">
          ${isEdit ? "Update" : "Create"}
        </button>
      </div>
    `;
        this._wireForm();
        this._formModal.classList.remove("hidden");
        document.getElementById("dcTitle").focus();
    }
    _wireForm() {
        // Type selector
        const typeSelector = document.getElementById("dcTypeSelector");
        typeSelector?.addEventListener("click", (e)=>{
            const btn = e.target.closest(".adj-selector-btn");
            if (!btn) return;
            typeSelector.querySelectorAll(".adj-selector-btn").forEach((b)=>b.classList.remove("active"));
            btn.classList.add("active");
            document.getElementById("dcType").value = btn.dataset.value;
            const label = document.getElementById("dcValueLabel");
            const input = document.getElementById("dcValue");
            if (btn.dataset.value === "fixed") {
                label.textContent = `Amount (${(0, $coRoT.currencySymbol)()})`;
                input.step = "0.01";
            } else {
                label.textContent = "Amount (%)";
                input.step = "1";
            }
        });
        // Usage selector
        const usageSelector = document.getElementById("dcUsageSelector");
        usageSelector?.addEventListener("click", (e)=>{
            const btn = e.target.closest(".adj-selector-btn");
            if (!btn) return;
            usageSelector.querySelectorAll(".adj-selector-btn").forEach((b)=>b.classList.remove("active"));
            btn.classList.add("active");
            document.getElementById("dcUsageType").value = btn.dataset.value;
            document.getElementById("dcCustomUsageField").style.display = btn.dataset.value === "custom" ? "" : "none";
        });
        // Auto-uppercase, no spaces
        document.getElementById("dcCode")?.addEventListener("input", (e)=>{
            const pos = e.target.selectionStart;
            e.target.value = e.target.value.toUpperCase().replace(/\s/g, "");
            e.target.setSelectionRange(pos, pos);
        });
        document.getElementById("dcFormCloseBtn")?.addEventListener("click", ()=>this.closeForm());
        document.getElementById("dcCancelBtn")?.addEventListener("click", ()=>this.closeForm());
    }
    closeForm() {
        this._formModal.classList.add("hidden");
        this._formModal.querySelector("#discountCodeForm").innerHTML = "";
    }
    _getFormData() {
        const usageType = document.getElementById("dcUsageType")?.value;
        let usageLimit = null;
        if (usageType === "one-time") usageLimit = 1;
        else if (usageType === "custom") usageLimit = parseInt(document.getElementById("dcUsageLimit")?.value) || null;
        return {
            id: document.getElementById("dcSaveBtn")?.dataset.editId || null,
            title: document.getElementById("dcTitle")?.value.trim(),
            code: document.getElementById("dcCode")?.value.toUpperCase().trim(),
            description: document.getElementById("dcDesc")?.value.trim(),
            type: document.getElementById("dcType")?.value,
            value: parseFloat(document.getElementById("dcValue")?.value),
            usageLimit: usageLimit
        };
    }
    // ── Handlers ─────────────────────────────────────────────────────────────────
    _addHandlerOpen(handler) {
        document.addEventListener("click", (e)=>{
            if (!e.target.closest("[data-action='promos']")) return;
            handler();
        });
    }
    _addHandlerClose(handler) {
        this._panel.querySelector(".promo-back").addEventListener("click", ()=>handler());
        // Close the form on backdrop click
        this._formModal.addEventListener("click", (e)=>{
            if (e.target === this._formModal) this.closeForm();
        });
    }
    _addHandlerNewCode(handler) {
        this._panel.querySelector("#promoNewBtn").addEventListener("click", ()=>handler());
        // Delegated: the empty-state New Code button (re-rendered on each render)
        this._grid.addEventListener("click", (e)=>{
            if (e.target.closest(".promo-empty-add")) handler();
        });
    }
    _addHandlerSave(handler) {
        this._formModal.addEventListener("click", (e)=>{
            const btn = e.target.closest("#dcSaveBtn");
            if (!btn) return;
            const data = this._getFormData();
            if (!data.title) {
                alert("Please enter a title.");
                return;
            }
            if (!data.code) {
                alert("Please enter a code.");
                return;
            }
            if (isNaN(data.value) || data.value < 0) {
                alert("Please enter a valid amount.");
                return;
            }
            if (document.getElementById("dcUsageType")?.value === "custom" && !data.usageLimit) {
                alert("Please enter the max number of uses.");
                return;
            }
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler(data), {
                busyText: "Saving\u2026"
            });
        });
    }
    _addHandlerEdit(handler) {
        this._grid.addEventListener("click", (e)=>{
            const btn = e.target.closest(".promo-act-edit");
            if (!btn) return;
            handler(btn.dataset.id);
        });
    }
    _addHandlerDelete(handler) {
        this._grid.addEventListener("click", (e)=>{
            const btn = e.target.closest(".promo-act-delete");
            if (!btn) return;
            handler(btn.dataset.id);
        });
    }
    _addHandlerToggleStatus(handler) {
        this._grid.addEventListener("click", (e)=>{
            const btn = e.target.closest(".promo-act-toggle");
            if (!btn) return;
            handler(btn.dataset.id);
        });
    }
}
var $066a3d689044816f$export$2e2bcd8739ae039 = new $066a3d689044816f$var$PromoView();




var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");

var $dv0h8 = parcelRequire("dv0h8");
// Shared client-side pagination for long lists (page over an already-loaded
// array - no re-fetch per page). Extracted from inventoryView.js's Items/POs/
// History pager (2026-08-27) so loyaltyView.js's customer list can reuse the
// same look and behavior instead of re-implementing it.
const $8c6cc8386f59a55a$export$2660a47c412cb681 = function(arr, page, pageSize) {
    const totalPages = Math.max(1, Math.ceil(arr.length / pageSize));
    const clamped = Math.min(Math.max(1, page), totalPages);
    const start = (clamped - 1) * pageSize;
    return {
        pageItems: arr.slice(start, start + pageSize),
        page: clamped,
        totalPages: totalPages,
        total: arr.length,
        start: start
    };
};
// Page numbers with ellipsis truncation for large page counts.
const $8c6cc8386f59a55a$var$pageButtons = function(page, totalPages) {
    if (totalPages <= 7) return Array.from({
        length: totalPages
    }, (_, i)=>i + 1);
    const set = new Set([
        1,
        2,
        totalPages - 1,
        totalPages,
        page - 1,
        page,
        page + 1
    ]);
    const arr = [
        ...set
    ].filter((p)=>p >= 1 && p <= totalPages).sort((a, b)=>a - b);
    const out = [];
    arr.forEach((p, i)=>{
        if (i > 0 && p - arr[i - 1] > 1) out.push("\u2026");
        out.push(p);
    });
    return out;
};
const $8c6cc8386f59a55a$export$e97ab1b483e292e5 = function(id, { page: page, totalPages: totalPages, total: total, start: start, count: count, pageSize: pageSize, pageSizeOptions: pageSizeOptions, label: label }) {
    if (!total) return '';
    const from = start + 1;
    const to = start + count;
    const pageBtns = $8c6cc8386f59a55a$var$pageButtons(page, totalPages).map((p)=>p === "\u2026" ? `<span class="pg-dots">\u{2026}</span>` : `<button class="pg-btn${p === page ? ' pg-btn--active' : ''}" data-page="${p}" type="button">${p}</button>`).join('');
    return `
    <div class="inv-pager" id="${id}">
      <div class="inv-pager-info">
        Showing <strong>${from.toLocaleString('en-US')}\u{2013}${to.toLocaleString('en-US')}</strong> of <strong>${total.toLocaleString('en-US')}</strong> ${label}
        <select class="inv-cat-select inv-pager-size" data-role="pagesize">
          ${pageSizeOptions.map((n)=>`<option value="${n}"${n === pageSize ? ' selected' : ''}>${n} / page</option>`).join('')}
        </select>
      </div>
      <div class="inv-pager-nav">
        <button class="pg-btn" data-page="${page - 1}" type="button" ${page <= 1 ? 'disabled' : ''}>\u{2039}</button>
        ${pageBtns}
        <button class="pg-btn" data-page="${page + 1}" type="button" ${page >= totalPages ? 'disabled' : ''}>\u{203A}</button>
      </div>
    </div>`;
};
const $8c6cc8386f59a55a$export$b9eef545e49d09b = function(id, onPage, onPageSize) {
    const el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('click', (e)=>{
        const btn = e.target.closest('.pg-btn');
        if (!btn || btn.disabled) return;
        onPage(parseInt(btn.dataset.page, 10));
    });
    el.querySelector('[data-role="pagesize"]')?.addEventListener('change', (e)=>onPageSize(parseInt(e.target.value, 10)));
};



// Shared "unlock with subscription" treatment used by every locked premium
// panel (Inventory / Timesheets / Loyalty / Reports). Pure markup + a
// self-initialized delegated click listener - not a View (owns no DOM element
// of its own), same "pure helper" shape as currency.js / escape.js. Card copy
// lives on model.PLAN_GATED_FEATURES so this file stays purely presentational.
//
// One consistent treatment everywhere: real stat tiles stay live where a
// panel already computes them (Inventory/Loyalty/Timesheets), but the deeper
// locked content is always ONE simple generic blurred preview - never
// customized per sub-tab/section. Each view builds that preview from a small
// set of fabricated records (never real data), and blurWrapMarkup() below
// wraps it with the lock card. Deliberately not "realistic per-tab" - kept
// simple everywhere, including Reports' non-Overview content.

const $ad2a264c69d845ec$var$LOCK_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>`;
const $ad2a264c69d845ec$export$1a67a0177c988e19 = function(featureKey) {
    const f = (0, $1e7ab04ca7920cff$export$c49d59850b41914f)[featureKey];
    if (!f) return '';
    return `
    <div class="plan-lock-card">
      <span class="plan-lock-icon" aria-hidden="true">${$ad2a264c69d845ec$var$LOCK_SVG}</span>
      <h3 class="plan-lock-title">Unlock ${f.title}</h3>
      <p class="plan-lock-blurb">${f.blurb}</p>
      <ul class="plan-lock-bullets">
        ${f.bullets.map((b)=>`<li>${b}</li>`).join('')}
      </ul>
      <div class="plan-lock-price"><span class="plan-lock-price-amt">$19</span><span class="plan-lock-price-period">/mo</span></div>
      <button type="button" class="btn-primary plan-lock-upgrade-btn" data-upgrade-feature="${featureKey}">Upgrade to Unlock</button>
    </div>`;
};
const $ad2a264c69d845ec$export$eef1d84709e6997f = function(featureKey, fakeContentHtml) {
    return `
    <div class="plan-blur-wrap">
      <div class="plan-blur-content" aria-hidden="true">${fakeContentHtml}</div>
      <div class="plan-blur-overlay">${$ad2a264c69d845ec$export$1a67a0177c988e19(featureKey)}</div>
    </div>`;
};
let $ad2a264c69d845ec$var$_upgradeHandler = null;
const $ad2a264c69d845ec$export$f537ff4f9eaa5ce8 = function(handler) {
    $ad2a264c69d845ec$var$_upgradeHandler = handler;
};
document.addEventListener('click', (e)=>{
    const btn = e.target.closest('[data-upgrade-feature]');
    if (!btn) return;
    $ad2a264c69d845ec$var$_upgradeHandler?.(btn.dataset.upgradeFeature);
});


// Fabricated members for the free-plan locked preview - never real data, just
// enough to feed the real _rowMarkup() renderer so the blurred list looks
// exactly like the real one. Same field shape as a real loyalty customer.
const $cc836a0573c6004c$var$FAKE_CUSTOMERS = [
    {
        id: 'fake-1',
        name: 'Jordan R.',
        phone: '15551234567',
        pointsBalance: 340,
        visitCount: 5
    },
    {
        id: 'fake-2',
        name: 'Casey T.',
        phone: '15559876543',
        pointsBalance: 120,
        visitCount: 2
    },
    {
        id: 'fake-3',
        name: 'Sam K.',
        phone: '15552223333',
        pointsBalance: 890,
        visitCount: 12
    },
    {
        id: 'fake-4',
        name: 'Taylor B.',
        phone: '15554445555',
        pointsBalance: 60,
        visitCount: 1
    },
    {
        id: 'fake-5',
        name: 'Morgan D.',
        phone: '15556667777',
        pointsBalance: 410,
        visitCount: 7
    }
];
// Name-hash avatar tint, matching the pattern already used for staff avatars
// (staffView.js) - same 6-color palette, so a customer list and a staff list
// read as the same visual language rather than two different ones.
const $cc836a0573c6004c$var$AVATAR_COLORS = [
    '#22c55e',
    '#3b82f6',
    '#f59e0b',
    '#ec4899',
    '#8b5cf6',
    '#06b6d4'
];
const $cc836a0573c6004c$var$avatarColorFor = (name)=>{
    let hash = 0;
    for (const ch of name)hash = hash * 31 + ch.charCodeAt(0) & 0xffffffff;
    return $cc836a0573c6004c$var$AVATAR_COLORS[Math.abs(hash) % $cc836a0573c6004c$var$AVATAR_COLORS.length];
};
const $cc836a0573c6004c$export$cc69fadc056cc192 = function(el, strip) {
    el.addEventListener("input", ()=>{
        const caretKept = strip(el.value.slice(0, el.selectionStart ?? el.value.length)).length;
        const clean = strip(el.value);
        if (clean !== el.value) {
            el.value = clean;
            try {
                el.setSelectionRange(caretKept, caretKept);
            } catch  {} // not all input types support it
        }
    });
};
// Top-level Loyalty panel: program settings (enable, earn rate, reward
// conversion, streak unit) + stat tiles + the customer list with per-customer
// detail (points ledger + purchase streaks). Customers enroll at checkout or
// via the Add Customer modal here. Follows the Promos panel shell/pattern.
class $cc836a0573c6004c$var$LoyaltyView {
    _panel = document.querySelector("#loyaltyPanel");
    _stats = document.querySelector("#loyaltyStats");
    _list = document.querySelector("#loyaltyCustomerList");
    _listColumns = document.querySelector("#loyaltyListColumns");
    _search = document.querySelector("#loyaltySearchInput");
    _detailModal = document.querySelector("#loyaltyDetailModal");
    _addModal = document.querySelector("#loyaltyAddModal");
    _body = document.querySelector("#loyaltyPanel .loyalty-body");
    _addCustomerBtn = document.querySelector("#loyaltyAddCustomerBtn");
    _settingsDirty = false;
    _lastSettings = null;
    _rewardsList = document.querySelector("#loyaltyRewardsList");
    _rewardsSearch = document.querySelector("#loyaltyRewardSearch");
    _rewardsResults = document.querySelector("#loyaltyRewardSearchResults");
    _rewardsPicked = document.querySelector("#loyaltyRewardPicked");
    _pickedRewardItemId = null;
    // Client-side pagination over the already-loaded (and possibly search-
    // filtered) customer array - a business can accumulate hundreds to low
    // thousands of loyalty members. _cachedCustomers/_cachedStreaks let a page
    // or page-size click re-render locally with no controller round-trip.
    _customersPage = 1;
    _customersPageSize = 25;
    _cachedCustomers = [];
    _cachedStreaks = new Map();
    // ── Open / Close ─────────────────────────────────────────────────────────────
    open() {
        this._panel.classList.remove("hidden", "cashflow-exiting");
        this._addCustomerBtn?.classList.remove("hidden");
        // Reverse a prior locked render: bring back every real body section and
        // hide the lock card (elements are hidden, never removed - see below).
        [
            ...this._body.children
        ].forEach((el)=>{
            if (el.id !== "loyaltyLockedSection") el.classList.remove("hidden");
        });
        this._body.querySelector("#loyaltyLockedSection")?.setAttribute("hidden", "");
    }
    // Free-plan gate: the real stat tiles (live member/points numbers) stay up
    // top; everything else in the body (settings, rewards, customer list) is
    // hidden - never removed, so a later realtime unlock can bring it straight
    // back - and replaced with the lock card. No extra fetch beyond what's
    // needed for the stats themselves.
    renderLockedTeaser(customers, streaks) {
        this._addCustomerBtn?.classList.add("hidden");
        this.renderStats(customers, streaks);
        [
            ...this._body.children
        ].forEach((el)=>{
            if (el.id !== "loyaltyStats" && el.id !== "loyaltyLockedSection") el.classList.add("hidden");
        });
        let lockEl = this._body.querySelector("#loyaltyLockedSection");
        if (!lockEl) {
            lockEl = document.createElement("div");
            lockEl.id = "loyaltyLockedSection";
            this._body.appendChild(lockEl);
        }
        lockEl.hidden = false;
        const fakeList = $cc836a0573c6004c$var$FAKE_CUSTOMERS.map((c)=>this._rowMarkup(c, streaks?.get?.(c.id))).join("");
        lockEl.innerHTML = (0, $ad2a264c69d845ec$export$eef1d84709e6997f)("loyalty", `<div class="loyalty-customer-list">${fakeList}</div>`);
    }
    close() {
        this._panel.classList.add("cashflow-exiting");
        setTimeout(()=>{
            this._panel.classList.add("hidden");
            this._panel.classList.remove("cashflow-exiting");
        }, 220);
    }
    // ── Settings card ────────────────────────────────────────────────────────────
    // Paint the settings controls from saved state and clear the dirty flag.
    syncSettings(settings) {
        this._settingsDirty = false;
        this._lastSettings = settings;
        this._panel.querySelector("#loyaltySettingsActions").classList.add("hidden");
        const toggle = this._panel.querySelector("#loyaltyEnabledToggle");
        toggle.checked = Boolean(settings.loyaltyEnabled);
        this._panel.querySelector("#loyaltyEnabledText").textContent = toggle.checked ? "On" : "Off";
        this._panel.querySelector("#loyaltySettingsFields").classList.toggle("loyalty-settings-fields--off", !toggle.checked);
        this._panel.querySelector("#loyaltyEarnRateInput").value = settings.loyaltyEarnRate;
        this._panel.querySelector("#loyaltyEarnAmountInput").value = settings.loyaltyEarnAmount;
        this._panel.querySelectorAll("[data-loyalty-currency]").forEach((el)=>{
            el.textContent = (0, $coRoT.currencySymbol)();
        });
        this._updateExamples();
        this._updateSettingsSummary(settings);
        this._renderDiscountReward(settings);
    }
    // One-line summary shown in the collapsed accordion header, so the current
    // rate is visible without opening the card.
    _updateSettingsSummary(settings) {
        const el = this._panel.querySelector("#loyaltySettingsSummary");
        if (!el) return;
        el.textContent = settings.loyaltyEnabled ? `Earn ${settings.loyaltyEarnRate} pt${settings.loyaltyEarnRate === 1 ? "" : "s"} per ${(0, $coRoT.currencySymbol)()}${settings.loyaltyEarnAmount} spent` : "Off - customers aren't earning points";
    }
    // ── Program Settings accordion ───────────────────────────────────────────────
    // Collapsed by default (see index.html comment) - toggled by clicking
    // anywhere on the header except the enable switch itself.
    _toggleSettingsAccordion(forceOpen) {
        const card = this._panel.querySelector("#loyaltySettingsCard");
        const fields = this._panel.querySelector("#loyaltySettingsFields");
        const head = this._panel.querySelector("#loyaltySettingsHead");
        let open = forceOpen ?? !card.classList.contains("loyalty-settings-card--expanded");
        // Never collapse away an unsaved change - the Save/Discard row lives
        // inside the collapsible area, so hiding it would hide the only way to
        // resolve the pending edit.
        if (!open && this._settingsDirty) open = true;
        card.classList.toggle("loyalty-settings-card--expanded", open);
        fields.classList.toggle("hidden", !open);
        head.setAttribute("aria-expanded", String(open));
    }
    // Live worked example under the earn inputs. Earning is block-based: N
    // points per FULL M spent (1 pt per 100 → a 250 sale = 2 pts).
    _updateExamples() {
        const earnRate = parseFloat(this._panel.querySelector("#loyaltyEarnRateInput")?.value) || 0;
        const earnAmount = parseFloat(this._panel.querySelector("#loyaltyEarnAmountInput")?.value) || 0;
        const earnEl = this._panel.querySelector("#loyaltyEarnExample");
        if (earnEl && earnRate > 0 && earnAmount > 0) {
            // Pick an example sale sized so the result is a clean, non-zero whole
            // number even for fractional rates (0.1 pt per 1 → a 20.00 sale earns
            // exactly 2). blocksForOnePoint = spend blocks needed for the first
            // whole point; the example uses two points' worth.
            const blocksForOnePoint = Math.ceil(1 / earnRate);
            const exampleBlocks = blocksForOnePoint * 2;
            const exampleSale = earnAmount * exampleBlocks;
            const pts = Math.floor(exampleBlocks * earnRate);
            earnEl.textContent = `Example: a ${(0, $coRoT.formatMoney)(exampleSale)} sale earns ${pts} point${pts === 1 ? "" : "s"}`;
        } else if (earnEl) earnEl.textContent = "";
    }
    _getSettingsValues() {
        return {
            loyaltyEnabled: this._panel.querySelector("#loyaltyEnabledToggle").checked,
            loyaltyEarnRate: parseFloat(this._panel.querySelector("#loyaltyEarnRateInput").value),
            loyaltyEarnAmount: parseFloat(this._panel.querySelector("#loyaltyEarnAmountInput").value)
        };
    }
    _markSettingsDirty() {
        this._settingsDirty = true;
        this._panel.querySelector("#loyaltySettingsActions").classList.remove("hidden");
    }
    // ── Discount Reward row (points → $ off) ─────────────────────────────────────
    // Its own compact inline-edit, separate from the Program Settings
    // Save/Discard flow: click the pencil to edit, Save persists immediately.
    _renderDiscountReward(settings) {
        this._panel.querySelector("#loyaltyDiscountPointsText").textContent = settings.loyaltyRedeemPoints;
        this._panel.querySelector("#loyaltyDiscountValueText").textContent = (0, $coRoT.formatMoney)(settings.loyaltyRedeemValue);
        this._panel.querySelector("#loyaltyDiscountPointsInput").value = settings.loyaltyRedeemPoints;
        this._panel.querySelector("#loyaltyDiscountValueInput").value = settings.loyaltyRedeemValue;
        this._exitDiscountRewardEdit();
    }
    _getDiscountRewardValues() {
        return {
            loyaltyRedeemPoints: parseInt(this._panel.querySelector("#loyaltyDiscountPointsInput").value),
            loyaltyRedeemValue: parseFloat(this._panel.querySelector("#loyaltyDiscountValueInput").value)
        };
    }
    _enterDiscountRewardEdit() {
        this._panel.querySelector("#loyaltyDiscountRewardDisplay").classList.add("hidden");
        this._panel.querySelector("#loyaltyDiscountRewardEdit").classList.remove("hidden");
        this._panel.querySelector("#loyaltyDiscountEditBtn").classList.add("hidden");
        this._panel.querySelector("#loyaltyDiscountPointsInput").focus();
    }
    _exitDiscountRewardEdit() {
        this._panel.querySelector("#loyaltyDiscountRewardDisplay").classList.remove("hidden");
        this._panel.querySelector("#loyaltyDiscountRewardEdit").classList.add("hidden");
        this._panel.querySelector("#loyaltyDiscountEditBtn").classList.remove("hidden");
    }
    // ── Stats + customer list ────────────────────────────────────────────────────
    // streaks: Map<customerId, { day, week, month }> (each { current, best, dateKeys })
    renderStats(customers, streaks) {
        this._stats.classList.toggle("hidden", customers.length === 0);
        if (!customers.length) return;
        const members = customers.length;
        const outstanding = customers.reduce((s, c)=>s + Math.max(0, c.pointsBalance), 0);
        const onStreak = customers.filter((c)=>(streaks.get(c.id)?.day?.current ?? 0) >= 2).length;
        const tile = (mod, icon, value, label)=>`
      <div class="loyalty-stat loyalty-stat--${mod}">
        <span class="loyalty-stat-icon" aria-hidden="true">${icon}</span>
        <span class="loyalty-stat-text">
          <span class="loyalty-stat-value">${value}</span>
          <span class="loyalty-stat-label">${label}</span>
        </span>
      </div>`;
        this._stats.innerHTML = `
      ${tile("members", "\uD83D\uDC65", members, `Member${members === 1 ? "" : "s"}`)}
      ${tile("points", "\u2B50", outstanding.toLocaleString(), "Points outstanding")}
      ${tile("streaks", "\uD83D\uDD25", onStreak, "On a 2+ day streak")}`;
    }
    // Public entry point - called on panel open and on every search keystroke,
    // i.e. whenever the underlying list may have changed. Always resets to
    // page 1 (a new search result set starting mid-page would be confusing).
    renderCustomers(customers, streaks) {
        this._customersPage = 1;
        this._cachedCustomers = customers;
        this._cachedStreaks = streaks;
        this._paintCustomers();
    }
    // Repaints the current page from the cached list - used by the pager's own
    // page/page-size clicks, which must NOT reset back to page 1.
    _paintCustomers() {
        const customers = this._cachedCustomers;
        const streaks = this._cachedStreaks;
        this._listColumns?.classList.toggle("hidden", customers.length === 0);
        if (!customers.length) {
            this._list.innerHTML = this._emptyMarkup();
            return;
        }
        const { pageItems: pageItems, page: page, totalPages: totalPages, total: total, start: start } = (0, $8c6cc8386f59a55a$export$2660a47c412cb681)(customers, this._customersPage, this._customersPageSize);
        this._customersPage = page;
        this._list.innerHTML = pageItems.map((c)=>this._rowMarkup(c, streaks.get(c.id))).join("") + (0, $8c6cc8386f59a55a$export$e97ab1b483e292e5)('loyaltyCustomersPager', {
            page: page,
            totalPages: totalPages,
            total: total,
            start: start,
            count: pageItems.length,
            pageSize: this._customersPageSize,
            pageSizeOptions: [
                25,
                50,
                100
            ],
            label: 'members'
        });
        (0, $8c6cc8386f59a55a$export$b9eef545e49d09b)('loyaltyCustomersPager', (p)=>{
            this._customersPage = p;
            this._paintCustomers();
        }, (n)=>{
            this._customersPageSize = n;
            this._customersPage = 1;
            this._paintCustomers();
        });
    }
    _rowMarkup(c, streak) {
        const current = streak?.day?.current ?? 0;
        const streakHtml = current >= 2 ? `<span class="loyalty-row-streak">\u{1F525} ${current} day${current === 1 ? "" : "s"}</span>` : "";
        const color = $cc836a0573c6004c$var$avatarColorFor(c.name || c.phone);
        const noPoints = c.pointsBalance <= 0;
        return `
      <button class="loyalty-row" data-id="${c.id}" type="button">
        <span class="loyalty-row-avatar" aria-hidden="true" style="color:${color}; background:color-mix(in srgb, ${color} 15%, transparent);">${(0, $cnCXJ.esc)((c.name || c.phone).charAt(0).toUpperCase())}</span>
        <span class="loyalty-row-main">
          <span class="loyalty-row-name-line">
            <span class="loyalty-row-name">${(0, $cnCXJ.esc)(c.name || (0, $dv0h8.formatPhone)(c.phone))}</span>
            ${streakHtml}
          </span>
          <span class="loyalty-row-sub">${c.name ? (0, $cnCXJ.esc)((0, $dv0h8.formatPhone)(c.phone)) : "No name"}</span>
        </span>
        <span class="loyalty-row-meta">
          <span class="loyalty-row-visits">${c.visitCount} visit${c.visitCount === 1 ? "" : "s"}</span>
          <span class="loyalty-row-points${noPoints ? " loyalty-row-points--zero" : ""}">${c.pointsBalance} pts</span>
        </span>
      </button>`;
    }
    _emptyMarkup() {
        return `
      <div class="loyalty-empty">
        <span class="pos-empty-emoji" aria-hidden="true">\u{2B50}</span>
        <p class="pos-empty-title">No members yet</p>
        <p class="pos-empty-sub">Enroll customers at checkout by asking for<br/>their phone number, or add one here.</p>
        <button class="btn primary pos-empty-add loyalty-empty-add" type="button">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
          Add Customer
        </button>
      </div>`;
    }
    // ── Rewards card ─────────────────────────────────────────────────────────────
    // menuItemsById: Map<itemId, menuItem> so a reward row can show the item's
    // current name (never stored on the reward row itself).
    renderRewards(rewards, menuItemsById) {
        this._rewardsList.innerHTML = rewards.length ? rewards.map((r)=>this._rewardRowMarkup(r, menuItemsById.get(r.itemId))).join("") : `<p class="loyalty-reward-list-empty">No rewards configured yet - search for an item above to add one.</p>`;
    }
    _rewardRowMarkup(reward, item) {
        const name = item ? item.itemName : "(item removed)";
        const emoji = item?.iconEmoji || (0, $69bdae3851aa6802$export$3eab5618e62baa45);
        return `
      <div class="loyalty-reward-row" data-id="${reward.id}">
        <span class="loyalty-reward-row-emoji" aria-hidden="true">${(0, $cnCXJ.esc)(emoji)}</span>
        <span class="loyalty-reward-row-name">${(0, $cnCXJ.esc)(name)}</span>
        <span class="loyalty-reward-row-cost">${reward.pointsCost} pts</span>
        <label class="loyalty-enable-toggle loyalty-reward-row-toggle">
          <input type="checkbox" class="loyalty-reward-toggle-input" data-id="${reward.id}" ${reward.active ? "checked" : ""} />
          <span class="loyalty-enable-track" aria-hidden="true"></span>
        </label>
        <button type="button" class="loyalty-reward-row-remove" data-id="${reward.id}" aria-label="Remove reward">\xd7</button>
      </div>`;
    }
    // Single-pick variant of the tax-exempt product search in discountView.js -
    // no staged multi-select, clicking a result immediately reveals the
    // points-cost mini-form via showRewardPicked().
    _renderRewardSearchResults(query, menuItems, excludedItemIds) {
        const q = query.trim().toLowerCase();
        if (!q) {
            this._rewardsResults.innerHTML = "";
            this._rewardsResults.classList.add("hidden");
            return;
        }
        const matches = menuItems.filter((i)=>!excludedItemIds.has(i._id) && i.itemName.toLowerCase().includes(q)).slice(0, 20);
        this._rewardsResults.innerHTML = matches.length ? matches.map((i)=>`
          <li class="loyalty-reward-search-row" data-id="${i._id}" data-name="${(0, $cnCXJ.esc)(i.itemName)}">
            <span class="loyalty-reward-search-row-name">${(0, $cnCXJ.esc)(i.itemName)}</span>
            <span class="loyalty-reward-search-row-meta">${i.category ? `${(0, $cnCXJ.esc)(i.category)} \xb7 ` : ""}${(0, $coRoT.formatMoney)(i.price)}</span>
          </li>`).join("") : `<li class="loyalty-reward-search-row loyalty-reward-search-row--empty">No matching items</li>`;
        this._rewardsResults.classList.remove("hidden");
    }
    showRewardPicked(itemId, itemName) {
        this._pickedRewardItemId = itemId;
        this._panel.querySelector("#loyaltyRewardPickedName").textContent = itemName;
        this._rewardsPicked.classList.remove("hidden");
        this._rewardsResults.classList.add("hidden");
        this._rewardsSearch.value = "";
        const pointsInput = this._panel.querySelector("#loyaltyRewardPointsInput");
        pointsInput.value = "";
        pointsInput.focus();
    }
    hideRewardPicked() {
        this._pickedRewardItemId = null;
        this._rewardsPicked.classList.add("hidden");
    }
    // ── Customer detail modal ────────────────────────────────────────────────────
    // streaks = { day, week, month }, each { current, best, dateKeys }.
    // allTimePoints = lifetime points earned (voided sales excluded).
    showDetail(customer, ledger, streaks, allTimePoints) {
        const memberSince = customer.createdAt ? new Date(customer.createdAt).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric"
        }) : "-";
        const kindMeta = {
            earn: {
                label: "Earned",
                cls: "earn"
            },
            redeem: {
                label: "Redeemed",
                cls: "redeem"
            },
            void_reversal: {
                label: "Sale voided",
                cls: "void"
            }
        };
        const ledgerHtml = ledger.length ? ledger.map((tx)=>{
            const meta = kindMeta[tx.kind] ?? {
                label: tx.kind,
                cls: "other"
            };
            const when = new Date(tx.created_at).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric"
            });
            return `
            <div class="loyalty-tx loyalty-tx--${meta.cls}">
              <span class="loyalty-tx-kind">${meta.label}</span>
              <span class="loyalty-tx-when">${when}</span>
              <span class="loyalty-tx-points">${tx.points > 0 ? "+" : ""}${tx.points} pts</span>
            </div>`;
        }).join("") : `<p class="loyalty-detail-none">No points activity yet.</p>`;
        const dates = streaks?.day?.dateKeys ?? [];
        const datesHtml = dates.length ? dates.slice(0, 14).map((k)=>{
            const [y, m, d] = k.split("-").map(Number);
            const label = new Date(y, m - 1, d).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric"
            });
            return `<span class="loyalty-date-chip">${label}</span>`;
        }).join("") + (dates.length > 14 ? `<span class="loyalty-date-chip loyalty-date-chip--more">+${dates.length - 14} more</span>` : "") : `<p class="loyalty-detail-none">No purchases yet.</p>`;
        const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        const profileBits = [];
        if (customer.email) profileBits.push(`<span class="loyalty-profile-bit">\u{2709}\u{FE0F} ${(0, $cnCXJ.esc)(customer.email)}</span>`);
        if (customer.birthdayMonth && customer.birthdayDay) profileBits.push(`<span class="loyalty-profile-bit">\u{1F382} ${months[customer.birthdayMonth - 1]} ${customer.birthdayDay}</span>`);
        if (customer.note) profileBits.push(`<span class="loyalty-profile-bit loyalty-profile-bit--note">\u{1F4DD} ${(0, $cnCXJ.esc)(customer.note)}</span>`);
        const profileHtml = profileBits.length ? `<div class="loyalty-detail-profile">${profileBits.join("")}</div>` : "";
        const avatarColor = $cc836a0573c6004c$var$avatarColorFor(customer.name || customer.phone);
        this._detailModal.querySelector("#loyaltyDetailBody").innerHTML = `
      <button class="modal-close-btn" id="loyaltyDetailCloseBtn" type="button">&times;</button>
      <div class="loyalty-detail-head">
        <span class="loyalty-row-avatar loyalty-detail-avatar" aria-hidden="true" style="color:${avatarColor}; background:color-mix(in srgb, ${avatarColor} 15%, transparent);">${(0, $cnCXJ.esc)((customer.name || customer.phone).charAt(0).toUpperCase())}</span>
        <div class="loyalty-detail-titles">
          <h2 class="edit-form-title">${(0, $cnCXJ.esc)(customer.name || (0, $dv0h8.formatPhone)(customer.phone))}</h2>
          <p class="loyalty-detail-sub">${(0, $cnCXJ.esc)((0, $dv0h8.formatPhone)(customer.phone))} \xb7 Member since ${memberSince}</p>
        </div>
        <button type="button" class="btn loyalty-detail-edit-btn" id="loyaltyDetailEditBtn" data-id="${customer.id}">Edit</button>
      </div>
      ${profileHtml}
      <div class="loyalty-detail-stats loyalty-detail-stats--three">
        <div class="loyalty-detail-stat loyalty-detail-stat--current"><span class="loyalty-detail-stat-value">${customer.pointsBalance}</span><span class="loyalty-detail-stat-label">Current points</span></div>
        <div class="loyalty-detail-stat loyalty-detail-stat--alltime"><span class="loyalty-detail-stat-value">${(allTimePoints ?? 0).toLocaleString()}</span><span class="loyalty-detail-stat-label">All-time points</span></div>
        <div class="loyalty-detail-stat loyalty-detail-stat--visits"><span class="loyalty-detail-stat-value">${customer.visitCount}</span><span class="loyalty-detail-stat-label">Visits</span></div>
      </div>
      <h3 class="loyalty-detail-section">Streaks</h3>
      <div class="loyalty-streak-grid">
        ${this._streakTile("Daily", "day", streaks)}
        ${this._streakTile("Weekly", "week", streaks)}
        ${this._streakTile("Monthly", "month", streaks)}
      </div>
      <h3 class="loyalty-detail-section">Purchase dates</h3>
      <div class="loyalty-date-chips">${datesHtml}</div>
      <h3 class="loyalty-detail-section">Points activity</h3>
      <div class="loyalty-tx-list">${ledgerHtml}</div>
    `;
        this._detailModal.classList.remove("hidden");
    }
    _streakTile(label, unit, streaks) {
        const s = streaks?.[unit] ?? {
            current: 0,
            best: 0
        };
        return `
      <div class="loyalty-streak-tile loyalty-streak-tile--${unit}">
        <span class="loyalty-streak-tile-label">${label}</span>
        <span class="loyalty-streak-tile-current">${s.current > 0 ? "\uD83D\uDD25 " : ""}${s.current}</span>
        <span class="loyalty-streak-tile-best">Best: ${s.best}</span>
      </div>`;
    }
    closeDetail() {
        this._detailModal.classList.add("hidden");
        this._detailModal.querySelector("#loyaltyDetailBody").innerHTML = "";
    }
    // ── Add-customer modal ───────────────────────────────────────────────────────
    // Dual-purpose form: Add Customer (customer = null) or Edit (prefilled).
    // Phone is read-only in edit mode - it's the identity key (merge/edit = v2).
    showAddForm(customer = null) {
        const isEdit = customer !== null;
        const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        const monthOptions = months.map((m, i)=>`<option value="${i + 1}"${isEdit && customer.birthdayMonth === i + 1 ? " selected" : ""}>${m}</option>`).join("");
        this._addModal.querySelector("#loyaltyAddForm").innerHTML = `
      <button class="modal-close-btn" id="loyaltyAddCloseBtn" type="button">&times;</button>
      <h2 class="edit-form-title">${isEdit ? "Edit Customer" : "Add Customer"}</h2>
      <div class="edit-field">
        <label for="loyaltyAddPhone">Phone number</label>
        <input type="tel" id="loyaltyAddPhone" placeholder="e.g. 5551234567" autocomplete="off" inputmode="numeric"
          value="${isEdit ? (0, $cnCXJ.esc)((0, $dv0h8.formatPhone)(customer.phone)) : ""}" ${isEdit ? "readonly" : 'maxlength="15"'} />
      </div>
      <div class="edit-field">
        <label for="loyaltyAddName">Name <span class="field-optional">(optional)</span></label>
        <input type="text" id="loyaltyAddName" placeholder="e.g. Maria Santos" autocomplete="off"
          value="${isEdit ? (0, $cnCXJ.esc)(customer.name ?? "") : ""}" />
      </div>
      <div class="edit-field">
        <label for="loyaltyAddEmail">Email <span class="field-optional">(optional)</span></label>
        <input type="text" inputmode="email" id="loyaltyAddEmail" placeholder="e.g. maria@email.com" autocomplete="off" spellcheck="false"
          value="${isEdit ? (0, $cnCXJ.esc)(customer.email ?? "") : ""}" />
      </div>
      <div class="edit-field">
        <label for="loyaltyAddBirthdayMonth">Birthday <span class="field-optional">(optional)</span></label>
        <div class="loyalty-birthday-row">
          <select id="loyaltyAddBirthdayMonth">
            <option value="">Month</option>
            ${monthOptions}
          </select>
          <input type="number" id="loyaltyAddBirthdayDay" min="1" max="31" placeholder="Day"
            value="${isEdit && customer.birthdayDay ? customer.birthdayDay : ""}" />
        </div>
      </div>
      <div class="edit-field">
        <label for="loyaltyAddNote">Note <span class="field-optional">(optional, staff only)</span></label>
        <textarea id="loyaltyAddNote" rows="2" placeholder="e.g. Prefers oat milk">${isEdit ? (0, $cnCXJ.esc)(customer.note ?? "") : ""}</textarea>
      </div>
      <div class="adj-form-actions">
        <button type="button" class="btn" id="loyaltyAddCancelBtn">Cancel</button>
        <button type="button" class="btn primary" id="loyaltyAddSaveBtn" data-edit-id="${isEdit ? customer.id : ""}">
          ${isEdit ? "Save" : "Add"}
        </button>
      </div>
    `;
        this._addModal.classList.remove("hidden");
        document.getElementById("loyaltyAddCloseBtn").addEventListener("click", ()=>this.closeAddForm());
        document.getElementById("loyaltyAddCancelBtn").addEventListener("click", ()=>this.closeAddForm());
        if (!isEdit) $cc836a0573c6004c$export$cc69fadc056cc192(document.getElementById("loyaltyAddPhone"), (0, $dv0h8.stripNonDigits));
        $cc836a0573c6004c$export$cc69fadc056cc192(document.getElementById("loyaltyAddName"), (0, $dv0h8.stripNonNameChars));
        $cc836a0573c6004c$export$cc69fadc056cc192(document.getElementById("loyaltyAddEmail"), (0, $dv0h8.stripNonEmailChars));
        document.getElementById(isEdit ? "loyaltyAddName" : "loyaltyAddPhone").focus();
    }
    closeAddForm() {
        this._addModal.classList.add("hidden");
        this._addModal.querySelector("#loyaltyAddForm").innerHTML = "";
    }
    // ── Handlers ─────────────────────────────────────────────────────────────────
    _addHandlerSettingsAccordion() {
        const head = this._panel.querySelector("#loyaltySettingsHead");
        head.addEventListener("click", (e)=>{
            if (e.target.closest(".loyalty-enable-toggle")) return; // don't toggle the accordion when flipping On/Off
            this._toggleSettingsAccordion();
        });
        head.addEventListener("keydown", (e)=>{
            if (e.target.closest(".loyalty-enable-toggle")) return;
            if (e.key !== "Enter" && e.key !== " ") return;
            e.preventDefault();
            this._toggleSettingsAccordion();
        });
    }
    _addHandlerOpen(handler) {
        document.addEventListener("click", (e)=>{
            if (!e.target.closest("[data-action='loyalty']")) return;
            handler();
        });
    }
    _addHandlerClose(handler) {
        this._panel.querySelector(".loyalty-back").addEventListener("click", ()=>handler());
        this._detailModal.addEventListener("click", (e)=>{
            if (e.target === this._detailModal || e.target.closest("#loyaltyDetailCloseBtn")) this.closeDetail();
        });
        this._addModal.addEventListener("click", (e)=>{
            if (e.target === this._addModal) this.closeAddForm();
        });
    }
    _addHandlerSettingsChange() {
        const fields = this._panel.querySelector("#loyaltySettingsFields");
        [
            "#loyaltyEarnRateInput",
            "#loyaltyEarnAmountInput"
        ].forEach((sel)=>{
            this._panel.querySelector(sel).addEventListener("input", ()=>{
                this._markSettingsDirty();
                this._updateExamples();
            });
        });
        this._panel.querySelector("#loyaltyEnabledToggle").addEventListener("change", (e)=>{
            this._panel.querySelector("#loyaltyEnabledText").textContent = e.target.checked ? "On" : "Off";
            fields.classList.toggle("loyalty-settings-fields--off", !e.target.checked);
            this._markSettingsDirty();
        });
    }
    _addHandlerSettingsSave(handler) {
        this._panel.querySelector("#loyaltySettingsSaveBtn").addEventListener("click", (e)=>{
            const values = this._getSettingsValues();
            if (isNaN(values.loyaltyEarnRate) || values.loyaltyEarnRate < 0) {
                alert("Please enter a valid number of points earned.");
                return;
            }
            if (isNaN(values.loyaltyEarnAmount) || values.loyaltyEarnAmount <= 0) {
                alert("Please enter a valid spend amount for earning points.");
                return;
            }
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(e.currentTarget, ()=>handler(values), {
                busyText: "Saving\u2026"
            });
        });
    }
    _addHandlerSettingsDiscard(handler) {
        this._panel.querySelector("#loyaltySettingsDiscardBtn").addEventListener("click", ()=>handler());
    }
    _addHandlerDiscountRewardEdit() {
        this._panel.querySelector("#loyaltyDiscountEditBtn").addEventListener("click", ()=>this._enterDiscountRewardEdit());
    }
    _addHandlerDiscountRewardCancel() {
        this._panel.querySelector("#loyaltyDiscountCancelBtn").addEventListener("click", ()=>{
            this._renderDiscountReward(this._lastSettings ?? this._getDiscountRewardValues());
        });
    }
    _addHandlerDiscountRewardSave(handler) {
        this._panel.querySelector("#loyaltyDiscountSaveBtn").addEventListener("click", (e)=>{
            const values = this._getDiscountRewardValues();
            if (isNaN(values.loyaltyRedeemPoints) || values.loyaltyRedeemPoints < 1) {
                alert("Please enter a valid reward point cost.");
                return;
            }
            if (isNaN(values.loyaltyRedeemValue) || values.loyaltyRedeemValue <= 0) {
                alert("Please enter a valid reward amount.");
                return;
            }
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(e.currentTarget, ()=>handler(values), {
                busyText: "Saving\u2026"
            });
        });
    }
    _addHandlerSearch(handler) {
        this._search.addEventListener("input", ()=>handler(this._search.value.trim()));
    }
    _addHandlerCustomerClick(handler) {
        this._list.addEventListener("click", (e)=>{
            const row = e.target.closest(".loyalty-row");
            if (row) handler(row.dataset.id);
        });
    }
    _addHandlerEditCustomer(handler) {
        this._detailModal.addEventListener("click", (e)=>{
            const btn = e.target.closest("#loyaltyDetailEditBtn");
            if (!btn) return;
            this.closeDetail();
            handler(btn.dataset.id);
        });
    }
    _addHandlerAddCustomer(handler) {
        this._panel.querySelector("#loyaltyAddCustomerBtn").addEventListener("click", ()=>handler());
        // Delegated: the empty-state Add Customer button (re-rendered each render)
        this._list.addEventListener("click", (e)=>{
            if (e.target.closest(".loyalty-empty-add")) handler();
        });
    }
    _addHandlerAddCustomerSave(handler) {
        this._addModal.addEventListener("click", (e)=>{
            const btn = e.target.closest("#loyaltyAddSaveBtn");
            if (!btn) return;
            const data = {
                id: btn.dataset.editId || null,
                phone: document.getElementById("loyaltyAddPhone")?.value.trim(),
                name: document.getElementById("loyaltyAddName")?.value.trim(),
                email: document.getElementById("loyaltyAddEmail")?.value.trim(),
                birthdayMonth: document.getElementById("loyaltyAddBirthdayMonth")?.value,
                birthdayDay: document.getElementById("loyaltyAddBirthdayDay")?.value,
                note: document.getElementById("loyaltyAddNote")?.value.trim()
            };
            if (!data.id && !data.phone) {
                alert("Please enter a phone number.");
                return;
            }
            if (data.email && !data.email.includes("@")) {
                alert("Please enter a valid email address.");
                return;
            }
            // Birthday needs both parts (or neither).
            if (data.birthdayMonth && !data.birthdayDay || !data.birthdayMonth && data.birthdayDay) {
                alert("Please pick both the birthday month and day.");
                return;
            }
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler(data), {
                busyText: "Saving\u2026"
            });
        });
    }
    // ── Rewards handlers ─────────────────────────────────────────────────────────
    _addHandlerRewardSearch(handler) {
        this._rewardsSearch.addEventListener("input", ()=>handler(this._rewardsSearch.value));
    }
    _addHandlerRewardPick(handler) {
        this._rewardsResults.addEventListener("click", (e)=>{
            const row = e.target.closest(".loyalty-reward-search-row[data-id]");
            if (!row) return;
            handler(row.dataset.id, row.dataset.name);
        });
    }
    _addHandlerRewardCancelPick(handler) {
        this._panel.querySelector("#loyaltyRewardCancelPickBtn").addEventListener("click", ()=>handler());
    }
    _addHandlerRewardAdd(handler) {
        this._panel.querySelector("#loyaltyRewardAddBtn").addEventListener("click", (e)=>{
            if (!this._pickedRewardItemId) return;
            const pointsCost = parseInt(this._panel.querySelector("#loyaltyRewardPointsInput").value);
            if (isNaN(pointsCost) || pointsCost < 1) {
                alert("Please enter a valid point cost.");
                return;
            }
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(e.currentTarget, ()=>handler(this._pickedRewardItemId, pointsCost), {
                busyText: "Adding\u2026"
            });
        });
    }
    _addHandlerRewardToggle(handler) {
        this._rewardsList.addEventListener("change", (e)=>{
            const input = e.target.closest(".loyalty-reward-toggle-input");
            if (!input) return;
            handler(input.dataset.id);
        });
    }
    _addHandlerRewardDelete(handler) {
        this._rewardsList.addEventListener("click", (e)=>{
            const btn = e.target.closest(".loyalty-reward-row-remove");
            if (!btn) return;
            handler(btn.dataset.id);
        });
    }
}
var $cc836a0573c6004c$export$2e2bcd8739ae039 = new $cc836a0573c6004c$var$LoyaltyView();



var $dv0h8 = parcelRequire("dv0h8");

var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");


var $dv0h8 = parcelRequire("dv0h8");
// Activity feed - real events derived by model.fetchActivityFeed, cached and
// passed in by the controller. Color associations by tone: good = green
// (sales, time-ins), warn = amber tinted row (low stock), danger = red tinted
// row (out of stock), bad = red icon/amount (money out, voids), info = purple
// (time-outs). `amount` renders as a bold colored figure after the text.
// Relative time label for a feed row. Browser-local, matching the rest of home.
const $8f20510e9e5c6549$var$_relTime = (iso)=>{
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    // Clamp: a timestamp slightly ahead of this device's clock (terminal skew)
    // must age normally instead of sitting on "Just now" until time catches up.
    const diffSec = Math.max(0, (Date.now() - d.getTime()) / 1000);
    if (diffSec < 60) return "Just now";
    if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m ago`;
    const clock = d.toLocaleTimeString([], {
        hour: "numeric",
        minute: "2-digit"
    });
    const startOfDay = (x)=>new Date(x.getFullYear(), x.getMonth(), x.getDate());
    const dayDiff = Math.round((startOfDay(new Date()) - startOfDay(d)) / 86400000);
    if (dayDiff === 0) return clock;
    if (dayDiff === 1) return `Yesterday \xb7 ${clock}`;
    if (dayDiff < 7) return `${d.toLocaleDateString([], {
        weekday: "short"
    })} \xb7 ${clock}`;
    return d.toLocaleDateString([], {
        month: "short",
        day: "numeric"
    });
};
// One event -> the row's presentation. Sale/void payloads are raw sales rows
// (snake_case); the rest are the small shapes fetchActivityFeed builds.
const $8f20510e9e5c6549$var$_toDisplay = (ev)=>{
    const p = ev.payload ?? {};
    switch(ev.type){
        case "sale":
            {
                const inv = p.receipt_number ? ` ${(0, $78df0284a57ee0dd$export$1fa50150e73e75ba)(p.receipt_number, p.sale_date)}` : "";
                return {
                    tone: "good",
                    emoji: "\uD83D\uDCB0",
                    text: `Sale${inv} recorded`,
                    amount: `+${(0, $coRoT.formatMoney)(p.total_price)}`,
                    amountTone: "good"
                };
            }
        case "void":
            {
                const inv = p.receipt_number ? ` ${(0, $78df0284a57ee0dd$export$1fa50150e73e75ba)(p.receipt_number, p.sale_date)}` : "";
                return {
                    tone: "bad",
                    emoji: "\uD83D\uDEAB",
                    text: `Sale${inv} voided`,
                    amount: `-${(0, $coRoT.formatMoney)(p.total_price)}`,
                    amountTone: "bad"
                };
            }
        case "clock_in":
            return {
                tone: "good",
                emoji: "\uD83D\uDC4B",
                text: `${p.staffName} timed in`
            };
        case "clock_out":
            return {
                tone: "info",
                emoji: "\uD83D\uDC4B",
                text: `${p.staffName} timed out`
            };
        case "expense":
            return {
                tone: "bad",
                emoji: "\uD83E\uDDFE",
                text: `Expense \xb7 ${p.description}`,
                amount: `-${(0, $coRoT.formatMoney)(p.amount)}`,
                amountTone: "bad"
            };
        case "stock_adjust":
            return {
                tone: p.delta > 0 ? "good" : "info",
                emoji: "\uD83D\uDDC3\uFE0F",
                text: `${p.itemName} ${p.delta > 0 ? "restocked" : "adjusted"}`,
                amount: `${p.delta > 0 ? "+" : ""}${p.delta} ${p.unit}`,
                amountTone: p.delta > 0 ? "good" : "bad"
            };
        case "customer_enrolled":
            return {
                tone: "good",
                emoji: "\u2B50",
                text: `${p.name || (0, $dv0h8.formatPhone)(p.phone)} joined the loyalty program`
            };
        case "po_received":
            return {
                tone: "good",
                emoji: "\uD83D\uDE9A",
                text: `PO-${String(p.poNumber ?? 0).padStart(3, "0")} received${p.supplierName ? ` from ${p.supplierName}` : ""} \xb7 stock updated`
            };
        case "low_stock":
            return {
                tone: "warn",
                emoji: "\u26A0\uFE0F",
                text: `${p.itemName} is running low \xb7 ${p.quantity} ${p.unit} left`
            };
        case "out_of_stock":
            return {
                tone: "danger",
                emoji: "\uD83D\uDEA8",
                text: `${p.itemName} is out of stock`
            };
        default:
            return {
                tone: "info",
                emoji: "\u2728",
                text: "Update"
            };
    }
};
const $8f20510e9e5c6549$var$_feedItemsMarkup = (entries)=>entries.map((ev)=>{
        const f = $8f20510e9e5c6549$var$_toDisplay(ev);
        const classes = `home-feed-item home-feed-item--${f.tone}${ev.clickable ? " home-feed-item--click" : ""}`;
        const attrs = ev.clickable ? ` role="button" tabindex="0"` : "";
        return `
    <li class="${classes}" data-evt-id="${(0, $cnCXJ.esc)(ev.id)}"${attrs}>
      <span class="home-feed-icon" aria-hidden="true">${f.emoji}</span>
      <span class="home-feed-text">${(0, $cnCXJ.esc)(f.text)}${f.amount ? ` <strong class="home-feed-amt home-feed-amt--${f.amountTone}">${(0, $cnCXJ.esc)(f.amount)}</strong>` : ""}</span>
      <span class="home-feed-time">${(0, $cnCXJ.esc)($8f20510e9e5c6549$var$_relTime(ev.ts))}</span>
    </li>`;
    }).join("");
// Per-step presentation, mirroring the "Set up your catalogue" banner's
// anatomy: emoji tile + title + one-line subtitle + green pill CTA. The
// owner's direction (2026-07-06): the steps must look like that banner,
// NOT like a checkbox list - so only PENDING steps render (as mini
// banners) and completed ones simply disappear, with the header's
// "N of 6 complete" + progress bar carrying the sense of progress.
const $8f20510e9e5c6549$var$STEP_META = {
    items: {
        emoji: "\uD83D\uDCE6",
        sub: "Add your items to start taking orders.",
        cta: "Add Items"
    },
    taxes: {
        emoji: "\uD83E\uDDFE",
        sub: "Review the taxes and fees on your receipts.",
        cta: "Review"
    },
    inventory: {
        emoji: "\uD83D\uDDC3\uFE0F",
        sub: "Track stock and get low-stock alerts.",
        cta: "Explore"
    },
    receipt: {
        emoji: "\uD83D\uDDA8\uFE0F",
        sub: "Choose what shows on your receipts.",
        cta: "Customize"
    },
    team: {
        emoji: "\uD83D\uDC65",
        sub: "Invite staff with their own logins and roles.",
        cta: "Set Up"
    },
    sale: {
        emoji: "\uD83D\uDED2",
        sub: "Ring up your first order at the register.",
        cta: "New Order"
    }
};
// Home "Getting Started" card (#homeChecklistCard). The controller computes
// the steps from live state and calls render(); every pending step's CTA
// deep-links to the panel where the step is done. When the last step
// completes while the card is on screen, the controller swaps in a short
// celebration (renderCelebrate) and then hides the card for good.
class $8f20510e9e5c6549$var$GettingStartedView {
    _card = document.getElementById("homeChecklistCard");
    _list = document.getElementById("homeChecklistList");
    _sub = document.getElementById("homeChecklistSub");
    _fill = document.getElementById("homeChecklistFill");
    render(steps) {
        if (!this._card) return;
        // Reset any activity-mode chrome (defensive - the checklist never returns
        // once the feed takes over, but render order shouldn't be able to wedge it).
        document.getElementById("homeChecklistTitle").textContent = "Getting Started";
        document.getElementById("homeChecklistProgress")?.classList.remove("hidden");
        document.getElementById("homeChecklistDismiss")?.classList.remove("hidden");
        document.getElementById("homeActivityViewAll")?.classList.add("hidden");
        document.getElementById("homeChecklistFoot")?.classList.remove("hidden");
        this._list.classList.remove("home-feed-list");
        const done = steps.filter((s)=>s.done).length;
        if (this._sub) this._sub.textContent = done === 0 ? "Set up your store step by step" : `${done} of ${steps.length} complete`;
        if (this._fill) this._fill.style.width = `${done / steps.length * 100}%`;
        this._list.innerHTML = steps.filter((s)=>!s.done).map((s)=>{
            const meta = $8f20510e9e5c6549$var$STEP_META[s.id] ?? {
                emoji: "\u2728",
                sub: "",
                cta: "Open"
            };
            return `
        <li>
          <div class="home-checklist-task">
            <span class="home-checklist-task-icon" aria-hidden="true">${meta.emoji}</span>
            <div class="home-checklist-task-text">
              <div class="home-checklist-task-title">${(0, $cnCXJ.esc)(s.label)}</div>
              <div class="home-checklist-task-sub">${(0, $cnCXJ.esc)(meta.sub)}</div>
            </div>
            <button class="btn primary home-checklist-cta" data-step="${s.id}" type="button">${(0, $cnCXJ.esc)(meta.cta)}</button>
          </div>
        </li>`;
        }).join("");
        this._card.classList.remove("hidden");
    }
    renderCelebrate(total) {
        if (!this._card) return;
        if (this._sub) this._sub.textContent = `All ${total} steps complete`;
        if (this._fill) this._fill.style.width = "100%";
        this._list.innerHTML = `
      <li class="home-checklist-done">
        <span class="home-checklist-done-emoji" aria-hidden="true">\u{1F389}</span>
        <p class="home-checklist-done-title">You're all set!</p>
        <p class="home-checklist-done-sub">Your store is ready for business. This card will make way for your activity feed soon.</p>
      </li>`;
        this._card.classList.remove("hidden");
    }
    hide() {
        this._card?.classList.add("hidden");
    }
    // ── Activity feed ────────────────────────────────────────────────────────────
    // Takes over the card once the checklist is completed or dismissed. Header
    // swaps to "Activity", the progress bar and the x give way to "View all"
    // (which opens the expanded modal). Entries come from the controller's
    // cached model.fetchActivityFeed result; { loaded } distinguishes "still
    // fetching" (quiet card) from "genuinely no activity" (empty state).
    renderActivityFeed(entries, { loaded: loaded = true } = {}) {
        if (!this._card) return;
        document.getElementById("homeChecklistTitle").textContent = "Activity";
        if (this._sub) this._sub.textContent = "What's been happening in your store";
        document.getElementById("homeChecklistProgress")?.classList.add("hidden");
        document.getElementById("homeChecklistDismiss")?.classList.add("hidden");
        document.getElementById("homeActivityViewAll")?.classList.remove("hidden");
        this._list.classList.add("home-feed-list");
        if (!loaded) this._list.innerHTML = "";
        else if (!entries.length) this._list.innerHTML = `<li class="home-feed-empty">No activity yet - sales, clock-ins, expenses and stock changes will show up here.</li>`;
        else // All 15 cached entries: the card is a fixed-height bento fill (its
        // bottom edge lines up with the Active Queue panel), so the list is
        // always full at any viewport and scrolls for the rest.
        this._list.innerHTML = $8f20510e9e5c6549$var$_feedItemsMarkup(entries);
        // The checklist footnote has no feed equivalent - hide it so its padding
        // doesn't eat row space (render() unhides it for the checklist).
        document.getElementById("homeChecklistFoot")?.classList.add("hidden");
        this._card.classList.remove("hidden");
    }
    showActivityModal(entries) {
        const modal = document.getElementById("activityLogModal");
        if (!modal) return;
        this.renderActivityModalList(entries);
        modal.classList.remove("hidden");
    }
    // Split out so the controller can live-update the list while the modal is open.
    renderActivityModalList(entries) {
        const list = document.getElementById("activityModalList");
        if (!list) return;
        list.innerHTML = entries.length ? $8f20510e9e5c6549$var$_feedItemsMarkup(entries) : `<li class="home-feed-empty">No activity yet - sales, clock-ins, expenses and stock changes will show up here.</li>`;
    }
    isActivityModalOpen() {
        return !document.getElementById("activityLogModal")?.classList.contains("hidden");
    }
    closeActivityModal() {
        document.getElementById("activityLogModal")?.classList.add("hidden");
    }
    _addHandlerViewAll(handler) {
        document.getElementById("homeActivityViewAll")?.addEventListener("click", ()=>handler());
        document.getElementById("activityModalCloseBtn")?.addEventListener("click", ()=>this.closeActivityModal());
    }
    _addHandlerActivityClick(handler) {
        const dispatch = (e)=>{
            const row = e.target.closest(".home-feed-item--click");
            if (!row) return;
            if (e.type === "keydown" && e.key !== "Enter" && e.key !== " ") return;
            if (e.type === "keydown") e.preventDefault();
            handler(row.dataset.evtId);
        };
        [
            this._list,
            document.getElementById("activityModalList")
        ].forEach((el)=>{
            el?.addEventListener("click", dispatch);
            el?.addEventListener("keydown", dispatch);
        });
    }
    _addHandlerStep(handler) {
        this._list?.addEventListener("click", (e)=>{
            const btn = e.target.closest(".home-checklist-cta");
            if (!btn) return;
            handler(btn.dataset.step);
        });
    }
    _addHandlerDismiss(handler) {
        document.getElementById("homeChecklistDismiss")?.addEventListener("click", ()=>handler());
    }
}
var $8f20510e9e5c6549$export$2e2bcd8739ae039 = new $8f20510e9e5c6549$var$GettingStartedView();




var $cnCXJ = parcelRequire("cnCXJ");
const $ad4542f6315399f1$export$eabead3694f936e9 = {
    shield: {
        color: '#22c55e',
        svg: `<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>`
    },
    star: {
        color: '#f59e0b',
        svg: `<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>`
    },
    utensils: {
        color: '#ef4444',
        svg: `<path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/>`
    },
    coffee: {
        color: '#b45309',
        svg: `<path d="M17 8h1a4 4 0 1 1 0 8h-1"/><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z"/><line x1="6" y1="2" x2="6" y2="4"/><line x1="10" y1="2" x2="10" y2="4"/><line x1="14" y1="2" x2="14" y2="4"/>`
    },
    card: {
        color: '#3b82f6',
        svg: `<rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>`
    },
    clipboard: {
        color: '#8b5cf6',
        svg: `<rect x="8" y="2" width="8" height="4" rx="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>`
    },
    headset: {
        color: '#06b6d4',
        svg: `<path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm18 0h-3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-5Z"/><path d="M21 11a9 9 0 0 0-18 0"/>`
    },
    sparkles: {
        color: '#ec4899',
        svg: `<path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3Z"/>`
    }
};
const $ad4542f6315399f1$var$ROLE_ICON_KEYS = Object.keys($ad4542f6315399f1$export$eabead3694f936e9);
const $ad4542f6315399f1$export$f2ded4d444c5e9fa = (role)=>{
    if (role?.icon && $ad4542f6315399f1$export$eabead3694f936e9[role.icon]) return role.icon;
    if (role?.locked) return 'shield';
    let hash = 0;
    for (const ch of role?.name ?? '')hash = hash * 31 + ch.charCodeAt(0) & 0xffffffff;
    return $ad4542f6315399f1$var$ROLE_ICON_KEYS[Math.abs(hash) % $ad4542f6315399f1$var$ROLE_ICON_KEYS.length];
};
const $ad4542f6315399f1$export$9f6b22197de5953a = (role)=>$ad4542f6315399f1$export$eabead3694f936e9[$ad4542f6315399f1$export$f2ded4d444c5e9fa(role)];
const $ad4542f6315399f1$var$roleIconTile = (role, size = 40)=>{
    const { color: color, svg: svg } = $ad4542f6315399f1$export$9f6b22197de5953a(role);
    return `
    <span class="staff-role-tile" style="background:color-mix(in srgb, ${color} 11%, transparent);color:${color};width:${size}px;height:${size}px">
      <svg xmlns="http://www.w3.org/2000/svg" width="${Math.round(size * 0.48)}" height="${Math.round(size * 0.48)}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">${svg}</svg>
    </span>`;
};
class $ad4542f6315399f1$var$StaffView {
    _panel = document.querySelector('#staffPanel');
    _list = document.querySelector('#staffList');
    _rolesEl = document.querySelector('#staffRolesContent');
    _formModal = document.querySelector('#inviteStaffModal');
    open(canManage = false) {
        this._panel.classList.remove('hidden', 'cashflow-exiting');
        const inviteBtn = this._panel.querySelector('#inviteStaffBtn');
        if (inviteBtn) inviteBtn.classList.toggle('hidden', !canManage);
        this._switchTab('members');
    }
    _switchTab(tab) {
        this._panel.querySelectorAll('.staff-tab').forEach((btn)=>{
            btn.classList.toggle('staff-tab--active', btn.dataset.tab === tab);
        });
        document.getElementById('staffMembersWrap')?.classList.toggle('hidden', tab !== 'members');
        this._rolesEl.classList.toggle('hidden', tab !== 'roles');
    }
    _addHandlerTabs() {
        this._panel.querySelector('.staff-sidebar')?.addEventListener('click', (e)=>{
            const btn = e.target.closest('.staff-tab, #inviteStaffBtn');
            if (!btn) return;
            if (btn.classList.contains('staff-tab')) this._switchTab(btn.dataset.tab);
            this._closeDrawer(); // Invite opens a modal; either way the drawer's job is done
        });
    }
    // ── Mobile sidebar drawer ────────────────────────────────────────────────────
    // Below 640px the sidebar is an off-canvas drawer (same pattern as the
    // Settings modal's mobile nav): opened from the header hamburger, closed by
    // the backdrop or by picking a tab / Invite.
    _openDrawer() {
        this._panel.querySelector('#staffSidebar')?.classList.add('panel-sidebar--open');
        this._panel.querySelector('#staffNavBackdrop')?.classList.add('panel-nav-backdrop--visible');
        this._panel.querySelector('#staffNavBtn')?.setAttribute('aria-expanded', 'true');
    }
    _closeDrawer() {
        this._panel.querySelector('#staffSidebar')?.classList.remove('panel-sidebar--open');
        this._panel.querySelector('#staffNavBackdrop')?.classList.remove('panel-nav-backdrop--visible');
        this._panel.querySelector('#staffNavBtn')?.setAttribute('aria-expanded', 'false');
    }
    _addHandlerDrawer() {
        const btn = this._panel.querySelector('#staffNavBtn');
        btn?.addEventListener('click', ()=>{
            if (btn.getAttribute('aria-expanded') === 'true') this._closeDrawer();
            else this._openDrawer();
        });
        this._panel.querySelector('#staffNavBackdrop')?.addEventListener('click', ()=>this._closeDrawer());
    }
    close() {
        this._closeDrawer();
        this._panel.classList.add('cashflow-exiting');
        setTimeout(()=>{
            this._panel.classList.add('hidden');
            this._panel.classList.remove('cashflow-exiting');
        }, 220);
    }
    _staffCache = {
        staff: [],
        canManage: false,
        roles: []
    };
    // Set by the controller from the reset_staff_mfa capability; gates the
    // "Remove 2FA" menu item separately from the rest of the manage_staff actions.
    canResetMFA = false;
    _staffQuery = '';
    _moreWired = false;
    render(staff, canManage = false, roles = []) {
        this._staffCache = {
            staff: staff,
            canManage: canManage,
            roles: roles
        };
        if (!this._moreWired) {
            this._moreWired = true;
            // "More" dropdown: toggle its own menu, close any other; outside click closes all.
            this._list.addEventListener('click', (e)=>{
                const btn = e.target.closest('[data-action="more"]');
                if (!btn) return;
                const menu = btn.closest('.staff-more')?.querySelector('.staff-more-menu');
                this._list.querySelectorAll('.staff-more-menu').forEach((m)=>{
                    if (m !== menu) m.classList.add('hidden');
                });
                menu?.classList.toggle('hidden');
            });
            document.addEventListener('click', (e)=>{
                if (e.target.closest('.staff-more')) return;
                this._list.querySelectorAll('.staff-more-menu').forEach((m)=>m.classList.add('hidden'));
            });
        }
        const head = document.getElementById('staffMembersHead');
        if (head) {
            head.innerHTML = `
        <div class="staff-members-top">
          <div>
            <h3 class="adj-section-title">Staff</h3>
            <p class="adj-section-hint">Manage your team members and their access.</p>
          </div>
          <div class="staff-members-tools">
            <div class="staff-search">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input type="text" id="staffSearchInput" placeholder="Search members..." autocomplete="off" value="${(0, $cnCXJ.esc)(this._staffQuery)}" />
            </div>
            <span class="staff-members-count">${staff.length} member${staff.length === 1 ? '' : 's'}</span>
          </div>
        </div>
        <div class="staff-table-cols">
          <span>Member</span><span>Role</span><span>Status</span><span>PIN Access</span><span class="staff-col-actions">Actions</span>
        </div>`;
            const input = document.getElementById('staffSearchInput');
            input?.addEventListener('input', ()=>{
                this._staffQuery = input.value;
                this._renderListBody();
            });
        }
        this._renderListBody();
    }
    _renderListBody() {
        const { staff: staff, canManage: canManage, roles: roles } = this._staffCache;
        const q = this._staffQuery.trim().toLowerCase();
        const filtered = q ? staff.filter((s)=>`${s.firstName ?? ''} ${s.lastName ?? ''} ${s.email ?? ''}`.toLowerCase().includes(q)) : staff;
        this._list.innerHTML = q && !filtered.length ? `<li class="staff-empty">No members match "${(0, $cnCXJ.esc)(this._staffQuery.trim())}".</li>` : this._generateListMarkup(filtered, canManage, roles);
    }
    // opts = { canManage, ownRoleId, labels, totalCaps, counts } (counts = roleId -> member count)
    renderRoles(roles, opts = {}) {
        const { canManage: canManage = false, ownRoleId: ownRoleId = null, labels: labels = {}, counts: counts = {} } = opts;
        if (!roles?.length) {
            this._rolesEl.innerHTML = `<p class="staff-empty">No roles defined.</p>`;
            return;
        }
        const cards = roles.map((r)=>{
            const isOwnRole = r.id === ownRoleId;
            const chips = r.locked ? '' : r.caps?.length ? r.caps.slice(0, 4).map((k)=>`<span class="staff-role-chip">${(0, $cnCXJ.esc)(labels[k] ?? k)}</span>`).join('') + (r.caps.length > 4 ? `<span class="staff-role-chip staff-role-chip--more">+${r.caps.length - 4}</span>` : '') : `<span class="staff-role-chip staff-role-chip--none">No access</span>`;
            const desc = r.locked ? 'Full access to all features and settings.' : r.description || `${r.caps?.length ?? 0} capabilities granted.`;
            const nMembers = counts[r.id] ?? 0;
            let actions = '';
            if (canManage) {
                if (r.locked) actions = `<span class="staff-role-locked" title="The Admin role always has full access">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            Locked
          </span>`;
                else if (isOwnRole) actions = `<span class="staff-role-locked" title="You can't edit the role you're currently assigned to">Your role</span>`;
                else actions = `
            <button class="staff-action-btn" data-role-action="edit" data-id="${r.id}" type="button" title="Edit role">Edit</button>
            <button class="staff-action-btn staff-action-btn--remove" data-role-action="delete" data-id="${r.id}" type="button" title="Delete role">Delete</button>`;
            }
            return `
        <div class="staff-role-card">
          ${$ad4542f6315399f1$var$roleIconTile(r, 44)}
          <div class="staff-role-card-info">
            <div class="staff-role-card-name">
              ${(0, $cnCXJ.esc)(r.name)}
              ${r.locked ? `<span class="staff-role-system">System role</span>` : ''}
            </div>
            <div class="staff-role-card-desc">${(0, $cnCXJ.esc)(desc)}</div>
            ${chips ? `<div class="staff-role-chips">${chips}</div>` : ''}
          </div>
          <span class="staff-role-members">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            ${nMembers} member${nMembers === 1 ? '' : 's'}
          </span>
          <div class="staff-role-card-actions">${actions}</div>
        </div>`;
        }).join('');
        this._rolesEl.innerHTML = `
      <div class="staff-members-top">
        <div>
          <h3 class="adj-section-title">Roles</h3>
          <p class="adj-section-hint">Create and manage roles with specific permissions.</p>
        </div>
        ${canManage ? `<button class="btn primary" id="staffAddRoleBtn" type="button">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
          New Role
        </button>` : ''}
      </div>
      <div class="staff-role-list">${cards}</div>`;
    }
    _generateListMarkup(staff, canManage, roles = []) {
        if (!staff.length) return `<li class="staff-empty">No staff members yet. Hit "+ Invite" to add someone.</li>`;
        const AVATAR_COLORS = [
            '#22c55e',
            '#3b82f6',
            '#f59e0b',
            '#ec4899',
            '#8b5cf6',
            '#06b6d4'
        ];
        const ROLE_CHIP_COLORS = [
            '#3b82f6',
            '#f59e0b',
            '#8b5cf6',
            '#06b6d4',
            '#ec4899',
            '#ef4444'
        ];
        return staff.map((s, i)=>{
            const initials = `${s.firstName?.[0] ?? ''}${s.lastName?.[0] ?? ''}`.toUpperCase() || '?';
            const color = AVATAR_COLORS[i % AVATAR_COLORS.length];
            const role = roles.find((r)=>r.id === s.roleId);
            const isAdmin = role?.locked || s.role === 'Admin';
            const chipColor = isAdmin ? 'var(--brand-1)' : ROLE_CHIP_COLORS[Math.max(0, roles.findIndex((r)=>r.id === s.roleId)) % ROLE_CHIP_COLORS.length];
            const roleSub = isAdmin ? 'Full access' : role?.description || 'Custom role';
            return `
      <li class="staff-item" data-id="${s.id}">
        <div class="staff-cell staff-cell--who">
          <div class="staff-avatar" style="background:${color}">${(0, $cnCXJ.esc)(initials)}</div>
          <div class="staff-item-info">
            <div class="staff-item-name">${(0, $cnCXJ.esc)(s.firstName)} ${(0, $cnCXJ.esc)(s.lastName)}${s.isSelf ? ' <span class="staff-you-tag">You</span>' : ''}</div>
            <div class="staff-item-email">${(0, $cnCXJ.esc)(s.email)}</div>
          </div>
        </div>
        <div class="staff-cell staff-cell--role">
          <span class="staff-role-badge" style="background:color-mix(in srgb, ${chipColor} 12%, transparent);color:${chipColor}">${(0, $cnCXJ.esc)(s.role)}</span>
          <span class="staff-cell-sub">${(0, $cnCXJ.esc)(roleSub)}</span>
        </div>
        <div class="staff-cell">
          <span class="staff-status-badge staff-status-badge--${s.isPending ? 'pending' : 'active'}">
            <span class="staff-status-dot"></span>${s.isPending ? 'Pending' : 'Active'}
          </span>
        </div>
        <div class="staff-cell staff-cell--pin">
          <span class="staff-pin-lock${s.hasPin ? ' staff-pin-lock--set' : ''}">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          </span>
          <div class="staff-item-info">
            <span class="staff-pin-label">${s.hasPin ? 'PIN set' : 'No PIN'}</span>
            <span class="staff-cell-sub">${s.hasPin ? "\u2022\u2022\u2022\u2022" : 'Not set'}</span>
          </div>
        </div>
        <div class="staff-cell staff-cell--actions">
        ${canManage && !s.isSelf ? `
          <div class="staff-more">
            <button class="staff-action-btn staff-more-btn staff-more-btn--lg" data-action="more" type="button" aria-label="More actions">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
              More
            </button>
            <div class="staff-more-menu hidden">
              ${!s.isOwner ? `
              <button class="staff-more-item" data-id="${s.id}" data-action="edit" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                Edit
              </button>` : ''}
              <button class="staff-more-item" data-id="${s.id}" data-action="pin" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                ${s.hasPin ? 'Change PIN' : 'Set PIN'}
              </button>
              ${!s.isOwner && this.canResetMFA ? `
              <button class="staff-more-item" data-id="${s.id}" data-action="remove-mfa" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><line x1="9.5" y1="9.5" x2="14.5" y2="14.5"/><line x1="14.5" y1="9.5" x2="9.5" y2="14.5"/></svg>
                Remove 2FA
              </button>` : ''}
              ${!s.isOwner ? `
              <button class="staff-more-item staff-more-item--danger" data-id="${s.id}" data-action="remove" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                Remove member
              </button>` : ''}
            </div>
          </div>
        ` : ''}
        </div>
      </li>`;
        }).join('');
    }
    showInviteForm(roles) {
        const formEl = this._formModal.querySelector('#inviteStaffForm');
        formEl.innerHTML = `
      <button class="modal-close-btn" id="inviteFormCloseBtn" type="button">&times;</button>
      <h2 class="edit-form-title">Invite Staff Member</h2>

      <div class="edit-fields-row">
        <div class="edit-field">
          <label for="inviteFirstName">First name</label>
          <input type="text" id="inviteFirstName" placeholder="Jane" autocomplete="off" />
        </div>
        <div class="edit-field">
          <label for="inviteLastName">Last name</label>
          <input type="text" id="inviteLastName" placeholder="Smith" autocomplete="off" />
        </div>
      </div>

      <div class="edit-field">
        <label for="inviteEmail">Email</label>
        <input type="email" id="inviteEmail" placeholder="staff@example.com" autocomplete="off" />
      </div>

      <div class="edit-field">
        <label for="inviteRole">Role</label>
        <select id="inviteRole" class="settings-select">
          ${roles.map((r)=>`<option value="${(0, $cnCXJ.esc)(r.id)}">${(0, $cnCXJ.esc)(r.name)}</option>`).join('')}
        </select>
      </div>

      <div id="inviteTcReflect">${this._tcReflectHtml(roles[0])}</div>

      <p class="settings-section-hint" style="margin-top:8px;">
        An invite email will be sent to this address. They'll set their password and PIN when they click the link.
      </p>

      <div class="adj-form-actions">
        <button type="button" class="btn" id="inviteCancelBtn">Cancel</button>
        <button type="button" class="btn primary" id="inviteSaveBtn">Add Member</button>
      </div>
    `;
        document.getElementById('inviteFormCloseBtn')?.addEventListener('click', ()=>this.closeForm());
        document.getElementById('inviteCancelBtn')?.addEventListener('click', ()=>this.closeForm());
        const roleSel = document.getElementById('inviteRole');
        const reflectEl = document.getElementById('inviteTcReflect');
        roleSel?.addEventListener('change', ()=>{
            if (reflectEl) reflectEl.innerHTML = this._tcReflectHtml(roles.find((r)=>r.id === roleSel.value));
        });
        this._formModal.classList.remove('hidden');
        document.getElementById('inviteFirstName')?.focus();
    }
    // Read-only reflection of whether a role grants time-clock access. Access is
    // role-based (the use_timeclock capability), so this just mirrors it - the
    // owner changes it under Staff → Roles, keeping a single source of truth.
    _tcReflectHtml(role) {
        const on = Array.isArray(role?.caps) && role.caps.includes('use_timeclock');
        return `
      <div class="tc-reflect tc-reflect--${on ? 'on' : 'off'}">
        <span class="tc-reflect-dot"></span>
        <div class="tc-reflect-text">
          <p class="tc-reflect-title">Time tracking: <strong>${on ? 'On' : 'Off'}</strong>${role ? ` <span class="tc-reflect-role">(from ${(0, $cnCXJ.esc)(role.name)})</span>` : ''}</p>
          <p class="tc-reflect-hint">${on ? 'This role can clock in and out on the Time Clock.' : "This role can't use the Time Clock."} Time-clock access is set by the role - edit it under Staff \u{2192} Roles.</p>
        </div>
      </div>`;
    }
    closeForm() {
        this._formModal.classList.add('hidden');
        this._formModal.querySelector('#inviteStaffForm').innerHTML = '';
    }
    _getInviteData() {
        return {
            firstName: document.getElementById('inviteFirstName')?.value.trim(),
            lastName: document.getElementById('inviteLastName')?.value.trim(),
            email: document.getElementById('inviteEmail')?.value.trim(),
            roleId: document.getElementById('inviteRole')?.value
        };
    }
    // ── Handlers ──────────────────────────────────────────────────────────────────
    _addHandlerOpen(handler) {
        document.addEventListener('click', (e)=>{
            if (!e.target.closest("[data-action='staff']")) return;
            handler();
        });
    }
    _addHandlerClose(handler) {
        this._panel.querySelector('.staff-back')?.addEventListener('click', ()=>handler());
        this._formModal.addEventListener('click', (e)=>{
            if (e.target === this._formModal) this.closeForm();
        });
    }
    _addHandlerInvite(handler) {
        this._panel.querySelector('#inviteStaffBtn')?.addEventListener('click', ()=>handler());
    }
    _addHandlerSaveInvite(handler) {
        let submitting = false;
        this._formModal.addEventListener('click', async (e)=>{
            if (!e.target.closest('#inviteSaveBtn')) return;
            // Guard against rapid double-clicks: each click would otherwise fire another
            // invite before the first insert lands (the duplicate-email check reads stale
            // state.staff), creating multiple pending rows for the same person.
            if (submitting) return;
            const data = this._getInviteData();
            if (!data.firstName) {
                alert('Please enter a first name.');
                return;
            }
            if (!data.lastName) {
                alert('Please enter a last name.');
                return;
            }
            if (!data.email) {
                alert('Please enter an email.');
                return;
            }
            submitting = true;
            const btn = document.getElementById('inviteSaveBtn');
            const prevText = btn?.textContent;
            if (btn) {
                btn.disabled = true;
                btn.textContent = "Adding\u2026";
            }
            try {
                await handler(data);
            } finally{
                submitting = false;
                if (btn) {
                    btn.disabled = false;
                    btn.textContent = prevText ?? 'Add Member';
                }
            }
        });
    }
    _addHandlerRemove(handler) {
        this._list.addEventListener('click', (e)=>{
            const btn = e.target.closest('[data-action="remove"]');
            if (!btn) return;
            handler(btn.dataset.id);
        });
    }
    _addHandlerRemoveMFA(handler) {
        this._list.addEventListener('click', (e)=>{
            const btn = e.target.closest('[data-action="remove-mfa"]');
            if (!btn) return;
            handler(btn.dataset.id);
        });
    }
    // Busy state for the "Remove 2FA" menu item while the request is in flight
    // (an Edge Function round-trip, so worth showing). Stashes the original
    // markup on the button itself so it can be restored exactly once done.
    setRemoveMFALoading(staffId, loading) {
        const btn = this._list.querySelector(`[data-action="remove-mfa"][data-id="${staffId}"]`);
        if (!btn) return;
        if (loading) {
            btn.dataset.origHtml = btn.innerHTML;
            btn.disabled = true;
            btn.innerHTML = '<span class="btn-spinner"></span>Removing\u2026';
        } else if (btn.dataset.origHtml) {
            btn.disabled = false;
            btn.innerHTML = btn.dataset.origHtml;
            delete btn.dataset.origHtml;
        }
    }
    _addHandlerEditRole(handler) {
        this._list.addEventListener('click', (e)=>{
            const btn = e.target.closest('[data-action="edit"]');
            if (!btn) return;
            if (document.getElementById('staffEditRoleModal')) return;
            const staffId = btn.dataset.id;
            handler(staffId);
        });
    }
    // Fires for the role-editor entry points in the Roles tab: create / edit / delete.
    _addHandlerRoleAction(handler) {
        this._rolesEl.addEventListener('click', (e)=>{
            if (e.target.closest('#staffAddRoleBtn')) {
                handler('create', null);
                return;
            }
            const btn = e.target.closest('[data-role-action]');
            if (!btn) return;
            handler(btn.dataset.roleAction, btn.dataset.id);
        });
    }
    // Capability editor for a role. opts = { role, isNew, allPermissions, labels,
    // descriptions, groups, grantableCaps }. Capabilities are shown grouped, each
    // group with a "check all" header toggle. grantableCaps = what the current user
    // may hand out (can't grant what you don't hold). Returns { onSave(cb) } where cb
    // receives (name, capsArray).
    showRoleEditor({ role: role, isNew: isNew, allPermissions: allPermissions, labels: labels, descriptions: descriptions = {}, groups: groups, grantableCaps: grantableCaps, members: members = [] }) {
        // New roles start with time-clock access on by default (everyone can clock in).
        const granted = new Set(role?.caps ?? (isNew ? [
            'use_timeclock'
        ] : []));
        const grantable = new Set(grantableCaps ?? []);
        // Fall back to one big group if none provided.
        const groupList = (groups?.length ? groups : [
            {
                label: '',
                keys: allPermissions
            }
        ]).map((g)=>({
                label: g.label,
                keys: g.keys.filter((k)=>allPermissions.includes(k))
            })).filter((g)=>g.keys.length);
        const renderRow = (key)=>{
            const canGrant = grantable.has(key);
            const checked = granted.has(key) ? 'checked' : '';
            const disabled = canGrant ? '' : 'disabled';
            const hint = canGrant ? '' : `<span class="role-cap-hint">you don't have this</span>`;
            const desc = descriptions[key] ? `<span class="role-cap-desc">${(0, $cnCXJ.esc)(descriptions[key])}</span>` : '';
            return `
        <label class="role-cap-row ${canGrant ? '' : 'role-cap-row--locked'}">
          <input type="checkbox" data-cap="${key}" data-group="${(0, $cnCXJ.esc)(key)}" ${checked} ${disabled} />
          <span class="role-cap-text">
            <span class="role-cap-label">${(0, $cnCXJ.esc)(labels[key] ?? key)} ${hint}</span>
            ${desc}
          </span>
        </label>`;
        };
        const groupsHtml = groupList.map((g, i)=>{
            const anyGrantable = g.keys.some((k)=>grantable.has(k));
            const headerCb = anyGrantable ? `<input type="checkbox" class="role-cap-group-toggle" data-group-idx="${i}" />` : `<input type="checkbox" disabled />`;
            const rows = g.keys.map(renderRow).join('');
            return `
        <div class="role-cap-group" data-group-idx="${i}">
          ${g.label ? `<label class="role-cap-group-header">${headerCb}<span>${(0, $cnCXJ.esc)(g.label)}</span></label>` : ''}
          ${rows}
        </div>`;
        }).join('');
        const modal = document.createElement('div');
        modal.className = 'cashier-picker-overlay';
        modal.id = 'staffRoleEditorModal';
        modal.style.zIndex = '99999';
        modal.innerHTML = `
      <div class="cashier-picker-card role-editor-card" style="max-width:460px;width:calc(100vw - 40px)">
        <div class="cashier-picker-header">
          <div>
            <h3 class="cashier-picker-title">${isNew ? 'New role' : 'Edit role'}</h3>
            <p class="cashier-picker-subtitle">Choose what this role can access</p>
          </div>
          <button class="modal-close-btn" id="roleEditorClose" type="button">&times;</button>
        </div>
        <div class="edit-field" style="margin-top:8px">
          <label for="roleEditorName">Role name</label>
          <input type="text" id="roleEditorName" class="settings-input" maxlength="40"
            placeholder="e.g. Shift Lead" value="${(0, $cnCXJ.esc)(role?.name ?? '')}" ${role?.locked ? 'disabled' : ''} />
        </div>
        <div class="edit-field" style="margin-top:10px">
          <label for="roleEditorDesc">Short description <span class="role-optional">(optional)</span></label>
          <input type="text" id="roleEditorDesc" class="settings-input" maxlength="80"
            placeholder="e.g. Manages operations and reports" value="${(0, $cnCXJ.esc)(role?.description ?? '')}" />
        </div>
        <div class="edit-field" style="margin-top:10px">
          <label>Icon</label>
          <div class="role-icon-picker" id="roleIconPicker">
            ${$ad4542f6315399f1$var$ROLE_ICON_KEYS.map((key)=>{
            const { color: color, svg: svg } = $ad4542f6315399f1$export$eabead3694f936e9[key];
            const selected = (role?.icon ?? (isNew ? '' : $ad4542f6315399f1$export$f2ded4d444c5e9fa(role))) === key;
            return `
                <button type="button" class="role-icon-option${selected ? ' role-icon-option--selected' : ''}"
                  data-icon="${key}" aria-label="${key}"
                  style="background:color-mix(in srgb, ${color} 11%, transparent);color:${color}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">${svg}</svg>
                </button>`;
        }).join('')}
          </div>
        </div>
        ${!isNew ? `
        <div class="edit-field" style="margin-top:10px">
          <label>Members with this role${members.length ? ` (${members.length})` : ''}</label>
          ${members.length ? `
          <div class="role-members-list">
            ${members.map((m, i)=>{
            const name = `${m.firstName ?? ''} ${m.lastName ?? ''}`.trim() || (m.email ?? '?');
            const initials = name.split(' ').map((w)=>w[0]).slice(0, 2).join('').toUpperCase();
            const colors = [
                '#22c55e',
                '#3b82f6',
                '#f59e0b',
                '#ec4899',
                '#8b5cf6',
                '#06b6d4'
            ];
            return `
                <span class="role-member-chip">
                  <span class="role-member-avatar" style="background:${colors[i % colors.length]}">${(0, $cnCXJ.esc)(initials)}</span>
                  ${(0, $cnCXJ.esc)(name)}
                </span>`;
        }).join('')}
          </div>` : `<p class="role-members-none">Nobody has this role yet.</p>`}
        </div>` : ''}
        <div class="role-cap-list">${groupsHtml}</div>
        <div class="adj-form-actions" style="margin-top:16px">
          <button type="button" class="btn" id="roleEditorCancel">Cancel</button>
          <button type="button" class="btn primary" id="roleEditorSave">${isNew ? 'Create role' : 'Save changes'}</button>
        </div>
      </div>`;
        document.body.appendChild(modal);
        const close = ()=>modal.remove();
        document.getElementById('roleEditorClose')?.addEventListener('click', close);
        document.getElementById('roleEditorCancel')?.addEventListener('click', close);
        modal.addEventListener('click', (e)=>{
            if (e.target === modal) close();
        });
        // Icon picker: single-select toggle
        const picker = modal.querySelector('#roleIconPicker');
        picker?.addEventListener('click', (e)=>{
            const opt = e.target.closest('.role-icon-option');
            if (!opt) return;
            picker.querySelectorAll('.role-icon-option').forEach((o)=>o.classList.toggle('role-icon-option--selected', o === opt));
        });
        // ── Group "check all" sync ──────────────────────────────────────────────────
        const groupEls = [
            ...modal.querySelectorAll('.role-cap-group')
        ];
        const childInputs = (groupEl)=>[
                ...groupEl.querySelectorAll('input[data-cap]:not(:disabled)')
            ];
        const syncGroupHeader = (groupEl)=>{
            const toggle = groupEl.querySelector('.role-cap-group-toggle');
            if (!toggle) return;
            const kids = childInputs(groupEl);
            const checkedCount = kids.filter((c)=>c.checked).length;
            toggle.checked = kids.length > 0 && checkedCount === kids.length;
            toggle.indeterminate = checkedCount > 0 && checkedCount < kids.length;
        };
        groupEls.forEach((groupEl)=>{
            syncGroupHeader(groupEl);
            const toggle = groupEl.querySelector('.role-cap-group-toggle');
            toggle?.addEventListener('change', ()=>{
                childInputs(groupEl).forEach((c)=>{
                    c.checked = toggle.checked;
                });
                toggle.indeterminate = false;
            });
            groupEl.addEventListener('change', (e)=>{
                if (e.target.matches('input[data-cap]')) syncGroupHeader(groupEl);
            });
        });
        return {
            onSave: (cb)=>{
                const saveBtn = document.getElementById('roleEditorSave');
                saveBtn?.addEventListener('click', ()=>{
                    const name = document.getElementById('roleEditorName')?.value.trim() ?? '';
                    const caps = [
                        ...modal.querySelectorAll('input[data-cap]:checked')
                    ].map((el)=>el.dataset.cap);
                    const meta = {
                        description: document.getElementById('roleEditorDesc')?.value.trim() || null,
                        icon: modal.querySelector('.role-icon-option--selected')?.dataset.icon || null
                    };
                    (0, $05116e7677d717d1$export$277a10cf25fc7086)(saveBtn, ()=>cb(name, caps, close, meta), {
                        busyText: "Saving\u2026"
                    });
                });
            }
        };
    }
    showEditRoleModal(staff, roles) {
        const name = `${staff.firstName ?? ''} ${staff.lastName ?? ''}`.trim();
        const initials = name.split(' ').map((w)=>w[0]).slice(0, 2).join('').toUpperCase() || '?';
        let hash = 0;
        for (const ch of name)hash = hash * 31 + ch.charCodeAt(0) & 0xffffffff;
        const avatarColor = [
            '#22c55e',
            '#3b82f6',
            '#f59e0b',
            '#ec4899',
            '#8b5cf6',
            '#06b6d4'
        ][Math.abs(hash) % 6];
        const modal = document.createElement('div');
        modal.className = 'cashier-picker-overlay';
        modal.id = 'staffEditRoleModal';
        modal.style.zIndex = '99999';
        modal.innerHTML = `
      <div class="cashier-picker-card" style="max-width:360px;width:calc(100vw - 40px)">
        <div class="cashier-picker-header">
          <div class="edit-staff-who">
            <div class="staff-avatar" style="background:${avatarColor}">${(0, $cnCXJ.esc)(initials)}</div>
            <div>
              <h3 class="cashier-picker-title">Edit Staff</h3>
              <p class="cashier-picker-subtitle">${(0, $cnCXJ.esc)(name)}</p>
              ${staff.email ? `<p class="edit-staff-email">${(0, $cnCXJ.esc)(staff.email)}</p>` : ''}
            </div>
          </div>
          <button class="modal-close-btn" id="editRoleCloseBtn" type="button">&times;</button>
        </div>
        <div class="edit-field" style="margin-top:8px">
          <label for="editRoleSelect">Role</label>
          <select id="editRoleSelect" class="settings-select">
            ${roles.map((r)=>`<option value="${(0, $cnCXJ.esc)(r.id)}" ${r.id === staff.roleId ? 'selected' : ''}>${(0, $cnCXJ.esc)(r.name)}</option>`).join('')}
          </select>
          <div id="editTcReflect" style="margin-top:8px">${this._tcReflectHtml(roles.find((r)=>r.id === staff.roleId) ?? roles[0])}</div>
        </div>
        <div class="adj-form-actions" style="margin-top:16px">
          <button type="button" class="btn" id="editRoleCancelBtn">Cancel</button>
          <button type="button" class="btn primary" id="editRoleSaveBtn">Save</button>
        </div>
      </div>
    `;
        document.body.appendChild(modal);
        const close = ()=>modal.remove();
        document.getElementById('editRoleCloseBtn')?.addEventListener('click', close);
        document.getElementById('editRoleCancelBtn')?.addEventListener('click', close);
        modal.addEventListener('click', (e)=>{
            if (e.target === modal) close();
        });
        const editRoleSel = document.getElementById('editRoleSelect');
        const editReflectEl = document.getElementById('editTcReflect');
        editRoleSel?.addEventListener('change', ()=>{
            if (editReflectEl) editReflectEl.innerHTML = this._tcReflectHtml(roles.find((r)=>r.id === editRoleSel.value));
        });
        return {
            onSave: (cb)=>{
                document.getElementById('editRoleSaveBtn')?.addEventListener('click', ()=>{
                    const roleId = document.getElementById('editRoleSelect')?.value;
                    close();
                    cb(roleId);
                });
            }
        };
    }
    _addHandlerSetPin(handler) {
        this._list.addEventListener('click', (e)=>{
            const btn = e.target.closest('[data-action="pin"]');
            if (!btn) return;
            if (document.querySelector('.cashier-picker-overlay')) return;
            const staffId = btn.dataset.id;
            const modal = document.createElement('div');
            modal.className = 'cashier-picker-overlay';
            modal.style.zIndex = '99999';
            modal.innerHTML = `
        <div class="cashier-picker-card" style="max-width:320px">
          <div class="cashier-picker-header">
            <div>
              <h3 class="cashier-picker-title">Set PIN</h3>
              <p class="cashier-picker-subtitle">6-digit cashier PIN</p>
            </div>
            <button class="modal-close-btn" data-action="pin-close" type="button">&times;</button>
          </div>
          <form class="edit-field" style="margin-top:8px" onsubmit="return false">
            <input type="password" data-input="pin" placeholder="\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}" maxlength="6" inputmode="numeric" autocomplete="new-password" class="settings-input pin-input" />
          </form>
          <div class="adj-form-actions" style="margin-top:16px">
            <button type="button" class="btn" data-action="pin-cancel">Cancel</button>
            <button type="button" class="btn primary" data-action="pin-save">Save PIN</button>
          </div>
        </div>
      `;
            document.body.appendChild(modal);
            const pinInput = modal.querySelector('[data-input="pin"]');
            pinInput?.focus();
            const close = ()=>modal.remove();
            modal.querySelector('[data-action="pin-close"]')?.addEventListener('click', close);
            modal.querySelector('[data-action="pin-cancel"]')?.addEventListener('click', close);
            modal.addEventListener('click', (e)=>{
                if (e.target === modal) close();
            });
            modal.querySelector('[data-action="pin-save"]')?.addEventListener('click', ()=>{
                const pin = pinInput?.value.trim();
                if (!pin || !/^\d{6}$/.test(pin)) {
                    pinInput?.classList.add('input-error');
                    return;
                }
                close();
                handler(staffId, pin);
            });
        });
    }
}
const $ad4542f6315399f1$var$_view = new $ad4542f6315399f1$var$StaffView();
$ad4542f6315399f1$var$_view._addHandlerTabs();
$ad4542f6315399f1$var$_view._addHandlerDrawer();
var $ad4542f6315399f1$export$2e2bcd8739ae039 = $ad4542f6315399f1$var$_view;



var $cnCXJ = parcelRequire("cnCXJ");


var $coRoT = parcelRequire("coRoT");

var $abGsl = parcelRequire("abGsl");

var $lDSCx = parcelRequire("lDSCx");
// Fabricated staff cards for the free-plan locked preview - never real data,
// built with the same .payroll-group/.payroll-group-header classes the real
// (collapsed) staff cards use, so the blurred list looks exactly like the
// real one.
const $a1ae7cc9759c5490$var$FAKE_STAFF = [
    {
        initials: 'AM',
        name: 'Alex M.',
        color: '#22c55e',
        shifts: 5,
        hours: '32h 30m'
    },
    {
        initials: 'JR',
        name: 'Jamie R.',
        color: '#3b82f6',
        shifts: 4,
        hours: '24h 00m'
    },
    {
        initials: 'CL',
        name: 'Casey L.',
        color: '#f59e0b',
        shifts: 6,
        hours: '38h 15m'
    },
    {
        initials: 'MT',
        name: 'Morgan T.',
        color: '#ec4899',
        shifts: 3,
        hours: '18h 00m'
    }
];
const $a1ae7cc9759c5490$var$fakeStaffCardsMarkup = ()=>$a1ae7cc9759c5490$var$FAKE_STAFF.map((s)=>`
  <div class="payroll-group">
    <div class="payroll-group-header payroll-group-header--collapsed">
      <div class="payroll-group-avatar" style="background:${s.color}">${s.initials}</div>
      <div class="payroll-group-name">${s.name}</div>
      <div class="payroll-group-count">${s.shifts} shifts</div>
      <div class="payroll-group-meta">${s.hours}</div>
      <svg class="payroll-group-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
    </div>
  </div>`).join('');
// Top-level Timesheets panel: a sidebar of sections (Timesheets / Corrections /
// Time Clock / Deleted shifts) + a per-staff filter, rendered from one data
// snapshot cached on the view. The controller refetches on period change; section
// and staff-filter switches re-render locally from the cache.
const $a1ae7cc9759c5490$var$AVATAR_COLORS = [
    '#22c55e',
    '#3b82f6',
    '#f59e0b',
    '#ec4899',
    '#8b5cf6',
    '#06b6d4'
];
// "Today" is the cafe's calendar day (business timezone), whatever zone this device is in.
const $a1ae7cc9759c5490$var$_todayDateValue = ()=>(0, $lDSCx.businessToday)();
const $a1ae7cc9759c5490$var$_todayMonthValue = ()=>(0, $lDSCx.businessToday)().slice(0, 7);
const $a1ae7cc9759c5490$var$_todayQuarterValue = ()=>{
    const [y, m] = (0, $lDSCx.businessToday)().split('-').map(Number);
    return `${y}-Q${Math.floor((m - 1) / 3) + 1}`;
};
const $a1ae7cc9759c5490$var$_todayYear = ()=>Number((0, $lDSCx.businessToday)().slice(0, 4));
const $a1ae7cc9759c5490$var$_currentWeekValue = ()=>(0, $lDSCx.mondayOf)((0, $lDSCx.businessToday)());
const $a1ae7cc9759c5490$var$_prevNextValue = (type, value, delta)=>{
    if (type === 'week') {
        const d = new Date(value + 'T00:00:00');
        d.setDate(d.getDate() + delta * 7);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    }
    if (type === 'month') {
        const [y, m] = value.split('-').map(Number);
        const d = new Date(y, m - 1 + delta, 1);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    }
    if (type === 'quarter') {
        const [y, q] = value.split('-Q').map(Number);
        const total = y * 4 + (q - 1) + delta;
        return `${Math.floor(total / 4)}-Q${total % 4 + 1}`;
    }
    if (type === 'year') return String(parseInt(value) + delta);
    return value;
};
const $a1ae7cc9759c5490$var$_isFutureValue = (type, value)=>{
    if (type === 'week') return value >= $a1ae7cc9759c5490$var$_currentWeekValue();
    if (type === 'month') return value >= $a1ae7cc9759c5490$var$_todayMonthValue();
    if (type === 'quarter') return value >= $a1ae7cc9759c5490$var$_todayQuarterValue();
    if (type === 'year') return parseInt(value) >= $a1ae7cc9759c5490$var$_todayYear();
    return false;
};
const $a1ae7cc9759c5490$var$fmtTime = (iso)=>new Date(iso).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit'
    });
const $a1ae7cc9759c5490$var$fmtDate = (iso)=>new Date(iso).toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
    });
// Compact numeric US date (mm/dd/yyyy) for exports, where spreadsheets parse it.
const $a1ae7cc9759c5490$var$fmtMDY = (iso)=>new Date(iso).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
    });
const $a1ae7cc9759c5490$var$fmtHM = (ms)=>{
    const h = Math.floor(ms / 3600000);
    const m = Math.floor(ms % 3600000 / 60000);
    return h > 0 ? `${h}h ${m}m` : `${m}m`;
};
const $a1ae7cc9759c5490$var$workedMs = (shift)=>{
    if (!shift.clockedOutAt) return null;
    const total = new Date(shift.clockedOutAt) - new Date(shift.clockedInAt);
    const breakMs = (shift.breaks ?? []).reduce((s, b)=>{
        if (!b.endedAt) return s;
        return s + (new Date(b.endedAt) - new Date(b.startedAt));
    }, 0);
    return Math.max(0, total - breakMs);
};
const $a1ae7cc9759c5490$var$trashSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>`;
class $a1ae7cc9759c5490$var$TimesheetView {
    _panel = document.querySelector('#timesheetPanel');
    _sidebar = document.querySelector('#timesheetSidebar');
    _content = document.querySelector('#timesheetContent');
    _lastTimeclockToken = null;
    _genTokenHandler = null;
    _locked = false;
    _lockedData = null;
    _section = 'timesheets';
    _staffFilter = null;
    _data = null;
    _expandedStaff = new Set();
    _expandedMonths = new Set();
    _expandedWeeks = new Set();
    open() {
        this._panel.classList.remove('hidden', 'cashflow-exiting');
    }
    // Free-plan gate: real summary stat tiles (on-shift now / hours this week /
    // pending requests) stay live; the shift list, corrections inbox, device
    // registry, etc. below are locked. The real sidebar nav stays visible -
    // _renderSidebar reads this._locked and re-shows this same locked teaser
    // for any tab instead of switching for real.
    // data: { onShiftCount, weekShifts, pendingCount, canEdit, editRequests, leaveRequests }
    renderLockedTeaser(data) {
        this._lockedData = data; // kept so a re-click from _renderSidebar can re-render
        const { onShiftCount: onShiftCount, weekShifts: weekShifts, pendingCount: pendingCount, canEdit: canEdit = false, editRequests: editRequests = [], leaveRequests: leaveRequests = [] } = data;
        this._locked = true;
        this._data = {
            shifts: weekShifts ?? [],
            staff: [],
            canEdit: canEdit,
            periodMeta: {
                type: 'week',
                value: '',
                label: 'This week'
            },
            editRequests: editRequests,
            deletedShifts: [],
            devices: [],
            leaveRequests: leaveRequests,
            onShift: []
        };
        this._renderSidebar();
        const weekMs = (weekShifts ?? []).reduce((sum, s)=>sum + ($a1ae7cc9759c5490$var$workedMs(s) ?? 0), 0);
        const weekHours = (weekMs / 3600000).toFixed(1);
        // Reuses the real .ts-stat-strip/.ts-stat-tile component (see the
        // Timesheets-tab period-summary strip above) so this reads as production
        // UI, not a bespoke widget - just fed the three metrics that make sense
        // to surface for free (the strip itself normally shows different ones).
        const statTile = (accent, label, val, sub)=>`
      <div class="ts-stat-tile" style="--tile-accent:${accent}">
        <div class="ts-stat-tile-label">${label}</div>
        <div class="ts-stat-tile-val">${val}</div>
        <div class="ts-stat-tile-sub">${sub}</div>
      </div>`;
        this._content.innerHTML = `
      <div class="ts-stat-strip">
        ${statTile('#18AE79', 'Hours This Week', `${weekHours}h`, 'across your team')}
        ${statTile('#3b82f6', 'On Shift Now', onShiftCount, 'staff clocked in')}
        ${statTile('#f59e0b', 'Pending Requests', pendingCount, 'corrections & leave')}
      </div>
      ${(0, $ad2a264c69d845ec$export$eef1d84709e6997f)('timesheets', $a1ae7cc9759c5490$var$fakeStaffCardsMarkup())}`;
    }
    // Preselect a sidebar section before data arrives (deep links, e.g. the home
    // sidebar's Time Clock shortcut).
    setSection(id) {
        this._section = id;
    }
    // Scrolls to + briefly flashes one request's row (notification bell item
    // click). Assumes the panel is already open on the matching section and
    // data has been rendered - call after renderTimesheets()/_render() resolve.
    focusCorrection(id) {
        this._section = 'corrections';
        this._render();
        const row = this._content.querySelector(`.ser-req[data-id="${(0, $cnCXJ.esc)(id)}"]`);
        if (!row) return;
        row.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
        });
        row.classList.add('ser-req--flash');
        setTimeout(()=>row.classList.remove('ser-req--flash'), 1600);
    }
    focusLeaveRequest(id) {
        this._section = 'leave';
        this._render();
        // Pending requests render as .ts-lv-card, upcoming (approved) ones as
        // .ts-lv-row - a request id only ever matches one of the two.
        const row = this._content.querySelector(`.ts-lv-card[data-id="${(0, $cnCXJ.esc)(id)}"], .ts-lv-row[data-id="${(0, $cnCXJ.esc)(id)}"]`);
        if (!row) return;
        row.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
        });
        row.classList.add('ts-lv-card--flash');
        setTimeout(()=>row.classList.remove('ts-lv-card--flash'), 1600);
    }
    close() {
        this._closeDrawer();
        this._panel.classList.add('cashflow-exiting');
        setTimeout(()=>{
            this._panel.classList.add('hidden');
            this._panel.classList.remove('cashflow-exiting');
        }, 220);
    }
    // ── Mobile sidebar drawer ────────────────────────────────────────────────────
    // Below 800px the sidebar is an off-canvas drawer (shared .panel-drawer-btn /
    // .panel-nav-backdrop pattern from the Settings modal): opened from the
    // header hamburger, closed by the backdrop or picking a section/staff filter.
    // The open class lives on the <nav> itself, so sidebar re-renders (which only
    // replace innerHTML) don't slam it shut mid-look.
    _openDrawer() {
        this._sidebar?.classList.add('panel-sidebar--open');
        this._panel.querySelector('#timesheetNavBackdrop')?.classList.add('panel-nav-backdrop--visible');
        this._panel.querySelector('#timesheetNavBtn')?.setAttribute('aria-expanded', 'true');
    }
    _closeDrawer() {
        this._sidebar?.classList.remove('panel-sidebar--open');
        this._panel.querySelector('#timesheetNavBackdrop')?.classList.remove('panel-nav-backdrop--visible');
        this._panel.querySelector('#timesheetNavBtn')?.setAttribute('aria-expanded', 'false');
    }
    _addHandlerDrawer() {
        const btn = this._panel.querySelector('#timesheetNavBtn');
        btn?.addEventListener('click', ()=>{
            if (btn.getAttribute('aria-expanded') === 'true') this._closeDrawer();
            else this._openDrawer();
        });
        this._panel.querySelector('#timesheetNavBackdrop')?.addEventListener('click', ()=>this._closeDrawer());
    }
    _addHandlerOpen(handler) {
        document.addEventListener('click', (e)=>{
            if (!e.target.closest("[data-action='timesheets']")) return;
            handler();
        });
    }
    _addHandlerClose(handler) {
        this._panel.querySelector('.timesheet-back')?.addEventListener('click', ()=>handler());
    }
    _periodChangeHandler = null;
    _addHandlerTimesheetPeriod(handler) {
        this._periodChangeHandler = handler;
    }
    // ── Tips data (Timesheets > Tips) ─────────────────────────────────────────
    // Set by the controller alongside renderTimesheets (manage_pay only).
    // { tips: [{ date, amount }], roles: [{ id, name }], poolRoleIds: null | [id], tipsEnabled }
    _tips = {
        tips: [],
        roles: [],
        poolRoleIds: null,
        tipsEnabled: false
    };
    setTipsData(data) {
        this._tips = {
            ...this._tips,
            ...data
        };
    }
    _tipPoolRolesHandler = null;
    _addHandlerTipPoolRoles(handler) {
        this._tipPoolRolesHandler = handler;
    }
    _addHandlerGenerateTimeclockToken(handler) {
        this._genTokenHandler = handler;
    }
    _reviewHandler = null;
    _addHandlerReviewRequest(handler) {
        this._reviewHandler = handler;
    }
    _deleteShiftsHandler = null;
    _addHandlerDeleteShifts(handler) {
        this._deleteShiftsHandler = handler;
    }
    _restoreShiftHandler = null;
    _addHandlerRestoreShift(handler) {
        this._restoreShiftHandler = handler;
    }
    // Cache the code so a re-render keeps showing it.
    showTimeclockToken(token) {
        this._lastTimeclockToken = token;
        const el = document.getElementById('payrollTcToken');
        if (el) {
            el.textContent = token;
            el.classList.remove('hidden');
        }
        document.getElementById('payrollTcCopyBtn')?.classList.remove('hidden');
        const btn = document.getElementById('payrollGenTokenBtn');
        if (btn) btn.textContent = 'Regenerate Code';
    }
    _revokeDeviceHandler = null;
    _addHandlerRevokeDevice(handler) {
        this._revokeDeviceHandler = handler;
    }
    renderTimesheets(shifts, staff, canEdit = false, periodMeta = {
        type: 'week',
        value: '',
        label: ''
    }, editRequests = [], deletedShifts = [], devices = [], leaveRequests = [], onShift = []) {
        this._locked = false;
        this._data = {
            shifts: shifts,
            staff: staff,
            canEdit: canEdit,
            periodMeta: periodMeta,
            editRequests: editRequests,
            deletedShifts: deletedShifts,
            devices: devices,
            leaveRequests: leaveRequests,
            onShift: onShift
        };
        // Sections a viewer can't use fall back to Timesheets.
        if (!canEdit && (this._section === 'corrections' || this._section === 'deleted')) this._section = 'timesheets';
        // A fresh fetch (period nav) starts every staff/month/week card collapsed
        // again - a local re-render (staff filter, section switch) keeps whatever's open.
        this._expandedStaff = new Set();
        this._expandedMonths = new Set();
        this._expandedWeeks = new Set();
        this._render();
    }
    _render() {
        if (!this._data) return;
        this._renderSidebar();
        if (this._section === 'corrections') this._renderCorrectionsSection();
        else if (this._section === 'timeclock') this._renderTimeclockSection();
        else if (this._section === 'leave') this._renderLeaveSection();
        else if (this._section === 'deleted') this._renderDeletedSection();
        else if (this._section === 'tips' && this._data.canEdit) this._renderTipsSection();
        else this._renderTimesheetsSection();
    }
    // ── Sidebar ─────────────────────────────────────────────────────────────────
    _renderSidebar() {
        const { canEdit: canEdit, editRequests: editRequests, deletedShifts: deletedShifts, staff: staff, leaveRequests: leaveRequests } = this._data;
        const pendingLeave = leaveRequests.filter((r)=>r.status === 'pending').length;
        // Section nav items use the shared .pb-nav-item look (color tile + name +
        // one-line description). Icons are unique app-wide - check before reusing.
        const navSections = {
            timesheets: {
                c: '#18AE79',
                desc: 'Hours &amp; pay periods',
                icon: '<rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/><line x1="12" y1="9" x2="12" y2="21"/>'
            },
            corrections: {
                c: '#F59E0B',
                desc: 'Staff-requested fixes',
                icon: '<path d="M12 20h9"/><path d="M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z"/><path d="m15 5 3 3"/>'
            },
            leave: {
                c: '#3B82F6',
                desc: 'Vacation &amp; sick days',
                icon: '<path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/>'
            },
            timeclock: {
                c: '#8B5CF6',
                desc: 'Kiosk devices',
                icon: '<circle cx="12" cy="13" r="8"/><path d="M12 9v4l2 2"/><path d="M5 3 2 6"/><path d="m22 6-3-3"/><path d="M6.38 18.7 4 21"/><path d="M17.64 18.67 20 21"/>'
            },
            tips: {
                c: '#EC4899',
                desc: 'Tip pool by hours',
                icon: '<circle cx="8" cy="8" r="6"/><path d="M18.09 10.37A6 6 0 1 1 10.34 18"/><path d="M7 6h1v4"/><path d="m16.71 13.88.7.71-2.82 2.82"/>'
            },
            deleted: {
                c: '#EF4444',
                desc: 'Restore within 7 days',
                icon: '<rect x="2" y="3" width="20" height="5" rx="1"/><path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"/><path d="m9.5 17 5-5"/><path d="m9.5 12 5 5"/>'
            }
        };
        const tab = (id, label, count = 0)=>`
      <button class="pb-nav-item ts-tab${this._section === id ? ' ts-tab--active' : ''}" data-section="${id}" type="button" style="--nav-c:${navSections[id].c}">
        <span class="pb-nav-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${navSections[id].icon}</svg></span>
        <span class="pb-nav-text"><span class="pb-nav-name">${label}</span><span class="pb-nav-desc">${navSections[id].desc}</span></span>
        ${count ? `<span class="ts-tab-count">${count}</span>` : ''}
      </button>`;
        // Per-staff filter, shown while browsing timesheets. Lists active members;
        // members with shifts only in history still show up via their staff row.
        const activeStaff = (staff ?? []).filter((s)=>s.isActive !== false);
        const staffItems = this._section === 'timesheets' ? `
      <p class="ts-side-label">View staff</p>
      <button class="ts-staff-item${this._staffFilter === null ? ' ts-staff-item--active' : ''}" data-staff="" type="button">
        <span class="ts-staff-avatar ts-staff-avatar--all">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
        </span>
        All staff
      </button>
      ${activeStaff.map((s, i)=>{
            const name = `${s.firstName ?? ''} ${s.lastName ?? ''}`.trim() || (s.email ?? '?');
            const initials = name.split(' ').map((w)=>w[0]).slice(0, 2).join('').toUpperCase();
            return `
          <button class="ts-staff-item${this._staffFilter === s.id ? ' ts-staff-item--active' : ''}" data-staff="${(0, $cnCXJ.esc)(s.id)}" type="button">
            <span class="ts-staff-avatar" style="background:${$a1ae7cc9759c5490$var$AVATAR_COLORS[i % $a1ae7cc9759c5490$var$AVATAR_COLORS.length]}">${(0, $cnCXJ.esc)(initials)}</span>
            ${(0, $cnCXJ.esc)(name)}
          </button>`;
        }).join('')}` : '';
        this._sidebar.innerHTML = `
      <p class="ts-side-label">Sections</p>
      ${tab('timesheets', 'Timesheets')}
      ${canEdit ? tab('corrections', 'Corrections', editRequests.length) : ''}
      ${tab('leave', 'Leave', canEdit ? pendingLeave : 0)}
      ${canEdit ? tab('tips', 'Tips') : ''}
      ${tab('timeclock', 'Time Clock')}
      ${canEdit ? tab('deleted', 'Deleted shifts', deletedShifts.length) : ''}
      ${staffItems}`;
        this._sidebar.querySelectorAll('.ts-tab').forEach((btn)=>btn.addEventListener('click', ()=>{
                // Free plan: every section shows the same locked teaser - just move
                // the active-tab highlight, never actually switch to a real section.
                if (this._locked) {
                    this._section = btn.dataset.section;
                    this.renderLockedTeaser(this._lockedData);
                    return;
                }
                if (btn.dataset.section === this._section) return this._closeDrawer();
                this._section = btn.dataset.section;
                this._render();
                this._closeDrawer();
            }));
        this._sidebar.querySelectorAll('.ts-staff-item').forEach((btn)=>btn.addEventListener('click', ()=>{
                if (this._locked) return;
                this._staffFilter = btn.dataset.staff || null;
                this._render();
                this._closeDrawer();
            }));
    }
    // ── Shared period bar (Timesheets + Tips) ───────────────────────────────────
    // Week / Month / Quarter / Year / Custom tabs + prev/next nav. Both sections
    // load through the same _periodChangeHandler, so switching between them keeps
    // the chosen period.
    _periodBarHtml(periodMeta) {
        const { type: type, value: value, label: label } = periodMeta;
        const isCurrent = type !== 'custom' && $a1ae7cc9759c5490$var$_isFutureValue(type, value);
        const chipLabel = type === 'month' ? 'This month' : type === 'quarter' ? 'This quarter' : type === 'year' ? 'This year' : 'This week';
        const prevSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>`;
        const nextSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>`;
        const navHtml = type === 'custom' ? `<div class="payroll-period-custom">
          <input type="date" id="payrollCustomFrom" class="payroll-period-input" value="${value?.from ?? ''}" />
          <span class="payroll-period-sep">\u{2013}</span>
          <input type="date" id="payrollCustomTo" class="payroll-period-input" value="${value?.to ?? ''}" />
          <button id="payrollCustomApply" class="btn primary" type="button" style="padding:4px 14px;font-size:0.82rem">Apply</button>
        </div>` : `<div class="payroll-period-nav">
          <button class="payroll-nav-btn" id="payrollPrev" type="button" aria-label="Previous">${prevSvg}</button>
          <span class="payroll-period-label">${label}</span>
          ${!isCurrent ? `<button class="payroll-period-chip" id="payrollToday" type="button">${chipLabel}</button>` : ''}
          <button class="payroll-nav-btn${isCurrent ? ' payroll-nav-btn--disabled' : ''}" id="payrollNext" type="button" aria-label="Next" ${isCurrent ? 'disabled' : ''}>${nextSvg}</button>
        </div>`;
        return `
      <div class="payroll-period-bar">
        <div class="payroll-period-tabs">
          ${[
            'week',
            'month',
            'quarter',
            'year',
            'custom'
        ].map((t)=>`<button class="payroll-period-tab${type === t ? ' payroll-period-tab--active' : ''}" data-ptype="${t}" type="button">${t.charAt(0).toUpperCase() + t.slice(1)}</button>`).join('')}
        </div>
        ${navHtml}
      </div>`;
    }
    _wirePeriodBar(periodMeta) {
        const { type: type, value: value } = periodMeta;
        const isCurrent = type !== 'custom' && $a1ae7cc9759c5490$var$_isFutureValue(type, value);
        this._content.querySelectorAll('.payroll-period-tab').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const newType = btn.dataset.ptype;
                if (newType === type) return;
                let newValue;
                if (newType === 'week') newValue = $a1ae7cc9759c5490$var$_currentWeekValue();
                else if (newType === 'month') newValue = $a1ae7cc9759c5490$var$_todayMonthValue();
                else if (newType === 'quarter') newValue = $a1ae7cc9759c5490$var$_todayQuarterValue();
                else if (newType === 'year') newValue = String($a1ae7cc9759c5490$var$_todayYear());
                else newValue = {
                    from: $a1ae7cc9759c5490$var$_todayDateValue(),
                    to: $a1ae7cc9759c5490$var$_todayDateValue()
                };
                this._periodChangeHandler?.(newType, newValue);
            });
        });
        document.getElementById('payrollPrev')?.addEventListener('click', ()=>{
            this._periodChangeHandler?.(type, $a1ae7cc9759c5490$var$_prevNextValue(type, value, -1));
        });
        document.getElementById('payrollNext')?.addEventListener('click', ()=>{
            if (!isCurrent) this._periodChangeHandler?.(type, $a1ae7cc9759c5490$var$_prevNextValue(type, value, 1));
        });
        document.getElementById('payrollToday')?.addEventListener('click', ()=>{
            const curVal = type === 'month' ? $a1ae7cc9759c5490$var$_todayMonthValue() : type === 'quarter' ? $a1ae7cc9759c5490$var$_todayQuarterValue() : type === 'year' ? String($a1ae7cc9759c5490$var$_todayYear()) : $a1ae7cc9759c5490$var$_currentWeekValue();
            this._periodChangeHandler?.(type, curVal);
        });
        document.getElementById('payrollCustomApply')?.addEventListener('click', ()=>{
            const from = document.getElementById('payrollCustomFrom')?.value;
            const to = document.getElementById('payrollCustomTo')?.value;
            if (!from || !to) return;
            if (from > to) {
                alert('Start date must be before end date.');
                return;
            }
            this._periodChangeHandler?.('custom', {
                from: from,
                to: to
            });
        });
    }
    // ── Section: Timesheets ─────────────────────────────────────────────────────
    _renderTimesheetsSection() {
        const { staff: staff, canEdit: canEdit, periodMeta: periodMeta } = this._data;
        const shifts = this._staffFilter ? this._data.shifts.filter((sh)=>sh.staffId === this._staffFilter) : this._data.shifts;
        // Deleting is deliberately limited to a WEEK's worth of shifts at once: the
        // Week view exposes it directly, and Month/Year group shifts by week with a
        // per-week delete - never a whole month or year in one click.
        const showDelete = canEdit && periodMeta.type === 'week';
        const byStaff = new Map();
        for (const sh of shifts){
            if (!byStaff.has(sh.staffId)) byStaff.set(sh.staffId, []);
            byStaff.get(sh.staffId).push(sh);
        }
        const groups = [];
        let colorIdx = 0;
        for (const [staffId, shs] of byStaff){
            const s = staff.find((m)=>m.id === staffId);
            const name = s ? `${s.firstName} ${s.lastName}`.trim() : shs[0]?.staffName ?? '?';
            const initials = name.split(' ').map((w)=>w[0]).join('').slice(0, 2).toUpperCase();
            const color = $a1ae7cc9759c5490$var$AVATAR_COLORS[colorIdx++ % $a1ae7cc9759c5490$var$AVATAR_COLORS.length];
            const totalMs = shs.reduce((acc, sh)=>{
                const ms = $a1ae7cc9759c5490$var$workedMs(sh);
                return ms != null ? acc + ms : acc;
            }, 0);
            // Hourly rate / gross pay is intentionally NOT surfaced (hidden from the UI
            // for now; the staff.hourly_rate column stays in the schema untouched).
            groups.push({
                staffId: staffId,
                shs: shs,
                name: name,
                initials: initials,
                color: color,
                totalMs: totalMs
            });
        }
        // Period summary stat strip - answers "how's this period looking" before
        // scrolling into any staff card. Skipped when there's nothing to summarize.
        let statStripHtml = '';
        if (shifts.length > 0) {
            const totalMs = shifts.reduce((acc, sh)=>{
                const ms = $a1ae7cc9759c5490$var$workedMs(sh);
                return ms != null ? acc + ms : acc;
            }, 0);
            const completed = shifts.filter((sh)=>$a1ae7cc9759c5490$var$workedMs(sh) != null).length;
            const avgMs = completed ? Math.round(totalMs / completed) : 0;
            const uniqueDays = new Set(shifts.map((sh)=>new Date(sh.clockedInAt).toDateString())).size;
            const statTile = (accent, label, val, sub)=>`
        <div class="ts-stat-tile" style="--tile-accent:${accent}">
          <div class="ts-stat-tile-label">${label}</div>
          <div class="ts-stat-tile-val">${val}</div>
          <div class="ts-stat-tile-sub">${sub}</div>
        </div>`;
            statStripHtml = `
        <div class="ts-stat-strip">
          ${statTile('#18AE79', 'Total Hours', $a1ae7cc9759c5490$var$fmtHM(totalMs), 'this period')}
          ${statTile('#3b82f6', 'Shifts Worked', shifts.length, `across ${byStaff.size} staff`)}
          ${statTile('#8b5cf6', 'Days Worked', uniqueDays, 'this period')}
          ${statTile('#f59e0b', 'Avg. Shift Length', completed ? $a1ae7cc9759c5490$var$fmtHM(avgMs) : "\u2013", 'per completed shift')}
        </div>`;
        }
        // Staff cards are collapsed to one summary row by default - raw shift rows
        // only render for a card (and, within it, a week) the viewer actually opened.
        // This is what keeps the panel legible once a year of shifts has piled up.
        const renderEntry = (sh)=>{
            const ms = $a1ae7cc9759c5490$var$workedMs(sh);
            const isOpen = !sh.clockedOutAt;
            const openBadge = isOpen ? `<span class="payroll-badge-active">Active</span>` : '';
            const allBreaks = sh.breaks ?? [];
            const breakSubRows = allBreaks.map((b)=>{
                const bMs = b.endedAt ? new Date(b.endedAt) - new Date(b.startedAt) : null;
                return `
          <div class="payroll-break-row">
            <div class="payroll-break-label">Break</div>
            <div>${$a1ae7cc9759c5490$var$fmtTime(b.startedAt)} \u{2192} ${b.endedAt ? $a1ae7cc9759c5490$var$fmtTime(b.endedAt) : "\u2013"}</div>
            <div class="payroll-break-dur">${bMs !== null ? $a1ae7cc9759c5490$var$fmtHM(bMs) : "\u2013"}</div>
            <div></div>
          </div>`;
            }).join('');
            // Provenance: normal clock-tracked shifts get no note; anything touched
            // by a human is flagged (approved request > admin edit > manual add).
            let provNote = '';
            if (sh.approvedBy) provNote = `<div class="payroll-prov-note payroll-prov-note--approved">Corrected via request \xb7 approved by ${(0, $cnCXJ.esc)(sh.approvedBy)}</div>`;
            else if (sh.source === 'request') provNote = `<div class="payroll-prov-note payroll-prov-note--approved">Corrected via request</div>`;
            else if (sh.editedBy) provNote = `<div class="payroll-prov-note payroll-prov-note--edited">${sh.source === 'manual' ? 'Added manually' : 'Edited'} by ${(0, $cnCXJ.esc)(sh.editedBy)}</div>`;
            else if (sh.source === 'manual') provNote = `<div class="payroll-prov-note payroll-prov-note--edited">Added manually</div>`;
            return `
        <div class="payroll-shift-entry">
          <div class="payroll-shift-row">
            <div class="payroll-shift-date">${$a1ae7cc9759c5490$var$fmtDate(sh.clockedInAt)}</div>
            <div class="payroll-shift-times">
              ${$a1ae7cc9759c5490$var$fmtTime(sh.clockedInAt)} \u{2192} ${sh.clockedOutAt ? $a1ae7cc9759c5490$var$fmtTime(sh.clockedOutAt) : "\u2013"}
              ${openBadge}
            </div>
            <div class="payroll-shift-hrs">${ms !== null ? $a1ae7cc9759c5490$var$fmtHM(ms) : "\u2013"}</div>
            <div class="payroll-shift-actions">
              ${canEdit ? `<button class="payroll-edit-btn" data-id="${sh.id}" type="button">Edit</button>` : ''}
              ${showDelete ? `<button class="payroll-del-btn" data-id="${sh.id}" data-desc="${(0, $cnCXJ.esc)(`${$a1ae7cc9759c5490$var$fmtDate(sh.clockedInAt)}'s shift`)}" type="button" aria-label="Delete shift">${$a1ae7cc9759c5490$var$trashSvg}</button>` : ''}
            </div>
          </div>
          ${provNote}
          ${breakSubRows}
        </div>`;
        };
        // Week view: flat rows, no further collapse level (there's only one week).
        // Month view: group by week, each week collapsed by default behind its own
        // subtotal row. Quarter/Year: an extra Month level sits between staff and
        // week (Staff -> Month -> Week -> shifts) - a whole quarter/year of
        // uncollapsed weeks is still a lot to page through. The delete unit stays a
        // WEEK regardless of how many collapse levels sit above it, never a whole
        // month/quarter/year in one click.
        const groupsByMonth = periodMeta.type === 'quarter' || periodMeta.type === 'year';
        const groupsByWeek = groupsByMonth || periodMeta.type === 'month';
        const weekStart = (iso)=>{
            const d = new Date(iso);
            d.setDate(d.getDate() - (d.getDay() + 6) % 7); // Monday
            d.setHours(0, 0, 0, 0);
            return d;
        };
        let groupsHtml = '';
        if (groups.length === 0) {
            const who = this._staffFilter ? 'this staff member' : 'this period';
            groupsHtml = `<p class="staff-empty" style="padding:24px 0">No shifts recorded for ${who}.</p>`;
        } else groupsHtml = groups.map((g)=>{
            const staffExpanded = this._expandedStaff.has(g.staffId);
            const weekDelBtn = showDelete && g.shs.length ? `
          <button class="payroll-week-del" type="button"
            data-ids="${(0, $cnCXJ.esc)(g.shs.map((s)=>s.id).join(','))}"
            data-desc="${(0, $cnCXJ.esc)(`${g.name}'s ${g.shs.length} shift${g.shs.length === 1 ? '' : 's'} this week`)}">
            ${$a1ae7cc9759c5490$var$trashSvg} Delete week
          </button>` : '';
            // Groups a slice of this staff member's shifts into collapsible week
            // rows - shared by the Month path (whole g.shs) and the Quarter/Year
            // path (one calendar month's worth of shifts at a time).
            const renderWeeks = (shs)=>{
                const byWeek = new Map();
                for (const sh of shs){
                    const key = weekStart(sh.clockedInAt).getTime();
                    if (!byWeek.has(key)) byWeek.set(key, []);
                    byWeek.get(key).push(sh);
                }
                return [
                    ...byWeek.entries()
                ].map(([key, weekShs])=>{
                    const start = new Date(key);
                    const end = new Date(key);
                    end.setDate(end.getDate() + 6);
                    const wLabel = `${start.toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric'
                    })} \u{2013} ${end.toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric'
                    })}`;
                    const weekKey = `${g.staffId}::${key}`;
                    const weekOpen = this._expandedWeeks.has(weekKey);
                    const weekMs = weekShs.reduce((acc, sh)=>{
                        const ms = $a1ae7cc9759c5490$var$workedMs(sh);
                        return ms != null ? acc + ms : acc;
                    }, 0);
                    const delBtn = canEdit ? `
              <button class="payroll-week-del" type="button"
                data-ids="${(0, $cnCXJ.esc)(weekShs.map((s)=>s.id).join(','))}"
                data-desc="${(0, $cnCXJ.esc)(`${g.name}'s ${weekShs.length} shift${weekShs.length === 1 ? '' : 's'} (week of ${wLabel})`)}">
                ${$a1ae7cc9759c5490$var$trashSvg}
              </button>` : '';
                    return `
              <div class="payroll-week-sep" data-week-toggle data-week-key="${(0, $cnCXJ.esc)(weekKey)}">
                <span>Week of ${wLabel}</span>
                <span class="payroll-week-sep-meta">
                  <span class="payroll-week-sep-count">${weekShs.length} shift${weekShs.length === 1 ? '' : 's'}</span>
                  <span class="payroll-week-sep-hrs">${$a1ae7cc9759c5490$var$fmtHM(weekMs)}</span>
                  ${delBtn}
                  <svg class="payroll-week-sep-chevron${weekOpen ? ' payroll-week-sep-chevron--open' : ''}" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                </span>
              </div>
              ${weekOpen ? weekShs.map(renderEntry).join('') : ''}`;
                }).join('');
            };
            let bodyHtml = '';
            if (staffExpanded) {
                if (groupsByMonth) {
                    const byMonth = new Map();
                    for (const sh of g.shs){
                        const d = new Date(sh.clockedInAt);
                        const mKey = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
                        if (!byMonth.has(mKey)) byMonth.set(mKey, []);
                        byMonth.get(mKey).push(sh);
                    }
                    bodyHtml = [
                        ...byMonth.entries()
                    ].map(([mKey, monthShs])=>{
                        const [my, mm] = mKey.split('-').map(Number);
                        const mLabel = new Date(my, mm - 1, 1).toLocaleDateString('en-US', {
                            month: 'long',
                            year: 'numeric'
                        });
                        const monthKey = `${g.staffId}::${mKey}`;
                        const monthOpen = this._expandedMonths.has(monthKey);
                        const monthMs = monthShs.reduce((acc, sh)=>{
                            const ms = $a1ae7cc9759c5490$var$workedMs(sh);
                            return ms != null ? acc + ms : acc;
                        }, 0);
                        return `
                <div class="payroll-week-sep payroll-month-sep" data-month-toggle data-month-key="${(0, $cnCXJ.esc)(monthKey)}">
                  <span>${mLabel}</span>
                  <span class="payroll-week-sep-meta">
                    <span class="payroll-week-sep-count">${monthShs.length} shift${monthShs.length === 1 ? '' : 's'}</span>
                    <span class="payroll-week-sep-hrs">${$a1ae7cc9759c5490$var$fmtHM(monthMs)}</span>
                    <svg class="payroll-week-sep-chevron${monthOpen ? ' payroll-week-sep-chevron--open' : ''}" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                  </span>
                </div>
                ${monthOpen ? renderWeeks(monthShs) : ''}`;
                    }).join('');
                } else if (groupsByWeek) bodyHtml = renderWeeks(g.shs);
                else bodyHtml = g.shs.map(renderEntry).join('');
            }
            return `
          <div class="payroll-group">
            <div class="payroll-group-header${staffExpanded ? '' : ' payroll-group-header--collapsed'}" data-staff-toggle data-staff-id="${(0, $cnCXJ.esc)(g.staffId)}">
              <div class="payroll-group-avatar" style="background:${g.color}">${(0, $cnCXJ.esc)(g.initials)}</div>
              <div class="payroll-group-name">${(0, $cnCXJ.esc)(g.name)}</div>
              <div class="payroll-group-count">${g.shs.length} shift${g.shs.length === 1 ? '' : 's'}</div>
              <div class="payroll-group-meta">${$a1ae7cc9759c5490$var$fmtHM(g.totalMs)}</div>
              ${weekDelBtn}
              <svg class="payroll-group-chevron${staffExpanded ? ' payroll-group-chevron--open' : ''}" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
            ${staffExpanded ? `<div class="payroll-group-shifts">${bodyHtml}</div>` : ''}
          </div>`;
        }).join('');
        const { type: type, value: value, label: label } = periodMeta;
        const exportCsv = ()=>{
            const rows = [];
            for (const g of groups)for (const sh of g.shs){
                const ms = $a1ae7cc9759c5490$var$workedMs(sh);
                const bMs = (sh.breaks ?? []).reduce((s, b)=>{
                    if (!b.endedAt) return s;
                    return s + (new Date(b.endedAt) - new Date(b.startedAt));
                }, 0);
                rows.push([
                    g.name,
                    $a1ae7cc9759c5490$var$fmtMDY(sh.clockedInAt),
                    $a1ae7cc9759c5490$var$fmtTime(sh.clockedInAt),
                    sh.clockedOutAt ? $a1ae7cc9759c5490$var$fmtTime(sh.clockedOutAt) : '',
                    bMs > 0 ? $a1ae7cc9759c5490$var$fmtHM(bMs) : '',
                    ms !== null ? $a1ae7cc9759c5490$var$fmtHM(ms) : ''
                ]);
            }
            rows.unshift([
                'Staff',
                'Date',
                'Clock In',
                'Clock Out',
                'Break',
                'Hours Worked'
            ]);
            rows.unshift([
                `Pointbunny Timesheets \u{2013} ${label}`
            ]);
            // A cell starting with = + - @ (or tab/CR) is a live formula to Excel/Sheets even
            // inside quotes - prefix with ' so a crafted staff name can't execute on reopen.
            const csvCell = (v)=>{
                let s = String(v);
                if (/^[=+\-@\t\r]/.test(s) && !Number.isFinite(Number(s))) s = `'${s}`;
                return `"${s.replace(/"/g, '""')}"`;
            };
            const csv = rows.map((r)=>r.map(csvCell).join(',')).join('\n');
            const slug = label.replace(/\s+[–-]\s+|[^a-z0-9]+/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
            const blob = new Blob([
                "\uFEFF" + csv
            ], {
                type: 'text/csv;charset=utf-8'
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `timesheets-${slug}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        };
        const exportPdf = ()=>{
            const sumRows = groups.map((g)=>`
        <tr>
          <td>${(0, $cnCXJ.esc)(g.name)}</td>
          <td class="hrs">${$a1ae7cc9759c5490$var$fmtHM(g.totalMs)}</td>
        </tr>`).join('');
            const details = groups.map((g)=>{
                const shiftRows = g.shs.map((sh)=>{
                    const ms = $a1ae7cc9759c5490$var$workedMs(sh);
                    const bMs = (sh.breaks ?? []).reduce((s, b)=>{
                        if (!b.endedAt) return s;
                        return s + (new Date(b.endedAt) - new Date(b.startedAt));
                    }, 0);
                    return `<tr>
            <td>${$a1ae7cc9759c5490$var$fmtDate(sh.clockedInAt)}</td>
            <td>${$a1ae7cc9759c5490$var$fmtTime(sh.clockedInAt)}</td>
            <td>${sh.clockedOutAt ? $a1ae7cc9759c5490$var$fmtTime(sh.clockedOutAt) : "\u2013"}</td>
            <td>${bMs > 0 ? $a1ae7cc9759c5490$var$fmtHM(bMs) : "\u2013"}</td>
            <td class="hrs">${ms !== null ? $a1ae7cc9759c5490$var$fmtHM(ms) : "\u2013"}</td>
          </tr>`;
                }).join('');
                return `
          <h2>${(0, $cnCXJ.esc)(g.name)}</h2>
          <table>
            <thead><tr><th>Date</th><th>Clock In</th><th>Clock Out</th><th>Break</th><th>Hours</th></tr></thead>
            <tbody>${shiftRows}</tbody>
          </table>`;
            }).join('');
            const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/>
        <title>Timesheets \u{2013} ${label}</title>
        <style>
          *{box-sizing:border-box}body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;padding:32px;color:#111;font-size:14px}
          h1{font-size:1.3rem;margin:0 0 2px}
          .period{color:#555;font-size:.85rem;margin-bottom:20px}
          h2{font-size:.95rem;margin:20px 0 6px;border-bottom:2px solid #e5e7eb;padding-bottom:4px}
          table{width:100%;border-collapse:collapse;margin-bottom:8px}
          th{text-align:left;font-size:.78rem;text-transform:uppercase;letter-spacing:.03em;color:#666;border-bottom:1.5px solid #e5e7eb;padding:5px 8px}
          td{padding:7px 8px;font-size:.85rem;border-bottom:1px solid #f0f0f0}
          .hrs{color:#16a34a;font-weight:700}
          @media print{body{padding:12px}}
        </style></head><body>
        <h1>Timesheets</h1>
        <p class="period">${label}</p>
        ${groups.length > 0 ? `
          <h2>Summary</h2>
          <table><thead><tr><th>Staff</th><th>Total Hours</th></tr></thead>
          <tbody>${sumRows}</tbody></table>
          ${details}` : '<p>No shifts recorded for this period.</p>'}
      </body></html>`;
            const win = window.open('', '_blank', 'width=820,height=900');
            if (!win) {
                alert('Allow pop-ups to export PDF.');
                return;
            }
            win.document.write(html);
            win.document.close();
            win.focus();
            setTimeout(()=>win.print(), 400);
        };
        const dlIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>`;
        const chevDown = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>`;
        const filteredName = this._staffFilter ? staff.find((s)=>s.id === this._staffFilter) ? `${staff.find((s)=>s.id === this._staffFilter).firstName ?? ''} ${staff.find((s)=>s.id === this._staffFilter).lastName ?? ''}`.trim() : 'Staff' : null;
        this._content.innerHTML = `
      <div class="payroll-header">
        <h3 class="payroll-title">${filteredName ? `${(0, $cnCXJ.esc)(filteredName)}'s Timesheet` : 'Timesheets'}</h3>
        <div class="payroll-header-actions">
          <div class="payroll-export-menu" id="payrollExportMenu">
            <button class="payroll-export-btn" id="payrollExportToggle" type="button">
              ${dlIcon} Export ${chevDown}
            </button>
            <div class="payroll-export-dropdown hidden" id="payrollExportDropdown">
              <button class="payroll-export-option" id="payrollExportPdf" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                PDF
              </button>
              <button class="payroll-export-option" id="payrollExportCsv" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M3 15h18M9 3v18"/></svg>
                CSV / Excel
              </button>
            </div>
          </div>
          ${canEdit ? `<button class="btn primary" id="payrollAddShiftBtn" type="button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
            Add Shift
          </button>` : ''}
        </div>
      </div>
      ${this._periodBarHtml(periodMeta)}
      ${statStripHtml}
      ${groupsHtml}
    `;
        this._wirePeriodBar(periodMeta);
        this._content.querySelectorAll('.payroll-del-btn').forEach((btn)=>btn.addEventListener('click', ()=>this._deleteShiftsHandler?.([
                    btn.dataset.id
                ], btn.dataset.desc)));
        // stopPropagation: this button now sits inside a staff/week header row that
        // toggles expand/collapse on click - deleting must not also toggle it.
        this._content.querySelectorAll('.payroll-week-del').forEach((btn)=>btn.addEventListener('click', (e)=>{
                e.stopPropagation();
                this._deleteShiftsHandler?.(btn.dataset.ids.split(','), btn.dataset.desc);
            }));
        this._content.querySelectorAll('[data-staff-toggle]').forEach((el)=>el.addEventListener('click', (e)=>{
                if (e.target.closest('.payroll-week-del')) return;
                const id = el.dataset.staffId;
                if (this._expandedStaff.has(id)) this._expandedStaff.delete(id);
                else this._expandedStaff.add(id);
                this._renderTimesheetsSection();
            }));
        this._content.querySelectorAll('[data-month-toggle]').forEach((el)=>el.addEventListener('click', ()=>{
                const key = el.dataset.monthKey;
                if (this._expandedMonths.has(key)) this._expandedMonths.delete(key);
                else this._expandedMonths.add(key);
                this._renderTimesheetsSection();
            }));
        this._content.querySelectorAll('[data-week-toggle]').forEach((el)=>el.addEventListener('click', (e)=>{
                if (e.target.closest('.payroll-week-del')) return;
                const key = el.dataset.weekKey;
                if (this._expandedWeeks.has(key)) this._expandedWeeks.delete(key);
                else this._expandedWeeks.add(key);
                this._renderTimesheetsSection();
            }));
        const exportToggle = document.getElementById('payrollExportToggle');
        const exportDropdown = document.getElementById('payrollExportDropdown');
        const closeExportMenu = ()=>{
            exportDropdown?.classList.add('hidden');
            exportToggle?.classList.remove('payroll-export-btn--open');
        };
        exportToggle?.addEventListener('click', (e)=>{
            e.stopPropagation();
            const opening = exportDropdown.classList.contains('hidden');
            exportDropdown.classList.toggle('hidden');
            exportToggle.classList.toggle('payroll-export-btn--open', opening);
            if (opening) setTimeout(()=>document.addEventListener('click', closeExportMenu, {
                    once: true
                }), 0);
        });
        document.getElementById('payrollExportPdf')?.addEventListener('click', (e)=>{
            e.stopPropagation();
            closeExportMenu();
            exportPdf();
        });
        document.getElementById('payrollExportCsv')?.addEventListener('click', (e)=>{
            e.stopPropagation();
            closeExportMenu();
            exportCsv();
        });
        if (canEdit) {
            document.getElementById('payrollAddShiftBtn')?.addEventListener('click', ()=>this._showShiftModal(null, staff));
            this._content.querySelectorAll('.payroll-edit-btn').forEach((btn)=>{
                btn.addEventListener('click', ()=>{
                    const sh = shifts.find((s)=>s.id === btn.dataset.id);
                    if (sh) this._showShiftModal(sh, staff);
                });
            });
        }
    }
    // ── Section: Corrections (review inbox) ─────────────────────────────────────
    _renderCorrectionsSection() {
        const { editRequests: editRequests } = this._data;
        const fmtTimeMaybe = (iso)=>iso ? $a1ae7cc9759c5490$var$fmtTime(iso) : "\u2014";
        const breakSummary = (breaks)=>{
            if (!Array.isArray(breaks) || !breaks.length) return '';
            return `<div class="ser-req-breaks">Breaks: ${breaks.map((b)=>`${fmtTimeMaybe(b.start)}\u{2013}${fmtTimeMaybe(b.end)}`).join(', ')}</div>`;
        };
        const reqRow = (r)=>{
            const isMissed = !r.shiftId;
            const dateIso = r.proposedIn ?? r.currentIn;
            const kind = isMissed ? 'Missed shift' : 'Correction';
            const change = isMissed ? `<span class="ser-req-new">${fmtTimeMaybe(r.proposedIn)} \u{2013} ${fmtTimeMaybe(r.proposedOut)}</span>` : `<span class="ser-req-old">${fmtTimeMaybe(r.currentIn)} \u{2013} ${fmtTimeMaybe(r.currentOut)}</span>
           <span class="ser-req-arrow">\u{2192}</span>
           <span class="ser-req-new">${fmtTimeMaybe(r.proposedIn)} \u{2013} ${fmtTimeMaybe(r.proposedOut)}</span>`;
            return `
        <li class="ser-req" data-id="${(0, $cnCXJ.esc)(r.id)}">
          <div class="ser-req-main">
            <div class="ser-req-head">
              <span class="ser-req-name">${(0, $cnCXJ.esc)(r.staffName || 'Staff')}</span>
              <span class="ser-req-kind ser-req-kind--${isMissed ? 'missed' : 'edit'}">${kind}</span>
              <span class="ser-req-date">${dateIso ? $a1ae7cc9759c5490$var$fmtDate(dateIso) : ''}</span>
            </div>
            <div class="ser-req-change">${change}</div>
            ${breakSummary(r.proposedBreaks)}
            ${r.reason ? `<div class="ser-req-reason">\u{201C}${(0, $cnCXJ.esc)(r.reason)}\u{201D}</div>` : ''}
          </div>
          <div class="ser-req-actions">
            <button class="btn ser-reject" data-id="${(0, $cnCXJ.esc)(r.id)}" type="button">Reject</button>
            <button class="btn primary ser-approve" data-id="${(0, $cnCXJ.esc)(r.id)}" type="button">Approve</button>
          </div>
        </li>`;
        };
        this._content.innerHTML = `
      <div class="payroll-header">
        <h3 class="payroll-title">Corrections</h3>
      </div>
      <p class="ts-section-sub">Shift corrections and missed-shift reports filed by staff from the Time Clock. Approving applies the proposed times immediately.</p>
      ${editRequests.length ? `
        <div class="ser-inbox ser-inbox--page">
          <ul class="ser-req-list">${editRequests.map(reqRow).join('')}</ul>
        </div>` : `
        <div class="ts-empty">
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
          <p>All caught up - no corrections waiting for review.</p>
        </div>`}
    `;
        this._content.querySelectorAll('.ser-approve').forEach((btn)=>btn.addEventListener('click', ()=>this._reviewHandler?.(btn.dataset.id, 'approved')));
        this._content.querySelectorAll('.ser-reject').forEach((btn)=>btn.addEventListener('click', ()=>this._reviewHandler?.(btn.dataset.id, 'rejected')));
    }
    // ── Section: Time Clock (device setup + registry) ───────────────────────────
    _renderTimeclockSection() {
        const { canEdit: canEdit, devices: devices, onShift: onShift = [] } = this._data;
        const fmtSince = (iso)=>new Date(iso).toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit'
            });
        const onlineRows = onShift.length ? onShift.map((s)=>`
      <li class="tc-online-row">
        <span class="onshift-dot${s.onBreak ? ' onshift-dot--break' : ''}"></span>
        <span class="tc-online-name">${(0, $cnCXJ.esc)(s.name || 'Staff')}</span>
        <span class="tc-online-meta">${s.onBreak ? 'On break' : `since ${fmtSince(s.clockedInAt)}`}</span>
      </li>`).join('') : '';
        this._content.innerHTML = `
      <div class="payroll-header">
        <h3 class="payroll-title">Time Clock</h3>
      </div>
      <button class="tc-open-cta" id="payrollOpenTimeclock" type="button">
        <span class="tc-open-cta-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        </span>
        <span class="tc-open-cta-text">
          <span class="tc-open-cta-title">Open Time Clock</span>
          <span class="tc-open-cta-sub">The page staff clock in and out on. Opens in a new tab, works on any tablet or shared device.</span>
        </span>
        <span class="tc-open-cta-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
        </span>
      </button>
      <div class="tc-online-card">
        <div class="tc-online-header">
          <span class="tc-online-title">Currently timed in</span>
          <span class="tc-online-count${onShift.length ? '' : ' tc-online-count--zero'}">${onShift.length}</span>
        </div>
        ${onShift.length ? `<ul class="tc-online-list">${onlineRows}</ul>` : `<p class="tc-online-empty">No one is timed in right now.</p>`}
      </div>
      ${canEdit ? `
      <div class="payroll-tc-card payroll-tc-card--device">
        <div class="payroll-tc-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
        </div>
        <div class="payroll-tc-body">
          <div class="payroll-tc-title">Set up a device</div>
          <div class="payroll-tc-desc">Register a tablet or shared device once with a code, then staff clock in and out on it. Generating a new code invalidates the old one. We recommend just one device per location - it's meant to be shared, not personal.</div>
          <div class="payroll-tc-device-row">
            <span class="tc-token-badge${this._lastTimeclockToken ? '' : ' hidden'}" id="payrollTcToken">${(0, $cnCXJ.esc)(this._lastTimeclockToken ?? '')}</span>
            <button class="btn payroll-copy-btn${this._lastTimeclockToken ? '' : ' hidden'}" id="payrollTcCopyBtn" type="button">Copy</button>
            <button class="btn" id="payrollGenTokenBtn" type="button">${this._lastTimeclockToken ? 'Regenerate Code' : 'Generate Code'}</button>
          </div>
          <!-- .payroll-tc-multi-warn removed 2026-09-19: Pro is now unlimited,
               so the "can hit your plan's sign-in limit" claim it made is no
               longer true. Bring it back once the Additional Terminal add-on
               ships - CSS still defined in pointbunny.css. -->
          ${devices.length ? `
          <ul class="payroll-devices">
            ${devices.map((d)=>`
            <li class="payroll-device-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>
              <span class="payroll-device-name">${(0, $cnCXJ.esc)(d.label)}</span>
              <span class="payroll-device-meta">Activated ${new Date(d.activatedAt).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric'
            })}</span>
              <button class="payroll-device-del" data-id="${(0, $cnCXJ.esc)(d.id)}" data-label="${(0, $cnCXJ.esc)(d.label)}" type="button" aria-label="Remove device">&times;</button>
            </li>`).join('')}
          </ul>` : ''}
        </div>
      </div>` : ''}
      <details class="payroll-info-card">
        <summary class="payroll-info-summary">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
          How does the Time Clock work?
          <svg class="payroll-info-chevron" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
        </summary>
        <ol class="payroll-info-steps">
          <li><strong>Set up a device:</strong> Click <em>Generate Code</em> above for a 6-character activation code.</li>
          <li><strong>Activate it:</strong> Open <em>Time Clock</em> on the tablet you'll use, tap Activate, and enter that code. The device only needs this once.</li>
          <li><strong>Staff sign in:</strong> Each staff member logs in with their own account (not the POS owner account), then clocks in, takes breaks, and clocks out.</li>
          <li><strong>Shifts appear here:</strong> Every clock-in/out is recorded as a shift in the Timesheets section. Admins can also manually add or edit shifts with <em>Add Shift</em>.</li>
        </ol>
      </details>
    `;
        document.getElementById('payrollOpenTimeclock')?.addEventListener('click', ()=>{
            // Clean /timeclock URL via the Netlify rewrite; the dev server has no
            // rewrites, so localhost opens the .html directly.
            window.open(location.hostname === 'localhost' ? 'timeclock.html' : '/timeclock', '_blank');
        });
        document.getElementById('payrollGenTokenBtn')?.addEventListener('click', ()=>this._genTokenHandler?.());
        const copyBtn = document.getElementById('payrollTcCopyBtn');
        copyBtn?.addEventListener('click', async ()=>{
            if (!this._lastTimeclockToken) return;
            try {
                await navigator.clipboard.writeText(this._lastTimeclockToken);
                copyBtn.textContent = 'Copied!';
                setTimeout(()=>{
                    copyBtn.textContent = 'Copy';
                }, 1600);
            } catch (_) {}
        });
        this._content.querySelectorAll('.payroll-device-del').forEach((btn)=>btn.addEventListener('click', ()=>this._revokeDeviceHandler?.(btn.dataset.id, btn.dataset.label)));
    }
    // ── Section: Leave (vacation / sick requests) ──────────────────────────────
    // ── Section: Tips ───────────────────────────────────────────────────────────
    // Each day's tips split among the people in the pool who worked that day, by
    // hours (tips.js computeTipPool). The owner is never in the pool; which roles
    // are is chosen here (null = every role except Admin).
    _tipPoolRoleIds() {
        const { roles: roles, poolRoleIds: poolRoleIds } = this._tips;
        return poolRoleIds ?? roles.filter((r)=>r.name !== 'Admin').map((r)=>r.id);
    }
    _renderTipsSection() {
        const { staff: staff, periodMeta: periodMeta } = this._data;
        const { tips: tips, roles: roles, tipsEnabled: tipsEnabled } = this._tips;
        const poolIds = new Set(this._tipPoolRoleIds());
        const pool = (0, $abGsl.computeTipPool)({
            tips: tips,
            shifts: this._data.shifts,
            inPool: (sh)=>!sh.staffIsOwner && (sh.staffRoleId == null ? this._tips.poolRoleIds == null // no role on record: default pool only
                 : poolIds.has(sh.staffRoleId))
        });
        const nameOf = (staffId)=>{
            const s = staff.find((m)=>m.id === staffId);
            if (s) return `${s.firstName ?? ''} ${s.lastName ?? ''}`.trim() || s.email || 'Staff';
            return this._data.shifts.find((sh)=>sh.staffId === staffId)?.staffName || 'Former staff';
        };
        const colorOf = (staffId)=>{
            const idx = Math.max(0, staff.findIndex((s)=>s.id === staffId));
            return $a1ae7cc9759c5490$var$AVATAR_COLORS[idx % $a1ae7cc9759c5490$var$AVATAR_COLORS.length];
        };
        const initialsOf = (name)=>name.split(' ').map((w)=>w[0]).slice(0, 2).join('').toUpperCase();
        const fmtH = (min)=>{
            const h = Math.floor(min / 60), m = Math.round(min % 60);
            return m === 60 ? `${h + 1}h` : m ? `${h}h ${m}m` : `${h}h`;
        };
        const fmtDay = (key)=>new Date(key + 'T00:00:00').toLocaleDateString('en-US', {
                weekday: 'short',
                month: 'short',
                day: 'numeric'
            });
        const statTile = (accent, label, val, sub)=>`
      <div class="ts-stat-tile" style="--tile-accent:${accent}">
        <div class="ts-stat-tile-label">${label}</div>
        <div class="ts-stat-tile-val">${val}</div>
        <div class="ts-stat-tile-sub">${sub}</div>
      </div>`;
        const perHour = pool.pooledMinutes > 0 ? pool.pooledTips / (pool.pooledMinutes / 60) : 0;
        const statsHtml = `
      <div class="ts-stat-strip">
        ${statTile('#EC4899', 'Tips Collected', (0, $coRoT.formatMoney)(pool.totalTips), periodMeta.label ? (0, $cnCXJ.esc)(periodMeta.label) : 'this period')}
        ${statTile('#18AE79', 'Shared Out', (0, $coRoT.formatMoney)(pool.pooledTips), `to ${pool.people.length} ${pool.people.length === 1 ? 'person' : 'people'}`)}
        ${statTile('#3b82f6', 'Pooled Hours', fmtH(pool.pooledMinutes), 'on days with tips')}
        ${statTile('#f59e0b', 'Per Hour', pool.pooledMinutes > 0 ? (0, $coRoT.formatMoney)(perHour) : "\u2013", 'tips per hour worked')}
      </div>`;
        const unassignedDays = pool.days.filter((d)=>!d.shares.length);
        const warnHtml = pool.unassigned > 0 ? `
      <div class="tp-warn" role="status">
        <span class="tp-warn-icon" aria-hidden="true">!</span>
        <p><b>${(0, $coRoT.formatMoney)(pool.unassigned)} isn't shared yet.</b> Nobody in the pool clocked a finished shift on
        ${unassignedDays.map((d)=>(0, $cnCXJ.esc)(fmtDay(d.day))).join(', ')}. Check the time clock for those days, or who shares tips below.</p>
      </div>` : '';
        const rolesHtml = `
      <section class="tp-card">
        <div class="tp-card-head">
          <div>
            <h4 class="tp-card-title">Who shares tips</h4>
            <p class="tp-card-hint">Tap a role to add or remove it. The owner never shares (US law bars owners and managers from an employee tip pool).</p>
          </div>
        </div>
        <div class="tp-role-chips">
          ${roles.length ? roles.map((r)=>{
            const on = poolIds.has(r.id);
            return `<button type="button" class="tp-role-chip${on ? ' tp-role-chip--on' : ''}" data-role-id="${(0, $cnCXJ.esc)(r.id)}" aria-pressed="${on}">
              <span class="tp-role-check" aria-hidden="true">${on ? "\u2713" : '+'}</span>${(0, $cnCXJ.esc)(r.name)}
            </button>`;
        }).join('') : '<p class="tp-card-hint">No roles yet. Add them in Staff.</p>'}
        </div>
      </section>`;
        const maxAmount = pool.people[0]?.amount || 1;
        const peopleHtml = pool.people.length ? `
      <section class="tp-card">
        <div class="tp-card-head"><h4 class="tp-card-title">Each person's share</h4></div>
        <div class="tp-people">
          ${pool.people.map((p)=>{
            const name = nameOf(p.staffId);
            return `
              <div class="tp-person">
                <span class="tp-avatar" style="background:${colorOf(p.staffId)}">${(0, $cnCXJ.esc)(initialsOf(name))}</span>
                <div class="tp-person-main">
                  <div class="tp-person-top">
                    <span class="tp-person-name">${(0, $cnCXJ.esc)(name)}</span>
                    <span class="tp-person-amount">${(0, $coRoT.formatMoney)(p.amount)}</span>
                  </div>
                  <div class="tp-bar"><span style="width:${Math.max(4, Math.round(p.amount / maxAmount * 100))}%"></span></div>
                  <span class="tp-person-meta">${fmtH(p.minutes)} on ${p.days} day${p.days === 1 ? '' : 's'} with tips</span>
                </div>
              </div>`;
        }).join('')}
        </div>
      </section>` : '';
        const daysHtml = pool.days.length ? `
      <section class="tp-card">
        <div class="tp-card-head"><h4 class="tp-card-title">By day</h4></div>
        <div class="tp-days">
          ${pool.days.map((d)=>`
            <div class="tp-day${d.shares.length ? '' : ' tp-day--unassigned'}">
              <div class="tp-day-head">
                <span class="tp-day-date">${(0, $cnCXJ.esc)(fmtDay(d.day))}</span>
                <span class="tp-day-meta">${d.shares.length ? `${fmtH(d.minutes)} worked` : 'Nobody in the pool worked'}</span>
                <span class="tp-day-amount">${(0, $coRoT.formatMoney)(d.tips)}</span>
              </div>
              ${d.shares.length ? `<div class="tp-day-shares">${d.shares.map((s)=>`
                <span class="tp-share"><b>${(0, $cnCXJ.esc)(nameOf(s.staffId))}</b> ${fmtH(s.minutes)} \xb7 ${(0, $coRoT.formatMoney)(s.amount)}</span>`).join('')}</div>` : ''}
            </div>`).join('')}
        </div>
      </section>` : '';
        const emptyHtml = !pool.days.length ? `
      <div class="tp-empty">
        <div class="tp-empty-icon" aria-hidden="true">\u{1F49D}</div>
        <p class="tp-empty-title">No tips in this period</p>
        <p class="tp-empty-sub">${tipsEnabled ? 'Tips added at checkout show up here, split by who worked each day.' : 'Turn on tips in Settings > POS > Tips, and they\'ll be split here by who worked each day.'}</p>
      </div>` : '';
        this._content.innerHTML = `
      <div class="payroll-header">
        <h3 class="payroll-title">Tips</h3>
        <div class="payroll-header-actions">
          ${pool.days.length ? `<button class="payroll-export-btn" id="tipPoolExportCsv" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            Export CSV
          </button>` : ''}
        </div>
      </div>
      ${this._periodBarHtml(periodMeta)}
      <p class="tp-intro">Each day's tips are split between the people who worked that day, by hours worked. Only finished shifts count.</p>
      ${pool.days.length ? statsHtml : ''}
      ${warnHtml}
      <div class="tp-grid">
        <div class="tp-col">${peopleHtml}${emptyHtml}${rolesHtml}</div>
        <div class="tp-col">${daysHtml}</div>
      </div>
    `;
        this._wirePeriodBar(periodMeta);
        this._content.querySelectorAll('.tp-role-chip').forEach((btn)=>btn.addEventListener('click', ()=>{
                const ids = new Set(this._tipPoolRoleIds());
                if (ids.has(btn.dataset.roleId)) ids.delete(btn.dataset.roleId);
                else ids.add(btn.dataset.roleId);
                this._tipPoolRolesHandler?.([
                    ...ids
                ]);
            }));
        document.getElementById('tipPoolExportCsv')?.addEventListener('click', ()=>{
            const q = (v)=>`"${String(v ?? '').replace(/"/g, '""')}"`;
            const rows = [
                [
                    'Date',
                    'Staff',
                    'Hours',
                    'Tip share',
                    'Day tips'
                ]
            ];
            for (const d of [
                ...pool.days
            ].reverse()){
                if (!d.shares.length) rows.push([
                    d.day,
                    '(nobody in the pool worked)',
                    '',
                    '',
                    d.tips.toFixed(2)
                ]);
                for (const s of d.shares)rows.push([
                    d.day,
                    nameOf(s.staffId),
                    (s.minutes / 60).toFixed(2),
                    s.amount.toFixed(2),
                    d.tips.toFixed(2)
                ]);
            }
            rows.push([], [
                'Total',
                'Staff',
                'Hours',
                'Tip share'
            ]);
            for (const p of pool.people)rows.push([
                '',
                nameOf(p.staffId),
                (p.minutes / 60).toFixed(2),
                p.amount.toFixed(2)
            ]);
            if (pool.unassigned > 0) rows.push([
                '',
                'Not shared (nobody in the pool worked)',
                '',
                pool.unassigned.toFixed(2)
            ]);
            const blob = new Blob([
                "\uFEFF" + rows.map((r)=>r.map(q).join(',')).join('\n')
            ], {
                type: 'text/csv;charset=utf-8;'
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `tips-${String(periodMeta.label || 'period').replace(/[^\w-]+/g, '-')}.csv`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        });
    }
    _renderLeaveSection() {
        const { canEdit: canEdit, leaveRequests: leaveRequests, staff: staff } = this._data;
        // Dates are DATE columns (no time); parse as local midnight for display.
        const fmtDay = (d)=>new Date(d + 'T00:00:00').toLocaleDateString('en-US', {
                weekday: 'short',
                month: 'short',
                day: 'numeric'
            });
        const dayCount = (r)=>{
            const n = Math.round((new Date(r.endDate + 'T00:00:00') - new Date(r.startDate + 'T00:00:00')) / 86400000) + 1;
            return `${n} day${n === 1 ? '' : 's'}`;
        };
        const range = (r)=>r.startDate === r.endDate ? fmtDay(r.startDate) : `${fmtDay(r.startDate)} \u{2013} ${fmtDay(r.endDate)}`;
        // Soft emoji pills for type + status (per Kelly's mockup).
        const typeChip = (t)=>t === 'sick' ? `<span class="ts-lv-pill ts-lv-pill--sick">\u{1F912} Sick</span>` : `<span class="ts-lv-pill ts-lv-pill--vacation">\u{2708}\u{FE0F} Vacation</span>`;
        const avatar = (r)=>{
            const name = r.staffName || 'Staff';
            const initials = name.split(' ').map((w)=>w[0]).slice(0, 2).join('').toUpperCase();
            const idx = Math.max(0, (staff ?? []).findIndex((s)=>s.id === r.staffId));
            return `<span class="ts-lv-avatar" style="background:${$a1ae7cc9759c5490$var$AVATAR_COLORS[idx % $a1ae7cc9759c5490$var$AVATAR_COLORS.length]}">${(0, $cnCXJ.esc)(initials)}</span>`;
        };
        const todayStr = (()=>{
            const d = new Date();
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        })();
        const pending = leaveRequests.filter((r)=>r.status === 'pending');
        // Nearest first: ongoing leaves (ending soonest) on top, then future ones
        // by how soon they start.
        const upcoming = leaveRequests.filter((r)=>r.status === 'approved' && r.endDate >= todayStr).sort((a, b)=>{
            const aOn = a.startDate <= todayStr, bOn = b.startDate <= todayStr;
            if (aOn !== bOn) return aOn ? -1 : 1;
            return aOn ? a.endDate.localeCompare(b.endDate) : a.startDate.localeCompare(b.startDate);
        });
        const history = leaveRequests.filter((r)=>!pending.includes(r) && !upcoming.includes(r));
        const onLeaveToday = new Set(upcoming.filter((r)=>r.startDate <= todayStr).map((r)=>r.staffId)).size;
        // Ongoing / countdown status pill for an approved upcoming leave.
        const startsIn = (r)=>{
            if (r.startDate <= todayStr) return `<span class="ts-lv-pill ts-lv-pill--now"><span class="ts-lv-pill-dot"></span>On leave now</span>`;
            const n = Math.round((new Date(r.startDate + 'T00:00:00') - new Date(todayStr + 'T00:00:00')) / 86400000);
            return `<span class="ts-lv-pill ts-lv-pill--soon">\u{1F550} Starts ${n === 1 ? 'tomorrow' : `in ${n} days`}</span>`;
        };
        const pendingCard = (r)=>`
      <li class="ts-lv-card" data-id="${(0, $cnCXJ.esc)(r.id)}">
        <div class="ts-lv-card-main">
          <div class="ts-lv-card-head">
            ${avatar(r)}
            <div class="ts-lv-card-who">
              <span class="ts-lv-card-name">${(0, $cnCXJ.esc)(r.staffName || 'Staff')}</span>
              <span class="ts-lv-card-range">\u{1F4C5} ${range(r)} \xb7 ${dayCount(r)}</span>
            </div>
            ${typeChip(r.type)}
          </div>
          ${r.reason ? `<p class="ts-lv-card-reason">\u{201C}${(0, $cnCXJ.esc)(r.reason)}\u{201D}</p>` : ''}
        </div>
        <div class="ts-lv-card-actions">
          <button class="btn ts-leave-reject" data-id="${(0, $cnCXJ.esc)(r.id)}" type="button">Reject</button>
          <button class="btn primary ts-leave-approve" data-id="${(0, $cnCXJ.esc)(r.id)}" type="button">Approve</button>
        </div>
      </li>`;
        const whoZone = (r)=>`
      <div class="ts-lv-zone ts-lv-zone--who">
        ${avatar(r)}
        <div class="ts-lv-row-who">
          <span class="ts-lv-card-name">${(0, $cnCXJ.esc)(r.staffName || 'Staff')}</span>
          <span class="ts-lv-card-range">\u{1F4C5} ${range(r)} \xb7 ${dayCount(r)}</span>
        </div>
      </div>`;
        // Reviewer-outcome icons: quiet grey line icons (shield-check style, per the
        // mockup) - the emoji treatment stays on the type/status pills only.
        const shieldPath = `<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1 1 0 0 1 1.52 0C14.5 3.8 17 5 19 5a1 1 0 0 1 1 1z"/>`;
        const apprIcon = (kind)=>{
            const inner = kind === 'ok' ? `${shieldPath}<path d="m9 12 2 2 4-4"/>` : kind === 'no' ? `${shieldPath}<path d="m14.5 9.5-5 5"/><path d="m9.5 9.5 5 5"/>` : `<circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/>`;
            return `<svg class="ts-lv-appr-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;
        };
        const upcomingRow = (r)=>`
      <li class="ts-lv-row" data-id="${(0, $cnCXJ.esc)(r.id)}">
        ${whoZone(r)}
        <div class="ts-lv-zone ts-lv-zone--status">
          ${typeChip(r.type)}
          ${startsIn(r)}
        </div>
        <div class="ts-lv-zone ts-lv-zone--approver">
          ${apprIcon('ok')}
          <div class="ts-lv-appr">
            <span class="ts-lv-appr-lbl">Approved by</span>
            <span class="ts-lv-appr-name">${(0, $cnCXJ.esc)(r.reviewedByName || "\u2014")}</span>
          </div>
        </div>
      </li>`;
        const historyRow = (r)=>{
            let outcome;
            if (r.status === 'approved') outcome = `
          ${apprIcon('ok')}
          <div class="ts-lv-appr">
            <span class="ts-lv-appr-lbl">Approved by</span>
            <span class="ts-lv-appr-name">${(0, $cnCXJ.esc)(r.reviewedByName || "\u2014")}</span>
          </div>`;
            else if (r.status === 'rejected') outcome = `
          ${apprIcon('no')}
          <div class="ts-lv-appr">
            <span class="ts-lv-appr-lbl">Rejected by</span>
            <span class="ts-lv-appr-name">${(0, $cnCXJ.esc)(r.reviewedByName || "\u2014")}</span>
          </div>`;
            else outcome = `
          ${apprIcon('cancel')}
          <div class="ts-lv-appr">
            <span class="ts-lv-appr-lbl">Cancelled</span>
            <span class="ts-lv-appr-name">by staff</span>
          </div>`;
            // Rejected rows show the whole conversation: what the staff member asked
            // for, and why it was declined.
            const msgs = r.reason || r.status === 'rejected' && r.reviewNote ? `
        <div class="ts-lv-msgs">
          ${r.reason ? `<span class="ts-lv-msg"><span class="ts-lv-msg-lbl">Request</span>\u{201C}${(0, $cnCXJ.esc)(r.reason)}\u{201D}</span>` : ''}
          ${r.status === 'rejected' && r.reviewNote ? `<span class="ts-lv-msg"><span class="ts-lv-msg-lbl ts-lv-msg-lbl--reject">Rejected</span>\u{201C}${(0, $cnCXJ.esc)(r.reviewNote)}\u{201D}</span>` : ''}
        </div>` : '';
            return `
        <li class="ts-lv-row ts-lv-row--history">
          ${whoZone(r)}
          <div class="ts-lv-zone ts-lv-zone--status ts-lv-zone--msgs">
            ${typeChip(r.type)}
            ${msgs}
          </div>
          <div class="ts-lv-zone ts-lv-zone--approver">${outcome}</div>
        </li>`;
        };
        const emptyBlock = (msg)=>`
      <div class="ts-lv-empty">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
        <span>${msg}</span>
      </div>`;
        this._content.innerHTML = `
      <div class="payroll-header">
        <h3 class="payroll-title">Leave</h3>
      </div>
      <p class="ts-section-sub">Vacation and sick leave requests. Staff file them from My Timesheet on the Time Clock${canEdit ? '; approving here marks the request - it does not change shifts or pay' : ''}.</p>

      <div class="ts-lv-tiles">
        ${canEdit ? `
        <div class="ts-lv-tile${pending.length ? ' ts-lv-tile--attn' : ''}">
          <span class="ts-lv-tile-num">${pending.length}</span>
          <span class="ts-lv-tile-lbl">Pending review</span>
        </div>` : ''}
        <div class="ts-lv-tile">
          <span class="ts-lv-tile-num">${upcoming.length}</span>
          <span class="ts-lv-tile-lbl">Upcoming leave${upcoming.length === 1 ? '' : 's'}</span>
        </div>
        <div class="ts-lv-tile">
          <span class="ts-lv-tile-num">${onLeaveToday}</span>
          <span class="ts-lv-tile-lbl">On leave today</span>
        </div>
      </div>

      ${canEdit ? `
      <h4 class="ts-leave-heading">Pending requests</h4>
      ${pending.length ? `<ul class="ts-lv-cards">${pending.map(pendingCard).join('')}</ul>` : emptyBlock('All caught up - no leave requests waiting for review.')}` : ''}

      <h4 class="ts-leave-heading">Upcoming leave</h4>
      ${upcoming.length ? `<ul class="ts-lv-list">${upcoming.map(upcomingRow).join('')}</ul>` : emptyBlock('No approved leave coming up.')}

      ${history.length ? `
      <details class="ts-leave-history">
        <summary class="ts-leave-history-summary">
          History
          <span class="ts-lv-count">${history.length}</span>
          <svg class="payroll-info-chevron" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
        </summary>
        <ul class="ts-lv-list">${history.map(historyRow).join('')}</ul>
      </details>` : ''}
    `;
        this._content.querySelectorAll('.ts-leave-approve').forEach((btn)=>btn.addEventListener('click', ()=>this._reviewLeaveHandler?.(btn.dataset.id, 'approved')));
        this._content.querySelectorAll('.ts-leave-reject').forEach((btn)=>btn.addEventListener('click', ()=>this._reviewLeaveHandler?.(btn.dataset.id, 'rejected')));
    }
    _reviewLeaveHandler = null;
    _addHandlerReviewLeave(handler) {
        this._reviewLeaveHandler = handler;
    }
    // ── Section: Deleted shifts ─────────────────────────────────────────────────
    _renderDeletedSection() {
        const { deletedShifts: deletedShifts } = this._data;
        const delRows = deletedShifts.map((d)=>`
      <li class="payroll-deleted-row">
        <div class="payroll-deleted-main">
          <span class="payroll-deleted-name">${(0, $cnCXJ.esc)(d.staffName || 'Staff')}</span>
          <span class="payroll-deleted-times">${$a1ae7cc9759c5490$var$fmtDate(d.clockedInAt)} \xb7 ${$a1ae7cc9759c5490$var$fmtTime(d.clockedInAt)} \u{2192} ${d.clockedOutAt ? $a1ae7cc9759c5490$var$fmtTime(d.clockedOutAt) : "\u2013"}</span>
        </div>
        <span class="payroll-deleted-by">Deleted by ${(0, $cnCXJ.esc)(d.deletedBy)} \xb7 ${$a1ae7cc9759c5490$var$fmtDate(d.deletedAt)}</span>
        <button class="btn payroll-restore-btn" data-id="${(0, $cnCXJ.esc)(d.id)}" type="button">Restore</button>
      </li>`).join('');
        this._content.innerHTML = `
      <div class="payroll-header">
        <h3 class="payroll-title">Deleted shifts</h3>
      </div>
      <p class="ts-section-sub">Deleted shifts can be restored for 7 days, then they are removed permanently.</p>
      ${deletedShifts.length ? `<div class="payroll-deleted payroll-deleted--page"><ul class="payroll-deleted-list">${delRows}</ul></div>` : `<div class="ts-empty">
            ${$a1ae7cc9759c5490$var$trashSvg}
            <p>Nothing here - no shifts deleted in the last 7 days.</p>
          </div>`}
    `;
        this._content.querySelectorAll('.payroll-restore-btn').forEach((btn)=>btn.addEventListener('click', ()=>this._restoreShiftHandler?.(btn.dataset.id)));
    }
    // ── Shift add/edit modal ────────────────────────────────────────────────────
    _showShiftModal(shift, staff) {
        if (document.getElementById('shiftEditModal')) return;
        const isEdit = !!shift;
        const modal = document.createElement('div');
        modal.className = 'cashier-picker-overlay';
        modal.id = 'shiftEditModal';
        modal.style.zIndex = '99999';
        const toLocalInput = (iso)=>{
            if (!iso) return '';
            const d = new Date(iso);
            const pad = (n)=>String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
        };
        const staffOptions = staff.map((s)=>`<option value="${(0, $cnCXJ.esc)(s.id)}" ${shift?.staffId === s.id ? 'selected' : ''}>${(0, $cnCXJ.esc)(s.firstName)} ${(0, $cnCXJ.esc)(s.lastName)}</option>`).join('');
        modal.innerHTML = `
      <div class="cashier-picker-card" style="max-width:360px;width:calc(100vw - 40px);overflow:hidden">
        <div class="cashier-picker-header">
          <div><h3 class="cashier-picker-title">${isEdit ? 'Edit Shift' : 'Add Shift'}</h3></div>
          <button class="modal-close-btn" data-action="close" type="button">&times;</button>
        </div>
        <div class="edit-field" style="margin-top:8px">
          <label>Staff Member</label>
          <select id="shiftStaffSelect" class="settings-select">${staffOptions}</select>
        </div>
        <div class="edit-field" style="margin-top:10px">
          <label>Clock In</label>
          <input type="datetime-local" id="shiftClockIn" class="settings-input" value="${toLocalInput(shift?.clockedInAt)}" style="width:100%" />
        </div>
        <div class="edit-field" style="margin-top:10px">
          <label>Clock Out</label>
          <input type="datetime-local" id="shiftClockOut" class="settings-input" value="${toLocalInput(shift?.clockedOutAt)}" style="width:100%" />
        </div>
        <div class="edit-field" style="margin-top:10px">
          <label>Note (optional)</label>
          <input type="text" id="shiftNote" class="settings-input" placeholder="e.g. Covered for Jane" value="${(0, $cnCXJ.esc)(shift?.note ?? '')}" />
        </div>
        <div class="adj-form-actions" style="margin-top:16px">
          <button type="button" class="btn" data-action="close">Cancel</button>
          <button type="button" class="btn primary" data-action="save">Save</button>
        </div>
      </div>
    `;
        document.body.appendChild(modal);
        const close = ()=>modal.remove();
        modal.querySelectorAll('[data-action="close"]').forEach((b)=>b.addEventListener('click', close));
        modal.addEventListener('click', (e)=>{
            if (e.target === modal) close();
        });
        modal.querySelector('[data-action="save"]').addEventListener('click', ()=>{
            const staffId = document.getElementById('shiftStaffSelect')?.value;
            const clockedInAt = document.getElementById('shiftClockIn')?.value;
            const clockedOutAt = document.getElementById('shiftClockOut')?.value;
            const note = document.getElementById('shiftNote')?.value.trim();
            if (!clockedInAt) {
                alert('Clock-in time is required.');
                return;
            }
            close();
            if (this._shiftSaveHandler) this._shiftSaveHandler({
                id: shift?.id ?? null,
                staffId: staffId,
                clockedInAt: new Date(clockedInAt).toISOString(),
                clockedOutAt: clockedOutAt ? new Date(clockedOutAt).toISOString() : null,
                note: note
            });
        });
    }
    _shiftSaveHandler = null;
    _addHandlerSaveShift(handler) {
        this._shiftSaveHandler = handler;
    }
}
const $a1ae7cc9759c5490$var$_view = new $a1ae7cc9759c5490$var$TimesheetView();
$a1ae7cc9759c5490$var$_view._addHandlerDrawer();
var $a1ae7cc9759c5490$export$2e2bcd8739ae039 = $a1ae7cc9759c5490$var$_view;



var $cnCXJ = parcelRequire("cnCXJ");

var $lDSCx = parcelRequire("lDSCx");
// "isn't available on Tuesdays" (WEEKDAYS is Mon-first short names).
const $27809bb01dc8a27e$var$WEEKDAY_PLURALS = [
    'Mondays',
    'Tuesdays',
    'Wednesdays',
    'Thursdays',
    'Fridays',
    'Saturdays',
    'Sundays'
];
// Schedule panel (2026-10-15, free on every plan): a week builder (team down the
// side, days across, shifts colored by station) and the business's station list.
// Same shell as Timesheets (.ts-layout sidebar + drawer). Times are planned in
// the business timezone (scheduleTime.js). Drafts (published_at null) have dashed
// edges until "Publish week". Mockup: claude.ai/artifact/D8EHoxaEPjAhWWAUCUVkjH.
const $27809bb01dc8a27e$var$AVATAR_COLORS = [
    '#0FA267',
    '#7C3AED',
    '#EA580C',
    '#2563EB',
    '#0E9384',
    '#DB2777',
    '#CA8A04',
    '#4F46E5'
];
const $27809bb01dc8a27e$export$49b726243aa707b7 = [
    '#0FA267',
    '#7C3AED',
    '#EA580C',
    '#2563EB',
    '#DB2777',
    '#0E9384',
    '#CA8A04',
    '#64748B'
];
const $27809bb01dc8a27e$var$NO_STATION_COLOR = '#64748B';
const $27809bb01dc8a27e$var$OVERTIME_HOURS = 40;
const $27809bb01dc8a27e$var$ICONS = {
    week: '<rect x="3" y="4" width="18" height="18" rx="2"/><path d="M3 10h18"/><path d="M8 14h.01"/><path d="M12 14h.01"/><path d="M16 14h.01"/><path d="M8 18h.01"/><path d="M12 18h.01"/>',
    stations: '<path d="m12.83 2.18 8.18 3.72a1 1 0 0 1 0 1.83l-8.18 3.72a2 2 0 0 1-1.66 0L3 7.73a1 1 0 0 1 0-1.83l8.17-3.72a2 2 0 0 1 1.66 0z"/><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"/><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"/>',
    copy: '<rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/>',
    send: '<path d="M22 2 11 13"/><path d="M22 2 15 22l-4-9-9-4Z"/>',
    requests: '<path d="M8 3 4 7l4 4"/><path d="M4 7h16"/><path d="m16 21 4-4-4-4"/><path d="M20 17H4"/>',
    availability: '<path d="M2 21a8 8 0 0 1 13.292-6"/><circle cx="10" cy="8" r="5"/><path d="m16 19 2 2 4-4"/>'
};
const $27809bb01dc8a27e$var$LEAVE_LABEL = {
    vacation: "\u2708\uFE0F Vacation",
    sick: "\uD83E\uDD12 Sick"
};
const $27809bb01dc8a27e$var$svg = (d, s = 16)=>`<svg xmlns="http://www.w3.org/2000/svg" width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
const $27809bb01dc8a27e$var$staffName = (s)=>`${s.firstName ?? ''} ${s.lastName ?? ''}`.trim() || s.email || 'Staff';
const $27809bb01dc8a27e$var$initials = (name)=>name.split(/\s+/).map((w)=>w[0]).slice(0, 2).join('').toUpperCase();
class $27809bb01dc8a27e$var$ScheduleView {
    _panel = document.querySelector('#schedulePanel');
    _sidebar = document.querySelector('#scheduleSidebar');
    _content = document.querySelector('#scheduleContent');
    _section = 'week';
    _data = null;
    _handlers = {};
    _lastTimes = {
        start: '09:00',
        end: '17:00'
    };
    open() {
        this._panel.classList.remove('hidden', 'cashflow-exiting');
    }
    close() {
        this._closeDrawer();
        this.closeDialog();
        this._panel.classList.add('cashflow-exiting');
        setTimeout(()=>{
            this._panel.classList.add('hidden');
            this._panel.classList.remove('cashflow-exiting');
        }, 220);
    }
    isOpen() {
        return !this._panel.classList.contains('hidden');
    }
    renderLoading() {
        this._content.innerHTML = `<div class="sch-loading"><span class="skel" style="height:44px;border-radius:14px"></span><span class="skel" style="height:86px;border-radius:16px"></span><span class="skel" style="height:320px;border-radius:18px"></span></div>`;
    }
    render(data) {
        this._data = data;
        this._renderSidebar();
        if (this._section === 'stations') this._renderStations();
        else if (this._section === 'requests') this._renderRequests();
        else if (this._section === 'availability') this._renderAvailability();
        else this._renderWeek();
    }
    setSection(id) {
        this._section = id;
    }
    // ── Handlers (controller callbacks) ──────────────────────────────────────────
    // onOpen, onClose, onWeek(delta | 0 = this week), onSaveShift(payload),
    // onDeleteShift(shift), onCopyLastWeek(), onPublish(), onAddStation({name,color}),
    // onUpdateStation(id, patch), onArchiveStation(id), onSection(id),
    // onReviewRequest(request, 'approve' | 'reject'), onSaveAvailability(staffId, days)
    bind(handlers) {
        this._handlers = handlers;
        document.addEventListener('click', (e)=>{
            if (e.target.closest("[data-action='schedule']")) handlers.onOpen();
        });
        this._panel.querySelector('.schedule-back')?.addEventListener('click', ()=>handlers.onClose());
        const btn = this._panel.querySelector('#scheduleNavBtn');
        btn?.addEventListener('click', ()=>btn.getAttribute('aria-expanded') === 'true' ? this._closeDrawer() : this._openDrawer());
        this._panel.querySelector('#scheduleNavBackdrop')?.addEventListener('click', ()=>this._closeDrawer());
        this._content.addEventListener('click', (e)=>this._onContentClick(e));
        this._content.addEventListener('change', (e)=>this._onContentChange(e));
        this._content.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' && e.target.matches('.sch-station-name, #schNewStationName')) {
                e.preventDefault();
                e.target.blur();
                if (e.target.id === 'schNewStationName') this._addStationFromInput();
            }
        });
    }
    // ── Mobile drawer (same pattern as Timesheets) ───────────────────────────────
    _openDrawer() {
        this._sidebar.classList.add('panel-sidebar--open');
        this._panel.querySelector('#scheduleNavBackdrop')?.classList.add('panel-nav-backdrop--visible');
        this._panel.querySelector('#scheduleNavBtn')?.setAttribute('aria-expanded', 'true');
    }
    _closeDrawer() {
        this._sidebar.classList.remove('panel-sidebar--open');
        this._panel.querySelector('#scheduleNavBackdrop')?.classList.remove('panel-nav-backdrop--visible');
        this._panel.querySelector('#scheduleNavBtn')?.setAttribute('aria-expanded', 'false');
    }
    // ── Sidebar ──────────────────────────────────────────────────────────────────
    _renderSidebar() {
        const waiting = this._pendingRequests().length;
        const nav = {
            week: {
                c: '#0FA267',
                label: 'Schedule',
                desc: 'Build &amp; publish the week'
            },
            requests: {
                c: '#2563EB',
                label: 'Requests',
                desc: 'Swaps &amp; open-shift pickups',
                count: waiting
            },
            availability: {
                c: '#EA580C',
                label: 'Availability',
                desc: 'When each person can work'
            },
            stations: {
                c: '#7C3AED',
                label: 'Stations',
                desc: 'Barista, kitchen &amp; more'
            }
        };
        this._sidebar.innerHTML = `<p class="ts-side-label">Sections</p>${Object.entries(nav).map(([id, n])=>`
      <button class="pb-nav-item ts-tab${this._section === id ? ' ts-tab--active' : ''}" data-section="${id}" type="button" style="--nav-c:${n.c}">
        <span class="pb-nav-icon">${$27809bb01dc8a27e$var$svg($27809bb01dc8a27e$var$ICONS[id], 18)}</span>
        <span class="pb-nav-text"><span class="pb-nav-name">${n.label}</span><span class="pb-nav-desc">${n.desc}</span></span>
        ${n.count ? `<span class="sch-nav-count" aria-label="${n.count} waiting">${n.count}</span>` : ''}
      </button>`).join('')}`;
        this._sidebar.querySelectorAll('.ts-tab').forEach((b)=>b.addEventListener('click', ()=>{
                this._closeDrawer();
                if (b.dataset.section === this._section) return;
                this._section = b.dataset.section;
                this.render(this._data);
                this._handlers.onSection?.(this._section);
            }));
    }
    // ── Week ─────────────────────────────────────────────────────────────────────
    _station(id) {
        return this._data.stations.find((s)=>s.id === id) ?? null;
    }
    _dayOf(iso) {
        return (0, $lDSCx.zonedParts)(new Date(iso), this._data.tz).dateStr;
    }
    _person(id) {
        return this._data.staff.find((s)=>s.id === id) ?? null;
    }
    _firstName(id) {
        const p = this._person(id);
        return p ? $27809bb01dc8a27e$var$staffName(p).split(' ')[0] : 'They';
    }
    _pendingRequests() {
        return (this._data?.requests ?? []).filter((r)=>r.status === 'pending');
    }
    // Leave covering a day: approved wins over pending.
    _leaveOn(staffId, day) {
        const list = (this._data.leave ?? []).filter((l)=>l.staffId === staffId && l.startDate <= day && l.endDate >= day);
        return list.find((l)=>l.status === 'approved') ?? list[0] ?? null;
    }
    _availOn(staffId, day) {
        return (this._data.availability ?? []).find((a)=>a.staffId === staffId && a.weekday === (0, $lDSCx.weekdayIndex)(day) && a.status !== 'available') ?? null;
    }
    // Why this person shouldn't work this shift, or null. kind: 'leave' | 'pending' | 'off' | 'outside'.
    _conflict(staffId, day, startTime, endTime) {
        if (!staffId) return null;
        const lv = this._leaveOn(staffId, day);
        if (lv?.status === 'approved') return {
            kind: 'leave',
            text: `${this._firstName(staffId)} is on ${lv.type === 'sick' ? 'sick leave' : 'vacation'} ${(0, $lDSCx.dayLabel)(day)}.`
        };
        const av = this._availOn(staffId, day);
        const why = av?.note ? ` (${av.note})` : '';
        if (av?.status === 'unavailable') return {
            kind: 'off',
            text: `${this._firstName(staffId)} isn't available on ${$27809bb01dc8a27e$var$WEEKDAY_PLURALS[(0, $lDSCx.weekdayIndex)(day)]}${why}.`
        };
        if (av?.status === 'partial' && startTime && !(0, $lDSCx.fitsWindow)(av.startTime, av.endTime, startTime, endTime)) return {
            kind: 'outside',
            text: `${this._firstName(staffId)} is only free ${(0, $lDSCx.clockShort)(av.startTime)}\u{2013}${(0, $lDSCx.clockShort)(av.endTime)} on ${$27809bb01dc8a27e$var$WEEKDAY_PLURALS[(0, $lDSCx.weekdayIndex)(day)]}${why}.`
        };
        if (lv) return {
            kind: 'pending',
            text: `${this._firstName(staffId)} has asked for leave on ${(0, $lDSCx.dayLabel)(day)} (not decided yet).`
        };
        return null;
    }
    _renderWeek() {
        const { monday: monday, tz: tz, staff: staff, shifts: shifts } = this._data;
        const days = [
            ...Array(7)
        ].map((_, i)=>(0, $lDSCx.addDays)(monday, i));
        const today = (0, $lDSCx.todayIn)(tz);
        const isThisWeek = (0, $lDSCx.mondayOf)(today) === monday;
        const drafts = shifts.filter((s)=>!s.publishedAt).length;
        const open = shifts.filter((s)=>!s.staffId);
        const totalH = shifts.reduce((h, s)=>h + (0, $lDSCx.hoursBetween)(s.startsAt, s.endsAt), 0);
        // Rows: active staff, plus anyone deactivated who still has a shift this week.
        const rows = staff.filter((s)=>s.isActive !== false);
        shifts.forEach((sh)=>{
            if (sh.staffId && !rows.some((r)=>r.id === sh.staffId)) {
                const s = staff.find((x)=>x.id === sh.staffId);
                rows.push(s ?? {
                    id: sh.staffId,
                    firstName: 'Former',
                    lastName: 'staff',
                    isActive: false
                });
            }
        });
        const peopleScheduled = new Set(shifts.filter((s)=>s.staffId).map((s)=>s.staffId)).size;
        const status = !shifts.length ? `<span class="sch-status sch-status--empty">Nothing scheduled yet</span>` : drafts ? `<span class="sch-status sch-status--draft">Draft \xb7 ${drafts} unpublished ${drafts === 1 ? 'shift' : 'shifts'}</span>` : `<span class="sch-status sch-status--live">Published</span>`;
        const tile = (accent, label, val, sub)=>`
      <div class="ts-stat-tile" style="--tile-accent:${accent}">
        <div class="ts-stat-tile-label">${label}</div>
        <div class="ts-stat-tile-val">${val}</div>
        <div class="ts-stat-tile-sub">${sub}</div>
      </div>`;
        const openReqs = (this._data.requests ?? []).filter((r)=>r.status === 'pending' || r.status === 'waiting_teammate');
        const chip = (sh)=>{
            const st = this._station(sh.stationId);
            const ovn = this._dayOf(sh.endsAt) !== this._dayOf(sh.startsAt) ? ' <span class="sch-shift-ovn" title="Ends the next day">+1</span>' : '';
            const clash = this._conflict(sh.staffId, this._dayOf(sh.startsAt), (0, $lDSCx.zonedParts)(new Date(sh.startsAt), tz).timeStr, (0, $lDSCx.zonedParts)(new Date(sh.endsAt), tz).timeStr);
            const bad = clash && clash.kind !== 'pending';
            const asks = openReqs.filter((r)=>r.shiftId === sh.id || r.targetShiftId === sh.id);
            const tag = !asks.length ? '' : sh.staffId ? ' <span class="sch-shift-req" title="Swap requested">\u21C4</span>' : ` <span class="sch-shift-req" title="${asks.length} asked to pick this up">\u{270B}${asks.length}</span>`;
            const title = [
                clash?.text,
                sh.note
            ].filter(Boolean).join(" \xb7 ");
            return `<button type="button" class="sch-shift${sh.publishedAt ? '' : ' sch-shift--draft'}${sh.staffId ? '' : ' sch-shift--open'}${bad ? ' sch-shift--clash' : ''}" data-shift="${(0, $cnCXJ.esc)(sh.id)}" style="--sc:${st?.color ?? $27809bb01dc8a27e$var$NO_STATION_COLOR}" title="${(0, $cnCXJ.esc)(title)}">
        <b>${sh.seriesId ? '<span class="sch-shift-rep" title="Repeats weekly">\u21BB</span> ' : ''}${(0, $lDSCx.shortTime)(new Date(sh.startsAt), tz)}\u{2013}${(0, $lDSCx.shortTime)(new Date(sh.endsAt), tz)}${ovn}${tag}</b>
        <span>${bad ? "\u26A0\uFE0F " : ''}${(0, $cnCXJ.esc)(st?.name ?? 'No station')}${sh.note ? " \xb7 \uD83D\uDCDD" : ''}</span>
      </button>`;
        };
        // A person's day shows approved/pending leave or their availability above the shifts.
        const dayNote = (staffId, day)=>{
            if (!staffId) return '';
            const lv = this._leaveOn(staffId, day);
            if (lv) return `<span class="sch-off sch-off--${lv.status === 'approved' ? 'leave' : 'pending'}">${lv.status === 'approved' ? $27809bb01dc8a27e$var$LEAVE_LABEL[lv.type] ?? 'On leave' : 'Leave asked'}</span>`;
            const av = this._availOn(staffId, day);
            if (av?.status === 'unavailable') return `<span class="sch-off sch-off--unavail" title="${(0, $cnCXJ.esc)(av.note || '')}">Unavailable</span>`;
            if (av?.status === 'partial') return `<span class="sch-off sch-off--partial" title="${(0, $cnCXJ.esc)(av.note || '')}">Free ${(0, $lDSCx.clockShort)(av.startTime)}\u{2013}${(0, $lDSCx.clockShort)(av.endTime)}</span>`;
            return '';
        };
        const cell = (staffId, day)=>{
            const list = shifts.filter((s)=>(s.staffId ?? null) === staffId && this._dayOf(s.startsAt) === day);
            const label = `Add a shift on ${(0, $lDSCx.dayLabel)(day)}`;
            const lv = staffId ? this._leaveOn(staffId, day) : null;
            const off = lv?.status === 'approved' || staffId && this._availOn(staffId, day)?.status === 'unavailable';
            return `<div class="sch-cell${day === today ? ' sch-cell--today' : ''}${list.length ? '' : ' sch-cell--empty'}${off ? ' sch-cell--off' : ''}">
        ${dayNote(staffId, day)}
        ${list.map(chip).join('')}
        <button type="button" class="sch-add" data-add-staff="${(0, $cnCXJ.esc)(staffId ?? '')}" data-add-day="${day}" aria-label="${(0, $cnCXJ.esc)(label)}" title="${(0, $cnCXJ.esc)(label)}">+</button>
      </div>`;
        };
        const rowHours = (staffId)=>shifts.filter((s)=>(s.staffId ?? null) === staffId).reduce((h, s)=>h + (0, $lDSCx.hoursBetween)(s.startsAt, s.endsAt), 0);
        const head = `<div class="sch-gh sch-gh--team">Team</div>${days.map((d, i)=>`
      <div class="sch-gh${d === today ? ' sch-gh--today' : ''}">${(0, $lDSCx.WEEKDAYS)[i]}<b>${(0, $lDSCx.dayNum)(d)}</b></div>`).join('')}`;
        const body = rows.map((s, i)=>{
            const name = $27809bb01dc8a27e$var$staffName(s), h = rowHours(s.id);
            return `<div class="sch-who">
          <span class="sch-av" style="--ac:${$27809bb01dc8a27e$var$AVATAR_COLORS[i % $27809bb01dc8a27e$var$AVATAR_COLORS.length]}">${(0, $cnCXJ.esc)($27809bb01dc8a27e$var$initials(name))}</span>
          <span class="sch-who-text"><b>${(0, $cnCXJ.esc)(name)}</b><span>${(0, $cnCXJ.esc)(s.role ?? '')}${s.role ? " \xb7 " : ''}<span class="${h > $27809bb01dc8a27e$var$OVERTIME_HOURS ? 'sch-over' : ''}">${(0, $lDSCx.fmtHours)(h)}</span></span></span>
        </div>${days.map((d)=>cell(s.id, d)).join('')}`;
        }).join('');
        const openRow = `<div class="sch-who sch-who--open">
        <span class="sch-av sch-av--open">?</span>
        <span class="sch-who-text"><b>Open shifts</b><span>Not assigned yet</span></span>
      </div>${days.map((d)=>cell(null, d)).join('')}`;
        const foot = `<div class="sch-foot sch-foot--label">Hours / day</div>${days.map((d)=>{
            const h = shifts.filter((s)=>this._dayOf(s.startsAt) === d).reduce((t, s)=>t + (0, $lDSCx.hoursBetween)(s.startsAt, s.endsAt), 0);
            return `<div class="sch-foot">${h ? (0, $lDSCx.fmtHours)(h) : "\u2013"}</div>`;
        }).join('')}`;
        const pendingCount = this._pendingRequests().length;
        const usedStations = this._data.stations.filter((st)=>!st.archived || shifts.some((s)=>s.stationId === st.id));
        this._content.innerHTML = `
      <div class="sch-toolbar">
        <div class="sch-week-nav">
          <button type="button" data-week="-1" aria-label="Previous week">\u{2039}</button>
          <span class="sch-week-label">${(0, $lDSCx.weekLabel)(monday)}</span>
          <button type="button" data-week="1" aria-label="Next week">\u{203A}</button>
        </div>
        ${isThisWeek ? '' : '<button type="button" class="sch-btn sch-btn--ghost" data-week="0">This week</button>'}
        ${status}
        <span class="sch-spacer"></span>
        <button type="button" class="sch-btn" id="schCopyBtn">${$27809bb01dc8a27e$var$svg($27809bb01dc8a27e$var$ICONS.copy)}Copy last week</button>
        <button type="button" class="sch-btn sch-btn--primary" id="schPublishBtn"${drafts ? '' : ' disabled'}>${$27809bb01dc8a27e$var$svg($27809bb01dc8a27e$var$ICONS.send)}Publish week</button>
      </div>
      <div class="ts-stat-strip sch-stats">
        ${tile('#18AE79', 'Scheduled', (0, $lDSCx.fmtHours)(totalH), `${shifts.length} ${shifts.length === 1 ? 'shift' : 'shifts'}`)}
        ${tile('#2563EB', 'Open shifts', open.length, open.length ? 'waiting for someone' : 'everything is covered')}
        ${tile('#F59E0B', 'Unpublished', drafts, drafts ? 'staff can\'t see these yet' : 'staff see everything')}
        ${tile('#7C3AED', 'Team scheduled', `${peopleScheduled} / ${rows.filter((r)=>r.isActive !== false).length}`, 'people this week')}
      </div>
      <div class="sch-grid-wrap"><div class="sch-grid">${head}${body}${openRow}${foot}</div></div>
      <div class="sch-legend">
        ${usedStations.map((st)=>`<span><i style="--sc:${st.color}"></i>${(0, $cnCXJ.esc)(st.name)}</span>`).join('')}
        <span><i class="sch-legend-draft"></i>Dashed = not published yet</span>
        <span><i class="sch-legend-off"></i>Off (leave or unavailable)</span>
        ${pendingCount ? `<button type="button" class="sch-legend-req" data-section-go="requests">\u{270B} ${pendingCount} ${pendingCount === 1 ? 'request needs' : 'requests need'} your OK</button>` : ''}
      </div>`;
    }
    // ── Shift dialog ─────────────────────────────────────────────────────────────
    // shift = an existing shift to edit, or { staffId, day } to add one.
    // Days are chips (several = one shift on each, "a week straight" in one go).
    // Repeat "Every week" turns the chosen weekdays into a repeating rule; editing
    // a repeat asks This / Following / All upcoming in the controller.
    openDialog(shift) {
        this.closeDialog();
        const { monday: monday, tz: tz, staff: staff } = this._data;
        const editing = !!shift.id;
        const series = shift.seriesId ? this._data.series.find((x)=>x.id === shift.seriesId) ?? null : null;
        const days = [
            ...Array(7)
        ].map((_, i)=>(0, $lDSCx.addDays)(monday, i));
        const ownDay = editing ? this._dayOf(shift.startsAt) : shift.day;
        const chosen = new Set(series ? days.filter((d, i)=>series.weekdays.includes(i)) : [
            ownDay
        ]);
        chosen.add(ownDay);
        const start = editing ? (0, $lDSCx.zonedParts)(new Date(shift.startsAt), tz).timeStr : this._lastTimes.start;
        const end = editing ? (0, $lDSCx.zonedParts)(new Date(shift.endsAt), tz).timeStr : this._lastTimes.end;
        const staffId = shift.staffId ?? '';
        const stationId = editing ? shift.stationId ?? '' : this._lastStation ?? this._data.stations.find((s)=>!s.archived)?.id ?? '';
        const people = staff.filter((s)=>s.isActive !== false || s.id === staffId);
        const stations = this._data.stations.filter((s)=>!s.archived || s.id === stationId);
        const until = series?.untilDate ?? '';
        const pill = series ? '<span class="sch-status sch-status--repeat">\u21BB Repeats weekly</span>' : editing && shift.publishedAt ? '<span class="sch-status sch-status--live">Published</span>' : editing ? '<span class="sch-status sch-status--draft">Draft</span>' : '';
        const el = document.createElement('div');
        el.className = 'modal-backdrop sch-dialog-backdrop';
        el.id = 'schDialog';
        el.innerHTML = `
      <div class="sch-dialog" role="dialog" aria-modal="true" aria-labelledby="schDialogTitle">
        <div class="sch-dialog-head">
          <h3 id="schDialogTitle">${editing ? 'Edit shift' : 'Add shift'}</h3>
          ${pill}
          <button type="button" class="modal-close sch-dialog-close" aria-label="Close">&times;</button>
        </div>
        <label class="sch-field"><span>Who</span>
          <select id="schWho">
            <option value="">Open shift (anyone can take it)</option>
            ${people.map((s)=>`<option value="${(0, $cnCXJ.esc)(s.id)}"${s.id === staffId ? ' selected' : ''}>${(0, $cnCXJ.esc)($27809bb01dc8a27e$var$staffName(s))}</option>`).join('')}
          </select>
        </label>
        <div class="sch-field"><span class="sch-field-label-row">Days
          <span class="sch-presets">
            <button type="button" data-preset="weekdays">Weekdays</button>
            <button type="button" data-preset="weekends">Weekends</button>
            <button type="button" data-preset="all">Every day</button>
          </span></span>
          <div class="sch-days" role="group" aria-label="Days">
            ${days.map((d, i)=>`<button type="button" class="sch-day${chosen.has(d) ? ' sch-day--on' : ''}" data-day="${d}" aria-pressed="${chosen.has(d)}"><span>${(0, $lDSCx.WEEKDAYS)[i].slice(0, 2)}</span><b>${(0, $lDSCx.dayNum)(d)}</b></button>`).join('')}
          </div>
        </div>
        <div class="sch-field-row sch-field-row--2">
          <label class="sch-field"><span>Start</span><input type="time" id="schStart" value="${start}" required /></label>
          <label class="sch-field"><span>End</span><input type="time" id="schEnd" value="${end}" required /></label>
        </div>
        <div class="sch-field-row sch-field-row--2">
          <label class="sch-field"><span>Repeat</span>
            <select id="schRepeat">
              <option value="none"${series ? '' : ' selected'}>Doesn't repeat</option>
              <option value="weekly"${series ? ' selected' : ''}>Every week</option>
            </select>
          </label>
          <label class="sch-field" id="schEndsField"${series ? '' : ' hidden'}><span>Ends</span>
            <select id="schEnds">
              <option value="never"${until ? '' : ' selected'}>Never</option>
              <option value="on"${until ? ' selected' : ''}>On a date</option>
            </select>
          </label>
        </div>
        <label class="sch-field" id="schUntilField"${until ? '' : ' hidden'}><span>Last day</span>
          <input type="date" id="schUntil" value="${until}" min="${ownDay}" />
        </label>
        <div class="sch-field"><span>Station</span>
          <div class="sch-station-pick" role="radiogroup" aria-label="Station">
            ${stations.map((st)=>`<button type="button" role="radio" aria-checked="${st.id === stationId}" class="sch-pick${st.id === stationId ? ' sch-pick--on' : ''}" data-pick="${(0, $cnCXJ.esc)(st.id)}" style="--sc:${st.color}"><i></i>${(0, $cnCXJ.esc)(st.name)}</button>`).join('')}
            <button type="button" role="radio" aria-checked="${!stationId}" class="sch-pick${stationId ? '' : ' sch-pick--on'}" data-pick="" style="--sc:${$27809bb01dc8a27e$var$NO_STATION_COLOR}"><i></i>None</button>
          </div>
        </div>
        <label class="sch-field"><span>Note for staff <em>(optional)</em></span>
          <input type="text" id="schNote" maxlength="200" placeholder="e.g. Open the store, receive milk delivery" value="${(0, $cnCXJ.esc)(shift.note ?? '')}" />
        </label>
        <div class="sch-dialog-info" id="schDialogInfo" aria-live="polite"></div>
        <div class="sch-dialog-actions">
          ${editing ? '<button type="button" class="sch-btn sch-btn--danger" id="schDeleteShift">Delete</button>' : ''}
          <span class="sch-spacer"></span>
          <button type="button" class="sch-btn" id="schCancelShift">Cancel</button>
          <button type="button" class="sch-btn sch-btn--primary" id="schSaveShift">${editing ? 'Save' : 'Add shift'}</button>
        </div>
      </div>`;
        document.body.appendChild(el);
        this._dialog = {
            el: el,
            shift: shift,
            series: series,
            stationId: stationId,
            days: days,
            ownDay: ownDay
        };
        const update = ()=>this._updateDialogInfo();
        const repeatOn = ()=>el.querySelector('#schRepeat').value === 'weekly';
        const setDay = (btn, on)=>{
            btn.classList.toggle('sch-day--on', on);
            btn.setAttribute('aria-pressed', String(on));
        };
        el.querySelectorAll('select, input').forEach((i)=>i.addEventListener('input', update));
        el.querySelector('#schRepeat').addEventListener('input', ()=>{
            el.querySelector('#schEndsField').hidden = !repeatOn();
            el.querySelector('#schUntilField').hidden = !repeatOn() || el.querySelector('#schEnds').value !== 'on';
            // Editing a single one-off shift: without a repeat it lives on one day only.
            if (!repeatOn() && editing && !series) el.querySelectorAll('.sch-day').forEach((b)=>setDay(b, b.dataset.day === ownDay));
            update();
        });
        el.querySelector('#schEnds').addEventListener('input', ()=>{
            const on = el.querySelector('#schEnds').value === 'on';
            el.querySelector('#schUntilField').hidden = !on;
            if (on && !el.querySelector('#schUntil').value) el.querySelector('#schUntil').value = (0, $lDSCx.addDays)(monday, 34);
            update();
        });
        el.querySelectorAll('.sch-day').forEach((b)=>b.addEventListener('click', ()=>{
                // A single one-off being edited moves between days; otherwise days toggle.
                if (editing && !series && !repeatOn()) el.querySelectorAll('.sch-day').forEach((x)=>setDay(x, x === b));
                else {
                    const on = !b.classList.contains('sch-day--on');
                    if (!on && el.querySelectorAll('.sch-day--on').length === 1) return; // keep at least one
                    setDay(b, on);
                }
                update();
            }));
        el.querySelectorAll('[data-preset]').forEach((p)=>p.addEventListener('click', ()=>{
                const pick = {
                    weekdays: [
                        0,
                        1,
                        2,
                        3,
                        4
                    ],
                    weekends: [
                        5,
                        6
                    ],
                    all: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6
                    ]
                }[p.dataset.preset];
                if (editing && !series && !repeatOn()) {
                    el.querySelector('#schRepeat').value = 'weekly';
                    el.querySelector('#schRepeat').dispatchEvent(new Event('input'));
                }
                el.querySelectorAll('.sch-day').forEach((b, i)=>setDay(b, pick.includes(i)));
                update();
            }));
        el.querySelector('.sch-dialog-close').addEventListener('click', ()=>this.closeDialog());
        el.querySelector('#schCancelShift').addEventListener('click', ()=>this.closeDialog());
        el.querySelectorAll('.sch-pick').forEach((b)=>b.addEventListener('click', ()=>{
                this._dialog.stationId = b.dataset.pick;
                el.querySelectorAll('.sch-pick').forEach((x)=>{
                    const on = x === b;
                    x.classList.toggle('sch-pick--on', on);
                    x.setAttribute('aria-checked', String(on));
                });
            }));
        el.querySelector('#schSaveShift').addEventListener('click', ()=>this._submitDialog());
        el.querySelector('#schDeleteShift')?.addEventListener('click', ()=>this._handlers.onDeleteShift?.(shift));
        el.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape') this.closeDialog();
            if (e.key === 'Enter' && e.target.matches('input:not([type="date"])')) {
                e.preventDefault();
                this._submitDialog();
            }
        });
        update();
        el.querySelector(editing ? '#schStart' : '#schWho').focus();
    }
    closeDialog() {
        this._dialog?.el.remove();
        this._dialog = null;
    }
    setDialogBusy(busy) {
        this._dialog?.el.querySelectorAll('button, select, input').forEach((b)=>{
            b.disabled = busy;
        });
    }
    // The form as plain values: { days[], startTime, endTime, hours, overnight, repeat, untilDate }.
    _readForm() {
        const el = this._dialog.el;
        const startTime = el.querySelector('#schStart').value;
        const endTime = el.querySelector('#schEnd').value;
        const days = [
            ...el.querySelectorAll('.sch-day--on')
        ].map((b)=>b.dataset.day);
        if (!startTime || !endTime || startTime === endTime || !days.length) return null;
        const tz = this._data.tz;
        const first = days[0];
        const startsAt = (0, $lDSCx.zonedToDate)(first, startTime, tz);
        const endsAt = (0, $lDSCx.zonedToDate)(endTime > startTime ? first : (0, $lDSCx.addDays)(first, 1), endTime, tz);
        const repeat = el.querySelector('#schRepeat').value === 'weekly';
        const untilDate = repeat && el.querySelector('#schEnds').value === 'on' ? el.querySelector('#schUntil').value || null : null;
        return {
            days: days,
            startTime: startTime,
            endTime: endTime,
            hours: (0, $lDSCx.hoursBetween)(startsAt, endsAt),
            overnight: endTime < startTime,
            repeat: repeat,
            untilDate: untilDate
        };
    }
    _updateDialogInfo() {
        const el = this._dialog.el;
        const info = el.querySelector('#schDialogInfo');
        const f = this._readForm();
        if (!f) {
            info.innerHTML = `<p class="sch-info">Pick at least one day and a start and end time.</p>`;
            return;
        }
        const tz = this._data.tz;
        const who = el.querySelector('#schWho').value;
        const { shift: shift, series: series } = this._dialog;
        // This shift (and, for a repeat, its siblings this week) are what we're replacing.
        const others = this._data.shifts.filter((s)=>who && s.staffId === who && s.id !== shift.id && !(series && s.seriesId === series.id));
        const weekH = others.reduce((h, s)=>h + (0, $lDSCx.hoursBetween)(s.startsAt, s.endsAt), 0) + f.hours * f.days.length;
        const person = this._data.staff.find((s)=>s.id === who);
        const first = person ? $27809bb01dc8a27e$var$staffName(person).split(' ')[0] : '';
        // "every day except Wed" reads better than listing six days (Kelly, 2026-10-15).
        const picked = f.days.map((0, $lDSCx.weekdayIndex));
        const missing = (0, $lDSCx.WEEKDAYS).filter((_, i)=>!picked.includes(i));
        const isWeekdays = picked.length === 5 && missing.join() === 'Sat,Sun';
        const isWeekends = picked.length === 2 && picked.includes(5) && picked.includes(6);
        const dayNames = picked.length === 7 ? 'day' : isWeekdays ? 'weekday' : isWeekends ? 'weekend day' : picked.length >= 5 ? `day except ${missing.join(' and ')}` : f.days.map((d)=>(0, $lDSCx.WEEKDAYS)[(0, $lDSCx.weekdayIndex)(d)]).join(', ');
        const what = f.repeat ? `Repeats every ${dayNames} \xb7 ${f.untilDate ? `until ${(0, $lDSCx.dayLabel)(f.untilDate)}` : 'no end date'}` : f.days.length > 1 ? `${f.days.length} shifts this week (every ${dayNames})` : '';
        const lines = [
            `<p class="sch-info">${(0, $lDSCx.fmtHours)(f.hours)} each${f.overnight ? " \xb7 ends the next day" : ''}${who ? ` \xb7 ${(0, $cnCXJ.esc)(first)} at ${(0, $lDSCx.fmtHours)(weekH)} this week` : ''}</p>`
        ];
        if (what) lines.push(`<p class="sch-info sch-info--strong">${what}</p>`);
        const clash = f.days.map((d)=>{
            const s0 = (0, $lDSCx.zonedToDate)(d, f.startTime, tz), e0 = (0, $lDSCx.zonedToDate)(f.endTime > f.startTime ? d : (0, $lDSCx.addDays)(d, 1), f.endTime, tz);
            return others.find((s)=>new Date(s.startsAt) < e0 && new Date(s.endsAt) > s0);
        }).find(Boolean);
        if (clash) lines.push(`<p class="sch-warn">\u{26A0}\u{FE0F} Overlaps ${(0, $cnCXJ.esc)(first)}'s ${(0, $lDSCx.dayLabel)(this._dayOf(clash.startsAt))} ${(0, $lDSCx.shortTime)(new Date(clash.startsAt), tz)}\u{2013}${(0, $lDSCx.shortTime)(new Date(clash.endsAt), tz)} shift.</p>`);
        if (who && weekH > $27809bb01dc8a27e$var$OVERTIME_HOURS) lines.push(`<p class="sch-warn">\u{26A0}\u{FE0F} This puts ${(0, $cnCXJ.esc)(first)} over ${$27809bb01dc8a27e$var$OVERTIME_HOURS} hours this week.</p>`);
        // Leave + availability (phase 2): one line per distinct problem.
        if (who) {
            const seen = new Set();
            f.days.forEach((d)=>{
                const c = this._conflict(who, d, f.startTime, f.endTime);
                if (!c || seen.has(c.text)) return;
                seen.add(c.text);
                lines.push(`<p class="${c.kind === 'pending' ? 'sch-info sch-info--strong' : 'sch-warn'}">${c.kind === 'pending' ? "\u2139\uFE0F" : "\u26A0\uFE0F"} ${(0, $cnCXJ.esc)(c.text)}</p>`);
            });
        }
        info.innerHTML = lines.join('');
    }
    _submitDialog() {
        const el = this._dialog.el;
        const f = this._readForm();
        if (!f) {
            el.querySelector('#schEnd').focus();
            return;
        }
        if (f.repeat && el.querySelector('#schEnds').value === 'on' && !f.untilDate) {
            el.querySelector('#schUntil').focus();
            return;
        }
        this._lastTimes = {
            start: f.startTime,
            end: f.endTime
        };
        this._lastStation = this._dialog.stationId || null;
        this._handlers.onSaveShift?.({
            shift: this._dialog.shift.id ? this._dialog.shift : null,
            staffId: el.querySelector('#schWho').value || null,
            stationId: this._dialog.stationId || null,
            days: f.days,
            weekdays: f.days.map((0, $lDSCx.weekdayIndex)),
            startTime: f.startTime,
            endTime: f.endTime,
            repeat: f.repeat,
            untilDate: f.untilDate,
            note: el.querySelector('#schNote').value
        });
    }
    // ── "Which shifts?" chooser (repeats, publishing) ────────────────────────────
    // options: [{ value, label, hint }]; checkbox: { label, showFor: [values] } (optional).
    // Resolves { value, checked } or null when cancelled.
    askChoice({ title: title, body: body = '', options: options, checkbox: checkbox = null, confirmLabel: confirmLabel = 'OK', danger: danger = false }) {
        return new Promise((resolve)=>{
            const el = document.createElement('div');
            el.className = 'modal-backdrop sch-dialog-backdrop sch-choice-backdrop';
            el.innerHTML = `
        <div class="sch-dialog sch-choice" role="dialog" aria-modal="true" aria-labelledby="schChoiceTitle">
          <div class="sch-dialog-head">
            <h3 id="schChoiceTitle">${(0, $cnCXJ.esc)(title)}</h3>
            <button type="button" class="modal-close sch-dialog-close" aria-label="Close">&times;</button>
          </div>
          ${body ? `<p class="sch-choice-body">${body}</p>` : ''}
          <div class="sch-choice-list" role="radiogroup">
            ${options.map((o, i)=>`
              <label class="sch-choice-opt">
                <input type="radio" name="schChoice" value="${(0, $cnCXJ.esc)(o.value)}"${i === 0 ? ' checked' : ''} />
                <span><b>${(0, $cnCXJ.esc)(o.label)}</b>${o.hint ? `<small>${(0, $cnCXJ.esc)(o.hint)}</small>` : ''}</span>
              </label>`).join('')}
          </div>
          ${checkbox ? `<label class="sch-choice-check" id="schChoiceCheck"><input type="checkbox" id="schChoiceBox" /><span>${(0, $cnCXJ.esc)(checkbox.label)}</span></label>` : ''}
          <div class="sch-dialog-actions">
            <span class="sch-spacer"></span>
            <button type="button" class="sch-btn" data-choice-cancel>Cancel</button>
            <button type="button" class="sch-btn ${danger ? 'sch-btn--danger-solid' : 'sch-btn--primary'}" data-choice-ok>${(0, $cnCXJ.esc)(confirmLabel)}</button>
          </div>
        </div>`;
            document.body.appendChild(el);
            const done = (v)=>{
                el.remove();
                resolve(v);
            };
            const sel = ()=>el.querySelector('input[name="schChoice"]:checked')?.value;
            const syncCheck = ()=>{
                const c = el.querySelector('#schChoiceCheck');
                if (c) c.hidden = !(checkbox.showFor ?? []).includes(sel());
            };
            el.querySelectorAll('input[name="schChoice"]').forEach((r)=>r.addEventListener('change', syncCheck));
            syncCheck();
            el.querySelector('.sch-dialog-close').addEventListener('click', ()=>done(null));
            el.querySelector('[data-choice-cancel]').addEventListener('click', ()=>done(null));
            el.querySelector('[data-choice-ok]').addEventListener('click', ()=>{
                const box = el.querySelector('#schChoiceBox');
                done({
                    value: sel(),
                    checked: !!(box && !el.querySelector('#schChoiceCheck').hidden && box.checked)
                });
            });
            el.addEventListener('keydown', (e)=>{
                if (e.key === 'Escape') done(null);
            });
            el.querySelector('[data-choice-ok]').focus();
        });
    }
    // ── Requests (phase 3): swaps + open-shift pickups ───────────────────────────
    // Staff file them on the Time Clock. A swap waits for the teammate first, then
    // lands here; approving moves the shift(s) (review_shift_request RPC).
    _renderRequests() {
        const { tz: tz } = this._data;
        const reqs = this._data.requests ?? [];
        const now = new Date();
        const pending = reqs.filter((r)=>r.status === 'pending');
        const waiting = reqs.filter((r)=>r.status === 'waiting_teammate');
        const closed = reqs.filter((r)=>r.status !== 'pending' && r.status !== 'waiting_teammate');
        const name = (id, fallback)=>{
            const p = this._person(id);
            return p ? $27809bb01dc8a27e$var$staffName(p) : fallback || 'Former staff';
        };
        const first = (id, fallback)=>name(id, fallback).split(' ')[0];
        const kindOf = (r)=>r.kind === 'pickup' ? {
                label: 'Open shift',
                c: '#2563EB'
            } : r.targetShiftId ? {
                label: 'Trade',
                c: '#7C3AED'
            } : {
                label: 'Cover',
                c: '#0E9384'
            };
        const ago = (iso)=>{
            const m = Math.max(0, Math.round((now - new Date(iso)) / 60000));
            return m < 60 ? `${m || 1}m ago` : m < 1440 ? `${Math.round(m / 60)}h ago` : `${Math.round(m / 1440)}d ago`;
        };
        // One shift moving to its new owner.
        const move = (sh, toId, toName)=>{
            if (!sh) return '<div class="sch-req-shift sch-req-shift--gone">This shift was removed</div>';
            const st = this._station(sh.stationId);
            return `<div class="sch-req-shift" style="--sc:${st?.color ?? $27809bb01dc8a27e$var$NO_STATION_COLOR}">
        <b>${(0, $cnCXJ.esc)((0, $lDSCx.dayLabel)(this._dayOf(sh.startsAt)))} \xb7 ${(0, $lDSCx.shortTime)(new Date(sh.startsAt), tz)}\u{2013}${(0, $lDSCx.shortTime)(new Date(sh.endsAt), tz)}</b>
        <span>${(0, $cnCXJ.esc)(st?.name ?? 'No station')} \xb7 ${(0, $lDSCx.fmtHours)((0, $lDSCx.hoursBetween)(sh.startsAt, sh.endsAt))}</span>
        <em>${sh.staffId ? `${(0, $cnCXJ.esc)(first(sh.staffId))} \u{2192} ` : "Open \u2192 "}${(0, $cnCXJ.esc)(first(toId, toName))}</em>
      </div>`;
        };
        const warnings = (r)=>{
            const out = [];
            const check = (sh, who)=>{
                if (!sh || !who) return;
                const c = this._conflict(who, this._dayOf(sh.startsAt), (0, $lDSCx.zonedParts)(new Date(sh.startsAt), tz).timeStr, (0, $lDSCx.zonedParts)(new Date(sh.endsAt), tz).timeStr);
                if (c) out.push(c);
            };
            check(r.shift, r.kind === 'pickup' ? r.requesterId : r.targetId);
            if (r.targetShift) check(r.targetShift, r.requesterId);
            if (r.kind === 'pickup') {
                const others = pending.filter((x)=>x.shiftId === r.shiftId && x.id !== r.id).length;
                if (others) out.push({
                    kind: 'pending',
                    text: `${others + 1} people asked for this shift. Approving one closes the others.`
                });
            }
            return out.map((c)=>`<p class="${c.kind === 'pending' ? 'sch-info' : 'sch-warn'}">${c.kind === 'pending' ? "\u2139\uFE0F" : "\u26A0\uFE0F"} ${(0, $cnCXJ.esc)(c.text)}</p>`).join('');
        };
        const title = (r)=>{
            const a = `<b>${(0, $cnCXJ.esc)(name(r.requesterId, r.requesterName))}</b>`, b = `<b>${(0, $cnCXJ.esc)(name(r.targetId, r.targetName))}</b>`;
            if (r.kind === 'pickup') return `${a} wants to pick up this open shift`;
            return r.targetShiftId ? `${a} and ${b} want to trade shifts` : `${a} asked ${b} to cover a shift`;
        };
        const card = (r, withActions)=>{
            const k = kindOf(r);
            const started = r.shift && new Date(r.shift.startsAt) <= now;
            const sub = r.kind === 'swap' ? r.status === 'pending' ? `${(0, $cnCXJ.esc)(first(r.targetId, r.targetName))} said yes` : `Waiting for ${(0, $cnCXJ.esc)(first(r.targetId, r.targetName))} to answer` : '';
            return `<article class="sch-req" style="--rc:${k.c}">
        <div class="sch-req-head">
          <span class="sch-req-kind">${k.label}</span>
          ${sub ? `<span class="sch-req-sub">${sub}</span>` : ''}
          <span class="sch-req-age">${ago(r.createdAt)}</span>
        </div>
        <p class="sch-req-title">${title(r)}</p>
        <div class="sch-req-shifts">
          ${move(r.shift, r.kind === 'pickup' ? r.requesterId : r.targetId, r.kind === 'pickup' ? r.requesterName : r.targetName)}
          ${r.targetShiftId ? move(r.targetShift, r.requesterId, r.requesterName) : ''}
        </div>
        ${r.note ? `<p class="sch-req-note">\u{201C}${(0, $cnCXJ.esc)(r.note)}\u{201D}</p>` : ''}
        ${withActions ? warnings(r) : ''}
        ${withActions ? `<div class="sch-req-actions">
          ${started ? '<span class="sch-req-expired">This shift already started</span>' : ''}
          <span class="sch-spacer"></span>
          <button type="button" class="sch-btn" data-review="reject" data-req="${(0, $cnCXJ.esc)(r.id)}">Decline</button>
          <button type="button" class="sch-btn sch-btn--primary" data-review="approve" data-req="${(0, $cnCXJ.esc)(r.id)}"${started ? ' disabled' : ''}>Approve</button>
        </div>` : ''}
      </article>`;
        };
        const STATUS = {
            approved: [
                'Approved',
                'live'
            ],
            rejected: [
                'Declined by a manager',
                'no'
            ],
            declined: [
                'Teammate said no',
                'no'
            ],
            cancelled: [
                'Cancelled',
                'muted'
            ]
        };
        const historyRow = (r)=>{
            const [label, tone] = STATUS[r.status] ?? [
                r.status,
                'muted'
            ];
            const sh = r.shift;
            const by = r.status === 'approved' || r.status === 'rejected' ? r.reviewedByName ? ` by ${(0, $cnCXJ.esc)(r.reviewedByName)}` : '' : '';
            return `<div class="sch-req-row">
        <span class="sch-req-dot" style="--rc:${kindOf(r).c}"></span>
        <span class="sch-req-row-main"><b>${(0, $cnCXJ.esc)(kindOf(r).label)}</b> \xb7 ${(0, $cnCXJ.esc)(first(r.requesterId, r.requesterName))}${r.kind === 'swap' ? ` \u{2192} ${(0, $cnCXJ.esc)(first(r.targetId, r.targetName))}` : ''}
          <small>${sh ? `${(0, $cnCXJ.esc)((0, $lDSCx.dayLabel)(this._dayOf(sh.startsAt)))} ${(0, $lDSCx.shortTime)(new Date(sh.startsAt), tz)}\u{2013}${(0, $lDSCx.shortTime)(new Date(sh.endsAt), tz)}` : 'Shift removed'}${r.reviewNote ? ` \xb7 ${(0, $cnCXJ.esc)(r.reviewNote)}` : ''}</small></span>
        <span class="sch-req-pill sch-req-pill--${tone}">${label}${r.status === 'approved' ? by : ''}</span>
      </div>`;
        };
        this._content.innerHTML = `
      <div class="sch-reqs">
        <div class="sch-stations-head">
          <h3>Requests</h3>
          <p>Your team asks to pick up open shifts or swap with each other on the Time Clock. A swap comes here once the teammate says yes. Nothing changes on the schedule until you approve.</p>
        </div>
        <section class="sch-req-group">
          <h4>Needs your OK <span class="sch-req-count">${pending.length}</span></h4>
          ${pending.length ? pending.map((r)=>card(r, true)).join('') : '<p class="sch-empty sch-req-empty">Nothing to approve right now.</p>'}
        </section>
        ${waiting.length ? `<section class="sch-req-group">
          <h4>Waiting on a teammate <span class="sch-req-count">${waiting.length}</span></h4>
          ${waiting.map((r)=>card(r, false)).join('')}
        </section>` : ''}
        ${closed.length ? `<details class="sch-req-history">
          <summary>Recent <span class="sch-req-count">${closed.length}</span></summary>
          ${closed.map(historyRow).join('')}
        </details>` : ''}
      </div>`;
    }
    // ── Availability (phase 2) ───────────────────────────────────────────────────
    _availRow(staffId) {
        return [
            ...Array(7)
        ].map((_, i)=>this._data.availability.find((a)=>a.staffId === staffId && a.weekday === i) ?? {
                staffId: staffId,
                weekday: i,
                status: 'available',
                startTime: '',
                endTime: '',
                note: ''
            });
    }
    _renderAvailability() {
        const people = this._data.staff.filter((s)=>s.isActive !== false);
        const pill = (a)=>{
            const note = a.note ? ` title="${(0, $cnCXJ.esc)(a.note)}"` : '';
            if (a.status === 'unavailable') return `<span class="sch-av-pill sch-av-pill--off"${note}>Off${a.note ? " \uD83D\uDCDD" : ''}</span>`;
            if (a.status === 'partial') return `<span class="sch-av-pill sch-av-pill--part"${note}>${(0, $lDSCx.clockShort)(a.startTime)}\u{2013}${(0, $lDSCx.clockShort)(a.endTime)}${a.note ? " \uD83D\uDCDD" : ''}</span>`;
            return `<span class="sch-av-pill"${note}>All day</span>`;
        };
        this._content.innerHTML = `
      <div class="sch-avail">
        <div class="sch-stations-head">
          <h3>Availability</h3>
          <p>When each person can work, week to week. Your team sets their own on the Time Clock (My availability), and you can change anyone's here. The schedule shows it on the grid and warns you when a shift doesn't fit.</p>
        </div>
        <div class="sch-grid-wrap"><div class="sch-avgrid">
          <div class="sch-gh sch-gh--team">Team</div>
          ${(0, $lDSCx.WEEKDAYS).map((d)=>`<div class="sch-gh">${d}</div>`).join('')}
          <div class="sch-gh"></div>
          ${people.map((s, i)=>{
            const n = $27809bb01dc8a27e$var$staffName(s);
            return `<div class="sch-who">
                <span class="sch-av" style="--ac:${$27809bb01dc8a27e$var$AVATAR_COLORS[i % $27809bb01dc8a27e$var$AVATAR_COLORS.length]}">${(0, $cnCXJ.esc)($27809bb01dc8a27e$var$initials(n))}</span>
                <span class="sch-who-text"><b>${(0, $cnCXJ.esc)(n)}</b><span>${(0, $cnCXJ.esc)(s.role ?? '')}</span></span>
              </div>${this._availRow(s.id).map((a)=>`<div class="sch-av-cell">${pill(a)}</div>`).join('')}
              <div class="sch-av-cell sch-av-cell--edit"><button type="button" class="sch-btn sch-btn--ghost" data-avail-edit="${(0, $cnCXJ.esc)(s.id)}" aria-label="Edit ${(0, $cnCXJ.esc)(n)}'s availability">Edit</button></div>`;
        }).join('') || '<p class="sch-empty">No team members yet.</p>'}
        </div></div>
      </div>`;
    }
    openAvailabilityDialog(staffId) {
        this.closeDialog();
        const person = this._person(staffId);
        if (!person) return;
        const rows = this._availRow(staffId);
        const el = document.createElement('div');
        el.className = 'modal-backdrop sch-dialog-backdrop';
        el.id = 'schDialog';
        el.innerHTML = `
      <div class="sch-dialog sch-dialog--wide" role="dialog" aria-modal="true" aria-labelledby="schAvTitle">
        <div class="sch-dialog-head">
          <h3 id="schAvTitle">${(0, $cnCXJ.esc)($27809bb01dc8a27e$var$staffName(person))}'s availability</h3>
          <button type="button" class="modal-close sch-dialog-close" aria-label="Close">&times;</button>
        </div>
        <p class="sch-choice-body">Repeats every week. Days left on "All day" are open for any shift.</p>
        <div class="sch-av-edit">
          ${rows.map((a)=>`
            <div class="sch-av-edit-row" data-wd="${a.weekday}">
              <b>${(0, $lDSCx.WEEKDAYS)[a.weekday]}</b>
              <div class="sch-seg" role="radiogroup" aria-label="${(0, $lDSCx.WEEKDAYS)[a.weekday]}">
                ${[
                [
                    'available',
                    'All day'
                ],
                [
                    'partial',
                    'Some hours'
                ],
                [
                    'unavailable',
                    'Off'
                ]
            ].map(([v, l])=>`
                  <button type="button" role="radio" class="sch-seg-btn${a.status === v ? ' sch-seg-btn--on' : ''}" data-st="${v}" aria-checked="${a.status === v}">${l}</button>`).join('')}
              </div>
              <span class="sch-av-times"${a.status === 'partial' ? '' : ' hidden'}>
                <input type="time" data-f="start" value="${a.startTime || '09:00'}" aria-label="From" />
                <span>to</span>
                <input type="time" data-f="end" value="${a.endTime || '17:00'}" aria-label="To" />
              </span>
              <input type="text" class="sch-av-note" data-f="note" maxlength="120" placeholder="Note (optional)" value="${(0, $cnCXJ.esc)(a.note)}" aria-label="Note for ${(0, $lDSCx.WEEKDAYS)[a.weekday]}" />
            </div>`).join('')}
        </div>
        <div class="sch-dialog-actions">
          <span class="sch-spacer"></span>
          <button type="button" class="sch-btn" id="schAvCancel">Cancel</button>
          <button type="button" class="sch-btn sch-btn--primary" id="schAvSave">Save</button>
        </div>
      </div>`;
        document.body.appendChild(el);
        this._dialog = {
            el: el,
            shift: {}
        };
        el.querySelectorAll('.sch-seg-btn').forEach((b)=>b.addEventListener('click', ()=>{
                const row = b.closest('.sch-av-edit-row');
                row.querySelectorAll('.sch-seg-btn').forEach((x)=>{
                    x.classList.toggle('sch-seg-btn--on', x === b);
                    x.setAttribute('aria-checked', String(x === b));
                });
                row.querySelector('.sch-av-times').hidden = b.dataset.st !== 'partial';
            }));
        const close = ()=>this.closeDialog();
        el.querySelector('.sch-dialog-close').addEventListener('click', close);
        el.querySelector('#schAvCancel').addEventListener('click', close);
        el.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape') close();
        });
        el.querySelector('#schAvSave').addEventListener('click', ()=>{
            const days = [
                ...el.querySelectorAll('.sch-av-edit-row')
            ].map((row)=>({
                    weekday: Number(row.dataset.wd),
                    status: row.querySelector('.sch-seg-btn--on').dataset.st,
                    startTime: row.querySelector('[data-f="start"]').value,
                    endTime: row.querySelector('[data-f="end"]').value,
                    note: row.querySelector('[data-f="note"]').value.trim()
                }));
            const bad = days.find((d)=>d.status === 'partial' && (!d.startTime || !d.endTime || d.startTime === d.endTime));
            if (bad) {
                el.querySelector(`[data-wd="${bad.weekday}"] [data-f="start"]`).focus();
                return;
            }
            this._handlers.onSaveAvailability?.(staffId, days.map((d)=>d.status === 'partial' ? d : {
                    ...d,
                    startTime: '',
                    endTime: ''
                }));
        });
    }
    // ── Stations ─────────────────────────────────────────────────────────────────
    _renderStations() {
        const active = this._data.stations.filter((s)=>!s.archived);
        this._content.innerHTML = `
      <div class="sch-stations">
        <div class="sch-stations-head">
          <h3>Stations</h3>
          <p>Label each shift with where the person works. Tap a color to change it. Removing a station keeps it on past shifts.</p>
        </div>
        <div class="sch-station-list">
          ${active.map((s)=>`
            <div class="sch-station-row" data-id="${(0, $cnCXJ.esc)(s.id)}">
              <button type="button" class="sch-swatch" data-swatch="${(0, $cnCXJ.esc)(s.id)}" style="--sc:${s.color}" aria-label="Change color of ${(0, $cnCXJ.esc)(s.name)}" title="Change color"></button>
              <input type="text" class="sch-station-name" data-name="${(0, $cnCXJ.esc)(s.id)}" value="${(0, $cnCXJ.esc)(s.name)}" maxlength="40" aria-label="Station name" />
              <button type="button" class="sch-station-remove" data-archive="${(0, $cnCXJ.esc)(s.id)}" aria-label="Remove ${(0, $cnCXJ.esc)(s.name)}" title="Remove">&times;</button>
            </div>`).join('') || '<p class="sch-empty">No stations yet. Add your first one below.</p>'}
        </div>
        <div class="sch-station-add">
          <input type="text" id="schNewStationName" maxlength="40" placeholder="New station, e.g. Drive-thru" aria-label="New station name" />
          <button type="button" class="sch-btn sch-btn--primary" id="schAddStation">Add station</button>
        </div>
      </div>`;
    }
    _addStationFromInput() {
        const input = this._content.querySelector('#schNewStationName');
        const name = input?.value.trim();
        if (!name) {
            input?.focus();
            return;
        }
        const used = this._data.stations.filter((s)=>!s.archived).map((s)=>s.color);
        const color = $27809bb01dc8a27e$export$49b726243aa707b7.find((c)=>!used.includes(c)) ?? $27809bb01dc8a27e$export$49b726243aa707b7[used.length % $27809bb01dc8a27e$export$49b726243aa707b7.length];
        this._handlers.onAddStation?.({
            name: name,
            color: color
        });
    }
    // ── Delegated content events ─────────────────────────────────────────────────
    _onContentClick(e) {
        const t = e.target;
        const week = t.closest('[data-week]');
        if (week) return this._handlers.onWeek?.(Number(week.dataset.week));
        const shiftBtn = t.closest('[data-shift]');
        if (shiftBtn) {
            const sh = this._data.shifts.find((s)=>s.id === shiftBtn.dataset.shift);
            if (sh) this.openDialog(sh);
            return;
        }
        const add = t.closest('[data-add-day]');
        if (add) return this.openDialog({
            staffId: add.dataset.addStaff || null,
            day: add.dataset.addDay
        });
        const go = t.closest('[data-section-go]');
        if (go) {
            this._section = go.dataset.sectionGo;
            this.render(this._data);
            return this._handlers.onSection?.(this._section);
        }
        const review = t.closest('[data-review]');
        if (review) {
            const req = (this._data.requests ?? []).find((r)=>r.id === review.dataset.req);
            if (req) this._handlers.onReviewRequest?.(req, review.dataset.review);
            return;
        }
        const avEdit = t.closest('[data-avail-edit]');
        if (avEdit) return this.openAvailabilityDialog(avEdit.dataset.availEdit);
        if (t.closest('#schCopyBtn')) return this._handlers.onCopyLastWeek?.();
        if (t.closest('#schPublishBtn')) return this._handlers.onPublish?.();
        if (t.closest('#schAddStation')) return this._addStationFromInput();
        const sw = t.closest('[data-swatch]');
        if (sw) {
            const st = this._station(sw.dataset.swatch);
            const next = $27809bb01dc8a27e$export$49b726243aa707b7[($27809bb01dc8a27e$export$49b726243aa707b7.indexOf(st.color) + 1) % $27809bb01dc8a27e$export$49b726243aa707b7.length];
            sw.style.setProperty('--sc', next);
            return this._handlers.onUpdateStation?.(st.id, {
                color: next
            });
        }
        const arch = t.closest('[data-archive]');
        if (arch) return this._handlers.onArchiveStation?.(arch.dataset.archive);
    }
    _onContentChange(e) {
        const input = e.target.closest('[data-name]');
        if (!input) return;
        const st = this._station(input.dataset.name);
        const name = input.value.trim();
        if (!name) {
            input.value = st.name;
            return;
        }
        if (name !== st.name) this._handlers.onUpdateStation?.(st.id, {
            name: name
        });
    }
}
var $27809bb01dc8a27e$export$2e2bcd8739ae039 = new $27809bb01dc8a27e$var$ScheduleView();



var $lDSCx = parcelRequire("lDSCx");

var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");
// One shared, self-creating image viewer for any "view this photo" link in the
// app (currently: purchase order receipts). Mirrors tooltip.js's pattern - a
// single element lazily appended to <body> on first use, self-initializing.
// Reuses .modal-backdrop so Javascript/modalBackdrop.js's global click-outside
// -to-close and its blur/dim styling apply for free; .pb-lightbox-close is
// registered there as a recognized close control.
//
// Zoom: buttons, mouse wheel, and touch pinch (via the unified Pointer Events
// API, so mouse-drag-to-pan and touch-pinch-to-zoom share one code path).
// Fullscreen uses the standard Fullscreen API, feature-detected - the button
// hides itself on browsers/platforms that don't support it (e.g. iOS Safari)
// rather than throwing.
const $b7dfaa8509a8211e$var$MIN_SCALE = 1;
const $b7dfaa8509a8211e$var$MAX_SCALE = 5;
let $b7dfaa8509a8211e$var$backdrop = null;
let $b7dfaa8509a8211e$var$stage = null;
let $b7dfaa8509a8211e$var$img = null;
let $b7dfaa8509a8211e$var$zoomLabel = null;
let $b7dfaa8509a8211e$var$fullscreenBtn = null;
let $b7dfaa8509a8211e$var$scale = 1;
let $b7dfaa8509a8211e$var$translateX = 0;
let $b7dfaa8509a8211e$var$translateY = 0;
const $b7dfaa8509a8211e$var$pointers = new Map();
let $b7dfaa8509a8211e$var$panStart = null;
let $b7dfaa8509a8211e$var$pinchStartDist = 0;
let $b7dfaa8509a8211e$var$pinchStartScale = 1;
let $b7dfaa8509a8211e$var$tapCandidate = null; // tracks a plain tap/click on the empty stage (not the image) to close
const $b7dfaa8509a8211e$var$TAP_THRESHOLD = 6;
const $b7dfaa8509a8211e$var$dist = (a, b)=>Math.hypot(a.x - b.x, a.y - b.y);
const $b7dfaa8509a8211e$var$clamp = (n, min, max)=>Math.min(max, Math.max(min, n));
const $b7dfaa8509a8211e$var$clampTranslate = ()=>{
    const maxX = Math.max(0, ($b7dfaa8509a8211e$var$img.offsetWidth * $b7dfaa8509a8211e$var$scale - $b7dfaa8509a8211e$var$stage.clientWidth) / 2);
    const maxY = Math.max(0, ($b7dfaa8509a8211e$var$img.offsetHeight * $b7dfaa8509a8211e$var$scale - $b7dfaa8509a8211e$var$stage.clientHeight) / 2);
    $b7dfaa8509a8211e$var$translateX = $b7dfaa8509a8211e$var$clamp($b7dfaa8509a8211e$var$translateX, -maxX, maxX);
    $b7dfaa8509a8211e$var$translateY = $b7dfaa8509a8211e$var$clamp($b7dfaa8509a8211e$var$translateY, -maxY, maxY);
};
const $b7dfaa8509a8211e$var$applyTransform = ()=>{
    $b7dfaa8509a8211e$var$clampTranslate();
    $b7dfaa8509a8211e$var$img.style.transform = `translate(${$b7dfaa8509a8211e$var$translateX}px, ${$b7dfaa8509a8211e$var$translateY}px) scale(${$b7dfaa8509a8211e$var$scale})`;
    $b7dfaa8509a8211e$var$zoomLabel.textContent = `${Math.round($b7dfaa8509a8211e$var$scale * 100)}%`;
    $b7dfaa8509a8211e$var$stage.classList.toggle("pb-lightbox-stage--zoomed", $b7dfaa8509a8211e$var$scale > 1);
};
const $b7dfaa8509a8211e$var$setScale = (next)=>{
    $b7dfaa8509a8211e$var$scale = $b7dfaa8509a8211e$var$clamp(next, $b7dfaa8509a8211e$var$MIN_SCALE, $b7dfaa8509a8211e$var$MAX_SCALE);
    if ($b7dfaa8509a8211e$var$scale === $b7dfaa8509a8211e$var$MIN_SCALE) {
        $b7dfaa8509a8211e$var$translateX = 0;
        $b7dfaa8509a8211e$var$translateY = 0;
    }
    $b7dfaa8509a8211e$var$applyTransform();
};
const $b7dfaa8509a8211e$var$resetZoom = ()=>{
    $b7dfaa8509a8211e$var$scale = 1;
    $b7dfaa8509a8211e$var$translateX = 0;
    $b7dfaa8509a8211e$var$translateY = 0;
    $b7dfaa8509a8211e$var$applyTransform();
};
const $b7dfaa8509a8211e$var$ensureEl = ()=>{
    if ($b7dfaa8509a8211e$var$backdrop) return;
    $b7dfaa8509a8211e$var$backdrop = document.createElement("div");
    $b7dfaa8509a8211e$var$backdrop.className = "modal-backdrop pb-lightbox-backdrop hidden";
    $b7dfaa8509a8211e$var$backdrop.innerHTML = `
    <div class="pb-lightbox-toolbar">
      <span class="pb-lightbox-zoom-label">100%</span>
      <button class="pb-lightbox-tool" data-act="zoom-out" type="button" aria-label="Zoom out">&minus;</button>
      <button class="pb-lightbox-tool" data-act="zoom-in" type="button" aria-label="Zoom in">+</button>
      <button class="pb-lightbox-tool" data-act="reset" type="button" aria-label="Reset zoom">Reset</button>
      <button class="pb-lightbox-tool" data-act="fullscreen" type="button" aria-label="Toggle fullscreen">&#x26F6;</button>
      <button class="pb-lightbox-close" type="button" aria-label="Close">&times;</button>
    </div>
    <div class="pb-lightbox-stage">
      <img class="pb-lightbox-img" alt="" draggable="false" />
      <p class="pb-lightbox-error hidden">Couldn't load this image.</p>
    </div>
  `;
    document.body.appendChild($b7dfaa8509a8211e$var$backdrop);
    $b7dfaa8509a8211e$var$stage = $b7dfaa8509a8211e$var$backdrop.querySelector(".pb-lightbox-stage");
    $b7dfaa8509a8211e$var$img = $b7dfaa8509a8211e$var$backdrop.querySelector(".pb-lightbox-img");
    $b7dfaa8509a8211e$var$zoomLabel = $b7dfaa8509a8211e$var$backdrop.querySelector(".pb-lightbox-zoom-label");
    $b7dfaa8509a8211e$var$fullscreenBtn = $b7dfaa8509a8211e$var$backdrop.querySelector('[data-act="fullscreen"]');
    const errorMsg = $b7dfaa8509a8211e$var$backdrop.querySelector(".pb-lightbox-error");
    if (!document.fullscreenEnabled) $b7dfaa8509a8211e$var$fullscreenBtn.classList.add("hidden");
    $b7dfaa8509a8211e$var$img.addEventListener("load", ()=>{
        errorMsg.classList.add("hidden");
        $b7dfaa8509a8211e$var$img.classList.remove("hidden");
    });
    $b7dfaa8509a8211e$var$img.addEventListener("error", ()=>{
        errorMsg.classList.remove("hidden");
        $b7dfaa8509a8211e$var$img.classList.add("hidden");
    });
    $b7dfaa8509a8211e$var$backdrop.querySelector(".pb-lightbox-close").addEventListener("click", $b7dfaa8509a8211e$var$close);
    $b7dfaa8509a8211e$var$backdrop.querySelector('[data-act="zoom-in"]').addEventListener("click", ()=>$b7dfaa8509a8211e$var$setScale($b7dfaa8509a8211e$var$scale * 1.4));
    $b7dfaa8509a8211e$var$backdrop.querySelector('[data-act="zoom-out"]').addEventListener("click", ()=>$b7dfaa8509a8211e$var$setScale($b7dfaa8509a8211e$var$scale / 1.4));
    $b7dfaa8509a8211e$var$backdrop.querySelector('[data-act="reset"]').addEventListener("click", $b7dfaa8509a8211e$var$resetZoom);
    $b7dfaa8509a8211e$var$fullscreenBtn.addEventListener("click", ()=>{
        if (document.fullscreenElement === $b7dfaa8509a8211e$var$backdrop) document.exitFullscreen?.();
        else $b7dfaa8509a8211e$var$backdrop.requestFullscreen?.().catch(()=>{});
    });
    document.addEventListener("fullscreenchange", ()=>{
        $b7dfaa8509a8211e$var$fullscreenBtn?.classList.toggle("pb-lightbox-tool--active", document.fullscreenElement === $b7dfaa8509a8211e$var$backdrop);
    });
    $b7dfaa8509a8211e$var$img.addEventListener("dblclick", ()=>$b7dfaa8509a8211e$var$scale > 1 ? $b7dfaa8509a8211e$var$resetZoom() : $b7dfaa8509a8211e$var$setScale(2.5));
    $b7dfaa8509a8211e$var$stage.addEventListener("wheel", (e)=>{
        if ($b7dfaa8509a8211e$var$backdrop.classList.contains("hidden")) return;
        e.preventDefault();
        $b7dfaa8509a8211e$var$setScale($b7dfaa8509a8211e$var$scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15));
    }, {
        passive: false
    });
    $b7dfaa8509a8211e$var$stage.addEventListener("pointerdown", (e)=>{
        $b7dfaa8509a8211e$var$stage.setPointerCapture(e.pointerId);
        $b7dfaa8509a8211e$var$pointers.set(e.pointerId, {
            x: e.clientX,
            y: e.clientY
        });
        if ($b7dfaa8509a8211e$var$pointers.size === 2) {
            const [a, b] = [
                ...$b7dfaa8509a8211e$var$pointers.values()
            ];
            $b7dfaa8509a8211e$var$pinchStartDist = $b7dfaa8509a8211e$var$dist(a, b);
            $b7dfaa8509a8211e$var$pinchStartScale = $b7dfaa8509a8211e$var$scale;
            $b7dfaa8509a8211e$var$panStart = null;
            $b7dfaa8509a8211e$var$tapCandidate = null;
        } else if ($b7dfaa8509a8211e$var$pointers.size === 1) {
            $b7dfaa8509a8211e$var$panStart = {
                x: e.clientX,
                y: e.clientY,
                tx: $b7dfaa8509a8211e$var$translateX,
                ty: $b7dfaa8509a8211e$var$translateY
            };
            // A tap that lands on the bare stage (not the image) and never turns
            // into a drag closes the viewer - the stage fills the whole backdrop,
            // so modalBackdrop.js's generic "click the backdrop itself" check can
            // never see a direct hit here; this is the equivalent for this viewer.
            $b7dfaa8509a8211e$var$tapCandidate = {
                target: e.target,
                x: e.clientX,
                y: e.clientY
            };
        }
    });
    $b7dfaa8509a8211e$var$stage.addEventListener("pointermove", (e)=>{
        if (!$b7dfaa8509a8211e$var$pointers.has(e.pointerId)) return;
        $b7dfaa8509a8211e$var$pointers.set(e.pointerId, {
            x: e.clientX,
            y: e.clientY
        });
        if ($b7dfaa8509a8211e$var$pointers.size === 2) {
            const [a, b] = [
                ...$b7dfaa8509a8211e$var$pointers.values()
            ];
            if ($b7dfaa8509a8211e$var$pinchStartDist > 0) $b7dfaa8509a8211e$var$setScale($b7dfaa8509a8211e$var$pinchStartScale * ($b7dfaa8509a8211e$var$dist(a, b) / $b7dfaa8509a8211e$var$pinchStartDist));
        } else if ($b7dfaa8509a8211e$var$pointers.size === 1 && $b7dfaa8509a8211e$var$panStart && $b7dfaa8509a8211e$var$scale > 1) {
            $b7dfaa8509a8211e$var$translateX = $b7dfaa8509a8211e$var$panStart.tx + (e.clientX - $b7dfaa8509a8211e$var$panStart.x);
            $b7dfaa8509a8211e$var$translateY = $b7dfaa8509a8211e$var$panStart.ty + (e.clientY - $b7dfaa8509a8211e$var$panStart.y);
            $b7dfaa8509a8211e$var$applyTransform();
        }
        if ($b7dfaa8509a8211e$var$tapCandidate && $b7dfaa8509a8211e$var$dist($b7dfaa8509a8211e$var$tapCandidate, {
            x: e.clientX,
            y: e.clientY
        }) > $b7dfaa8509a8211e$var$TAP_THRESHOLD) $b7dfaa8509a8211e$var$tapCandidate = null;
    });
    const endPointer = (e)=>{
        $b7dfaa8509a8211e$var$pointers.delete(e.pointerId);
        $b7dfaa8509a8211e$var$pinchStartDist = 0;
        if ($b7dfaa8509a8211e$var$pointers.size === 0 && $b7dfaa8509a8211e$var$tapCandidate?.target === $b7dfaa8509a8211e$var$stage) $b7dfaa8509a8211e$var$close();
        $b7dfaa8509a8211e$var$tapCandidate = null;
        $b7dfaa8509a8211e$var$panStart = $b7dfaa8509a8211e$var$pointers.size === 1 ? {
            x: [
                ...$b7dfaa8509a8211e$var$pointers.values()
            ][0].x,
            y: [
                ...$b7dfaa8509a8211e$var$pointers.values()
            ][0].y,
            tx: $b7dfaa8509a8211e$var$translateX,
            ty: $b7dfaa8509a8211e$var$translateY
        } : null;
    };
    $b7dfaa8509a8211e$var$stage.addEventListener("pointerup", endPointer);
    $b7dfaa8509a8211e$var$stage.addEventListener("pointercancel", endPointer);
    document.addEventListener("keydown", (e)=>{
        if (e.key !== "Escape" || $b7dfaa8509a8211e$var$backdrop.classList.contains("hidden")) return;
        if (document.fullscreenElement === $b7dfaa8509a8211e$var$backdrop) return; // let the browser exit fullscreen first
        $b7dfaa8509a8211e$var$close();
    });
};
const $b7dfaa8509a8211e$var$close = ()=>{
    if (!$b7dfaa8509a8211e$var$backdrop) return;
    $b7dfaa8509a8211e$var$backdrop.classList.add("hidden");
    if (document.fullscreenElement === $b7dfaa8509a8211e$var$backdrop) document.exitFullscreen?.();
    $b7dfaa8509a8211e$var$pointers.clear();
    $b7dfaa8509a8211e$var$panStart = null;
};
const $b7dfaa8509a8211e$export$78f5d28b604adfe0 = function(url, altText = "") {
    if (!url) return;
    $b7dfaa8509a8211e$var$ensureEl();
    $b7dfaa8509a8211e$var$resetZoom();
    $b7dfaa8509a8211e$var$img.src = url;
    $b7dfaa8509a8211e$var$img.alt = altText;
    $b7dfaa8509a8211e$var$backdrop.classList.remove("hidden");
};




// Fabricated items for the free-plan locked preview - never real data, just
// enough to feed the real _itemRowHtml() renderer so the blurred table looks
// exactly like the real one. Same field shape as a real inventory item.
const $b0886db79b2df847$var$FAKE_ITEMS = [
    {
        id: 'fake-1',
        name: 'Espresso Beans - 2kg',
        sku: 'ESP-2KG',
        quantity: 34,
        unit: 'bag',
        lowStockThreshold: 10,
        unitCost: 18.5,
        supplierId: null,
        updatedAt: new Date().toISOString()
    },
    {
        id: 'fake-2',
        name: 'Oat Milk - 1L',
        sku: 'OAT-1L',
        quantity: 12,
        unit: 'carton',
        lowStockThreshold: 15,
        unitCost: 3.25,
        supplierId: null,
        updatedAt: new Date().toISOString()
    },
    {
        id: 'fake-3',
        name: 'Paper Cups (12oz)',
        sku: 'CUP-12',
        quantity: 210,
        unit: 'sleeve',
        lowStockThreshold: 50,
        unitCost: 6.1,
        supplierId: null,
        updatedAt: new Date().toISOString()
    },
    {
        id: 'fake-4',
        name: 'Vanilla Syrup',
        sku: 'SYR-VAN',
        quantity: 8,
        unit: 'bottle',
        lowStockThreshold: 6,
        unitCost: 9.75,
        supplierId: null,
        updatedAt: new Date().toISOString()
    },
    {
        id: 'fake-5',
        name: 'To-Go Lids',
        sku: 'LID-STD',
        quantity: 156,
        unit: 'sleeve',
        lowStockThreshold: 40,
        unitCost: 4.4,
        supplierId: null,
        updatedAt: new Date().toISOString()
    }
];
// Top-level Inventory panel - a full inventory management system (2026-07-17
// overhaul, mockup-driven): Items (table + detail drawer with "Used by"
// product links), Purchase Orders, Suppliers (strictly optional), Stock
// Counts, and History. Shares the Timesheets panel's structural shell
// (.ts-layout sidebar chrome); the content area is styled fresh per the UI
// quality bar. Vocabulary: product = thing sold, item/ingredient = inventory,
// stock = on-hand count.
// Quantities are plain numbers in the item's own unit - never money. Trim
// trailing zeros so "4000" doesn't render as "4000.00" but "2.5" survives.
const $b0886db79b2df847$var$fmtQty = (n)=>{
    const num = Number(n ?? 0);
    if (Number.isInteger(num)) return num.toLocaleString('en-US');
    return parseFloat(num.toFixed(3)).toLocaleString('en-US', {
        maximumFractionDigits: 3
    });
};
const $b0886db79b2df847$var$fmtTime = (iso)=>new Date(iso).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit'
    });
// Accepts a timestamp OR a calendar date. Calendar dates ('YYYY-MM-DD', e.g. a
// PO's expected_date - a Postgres `date`, no time or zone) must be read as that
// local day: new Date('2026-10-02') is midnight UTC, which shows as Oct 1
// anywhere west of UTC. Timestamps keep the normal UTC -> local display.
const $b0886db79b2df847$var$fmtDate = (iso)=>{
    if (!iso) return '-';
    const ymd = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    const d = ymd ? new Date(+ymd[1], +ymd[2] - 1, +ymd[3]) : new Date(iso);
    return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};
// Relative "Updated" label for table rows.
const $b0886db79b2df847$var$fmtRel = (iso)=>{
    if (!iso) return '-';
    const d = new Date(iso);
    const mins = Math.max(0, Math.floor((Date.now() - d) / 60000));
    if (mins < 1) return 'Just now';
    if (mins < 60) return `${mins}m ago`;
    if (mins < 1440 && d.toDateString() === new Date().toDateString()) return `Today, ${$b0886db79b2df847$var$fmtTime(iso)}`;
    if (d.toDateString() === new Date(Date.now() - 86400000).toDateString()) return `Yesterday, ${$b0886db79b2df847$var$fmtTime(iso)}`;
    return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
    });
};
// Displayed PO number: internal sequential integer -> "PO-001".
const $b0886db79b2df847$var$fmtPo = (n)=>`PO-${String(n ?? 0).padStart(3, '0')}`;
// Real units only (owner picks from a dropdown - free text invited typos like
// pc/pcs/pieces splitting the same unit). Most common first, then grouped.
const $b0886db79b2df847$var$UNIT_GROUPS = [
    [
        'Common',
        [
            'pc',
            'unit',
            'g',
            'kg',
            'ml',
            'L',
            'oz',
            'lb'
        ]
    ],
    [
        'Count',
        [
            'dozen',
            'pack',
            'box',
            'case',
            'bag',
            'bottle',
            'can',
            'jar',
            'tray',
            'roll',
            'sachet',
            'slice',
            'serving'
        ]
    ],
    [
        'Weight',
        [
            'mg'
        ]
    ],
    [
        'Volume',
        [
            'fl oz',
            'cup',
            'tbsp',
            'tsp',
            'pt',
            'qt',
            'gal'
        ]
    ]
];
const $b0886db79b2df847$var$ALL_UNITS = $b0886db79b2df847$var$UNIT_GROUPS.flatMap(([, units])=>units);
// <option> markup for the unit dropdown. A legacy free-text unit that is not
// in the canonical list stays selectable so existing items keep their value.
const $b0886db79b2df847$var$unitSelectOptions = (selected)=>{
    const current = (selected ?? '').trim();
    const legacy = current && !$b0886db79b2df847$var$ALL_UNITS.includes(current) ? `<option value="${(0, $cnCXJ.esc)(current)}" selected>${(0, $cnCXJ.esc)(current)} (current)</option>` : '';
    return legacy + $b0886db79b2df847$var$UNIT_GROUPS.map(([label, units])=>`
    <optgroup label="${label}">
      ${units.map((u)=>`<option value="${u}"${u === current ? ' selected' : ''}>${u}</option>`).join('')}
    </optgroup>`).join('');
};
const $b0886db79b2df847$var$TILE_COLORS = [
    '#22c55e',
    '#3b82f6',
    '#f59e0b',
    '#ec4899',
    '#8b5cf6',
    '#06b6d4'
];
const $b0886db79b2df847$var$tileColor = (name)=>{
    let hash = 0;
    for (const ch of name)hash = hash * 31 + ch.charCodeAt(0) & 0xffffffff;
    return $b0886db79b2df847$var$TILE_COLORS[Math.abs(hash) % $b0886db79b2df847$var$TILE_COLORS.length];
};
// Inventory tracking master toggle copy, shared by the render and the
// in-place patch on change.
const $b0886db79b2df847$var$INV_TOGGLE_COPY = {
    true: {
        icon: "\uD83C\uDF9A\uFE0F",
        label: 'On',
        sub: 'On: sales lower stock, alerts show on the order screen.'
    },
    false: {
        icon: "\u23F8\uFE0F",
        label: 'Off',
        sub: 'Off: sales do not lower stock and no alerts show anywhere. Your items and history are kept.'
    }
};
const $b0886db79b2df847$var$icons = {
    edit: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>`,
    trash: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>`,
    plusCircle: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>`,
    search: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>`,
    phone: `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>`,
    mail: `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>`
};
class $b0886db79b2df847$var$InventoryView {
    _panel = document.querySelector('#inventoryPanel');
    _sidebar = document.querySelector('#inventorySidebar');
    _content = document.querySelector('#inventoryContent');
    _drawer = document.querySelector('#inventoryDrawer');
    _scrim = document.querySelector('#inventoryDrawerScrim');
    _section = 'items';
    _locked = false;
    _query = '';
    _statusFilter = 'all';
    _itemSort = 'updated';
    _itemsPage = 1;
    _itemsPageSize = 25;
    _poQuery = '';
    _poStatusFilter = 'all';
    _poDateRange = 'all';
    _poDateFrom = '';
    _poDateTo = '';
    _poPage = 1;
    _poPageSize = 25;
    _supplierQuery = '';
    _countQuery = '';
    _countDraft = new Map();
    _historyTypeFilter = 'all';
    _historyDateRange = 'all';
    _historyDateFrom = '';
    _historyDateTo = '';
    _historyPage = 1;
    _historyPageSize = 30;
    _drawerCtx = null;
    _data = null;
    // Controller callbacks
    _adjustHandler = null;
    _newItemHandler = null;
    _editItemHandler = null;
    _deleteItemHandler = null;
    _historyFilterHandler = null;
    _addLinkHandler = null;
    _updateLinkHandler = null;
    _removeLinkHandler = null;
    _editProductHandler = null;
    _saveSupplierHandler = null;
    _deleteSupplierHandler = null;
    _createPoHandler = null;
    _updatePoHandler = null;
    _poStatusHandler = null;
    _receivePoHandler = null;
    _applyCountHandler = null;
    _toggleEnabledHandler = null;
    _addItemSupplierHandler = null;
    _preferSupplierHandler = null;
    _supplierCostHandler = null;
    _removeItemSupplierHandler = null;
    open() {
        this._panel.classList.remove('hidden', 'cashflow-exiting');
    }
    // Free-plan gate. The real sidebar nav stays visible (_renderSidebar reads
    // this._locked and re-renders this same locked teaser instead of switching
    // for real), but content is the SAME generic locked preview no matter which
    // tab is active - deliberately not customized per section (kept simple on
    // purpose). Real stat tiles stay live; the table below is fabricated
    // records through the real _itemRowHtml() renderer - never real data.
    renderLockedTeaser(data) {
        this._data = data;
        this._locked = true;
        this._renderSidebar();
        const items = data.items ?? [];
        const fakeTable = `
      <div class="inv-table">
        <div class="inv-thead">
          <span>Item</span><span>Supplier</span><span>On hand</span><span>Reorder point</span>
          <span>Status</span><span>Unit cost</span><span>Value</span><span>Updated</span>
        </div>
        ${$b0886db79b2df847$var$FAKE_ITEMS.map((item)=>this._itemRowHtml(item)).join('')}
      </div>`;
        this._content.innerHTML = `
      ${this._itemsStatsHtml(items, {
            actionable: false
        })}
      ${(0, $ad2a264c69d845ec$export$eef1d84709e6997f)('inventory', fakeTable)}`;
    }
    close() {
        this._closeNavDrawer();
        this._closeDetail();
        this._panel.classList.add('cashflow-exiting');
        setTimeout(()=>{
            this._panel.classList.add('hidden');
            this._panel.classList.remove('cashflow-exiting');
        }, 220);
    }
    // ── Mobile sidebar nav drawer (shared .panel-drawer-btn pattern) ────────────
    _openNavDrawer() {
        this._sidebar?.classList.add('panel-sidebar--open');
        this._panel.querySelector('#inventoryNavBackdrop')?.classList.add('panel-nav-backdrop--visible');
        this._panel.querySelector('#inventoryNavBtn')?.setAttribute('aria-expanded', 'true');
    }
    _closeNavDrawer() {
        this._sidebar?.classList.remove('panel-sidebar--open');
        this._panel.querySelector('#inventoryNavBackdrop')?.classList.remove('panel-nav-backdrop--visible');
        this._panel.querySelector('#inventoryNavBtn')?.setAttribute('aria-expanded', 'false');
    }
    _addHandlerDrawer() {
        const btn = this._panel.querySelector('#inventoryNavBtn');
        btn?.addEventListener('click', ()=>{
            if (btn.getAttribute('aria-expanded') === 'true') this._closeNavDrawer();
            else this._openNavDrawer();
        });
        this._panel.querySelector('#inventoryNavBackdrop')?.addEventListener('click', ()=>this._closeNavDrawer());
        // Detail drawer chrome: scrim click + Escape close.
        this._scrim?.addEventListener('click', ()=>this._closeDetail());
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape' && this._drawerCtx && this.isOpen()) this._closeDetail();
        });
    }
    isOpen() {
        return !this._panel.classList.contains('hidden');
    }
    _addHandlerOpen(handler) {
        document.addEventListener('click', (e)=>{
            if (!e.target.closest("[data-action='inventory']")) return;
            handler();
        });
    }
    _addHandlerClose(handler) {
        this._panel.querySelector('.inventory-back')?.addEventListener('click', ()=>handler());
    }
    _addHandlerAdjust(handler) {
        this._adjustHandler = handler;
    }
    _addHandlerNewItem(handler) {
        this._newItemHandler = handler;
    }
    _addHandlerEditItem(handler) {
        this._editItemHandler = handler;
    }
    _addHandlerDeleteItem(handler) {
        this._deleteItemHandler = handler;
    }
    _addHandlerHistoryFilter(handler) {
        this._historyFilterHandler = handler;
    }
    _addHandlerAddLink(handler) {
        this._addLinkHandler = handler;
    }
    _addHandlerUpdateLink(handler) {
        this._updateLinkHandler = handler;
    }
    _addHandlerRemoveLink(handler) {
        this._removeLinkHandler = handler;
    }
    _addHandlerEditProduct(handler) {
        this._editProductHandler = handler;
    }
    _addHandlerSaveSupplier(handler) {
        this._saveSupplierHandler = handler;
    }
    _addHandlerDeleteSupplier(handler) {
        this._deleteSupplierHandler = handler;
    }
    _addHandlerCreatePo(handler) {
        this._createPoHandler = handler;
    }
    _addHandlerUpdatePo(handler) {
        this._updatePoHandler = handler;
    }
    _addHandlerPoStatus(handler) {
        this._poStatusHandler = handler;
    }
    _addHandlerReceivePo(handler) {
        this._receivePoHandler = handler;
    }
    _addHandlerApplyCount(handler) {
        this._applyCountHandler = handler;
    }
    _addHandlerToggleEnabled(handler) {
        this._toggleEnabledHandler = handler;
    }
    _addHandlerAddItemSupplier(handler) {
        this._addItemSupplierHandler = handler;
    }
    _addHandlerPreferSupplier(handler) {
        this._preferSupplierHandler = handler;
    }
    _addHandlerSupplierCost(handler) {
        this._supplierCostHandler = handler;
    }
    _addHandlerRemoveItemSupplier(handler) {
        this._removeItemSupplierHandler = handler;
    }
    // Single data entry point.
    // { items, links, adjustments, menuItems, suppliers, purchaseOrders,
    //   historyFilter, invoiceLabelFor }
    render(data) {
        this._data = data;
        this._locked = false;
        this._render();
    }
    // Re-render from fresh model state (other-terminal broadcast or local
    // mutation). Keeps the current section and re-renders any open drawer from
    // the fresh entity (closing it if the entity is gone).
    refreshIfOpen(data) {
        if (!this.isOpen()) return;
        if (data) this._data = data;
        this._render();
    }
    // ── Deep links (external callers, e.g. the notification bell) ──────────────
    // Jump straight to the Purchase Orders section, filtered to drafts (the
    // ones needing approval). Shared by the PO-approval banner's Review button
    // and the notification bell.
    showDraftPOs() {
        this._section = 'po';
        this._poStatusFilter = 'draft';
        this._poPage = 1;
        this._closeDetail();
        this._render();
    }
    // Switch to a sidebar section with any drawer closed (the guided tutorial
    // walks the user through Items -> Purchase Orders -> History).
    showSection(id) {
        this._section = id;
        this._closeDetail();
        this._render();
    }
    // Back to a clean Items view with an empty drawer - the tutorial calls this
    // when its practice data is swapped out, so no practice markup lingers.
    resetView() {
        this._section = 'items';
        this._poStatusFilter = 'all';
        this._closeDetail();
        if (this._drawer) this._drawer.innerHTML = '';
    }
    // Jump to one specific PO's detail drawer (notification bell item click).
    // statusFilter 'all' keeps the list populated after the PO changes status
    // (the tutorial approves + receives it in place).
    focusPO(id, statusFilter = 'draft') {
        this.showDraftPOs();
        if (statusFilter !== 'draft') {
            this._poStatusFilter = statusFilter;
            this._render();
        }
        this._openDetail('po', id);
    }
    // ── Stock-state helpers ─────────────────────────────────────────────────────
    _state(item) {
        if (item.quantity <= 0) return 'out';
        if (item.lowStockThreshold != null && item.quantity <= item.lowStockThreshold) return 'low';
        return 'ok';
    }
    _statePill(item) {
        const s = this._state(item);
        if (s === 'out') return `<span class="inv-pill inv-pill--out">Out of stock</span>`;
        if (s === 'low') return `<span class="inv-pill inv-pill--low">Low stock</span>`;
        return `<span class="inv-pill inv-pill--ok">In stock</span>`;
    }
    _itemValue(item) {
        return item.unitCost == null ? null : item.quantity * item.unitCost;
    }
    // Incoming stock for an item = the sum of its lines on SENT purchase orders
    // (already ordered, awaiting delivery). Drafts don't count - nothing is on
    // its way yet.
    _incomingForItem(itemId) {
        let qty = 0;
        const pos = [];
        (this._data?.purchaseOrders ?? []).forEach((p)=>{
            if (p.status !== 'sent') return;
            const lineQty = (p.lines ?? []).filter((l)=>l.inventoryItemId === itemId && l.qty > 0).reduce((s, l)=>s + l.qty, 0);
            if (lineQty > 0) {
                qty += lineQty;
                pos.push(p);
            }
        });
        return {
            qty: qty,
            pos: pos
        };
    }
    // Suggested reorder quantity: enough to get back to twice the reorder point
    // (at least one reorder point's worth). No reorder point = leave it blank.
    _suggestReorderQty(item) {
        if (item.lowStockThreshold == null || item.lowStockThreshold <= 0) return '';
        return Math.max(Math.ceil(item.lowStockThreshold * 2 - item.quantity), Math.ceil(item.lowStockThreshold));
    }
    // Open the PO form pre-filled with these items (reorder flows).
    _openReorderPo(itemsToOrder, supplierId = null) {
        const prefill = itemsToOrder.map((item)=>({
                inventoryItemId: item.id,
                qty: this._suggestReorderQty(item),
                unitCost: item.unitCost
            }));
        this._showPoModal(null, {
            prefill: prefill,
            supplierId: supplierId
        });
    }
    // PO display status: 'overdue' is DERIVED (sent + expected date past), never stored.
    _poDisplayStatus(po) {
        if (po.status === 'sent' && po.expectedDate) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (new Date(po.expectedDate + 'T23:59:59') < today) return 'overdue';
        }
        return po.status;
    }
    // Display labels for PO statuses (stored values stay draft/sent/received/
    // cancelled - these are friendlier owner-facing terms, Kelly's wording).
    _poPill(po) {
        const s = this._poDisplayStatus(po);
        const meta = {
            draft: [
                'draft',
                'For approval'
            ],
            sent: [
                'sent',
                'Waiting for delivery'
            ],
            overdue: [
                'overdue',
                'Overdue'
            ],
            received: [
                'received',
                'Received'
            ],
            cancelled: [
                'cancelled',
                'Cancelled'
            ]
        }[s] ?? [
            'draft',
            s
        ];
        return `<span class="inv-pill inv-pill--${meta[0]}">${meta[1]}</span>`;
    }
    _poTotal(po) {
        const lines = (po.lines ?? []).reduce((s, l)=>s + l.qty * (l.unitCost ?? 0), 0);
        return lines + (po.tax ?? 0) + (po.shipping ?? 0);
    }
    _supplierPill(s) {
        const meta = {
            active: [
                's-active',
                'Active'
            ],
            preferred: [
                's-preferred',
                'Preferred'
            ],
            on_hold: [
                's-onhold',
                'On hold'
            ]
        }[s.status] ?? [
            's-active',
            'Active'
        ];
        return `<span class="inv-pill inv-pill--${meta[0]}">${meta[1]}</span>`;
    }
    // ── Shared: stat tiles, date filtering, pagination ──────────────────────────
    // color: 'green' | 'amber' | 'red' | 'blue' | 'muted'
    // Action-style stat tile (owner's pick from the 2026-10-02 design round):
    // neutral by default; tone 'warn' (amber) / 'crit' (red) tints it ONLY while
    // count > 0, so the tiles stay calm until something needs doing. filter
    // ('items:low', 'po:overdue', ...) makes the whole tile a button that
    // filters the list below, with a "View N ->" link; otherwise `sub` is a
    // short helper line. Clicks are delegated (_wireStatTiles).
    _statTile({ icon: icon, label: label, value: value, tone: tone = null, count: count = Number(value) || 0, filter: filter = null, sub: sub = null, dataStat: dataStat = null }) {
        const toneCls = tone && count > 0 ? ` invx-stat--${tone}` : '';
        const tag = filter ? 'button' : 'div';
        const attrs = filter ? ` type="button" data-tile-filter="${filter}" aria-label="${(0, $cnCXJ.esc)(`View ${label.toLowerCase()}`)}"` : '';
        const foot = filter ? `<span class="invx-stat-go">${filter === 'items:all' ? 'All items' : `View ${count} &rarr;`}</span>` : sub ? `<span class="invx-stat-sub">${sub}</span>` : '';
        return `
      <${tag} class="invx-stat${toneCls}${filter ? ' invx-stat--action' : ''}"${attrs}>
        <span class="invx-stat-lbl"><span class="invx-stat-icon" aria-hidden="true">${icon}</span>${(0, $cnCXJ.esc)(label)}</span>
        <span class="invx-stat-num"${dataStat ? ` data-stat="${dataStat}"` : ''}>${value}</span>
        ${foot}
      </${tag}>`;
    }
    // Money tile: big amounts shorten ("$1.08M") with the exact figure on the
    // helper line, so nothing is ever cut off.
    _moneyTile(icon, label, amount, note = null) {
        const exact = (0, $coRoT.formatMoney)(amount);
        const short = (0, $coRoT.formatMoneyCompact)(amount);
        const sub = short !== exact ? exact + (note ? ` \xb7 ${note}` : '') : note;
        return this._statTile({
            icon: icon,
            label: label,
            value: short,
            sub: sub,
            dataStat: 'value'
        });
    }
    // The four Items tiles - shared by the Items section, the locked teaser,
    // and _patchStatTiles (which re-renders the row so tones/links stay right).
    _itemsStatsHtml(items, { actionable: actionable = true } = {}) {
        const low = items.filter((i)=>this._state(i) === 'low').length;
        const out = items.filter((i)=>this._state(i) === 'out').length;
        const costed = items.filter((i)=>i.unitCost != null);
        const value = costed.reduce((s, i)=>s + i.quantity * i.unitCost, 0);
        const missing = items.length - costed.length;
        const ok = items.length - low - out;
        return `
      <div class="invx-stats">
        ${this._statTile({
            icon: "\uD83D\uDCE6",
            label: 'Items tracked',
            value: items.length,
            sub: items.length ? `${ok} in stock` : 'Add your first item',
            dataStat: 'items'
        })}
        ${this._statTile({
            icon: "\u26A0\uFE0F",
            label: 'Low stock',
            value: low,
            tone: 'warn',
            filter: actionable && low ? 'items:low' : null,
            sub: low ? 'Time to reorder' : 'None right now',
            dataStat: 'low'
        })}
        ${this._statTile({
            icon: "\uD83D\uDEAB",
            label: 'Out of stock',
            value: out,
            tone: 'crit',
            filter: actionable && out ? 'items:out' : null,
            sub: out ? 'Restock soon' : 'None right now',
            dataStat: 'out'
        })}
        ${this._moneyTile("\uD83D\uDCB0", 'Inventory value', value, missing ? `${missing} missing cost` : null)}
      </div>`;
    }
    // Tile clicks -> the same filters the chips use. Delegated on the content
    // area once, so every re-render is covered.
    _wireStatTiles() {
        this._content?.addEventListener('click', (e)=>{
            const tile = e.target.closest('[data-tile-filter]');
            if (!tile || this._locked) return;
            const [kind, value] = tile.dataset.tileFilter.split(':');
            if (kind === 'items') {
                this._statusFilter = value;
                this._itemsPage = 1;
                this._renderItemsSection();
            } else if (kind === 'po') {
                this._poStatusFilter = value;
                this._poPage = 1;
                this._renderPoSection();
            }
            this._content.querySelector('#invItemsTable, #invPoTable')?.scrollIntoView({
                block: 'nearest',
                behavior: 'smooth'
            });
        });
    }
    // Shared date-range dropdown + optional custom from/to inputs, used by the
    // Purchase Orders and History toolbars.
    _dateRangeControls(idPrefix, range, from, to) {
        const opts = [
            [
                'all',
                'All time'
            ],
            [
                'today',
                'Today'
            ],
            [
                'week',
                'This week'
            ],
            [
                'month',
                'This month'
            ],
            [
                'custom',
                "Custom range\u2026"
            ]
        ];
        return `
      <select id="${idPrefix}Range" class="inv-cat-select">
        ${opts.map(([v, l])=>`<option value="${v}"${range === v ? ' selected' : ''}>${l}</option>`).join('')}
      </select>
      ${range === 'custom' ? `
        <input type="date" id="${idPrefix}From" class="inv-cat-select" value="${(0, $cnCXJ.esc)(from)}" aria-label="From date" />
        <span class="inv-date-sep">to</span>
        <input type="date" id="${idPrefix}To" class="inv-cat-select" value="${(0, $cnCXJ.esc)(to)}" aria-label="To date" />` : ''}`;
    }
    _dateRangeBounds(range, from, to) {
        const startOfToday = new Date();
        startOfToday.setHours(0, 0, 0, 0);
        if (range === 'today') return {
            start: startOfToday,
            end: null
        };
        if (range === 'week') {
            const d = new Date(startOfToday);
            d.setDate(d.getDate() - 6);
            return {
                start: d,
                end: null
            };
        }
        if (range === 'month') {
            const d = new Date(startOfToday);
            d.setDate(d.getDate() - 29);
            return {
                start: d,
                end: null
            };
        }
        if (range === 'custom') return {
            start: from ? new Date(from + 'T00:00:00') : null,
            end: to ? new Date(to + 'T23:59:59') : null
        };
        return {
            start: null,
            end: null
        };
    }
    _inDateRange(iso, range, from, to) {
        const { start: start, end: end } = this._dateRangeBounds(range, from, to);
        if (!start && !end) return true;
        const d = new Date(iso);
        if (start && d < start) return false;
        if (end && d > end) return false;
        return true;
    }
    // ── Render dispatch ─────────────────────────────────────────────────────────
    _render() {
        if (!this._data) return;
        this._renderSidebar();
        if (this._section === 'history') this._renderHistorySection();
        else if (this._section === 'po') this._renderPoSection();
        else if (this._section === 'suppliers') this._renderSuppliersSection();
        else if (this._section === 'counts') this._renderCountsSection();
        else this._renderItemsSection();
        this._renderDrawer();
    }
    _renderSidebar() {
        const attention = (this._data.items ?? []).filter((i)=>this._state(i) !== 'ok').length;
        const overdue = (this._data.purchaseOrders ?? []).filter((p)=>this._poDisplayStatus(p) === 'overdue').length;
        // Section nav items use the shared .pb-nav-item look (color tile + name +
        // one-line description). Icons are unique app-wide - check before reusing.
        const navSections = {
            items: {
                c: '#18AE79',
                desc: 'Stock levels &amp; alerts',
                icon: '<path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/>'
            },
            po: {
                c: '#3B82F6',
                desc: 'Order &amp; receive stock',
                icon: '<path d="m15 11-1 9"/><path d="m19 11-4-7"/><path d="M2 11h20"/><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"/><path d="M4.5 15.5h15"/><path d="m5 11 4-7"/><path d="m9 11 1 9"/>'
            },
            suppliers: {
                c: '#8B5CF6',
                desc: 'Vendors &amp; contacts',
                icon: '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>'
            },
            counts: {
                c: '#F59E0B',
                desc: 'Physical count checks',
                icon: '<path d="m3 17 2 2 4-4"/><path d="m3 7 2 2 4-4"/><path d="M13 6h8"/><path d="M13 12h8"/><path d="M13 18h8"/>'
            },
            history: {
                c: '#14B8A6',
                desc: 'Every stock change',
                icon: '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/>'
            }
        };
        const tab = (id, label, count = 0)=>`
      <button class="pb-nav-item ts-tab${this._section === id ? ' ts-tab--active' : ''}" data-section="${id}" type="button" style="--nav-c:${navSections[id].c}">
        <span class="pb-nav-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${navSections[id].icon}</svg></span>
        <span class="pb-nav-text"><span class="pb-nav-name">${label}</span><span class="pb-nav-desc">${navSections[id].desc}</span></span>
        ${count ? `<span class="ts-tab-count">${count}</span>` : ''}
      </button>`;
        this._sidebar.innerHTML = `
      <p class="ts-side-label">Sections</p>
      ${tab('items', 'Items', attention)}
      ${tab('po', 'Purchase Orders', overdue)}
      ${tab('suppliers', 'Suppliers')}
      ${tab('counts', 'Stock Counts')}
      ${tab('history', 'History')}`;
        this._sidebar.querySelectorAll('.ts-tab').forEach((btn)=>btn.addEventListener('click', ()=>{
                // Free plan: every section shows the same locked teaser - just move
                // the active-tab highlight, never actually switch to a real section.
                if (this._locked) {
                    this._section = btn.dataset.section;
                    this.renderLockedTeaser(this._data);
                    return;
                }
                if (btn.dataset.section === this._section) return this._closeNavDrawer();
                const go = ()=>{
                    this._section = btn.dataset.section;
                    this._closeDetail();
                    this._render();
                    this._closeNavDrawer();
                };
                // Leaving Stock Counts with unsaved counts asks first.
                if (this._section === 'counts' && [
                    ...this._countDraft.values()
                ].some((v)=>v !== '')) this._showConfirmModal({
                    title: 'Leave without applying?',
                    message: 'Your typed counts will be discarded.',
                    confirmLabel: 'Discard counts',
                    onConfirm: ()=>{
                        this._countDraft.clear();
                        go();
                    }
                });
                else go();
            }));
    }
    // ── Detail drawer (item / supplier / PO) ────────────────────────────────────
    _openDetail(type, id) {
        this._drawerCtx = {
            type: type,
            id: id
        };
        this._renderDrawer();
    }
    _closeDetail() {
        this._drawerCtx = null;
        this._drawer?.classList.remove('inv-drawer--open');
        this._scrim?.classList.remove('inv-drawer-scrim--visible');
        this._drawer?.setAttribute('aria-hidden', 'true');
    }
    _renderDrawer() {
        if (!this._drawer) return;
        if (!this._drawerCtx) {
            this._closeDetail();
            return;
        }
        const { type: type, id: id } = this._drawerCtx;
        let html = null;
        if (type === 'item') {
            const item = (this._data.items ?? []).find((i)=>i.id === id);
            html = item ? this._itemDrawerHtml(item) : null;
        } else if (type === 'supplier') {
            const s = (this._data.suppliers ?? []).find((x)=>x.id === id);
            html = s ? this._supplierDrawerHtml(s) : null;
        } else if (type === 'po') {
            const po = (this._data.purchaseOrders ?? []).find((p)=>p.id === id);
            html = po ? this._poDrawerHtml(po) : null;
        }
        if (html == null) {
            this._closeDetail();
            return;
        }
        this._drawer.innerHTML = html;
        this._drawer.classList.add('inv-drawer--open');
        this._scrim?.classList.add('inv-drawer-scrim--visible');
        this._drawer.setAttribute('aria-hidden', 'false');
        this._drawer.querySelector('.inv-drawer-close')?.addEventListener('click', ()=>this._closeDetail());
        if (type === 'item') this._wireItemDrawer(id);
        else if (type === 'supplier') this._wireSupplierDrawer(id);
        else if (type === 'po') this._wirePoDrawer(id);
    }
    // ── Section: Items ──────────────────────────────────────────────────────────
    _renderItemsSection() {
        const { items: items } = this._data;
        const q = this._query.trim().toLowerCase();
        let visible = items;
        if (q) visible = visible.filter((i)=>i.name.toLowerCase().includes(q) || (i.sku ?? '').toLowerCase().includes(q));
        if (this._statusFilter === 'low') visible = visible.filter((i)=>this._state(i) === 'low');
        if (this._statusFilter === 'out') visible = visible.filter((i)=>this._state(i) === 'out');
        visible = [
            ...visible
        ].sort((a, b)=>{
            if (this._itemSort === 'name') return a.name.localeCompare(b.name);
            if (this._itemSort === 'stock') return a.quantity - b.quantity;
            if (this._itemSort === 'value') return (this._itemValue(b) ?? -1) - (this._itemValue(a) ?? -1);
            return new Date(b.updatedAt ?? b.createdAt) - new Date(a.updatedAt ?? a.createdAt);
        });
        const lowCount = items.filter((i)=>this._state(i) === 'low').length;
        const outCount = items.filter((i)=>this._state(i) === 'out').length;
        const { pageItems: pageItems, page: page, totalPages: totalPages, total: total, start: start } = (0, $8c6cc8386f59a55a$export$2660a47c412cb681)(visible, this._itemsPage, this._itemsPageSize);
        this._itemsPage = page;
        const rows = pageItems.map((item)=>this._itemRowHtml(item)).join('');
        const enabled = this._data.inventoryEnabled !== false;
        // Purchase orders needing approval - surfaced right on the Items ("home") tab.
        const draftPos = (this._data.purchaseOrders ?? []).filter((p)=>p.status === 'draft');
        this._content.innerHTML = `
      <div class="inv-toggle-card${enabled ? '' : ' inv-toggle-card--off'}">
        <span class="inv-toggle-icon" aria-hidden="true">${$b0886db79b2df847$var$INV_TOGGLE_COPY[enabled].icon}</span>
        <div class="inv-toggle-info">
          <span class="inv-toggle-title">Inventory tracking</span>
          <span class="inv-toggle-sub">${$b0886db79b2df847$var$INV_TOGGLE_COPY[enabled].sub}</span>
        </div>
        <label class="loyalty-enable-toggle" for="invEnabledToggle">
          <input type="checkbox" id="invEnabledToggle" ${enabled ? 'checked' : ''} />
          <span class="loyalty-enable-track" aria-hidden="true"></span>
          <span class="loyalty-enable-text">${$b0886db79b2df847$var$INV_TOGGLE_COPY[enabled].label}</span>
        </label>
      </div>
      ${lowCount + outCount > 0 && this._statusFilter === 'all' || draftPos.length ? `
        <div class="inv-attn-band">
          ${lowCount + outCount > 0 && this._statusFilter === 'all' ? `
            <div class="inv-attn">
              <span class="inv-attn-icon" aria-hidden="true">\u{26A0}\u{FE0F}</span>
              <span class="inv-attn-text"><strong>${lowCount + outCount} item${lowCount + outCount === 1 ? '' : 's'}</strong> need${lowCount + outCount === 1 ? 's' : ''} attention</span>
              <button class="inv-attn-btn" id="invAttnShow" type="button">Show</button>
              <button class="inv-attn-btn inv-attn-btn--primary" id="invAttnReorder" type="button">\u{1F6D2} Reorder</button>
            </div>` : ''}
          ${draftPos.length ? `
            <div class="inv-attn inv-attn--po">
              <span class="inv-attn-icon" aria-hidden="true">\u{1F4DD}</span>
              <span class="inv-attn-text"><strong>${draftPos.length} purchase order${draftPos.length === 1 ? '' : 's'}</strong> need${draftPos.length === 1 ? 's' : ''} approval</span>
              <button class="inv-attn-btn inv-attn-btn--primary" id="invAttnReviewPo" type="button">Review</button>
            </div>` : ''}
        </div>` : ''}
      ${this._itemsStatsHtml(items)}
      <div class="invx-toolbar">
        <div class="invx-search">
          ${$b0886db79b2df847$var$icons.search}
          <input type="search" id="invSearchInput" placeholder="Search items or SKU..." autocomplete="off" value="${(0, $cnCXJ.esc)(this._query)}" />
        </div>
        <div class="inv-chiprow" id="invStatusChips">
          ${[
            'all',
            'low',
            'out'
        ].map((f)=>`
            <button class="inv-chip${this._statusFilter === f ? ' inv-chip--active' : ''}" data-filter="${f}" type="button">
              ${f === 'all' ? 'All' : f === 'low' ? 'Low' : 'Out'}
            </button>`).join('')}
        </div>
        <select id="invItemSort" class="inv-cat-select">
          <option value="updated"${this._itemSort === 'updated' ? ' selected' : ''}>Sort: Recently updated</option>
          <option value="name"${this._itemSort === 'name' ? ' selected' : ''}>Sort: Name A\u{2013}Z</option>
          <option value="stock"${this._itemSort === 'stock' ? ' selected' : ''}>Sort: Stock, low to high</option>
          <option value="value"${this._itemSort === 'value' ? ' selected' : ''}>Sort: Value, high to low</option>
        </select>
        <button class="btn primary invx-new-btn" id="invNewItemBtn" type="button">${$b0886db79b2df847$var$icons.plusCircle} New Item</button>
      </div>
      ${visible.length ? `
        <div class="inv-table" id="invItemsTable">
          <div class="inv-thead">
            <span>Item</span><span>Supplier</span><span>On hand</span><span>Reorder point</span>
            <span>Status</span><span>Unit cost</span><span>Value</span><span>Updated</span>
          </div>
          ${rows}
        </div>
        ${(0, $8c6cc8386f59a55a$export$e97ab1b483e292e5)('invItemsPager', {
            page: page,
            totalPages: totalPages,
            total: total,
            start: start,
            count: pageItems.length,
            pageSize: this._itemsPageSize,
            pageSizeOptions: [
                25,
                50,
                100
            ],
            label: 'items'
        })}` : `
        <div class="invx-empty">
          <div class="invx-empty-icon">\u{1F4E6}</div>
          <p class="invx-empty-title">${q || this._statusFilter !== 'all' ? 'No items match.' : 'No inventory items yet'}</p>
          ${q || this._statusFilter !== 'all' ? '' : `<p class="invx-empty-sub">Add the things you keep in stock (milk, cups, beans...) and connect them to your products. Selling a product then lowers its stock automatically.</p>`}
        </div>`}
    `;
        document.getElementById('invSearchInput')?.addEventListener('input', (e)=>{
            this._query = e.target.value;
            this._itemsPage = 1;
            const scroll = this._content.scrollTop;
            this._renderItemsSection();
            this._content.scrollTop = scroll;
            const input = document.getElementById('invSearchInput');
            if (input) {
                input.focus();
                input.setSelectionRange(input.value.length, input.value.length);
            }
        });
        // Patch the card in place so the switch slides and the card recolors
        // smoothly, then hand off to the controller (whose refresh re-renders the
        // section) once the 180ms switch transition has finished.
        document.getElementById('invEnabledToggle')?.addEventListener('change', (e)=>{
            const on = e.target.checked;
            const card = e.target.closest('.inv-toggle-card');
            if (card) {
                card.classList.toggle('inv-toggle-card--off', !on);
                card.querySelector('.inv-toggle-icon').textContent = $b0886db79b2df847$var$INV_TOGGLE_COPY[on].icon;
                card.querySelector('.inv-toggle-sub').textContent = $b0886db79b2df847$var$INV_TOGGLE_COPY[on].sub;
                card.querySelector('.loyalty-enable-text').textContent = $b0886db79b2df847$var$INV_TOGGLE_COPY[on].label;
            }
            setTimeout(()=>this._toggleEnabledHandler?.(on), 200);
        });
        document.getElementById('invNewItemBtn')?.addEventListener('click', ()=>this._showItemModal());
        document.getElementById('invItemSort')?.addEventListener('change', (e)=>{
            this._itemSort = e.target.value;
            this._itemsPage = 1;
            this._renderItemsSection();
        });
        document.getElementById('invAttnShow')?.addEventListener('click', ()=>{
            this._statusFilter = outCount ? 'out' : 'low';
            this._itemsPage = 1;
            this._renderItemsSection();
        });
        document.getElementById('invAttnReorder')?.addEventListener('click', ()=>{
            // One order pre-filled with every low/out item (suggested quantities).
            this._openReorderPo(items.filter((i)=>this._state(i) !== 'ok'));
        });
        document.getElementById('invAttnReviewPo')?.addEventListener('click', ()=>this.showDraftPOs());
        document.getElementById('invStatusChips')?.addEventListener('click', (e)=>{
            const chip = e.target.closest('.inv-chip');
            if (!chip) return;
            this._statusFilter = chip.dataset.filter;
            this._itemsPage = 1;
            this._renderItemsSection();
        });
        document.getElementById('invItemsTable')?.addEventListener('click', (e)=>{
            const row = e.target.closest('.inv-tr');
            if (row) this._openDetail('item', row.dataset.id);
        });
        (0, $8c6cc8386f59a55a$export$b9eef545e49d09b)('invItemsPager', (p)=>{
            this._itemsPage = p;
            this._renderItemsSection();
        }, (n)=>{
            this._itemsPageSize = n;
            this._itemsPage = 1;
            this._renderItemsSection();
        });
    }
    _itemRowHtml(item) {
        const value = this._itemValue(item);
        const state = this._state(item);
        const initial = (item.name.trim()[0] || '?').toUpperCase();
        const incoming = this._incomingForItem(item.id);
        return `
      <div class="inv-tr" data-id="${item.id}" role="button" tabindex="0">
        <span class="inv-td inv-td--item">
          <span class="invx-tile invx-tile--sm" style="background:${$b0886db79b2df847$var$tileColor(item.name)}">${(0, $cnCXJ.esc)(initial)}</span>
          <span class="inv-td-stack">
            <span class="inv-td-name">${(0, $cnCXJ.esc)(item.name)}</span>
            ${item.sku ? `<span class="inv-td-sub">SKU: ${(0, $cnCXJ.esc)(item.sku)}</span>` : ''}
          </span>
        </span>
        <span class="inv-td" data-th="Supplier">${(()=>{
            const sup = item.supplierId ? (this._data?.suppliers ?? []).find((s)=>s.id === item.supplierId) : null;
            return sup ? (0, $cnCXJ.esc)(sup.name) : '<span class="inv-dim">-</span>';
        })()}</span>
        <span class="inv-td inv-td--qty inv-qty--${state}" data-th="On hand">${$b0886db79b2df847$var$fmtQty(item.quantity)} <small>${(0, $cnCXJ.esc)(item.unit)}</small>${incoming.qty > 0 ? `<span class="inv-td-incoming" title="${incoming.pos.map((p)=>$b0886db79b2df847$var$fmtPo(p.poNumber)).join(', ')} awaiting delivery">\u{1F69A} +${$b0886db79b2df847$var$fmtQty(incoming.qty)} on order</span>` : ''}</span>
        <span class="inv-td" data-th="Reorder point">${item.lowStockThreshold != null ? `${$b0886db79b2df847$var$fmtQty(item.lowStockThreshold)} <small>${(0, $cnCXJ.esc)(item.unit)}</small>` : '<span class="inv-dim">-</span>'}</span>
        <span class="inv-td" data-th="Status">${this._statePill(item)}</span>
        <span class="inv-td" data-th="Unit cost">${item.unitCost != null ? `${(0, $coRoT.formatMoney)(item.unitCost)} <small>/ ${(0, $cnCXJ.esc)(item.unit)}</small>` : '<span class="inv-dim">-</span>'}</span>
        <span class="inv-td" data-th="Value">${value != null ? (0, $coRoT.formatMoney)(value) : '<span class="inv-dim">-</span>'}</span>
        <span class="inv-td inv-td--updated" data-th="Updated">${$b0886db79b2df847$var$fmtRel(item.updatedAt ?? item.createdAt)}</span>
      </div>`;
    }
    // Surgical update after a quantity change: the table row, stat tiles, and
    // (if it shows this item) the open drawer - no list re-render, no blink.
    patchItemRow(item) {
        const cached = this._data?.items?.find((i)=>i.id === item.id);
        if (cached) {
            cached.quantity = item.quantity;
            cached.updatedAt = new Date().toISOString();
        }
        const row = this._content.querySelector(`.inv-tr[data-id="${item.id}"]`);
        if (row && cached) row.outerHTML = this._itemRowHtml(cached);
        this._patchStatTiles();
        if (this._drawerCtx?.type === 'item' && this._drawerCtx.id === item.id) this._renderDrawer();
    }
    _patchStatTiles() {
        const row = this._content.querySelector('.invx-stats');
        if (!row || this._section !== 'items') return;
        row.outerHTML = this._itemsStatsHtml(this._data?.items ?? [], {
            actionable: !this._locked
        });
    }
    // ── Item detail drawer ──────────────────────────────────────────────────────
    _itemDrawerHtml(item) {
        const { links: links, menuItems: menuItems, suppliers: suppliers, adjustments: adjustments } = this._data;
        const value = this._itemValue(item);
        const supplier = item.supplierId ? (suppliers ?? []).find((s)=>s.id === item.supplierId) : null;
        const isAuto = !!item.linkedMenuItemId;
        // Used-by: base links resolved against live products.
        const liveProducts = new Map((menuItems ?? []).filter((m)=>m.status !== 'deleted').map((m)=>[
                m._id,
                m
            ]));
        const baseLinks = (links ?? []).filter((l)=>l.inventoryItemId === item.id && l.variantLabel == null && liveProducts.has(l.menuItemId));
        const overrideCounts = new Map();
        (links ?? []).forEach((l)=>{
            if (l.inventoryItemId === item.id && l.variantLabel != null && liveProducts.has(l.menuItemId)) overrideCounts.set(l.menuItemId, (overrideCounts.get(l.menuItemId) ?? 0) + 1);
        });
        const usedByRows = baseLinks.map((l)=>{
            const product = liveProducts.get(l.menuItemId);
            const locked = isAuto && l.menuItemId === item.linkedMenuItemId;
            const overrides = overrideCounts.get(l.menuItemId) ?? 0;
            return `
        <div class="inv-usedby-row" data-link-id="${l.id}" data-menu-item="${l.menuItemId}">
          <span class="inv-usedby-name">${(0, $cnCXJ.esc)(product.itemName)}</span>
          <span class="inv-usedby-qty">
            ${locked ? `<span class="inv-usedby-fixed" title="Managed by this product's Simple count setting">${$b0886db79b2df847$var$fmtQty(l.qty)} ${(0, $cnCXJ.esc)(item.unit)} per sale \u{1F512}</span>` : `<button class="inv-usedby-qty-btn" data-act="edit-qty" type="button" title="Change amount per sale">${$b0886db79b2df847$var$fmtQty(l.qty)} ${(0, $cnCXJ.esc)(item.unit)} per sale ${$b0886db79b2df847$var$icons.edit}</button>`}
            ${overrides ? `<button class="inv-usedby-ovr" data-act="edit-product" type="button" title="Edit variant amounts in the product editor">${overrides} variant override${overrides === 1 ? '' : 's'}</button>` : ''}
          </span>
          ${locked ? '' : `<button class="inv-usedby-remove" data-act="remove-link" type="button" aria-label="Unlink product">&times;</button>`}
        </div>`;
        }).join('');
        const recent = (adjustments ?? []).filter((a)=>a.inventoryItemId === item.id).slice(0, 5);
        const recentRows = recent.map((a)=>`
      <div class="inv-act-row">
        <div class="inv-act-main">
          <span class="inv-act-note">${(0, $cnCXJ.esc)(a.note || this._historyKindLabel(a))}</span>
          <span class="inv-act-meta">${a.staffName ? `${(0, $cnCXJ.esc)(a.staffName)} \xb7 ` : ''}${$b0886db79b2df847$var$fmtRel(a.createdAt)}</span>
        </div>
        <span class="invx-delta ${a.delta >= 0 ? 'invx-delta--pos' : 'invx-delta--neg'}">${a.delta >= 0 ? '+' : "\u2212"}${$b0886db79b2df847$var$fmtQty(Math.abs(a.delta))} ${(0, $cnCXJ.esc)(item.unit)}</span>
      </div>`).join('');
        return `
      <div class="inv-drawer-head">
        <span class="invx-tile" style="background:${$b0886db79b2df847$var$tileColor(item.name)}">${(0, $cnCXJ.esc)((item.name.trim()[0] || '?').toUpperCase())}</span>
        <div class="inv-drawer-titles">
          <h3 class="inv-drawer-title">${(0, $cnCXJ.esc)(item.name)}</h3>
          <p class="inv-drawer-sub">${item.sku ? `SKU: ${(0, $cnCXJ.esc)(item.sku)}` : ''}</p>
        </div>
        ${this._statePill(item)}
        <button class="inv-drawer-close" type="button" aria-label="Close details">&times;</button>
      </div>
      <div class="inv-drawer-body">
        <div class="inv-drawer-stats">
          <div class="inv-dstat"><span class="inv-dstat-val inv-qty--${this._state(item)}">${$b0886db79b2df847$var$fmtQty(item.quantity)} <small>${(0, $cnCXJ.esc)(item.unit)}</small></span><span class="inv-dstat-lbl">On hand</span></div>
          <div class="inv-dstat"><span class="inv-dstat-val">${item.lowStockThreshold != null ? $b0886db79b2df847$var$fmtQty(item.lowStockThreshold) : '-'}</span><span class="inv-dstat-lbl">Reorder point</span></div>
          <div class="inv-dstat"><span class="inv-dstat-val">${item.unitCost != null ? (0, $coRoT.formatMoney)(item.unitCost) : '-'}</span><span class="inv-dstat-lbl">Unit cost</span></div>
          <div class="inv-dstat"><span class="inv-dstat-val">${value != null ? (0, $coRoT.formatMoney)(value) : '-'}</span><span class="inv-dstat-lbl">Value</span></div>
        </div>
        ${(()=>{
            const incoming = this._incomingForItem(item.id);
            if (!incoming.qty) return '';
            return `
          <div class="inv-incoming">
            <span aria-hidden="true">\u{1F69A}</span>
            <span class="inv-incoming-text"><strong>+${$b0886db79b2df847$var$fmtQty(incoming.qty)} ${(0, $cnCXJ.esc)(item.unit)}</strong> already on order \xb7
              ${incoming.pos.map((p)=>`<button class="inv-inline-link" data-act="open-po" data-id="${p.id}" type="button">${$b0886db79b2df847$var$fmtPo(p.poNumber)}${p.expectedDate ? ` (${$b0886db79b2df847$var$fmtDate(p.expectedDate)})` : ''}</button>`).join(" \xb7 ")}
            </span>
          </div>`;
        })()}
        <div class="inv-drawer-actions">
          <button class="btn primary" data-act="receive" type="button">+ Receive stock</button>
          <button class="btn" data-act="remove" type="button">&minus; Use / Remove</button>
          <button class="btn" data-act="reorder" type="button" title="Draft a purchase order for this item">\u{1F6D2} Reorder</button>
        </div>
        <button class="inv-connect-btn" data-act="add-link" type="button">
          <span class="inv-connect-btn-icon" aria-hidden="true">${$b0886db79b2df847$var$icons.plusCircle}</span>
          <span class="inv-connect-btn-text">
            <span class="inv-connect-btn-title">Connect a product</span>
            <span class="inv-connect-btn-sub">Selling that product then lowers this stock automatically</span>
          </span>
        </button>
        <div class="inv-drawer-actions inv-drawer-actions--secondary">
          <button class="btn" data-act="edit-item" type="button">${$b0886db79b2df847$var$icons.edit} Edit item</button>
          ${isAuto ? '' : `<button class="btn inv-btn-icon-danger" data-act="delete-item" type="button" aria-label="Delete item">${$b0886db79b2df847$var$icons.trash}</button>`}
        </div>
        <h4 class="inv-drawer-section">Suppliers <span class="inv-drawer-section-sub">\u{2605} preferred - used for reorders</span></h4>
        ${(()=>{
            const rows = (this._data.itemSuppliers ?? []).filter((r)=>r.inventoryItemId === item.id).sort((a, b)=>(b.preferred ? 1 : 0) - (a.preferred ? 1 : 0));
            const linked = new Set(rows.map((r)=>r.supplierId));
            const unlinked = (suppliers ?? []).filter((s)=>!linked.has(s.id));
            const rowHtml = rows.map((r)=>{
                const s = (suppliers ?? []).find((x)=>x.id === r.supplierId);
                if (!s) return '';
                return `
              <div class="inv-isup-row" data-id="${r.id}">
                <button class="inv-isup-star${r.preferred ? ' inv-isup-star--on' : ''}" data-act="prefer-sup" type="button" title="${r.preferred ? 'Preferred supplier' : 'Make preferred'}" aria-label="${r.preferred ? 'Preferred supplier' : 'Make preferred'}">\u{2605}</button>
                <button class="inv-isup-name" data-act="open-supplier" data-id="${s.id}" type="button">${(0, $cnCXJ.esc)(s.name)}</button>
                <button class="inv-isup-price" data-act="edit-sup-price" type="button" title="Change this supplier's price">${r.unitCost != null ? `${(0, $coRoT.formatMoney)(r.unitCost)} / ${(0, $cnCXJ.esc)(item.unit)}` : 'Set price'} ${$b0886db79b2df847$var$icons.edit}</button>
                <button class="inv-usedby-remove" data-act="remove-sup" type="button" aria-label="Unlink supplier">&times;</button>
              </div>`;
            }).join('');
            const addHtml = unlinked.length ? `
            <div class="inv-isup-add">
              <select id="invIsupPick" class="inv-cat-select" aria-label="Add a supplier">
                <option value="">Add a supplier...</option>
                ${unlinked.map((s)=>`<option value="${s.id}">${(0, $cnCXJ.esc)(s.name)}</option>`).join('')}
              </select>
              <input type="number" id="invIsupPrice" min="0" step="0.01" placeholder="Price / ${(0, $cnCXJ.esc)(item.unit)}" aria-label="Price per ${(0, $cnCXJ.esc)(item.unit)}" />
              <button class="btn" id="invIsupAddBtn" type="button">Add</button>
            </div>` : (suppliers ?? []).length ? '' : `
            <p class="inv-drawer-none">Suppliers are optional. <button class="inv-inline-link" data-act="new-supplier" type="button">Create your first supplier</button></p>`;
            return (rowHtml || `<p class="inv-drawer-none">No suppliers linked yet.</p>`) + addHtml;
        })()}
        <h4 class="inv-drawer-section">Used by <span class="inv-drawer-section-sub">how much one sale uses</span></h4>
        ${usedByRows || `<p class="inv-drawer-none">No products connected yet. Use the green Connect a product button above.</p>`}
        <h4 class="inv-drawer-section">Recent activity</h4>
        ${recentRows || `<p class="inv-drawer-none">No stock changes yet.</p>`}
        ${recent.length ? `<button class="inv-inline-link" data-act="view-history" type="button">View all activity</button>` : ''}
      </div>`;
    }
    _wireItemDrawer(itemId) {
        const item = this._data.items.find((i)=>i.id === itemId);
        if (!item) return;
        const d = this._drawer;
        d.querySelector('[data-act="receive"]')?.addEventListener('click', ()=>this._showAdjustModal(item, +1));
        d.querySelector('[data-act="remove"]')?.addEventListener('click', ()=>this._showAdjustModal(item, -1));
        d.querySelectorAll('[data-act="edit-item"]').forEach((b)=>b.addEventListener('click', ()=>this._showItemModal(item)));
        d.querySelector('[data-act="delete-item"]')?.addEventListener('click', ()=>{
            const linked = new Set((this._data.links ?? []).filter((l)=>l.inventoryItemId === item.id).map((l)=>l.menuItemId)).size;
            this._showConfirmModal({
                title: `Delete ${item.name}?`,
                message: linked ? `${linked} linked product${linked === 1 ? '' : 's'} will stop tracking it, and its adjustment history will be removed. This cannot be undone.` : 'Its adjustment history will be removed. This cannot be undone.',
                confirmLabel: 'Delete',
                onConfirm: ()=>{
                    this._closeDetail();
                    this._deleteItemHandler?.(item.id);
                }
            });
        });
        d.querySelectorAll('[data-act="open-supplier"]').forEach((b)=>b.addEventListener('click', ()=>this._openDetail('supplier', b.dataset.id)));
        d.querySelector('[data-act="new-supplier"]')?.addEventListener('click', ()=>this._showSupplierModal());
        // Supplier price list: prefer / inline price edit / unlink / add.
        d.querySelectorAll('.inv-isup-row').forEach((row)=>{
            const rowId = row.dataset.id;
            row.querySelector('[data-act="prefer-sup"]')?.addEventListener('click', ()=>this._preferSupplierHandler?.(rowId));
            row.querySelector('[data-act="remove-sup"]')?.addEventListener('click', ()=>this._removeItemSupplierHandler?.(rowId));
            row.querySelector('[data-act="edit-sup-price"]')?.addEventListener('click', (e)=>{
                const btn = e.currentTarget;
                const current = (this._data.itemSuppliers ?? []).find((r)=>r.id === rowId)?.unitCost ?? '';
                const wrap = document.createElement('span');
                wrap.className = 'inv-usedby-editwrap';
                wrap.innerHTML = `
          <input type="number" class="inv-usedby-input" min="0" step="0.01" value="${current}" aria-label="Price per ${(0, $cnCXJ.esc)(item.unit)}" />
          <span class="inv-usedby-unit">/ ${(0, $cnCXJ.esc)(item.unit)}</span>`;
                btn.replaceWith(wrap);
                const input = wrap.querySelector('input');
                input.focus();
                input.select();
                const commit = ()=>{
                    const price = input.value === '' ? null : parseFloat(input.value);
                    if (price !== current && (price === null || Number.isFinite(price) && price >= 0)) this._supplierCostHandler?.(rowId, price);
                    else this._renderDrawer();
                };
                input.addEventListener('keydown', (ev)=>{
                    if (ev.key === 'Enter') commit();
                    if (ev.key === 'Escape') this._renderDrawer();
                });
                input.addEventListener('blur', commit);
            });
        });
        d.querySelector('#invIsupAddBtn')?.addEventListener('click', ()=>{
            const supplierId = d.querySelector('#invIsupPick')?.value;
            const price = d.querySelector('#invIsupPrice')?.value;
            if (supplierId) this._addItemSupplierHandler?.(item.id, supplierId, price);
        });
        d.querySelector('[data-act="reorder"]')?.addEventListener('click', ()=>this._openReorderPo([
                item
            ], item.supplierId ?? null));
        d.querySelectorAll('[data-act="open-po"]').forEach((b)=>b.addEventListener('click', ()=>this._openDetail('po', b.dataset.id)));
        d.querySelector('[data-act="add-link"]')?.addEventListener('click', ()=>this._showAddLinkModal(item));
        d.querySelector('[data-act="view-history"]')?.addEventListener('click', ()=>{
            this._section = 'history';
            this._historyFilterHandler?.(item.id);
            this._closeDetail();
        });
        d.querySelectorAll('.inv-usedby-row').forEach((row)=>{
            const linkId = row.dataset.linkId;
            const menuItemId = row.dataset.menuItem;
            row.querySelector('[data-act="remove-link"]')?.addEventListener('click', ()=>{
                const name = row.querySelector('.inv-usedby-name')?.textContent ?? 'this product';
                this._showConfirmModal({
                    title: `Unlink ${name}?`,
                    message: `Selling ${name} will no longer lower ${item.name} stock.`,
                    confirmLabel: 'Unlink',
                    onConfirm: ()=>this._removeLinkHandler?.(linkId)
                });
            });
            row.querySelector('[data-act="edit-product"]')?.addEventListener('click', ()=>this._editProductHandler?.(menuItemId));
            row.querySelector('[data-act="edit-qty"]')?.addEventListener('click', (e)=>{
                // Swap the button for an inline number input.
                const btn = e.currentTarget;
                const current = (this._data.links ?? []).find((l)=>l.id === linkId)?.qty ?? 0;
                const wrap = document.createElement('span');
                wrap.className = 'inv-usedby-editwrap';
                wrap.innerHTML = `
          <input type="number" class="inv-usedby-input" min="0" step="any" value="${current}" aria-label="Amount per sale" />
          <span class="inv-usedby-unit">${(0, $cnCXJ.esc)(item.unit)} per sale</span>`;
                btn.replaceWith(wrap);
                const input = wrap.querySelector('input');
                input.focus();
                input.select();
                const commit = ()=>{
                    const qty = parseFloat(input.value);
                    if (Number.isFinite(qty) && qty > 0 && qty !== current) this._updateLinkHandler?.(linkId, qty);
                    else this._renderDrawer(); // revert
                };
                input.addEventListener('keydown', (ev)=>{
                    if (ev.key === 'Enter') commit();
                    if (ev.key === 'Escape') this._renderDrawer();
                });
                input.addEventListener('blur', commit);
            });
        });
    }
    // "Connect a product" picker: search products, pick one, set the per-sale amount.
    _showAddLinkModal(item) {
        const liveProducts = (this._data.menuItems ?? []).filter((m)=>m.status !== 'deleted');
        const alreadyLinked = new Set((this._data.links ?? []).filter((l)=>l.inventoryItemId === item.id && l.variantLabel == null).map((l)=>l.menuItemId));
        const candidates = liveProducts.filter((m)=>!alreadyLinked.has(m._id));
        const overlay = document.createElement('div');
        overlay.className = 'modal-overlay-form';
        overlay.style.zIndex = '99999';
        overlay.innerHTML = `
      <div class="invx-modal-card">
        <button class="modal-close-btn" type="button">&times;</button>
        <h3 class="invx-modal-title">Connect a product</h3>
        <p class="invx-modal-sub">Pick a product that uses ${(0, $cnCXJ.esc)(item.name)}, then say how much one sale uses.</p>
        <div class="invx-field">
          <input type="search" id="invLinkSearch" placeholder="Search products..." autocomplete="off" />
        </div>
        <div class="inv-link-results" id="invLinkResults"></div>
        <div class="inv-link-picked hidden" id="invLinkPicked">
          <p class="inv-link-picked-name" id="invLinkPickedName"></p>
          <div class="invx-field">
            <label for="invLinkQty">How much ${(0, $cnCXJ.esc)(item.unit)} does one sale use? <span class="pb-tip" tabindex="0" role="img" aria-label="More info" data-tip="If this product uses the same amount of ${(0, $cnCXJ.esc)(item.name)} no matter the variant, put it here and leave the per-variant fields blank. If the amount depends on the variant, leave this blank and fill the per-variant amounts instead.">i</span></label>
            <input type="number" id="invLinkQty" min="0" step="any" placeholder="e.g. 18" autocomplete="off" />
          </div>
          <div id="invLinkVariants"></div>
        </div>
        <p class="invx-modal-error" id="invLinkError"></p>
        <div class="adj-form-actions">
          <button type="button" class="btn" data-act="cancel">Cancel</button>
          <button type="button" class="btn primary" data-act="save" disabled>Connect</button>
        </div>
      </div>`;
        document.body.appendChild(overlay);
        const close = ()=>overlay.remove();
        overlay.querySelector('.modal-close-btn').addEventListener('click', close);
        overlay.querySelector('[data-act="cancel"]').addEventListener('click', close);
        let picked = null;
        const resultsEl = overlay.querySelector('#invLinkResults');
        const saveBtn = overlay.querySelector('[data-act="save"]');
        const renderResults = (q)=>{
            const query = q.trim().toLowerCase();
            const matches = (query ? candidates.filter((m)=>m.itemName.toLowerCase().includes(query)) : candidates).slice(0, 8);
            resultsEl.innerHTML = matches.length ? matches.map((m)=>`<button class="inv-link-result" data-id="${m._id}" type="button">${(0, $cnCXJ.esc)(m.itemName)}</button>`).join('') : `<p class="inv-drawer-none">${candidates.length ? 'No products match.' : 'Every product is already connected.'}</p>`;
            resultsEl.querySelectorAll('.inv-link-result').forEach((btn)=>btn.addEventListener('click', ()=>{
                    picked = candidates.find((m)=>m._id === btn.dataset.id);
                    overlay.querySelector('#invLinkPicked').classList.remove('hidden');
                    overlay.querySelector('#invLinkPickedName').textContent = picked.itemName;
                    // Variant products get optional per-option amounts (same override
                    // rows the product editor writes). Blank = the base amount above;
                    // 0 = that option does not use this item at all.
                    const variantsEl = overlay.querySelector('#invLinkVariants');
                    const groups = (picked.variants ?? []).filter((g)=>g?.options?.length);
                    variantsEl.innerHTML = groups.length ? `
            <p class="inv-link-var-intro">This product has variants - two ways to set it up:</p>
            <ul class="inv-link-var-rules">
              <li><strong>Same amount for every variant?</strong> Fill the field above, leave these blank.</li>
              <li><strong>Depends on the variant?</strong> (e.g. Large uses more) Type each option's amount below - the field above can stay blank.</li>
              <li>Type <strong>0</strong> for an option that does not use ${(0, $cnCXJ.esc)(item.name)} at all.</li>
            </ul>
            ${groups.map((g)=>`
              <div class="inv-link-var-group">
                <p class="inv-link-var-label">${(0, $cnCXJ.esc)(g.optionLabel)}</p>
                ${g.options.map((o)=>`
                  <label class="inv-link-var-row">
                    <span class="inv-link-var-name">${(0, $cnCXJ.esc)(o.optionName)}</span>
                    <span class="inv-link-var-input">
                      <input type="number" min="0" step="any" placeholder="base"
                        data-variant-label="${(0, $cnCXJ.esc)(g.optionLabel)}" data-variant-option="${(0, $cnCXJ.esc)(o.optionName)}" />
                      <small>${(0, $cnCXJ.esc)(item.unit)}</small>
                    </span>
                  </label>`).join('')}
              </div>`).join('')}` : '';
                    resultsEl.innerHTML = '';
                    overlay.querySelector('#invLinkSearch').value = '';
                    saveBtn.disabled = false;
                    overlay.querySelector('#invLinkQty').focus();
                }));
        };
        renderResults('');
        overlay.querySelector('#invLinkSearch').addEventListener('input', (e)=>renderResults(e.target.value));
        overlay.querySelector('#invLinkSearch').focus();
        saveBtn.addEventListener('click', ()=>{
            const rawQty = overlay.querySelector('#invLinkQty').value;
            const qty = parseFloat(rawQty);
            const errEl = overlay.querySelector('#invLinkError');
            if (!picked) {
                errEl.textContent = 'Pick a product first.';
                return;
            }
            // Filled per-option inputs become override rows; blanks fall back to base.
            const overrides = [
                ...overlay.querySelectorAll('#invLinkVariants input[data-variant-label]')
            ].filter((input)=>input.value !== '' && Number.isFinite(parseFloat(input.value))).map((input)=>({
                    variantLabel: input.dataset.variantLabel,
                    variantOption: input.dataset.variantOption,
                    qty: parseFloat(input.value)
                }));
            const hasBase = Number.isFinite(qty) && qty > 0;
            // Amounts can come from the base field, the per-variant fields, or both -
            // but at least one of them. A blank base with per-variant amounts stores
            // a 0-qty base row (options without their own amount then use nothing).
            if (!hasBase && !overrides.length) {
                errEl.textContent = 'Enter how much one sale uses - either the base amount or the per-variant amounts.';
                return;
            }
            close();
            this._addLinkHandler?.(picked._id, item.id, hasBase ? qty : 0, overrides);
        });
    }
    _requirePoDate(overlay) {
        const errEl = overlay.querySelector('#invPoError');
        const date = overlay.querySelector('#invPoExpected').value;
        if (!date) {
            errEl.textContent = 'Pick the expected or actual delivery date.';
            return null;
        }
        return date;
    }
    // ── Section: Purchase Orders ────────────────────────────────────────────────
    _renderPoSection() {
        const pos = this._data.purchaseOrders ?? [];
        const q = this._poQuery.trim().toLowerCase();
        let visible = pos;
        if (q) visible = visible.filter((p)=>$b0886db79b2df847$var$fmtPo(p.poNumber).toLowerCase().includes(q) || (p.supplierName ?? '').toLowerCase().includes(q));
        if (this._poStatusFilter !== 'all') visible = visible.filter((p)=>this._poDisplayStatus(p) === this._poStatusFilter);
        if (this._poDateRange !== 'all') visible = visible.filter((p)=>this._inDateRange(p.createdAt, this._poDateRange, this._poDateFrom, this._poDateTo));
        const open = pos.filter((p)=>p.status === 'draft' || p.status === 'sent');
        const sent = pos.filter((p)=>p.status === 'sent');
        const overdue = pos.filter((p)=>this._poDisplayStatus(p) === 'overdue');
        const now = new Date();
        const monthTotal = pos.filter((p)=>p.status !== 'cancelled' && new Date(p.createdAt).getMonth() === now.getMonth() && new Date(p.createdAt).getFullYear() === now.getFullYear()).reduce((s, p)=>s + this._poTotal(p), 0);
        const { pageItems: pageItems, page: page, totalPages: totalPages, total: total, start: start } = (0, $8c6cc8386f59a55a$export$2660a47c412cb681)(visible, this._poPage, this._poPageSize);
        this._poPage = page;
        const rows = pageItems.map((po)=>`
      <div class="inv-tr inv-tr--po" data-id="${po.id}" role="button" tabindex="0">
        <span class="inv-td inv-td-name">${$b0886db79b2df847$var$fmtPo(po.poNumber)}</span>
        <span class="inv-td" data-th="Supplier">${po.supplierName ? (0, $cnCXJ.esc)(po.supplierName) : '<span class="inv-dim">No supplier</span>'}</span>
        <span class="inv-td" data-th="Items">${po.lines.length} item${po.lines.length === 1 ? '' : 's'}</span>
        <span class="inv-td" data-th="Status">${this._poPill(po)}</span>
        <span class="inv-td" data-th="Expected">${po.expectedDate ? $b0886db79b2df847$var$fmtDate(po.expectedDate) : '<span class="inv-dim">-</span>'}</span>
        <span class="inv-td" data-th="Total">${(0, $coRoT.formatMoney)(this._poTotal(po))}</span>
        <span class="inv-td inv-td--updated" data-th="Created by">${po.createdByName ? (0, $cnCXJ.esc)(po.createdByName) : '-'}</span>
      </div>`).join('');
        const statusChips = [
            [
                'all',
                'All'
            ],
            [
                'draft',
                'For approval'
            ],
            [
                'sent',
                'Waiting'
            ],
            [
                'overdue',
                'Overdue'
            ],
            [
                'received',
                'Received'
            ],
            [
                'cancelled',
                'Cancelled'
            ]
        ];
        this._content.innerHTML = `
      <div class="invx-stats">
        ${this._statTile({
            icon: "\uD83D\uDCCB",
            label: 'Open orders',
            value: open.length,
            sub: open.length ? 'For approval or on the way' : 'Nothing on order'
        })}
        ${this._statTile({
            icon: "\uD83D\uDE9A",
            label: 'Waiting for delivery',
            value: sent.length,
            filter: sent.length ? 'po:sent' : null,
            sub: sent.length ? null : 'Nothing on the way'
        })}
        ${this._statTile({
            icon: "\u23F0",
            label: 'Overdue',
            value: overdue.length,
            tone: 'crit',
            filter: overdue.length ? 'po:overdue' : null,
            sub: overdue.length ? null : 'All on time'
        })}
        ${this._moneyTile("\uD83D\uDCB0", 'Ordered this month', monthTotal)}
      </div>
      <div class="invx-toolbar">
        <div class="invx-search">
          ${$b0886db79b2df847$var$icons.search}
          <input type="search" id="invPoSearch" placeholder="Search orders or suppliers..." autocomplete="off" value="${(0, $cnCXJ.esc)(this._poQuery)}" />
        </div>
        <div class="inv-chiprow" id="invPoStatusChips">
          ${statusChips.map(([f, l])=>`
            <button class="inv-chip${this._poStatusFilter === f ? ' inv-chip--active' : ''}" data-filter="${f}" type="button">${l}</button>`).join('')}
        </div>
        <div class="inv-daterow" id="invPoDateRow">
          ${this._dateRangeControls('invPoDate', this._poDateRange, this._poDateFrom, this._poDateTo)}
        </div>
        <button class="btn primary invx-new-btn" id="invNewPoBtn" type="button">${$b0886db79b2df847$var$icons.plusCircle} New Purchase Order</button>
      </div>
      ${visible.length ? `
        <div class="inv-table inv-table--po" id="invPoTable">
          <div class="inv-thead">
            <span>Order</span><span>Supplier</span><span>Items</span><span>Status</span>
            <span>Expected</span><span>Total</span><span>Created by</span>
          </div>
          ${rows}
        </div>
        ${(0, $8c6cc8386f59a55a$export$e97ab1b483e292e5)('invPoPager', {
            page: page,
            totalPages: totalPages,
            total: total,
            start: start,
            count: pageItems.length,
            pageSize: this._poPageSize,
            pageSizeOptions: [
                10,
                25,
                50
            ],
            label: 'orders'
        })}` : `
        <div class="invx-empty">
          <div class="invx-empty-icon">\u{1F4CB}</div>
          <p class="invx-empty-title">${q || this._poStatusFilter !== 'all' || this._poDateRange !== 'all' ? 'No orders match.' : 'No purchase orders yet'}</p>
          ${q || this._poStatusFilter !== 'all' || this._poDateRange !== 'all' ? '' : `<p class="invx-empty-sub">Draft an order for the stock you need to buy. When it arrives, mark it received and everything is added to stock automatically.</p>`}
        </div>`}
    `;
        document.getElementById('invPoSearch')?.addEventListener('input', (e)=>{
            this._poQuery = e.target.value;
            this._poPage = 1;
            const scroll = this._content.scrollTop;
            this._renderPoSection();
            this._content.scrollTop = scroll;
            const input = document.getElementById('invPoSearch');
            if (input) {
                input.focus();
                input.setSelectionRange(input.value.length, input.value.length);
            }
        });
        document.getElementById('invNewPoBtn')?.addEventListener('click', ()=>this._showPoModal());
        document.getElementById('invPoStatusChips')?.addEventListener('click', (e)=>{
            const chip = e.target.closest('.inv-chip');
            if (!chip) return;
            this._poStatusFilter = chip.dataset.filter;
            this._poPage = 1;
            this._renderPoSection();
        });
        document.getElementById('invPoDateRow')?.addEventListener('change', (e)=>{
            if (e.target.id === 'invPoDateRange') this._poDateRange = e.target.value;
            else if (e.target.id === 'invPoDateFrom') this._poDateFrom = e.target.value;
            else if (e.target.id === 'invPoDateTo') this._poDateTo = e.target.value;
            else return;
            this._poPage = 1;
            this._renderPoSection();
        });
        document.getElementById('invPoTable')?.addEventListener('click', (e)=>{
            const row = e.target.closest('.inv-tr');
            if (row) this._openDetail('po', row.dataset.id);
        });
        (0, $8c6cc8386f59a55a$export$b9eef545e49d09b)('invPoPager', (p)=>{
            this._poPage = p;
            this._renderPoSection();
        }, (n)=>{
            this._poPageSize = n;
            this._poPage = 1;
            this._renderPoSection();
        });
    }
    _poDrawerHtml(po) {
        const supplier = po.supplierId ? (this._data.suppliers ?? []).find((s)=>s.id === po.supplierId) : null;
        const linesTotal = (po.lines ?? []).reduce((s, l)=>s + l.qty * (l.unitCost ?? 0), 0);
        const lineRows = (po.lines ?? []).map((l)=>`
      <div class="inv-po-line">
        ${l.inventoryItemId ? `<button class="inv-po-line-name inv-po-line-name--link" data-act="open-line-item" data-id="${l.inventoryItemId}" type="button" title="View this item">${(0, $cnCXJ.esc)(l.itemName)}</button>` : `<span class="inv-po-line-name">${(0, $cnCXJ.esc)(l.itemName)}</span>`}
        <span class="inv-po-line-qty">${$b0886db79b2df847$var$fmtQty(l.qty)} ${(0, $cnCXJ.esc)(l.unit)}</span>
        <span class="inv-po-line-cost">${l.unitCost != null ? (0, $coRoT.formatMoney)(l.unitCost) : '-'}</span>
        <span class="inv-po-line-total">${l.unitCost != null ? (0, $coRoT.formatMoney)(l.qty * l.unitCost) : '-'}</span>
      </div>`).join('');
        const actions = po.status === 'draft' ? `
        <button class="btn primary" data-act="send" type="button">Approve order</button>
        <button class="btn" data-act="receive" type="button">Mark as received</button>
        <button class="btn" data-act="edit" type="button">${$b0886db79b2df847$var$icons.edit} Edit</button>
        <button class="btn inv-btn-text-danger" data-act="cancel-po" type="button">Cancel order</button>` : po.status === 'sent' ? `
        <button class="btn primary" data-act="receive" type="button">Mark as received</button>
        <button class="btn inv-btn-text-danger" data-act="cancel-po" type="button">Cancel order</button>` : '';
        return `
      <div class="inv-drawer-head">
        <div class="inv-drawer-titles">
          <h3 class="inv-drawer-title">${$b0886db79b2df847$var$fmtPo(po.poNumber)}</h3>
          <p class="inv-drawer-sub">${po.supplierName ? (0, $cnCXJ.esc)(po.supplierName) : 'No supplier'}${po.createdByName ? ` \xb7 by ${(0, $cnCXJ.esc)(po.createdByName)}` : ''}</p>
        </div>
        ${this._poPill(po)}
        <button class="inv-drawer-close" type="button" aria-label="Close details">&times;</button>
      </div>
      <div class="inv-drawer-body">
        <div class="inv-meta-rows">
          <div class="inv-meta-row"><span>Created</span><span>${$b0886db79b2df847$var$fmtDate(po.createdAt)}</span></div>
          ${po.sentAt ? `<div class="inv-meta-row"><span>Sent</span><span>${$b0886db79b2df847$var$fmtDate(po.sentAt)}</span></div>` : ''}
          <div class="inv-meta-row"><span>Expected delivery</span><span>${po.expectedDate ? $b0886db79b2df847$var$fmtDate(po.expectedDate) : '-'}</span></div>
          ${po.receivedAt ? `<div class="inv-meta-row"><span>Received</span><span>${$b0886db79b2df847$var$fmtDate(po.receivedAt)}</span></div>` : ''}
          ${po.cancelledAt ? `<div class="inv-meta-row"><span>Cancelled</span><span>${$b0886db79b2df847$var$fmtDate(po.cancelledAt)}</span></div>` : ''}
          ${po.receiptUrl ? `<div class="inv-meta-row"><span>Receipt</span><span><button class="inv-inline-link" data-act="view-receipt" type="button">View receipt</button></span></div>` : ''}
        </div>
        ${supplier && (supplier.phone || supplier.email) ? `
          <p class="inv-drawer-hint">Order with ${(0, $cnCXJ.esc)(supplier.name)} however you normally do:${supplier.phone ? ` ${$b0886db79b2df847$var$icons.phone} ${(0, $cnCXJ.esc)(supplier.phone)}` : ''}${supplier.email ? ` \xb7 ${$b0886db79b2df847$var$icons.mail} ${(0, $cnCXJ.esc)(supplier.email)}` : ''}</p>` : ''}
        <h4 class="inv-drawer-section">Items (${po.lines.length})</h4>
        <div class="inv-po-line inv-po-line--head">
          <span>Item</span><span>Qty</span><span>Unit cost</span><span>Total</span>
        </div>
        ${lineRows || `<p class="inv-drawer-none">No items on this order.</p>`}
        <div class="inv-meta-rows inv-po-totals">
          <div class="inv-meta-row"><span>Subtotal</span><span>${(0, $coRoT.formatMoney)(linesTotal)}</span></div>
          ${po.tax != null ? `<div class="inv-meta-row"><span>Tax</span><span>${(0, $coRoT.formatMoney)(po.tax)}</span></div>` : ''}
          ${po.shipping != null ? `<div class="inv-meta-row"><span>Shipping</span><span>${(0, $coRoT.formatMoney)(po.shipping)}</span></div>` : ''}
          <div class="inv-meta-row inv-meta-row--total"><span>Total</span><span>${(0, $coRoT.formatMoney)(this._poTotal(po))}</span></div>
        </div>
        ${po.notes ? `<h4 class="inv-drawer-section">Notes</h4><p class="inv-drawer-notes">${(0, $cnCXJ.esc)(po.notes)}</p>` : ''}
        ${actions ? `<div class="inv-drawer-actions inv-drawer-actions--stack">${actions}</div>` : ''}
      </div>`;
    }
    _wirePoDrawer(poId) {
        const po = (this._data.purchaseOrders ?? []).find((p)=>p.id === poId);
        if (!po) return;
        const d = this._drawer;
        d.querySelectorAll('[data-act="open-line-item"]').forEach((b)=>b.addEventListener('click', ()=>this._openDetail('item', b.dataset.id)));
        d.querySelector('[data-act="view-receipt"]')?.addEventListener('click', ()=>(0, $b7dfaa8509a8211e$export$78f5d28b604adfe0)(po.receiptUrl, `Receipt for ${$b0886db79b2df847$var$fmtPo(po.poNumber)}`));
        d.querySelector('[data-act="send"]')?.addEventListener('click', ()=>this._poStatusHandler?.(po.id, 'sent'));
        d.querySelector('[data-act="edit"]')?.addEventListener('click', ()=>this._showPoModal(po));
        d.querySelector('[data-act="cancel-po"]')?.addEventListener('click', ()=>{
            this._showConfirmModal({
                title: `Cancel ${$b0886db79b2df847$var$fmtPo(po.poNumber)}?`,
                message: 'Nothing is added to stock. The order stays in the list as cancelled.',
                confirmLabel: 'Cancel order',
                onConfirm: ()=>this._poStatusHandler?.(po.id, 'cancelled')
            });
        });
        d.querySelector('[data-act="receive"]')?.addEventListener('click', ()=>{
            const n = po.lines.filter((l)=>l.inventoryItemId && l.qty > 0).length;
            this._showConfirmModal({
                title: `Receive ${$b0886db79b2df847$var$fmtPo(po.poNumber)}?`,
                message: `${n} item${n === 1 ? '' : 's'} will be added to stock. This cannot be undone.`,
                confirmLabel: 'Add to stock',
                onConfirm: ()=>this._receivePoHandler?.(po.id)
            });
        });
    }
    // Create (po = null) or edit a DRAFT purchase order. The cost column asks
    // for the LINE TOTAL (what you pay for the whole quantity) - the per-piece
    // cost is derived by division, and tax + shipping get spread into the
    // per-piece cost when the order is received (landed cost, server-side).
    _showPoModal(po = null, opts = {}) {
        const isEdit = !!po;
        const items = this._data.items ?? [];
        const suppliers = this._data.suppliers ?? [];
        const preSupplier = po?.supplierId ?? opts.supplierId ?? null;
        const initialLines = po?.lines?.length ? po.lines : opts.prefill?.length ? opts.prefill : [
            null
        ];
        const overlay = document.createElement('div');
        overlay.className = 'modal-overlay-form';
        overlay.style.zIndex = '99999';
        const tip = (text)=>`<span class="pb-tip" tabindex="0" role="img" aria-label="More info" data-tip="${(0, $cnCXJ.esc)(text)}">i</span>`;
        // Stored unitCost is per-piece; the form shows the line TOTAL. Each line
        // is a small card: item on top, labeled Qty + Total cost below, with a
        // live "= X each" hint once both are filled.
        const lineRowHtml = (line = null)=>{
            const qtyNum = Number(line?.qty);
            const lineTotal = line && line.unitCost != null && Number.isFinite(qtyNum) && qtyNum > 0 ? Math.round(qtyNum * line.unitCost * 100) / 100 : '';
            const lineItem = line?.inventoryItemId ? items.find((i)=>i.id === line.inventoryItemId) : null;
            const qtyLabel = lineItem ? `Qty (${(0, $cnCXJ.esc)(lineItem.unit)})` : 'Qty';
            return `
      <div class="inv-po-form-line">
        <div class="inv-po-form-line-top">
          <select class="inv-po-item-select" aria-label="Item">
            <option value="">Pick an item...</option>
            <option value="__new__">+ Add a new item...</option>
            ${items.map((i)=>`<option value="${i.id}"${line?.inventoryItemId === i.id ? ' selected' : ''}>${(0, $cnCXJ.esc)(i.name)} (${(0, $cnCXJ.esc)(i.unit)})</option>`).join('')}
          </select>
          <button class="inv-usedby-remove" data-act="remove-line" type="button" aria-label="Remove line">&times;</button>
        </div>
        <div class="inv-po-form-line-bottom">
          <label class="inv-po-mini-field">
            <span class="inv-po-qty-label">${qtyLabel}</span>
            <input type="number" class="inv-po-qty" min="0" step="any" placeholder="0" aria-label="Quantity" value="${line?.qty ?? ''}" />
          </label>
          <label class="inv-po-mini-field">
            <span>Total cost (${(0, $coRoT.currencySymbol)()})</span>
            <input type="number" class="inv-po-cost" min="0" step="0.01" placeholder="0.00" aria-label="Total cost for this line" value="${lineTotal}" />
          </label>
          <span class="inv-po-line-sum"></span>
        </div>
      </div>`;
        };
        overlay.innerHTML = `
      <div class="invx-modal-card invx-modal-card--wide">
        <button class="modal-close-btn" type="button">&times;</button>
        <h3 class="invx-modal-title">${isEdit ? `Edit ${$b0886db79b2df847$var$fmtPo(po.poNumber)}` : 'New Purchase Order'}</h3>
        <div class="invx-field-row">
          <div class="invx-field">
            <label for="invPoSupplier">Supplier</label>
            <select id="invPoSupplier">
              <option value="">No supplier</option>
              ${suppliers.map((s)=>`<option value="${s.id}"${preSupplier === s.id ? ' selected' : ''}>${(0, $cnCXJ.esc)(s.name)}</option>`).join('')}
            </select>
          </div>
          <div class="invx-field">
            <label for="invPoExpected">Expected or actual delivery date <span class="inv-req" aria-hidden="true">*</span></label>
            <input type="date" id="invPoExpected" value="${po?.expectedDate ?? new Intl.DateTimeFormat('sv-SE').format(new Date())}" />
          </div>
        </div>
        <p class="adj-form-sublabel">Items to order ${tip('Cost = what you pay for the WHOLE quantity of that line, not per piece. The per-piece cost is worked out automatically.')}</p>
        <div id="invPoLines">${initialLines.map(lineRowHtml).join('')}</div>
        <button class="inv-add-link-btn inv-add-link-btn--strong" id="invPoAddLine" type="button">${$b0886db79b2df847$var$icons.plusCircle} Add another item</button>
        <div class="invx-field-row">
          <div class="invx-field">
            <label for="invPoTax">Tax (${(0, $coRoT.currencySymbol)()}) ${tip("Spread into each item\u2019s per-piece cost when the order is received, so your inventory value reflects what things really cost you.")}</label>
            <input type="number" id="invPoTax" min="0" step="0.01" placeholder="0" value="${po?.tax ?? ''}" />
          </div>
          <div class="invx-field">
            <label for="invPoShipping">Shipping (${(0, $coRoT.currencySymbol)()}) ${tip('Also spread into the per-piece cost on receive, same as tax.')}</label>
            <input type="number" id="invPoShipping" min="0" step="0.01" placeholder="0" value="${po?.shipping ?? ''}" />
          </div>
        </div>
        <div class="invx-field">
          <label for="invPoReceipt">Receipt photo ${tip('A photo of the supplier receipt or invoice, kept with this order. Max 5 MB - big photos are shrunk automatically.')}</label>
          <input type="file" id="invPoReceipt" accept="image/*" />
          ${isEdit && po.receiptUrl ? `<p class="inv-po-receipt-note">A receipt is already attached - choosing a new file replaces it.</p>` : ''}
        </div>
        <div class="invx-field">
          <label for="invPoNotes">Notes</label>
          <textarea id="invPoNotes" rows="2" maxlength="500" placeholder="e.g. Deliver before 10 AM">${po?.notes ? (0, $cnCXJ.esc)(po.notes) : ''}</textarea>
        </div>
        <p class="inv-po-grand" id="invPoGrand"></p>
        <p class="invx-modal-error" id="invPoError"></p>
        <div class="adj-form-actions">
          <button type="button" class="btn" data-act="cancel">Cancel</button>
          ${isEdit ? `
          <button type="button" class="btn primary" data-act="save">Save changes</button>` : `
          <div class="inv-split">
            <button type="button" class="btn primary inv-split-main" data-act="save" data-status="draft">Create - for approval</button>
            <button type="button" class="btn primary inv-split-caret" data-act="save-menu" aria-haspopup="true" aria-expanded="false" aria-label="More create options">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>
            </button>
            <div class="inv-split-menu hidden" id="invPoSplitMenu" role="menu">
              <button type="button" role="menuitem" data-status="draft"><strong>For approval</strong><small>Save it - approve later to count it as ordered</small></button>
              <button type="button" role="menuitem" data-status="sent"><strong>Waiting for delivery</strong><small>Already ordered from the supplier</small></button>
              <button type="button" role="menuitem" data-status="received"><strong>Received</strong><small>Already have it - add everything to stock now</small></button>
            </div>
          </div>`}
        </div>
      </div>`;
        document.body.appendChild(overlay);
        const close = ()=>overlay.remove();
        overlay.querySelector('.modal-close-btn').addEventListener('click', close);
        overlay.querySelector('[data-act="cancel"]').addEventListener('click', close);
        const linesEl = overlay.querySelector('#invPoLines');
        const recalc = ()=>{
            let total = 0;
            linesEl.querySelectorAll('.inv-po-form-line').forEach((row)=>{
                const qty = parseFloat(row.querySelector('.inv-po-qty').value) || 0;
                const lineTotal = parseFloat(row.querySelector('.inv-po-cost').value) || 0;
                // The hint shows the derived per-piece cost (empty until computable).
                const sumEl = row.querySelector('.inv-po-line-sum');
                sumEl.textContent = qty > 0 && lineTotal > 0 ? `= ${(0, $coRoT.formatMoney)(lineTotal / qty)} each` : '';
                total += lineTotal;
            });
            total += parseFloat(overlay.querySelector('#invPoTax').value) || 0;
            total += parseFloat(overlay.querySelector('#invPoShipping').value) || 0;
            overlay.querySelector('#invPoGrand').textContent = `Order total: ${(0, $coRoT.formatMoney)(total)}`;
        };
        // Prefill the line total from the item's known per-piece cost x qty, but
        // only while the cost box is empty (never fight the user's typing).
        const prefillLine = (row)=>{
            const pool = this._data?.items ?? items; // fresh list after a quick-add
            const item = pool.find((i)=>i.id === row.querySelector('.inv-po-item-select').value);
            const qty = parseFloat(row.querySelector('.inv-po-qty').value);
            const costEl = row.querySelector('.inv-po-cost');
            if (item && Number.isFinite(qty) && qty > 0 && costEl.value === '') {
                // Prefer the SELECTED supplier's price for this item; fall back to the
                // item's own unit cost.
                const supplierId = overlay.querySelector('#invPoSupplier')?.value || null;
                const supRow = supplierId ? (this._data?.itemSuppliers ?? []).find((r)=>r.inventoryItemId === item.id && r.supplierId === supplierId) : null;
                const per = supRow?.unitCost ?? item.unitCost;
                if (per != null) costEl.value = Math.round(per * qty * 100) / 100;
            }
            // The Qty label speaks the picked item's unit: "Qty (pc)", "Qty (g)"...
            const lbl = row.querySelector('.inv-po-qty-label');
            if (lbl) lbl.textContent = item ? `Qty (${item.unit})` : 'Qty';
        };
        // Rebuild every line's item options from fresh data (after a quick-add).
        const refreshItemSelects = ()=>{
            const fresh = this._data?.items ?? items;
            overlay.querySelectorAll('.inv-po-item-select').forEach((sel)=>{
                const current = sel.value;
                sel.innerHTML = `
          <option value="">Pick an item...</option>
          <option value="__new__">+ Add a new item...</option>
          ${fresh.map((i)=>`<option value="${i.id}">${(0, $cnCXJ.esc)(i.name)} (${(0, $cnCXJ.esc)(i.unit)})</option>`).join('')}`;
                sel.value = current;
            });
        };
        linesEl.addEventListener('change', (e)=>{
            const select = e.target.closest('.inv-po-item-select');
            const row = e.target.closest('.inv-po-form-line');
            // "+ Add a new item...": quick-create without leaving the order. The new
            // item lands back in THIS line, selected, with its cost prefilled.
            if (select && select.value === '__new__') {
                select.value = ''; // cancelling the quick-add leaves a clean picker
                this._showItemModal(null, {
                    onSaved: (created)=>{
                        refreshItemSelects();
                        select.value = created.id;
                        prefillLine(row);
                        recalc();
                    }
                });
                return;
            }
            if (row) prefillLine(row);
            recalc();
        });
        linesEl.addEventListener('input', (e)=>{
            const row = e.target.closest('.inv-po-form-line');
            if (row && e.target.classList.contains('inv-po-qty')) prefillLine(row);
            recalc();
        });
        overlay.querySelector('#invPoTax').addEventListener('input', recalc);
        overlay.querySelector('#invPoShipping').addEventListener('input', recalc);
        // Switching supplier re-prefills any still-empty cost boxes with that
        // supplier's prices.
        overlay.querySelector('#invPoSupplier').addEventListener('change', ()=>{
            linesEl.querySelectorAll('.inv-po-form-line').forEach((row)=>prefillLine(row));
            recalc();
        });
        linesEl.addEventListener('click', (e)=>{
            const btn = e.target.closest('[data-act="remove-line"]');
            if (!btn) return;
            if (linesEl.querySelectorAll('.inv-po-form-line').length > 1) btn.closest('.inv-po-form-line').remove();
            else btn.closest('.inv-po-form-line').querySelectorAll('input, select').forEach((el)=>{
                el.value = '';
            });
            recalc();
        });
        overlay.querySelector('#invPoAddLine').addEventListener('click', ()=>{
            linesEl.insertAdjacentHTML('beforeend', lineRowHtml());
            recalc();
        });
        recalc();
        // Shared save path. initialStatus: null for edits, else the split-button
        // pick (Gmail-style: the main button saves as "for approval"; the chevron
        // menu offers "waiting for delivery" / "received").
        const doSave = (initialStatus)=>{
            const errEl = overlay.querySelector('#invPoError');
            const lines = [
                ...linesEl.querySelectorAll('.inv-po-form-line')
            ].map((row)=>{
                const qty = parseFloat(row.querySelector('.inv-po-qty').value);
                const rawTotal = row.querySelector('.inv-po-cost').value;
                const lineTotal = rawTotal === '' ? null : parseFloat(rawTotal);
                return {
                    inventoryItemId: row.querySelector('.inv-po-item-select').value || null,
                    qty: qty,
                    // Stored per-piece: the entered line total divided by quantity.
                    unitCost: lineTotal == null || !Number.isFinite(qty) || qty <= 0 ? null : lineTotal / qty
                };
            }).filter((l)=>l.inventoryItemId && Number.isFinite(l.qty) && l.qty > 0);
            if (!lines.length) {
                errEl.textContent = 'Add at least one item with a quantity.';
                return;
            }
            const expectedDate = this._requirePoDate(overlay);
            if (!expectedDate) return;
            const data = {
                supplierId: overlay.querySelector('#invPoSupplier').value || null,
                expectedDate: expectedDate,
                notes: overlay.querySelector('#invPoNotes').value.trim(),
                tax: overlay.querySelector('#invPoTax').value,
                shipping: overlay.querySelector('#invPoShipping').value,
                receiptFile: overlay.querySelector('#invPoReceipt')?.files?.[0] ?? null,
                initialStatus: initialStatus,
                lines: lines
            };
            close();
            if (isEdit) this._updatePoHandler?.(po.id, data);
            else this._createPoHandler?.(data);
        };
        if (isEdit) overlay.querySelector('[data-act="save"]').addEventListener('click', ()=>doSave(null));
        else {
            overlay.querySelector('.inv-split-main').addEventListener('click', ()=>doSave('draft'));
            const caret = overlay.querySelector('.inv-split-caret');
            const menu = overlay.querySelector('#invPoSplitMenu');
            caret.addEventListener('click', (e)=>{
                e.stopPropagation();
                const open = menu.classList.toggle('hidden');
                caret.setAttribute('aria-expanded', String(!open));
            });
            menu.querySelectorAll('[data-status]').forEach((btn)=>btn.addEventListener('click', ()=>doSave(btn.dataset.status)));
            overlay.addEventListener('click', (e)=>{
                if (!e.target.closest('.inv-split')) {
                    menu.classList.add('hidden');
                    caret.setAttribute('aria-expanded', 'false');
                }
            });
        }
    }
    // ── Section: Suppliers ──────────────────────────────────────────────────────
    _renderSuppliersSection() {
        const suppliers = this._data.suppliers ?? [];
        const pos = this._data.purchaseOrders ?? [];
        const q = this._supplierQuery.trim().toLowerCase();
        const visible = q ? suppliers.filter((s)=>s.name.toLowerCase().includes(q) || (s.contactName ?? '').toLowerCase().includes(q)) : suppliers;
        const openPoCount = (id)=>pos.filter((p)=>p.supplierId === id && (p.status === 'draft' || p.status === 'sent')).length;
        const lastOrder = (id)=>{
            const latest = pos.find((p)=>p.supplierId === id); // purchaseOrders is newest-first
            return latest ? $b0886db79b2df847$var$fmtDate(latest.createdAt) : '-';
        };
        const rows = visible.map((s)=>`
      <div class="inv-tr inv-tr--supplier" data-id="${s.id}" role="button" tabindex="0">
        <span class="inv-td inv-td--item">
          <span class="invx-tile invx-tile--sm" style="background:${$b0886db79b2df847$var$tileColor(s.name)}">${(0, $cnCXJ.esc)((s.name.trim()[0] || '?').toUpperCase())}</span>
          <span class="inv-td-stack">
            <span class="inv-td-name">${(0, $cnCXJ.esc)(s.name)}</span>
          </span>
        </span>
        <span class="inv-td" data-th="Contact">${s.contactName || s.email || s.phone ? `${s.contactName ? (0, $cnCXJ.esc)(s.contactName) : ''}${s.contactName && (s.email || s.phone) ? '<br/>' : ''}<span class="inv-td-sub">${(0, $cnCXJ.esc)(s.email || s.phone || '')}</span>` : '<span class="inv-dim">-</span>'}</span>
        <span class="inv-td" data-th="Lead time">${s.leadTimeDays != null ? `${s.leadTimeDays} day${s.leadTimeDays === 1 ? '' : 's'}` : '<span class="inv-dim">-</span>'}</span>
        <span class="inv-td" data-th="Payment terms">${s.paymentTerms ? (0, $cnCXJ.esc)(s.paymentTerms) : '<span class="inv-dim">-</span>'}</span>
        <span class="inv-td" data-th="Status">${this._supplierPill(s)}</span>
        <span class="inv-td" data-th="Open POs">${openPoCount(s.id) || '<span class="inv-dim">0</span>'}</span>
        <span class="inv-td inv-td--updated" data-th="Last order">${lastOrder(s.id)}</span>
      </div>`).join('');
        this._content.innerHTML = `
      <div class="invx-stats">
        ${this._statTile({
            icon: "\uD83E\uDD1D",
            value: suppliers.length,
            label: 'Suppliers'
        })}
        ${this._statTile({
            icon: "\u2B50",
            value: suppliers.filter((s)=>s.status === 'preferred').length,
            label: 'Preferred'
        })}
        ${this._statTile({
            icon: "\u23F8\uFE0F",
            value: suppliers.filter((s)=>s.status === 'on_hold').length,
            label: 'On hold'
        })}
      </div>
      <div class="invx-toolbar">
        <div class="invx-search">
          ${$b0886db79b2df847$var$icons.search}
          <input type="search" id="invSupplierSearch" placeholder="Search suppliers..." autocomplete="off" value="${(0, $cnCXJ.esc)(this._supplierQuery)}" />
        </div>
        <button class="btn primary invx-new-btn" id="invNewSupplierBtn" type="button">${$b0886db79b2df847$var$icons.plusCircle} Add Supplier</button>
      </div>
      ${visible.length ? `
        <div class="inv-table inv-table--supplier" id="invSupplierTable">
          <div class="inv-thead">
            <span>Supplier</span><span>Contact</span><span>Lead time</span><span>Payment terms</span>
            <span>Status</span><span>Open POs</span><span>Last order</span>
          </div>
          ${rows}
        </div>` : `
        <div class="invx-empty">
          <div class="invx-empty-icon">\u{1F91D}</div>
          <p class="invx-empty-title">${q ? 'No suppliers match.' : 'No suppliers yet'}</p>
          ${q ? '' : `<p class="invx-empty-sub">Suppliers are optional. Add the vendors you buy from if you want their contact details and purchase orders in one place.</p>`}
        </div>`}
    `;
        document.getElementById('invSupplierSearch')?.addEventListener('input', (e)=>{
            this._supplierQuery = e.target.value;
            const scroll = this._content.scrollTop;
            this._renderSuppliersSection();
            this._content.scrollTop = scroll;
            const input = document.getElementById('invSupplierSearch');
            if (input) {
                input.focus();
                input.setSelectionRange(input.value.length, input.value.length);
            }
        });
        document.getElementById('invNewSupplierBtn')?.addEventListener('click', ()=>this._showSupplierModal());
        document.getElementById('invSupplierTable')?.addEventListener('click', (e)=>{
            const row = e.target.closest('.inv-tr');
            if (row) this._openDetail('supplier', row.dataset.id);
        });
    }
    _supplierDrawerHtml(s) {
        // The SAME item<->supplier price rows the item drawer manages - edited
        // from either side, always in sync (one table underneath).
        const supRows = (this._data.itemSuppliers ?? []).filter((r)=>r.supplierId === s.id);
        const linkedItemIds = new Set(supRows.map((r)=>r.inventoryItemId));
        const unlinkedItems = (this._data.items ?? []).filter((i)=>!linkedItemIds.has(i.id));
        const pos = (this._data.purchaseOrders ?? []).filter((p)=>p.supplierId === s.id).slice(0, 5);
        const itemRows = supRows.map((r)=>{
            const i = (this._data.items ?? []).find((x)=>x.id === r.inventoryItemId);
            if (!i) return '';
            return `
      <div class="inv-isup-row" data-id="${r.id}">
        ${r.preferred ? `<span class="inv-isup-star inv-isup-star--on" title="This supplier is ${(0, $cnCXJ.esc)(i.name)}'s preferred supplier">\u{2605}</span>` : `<span class="inv-isup-star inv-isup-star--ghost" aria-hidden="true"></span>`}
        <button class="inv-isup-name" data-act="open-item" data-id="${i.id}" type="button">${(0, $cnCXJ.esc)(i.name)}</button>
        <button class="inv-isup-price" data-act="edit-sup-price" data-unit="${(0, $cnCXJ.esc)(i.unit)}" type="button" title="Change the price">${r.unitCost != null ? `${(0, $coRoT.formatMoney)(r.unitCost)} / ${(0, $cnCXJ.esc)(i.unit)}` : 'Set price'} ${$b0886db79b2df847$var$icons.edit}</button>
        <button class="inv-usedby-remove" data-act="remove-sup" type="button" aria-label="Unlink item">&times;</button>
      </div>`;
        }).join('');
        const addItemHtml = unlinkedItems.length ? `
      <div class="inv-isup-add">
        <select id="invSupItemPick" class="inv-cat-select" aria-label="Add an item this supplier supplies">
          <option value="">Add an item they supply...</option>
          ${unlinkedItems.map((i)=>`<option value="${i.id}">${(0, $cnCXJ.esc)(i.name)} (${(0, $cnCXJ.esc)(i.unit)})</option>`).join('')}
        </select>
        <input type="number" id="invSupItemPrice" min="0" step="0.01" placeholder="Price" aria-label="Price" />
        <button class="btn" id="invSupItemAddBtn" type="button">Add</button>
      </div>` : '';
        const poRows = pos.map((p)=>`
      <button class="inv-mini-row" data-act="open-po" data-id="${p.id}" type="button">
        <span>${$b0886db79b2df847$var$fmtPo(p.poNumber)} \xb7 ${$b0886db79b2df847$var$fmtDate(p.createdAt)}</span>
        <span class="inv-mini-row-meta">${(0, $coRoT.formatMoney)(this._poTotal(p))} ${this._poPill(p)}</span>
      </button>`).join('');
        return `
      <div class="inv-drawer-head">
        <span class="invx-tile" style="background:${$b0886db79b2df847$var$tileColor(s.name)}">${(0, $cnCXJ.esc)((s.name.trim()[0] || '?').toUpperCase())}</span>
        <div class="inv-drawer-titles">
          <h3 class="inv-drawer-title">${(0, $cnCXJ.esc)(s.name)}</h3>
          <p class="inv-drawer-sub">Supplier</p>
        </div>
        ${this._supplierPill(s)}
        <button class="inv-drawer-close" type="button" aria-label="Close details">&times;</button>
      </div>
      <div class="inv-drawer-body">
        <div class="inv-meta-rows">
          ${s.contactName ? `<div class="inv-meta-row"><span>Contact</span><span>${(0, $cnCXJ.esc)(s.contactName)}</span></div>` : ''}
          ${s.phone ? `<div class="inv-meta-row"><span>Phone</span><span>${(0, $cnCXJ.esc)(s.phone)}</span></div>` : ''}
          ${s.email ? `<div class="inv-meta-row"><span>Email</span><span>${(0, $cnCXJ.esc)(s.email)}</span></div>` : ''}
          ${s.address ? `<div class="inv-meta-row"><span>Address</span><span>${(0, $cnCXJ.esc)(s.address)}</span></div>` : ''}
          ${s.leadTimeDays != null ? `<div class="inv-meta-row"><span>Lead time</span><span>${s.leadTimeDays} day${s.leadTimeDays === 1 ? '' : 's'}</span></div>` : ''}
          ${s.paymentTerms ? `<div class="inv-meta-row"><span>Payment terms</span><span>${(0, $cnCXJ.esc)(s.paymentTerms)}</span></div>` : ''}
          ${s.minOrder ? `<div class="inv-meta-row"><span>Minimum order</span><span>${(0, $cnCXJ.esc)(s.minOrder)}</span></div>` : ''}
        </div>
        ${s.notes ? `<h4 class="inv-drawer-section">Notes</h4><p class="inv-drawer-notes">${(0, $cnCXJ.esc)(s.notes)}</p>` : ''}
        <h4 class="inv-drawer-section">Items they supply (${supRows.length}) <span class="inv-drawer-section-sub">with their price \xb7 \u{2605} = preferred for that item</span></h4>
        ${itemRows || `<p class="inv-drawer-none">No items linked yet - add one below.</p>`}
        ${addItemHtml}
        <h4 class="inv-drawer-section">Recent purchase orders</h4>
        ${poRows || `<p class="inv-drawer-none">No purchase orders yet.</p>`}
        <div class="inv-drawer-actions">
          <button class="btn primary" data-act="new-po" type="button">${$b0886db79b2df847$var$icons.plusCircle} New Purchase Order</button>
          <button class="btn" data-act="edit-supplier" type="button">${$b0886db79b2df847$var$icons.edit} Edit</button>
          <button class="btn inv-btn-icon-danger" data-act="delete-supplier" type="button" aria-label="Delete supplier">${$b0886db79b2df847$var$icons.trash}</button>
        </div>
      </div>`;
    }
    _wireSupplierDrawer(supplierId) {
        const s = (this._data.suppliers ?? []).find((x)=>x.id === supplierId);
        if (!s) return;
        const d = this._drawer;
        d.querySelectorAll('[data-act="open-item"]').forEach((b)=>b.addEventListener('click', ()=>this._openDetail('item', b.dataset.id)));
        // Price list rows (same handlers as the item drawer - shared table).
        d.querySelectorAll('.inv-isup-row').forEach((row)=>{
            const rowId = row.dataset.id;
            row.querySelector('[data-act="remove-sup"]')?.addEventListener('click', ()=>this._removeItemSupplierHandler?.(rowId));
            row.querySelector('[data-act="edit-sup-price"]')?.addEventListener('click', (e)=>{
                const btn = e.currentTarget;
                const unit = btn.dataset.unit ?? '';
                const current = (this._data.itemSuppliers ?? []).find((r)=>r.id === rowId)?.unitCost ?? '';
                const wrap = document.createElement('span');
                wrap.className = 'inv-usedby-editwrap';
                wrap.innerHTML = `
          <input type="number" class="inv-usedby-input" min="0" step="0.01" value="${current}" aria-label="Price" />
          <span class="inv-usedby-unit">/ ${(0, $cnCXJ.esc)(unit)}</span>`;
                btn.replaceWith(wrap);
                const input = wrap.querySelector('input');
                input.focus();
                input.select();
                const commit = ()=>{
                    const price = input.value === '' ? null : parseFloat(input.value);
                    if (price !== current && (price === null || Number.isFinite(price) && price >= 0)) this._supplierCostHandler?.(rowId, price);
                    else this._renderDrawer();
                };
                input.addEventListener('keydown', (ev)=>{
                    if (ev.key === 'Enter') commit();
                    if (ev.key === 'Escape') this._renderDrawer();
                });
                input.addEventListener('blur', commit);
            });
        });
        d.querySelector('#invSupItemAddBtn')?.addEventListener('click', ()=>{
            const itemId = d.querySelector('#invSupItemPick')?.value;
            const price = d.querySelector('#invSupItemPrice')?.value;
            if (itemId) this._addItemSupplierHandler?.(itemId, s.id, price);
        });
        d.querySelectorAll('[data-act="open-po"]').forEach((b)=>b.addEventListener('click', ()=>this._openDetail('po', b.dataset.id)));
        d.querySelector('[data-act="new-po"]')?.addEventListener('click', ()=>this._showPoModal(null, {
                supplierId: s.id
            }));
        d.querySelector('[data-act="edit-supplier"]')?.addEventListener('click', ()=>this._showSupplierModal(s));
        d.querySelector('[data-act="delete-supplier"]')?.addEventListener('click', ()=>{
            this._showConfirmModal({
                title: `Delete ${s.name}?`,
                message: 'Items keep their history and just show no supplier. Past purchase orders keep the name.',
                confirmLabel: 'Delete',
                onConfirm: ()=>{
                    this._closeDetail();
                    this._deleteSupplierHandler?.(s.id);
                }
            });
        });
    }
    _showSupplierModal(s = null) {
        const isEdit = !!s;
        const allItems = this._data?.items ?? [];
        // Edit mode prefills the shared item<->supplier price rows.
        const existingRows = isEdit ? (this._data?.itemSuppliers ?? []).filter((r)=>r.supplierId === s.id) : [];
        const supItemRowHtml = (row = null)=>`
      <div class="inv-sup-form-item">
        <select class="inv-sup-item-select" aria-label="Item they supply">
          <option value="">Pick an item...</option>
          ${allItems.map((i)=>`<option value="${i.id}"${row?.inventoryItemId === i.id ? ' selected' : ''}>${(0, $cnCXJ.esc)(i.name)} (${(0, $cnCXJ.esc)(i.unit)})</option>`).join('')}
        </select>
        <input type="number" class="inv-sup-item-price" min="0" step="0.01" placeholder="Price / unit" aria-label="Price per unit" value="${row?.unitCost ?? ''}" />
        <button class="inv-usedby-remove" data-act="remove-sup-item" type="button" aria-label="Remove row">&times;</button>
      </div>`;
        const overlay = document.createElement('div');
        overlay.className = 'modal-overlay-form';
        overlay.style.zIndex = '99999';
        overlay.innerHTML = `
      <div class="invx-modal-card invx-modal-card--wide">
        <button class="modal-close-btn" type="button">&times;</button>
        <h3 class="invx-modal-title">${isEdit ? 'Edit supplier' : 'Add supplier'}</h3>
        <div class="invx-field">
          <label for="invSupName">Name <span class="inv-req" aria-hidden="true">*</span></label>
          <input type="text" id="invSupName" maxlength="80" placeholder="e.g. Green Bean Co." autocomplete="off" value="${isEdit ? (0, $cnCXJ.esc)(s.name) : ''}" />
        </div>
        <p class="adj-form-sublabel">Items they supply <span class="pb-tip" tabindex="0" role="img" aria-label="More info" data-tip="Pick the inventory items you buy from this supplier and their price per unit. Purchase orders for this supplier prefill these prices. You can also manage this later from the item or supplier details.">i</span></p>
        <div id="invSupItems">${existingRows.length ? existingRows.map(supItemRowHtml).join('') : supItemRowHtml()}</div>
        <button class="inv-add-link-btn inv-add-link-btn--strong" id="invSupAddItemRow" type="button">${$b0886db79b2df847$var$icons.plusCircle} Add another item</button>
        <div class="invx-field-row">
          <div class="invx-field">
            <label for="invSupContact">Contact person</label>
            <input type="text" id="invSupContact" data-filter="name" maxlength="80" placeholder="e.g. John Doe" autocomplete="off" value="${isEdit ? (0, $cnCXJ.esc)(s.contactName ?? '') : ''}" />
          </div>
          <div class="invx-field">
            <label for="invSupPhone">Phone</label>
            <input type="tel" id="invSupPhone" maxlength="15" placeholder="e.g. 5551234567" autocomplete="off" value="${isEdit ? (0, $cnCXJ.esc)(s.phone ?? '') : ''}" />
          </div>
        </div>
        <div class="invx-field-row">
          <div class="invx-field">
            <label for="invSupEmail">Email</label>
            <input type="email" id="invSupEmail" maxlength="120" placeholder="e.g. orders@vendor.com" autocomplete="off" value="${isEdit ? (0, $cnCXJ.esc)(s.email ?? '') : ''}" />
          </div>
          <div class="invx-field">
            <label for="invSupStatus">Status</label>
            <select id="invSupStatus">
              <option value="active"${!isEdit || s.status === 'active' ? ' selected' : ''}>Active</option>
              <option value="preferred"${isEdit && s.status === 'preferred' ? ' selected' : ''}>Preferred</option>
              <option value="on_hold"${isEdit && s.status === 'on_hold' ? ' selected' : ''}>On hold</option>
            </select>
          </div>
        </div>
        <div class="invx-field-row">
          <div class="invx-field">
            <label for="invSupLead">Lead time, days <span class="pb-tip" tabindex="0" role="img" aria-label="More info" data-tip="How many days this supplier usually takes to deliver after you place an order. Helps you time reorders.">i</span></label>
            <input type="number" id="invSupLead" min="0" step="1" placeholder="e.g. 3" value="${isEdit && s.leadTimeDays != null ? s.leadTimeDays : ''}" />
          </div>
          <div class="invx-field">
            <label for="invSupMin">Minimum order <span class="pb-tip" tabindex="0" role="img" aria-label="More info" data-tip="The smallest order this supplier accepts, in money or quantity - e.g. 10 kg or 200.">i</span></label>
            <input type="text" id="invSupMin" maxlength="40" placeholder="e.g. 10 kg" autocomplete="off" value="${isEdit ? (0, $cnCXJ.esc)(s.minOrder ?? '') : ''}" />
          </div>
        </div>
        <div class="invx-field-row">
          <div class="invx-field">
            <label for="invSupTerms">Payment terms <span class="pb-tip" tabindex="0" role="img" aria-label="More info" data-tip="When payment is due. Net 30 means you pay within 30 days of the invoice; COD means cash on delivery.">i</span></label>
            <input type="text" id="invSupTerms" maxlength="40" placeholder="e.g. Net 30" autocomplete="off" value="${isEdit ? (0, $cnCXJ.esc)(s.paymentTerms ?? '') : ''}" />
          </div>
          <div class="invx-field">
            <label for="invSupAddress">Address</label>
            <input type="text" id="invSupAddress" maxlength="160" autocomplete="off" value="${isEdit ? (0, $cnCXJ.esc)(s.address ?? '') : ''}" />
          </div>
        </div>
        <div class="invx-field">
          <label for="invSupNotes">Notes</label>
          <textarea id="invSupNotes" rows="2" maxlength="500" placeholder="e.g. Call before delivery">${isEdit && s.notes ? (0, $cnCXJ.esc)(s.notes) : ''}</textarea>
        </div>
        <p class="invx-modal-error" id="invSupError"></p>
        <div class="adj-form-actions">
          <button type="button" class="btn" data-act="cancel">Cancel</button>
          <button type="button" class="btn primary" data-act="save">${isEdit ? 'Save' : 'Add supplier'}</button>
        </div>
      </div>`;
        document.body.appendChild(overlay);
        const close = ()=>overlay.remove();
        overlay.querySelector('.modal-close-btn').addEventListener('click', close);
        overlay.querySelector('[data-act="cancel"]').addEventListener('click', close);
        overlay.querySelector('#invSupName').focus();
        const supItemsEl = overlay.querySelector('#invSupItems');
        overlay.querySelector('#invSupAddItemRow')?.addEventListener('click', ()=>{
            supItemsEl.insertAdjacentHTML('beforeend', supItemRowHtml());
        });
        supItemsEl?.addEventListener('click', (e)=>{
            const btn = e.target.closest('[data-act="remove-sup-item"]');
            if (!btn) return;
            if (supItemsEl.querySelectorAll('.inv-sup-form-item').length > 1) btn.closest('.inv-sup-form-item').remove();
            else btn.closest('.inv-sup-form-item').querySelectorAll('input, select').forEach((el)=>{
                el.value = '';
            });
        });
        overlay.querySelector('[data-act="save"]').addEventListener('click', ()=>{
            const errEl = overlay.querySelector('#invSupError');
            const name = overlay.querySelector('#invSupName').value.trim();
            if (!name) {
                errEl.textContent = 'Give the supplier a name.';
                return;
            }
            const email = overlay.querySelector('#invSupEmail').value.trim();
            if (email && !email.includes('@')) {
                errEl.textContent = 'That email address does not look right.';
                return;
            }
            // Supplied-items rows: first occurrence wins on duplicates.
            const seen = new Set();
            const supplyItems = [
                ...supItemsEl.querySelectorAll('.inv-sup-form-item')
            ].map((row)=>({
                    inventoryItemId: row.querySelector('.inv-sup-item-select').value || null,
                    unitCost: row.querySelector('.inv-sup-item-price').value
                })).filter((r)=>{
                if (!r.inventoryItemId || seen.has(r.inventoryItemId)) return false;
                seen.add(r.inventoryItemId);
                return true;
            });
            close();
            this._saveSupplierHandler?.(isEdit ? s.id : null, {
                supplyItems: supplyItems,
                name: name,
                contactName: overlay.querySelector('#invSupContact').value,
                phone: overlay.querySelector('#invSupPhone').value,
                email: email,
                address: overlay.querySelector('#invSupAddress').value,
                leadTimeDays: overlay.querySelector('#invSupLead').value,
                paymentTerms: overlay.querySelector('#invSupTerms').value,
                minOrder: overlay.querySelector('#invSupMin').value,
                status: overlay.querySelector('#invSupStatus').value,
                notes: overlay.querySelector('#invSupNotes').value
            });
        });
    }
    // ── Section: Stock Counts ───────────────────────────────────────────────────
    _renderCountsSection() {
        const items = this._data.items ?? [];
        const q = this._countQuery.trim().toLowerCase();
        const visible = q ? items.filter((i)=>i.name.toLowerCase().includes(q)) : items;
        const diffs = this._countDiffs();
        const rows = visible.map((item)=>{
            const raw = this._countDraft.get(item.id) ?? '';
            const counted = raw === '' ? null : parseFloat(raw);
            const hasDiff = counted != null && Number.isFinite(counted) && counted !== item.quantity;
            const delta = hasDiff ? counted - item.quantity : 0;
            return `
        <div class="inv-count-row" data-id="${item.id}">
          <span class="invx-tile invx-tile--sm" style="background:${$b0886db79b2df847$var$tileColor(item.name)}">${(0, $cnCXJ.esc)((item.name.trim()[0] || '?').toUpperCase())}</span>
          <span class="inv-count-name">${(0, $cnCXJ.esc)(item.name)}</span>
          <span class="inv-count-onhand">${$b0886db79b2df847$var$fmtQty(item.quantity)} ${(0, $cnCXJ.esc)(item.unit)}</span>
          <input type="number" class="inv-count-input" min="0" step="any" placeholder="Counted" value="${(0, $cnCXJ.esc)(raw)}" aria-label="Counted quantity for ${(0, $cnCXJ.esc)(item.name)}" />
          <span class="inv-count-diff ${hasDiff ? delta > 0 ? 'invx-delta--pos' : 'invx-delta--neg' : 'inv-count-diff--none'}">
            ${hasDiff ? `${delta > 0 ? '+' : "\u2212"}${$b0886db79b2df847$var$fmtQty(Math.abs(delta))}` : ''}
          </span>
        </div>`;
        }).join('');
        this._content.innerHTML = `
      <p class="inv-count-intro">Walk your shelves and type what you actually have. Blank = skip. Nothing changes until you apply.</p>
      <div class="invx-toolbar">
        <div class="invx-search">
          ${$b0886db79b2df847$var$icons.search}
          <input type="search" id="invCountSearch" placeholder="Search items..." autocomplete="off" value="${(0, $cnCXJ.esc)(this._countQuery)}" />
        </div>
      </div>
      ${visible.length ? `<div class="inv-count-list">${rows}</div>` : `
        <div class="invx-empty">
          <div class="invx-empty-icon">\u{2705}</div>
          <p class="invx-empty-title">${q ? 'No items match.' : 'Nothing to count yet'}</p>
          ${q ? '' : `<p class="invx-empty-sub">Add inventory items first, then use this section to reconcile the real shelf counts.</p>`}
        </div>`}
      <div class="inv-count-footer${diffs.length ? ' inv-count-footer--active' : ''}" id="invCountFooter">
        <span class="inv-count-footer-text">${diffs.length ? `${diffs.length} change${diffs.length === 1 ? '' : 's'} to apply` : 'No changes yet'}</span>
        <button class="btn primary" id="invCountApply" type="button" ${diffs.length ? '' : 'disabled'}>Apply count</button>
      </div>
    `;
        document.getElementById('invCountSearch')?.addEventListener('input', (e)=>{
            this._countQuery = e.target.value;
            const scroll = this._content.scrollTop;
            this._renderCountsSection();
            this._content.scrollTop = scroll;
            const input = document.getElementById('invCountSearch');
            if (input) {
                input.focus();
                input.setSelectionRange(input.value.length, input.value.length);
            }
        });
        this._content.querySelectorAll('.inv-count-input').forEach((input)=>{
            input.addEventListener('input', ()=>{
                const row = input.closest('.inv-count-row');
                this._countDraft.set(row.dataset.id, input.value);
                // Patch just this row's diff chip + the footer (keep typing focus).
                const item = items.find((i)=>i.id === row.dataset.id);
                const counted = input.value === '' ? null : parseFloat(input.value);
                const hasDiff = item && counted != null && Number.isFinite(counted) && counted !== item.quantity;
                const delta = hasDiff ? counted - item.quantity : 0;
                const chip = row.querySelector('.inv-count-diff');
                chip.className = `inv-count-diff ${hasDiff ? delta > 0 ? 'invx-delta--pos' : 'invx-delta--neg' : 'inv-count-diff--none'}`;
                chip.textContent = hasDiff ? `${delta > 0 ? '+' : "\u2212"}${$b0886db79b2df847$var$fmtQty(Math.abs(delta))}` : '';
                const diffsNow = this._countDiffs();
                const footer = document.getElementById('invCountFooter');
                footer.classList.toggle('inv-count-footer--active', diffsNow.length > 0);
                footer.querySelector('.inv-count-footer-text').textContent = diffsNow.length ? `${diffsNow.length} change${diffsNow.length === 1 ? '' : 's'} to apply` : 'No changes yet';
                document.getElementById('invCountApply').disabled = diffsNow.length === 0;
            });
        });
        document.getElementById('invCountApply')?.addEventListener('click', ()=>this._showCountConfirm());
    }
    _countDiffs() {
        const items = this._data?.items ?? [];
        const diffs = [];
        for (const [id, raw] of this._countDraft){
            if (raw === '') continue;
            const counted = parseFloat(raw);
            if (!Number.isFinite(counted) || counted < 0) continue;
            const item = items.find((i)=>i.id === id);
            if (!item || counted === item.quantity) continue;
            diffs.push({
                item: item,
                counted: counted,
                delta: counted - item.quantity
            });
        }
        return diffs;
    }
    _showCountConfirm() {
        const diffs = this._countDiffs();
        if (!diffs.length) return;
        const overlay = document.createElement('div');
        overlay.className = 'modal-overlay-form';
        overlay.style.zIndex = '99999';
        overlay.innerHTML = `
      <div class="invx-modal-card">
        <button class="modal-close-btn" type="button">&times;</button>
        <h3 class="invx-modal-title">Apply this count?</h3>
        <p class="invx-modal-sub">Stock will be set to what you counted. Every change is logged in History.</p>
        <div class="inv-count-summary">
          ${diffs.map((d)=>`
            <div class="inv-count-sum-row">
              <span>${(0, $cnCXJ.esc)(d.item.name)}</span>
              <span class="inv-count-sum-move">${$b0886db79b2df847$var$fmtQty(d.item.quantity)} \u{2192} <strong>${$b0886db79b2df847$var$fmtQty(d.counted)}</strong> ${(0, $cnCXJ.esc)(d.item.unit)}</span>
              <span class="invx-delta ${d.delta > 0 ? 'invx-delta--pos' : 'invx-delta--neg'}">${d.delta > 0 ? '+' : "\u2212"}${$b0886db79b2df847$var$fmtQty(Math.abs(d.delta))}</span>
            </div>`).join('')}
        </div>
        <div class="adj-form-actions">
          <button type="button" class="btn" data-act="cancel">Go back</button>
          <button type="button" class="btn primary" data-act="apply">Apply ${diffs.length} change${diffs.length === 1 ? '' : 's'}</button>
        </div>
      </div>`;
        document.body.appendChild(overlay);
        const close = ()=>overlay.remove();
        overlay.querySelector('.modal-close-btn').addEventListener('click', close);
        overlay.querySelector('[data-act="cancel"]').addEventListener('click', close);
        overlay.querySelector('[data-act="apply"]').addEventListener('click', ()=>{
            close();
            this._countDraft.clear();
            this._applyCountHandler?.(diffs.map((d)=>({
                    inventory_item_id: d.item.id,
                    counted: d.counted
                })));
        });
    }
    // ── Section: History ────────────────────────────────────────────────────────
    _historyKindLabel(adj) {
        const { invoiceLabelFor: invoiceLabelFor } = this._data ?? {};
        if (adj.kind === 'sale') return adj.receiptNumber != null && invoiceLabelFor ? `Sale ${invoiceLabelFor(adj)}` : 'Sale';
        if (adj.kind === 'void') return adj.receiptNumber != null && invoiceLabelFor ? `Void ${invoiceLabelFor(adj)}` : 'Sale voided';
        if (adj.kind === 'po') return 'Received purchase order';
        if (adj.kind === 'count') return 'Stock count';
        return 'Manual adjustment';
    }
    _renderHistorySection() {
        const { items: items, adjustments: adjustments, historyFilter: historyFilter } = this._data;
        const itemOf = (id)=>items.find((i)=>i.id === id);
        const typeOf = (adj)=>adj.kind === 'sale' || adj.kind === 'void' ? 'sale' : adj.kind ?? 'manual';
        let visible = adjustments ?? [];
        if (this._historyTypeFilter !== 'all') visible = visible.filter((a)=>typeOf(a) === this._historyTypeFilter);
        if (this._historyDateRange !== 'all') visible = visible.filter((a)=>this._inDateRange(a.createdAt, this._historyDateRange, this._historyDateFrom, this._historyDateTo));
        const { pageItems: pageItems, page: page, totalPages: totalPages, total: total, start: start } = (0, $8c6cc8386f59a55a$export$2660a47c412cb681)(visible, this._historyPage, this._historyPageSize);
        this._historyPage = page;
        const dayKey = (iso)=>new Date(iso).toDateString();
        const dayLabel = (iso)=>{
            const d = new Date(iso);
            const today = new Date();
            const yest = new Date(Date.now() - 86400000);
            if (d.toDateString() === today.toDateString()) return 'Today';
            if (d.toDateString() === yest.toDateString()) return 'Yesterday';
            return d.toLocaleDateString('en-US', {
                weekday: 'short',
                month: 'short',
                day: 'numeric'
            });
        };
        const groups = [];
        pageItems.forEach((adj)=>{
            const key = dayKey(adj.createdAt);
            let g = groups[groups.length - 1];
            if (!g || g.key !== key) {
                g = {
                    key: key,
                    label: dayLabel(adj.createdAt),
                    rows: []
                };
                groups.push(g);
            }
            g.rows.push(adj);
        });
        const rowHtml = (adj)=>{
            const item = itemOf(adj.inventoryItemId);
            const name = item?.name ?? '(deleted item)';
            const unit = item?.unit ?? '';
            const initial = (name.trim()[0] || '?').toUpperCase();
            return `
      <li class="invx-hist-row">
        <div class="invx-tile invx-tile--sm" style="background:${item ? $b0886db79b2df847$var$tileColor(name) : 'var(--muted)'}">${(0, $cnCXJ.esc)(initial)}</div>
        <div class="invx-hist-main">
          <span class="invx-hist-item">${(0, $cnCXJ.esc)(name)}</span>
          <span class="invx-hist-note">${(0, $cnCXJ.esc)(adj.note || this._historyKindLabel(adj))}</span>
        </div>
        <span class="invx-hist-meta">${adj.staffName ? `${(0, $cnCXJ.esc)(adj.staffName)} \xb7 ` : ''}${$b0886db79b2df847$var$fmtTime(adj.createdAt)}</span>
        <span class="invx-delta ${adj.delta >= 0 ? 'invx-delta--pos' : 'invx-delta--neg'}">
          ${adj.delta >= 0 ? '+' : "\u2212"}${$b0886db79b2df847$var$fmtQty(Math.abs(adj.delta))} ${(0, $cnCXJ.esc)(unit)}
        </span>
      </li>`;
        };
        const typeOpts = [
            [
                'all',
                'All types'
            ],
            [
                'sale',
                'Sales'
            ],
            [
                'po',
                'Purchase orders'
            ],
            [
                'count',
                'Stock counts'
            ],
            [
                'manual',
                'Manual adjustments'
            ]
        ];
        this._content.innerHTML = `
      <div class="invx-toolbar">
        <select id="invHistFilter" class="invx-hist-select">
          <option value="">All items</option>
          ${items.map((i)=>`<option value="${i.id}"${historyFilter === i.id ? ' selected' : ''}>${(0, $cnCXJ.esc)(i.name)}</option>`).join('')}
        </select>
        <select id="invHistTypeFilter" class="inv-cat-select">
          ${typeOpts.map(([v, l])=>`<option value="${v}"${this._historyTypeFilter === v ? ' selected' : ''}>${l}</option>`).join('')}
        </select>
        <div class="inv-daterow" id="invHistDateRow">
          ${this._dateRangeControls('invHistDate', this._historyDateRange, this._historyDateFrom, this._historyDateTo)}
        </div>
      </div>
      ${groups.length ? groups.map((g)=>`
        <p class="invx-day-label">${(0, $cnCXJ.esc)(g.label)}</p>
        <ul class="invx-hist-list">${g.rows.map(rowHtml).join('')}</ul>`).join('') + (0, $8c6cc8386f59a55a$export$e97ab1b483e292e5)('invHistPager', {
            page: page,
            totalPages: totalPages,
            total: total,
            start: start,
            count: pageItems.length,
            pageSize: this._historyPageSize,
            pageSizeOptions: [
                30,
                50,
                100
            ],
            label: 'entries'
        }) : `
        <div class="invx-empty">
          <div class="invx-empty-icon">\u{1F558}</div>
          <p class="invx-empty-title">${this._historyTypeFilter !== 'all' || this._historyDateRange !== 'all' || historyFilter ? 'No history matches.' : 'No history yet'}</p>
          ${this._historyTypeFilter !== 'all' || this._historyDateRange !== 'all' || historyFilter ? '' : `<p class="invx-empty-sub">Every stock change shows up here: sales, voids, purchase orders, counts, and manual adjustments.</p>`}
        </div>`}
    `;
        document.getElementById('invHistFilter')?.addEventListener('change', (e)=>{
            this._historyPage = 1;
            this._historyFilterHandler?.(e.target.value || null);
        });
        document.getElementById('invHistTypeFilter')?.addEventListener('change', (e)=>{
            this._historyTypeFilter = e.target.value;
            this._historyPage = 1;
            this._renderHistorySection();
        });
        document.getElementById('invHistDateRow')?.addEventListener('change', (e)=>{
            if (e.target.id === 'invHistDateRange') this._historyDateRange = e.target.value;
            else if (e.target.id === 'invHistDateFrom') this._historyDateFrom = e.target.value;
            else if (e.target.id === 'invHistDateTo') this._historyDateTo = e.target.value;
            else return;
            this._historyPage = 1;
            this._renderHistorySection();
        });
        (0, $8c6cc8386f59a55a$export$b9eef545e49d09b)('invHistPager', (p)=>{
            this._historyPage = p;
            this._renderHistorySection();
        }, (n)=>{
            this._historyPageSize = n;
            this._historyPage = 1;
            this._renderHistorySection();
        });
    }
    // ── Modals (adjust / item / confirm) ────────────────────────────────────────
    // Quick +/- adjustment. direction: +1 add, -1 remove.
    _showAdjustModal(item, direction) {
        const overlay = document.createElement('div');
        overlay.className = 'modal-overlay-form';
        overlay.style.zIndex = '99999';
        overlay.innerHTML = `
      <div class="invx-modal-card">
        <button class="modal-close-btn" type="button">&times;</button>
        <div class="invx-modal-head">
          <div class="invx-tile" style="background:${$b0886db79b2df847$var$tileColor(item.name)}">${(0, $cnCXJ.esc)((item.name.trim()[0] || '?').toUpperCase())}</div>
          <div>
            <h3 class="invx-modal-title">${direction > 0 ? 'Receive stock' : 'Use / remove stock'}</h3>
            <p class="invx-modal-sub">${(0, $cnCXJ.esc)(item.name)} \xb7 currently ${$b0886db79b2df847$var$fmtQty(item.quantity)} ${(0, $cnCXJ.esc)(item.unit)}</p>
          </div>
        </div>
        ${direction > 0 ? `
        <div class="inv-adj-hint">
          <span aria-hidden="true">\u{1F4A1}</span>
          <span>Quick add - best for <strong>corrections and recounts</strong>. Restocking after a purchase? <button class="inv-inline-link" data-act="go-po" type="button">Use a Purchase Order</button> instead - it also records the cost, supplier, and receipt.</span>
        </div>` : `
        <div class="inv-adj-hint">
          <span aria-hidden="true">\u{1F4A1}</span>
          <span>For <strong>spoilage, waste, and corrections</strong>. No need to remove stock for things you sold - sales lower it automatically.</span>
        </div>`}
        <div class="invx-field">
          <label for="invAdjAmount">Amount (${(0, $cnCXJ.esc)(item.unit)})</label>
          <input type="number" id="invAdjAmount" min="0" step="any" placeholder="0" autocomplete="off" />
        </div>
        <div class="invx-field">
          <label for="invAdjNote">Reason</label>
          <input type="text" id="invAdjNote" placeholder="${direction > 0 ? 'e.g. Weekly delivery' : 'e.g. Spoilage, recount'}" maxlength="120" autocomplete="off" />
        </div>
        <p class="invx-modal-error" id="invAdjError"></p>
        <div class="adj-form-actions">
          <button type="button" class="btn" data-act="cancel">Cancel</button>
          <button type="button" class="btn primary" data-act="save">${direction > 0 ? 'Add' : 'Remove'}</button>
        </div>
      </div>`;
        document.body.appendChild(overlay);
        const close = ()=>overlay.remove();
        overlay.querySelector('.modal-close-btn').addEventListener('click', close);
        overlay.querySelector('[data-act="cancel"]').addEventListener('click', close);
        // "Use a Purchase Order" shortcut: swap this quick-add for a PO pre-filled
        // with this item (and its supplier), so the restock stays fully tracked.
        overlay.querySelector('[data-act="go-po"]')?.addEventListener('click', ()=>{
            close();
            this._openReorderPo([
                item
            ], item.supplierId ?? null);
        });
        const amountEl = overlay.querySelector('#invAdjAmount');
        amountEl.focus();
        const save = ()=>{
            const amount = parseFloat(amountEl.value);
            const errEl = overlay.querySelector('#invAdjError');
            if (!Number.isFinite(amount) || amount <= 0) {
                errEl.textContent = 'Enter an amount greater than zero.';
                return;
            }
            const note = overlay.querySelector('#invAdjNote').value.trim();
            close();
            this._adjustHandler?.(item.id, direction * amount, note);
        };
        overlay.querySelector('[data-act="save"]').addEventListener('click', save);
        overlay.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter') save();
        });
    }
    // Create (no item) or edit (item passed). Quantity is deliberately absent in
    // edit mode - it only moves via Receive/Use so every change leaves a history
    // row. Optional profile fields: SKU / unit cost / supplier.
    // opts.onSaved(item) fires after a CREATE completes (the PO form's quick-add
    // uses it to select the new item in place).
    _showItemModal(item = null, opts = {}) {
        const isEdit = !!item;
        const suppliers = this._data?.suppliers ?? [];
        const overlay = document.createElement('div');
        overlay.className = 'modal-overlay-form';
        overlay.style.zIndex = '99999';
        overlay.innerHTML = `
      <div class="invx-modal-card invx-modal-card--wide">
        <button class="modal-close-btn" type="button">&times;</button>
        <h3 class="invx-modal-title">${isEdit ? 'Edit item' : 'New inventory item'}</h3>
        ${isEdit && item.linkedMenuItemId ? `<p class="invx-modal-sub">Auto-created by a product's Simple count mode. The name follows the product.</p>` : ''}
        <div class="invx-field">
          <label for="invItemName">Name <span class="inv-req" aria-hidden="true">*</span></label>
          <input type="text" id="invItemName" placeholder="e.g. Milk" maxlength="80" autocomplete="off" value="${isEdit ? (0, $cnCXJ.esc)(item.name) : ''}" ${isEdit && item.linkedMenuItemId ? 'disabled' : ''} />
        </div>
        <div class="invx-field-row">
          <div class="invx-field">
            <label for="invItemUnit">Unit</label>
            <select id="invItemUnit">${$b0886db79b2df847$var$unitSelectOptions(isEdit ? item.unit : 'pc')}</select>
          </div>
          ${isEdit ? `
          <div class="invx-field">
            <label>On hand</label>
            <input type="text" value="${$b0886db79b2df847$var$fmtQty(item.quantity)} ${(0, $cnCXJ.esc)(item.unit)}" disabled title="Use Receive / Use-Remove so the change is logged" />
          </div>` : `
          <div class="invx-field">
            <label for="invItemQty">Starting quantity</label>
            <input type="number" id="invItemQty" min="0" step="any" placeholder="0" autocomplete="off" />
          </div>`}
        </div>
        <div class="invx-field-row">
          <div class="invx-field">
            <label for="invItemThreshold">Reorder point <span class="inv-req" aria-hidden="true">*</span> <span class="field-optional">(alerts at this level)</span></label>
            <input type="number" id="invItemThreshold" min="0" step="any" placeholder="e.g. 500" autocomplete="off" value="${isEdit && item.lowStockThreshold != null ? $b0886db79b2df847$var$fmtQty(item.lowStockThreshold) : ''}" />
          </div>
          <div class="invx-field">
            <label for="invItemCost">Unit cost (${(0, $coRoT.currencySymbol)()})</label>
            <input type="number" id="invItemCost" min="0" step="0.01" placeholder="e.g. 12.50" autocomplete="off" value="${isEdit && item.unitCost != null ? item.unitCost : ''}" />
          </div>
        </div>
        <div class="invx-field-row">
          <div class="invx-field">
            <label for="invItemSku">SKU</label>
            <input type="text" id="invItemSku" maxlength="40" placeholder="e.g. CB-001" autocomplete="off" spellcheck="false" value="${isEdit ? (0, $cnCXJ.esc)(item.sku ?? '') : ''}" />
          </div>
        </div>
        <p class="invx-modal-sub">Suppliers and their prices are managed on the item's details panel.</p>
        <p class="invx-modal-error" id="invItemError"></p>
        <div class="adj-form-actions">
          <button type="button" class="btn" data-act="cancel">Cancel</button>
          <button type="button" class="btn primary" data-act="save">${isEdit ? 'Save' : 'Add Item'}</button>
        </div>
      </div>`;
        document.body.appendChild(overlay);
        const close = ()=>overlay.remove();
        overlay.querySelector('.modal-close-btn').addEventListener('click', close);
        overlay.querySelector('[data-act="cancel"]').addEventListener('click', close);
        overlay.querySelector('#invItemName')?.focus();
        overlay.querySelector('[data-act="save"]').addEventListener('click', ()=>{
            const errEl = overlay.querySelector('#invItemError');
            const name = overlay.querySelector('#invItemName').value.trim();
            if (!name) {
                errEl.textContent = 'Give the item a name.';
                return;
            }
            const unit = overlay.querySelector('#invItemUnit').value || 'pc';
            const thresholdRaw = overlay.querySelector('#invItemThreshold').value;
            const lowStockThreshold = parseFloat(thresholdRaw);
            if (!Number.isFinite(lowStockThreshold) || lowStockThreshold <= 0) {
                errEl.textContent = 'Set a reorder point greater than zero.';
                return;
            }
            const extras = {
                sku: overlay.querySelector('#invItemSku').value,
                unitCost: overlay.querySelector('#invItemCost').value
            };
            close();
            if (isEdit) this._editItemHandler?.(item.id, {
                name: name,
                unit: unit,
                lowStockThreshold: lowStockThreshold,
                ...extras
            });
            else {
                const qtyRaw = overlay.querySelector('#invItemQty').value;
                const quantity = qtyRaw === '' ? 0 : parseFloat(qtyRaw) || 0;
                this._newItemHandler?.({
                    name: name,
                    unit: unit,
                    quantity: quantity,
                    lowStockThreshold: lowStockThreshold,
                    ...extras
                }, opts.onSaved);
            }
        });
    }
    _showConfirmModal({ title: title, message: message, confirmLabel: confirmLabel, onConfirm: onConfirm }) {
        const overlay = document.createElement('div');
        overlay.className = 'modal-overlay-form';
        overlay.style.zIndex = '99999';
        overlay.innerHTML = `
      <div class="invx-modal-card">
        <button class="modal-close-btn" type="button">&times;</button>
        <h3 class="invx-modal-title">${(0, $cnCXJ.esc)(title)}</h3>
        <p class="invx-modal-sub">${(0, $cnCXJ.esc)(message)}</p>
        <div class="adj-form-actions">
          <button type="button" class="btn" data-act="cancel">Cancel</button>
          <button type="button" class="btn invx-btn-danger" data-act="confirm">${(0, $cnCXJ.esc)(confirmLabel)}</button>
        </div>
      </div>`;
        document.body.appendChild(overlay);
        const close = ()=>overlay.remove();
        overlay.querySelector('.modal-close-btn').addEventListener('click', close);
        overlay.querySelector('[data-act="cancel"]').addEventListener('click', close);
        overlay.querySelector('[data-act="confirm"]').addEventListener('click', ()=>{
            close();
            onConfirm?.();
        });
    }
}
const $b0886db79b2df847$var$_view = new $b0886db79b2df847$var$InventoryView();
$b0886db79b2df847$var$_view._addHandlerDrawer();
$b0886db79b2df847$var$_view._wireStatTiles();
var $b0886db79b2df847$export$2e2bcd8739ae039 = $b0886db79b2df847$var$_view;



var $cnCXJ = parcelRequire("cnCXJ");
// Floating "who's on shift" indicator - a small circle pinned to the lower-right
// corner of the home page. Hover (or tap) reveals the list of staff currently
// clocked in, with an amber dot for anyone on break. Hidden when nobody is in.
class $c5fa03bf5fec6559$var$OnShiftView {
    _el = document.getElementById('onShiftBubble');
    constructor(){
        // Tap-to-toggle for touch devices (hover handles desktop via CSS).
        this._el?.addEventListener('click', (e)=>{
            if (e.target.closest('.onshift-circle')) this._el.classList.toggle('onshift--open');
        });
        document.addEventListener('click', (e)=>{
            if (!e.target.closest('#onShiftBubble')) this._el?.classList.remove('onshift--open');
        });
    }
    render(list) {
        if (!this._el) return;
        if (!list.length) {
            this._el.classList.add('hidden');
            this._el.innerHTML = '';
            return;
        }
        const fmtSince = (iso)=>new Date(iso).toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit'
            });
        this._el.innerHTML = `
      <div class="onshift-pop">
        <p class="onshift-pop-title">On shift now</p>
        ${list.map((s)=>`
          <div class="onshift-row">
            <span class="onshift-dot${s.onBreak ? ' onshift-dot--break' : ''}"></span>
            <span class="onshift-name">${(0, $cnCXJ.esc)(s.name || 'Staff')}</span>
            <span class="onshift-meta">${s.onBreak ? 'On break' : `since ${fmtSince(s.clockedInAt)}`}</span>
          </div>`).join('')}
      </div>
      <button class="onshift-circle" type="button" aria-label="${list.length} staff on shift">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
        <span class="onshift-count">${list.length}</span>
      </button>`;
        this._el.classList.remove('hidden');
    }
}
var $c5fa03bf5fec6559$export$2e2bcd8739ae039 = new $c5fa03bf5fec6559$var$OnShiftView();



var $cnCXJ = parcelRequire("cnCXJ");

var $lDSCx = parcelRequire("lDSCx");
// Swappable home cards and stat tiles (Kelly, 2026-10-24, mockup
// claude.ai/artifact/Nazw5VvuysHcz11oNM6ocJ). The home screen has two big card
// spots (left: Getting Started / Activity / My shift, right: Active Queue) and
// three stat tiles. Each DEVICE picks what fills them - saved in localStorage,
// not business settings, because a host stand iPad and the counter register
// want different things. Anyone can swap. A choice never turns a feature on or
// off; a card whose feature is off simply falls back to the default.
const $3aa6878d3c2fc9b3$var$STORE = 'pointbunny_home_cards';
const $3aa6878d3c2fc9b3$export$5f768699f44cc740 = [
    {
        key: 'main',
        group: 'Orders and sales',
        label: 'Activity',
        desc: 'Sales, clock-ins and stock alerts'
    },
    {
        key: 'queue',
        group: 'Orders and sales',
        label: 'Active queue',
        desc: 'Orders waiting to be made'
    },
    {
        key: 'salesToday',
        group: 'Orders and sales',
        label: 'Sales today',
        desc: 'Hour by hour, next to yesterday'
    },
    {
        key: 'salesWeek',
        group: 'Orders and sales',
        label: 'Last 7 days',
        desc: 'Daily sales, next to the week before'
    },
    {
        key: 'topSellers',
        group: 'Orders and sales',
        label: 'Top sellers today',
        desc: 'Your 5 best items so far'
    },
    {
        key: 'tables',
        group: 'Tables',
        label: 'Tables',
        desc: 'Live floor: free, seated, needs cleaning'
    },
    {
        key: 'reservations',
        group: 'Tables',
        label: "Today's reservations",
        desc: 'Next bookings with a Seat button'
    },
    {
        key: 'waitlist',
        group: 'Tables',
        label: 'Waitlist',
        desc: 'Parties waiting and how long'
    },
    {
        key: 'schedule',
        group: 'Team',
        label: "Today's schedule",
        desc: 'Who works today, and who is late'
    },
    {
        key: 'team',
        group: 'Team',
        label: "Who's working",
        desc: 'Who is clocked in right now'
    },
    {
        key: 'inbox',
        group: 'Team',
        label: 'Needs your OK',
        desc: 'Swaps, time off and orders to review'
    },
    {
        key: 'lowStock',
        group: 'Stock',
        label: 'Low stock',
        desc: 'Items running out',
        pro: true
    },
    {
        key: 'purchaseOrders',
        group: 'Stock',
        label: 'Purchase orders',
        desc: 'Orders on the way and drafts',
        pro: true
    }
];
const $3aa6878d3c2fc9b3$export$34ddeca23ac38a20 = [
    {
        key: 'sales',
        group: 'Sales',
        label: "Today's sales"
    },
    {
        key: 'txns',
        group: 'Sales',
        label: 'Transactions'
    },
    {
        key: 'avgOrder',
        group: 'Sales',
        label: 'Average order'
    },
    {
        key: 'tips',
        group: 'Sales',
        label: 'Tips today'
    },
    {
        key: 'itemsSold',
        group: 'Sales',
        label: 'Items sold'
    },
    {
        key: 'lastWeek',
        group: 'Sales',
        label: 'vs. last week'
    },
    {
        key: 'expenses',
        group: 'Sales',
        label: 'Expenses today'
    },
    {
        key: 'serving',
        group: 'Kitchen and team',
        label: 'Avg serving time'
    },
    {
        key: 'waiting',
        group: 'Kitchen and team',
        label: 'Orders waiting'
    },
    {
        key: 'onShift',
        group: 'Kitchen and team',
        label: 'On shift now'
    },
    {
        key: 'requests',
        group: 'Kitchen and team',
        label: 'To review'
    },
    {
        key: 'freeTables',
        group: 'Tables',
        label: 'Free tables'
    },
    {
        key: 'openTabs',
        group: 'Tables',
        label: 'Open tabs'
    },
    {
        key: 'nextBooking',
        group: 'Tables',
        label: 'Next booking'
    },
    {
        key: 'lowItems',
        group: 'Stock',
        label: 'Low stock'
    }
];
const $3aa6878d3c2fc9b3$export$65e7841ac6ed0223 = [
    'main',
    'queue'
];
const $3aa6878d3c2fc9b3$export$f38b4fdd358d10bf = [
    'sales',
    'txns',
    'serving'
];
const $3aa6878d3c2fc9b3$var$CARD_KEYS = new Set($3aa6878d3c2fc9b3$export$5f768699f44cc740.map((c)=>c.key));
const $3aa6878d3c2fc9b3$var$TILE_KEYS = new Set($3aa6878d3c2fc9b3$export$34ddeca23ac38a20.map((t)=>t.key));
// Suggested per type of place. Anything unavailable falls back in resolve().
const $3aa6878d3c2fc9b3$var$SUGGESTED = {
    restaurant: {
        cards: [
            'tables',
            'queue'
        ],
        tiles: [
            'sales',
            'openTabs',
            'freeTables'
        ]
    },
    bakery: {
        cards: [
            'main',
            'queue'
        ],
        tiles: [
            'sales',
            'txns',
            'lowItems'
        ]
    }
};
const $3aa6878d3c2fc9b3$export$eb578a3e3b5009bd = (placeType)=>{
    const s = $3aa6878d3c2fc9b3$var$SUGGESTED[placeType];
    return {
        cards: [
            ...s?.cards ?? $3aa6878d3c2fc9b3$export$65e7841ac6ed0223
        ],
        tiles: [
            ...s?.tiles ?? $3aa6878d3c2fc9b3$export$f38b4fdd358d10bf
        ]
    };
};
const $3aa6878d3c2fc9b3$var$clean = (list, known, defaults)=>{
    const out = Array.isArray(list) ? list.slice(0, defaults.length) : [];
    return defaults.map((d, i)=>known.has(out[i]) ? out[i] : d);
};
const $3aa6878d3c2fc9b3$export$11e63f7b0f3d9900 = ()=>{
    let saved = null;
    try {
        saved = JSON.parse(localStorage.getItem($3aa6878d3c2fc9b3$var$STORE) || 'null');
    } catch  {}
    return {
        cards: $3aa6878d3c2fc9b3$var$clean(saved?.cards, $3aa6878d3c2fc9b3$var$CARD_KEYS, $3aa6878d3c2fc9b3$export$65e7841ac6ed0223),
        tiles: $3aa6878d3c2fc9b3$var$clean(saved?.tiles, $3aa6878d3c2fc9b3$var$TILE_KEYS, $3aa6878d3c2fc9b3$export$f38b4fdd358d10bf)
    };
};
const $3aa6878d3c2fc9b3$export$a1544dad697b423d = (prefs)=>{
    try {
        localStorage.setItem($3aa6878d3c2fc9b3$var$STORE, JSON.stringify({
            cards: prefs.cards,
            tiles: prefs.tiles
        }));
    } catch  {}
};
const $3aa6878d3c2fc9b3$export$357523c63a2253b9 = (list, slot, key)=>{
    const next = [
        ...list
    ];
    const from = next.indexOf(key);
    if (from === slot) return next;
    if (from !== -1) next[from] = next[slot];
    next[slot] = key;
    return next;
};
const $3aa6878d3c2fc9b3$export$f7ad0328861e2f03 = (list, defaults, isAvailable, allKeys)=>{
    const out = [];
    list.forEach((key, i)=>{
        const tries = [
            key,
            defaults[i],
            ...allKeys
        ];
        out.push(tries.find((k)=>isAvailable(k) && !out.includes(k)));
    });
    return out;
};
const $3aa6878d3c2fc9b3$export$33e05acb58ff054f = $3aa6878d3c2fc9b3$export$5f768699f44cc740.map((c)=>c.key);
const $3aa6878d3c2fc9b3$export$6c988621b2141f2e = $3aa6878d3c2fc9b3$export$34ddeca23ac38a20.map((t)=>t.key);
const $3aa6878d3c2fc9b3$export$acd4ea891440d33b = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 16V4m0 0L3 8m4-4 4 4M17 8v12m0 0 4-4m-4 4-4-4"/></svg>';
const $3aa6878d3c2fc9b3$export$ad45c99c3690e609 = (key)=>`<button type="button" class="home-swap-btn" data-swap-card="${key}" aria-label="Swap this card" title="Choose what shows here">${$3aa6878d3c2fc9b3$export$acd4ea891440d33b}</button>`;


// Home "My shift" card (#homeMyShiftCard). Fills the left-column slot for staff
// who don't get the Getting Started / Activity card: their own clock status,
// time worked today, breaks today and hours this week (Mon-Sun bars). Clocking
// itself happens only on the Time Clock (timeclock.html), so the card is
// read-only. Worked time ticks live from the cached shifts (no refetch).
const $e33f5b9e7cf6b9c8$var$DAY_LABELS = [
    'M',
    'T',
    'W',
    'T',
    'F',
    'S',
    'S'
];
const $e33f5b9e7cf6b9c8$var$CLOCK_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
const $e33f5b9e7cf6b9c8$var$COFFEE_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8h1a4 4 0 1 1 0 8h-1"/><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z"/><line x1="6" y1="2" x2="6" y2="4"/><line x1="10" y1="2" x2="10" y2="4"/><line x1="14" y1="2" x2="14" y2="4"/></svg>';
const $e33f5b9e7cf6b9c8$export$a82ba44f2bc80e0d = function(now = new Date()) {
    const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    d.setDate(d.getDate() - (d.getDay() + 6) % 7);
    return d;
};
const $e33f5b9e7cf6b9c8$var$overlap = (aStart, aEnd, bStart, bEnd)=>Math.max(0, Math.min(aEnd, bEnd) - Math.max(aStart, bStart));
// Worked ms inside [from, to): shift time minus break time, open items run to `now`.
const $e33f5b9e7cf6b9c8$var$workedBetween = function(shifts, from, to, now) {
    let ms = 0;
    for (const s of shifts){
        const sIn = new Date(s.clockedInAt).getTime();
        const sOut = s.clockedOutAt ? new Date(s.clockedOutAt).getTime() : now;
        ms += $e33f5b9e7cf6b9c8$var$overlap(sIn, sOut, from, to);
        for (const b of s.breaks){
            const bIn = new Date(b.startedAt).getTime();
            const bOut = b.endedAt ? new Date(b.endedAt).getTime() : now;
            ms -= $e33f5b9e7cf6b9c8$var$overlap(Math.max(bIn, sIn), Math.min(bOut, sOut), from, to);
        }
    }
    return Math.max(0, ms);
};
const $e33f5b9e7cf6b9c8$var$fmtDur = function(ms, { hero: hero = false } = {}) {
    const mins = Math.floor(ms / 60000);
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    if (hero) return `${h}h ${String(m).padStart(2, "0")}m`;
    if (h === 0) return `${m}m`;
    return m ? `${h}h ${m}m` : `${h}h`;
};
const $e33f5b9e7cf6b9c8$var$fmtTime = (iso)=>new Date(iso).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit'
    });
class $e33f5b9e7cf6b9c8$var$MyShiftView {
    _card = document.getElementById('homeMyShiftCard');
    _data = null;
    _timer = null;
    // data: { name, roleName, timeTracking, shifts }
    render(data) {
        if (!this._card) return;
        this._data = data;
        this._paint();
        this._card.classList.remove('hidden');
        clearInterval(this._timer);
        // Minute-resolution display, so a 20s tick is plenty and cheap.
        if (data.timeTracking) this._timer = setInterval(()=>{
            if (!document.hidden) this._paint();
        }, 20000);
    }
    hide() {
        clearInterval(this._timer);
        this._timer = null;
        this._data = null;
        this._card?.classList.add('hidden');
    }
    _paint() {
        const d = this._data;
        if (!d) return;
        const initials = (d.name || '').split(/\s+/).filter(Boolean).slice(0, 2).map((w)=>w[0].toUpperCase()).join('') || '?';
        const head = (pill)=>`
      <div class="ms-head">
        <div class="ms-who">
          <span class="ms-avatar" aria-hidden="true">${(0, $cnCXJ.esc)(initials)}</span>
          <div class="ms-who-text">
            <p class="ms-eyebrow">My shift</p>
            <h3 class="ms-name">${(0, $cnCXJ.esc)(d.name || 'Staff member')}</h3>
            ${d.roleName ? `<span class="ms-role">${(0, $cnCXJ.esc)(d.roleName)}</span>` : ''}
          </div>
        </div>
        <div class="ms-head-end">${pill}${(0, $3aa6878d3c2fc9b3$export$ad45c99c3690e609)('main')}</div>
      </div>`;
        if (!d.timeTracking) {
            this._card.innerHTML = `
        ${head('<span class="ms-pill"><span class="ms-pill-dot"></span>Time tracking off</span>')}
        <div class="ms-off">
          <span class="ms-off-icon" aria-hidden="true">${$e33f5b9e7cf6b9c8$var$CLOCK_ICON}</span>
          <p class="ms-off-title">Time tracking is off for your role</p>
          <p class="ms-off-text">Your role doesn't use the Time Clock, so there are no shifts to show here. If you should be clocking in, ask your manager to turn on time tracking for your role.</p>
        </div>`;
            return;
        }
        const now = Date.now();
        const shifts = d.shifts ?? [];
        const open = shifts.find((s)=>!s.clockedOutAt);
        const openBreak = open?.breaks.find((b)=>!b.endedAt);
        const today = new Date();
        const dayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
        const dayEnd = dayStart + 86400000;
        const wkStart = $e33f5b9e7cf6b9c8$export$a82ba44f2bc80e0d(today);
        const todayIdx = (today.getDay() + 6) % 7;
        const workedToday = $e33f5b9e7cf6b9c8$var$workedBetween(shifts, dayStart, dayEnd, now);
        const days = $e33f5b9e7cf6b9c8$var$DAY_LABELS.map((_, i)=>{
            const from = new Date(wkStart.getFullYear(), wkStart.getMonth(), wkStart.getDate() + i).getTime();
            const to = new Date(wkStart.getFullYear(), wkStart.getMonth(), wkStart.getDate() + i + 1).getTime();
            return $e33f5b9e7cf6b9c8$var$workedBetween(shifts, from, to, now);
        });
        const weekTotal = days.reduce((a, b)=>a + b, 0);
        let breakCount = 0, breakMs = 0;
        for (const s of shifts)for (const b of s.breaks){
            const bIn = new Date(b.startedAt).getTime();
            if (bIn < dayStart || bIn >= dayEnd) continue;
            breakCount++;
            breakMs += (b.endedAt ? new Date(b.endedAt).getTime() : now) - bIn;
        }
        let state, pill, label;
        if (openBreak) {
            state = 'break';
            pill = `<span class="ms-pill ms-pill--break"><span class="ms-pill-dot"></span>On break &middot; ${$e33f5b9e7cf6b9c8$var$fmtDur(now - new Date(openBreak.startedAt).getTime())}</span>`;
            label = `worked today &middot; break started ${$e33f5b9e7cf6b9c8$var$fmtTime(openBreak.startedAt)}`;
        } else if (open) {
            state = 'on';
            pill = '<span class="ms-pill ms-pill--on"><span class="ms-pill-dot"></span>On shift</span>';
            label = `worked today &middot; clocked in at ${$e33f5b9e7cf6b9c8$var$fmtTime(open.clockedInAt)}`;
        } else {
            state = 'off';
            pill = '<span class="ms-pill"><span class="ms-pill-dot"></span>Not clocked in</span>';
            label = workedToday > 0 ? 'worked today &middot; clocked out' : 'not clocked in yet today';
        }
        // Bars scale to the busiest day this week (min 8h so a short day isn't a full bar).
        const scale = Math.max(28800000, ...days);
        const bars = days.map((ms, i)=>`
      <div class="ms-day${i === todayIdx ? ' ms-day--today' : ''}" title="${$e33f5b9e7cf6b9c8$var$fmtDur(ms)}">
        <div class="ms-bar-track"><div class="ms-bar" style="height:${Math.max(6, Math.round(ms / scale * 100))}%"></div></div>
        <span>${$e33f5b9e7cf6b9c8$var$DAY_LABELS[i]}</span>
      </div>`).join('');
        this._card.innerHTML = `
      ${head(pill)}
      <div class="ms-hero">
        <span class="ms-hero-icon ms-hero-icon--${state}" aria-hidden="true">${state === 'break' ? $e33f5b9e7cf6b9c8$var$COFFEE_ICON : $e33f5b9e7cf6b9c8$var$CLOCK_ICON}</span>
        <div>
          <div class="ms-time">${$e33f5b9e7cf6b9c8$var$fmtDur(workedToday, {
            hero: true
        })}</div>
          <div class="ms-time-label">${label}</div>
        </div>
      </div>
      <div class="ms-stats">
        <div class="ms-stat">
          <div class="ms-stat-label">Breaks today</div>
          <div class="ms-stat-value">${breakCount ? `${breakCount} &middot; ${$e33f5b9e7cf6b9c8$var$fmtDur(breakMs)}` : 'None'}</div>
        </div>
        <div class="ms-stat">
          <div class="ms-stat-label">This week</div>
          <div class="ms-stat-value">${$e33f5b9e7cf6b9c8$var$fmtDur(weekTotal)}</div>
        </div>
      </div>
      <div class="ms-week" aria-label="Hours worked each day this week">${bars}</div>
      ${this._swapAskMarkup(d)}
      ${this._nextShiftMarkup(d) || `<div class="ms-foot">${$e33f5b9e7cf6b9c8$var$CLOCK_ICON}Clock in, take breaks and clock out on the Time Clock.</div>`}`;
    }
    // A teammate asked them to cover or trade a shift (2026-10-17). Answered on
    // the Time Clock's My Schedule page; in-app only, no email.
    _swapAskMarkup(d) {
        const n = d.swapAsks ?? 0;
        if (!n) return '';
        return `<div class="ms-ask"><b>${n === 1 ? 'A teammate asked you to take a shift' : `${n} teammates asked you to take shifts`}</b><span>Answer on the Time Clock, under My schedule.</span></div>`;
    }
    // Next PUBLISHED scheduled shift (2026-10-15), in the business timezone.
    _nextShiftMarkup(d) {
        const s = d.nextShift;
        if (!s || !d.tz) return '';
        const now = Date.now();
        if (new Date(s.endsAt).getTime() <= now) return '';
        const day = (0, $lDSCx.zonedParts)(new Date(s.startsAt), d.tz).dateStr;
        const today = (0, $lDSCx.todayIn)(d.tz);
        const range = `${(0, $lDSCx.shortTime)(new Date(s.startsAt), d.tz)} \u{2013} ${(0, $lDSCx.shortTime)(new Date(s.endsAt), d.tz)}`;
        const nowOn = new Date(s.startsAt).getTime() <= now;
        const when = nowOn ? `Now, until ${(0, $lDSCx.shortTime)(new Date(s.endsAt), d.tz)}` : day === today ? `Today ${range}` : day === (0, $lDSCx.addDays)(today, 1) ? `Tomorrow ${range}` : `${(0, $lDSCx.dayLabel)(day)} \xb7 ${range}`;
        return `
      <div class="ms-next" style="--sc:${(0, $cnCXJ.esc)(s.stationColor || '#0FA267')}">
        <span class="ms-next-label">${nowOn ? 'Scheduled shift' : 'Next shift'}</span>
        <span class="ms-next-when">${(0, $cnCXJ.esc)(when)}</span>
        ${s.stationName ? `<span class="ms-next-station">${(0, $cnCXJ.esc)(s.stationName)}</span>` : ''}
      </div>`;
    }
}
var $e33f5b9e7cf6b9c8$export$2e2bcd8739ae039 = new $e33f5b9e7cf6b9c8$var$MyShiftView();



var $cggJi = parcelRequire("cggJi");

var $cnCXJ = parcelRequire("cnCXJ");
const $f3651885b15417e3$var$PREVIEW_COUNT = 8;
// Seconds → "m:ss" (or "h:mm:ss" past an hour) for the row timers.
const $f3651885b15417e3$var$fmtClock = (totalSecs)=>{
    const s = Math.max(0, totalSecs);
    const h = Math.floor(s / 3600);
    const m = Math.floor(s % 3600 / 60);
    const ss = String(s % 60).padStart(2, '0');
    return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`;
};
// Seconds → "04m 32s" (or "01h 04m 32s" past an hour) for the "Today so far"
// tiles. Returns markup: the unit letters are wrapped so they render smaller.
const $f3651885b15417e3$var$fmtDuration = (totalSecs)=>{
    const s = Math.max(0, Math.round(totalSecs));
    const pad = (n)=>String(n).padStart(2, '0');
    const h = Math.floor(s / 3600);
    const parts = [
        [
            Math.floor(s % 3600 / 60),
            'm'
        ],
        [
            s % 60,
            's'
        ]
    ];
    if (h > 0) parts.unshift([
        h,
        'h'
    ]);
    return parts.map(([n, u])=>`${pad(n)}<i>${u}</i>`).join(' ');
};
const $f3651885b15417e3$var$MORE_ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="5" cy="12" r="1.8"/><circle cx="12" cy="12" r="1.8"/><circle cx="19" cy="12" r="1.8"/></svg>';
const $f3651885b15417e3$var$CHECK_ICON = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
class $f3651885b15417e3$var$KDSView {
    _list = document.getElementById('openOrdersList');
    _viewAllBtn = document.getElementById('openOrdersViewAll');
    _expanded = false;
    _modalBackdrop = document.getElementById('allOrdersBackdrop');
    _modalList = document.getElementById('allOrdersModalList');
    _modalCount = document.getElementById('allOrdersModalCount');
    _modalOpen = false;
    _summary = document.getElementById('oqSummary');
    _count = document.getElementById('oqCount');
    _thr = null;
    // Queue timer thresholds (seconds). updateTimers receives the live values
    // every tick; before the first tick fall back to the same localStorage
    // keys/defaults model.state.settings reads, so the first paint is right.
    _thresholds() {
        return this._thr ?? {
            yellow: parseInt(localStorage.getItem('pointbunny_kds_yellow') || '600'),
            red: parseInt(localStorage.getItem('pointbunny_kds_red') || '900')
        };
    }
    // Everything a row shows that changes with time. Urgency escalates on the
    // order's TOTAL age (a ready order sitting uncollected keeps aging toward
    // late - deliberate); the clock counts from ready-time for ready orders
    // ("how long has this sat uncollected"), from order-time otherwise.
    _rowState(order, now) {
        const { yellow: yellow, red: red } = this._thresholds();
        const age = Math.floor((now - order.startedAt) / 1000);
        const isReady = !!order.readyAt;
        const level = age >= red ? 'urgent' : age >= yellow ? 'warn' : 'ok';
        const shown = Math.floor((now - (isReady ? order.readyAt : order.startedAt)) / 1000);
        let note = '';
        if (isReady) note = 'waiting for pickup';
        else if (level === 'urgent') note = `over by ${$f3651885b15417e3$var$fmtClock(age - red)}`;
        return {
            isReady: isReady,
            level: level,
            label: isReady ? 'Ready' : level === 'urgent' ? 'Late' : level === 'warn' ? 'Slow' : 'Order',
            clock: $f3651885b15417e3$var$fmtClock(shown),
            note: note,
            pct: red > 0 ? Math.min(100, Math.round(age / red * 100)) : 0
        };
    }
    _rowClass(st, hidden) {
        return `oq-row${st.isReady ? ' oq-row--ready' : ''}${st.level !== 'ok' ? ` oq-row--${st.level}` : ''}${hidden ? ' oq-row--hidden' : ''}`;
    }
    // Header line under the title: "3 preparing · 1 ready · 1 late".
    _renderSummary(queue, now = Date.now()) {
        if (this._count) this._count.textContent = queue.length ? `${queue.length} order${queue.length !== 1 ? 's' : ''}` : '';
        if (!this._summary) return;
        if (!queue.length) {
            this._summary.classList.add('hidden');
            return;
        }
        let ready = 0, late = 0;
        queue.forEach((o)=>{
            const st = this._rowState(o, now);
            if (st.isReady) ready++;
            if (st.level === 'urgent') late++;
        });
        const preparing = queue.length - ready;
        const html = `<span class="oq-sum oq-sum--prep"><i></i>${preparing} preparing</span>` + (ready ? `<span class="oq-sum oq-sum--ready"><i></i>${ready} ready</span>` : '') + (late ? `<span class="oq-sum oq-sum--late"><i></i>${late} late</span>` : '');
        // Called every timer tick: only touch the DOM when a count changed, so
        // the aria-live region announces real changes, not every second.
        if (this._summary.innerHTML !== html) this._summary.innerHTML = html;
        this._summary.classList.remove('hidden');
    }
    // ── "Today so far" (empty state) ──────────────────────────────────────────
    // Stats come from the controller's today totals query (fetchPeriodTotals).
    // Shown under the bunny only once at least one order has been completed
    // today; otherwise the empty state is just the bunny.
    _todayStats = null;
    setTodayStats(stats) {
        this._todayStats = stats ?? null;
        // Patch the open empty state in place - re-rendering it would restart
        // the bunny's animations.
        const empty = this._list.querySelector('.oq-empty-state');
        if (!empty) return;
        empty.querySelector('.oq-today')?.remove();
        empty.insertAdjacentHTML('beforeend', this._todayStatsMarkup());
    }
    _todayStatsMarkup() {
        const s = this._todayStats;
        if (!s?.completed) return '';
        const hourLabel = (h)=>new Date(2000, 0, 1, h % 24).toLocaleTimeString('en-US', {
                hour: 'numeric'
            });
        // Done orders bucketed by the same queue timer settings that turn rows
        // Slow / Late: under "slow" = on time, under "late" = slow, past it = delayed.
        const { yellow: yellow, red: red } = this._thresholds();
        const timed = s.servingMinutes ?? [];
        const onTime = timed.filter((m)=>m * 60 < yellow).length;
        const delayed = timed.filter((m)=>m * 60 >= red).length;
        const slow = timed.length - onTime - delayed;
        const mins = (secs)=>`${Math.round(secs / 60)} min`;
        const longest = s.longest ? $f3651885b15417e3$var$fmtDuration(s.longest.minutes * 60) : null;
        const lastOut = s.lastDoneAt ? new Date(s.lastDoneAt).toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit'
        }) : null;
        // Each tile opens Reports on the section that explains it.
        const tile = (section, tone, label, value, sub, aria)=>`
      <button type="button" class="oq-today-tile oq-today-tile--${tone}" data-report-section="${section}" aria-label="${aria}, open in Reports">
        <small>${label}</small><b>${value}</b><span>${sub}</span>
      </button>`;
        return `
      <div class="oq-today">
        <span class="oq-today-label">Today so far</span>
        <div class="oq-today-tiles">
          ${tile('traffic', 'neutral', 'Total orders', s.completed, 'done today', `${s.completed} orders done today`)}
          ${tile('kitchen', 'good', 'On time', onTime, `under ${mins(yellow)}`, `${onTime} orders on time`)}
          ${tile('kitchen', 'warn', 'Slow', slow, `${Math.round(yellow / 60)}-${mins(red)}`, `${slow} slow orders`)}
          ${tile('kitchen', 'bad', 'Delayed', delayed, `over ${mins(red)}`, `${delayed} delayed orders`)}
        </div>
        <div class="oq-today-foot">
          ${longest ? `<span>Longest wait <b>${longest}</b>${s.longest.ticketNumber ? ` (#${s.longest.ticketNumber})` : ''}</span>` : ''}
          ${lastOut ? `<span>Last order out at <b>${lastOut}</b></span>` : ''}
          ${s.busiestHour ? `<button type="button" class="oq-today-link" data-report-section="traffic">Busiest hour: <b>${hourLabel(s.busiestHour.hour)} \u{2013} ${hourLabel(s.busiestHour.hour + 1)}</b></button>` : ''}
        </div>
      </div>`;
    }
    _addHandlerTodayStats(openReports) {
        this._list.addEventListener('click', (e)=>{
            const el = e.target.closest('.oq-today [data-report-section]');
            if (el) openReports(el.dataset.reportSection);
        });
    }
    renderQueue(queue) {
        this.closeStatusPopover(); // rows re-render; the popover's anchor is gone
        if (queue.length === 0) {
            // Rabbit body/feet/tail/ears (.oq-hop-rabbit) adapted from "Rabbit" by
            // Katy DeCorah / Beard Chicken: https://codepen.io/katydecorah/pen/nKGxJd
            // used under the MIT License - eyes/face removed and dust-puff dropped
            // per the approved direction below; hop/kick timing otherwise unchanged.
            this._list.innerHTML = `
        <li class="oq-empty-state">
          <div class="oq-empty-scene">
            <div class="oq-aura oq-aura--1" aria-hidden="true"></div>
            <div class="oq-aura oq-aura--2" aria-hidden="true"></div>
            <div class="oq-aura oq-aura--3" aria-hidden="true"></div>
            <span class="oq-particle oq-particle--1" aria-hidden="true"></span>
            <span class="oq-particle oq-particle--2" aria-hidden="true"></span>
            <span class="oq-particle oq-particle--3" aria-hidden="true"></span>
            <span class="oq-particle oq-particle--4" aria-hidden="true"></span>
            <span class="oq-particle oq-particle--5" aria-hidden="true"></span>
            <span class="oq-empty-item oq-empty-item--1" role="img" aria-label="Drink order">\u{1F964}</span>
            <span class="oq-empty-item oq-empty-item--2" role="img" aria-label="Dessert order">\u{1F370}</span>
            <span class="oq-empty-item oq-empty-item--3" role="img" aria-label="Food order">\u{1F354}</span>
            <div class="oq-runway-shadow" aria-hidden="true"></div>
            <div class="oq-hop-rabbit" aria-hidden="true"></div>
          </div>
          <span class="oq-empty-title">All caught up</span>
          <span class="oq-empty-subtitle">The queue is quiet&hellip; for now.<br>Get ready!</span>
          ${this._todayStatsMarkup()}
        </li>`;
            this._viewAllBtn.classList.add('hidden');
            this._expanded = false;
        } else {
            this._list.innerHTML = queue.map((order, i)=>this._rowMarkup(order, i + 1, i >= $f3651885b15417e3$var$PREVIEW_COUNT && !this._expanded)).join('');
            if (queue.length > $f3651885b15417e3$var$PREVIEW_COUNT) {
                this._viewAllBtn.classList.remove('hidden');
                this._viewAllBtn.textContent = this._expanded ? 'Show Less' : `View All (${queue.length})`;
            } else {
                this._viewAllBtn.classList.add('hidden');
                this._expanded = false;
            }
        }
        this._renderSummary(queue);
        if (this._modalOpen) this._renderModalList(queue);
    }
    _renderModalList(queue) {
        if (this._modalCount) this._modalCount.textContent = queue.length > 0 ? `${queue.length} order${queue.length !== 1 ? 's' : ''}` : '';
        if (queue.length === 0) {
            this._modalList.innerHTML = '<li class="oq-empty">No active orders.</li>';
            return; // modal uses compact empty state
        }
        this._modalList.innerHTML = queue.map((order, i)=>this._rowMarkup(order, i + 1, false)).join('');
    }
    openModal(queue) {
        this._modalOpen = true;
        this._modalBackdrop.classList.remove('hidden');
        this._renderModalList(queue);
    }
    closeModal() {
        this._modalOpen = false;
        this._modalBackdrop.classList.add('hidden');
    }
    _addHandlerOpenModal(getQueue) {
        document.getElementById('openOrdersExpandBtn')?.addEventListener('click', ()=>{
            this.openModal(getQueue());
        });
    }
    _addHandlerModalClose() {
        document.getElementById('allOrdersCloseBtn')?.addEventListener('click', ()=>this.closeModal());
        this._modalBackdrop?.addEventListener('click', (e)=>{
            if (e.target === this._modalBackdrop) this.closeModal();
        });
    }
    // ── "Mark as…" mini-modal ──────────────────────────────────────────────────
    // ONE shared floating popover on <body> (same singleton pattern as
    // tooltip.js) so it never clips inside the queue panel or the All Orders
    // modal. Anchored to the clicked button, viewport-clamped, flips above when
    // there's no room below.
    _popover = null;
    _onReadyChoice = null;
    _onDoneChoice = null;
    _onUnreadyChoice = null;
    _ensurePopover() {
        if (this._popover) return this._popover;
        const el = document.createElement('div');
        el.className = 'status-popover';
        el.setAttribute('role', 'menu');
        el.innerHTML = `
      <p class="status-popover-title" data-pop-title></p>
      <button class="status-popover-ready" type="button" role="menuitem">\u{1F6CE}\u{FE0F} Ready for Pickup</button>
      <button class="status-popover-unready hidden" type="button" role="menuitem">\u{21A9} Back to Preparing</button>
      <button class="status-popover-done" type="button" role="menuitem">\u{2713} Done</button>`;
        document.body.appendChild(el);
        el.querySelector('.status-popover-ready').addEventListener('click', ()=>{
            const id = el.dataset.orderId;
            this.closeStatusPopover();
            if (id && this._onReadyChoice) this._onReadyChoice(id);
        });
        el.querySelector('.status-popover-unready').addEventListener('click', ()=>{
            const id = el.dataset.orderId;
            this.closeStatusPopover();
            if (id && this._onUnreadyChoice) this._onUnreadyChoice(id);
        });
        el.querySelector('.status-popover-done').addEventListener('click', ()=>{
            const id = el.dataset.orderId;
            this.closeStatusPopover();
            if (id && this._onDoneChoice) this._onDoneChoice(id);
        });
        this._popover = el;
        return el;
    }
    _openStatusPopover(btn) {
        const el = this._ensurePopover();
        const isReady = btn.dataset.state === 'ready';
        el.dataset.orderId = btn.dataset.orderId;
        el.querySelector('[data-pop-title]').textContent = `Update order #${btn.dataset.ticket}`;
        // State-aware choices: preparing → Ready/Done; ready → Back to Preparing/Done
        // (Done takes the green when it's the natural next step).
        el.querySelector('.status-popover-ready').classList.toggle('hidden', isReady);
        el.querySelector('.status-popover-unready').classList.toggle('hidden', !isReady);
        el.classList.toggle('status-popover--ready', isReady);
        el.classList.add('status-popover--open');
        const r = btn.getBoundingClientRect();
        const pw = el.offsetWidth;
        const ph = el.offsetHeight;
        const left = Math.min(Math.max(8, r.right - pw), window.innerWidth - pw - 8);
        let top = r.bottom + 6;
        if (top + ph > window.innerHeight - 8) top = r.top - ph - 6;
        el.style.left = `${left}px`;
        el.style.top = `${top}px`;
    }
    closeStatusPopover() {
        if (!this._popover) return;
        this._popover.classList.remove('status-popover--open');
        delete this._popover.dataset.orderId;
    }
    // One delegated listener per list covers every row action: the one-tap next
    // step (Mark ready / Done), the ⋯ "more" mini-modal trigger, the direct
    // Mark Done on ready rows, and the cashier's "back to Preparing" revert.
    _wireActions(root, onDone, onReady, onUnready) {
        this._onReadyChoice = onReady;
        this._onDoneChoice = onDone;
        this._onUnreadyChoice = onUnready;
        root?.addEventListener('click', (e)=>{
            const next = e.target.closest('.oq-next-btn');
            if (next) {
                this.closeStatusPopover();
                return next.dataset.action === 'done' ? onDone(next.dataset.orderId) : onReady(next.dataset.orderId);
            }
            const statusBtn = e.target.closest('.oq-status-btn');
            if (statusBtn) {
                const isOpenForThis = this._popover?.classList.contains('status-popover--open') && this._popover.dataset.orderId === statusBtn.dataset.orderId;
                if (isOpenForThis) this.closeStatusPopover();
                else this._openStatusPopover(statusBtn);
                return;
            }
            const done = e.target.closest('.oq-done-btn');
            if (done) return onDone(done.dataset.orderId);
            const unready = e.target.closest('.oq-unready-btn');
            if (unready) return onUnready(unready.dataset.orderId);
        });
    }
    _addHandlerActions(onDone, onReady, onUnready) {
        this._wireActions(this._list, onDone, onReady, onUnready);
    }
    _addHandlerModalActions(onDone, onReady, onUnready) {
        this._wireActions(this._modalList, onDone, onReady, onUnready);
    }
    // Outside click, Escape, scroll, or resize dismisses the mini-modal (its
    // anchor may have moved or gone).
    _addHandlerChooserDismiss() {
        document.addEventListener('click', (e)=>{
            if (e.target.closest('.status-popover') || e.target.closest('.oq-status-btn')) return;
            this.closeStatusPopover();
        });
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape') this.closeStatusPopover();
        });
        document.addEventListener('scroll', ()=>this.closeStatusPopover(), true);
        window.addEventListener('resize', ()=>this.closeStatusPopover());
    }
    // One line per item, quantity first ("2× Iced Latte · Large"). The first two
    // items show; the rest collapse into "+N more" on the second line.
    _itemLines(items) {
        const lines = items.map((it)=>{
            const variants = (it.selectedVariants ?? []).map((v)=>v?.optionName).filter(Boolean);
            return `${it.quantity ?? 1}\xd7 ${(0, $cnCXJ.esc)(it.itemName)}${variants.length ? ` <span class="oq-item-opt">\xb7 ${(0, $cnCXJ.esc)(variants.join(', '))}</span>` : ''}`;
        });
        const shown = lines.slice(0, 2);
        const extra = lines.length - shown.length;
        return shown.map((l, i)=>`<span class="oq-item">${l}${extra > 0 && i === shown.length - 1 ? ` <span class="oq-item-more">+${extra} more</span>` : ''}</span>`).join('');
    }
    _rowMarkup(order, num, hidden) {
        const orderTypeEnabled = localStorage.getItem('pointbunny_order_type_enabled') !== 'false';
        const typeLabel = !orderTypeEnabled || !order.orderType ? '' : (0, $cggJi.orderTypeLabel)(order.orderType);
        const st = this._rowState(order, Date.now());
        // A tab's kitchen ticket shows its table instead of a ticket number.
        const ticket = order.fromTab && order.tableName ? (0, $cnCXJ.esc)(order.tableName) : order.ticketNumber ?? num;
        return `
      <li class="${this._rowClass(st, hidden)}" data-order-id="${order.id}">
        <div class="oq-tkt"><small class="oq-tkt-label">${st.label}</small><b>${ticket}</b></div>
        <div class="oq-body">
          <div class="oq-meta">
            ${typeLabel && !order.fromTab ? `<span class="oq-type">${typeLabel}</span>` : ''}
            ${order.tableName ? `<span class="oq-type oq-table">Table ${(0, $cnCXJ.esc)(order.tableName)}</span>` : ''}
            ${order.practice ? '<span class="oq-practice" title="Tutorial practice order: not saved, disappears when the tutorial ends">\uD83C\uDF93 Practice</span>' : ''}
            <span class="oq-clock">${st.clock}</span>
            <span class="oq-note">${st.note}</span>
          </div>
          ${this._itemLines(order.items)}
        </div>
        <div class="oq-actions">
          <button class="oq-next-btn${st.isReady ? ' oq-next-btn--done' : ''}" type="button" data-order-id="${order.id}" data-action="${st.isReady ? 'done' : 'ready'}">${st.isReady ? `${$f3651885b15417e3$var$CHECK_ICON}Done` : 'Mark ready'}</button>
          <button class="oq-status-btn oq-more-btn" type="button" data-order-id="${order.id}" data-ticket="${ticket}" data-state="${st.isReady ? 'ready' : 'preparing'}" aria-label="More actions for order ${ticket}" title="More actions">${$f3651885b15417e3$var$MORE_ICON}</button>
        </div>
        <div class="oq-track" aria-hidden="true"><i style="width:${st.pct}%"></i></div>
      </li>`;
    }
    updateTimers(queue, now, yellowThreshold, redThreshold) {
        this._thr = {
            yellow: yellowThreshold,
            red: redThreshold
        };
        const roots = this._modalOpen ? [
            this._list,
            this._modalList
        ] : [
            this._list
        ];
        queue.forEach((order)=>{
            const st = this._rowState(order, now);
            roots.forEach((root)=>{
                const row = root.querySelector(`.oq-row[data-order-id="${order.id}"]`);
                if (!row) return;
                row.className = this._rowClass(st, row.classList.contains('oq-row--hidden'));
                row.querySelector('.oq-tkt-label').textContent = st.label;
                row.querySelector('.oq-clock').textContent = st.clock;
                row.querySelector('.oq-note').textContent = st.note;
                row.querySelector('.oq-track > i').style.width = `${st.pct}%`;
            });
        });
        this._renderSummary(queue, now);
    }
    playNewOrderSound() {
        try {
            const ctx = new AudioContext();
            const frequencies = [
                523.25,
                659.25,
                783.99
            ];
            frequencies.forEach((freq, i)=>{
                const osc = ctx.createOscillator();
                const gain = ctx.createGain();
                osc.connect(gain);
                gain.connect(ctx.destination);
                osc.type = 'sine';
                osc.frequency.value = freq;
                gain.gain.setValueAtTime(0, ctx.currentTime + i * 0.07);
                gain.gain.linearRampToValueAtTime(0.18, ctx.currentTime + i * 0.07 + 0.02);
                gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + i * 0.07 + 0.35);
                osc.start(ctx.currentTime + i * 0.07);
                osc.stop(ctx.currentTime + i * 0.07 + 0.35);
            });
        } catch (_) {}
    }
    _addHandlerViewAll() {
        this._viewAllBtn.addEventListener('click', ()=>{
            this._expanded = !this._expanded;
            Array.from(this._list.querySelectorAll('.oq-row')).forEach((row, i)=>{
                row.classList.toggle('oq-row--hidden', !this._expanded && i >= $f3651885b15417e3$var$PREVIEW_COUNT);
            });
            this._viewAllBtn.textContent = this._expanded ? 'Show Less' : `View All`;
        });
    }
    showUndoToast(order, onUndo, durationMs) {
        const label = order.tableName ? `Table ${(0, $cnCXJ.esc)(order.tableName)}` : order.ticketNumber ? `#${order.ticketNumber}` : 'Order';
        const el = document.createElement('div');
        el.className = 'toast toast--undo';
        let remaining = Math.ceil(durationMs / 1000);
        el.innerHTML = `
      <span class="toast-undo-msg">${label} marked done</span>
      <span class="toast-undo-countdown">${remaining}s</span>
      <button class="toast-undo-btn" type="button">Undo</button>`;
        el.querySelector('.toast-undo-btn').addEventListener('click', onUndo, {
            once: true
        });
        let container = document.getElementById('undoToastContainer');
        if (!container) {
            container = document.createElement('div');
            container.id = 'undoToastContainer';
            container.className = 'undo-toast-container';
            document.body.appendChild(container);
        }
        container.appendChild(el);
        el.offsetHeight;
        el.classList.add('toast--visible');
        const countdownInterval = setInterval(()=>{
            remaining--;
            const cd = el.querySelector('.toast-undo-countdown');
            if (cd) cd.textContent = `${remaining}s`;
        }, 1000);
        return ()=>{
            clearInterval(countdownInterval);
            el.classList.remove('toast--visible');
            el.addEventListener('transitionend', ()=>{
                el.remove();
                const c = document.getElementById('undoToastContainer');
                if (c && c.children.length === 0) c.remove();
            }, {
                once: true
            });
        };
    }
}
var $f3651885b15417e3$export$2e2bcd8739ae039 = new $f3651885b15417e3$var$KDSView();



var $boau7 = parcelRequire("boau7");


var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");


var $lDSCx = parcelRequire("lDSCx");
const $d94c521226fbc9fa$var$fmt = (n)=>(0, $coRoT.formatMoney)(n);
// One generic fabricated preview for ANY locked Reports content (any sidebar
// section but Overview, or any period but Today) - never real data, and
// deliberately NOT customized per tab/section (kept simple on purpose - see
// CLAUDE.md "Free vs. Paid Plan Gating"). Built with the same .rp-kpi/
// .rp-item-row classes the real Sales tab peak cards + Top Items list use.
const $d94c521226fbc9fa$var$FAKE_PEAK_CARDS = [
    [
        "\uD83D\uDD25",
        'Best Seller',
        'Iced Latte',
        '128 sold'
    ],
    [
        "\uD83C\uDFC6",
        'Top Category',
        'Beverages',
        $d94c521226fbc9fa$var$fmt(2140)
    ],
    [
        "\u2B50",
        'Top Staff',
        'Alex M.',
        $d94c521226fbc9fa$var$fmt(1860)
    ]
];
const $d94c521226fbc9fa$var$FAKE_TOP_ITEMS = [
    [
        "\uD83E\uDD47",
        'Iced Latte',
        128
    ],
    [
        "\uD83E\uDD48",
        'Croissant',
        94
    ],
    [
        "\uD83E\uDD49",
        'Cold Brew',
        81
    ],
    [
        '4',
        'Bagel & Cream Cheese',
        63
    ],
    [
        '5',
        'Matcha Latte',
        47
    ]
];
const $d94c521226fbc9fa$var$fakeReportsMarkup = ()=>{
    const maxQty = Math.max(...$d94c521226fbc9fa$var$FAKE_TOP_ITEMS.map(([, , q])=>q));
    return `
    <div class="rp-kpi-strip">
      ${$d94c521226fbc9fa$var$FAKE_PEAK_CARDS.map(([emoji, label, val, sub])=>`
        <div class="rp-kpi rp-kpi--iconcol">
          <span class="rp-kpi-emoji">${emoji}</span>
          <div class="rp-kpi-main">
            <div class="rp-kpi-label-row"><span class="rp-kpi-label">${label}</span></div>
            <span class="rp-kpi-val rp-kpi-val--name">${val}</span>
            <span class="rp-peak-count">${sub}</span>
          </div>
        </div>`).join('')}
    </div>
    <section class="rp-card">
      <div class="rp-card-head"><h3>Top Items</h3></div>
      <div class="rp-item-list">
        ${$d94c521226fbc9fa$var$FAKE_TOP_ITEMS.map(([rank, name, qty])=>`
          <div class="rp-item-row">
            <span class="rp-item-rank">${rank}</span>
            <div class="rp-item-main">
              <div class="rp-item-row-top">
                <span class="rp-item-name">${name}</span>
                <span class="rp-item-rev">${qty}</span>
              </div>
              <div class="rp-item-bar-track">
                <div class="rp-item-bar" style="width:${Math.round(qty / maxQty * 100)}%"></div>
              </div>
            </div>
          </div>`).join('')}
      </div>
    </section>`;
};
const $d94c521226fbc9fa$var$PALETTE = [
    '#22c55e',
    '#60a5fa',
    '#f59e0b',
    '#f87171',
    '#a78bfa',
    '#34d399',
    '#fb923c',
    '#818cf8'
];
const $d94c521226fbc9fa$var$makeOuterLabelPlugin = (mutedColor, textColor)=>({
        id: 'outerLabels',
        afterDraw (chart) {
            const { ctx: ctx } = chart;
            const meta = chart.getDatasetMeta(0);
            const ds = chart.data.datasets[0];
            const total = ds.data.reduce((s, v)=>s + v, 0);
            if (!total) return;
            ctx.save();
            ctx.textBaseline = 'middle';
            meta.data.forEach((arc, i)=>{
                const pct = ds.data[i] / total * 100;
                if (pct < 5) return;
                const mid = (arc.startAngle + arc.endAngle) / 2;
                const r = arc.outerRadius + 22;
                const x = arc.x + Math.cos(mid) * r;
                const y = arc.y + Math.sin(mid) * r;
                const align = x >= arc.x ? 'left' : 'right';
                ctx.textAlign = align;
                const raw = chart.data.labels[i] ?? '';
                const label = raw.length > 11 ? raw.slice(0, 10) + "\u2026" : raw;
                ctx.font = '700 11px system-ui, sans-serif';
                ctx.fillStyle = textColor ?? mutedColor;
                ctx.fillText(`${pct.toFixed(1)}%`, x, y - 8);
                ctx.font = '11px system-ui, sans-serif';
                ctx.fillStyle = mutedColor;
                ctx.fillText(label, x, y + 8);
            });
            ctx.restore();
        }
    });

class $d94c521226fbc9fa$var$ReportsView extends (0, $081656bd50f85abd$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("#reportsPanel");
    _Chart = null;
    _charts = {};
    _observers = {};
    _activeSection = "overview";
    _servingMetric = "overall";
    _servingTimeData = null;
    _channelSort = {
        orderType: "revenue",
        payment: "revenue"
    };
    _channelMixData = null;
    _paymentMixData = null;
    _channelOrderTypeEnabled = false;
    // Colors for the three serving-time cohorts + the Channels tab categories.
    // Kept in one place so the tile accents, flow diagram, stack bar, chart bars,
    // and donuts all agree (2026-08-27).
    static COHORT_COLOR = {
        overall: "#f59e0b",
        kitchen: "#F97316",
        pickup: "#14B8A6"
    };
    static ORDER_TYPE_COLOR = {
        "dine-in": "#18AE79",
        takeout: "#F59E0B"
    };
    static PAYMENT_COLOR = {
        cash: "#10B981",
        card: "#2563EB",
        qr: "#DB2777"
    };
    // ── Panel open / close ───────────────────────────────────────────────────
    open() {
        const el = this._parentElement;
        el.classList.remove("hidden", "rp-panel--exiting");
        el.querySelector(".rp-sidebar")?.classList.remove("hidden");
        el.querySelectorAll(".rp-tab").forEach((btn)=>{
            btn.classList.toggle("active", btn.dataset.period === "today");
        });
        document.querySelector("#reportsCustomRange").classList.add("hidden");
        this._hideLocked();
        this._switchSection("overview"); // animates the overview cards in
    }
    // ── Free-plan gate: Today+Overview is real; everything else shows one ─────
    // generic locked preview (not customized per section/period - kept simple
    // on purpose). The home dashboard's own today's-sales stat cards are a
    // separate surface and are unaffected by any of this.
    _lockedEl() {
        let el = this._parentElement.querySelector("#rpLockedSection");
        if (!el) {
            el = document.createElement("div");
            el.id = "rpLockedSection";
            this._parentElement.querySelector(".rp-body").appendChild(el);
        }
        return el;
    }
    _hideLocked() {
        this._lockedEl().hidden = true;
    }
    _showLocked() {
        this._parentElement.querySelectorAll(".rp-section").forEach((sec)=>sec.classList.add("hidden"));
        const el = this._lockedEl();
        el.hidden = false;
        el.innerHTML = (0, $ad2a264c69d845ec$export$eef1d84709e6997f)("reports", $d94c521226fbc9fa$var$fakeReportsMarkup());
    }
    // Shows/hides the generic locked preview for whichever section is
    // currently active, without re-switching sections - used when a period
    // change finishes (real Today fetch landed, or a locked period was
    // requested) and the active section itself hasn't changed.
    setSectionLocked(locked) {
        if (locked) {
            this._showLocked();
            return;
        }
        this._hideLocked();
        this._parentElement.querySelector(`.rp-section[data-section="${this._activeSection}"]`)?.classList.remove("hidden");
    }
    // Fade-up + stagger entrance for the cards within `scope`. Runs on open AND on
    // every tab switch so each section animates in fresh, not just the first time.
    _animateCards(scope) {
        if (!scope) return;
        scope.querySelectorAll(".rp-kpi, .rp-card, .rp-tile").forEach((card, i)=>{
            card.animate([
                {
                    opacity: 0,
                    transform: "translateY(22px)"
                },
                {
                    opacity: 1,
                    transform: "translateY(0)"
                }
            ], {
                duration: 500,
                delay: 40 + i * 45,
                easing: "cubic-bezier(0.22,1,0.36,1)",
                fill: "backwards"
            });
        });
    }
    // Replay the entrance animation on whichever section is currently shown.
    // Called after a period change (Today/Week/Month/Year) so the cards - and the
    // donut/bar charts inside them - visibly animate in every time, not just on
    // first open or tab switch.
    replayActiveSection() {
        const active = this._parentElement.querySelector(`.rp-section[data-section="${this._activeSection}"]`);
        this._animateCards(active);
    }
    // ── Sidebar section switching ─────────────────────────────────────────────
    _switchSection(section, locked = false) {
        this._activeSection = section;
        this._parentElement.querySelectorAll(".rp-nav-tab").forEach((btn)=>{
            btn.classList.toggle("rp-nav-tab--active", btn.dataset.section === section);
        });
        if (locked) {
            this._showLocked();
            return;
        }
        this._hideLocked();
        let activeSec = null;
        this._parentElement.querySelectorAll(".rp-section").forEach((sec)=>{
            const isActive = sec.dataset.section === section;
            sec.classList.toggle("hidden", !isActive);
            if (isActive) activeSec = sec;
        });
        this._animateCards(activeSec); // replay the entrance on every switch
    }
    // isSectionLocked(section): controller-supplied predicate combining plan +
    // the current period (only Overview+Today is ever real on a free plan).
    _addHandlerSections(isSectionLocked) {
        this._parentElement.querySelector(".rp-sidebar")?.addEventListener("click", (e)=>{
            const btn = e.target.closest(".rp-nav-tab");
            if (!btn) return;
            const section = btn.dataset.section;
            this._switchSection(section, isSectionLocked?.(section) ?? false);
        });
    }
    close() {
        this._parentElement.classList.add("rp-panel--exiting");
        setTimeout(()=>{
            this._parentElement.classList.add("hidden");
            this._parentElement.classList.remove("rp-panel--exiting");
        }, 240);
    }
    setPeriodLabel(label) {
        document.querySelector("#reportsPeriodLabel").textContent = label;
    }
    // ‹ › arrows + "Today" chip around the period label. Arrows hide for Custom;
    // › is disabled on the current period (no future); "Today" shows once the
    // user has stepped away from it.
    setStepper(period, offset = 0) {
        const el = document.querySelector("#reportsStepper");
        if (!el) return;
        el.classList.toggle("period-stepper--static", period === "custom");
        const next = el.querySelector('[data-step="1"]');
        if (next) next.disabled = offset >= 0;
        el.querySelector(".period-step-today")?.classList.toggle("hidden", period === "custom" || offset === 0);
    }
    _addHandlerStep(handler) {
        document.querySelector("#reportsStepper")?.addEventListener("click", (e)=>{
            const btn = e.target.closest("[data-step]");
            if (!btn || btn.disabled) return;
            handler(Number(btn.dataset.step));
        });
    }
    setActivePeriod(period) {
        this._parentElement.querySelectorAll(".rp-tab").forEach((btn)=>{
            btn.classList.toggle("active", btn.dataset.period === period);
        });
        document.querySelector("#reportsCustomRange").classList.toggle("hidden", period !== "custom");
    }
    // ── Loading skeleton ─────────────────────────────────────────────────────
    renderLoading() {
        // Skeleton the Overview KPI values so a (re)load never shows stale numbers.
        // reportsNetIncome/reportsOverviewTransactions were missing here (found
        // 2026-09-02 building the Reports plan-gate skeleton reuse) - Net Income
        // and Transactions kept showing the previous period's frozen values.
        [
            "reportsRevenue",
            "reportsNetIncome",
            "reportsOverviewTransactions",
            "reportsTransactions",
            "reportsAvgOrder",
            "reportsServingTime",
            "reportsKitchenTime",
            "reportsPickupWait"
        ].forEach((id)=>{
            const el = document.querySelector(`#${id}`);
            if (el) {
                el.classList.remove("rp-kpi-val--muted", "rp-tile-val--muted");
                el.innerHTML = '<span class="skel rp-kpi-skel"></span>';
            }
        });
        // Reset the serving-time metric toggle and hide the lifecycle flow / Channels
        // cards until fresh data lands, same "don't show stale data mid-load" rule.
        this._servingMetric = "overall";
        this._servingTimeData = null;
        document.querySelectorAll("#rpServingMetricSeg button").forEach((b)=>{
            b.classList.toggle("active", b.dataset.metric === "overall");
        });
        document.querySelector("#rpServingMetricSeg")?.style.setProperty("--seg-accent", $d94c521226fbc9fa$var$ReportsView.COHORT_COLOR.overall);
        document.querySelector("#rpLifecycleBody")?.classList.add("hidden");
        document.querySelector("#rpLifecycleEmpty")?.classList.add("hidden");
        [
            "rpSpeedBody",
            "rpSpeedEmpty",
            "rpSpeedCmp"
        ].forEach((id)=>document.querySelector(`#${id}`)?.classList.add("hidden"));
        [
            "rpOrderTypeBody",
            "rpPaymentBody"
        ].forEach((id)=>document.querySelector(`#${id}`)?.classList.add("hidden"));
        [
            "rpOrderTypeEmpty",
            "rpPaymentEmpty"
        ].forEach((id)=>document.querySelector(`#${id}`)?.classList.add("hidden"));
        document.querySelector("#rpChanServingCard")?.classList.add("hidden");
        // Reset the Channels Qty/Gross Income toggles and destroy their donuts so
        // a period change doesn't briefly show the previous period's chart.
        this._channelSort = {
            orderType: "revenue",
            payment: "revenue"
        };
        [
            "orderTypeSortPills",
            "paymentSortPills"
        ].forEach((id)=>{
            document.querySelectorAll(`#${id} .rp-sort-pill`).forEach((b)=>b.classList.toggle("active", b.dataset.sort === "revenue"));
        });
        [
            "orderType",
            "payment"
        ].forEach((key)=>{
            if (this._charts[key]) {
                this._charts[key].destroy();
                this._charts[key] = null;
            }
        });
        this._observers["rpOrderTypeCanvas"]?.disconnect();
        this._observers["rpPaymentCanvas"]?.disconnect();
        // Reset the donut/bar charts to their skeleton placeholders so the new chart
        // visibly animates IN when the data arrives (rather than swapping over stale
        // data, where the entrance animation is easy to miss).
        this._chartCards().forEach(([cardId, phId, wrapId, key, canvasId])=>{
            this._observers[canvasId]?.disconnect();
            delete this._observers[canvasId];
            if (this._charts[key]) {
                this._charts[key].destroy();
                this._charts[key] = null;
            }
            this._deactivateCard(cardId, phId, wrapId);
        });
        document.querySelector("#reportsTopItems").innerHTML = `
      <div class="rp-item-list">
        ${[
            80,
            65,
            50,
            35,
            20
        ].map((w)=>`
          <div class="rp-item-row">
            <div class="rp-skeleton rp-skeleton--rank"></div>
            <div class="rp-item-main">
              <div class="rp-skeleton" style="width:${w}%;height:12px;margin-bottom:8px;border-radius:6px"></div>
              <div class="rp-skeleton" style="width:100%;height:4px;border-radius:99px"></div>
            </div>
          </div>`).join("")}
      </div>`;
    }
    // ── Summary KPIs ─────────────────────────────────────────────────────────
    renderSummary({ revenue: revenue, transactions: transactions, avgOrder: avgOrder, avgServingMinutes: avgServingMinutes }) {
        document.querySelector("#reportsRevenue").textContent = $d94c521226fbc9fa$var$fmt(revenue);
        const sgEl = document.querySelector("#salesGrossIncome");
        if (sgEl) sgEl.textContent = $d94c521226fbc9fa$var$fmt(revenue);
        document.querySelector("#reportsTransactions").textContent = transactions;
        const otEl = document.querySelector("#reportsOverviewTransactions");
        if (otEl) otEl.textContent = transactions;
        document.querySelector("#reportsAvgOrder").textContent = $d94c521226fbc9fa$var$fmt(avgOrder);
        const servEl = document.querySelector("#reportsServingTime");
        if (servEl) {
            servEl.textContent = this._fmtDur(avgServingMinutes);
            servEl.classList.toggle("rp-tile-val--muted", avgServingMinutes == null);
        }
    }
    // ── Kitchen / Queue: serving-time cohorts ────────────────────────────────
    _fmtDur(mins) {
        if (mins == null) return "\u2014";
        const m = Math.floor(mins);
        const s = Math.round((mins - m) * 60);
        return s > 0 ? `${m}m ${s}s` : `${m}m`;
    }
    // Chart.js y-axis tick label for a minutes value. Whole-minute rounding is fine
    // once values span multiple minutes, but a sub-minute chart (Today with only a
    // few orders, or the Pickup wait cohort) had every tick round to the same "0m"/
    // "1m" - switch to seconds below 1 minute so the ticks stay distinct.
    _fmtAxisMin(v) {
        return v < 1 ? `${Math.round(v * 60)}s` : `${v.toFixed(0)}m`;
    }
    // The two new sub-cohorts (2026-08-27): kitchen = Placed -> Ready, pickup =
    // Ready -> Done. Both are null when no order in the period was ever marked
    // Ready (that step is optional), in which case the lifecycle diagram shows an
    // empty note instead of a 0/0 split.
    renderKitchenBreakdown(servingTime) {
        const kitchenEl = document.querySelector("#reportsKitchenTime");
        const pickupEl = document.querySelector("#reportsPickupWait");
        const kitchenMins = servingTime?.kitchen?.avgMinutes ?? null;
        const pickupMins = servingTime?.pickup?.avgMinutes ?? null;
        if (kitchenEl) {
            kitchenEl.textContent = this._fmtDur(kitchenMins);
            kitchenEl.classList.toggle("rp-tile-val--muted", kitchenMins == null);
        }
        if (pickupEl) {
            pickupEl.textContent = this._fmtDur(pickupMins);
            pickupEl.classList.toggle("rp-tile-val--muted", pickupMins == null);
        }
        const body = document.querySelector("#rpLifecycleBody");
        const empty = document.querySelector("#rpLifecycleEmpty");
        if (!body) return;
        if (kitchenMins == null || pickupMins == null) {
            body.classList.add("hidden");
            if (empty) {
                empty.textContent = "No orders in this period were marked Ready for Pickup, so there's no Kitchen / Pickup Wait split to show yet.";
                empty.classList.remove("hidden");
            }
            return;
        }
        body.classList.remove("hidden");
        if (empty) empty.classList.add("hidden");
        const total = kitchenMins + pickupMins;
        const kitchenPct = total > 0 ? Math.round(kitchenMins / total * 100) : 50;
        const pickupPct = 100 - kitchenPct;
        const { kitchen: kColor, pickup: pColor } = $d94c521226fbc9fa$var$ReportsView.COHORT_COLOR;
        const kFill = document.querySelector("#rpFlowKitchenFill");
        if (kFill) kFill.style.width = `${kitchenPct}%`;
        const kCap = document.querySelector("#rpFlowKitchenCaption");
        if (kCap) kCap.textContent = `Kitchen \xb7 ${this._fmtDur(kitchenMins)} avg`;
        const pFill = document.querySelector("#rpFlowPickupFill");
        if (pFill) pFill.style.width = `${pickupPct}%`;
        const pCap = document.querySelector("#rpFlowPickupCaption");
        if (pCap) pCap.textContent = `Pickup wait \xb7 ${this._fmtDur(pickupMins)} avg`;
        // A segment too thin to fit its label drops the text (it was clipped to
        // "m 26") - the flow captions above and the hover title still give it.
        const setStack = (el, pct, mins)=>{
            if (!el) return;
            el.style.width = `${pct}%`;
            el.textContent = pct >= 18 ? this._fmtDur(mins) : "";
            el.title = this._fmtDur(mins);
        };
        setStack(document.querySelector("#rpTimeStackKitchen"), kitchenPct, kitchenMins);
        setStack(document.querySelector("#rpTimeStackPickup"), pickupPct, pickupMins);
        const note = document.querySelector("#rpLifecycleNote");
        if (note) {
            const pct = Math.round((servingTime.readyShare ?? 0) * 100);
            note.textContent = `Only orders marked Ready for Pickup \u{2014} ${pct}% of orders this period (${servingTime.readyCount ?? 0} of ${servingTime.preparedCount ?? 0}).`;
        }
    }
    // ── Kitchen: Speed of Service ────────────────────────────────────────────
    // `speed` / `prevSpeed` are { onTime, slow, delayed, total, yellow, red }
    // from the controller's _computeSpeedOfService (null = no done orders).
    // The comparison pill is the change in on-time SHARE, in percentage points.
    renderSpeedOfService(speed, prevSpeed, vsLabel) {
        const body = document.querySelector("#rpSpeedBody");
        const empty = document.querySelector("#rpSpeedEmpty");
        const cmp = document.querySelector("#rpSpeedCmp");
        if (!body) return;
        if (cmp) {
            cmp.innerHTML = "";
            cmp.className = "rp-kpi-cmp hidden";
        }
        if (!speed?.total) {
            body.classList.add("hidden");
            empty?.classList.remove("hidden");
            return;
        }
        body.classList.remove("hidden");
        empty?.classList.add("hidden");
        const pct = (n)=>Math.round(n / speed.total * 100);
        const min = (secs)=>`${Math.round(secs / 60)} min`;
        const rows = [
            [
                "OnTime",
                speed.onTime,
                `under ${min(speed.yellow)}`
            ],
            [
                "Slow",
                speed.slow,
                `${Math.round(speed.yellow / 60)}-${min(speed.red)}`
            ],
            [
                "Delayed",
                speed.delayed,
                `over ${min(speed.red)}`
            ]
        ];
        rows.forEach(([key, n, range])=>{
            document.querySelector(`#rpSpeed${key}`).textContent = n;
            document.querySelector(`#rpSpeed${key}Sub`).textContent = `${pct(n)}% \xb7 ${range}`;
            document.querySelector(`#rpSpeedSeg${key}`).style.width = `${n / speed.total * 100}%`;
        });
        document.querySelector("#rpSpeedBar")?.setAttribute("aria-label", `${pct(speed.onTime)}% on time, ${pct(speed.slow)}% slow, ${pct(speed.delayed)}% delayed`);
        const note = document.querySelector("#rpSpeedNote");
        if (note) note.textContent = `${speed.total} completed order${speed.total !== 1 ? "s" : ""} this period.`;
        if (cmp && prevSpeed?.total) {
            const diff = pct(speed.onTime) - Math.round(prevSpeed.onTime / prevSpeed.total * 100);
            const arrow = diff >= 0 ? `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>` : `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>`;
            cmp.className = `rp-kpi-cmp ${diff >= 0 ? "rp-kpi-cmp--up" : "rp-kpi-cmp--down"}`;
            cmp.innerHTML = `${arrow} ${Math.abs(diff)} pts on time vs ${vsLabel}`;
        }
    }
    // ── Channels tab: Order Type & Payment Method ────────────────────────────
    // Donuts use the same Chart.js treatment as the Sales tab's Category/Item
    // Mix charts (border gap, rounded segments, hover pop, animate-in, center
    // total that flips to the hovered segment) rather than a hand-rolled CSS
    // conic-gradient - which also had a hairline seam at the 12 o'clock start/
    // end angle when a segment's rounded percentage didn't land exactly on
    // 100% (found 2026-08-27, visible on Order Type when Takeout was a sliver).
    async renderChannels({ channelMix: channelMix, paymentMix: paymentMix, orderTypeEnabled: orderTypeEnabled }) {
        this._channelMixData = channelMix;
        this._paymentMixData = paymentMix;
        this._channelOrderTypeEnabled = orderTypeEnabled;
        let Chart;
        try {
            Chart = await this._ensureChart();
        } catch  {
            return; // error state already shown by renderCharts
        }
        this._renderChannelCard(Chart, "orderType", {
            bodyId: "rpOrderTypeBody",
            emptyId: "rpOrderTypeEmpty",
            canvasId: "rpOrderTypeCanvas",
            rowsId: "rpOrderTypeRows",
            items: orderTypeEnabled ? channelMix.filter((c)=>c.type !== "unspecified") : [],
            colorFor: (item)=>$d94c521226fbc9fa$var$ReportsView.ORDER_TYPE_COLOR[item.type] ?? "#98A2B3",
            emptyMsg: orderTypeEnabled ? "No order-type data for this period." : "Dine In / Takeout tracking is off. Turn it on in Settings \u2192 POS to see this.",
            avgFmt: (item)=>`avg ${$d94c521226fbc9fa$var$fmt(item.avgOrder)}`,
            totalSuffix: "orders"
        });
        this._renderChannelCard(Chart, "payment", {
            bodyId: "rpPaymentBody",
            emptyId: "rpPaymentEmpty",
            canvasId: "rpPaymentCanvas",
            rowsId: "rpPaymentRows",
            items: paymentMix,
            colorFor: (item)=>$d94c521226fbc9fa$var$ReportsView.PAYMENT_COLOR[item.method] ?? "#98A2B3",
            emptyMsg: "No sales data for this period.",
            avgFmt: null,
            totalSuffix: "orders"
        });
        const dineIn = channelMix.find((c)=>c.type === "dine-in");
        const takeout = channelMix.find((c)=>c.type === "takeout");
        const chanServingCard = document.querySelector("#rpChanServingCard");
        if (chanServingCard) {
            const show = orderTypeEnabled && dineIn?.avgServingMinutes != null && takeout?.avgServingMinutes != null;
            chanServingCard.classList.toggle("hidden", !show);
            if (show) {
                const dEl = document.querySelector("#rpChanServingDineIn");
                const tEl = document.querySelector("#rpChanServingTakeout");
                if (dEl) dEl.textContent = this._fmtDur(dineIn.avgServingMinutes);
                if (tEl) tEl.textContent = this._fmtDur(takeout.avgServingMinutes);
            }
        }
    }
    // Shared renderer for the Order Type / Payment Method cards - a Chart.js
    // doughnut (mirrors _renderCategoryChart's border/cutout/animation/hover)
    // plus a comparison row per category. `chartKey` selects `this._charts[key]`
    // and `this._channelSort[key]` ("revenue" | "count" - the Qty/Gross Income
    // toggle), so the donut size, row ordering, and which number is bold all
    // switch together.
    _renderChannelCard(Chart, chartKey, { bodyId: bodyId, emptyId: emptyId, canvasId: canvasId, rowsId: rowsId, items: items, colorFor: colorFor, emptyMsg: emptyMsg, avgFmt: avgFmt, totalSuffix: totalSuffix }) {
        const body = document.querySelector(`#${bodyId}`);
        const empty = document.querySelector(`#${emptyId}`);
        const canvas = document.querySelector(`#${canvasId}`);
        if (!body || !canvas) return;
        if (!items.length) {
            body.classList.add("hidden");
            if (empty) {
                empty.textContent = emptyMsg;
                empty.classList.remove("hidden");
            }
            if (this._charts[chartKey]) {
                this._charts[chartKey].destroy();
                this._charts[chartKey] = null;
            }
            this._observers[canvasId]?.disconnect();
            return;
        }
        body.classList.remove("hidden");
        if (empty) empty.classList.add("hidden");
        const sortKey = this._channelSort[chartKey] ?? "revenue"; // "revenue" | "count"
        const byCount = sortKey === "count";
        const sorted = [
            ...items
        ].sort((a, b)=>byCount ? b.count - a.count : b.revenue - a.revenue);
        const totalCount = items.reduce((s, i)=>s + i.count, 0);
        const colors = sorted.map(colorFor);
        const gapColor = this._css("--panel-strong");
        const textColor = this._css("--text");
        const mutedColor = this._css("--muted");
        if (this._charts[chartKey]) {
            this._charts[chartKey].destroy();
            this._charts[chartKey] = null;
        }
        const centerPlugin = {
            id: `centerText_${chartKey}`,
            afterDraw: (chart)=>{
                const { ctx: ctx, chartArea: { top: top, bottom: bottom, left: left, right: right } } = chart;
                const cx = (left + right) / 2, cy = (top + bottom) / 2;
                const active = chart.getActiveElements();
                let l1, l2;
                if (active.length > 0) {
                    const { index: index } = active[0];
                    const item = sorted[index];
                    l1 = byCount ? String(item.count) : $d94c521226fbc9fa$var$fmt(item.revenue);
                    l2 = item.label.length > 10 ? item.label.slice(0, 9) + "\u2026" : item.label;
                } else {
                    l1 = String(totalCount);
                    l2 = totalSuffix;
                }
                ctx.save();
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                ctx.font = "bold 19px system-ui, sans-serif";
                ctx.fillStyle = textColor;
                ctx.fillText(l1, cx, cy - 9);
                ctx.font = "11px system-ui, sans-serif";
                ctx.fillStyle = mutedColor;
                ctx.fillText(l2, cx, cy + 11);
                ctx.restore();
            }
        };
        this._observeChart(canvasId, (cvs)=>{
            this._charts[chartKey] = new Chart(cvs, {
                type: "doughnut",
                data: {
                    labels: sorted.map((i)=>i.label),
                    datasets: [
                        {
                            data: sorted.map((i)=>byCount ? i.count : i.revenue),
                            backgroundColor: colors,
                            borderWidth: 3,
                            borderColor: gapColor,
                            borderRadius: 6,
                            hoverOffset: 10,
                            hoverBorderColor: gapColor
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutout: "68%",
                    animation: this._donutAnim(),
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx)=>byCount ? ` ${ctx.label}: ${ctx.raw} order${ctx.raw !== 1 ? "s" : ""}` : ` ${ctx.label}: ${$d94c521226fbc9fa$var$fmt(ctx.raw)}`
                            }
                        }
                    }
                },
                plugins: [
                    centerPlugin
                ]
            });
            requestAnimationFrame(()=>this._charts[chartKey]?.resize());
        });
        const rows = document.querySelector(`#${rowsId}`);
        if (rows) rows.innerHTML = sorted.map((item)=>{
            const color = colorFor(item);
            const pct = Math.round(((byCount ? item.countShare : item.share) ?? 0) * 100);
            const primary = byCount ? `${item.count} order${item.count !== 1 ? "s" : ""}` : $d94c521226fbc9fa$var$fmt(item.revenue);
            const secondary = byCount ? $d94c521226fbc9fa$var$fmt(item.revenue) : `${item.count} order${item.count !== 1 ? "s" : ""}`;
            const avgPart = avgFmt ? ` \xb7 ${avgFmt(item)}` : "";
            return `
          <div>
            <div class="chan-row-top">
              <span class="chan-row-name"><span class="chan-dot" style="background:${color}"></span>${(0, $cnCXJ.esc)(item.label)}</span>
              <span class="chan-row-val">${primary}</span>
            </div>
            <div class="chan-row-sub">${secondary}${avgPart} \xb7 ${pct}%</div>
            <div class="chan-track"><div class="chan-fill" style="width:${pct}%;background:${color}"></div></div>
          </div>`;
        }).join("");
    }
    _addHandlerChannelSort() {
        const wire = (containerId, chartKey)=>{
            document.querySelector(`#${containerId}`)?.addEventListener("click", (e)=>{
                const pill = e.target.closest(".rp-sort-pill");
                if (!pill || pill.classList.contains("active")) return;
                document.querySelectorAll(`#${containerId} .rp-sort-pill`).forEach((b)=>b.classList.remove("active"));
                pill.classList.add("active");
                this._channelSort[chartKey] = pill.dataset.sort;
                this._ensureChart().then((Chart)=>{
                    if (chartKey === "orderType") this._renderChannelCard(Chart, "orderType", {
                        bodyId: "rpOrderTypeBody",
                        emptyId: "rpOrderTypeEmpty",
                        canvasId: "rpOrderTypeCanvas",
                        rowsId: "rpOrderTypeRows",
                        items: this._channelOrderTypeEnabled ? (this._channelMixData ?? []).filter((c)=>c.type !== "unspecified") : [],
                        colorFor: (item)=>$d94c521226fbc9fa$var$ReportsView.ORDER_TYPE_COLOR[item.type] ?? "#98A2B3",
                        emptyMsg: this._channelOrderTypeEnabled ? "No order-type data for this period." : "Dine In / Takeout tracking is off. Turn it on in Settings \u2192 POS to see this.",
                        avgFmt: (item)=>`avg ${$d94c521226fbc9fa$var$fmt(item.avgOrder)}`,
                        totalSuffix: "orders"
                    });
                    else this._renderChannelCard(Chart, "payment", {
                        bodyId: "rpPaymentBody",
                        emptyId: "rpPaymentEmpty",
                        canvasId: "rpPaymentCanvas",
                        rowsId: "rpPaymentRows",
                        items: this._paymentMixData ?? [],
                        colorFor: (item)=>$d94c521226fbc9fa$var$ReportsView.PAYMENT_COLOR[item.method] ?? "#98A2B3",
                        emptyMsg: "No sales data for this period.",
                        avgFmt: null,
                        totalSuffix: "orders"
                    });
                }).catch(()=>{});
            });
        };
        wire("orderTypeSortPills", "orderType");
        wire("paymentSortPills", "payment");
    }
    // ── Full-list modal ──────────────────────────────────────────────────────
    _openListModal(title, bodyHtml) {
        const modal = document.querySelector("#rpListModal");
        if (!modal) return;
        document.querySelector("#rpListModalTitle").textContent = title;
        document.querySelector("#rpListModalBody").innerHTML = bodyHtml;
        modal.classList.remove("hidden");
        const close = ()=>modal.classList.add("hidden");
        document.querySelector("#rpListModalClose").onclick = close;
        modal.onclick = (e)=>{
            if (e.target === modal) close();
        };
    }
    // ── Top items list ───────────────────────────────────────────────────────
    renderTopItems(items, sortKey = "quantity") {
        const el = document.querySelector("#reportsTopItems");
        if (!items.length) {
            el.innerHTML = `<p class="rp-empty">No sales data for this period.</p>`;
            return;
        }
        const LIMIT = 6;
        const preview = items.slice(0, LIMIT);
        const maxQty = items[0].quantity;
        const maxRev = items[0].revenue;
        const byQty = sortKey === "quantity";
        const MEDALS = [
            "\uD83E\uDD47",
            "\uD83E\uDD48",
            "\uD83E\uDD49"
        ];
        const rowHtml = (item, i)=>`
      <div class="rp-item-row">
        <span class="rp-item-rank">${MEDALS[i] ?? i + 1}</span>
        <div class="rp-item-main">
          <div class="rp-item-row-top">
            <span class="rp-item-name">${(0, $cnCXJ.esc)(item.name)}</span>
            <span class="rp-item-rev">${byQty ? item.quantity : $d94c521226fbc9fa$var$fmt(item.revenue)}</span>
          </div>
          <div class="rp-item-bar-track">
            <div class="rp-item-bar" style="width:${byQty ? Math.round(item.quantity / maxQty * 100) : Math.round(item.revenue / maxRev * 100)}%"></div>
          </div>
          <span class="rp-item-qty">${byQty ? $d94c521226fbc9fa$var$fmt(item.revenue) : `${item.quantity} sold`}</span>
        </div>
      </div>`;
        el.innerHTML = `
      <div class="rp-item-list rp-item-list--grid">
        ${preview.map((item, i)=>rowHtml(item, i)).join("")}
      </div>
      ${items.length > LIMIT ? `<button class="rp-top-items-toggle">View full list (${items.length} items)</button>` : ""}`;
        if (items.length > LIMIT) el.querySelector(".rp-top-items-toggle").addEventListener("click", ()=>{
            this._openListModal("Top Items", `
          <div class="rp-item-list">
            ${items.map((item, i)=>rowHtml(item, i)).join("")}
          </div>`);
        });
    }
    // ── Charts ───────────────────────────────────────────────────────────────
    // ── Comparison badges ────────────────────────────────────────────────────
    renderComparison(current, previous, vsLabel) {
        const update = (id, curr, prev, invert = false)=>{
            const el = document.querySelector(`#${id}`);
            if (!el) return;
            if (prev == null || prev === 0) {
                // No prior-period value to compare against - hide the pill entirely
                // rather than leaving it empty, which (with a stale --up/--down class
                // from a previous render still applied) rendered as a small colored
                // blob with no text. Reset the class too so it starts clean if data
                // becomes available on a later render.
                el.innerHTML = "";
                el.className = "rp-kpi-cmp hidden";
                return;
            }
            const pct = Math.round((curr - prev) / prev * 100);
            const up = invert ? pct <= 0 : pct >= 0;
            const arrow = pct >= 0 ? `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>` : `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>`;
            el.className = `rp-kpi-cmp ${up ? "rp-kpi-cmp--up" : "rp-kpi-cmp--down"}`;
            el.innerHTML = `${arrow} ${Math.abs(pct)}% vs ${vsLabel}`;
        };
        update("reportsRevenueCmp", current.revenue, previous.revenue);
        update("reportsTransCmp", current.transactions, previous.transactions);
        update("reportsAvgCmp", current.avgOrder, previous.avgOrder);
        update("reportsServingCmp", current.avgServingMinutes, previous.avgServingMinutes, true);
        update("reportsNetCmp", current.net, previous.net);
        update("reportsOverviewTransCmp", current.transactions, previous.transactions);
    }
    // ── Charts ───────────────────────────────────────────────────────────────
    async renderCharts({ categoryMix: categoryMix, itemMix: itemMix, hourlyBreakdown: hourlyBreakdown, dayOfWeek: dayOfWeek, servingTime: servingTime }) {
        let Chart;
        try {
            Chart = await this._ensureChart();
        } catch (err) {
            console.error('[Pointbunny] Chart.js failed to load after retries:', err);
            this._setChartsError();
            return;
        }
        this._servingTimeData = servingTime;
        this._renderCategoryChart(Chart, categoryMix);
        this._renderItemMixChart(Chart, itemMix ?? []);
        this._renderHourlyChart(Chart, hourlyBreakdown);
        this._renderDowChart(Chart, dayOfWeek);
        this._renderServingHourChart(Chart, servingTime);
        this._renderServingDayChart(Chart, servingTime);
    }
    // ── Chart.js loader with retry ─────────────────────────────────────────────
    // Parcel compiles dynamic-import chunks lazily; on a cold dev-server start
    // the chunk may not exist yet when we first try to fetch it. Retry with
    // increasing delays so charts appear automatically once Parcel finishes.
    async _ensureChart() {
        if (this._Chart) return this._Chart;
        if (this._chartPromise) return this._chartPromise; // deduplicate concurrent calls
        const DELAYS = [
            1500,
            2000,
            3000,
            4000
        ]; // ms between attempts (4 retries)
        let spinnerShown = false;
        this._chartPromise = (async ()=>{
            for(let attempt = 0; attempt <= DELAYS.length; attempt++)try {
                const { Chart: Chart, registerables: registerables } = await (parcelRequire("hHoOP"));
                Chart.register(...registerables);
                Chart.defaults.font.family = 'Inter, sans-serif';
                Chart.defaults.font.size = 11;
                this._Chart = Chart;
                this._chartPromise = null;
                return Chart;
            } catch (err) {
                if (attempt < DELAYS.length) {
                    // On first failure: swap skeleton bars → spinner so user knows what's happening
                    if (!spinnerShown) {
                        spinnerShown = true;
                        this._setChartPlaceholdersSpinner();
                    }
                    await new Promise((r)=>setTimeout(r, DELAYS[attempt]));
                } else {
                    // All retries exhausted
                    this._chartPromise = null;
                    this._Chart = null;
                    throw err;
                }
            }
        })();
        return this._chartPromise;
    }
    // Kick off Chart.js loading eagerly (fire-and-forget) so Parcel has max time
    preloadChart() {
        this._ensureChart().catch(()=>{});
    }
    _setChartPlaceholdersSpinner() {
        const html = `
      <div class="rp-chart-loading">
        <span class="rp-chart-spinner"></span>
        <span class="rp-chart-loading-text">Loading charts\u{2026}</span>
      </div>`;
        [
            'rpRevenuePh',
            'rpCategoryPh',
            'rpHourlyPh'
        ].forEach((id)=>{
            const el = document.querySelector(`#${id}`);
            if (el && !el.classList.contains('hidden')) el.innerHTML = html;
        });
    }
    _setChartsError() {
        this._Chart = null; // reset so reopening Reports will retry fresh
        const html = `
      <div class="rp-chart-error">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        <span>Charts failed to load</span>
        <button class="rp-chart-retry-btn" type="button" onclick="window.location.reload()">Reload page</button>
      </div>`;
        [
            'rpRevenuePh',
            'rpCategoryPh',
            'rpHourlyPh'
        ].forEach((id)=>{
            const el = document.querySelector(`#${id}`);
            if (el && !el.classList.contains('hidden')) el.innerHTML = html;
        });
    }
    _css(v) {
        return getComputedStyle(document.documentElement).getPropertyValue(v).trim();
    }
    _withAlpha(hex, a) {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r},${g},${b},${a})`;
    }
    _barAnim(stagger = 30) {
        return {
            duration: 700,
            easing: "easeOutQuart",
            delay: (ctx)=>ctx.type === "data" && ctx.mode === "default" ? ctx.dataIndex * stagger : 0
        };
    }
    _donutAnim() {
        return {
            animateRotate: true,
            animateScale: true,
            duration: 850,
            easing: "easeOutCubic"
        };
    }
    _activateCard(cardId, phId, wrapId, badgeId) {
        document.querySelector(`#${cardId}`)?.classList.remove("rp-card--ph");
        document.querySelector(`#${phId}`)?.classList.add("hidden");
        document.querySelector(`#${wrapId}`)?.classList.remove("hidden");
        const badge = document.querySelector(`#${badgeId}`);
        if (badge) badge.style.display = "none";
    }
    // Reverse of _activateCard: drop the live chart back to its placeholder
    // skeleton (hide the canvas wrap, show the rp-ph shapes). Used while loading so
    // each chart visibly animates back IN when the new data lands.
    _deactivateCard(cardId, phId, wrapId) {
        document.querySelector(`#${cardId}`)?.classList.add("rp-card--ph");
        document.querySelector(`#${phId}`)?.classList.remove("hidden");
        document.querySelector(`#${wrapId}`)?.classList.add("hidden");
    }
    // Chart cards that render via _observeChart (donuts + bars). [card, ph, wrap,
    // chartKey, canvasId]. The Overview line chart is excluded - it has its own
    // render path and metric state.
    _chartCards() {
        return [
            [
                "rpCategoryCard",
                "rpCategoryPh",
                "rpCategoryWrap",
                "category",
                "rpCategoryCanvas"
            ],
            [
                "rpItemMixCard",
                "rpItemMixPh",
                "rpItemMixWrap",
                "itemMix",
                "rpItemMixCanvas"
            ],
            [
                "rpHourlyCard",
                "rpHourlyPh",
                "rpHourlyWrap",
                "hourly",
                "rpHourlyCanvas"
            ],
            [
                "rpDowCard",
                "rpDowPh",
                "rpDowWrap",
                "dow",
                "rpDowCanvas"
            ],
            [
                "rpServingHourCard",
                "rpServingHourPh",
                "rpServingHourWrap",
                "servingHour",
                "rpServingHourCanvas"
            ],
            [
                "rpServingDayCard",
                "rpServingDayPh",
                "rpServingDayWrap",
                "servingDay",
                "rpServingDayCanvas"
            ],
            [
                "rpTipsCard",
                "rpTipsPh",
                "rpTipsWrap",
                "tips",
                "rpTipsCanvas"
            ]
        ];
    }
    _observeChart(canvasId, factory) {
        this._observers[canvasId]?.disconnect();
        delete this._observers[canvasId];
        const canvas = document.querySelector(`#${canvasId}`);
        if (!canvas) return;
        // Observe the parent wrap (has CSS height) — canvas itself may be 0px before Chart.js runs
        const target = canvas.parentElement ?? canvas;
        // If the chart is already on-screen (e.g. changing the period while viewing
        // this section), build it on the next frame so the Chart.js entrance
        // animation replays every time - not just on first reveal. Deferring a frame
        // lets layout settle first, so the factory's chart.resize() is a no-op and
        // doesn't cancel the just-started animation. Only fall back to the observer
        // for hidden/off-screen sections (lazy first render).
        const rect = target.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const onScreen = rect.width > 0 && rect.height > 0 && rect.top < vh && rect.bottom > 0;
        if (onScreen) {
            requestAnimationFrame(()=>factory(canvas));
            return;
        }
        const obs = new IntersectionObserver((entries)=>{
            if (!entries[0].isIntersecting) return;
            obs.disconnect();
            delete this._observers[canvasId];
            factory(canvas);
        }, {
            threshold: 0
        });
        this._observers[canvasId] = obs;
        obs.observe(target);
    }
    async renderOverviewChart({ labels: labels, datasets: datasets }) {
        let Chart;
        try {
            Chart = await this._ensureChart();
        } catch  {
            return; // error state already shown by renderCharts
        }
        this._activateCard("rpRevenueCard", "rpRevenuePh", "rpRevenueWrap", "rpRevenueBadge");
        // Cancel any pending observer so we can render immediately (canvas is visible)
        this._observers['rpRevenueCanvas']?.disconnect();
        delete this._observers['rpRevenueCanvas'];
        if (this._charts.revenue) {
            this._charts.revenue.destroy();
            this._charts.revenue = null;
        }
        const canvas = document.querySelector('#rpRevenueCanvas');
        if (!canvas) return;
        // Empty state: no metrics selected
        const wrap = canvas.parentElement;
        let emptyEl = wrap.querySelector('.rp-chart-empty');
        if (!emptyEl) {
            emptyEl = document.createElement('div');
            emptyEl.className = 'rp-chart-empty';
            emptyEl.innerHTML = '<span>Select a card above to display it on the chart</span>';
            wrap.appendChild(emptyEl);
        }
        const legendEl = document.getElementById('rpOverviewLegend');
        if (datasets.length === 0) {
            canvas.style.display = 'none';
            emptyEl.style.display = '';
            const titleEl = document.getElementById('rpOverviewChartTitle');
            if (titleEl) titleEl.textContent = 'Overview';
            if (legendEl) legendEl.innerHTML = '';
            return;
        }
        canvas.style.display = '';
        emptyEl.style.display = 'none';
        const gridColor = this._css('--line');
        const mutedColor = this._css('--muted');
        const CURRENCY = new Set([
            'revenue',
            'expenses',
            'net',
            'avgOrder'
        ]);
        const hasCurrency = datasets.some((d)=>CURRENCY.has(d._metric));
        const hasNonCurrency = datasets.some((d)=>!CURRENCY.has(d._metric));
        const mapped = datasets.map((d)=>({
                ...d,
                yAxisID: CURRENCY.has(d._metric) ? 'yLeft' : 'yRight'
            }));
        // Update the title span
        const titleEl = document.getElementById('rpOverviewChartTitle');
        if (titleEl) {
            const names = datasets.map((d)=>d.label);
            titleEl.textContent = names.length <= 3 ? names.join(" \xb7 ") : 'Overview';
        }
        // Build custom DOM legend next to the title (no canvas space used → no reflow)
        if (legendEl) legendEl.innerHTML = mapped.length > 1 ? mapped.map((d)=>`
            <span class="rp-legend-item">
              <span class="rp-legend-dot" style="background:${d.borderColor}"></span>
              ${d.label}
            </span>`).join('') : '';
        this._charts.revenue = new Chart(canvas, {
            type: 'line',
            data: {
                labels: labels,
                datasets: mapped
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 350,
                    easing: 'easeOutQuart'
                },
                interaction: {
                    mode: 'index',
                    intersect: false
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: (ctx)=>{
                                const m = ctx.dataset._metric;
                                const v = ctx.raw;
                                if (m === 'transactions') return ` ${Math.round(v)} orders`;
                                return ' ' + $d94c521226fbc9fa$var$fmt(v);
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        grid: {
                            color: gridColor,
                            drawTicks: false
                        },
                        ticks: {
                            color: mutedColor,
                            maxRotation: 0,
                            autoSkip: true,
                            maxTicksLimit: 12
                        }
                    },
                    yLeft: {
                        display: hasCurrency,
                        position: 'left',
                        grid: {
                            color: gridColor
                        },
                        ticks: {
                            color: mutedColor,
                            callback: (v)=>{
                                const s = (0, $coRoT.currencySymbol)();
                                return v === 0 ? s + '0' : s + (v >= 1000 ? (v / 1000).toFixed(1) + 'k' : v.toFixed(0));
                            }
                        },
                        beginAtZero: true
                    },
                    yRight: {
                        display: hasNonCurrency,
                        position: 'right',
                        grid: {
                            drawOnChartArea: false
                        },
                        ticks: {
                            color: mutedColor,
                            callback: (v)=>Math.round(v)
                        },
                        beginAtZero: true
                    }
                }
            }
        });
    }
    setSelectedMetrics(set) {
        this._parentElement.querySelectorAll('.rp-kpi[data-metric]').forEach((card)=>{
            const selected = set.has(card.dataset.metric);
            card.classList.toggle('rp-kpi--selected', selected);
            card.setAttribute('aria-pressed', String(selected));
        });
    }
    _addHandlerKpiToggle(handler) {
        const strip = this._parentElement.querySelector('.rp-kpi-strip');
        if (!strip) return;
        strip.addEventListener('click', (e)=>{
            const card = e.target.closest('[data-metric]');
            if (!card || e.target.closest('button')) return;
            handler(card.dataset.metric);
        });
        strip.addEventListener('keydown', (e)=>{
            if (e.key !== 'Enter' && e.key !== ' ') return;
            const card = e.target.closest('[data-metric]');
            if (!card) return;
            e.preventDefault();
            handler(card.dataset.metric);
        });
    }
    _renderCategoryChart(Chart, items) {
        this._activateCard("rpCategoryCard", "rpCategoryPh", "rpCategoryWrap", "rpCategoryBadge");
        const canvas = document.querySelector("#rpCategoryCanvas");
        if (!canvas) return;
        const catWrap = canvas.parentElement;
        let catEmpty = catWrap.querySelector(".rp-cat-empty");
        if (!catEmpty) {
            catEmpty = document.createElement("p");
            catEmpty.className = "rp-empty rp-cat-empty";
            catWrap.appendChild(catEmpty);
        }
        if (!items.length) {
            if (this._charts.category) {
                this._charts.category.destroy();
                this._charts.category = null;
            }
            this._observers["rpCategoryCanvas"]?.disconnect();
            canvas.style.display = "none";
            catEmpty.textContent = "No data.";
            catEmpty.style.display = "";
            return;
        }
        canvas.style.display = "";
        catEmpty.style.display = "none";
        if (this._charts.category) {
            this._charts.category.destroy();
            this._charts.category = null;
        }
        const totalValue = items.reduce((s, i)=>s + i.value, 0);
        const mutedColor = this._css("--muted");
        const textColor = this._css("--text");
        const gapColor = this._css("--panel-strong");
        const outerLabels = $d94c521226fbc9fa$var$makeOuterLabelPlugin(mutedColor, textColor);
        const centerPlugin = {
            id: 'centerText',
            afterDraw (chart) {
                const { ctx: ctx, chartArea: { top: top, bottom: bottom, left: left, right: right } } = chart;
                const cx = (left + right) / 2, cy = (top + bottom) / 2;
                const active = chart.getActiveElements();
                let l1, l2;
                if (active.length > 0) {
                    const { datasetIndex: datasetIndex, index: index } = active[0];
                    const v = chart.data.datasets[datasetIndex].data[index];
                    const lbl = chart.data.labels[index];
                    l1 = $d94c521226fbc9fa$var$fmt(v);
                    l2 = lbl.length > 13 ? lbl.slice(0, 11) + "\u2026" : lbl;
                } else {
                    l1 = $d94c521226fbc9fa$var$fmt(totalValue);
                    l2 = 'total sales';
                }
                ctx.save();
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.font = `bold 16px system-ui, sans-serif`;
                ctx.fillStyle = textColor;
                ctx.fillText(l1, cx, cy - 9);
                ctx.font = `11px system-ui, sans-serif`;
                ctx.fillStyle = mutedColor;
                ctx.fillText(l2, cx, cy + 9);
                ctx.restore();
            }
        };
        this._observeChart("rpCategoryCanvas", (cvs)=>{
            this._charts.category = new Chart(cvs, {
                type: "doughnut",
                data: {
                    labels: items.map((i)=>i.label),
                    datasets: [
                        {
                            data: items.map((i)=>i.value),
                            backgroundColor: $d94c521226fbc9fa$var$PALETTE.slice(0, items.length),
                            borderWidth: 3,
                            borderColor: gapColor,
                            borderRadius: 6,
                            hoverOffset: 14,
                            hoverBorderColor: gapColor
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutout: "70%",
                    layout: {
                        padding: 52
                    },
                    animation: this._donutAnim(),
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx)=>{
                                    const pct = totalValue > 0 ? (ctx.raw / totalValue * 100).toFixed(1) : 0;
                                    return ` ${ctx.label}: ${$d94c521226fbc9fa$var$fmt(ctx.raw)} (${pct}%)`;
                                }
                            }
                        }
                    }
                },
                plugins: [
                    centerPlugin,
                    outerLabels
                ]
            });
            requestAnimationFrame(()=>this._charts.category?.resize());
        });
    }
    _renderItemMixChart(Chart, items) {
        this._activateCard("rpItemMixCard", "rpItemMixPh", "rpItemMixWrap", "rpItemMixBadge");
        const canvas = document.querySelector("#rpItemMixCanvas");
        if (!canvas) return;
        const wrap = canvas.parentElement;
        let emptyEl = wrap.querySelector(".rp-item-mix-empty");
        if (!emptyEl) {
            emptyEl = document.createElement("p");
            emptyEl.className = "rp-empty rp-item-mix-empty";
            wrap.appendChild(emptyEl);
        }
        if (!items.length) {
            if (this._charts.itemMix) {
                this._charts.itemMix.destroy();
                this._charts.itemMix = null;
            }
            this._observers["rpItemMixCanvas"]?.disconnect();
            canvas.style.display = "none";
            emptyEl.textContent = "No data.";
            emptyEl.style.display = "";
            return;
        }
        canvas.style.display = "";
        emptyEl.style.display = "none";
        if (this._charts.itemMix) {
            this._charts.itemMix.destroy();
            this._charts.itemMix = null;
        }
        const top = items.slice(0, 8);
        const totalQty = top.reduce((s, i)=>s + i.quantity, 0);
        const mutedColor = this._css("--muted");
        const textColor = this._css("--text");
        const gapColor = this._css("--panel-strong");
        const outerLabels = $d94c521226fbc9fa$var$makeOuterLabelPlugin(mutedColor, textColor);
        const centerPlugin = {
            id: 'centerText',
            afterDraw (chart) {
                const { ctx: ctx, chartArea: { top: top, bottom: bottom, left: left, right: right } } = chart;
                const cx = (left + right) / 2, cy = (top + bottom) / 2;
                const active = chart.getActiveElements();
                let l1, l2;
                if (active.length > 0) {
                    const { datasetIndex: datasetIndex, index: index } = active[0];
                    const v = chart.data.datasets[datasetIndex].data[index];
                    const lbl = chart.data.labels[index];
                    const pct = totalQty > 0 ? (v / totalQty * 100).toFixed(1) : 0;
                    l1 = `${pct}%`;
                    l2 = lbl.length > 13 ? lbl.slice(0, 11) + "\u2026" : lbl;
                } else {
                    l1 = String(totalQty);
                    l2 = 'items sold';
                }
                ctx.save();
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.font = `bold 16px system-ui, sans-serif`;
                ctx.fillStyle = textColor;
                ctx.fillText(l1, cx, cy - 9);
                ctx.font = `11px system-ui, sans-serif`;
                ctx.fillStyle = mutedColor;
                ctx.fillText(l2, cx, cy + 9);
                ctx.restore();
            }
        };
        this._observeChart("rpItemMixCanvas", (cvs)=>{
            this._charts.itemMix = new Chart(cvs, {
                type: "doughnut",
                data: {
                    labels: top.map((i)=>i.name),
                    datasets: [
                        {
                            data: top.map((i)=>i.quantity),
                            backgroundColor: $d94c521226fbc9fa$var$PALETTE.slice(0, top.length),
                            borderWidth: 3,
                            borderColor: gapColor,
                            borderRadius: 6,
                            hoverOffset: 14,
                            hoverBorderColor: gapColor
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutout: "70%",
                    layout: {
                        padding: 52
                    },
                    animation: this._donutAnim(),
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx)=>{
                                    const pct = totalQty > 0 ? (ctx.raw / totalQty * 100).toFixed(1) : 0;
                                    return ` ${ctx.label}: ${ctx.raw} sold (${pct}%)`;
                                }
                            }
                        }
                    }
                },
                plugins: [
                    centerPlugin,
                    outerLabels
                ]
            });
            requestAnimationFrame(()=>this._charts.itemMix?.resize());
        });
    }
    _renderHourlyChart(Chart, { labels: labels, data: data }) {
        this._activateCard("rpHourlyCard", "rpHourlyPh", "rpHourlyWrap", "rpHourlyBadge");
        if (this._charts.hourly) {
            this._charts.hourly.destroy();
            this._charts.hourly = null;
        }
        const brand = "#22c55e";
        const gridColor = this._css("--line");
        const mutedColor = this._css("--muted");
        const peak = Math.max(...data, 1);
        const bgColors = data.map((v)=>this._withAlpha(brand, 0.25 + v / peak * 0.65));
        this._observeChart("rpHourlyCanvas", (canvas)=>{
            this._charts.hourly = new Chart(canvas, {
                type: "bar",
                data: {
                    labels: labels,
                    datasets: [
                        {
                            data: data,
                            backgroundColor: bgColors,
                            borderColor: brand,
                            borderWidth: 0,
                            borderRadius: 4,
                            borderSkipped: false
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: this._barAnim(15),
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx)=>" " + Math.round(ctx.raw) + " orders"
                            }
                        }
                    },
                    scales: {
                        x: {
                            grid: {
                                display: false
                            },
                            ticks: {
                                color: mutedColor,
                                maxRotation: 0,
                                autoSkip: true,
                                maxTicksLimit: 12
                            }
                        },
                        y: {
                            grid: {
                                color: gridColor
                            },
                            ticks: {
                                color: mutedColor,
                                callback: (v)=>Number.isInteger(v) ? v : ""
                            },
                            beginAtZero: true
                        }
                    }
                }
            });
        });
    }
    // ── Tips (Sales section) ──────────────────────────────────────────────────
    // { show, labels, data, total, gross, tippedCount, txCount }. The card is
    // hidden while tips are off and the period has none.
    async renderTips({ show: show, labels: labels, data: data, total: total, gross: gross, tippedCount: tippedCount, txCount: txCount }) {
        const card = document.querySelector("#rpTipsCard");
        if (!card) return;
        card.classList.toggle("hidden", !show);
        if (!show) return;
        const pct = (n, d)=>d > 0 ? `${(n / d * 100).toFixed(1).replace(/\.0$/, "")}%` : "\u2013";
        const stat = (label, val, sub, lead = false)=>`
      <div class="rp-tips-stat${lead ? " rp-tips-stat--lead" : ""}">
        <span class="rp-tips-stat-label">${label}</span>
        <span class="rp-tips-stat-val">${val}</span>
        <span class="rp-tips-stat-sub">${sub}</span>
      </div>`;
        document.querySelector("#rpTipsStats").innerHTML = [
            stat("Total tips", $d94c521226fbc9fa$var$fmt(total), "for your team", true),
            stat("Tip rate", pct(total, gross), "of gross income"),
            stat("Avg. tip", tippedCount ? $d94c521226fbc9fa$var$fmt(total / tippedCount) : "\u2013", "per tipped order"),
            stat("Orders tipped", pct(tippedCount, txCount), `${tippedCount} of ${txCount}`)
        ].join("");
        let Chart;
        try {
            Chart = await this._ensureChart();
        } catch  {
            return;
        }
        this._activateCard("rpTipsCard", "rpTipsPh", "rpTipsWrap", "rpTipsBadge");
        const canvas = document.querySelector("#rpTipsCanvas");
        if (!canvas) return;
        const wrap = canvas.parentElement;
        let emptyMsg = wrap.querySelector(".rp-tips-empty");
        if (!emptyMsg) {
            emptyMsg = document.createElement("p");
            emptyMsg.className = "rp-empty rp-tips-empty";
            emptyMsg.textContent = "No tips in this period yet.";
            wrap.appendChild(emptyMsg);
        }
        if (this._charts.tips) {
            this._charts.tips.destroy();
            this._charts.tips = null;
        }
        const isEmpty = !(total > 0);
        canvas.style.display = isEmpty ? "none" : "";
        emptyMsg.style.display = isEmpty ? "" : "none";
        if (isEmpty) {
            this._observers["rpTipsCanvas"]?.disconnect();
            return;
        }
        const pink = "#ec4899";
        const mutedColor = this._css("--muted");
        // Compact money ticks ("$1.6k"), same as the Overview chart.
        const axisMoney = (v)=>{
            const s = (0, $coRoT.currencySymbol)();
            return v === 0 ? s + "0" : s + (v >= 1000 ? (v / 1000).toFixed(1).replace(/.0$/, "") + "k" : Math.round(v));
        };
        this._observeChart("rpTipsCanvas", (cvs)=>{
            const ctx2d = cvs.getContext("2d");
            const grad = ctx2d.createLinearGradient(0, 0, 0, cvs.clientHeight || 220);
            grad.addColorStop(0, pink);
            grad.addColorStop(1, this._withAlpha(pink, 0.35));
            this._charts.tips = new Chart(cvs, {
                type: "bar",
                data: {
                    labels: labels,
                    datasets: [
                        {
                            data: data,
                            backgroundColor: grad,
                            hoverBackgroundColor: pink,
                            borderWidth: 0,
                            borderRadius: {
                                topLeft: 8,
                                topRight: 8
                            },
                            borderSkipped: "bottom",
                            maxBarThickness: 28,
                            categoryPercentage: 0.7
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: this._barAnim(30),
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx)=>" " + $d94c521226fbc9fa$var$fmt(ctx.raw) + " in tips"
                            }
                        }
                    },
                    scales: {
                        x: {
                            grid: {
                                display: false
                            },
                            border: {
                                display: false
                            },
                            ticks: {
                                color: mutedColor,
                                font: {
                                    size: 11,
                                    weight: "500"
                                },
                                maxRotation: 0,
                                autoSkip: true,
                                maxTicksLimit: 12
                            }
                        },
                        y: {
                            // Soft grey that reads in both themes (--line resolves to the light value here).
                            grid: {
                                color: "rgba(148, 163, 184, 0.18)"
                            },
                            border: {
                                display: false
                            },
                            ticks: {
                                color: mutedColor,
                                maxTicksLimit: 5,
                                callback: axisMoney
                            },
                            beginAtZero: true
                        }
                    }
                }
            });
        });
    }
    _renderDowChart(Chart, { labels: labels, data: data, isEmpty: isEmpty }) {
        this._activateCard("rpDowCard", "rpDowPh", "rpDowWrap", "rpDowBadge");
        const canvas = document.querySelector("#rpDowCanvas");
        if (!canvas) return;
        const wrap = canvas.parentElement;
        let emptyMsg = wrap.querySelector(".rp-dow-empty");
        if (!emptyMsg) {
            emptyMsg = document.createElement("p");
            emptyMsg.className = "rp-empty rp-dow-empty";
            wrap.appendChild(emptyMsg);
        }
        if (isEmpty) {
            if (this._charts.dow) {
                this._charts.dow.destroy();
                this._charts.dow = null;
            }
            this._observers["rpDowCanvas"]?.disconnect();
            canvas.style.display = "none";
            emptyMsg.textContent = "Select a wider period to see day-of-week patterns.";
            emptyMsg.style.display = "";
            return;
        }
        canvas.style.display = "";
        emptyMsg.style.display = "none";
        if (this._charts.dow) {
            this._charts.dow.destroy();
            this._charts.dow = null;
        }
        const brand = "#22c55e";
        const gridColor = this._css("--line");
        const mutedColor = this._css("--muted");
        const peak = Math.max(...data, 1);
        const bgColors = data.map((v)=>this._withAlpha(brand, 0.3 + v / peak * 0.6));
        const borderColors = data.map((v)=>v === peak ? brand : this._withAlpha(brand, 0));
        this._observeChart("rpDowCanvas", (cvs)=>{
            this._charts.dow = new Chart(cvs, {
                type: "bar",
                data: {
                    labels: labels,
                    datasets: [
                        {
                            data: data,
                            backgroundColor: bgColors,
                            borderColor: borderColors,
                            borderWidth: 2,
                            borderRadius: 6,
                            borderSkipped: false
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: this._barAnim(60),
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx)=>" " + Math.round(ctx.raw) + " orders"
                            }
                        }
                    },
                    scales: {
                        x: {
                            grid: {
                                display: false
                            },
                            ticks: {
                                color: mutedColor,
                                font: {
                                    size: 12,
                                    weight: "500"
                                }
                            }
                        },
                        y: {
                            grid: {
                                color: gridColor
                            },
                            ticks: {
                                color: mutedColor,
                                callback: (v)=>Number.isInteger(v) ? v : ""
                            },
                            beginAtZero: true
                        }
                    }
                }
            });
        });
    }
    // `metric` picks which cohort's byHour/byDay to plot: "overall" (the top-level
    // servingTime object, unchanged), or "kitchen"/"pickup" (its sub-objects, only
    // present when at least one order in the period was marked Ready for Pickup).
    _servingMetricData(servingTime) {
        if (!servingTime) return null;
        if (this._servingMetric === "overall") return servingTime;
        return servingTime[this._servingMetric] ?? null;
    }
    _renderServingHourChart(Chart, servingTime) {
        this._activateCard("rpServingHourCard", "rpServingHourPh", "rpServingHourWrap", "rpServingHourBadge");
        const canvas = document.querySelector("#rpServingHourCanvas");
        if (!canvas) return;
        const wrap = canvas.parentElement;
        let emptyMsg = wrap.querySelector(".rp-serving-hour-empty");
        if (!emptyMsg) {
            emptyMsg = document.createElement("p");
            emptyMsg.className = "rp-empty rp-serving-hour-empty";
            wrap.appendChild(emptyMsg);
        }
        const metricData = this._servingMetricData(servingTime);
        if (!servingTime || !metricData) {
            if (this._charts.servingHour) {
                this._charts.servingHour.destroy();
                this._charts.servingHour = null;
            }
            this._observers["rpServingHourCanvas"]?.disconnect();
            canvas.style.display = "none";
            emptyMsg.textContent = this._servingMetric === "overall" ? "No serving time data. Orders must be marked done in the Queue Display to track this." : "No orders in this period were marked Ready for Pickup, so this cohort has no data yet.";
            emptyMsg.style.display = "";
            return;
        }
        canvas.style.display = "";
        emptyMsg.style.display = "none";
        if (this._charts.servingHour) {
            this._charts.servingHour.destroy();
            this._charts.servingHour = null;
        }
        const { labels: labels, data: data } = metricData.byHour;
        const orange = $d94c521226fbc9fa$var$ReportsView.COHORT_COLOR[this._servingMetric];
        const gridColor = this._css("--line");
        const mutedColor = this._css("--muted");
        const peak = Math.max(...data, 0.001);
        const bgColors = data.map((v)=>this._withAlpha(orange, v > 0 ? 0.3 + v / peak * 0.6 : 0));
        const borderColors = data.map((v)=>v === peak && v > 0 ? orange : this._withAlpha(orange, 0));
        this._observeChart("rpServingHourCanvas", (cvs)=>{
            this._charts.servingHour = new Chart(cvs, {
                type: "bar",
                data: {
                    labels: labels,
                    datasets: [
                        {
                            data: data,
                            backgroundColor: bgColors,
                            borderColor: borderColors,
                            borderWidth: 2,
                            borderRadius: 5,
                            borderSkipped: false
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: this._barAnim(15),
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx)=>` ${ctx.raw.toFixed(1)} min avg`
                            }
                        }
                    },
                    scales: {
                        x: {
                            grid: {
                                display: false
                            },
                            ticks: {
                                color: mutedColor,
                                maxRotation: 0,
                                autoSkip: true,
                                maxTicksLimit: 12
                            }
                        },
                        y: {
                            grid: {
                                color: gridColor
                            },
                            ticks: {
                                color: mutedColor,
                                callback: (v)=>this._fmtAxisMin(v)
                            },
                            beginAtZero: true
                        }
                    }
                }
            });
        });
    }
    _renderServingDayChart(Chart, servingTime) {
        this._activateCard("rpServingDayCard", "rpServingDayPh", "rpServingDayWrap", "rpServingDayBadge");
        const canvas = document.querySelector("#rpServingDayCanvas");
        if (!canvas) return;
        const wrap = canvas.parentElement;
        let emptyMsg = wrap.querySelector(".rp-serving-day-empty");
        if (!emptyMsg) {
            emptyMsg = document.createElement("p");
            emptyMsg.className = "rp-empty rp-serving-day-empty";
            wrap.appendChild(emptyMsg);
        }
        const metricData = this._servingMetricData(servingTime);
        if (!servingTime || !metricData) {
            if (this._charts.servingDay) {
                this._charts.servingDay.destroy();
                this._charts.servingDay = null;
            }
            this._observers["rpServingDayCanvas"]?.disconnect();
            canvas.style.display = "none";
            emptyMsg.textContent = this._servingMetric === "overall" ? "No serving time data for this period." : "No orders in this period were marked Ready for Pickup, so this cohort has no data yet.";
            emptyMsg.style.display = "";
            return;
        }
        canvas.style.display = "";
        emptyMsg.style.display = "none";
        if (this._charts.servingDay) {
            this._charts.servingDay.destroy();
            this._charts.servingDay = null;
        }
        const { labels: labels, data: data } = metricData.byDay;
        const orange = $d94c521226fbc9fa$var$ReportsView.COHORT_COLOR[this._servingMetric];
        const gridColor = this._css("--line");
        const mutedColor = this._css("--muted");
        const peak = Math.max(...data, 0.001);
        const bgColors = data.map((v)=>this._withAlpha(orange, v > 0 ? 0.3 + v / peak * 0.6 : 0));
        const borderColors = data.map((v)=>v === peak && v > 0 ? orange : this._withAlpha(orange, 0));
        this._observeChart("rpServingDayCanvas", (cvs)=>{
            this._charts.servingDay = new Chart(cvs, {
                type: "bar",
                data: {
                    labels: labels,
                    datasets: [
                        {
                            data: data,
                            backgroundColor: bgColors,
                            borderColor: borderColors,
                            borderWidth: 2,
                            borderRadius: 6,
                            borderSkipped: false
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: this._barAnim(60),
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx)=>` ${ctx.raw.toFixed(1)} min avg`
                            }
                        }
                    },
                    scales: {
                        x: {
                            grid: {
                                display: false
                            },
                            ticks: {
                                color: mutedColor,
                                font: {
                                    size: 12,
                                    weight: "500"
                                }
                            }
                        },
                        y: {
                            grid: {
                                color: gridColor
                            },
                            ticks: {
                                color: mutedColor,
                                callback: (v)=>this._fmtAxisMin(v)
                            },
                            beginAtZero: true
                        }
                    }
                }
            });
        });
    }
    // ── Staff performance ────────────────────────────────────────────────────
    renderStaff(staff, sortKey = "revenue") {
        const el = document.querySelector("#reportsStaff");
        if (!el) return;
        if (!staff.length) {
            el.innerHTML = `<p class="rp-empty">No sales data for this period.</p>`;
            return;
        }
        const LIMIT = 6;
        const preview = staff.slice(0, LIMIT);
        const maxRev = staff[0].revenue;
        const maxTx = staff[0].transactions;
        const byQty = sortKey === "quantity";
        const MEDALS = [
            "\uD83E\uDD47",
            "\uD83E\uDD48",
            "\uD83E\uDD49"
        ];
        const rowHtml = (s, i)=>`
      <div class="rp-staff-row">
        <span class="rp-item-rank">${MEDALS[i] ?? i + 1}</span>
        <div class="rp-item-main">
          <div class="rp-item-row-top">
            <span class="rp-item-name">${(0, $cnCXJ.esc)(s.name)}</span>
            <span class="rp-item-rev">${byQty ? s.transactions : $d94c521226fbc9fa$var$fmt(s.revenue)}</span>
          </div>
          <div class="rp-item-bar-track">
            <div class="rp-item-bar rp-item-bar--staff" style="width:${byQty ? Math.round(s.transactions / maxTx * 100) : Math.round(s.revenue / maxRev * 100)}%"></div>
          </div>
          <span class="rp-item-qty">${byQty ? $d94c521226fbc9fa$var$fmt(s.revenue) : `${s.transactions} transaction${s.transactions !== 1 ? "s" : ""}`}${s.tips > 0 ? ` \xb7 <span class="rp-staff-tips">${$d94c521226fbc9fa$var$fmt(s.tips)} in tips</span>` : ""}</span>
        </div>
      </div>`;
        el.innerHTML = `
      <div class="rp-staff-list rp-staff-list--grid">
        ${preview.map((s, i)=>rowHtml(s, i)).join("")}
      </div>
      ${staff.length > LIMIT ? `<button class="rp-top-items-toggle">View full list (${staff.length} members)</button>` : ""}`;
        if (staff.length > LIMIT) el.querySelector(".rp-top-items-toggle").addEventListener("click", ()=>{
            this._openListModal("Staff Performance", `
          <div class="rp-staff-list">
            ${staff.map((s, i)=>rowHtml(s, i)).join("")}
          </div>`);
        });
    }
    // ── Sort pills ───────────────────────────────────────────────────────────
    setTopItemsSort(key) {
        document.querySelectorAll("#topItemsSortPills .rp-sort-pill").forEach((btn)=>{
            btn.classList.toggle("active", btn.dataset.sort === key);
        });
    }
    setStaffSort(key) {
        document.querySelectorAll("#staffSortPills .rp-sort-pill").forEach((btn)=>{
            btn.classList.toggle("active", btn.dataset.sort === key);
        });
    }
    _addHandlerTopItemsSort(handler) {
        document.querySelector("#topItemsSortPills")?.addEventListener("click", (e)=>{
            const pill = e.target.closest(".rp-sort-pill");
            if (!pill || pill.classList.contains("active")) return;
            handler(pill.dataset.sort);
        });
    }
    _addHandlerStaffSort(handler) {
        document.querySelector("#staffSortPills")?.addEventListener("click", (e)=>{
            const pill = e.target.closest(".rp-sort-pill");
            if (!pill || pill.classList.contains("active")) return;
            handler(pill.dataset.sort);
        });
    }
    // Segmented toggle on the Serving Time by Hour/Day cards - switches which
    // cohort (overall / kitchen / pickup) they plot. Purely a local re-render, no
    // controller round-trip needed since `_servingTimeData` already has all three.
    _addHandlerServingMetricToggle() {
        document.querySelector("#rpServingMetricSeg")?.addEventListener("click", (e)=>{
            const btn = e.target.closest("button");
            if (!btn || btn.classList.contains("active")) return;
            document.querySelectorAll("#rpServingMetricSeg button").forEach((b)=>b.classList.remove("active"));
            btn.classList.add("active");
            this._servingMetric = btn.dataset.metric;
            document.querySelector("#rpServingMetricSeg").style.setProperty("--seg-accent", $d94c521226fbc9fa$var$ReportsView.COHORT_COLOR[this._servingMetric]);
            this._ensureChart().then((Chart)=>{
                this._renderServingHourChart(Chart, this._servingTimeData);
                this._renderServingDayChart(Chart, this._servingTimeData);
            }).catch(()=>{});
        });
    }
    // ── Info tooltips ────────────────────────────────────────────────────────
    _addHandlerInfoTooltips() {
        const tip = document.createElement("div");
        tip.className = "rp-tip-float hidden";
        document.body.appendChild(tip);
        let activeBtn = null;
        this._parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest(".rp-info-btn");
            if (!btn || !btn.dataset.tip) {
                tip.classList.add("hidden");
                activeBtn = null;
                return;
            }
            e.stopPropagation();
            if (activeBtn === btn) {
                tip.classList.add("hidden");
                activeBtn = null;
                return;
            }
            activeBtn = btn;
            tip.textContent = btn.dataset.tip;
            tip.classList.remove("hidden");
            const rect = btn.getBoundingClientRect();
            const tw = 224;
            tip.style.top = `${rect.bottom + 8}px`;
            tip.style.left = `${Math.max(8, Math.min(rect.left, window.innerWidth - tw - 8))}px`;
        });
        document.addEventListener("click", (e)=>{
            if (!e.target.closest(".rp-info-btn")) {
                tip.classList.add("hidden");
                activeBtn = null;
            }
        });
    }
    // ── Event handlers ───────────────────────────────────────────────────────
    _addHandlerOpen(handler) {
        document.addEventListener("click", (e)=>{
            if (e.target.closest("[data-action='summary']")) handler();
        });
    }
    _addHandlerClose(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            if (e.target.closest(".rp-back")) handler();
        });
    }
    _addHandlerPeriodChange(handler) {
        this._parentElement.querySelector(".rp-tabs").addEventListener("click", (e)=>{
            const btn = e.target.closest(".rp-tab");
            if (!btn) return;
            const period = btn.dataset.period;
            this.setActivePeriod(period);
            if (period !== "custom") handler({
                period: period
            });
        });
    }
    // ── Compare mode ─────────────────────────────────────────────────────────
    enterCompareMode() {
        document.querySelector("#reportsTabs")?.classList.add("hidden");
        document.querySelector("#reportsCustomRange")?.classList.add("hidden");
        document.querySelector("#reportsCompareBar")?.classList.remove("hidden");
        document.querySelector(".rp-sidebar")?.classList.add("hidden");
        this._parentElement.querySelectorAll(".rp-section").forEach((s)=>s.classList.add("hidden"));
        document.querySelector("#rpCompareResults")?.classList.add("hidden");
        const btn = document.querySelector("#reportsCompareBtn");
        if (btn) {
            btn.classList.add("active");
            btn.querySelector(".rp-compare-btn-label").textContent = "\u2190 Back";
            btn.querySelector("#reportsCompareBtnIcon").innerHTML = '<polyline points="15 18 9 12 15 6"/>';
        }
    }
    exitCompareMode() {
        document.querySelector("#reportsTabs")?.classList.remove("hidden");
        document.querySelector("#reportsCompareBar")?.classList.add("hidden");
        document.querySelector("#rpCompareResults")?.classList.add("hidden");
        document.querySelector(".rp-sidebar")?.classList.remove("hidden");
        this._switchSection(this._activeSection);
        const btn = document.querySelector("#reportsCompareBtn");
        if (btn) {
            btn.classList.remove("active");
            btn.querySelector(".rp-compare-btn-label").textContent = "Compare";
            btn.querySelector("#reportsCompareBtnIcon").innerHTML = '<rect x="2" y="3" width="9" height="18" rx="2"/><rect x="13" y="3" width="9" height="18" rx="2"/>';
        }
    }
    renderCompareResults({ labelA: labelA, labelB: labelB, summaryA: summaryA, summaryB: summaryB, topItemsA: topItemsA, topItemsB: topItemsB }) {
        const fmtServ = (v)=>{
            if (v == null) return "\u2014";
            const mins = Math.floor(v);
            const secs = Math.round((v - mins) * 60);
            return secs > 0 ? `${mins}m ${secs}s` : `${mins}m`;
        };
        const deltaBadge = (a, b, invert = false)=>{
            if (b == null || b === 0 || a == null) return "";
            const pct = Math.round((a - b) / b * 100);
            const up = invert ? pct <= 0 : pct >= 0;
            const arrow = pct >= 0 ? `<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>` : `<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>`;
            return `<span class="rp-cmp-delta-badge rp-cmp-delta-badge--${up ? "up" : "down"}">${arrow} ${Math.abs(pct)}%</span>`;
        };
        const setKpi = (idA, idB, idDelta, a, b, fmtFn, invert = false)=>{
            const elA = document.querySelector(`#${idA}`);
            const elB = document.querySelector(`#${idB}`);
            const aWins = invert ? a != null && b != null && a < b : a > b;
            const bWins = invert ? a != null && b != null && b < a : b > a;
            if (elA) {
                elA.textContent = fmtFn(a);
                elA.className = `rp-cmp-kpi-val${aWins ? " rp-cmp-kpi-val--up" : !aWins && a !== b && a != null && b != null ? " rp-cmp-kpi-val--down" : ""}`;
            }
            if (elB) {
                elB.textContent = fmtFn(b);
                elB.className = `rp-cmp-kpi-val${bWins ? " rp-cmp-kpi-val--up" : !bWins && a !== b && a != null && b != null ? " rp-cmp-kpi-val--down" : ""}`;
            }
            const deltaEl = document.querySelector(`#${idDelta}`);
            if (deltaEl) deltaEl.outerHTML = `<span id="${idDelta}">${deltaBadge(a, b, invert)}</span>`;
        };
        document.querySelectorAll(".rp-cmp-period-name-a").forEach((el)=>el.textContent = labelA);
        document.querySelectorAll(".rp-cmp-period-name-b").forEach((el)=>el.textContent = labelB);
        setKpi("rpCmpRevA", "rpCmpRevB", "rpCmpRevDelta", summaryA.revenue, summaryB.revenue, $d94c521226fbc9fa$var$fmt);
        setKpi("rpCmpTxA", "rpCmpTxB", "rpCmpTxDelta", summaryA.transactions, summaryB.transactions, String);
        setKpi("rpCmpAvgA", "rpCmpAvgB", "rpCmpAvgDelta", summaryA.avgOrder, summaryB.avgOrder, $d94c521226fbc9fa$var$fmt);
        setKpi("rpCmpServA", "rpCmpServB", "rpCmpServDelta", summaryA.avgServingMinutes, summaryB.avgServingMinutes, fmtServ, true);
        this._renderCmpItemList("#rpCmpTopItemsA", topItemsA);
        this._renderCmpItemList("#rpCmpTopItemsB", topItemsB);
        document.querySelector("#rpCompareResults")?.classList.remove("hidden");
    }
    _renderCmpItemList(selector, items) {
        const el = document.querySelector(selector);
        if (!el) return;
        if (!items.length) {
            el.innerHTML = `<p class="rp-empty">No data.</p>`;
            return;
        }
        const maxQty = items[0].quantity;
        el.innerHTML = `
      <div class="rp-item-list">
        ${items.map((item, i)=>`
          <div class="rp-item-row">
            <span class="rp-item-rank">${i + 1}</span>
            <div class="rp-item-main">
              <div class="rp-item-row-top">
                <span class="rp-item-name">${(0, $cnCXJ.esc)(item.name)}</span>
                <span class="rp-item-rev">${$d94c521226fbc9fa$var$fmt(item.revenue)}</span>
              </div>
              <div class="rp-item-bar-track">
                <div class="rp-item-bar" style="width:${Math.round(item.quantity / maxQty * 100)}%"></div>
              </div>
              <span class="rp-item-qty">${item.quantity} sold</span>
            </div>
          </div>`).join("")}
      </div>`;
    }
    async renderCompareChart({ labelA: labelA, dataA: dataA, labelB: labelB, dataB: dataB, labels: labels }) {
        const Chart = await this._ensureChart();
        if (this._charts.cmpRevenue) {
            this._charts.cmpRevenue.destroy();
            this._charts.cmpRevenue = null;
        }
        const gridColor = this._css("--line");
        const mutedColor = this._css("--muted");
        const colorA = "#22c55e";
        const colorB = "#60a5fa";
        this._observeChart("rpCmpRevenueCanvas", (canvas)=>{
            this._charts.cmpRevenue = new Chart(canvas, {
                type: "bar",
                data: {
                    labels: labels,
                    datasets: [
                        {
                            label: labelA,
                            data: dataA,
                            backgroundColor: this._withAlpha(colorA, 0.7),
                            borderColor: colorA,
                            borderWidth: 0,
                            borderRadius: 4,
                            borderSkipped: false
                        },
                        {
                            label: labelB,
                            data: dataB,
                            backgroundColor: this._withAlpha(colorB, 0.7),
                            borderColor: colorB,
                            borderWidth: 0,
                            borderRadius: 4,
                            borderSkipped: false
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: "top",
                            align: "end",
                            labels: {
                                color: mutedColor,
                                boxWidth: 10,
                                boxHeight: 10,
                                borderRadius: 3,
                                padding: 12,
                                font: {
                                    size: 11
                                }
                            }
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx)=>` ${ctx.dataset.label}: ${$d94c521226fbc9fa$var$fmt(ctx.raw)}`
                            }
                        }
                    },
                    scales: {
                        x: {
                            grid: {
                                color: gridColor,
                                drawTicks: false
                            },
                            ticks: {
                                color: mutedColor,
                                maxRotation: 0,
                                autoSkip: true,
                                maxTicksLimit: 16
                            }
                        },
                        y: {
                            grid: {
                                color: gridColor
                            },
                            ticks: {
                                color: mutedColor,
                                callback: (v)=>{
                                    const s = (0, $coRoT.currencySymbol)();
                                    return v === 0 ? s + "0" : s + (v >= 1000 ? (v / 1000).toFixed(1) + "k" : v);
                                }
                            },
                            beginAtZero: true
                        }
                    }
                }
            });
        });
    }
    renderCmpTopItems(itemsA, itemsB) {
        this._renderCmpItemList("#rpCmpTopItemsA", itemsA);
        this._renderCmpItemList("#rpCmpTopItemsB", itemsB);
    }
    renderCmpPeakStats({ salesPeaksA: salesPeaksA, salesPeaksB: salesPeaksB, tPeaksA: tPeaksA, tPeaksB: tPeaksB }) {
        const set = (id, val)=>{
            const el = document.getElementById(id);
            if (el) el.textContent = val;
        };
        set("rpCmpBestSellerA", salesPeaksA.bestSeller);
        set("rpCmpBestSellerB", salesPeaksB.bestSeller);
        set("rpCmpBestSellerSubA", salesPeaksA.bestSellerSub);
        set("rpCmpBestSellerSubB", salesPeaksB.bestSellerSub);
        set("rpCmpTopCatA", salesPeaksA.topCategory);
        set("rpCmpTopCatB", salesPeaksB.topCategory);
        set("rpCmpTopCatSubA", salesPeaksA.topCategorySub);
        set("rpCmpTopCatSubB", salesPeaksB.topCategorySub);
        set("rpCmpTopStaffA", salesPeaksA.topStaff);
        set("rpCmpTopStaffB", salesPeaksB.topStaff);
        set("rpCmpTopStaffSubA", salesPeaksA.topStaffSub);
        set("rpCmpTopStaffSubB", salesPeaksB.topStaffSub);
        set("rpCmpPeakHourA", tPeaksA.peakHour);
        set("rpCmpPeakHourB", tPeaksB.peakHour);
        set("rpCmpPeakHourSubA", tPeaksA.peakHourCount > 0 ? `${tPeaksA.peakHourCount} orders` : "");
        set("rpCmpPeakHourSubB", tPeaksB.peakHourCount > 0 ? `${tPeaksB.peakHourCount} orders` : "");
        set("rpCmpPeakDayA", tPeaksA.peakDay);
        set("rpCmpPeakDayB", tPeaksB.peakDay);
        set("rpCmpPeakDaySubA", tPeaksA.peakDayCount > 0 ? `${tPeaksA.peakDayCount} orders` : "");
        set("rpCmpPeakDaySubB", tPeaksB.peakDayCount > 0 ? `${tPeaksB.peakDayCount} orders` : "");
    }
    renderCmpStaff({ staffA: staffA, staffB: staffB }) {
        const renderList = (elId, staff)=>{
            const el = document.getElementById(elId);
            if (!el) return;
            if (!staff.length) {
                el.innerHTML = `<p class="rp-empty">No data.</p>`;
                return;
            }
            const maxRev = staff[0].revenue;
            el.innerHTML = `<div class="rp-item-list">${staff.map((s, i)=>`
        <div class="rp-item-row">
          <span class="rp-item-rank">${i + 1}</span>
          <div class="rp-item-main">
            <div class="rp-item-row-top">
              <span class="rp-item-name">${(0, $cnCXJ.esc)(s.name)}</span>
              <span class="rp-item-rev">${$d94c521226fbc9fa$var$fmt(s.revenue)}</span>
            </div>
            <div class="rp-item-bar-track">
              <div class="rp-item-bar" style="width:${maxRev > 0 ? Math.round(s.revenue / maxRev * 100) : 0}%"></div>
            </div>
            <span class="rp-item-qty">${s.transactions} orders</span>
          </div>
        </div>`).join("")}</div>`;
        };
        renderList("rpCmpStaffA", staffA);
        renderList("rpCmpStaffB", staffB);
    }
    async renderCmpSalesCharts({ categoryA: categoryA, categoryB: categoryB, itemMixA: itemMixA, itemMixB: itemMixB }) {
        const Chart = await this._ensureChart();
        const mutedColor = this._css("--muted");
        const gapColor = this._css("--panel-strong");
        const renderDonut = (chartKey, canvasId, items)=>{
            if (this._charts[chartKey]) {
                this._charts[chartKey].destroy();
                this._charts[chartKey] = null;
            }
            const canvas = document.querySelector(`#${canvasId}`);
            if (!canvas) return;
            if (!items.length) {
                canvas.style.display = "none";
                let empty = canvas.parentElement.querySelector(".rp-empty");
                if (!empty) {
                    empty = document.createElement("p");
                    empty.className = "rp-empty";
                    canvas.parentElement.appendChild(empty);
                }
                empty.textContent = "No data.";
                empty.style.display = "";
                return;
            }
            canvas.style.display = "";
            const totalValue = items.reduce((s, i)=>s + i.value, 0);
            this._observeChart(canvasId, (cvs)=>{
                this._charts[chartKey] = new Chart(cvs, {
                    type: "doughnut",
                    data: {
                        labels: items.map((i)=>i.label),
                        datasets: [
                            {
                                data: items.map((i)=>i.value),
                                backgroundColor: $d94c521226fbc9fa$var$PALETTE.slice(0, items.length),
                                borderWidth: 3,
                                borderColor: gapColor,
                                borderRadius: 4,
                                hoverOffset: 10
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        cutout: "65%",
                        animation: this._donutAnim(),
                        plugins: {
                            legend: {
                                display: true,
                                position: "right",
                                labels: {
                                    color: mutedColor,
                                    boxWidth: 10,
                                    boxHeight: 10,
                                    font: {
                                        size: 11
                                    },
                                    padding: 10
                                }
                            },
                            tooltip: {
                                callbacks: {
                                    label: (ctx)=>{
                                        const pct = totalValue > 0 ? (ctx.raw / totalValue * 100).toFixed(1) : 0;
                                        return ` ${ctx.label}: ${$d94c521226fbc9fa$var$fmt(ctx.raw)} (${pct}%)`;
                                    }
                                }
                            }
                        }
                    }
                });
            });
        };
        const renderItemDonut = (chartKey, canvasId, items)=>{
            if (this._charts[chartKey]) {
                this._charts[chartKey].destroy();
                this._charts[chartKey] = null;
            }
            const canvas = document.querySelector(`#${canvasId}`);
            if (!canvas) return;
            if (!items.length) {
                canvas.style.display = "none";
                let empty = canvas.parentElement.querySelector(".rp-empty");
                if (!empty) {
                    empty = document.createElement("p");
                    empty.className = "rp-empty";
                    canvas.parentElement.appendChild(empty);
                }
                empty.textContent = "No data.";
                empty.style.display = "";
                return;
            }
            canvas.style.display = "";
            const top = items.slice(0, 8);
            const totalQty = top.reduce((s, i)=>s + i.quantity, 0);
            this._observeChart(canvasId, (cvs)=>{
                this._charts[chartKey] = new Chart(cvs, {
                    type: "doughnut",
                    data: {
                        labels: top.map((i)=>i.name),
                        datasets: [
                            {
                                data: top.map((i)=>i.quantity),
                                backgroundColor: $d94c521226fbc9fa$var$PALETTE.slice(0, top.length),
                                borderWidth: 3,
                                borderColor: gapColor,
                                borderRadius: 4,
                                hoverOffset: 10
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        cutout: "65%",
                        animation: this._donutAnim(),
                        plugins: {
                            legend: {
                                display: true,
                                position: "right",
                                labels: {
                                    color: mutedColor,
                                    boxWidth: 10,
                                    boxHeight: 10,
                                    font: {
                                        size: 11
                                    },
                                    padding: 10
                                }
                            },
                            tooltip: {
                                callbacks: {
                                    label: (ctx)=>{
                                        const pct = totalQty > 0 ? (ctx.raw / totalQty * 100).toFixed(1) : 0;
                                        return ` ${ctx.label}: ${ctx.raw} sold (${pct}%)`;
                                    }
                                }
                            }
                        }
                    }
                });
            });
        };
        renderDonut("cmpCategoryA", "rpCmpCategoryCanvasA", categoryA);
        renderDonut("cmpCategoryB", "rpCmpCategoryCanvasB", categoryB);
        renderItemDonut("cmpItemMixA", "rpCmpItemMixCanvasA", itemMixA);
        renderItemDonut("cmpItemMixB", "rpCmpItemMixCanvasB", itemMixB);
    }
    async renderCmpTrafficCharts({ hourlyA: hourlyA, hourlyB: hourlyB, dowA: dowA, dowB: dowB, labelA: labelA, labelB: labelB }) {
        const Chart = await this._ensureChart();
        this._renderCmpGroupedBar(Chart, "cmpHourly", "rpCmpHourlyCanvas", hourlyA.labels, hourlyA.data, hourlyB.data, labelA, labelB, (v)=>String(Math.round(v)));
        this._renderCmpGroupedBar(Chart, "cmpDow", "rpCmpDowCanvas", dowA.labels, dowA.data, dowB.data, labelA, labelB, (v)=>String(Math.round(v)));
    }
    async renderCmpKitchenCharts({ servingA: servingA, servingB: servingB, labelA: labelA, labelB: labelB }) {
        const Chart = await this._ensureChart();
        const fmtMin = (v)=>v > 0 ? `${v.toFixed(1)}m` : "0m";
        const fmtHour = (i)=>i === 0 ? "12am" : i < 12 ? `${i}am` : i === 12 ? "12pm" : `${i - 12}pm`;
        const fallbackHour = {
            labels: Array.from({
                length: 24
            }, (_, i)=>fmtHour(i)),
            data: Array(24).fill(0)
        };
        const fallbackDay = {
            labels: [
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat",
                "Sun"
            ],
            data: Array(7).fill(0)
        };
        const hA = servingA?.byHour ?? fallbackHour;
        const hB = servingB?.byHour ?? fallbackHour;
        const dA = servingA?.byDay ?? fallbackDay;
        const dB = servingB?.byDay ?? fallbackDay;
        this._renderCmpGroupedBar(Chart, "cmpServingHour", "rpCmpServingHourCanvas", hA.labels, hA.data, hB.data, labelA, labelB, fmtMin);
        this._renderCmpGroupedBar(Chart, "cmpServingDay", "rpCmpServingDayCanvas", dA.labels, dA.data, dB.data, labelA, labelB, fmtMin);
    }
    _renderCmpGroupedBar(Chart, chartKey, canvasId, labels, dataA, dataB, labelA, labelB, yFmt) {
        if (this._charts[chartKey]) {
            this._charts[chartKey].destroy();
            this._charts[chartKey] = null;
        }
        const canvas = document.querySelector(`#${canvasId}`);
        if (!canvas) return;
        const gridColor = this._css("--line");
        const mutedColor = this._css("--muted");
        const colorA = "#22c55e", colorB = "#60a5fa";
        this._observeChart(canvasId, (cvs)=>{
            this._charts[chartKey] = new Chart(cvs, {
                type: "bar",
                data: {
                    labels: labels,
                    datasets: [
                        {
                            label: labelA,
                            data: dataA,
                            backgroundColor: this._withAlpha(colorA, 0.7),
                            borderColor: colorA,
                            borderWidth: 0,
                            borderRadius: 4,
                            borderSkipped: false
                        },
                        {
                            label: labelB,
                            data: dataB,
                            backgroundColor: this._withAlpha(colorB, 0.7),
                            borderColor: colorB,
                            borderWidth: 0,
                            borderRadius: 4,
                            borderSkipped: false
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: "top",
                            align: "end",
                            labels: {
                                color: mutedColor,
                                boxWidth: 10,
                                boxHeight: 10,
                                borderRadius: 3,
                                padding: 12,
                                font: {
                                    size: 11
                                }
                            }
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx)=>` ${ctx.dataset.label}: ${yFmt(ctx.raw)}`
                            }
                        }
                    },
                    scales: {
                        x: {
                            grid: {
                                color: gridColor,
                                drawTicks: false
                            },
                            ticks: {
                                color: mutedColor,
                                maxRotation: 0,
                                autoSkip: true,
                                maxTicksLimit: 16
                            }
                        },
                        y: {
                            grid: {
                                color: gridColor
                            },
                            ticks: {
                                color: mutedColor,
                                callback: yFmt
                            },
                            beginAtZero: true
                        }
                    }
                }
            });
        });
    }
    setCmpTopItemsSort(key) {
        document.querySelectorAll(".rp-cmp-sort-pills .rp-sort-pill").forEach((btn)=>{
            btn.classList.toggle("active", btn.dataset.sort === key);
        });
    }
    _addHandlerCmpTopItemsSort(handler) {
        document.querySelectorAll(".rp-cmp-sort-pills").forEach((group)=>{
            group.addEventListener("click", (e)=>{
                const pill = e.target.closest(".rp-sort-pill");
                if (!pill || pill.classList.contains("active")) return;
                handler(pill.dataset.sort);
            });
        });
    }
    _addHandlerCompareBack(handler) {
        document.querySelector("#rpCmpBackBtn")?.addEventListener("click", handler);
    }
    _addHandlerCompareToggle(handler) {
        document.querySelector("#reportsCompareBtn")?.addEventListener("click", handler);
    }
    _addHandlerRunComparison(handler) {
        const typeAEl = document.querySelector("#rpCmpTypeA");
        const vsLabel = document.querySelector("#rpCmpVsLabel");
        const A_WRAPPERS = {
            day: document.querySelector("#rpCmpADayWrap"),
            week: document.querySelector("#rpCmpAWeekWrap"),
            month: document.querySelector("#rpCmpAMonthWrap"),
            year: document.querySelector("#rpCmpAYearWrap"),
            custom: document.querySelector("#rpCmpCustomA")
        };
        const B_WRAPPERS = {
            day: document.querySelector("#rpCmpBDayWrap"),
            week: document.querySelector("#rpCmpBWeekWrap"),
            month: document.querySelector("#rpCmpBMonthWrap"),
            year: document.querySelector("#rpCmpBYearWrap"),
            custom: document.querySelector("#rpCmpCustomB")
        };
        const VS_LABELS = {
            day: "Day vs Day",
            week: "Week vs Week",
            month: "Month vs Month",
            year: "Year vs Year",
            custom: "Custom Range"
        };
        // Format helpers for button labels
        const fmtDay = (ymd)=>{
            if (!ymd) return "Pick date";
            const d = new Date(ymd + "T00:00:00");
            return d.toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric"
            });
        };
        const fmtMonth = (ym)=>{
            if (!ym) return "Pick month";
            const [y, m] = ym.split("-");
            return new Date(+y, +m - 1, 1).toLocaleDateString("en-US", {
                month: "long",
                year: "numeric"
            });
        };
        // Wire showPicker() for all date/month buttons
        const wirePicker = (inputId, btnId, fmtFn)=>{
            const input = document.querySelector(`#${inputId}`);
            const btn = document.querySelector(`#${btnId}`);
            if (!input || !btn) return;
            btn.addEventListener("click", ()=>{
                try {
                    input.showPicker();
                } catch (e) {}
            });
            input.addEventListener("change", ()=>{
                btn.textContent = fmtFn(input.value);
            });
        };
        wirePicker("rpCmpADay", "rpCmpADayLabel", fmtDay);
        wirePicker("rpCmpBDay", "rpCmpBDayLabel", fmtDay);
        wirePicker("rpCmpAWeek", "rpCmpAWeekLabel", fmtDay);
        wirePicker("rpCmpBWeek", "rpCmpBWeekLabel", fmtDay);
        wirePicker("rpCmpAMonth", "rpCmpAMonthLabel", fmtMonth);
        wirePicker("rpCmpBMonth", "rpCmpBMonthLabel", fmtMonth);
        wirePicker("rpCmpFromA", "rpCmpFromALabel", fmtDay);
        wirePicker("rpCmpToA", "rpCmpToALabel", fmtDay);
        wirePicker("rpCmpFromB", "rpCmpFromBLabel", fmtDay);
        wirePicker("rpCmpToB", "rpCmpToBLabel", fmtDay);
        const setLabel = (btnId, val, fmtFn)=>{
            const btn = document.querySelector(`#${btnId}`);
            if (btn) btn.textContent = fmtFn(val);
        };
        const setDefaults = (type)=>{
            const today = (0, $lDSCx.businessToday)(); // the cafe's calendar day, "YYYY-MM-DD"
            const [ty, tm] = today.split("-").map(Number);
            if (type === "day") {
                const aEl = document.querySelector("#rpCmpADay");
                const bEl = document.querySelector("#rpCmpBDay");
                if (aEl) {
                    aEl.value = today;
                    setLabel("rpCmpADayLabel", aEl.value, fmtDay);
                }
                if (bEl) {
                    bEl.value = (0, $lDSCx.addDays)(today, -1);
                    setLabel("rpCmpBDayLabel", bEl.value, fmtDay);
                }
            } else if (type === "week") {
                const thisMon = (0, $lDSCx.mondayOf)(today);
                const aEl = document.querySelector("#rpCmpAWeek");
                const bEl = document.querySelector("#rpCmpBWeek");
                if (aEl) {
                    aEl.value = thisMon;
                    setLabel("rpCmpAWeekLabel", aEl.value, fmtDay);
                }
                if (bEl) {
                    bEl.value = (0, $lDSCx.addDays)(thisMon, -7);
                    setLabel("rpCmpBWeekLabel", bEl.value, fmtDay);
                }
            } else if (type === "month") {
                const prev = tm === 1 ? `${ty - 1}-12` : `${ty}-${String(tm - 1).padStart(2, "0")}`;
                const aEl = document.querySelector("#rpCmpAMonth");
                const bEl = document.querySelector("#rpCmpBMonth");
                if (aEl) {
                    aEl.value = today.slice(0, 7);
                    setLabel("rpCmpAMonthLabel", aEl.value, fmtMonth);
                }
                if (bEl) {
                    bEl.value = prev;
                    setLabel("rpCmpBMonthLabel", bEl.value, fmtMonth);
                }
            } else if (type === "year") {
                const aEl = document.querySelector("#rpCmpAYear");
                const bEl = document.querySelector("#rpCmpBYear");
                if (aEl) aEl.value = String(ty);
                if (bEl) bEl.value = String(ty - 1);
            }
        };
        const showWrappers = (type)=>{
            Object.values(A_WRAPPERS).forEach((w)=>w?.classList.add("hidden"));
            Object.values(B_WRAPPERS).forEach((w)=>w?.classList.add("hidden"));
            A_WRAPPERS[type]?.classList.remove("hidden");
            B_WRAPPERS[type]?.classList.remove("hidden");
            if (vsLabel) vsLabel.textContent = VS_LABELS[type] ?? "vs";
        };
        setDefaults("day");
        showWrappers("day");
        typeAEl?.addEventListener("change", (e)=>{
            showWrappers(e.target.value);
            setDefaults(e.target.value);
        });
        document.querySelector("#rpRunCmpBtn")?.addEventListener("click", ()=>{
            const type = typeAEl?.value;
            if (!type) return;
            if (type === "custom") {
                const fromA = document.querySelector("#rpCmpFromA")?.value;
                const toA = document.querySelector("#rpCmpToA")?.value;
                const fromB = document.querySelector("#rpCmpFromB")?.value;
                const toB = document.querySelector("#rpCmpToB")?.value;
                if (!fromA || !toA || !fromB || !toB) return;
                handler({
                    type: type,
                    fromA: fromA,
                    toA: toA,
                    fromB: fromB,
                    toB: toB
                });
            } else {
                const A_VALS = {
                    day: document.querySelector("#rpCmpADay")?.value,
                    week: document.querySelector("#rpCmpAWeek")?.value,
                    month: document.querySelector("#rpCmpAMonth")?.value,
                    year: document.querySelector("#rpCmpAYear")?.value
                };
                const B_VALS = {
                    day: document.querySelector("#rpCmpBDay")?.value,
                    week: document.querySelector("#rpCmpBWeek")?.value,
                    month: document.querySelector("#rpCmpBMonth")?.value,
                    year: document.querySelector("#rpCmpBYear")?.value
                };
                const aValue = A_VALS[type];
                const bValue = B_VALS[type];
                if (!aValue || !bValue) return;
                handler({
                    type: type,
                    aValue: aValue,
                    bValue: bValue
                });
            }
        });
    }
    _addHandlerExport(csvHandler, pdfHandler) {
        const btn = document.querySelector("#reportsExportBtn");
        const menu = document.querySelector("#reportsExportMenu");
        if (!btn || !menu) return;
        btn.addEventListener("click", (e)=>{
            e.stopPropagation();
            menu.classList.toggle("hidden");
        });
        document.querySelector("#reportsExportCsvBtn")?.addEventListener("click", ()=>{
            menu.classList.add("hidden");
            csvHandler();
        });
        document.querySelector("#reportsExportPdfBtn")?.addEventListener("click", ()=>{
            menu.classList.add("hidden");
            pdfHandler();
        });
        document.addEventListener("click", (e)=>{
            if (!document.querySelector("#reportsExportWrap")?.contains(e.target)) menu.classList.add("hidden");
        });
    }
    _addHandlerCustomRange(handler) {
        const fromEl = document.querySelector("#reportsFrom");
        const toEl = document.querySelector("#reportsTo");
        const fromLabel = document.querySelector("#reportsFromLabel");
        const toLabel = document.querySelector("#reportsToLabel");
        const fmtDate = (ymd)=>{
            if (!ymd) return "Start date";
            const d = new Date(ymd + "T00:00:00");
            return d.toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric"
            });
        };
        // Buttons trigger the native date picker
        fromLabel?.addEventListener("click", ()=>{
            try {
                fromEl.showPicker();
            } catch (e) {}
        });
        toLabel?.addEventListener("click", ()=>{
            try {
                toEl.showPicker();
            } catch (e) {}
        });
        fromEl.addEventListener("change", ()=>{
            fromLabel.textContent = fmtDate(fromEl.value);
            if (toEl.value && toEl.value < fromEl.value) {
                toEl.value = fromEl.value;
                toLabel.textContent = fmtDate(toEl.value);
            }
            toEl.min = fromEl.value;
        });
        toEl.addEventListener("change", ()=>{
            toLabel.textContent = fmtDate(toEl.value);
        });
        document.querySelector("#applyReportsRangeBtn").addEventListener("click", ()=>{
            const from = fromEl.value;
            const to = toEl.value;
            if (!from || !to) return;
            if (to < from) {
                toEl.value = from;
                toLabel.textContent = fmtDate(toEl.value);
                return;
            }
            handler({
                period: "custom",
                from: from,
                to: to
            });
        });
    }
    // ── Expenses ──────────────────────────────────────────────────────────────
    renderExpenseKpis({ expenses: expenses, net: net, avgGross: avgGross = 0, avgNet: avgNet = 0, avgSuffix: avgSuffix = '', avgTooltip: avgTooltip = '' }) {
        const setVal = (id, val)=>{
            const el = document.getElementById(id);
            if (el) el.textContent = $d94c521226fbc9fa$var$fmt(val);
        };
        setVal("reportsExpenses", expenses);
        setVal("reportsNetIncome", net);
        setVal("salesNetIncome", net);
        setVal("salesAvgGross", avgGross);
        setVal("salesAvgNet", avgNet);
        const applyNetClass = (id)=>{
            const el = document.getElementById(id);
            if (el) {
                el.classList.toggle("rp-kpi-val--positive", net >= 0);
                el.classList.toggle("rp-kpi-val--negative", net < 0);
            }
        };
        applyNetClass("reportsNetIncome");
        applyNetClass("salesNetIncome");
        const avgNetEl = document.getElementById("salesAvgNet");
        if (avgNetEl) {
            avgNetEl.classList.toggle("rp-kpi-val--positive", avgNet >= 0);
            avgNetEl.classList.toggle("rp-kpi-val--negative", avgNet < 0);
        }
        if (avgSuffix) {
            const glEl = document.getElementById("salesAvgGrossLabel");
            const nlEl = document.getElementById("salesAvgNetLabel");
            if (glEl) glEl.textContent = `Avg. Gross ${avgSuffix}`;
            if (nlEl) nlEl.textContent = `Avg. Net ${avgSuffix}`;
        }
        if (avgTooltip) {
            const gi = document.getElementById("salesAvgGrossInfo");
            const ni = document.getElementById("salesAvgNetInfo");
            if (gi) gi.dataset.tip = avgTooltip;
            if (ni) ni.dataset.tip = avgTooltip;
        }
    }
    renderSalesKpis({ bestSeller: bestSeller, topCategory: topCategory, topStaff: topStaff }) {
        const set = (valId, subId, val, sub)=>{
            const v = document.getElementById(valId);
            const s = document.getElementById(subId);
            if (v) v.textContent = val ?? "\u2014";
            if (s) s.textContent = sub ?? '';
        };
        set('salesBestSeller', 'salesBestSellerSub', bestSeller?.name, bestSeller ? `${bestSeller.quantity} sold` : '');
        set('salesTopCategory', 'salesTopCategorySub', topCategory?.label, topCategory ? $d94c521226fbc9fa$var$fmt(topCategory.value) : '');
        set('salesTopStaff', 'salesTopStaffSub', topStaff?.name, topStaff ? $d94c521226fbc9fa$var$fmt(topStaff.revenue) : '');
    }
    renderTrafficKpis({ peakHour: peakHour, peakDay: peakDay, total: total, avgDaily: avgDaily }) {
        const hourVal = document.getElementById('trafficPeakHour');
        const hourSub = document.getElementById('trafficPeakHourSub');
        const dayVal = document.getElementById('trafficPeakDay');
        const daySub = document.getElementById('trafficPeakDaySub');
        const avgVal = document.getElementById('trafficAvgDaily');
        const avgSub = document.getElementById('trafficAvgDailySub');
        if (hourVal) hourVal.textContent = peakHour ? peakHour.label : "\u2014";
        if (hourSub) hourSub.textContent = peakHour ? `${peakHour.count} orders` : '';
        if (dayVal) dayVal.textContent = peakDay ? peakDay.label : "\u2014";
        if (daySub) daySub.textContent = peakDay ? `${peakDay.count} orders` : '';
        if (avgVal) avgVal.textContent = avgDaily > 0 ? Number.isInteger(avgDaily) ? avgDaily : avgDaily.toFixed(1) : "\u2014";
        if (avgSub) avgSub.textContent = total > 0 ? `${total} total` : '';
    }
}
var $d94c521226fbc9fa$export$2e2bcd8739ae039 = new $d94c521226fbc9fa$var$ReportsView();




var $cnCXJ = parcelRequire("cnCXJ");
const $5d00d49bfb2356db$var$CATEGORY_LABELS = {
    billing: 'Billing',
    bug_report: 'Bug Report',
    feature_request: 'Feature Request',
    account: 'Account',
    other: 'Other'
};
class $5d00d49bfb2356db$var$SupportView {
    _modal = document.getElementById('supportModal');
    _shell = document.querySelector('.support-shell');
    _closeBtn = document.getElementById('supportCloseBtn');
    _ticketList = document.getElementById('supportTicketList');
    _thread = document.getElementById('supportThread');
    _detailTitle = document.getElementById('supportDetailTitle');
    _detailStatus = document.getElementById('supportDetailStatus');
    _detailCategory = document.getElementById('supportDetailCategory');
    _unreadBadge = document.getElementById('supportUnreadBadge');
    _currentTicketId = null;
    _selectedRating = 0;
    // ── Open / Close ──────────────────────────────────────────────────────────────
    open() {
        this._modal.classList.remove('hidden');
        this._shell?.classList.remove('support-shell--detail');
        this._showMain('welcome');
    }
    _close() {
        this._shell?.classList.add('modal-exiting');
        setTimeout(()=>{
            this._shell?.classList.remove('modal-exiting');
            this._modal.classList.add('hidden');
        }, 220);
    }
    // ── Main panel switching (right side) ────────────────────────────────────────
    _showMain(name) {
        [
            'supportWelcomePanel',
            'supportNewPanel',
            'supportDetailPanel',
            'supportSuccessPanel'
        ].forEach((id)=>document.getElementById(id)?.classList.add('hidden'));
        document.getElementById(`support${name.charAt(0).toUpperCase() + name.slice(1)}Panel`)?.classList.remove('hidden');
    }
    showNewTicketPanel() {
        this._clearActiveRow();
        document.getElementById('newTicketModal')?.classList.remove('hidden');
    }
    closeNewTicketModal() {
        const modal = document.getElementById('newTicketModal');
        const inner = modal?.querySelector('.modal-container');
        if (inner) inner.classList.add('modal-exiting');
        setTimeout(()=>{
            inner?.classList.remove('modal-exiting');
            modal?.classList.add('hidden');
        }, 220);
    }
    showListPanel() {
        this._shell?.classList.remove('support-shell--detail');
        this._showMain('welcome');
        this._clearActiveRow();
    }
    showSuccessPanel() {
        this.closeNewTicketModal();
        this._showMain('success');
    }
    // ── Ticket list rendering ─────────────────────────────────────────────────────
    renderTicketList(tickets) {
        if (!tickets.length) {
            this._ticketList.innerHTML = '<li class="support-empty">No tickets yet.<br>Hit "New Ticket" to get started.</li>';
            return;
        }
        this._ticketList.innerHTML = tickets.map((t)=>`
      <li class="support-ticket-row${this._currentTicketId === t.id ? ' support-ticket-row--active' : ''}" data-id="${t.id}">
        ${t.has_unread_reply ? '<span class="support-unread-dot"></span>' : '<span style="width:7px;flex-shrink:0"></span>'}
        <div class="support-ticket-info">
          <span class="support-ticket-subject">${(0, $cnCXJ.esc)(t.subject)}</span>
          <span class="support-ticket-meta">${$5d00d49bfb2356db$var$CATEGORY_LABELS[t.category] ?? t.category} &middot; ${this._relativeDate(t.created_at)}</span>
          <span class="support-chip support-chip--${t.status}">${t.status === 'solved' ? 'Solved' : 'Open'}</span>
        </div>
      </li>
    `).join('');
    }
    _clearActiveRow() {
        this._currentTicketId = null;
        document.querySelectorAll('.support-ticket-row--active').forEach((r)=>r.classList.remove('support-ticket-row--active'));
    }
    _setActiveRow(ticketId) {
        document.querySelectorAll('.support-ticket-row').forEach((r)=>{
            r.classList.toggle('support-ticket-row--active', r.dataset.id === ticketId);
        });
    }
    // ── Thread rendering ──────────────────────────────────────────────────────────
    renderThread(ticket, replies) {
        this._currentTicketId = ticket.id;
        this._setActiveRow(ticket.id);
        this._detailTitle.textContent = ticket.subject;
        this._detailCategory.textContent = $5d00d49bfb2356db$var$CATEGORY_LABELS[ticket.category] ?? ticket.category;
        this._detailCategory.className = `support-chip support-chip--open`;
        this._detailStatus.textContent = ticket.status === 'solved' ? 'Solved' : 'Open';
        this._detailStatus.className = `support-status-chip support-chip--${ticket.status}`;
        const ticketIdEl = document.getElementById('supportDetailTicketId');
        if (ticketIdEl) ticketIdEl.textContent = '#' + ticket.id.replace(/-/g, '').slice(0, 8).toUpperCase();
        const solvedBtn = document.getElementById('supportMarkSolvedBtn');
        if (solvedBtn) solvedBtn.classList.toggle('hidden', ticket.status === 'solved');
        const replyBar = document.getElementById('supportReplyBar');
        if (replyBar) replyBar.classList.toggle('hidden', ticket.status === 'solved');
        const ratingBar = document.getElementById('supportRatingBar');
        const ratingDone = document.getElementById('supportRatingDone');
        const showPrompt = ticket.status === 'solved' && !ticket.rating;
        if (ratingBar) ratingBar.classList.toggle('hidden', !showPrompt);
        if (ratingDone) ratingDone.classList.add('hidden');
        if (showPrompt) this._resetStars();
        const emojis = [
            '',
            "\uD83D\uDE24",
            "\uD83D\uDE15",
            "\uD83D\uDE10",
            "\uD83D\uDE0A",
            "\uD83E\uDD29"
        ];
        const labels = [
            '',
            'Bad',
            'Poor',
            'OK',
            'Good',
            'Great'
        ];
        const allMessages = [
            {
                sender_type: 'business',
                message: ticket.message,
                created_at: ticket.created_at,
                attachment: ticket.attachments?.[0]
            },
            ...replies
        ];
        const closureBlock = ticket.status === 'solved' ? `
      <div class="support-closure">
        <div class="support-closure-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        </div>
        <p class="support-closure-title">Ticket closed</p>
        ${ticket.rating ? `<p class="support-closure-rating">You rated this conversation ${emojis[ticket.rating]} <strong>${labels[ticket.rating]}</strong></p>` : ''}
      </div>
    ` : '';
        this._thread.innerHTML = allMessages.map((msg)=>`
      <div class="support-msg support-msg--${msg.sender_type}">
        <div class="support-msg-bubble">
          <p class="support-msg-text">${(0, $cnCXJ.esc)(msg.message)}</p>
          ${msg.attachment ? `<a class="support-msg-attachment" href="${(0, $cnCXJ.esc)(msg.attachment)}" target="_blank" rel="noopener">View attachment</a>` : ''}
        </div>
        <span class="support-msg-time">${msg.sender_type === 'admin' ? 'Pointbunny Support' : 'You'} &middot; ${this._relativeDate(msg.created_at)}</span>
      </div>
    `).join('') + closureBlock;
        this._shell?.classList.add('support-shell--detail');
        this._showMain('detail');
        setTimeout(()=>{
            this._thread.scrollTop = this._thread.scrollHeight;
        }, 0);
    }
    // ── Unread badge on home card ─────────────────────────────────────────────────
    syncUnreadBadge(tickets) {
        const count = tickets.filter((t)=>t.has_unread_reply).length;
        if (count > 0) {
            this._unreadBadge.textContent = count;
            this._unreadBadge.classList.remove('hidden');
        } else this._unreadBadge.classList.add('hidden');
    }
    // ── New ticket form helpers ───────────────────────────────────────────────────
    _getTicketFormData() {
        const input = document.getElementById('ticketFiles');
        return {
            category: document.getElementById('ticketCategory')?.value,
            subject: document.getElementById('ticketSubject')?.value.trim(),
            message: document.getElementById('ticketMessage')?.value.trim(),
            files: input ? Array.from(input.files).slice(0, 1) : []
        };
    }
    setTicketSubmitting(loading) {
        const btn = document.getElementById('ticketSubmitBtn');
        if (!btn) return;
        btn.disabled = loading;
        btn.textContent = loading ? "Sending\u2026" : 'Send Message';
    }
    showTicketResult(success, message) {
        const el = document.getElementById('ticketStatusMsg');
        if (!el) return;
        el.textContent = message;
        el.className = `ticket-status-msg ${success ? 'ticket-status-msg--ok' : 'ticket-status-msg--err'}`;
    }
    resetTicketForm() {
        [
            'ticketCategory',
            'ticketSubject',
            'ticketMessage',
            'ticketFiles'
        ].forEach((id)=>{
            const el = document.getElementById(id);
            if (el) el.value = '';
        });
        const list = document.getElementById('ticketFileList');
        if (list) list.innerHTML = '';
        const msg = document.getElementById('ticketStatusMsg');
        if (msg) msg.className = 'ticket-status-msg hidden';
    }
    // ── Handlers ──────────────────────────────────────────────────────────────────
    _addHandlerOpen(handler) {
        document.addEventListener('click', (e)=>{
            if (e.target.closest("[data-action='support']")) handler();
        });
    }
    _addHandlerClose() {
        this._closeBtn.addEventListener('click', ()=>this._close());
        this._modal.addEventListener('click', (e)=>{
            if (e.target === this._modal) this._close();
        });
    }
    _addHandlerNewTicket(handler) {
        document.getElementById('supportNewTicketBtn')?.addEventListener('click', handler);
    }
    _addHandlerCloseNewTicket(handler) {
        const modal = document.getElementById('newTicketModal');
        document.getElementById('newTicketCloseBtn')?.addEventListener('click', handler);
        modal?.addEventListener('click', (e)=>{
            if (e.target === modal) handler();
        });
    }
    _addHandlerBackToList(handler) {
        document.getElementById('supportBackToListBtn2')?.addEventListener('click', handler);
    }
    _addHandlerTicketClick(handler) {
        this._ticketList.addEventListener('click', (e)=>{
            const row = e.target.closest('.support-ticket-row[data-id]');
            if (!row) return;
            handler(row.dataset.id);
        });
    }
    _addHandlerMarkSolved(handler) {
        document.getElementById('supportMarkSolvedBtn')?.addEventListener('click', ()=>{
            handler(this._currentTicketId);
        });
    }
    _addHandlerSubmitTicket(handler) {
        document.getElementById('ticketSubmitBtn')?.addEventListener('click', (e)=>(0, $05116e7677d717d1$export$277a10cf25fc7086)(e.currentTarget, ()=>handler(), {
                busyText: "Sending\u2026"
            }));
    }
    _addHandlerViewTickets(handler) {
        document.getElementById('supportViewTicketsBtn')?.addEventListener('click', handler);
    }
    _addHandlerSendReply(handler) {
        const sendBtn = document.getElementById('supportReplySendBtn');
        sendBtn?.addEventListener('click', ()=>(0, $05116e7677d717d1$export$277a10cf25fc7086)(sendBtn, ()=>handler()));
        document.getElementById('supportReplyInput')?.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) (0, $05116e7677d717d1$export$277a10cf25fc7086)(sendBtn, ()=>handler());
        });
    }
    // One-click rating: hovering shows the reaction word, a single click selects
    // AND submits immediately (no separate "Submit" button). `handler` is the
    // submit callback; the guard blocks a second click once a rating is chosen.
    _addHandlerRating(handler) {
        const container = document.getElementById('supportStars');
        const hint = document.getElementById('supportRatingHint');
        if (!container) return;
        const labels = [
            '',
            'Bad',
            'Poor',
            'OK',
            'Good',
            'Great'
        ];
        container.addEventListener('mouseover', (e)=>{
            const star = e.target.closest('.support-star[data-value]');
            if (!star) return;
            container.querySelectorAll('.support-star').forEach((s)=>s.classList.toggle('support-star--hover', s === star));
            if (hint) hint.textContent = labels[parseInt(star.dataset.value)];
        });
        container.addEventListener('mouseleave', ()=>{
            container.querySelectorAll('.support-star').forEach((s)=>s.classList.remove('support-star--hover'));
            if (hint && !this._selectedRating) hint.textContent = 'Tap a reaction - it sends right away';
        });
        container.addEventListener('click', (e)=>{
            const star = e.target.closest('.support-star[data-value]');
            if (!star || this._selectedRating) return; // ignore double-clicks after send
            this._selectedRating = parseInt(star.dataset.value);
            container.querySelectorAll('.support-star').forEach((s)=>s.classList.toggle('support-star--active', s === star));
            handler();
        });
    }
    // Delegated from the stable #supportRatingDone container because the comment
    // row's markup is rebuilt on each rating (see showRatingThanks).
    _addHandlerRatingComment(handler) {
        document.getElementById('supportRatingDone')?.addEventListener('click', (e)=>{
            const btn = e.target.closest('.support-rating-comment-btn');
            if (!btn) return;
            (0, $05116e7677d717d1$export$277a10cf25fc7086)(btn, ()=>handler());
        });
    }
    getRatingComment() {
        return document.getElementById('supportRatingComment')?.value.trim() ?? '';
    }
    // Swap the emoji row for the thank-you + optional-comment step (optimistic).
    showRatingThanks(rating) {
        const emojis = [
            '',
            "\uD83D\uDE24",
            "\uD83D\uDE15",
            "\uD83D\uDE10",
            "\uD83D\uDE0A",
            "\uD83E\uDD29"
        ];
        document.getElementById('supportRatingBar')?.classList.add('hidden');
        const emoji = document.getElementById('supportRatingThanksEmoji');
        if (emoji) emoji.textContent = emojis[rating] || "\uD83C\uDF89";
        // Rebuild the comment row so a ticket rated after one whose comment was
        // already saved still gets a fresh textarea + button.
        const row = document.getElementById('supportRatingCommentRow');
        if (row) row.innerHTML = '<textarea class="support-reply-input" id="supportRatingComment" placeholder="Want to tell us more? (optional)" rows="2"></textarea><button type="button" class="btn ghost support-rating-comment-btn" id="supportRatingCommentBtn">Add a comment</button>';
        document.getElementById('supportRatingDone')?.classList.remove('hidden');
    }
    // Roll back to the emoji row if the optimistic submit failed.
    revertRating() {
        document.getElementById('supportRatingDone')?.classList.add('hidden');
        document.getElementById('supportRatingBar')?.classList.remove('hidden');
        this._resetStars();
    }
    showCommentSaved() {
        const row = document.getElementById('supportRatingCommentRow');
        if (row) row.innerHTML = '<p class="support-rating-saved">Comment saved - thank you!</p>';
    }
    _resetStars() {
        this._selectedRating = 0;
        document.querySelectorAll('.support-star').forEach((s)=>{
            s.classList.remove('support-star--active', 'support-star--hover');
        });
        const hint = document.getElementById('supportRatingHint');
        if (hint) hint.textContent = 'Tap a reaction - it sends right away';
        const comment = document.getElementById('supportRatingComment');
        if (comment) comment.value = '';
    }
    _addHandlerTicketFiles() {
        const input = document.getElementById('ticketFiles');
        const list = document.getElementById('ticketFileList');
        if (!input || !list) return;
        input.addEventListener('change', ()=>{
            const files = Array.from(input.files).slice(0, 1);
            list.innerHTML = files.map((f)=>`<li class="ticket-file-item">${(0, $cnCXJ.esc)(f.name)}</li>`).join('');
        });
    }
    _getReplyText() {
        return document.getElementById('supportReplyInput')?.value.trim() ?? '';
    }
    clearReplyInput() {
        const el = document.getElementById('supportReplyInput');
        if (el) el.value = '';
    }
    setReplySending(loading) {
        const btn = document.getElementById('supportReplySendBtn');
        if (!btn) return;
        btn.disabled = loading;
        btn.textContent = loading ? "Sending\u2026" : 'Send';
    }
    setCurrentTicket(id) {
        this._currentTicketId = id;
    }
    // ── Helpers ───────────────────────────────────────────────────────────────────
    _relativeDate(iso) {
        const diff = Date.now() - new Date(iso).getTime();
        const mins = Math.floor(diff / 60000);
        if (mins < 1) return 'Just now';
        if (mins < 60) return `${mins}m ago`;
        const hrs = Math.floor(mins / 60);
        if (hrs < 24) return `${hrs}h ago`;
        return `${Math.floor(hrs / 24)}d ago`;
    }
}
var $5d00d49bfb2356db$export$2e2bcd8739ae039 = new $5d00d49bfb2356db$var$SupportView();



var $cnCXJ = parcelRequire("cnCXJ");
// Navbar notification bell: draft Purchase Orders / pending shift corrections /
// pending leave requests / leave starting soon (7-day + 1-day reminder) /
// shift swaps + pickups waiting for a manager (2026-10-17), all
// gated by the controller on the signed-in account's actual capabilities (not
// the switchable cashier - see controller.js _refreshNotifications). This view
// only renders what it's handed; it never checks permissions itself.
const $9e6597a253ab6810$var$fmtRelDate = (iso)=>{
    if (!iso) return '';
    const d = new Date(iso);
    const days = Math.floor((Date.now() - d) / 86400000);
    if (days <= 0) return 'Today';
    if (days === 1) return 'Yesterday';
    return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
    });
};
const $9e6597a253ab6810$var$fmtPoNumber = (n)=>`PO-${String(n ?? 0).padStart(3, '0')}`;
const $9e6597a253ab6810$var$fmtStartsIn = (dateStr)=>{
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const days = Math.round((new Date(dateStr + 'T00:00:00') - today) / 86400000);
    return days === 1 ? 'Starts tomorrow' : `Starts in ${days} days`;
};
class $9e6597a253ab6810$var$NotificationView {
    _control = document.getElementById('notifControl');
    _toggle = document.getElementById('notifToggle');
    _dropdown = document.getElementById('notifDropdown');
    _list = document.getElementById('notifList');
    _badge = document.getElementById('notifBadge');
    _categoryClickHandler = null;
    _itemClickHandler = null;
    _addHandlerCategoryClick(handler) {
        this._categoryClickHandler = handler;
    }
    _addHandlerItemClick(handler) {
        this._itemClickHandler = handler;
    }
    reveal() {
        this._control?.classList.remove('hidden');
    }
    // { pos, corrections, leave, leaveUpcoming, shiftRequests }, { canPOs, canPay, canSchedule, leaveUpcomingUnseen }
    render({ pos: pos = [], corrections: corrections = [], leave: leave = [], leaveUpcoming: leaveUpcoming = [], shiftRequests: shiftRequests = [] } = {}, { canPOs: canPOs = false, canPay: canPay = false, canSchedule: canSchedule = false, leaveUpcomingUnseen: leaveUpcomingUnseen = leaveUpcoming.length } = {}) {
        if (!this._list || !this._badge) return;
        const sections = [];
        if (canPOs) sections.push(this._section('po', "\uD83D\uDCDD", 'Purchase orders', pos, (po)=>`<span class="notif-item-title">${(0, $cnCXJ.esc)($9e6597a253ab6810$var$fmtPoNumber(po.poNumber))}</span><span class="notif-item-sub">${(0, $cnCXJ.esc)(po.supplierName || 'No supplier')}</span>`));
        if (canPay) sections.push(this._section('corrections', "\u23F1\uFE0F", 'Shift corrections', corrections, (r)=>`<span class="notif-item-title">${(0, $cnCXJ.esc)(r.staffName || 'Staff')}</span><span class="notif-item-sub">${r.shiftId ? 'Correction' : 'Missed shift'} \xb7 ${(0, $cnCXJ.esc)($9e6597a253ab6810$var$fmtRelDate(r.createdAt))}</span>`));
        if (canPay) sections.push(this._section('leave', "\uD83D\uDCC5", 'Leave requests', leave, (r)=>`<span class="notif-item-title">${(0, $cnCXJ.esc)(r.staffName || 'Staff')}</span><span class="notif-item-sub">${r.type === 'sick' ? "\uD83E\uDD12 Sick" : "\u2708\uFE0F Vacation"} \xb7 ${(0, $cnCXJ.esc)($9e6597a253ab6810$var$fmtRelDate(r.createdAt))}</span>`));
        // badgeCount is the UNSEEN count, not rows.length - unlike the other three
        // categories, a reminder here never resolves on its own (no approve/reject),
        // so it has to be dismissed by opening the bell instead, or it would just
        // sit in the badge for its whole 7-day/1-day window. Rows still list every
        // active reminder (seen or not) - only the count badge reacts to "seen".
        if (canPay) sections.push(this._section('leaveUpcoming', "\u23F3", 'Upcoming leave', leaveUpcoming, (r)=>`<span class="notif-item-title">${(0, $cnCXJ.esc)(r.staffName || 'Staff')}</span><span class="notif-item-sub">${(0, $cnCXJ.esc)($9e6597a253ab6810$var$fmtStartsIn(r.startDate))}</span>`, 'Nothing coming up', leaveUpcomingUnseen));
        // Swaps + open-shift pickups waiting for a manager (shift schedule phase 3).
        if (canSchedule) sections.push(this._section('shiftRequests', "\uD83D\uDD01", 'Shift requests', shiftRequests, (r)=>`<span class="notif-item-title">${(0, $cnCXJ.esc)(r.requesterName || 'Staff')}</span><span class="notif-item-sub">${r.kind === 'pickup' ? 'Wants an open shift' : r.targetShiftId ? `Trade with ${(0, $cnCXJ.esc)(r.targetName || 'a teammate')}` : `Cover by ${(0, $cnCXJ.esc)(r.targetName || 'a teammate')}`} \xb7 ${(0, $cnCXJ.esc)($9e6597a253ab6810$var$fmtRelDate(r.createdAt))}</span>`));
        const total = sections.reduce((s, sec)=>s + sec.count, 0);
        this._list.innerHTML = sections.length ? sections.map((sec)=>sec.html).join('') : `<div class="notif-empty">You're all caught up \u{1F389}</div>`;
        if (total > 0) {
            this._badge.textContent = total > 99 ? '99+' : String(total);
            this._badge.classList.remove('hidden');
        } else this._badge.classList.add('hidden');
    }
    _section(cat, icon, label, rows, rowHtml, emptyText = 'None pending', badgeCount = rows.length) {
        const html = `
      <div class="notif-section">
        <button class="notif-section-head" data-cat="${cat}" type="button">
          <span class="notif-section-icon" aria-hidden="true">${icon}</span>
          <span class="notif-section-label">${label}</span>
          <span class="notif-section-count">${badgeCount}</span>
        </button>
        ${rows.length ? `<div class="notif-section-items">
          ${rows.slice(0, 5).map((r)=>`
            <button class="notif-item" data-cat="${cat}" data-id="${(0, $cnCXJ.esc)(r.id)}" type="button">
              ${rowHtml(r)}
            </button>`).join('')}
          ${rows.length > 5 ? `<button class="notif-item notif-item--more" data-cat="${cat}" type="button">+${rows.length - 5} more</button>` : ''}
        </div>` : `<p class="notif-section-empty">${(0, $cnCXJ.esc)(emptyText)}</p>`}
      </div>`;
        return {
            count: badgeCount,
            html: html
        };
    }
    _addHandlerDropdownClicks() {
        this._list?.addEventListener('click', (e)=>{
            const itemBtn = e.target.closest('.notif-item');
            const headBtn = e.target.closest('.notif-section-head');
            if (itemBtn) {
                const { cat: cat, id: id } = itemBtn.dataset;
                if (id) this._itemClickHandler?.(cat, id);
                else this._categoryClickHandler?.(cat); // "+N more" row
            } else if (headBtn) this._categoryClickHandler?.(headBtn.dataset.cat);
        });
    }
}
const $9e6597a253ab6810$var$_view = new $9e6597a253ab6810$var$NotificationView();
$9e6597a253ab6810$var$_view._addHandlerDropdownClicks();
var $9e6597a253ab6810$export$2e2bcd8739ae039 = $9e6597a253ab6810$var$_view;






var $cnCXJ = parcelRequire("cnCXJ");

const $e03adf9eaa390216$var$STEPS = 5;
const $e03adf9eaa390216$var$STEP_PLACE = 1, $e03adf9eaa390216$var$STEP_FEATURES = 2, $e03adf9eaa390216$var$STEP_ADDRESS = 3, $e03adf9eaa390216$var$STEP_PHONE = 4;
// Step 2 card icons (stroke paths), one per type of place.
const $e03adf9eaa390216$var$PLACE_ICONS = {
    cafe: '<path d="M17 8h1a4 4 0 0 1 0 8h-1"/><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z"/><path d="M6 2v3M10 2v3M14 2v3"/>',
    restaurant: '<path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/>',
    bakery: '<path d="M4 15a8 8 0 0 1 16 0v4H4Z"/><path d="M9 11V9M12 10V7M15 11V9"/>',
    food_truck: '<path d="M3 7h11v10H3Z"/><path d="M14 10h4l3 3v4h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>',
    bar: '<path d="M8 22h8"/><path d="M12 15v7"/><path d="M5 3h14l-7 12Z"/>',
    other: '<path d="M12 5v14M5 12h14"/>'
};
// Step 3 rows. `hide` = the home shortcut a row shows or hides; rows without
// it are checkout steps (their own setting).
const $e03adf9eaa390216$var$FEATURES = [
    {
        id: 'orderType',
        label: 'Dine in / Takeout',
        hint: 'Choose one at checkout'
    },
    {
        id: 'tips',
        label: 'Tips',
        hint: 'Tip buttons at checkout'
    },
    {
        id: 'tables',
        label: 'Tables',
        hint: 'Know where each order goes'
    },
    {
        id: 'kds',
        label: 'Queue Screen',
        hint: 'Orders on a screen in the kitchen',
        hide: 'kds'
    },
    {
        id: 'schedule',
        label: 'Staff schedule',
        hint: 'Build the week, swaps, time off',
        hide: 'schedule'
    },
    {
        id: 'loyalty',
        label: 'Loyalty points',
        hint: 'Regulars earn rewards',
        hide: 'loyalty',
        pro: true
    },
    {
        id: 'inventory',
        label: 'Inventory',
        hint: 'Stock counts, suppliers, purchase orders',
        hide: 'inventory',
        pro: true
    }
];
const $e03adf9eaa390216$var$CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
class $e03adf9eaa390216$var$OnboardingView {
    _overlay = document.getElementById('onboardingOverlay');
    _errorEl = document.getElementById('onboardingError');
    _nextBtn = document.getElementById('onboardingNextBtn');
    _backBtn = document.getElementById('onboardingBackBtn');
    _dots = [
        ...document.querySelectorAll('.ob-dot')
    ];
    _steps = [
        ...document.querySelectorAll('.ob-step')
    ];
    _current = 0;
    _phoneIti = null;
    _place = null;
    _setup = null;
    _detectCountry() {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
        const lang = (navigator.language ?? '').toUpperCase();
        if (lang.endsWith('-US') || tz.startsWith('America/') && !lang.endsWith('-CA') && !lang.endsWith('-MX') && !lang.endsWith('-BR')) return 'us';
        if (lang.endsWith('-PH') || tz === 'Asia/Manila') return 'ph';
        if (lang.endsWith('-CA') || tz.startsWith('America/Toronto') || tz.startsWith('America/Vancouver') || tz.startsWith('America/Winnipeg')) return 'ca';
        if (lang.endsWith('-GB') || tz === 'Europe/London') return 'gb';
        if (lang.endsWith('-AU') || tz.startsWith('Australia/')) return 'au';
        if (lang.endsWith('-SG') || tz === 'Asia/Singapore') return 'sg';
        if (lang.endsWith('-MY') || tz === 'Asia/Kuala_Lumpur') return 'my';
        if (lang.endsWith('-IN') || tz.startsWith('Asia/Kolkata')) return 'in';
        if (lang.endsWith('-NZ') || tz.startsWith('Pacific/Auckland')) return 'nz';
        if (lang.endsWith('-AE') || tz === 'Asia/Dubai') return 'ae';
        if (lang.endsWith('-JP') || tz === 'Asia/Tokyo') return 'jp';
        return 'us';
    }
    show() {
        this._current = 0;
        this._steps.forEach((s, i)=>s.classList.toggle('ob-step--hidden', i !== 0));
        this._updateUI();
        this._overlay.classList.remove('hidden');
        this._focusCurrent();
        const detected = this._detectCountry();
        if (!this._phoneIti) this._phoneIti = (0, $7c8d851372c266f6$export$4ff15454b4105eeb)('onboardingPhone');
        if (this._phoneIti) this._phoneIti.setCountry(detected);
        const countryEl = document.getElementById('onboardingCountry');
        if (countryEl && !countryEl.value) countryEl.value = detected.toUpperCase();
        this._place = null;
        this._setup = null;
        this._showDonePanel(false);
        this._renderPlaces();
        this._renderOtherKinds();
        this._renderFeatures();
        // Show the right Province/State control (constrained dropdown for US/CA, else text).
        this._syncStateField(countryEl?.value ?? detected.toUpperCase());
    }
    hide() {
        this._overlay.classList.add('hidden');
    }
    showError(msg) {
        this._errorEl.textContent = msg;
    }
    clearError() {
        this._errorEl.textContent = '';
    }
    setLoading(bool) {
        this._nextBtn.disabled = bool;
        this._nextBtn.textContent = bool ? "Saving\u2026" : this._nextLabel();
    }
    _nextLabel() {
        return this._current === $e03adf9eaa390216$var$STEPS - 1 ? 'Get Started' : 'Next';
    }
    _updateUI() {
        this._dots.forEach((d, i)=>d.classList.toggle('ob-dot--active', i === this._current));
        this._backBtn.classList.toggle('hidden', this._current === 0);
        // The card widens for the two choice steps (cards and checklist).
        this._overlay.querySelector('.auth-card')?.classList.toggle('auth-card--wide', this._current === $e03adf9eaa390216$var$STEP_PLACE || this._current === $e03adf9eaa390216$var$STEP_FEATURES);
        this._nextBtn.textContent = this._nextLabel();
    }
    // ── Step 2: type of place ──────────────────────────────────────────────────
    _renderPlaces() {
        const grid = document.getElementById('obPlaceGrid');
        if (!grid) return;
        grid.innerHTML = (0, $aa52f24595bb637d$export$4ee9af756839e9a2).map((p)=>{
            const on = p.id === this._place;
            return `
        <button type="button" class="ob-place${on ? ' ob-place--on' : ''}" role="radio" aria-checked="${on}" data-place="${p.id}">
          <span class="ob-place-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${$e03adf9eaa390216$var$PLACE_ICONS[p.id]}</svg></span>
          <span class="ob-place-text"><span class="ob-place-name">${p.label}</span><span class="ob-place-hint">${p.hint}</span></span>
        </button>`;
        }).join('');
        document.getElementById('obOtherKindField')?.classList.toggle('hidden', this._place !== 'other');
    }
    _renderOtherKinds() {
        const sel = document.getElementById('obOtherKind');
        if (!sel || sel.options.length > 1) return;
        (0, $aa52f24595bb637d$export$c9ab7a41fee2db9f).forEach((k)=>{
            const o = document.createElement('option');
            o.value = k.id;
            o.textContent = k.label;
            sel.appendChild(o);
        });
    }
    // Picking a different type re-ticks step 3 from that type's suggestions.
    _pickPlace(id) {
        if (id === this._place) return;
        this._place = id;
        this._setup = this._seedSetup(id);
        this._renderPlaces();
        this._renderFeatures();
        this.clearError();
    }
    // Step 2's title uses the name from step 1.
    _syncPlaceTitle() {
        const name = document.getElementById('onboardingBizName')?.value.trim();
        const el = document.getElementById('obPlaceTitle');
        if (el) el.textContent = name ? `What kind of place is ${name}?` : 'What kind of place is it?';
    }
    // ── Step 3: features ───────────────────────────────────────────────────────
    _seedSetup(place) {
        const s = (0, $aa52f24595bb637d$export$1df807e10c721ac1)(place);
        return {
            orderType: s.orderTypeEnabled,
            tips: s.tipsEnabled,
            tables: s.tableService !== 'off',
            tableMode: s.tableService === 'full' ? 'full' : 'numbers',
            waitlist: s.tableService === 'full' ? s.waitlistEnabled : true,
            reservations: s.reservationsEnabled,
            // Shortcuts step 3 doesn't ask about keep the type's suggestion.
            hidden: s.homeHidden,
            ...Object.fromEntries($e03adf9eaa390216$var$FEATURES.filter((f)=>f.hide).map((f)=>[
                    f.id,
                    !s.homeHidden.includes(f.hide)
                ]))
        };
    }
    _renderFeatures() {
        const list = document.getElementById('obFeatureList');
        if (!list) return;
        if (!this._setup) this._setup = this._seedSetup(this._place ?? 'cafe');
        const s = this._setup;
        const placeLabel = (0, $aa52f24595bb637d$export$4ee9af756839e9a2).find((p)=>p.id === this._place)?.label;
        const hint = document.getElementById('obFeatureHint');
        if (hint) hint.textContent = (placeLabel && this._place !== 'other' ? `We ticked what a ${placeLabel.split(' /')[0].toLowerCase()} usually uses. ` : '') + 'This only sets up your home screen. Every feature stays available to you, and you can change it anytime in Settings.';
        list.innerHTML = $e03adf9eaa390216$var$FEATURES.map((f)=>{
            const on = !!s[f.id];
            const tag = f.pro ? '<span class="ob-tag ob-tag--pro">Pro</span>' : '';
            const sub = f.id === 'tables' && on ? `
        <div class="ob-sub">
          <div class="ob-seg" role="radiogroup" aria-label="How tables work">
            <button type="button" class="ob-seg-btn${s.tableMode === 'numbers' ? ' ob-seg-btn--on' : ''}" role="radio" aria-checked="${s.tableMode === 'numbers'}" data-table-mode="numbers">They pay first, then sit</button>
            <button type="button" class="ob-seg-btn${s.tableMode === 'full' ? ' ob-seg-btn--on' : ''}" role="radio" aria-checked="${s.tableMode === 'full'}" data-table-mode="full">We serve at the table</button>
          </div>
          <p class="ob-sub-hint">${s.tableMode === 'full' ? 'Floor plan, open tabs, send to the kitchen as they order, pay at the end.' : 'Checkout asks for a table number so you can bring the order over.'}</p>
          ${s.tableMode === 'full' ? `
          <div class="ob-sub-checks">
            <label><input type="checkbox" data-sub="waitlist"${s.waitlist ? ' checked' : ''}> Waitlist</label>
            <label><input type="checkbox" data-sub="reservations"${s.reservations ? ' checked' : ''}> Reservations</label>
          </div>` : ''}
        </div>` : '';
            return `
        <div class="ob-feature${on ? ' ob-feature--on' : ''}">
          <button type="button" class="ob-feature-row" role="checkbox" aria-checked="${on}" data-feature="${f.id}">
            <span class="ob-check" aria-hidden="true">${$e03adf9eaa390216$var$CHECK_SVG}</span>
            <span class="ob-feature-text"><span class="ob-feature-name">${f.label}</span><span class="ob-feature-hint">${f.hint}</span></span>
            ${tag}
          </button>${sub}
        </div>`;
        }).join('') + '<p class="ob-fine">Pro features are included in your 7-day free trial.</p>';
    }
    // What the choices mean in settings terms (keys of state.settings).
    _result() {
        const s = this._setup ?? this._seedSetup(this._place ?? 'other');
        let hidden = [
            ...s.hidden
        ];
        for (const f of $e03adf9eaa390216$var$FEATURES.filter((x)=>x.hide))hidden = s[f.id] ? hidden.filter((k)=>k !== f.hide) : [
            ...hidden,
            f.hide
        ];
        const tableService = s.tables ? s.tableMode : 'off';
        return {
            placeType: this._place,
            orderTypeEnabled: !!s.orderType,
            tipsEnabled: !!s.tips,
            tableService: tableService,
            waitlistEnabled: tableService === 'full' && !!s.waitlist,
            reservationsEnabled: tableService === 'full' && !!s.reservations,
            homeHidden: (0, $aa52f24595bb637d$export$828e33864f81b452)(hidden)
        };
    }
    // ── Done screen ────────────────────────────────────────────────────────────
    _showDonePanel(show) {
        const card = this._overlay.querySelector('.auth-card');
        card?.classList.toggle('ob-card--done', show);
        if (show) card?.classList.add('auth-card--wide');
        document.getElementById('onboardingDone')?.classList.toggle('hidden', !show);
    }
    // Lists what's on the home screen now, from the choices just saved.
    showDone() {
        const s = this._setup ?? {};
        const r = this._result();
        const rows = $e03adf9eaa390216$var$FEATURES.map((f)=>{
            const on = !!s[f.id];
            let note = f.hint;
            if (f.id === 'tables' && on) note = r.tableService === 'full' ? 'Floor plan and open tabs' : 'Table number at checkout';
            if (!on) note = f.hide ? 'Hidden from home, still available' : 'Off, turn it on in Settings';
            return `
        <li class="ob-done-row${on ? '' : ' ob-done-row--off'}">
          <span class="ob-done-mark" aria-hidden="true">${on ? $e03adf9eaa390216$var$CHECK_SVG : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M6 12h12"/></svg>'}</span>
          <span class="ob-done-text"><span class="ob-done-name">${(0, $cnCXJ.esc)(f.label)}</span><span class="ob-done-hint">${(0, $cnCXJ.esc)(note)}</span></span>
          <span class="ob-done-state">${on ? 'On' : 'Off'}</span>
        </li>`;
        }).join('');
        const list = document.getElementById('obDoneList');
        if (list) list.innerHTML = rows;
        this._showDonePanel(true);
        setTimeout(()=>document.getElementById('onboardingDoneBtn')?.focus(), 150);
    }
    _addHandlerDone(handler) {
        document.getElementById('onboardingDoneBtn')?.addEventListener('click', ()=>handler());
    }
    // Fill the region dropdown for the given country (e.g. US states, CA provinces).
    // Re-fills when the country changes so US <-> CA switches show the right list.
    _populateRegions(country, regions) {
        const sel = document.getElementById('onboardingStateSelect');
        if (!sel) return;
        const cc = (country ?? '').toUpperCase();
        if (sel.dataset.filledFor === cc) return; // already populated for this country
        sel.innerHTML = '<option value="">Select one</option>';
        regions.forEach(({ code: code, name: name })=>{
            const o = document.createElement('option');
            o.value = code;
            o.textContent = name;
            sel.appendChild(o);
        });
        sel.dataset.filledFor = cc;
    }
    // Countries with sub-region tax (US states, CA provinces) get the constrained
    // dropdown so the region can't be mistyped; any other country keeps free text.
    _syncStateField(country) {
        const input = document.getElementById('onboardingProvince');
        const sel = document.getElementById('onboardingStateSelect');
        if (!input || !sel) return;
        const regions = (0, $0dd9374d56731bb4$export$f92ef939dc69d13b)(country);
        if (regions) this._populateRegions(country, regions);
        sel.classList.toggle('hidden', !regions);
        input.classList.toggle('hidden', !!regions);
    }
    // Default the phone's country from the address country the user chose in step 3.
    // "OTHER" / a country the phone widget doesn't recognize is left as-is.
    _syncPhoneCountryFromAddress() {
        if (!this._phoneIti) return;
        const cc = document.getElementById('onboardingCountry')?.value;
        if (cc && cc !== 'OTHER') this._phoneIti.setCountry(cc.toLowerCase());
    }
    // The Province / State value, reading whichever control is active for the country.
    _provinceValue() {
        const sel = document.getElementById('onboardingStateSelect');
        if (sel && !sel.classList.contains('hidden')) {
            // Empty value = placeholder still selected -> treat as no input (don't return the
            // placeholder label). Otherwise store the full region name (readable on receipts/
            // address); the tax lookup resolves the name back to a code.
            if (!sel.value) return '';
            return sel.selectedOptions[0]?.textContent.trim() ?? '';
        }
        return document.getElementById('onboardingProvince')?.value.trim() ?? '';
    }
    _focusCurrent() {
        const input = this._steps[this._current]?.querySelector('input, select');
        if (input) setTimeout(()=>input.focus(), 200);
    }
    _goTo(index, direction) {
        const outEl = this._steps[this._current];
        const inEl = this._steps[index];
        const outX = direction === 'forward' ? '-28px' : '28px';
        const inX = direction === 'forward' ? '28px' : '-28px';
        outEl.style.transition = 'opacity 160ms ease, transform 160ms ease';
        outEl.style.opacity = '0';
        outEl.style.transform = `translateX(${outX})`;
        setTimeout(()=>{
            outEl.classList.add('ob-step--hidden');
            outEl.style.cssText = '';
            inEl.style.opacity = '0';
            inEl.style.transform = `translateX(${inX})`;
            inEl.classList.remove('ob-step--hidden');
            requestAnimationFrame(()=>requestAnimationFrame(()=>{
                    inEl.style.transition = 'opacity 160ms ease, transform 160ms ease';
                    inEl.style.opacity = '1';
                    inEl.style.transform = 'translateX(0)';
                    setTimeout(()=>{
                        inEl.style.cssText = '';
                    }, 170);
                }));
            this._current = index;
            this._updateUI();
            this.clearError();
            this._focusCurrent();
            if (index === $e03adf9eaa390216$var$STEP_PLACE) this._syncPlaceTitle();
            if (index === $e03adf9eaa390216$var$STEP_FEATURES) this._renderFeatures();
            // Reaching the phone step: seed its country from the address country.
            if (index === $e03adf9eaa390216$var$STEP_PHONE) this._syncPhoneCountryFromAddress();
        }, 160);
    }
    _validate() {
        if (this._current === 0) {
            if (!document.getElementById('onboardingBizName')?.value.trim()) {
                this.showError('Please enter your business name.');
                return false;
            }
        }
        if (this._current === $e03adf9eaa390216$var$STEP_PLACE) {
            if (!this._place) {
                this.showError('Please pick the closest type of place.');
                return false;
            }
            if (this._place === 'other' && !document.getElementById('obOtherKind')?.value) {
                this.showError('Please pick what you sell.');
                return false;
            }
        }
        // Address comes before Phone so the phone's country can default from the
        // chosen address country.
        if (this._current === $e03adf9eaa390216$var$STEP_ADDRESS) {
            const street = document.getElementById('onboardingStreet')?.value.trim();
            const city = document.getElementById('onboardingCity')?.value.trim();
            const province = this._provinceValue();
            const zip = document.getElementById('onboardingZip')?.value.trim();
            const country = document.getElementById('onboardingCountry')?.value;
            if (!country) {
                this.showError('Please select your country.');
                return false;
            }
            if (!street) {
                this.showError('Please enter your street address.');
                return false;
            }
            if (!city) {
                this.showError('Please enter your city or municipality.');
                return false;
            }
            if (!province) {
                this.showError('Please enter your province or state.');
                return false;
            }
            if (!zip) {
                this.showError('Please enter your ZIP or postal code.');
                return false;
            }
        }
        if (this._current === $e03adf9eaa390216$var$STEP_PHONE) {
            const phone = this._phoneIti?.getNumber() ?? '';
            if (!phone) {
                this.showError('Please enter a phone number.');
                return false;
            }
            if (!this._phoneIti?.isValidNumber()) {
                this.showError('Please enter a valid phone number.');
                return false;
            }
        }
        return true;
    }
    _addHandlerExit(handler) {
        document.getElementById('onboardingExitLink')?.addEventListener('click', (e)=>{
            e.preventDefault();
            handler();
        });
    }
    _addHandlerSubmit(handler) {
        this._nextBtn.addEventListener('click', ()=>{
            this.clearError();
            if (!this._validate()) return;
            if (this._current < $e03adf9eaa390216$var$STEPS - 1) this._goTo(this._current + 1, 'forward');
            else (0, $05116e7677d717d1$export$277a10cf25fc7086)(this._nextBtn, ()=>handler({
                    businessName: document.getElementById('onboardingBizName')?.value.trim(),
                    // Food places keep business_type 'food_beverage' (the admin panel
                    // reads it) with the kind as the industry; others store what they sell.
                    businessType: this._place === 'other' ? document.getElementById('obOtherKind')?.value : 'food_beverage',
                    industry: this._place,
                    setup: this._result(),
                    phone: this._phoneIti?.getNumber() ?? '',
                    street: document.getElementById('onboardingStreet')?.value.trim(),
                    city: document.getElementById('onboardingCity')?.value.trim(),
                    province: this._provinceValue(),
                    zip: document.getElementById('onboardingZip')?.value.trim(),
                    country: document.getElementById('onboardingCountry')?.value
                })); // text/disable owned by the controller's setLoading(); guard adds re-entry protection
        });
        this._backBtn.addEventListener('click', ()=>{
            if (this._current > 0) this._goTo(this._current - 1, 'back');
        });
        document.getElementById('obPlaceGrid')?.addEventListener('click', (e)=>{
            const btn = e.target.closest('[data-place]');
            if (btn) this._pickPlace(btn.dataset.place);
        });
        document.getElementById('obOtherKind')?.addEventListener('change', ()=>this.clearError());
        // Checklist rows re-render on every change, so put focus back on the
        // control that was used.
        const features = document.getElementById('obFeatureList');
        features?.addEventListener('click', (e)=>{
            const row = e.target.closest('[data-feature]');
            const mode = e.target.closest('[data-table-mode]');
            let refocus;
            if (row) {
                this._setup[row.dataset.feature] = !this._setup[row.dataset.feature];
                refocus = `[data-feature="${row.dataset.feature}"]`;
            } else if (mode) {
                this._setup.tableMode = mode.dataset.tableMode;
                refocus = `[data-table-mode="${mode.dataset.tableMode}"]`;
            } else return;
            this._renderFeatures();
            features.querySelector(refocus)?.focus();
        });
        features?.addEventListener('change', (e)=>{
            const box = e.target.closest('[data-sub]');
            if (box) this._setup[box.dataset.sub] = box.checked;
        });
        // Country drives whether Province/State is a constrained US dropdown or free text.
        document.getElementById('onboardingCountry')?.addEventListener('change', (e)=>{
            this._syncStateField(e.target.value);
        });
        this._overlay.addEventListener('keydown', (e)=>{
            // Enter on a card or checklist row picks it (the button's own click), not Next.
            if (e.key === 'Enter' && e.target.closest('.ob-place-grid, .ob-feature-list')) return;
            if (e.key === 'Enter' && !document.getElementById('onboardingDone')?.classList.contains('hidden')) {
                e.preventDefault();
                document.getElementById('onboardingDoneBtn')?.click();
                return;
            }
            if (e.key === 'Enter' && !this._nextBtn.disabled) {
                e.preventDefault();
                this._nextBtn.click();
            }
        });
    }
    // --- Tax suggestion prompt (shown after onboarding when a rate is known) ---
    showTaxPrompt({ label: label, rate: rate }) {
        const overlay = document.getElementById('taxSuggestOverlay');
        const promptEl = document.getElementById('taxSuggestPrompt');
        if (!overlay || !promptEl) return;
        promptEl.textContent = `Add ${label} (${rate}%) to your receipts?`;
        overlay.classList.remove('hidden');
    }
    hideTaxPrompt() {
        document.getElementById('taxSuggestOverlay')?.classList.add('hidden');
    }
    setTaxLoading(bool) {
        const addBtn = document.getElementById('taxSuggestAddBtn');
        if (addBtn) {
            addBtn.disabled = bool;
            addBtn.textContent = bool ? "Adding\u2026" : 'Add to receipts';
        }
    }
    _addHandlerTaxPrompt(onAdd, onSkip) {
        document.getElementById('taxSuggestAddBtn')?.addEventListener('click', ()=>onAdd());
        document.getElementById('taxSuggestSkipBtn')?.addEventListener('click', ()=>onSkip());
    }
}
var $e03adf9eaa390216$export$2e2bcd8739ae039 = new $e03adf9eaa390216$var$OnboardingView();


// Which shortcuts the home Manage menu and the top-bar Screens menu show
// (2026-10-22, homeLayout.js), plus the Manage menu's Customize mode: an eye
// on each shortcut, Reset and Done. Hiding never turns a feature off; the
// shortcut just leaves the menu. Hidden items stay listed in Settings > Home
// screen. Catalogue and Help have no data-home-key, so they can't be hidden.
const $f850a85e1d95a80e$var$EYE_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg>';
const $f850a85e1d95a80e$var$EYE_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 3 18 18"/><path d="M10.6 5.1A10 10 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3 3.9"/><path d="M6.6 6.6A17 17 0 0 0 2 12s3.5 7 10 7a9.7 9.7 0 0 0 4.4-1"/></svg>';
class $f850a85e1d95a80e$var$HomeNavView {
    _nav = document.getElementById('homeSideNav');
    _list = document.getElementById('homeSideNavList');
    _box = document.getElementById('homeNavCustomize');
    _editing = false;
    _draft = null;
    _hidden = new Set();
    _tablesOn = false;
    constructor(){
        // One eye per hideable shortcut; CSS shows them only while customizing.
        this._list?.querySelectorAll('[data-home-key]').forEach((el)=>{
            const eye = document.createElement('span');
            eye.className = 'home-nav-eye';
            eye.setAttribute('aria-hidden', 'true');
            el.appendChild(eye);
        });
    }
    // hidden: keys left off the menus. tablesOn: table service isn't 'off'
    // (the Tables shortcut needs it no matter what the list says).
    apply({ hidden: hidden, tablesOn: tablesOn }) {
        this._hidden = new Set(hidden);
        this._tablesOn = tablesOn;
        if (this._editing) return this._paintEditing();
        document.querySelectorAll('[data-home-key]').forEach((el)=>{
            const key = el.dataset.homeKey;
            const off = this._hidden.has(key) || key === 'tables' && !tablesOn;
            el.classList.toggle('home-hidden', off);
        });
        this._syncScreensMenu();
    }
    // The Screens menu says so when every screen is hidden (the menu itself
    // stays, since tutorials point at it).
    _syncScreensMenu() {
        const menu = document.getElementById('displayDropdownMenu');
        if (!menu) return;
        let note = menu.querySelector('.nav-display-empty');
        const allHidden = [
            ...menu.querySelectorAll('[data-home-key]')
        ].every((el)=>el.classList.contains('home-hidden'));
        if (allHidden && !note) {
            note = document.createElement('p');
            note.className = 'nav-display-empty';
            note.textContent = 'All screens are hidden. Show them in Settings > Home screen.';
            menu.appendChild(note);
        }
        note?.classList.toggle('hidden', !allHidden);
    }
    _paintEditing() {
        this._list?.querySelectorAll('[data-home-key]').forEach((el)=>{
            const key = el.dataset.homeKey;
            if (key === 'tables' && !this._tablesOn) {
                el.classList.add('home-hidden');
                return;
            }
            const off = this._draft.has(key);
            el.classList.remove('home-hidden');
            el.classList.toggle('home-nav-item--off', off);
            el.setAttribute('aria-pressed', String(!off));
            const label = el.querySelector('.home-side-nav-label')?.textContent.trim() ?? '';
            if (el.dataset.origLabel == null) el.dataset.origLabel = el.getAttribute('aria-label') ?? '';
            el.setAttribute('aria-label', `${off ? 'Show' : 'Hide'} ${label}`);
            const eye = el.querySelector('.home-nav-eye');
            if (eye) eye.innerHTML = off ? $f850a85e1d95a80e$var$EYE_OFF : $f850a85e1d95a80e$var$EYE_ON;
        });
    }
    _setEditing(on) {
        this._editing = on;
        this._nav?.classList.toggle('home-side-nav--editing', on);
        if (on) this._nav?.classList.add('home-side-nav--open');
        this._box?.classList.toggle('home-nav-customize--editing', on);
        if (on) {
            this._draft = new Set(this._hidden);
            this._paintEditing();
        } else {
            this._list?.querySelectorAll('[data-home-key]').forEach((el)=>{
                el.classList.remove('home-nav-item--off');
                el.removeAttribute('aria-pressed');
                if (el.dataset.origLabel != null) {
                    el.setAttribute('aria-label', el.dataset.origLabel);
                    delete el.dataset.origLabel;
                }
            });
            this._draft = null;
            this.apply({
                hidden: [
                    ...this._hidden
                ],
                tablesOn: this._tablesOn
            });
        }
    }
    get editing() {
        return this._editing;
    }
    // onSave(hiddenKeys) fires on Done when something changed.
    _addHandlerCustomize(onSave) {
        document.getElementById('homeNavCustomizeBtn')?.addEventListener('click', ()=>this._setEditing(true));
        document.getElementById('homeNavResetBtn')?.addEventListener('click', ()=>{
            this._draft = new Set();
            this._paintEditing();
        });
        document.getElementById('homeNavDoneBtn')?.addEventListener('click', ()=>{
            const next = [
                ...this._draft
            ];
            const changed = next.length !== this._hidden.size || next.some((k)=>!this._hidden.has(k));
            if (changed) this._hidden = new Set(next);
            this._setEditing(false);
            if (changed) onSave(next);
        });
        // While customizing, a tap on a shortcut shows / hides it instead of
        // opening it. Capture phase, so the panels' own listeners never see it.
        this._list?.addEventListener('click', (e)=>{
            if (!this._editing) return;
            const item = e.target.closest('.home-side-nav-item');
            if (!item) return;
            e.preventDefault();
            e.stopPropagation();
            const key = item.dataset.homeKey;
            if (!key) return;
            if (this._draft.has(key)) this._draft.delete(key);
            else this._draft.add(key);
            this._paintEditing();
        }, true);
    }
}
var $f850a85e1d95a80e$export$2e2bcd8739ae039 = new $f850a85e1d95a80e$var$HomeNavView();



var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");


var $lDSCx = parcelRequire("lDSCx");
// Tables panel (2026-10-22, free on every plan). Same shell as Schedule
// (.ts-layout sidebar + drawer). Two modes, from Settings > Home screen:
//   numbers - a plain list of table names for the checkout picker
//   full    - live floor plan + open tabs, layout editor, reservations, waitlist
// Mockup: claude.ai/artifact/RHVFJ2SoqrkBqB91h32yJx. Positions are stored on a
// 1000 x 700 grid and drawn as percentages, so the floor scales to any screen.
const $ab39ca298e181461$var$W = 1000, $ab39ca298e181461$var$H = 700, $ab39ca298e181461$var$SNAP = 10;
const $ab39ca298e181461$var$WAIT_PARTY_SIZES = [
    1,
    2,
    3,
    4,
    5,
    6,
    8
];
const $ab39ca298e181461$var$SHAPES = {
    round: {
        label: 'Round',
        w: 90,
        h: 90,
        seats: 2
    },
    square: {
        label: 'Square',
        w: 110,
        h: 110,
        seats: 4
    },
    long: {
        label: 'Long',
        w: 220,
        h: 110,
        seats: 6
    },
    booth: {
        label: 'Booth',
        w: 150,
        h: 100,
        seats: 4
    },
    bar: {
        label: 'Bar seat',
        w: 50,
        h: 50,
        seats: 1
    }
};
const $ab39ca298e181461$var$STATUS = {
    free: 'Free',
    reserved: 'Reserved',
    seated: 'Seated',
    ordered: 'Ordered',
    bill: 'Wants bill',
    dirty: 'Clean up'
};
const $ab39ca298e181461$var$ICONS = {
    floor: '<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="3.5"/><rect x="3" y="14" width="7" height="7" rx="3.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>',
    reservations: '<path d="M8 2v4"/><path d="M16 2v4"/><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M3 10h18"/><path d="m9 16 2 2 4-4"/>',
    waitlist: '<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20a6.5 6.5 0 0 1 13 0"/><path d="M17 4.5a3.5 3.5 0 0 1 0 7"/><path d="M21.5 20a6.5 6.5 0 0 0-4-6"/>',
    layout: '<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/>',
    list: '<path d="M8 6h13"/><path d="M8 12h13"/><path d="M8 18h13"/><path d="M3 6h.01"/><path d="M3 12h.01"/><path d="M3 18h.01"/>'
};
const $ab39ca298e181461$var$svg = (d, s = 16)=>`<svg xmlns="http://www.w3.org/2000/svg" width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
const $ab39ca298e181461$var$clamp = (n, lo, hi)=>Math.max(lo, Math.min(hi, n));
const $ab39ca298e181461$var$snap = (n)=>Math.round(n / $ab39ca298e181461$var$SNAP) * $ab39ca298e181461$var$SNAP;
const $ab39ca298e181461$var$mins = (ms)=>Math.max(0, Math.floor(ms / 60000));
const $ab39ca298e181461$var$ago = (iso, now)=>{
    const m = $ab39ca298e181461$var$mins(now - new Date(iso).getTime());
    return m < 60 ? `${m}m` : `${Math.floor(m / 60)}h ${m % 60}m`;
};
// Times show in the BUSINESS's timezone (set from render data), so a device
// in another zone still reads the cafe's clock.
let $ab39ca298e181461$var$TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
const $ab39ca298e181461$var$clock = (d)=>{
    const { h: h, mi: m } = (0, $lDSCx.zonedParts)(new Date(d), $ab39ca298e181461$var$TZ);
    return `${h % 12 || 12}${m ? `:${String(m).padStart(2, '0')}` : ''}${h < 12 ? 'a' : 'p'}`;
};
// An hour of the cafe's day (0-23) as a label, for the timeline axis. Not clock(): that
// converts an instant to the business zone, and a device-local Date made from the hour
// would shift by the device's offset (axis 12p-6a on a Manila laptop, 2026-10-25).
const $ab39ca298e181461$var$hourLabel = (h)=>`${h % 12 || 12}${h % 24 < 12 ? 'a' : 'p'}`;
// Sunday = 0 for a "YYYY-MM-DD" business day (bookingRules.hours order).
const $ab39ca298e181461$var$sundayIndex = (dateStr)=>((0, $lDSCx.weekdayIndex)(dateStr) + 1) % 7;
const $ab39ca298e181461$var$seatsLabel = (n)=>`${n} ${n === 1 ? 'seat' : 'seats'}`;
const $ab39ca298e181461$export$49881d192203ad4a = (table, tab, reservations, now = Date.now())=>{
    if (tab) {
        if (tab.billRequestedAt) return 'bill';
        return tab.items.some((l)=>l.sentAt) ? 'ordered' : 'seated';
    }
    if (table.needsCleaning) return 'dirty';
    const soon = (reservations ?? []).find((r)=>r.tableId === table.id && r.status === 'booked' && new Date(r.startsAt).getTime() - now < 1800000 && now - new Date(r.startsAt).getTime() < 1800000);
    return soon ? 'reserved' : 'free';
};
const $ab39ca298e181461$var$unpaid = (tab)=>(tab?.items ?? []).filter((l)=>!l.paidSaleId);
const $ab39ca298e181461$var$lineTotal = (l)=>l.unitPrice * l.quantity;
const $ab39ca298e181461$var$tabTotal = (tab, lids = null)=>$ab39ca298e181461$var$unpaid(tab).filter((l)=>!lids || lids.has(l.lid)).reduce((s, l)=>s + $ab39ca298e181461$var$lineTotal(l), 0);
class $ab39ca298e181461$var$TablesView {
    _panel = document.querySelector('#tablesPanel');
    _sidebar = document.querySelector('#tablesSidebar');
    _content = document.querySelector('#tablesContent');
    _data = null;
    _handlers = {};
    _section = 'floor';
    _area = null;
    _selId = null;
    _split = null;
    _pick = null;
    _guests = 2;
    _draft = null;
    _removed = [];
    _removeArmed = null;
    _layoutSel = null;
    _addingArea = false;
    _resForm = null;
    _resSel = null;
    _waitForm = {
        name: '',
        partySize: 2,
        phone: '',
        note: '',
        quotedMin: null
    };
    open() {
        this._panel.classList.remove('hidden', 'cashflow-exiting');
    }
    close() {
        this._closeDrawer();
        this._panel.classList.add('cashflow-exiting');
        setTimeout(()=>{
            this._panel.classList.add('hidden');
            this._panel.classList.remove('cashflow-exiting');
        }, 220);
    }
    isOpen() {
        return !this._panel.classList.contains('hidden');
    }
    renderLoading() {
        this._content.innerHTML = '<div class="sch-loading"><span class="skel" style="height:44px;border-radius:14px"></span><span class="skel" style="height:420px;border-radius:18px"></span></div>';
    }
    get section() {
        return this._section;
    }
    get reservationDay() {
        return this._data?.day ?? (0, $lDSCx.todayIn)($ab39ca298e181461$var$TZ);
    }
    // data: { mode, tables, tabs, reservations, dayReservations, day, waitlist,
    //         waitlistOn, reservationsOn, canEditLayout, now }
    render(data) {
        this._data = data;
        if (data.tz) $ab39ca298e181461$var$TZ = data.tz;
        const sections = this._sections();
        if (!sections.some((s)=>s.id === this._section)) this._section = sections[0].id;
        this._renderSidebar(sections);
        const areas = this._areas();
        if (!areas.includes(this._area)) this._area = areas[0] ?? 'Inside';
        if (this._section === 'list') this._renderList();
        else if (this._section === 'layout') this._renderLayout();
        else if (this._section === 'reservations') this._renderReservations();
        else if (this._section === 'waitlist') this._renderWaitlist();
        else this._renderFloor();
    }
    // Lets the controller jump straight to a table (e.g. after paying its tab).
    // Keeps the floor on that table's area (seating a party in "Inside" must not
    // leave the floor showing "Patio").
    select(tableId) {
        this._selId = tableId;
        this._section = 'floor';
        const area = this._data?.tables.find((t)=>t.id === tableId)?.area;
        if (area) this._area = area;
    }
    // Open on a section (home cards' Open / Add a party). Unknown ids fall back in render.
    showSection(id) {
        this._section = id;
        this._split = null;
        this._pick = null;
    }
    bind(handlers) {
        this._handlers = handlers;
        document.addEventListener('click', (e)=>{
            if (e.target.closest("[data-action='tables']")) handlers.onOpen();
        });
        this._panel.querySelector('.tables-back')?.addEventListener('click', ()=>handlers.onClose());
        const btn = this._panel.querySelector('#tablesNavBtn');
        btn?.addEventListener('click', ()=>btn.getAttribute('aria-expanded') === 'true' ? this._closeDrawer() : this._openDrawer());
        this._panel.querySelector('#tablesNavBackdrop')?.addEventListener('click', ()=>this._closeDrawer());
        this._content.addEventListener('click', (e)=>this._onClick(e));
        this._content.addEventListener('change', (e)=>this._onChange(e));
        this._content.addEventListener('input', (e)=>this._onInput(e));
        this._content.addEventListener('pointerdown', (e)=>this._onPointerDown(e));
        this._content.addEventListener('keydown', (e)=>this._onKeyDown(e));
    }
    // ── Drawer + sidebar ─────────────────────────────────────────────────────────
    _openDrawer() {
        this._sidebar.classList.add('panel-sidebar--open');
        this._panel.querySelector('#tablesNavBackdrop')?.classList.add('panel-nav-backdrop--visible');
        this._panel.querySelector('#tablesNavBtn')?.setAttribute('aria-expanded', 'true');
    }
    _closeDrawer() {
        this._sidebar.classList.remove('panel-sidebar--open');
        this._panel.querySelector('#tablesNavBackdrop')?.classList.remove('panel-nav-backdrop--visible');
        this._panel.querySelector('#tablesNavBtn')?.setAttribute('aria-expanded', 'false');
    }
    _sections() {
        const d = this._data;
        if (d.mode !== 'full') return [
            {
                id: 'list',
                c: '#0FA267',
                label: 'Tables',
                desc: 'Names for the checkout picker'
            }
        ];
        const waiting = d.waitlist.filter((w)=>w.status === 'waiting').length;
        const today = d.reservations.filter((r)=>r.status !== 'cancelled').length;
        return [
            {
                id: 'floor',
                c: '#0FA267',
                label: 'Floor',
                desc: 'Live table status'
            },
            ...d.reservationsOn ? [
                {
                    id: 'reservations',
                    c: '#7C3AED',
                    label: 'Reservations',
                    desc: today ? `${today} today` : 'None today',
                    count: 0
                }
            ] : [],
            ...d.waitlistOn ? [
                {
                    id: 'waitlist',
                    c: '#EA580C',
                    label: 'Waitlist',
                    desc: waiting ? `${waiting} waiting` : 'Nobody waiting',
                    count: waiting
                }
            ] : [],
            ...d.canEditLayout ? [
                {
                    id: 'layout',
                    c: '#2563EB',
                    label: 'Edit layout',
                    desc: 'Tables, seats &amp; areas'
                }
            ] : []
        ];
    }
    _renderSidebar(sections) {
        this._sidebar.innerHTML = `<p class="ts-side-label">Sections</p>${sections.map((n)=>`
      <button class="pb-nav-item ts-tab${this._section === n.id ? ' ts-tab--active' : ''}" data-section="${n.id}" type="button" style="--nav-c:${n.c}">
        <span class="pb-nav-icon">${$ab39ca298e181461$var$svg($ab39ca298e181461$var$ICONS[n.id], 18)}</span>
        <span class="pb-nav-text"><span class="pb-nav-name">${n.label}</span><span class="pb-nav-desc">${n.desc}</span></span>
        ${n.count ? `<span class="sch-nav-count" aria-label="${n.count} waiting">${n.count}</span>` : ''}
      </button>`).join('')}`;
        this._sidebar.querySelectorAll('.ts-tab').forEach((b)=>b.addEventListener('click', ()=>{
                this._goSection(b.dataset.section);
                this._closeDrawer();
            }));
    }
    _goSection(id) {
        if (this._section === 'layout' && id !== 'layout') this._draft = null;
        this._section = id;
        this._split = null;
        this._pick = null;
        this._handlers.onSection?.(id);
        this.render(this._data);
    }
    _areas() {
        const src = this._section === 'layout' && this._draft ? this._draft : this._data.tables;
        const list = [
            ...new Set(src.map((t)=>t.area || 'Inside'))
        ];
        if (this._area && !list.includes(this._area) && this._section === 'layout') list.push(this._area);
        return list.length ? list : [
            'Inside'
        ];
    }
    _areaTabs(extra = '') {
        const areas = this._areas();
        if (areas.length < 2 && !extra) return '';
        return `<div class="tb-areas" role="tablist" aria-label="Area">${areas.map((a)=>`
      <button type="button" role="tab" aria-selected="${a === this._area}" class="tb-area${a === this._area ? ' tb-area--on' : ''}" data-area="${(0, $cnCXJ.esc)(a)}">${(0, $cnCXJ.esc)(a)}</button>`).join('')}${extra}</div>`;
    }
    // ── Floor ────────────────────────────────────────────────────────────────────
    _tabFor(tableId) {
        return this._data.tabs.find((t)=>t.tableId === tableId) ?? null;
    }
    _renderFloor() {
        const d = this._data;
        if (!d.tables.length) {
            this._content.innerHTML = `
        <div class="tb-empty">
          <span class="tb-empty-icon" aria-hidden="true">${$ab39ca298e181461$var$svg($ab39ca298e181461$var$ICONS.floor, 28)}</span>
          <h3>No tables yet</h3>
          <p>${d.canEditLayout ? 'Draw your floor once: drag tables in, name them, and you\'re set.' : 'Ask a manager to set up the floor plan.'}</p>
          ${d.canEditLayout ? '<button type="button" class="btn primary" data-go="layout">Set up tables</button>' : ''}
        </div>`;
            return;
        }
        const inArea = d.tables.filter((t)=>(t.area || 'Inside') === this._area);
        const statuses = d.tables.map((t)=>$ab39ca298e181461$export$49881d192203ad4a(t, this._tabFor(t.id), d.reservations, d.now));
        const count = (s)=>statuses.filter((x)=>x === s).length;
        const seated = count('seated') + count('ordered') + count('bill');
        const next = d.reservations.filter((r)=>r.status === 'booked' && new Date(r.startsAt).getTime() > d.now - 1800000)[0];
        const sel = d.tables.find((t)=>t.id === this._selId) ?? null;
        if (!sel) this._selId = null;
        this._content.innerHTML = `
      <div class="tb-floor">
        <div class="tb-bar">
          ${this._areaTabs()}
          <p class="tb-summary"><b>${seated}</b> seated \xb7 <b>${count('free')}</b> free${next ? ` \xb7 next booking <b>${$ab39ca298e181461$var$clock(next.startsAt)} ${(0, $cnCXJ.esc)(next.name)}, ${next.partySize}</b>` : ''}</p>
        </div>
        ${this._pick ? `<div class="tb-pick-note">${this._pick === 'move' ? 'Tap the table to move this tab to.' : 'Tap the table to join with this one.'} <button type="button" class="tb-link" data-pick-cancel="1">Cancel</button></div>` : ''}
        <div class="tb-floor-main">
          <div class="tb-canvas-wrap">
            <div class="tb-canvas" role="group" aria-label="Floor plan, ${(0, $cnCXJ.esc)(this._area)}">
              ${inArea.map((t)=>this._tableMarkup(t, $ab39ca298e181461$export$49881d192203ad4a(t, this._tabFor(t.id), d.reservations, d.now))).join('')}
            </div>
            <p class="tb-swipe-hint">Swipe sideways to see the whole floor.</p>
          </div>
          <aside class="tb-detail" aria-live="polite">${sel ? this._detailMarkup(sel) : this._detailEmpty()}</aside>
        </div>
        <div class="tb-legend">${Object.entries($ab39ca298e181461$var$STATUS).map(([k, v])=>`<span><i class="tb-dot tb-dot--${k}"></i>${v === 'Clean up' ? 'Needs cleaning' : v}</span>`).join('')}</div>
      </div>`;
    }
    _tableMarkup(t, status) {
        const tab = this._tabFor(t.id);
        const now = this._data.now;
        let meta = `${$ab39ca298e181461$var$seatsLabel(t.seats)}`;
        if (tab) meta = `${tab.guests} \xb7 ${$ab39ca298e181461$var$ago(tab.openedAt, now)}`;
        else if (status === 'reserved') {
            const r = this._data.reservations.find((x)=>x.tableId === t.id && x.status === 'booked');
            if (r) meta = `${$ab39ca298e181461$var$clock(r.startsAt)} \xb7 ${r.partySize}`;
        } else if (status === 'dirty') meta = 'Mark clean';
        const pos = `left:${t.x / $ab39ca298e181461$var$W * 100}%;top:${t.y / $ab39ca298e181461$var$H * 100}%;width:${t.w / $ab39ca298e181461$var$W * 100}%;height:${t.h / $ab39ca298e181461$var$H * 100}%`;
        const on = t.id === this._selId;
        return `
      <button type="button" class="tb-table tb-table--${status} tb-shape--${t.shape}${on ? ' tb-table--sel' : ''}" style="${pos}" data-table="${t.id}" aria-pressed="${on}" aria-label="Table ${(0, $cnCXJ.esc)(t.name)}, ${$ab39ca298e181461$var$STATUS[status]}">
        <b class="tb-table-name">${(0, $cnCXJ.esc)(t.name)}</b>
        <span class="tb-table-status">${$ab39ca298e181461$var$STATUS[status]}</span>
        <span class="tb-table-meta">${(0, $cnCXJ.esc)(meta)}</span>
      </button>`;
    }
    _detailEmpty() {
        return `<div class="tb-detail-empty">${$ab39ca298e181461$var$svg($ab39ca298e181461$var$ICONS.floor, 26)}<p>Tap a table to seat guests, add items or take payment.</p></div>`;
    }
    _detailMarkup(t) {
        const d = this._data;
        const tab = this._tabFor(t.id);
        const status = $ab39ca298e181461$export$49881d192203ad4a(t, tab, d.reservations, d.now);
        const head = `
      <div class="tb-detail-head">
        <h3>Table ${(0, $cnCXJ.esc)(t.name)}</h3>
        <span class="tb-pill tb-pill--${status}">${$ab39ca298e181461$var$STATUS[status]}</span>
        <span class="tb-detail-seats">${$ab39ca298e181461$var$seatsLabel(t.seats)}</span>
      </div>`;
        if (tab) return head + this._tabMarkup(t, tab);
        if (status === 'dirty') return `${head}<p class="tb-detail-text">The last party paid. Mark it clean when it's wiped down and it goes back to Free.</p>
        <button type="button" class="tb-btn tb-btn--pri" data-clean="${t.id}">Mark clean</button>`;
        const res = d.reservations.find((r)=>r.tableId === t.id && r.status === 'booked' && new Date(r.startsAt).getTime() > d.now - 1800000);
        const resCard = res ? `
      <div class="tb-res-card">
        <b>${(0, $cnCXJ.esc)(res.name)} \xb7 party of ${res.partySize}</b>
        <span>Booked for ${$ab39ca298e181461$var$clock(res.startsAt)}${res.note ? ` \xb7 ${(0, $cnCXJ.esc)(res.note)}` : ''}</span>
      </div>` : '';
        const waiting = d.waitlistOn ? d.waitlist.filter((w)=>w.status === 'waiting') : [];
        return `${head}
      ${status === 'reserved' ? `${resCard}
        <button type="button" class="tb-btn tb-btn--pri" data-seat-res="${res.id}">They're here: seat ${(0, $cnCXJ.esc)(res.name)}</button>
        <p class="tb-detail-text">Or seat a walk-in for now:</p>` : `<p class="tb-detail-text">Ready for guests.${res ? ` Booked at ${$ab39ca298e181461$var$clock(res.startsAt)} for ${(0, $cnCXJ.esc)(res.name)}.` : ''}</p>`}
      <div class="tb-guests">
        <span>Guests</span>
        <button type="button" class="tb-step" data-guests="-1" aria-label="Fewer guests">\u{2212}</button>
        <b>${this._guests}</b>
        <button type="button" class="tb-step" data-guests="1" aria-label="More guests">+</button>
      </div>
      <button type="button" class="tb-btn ${status === 'reserved' ? '' : 'tb-btn--pri'}" data-seat="${t.id}">Seat walk-in</button>
      ${waiting.length ? `
        <div class="tb-sub-title">From the waitlist</div>
        <div class="tb-wait-picks">${waiting.slice(0, 4).map((w)=>`
          <button type="button" class="tb-wait-pick" data-seat-wait="${w.id}">
            <b>${(0, $cnCXJ.esc)(w.name)}</b><span>${w.partySize} \xb7 waited ${$ab39ca298e181461$var$ago(w.addedAt, d.now)}</span>
          </button>`).join('')}</div>` : ''}`;
    }
    _tabMarkup(t, tab) {
        const d = this._data;
        const lines = tab.items;
        const open = $ab39ca298e181461$var$unpaid(tab);
        const unsent = open.filter((l)=>!l.sentAt);
        const split = this._split;
        const total = $ab39ca298e181461$var$tabTotal(tab);
        const splitTotal = split ? $ab39ca298e181461$var$tabTotal(tab, split) : 0;
        const rows = lines.map((l)=>{
            const tag = l.paidSaleId ? [
                'Paid',
                'paid'
            ] : l.sentAt ? [
                'Sent',
                'sent'
            ] : [
                'Not sent',
                'new'
            ];
            const variants = l.selectedVariants.map((v)=>v.variantName).filter(Boolean).join(', ');
            const pickable = split && !l.paidSaleId;
            return `
        <li class="tb-line${l.paidSaleId ? ' tb-line--paid' : ''}">
          ${pickable ? `<input type="checkbox" class="tb-line-pick" data-split-line="${l.lid}"${split.has(l.lid) ? ' checked' : ''} aria-label="Pay ${(0, $cnCXJ.esc)(l.itemName)}">` : ''}
          <b class="tb-line-qty">${l.quantity}\xd7</b>
          <span class="tb-line-name">${(0, $cnCXJ.esc)(l.itemName)}${variants ? `<small>${(0, $cnCXJ.esc)(variants)}</small>` : ''}${l.note ? `<small>${(0, $cnCXJ.esc)(l.note)}</small>` : ''}</span>
          <span class="tb-tag tb-tag--${tag[1]}">${tag[0]}</span>
          <span class="tb-line-price">${(0, $coRoT.formatMoney)($ab39ca298e181461$var$lineTotal(l))}</span>
          ${!l.sentAt && !l.paidSaleId && !split ? `<button type="button" class="tb-line-x" data-remove-line="${l.lid}" aria-label="Remove ${(0, $cnCXJ.esc)(l.itemName)}">\xd7</button>` : ''}
        </li>`;
        }).join('');
        if (this._pick) return `<p class="tb-detail-text">${this._pick === 'move' ? `Pick a free table to move Table ${(0, $cnCXJ.esc)(t.name)}'s tab to.` : `Pick another seated table. Its tab joins this one.`}</p>
        <button type="button" class="tb-btn" data-pick-cancel="1">Cancel</button>`;
        return `
      <div class="tb-stats">
        <div><span>Guests</span><b class="tb-stat-guests"><button type="button" class="tb-step tb-step--sm" data-tab-guests="-1" aria-label="Fewer guests">\u{2212}</button>${tab.guests}<button type="button" class="tb-step tb-step--sm" data-tab-guests="1" aria-label="More guests">+</button></b></div>
        <div><span>Seated</span><b>${$ab39ca298e181461$var$ago(tab.openedAt, d.now)}</b></div>
        <div><span>Server</span><b>${(0, $cnCXJ.esc)(tab.serverName || '-')}</b></div>
      </div>
      <div class="tb-sub-title">${split ? 'Pick what this guest pays for' : 'Open tab'}</div>
      ${lines.length ? `<ul class="tb-lines">${rows}</ul>` : '<p class="tb-detail-text">Nothing ordered yet.</p>'}
      ${split ? `
        <div class="tb-total"><span>Selected</span><b>${(0, $coRoT.formatMoney)(splitTotal)}</b></div>
        <button type="button" class="tb-btn tb-btn--pri" data-pay-split="1"${split.size ? '' : ' disabled'}>Pay ${(0, $coRoT.formatMoney)(splitTotal)}</button>
        <button type="button" class="tb-btn" data-split-cancel="1">Cancel split</button>` : `
        <div class="tb-total"><span>${open.length < lines.length ? 'Still to pay' : 'Tab so far'}</span><b>${(0, $coRoT.formatMoney)(total)}</b></div>
        <div class="tb-row">
          <button type="button" class="tb-btn" data-add-items="${tab.id}">Add items</button>
          ${unsent.length ? `<button type="button" class="tb-btn tb-btn--send" data-send="${tab.id}">Send ${unsent.length} to kitchen</button>` : `<button type="button" class="tb-btn" data-bill="${tab.billRequestedAt ? 'off' : 'on'}">${tab.billRequestedAt ? 'Not ready to pay' : 'Wants the bill'}</button>`}
        </div>
        ${open.length ? `<button type="button" class="tb-btn tb-btn--pri" data-pay="${tab.id}">Pay ${(0, $coRoT.formatMoney)(total)}</button>` : ''}
        <div class="tb-links">
          <button type="button" class="tb-link" data-pick="move">Move table</button>
          <button type="button" class="tb-link" data-pick="join">Join tables</button>
          ${open.length > 1 ? '<button type="button" class="tb-link" data-split="1">Split bill</button>' : ''}
          <button type="button" class="tb-link tb-link--muted" data-close-tab="${tab.id}">Close tab</button>
        </div>`}`;
    }
    // ── Table list (Table numbers mode) ──────────────────────────────────────────
    _renderList() {
        if (!this._draft) {
            this._draft = this._data.tables.map((t)=>({
                    ...t
                }));
            this._removed = [];
        }
        const can = this._data.canEditLayout;
        this._content.innerHTML = `
      <div class="tb-list">
        <div class="tb-list-head">
          <div>
            <h3>Your tables</h3>
            <p>Checkout shows these so staff know where to bring each order. Want a floor plan and open tabs? Pick Full service in Settings &gt; Home screen.</p>
          </div>
        </div>
        <div class="tb-list-rows">
          ${this._draft.map((t, i)=>`
            <div class="tb-list-row">
              <label class="tb-field"><span>Name</span><input type="text" maxlength="12" value="${(0, $cnCXJ.esc)(t.name)}" data-list-name="${i}"${can ? '' : ' disabled'} /></label>
              <label class="tb-field tb-field--sm"><span>Seats</span><input type="number" min="1" max="40" value="${t.seats}" data-list-seats="${i}"${can ? '' : ' disabled'} /></label>
              ${can ? `<button type="button" class="tb-icon-btn" data-list-remove="${i}" aria-label="Remove table ${(0, $cnCXJ.esc)(t.name)}">\xd7</button>` : ''}
            </div>`).join('') || '<p class="tb-detail-text">No tables yet.</p>'}
        </div>
        ${can ? `
          <div class="tb-list-actions">
            <button type="button" class="tb-btn" data-list-add="1">+ Add table</button>
            <button type="button" class="tb-btn" data-list-add="10">+ Add 1 to 10</button>
            <span class="tb-spacer"></span>
            <button type="button" class="tb-btn tb-btn--pri" data-list-save="1">Save tables</button>
          </div>` : '<p class="tb-detail-text">Ask a manager to change the list.</p>'}
      </div>`;
    }
    // Next free spot on the grid for a new table (left to right, top to bottom).
    _freeSpot(w, h, area) {
        const taken = (this._draft ?? []).filter((t)=>(t.area || 'Inside') === area);
        for(let y = 30; y + h <= $ab39ca298e181461$var$H; y += 20)for(let x = 30; x + w <= $ab39ca298e181461$var$W; x += 20){
            if (!taken.some((t)=>x < t.x + t.w + 20 && x + w + 20 > t.x && y < t.y + t.h + 20 && y + h + 20 > t.y)) return {
                x: x,
                y: y
            };
        }
        return {
            x: 30,
            y: 30
        };
    }
    // A name no other table uses. With a source name ("T4", "Patio 2") the
    // copy counts on from its number ("T5"); otherwise the next plain number.
    _nextName(from = null) {
        const taken = new Set((this._draft ?? []).map((t)=>String(t.name).trim().toLowerCase()));
        const m = from && /^(.*?)(\d+)$/.exec(String(from).trim());
        if (m) for(let n = Number(m[2]) + 1; n < 1000; n++){
            const name = `${m[1]}${n}`.slice(0, 12);
            if (!taken.has(name.toLowerCase())) return name;
        }
        else if (from) for(let n = 2; n < 1000; n++){
            const name = `${String(from).trim().slice(0, 9)} ${n}`;
            if (!taken.has(name.toLowerCase())) return name;
        }
        const nums = (this._draft ?? []).map((t)=>parseInt(t.name, 10)).filter(Number.isFinite);
        let n = (nums.length ? Math.max(...nums) : 0) + 1;
        while(taken.has(String(n)))n++;
        return String(n);
    }
    _newTable(shape, area = this._area || 'Inside') {
        const s = $ab39ca298e181461$var$SHAPES[shape] ?? $ab39ca298e181461$var$SHAPES.square;
        const spot = this._freeSpot(s.w, s.h, area);
        return {
            id: null,
            name: this._nextName(),
            seats: s.seats,
            shape: shape,
            area: area,
            x: spot.x,
            y: spot.y,
            w: s.w,
            h: s.h,
            canReserve: true
        };
    }
    // ── Layout editor ────────────────────────────────────────────────────────────
    _renderLayout() {
        if (!this._draft) {
            this._draft = this._data.tables.map((t)=>({
                    ...t
                }));
            this._removed = [];
            this._layoutSel = null;
        }
        const inArea = this._draft.map((t, i)=>[
                t,
                i
            ]).filter(([t])=>(t.area || 'Inside') === this._area);
        const sel = this._layoutSel != null ? this._draft[this._layoutSel] : null;
        const seats = this._draft.reduce((s, t)=>s + Number(t.seats || 0), 0);
        this._content.innerHTML = `
      <div class="tb-layout">
        <div class="tb-bar">
          ${this._areaTabs(this._addingArea ? '<span class="tb-area-new"><input type="text" id="tbNewArea" maxlength="30" placeholder="Patio, Upstairs\u2026" aria-label="New area name" /><button type="button" class="tb-area" data-area-ok="1">Add</button><button type="button" class="tb-area" data-area-cancel="1" aria-label="Cancel">\xd7</button></span>' : '<button type="button" class="tb-area tb-area--add" data-area-add="1">+ Area</button>')}
          <p class="tb-summary">${this._draft.length} tables \xb7 ${seats} seats</p>
          <span class="tb-spacer"></span>
          <button type="button" class="tb-btn" data-layout-cancel="1">Cancel</button>
          <button type="button" class="tb-btn tb-btn--pri" data-layout-save="1">Save layout</button>
        </div>
        <div class="tb-layout-main">
          <div class="tb-palette">
            <p class="tb-sub-title">Add a table</p>
            <div class="tb-palette-grid">${Object.entries($ab39ca298e181461$var$SHAPES).map(([k, s])=>`
              <button type="button" class="tb-palette-item" data-add-shape="${k}">
                <i class="tb-palette-shape tb-palette-shape--${k}" aria-hidden="true"></i><span>${s.label}${k === 'bar' ? '' : ` ${s.seats}`}</span>
              </button>`).join('')}</div>
            <p class="tb-detail-text">Drag tables to move them. Drag the corner to resize. Arrow keys nudge the selected table. Open tabs are never affected.</p>
          </div>
          <div class="tb-canvas-wrap">
            <div class="tb-canvas tb-canvas--edit" id="tbEditCanvas" aria-label="Floor layout, ${(0, $cnCXJ.esc)(this._area)}">
              ${inArea.map(([t, i])=>`
                <div class="tb-table tb-table--edit tb-shape--${t.shape}${i === this._layoutSel ? ' tb-table--sel' : ''}" style="left:${t.x / $ab39ca298e181461$var$W * 100}%;top:${t.y / $ab39ca298e181461$var$H * 100}%;width:${t.w / $ab39ca298e181461$var$W * 100}%;height:${t.h / $ab39ca298e181461$var$H * 100}%" data-edit="${i}" tabindex="0" role="button" aria-label="Table ${(0, $cnCXJ.esc)(t.name)}, ${$ab39ca298e181461$var$seatsLabel(t.seats)}. Arrow keys move it.">
                  <b class="tb-table-name">${(0, $cnCXJ.esc)(t.name)}</b><span class="tb-table-meta">${$ab39ca298e181461$var$seatsLabel(t.seats)}</span>
                  ${i === this._layoutSel ? '<span class="tb-resize" data-resize="1" aria-hidden="true"></span>' : ''}
                </div>`).join('')}
              ${inArea.length ? '' : '<p class="tb-canvas-empty">Tap a table on the left to add it here.</p>'}
            </div>
            <p class="tb-swipe-hint">Swipe sideways to see the whole floor. Drag a table to move it.</p>
          </div>
          <aside class="tb-props">${sel ? this._propsMarkup(sel) : '<div class="tb-detail-empty"><p>Select a table to name it and set its seats.</p></div>'}</aside>
        </div>
      </div>`;
    }
    _propsMarkup(t) {
        const areas = this._areas();
        return `
      <h3 class="tb-props-title">Table ${(0, $cnCXJ.esc)(t.name)}</h3>
      <label class="tb-field"><span>Name or number</span><input type="text" maxlength="12" value="${(0, $cnCXJ.esc)(t.name)}" data-prop="name" /></label>
      <div class="tb-field"><span>Seats</span>
        <div class="tb-guests tb-guests--prop">
          <button type="button" class="tb-step" data-prop-seats="-1" aria-label="Fewer seats">\u{2212}</button>
          <b>${t.seats}</b>
          <button type="button" class="tb-step" data-prop-seats="1" aria-label="More seats">+</button>
        </div>
      </div>
      <div class="tb-field"><span>Shape</span>
        <div class="tb-seg" role="radiogroup" aria-label="Shape">${[
            'round',
            'square',
            'long',
            'booth',
            'bar'
        ].map((k)=>`
          <button type="button" class="tb-seg-btn${t.shape === k ? ' tb-seg-btn--on' : ''}" role="radio" aria-checked="${t.shape === k}" data-prop-shape="${k}">${$ab39ca298e181461$var$SHAPES[k].label}</button>`).join('')}</div>
      </div>
      <label class="tb-field"><span>Area</span>
        <select data-prop="area">${areas.map((a)=>`<option${a === t.area ? ' selected' : ''}>${(0, $cnCXJ.esc)(a)}</option>`).join('')}</select>
      </label>
      <label class="tb-check"><input type="checkbox" data-prop="canReserve"${t.canReserve !== false ? ' checked' : ''} /> Can take reservations</label>
      <span class="tb-spacer"></span>
      <button type="button" class="tb-btn" data-prop-dup="1">Duplicate</button>
      ${this._removeArmed === t ? `<button type="button" class="tb-btn tb-btn--danger tb-btn--armed" data-prop-remove="1">Tap again to remove ${(0, $cnCXJ.esc)(t.name)}</button>` : '<button type="button" class="tb-btn tb-btn--danger" data-prop-remove="1">Remove table</button>'}`;
    }
    // Moves / resizes a table on the edit canvas without re-rendering.
    _onPointerDown(e) {
        if (this._section !== 'layout') return;
        const el = e.target.closest('[data-edit]');
        if (!el || e.button > 0) return;
        const i = Number(el.dataset.edit);
        const resizing = !!e.target.closest('[data-resize]');
        if (this._layoutSel !== i) {
            this._layoutSel = i;
            this._renderLayout();
            const again = this._content.querySelector(`[data-edit="${i}"]`);
            if (!again) return;
            return this._startDrag(e, again, i, false);
        }
        this._startDrag(e, el, i, resizing);
    }
    _startDrag(e, el, i, resizing) {
        const canvas = this._content.querySelector('#tbEditCanvas');
        if (!canvas) return;
        e.preventDefault();
        const rect = canvas.getBoundingClientRect();
        const k = $ab39ca298e181461$var$W / rect.width;
        const t = this._draft[i];
        const start = {
            px: e.clientX,
            py: e.clientY,
            x: t.x,
            y: t.y,
            w: t.w,
            h: t.h
        };
        let moved = false;
        const move = (ev)=>{
            const dx = (ev.clientX - start.px) * k, dy = (ev.clientY - start.py) * k;
            if (Math.abs(dx) + Math.abs(dy) > 3) moved = true;
            if (resizing) {
                t.w = $ab39ca298e181461$var$clamp($ab39ca298e181461$var$snap(start.w + dx), 40, $ab39ca298e181461$var$W - t.x);
                t.h = $ab39ca298e181461$var$clamp($ab39ca298e181461$var$snap(start.h + dy), 40, $ab39ca298e181461$var$H - t.y);
            } else {
                t.x = $ab39ca298e181461$var$clamp($ab39ca298e181461$var$snap(start.x + dx), 0, $ab39ca298e181461$var$W - t.w);
                t.y = $ab39ca298e181461$var$clamp($ab39ca298e181461$var$snap(start.y + dy), 0, $ab39ca298e181461$var$H - t.h);
            }
            el.style.left = `${t.x / $ab39ca298e181461$var$W * 100}%`;
            el.style.top = `${t.y / $ab39ca298e181461$var$H * 100}%`;
            el.style.width = `${t.w / $ab39ca298e181461$var$W * 100}%`;
            el.style.height = `${t.h / $ab39ca298e181461$var$H * 100}%`;
        };
        const up = ()=>{
            window.removeEventListener('pointermove', move);
            window.removeEventListener('pointerup', up);
            if (moved) this._content.querySelector(`[data-edit="${i}"]`)?.focus();
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
    }
    // A new area exists once a table is put in it (areas are just table labels).
    _addArea() {
        const name = (this._content.querySelector('#tbNewArea')?.value ?? '').trim().slice(0, 30);
        this._addingArea = false;
        if (name) {
            this._area = name;
            this._layoutSel = null;
        }
        this._rerender();
    }
    _onKeyDown(e) {
        if (e.target.id === 'tbNewArea') {
            if (e.key === 'Enter') {
                e.preventDefault();
                this._addArea();
            }
            if (e.key === 'Escape') {
                this._addingArea = false;
                this._rerender();
            }
            return;
        }
        if (this._section !== 'layout') return;
        const el = e.target.closest('[data-edit]');
        if (!el) return;
        const i = Number(el.dataset.edit);
        const t = this._draft[i];
        const step = e.shiftKey ? 50 : $ab39ca298e181461$var$SNAP;
        const moves = {
            ArrowLeft: [
                -step,
                0
            ],
            ArrowRight: [
                step,
                0
            ],
            ArrowUp: [
                0,
                -step
            ],
            ArrowDown: [
                0,
                step
            ]
        };
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this._layoutSel = i;
            this._renderLayout();
            this._content.querySelector(`[data-edit="${i}"]`)?.focus();
            return;
        }
        if (!moves[e.key]) return;
        e.preventDefault();
        t.x = $ab39ca298e181461$var$clamp(t.x + moves[e.key][0], 0, $ab39ca298e181461$var$W - t.w);
        t.y = $ab39ca298e181461$var$clamp(t.y + moves[e.key][1], 0, $ab39ca298e181461$var$H - t.h);
        this._layoutSel = i;
        this._renderLayout();
        this._content.querySelector(`[data-edit="${i}"]`)?.focus();
    }
    // ── Reservations ─────────────────────────────────────────────────────────────
    _renderReservations() {
        const d = this._data;
        const day = d.day;
        const isToday = day === (0, $lDSCx.todayIn)($ab39ca298e181461$var$TZ);
        const list = d.dayReservations;
        const booked = list.filter((r)=>r.status !== 'cancelled');
        const guests = booked.reduce((s, r)=>s + r.partySize, 0);
        // Timeline covers the day's booking hours (plus one hold after the last
        // start) and any booking outside them; 11a-10p on a day with no bookings.
        const bh = d.bookingRules.hours[$ab39ca298e181461$var$sundayIndex(day)];
        const baseFrom = bh.on ? Math.floor((0, $3c9e88a543a9da6a$export$4a79f0068700788b)(bh.from) / 60) : 11;
        const baseTo = bh.on ? Math.min(24, Math.ceil(((0, $3c9e88a543a9da6a$export$4a79f0068700788b)(bh.to) + d.bookingRules.holdMin) / 60)) : 22;
        const hours = booked.map((r)=>(0, $lDSCx.zonedParts)(new Date(r.startsAt), $ab39ca298e181461$var$TZ).h);
        const from = Math.min(baseFrom, ...hours);
        const to = Math.max(baseTo, from + 4, ...hours.map((h)=>Math.min(24, h + 2)));
        const span = to - from;
        const start = (0, $lDSCx.zonedToDate)(day, `${String(from).padStart(2, '0')}:00`, $ab39ca298e181461$var$TZ);
        const pct = (iso)=>$ab39ca298e181461$var$clamp((new Date(iso).getTime() - start.getTime()) / (span * 3600000) * 100, 0, 100);
        const rows = d.tables.filter((t)=>t.canReserve !== false);
        const sel = list.find((r)=>r.id === this._resSel) ?? null;
        const nowPct = isToday ? pct(new Date().toISOString()) : null;
        const [ly, lm, ld] = day.split('-').map(Number);
        const label = new Date(ly, lm - 1, ld).toLocaleDateString(undefined, {
            weekday: 'short',
            month: 'short',
            day: 'numeric'
        });
        this._content.innerHTML = `
      <div class="tb-res">
        <div class="tb-bar">
          <div class="tb-day">
            <button type="button" class="tb-step" data-day="-1" aria-label="Previous day">\u{2039}</button>
            <b>${isToday ? 'Today, ' : ''}${(0, $cnCXJ.esc)(label)}</b>
            <button type="button" class="tb-step" data-day="1" aria-label="Next day">\u{203A}</button>
          </div>
          ${isToday ? '' : '<button type="button" class="tb-link" data-day="0">Today</button>'}
          <p class="tb-summary"><b>${booked.length}</b> ${booked.length === 1 ? 'booking' : 'bookings'} \xb7 <b>${guests}</b> ${guests === 1 ? 'guest' : 'guests'}</p>
        </div>
        <div class="tb-res-main">
          <div class="tb-timeline" role="table" aria-label="Bookings by table">
            <div class="tb-tl-head" role="row"><span role="columnheader">Table</span><div class="tb-tl-hours">${Array.from({
            length: span
        }, (_, i)=>`<span>${$ab39ca298e181461$var$hourLabel(from + i)}</span>`).join('')}</div></div>
            ${rows.map((t)=>`
              <div class="tb-tl-row" role="row">
                <span class="tb-tl-name" role="rowheader"><b>${(0, $cnCXJ.esc)(t.name)}</b><small>${$ab39ca298e181461$var$seatsLabel(t.seats)}</small></span>
                <div class="tb-tl-track" style="--hours:${span}">
                  ${nowPct != null ? `<i class="tb-tl-now" style="left:${nowPct}%"></i>` : ''}
                  ${booked.filter((r)=>r.tableId === t.id).map((r)=>{
                const end = new Date(new Date(r.startsAt).getTime() + r.durationMin * 60000).toISOString();
                return `<button type="button" class="tb-tl-block tb-tl-block--${r.status}${r.id === this._resSel ? ' tb-tl-block--sel' : ''}" style="left:${pct(r.startsAt)}%;width:${Math.max(2, pct(end) - pct(r.startsAt))}%" data-res="${r.id}"><b>${(0, $cnCXJ.esc)(r.name)} \xb7 ${r.partySize}</b><span>${$ab39ca298e181461$var$clock(r.startsAt)}</span></button>`;
            }).join('')}
                </div>
              </div>`).join('')}
            ${booked.some((r)=>!r.tableId) ? `
              <div class="tb-tl-row" role="row">
                <span class="tb-tl-name" role="rowheader"><b>No table</b></span>
                <div class="tb-tl-track tb-tl-track--list">${booked.filter((r)=>!r.tableId).map((r)=>`<button type="button" class="tb-tl-chip${r.id === this._resSel ? ' tb-tl-block--sel' : ''}" data-res="${r.id}">${$ab39ca298e181461$var$clock(r.startsAt)} ${(0, $cnCXJ.esc)(r.name)} \xb7 ${r.partySize}</button>`).join('')}</div>
              </div>` : ''}
            ${rows.length ? '' : '<p class="tb-detail-text">Add tables in Edit layout to book them.</p>'}
          </div>
          <aside class="tb-detail">${sel ? this._resDetail(sel) : this._resFormMarkup()}</aside>
        </div>
      </div>`;
    }
    _resDetail(r) {
        const t = this._data.tables.find((x)=>x.id === r.tableId);
        const end = new Date(new Date(r.startsAt).getTime() + r.durationMin * 60000);
        const statusText = {
            booked: 'Booked',
            seated: 'Seated',
            cancelled: 'Cancelled',
            no_show: 'No-show'
        }[r.status];
        return `
      <div class="tb-detail-head"><h3>${(0, $cnCXJ.esc)(r.name)}</h3><span class="tb-pill tb-pill--${r.status === 'booked' ? 'reserved' : r.status === 'seated' ? 'seated' : 'free'}">${statusText}</span></div>
      <div class="tb-res-card">
        <b>Party of ${r.partySize} \xb7 ${$ab39ca298e181461$var$clock(r.startsAt)} to ${$ab39ca298e181461$var$clock(end)}</b>
        <span>${t ? `Table ${(0, $cnCXJ.esc)(t.name)}` : 'No table yet'}${r.phone ? ` \xb7 ${(0, $cnCXJ.esc)(r.phone)}` : ''}</span>
        ${r.note ? `<span>${(0, $cnCXJ.esc)(r.note)}</span>` : ''}
      </div>
      ${r.status === 'booked' ? `
        ${t ? `<button type="button" class="tb-btn tb-btn--pri" data-seat-res="${r.id}">They're here: seat at ${(0, $cnCXJ.esc)(t.name)}</button>` : ''}
        <button type="button" class="tb-btn" data-res-status="no_show" data-res-id="${r.id}">Mark no-show</button>
        <button type="button" class="tb-btn tb-btn--danger" data-res-status="cancelled" data-res-id="${r.id}">Cancel booking</button>` : ''}
      <button type="button" class="tb-link" data-res-new="1">+ New reservation</button>`;
    }
    _resFormMarkup() {
        const d = this._data;
        const rules = d.bookingRules;
        const f = this._resForm ?? (this._resForm = {
            name: '',
            phone: '',
            partySize: 2,
            partyOther: false,
            time: null,
            timeOther: false,
            durationMin: null,
            tableId: null,
            note: ''
        });
        const hold = this._holdMin();
        const slots = this._slots();
        // A typed one-off time stays as typed; otherwise snap to the first open slot.
        if (!f.timeOther && (!f.time || !slots.some((s)=>s.value === f.time && !s.full))) f.time = slots.find((s)=>!s.full)?.value ?? null;
        const fit = this._fitTable(f.partySize, f.time, hold);
        // A picked table that no longer fits (booked then, or too small) drops
        // back to Pick for me - and says so, instead of switching quietly.
        let switched = null;
        const picked = f.tableId && d.tables.find((x)=>x.id === f.tableId);
        if (picked && (!this._tableFree(f.tableId, f.time, hold) || picked.seats < f.partySize)) {
            switched = `${picked.name} ${picked.seats < f.partySize ? `only seats ${picked.seats}` : 'is booked then'}`;
            f.tableId = null;
        }
        const reservable = d.tables.filter((x)=>x.canReserve !== false);
        const biggest = Math.max(0, ...reservable.map((x)=>x.seats));
        const tableId = f.tableId ?? fit?.id ?? null;
        const t = d.tables.find((x)=>x.id === tableId);
        const dayName = (0, $3c9e88a543a9da6a$export$32c1f2e7a501558d)[$ab39ca298e181461$var$sundayIndex(d.day)];
        const closed = !rules.hours[$ab39ca298e181461$var$sundayIndex(d.day)].on;
        const partyOther = f.partyOther || !(0, $3c9e88a543a9da6a$export$7d3dcc20d590cb17).includes(f.partySize);
        const usual = (0, $3c9e88a543a9da6a$export$505ac917808ea098)(rules, f.partySize);
        return `
      <h3 class="tb-props-title">New reservation</h3>
      <div class="tb-form-2">
        <label class="tb-field"><span>Name</span><input type="text" maxlength="60" value="${(0, $cnCXJ.esc)(f.name)}" data-res-f="name" autocomplete="off" /></label>
        <label class="tb-field"><span>Phone</span><input type="tel" maxlength="30" value="${(0, $cnCXJ.esc)(f.phone)}" data-res-f="phone" autocomplete="off" /></label>
      </div>
      <div class="tb-field"><span>Party size</span>
        <div class="tb-chips">
          ${(0, $3c9e88a543a9da6a$export$7d3dcc20d590cb17).map((n)=>`<button type="button" class="tb-chip${!partyOther && f.partySize === n ? ' tb-chip--on' : ''}" data-res-party="${n}" aria-pressed="${!partyOther && f.partySize === n}">${n}</button>`).join('')}
          <button type="button" class="tb-chip${partyOther ? ' tb-chip--on' : ''}" data-res-party-other="1" aria-pressed="${partyOther}">Other\u{2026}</button>
        </div>
        ${partyOther ? `<input type="number" class="tb-other-input" min="1" max="99" value="${f.partySize}" data-res-party-n="1" aria-label="Party size" />` : ''}
      </div>
      <div class="tb-field"><span>Time</span>
        <div class="tb-chips tb-chips--time">
          ${slots.map((s)=>`<button type="button" class="tb-chip${!f.timeOther && s.value === f.time ? ' tb-chip--on' : ''}${s.full ? ' tb-chip--full' : ''}" data-res-time="${s.value}" aria-pressed="${!f.timeOther && s.value === f.time}"${s.full ? ' disabled' : ''}>${s.label}</button>`).join('')}
          <button type="button" class="tb-chip${f.timeOther ? ' tb-chip--on' : ''}" data-res-time-other="1" aria-pressed="${f.timeOther}">Other time\u{2026}</button>
        </div>
        ${f.timeOther ? `<input type="time" class="tb-other-input" value="${f.time ? (0, $3c9e88a543a9da6a$export$2573b0584d6d05ea)((0, $3c9e88a543a9da6a$export$4a79f0068700788b)(f.time)) : ''}" data-res-time-n="1" aria-label="Booking time" />` : ''}
        ${slots.some((s)=>s.full) ? `<small class="tb-hint">Crossed-out times have no free table for ${f.partySize}.</small>` : ''}
        ${closed ? `<small class="tb-hint">No bookings on ${dayName}s (Settings &gt; Home screen). Use Other time for a one-off.</small>` : slots.length ? '' : '<small class="tb-hint">No times left on this day. Use Other time for a one-off.</small>'}
      </div>
      <div class="tb-field"><span>Table held for</span>
        <div class="tb-hold">
          <input type="number" class="tb-other-input" min="15" max="600" step="15" value="${hold}" data-res-hold="1" aria-label="Minutes the table is held" />
          <span>min</span>
          <small class="tb-hint">${f.durationMin != null && f.durationMin !== usual ? `Usual for ${f.partySize}: ${(0, $3c9e88a543a9da6a$export$6983ec1528bb4f57)(usual)}. <button type="button" class="tb-link" data-res-hold-reset="1">Use usual</button>` : `Usual for ${f.partySize}: ${(0, $3c9e88a543a9da6a$export$6983ec1528bb4f57)(usual)}`}</small>
        </div>
      </div>
      <label class="tb-field"><span>Table</span>
        <select data-res-f="tableId">
          <option value="">${fit ? `Pick for me (Table ${(0, $cnCXJ.esc)(fit.name)})` : 'No table yet'}</option>
          ${reservable.map((x)=>{
            // Only tables that seat the party and are free then can be picked;
            // the rest stay listed (greyed) so staff can see why.
            const small = x.seats < f.partySize;
            const busy = !this._tableFree(x.id, f.time, hold);
            const why = small ? " \xb7 too small" : busy ? " \xb7 booked then" : '';
            return `<option value="${x.id}"${f.tableId === x.id ? ' selected' : ''}${small || busy ? ' disabled' : ''}>Table ${(0, $cnCXJ.esc)(x.name)} \xb7 ${$ab39ca298e181461$var$seatsLabel(x.seats)}${why}</option>`;
        }).join('')}
        </select>
        ${!fit && reservable.length && biggest < f.partySize ? `<small class="tb-hint">No table seats ${f.partySize}. Save it without a table, then join tables when they arrive.</small>` : ''}
        ${switched ? `<small class="tb-hint tb-hint--note">Table ${(0, $cnCXJ.esc)(switched)}, so it's back on Pick for me.</small>` : ''}
      </label>
      <label class="tb-field"><span>Note (optional)</span><input type="text" maxlength="200" value="${(0, $cnCXJ.esc)(f.note)}" data-res-f="note" placeholder="Allergies, high chair, occasion" /></label>
      <span class="tb-spacer"></span>
      <button type="button" class="tb-btn tb-btn--pri" data-res-save="1"${f.time ? '' : ' disabled'}>Book${f.time ? ` ${$ab39ca298e181461$var$clock(this._slotDate(f.time))}` : ''} for ${f.partySize}${t ? ` \xb7 Table ${(0, $cnCXJ.esc)(t.name)}` : ''}</button>`;
    }
    // "H:MM" on the open day, at the business's wall clock.
    _slotDate(value) {
        const [h, m] = value.split(':').map(Number);
        return (0, $lDSCx.zonedToDate)(this._data.day, `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`, $ab39ca298e181461$var$TZ);
    }
    // This booking's hold: what staff typed, else the usual for the party size.
    _holdMin() {
        const f = this._resForm;
        return f?.durationMin ?? (0, $3c9e88a543a9da6a$export$505ac917808ea098)(this._data.bookingRules, f?.partySize ?? 2);
    }
    // Start times from the owner's booking hours for this weekday (bookingRules.js).
    // Today, times more than 15 minutes ago drop off.
    _slots() {
        const d = this._data;
        const now = Date.now();
        const hold = this._holdMin();
        const party = this._resForm?.partySize ?? 2;
        const reservable = d.tables.some((t)=>t.canReserve !== false);
        return (0, $3c9e88a543a9da6a$export$e9b1c15965e391ae)(d.bookingRules, $ab39ca298e181461$var$sundayIndex(d.day)).filter((value)=>this._slotDate(value).getTime() >= now - 900000).map((value)=>({
                value: value,
                label: $ab39ca298e181461$var$clock(this._slotDate(value)),
                full: reservable && !this._fitTable(party, value, hold)
            }));
    }
    _tableFree(tableId, time, durationMin = this._holdMin()) {
        if (!time) return true;
        const s = this._slotDate(time).getTime(), e = s + durationMin * 60000;
        return !this._data.dayReservations.some((r)=>r.tableId === tableId && r.status === 'booked' && new Date(r.startsAt).getTime() < e && new Date(r.startsAt).getTime() + r.durationMin * 60000 > s);
    }
    // Smallest reservable table that fits the party and is free then.
    _fitTable(party, time, durationMin = this._holdMin()) {
        return this._data.tables.filter((t)=>t.canReserve !== false && t.seats >= party && this._tableFree(t.id, time, durationMin)).sort((a, b)=>a.seats - b.seats)[0] ?? null;
    }
    // ── Waitlist ─────────────────────────────────────────────────────────────────
    _renderWaitlist() {
        const d = this._data;
        const waiting = d.waitlist.filter((w)=>w.status === 'waiting');
        const done = d.waitlist.filter((w)=>w.status !== 'waiting').slice(-5).reverse();
        const free = d.tables.filter((t)=>$ab39ca298e181461$export$49881d192203ad4a(t, this._tabFor(t.id), d.reservations, d.now) === 'free');
        // A new party waits at least as long as what the parties ahead of it were told is left
        // (a party quoted 35m, 2m in, means about 35 more - not "About 5 min").
        const quotedLeft = Math.max(0, ...waiting.filter((w)=>w.quotedMin != null).map((w)=>w.quotedMin - $ab39ca298e181461$var$mins(d.now - new Date(w.addedAt).getTime())));
        const estimate = waiting.length ? Math.max(5, Math.ceil(Math.max(quotedLeft, (waiting.length + 1) * 10 / Math.max(1, free.length)) / 5) * 5) : 0;
        const f = this._waitForm;
        const quotes = d.waitlistQuotes;
        if (f.quotedMin == null) f.quotedMin = quotes[Math.min(2, quotes.length - 1)];
        const quoteOther = f.quoteOther || !quotes.includes(f.quotedMin);
        const wPartyOther = f.partyOther || !$ab39ca298e181461$var$WAIT_PARTY_SIZES.includes(f.partySize);
        this._content.innerHTML = `
      <div class="tb-wait">
        <div class="tb-wait-main">
          <div class="tb-wait-hero">
            <div><span>Wait for a new party</span><b>${!free.length ? 'No table free right now' : waiting.length ? `About ${estimate} min` : 'No wait'}</b></div>
            <p>${free.length} free table${free.length === 1 ? '' : 's'} \xb7 ${waiting.length} waiting</p>
          </div>
          ${waiting.map((w)=>{
            const waited = $ab39ca298e181461$var$mins(d.now - new Date(w.addedAt).getTime());
            const over = w.quotedMin != null && waited > w.quotedMin;
            const fit = free.filter((t)=>t.seats >= w.partySize).sort((a, b)=>a.seats - b.seats)[0];
            const pctDone = w.quotedMin ? $ab39ca298e181461$var$clamp(waited / w.quotedMin * 100, 4, 100) : 30;
            return `
              <div class="tb-wait-card${over ? ' tb-wait-card--over' : ''}">
                <div class="tb-wait-top">
                  <span class="tb-wait-size" aria-label="Party of ${w.partySize}">${w.partySize}</span>
                  <span class="tb-wait-who"><b>${(0, $cnCXJ.esc)(w.name)}</b><small>${(0, $cnCXJ.esc)(w.note || w.phone || '')}</small></span>
                  <span class="tb-wait-time"><b>${waited}m</b><small>${w.quotedMin != null ? `told ${w.quotedMin}m` : 'waiting'}</small></span>
                </div>
                <div class="tb-wait-bar"><i style="width:${pctDone}%"></i></div>
                <div class="tb-row">
                  ${fit ? `<button type="button" class="tb-btn tb-btn--pri" data-wait-seat="${w.id}" data-wait-table="${fit.id}">Seat at ${(0, $cnCXJ.esc)(fit.name)}</button>` : '<span class="tb-hint">No free table fits yet</span>'}
                  <select class="tb-wait-pick-table" data-wait-choose="${w.id}" aria-label="Seat ${(0, $cnCXJ.esc)(w.name)} at another table">
                    <option value="">Other table\u{2026}</option>
                    ${free.map((t)=>`<option value="${t.id}">Table ${(0, $cnCXJ.esc)(t.name)} \xb7 ${t.seats}</option>`).join('')}
                  </select>
                  <button type="button" class="tb-btn" data-wait-remove="${w.id}">Remove</button>
                </div>
              </div>`;
        }).join('') || '<p class="tb-detail-text tb-wait-none">Nobody is waiting.</p>'}
          ${done.length ? `<p class="tb-sub-title">Earlier</p><ul class="tb-wait-done">${done.map((w)=>`<li><b>${(0, $cnCXJ.esc)(w.name)}</b> \xb7 ${w.partySize} \xb7 ${w.status === 'seated' ? 'seated' : 'removed'} ${$ab39ca298e181461$var$clock(w.seatedAt ?? w.addedAt)}</li>`).join('')}</ul>` : ''}
        </div>
        <aside class="tb-detail">
          <h3 class="tb-props-title">Add a party</h3>
          <label class="tb-field"><span>Name</span><input type="text" maxlength="60" value="${(0, $cnCXJ.esc)(f.name)}" data-wait-f="name" autocomplete="off" /></label>
          <div class="tb-field"><span>Party size</span>
            <div class="tb-chips">
              ${$ab39ca298e181461$var$WAIT_PARTY_SIZES.map((n)=>`<button type="button" class="tb-chip${!wPartyOther && f.partySize === n ? ' tb-chip--on' : ''}" data-wait-party="${n}" aria-pressed="${!wPartyOther && f.partySize === n}">${n}</button>`).join('')}
              <button type="button" class="tb-chip${wPartyOther ? ' tb-chip--on' : ''}" data-wait-party-other="1" aria-pressed="${wPartyOther}">Other\u{2026}</button>
            </div>
            ${wPartyOther ? `<input type="number" class="tb-other-input" min="1" max="99" value="${f.partySize}" data-wait-party-n="1" aria-label="Party size" />` : ''}
          </div>
          <label class="tb-field"><span>Phone (optional)</span><input type="tel" maxlength="30" value="${(0, $cnCXJ.esc)(f.phone)}" data-wait-f="phone" autocomplete="off" /></label>
          <label class="tb-field"><span>Note (optional)</span><input type="text" maxlength="200" value="${(0, $cnCXJ.esc)(f.note)}" data-wait-f="note" placeholder="Booth if possible" /></label>
          <div class="tb-field"><span>Wait you told them</span>
            <div class="tb-chips">
              ${quotes.map((n)=>`<button type="button" class="tb-chip${!quoteOther && f.quotedMin === n ? ' tb-chip--on' : ''}" data-wait-quote="${n}" aria-pressed="${!quoteOther && f.quotedMin === n}">${n}m</button>`).join('')}
              <button type="button" class="tb-chip${quoteOther ? ' tb-chip--on' : ''}" data-wait-quote-other="1" aria-pressed="${quoteOther}">Other\u{2026}</button>
            </div>
            ${quoteOther ? `<span class="tb-hold"><input type="number" class="tb-other-input" min="1" max="600" value="${f.quotedMin ?? ''}" data-wait-quote-n="1" aria-label="Minutes you told them" /><span>min</span></span>` : ''}
          </div>
          <span class="tb-spacer"></span>
          <button type="button" class="tb-btn tb-btn--pri" data-wait-add="1">Add to waitlist</button>
          <p class="tb-hint">Texting guests when their table is ready can come later. For now, call out their name.</p>
        </aside>
      </div>`;
    }
    // ── Events ───────────────────────────────────────────────────────────────────
    _rerender(focusSel) {
        this.render(this._data);
        if (focusSel) this._content.querySelector(focusSel)?.focus();
    }
    _onClick(e) {
        const h = this._handlers;
        const d = this._data;
        const q = (sel)=>e.target.closest(sel);
        let el;
        if (el = q('[data-go]')) return this._goSection(el.dataset.go);
        if (el = q('[data-area]')) {
            this._area = el.dataset.area;
            this._layoutSel = null;
            return this._rerender(`[data-area="${CSS.escape(this._area)}"]`);
        }
        // Floor
        if (el = q('[data-table]')) {
            const id = el.dataset.table;
            if (this._pick) {
                const tab = this._tabFor(this._selId);
                const target = this._tabFor(id);
                if (!tab || id === this._selId) return;
                const mode = this._pick;
                this._pick = null;
                if (mode === 'move') {
                    if (target) return h.onToast?.('That table already has guests. Use Join tables instead.');
                    return h.onMove(tab.id, id);
                }
                if (!target) return h.onToast?.('That table has no open tab to join.');
                return h.onMerge(target.id, tab.id);
            }
            this._selId = this._selId === id ? null : id;
            this._split = null;
            this._guests = Math.min(this._guests, 99);
            return this._rerender(`[data-table="${id}"]`);
        }
        if (el = q('[data-guests]')) {
            this._guests = $ab39ca298e181461$var$clamp(this._guests + Number(el.dataset.guests), 1, 99);
            return this._rerender(`[data-guests="${el.dataset.guests}"]`);
        }
        if (el = q('[data-seat]')) return h.onSeat(el.dataset.seat, this._guests);
        if (el = q('[data-seat-res]')) return h.onSeatReservation(el.dataset.seatRes);
        if (el = q('[data-seat-wait]')) return h.onSeatWaitlist(el.dataset.seatWait, this._selId);
        if (el = q('[data-clean]')) return h.onClean(el.dataset.clean);
        if (el = q('[data-add-items]')) return h.onAddItems(el.dataset.addItems);
        if (el = q('[data-send]')) return h.onSend(el.dataset.send);
        if (el = q('[data-remove-line]')) return h.onRemoveLine(this._tabFor(this._selId)?.id, el.dataset.removeLine);
        if (el = q('[data-tab-guests]')) {
            const tab = this._tabFor(this._selId);
            if (tab) h.onGuests(tab.id, $ab39ca298e181461$var$clamp(tab.guests + Number(el.dataset.tabGuests), 1, 99));
            return;
        }
        if (el = q('[data-bill]')) {
            const tab = this._tabFor(this._selId);
            if (tab) h.onBill(tab.id, el.dataset.bill === 'on');
            return;
        }
        if (el = q('[data-pay]')) return h.onPay(el.dataset.pay, null);
        if (q('[data-split]')) {
            this._split = new Set();
            return this._rerender();
        }
        if (q('[data-split-cancel]')) {
            this._split = null;
            return this._rerender();
        }
        if (q('[data-pay-split]')) {
            const tab = this._tabFor(this._selId);
            if (tab && this._split?.size) h.onPay(tab.id, [
                ...this._split
            ]);
            return;
        }
        if (el = q('[data-pick]')) {
            this._pick = el.dataset.pick;
            return this._rerender();
        }
        if (q('[data-pick-cancel]')) {
            this._pick = null;
            return this._rerender();
        }
        if (el = q('[data-close-tab]')) return h.onCloseTab(el.dataset.closeTab);
        // Table list (numbers mode)
        if (el = q('[data-list-add]')) {
            const n = Number(el.dataset.listAdd);
            if (n === 10) {
                const have = new Set(this._draft.map((t)=>t.name));
                for(let i = 1; i <= 10; i++)if (!have.has(String(i))) this._draft.push({
                    ...this._newTable('square', 'Inside'),
                    name: String(i)
                });
            } else this._draft.push(this._newTable('square', 'Inside'));
            this._rerender();
            this._content.querySelector(`[data-list-name="${this._draft.length - 1}"]`)?.focus();
            return;
        }
        if (el = q('[data-list-remove]')) {
            const [t] = this._draft.splice(Number(el.dataset.listRemove), 1);
            if (t?.id) this._removed.push(t.id);
            return this._rerender();
        }
        if (q('[data-list-save]')) return this._saveDraft();
        // Layout editor
        if (el = q('[data-add-shape]')) {
            this._draft.push(this._newTable(el.dataset.addShape));
            this._layoutSel = this._draft.length - 1;
            return this._rerender(`[data-edit="${this._layoutSel}"]`);
        }
        if (q('[data-area-add]')) {
            this._addingArea = true;
            return this._rerender('#tbNewArea');
        }
        if (q('[data-area-cancel]')) {
            this._addingArea = false;
            return this._rerender();
        }
        if (q('[data-area-ok]')) return this._addArea();
        if (el = q('[data-prop-seats]')) {
            const t = this._draft[this._layoutSel];
            t.seats = $ab39ca298e181461$var$clamp(t.seats + Number(el.dataset.propSeats), 1, 40);
            return this._rerender(`[data-prop-seats="${el.dataset.propSeats}"]`);
        }
        if (el = q('[data-prop-shape]')) {
            const t = this._draft[this._layoutSel];
            const s = $ab39ca298e181461$var$SHAPES[el.dataset.propShape];
            t.shape = el.dataset.propShape;
            t.w = s.w;
            t.h = s.h;
            t.x = $ab39ca298e181461$var$clamp(t.x, 0, $ab39ca298e181461$var$W - t.w);
            t.y = $ab39ca298e181461$var$clamp(t.y, 0, $ab39ca298e181461$var$H - t.h);
            return this._rerender(`[data-prop-shape="${t.shape}"]`);
        }
        if (q('[data-prop-dup]')) {
            const t = this._draft[this._layoutSel];
            const copy = {
                ...t,
                id: null,
                name: this._nextName(t.name),
                ...this._freeSpot(t.w, t.h, t.area)
            };
            this._draft.push(copy);
            this._layoutSel = this._draft.length - 1;
            return this._rerender();
        }
        if (q('[data-prop-remove]')) {
            const t = this._draft[this._layoutSel];
            if (t.id && d.tabs.some((x)=>x.tableId === t.id)) return h.onToast?.('This table has an open tab. Pay or move it first.');
            // Two taps: the first arms the button ("Tap again to remove").
            if (this._removeArmed !== t) {
                this._removeArmed = t;
                return this._rerender('[data-prop-remove]');
            }
            this._removeArmed = null;
            this._draft.splice(this._layoutSel, 1);
            if (t.id) this._removed.push(t.id);
            this._layoutSel = null;
            return this._rerender();
        }
        if (q('[data-layout-cancel]')) {
            this._draft = null;
            this._layoutSel = null;
            return this._goSection('floor');
        }
        if (q('[data-layout-save]')) return this._saveDraft();
        // Reservations
        if (el = q('[data-day]')) {
            // Changing the day keeps what's typed; only the time has to be picked again.
            this._resSel = null;
            if (this._resForm && !this._resForm.timeOther) this._resForm.time = null;
            return h.onDay(Number(el.dataset.day));
        }
        if (el = q('[data-res]')) {
            this._resSel = this._resSel === el.dataset.res ? null : el.dataset.res;
            return this._rerender();
        }
        if (q('[data-res-new]')) {
            this._resSel = null;
            return this._rerender('[data-res-f="name"]');
        }
        if (el = q('[data-res-party]')) {
            Object.assign(this._resForm, {
                partySize: Number(el.dataset.resParty),
                partyOther: false
            });
            return this._rerender(`[data-res-party="${el.dataset.resParty}"]`);
        }
        if (q('[data-res-party-other]')) {
            this._resForm.partyOther = true;
            return this._rerender('[data-res-party-n]');
        }
        if (el = q('[data-res-time]')) {
            Object.assign(this._resForm, {
                time: el.dataset.resTime,
                timeOther: false
            });
            return this._rerender(`[data-res-time="${el.dataset.resTime}"]`);
        }
        if (q('[data-res-time-other]')) {
            this._resForm.timeOther = true;
            return this._rerender('[data-res-time-n]');
        }
        if (q('[data-res-hold-reset]')) {
            this._resForm.durationMin = null;
            return this._rerender('[data-res-hold]');
        }
        if (el = q('[data-res-status]')) return h.onReservationStatus(el.dataset.resId, el.dataset.resStatus);
        if (q('[data-res-save]')) {
            const f = this._resForm;
            if (!f.name.trim()) return h.onToast?.('Add a name for the booking.');
            if (!f.time) return h.onToast?.('Pick a time for the booking.');
            const hold = this._holdMin();
            const tableId = f.tableId || this._fitTable(f.partySize, f.time, hold)?.id || null;
            return h.onSaveReservation({
                name: f.name,
                phone: f.phone,
                partySize: f.partySize,
                note: f.note,
                startsAt: this._slotDate(f.time).toISOString(),
                durationMin: hold,
                tableId: tableId
            });
        }
        // Waitlist
        if (el = q('[data-wait-party]')) {
            Object.assign(this._waitForm, {
                partySize: Number(el.dataset.waitParty),
                partyOther: false
            });
            return this._rerender(`[data-wait-party="${el.dataset.waitParty}"]`);
        }
        if (q('[data-wait-party-other]')) {
            this._waitForm.partyOther = true;
            return this._rerender('[data-wait-party-n]');
        }
        if (el = q('[data-wait-quote]')) {
            Object.assign(this._waitForm, {
                quotedMin: Number(el.dataset.waitQuote),
                quoteOther: false
            });
            return this._rerender(`[data-wait-quote="${el.dataset.waitQuote}"]`);
        }
        if (q('[data-wait-quote-other]')) {
            this._waitForm.quoteOther = true;
            return this._rerender('[data-wait-quote-n]');
        }
        if (q('[data-wait-add]')) {
            const f = this._waitForm;
            if (!f.name.trim()) return h.onToast?.('Add a name so you can call them.');
            return h.onAddWaitlist({
                ...f
            });
        }
        if (el = q('[data-wait-seat]')) return h.onSeatWaitlist(el.dataset.waitSeat, el.dataset.waitTable);
        if (el = q('[data-wait-remove]')) return h.onWaitlistStatus(el.dataset.waitRemove, 'removed');
    }
    _onChange(e) {
        const t = e.target;
        if (t.matches('[data-split-line]')) {
            if (t.checked) this._split.add(t.dataset.splitLine);
            else this._split.delete(t.dataset.splitLine);
            return this._rerender(`[data-split-line="${t.dataset.splitLine}"]`);
        }
        if (t.matches('[data-prop="area"]')) {
            this._draft[this._layoutSel].area = t.value;
            this._area = t.value;
            return this._rerender();
        }
        if (t.matches('[data-prop="canReserve"]')) {
            this._draft[this._layoutSel].canReserve = t.checked;
            return;
        }
        if (t.matches('[data-list-seats]')) {
            this._draft[Number(t.dataset.listSeats)].seats = $ab39ca298e181461$var$clamp(parseInt(t.value, 10) || 1, 1, 40);
            return;
        }
        if (t.matches('[data-res-f="tableId"]')) {
            this._resForm.tableId = t.value || null;
            return this._rerender('[data-res-f="tableId"]');
        }
        // "Other…" one-offs: applied on change (not every keystroke) so the time
        // list and free tables update once the number is in.
        if (t.matches('[data-res-party-n]')) {
            this._resForm.partySize = $ab39ca298e181461$var$clamp(parseInt(t.value, 10) || 1, 1, 99);
            return this._rerender('[data-res-party-n]');
        }
        if (t.matches('[data-res-time-n]')) {
            if (!t.value) return;
            const [hh, mm] = t.value.split(':').map(Number);
            this._resForm.time = `${hh}:${mm}`;
            return this._rerender('[data-res-time-n]');
        }
        if (t.matches('[data-res-hold]')) {
            this._resForm.durationMin = $ab39ca298e181461$var$clamp(Math.round((parseInt(t.value, 10) || 90) / 5) * 5, 15, 600);
            return this._rerender('[data-res-hold]');
        }
        if (t.matches('[data-wait-party-n]')) {
            this._waitForm.partySize = $ab39ca298e181461$var$clamp(parseInt(t.value, 10) || 1, 1, 99);
            return this._rerender('[data-wait-party-n]');
        }
        if (t.matches('[data-wait-quote-n]')) {
            this._waitForm.quotedMin = $ab39ca298e181461$var$clamp(parseInt(t.value, 10) || 0, 0, 600);
            return this._rerender('[data-wait-quote-n]');
        }
        if (t.matches('[data-wait-choose]') && t.value) return this._handlers.onSeatWaitlist(t.dataset.waitChoose, t.value);
    }
    _onInput(e) {
        const t = e.target;
        if (t.matches('[data-prop="name"]')) {
            this._draft[this._layoutSel].name = t.value;
            const el = this._content.querySelector(`[data-edit="${this._layoutSel}"] .tb-table-name`);
            if (el) el.textContent = t.value;
            return;
        }
        if (t.matches('[data-list-name]')) {
            this._draft[Number(t.dataset.listName)].name = t.value;
            return;
        }
        if (t.matches('[data-res-f]') && t.dataset.resF !== 'tableId') {
            this._resForm[t.dataset.resF] = t.value;
            return;
        }
        // "Other…" numbers count as soon as they're typed (Add / Book work without
        // Enter); the time list and tables refresh on change, which keeps focus.
        const n = parseInt(t.value, 10);
        if (t.matches('[data-wait-party-n]') && n >= 1) {
            this._waitForm.partySize = $ab39ca298e181461$var$clamp(n, 1, 99);
            return;
        }
        if (t.matches('[data-wait-quote-n]') && n >= 0) {
            this._waitForm.quotedMin = $ab39ca298e181461$var$clamp(n, 0, 600);
            return;
        }
        if (t.matches('[data-res-party-n]') && n >= 1) {
            this._resForm.partySize = $ab39ca298e181461$var$clamp(n, 1, 99);
            return;
        }
        if (t.matches('[data-res-hold]') && n >= 15) {
            this._resForm.durationMin = $ab39ca298e181461$var$clamp(n, 15, 600);
            return;
        }
        if (t.matches('[data-wait-f]')) this._waitForm[t.dataset.waitF] = t.value;
    }
    _saveDraft() {
        const names = this._draft.map((t)=>String(t.name).trim());
        if (names.some((n)=>!n)) return this._handlers.onToast?.('Every table needs a name or number.');
        if (new Set(names.map((n)=>n.toLowerCase())).size !== names.length) return this._handlers.onToast?.('Two tables have the same name. Give each one its own.');
        this._handlers.onSaveLayout(this._draft.map((t)=>({
                ...t,
                name: String(t.name).trim()
            })), this._removed);
    }
    // Called by the controller after a successful save / add.
    afterLayoutSaved() {
        this._draft = null;
        this._removed = [];
        this._layoutSel = null;
        if (this._section === 'layout') this._section = 'floor';
    }
    afterReservationSaved() {
        this._resForm = null;
        this._resSel = null;
    }
    afterWaitlistAdded() {
        this._waitForm = {
            name: '',
            partySize: 2,
            phone: '',
            note: '',
            quotedMin: null
        };
    }
    clearSplit() {
        this._split = null;
        this._pick = null;
    }
}
var $ab39ca298e181461$export$2e2bcd8739ae039 = new $ab39ca298e181461$var$TablesView();



var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");



var $lDSCx = parcelRequire("lDSCx");
// Swappable home cards + stat tiles (homeCards.js has the lists and the
// per-device prefs). The two built-in cards (the left column's Getting
// Started / Activity / My shift card and the Active Queue panel) are MOVED
// between the columns, never re-rendered, so their own views and handlers keep
// working. Every other card is drawn into one of two spare slot elements.
// Tiles work the same way: the three original tiles stay in index.html (the
// dashboard count-ups write to their ids) and extra tiles are drawn here; CSS
// `order` puts the chosen three in place.
const $717baed02964aa54$var$STATIC_TILES = {
    sales: '.home-sales-stat',
    txns: '#transactionsCard',
    serving: '.home-dash-stat--serving'
};
const $717baed02964aa54$var$TILE_LOOK = {
    avgOrder: {
        emoji: "\uD83E\uDDFE",
        accent: 'sales',
        title: 'View sales report'
    },
    tips: {
        emoji: "\uD83D\uDCB5",
        accent: 'sales',
        title: 'View sales report'
    },
    itemsSold: {
        emoji: "\uD83C\uDF7D\uFE0F",
        accent: 'sales',
        title: 'View sales report'
    },
    lastWeek: {
        emoji: "\uD83D\uDCC8",
        accent: 'sales',
        title: 'View sales report'
    },
    expenses: {
        emoji: "\uD83D\uDCB8",
        accent: 'sales',
        title: 'Open Sales & Expenses'
    },
    waiting: {
        emoji: "\u23F3",
        accent: 'kitchen',
        title: 'Open the Active Queue'
    },
    onShift: {
        emoji: "\uD83D\uDC65",
        accent: 'kitchen',
        title: "See who's working"
    },
    requests: {
        emoji: "\uD83D\uDCEC",
        accent: 'kitchen',
        title: 'Review requests'
    },
    freeTables: {
        emoji: "\uD83E\uDE91",
        accent: 'tables',
        title: 'Open Tables'
    },
    openTabs: {
        emoji: "\uD83D\uDCCB",
        accent: 'tables',
        title: 'Open Tables'
    },
    nextBooking: {
        emoji: "\uD83D\uDCC5",
        accent: 'tables',
        title: 'Open reservations'
    },
    lowItems: {
        emoji: "\uD83D\uDCE6",
        accent: 'stock',
        title: 'Open Inventory'
    }
};
const $717baed02964aa54$var$svg = (d, s = 18)=>`<svg xmlns="http://www.w3.org/2000/svg" width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
const $717baed02964aa54$var$CARD_ICONS = {
    main: '<path d="M22 12h-4l-3 9L9 3l-3 9H2"/>',
    queue: '<path d="M9 11l3 3 8-8"/><path d="M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9"/>',
    tables: '<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="3.5"/><rect x="3" y="14" width="7" height="7" rx="3.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>',
    reservations: '<path d="M8 2v4"/><path d="M16 2v4"/><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M3 10h18"/><path d="m9 16 2 2 4-4"/>',
    waitlist: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    team: '<path d="M16 21v-2a4 4 0 0 0-8 0v2"/><circle cx="12" cy="7" r="4"/>',
    topSellers: '<path d="M3 3v18h18"/><path d="m7 15 4-4 3 3 6-6"/>',
    lowStock: '<path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="m3 8 9 5 9-5"/><path d="M12 13v8"/>',
    salesToday: '<path d="M4 20V10"/><path d="M10 20V4"/><path d="M16 20v-7"/><path d="M22 20H2"/>',
    salesWeek: '<rect x="3" y="4" width="18" height="17" rx="2"/><path d="M3 9h18"/><path d="M8 14v3"/><path d="M12 12v5"/><path d="M16 15v2"/>',
    schedule: '<rect x="3" y="4" width="18" height="17" rx="2"/><path d="M3 9h18"/><path d="M8 2v4"/><path d="M16 2v4"/><path d="M7 13h4"/><path d="M7 17h7"/>',
    inbox: '<path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.5 5h13L22 12v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6z"/>',
    purchaseOrders: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M8 13h8"/><path d="M8 17h5"/>'
};
const $717baed02964aa54$var$mins = (ms)=>Math.max(0, Math.floor(ms / 60000));
const $717baed02964aa54$var$ago = (iso, now)=>{
    const m = $717baed02964aa54$var$mins(now - new Date(iso).getTime());
    return m < 60 ? `${m}m` : `${Math.floor(m / 60)}h ${m % 60}m`;
};
// Business-timezone clock (set from renderCards data), like the Tables panel.
let $717baed02964aa54$var$TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
const $717baed02964aa54$var$clock = (d)=>{
    const { h: h, mi: m } = (0, $lDSCx.zonedParts)(new Date(d), $717baed02964aa54$var$TZ);
    return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}`;
};
const $717baed02964aa54$var$initials = (name)=>(name || '').split(/\s+/).filter(Boolean).slice(0, 2).map((w)=>w[0].toUpperCase()).join('') || '?';
const $717baed02964aa54$var$plural = (n, one, many = `${one}s`)=>`${n} ${n === 1 ? one : many}`;
// Whole units for bar labels ("$1,240", "$12.3k"); the exact amount is in the bar's title.
const $717baed02964aa54$var$shortMoney = (n)=>{
    const v = Math.round(Number(n) || 0);
    return v >= 10000 ? `${(0, $coRoT.currencySymbol)()}${(v / 1000).toFixed(1).replace(/\.0$/, '')}k` : `${(0, $coRoT.currencySymbol)()}${v.toLocaleString('en-US')}`;
};
const $717baed02964aa54$var$STATUS_LABEL = {
    free: 'Free',
    reserved: 'Reserved',
    seated: 'Seated',
    ordered: 'Ordered',
    bill: 'Wants bill',
    dirty: 'Clean up'
};
class $717baed02964aa54$var$HomeCardsView {
    _layout = document.querySelector('.home-layout');
    _cols = [
        document.querySelector('.home-left-col'),
        document.querySelector('.home-right-col')
    ];
    _dash = document.querySelector('.home-dash-card');
    _main = [
        document.getElementById('homeChecklistCard'),
        document.getElementById('homeMyShiftCard')
    ];
    _queue = document.querySelector('.home-queue-panel');
    _slots = [];
    _tiles = new Map();
    _cards = [];
    _area = null;
    _handlers = {};
    _picker = null;
    // handlers: { onSwapCard(key, btn), onSwapTile(key, btn), onTile(key), onAction(act, dataset) }
    init(handlers) {
        this._handlers = handlers;
        this._slots = [
            0,
            1
        ].map((i)=>{
            const el = document.createElement('article');
            el.className = 'home-card home-slot-away';
            el.dataset.slot = String(i);
            el.addEventListener('click', (e)=>this._onCardClick(e));
            this._cols[i]?.append(el);
            return el;
        });
        Object.entries($717baed02964aa54$var$STATIC_TILES).forEach(([key, sel])=>{
            const el = document.querySelector(sel);
            if (!el) return;
            this._tiles.set(key, el);
            this._addTileSwap(el, key);
        });
        // Built-in cards carry their own swap button (index.html / myShiftView.js).
        this._layout?.addEventListener('click', (e)=>{
            const btn = e.target.closest('[data-swap-card]');
            if (btn && !btn.closest('.home-card')) handlers.onSwapCard(btn.dataset.swapCard, btn);
        });
    }
    _addTileSwap(el, key) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'home-tile-swap';
        btn.setAttribute('aria-label', 'Swap this tile');
        btn.title = 'Choose what shows here';
        btn.innerHTML = (0, $3aa6878d3c2fc9b3$export$acd4ea891440d33b);
        // The tile itself opens a report: the swap button must not.
        btn.addEventListener('click', (e)=>{
            e.stopPropagation();
            this._handlers.onSwapTile(key, btn);
        });
        btn.addEventListener('keydown', (e)=>e.stopPropagation());
        el.append(btn);
    }
    _tile(key) {
        if (this._tiles.has(key)) return this._tiles.get(key);
        const look = $717baed02964aa54$var$TILE_LOOK[key];
        const label = (0, $3aa6878d3c2fc9b3$export$34ddeca23ac38a20).find((t)=>t.key === key)?.label ?? key;
        const el = document.createElement('div');
        el.className = `home-dash-stat home-dash-stat--extra home-dash-stat--${look.accent}`;
        el.dataset.tile = key;
        el.setAttribute('role', 'button');
        el.tabIndex = 0;
        el.title = look.title;
        el.innerHTML = `
      <span class="home-dash-emoji" aria-hidden="true">${look.emoji}</span>
      <div class="home-dash-body">
        <div class="home-dash-label">${label}</div>
        <div class="home-dash-value" data-tile-value>\u{2014}</div>
        <div class="svs-base" data-tile-sub></div>
      </div>`;
        el.addEventListener('click', ()=>this._handlers.onTile(key));
        el.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this._handlers.onTile(key);
            }
        });
        this._addTileSwap(el, key);
        this._dash?.append(el);
        this._tiles.set(key, el);
        return el;
    }
    // ── Placement ─────────────────────────────────────────────────────────────
    apply({ cards: cards, tiles: tiles }) {
        if (!this._slots.length) return; // before init(): the first apply after login does it
        this._cards = cards;
        [
            ...this._main,
            this._queue,
            ...this._slots
        ].forEach((el)=>el?.classList.add('home-slot-away'));
        cards.forEach((key, i)=>{
            const col = this._cols[i];
            if (!col) return;
            if (key === 'main') this._main.forEach((el)=>{
                if (el) {
                    col.append(el);
                    el.classList.remove('home-slot-away');
                }
            });
            else if (key === 'queue') {
                col.append(this._queue);
                this._queue.classList.remove('home-slot-away');
            } else {
                const slot = this._slots[i];
                if (slot.dataset.card !== key) {
                    slot.dataset.card = key;
                    slot.innerHTML = this._shell(key, this._cardLabel(key), '', '', '<p class="hc-empty">Loading\u2026</p>');
                }
                col.append(slot);
                slot.classList.remove('home-slot-away');
            }
        });
        const shown = new Set(tiles);
        tiles.forEach((key, i)=>{
            const el = this._tile(key);
            el.style.order = String(i);
            el.classList.remove('home-slot-away');
        });
        this._tiles.forEach((el, key)=>{
            if (!shown.has(key)) el.classList.add('home-slot-away');
        });
    }
    // Custom cards on show, so the controller only loads what is needed.
    customCards() {
        return this._cards.filter((k)=>k !== 'main' && k !== 'queue');
    }
    _cardLabel(key) {
        return (0, $3aa6878d3c2fc9b3$export$5f768699f44cc740).find((c)=>c.key === key)?.label ?? key;
    }
    // ── Rendering ─────────────────────────────────────────────────────────────
    renderCards(data) {
        if (data.tz) $717baed02964aa54$var$TZ = data.tz;
        this._cards.forEach((key, i)=>{
            if (key === 'main' || key === 'queue') return;
            const slot = this._slots[i];
            const body = slot.querySelector('.hc-body');
            const top = body?.scrollTop ?? 0;
            slot.innerHTML = this[`_${key}`](data);
            const nextBody = slot.querySelector('.hc-body');
            if (nextBody) nextBody.scrollTop = top;
        });
    }
    renderTiles(values) {
        this._tiles.forEach((el, key)=>{
            if ($717baed02964aa54$var$STATIC_TILES[key] || !values[key]) return;
            el.querySelector('[data-tile-value]').textContent = values[key].value;
            el.querySelector('[data-tile-sub]').textContent = values[key].sub ?? '';
        });
    }
    _shell(key, title, sub, actions, body) {
        return `
      <div class="hc-head">
        <div class="hc-head-text">
          <h3 class="hc-title">${title}</h3>
          ${sub ? `<p class="hc-sub">${sub}</p>` : ''}
        </div>
        <div class="hc-actions">${actions}${(0, $3aa6878d3c2fc9b3$export$ad45c99c3690e609)(key)}</div>
      </div>
      <div class="hc-body">${body}</div>`;
    }
    _link(label, act, extra = '') {
        return `<button type="button" class="hc-link" data-hc-act="${act}"${extra}>${label}</button>`;
    }
    _tables({ tables: d }) {
        if (!d) return this._shell('tables', 'Tables', '', '', '<p class="hc-empty">Loading\u2026</p>');
        if (!d.tables.length) return this._shell('tables', 'Tables', '', '', `
        <div class="hc-empty-box">
          <p class="hc-empty">No tables yet.</p>
          ${this._link('Set up tables', 'open-tables')}
        </div>`);
        const tabFor = (id)=>d.tabs.find((t)=>t.tableId === id) ?? null;
        const withStatus = d.tables.map((t)=>({
                t: t,
                status: (0, $ab39ca298e181461$export$49881d192203ad4a)(t, tabFor(t.id), d.reservations, d.now)
            }));
        const count = (...s)=>withStatus.filter((x)=>s.includes(x.status)).length;
        const chips = [
            [
                'free',
                'Free',
                count('free', 'reserved')
            ],
            [
                'seated',
                'Seated',
                count('seated', 'ordered')
            ],
            [
                'bill',
                'Wants bill',
                count('bill')
            ],
            [
                'dirty',
                'Clean up',
                count('dirty')
            ]
        ];
        const areas = [
            ...new Set(d.tables.map((t)=>t.area))
        ];
        if (!areas.includes(this._area)) this._area = areas[0];
        const inArea = withStatus.filter((x)=>x.t.area === this._area);
        // Crop the 1000 x 700 floor grid to this area's tables so they fill the card.
        const pad = 20;
        const x0 = Math.max(0, Math.min(...inArea.map(({ t: t })=>t.x)) - pad);
        const y0 = Math.max(0, Math.min(...inArea.map(({ t: t })=>t.y)) - pad);
        const x1 = Math.max(...inArea.map(({ t: t })=>t.x + t.w)) + pad;
        const y1 = Math.max(...inArea.map(({ t: t })=>t.y + t.h)) + pad;
        const bw = Math.max(1, x1 - x0), bh = Math.max(1, y1 - y0);
        const tableBtn = ({ t: t, status: status })=>{
            const tab = tabFor(t.id);
            // Small tables (bar seats) only fit their name; the color says the rest.
            const meta = tab ? `${tab.guests} \xb7 ${$717baed02964aa54$var$ago(tab.openedAt, d.now)}` : status === 'dirty' ? 'Clean up' : `${t.seats} ${t.seats === 1 ? 'seat' : 'seats'}`;
            const pos = `left:${(t.x - x0) / bw * 100}%;top:${(t.y - y0) / bh * 100}%;width:${t.w / bw * 100}%;height:${t.h / bh * 100}%`;
            return `
        <button type="button" class="hc-table hc-table--${status} hc-shape--${t.shape}" style="${pos}" data-hc-act="table" data-id="${t.id}" aria-label="Table ${(0, $cnCXJ.esc)(t.name)}, ${$717baed02964aa54$var$STATUS_LABEL[status]}">
          <b>${(0, $cnCXJ.esc)(t.name)}</b><span>${(0, $cnCXJ.esc)(meta)}</span>
        </button>`;
        };
        const areaTabs = areas.length > 1 ? `
      <div class="hc-areas" role="tablist" aria-label="Area">
        ${areas.map((a)=>`<button type="button" role="tab" class="hc-area${a === this._area ? ' hc-area--on' : ''}" aria-selected="${a === this._area}" data-hc-act="area" data-area="${(0, $cnCXJ.esc)(a)}">${(0, $cnCXJ.esc)(a)}</button>`).join('')}
      </div>` : '';
        return this._shell('tables', 'Tables', 'Tap a table to open it', this._link('Full floor', 'open-tables'), `
      <div class="hc-counts">
        ${chips.map(([s, label, n])=>`<div class="hc-count hc-count--${s}"><b>${n}</b><span>${label}</span></div>`).join('')}
      </div>
      ${areaTabs}
      <div class="hc-floor-wrap">
        <div class="hc-floor" style="aspect-ratio:${bw} / ${bh}">${inArea.map(tableBtn).join('')}</div>
      </div>`);
    }
    _reservations({ tables: d }) {
        if (!d) return this._shell('reservations', "Today's reservations", '', '', '<p class="hc-empty">Loading\u2026</p>');
        const list = d.reservations.filter((r)=>r.status === 'booked' || r.status === 'seated').sort((a, b)=>new Date(a.startsAt) - new Date(b.startsAt));
        const guests = list.reduce((s, r)=>s + (r.partySize || 0), 0);
        const tableName = (id)=>d.tables.find((t)=>t.id === id)?.name ?? null;
        const busy = (id)=>d.tabs.some((t)=>t.tableId === id);
        const rows = list.map((r)=>{
            const late = r.status === 'booked' && new Date(r.startsAt).getTime() < d.now;
            const name = tableName(r.tableId);
            let action;
            if (r.status === 'seated') action = '<span class="hc-done">Seated</span>';
            else if (r.tableId && !busy(r.tableId)) action = `<button type="button" class="hc-btn" data-hc-act="seat-res" data-id="${r.id}">Seat</button>`;
            else action = `<button type="button" class="hc-btn" data-hc-act="open-res" data-id="${r.id}">Open</button>`;
            return `
        <li class="hc-row${late ? ' hc-row--late' : ''}${r.status === 'seated' ? ' hc-row--muted' : ''}">
          <span class="hc-res-time">${$717baed02964aa54$var$clock(r.startsAt)}</span>
          <span class="hc-row-text">
            <b>${(0, $cnCXJ.esc)(r.name)} <span class="hc-row-meta">\xb7 ${$717baed02964aa54$var$plural(r.partySize, 'guest')}</span></b>
            ${r.note ? `<small>${(0, $cnCXJ.esc)(r.note)}</small>` : ''}
          </span>
          <span class="hc-chip">${name ? `Table ${(0, $cnCXJ.esc)(name)}` : 'No table'}</span>
          ${action}
        </li>`;
        }).join('');
        return this._shell('reservations', "Today's reservations", list.length ? `${$717baed02964aa54$var$plural(list.length, 'booking')} \xb7 ${$717baed02964aa54$var$plural(guests, 'guest')}` : '', this._link('Open', 'open-section', ' data-section="reservations"'), rows ? `<ul class="hc-list">${rows}</ul>` : '<p class="hc-empty">No bookings today.</p>');
    }
    _waitlist({ tables: d }) {
        if (!d) return this._shell('waitlist', 'Waitlist', '', '', '<p class="hc-empty">Loading\u2026</p>');
        const waiting = d.waitlist.filter((w)=>w.status === 'waiting');
        const free = d.tables.filter((t)=>(0, $ab39ca298e181461$export$49881d192203ad4a)(t, d.tabs.find((x)=>x.tableId === t.id), d.reservations, d.now) === 'free');
        const rows = waiting.map((w)=>{
            const waited = $717baed02964aa54$var$mins(d.now - new Date(w.addedAt).getTime());
            const over = w.quotedMin != null && waited > w.quotedMin;
            const fit = free.filter((t)=>t.seats >= w.partySize).sort((a, b)=>a.seats - b.seats)[0];
            const action = fit ? `<button type="button" class="hc-btn" data-hc-act="seat-wait" data-id="${w.id}" data-table="${fit.id}">Seat at ${(0, $cnCXJ.esc)(fit.name)}</button>` : `<button type="button" class="hc-btn" data-hc-act="open-section" data-section="waitlist">Open</button>`;
            return `
        <li class="hc-row">
          <span class="hc-party" aria-label="Party of ${w.partySize}"><b>${w.partySize}</b><small>guests</small></span>
          <span class="hc-row-text"><b>${(0, $cnCXJ.esc)(w.name)}</b>${w.note ? `<small>${(0, $cnCXJ.esc)(w.note)}</small>` : ''}</span>
          <span class="hc-wait${over ? ' hc-wait--over' : ''}"><b>${waited} min</b><small>${w.quotedMin != null ? `told ${w.quotedMin} min` : 'waiting'}</small></span>
          ${action}
        </li>`;
        }).join('');
        return this._shell('waitlist', 'Waitlist', waiting.length ? `${waiting.length} waiting \xb7 ${$717baed02964aa54$var$plural(free.length, 'free table')}` : '', `<button type="button" class="hc-btn hc-btn--pri" data-hc-act="open-section" data-section="waitlist">Add a party</button>`, rows ? `<ul class="hc-list">${rows}</ul>` : '<p class="hc-empty">Nobody is waiting.</p>');
    }
    _team({ onShift: onShift, now: now }) {
        if (!onShift) return this._shell('team', "Who's working", '', '', '<p class="hc-empty">Loading\u2026</p>');
        const list = [
            ...onShift
        ].sort((a, b)=>new Date(a.clockedInAt) - new Date(b.clockedInAt));
        const rows = list.map((p)=>`
      <li class="hc-row">
        <span class="hc-avatar" aria-hidden="true">${(0, $cnCXJ.esc)($717baed02964aa54$var$initials(p.name))}</span>
        <span class="hc-row-text"><b>${(0, $cnCXJ.esc)(p.name || 'Staff member')}</b><small>In since ${$717baed02964aa54$var$clock(p.clockedInAt)} \xb7 ${$717baed02964aa54$var$ago(p.clockedInAt, now)}</small></span>
        ${p.onBreak ? '<span class="hc-chip hc-chip--break">On break</span>' : '<span class="hc-chip hc-chip--on">Working</span>'}
      </li>`).join('');
        return this._shell('team', "Who's working", list.length ? `${list.length} clocked in` : '', '', rows ? `<ul class="hc-list">${rows}</ul>` : '<p class="hc-empty">Nobody is clocked in yet.</p>');
    }
    _topSellers({ top: top }) {
        if (!top) return this._shell('topSellers', 'Top sellers today', '', '', '<p class="hc-empty">Loading\u2026</p>');
        const max = Math.max(1, ...top.map((t)=>t.quantity));
        const rows = top.map((t, i)=>`
      <li class="hc-rank">
        <span class="hc-rank-n">${i + 1}</span>
        <span class="hc-rank-text">
          <span class="hc-rank-top"><b>${(0, $cnCXJ.esc)(t.name)}</b><span>${t.quantity} sold</span></span>
          <span class="hc-bar"><i style="width:${Math.max(4, t.quantity / max * 100)}%"></i></span>
        </span>
      </li>`).join('');
        return this._shell('topSellers', 'Top sellers today', top.length ? 'By items sold' : '', '', rows ? `<ol class="hc-list">${rows}</ol>` : '<p class="hc-empty">No sales yet today.</p>');
    }
    _lowStock({ lowStock: lowStock, canInventory: canInventory }) {
        if (!lowStock) return this._shell('lowStock', 'Low stock', '', '', '<p class="hc-empty">Loading\u2026</p>');
        const rows = lowStock.map((it)=>{
            const inner = `
        <span class="hc-row-text"><b>${(0, $cnCXJ.esc)(it.name)}</b><small>${(0, $cnCXJ.esc)(`${it.quantity} ${it.unit ?? ''}`.trim())} left</small></span>
        <span class="hc-chip ${it.out ? 'hc-chip--out' : 'hc-chip--low'}">${it.out ? 'Out' : 'Low'}</span>`;
            return canInventory ? `<li><button type="button" class="hc-row hc-row--btn" data-hc-act="inventory">${inner}</button></li>` : `<li class="hc-row">${inner}</li>`;
        }).join('');
        return this._shell('lowStock', 'Low stock', lowStock.length ? $717baed02964aa54$var$plural(lowStock.length, 'item') : '', canInventory ? this._link('Inventory', 'inventory') : '', rows ? `<ul class="hc-list">${rows}</ul>` : '<p class="hc-empty">Nothing is running low.</p>');
    }
    // "+12% vs ..." line under a sales card title.
    _trend(now, before, vsLabel) {
        if (!before) return now > 0 ? `<span class="hc-trend hc-trend--up">New</span> ${vsLabel}` : '';
        const pct = Math.round((now - before) / before * 100);
        const up = pct >= 0;
        return `<span class="hc-trend ${up ? 'hc-trend--up' : 'hc-trend--down'}">${up ? "\u25B2" : "\u25BC"} ${Math.abs(pct)}%</span> ${vsLabel}`;
    }
    _salesToday({ salesTrend: t }) {
        if (!t) return this._shell('salesToday', 'Sales today', '', '', '<p class="hc-empty">Loading\u2026</p>');
        const max = Math.max(1, ...t.hours.map((h)=>Math.max(h.today, h.yday)));
        const bars = t.hours.map((h)=>`
      <div class="hc-col${h.now ? ' hc-col--now' : ''}" title="${h.label}: ${(0, $coRoT.formatMoney)(h.today)} (yesterday ${(0, $coRoT.formatMoney)(h.yday)})">
        <div class="hc-col-bars">
          <i class="hc-col-ghost" style="height:${h.yday / max * 100}%"></i>
          ${h.future ? '' : `<i class="hc-col-fill" style="height:${Math.max(h.today ? 3 : 0, h.today / max * 100)}%"></i>`}
        </div>
        <span class="hc-col-label">${h.showLabel ? h.label : ''}</span>
      </div>`).join('');
        const best = t.hours.filter((h)=>!h.future && h.today > 0).sort((a, b)=>b.today - a.today)[0];
        return this._shell('salesToday', 'Sales today', `<b class="hc-big">${(0, $coRoT.formatMoney)(t.total)}</b> ${this._trend(t.total, t.ydaySoFar, 'vs this time yesterday')}`, this._link('Reports', 'reports'), `
      <div class="hc-chart" role="img" aria-label="Sales by hour today, ${(0, $coRoT.formatMoney)(t.total)} so far">${bars}</div>
      <div class="hc-legend">
        <span><i class="hc-key hc-key--today"></i>Today</span>
        <span><i class="hc-key hc-key--ghost"></i>Yesterday</span>
        ${best ? `<span class="hc-legend-note">Busiest so far: ${best.label}</span>` : ''}
      </div>`);
    }
    _salesWeek({ salesTrend: t }) {
        if (!t) return this._shell('salesWeek', 'Last 7 days', '', '', '<p class="hc-empty">Loading\u2026</p>');
        const max = Math.max(1, ...t.days.map((d)=>Math.max(d.value, d.prev)));
        const best = [
            ...t.days
        ].sort((a, b)=>b.value - a.value)[0];
        const bars = t.days.map((d)=>`
      <div class="hc-col hc-col--day${d.today ? ' hc-col--now' : ''}" title="${d.label}: ${(0, $coRoT.formatMoney)(d.value)} (week before ${(0, $coRoT.formatMoney)(d.prev)})">
        <span class="hc-col-value">${d.value ? $717baed02964aa54$var$shortMoney(d.value) : ''}</span>
        <div class="hc-col-bars">
          <i class="hc-col-ghost" style="height:${d.prev / max * 100}%"></i>
          <i class="hc-col-fill" style="height:${Math.max(d.value ? 3 : 0, d.value / max * 100)}%"></i>
        </div>
        <span class="hc-col-label">${d.short}</span>
      </div>`).join('');
        return this._shell('salesWeek', 'Last 7 days', `<b class="hc-big">${(0, $coRoT.formatMoney)(t.weekTotal)}</b> ${this._trend(t.weekTotal, t.prevWeekTotal, 'vs the 7 days before')}`, this._link('Reports', 'reports'), `
      <div class="hc-chart hc-chart--week" role="img" aria-label="Sales for the last 7 days, ${(0, $coRoT.formatMoney)(t.weekTotal)}">${bars}</div>
      <div class="hc-legend">
        <span><i class="hc-key hc-key--today"></i>This week</span>
        <span><i class="hc-key hc-key--ghost"></i>Week before</span>
        ${best?.value ? `<span class="hc-legend-note">Best day: ${best.label}</span>` : ''}
      </div>`);
    }
    _schedule({ schedule: s }) {
        if (!s) return this._shell('schedule', "Today's schedule", '', '', '<p class="hc-empty">Loading\u2026</p>');
        const chip = {
            working: '<span class="hc-chip hc-chip--on">Working</span>',
            break: '<span class="hc-chip hc-chip--break">On break</span>',
            late: '<span class="hc-chip hc-chip--late">Not in yet</span>',
            done: '<span class="hc-chip">Done</span>',
            open: '<span class="hc-chip hc-chip--open">Open shift</span>'
        };
        const rows = s.rows.map((r)=>`
      <li class="hc-row hc-row--shift${r.state === 'done' ? ' hc-row--muted' : ''}" style="--station:${(0, $cnCXJ.esc)(r.color || '#64748B')}">
        <span class="hc-shift-bar" aria-hidden="true"></span>
        <span class="hc-row-text">
          <b>${r.open ? 'Open shift' : (0, $cnCXJ.esc)(r.name)}</b>
          <small>${r.time}${r.station ? ` \xb7 ${(0, $cnCXJ.esc)(r.station)}` : ''}</small>
        </span>
        ${chip[r.state] ?? `<span class="hc-chip">${(0, $cnCXJ.esc)(r.startsIn)}</span>`}
      </li>`).join('');
        const late = s.rows.filter((r)=>r.state === 'late').length;
        return this._shell('schedule', "Today's schedule", s.rows.length ? `${$717baed02964aa54$var$plural(s.rows.length, 'shift')}${late ? ` \xb7 <span class="hc-warn">${late} not in yet</span>` : ''}` : '', s.canOpen ? this._link('Schedule', 'schedule') : '', rows ? `<ul class="hc-list">${rows}</ul>` : '<p class="hc-empty">No shifts scheduled today.</p>');
    }
    _inbox({ inbox: inbox }) {
        if (!inbox) return this._shell('inbox', 'Needs your OK', '', '', '<p class="hc-empty">Loading\u2026</p>');
        const total = inbox.reduce((s, r)=>s + r.count, 0);
        const rows = inbox.filter((r)=>r.count > 0).map((r)=>`
      <li><button type="button" class="hc-row hc-row--btn" data-hc-act="inbox" data-cat="${r.cat}">
        <span class="hc-inbox-icon hc-inbox-icon--${r.cat}" aria-hidden="true">${$717baed02964aa54$var$svg(r.icon, 18)}</span>
        <span class="hc-row-text"><b>${r.label}</b><small>${r.sub}</small></span>
        <span class="hc-count-badge">${r.count}</span>
      </button></li>`).join('');
        return this._shell('inbox', 'Needs your OK', total ? `${$717baed02964aa54$var$plural(total, 'thing')} waiting for you` : '', '', rows ? `<ul class="hc-list">${rows}</ul>` : `
        <div class="hc-empty-box">
          <span class="hc-done-icon" aria-hidden="true">${$717baed02964aa54$var$svg('<path d="M20 6 9 17l-5-5"/>', 22)}</span>
          <p class="hc-empty">All caught up. Nothing is waiting for you.</p>
        </div>`);
    }
    _purchaseOrders({ pos: pos }) {
        if (!pos) return this._shell('purchaseOrders', 'Purchase orders', '', '', '<p class="hc-empty">Loading\u2026</p>');
        const rows = pos.open.map((p)=>`
      <li><button type="button" class="hc-row hc-row--btn" data-hc-act="po" data-id="${p.id}">
        <span class="hc-row-text">
          <b>${p.label}${p.supplier ? ` <span class="hc-row-meta">\xb7 ${(0, $cnCXJ.esc)(p.supplier)}</span>` : ''}</b>
          <small>${$717baed02964aa54$var$plural(p.lines, 'item')} \xb7 ${(0, $coRoT.formatMoney)(p.total)}</small>
        </span>
        <span class="hc-chip${p.overdue ? ' hc-chip--late' : ''}">${(0, $cnCXJ.esc)(p.when)}</span>
      </button></li>`).join('');
        return this._shell('purchaseOrders', 'Purchase orders', pos.open.length ? `${$717baed02964aa54$var$plural(pos.open.length, 'order')} on the way` : '', this._link('Inventory', 'inventory'), `
      ${rows ? `<ul class="hc-list">${rows}</ul>` : '<p class="hc-empty">No orders on the way.</p>'}
      ${pos.drafts ? `<button type="button" class="hc-note" data-hc-act="inbox" data-cat="po">${$717baed02964aa54$var$plural(pos.drafts, 'draft')} not sent yet</button>` : ''}`);
    }
    _onCardClick(e) {
        const swap = e.target.closest('[data-swap-card]');
        if (swap) {
            this._handlers.onSwapCard(swap.dataset.swapCard, swap);
            return;
        }
        const btn = e.target.closest('[data-hc-act]');
        if (!btn) return;
        if (btn.dataset.hcAct === 'area') {
            this._area = btn.dataset.area;
            this._handlers.onAction('rerender', btn.dataset);
            return;
        }
        this._handlers.onAction(btn.dataset.hcAct, btn.dataset);
    }
    // ── Picker ────────────────────────────────────────────────────────────────
    // options: [{ key, label, desc?, value?, group?, selected, disabled, tag? }]
    openPicker({ anchor: anchor, kind: kind, title: title, sub: sub, options: options, onPick: onPick, onSuggested: onSuggested }) {
        this.closePicker();
        const scrim = document.createElement('div');
        scrim.className = 'hc-picker-scrim';
        const box = document.createElement('section');
        box.className = `hc-picker hc-picker--${kind}`;
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-label', title);
        const optionBtn = (o)=>`
      <button type="button" class="hc-opt${o.selected ? ' hc-opt--on' : ''}" data-pick="${o.key}"${o.disabled ? ' disabled aria-disabled="true"' : ''} aria-pressed="${o.selected}">
        ${kind === 'card' ? `<span class="hc-opt-icon">${$717baed02964aa54$var$svg($717baed02964aa54$var$CARD_ICONS[o.key] ?? '')}</span>` : ''}
        <span class="hc-opt-text">
          <span class="hc-opt-label">${(0, $cnCXJ.esc)(o.label)}</span>
          ${o.value != null ? `<span class="hc-opt-value">${(0, $cnCXJ.esc)(o.value)}</span>` : ''}
          ${o.desc ? `<span class="hc-opt-desc">${(0, $cnCXJ.esc)(o.desc)}</span>` : ''}
        </span>
        ${o.tag ? `<span class="hc-opt-tag${o.tag === 'Pro' ? ' hc-opt-tag--pro' : ''}">${(0, $cnCXJ.esc)(o.tag)}</span>` : ''}
        ${o.selected ? `<span class="hc-opt-check" aria-hidden="true">${$717baed02964aa54$var$svg('<path d="M20 6 9 17l-5-5"/>', 18)}</span>` : ''}
      </button>`;
        const groups = [
            ...new Set(options.map((o)=>o.group))
        ];
        const list = groups.map((g)=>`
      <div class="hc-opt-group">
        <p class="hc-opt-group-name">${(0, $cnCXJ.esc)(g)}</p>
        <div class="${kind === 'tile' ? 'hc-opt-grid' : 'hc-opt-list'}">${options.filter((o)=>o.group === g).map(optionBtn).join('')}</div>
      </div>`).join('');
        box.innerHTML = `
      <div class="hc-picker-head">
        <div>
          <h2 class="hc-picker-title">${(0, $cnCXJ.esc)(title)}</h2>
          <p class="hc-picker-sub">${(0, $cnCXJ.esc)(sub)}</p>
        </div>
        <button type="button" class="hc-picker-close" data-close aria-label="Close">&times;</button>
      </div>
      <div class="hc-picker-body">${list}</div>
      <div class="hc-picker-foot">
        <span>${kind === 'tile' ? "Picking one that's already showing swaps the two." : 'Only changes this device. Nothing is turned off.'}</span>
        <button type="button" class="hc-link" data-suggest>Use suggested</button>
      </div>`;
        document.body.append(scrim, box);
        this._picker = {
            scrim: scrim,
            box: box,
            anchor: anchor
        };
        this._placePicker();
        const close = ()=>this.closePicker(true);
        scrim.addEventListener('click', close);
        box.addEventListener('click', (e)=>{
            if (e.target.closest('[data-close]')) return close();
            if (e.target.closest('[data-suggest]')) {
                this.closePicker(true);
                onSuggested();
                return;
            }
            const opt = e.target.closest('[data-pick]');
            if (opt && !opt.disabled) {
                this.closePicker(true);
                onPick(opt.dataset.pick);
            }
        });
        box.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                close();
            }
        });
        this._onResize = ()=>this._placePicker();
        window.addEventListener('resize', this._onResize);
        (box.querySelector('.hc-opt--on') ?? box.querySelector('.hc-opt:not([disabled])'))?.focus();
    }
    _placePicker() {
        const p = this._picker;
        if (!p) return;
        const vw = window.innerWidth, vh = window.innerHeight;
        if (vw <= 600) {
            p.box.classList.add('hc-picker--sheet');
            p.box.style.cssText = '';
            return;
        }
        p.box.classList.remove('hc-picker--sheet');
        const r = p.anchor.getBoundingClientRect();
        const w = p.box.offsetWidth, h = p.box.offsetHeight;
        const left = Math.min(Math.max(12, r.right - w), vw - w - 12);
        let top = r.bottom + 8;
        if (top + h > vh - 12) top = Math.max(12, vh - h - 12);
        p.box.style.left = `${left}px`;
        p.box.style.top = `${top}px`;
    }
    closePicker(restoreFocus = false) {
        const p = this._picker;
        if (!p) return;
        p.scrim.remove();
        p.box.remove();
        window.removeEventListener('resize', this._onResize);
        this._picker = null;
        if (restoreFocus && p.anchor.isConnected) p.anchor.focus();
    }
}
var $717baed02964aa54$export$2e2bcd8739ae039 = new $717baed02964aa54$var$HomeCardsView();






var $cnCXJ = parcelRequire("cnCXJ");

var $coRoT = parcelRequire("coRoT");

var $abGsl = parcelRequire("abGsl");



// Minimal ESC/POS encoder for 58mm / 80mm thermal printers.
//
// Produces a Uint8Array of printer command bytes from a Pointbunny sale object -
// the same data the HTML receipt (receiptView.js) renders, but as ESC/POS so it
// can be streamed to a Bluetooth thermal printer (btPrinter.js).
//
// Text is reduced to printable ASCII: generic thermal printers default to the
// CP437 code page and won't render UTF-8, so non-ASCII characters are
// transliterated where possible and otherwise dropped (best-effort, never throws).

var $cggJi = parcelRequire("cggJi");


var $coRoT = parcelRequire("coRoT");


var $dv0h8 = parcelRequire("dv0h8");

const $9b70c844273b1ba0$var$ESC = 0x1b;
const $9b70c844273b1ba0$var$GS = 0x1d;
// Characters per line at Font A: 58mm paper fits ~32, 80mm fits ~48.
const $9b70c844273b1ba0$var$COLS = {
    58: 32,
    80: 48
};
class $9b70c844273b1ba0$var$Encoder {
    constructor(cols){
        this.cols = cols;
        this.bytes = [];
    }
    raw(...b) {
        for (const x of b)this.bytes.push(x & 0xff);
        return this;
    }
    _ascii(str) {
        return String(str ?? "").replace(/[‘’′]/g, "'").replace(/[“”″]/g, '"').replace(/[–—]/g, "-").replace(/₱/g, "P") // peso sign -> P (printer-safe)
        .replace(/[^\x20-\x7E]/g, ""); // drop remaining non-ASCII
    }
    text(str) {
        const s = this._ascii(str);
        for(let i = 0; i < s.length; i++)this.bytes.push(s.charCodeAt(i) & 0xff);
        return this;
    }
    lf(n = 1) {
        for(let i = 0; i < n; i++)this.bytes.push(0x0a);
        return this;
    }
    line(str = "") {
        return this.text(str).lf();
    }
    init() {
        return this.raw($9b70c844273b1ba0$var$ESC, 0x40); // ESC @  (reset)
    }
    align(n) {
        return this.raw($9b70c844273b1ba0$var$ESC, 0x61, n); // 0 left, 1 center, 2 right
    }
    bold(on) {
        return this.raw($9b70c844273b1ba0$var$ESC, 0x45, on ? 1 : 0);
    }
    // QR code as a GS v 0 raster image (supported far more widely than the
    // native GS ( k QR command). One module = `scale` dots, sized to ~80% of
    // the paper (Font A is 12 dots per column), with a 4-module quiet zone.
    qr(matrix) {
        const q = 4;
        const n = matrix.size + q * 2;
        const scale = Math.max(2, Math.min(6, Math.floor(this.cols * 12 * 0.8 / n)));
        const wDots = n * scale;
        const wBytes = Math.ceil(wDots / 8);
        this.raw($9b70c844273b1ba0$var$GS, 0x76, 0x30, 0, wBytes & 0xff, wBytes >> 8, wDots & 0xff, wDots >> 8);
        for(let y = 0; y < wDots; y++){
            const r = Math.floor(y / scale) - q;
            for(let xb = 0; xb < wBytes; xb++){
                let byte = 0;
                for(let bit = 0; bit < 8; bit++){
                    const x = xb * 8 + bit;
                    const c = Math.floor(x / scale) - q;
                    if (x < wDots && r >= 0 && r < matrix.size && c >= 0 && c < matrix.size && matrix.dark(r, c)) byte |= 0x80 >> bit;
                }
                this.bytes.push(byte);
            }
        }
        return this.lf();
    }
    // width / height are 1..8 multipliers.
    size(w, h) {
        const n = (w - 1 & 0x07) << 4 | h - 1 & 0x07;
        return this.raw($9b70c844273b1ba0$var$GS, 0x21, n); // GS !
    }
    divider(ch = "-") {
        return this.line(ch.repeat(this.cols));
    }
    // A left label and a right value padded to fill the line. If the label is too
    // long it wraps onto following lines with the value kept on the first line.
    row(left, right) {
        left = this._ascii(left);
        right = this._ascii(right);
        const max = this.cols - right.length - 1;
        if (left.length <= max || max <= 0) {
            const pad = Math.max(1, this.cols - left.length - right.length);
            return this.line(left + " ".repeat(pad) + right);
        }
        const first = left.slice(0, max);
        const pad = Math.max(1, this.cols - first.length - right.length);
        this.line(first + " ".repeat(pad) + right);
        let rest = left.slice(max);
        while(rest.length){
            this.line(rest.slice(0, this.cols));
            rest = rest.slice(this.cols);
        }
        return this;
    }
    cut() {
        return this.lf(4).raw($9b70c844273b1ba0$var$GS, 0x56, 0x42, 0x00); // feed + partial cut (ignored if no cutter)
    }
    done() {
        return new Uint8Array(this.bytes);
    }
}
// Thermal printers can't render symbols like ₱/€/£, so print the currency CODE
// instead (e.g. "PHP 100.00"). Currency follows the business country.
const $9b70c844273b1ba0$var$money = (n)=>(0, $coRoT.formatMoney)(n, {
        ascii: true
    });
// Negative amounts read better as "-PHP 5.00" than "PHP -5.00".
const $9b70c844273b1ba0$var$signedMoney = (n)=>n < 0 ? "-" + $9b70c844273b1ba0$var$money(Math.abs(n)) : "+" + $9b70c844273b1ba0$var$money(n);
function $9b70c844273b1ba0$export$3a40b3618ea1d38a(sale, { width: width = 80 } = {}) {
    const cols = $9b70c844273b1ba0$var$COLS[width] ?? $9b70c844273b1ba0$var$COLS[80];
    const e = new $9b70c844273b1ba0$var$Encoder(cols);
    const date = new Date(sale.date);
    const dateStr = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric"
    });
    const timeStr = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit"
    });
    const storeName = sale.storeName?.includes("@") ? "POINTBUNNY POS" : sale.storeName ?? "POINTBUNNY POS";
    const paymentMethod = sale.paymentMethod ?? "cash";
    const paymentLabel = {
        cash: "Cash",
        card: "Card",
        qr: "QR"
    }[paymentMethod] ?? "Cash";
    e.init();
    // ── Header ──
    e.align(1).bold(true).size(2, 2).line(storeName).size(1, 1).bold(false);
    if (sale.addressStreet) {
        e.line(sale.addressStreet);
        const locality = [
            sale.addressCity,
            sale.addressProvince
        ].filter(Boolean).join(", ");
        const localityZip = [
            locality,
            sale.addressZip
        ].filter(Boolean).join(" ");
        if (localityZip) e.line(localityZip);
    }
    if (sale.businessPhone && sale.showBusinessPhone !== false) e.line(sale.businessPhone);
    e.line(`${dateStr}  ${timeStr}`);
    if (sale.showInvoiceNumber !== false && sale.receiptNumber != null) e.bold(true).line(`${(0, $78df0284a57ee0dd$export$bb60034feb8a6f01)(sale.addressCountry)} ${(0, $78df0284a57ee0dd$export$1fa50150e73e75ba)(sale.receiptNumber, sale.date)}`).bold(false);
    if (sale.cashierName && sale.showCashier !== false) e.line(`Cashier: ${sale.cashierName}`);
    if (sale.orderType) e.bold(true).line((0, $cggJi.orderTypeLabel)(sale.orderType, sale.addressCountry, {
        upper: true
    })).bold(false);
    if (sale.tableName) e.bold(true).line(`TABLE ${sale.tableName}`).bold(false);
    if (sale.showTicketNumber !== false && sale.ticketNumber != null) e.lf().bold(true).size(2, 2).line(`TICKET #${sale.ticketNumber}`).size(1, 1).bold(false);
    // ── Items ──
    // Free-item reward redemptions print as $0 (FREE) on the item's own row
    // instead of a separate "Free X (Reward)" discount line - no strikethrough
    // on plain ESC/POS text, so a (FREE) tag carries the same meaning.
    const redeemedLineIds = (0, $dv0h8.redeemedRewardLineIds)(sale.adjustments);
    e.align(0).divider();
    for (const item of sale.items){
        const isFreeReward = redeemedLineIds.has(item.lineId);
        const label = `${item.itemName} x${item.quantity}${isFreeReward ? " (FREE)" : ""}`;
        e.row(label, $9b70c844273b1ba0$var$money(isFreeReward ? 0 : item.totalPrice));
        const variants = item.selectedVariants?.map((v)=>v.variantName).filter(Boolean).join(", ");
        if (variants) e.line("  " + variants);
    }
    // ── Adjustments ──
    const activeAdj = (sale.adjustments ?? []).filter((a)=>!a.removed && a.computedAmount !== undefined && a.source !== "loyalty_reward");
    const removedAdj = sale.showRemovedAdjustments ? sale.removedAdjustments ?? [] : [];
    if (activeAdj.length || removedAdj.length) {
        e.divider();
        e.row("Subtotal", $9b70c844273b1ba0$var$money(sale.subtotal ?? sale.totalPrice));
        for (const adj of activeAdj){
            const name = adj.name + (adj.calculation === "percentage" ? ` (${adj.appliedValue}%)` : "");
            e.row(name, $9b70c844273b1ba0$var$signedMoney(Number(adj.computedAmount)));
        }
        for (const adj of removedAdj){
            const name = adj.name + (adj.calculation === "percentage" ? ` (${adj.appliedValue}%)` : "") + " (removed)";
            e.row(name, "--");
        }
    }
    // ── Totals ──
    e.divider();
    e.bold(true).size(1, 2).row("TOTAL", $9b70c844273b1ba0$var$money(sale.totalPrice)).size(1, 1).bold(false);
    // Tax-inclusive breakdown (total unchanged; tax is extracted from it).
    // Per-item exemption (2026-07-07): only taxable items feed the VAT extraction;
    // exempt items get their own gross line. Gated on the sale actually being
    // tax-inclusive so an all-exempt sale still prints its exempt-sales line.
    const isInclusiveSale = Number(sale.taxInclusiveRate) > 0;
    const { taxableGross: taxableGross, exemptGross: exemptGross } = (0, $ff150a18d4a6f5bb$export$1a11748b971a7a75)(sale.items, (it)=>it.taxClass === "exempt");
    const vat = isInclusiveSale ? (0, $ff150a18d4a6f5bb$export$b07c8f45d340b388)(taxableGross, sale.taxInclusiveRate) : null;
    if (vat) {
        const lbl = (0, $ff150a18d4a6f5bb$export$c829991a0e9a63)(sale.addressCountry);
        e.row(`${lbl}able Sales`, $9b70c844273b1ba0$var$money(vat.net));
        e.row(`${lbl} (${vat.rate}%)`, $9b70c844273b1ba0$var$money(vat.tax));
    }
    // Tax added at checkout: a sale with a tax line also lists its exempt sales.
    const hasAddedTax = (sale.adjustments ?? []).some((a)=>a.isTax && !a.removed);
    if ((isInclusiveSale || hasAddedTax) && exemptGross > 0) e.row(`${(0, $ff150a18d4a6f5bb$export$d9b10f19e66f377b)(sale.addressCountry)} Sales`, $9b70c844273b1ba0$var$money(exemptGross));
    // Tip sits outside the sale total (never taxed).
    const tip = Number(sale.tipAmount) || 0;
    if (tip > 0) {
        e.row("Tip", $9b70c844273b1ba0$var$money(tip));
        e.bold(true).row("TOTAL WITH TIP", $9b70c844273b1ba0$var$money(Number(sale.totalPrice) + tip)).bold(false);
    }
    e.row("Payment", paymentLabel);
    if (paymentMethod === "cash") {
        e.row("Cash Tendered", $9b70c844273b1ba0$var$money(sale.customerPayment));
        e.bold(true).row("Change", $9b70c844273b1ba0$var$money(sale.customerChange)).bold(false);
    } else e.bold(true).row("Paid in full", $9b70c844273b1ba0$var$money(Number(sale.totalPrice) + tip)).bold(false);
    // ── Footer ──
    e.divider();
    // Custom footer + feedback QR are Pro-only (free keeps the default line).
    const paid = !sale.isFreePlan;
    e.align(1).line(paid && sale.receiptFooter ? sale.receiptFooter : "Thank you for your purchase!");
    const feedbackQr = paid ? (0, $9db03be56d1ffd3b$export$7ec6fdd2f863a10d)(sale.receiptQrUrl) : null;
    if (feedbackQr) e.qr(feedbackQr);
    // Free-plan branding (see CLAUDE.md "Free vs. Paid Plan Gating") - a slogan
    // pitched at the customer holding the receipt, not an "upgrade" nag. It takes
    // the place of the "Powered by" line as one short spaced-out block with no
    // extra divider rules (the HTML receipt draws it as a single rounded badge).
    // The slogan is split in two so it never wraps mid-word on 58mm (32 cols).
    if (sale.isFreePlan) e.lf().bold(true).line("P O I N T B U N N Y   P O S").bold(false).line("The all-in-one POS").line("to run your shop").bold(true).line("pointbunny.com").bold(false);
    else e.bold(true).line("Powered by Pointbunny POS").bold(false);
    e.cut();
    return e.done();
}



var $3kKUy = parcelRequire("3kKUy");




var $cggJi = parcelRequire("cggJi");

// Guided tutorials ("tours"): a spotlight + coach-mark card that walks the user
// through the REAL app (no fake demo screens). Generic engine only - the tour
// content lives in tours.js and reaches the app through the `api` object the
// controller passes to init(), so this module never touches the model.
//
// Step shape (every field may also be a function of `api`, evaluated live):
//   id        unique within the tour
//   chapter   chapter id (tour.chapters) - resume restarts at a chapter's start
//   title / body / tip   copy (authored HTML, never user data)
//   target    selector | selector[] | () => Element. First VISIBLE match wins,
//             re-resolved every frame, so a list lets the spotlight hop onto a
//             sub-modal the moment it opens (e.g. the variant picker).
//   mode      'next' (default: Next button) | 'click' (advance when the target
//             is clicked) | 'wait' (advance on `signal` / `until`)
//   signal    name or names that advance a 'wait' step (Tour.signal from the controller)
//   until     () => bool, polled; true advances
//   skipIf    () => bool, checked on arrival (already-satisfied steps are skipped)
//   next      step id to jump to instead of the following step
//   action    { label, run } extra card button (e.g. "Open it now")
//   block     false lets clicks through outside the spotlight (default true).
//             'next' steps are look-only: even the spotlit element is blocked.
//
//   onEnter   (api) => void, runs on arrival (navigate the panel for this step)
//
// Tour-level: practice (controller swaps real sales for pretend ones while it
// runs, see practiceMode), onStart(api) (load pretend data before the panel
// opens), onEnd(api) (cleanup however the tour ends), resumable: false
// (always restart from step 1 - for tours built on rebuilt practice data).
// Steps can't be skipped one by one - only the whole tour, which then
// spotlights the ? button so the user knows how to come back.
//   placement 'bottom' | 'top' | 'right' | 'left' preference for the card
//
// Progress is per user, per browser (localStorage, keyed by user id so one
// account's progress never leaks into another on a shared terminal).
const $399d412ac621ced9$var$STORE_PREFIX = "pointbunny_tours_v1:";
const $399d412ac621ced9$var$MISSING_GRACE_MS = 700; // a target that vanishes briefly (re-render, modal swap) keeps its spot
const $399d412ac621ced9$var$PAD = 8;
const $399d412ac621ced9$var$visible = (el)=>{
    if (!el || !el.isConnected) return false;
    const r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    // Above/below the fold still counts (it can be scrolled into view), but
    // fully off to the side means an off-canvas drawer or slide-out that is
    // closed - never a target.
    if (r.right <= 0 || r.left >= window.innerWidth) return false;
    const cs = getComputedStyle(el);
    if (cs.visibility === "hidden" || cs.display === "none") return false;
    return !$399d412ac621ced9$var$covered(el, r);
};
// Something else painted on top of it (e.g. the navbar "?" while a
// full-screen panel is open)? Checked at the element's centre, ignoring the
// tour's own layers. Below-the-fold centres can't be probed - not covered.
const $399d412ac621ced9$var$covered = (el, r)=>{
    const x = r.left + r.width / 2;
    const y = r.top + r.height / 2;
    if (x < 0 || y < 0 || x > window.innerWidth || y > window.innerHeight) return false;
    const top = document.elementsFromPoint(x, y).find((n)=>!n.closest(".tour-root"));
    return !!top && top !== el && !el.contains(top) && !top.contains(el);
};
class $399d412ac621ced9$var$TourEngine {
    _tours = new Map();
    _order = [];
    _api = {};
    _userId = null;
    _store = {
        offered: {},
        tours: {}
    };
    _persist = null;
    _syncTimer = null;
    _run = null;
    _els = null;
    _raf = 0;
    _lastLogic = 0;
    _offerTimer = null;
    _hubEl = null;
    // ── Setup ──────────────────────────────────────────────────────────────────
    init({ tours: tours, api: api, userId: userId, remote: remote = null, persist: persist = null }) {
        this._api = api ?? {};
        this._tours.clear();
        this._order = [];
        (tours ?? []).forEach((t)=>{
            this._tours.set(t.id, t);
            this._order.push(t.id);
        });
        this._userId = userId ?? "anon";
        this._persist = persist;
        this._store = this._merge(this._load(), remote);
        try {
            localStorage.setItem(this._key(), JSON.stringify(this._store));
        } catch (_) {}
        // This browser knew something the account didn't (progress from before
        // syncing existed, or a save that never made it): push it up.
        if (persist && JSON.stringify(this._store) !== JSON.stringify(this._merge(this._blank(), remote))) this._queueSync();
        this._wireGlobal();
        this.mountHelpButtons();
        this._syncHubBtn();
    }
    // Stops everything silently (sign-out). Progress already saved stays saved.
    stop() {
        this._flushSync();
        clearInterval(this._offerTimer);
        this._offerTimer = null;
        if (this._run) this._teardown();
        this._closeHub();
    }
    isRunning() {
        return !!this._run;
    }
    // ── Persistence ────────────────────────────────────────────────────────────
    _key() {
        return $399d412ac621ced9$var$STORE_PREFIX + this._userId;
    }
    _blank() {
        return {
            offered: {},
            tours: {}
        };
    }
    _load() {
        try {
            const raw = JSON.parse(localStorage.getItem(this._key()) ?? "null");
            if (raw && typeof raw === "object") return {
                offered: raw.offered ?? {},
                tours: raw.tours ?? {}
            };
        } catch (_) {}
        return this._blank();
    }
    // Combines this browser's copy with the account's synced copy. Whichever
    // has got further wins per tour (done > skipped > paused > active > new),
    // finished chapters are unioned, and "offered" sticks once either side set
    // it - so a tour finished or dismissed anywhere never auto-starts again.
    _merge(local, remote) {
        const rank = {
            new: 0,
            active: 1,
            paused: 2,
            skipped: 3,
            done: 4
        };
        const out = {
            offered: {
                ...local.offered ?? {}
            },
            tours: {
                ...local.tours ?? {}
            }
        };
        if (!remote || typeof remote !== "object") return out;
        Object.entries(remote.offered ?? {}).forEach(([id, v])=>{
            if (v) out.offered[id] = true;
        });
        Object.entries(remote.tours ?? {}).forEach(([id, r])=>{
            if (!r || typeof r !== "object") return;
            const l = out.tours[id];
            if (!l) {
                out.tours[id] = r;
                return;
            }
            const winner = (rank[r.status] ?? 0) > (rank[l.status] ?? 0) ? r : l;
            out.tours[id] = {
                ...winner,
                chapters: [
                    ...new Set([
                        ...l.chapters ?? [],
                        ...r.chapters ?? []
                    ])
                ]
            };
        });
        return out;
    }
    _save() {
        try {
            localStorage.setItem(this._key(), JSON.stringify(this._store));
        } catch (_) {}
        this._syncHubBtn();
        this._queueSync();
    }
    // Account sync is debounced: steps save on every move, the account only
    // needs to hear about it once things settle.
    _queueSync() {
        if (!this._persist) return;
        clearTimeout(this._syncTimer);
        this._syncTimer = setTimeout(()=>this._flushSync(), 1500);
    }
    _flushSync() {
        if (!this._persist || !this._syncTimer) return;
        clearTimeout(this._syncTimer);
        this._syncTimer = null;
        Promise.resolve(this._persist(this._store)).catch(()=>{});
    }
    progress(id) {
        const p = this._store.tours[id] ?? {};
        return {
            status: p.status ?? "new",
            step: p.step ?? null,
            chapters: p.chapters ?? []
        };
    }
    _setProgress(id, patch) {
        this._store.tours[id] = {
            ...this.progress(id),
            ...patch
        };
        this._save();
    }
    // ── Starting / resuming ────────────────────────────────────────────────────
    // Offers a tour once per user: waits until the app is idle (no onboarding,
    // PIN setup, or open modal) and then opens the tour's first step, which is
    // expected to be a welcome card with a "Maybe later" option.
    offer(id) {
        const tour = this._tours.get(id);
        if (!tour || this._store.offered[id] || this.progress(id).status !== "new") return;
        if (tour.can && !tour.can(this._api)) return;
        clearInterval(this._offerTimer);
        let calm = 0;
        this._offerTimer = setInterval(()=>{
            if (this._run) return;
            calm = this._api.isIdle?.() === false ? 0 : calm + 1;
            if (calm < 2) return;
            clearInterval(this._offerTimer);
            this._offerTimer = null;
            this._store.offered[id] = true;
            this._save();
            this.start(id, {
                fromStart: true
            });
        }, 800);
    }
    // Starts (or resumes) a tour. Resuming restarts at the beginning of the
    // chapter that was in progress; steps that are already satisfied are
    // skipped automatically by their skipIf.
    async start(id, { fromStart: fromStart = false, chapter: chapter = null } = {}) {
        const tour = this._tours.get(id);
        if (!tour) return;
        if (tour.can && !tour.can(this._api)) {
            this._api.toast?.("You don't have access to this part of the app yet.", "info");
            return;
        }
        if (this._run) this.pause({
            quiet: true
        });
        this._closeHub();
        // Practice tours load their pretend data before the panel opens (the
        // matching onEnd puts the real data back, see _teardown).
        if (tour.onStart) this._safe(()=>tour.onStart(this._api));
        if (tour.open && !tour.isOpen?.(this._api)) {
            try {
                await tour.open(this._api);
            } catch (_) {}
            await new Promise((r)=>setTimeout(r, 350));
        }
        const steps = tour.steps;
        let idx = 0;
        if (chapter) idx = Math.max(0, steps.findIndex((s)=>s.chapter === chapter));
        else if (!fromStart && tour.resumable !== false) {
            // Practice tours (resumable: false) always restart: their pretend data
            // is rebuilt fresh, so a mid-story step would have nothing to point at.
            const p = this.progress(id);
            if (p.status !== "done" && p.step) {
                const at = steps.findIndex((s)=>s.id === p.step);
                if (at > 0) idx = this._chapterEntry(tour, at);
            }
        }
        this._run = {
            tour: tour,
            idx: -1,
            history: [],
            targetEl: null,
            missingSince: 0,
            lastRect: null,
            scrolled: false
        };
        this._build();
        this._setProgress(id, {
            status: "active"
        });
        this._goTo(idx, {
            push: false
        });
    }
    // Index of the first step of the chapter containing `at`, stepping back one
    // chapter at a time while a chapter's `entry` check says the app isn't in
    // the state that chapter starts from (e.g. resuming "checkout" from home).
    _chapterEntry(tour, at) {
        const chapters = tour.chapters ?? [];
        let ch = tour.steps[at].chapter;
        if (!ch) return at;
        let ci = chapters.findIndex((c)=>c.id === ch);
        while(ci > 0 && chapters[ci].entry && !chapters[ci].entry(this._api))ci--;
        ch = chapters[ci]?.id ?? ch;
        return Math.max(0, tour.steps.findIndex((s)=>s.chapter === ch));
    }
    // The x: saves the spot, then points at the ? so they know how to come back.
    pause({ quiet: quiet = false } = {}) {
        if (!this._run) return;
        const { tour: tour } = this._run;
        if (tour.ephemeral) {
            this._teardown();
            return;
        }
        this._setProgress(tour.id, {
            status: "paused",
            step: this._step()?.id ?? null
        });
        this._teardown();
        if (!quiet) this._showReminder("Paused, not lost", tour.resumable === false ? "<p>Tap this <strong>?</strong> anytime to run this tutorial again. Every tutorial is also listed under the <strong>?</strong> at the top of the home screen.</p>" : "<p>Tap this <strong>?</strong> anytime to pick up right where you left off, or to replay any part.</p>");
    }
    // "Skip tutorial" / "Maybe later": ends the whole tour, same pointer to the ?.
    skip() {
        if (!this._run) return;
        const { tour: tour } = this._run;
        this._setProgress(tour.id, {
            status: "skipped",
            step: this._step()?.id ?? null
        });
        this._teardown();
        this._showReminder("No problem!", "<p>Whenever you want the tour, open <strong>Tutorials</strong> from here. You can start it again or jump straight to any part.</p>");
    }
    // True while a tour that wants pretend data (the first-sale tour) is on
    // screen - the controller swaps the real sale for a practice one.
    practiceMode() {
        return !!this._run?.tour.practice;
    }
    // One-card, unsaved "tour" that spotlights the ? button (or the mobile menu
    // button, where the ? lives on phones).
    _showReminder(title, body) {
        const tour = {
            id: "_reminder",
            ephemeral: true,
            title: "Tutorials",
            icon: "\uD83C\uDF93",
            // Tutorials lives in the top-bar profile menu: spotlight the profile
            // button (phones: the menu button) - both checked BEFORE .tour-help-btn,
            // or on home the Active Queue's own ? wins. When a full-screen panel
            // covers the top bar, that panel's ? next to its title.
            steps: [
                {
                    id: "reminder",
                    reminder: true,
                    target: [
                        "#tourHubBtn",
                        "#navProfileBtn",
                        "#navMenuBtn",
                        ".tour-help-btn"
                    ],
                    title: title,
                    body: body,
                    nextLabel: "Got it"
                }
            ]
        };
        this._run = {
            tour: tour,
            idx: -1,
            history: [],
            targetEl: null,
            missingSince: 0,
            lastRect: null,
            scrolled: false
        };
        this._build();
        this._goTo(0, {
            push: false
        });
        this._pulseHubBtn();
    }
    // Controller hook: "the user just did X". Advances the current 'wait' step,
    // or - for a fast user who got ahead of the card - jumps past a step a little
    // further on that was waiting for the same thing.
    signal(name) {
        if (!this._run) return;
        const { tour: tour, idx: idx } = this._run;
        const wants = (s)=>[].concat(this._val(s.signal) ?? []).includes(name);
        const cur = tour.steps[idx];
        if (cur && this._mode(cur) === "wait" && wants(cur)) {
            setTimeout(()=>this._next(), 120);
            return;
        }
        for(let j = idx + 1; j <= idx + 3 && j < tour.steps.length; j++){
            const s = tour.steps[j];
            if (s.chapter !== cur?.chapter) break;
            if (wants(s)) {
                setTimeout(()=>this._goTo(j + 1), 120);
                return;
            }
        }
    }
    // ── Step navigation ────────────────────────────────────────────────────────
    _val(v) {
        return typeof v === "function" ? v(this._api) : v;
    }
    _step() {
        return this._run ? this._run.tour.steps[this._run.idx] : null;
    }
    _mode(step) {
        return this._val(step.mode) ?? "next";
    }
    _next() {
        if (!this._run) return;
        const step = this._step();
        const jump = this._val(step?.next);
        const to = jump ? this._run.tour.steps.findIndex((s)=>s.id === jump) : this._run.idx + 1;
        this._goTo(to < 0 ? this._run.idx + 1 : to);
    }
    _back() {
        if (!this._run || !this._run.history.length) return;
        const prev = this._run.history.pop();
        this._goTo(prev, {
            push: false,
            noSkip: true
        });
    }
    _goTo(idx, { push: push = true, noSkip: noSkip = false } = {}) {
        const run = this._run;
        if (!run) return;
        const steps = run.tour.steps;
        if (!noSkip) while(idx < steps.length && steps[idx].skipIf && this._safe(()=>steps[idx].skipIf(this._api)))idx++;
        const prevStep = steps[run.idx];
        if (idx >= steps.length) {
            this._finish();
            return;
        }
        if (push && run.idx >= 0) run.history.push(run.idx);
        // Leaving a chapter forward marks it done.
        if (prevStep?.chapter && prevStep.chapter !== steps[idx].chapter && idx > run.idx) this._markChapter(run.tour.id, prevStep.chapter);
        run.idx = idx;
        run.targetEl = null;
        run.missingSince = performance.now();
        run.scrolled = false;
        run.lastRect = null;
        if (!run.tour.ephemeral) this._setProgress(run.tour.id, {
            status: "active",
            step: steps[idx].id
        });
        // Step setup (e.g. switch the panel to the section this step talks about).
        if (steps[idx].onEnter) this._safe(()=>steps[idx].onEnter(this._api));
        this._glide();
        this._renderCard();
        this._tick(true);
    }
    _markChapter(tourId, ch) {
        const chapters = new Set(this.progress(tourId).chapters);
        chapters.add(ch);
        this._setProgress(tourId, {
            chapters: [
                ...chapters
            ]
        });
    }
    _finish() {
        const { tour: tour } = this._run;
        if (!tour.ephemeral) {
            const all = (tour.chapters ?? []).map((c)=>c.id);
            this._setProgress(tour.id, {
                status: "done",
                step: null,
                chapters: all
            });
        }
        this._teardown();
    }
    _safe(fn) {
        try {
            return fn();
        } catch (_) {
            return false;
        }
    }
    // ── DOM: overlay, spotlight, blockers, card ────────────────────────────────
    _build() {
        if (this._els) return;
        const root = document.createElement("div");
        root.className = "tour-root";
        root.innerHTML = `
      <div class="tour-block" data-b="t"></div>
      <div class="tour-block" data-b="r"></div>
      <div class="tour-block" data-b="b"></div>
      <div class="tour-block" data-b="l"></div>
      <div class="tour-spot" aria-hidden="true"></div>
      <div class="tour-card" role="dialog" aria-modal="false" aria-labelledby="tourCardTitle" tabindex="-1"></div>`;
        document.body.appendChild(root);
        const blocks = [
            ...root.querySelectorAll(".tour-block")
        ];
        blocks.forEach((b)=>b.addEventListener("click", (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this._nudge();
            }));
        const card = root.querySelector(".tour-card");
        card.addEventListener("click", (e)=>this._onCardClick(e));
        this._els = {
            root: root,
            blocks: blocks,
            spot: root.querySelector(".tour-spot"),
            card: card
        };
        document.body.classList.add("tour-active");
        const loop = (t)=>{
            this._tick(false, t);
            this._raf = requestAnimationFrame(loop);
        };
        this._raf = requestAnimationFrame(loop);
    }
    _teardown() {
        const tour = this._run?.tour;
        cancelAnimationFrame(this._raf);
        this._els?.root.remove();
        this._els = null;
        this._run = null;
        document.body.classList.remove("tour-active");
        // Tours that create pretend data clean it up however they end
        // (finished, skipped, closed, or replaced by another tour).
        if (tour?.onEnd) this._safe(()=>tour.onEnd(this._api));
    }
    _renderCard() {
        const run = this._run;
        const step = this._step();
        if (!run || !step || !this._els) return;
        const { tour: tour } = run;
        const mode = this._mode(step);
        const chapters = tour.chapters ?? [];
        const ci = chapters.findIndex((c)=>c.id === step.chapter);
        const chip = ci >= 0 ? `${tour.icon ?? ""} Part ${ci + 1} of ${chapters.length} \xb7 ${chapters[ci].title}` : `${tour.icon ?? ""} ${tour.title}`;
        const pct = Math.round((run.idx + 1) / tour.steps.length * 100);
        const isLast = run.idx === tour.steps.length - 1;
        const tip = this._val(step.tip);
        const action = this._val(step.action);
        // No Back on a step that navigated somewhere (onEnter): going back would
        // show the previous card without undoing the navigation.
        const canBack = run.history.length > 0 && mode === "next" && !step.onEnter && this._mode(tour.steps[run.history[run.history.length - 1]]) === "next";
        const doHint = mode === "click" ? "Tap the highlighted spot to continue" : mode === "wait" ? this._val(step.waitHint) ?? "Go ahead, the tutorial follows along" : "";
        // Steps are never skippable one by one - the only way out is the whole
        // tutorial (which then points at the ? to come back).
        const skipBtn = step.reminder ? "" : step.welcome ? `<button class="tour-btn tour-btn--ghost" data-act="skip" type="button">Maybe later</button>` : `<button class="tour-btn tour-btn--ghost" data-act="skip" type="button">Skip tutorial</button>`;
        const backBtn = canBack ? `<button class="tour-btn tour-btn--ghost" data-act="back" type="button">Back</button>` : "";
        const primary = mode === "next" ? `<button class="tour-btn tour-btn--primary" data-act="next" type="button">${this._val(step.nextLabel) ?? (isLast ? "Finish" : "Next")}</button>` : "";
        this._els.card.className = `tour-card${step.welcome ? " tour-card--welcome" : ""}`;
        this._els.card.innerHTML = `
      <div class="tour-card-top">
        <span class="tour-card-chip">${chip}</span>
        <button class="tour-card-x" data-act="close" type="button" aria-label="Close tutorial" title="${tour.ephemeral ? "Close" : "Close (your progress is saved)"}">&times;</button>
      </div>
      ${step.welcome && tour.hero ? `<div class="tour-card-hero" aria-hidden="true">${tour.hero}</div>` : ""}
      <h3 class="tour-card-title" id="tourCardTitle">${this._val(step.title) ?? ""}</h3>
      <div class="tour-card-body">${this._val(step.body) ?? ""}</div>
      ${tip ? `<div class="tour-card-tip"><span class="tour-card-tip-icon" aria-hidden="true">\u{1F4A1}</span><div>${tip}</div></div>` : ""}
      ${doHint ? `<div class="tour-card-do"><span class="tour-card-do-emoji" aria-hidden="true">\u{1F446}</span>${doHint}</div>` : ""}
      ${action ? `<button class="tour-btn tour-btn--soft tour-card-action" data-act="action" type="button">${action.label}</button>` : ""}
      <div class="tour-card-foot">
        ${tour.ephemeral ? "" : `<div class="tour-card-bar" aria-hidden="true"><span style="width:${pct}%"></span></div>`}
        <div class="tour-card-btns">
          ${skipBtn}
          <span class="tour-card-spacer"></span>
          ${backBtn}
          ${primary}
        </div>
      </div>`;
        this._els.card.classList.remove("tour-card--in");
        this._els.card.offsetWidth;
        this._els.card.classList.add("tour-card--in");
        requestAnimationFrame(()=>{
            const focusEl = this._els?.card.querySelector('[data-act="next"]') ?? this._els?.card;
            focusEl?.focus({
                preventScroll: true
            });
        });
    }
    _onCardClick(e) {
        const btn = e.target.closest("[data-act]");
        if (!btn || !this._run) return;
        const act = btn.dataset.act;
        if (act === "next") this._next();
        else if (act === "back") this._back();
        else if (act === "close") this.pause();
        else if (act === "skip") this.skip();
        else if (act === "action") this._safe(()=>this._val(this._step().action)?.run(this._api));
    }
    _nudge() {
        const card = this._els?.card;
        if (!card) return;
        card.classList.remove("tour-card--nudge");
        card.offsetWidth;
        card.classList.add("tour-card--nudge");
    }
    // ── Frame loop: resolve target, position spotlight + card, poll conditions ──
    _resolveTarget(step) {
        const t = this._val(step.target);
        if (!t) return null;
        for (const s of [].concat(t)){
            if (!s) continue;
            const list = typeof s === "string" ? document.querySelectorAll(s) : [
                s
            ];
            for (const el of list)if ($399d412ac621ced9$var$visible(el) && !this._els?.root.contains(el)) return el;
        }
        return null;
    }
    _tick(force, now = performance.now()) {
        const run = this._run;
        if (!run || !this._els) return;
        const step = this._step();
        if (!step) return;
        const mode = this._mode(step);
        const wantsTarget = !!step.target;
        const el = wantsTarget ? this._resolveTarget(step) : null;
        if (el) {
            run.missingSince = 0;
            if (run.targetEl !== el) {
                run.targetEl = el;
                run.scrolled = false;
                this._glide();
            }
            if (!run.scrolled) {
                run.scrolled = true;
                const r = el.getBoundingClientRect();
                if (r.top < 60 || r.bottom > window.innerHeight - 20) el.scrollIntoView({
                    block: "center",
                    inline: "nearest",
                    behavior: "smooth"
                });
            }
            const r = el.getBoundingClientRect();
            const rect = {
                top: Math.max(4, r.top - $399d412ac621ced9$var$PAD),
                left: Math.max(4, r.left - $399d412ac621ced9$var$PAD),
                right: Math.min(window.innerWidth - 4, r.right + $399d412ac621ced9$var$PAD),
                bottom: Math.min(window.innerHeight - 4, r.bottom + $399d412ac621ced9$var$PAD)
            };
            run.lastRect = rect;
            this._layout(rect, step, mode, force);
        } else if (wantsTarget && run.lastRect && (!run.missingSince || now - run.missingSince < $399d412ac621ced9$var$MISSING_GRACE_MS)) // Brief gap (re-render, modal swap): hold the last position.
        {
            if (!run.missingSince) run.missingSince = now;
        } else {
            if (wantsTarget && !run.missingSince) run.missingSince = now;
            run.targetEl = null;
            run.lastRect = null;
            this._layout(null, step, mode, force);
        }
        if (now - this._lastLogic > 250) {
            this._lastLogic = now;
            if (mode === "wait" && step.until && this._safe(()=>step.until(this._api))) this._next();
        }
    }
    // The spotlight + card glide only when they move to a NEW target. The rest
    // of the time they track their target frame by frame with no easing, so a
    // modal sliding in never leaves the highlight trailing off-center.
    _glide() {
        const root = this._els?.root;
        if (!root) return;
        root.classList.add("tour-root--glide");
        clearTimeout(this._glideTimer);
        this._glideTimer = setTimeout(()=>root.classList.remove("tour-root--glide"), 340);
    }
    _layout(rect, step, mode, force) {
        const { spot: spot, blocks: blocks, card: card, root: root } = this._els;
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const block = this._val(step.block) !== false;
        // No target: intro/outro cards dim the whole screen; an action step whose
        // target hasn't appeared stays out of the way so the user can recover.
        const dimAll = !rect && mode === "next";
        root.classList.toggle("tour-root--clear", !rect && !dimAll);
        if (rect) {
            Object.assign(spot.style, {
                top: `${rect.top}px`,
                left: `${rect.left}px`,
                width: `${rect.right - rect.left}px`,
                height: `${rect.bottom - rect.top}px`
            });
            spot.classList.remove("tour-spot--none");
        } else {
            Object.assign(spot.style, {
                top: `${vh / 2}px`,
                left: `${vw / 2}px`,
                width: "0px",
                height: "0px"
            });
            spot.classList.toggle("tour-spot--none", !dimAll);
        }
        const on = block && (rect || dimAll);
        // "Look at this" steps (Next button) keep the spotlight look-only: clicking
        // the highlighted thing would wander off the script (e.g. Upload CSV is a
        // recommendation, not an action). Only click/wait steps open the hole.
        const h = rect && mode !== "next" ? rect : {
            top: vh,
            left: vw,
            right: vw,
            bottom: vh
        };
        const set = (b, top, left, w, ht)=>Object.assign(b.style, {
                display: on ? "block" : "none",
                top: `${top}px`,
                left: `${left}px`,
                width: `${Math.max(0, w)}px`,
                height: `${Math.max(0, ht)}px`
            });
        set(blocks[0], 0, 0, vw, h.top);
        set(blocks[1], h.top, h.right, vw - h.right, h.bottom - h.top);
        set(blocks[2], h.bottom, 0, vw, vh - h.bottom);
        set(blocks[3], h.top, 0, h.left, h.bottom - h.top);
        this._placeCard(card, rect, this._val(step.placement), mode !== "next");
    }
    _placeCard(card, rect, pref, interactive) {
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const m = 12;
        const gap = 14;
        const cw = card.offsetWidth;
        const ch = card.offsetHeight;
        let top;
        let left;
        if (vw < 640) {
            // Phones: dock to whichever edge leaves the target uncovered. A target
            // taller than the room left over (the item sheet, the whole item grid)
            // can't avoid overlap, so the card shrinks to its title + hint and docks
            // at the TOP: sheets and modals keep their primary action (Add to cart,
            // Save) at the bottom, and a card docked there would block the very tap
            // the step is waiting for.
            card.classList.add("tour-card--docked");
            card.classList.remove("tour-card--compact");
            let dockTop = false;
            if (rect) {
                const fullH = card.offsetHeight;
                if (vh - rect.bottom >= fullH + m) dockTop = false;
                else if (rect.top >= fullH + m) dockTop = true;
                else {
                    dockTop = true;
                    if (interactive) card.classList.add("tour-card--compact");
                }
            }
            const h = card.offsetHeight;
            top = dockTop ? m : vh - h - m;
            left = m;
            card.style.top = `${Math.round(Math.max(m, top))}px`;
            card.style.left = `${m}px`;
            return;
        } else {
            card.classList.remove("tour-card--docked", "tour-card--compact");
            if (!rect) {
                top = (vh - ch) / 2;
                left = (vw - cw) / 2;
            } else {
                const cx = (rect.left + rect.right) / 2;
                const cy = (rect.top + rect.bottom) / 2;
                const opts = {
                    bottom: {
                        fits: rect.bottom + gap + ch <= vh - m,
                        space: vh - rect.bottom,
                        top: rect.bottom + gap,
                        left: cx - cw / 2
                    },
                    top: {
                        fits: rect.top - gap - ch >= m,
                        space: rect.top,
                        top: rect.top - gap - ch,
                        left: cx - cw / 2
                    },
                    right: {
                        fits: rect.right + gap + cw <= vw - m,
                        space: vw - rect.right,
                        top: cy - ch / 2,
                        left: rect.right + gap
                    },
                    left: {
                        fits: rect.left - gap - cw >= m,
                        space: rect.left,
                        top: cy - ch / 2,
                        left: rect.left - gap - cw
                    }
                };
                const order = [
                    pref,
                    "bottom",
                    "right",
                    "top",
                    "left"
                ].filter((k, i, a)=>k && opts[k] && a.indexOf(k) === i);
                let pick = order.find((k)=>opts[k].fits);
                if (!pick) {
                    // Huge target (a whole form): sit in the corner with the most room.
                    pick = null;
                    top = vh - ch - m;
                    left = vw - cw - m;
                    if (rect.left > vw - rect.right) left = m;
                } else {
                    top = opts[pick].top;
                    left = opts[pick].left;
                }
            }
        }
        top = Math.max(m, Math.min(top, vh - ch - m));
        left = Math.max(m, Math.min(left, vw - cw - m));
        card.style.top = `${Math.round(top)}px`;
        card.style.left = `${Math.round(left)}px`;
    }
    // ── Global listeners ───────────────────────────────────────────────────────
    _wireGlobal() {
        if (this._wired) return;
        this._wired = true;
        // Click-to-advance steps: let the app handle the click first, then move on.
        document.addEventListener("click", (e)=>{
            const run = this._run;
            if (!run || !run.targetEl || this._els?.root.contains(e.target)) return;
            if (!run.targetEl.contains(e.target)) return;
            if (this._mode(this._step()) === "click") setTimeout(()=>this._next(), 60);
        }, true);
        document.addEventListener("keydown", (e)=>{
            if (e.key !== "Escape") return;
            if (this._hubEl) {
                this._closeHub();
                return;
            }
            if (this._run) {
                e.stopPropagation();
                this.pause();
            }
        }, true);
        // "?" help buttons, wherever they are mounted.
        document.addEventListener("click", (e)=>{
            const btn = e.target.closest(".tour-help-btn, [data-tour-hub]");
            if (!btn) return;
            e.preventDefault();
            e.stopPropagation();
            if (btn.hasAttribute("data-tour-hub")) {
                this.openHub();
                return;
            }
            const id = btn.dataset.tour;
            const chapter = btn.dataset.tourChapter || null;
            this.start(id, chapter ? {
                chapter: chapter
            } : {
                fromStart: this.progress(id).status === "done"
            });
        });
        // Re-mount help buttons into views that re-render their markup.
        const mo = new MutationObserver(()=>this.mountHelpButtons());
        document.querySelectorAll(".modal-parent").forEach((n)=>mo.observe(n, {
                childList: true,
                subtree: false
            }));
    }
    // Each tour may declare helpAnchor (a heading selector) - a small "?" is
    // appended inside it. Idempotent; safe to call on every re-render.
    mountHelpButtons() {
        this._tours.forEach((tour)=>{
            [].concat(tour.helpAnchors ?? []).forEach(({ selector: selector, chapter: chapter })=>{
                document.querySelectorAll(selector).forEach((h)=>{
                    if (h.querySelector(":scope > .tour-help-btn")) return;
                    if (tour.can && !this._safe(()=>tour.can(this._api))) return;
                    const b = document.createElement("button");
                    b.type = "button";
                    b.className = "tour-help-btn";
                    b.dataset.tour = tour.id;
                    if (chapter) b.dataset.tourChapter = chapter;
                    b.setAttribute("aria-label", `Show me how: ${tour.title}`);
                    b.title = "Show me how";
                    b.textContent = "?";
                    h.appendChild(b);
                });
            });
        });
    }
    // ── Hub button state + Tutorials hub ───────────────────────────────────────
    _syncHubBtn() {
        const btn = document.getElementById("tourHubBtn");
        if (!btn) return;
        const main = this._order.map((id)=>this._tours.get(id)).find((t)=>t.featured);
        const st = main ? this.progress(main.id).status : "done";
        btn.classList.toggle("tour-hub-btn--dot", st !== "done");
    }
    _pulseHubBtn() {
        const btn = document.getElementById("tourHubBtn");
        if (!btn) return;
        btn.classList.remove("tour-hub-btn--pulse");
        btn.offsetWidth;
        btn.classList.add("tour-hub-btn--pulse");
        setTimeout(()=>btn.classList.remove("tour-hub-btn--pulse"), 3200);
    }
    _statusChip(st) {
        const map = {
            new: [
                "New",
                "new"
            ],
            active: [
                "In progress",
                "progress"
            ],
            paused: [
                "In progress",
                "progress"
            ],
            skipped: [
                "Skipped",
                "skipped"
            ],
            done: [
                "Done",
                "done"
            ]
        };
        const [label, cls] = map[st] ?? map.new;
        return `<span class="tour-chip tour-chip--${cls}">${st === "done" ? "\u2713 " : ""}${label}</span>`;
    }
    _cta(st) {
        if (st === "active" || st === "paused") return "Resume";
        if (st === "done") return "Replay";
        return "Start";
    }
    openHub() {
        if (this._run) this.pause({
            quiet: true
        });
        this._closeHub();
        const tours = this._order.map((id)=>this._tours.get(id)).filter((t)=>!t.can || this._safe(()=>t.can(this._api)));
        const featured = tours.filter((t)=>t.featured);
        const rest = tours.filter((t)=>!t.featured);
        const heroMarkup = featured.map((t)=>{
            const p = this.progress(t.id);
            const chapters = t.chapters ?? [];
            const done = new Set(p.chapters);
            const doneCount = chapters.filter((c)=>done.has(c.id)).length;
            return `
        <section class="tour-hub-hero">
          <div class="tour-hub-hero-head">
            <span class="tour-hub-hero-icon" aria-hidden="true">${t.icon}</span>
            <div class="tour-hub-hero-text">
              <div class="tour-hub-hero-title">${t.title} ${this._statusChip(p.status)}</div>
              <p class="tour-hub-hero-sub">${t.description}</p>
            </div>
            <button class="tour-btn tour-btn--primary" data-hub-start="${t.id}" type="button">${this._cta(p.status)}</button>
          </div>
          <div class="tour-hub-hero-bar" aria-label="${doneCount} of ${chapters.length} parts done"><span style="width:${chapters.length ? doneCount / chapters.length * 100 : 0}%"></span></div>
          <ol class="tour-hub-chapters">
            ${chapters.map((c, i)=>`
              <li>
                <button class="tour-hub-chapter${done.has(c.id) ? " tour-hub-chapter--done" : ""}" data-hub-start="${t.id}" data-hub-chapter="${c.id}" type="button">
                  <span class="tour-hub-chapter-num" aria-hidden="true">${done.has(c.id) ? "\u2713" : i + 1}</span>
                  <span class="tour-hub-chapter-text"><span class="tour-hub-chapter-title">${c.title}</span><span class="tour-hub-chapter-sub">${c.blurb ?? ""}</span></span>
                </button>
              </li>`).join("")}
          </ol>
        </section>`;
        }).join("");
        const cards = rest.map((t)=>{
            const p = this.progress(t.id);
            return `
        <button class="tour-hub-card" data-hub-start="${t.id}" type="button">
          <span class="tour-hub-card-icon" aria-hidden="true">${t.icon}</span>
          <span class="tour-hub-card-text">
            <span class="tour-hub-card-title">${t.title}</span>
            <span class="tour-hub-card-sub">${t.description}</span>
          </span>
          ${this._statusChip(p.status)}
        </button>`;
        }).join("");
        const el = document.createElement("div");
        el.className = "tour-hub-overlay";
        el.innerHTML = `
      <div class="tour-hub" role="dialog" aria-modal="true" aria-labelledby="tourHubTitle">
        <header class="tour-hub-head">
          <div>
            <h2 class="tour-hub-title" id="tourHubTitle">Tutorials</h2>
            <p class="tour-hub-sub">Short walkthroughs inside the real app. Close any of them midway and pick up right where you left off.</p>
          </div>
          <button class="tour-hub-close" type="button" aria-label="Close">&times;</button>
        </header>
        <div class="tour-hub-scroll">
          ${heroMarkup}
          ${cards ? `<h3 class="tour-hub-label">Feature guides</h3><div class="tour-hub-grid">${cards}</div>` : ""}
          <p class="tour-hub-foot">Tip: look for the <span class="tour-help-btn tour-help-btn--inline" aria-hidden="true">?</span> next to a screen's title to get its guide right there.</p>
        </div>
      </div>`;
        el.addEventListener("click", (e)=>{
            if (e.target === el || e.target.closest(".tour-hub-close")) {
                this._closeHub();
                return;
            }
            const b = e.target.closest("[data-hub-start]");
            if (!b) return;
            const id = b.dataset.hubStart;
            const chapter = b.dataset.hubChapter;
            this._closeHub();
            if (chapter) this.start(id, {
                chapter: chapter
            });
            else this.start(id, {
                fromStart: this.progress(id).status === "done" || this.progress(id).status === "skipped"
            });
        });
        document.body.appendChild(el);
        this._hubEl = el;
        requestAnimationFrame(()=>el.querySelector(".tour-hub-close")?.focus());
    }
    _closeHub() {
        this._hubEl?.remove();
        this._hubEl = null;
    }
}
var $399d412ac621ced9$export$2e2bcd8739ae039 = new $399d412ac621ced9$var$TourEngine();


// Practice data for the hands-on tutorials (tours.js): a pretend café, "Bunny
// Café", with its own products, supplies, suppliers, purchase orders, staff and
// shifts. Pure factories - no DOM, no Supabase. The controller swaps these into
// model.state while a practice tour runs (_startInventoryPractice /
// _startTimesheetPractice) and puts the business's real data back afterwards.
//
// Every id starts with "practice-" so a practice row is recognizable anywhere
// it might surface. Built fresh on every call, with dates relative to now, so
// a replay always starts from the same story.
const $b10fec56003d56fb$var$iso = (d)=>d.toISOString();
const $b10fec56003d56fb$var$daysAgo = (n, h = 9, m = 0)=>{
    const d = new Date();
    d.setDate(d.getDate() - n);
    d.setHours(h, m, 0, 0);
    return d;
};
const $b10fec56003d56fb$var$ymd = (d)=>`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const $b10fec56003d56fb$export$bba2591dc30e4a13 = {
    latte: "practice-menu-latte",
    cappuccino: "practice-menu-cappuccino",
    croissant: "practice-menu-croissant",
    beans: "practice-inv-beans",
    milk: "practice-inv-milk",
    cups: "practice-inv-cups",
    croissantStock: "practice-inv-croissant",
    roaster: "practice-sup-roaster",
    dairy: "practice-sup-dairy",
    jon: "practice-staff-jon",
    maya: "practice-staff-maya",
    ana: "practice-staff-ana",
    jonOpenShift: "practice-shift-jon-open",
    anaRequest: "practice-req-ana",
    jonLeave: "practice-leave-jon"
};
const $b10fec56003d56fb$export$43d9f4e1cc9f3778 = {
    lattes: 40,
    perSale: 5
};
function $b10fec56003d56fb$export$c139289dfab6026() {
    const P = $b10fec56003d56fb$export$bba2591dc30e4a13;
    const created = $b10fec56003d56fb$var$iso($b10fec56003d56fb$var$daysAgo(30));
    const menuItems = [
        {
            _id: P.latte,
            itemName: "Latte",
            price: 4.5,
            category: "Coffee",
            imageURL: null,
            iconEmoji: "\u2615",
            _stock: "0",
            hasVariants: false,
            variants: [],
            description: "",
            status: "active",
            taxClass: "standard"
        },
        {
            _id: P.cappuccino,
            itemName: "Cappuccino",
            price: 4,
            category: "Coffee",
            imageURL: null,
            iconEmoji: "\uD83E\uDED6",
            _stock: "0",
            hasVariants: false,
            variants: [],
            description: "",
            status: "active",
            taxClass: "standard"
        },
        {
            _id: P.croissant,
            itemName: "Croissant",
            price: 3.5,
            category: "Pastry",
            imageURL: null,
            iconEmoji: "\uD83E\uDD50",
            _stock: "0",
            hasVariants: false,
            variants: [],
            description: "",
            status: "active",
            taxClass: "standard"
        }
    ];
    const suppliers = [
        {
            id: P.roaster,
            name: "Bean There Roasters",
            category: null,
            contactName: "Mia",
            phone: "555 0142",
            email: "orders@beanthere.example",
            address: null,
            leadTimeDays: 2,
            paymentTerms: "Net 15",
            minOrder: null,
            status: "preferred",
            notes: null,
            createdAt: created
        },
        {
            id: P.dairy,
            name: "Fresh Dairy Co.",
            category: null,
            contactName: "Leo",
            phone: "555 0199",
            email: null,
            address: null,
            leadTimeDays: 1,
            paymentTerms: "On delivery",
            minOrder: null,
            status: "active",
            notes: null,
            createdAt: created
        }
    ];
    const items = [
        {
            id: P.beans,
            name: "Coffee beans",
            unit: "g",
            quantity: 1200,
            lowStockThreshold: 500,
            linkedMenuItemId: null,
            sku: "BEAN-HOUSE",
            category: null,
            unitCost: 0.02,
            supplierId: P.roaster,
            createdAt: created,
            updatedAt: $b10fec56003d56fb$var$iso($b10fec56003d56fb$var$daysAgo(6))
        },
        {
            id: P.milk,
            name: "Oat milk",
            unit: "L",
            quantity: 14,
            lowStockThreshold: 3,
            linkedMenuItemId: null,
            sku: null,
            category: null,
            unitCost: 3,
            supplierId: P.dairy,
            createdAt: created,
            updatedAt: $b10fec56003d56fb$var$iso($b10fec56003d56fb$var$daysAgo(6))
        },
        {
            id: P.cups,
            name: "Paper cups",
            unit: "pc",
            quantity: 160,
            lowStockThreshold: 50,
            linkedMenuItemId: null,
            sku: "CUP-12OZ",
            category: null,
            unitCost: 0.15,
            supplierId: P.roaster,
            createdAt: created,
            updatedAt: $b10fec56003d56fb$var$iso($b10fec56003d56fb$var$daysAgo(6))
        },
        // A "Simple count" product: its auto item carries the product's name.
        {
            id: P.croissantStock,
            name: "Croissant",
            unit: "pc",
            quantity: 14,
            lowStockThreshold: 4,
            linkedMenuItemId: P.croissant,
            sku: null,
            category: null,
            unitCost: 1.1,
            supplierId: null,
            createdAt: created,
            updatedAt: $b10fec56003d56fb$var$iso($b10fec56003d56fb$var$daysAgo(1))
        }
    ];
    const link = (n, menuItemId, inventoryItemId, qty)=>({
            id: `practice-link-${n}`,
            menuItemId: menuItemId,
            inventoryItemId: inventoryItemId,
            qty: qty,
            variantLabel: null,
            variantOption: null
        });
    const links = [
        link(1, P.latte, P.beans, 18),
        link(2, P.latte, P.milk, 0.2),
        link(3, P.latte, P.cups, 1),
        link(4, P.cappuccino, P.beans, 18),
        link(5, P.cappuccino, P.milk, 0.12),
        link(6, P.cappuccino, P.cups, 1),
        link(7, P.croissant, P.croissantStock, 1)
    ];
    const itemSuppliers = [
        {
            id: "practice-isup-1",
            inventoryItemId: P.beans,
            supplierId: P.roaster,
            unitCost: 0.02,
            preferred: true
        },
        {
            id: "practice-isup-2",
            inventoryItemId: P.cups,
            supplierId: P.roaster,
            unitCost: 0.15,
            preferred: true
        },
        {
            id: "practice-isup-3",
            inventoryItemId: P.milk,
            supplierId: P.dairy,
            unitCost: 3,
            preferred: true
        }
    ];
    // Last week's delivery, already received - gives History and the PO list
    // something real-looking before the user makes their own order.
    const receivedAt = $b10fec56003d56fb$var$iso($b10fec56003d56fb$var$daysAgo(6, 10, 30));
    const purchaseOrders = [
        {
            id: "practice-po-1",
            poNumber: 1,
            supplierId: P.roaster,
            supplierName: "Bean There Roasters",
            status: "received",
            expectedDate: $b10fec56003d56fb$var$ymd($b10fec56003d56fb$var$daysAgo(6)),
            notes: null,
            shipping: 5,
            tax: null,
            createdByName: "Bunny Caf\xe9",
            receiptUrl: null,
            createdAt: $b10fec56003d56fb$var$iso($b10fec56003d56fb$var$daysAgo(8, 15)),
            sentAt: $b10fec56003d56fb$var$iso($b10fec56003d56fb$var$daysAgo(8, 15, 5)),
            receivedAt: receivedAt,
            cancelledAt: null,
            lines: [
                {
                    id: "practice-pol-1",
                    inventoryItemId: P.beans,
                    itemName: "Coffee beans",
                    unit: "g",
                    qty: 1000,
                    unitCost: 0.02,
                    createdAt: $b10fec56003d56fb$var$iso($b10fec56003d56fb$var$daysAgo(8, 15))
                },
                {
                    id: "practice-pol-2",
                    inventoryItemId: P.cups,
                    itemName: "Paper cups",
                    unit: "pc",
                    qty: 100,
                    unitCost: 0.15,
                    createdAt: $b10fec56003d56fb$var$iso($b10fec56003d56fb$var$daysAgo(8, 15))
                }
            ]
        }
    ];
    const adj = (n, inventoryItemId, delta, kind, createdAt, extra = {})=>({
            id: `practice-adj-${n}`,
            inventoryItemId: inventoryItemId,
            delta: delta,
            kind: kind,
            note: null,
            saleId: null,
            receiptNumber: null,
            saleDate: null,
            staffName: "Bunny Caf\xe9",
            createdAt: createdAt,
            ...extra
        });
    const adjustments = [
        adj(3, P.croissantStock, -2, "sale", $b10fec56003d56fb$var$iso($b10fec56003d56fb$var$daysAgo(1, 8, 40)), {
            saleId: "practice-sale-1",
            receiptNumber: 1041,
            saleDate: $b10fec56003d56fb$var$iso($b10fec56003d56fb$var$daysAgo(1, 8, 40))
        }),
        adj(2, P.cups, 100, "po", receivedAt),
        adj(1, P.beans, 1000, "po", receivedAt)
    ];
    return {
        menuItems: menuItems,
        menuCategories: [
            "Coffee",
            "Pastry"
        ],
        items: items,
        links: links,
        suppliers: suppliers,
        itemSuppliers: itemSuppliers,
        purchaseOrders: purchaseOrders,
        adjustments: adjustments,
        nextPoNumber: 2,
        nextReceipt: 1042
    };
}
function $b10fec56003d56fb$export$7b6472890327bb48() {
    const P = $b10fec56003d56fb$export$bba2591dc30e4a13;
    const now = new Date();
    const thisMonday = new Date(now);
    thisMonday.setHours(0, 0, 0, 0);
    thisMonday.setDate(now.getDate() - (now.getDay() + 6) % 7);
    const monday = new Date(thisMonday);
    monday.setDate(thisMonday.getDate() - 7);
    const day = (offset, h, m = 0)=>{
        const d = new Date(monday);
        d.setDate(monday.getDate() + offset);
        d.setHours(h, m, 0, 0);
        return d;
    };
    const staff = [
        {
            id: P.maya,
            firstName: "Maya",
            lastName: "Santos",
            email: "maya@bunnycafe.example",
            isActive: true,
            role: "Manager"
        },
        {
            id: P.jon,
            firstName: "Jon",
            lastName: "Reyes",
            email: "jon@bunnycafe.example",
            isActive: true,
            role: "Barista"
        },
        {
            id: P.ana,
            firstName: "Ana",
            lastName: "Cruz",
            email: "ana@bunnycafe.example",
            isActive: true,
            role: "Barista"
        }
    ];
    const names = {
        [P.maya]: "Maya Santos",
        [P.jon]: "Jon Reyes",
        [P.ana]: "Ana Cruz"
    };
    let n = 0;
    const shift = (staffId, offset, inH, inM, outH, outM, { open: open = false, id: id = null } = {})=>{
        n += 1;
        const clockIn = day(offset, inH, inM);
        const breakStart = day(offset, inH + 3, 0);
        return {
            id: id ?? `practice-shift-${n}`,
            staffId: staffId,
            staffName: names[staffId],
            hourlyRate: null,
            clockedInAt: $b10fec56003d56fb$var$iso(clockIn),
            clockedOutAt: open ? null : $b10fec56003d56fb$var$iso(day(offset, outH, outM)),
            note: "",
            source: "clock",
            editedBy: null,
            approvedBy: null,
            breaks: [
                {
                    id: `practice-break-${n}`,
                    startedAt: $b10fec56003d56fb$var$iso(breakStart),
                    endedAt: $b10fec56003d56fb$var$iso(new Date(breakStart.getTime() + 1800000))
                }
            ]
        };
    };
    const anaWed = shift(P.ana, 2, 9, 20, 15, 0, {
        id: "practice-shift-ana-wed"
    });
    const shifts = [
        shift(P.maya, 0, 8, 0, 16, 30),
        shift(P.ana, 0, 9, 0, 15, 0),
        shift(P.maya, 1, 8, 0, 16, 30),
        shift(P.jon, 1, 12, 0, 20, 0),
        shift(P.maya, 2, 8, 0, 16, 30),
        anaWed,
        shift(P.jon, 2, 12, 0, 20, 0),
        shift(P.maya, 3, 8, 0, 16, 30),
        shift(P.jon, 3, 12, 0, 20, 0, {
            open: true,
            id: P.jonOpenShift
        }),
        shift(P.maya, 4, 8, 0, 16, 30),
        shift(P.ana, 4, 9, 0, 15, 0),
        shift(P.jon, 4, 12, 0, 20, 0),
        shift(P.jon, 5, 10, 0, 18, 0)
    ].sort((a, b)=>new Date(a.clockedInAt) - new Date(b.clockedInAt));
    const editRequests = [
        {
            id: P.anaRequest,
            staffId: P.ana,
            staffName: names[P.ana],
            shiftId: anaWed.id,
            proposedIn: $b10fec56003d56fb$var$iso(day(2, 9, 0)),
            proposedOut: $b10fec56003d56fb$var$iso(day(2, 15, 0)),
            proposedBreaks: null,
            reason: "I started at 9:00, the tablet didn't take my PIN until later.",
            createdAt: $b10fec56003d56fb$var$iso(day(3, 9, 5)),
            currentIn: anaWed.clockedInAt,
            currentOut: anaWed.clockedOutAt
        }
    ];
    // Next Friday (from today's week), so the request is always upcoming.
    const nextFriday = new Date(thisMonday);
    nextFriday.setDate(thisMonday.getDate() + 11);
    const leaveRequests = [
        {
            id: P.jonLeave,
            staffId: P.jon,
            staffName: names[P.jon],
            type: "vacation",
            startDate: $b10fec56003d56fb$var$ymd(nextFriday),
            endDate: $b10fec56003d56fb$var$ymd(nextFriday),
            reason: "Family trip",
            status: "pending",
            createdAt: $b10fec56003d56fb$var$iso(day(4, 18)),
            reviewedByName: null,
            reviewedAt: null,
            reviewNote: null
        },
        {
            id: "practice-leave-maya",
            staffId: P.maya,
            staffName: names[P.maya],
            type: "sick",
            startDate: $b10fec56003d56fb$var$ymd(day(-10, 0)),
            endDate: $b10fec56003d56fb$var$ymd(day(-10, 0)),
            reason: "",
            status: "approved",
            createdAt: $b10fec56003d56fb$var$iso(day(-10, 7)),
            reviewedByName: "Bunny Caf\xe9",
            reviewedAt: $b10fec56003d56fb$var$iso(day(-10, 8)),
            reviewNote: null
        }
    ];
    const devices = [
        {
            id: "practice-device-1",
            label: "Front counter iPad",
            activatedAt: $b10fec56003d56fb$var$iso(day(-20, 9)),
            lastSeenAt: $b10fec56003d56fb$var$iso(new Date(now.getTime() - 600000))
        }
    ];
    const fmt = (d)=>d.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric"
        });
    const sunday = day(6, 0);
    return {
        staff: staff,
        shifts: shifts,
        editRequests: editRequests,
        leaveRequests: leaveRequests,
        deletedShifts: [],
        devices: devices,
        onShift: [
            {
                staffId: P.maya,
                name: names[P.maya],
                clockedInAt: $b10fec56003d56fb$var$iso(new Date(now.getTime() - 7200000)),
                onBreak: false
            }
        ],
        periodMeta: {
            type: "week",
            value: $b10fec56003d56fb$var$ymd(monday),
            label: `${fmt(monday)} \u{2013} ${fmt(sunday)} (practice week)`
        }
    };
}


// Tutorial content for tour.js. Copy is authored HTML (never user data). The
// `api` argument is built by the controller (see _tourApi in controller.js):
// permission/plan checks, a few state counts, and panel openers - so tour
// content never reaches into the model directly.
//
// Writing rule (CLAUDE.md): no em dashes in any of this copy.

const $8a6af5bb762aa044$var$$ = (sel)=>document.querySelector(sel);
const $8a6af5bb762aa044$var$shown = (sel)=>{
    const el = $8a6af5bb762aa044$var$$(sel);
    return !!el && !el.classList.contains("hidden") && el.getClientRects().length > 0;
};
// Screen-state checks shared by the steps. These MUST test visibility, not
// presence: a closed Catalogue stays in the DOM (hidden), so "exists" stays
// true forever after the first visit and broke replays.
const $8a6af5bb762aa044$var$visibleEl = (sel)=>[
        ...document.querySelectorAll(sel)
    ].some((el)=>el.getClientRects().length > 0 && !el.closest(".hidden"));
const $8a6af5bb762aa044$var$catalogueOpen = ()=>$8a6af5bb762aa044$var$visibleEl("#menuModal");
const $8a6af5bb762aa044$var$orderOpen = ()=>$8a6af5bb762aa044$var$visibleEl("#newOrderModal .pos-items-area, #newOrderModal .pos-empty");
const $8a6af5bb762aa044$var$checkoutOpen = ()=>$8a6af5bb762aa044$var$visibleEl("#newOrderModal .payment-method-toggle");
const $8a6af5bb762aa044$var$panelOpen = (id)=>()=>$8a6af5bb762aa044$var$shown(`#${id}`);
// Feature tours open their panel from the hub; the panel's own "?" button
// starts them with the panel already open.
const $8a6af5bb762aa044$var$panelTour = ({ id: id, panel: panel, title: title, icon: icon, description: description, perm: perm, open: open, steps: steps })=>({
        id: id,
        title: title,
        icon: icon,
        description: description,
        can: (api)=>!perm || api.can(perm),
        isOpen: $8a6af5bb762aa044$var$panelOpen(panel),
        open: (api)=>api.open[open](),
        helpAnchors: [
            {
                selector: `#${panel} .cashflow-title, #${panel} .rp-title`
            }
        ],
        steps: steps
    });
const $8a6af5bb762aa044$var$proNote = (api, feature, what)=>api.isLocked(feature) ? `<p class="tour-pro-note">\u{2728} ${what} is part of <strong>Pointbunny Pro</strong>. You can see the summary now and unlock the rest anytime.</p>` : "";
// ── Main tour: your first sale ───────────────────────────────────────────────
const $8a6af5bb762aa044$var$firstSale = {
    id: "first-sale",
    featured: true,
    title: "Your first sale",
    icon: "\uD83D\uDED2",
    hero: "\uD83D\uDC30",
    description: "Add your items, ring up a practice order, see the receipt and hand it over. About 3 minutes.",
    can: (api)=>api.can("take_orders") || api.can("manage_menu"),
    // Checkout records a pretend sale while this tour runs (controller
    // _recordPracticeSale); the practice order is removed however it ends.
    practice: true,
    onStart: (api)=>api.homeDefaults(true),
    onEnd: (api)=>{
        api.clearPractice();
        api.homeDefaults(false);
    },
    helpAnchors: [
        {
            selector: "#queueTitle",
            chapter: "queue"
        },
        {
            selector: "#newOrderModal .pos-title",
            chapter: "order"
        }
    ],
    chapters: [
        {
            id: "items",
            title: "Add your items",
            blurb: "Type them in or import a CSV"
        },
        {
            id: "screens",
            title: "Customer screen",
            blurb: "Let customers watch their order"
        },
        {
            id: "order",
            title: "Ring up an order",
            blurb: "Tap items into the cart"
        },
        {
            id: "checkout",
            title: "Payment & receipt",
            blurb: "Take payment, print or just save",
            entry: ()=>$8a6af5bb762aa044$var$checkoutOpen()
        },
        {
            id: "queue",
            title: "Active Queue & pickup",
            blurb: "Mark it ready, then done"
        }
    ],
    steps: [
        {
            id: "welcome",
            chapter: "items",
            welcome: true,
            title: "Welcome to Pointbunny! \uD83D\uDC4B",
            body: `<p>Let's ring up a sale together, from adding your items all the way to handing the order over.</p>
             <p>It takes about 3 minutes. Close it anytime and pick up right where you left off from the <strong>?</strong> at the top.</p>`,
            tip: "This is <strong>practice mode</strong>. The sale you make isn't saved, nothing prints, and your numbers don't change. The practice order disappears as soon as the tutorial ends. (Items you add to your Catalogue are real and stay.)",
            nextLabel: "Let's go"
        },
        // ── Part 1: items ──
        {
            id: "open-catalogue",
            chapter: "items",
            skipIf: (api)=>!api.can("manage_menu") || $8a6af5bb762aa044$var$catalogueOpen(),
            target: "#menu-list",
            mode: "click",
            placement: "right",
            title: "Open your Catalogue",
            body: "<p>The Catalogue holds everything you sell: products, services, sizes and add-ons. Tap it to open.</p>"
        },
        {
            id: "csv",
            chapter: "items",
            skipIf: (api)=>!api.can("manage_menu") || !$8a6af5bb762aa044$var$catalogueOpen(),
            target: "#menuUploadCsvBtn",
            title: "Already have a list? Import it",
            body: `<p>If your items live in a spreadsheet, <strong>Upload CSV</strong> adds them all in one go. Inside there's a template that shows the format: one row per item, with optional sizes or flavors.</p>`,
            tip: "<strong>No need to tap it now.</strong> Just keep it in mind for later. Tap <strong>Next</strong> and we'll add one by hand."
        },
        {
            id: "add-item",
            chapter: "items",
            skipIf: (api)=>!api.can("manage_menu") || !$8a6af5bb762aa044$var$catalogueOpen(),
            target: "#openAddModal",
            mode: (api)=>api.hasItems() ? "next" : "click",
            title: (api)=>api.hasItems() ? "Add more anytime" : "Or add one by hand",
            body: (api)=>api.hasItems() ? "<p>You already have items, nice. Use <strong>Add Item</strong> whenever you want to add another.</p>" : "<p>Tap <strong>Add Item</strong> to create your first product.</p>",
            next: (api)=>api.hasItems() ? "inventory" : null
        },
        {
            id: "item-form",
            chapter: "items",
            skipIf: ()=>!$8a6af5bb762aa044$var$shown("#addMenuModal"),
            target: "#addMenuModal .modal-content",
            mode: "wait",
            signal: "item-added",
            waitHint: "Save your item to continue",
            placement: "right",
            title: "Name it and price it",
            body: `<p>Only a <strong>name</strong> and <strong>price</strong> are needed. A category, photo or emoji is optional.</p>
             <p>Sizes, flavors or add-ons go under <strong>Variants</strong>. Tap <strong>Save</strong> when you're done.</p>`,
            next: "inventory"
        },
        {
            id: "inventory",
            chapter: "items",
            skipIf: (api)=>!api.can("manage_menu") || !$8a6af5bb762aa044$var$catalogueOpen() || !api.hasItems(),
            target: [
                "#menuModal .menu-items-area .card",
                "#menuModal .menu-items-area"
            ],
            title: "Want to track stock too?",
            body: (api)=>`<p>Tap any item to edit it and set <strong>Inventory</strong> to <em>Simple count</em> or <em>Ingredients</em>. Stock goes down by itself with every sale, and you'll get low and out-of-stock alerts.</p>
             <p>It's optional. There's a separate <strong>Inventory tutorial</strong> waiting for you whenever you're ready (open Inventory and tap its <strong>?</strong>).</p>
             ${$8a6af5bb762aa044$var$proNote(api, "inventory", "Inventory")}`
        },
        {
            id: "close-catalogue",
            chapter: "items",
            skipIf: ()=>!$8a6af5bb762aa044$var$catalogueOpen(),
            target: "#menuModal .menu-modal-header .modal-close",
            mode: "click",
            placement: "left",
            title: "Your catalogue is ready",
            body: "<p>Close the Catalogue and let's sell something.</p>"
        },
        // ── Part 2: customer screen ──
        {
            id: "customer-screen",
            chapter: "screens",
            target: "#displayDropdownToggle",
            title: "Show customers their order",
            body: `<p>Under <strong>Screens</strong> you'll find the <strong>Customer Screen</strong>. Put it on a second monitor or a tablet facing the counter.</p>
             <p>As you add items to an order, they appear there live with the running total, so customers can check it before paying.</p>`,
            tip: "Using a separate tablet? Sign in on it, open Customer Screen, and set its terminal number to match this one (the Terminal button up here).",
            action: {
                label: "Open it now",
                run: (api)=>api.openCustomerDisplay()
            }
        },
        // ── Part 3: ring up an order ──
        {
            id: "new-order",
            chapter: "order",
            skipIf: ()=>$8a6af5bb762aa044$var$orderOpen() || $8a6af5bb762aa044$var$checkoutOpen(),
            target: "#newOrderBtn",
            mode: "click",
            title: "Start a new order",
            body: "<p>Tap <strong>New Order</strong> to open the register.</p>"
        },
        {
            id: "add-to-cart",
            chapter: "order",
            skipIf: (api)=>$8a6af5bb762aa044$var$checkoutOpen() || api.cartCount() > 0 && !$8a6af5bb762aa044$var$orderOpen(),
            target: [
                "#stockNoticeModal:not(.hidden) > *",
                ".item-modal-overlay:not(.hidden) .pos-item-detail-card",
                "#posItemsArea",
                "#newOrderModal .pos-empty"
            ],
            mode: (api)=>api.hasItems() ? "wait" : "next",
            signal: "cart-add",
            waitHint: "Add an item to continue",
            placement: "left",
            title: (api)=>api.hasItems() ? "Tap an item to add it" : "Nothing to sell yet",
            body: (api)=>api.hasItems() ? `<p>Items with sizes or add-ons ask you to pick options first, then <strong>Add to cart</strong>.</p>
             <p>Add as many as you like.</p>` : `<p>There are no active items to sell yet. Add an item in the Catalogue (or set one back to Active), then come back to this part from the <strong>?</strong>.</p>`,
            next: (api)=>api.hasItems() ? null : "finish"
        },
        {
            id: "cart",
            chapter: "order",
            skipIf: ()=>!$8a6af5bb762aa044$var$orderOpen(),
            target: [
                ".pos-cart-sidebar",
                ".pos-cart-fab"
            ],
            placement: "left",
            title: "What you see, they see",
            body: `<p>The cart updates as you go. If the <strong>Customer Screen</strong> is open, your customer is seeing these same items and the total right now.</p>`
        },
        {
            id: "to-checkout",
            chapter: "order",
            skipIf: ()=>$8a6af5bb762aa044$var$checkoutOpen(),
            target: [
                ".pos-checkout-btn",
                ".pos-cart-fab"
            ],
            mode: "click",
            title: "Head to checkout",
            body: "<p>Tap <strong>Checkout</strong> when the order is complete.</p>"
        },
        // ── Part 4: payment & receipt ──
        {
            id: "payment",
            chapter: "checkout",
            skipIf: ()=>$8a6af5bb762aa044$var$shown("#printReceiptBtn"),
            target: ".pos-pay-panel",
            mode: "wait",
            until: ()=>$8a6af5bb762aa044$var$shown("#printReceiptBtn"),
            waitHint: "Choose a payment method to continue",
            placement: "left",
            title: "How are they paying?",
            body: `<p>Pick <strong>Cash</strong>, <strong>Card</strong> or <strong>QR</strong>.</p>
             <p>For cash, type the amount they handed you and tap <strong>Enter</strong>. We'll work out the change.</p>`,
            tip: "Taking QR payments? Upload your payment QR code in <strong>Settings \u203A Displays \u203A Payment QR Code</strong>. When you pick QR here, it pops up on the Customer Screen for them to scan. You can add it now or anytime later."
        },
        {
            id: "receipt",
            chapter: "checkout",
            target: "#printReceiptBtn",
            mode: "click",
            placement: "left",
            title: (api)=>api.printingOn() ? "Print the receipt" : "Record the sale",
            body: (api)=>api.printingOn() ? "<p>On a real sale, <strong>Print Receipt</strong> saves the sale and prints it. You get a quick preview first to double-check. (In practice mode nothing prints.)</p>" : "<p>Printing is off, so <strong>Record Sale</strong> just saves the transaction. You get a quick preview first. (In practice mode nothing is saved.)</p>",
            tip: (api)=>api.printingOn() ? "No receipt printer, or just want to save transactions? Turn printing off in <strong>Settings \u203A POS</strong> and this button becomes Record Sale. Every sale is still kept under Sales &amp; Expenses." : "Want paper receipts? Turn printing on in <strong>Settings \u203A POS</strong>. You can connect a Bluetooth printer there too."
        },
        {
            id: "confirm",
            chapter: "checkout",
            target: [
                ".confirm-overlay:not(.receipt-preview-overlay) > *",
                ".receipt-preview-overlay > *"
            ],
            mode: "wait",
            signal: "sale-done",
            waitHint: "Confirm to finish the practice sale",
            title: "Check it, then confirm",
            body: (api)=>`<p>This is exactly what goes on the receipt. On a real sale, <strong>Confirm</strong> saves it${api.printingOn() ? " and prints it" : ""}. Need a change? <strong>Go Back</strong> first.</p>
             <p>The invoice and ticket numbers fill in once you confirm.</p>`
        },
        {
            id: "saved",
            chapter: "checkout",
            title: "Nice work! \uD83C\uDF89",
            body: `<p>That's how every sale goes. Real sales show up in today's numbers on the home screen and in <strong>Sales &amp; Expenses</strong>, where you can reprint or void them.</p>
             <p>Your practice order just landed in the Active Queue, tagged <strong>\u{1F393} Practice</strong>. Let's look.</p>`
        },
        {
            id: "settings",
            chapter: "checkout",
            target: [
                "#settingsBtn",
                "#navProfileBtn"
            ],
            title: "Receipts your way",
            body: `<p><strong>Settings \u{203A} POS</strong> (open it from your profile menu, top right) is where you turn receipt printing on or off, connect a Bluetooth printer, and choose what shows on the receipt.</p>
             <p>Printing off means sales are simply saved, perfect if you don't hand out paper receipts.</p>`
        },
        // ── Part 5: active queue & pickup ──
        {
            id: "queue",
            chapter: "queue",
            target: ".home-queue-panel",
            placement: "left",
            title: "Your Active Queue",
            body: `<p>Every sale lands here as a ticket with its number, items and a timer. The bar under each one fills up as it gets close to late.</p>
             <p>Rows turn amber, then red, the longer an order waits. Change those timings in <strong>Settings \u{203A} Order Queue Timers</strong>.</p>`
        },
        {
            id: "mark-ready",
            chapter: "queue",
            target: [
                ".status-popover.status-popover--open",
                "#openOrdersList .oq-row:has(.oq-practice) .oq-next-btn",
                "#openOrdersList .oq-row .oq-next-btn"
            ],
            mode: (api)=>api.queueCount() > 0 ? "wait" : "next",
            signal: [
                "order-ready",
                "order-done"
            ],
            waitHint: "Mark the order ready to continue",
            placement: "left",
            title: "Mark it Ready for Pickup",
            body: (api)=>api.queueCount() > 0 ? "<p>When the order is ready, tap <strong>Mark ready</strong> on its row. The <strong>\u22EF</strong> beside it has the other choices.</p>" : "<p>When an order is ready, tap <strong>Mark ready</strong> on its row. The <strong>\u22EF</strong> beside it has the other choices.</p>"
        },
        {
            id: "pickup-screen",
            chapter: "queue",
            target: "#displayDropdownToggle",
            title: "Call out orders on the Pickup Screen",
            body: `<p><strong>Screens \u{203A} Pickup Screen</strong> is a board for a TV or tablet your customers can see. Orders sit under <em>Preparing</em> and jump to <em>Ready for Pickup</em> the moment you mark them.</p>
             <p>In the kitchen? <strong>Screens \u{203A} Queue Screen</strong> shows the same queue for your cooks.</p>`,
            tip: "Practice orders stay on this screen only, so you won't see this one on the Pickup or Queue Screen. Real orders show up there instantly.",
            action: {
                label: "Open Pickup Screen",
                run: (api)=>api.openPickupDisplay()
            }
        },
        {
            id: "mark-done",
            chapter: "queue",
            skipIf: (api)=>api.queueCount() === 0,
            target: [
                ".status-popover.status-popover--open",
                "#openOrdersList .oq-row:has(.oq-practice) .oq-next-btn",
                "#openOrdersList .oq-row .oq-next-btn"
            ],
            mode: "wait",
            signal: "order-done",
            waitHint: "Mark the order done to continue",
            placement: "left",
            title: "Hand it over, then Done",
            body: `<p>Once the customer has it, tap <strong>Done</strong> to clear it from the queue.</p>
             <p>Tapped it by mistake? You get 10 seconds to <strong>Undo</strong>.</p>`
        },
        {
            id: "finish",
            chapter: "queue",
            target: [
                "#tourHubBtn",
                "#navProfileBtn",
                "#navMenuBtn"
            ],
            title: "You're ready to sell \uD83C\uDF89",
            body: `<p>That's the whole loop: items, order, payment, receipt, queue, pickup. Your practice order is cleared when you tap Finish.</p>
             <p>Want a refresher later? Open <strong>Tutorials</strong> from here anytime to redo the tour, jump to one part, or open a guide for any other feature.</p>`,
            nextLabel: "Finish"
        }
    ]
};
// ── Feature guides ───────────────────────────────────────────────────────────
const $8a6af5bb762aa044$var$catalogue = {
    id: "catalogue",
    title: "Catalogue",
    icon: "\uD83D\uDCE6",
    description: "Items, variants, categories, CSV import and bulk edits.",
    can: (api)=>api.can("manage_menu"),
    isOpen: $8a6af5bb762aa044$var$catalogueOpen,
    open: (api)=>api.open.catalogue(),
    helpAnchors: [
        {
            selector: "#menuModal .menu-modal-title"
        }
    ],
    steps: [
        {
            id: "actions",
            target: "#menuModal .menu-header-actions",
            title: "Add items your way",
            body: `<p><strong>Add Item</strong> creates one at a time. <strong>Upload CSV</strong> imports a whole list from a spreadsheet, with a template to start from.</p>`
        },
        {
            id: "categories",
            target: "#menuModal .menu-cat-manage",
            title: "Categories",
            body: "<p>Group items into categories. They become the tabs on the New Order screen, so staff find things fast.</p>"
        },
        {
            id: "items",
            target: [
                "#menuModal .menu-items-area .card",
                "#menuModal .menu-items-area"
            ],
            title: "Tap an item to edit it",
            body: `<p>Change its price, photo or emoji, variants (sizes, add-ons), tax exemption and status.</p>
             <p>Set it to <em>Unavailable</em> to grey it out for the day without deleting it. The <strong>Inventory</strong> section links it to stock.</p>`
        },
        {
            id: "select",
            skipIf: ()=>!$8a6af5bb762aa044$var$$("#menuSelectToggle"),
            target: "#menuSelectToggle",
            title: "Bulk edits",
            body: "<p><strong>Select</strong> lets you pick several items at once to change their status or delete them together.</p>"
        }
    ]
};
// Hands-on, on practice data (practiceData.js): the user sells lattes, watches
// the beans go Low (in Inventory AND on New Order), reorders with a purchase
// order, approves it, receives it, and sees stock + history update. The
// controller swaps the practice café in on start and the real data back on
// end; every Inventory write is fenced by _practiceGuard meanwhile.
const $8a6af5bb762aa044$var$invRow = (api)=>`#inventoryContent .inv-tr[data-id="${api.practice.ids.beans}"]`;
const $8a6af5bb762aa044$var$inventory = {
    id: "inventory",
    title: "Inventory",
    icon: "\uD83D\uDDC3\uFE0F",
    hero: "\u2615",
    description: "Hands-on with a practice caf\xe9: sell lattes, watch beans run low, reorder and restock.",
    can: (api)=>api.can("manage_inventory"),
    practice: true,
    resumable: false,
    onStart: (api)=>api.practice.startInventory(),
    onEnd: (api)=>{
        api.practice.end();
        api.clearPractice();
    },
    isOpen: $8a6af5bb762aa044$var$panelOpen("inventoryPanel"),
    open: (api)=>api.open.inventory(),
    helpAnchors: [
        {
            selector: "#inventoryPanel .cashflow-title"
        }
    ],
    steps: [
        {
            id: "welcome",
            welcome: true,
            title: "Let's run a caf\xe9 for a minute",
            body: `<p>Meet <strong>Bunny Caf\xe9</strong>: a few drinks, a pastry, and the supplies behind them. You'll sell some lattes, watch the coffee beans run low, then reorder and restock them, start to finish.</p>`,
            tip: "This is <strong>practice data</strong>. Your real inventory is tucked away, untouched, and comes back the moment you finish or close this tutorial.",
            nextLabel: "Let's go"
        },
        {
            id: "stats",
            onEnter: (api)=>api.practice.inventorySection("items"),
            target: "#inventoryContent .invx-stats",
            title: "Your stock at a glance",
            body: "<p>How many supplies you track, how many are running low or out, and what everything on your shelves is worth.</p>"
        },
        {
            id: "supplies",
            target: "#inventoryContent .inv-table",
            title: "Track what you sell, or what goes into it",
            body: `<p>Some things are counted as they are, like the <strong>Croissant</strong>: one sold, one gone (<em>Simple count</em>).</p>
             <p>Others are tracked by what goes into them: coffee beans by the gram, oat milk by the litre, cups by the piece (<em>Ingredients</em>).</p>
             <p>Each one has a <strong>reorder point</strong>. Beans get flagged the moment they drop to 500 g.</p>`
        },
        {
            id: "open-beans",
            target: $8a6af5bb762aa044$var$invRow,
            mode: "click",
            title: "Tap Coffee beans",
            body: "<p>Let's see what uses them.</p>"
        },
        {
            id: "used-by",
            target: "#inventoryDrawer",
            placement: "left",
            title: "How stock goes down by itself",
            body: `<p><strong>Used by</strong> lists every product that takes beans: each Latte and Cappuccino uses 18 g. Ring one up and the beans go down automatically. No counting by hand.</p>
             <p>Just above it are the suppliers you buy beans from, with their prices.</p>`
        },
        {
            id: "sell",
            onEnter: (api)=>api.practice.inventorySection("items"),
            target: $8a6af5bb762aa044$var$invRow,
            mode: "wait",
            signal: "practice-sold",
            waitHint: "Tap Sell 40 lattes",
            title: "Busy morning!",
            body: "<p>Ring up 40 lattes and keep your eye on the beans: 40 \xd7 18 g = 720 g used.</p>",
            action: {
                label: "\u2615 Sell 40 lattes",
                run: (api)=>api.practice.sellLattes()
            }
        },
        {
            id: "low",
            target: [
                "#inventoryContent .inv-attn:not(.inv-attn--po)",
                "#inventoryContent .invx-stats"
            ],
            title: "Beans are running low",
            body: `<p>They dropped to 480 g, under the 500 g reorder point. The row turns <strong>Low</strong>, the Low stock tile counts it, and this banner pops up so nobody misses it.</p>`
        },
        {
            id: "new-order",
            skipIf: (api)=>!api.can("take_orders"),
            onEnter: (api)=>api.practice.showNewOrder(),
            target: `#newOrderModal .pos-item-card[data-id="${(0, $b10fec56003d56fb$export$bba2591dc30e4a13).latte}"]`,
            placement: "bottom",
            title: "Your cashiers see it too",
            body: `<p>On New Order, the Latte and Cappuccino now wear a <strong>LOW</strong> chip (both use beans). It never blocks a sale, it just gives a heads-up before someone promises ten lattes.</p>
             <p>Tapping the chip shows which supply is low.</p>`
        },
        {
            id: "reorder",
            onEnter: (api)=>{
                if (document.querySelector("#newOrderModal .pos-items-area")) api.practice.showInventory();
            },
            target: "#invAttnReorder",
            mode: "click",
            title: "Reorder in one tap",
            body: "<p>Tap <strong>\uD83D\uDED2 Reorder</strong> to start a purchase order for everything that's low.</p>"
        },
        {
            id: "po-form",
            target: "body > .modal-overlay-form .invx-modal-card--wide",
            mode: "wait",
            signal: "po-created",
            waitHint: "Tap Create - for approval",
            placement: "left",
            title: "Check the order",
            body: `<p>It's filled in for you: enough beans to get back to a comfortable level, priced at what you paid last time.</p>
             <p>Pick <strong>Bean There Roasters</strong> as the supplier if you like, then tap <strong>Create - for approval</strong>.</p>`
        },
        {
            id: "approve",
            onEnter: (api)=>api.practice.focusNewestPo(),
            target: '#inventoryDrawer [data-act="send"]',
            mode: "click",
            placement: "left",
            title: "Approve it",
            body: `<p>New orders wait <strong>For approval</strong>, so someone can check them before money is spent.</p>
             <p>Tap <strong>Approve order</strong> once you've placed it with the supplier.</p>`
        },
        {
            id: "receive",
            target: '#inventoryDrawer [data-act="receive"]',
            mode: "click",
            placement: "left",
            title: "Delivery day",
            body: `<p>The order is now <strong>Waiting for delivery</strong> (and turns Overdue if it's late). When the boxes arrive, tap <strong>Mark as received</strong>.</p>`
        },
        {
            id: "receive-confirm",
            target: "body > .modal-overlay-form .invx-modal-card",
            mode: "wait",
            signal: "po-received",
            waitHint: "Tap Add to stock",
            title: "Add it to stock",
            body: "<p>Confirm, and every line on the order is added to your stock in one go.</p>"
        },
        {
            id: "restocked",
            onEnter: (api)=>api.practice.inventorySection("items"),
            target: $8a6af5bb762aa044$var$invRow,
            title: "Back to OK",
            body: `<p>Beans are topped up and the Low flag is gone, here and on New Order.</p>
             <p>The cost per gram updates to what you just paid, so your inventory value stays accurate.</p>`
        },
        {
            id: "history",
            onEnter: (api)=>api.practice.inventorySection("history"),
            target: "#inventoryContent",
            placement: "left",
            title: "Every movement, logged",
            body: "<p>Each sale, delivery, stock count and manual change, with who did it. Filter by type or date when something doesn't add up.</p>"
        },
        {
            id: "rest",
            target: "#inventorySidebar",
            placement: "right",
            title: "The rest of Inventory",
            body: `<p><strong>Purchase Orders</strong> lists every order. <strong>Suppliers</strong> keeps contacts and prices. <strong>Stock Counts</strong> is for walking the shelves and fixing the numbers to match what's really there.</p>`
        },
        {
            id: "finish",
            title: "Now make it yours",
            body: (api)=>`<p>1. Add your supplies here with <strong>New Item</strong>.<br>2. Open a product in the Catalogue and set its Inventory to <em>Simple count</em> or <em>Ingredients</em>.<br>3. Set reorder points, and Pointbunny keeps watch.</p>
             ${$8a6af5bb762aa044$var$proNote(api, "inventory", "Inventory")}`,
            tip: "Your real inventory comes back as soon as you tap Finish.",
            nextLabel: "Finish"
        }
    ]
};
const $8a6af5bb762aa044$var$discounts = $8a6af5bb762aa044$var$panelTour({
    id: "discounts",
    panel: "discountPanel",
    open: "discounts",
    perm: "manage_adjustments",
    title: "Receipt & Tax",
    icon: "\uD83E\uDDFE",
    description: "Sales tax or VAT, service charges and per-item exemptions.",
    steps: [
        {
            id: "tax",
            target: "#discountPanel .tax-settings-card",
            title: "How you charge tax",
            body: `<p>Choose whether tax is <strong>added at checkout</strong>, or already <strong>included</strong> in your prices (VAT style), and set your rate. We mark the option and rate recommended for your location.</p>
             <p>You can also exempt specific items.</p>`
        },
        {
            id: "auto",
            target: "#adjOnTopCard",
            title: "Automatic adjustments",
            body: "<p>Fees and discounts listed here are applied to every receipt, like a service charge. Switch any of them on or off. Sales tax lives in Tax Settings above.</p>"
        },
        {
            id: "add",
            target: "#adjPanelAddBtn",
            title: "Add one",
            body: "<p>Create a percentage or fixed amount. Cashiers can still adjust or remove it on a single receipt at checkout.</p>"
        }
    ]
});
const $8a6af5bb762aa044$var$promos = $8a6af5bb762aa044$var$panelTour({
    id: "promos",
    panel: "promoPanel",
    open: "promos",
    perm: "manage_discounts",
    title: "Promo codes",
    icon: "\uD83C\uDF9F\uFE0F",
    description: "Create discount codes customers can use at checkout.",
    steps: [
        {
            id: "new",
            target: "#promoNewBtn",
            title: "Create a code",
            body: "<p>Make a code like <em>WELCOME10</em> for a percentage or fixed discount, with optional limits and an end date.</p>"
        },
        {
            id: "stats",
            target: "#promoStats",
            title: "See what's working",
            body: "<p>A quick view of active codes and how often they're used.</p>"
        },
        {
            id: "use",
            title: "Using a code",
            body: "<p>At checkout, type the code in the promo field and the discount is applied to that receipt.</p>"
        }
    ]
});
const $8a6af5bb762aa044$var$loyalty = $8a6af5bb762aa044$var$panelTour({
    id: "loyalty",
    panel: "loyaltyPanel",
    open: "loyalty",
    perm: "manage_loyalty",
    title: "Loyalty",
    icon: "\u2B50",
    description: "Reward regulars with points, discounts and free items.",
    steps: [
        {
            id: "intro",
            title: "Turn regulars into fans",
            body: (api)=>`<p>Customers join with their phone number at checkout, earn points on every purchase, and spend them on rewards.</p>${$8a6af5bb762aa044$var$proNote(api, "loyalty", "Loyalty")}`
        },
        {
            id: "settings",
            target: "#loyaltySettingsCard",
            title: "How points work",
            body: "<p>Switch the program on, then set how many points a purchase earns and what points are worth as a discount.</p>"
        },
        {
            id: "rewards",
            target: "#loyaltyPanel .loyalty-rewards-card",
            title: "Free-item rewards",
            body: "<p>Offer specific items for a set number of points, like a free coffee for 100 points.</p>"
        },
        {
            id: "customers",
            target: "#loyaltyPanel .loyalty-customers-card",
            title: "Your members",
            body: "<p>Look anyone up, see their points and visit streak, or add a member by hand.</p>"
        }
    ]
});
const $8a6af5bb762aa044$var$staff = $8a6af5bb762aa044$var$panelTour({
    id: "staff",
    panel: "staffPanel",
    open: "staff",
    perm: "manage_staff",
    title: "Staff & roles",
    icon: "\uD83D\uDC65",
    description: "Invite your team and control what each person can do.",
    steps: [
        {
            id: "invite",
            target: "#inviteStaffBtn",
            title: "Invite your team",
            body: "<p>Send an invite by email. Each person gets their own login and a 6-digit PIN for switching cashiers at the register.</p>"
        },
        {
            id: "tabs",
            target: "#staffSidebar",
            placement: "right",
            title: "Members and Roles",
            body: "<p><strong>Members</strong> lists everyone on your team. <strong>Roles</strong> decides what each role can see and do, like taking orders, voiding sales or viewing reports.</p>"
        },
        {
            id: "switch",
            title: "Switching cashiers",
            body: "<p>On the home screen, tap the <strong>Cashier</strong> tile to switch who's at the register. Every sale records who rang it up.</p>"
        }
    ]
});
const $8a6af5bb762aa044$var$schedule = $8a6af5bb762aa044$var$panelTour({
    id: "schedule",
    panel: "schedulePanel",
    open: "schedule",
    perm: "manage_schedule",
    title: "Shift schedule",
    icon: "\uD83D\uDDD3\uFE0F",
    description: "Plan the week, then publish it so your team sees their shifts.",
    steps: [
        {
            id: "grid",
            target: "#scheduleContent .sch-grid-wrap",
            title: "Your week at a glance",
            body: "<p>Your team runs down the side and the days run across. Tap the <strong>+</strong> in a day to add a shift, or tap a shift to change it. Leave <strong>Who</strong> empty to post an open shift. Striped days mean someone is on leave or unavailable.</p>"
        },
        {
            id: "publish",
            target: "#schPublishBtn",
            title: "Publish when it's ready",
            body: "<p>New shifts start as <strong>drafts</strong> (dashed edges) that only schedulers see. <strong>Publish week</strong> sends them to your team's Time Clock.</p>"
        },
        {
            id: "copy",
            target: "#schCopyBtn",
            title: "Copy last week",
            body: "<p>Most weeks look alike. Copy last week's shifts as drafts, adjust, then publish.</p>"
        },
        {
            id: "stations",
            target: "#scheduleSidebar",
            placement: "right",
            title: "Requests, availability, stations",
            body: "<p><strong>Requests</strong> holds shift swaps and open-shift pickups waiting for your OK. <strong>Availability</strong> shows when each person can work. <strong>Stations</strong> are the labels on shifts, like Barista or Kitchen.</p>"
        }
    ]
});
// Hands-on, on a practice team (practiceData.js): fix a forgotten clock-out,
// approve a correction and a day off, tour the Time Clock setup and export.
// Every Timesheets write is fenced by _practiceGuard while it runs.
const $8a6af5bb762aa044$var$fillClockOut = ()=>{
    const inEl = document.getElementById("shiftClockIn");
    const outEl = document.getElementById("shiftClockOut");
    if (!inEl?.value || !outEl) return;
    outEl.value = `${inEl.value.slice(0, 10)}T20:00`;
    outEl.dispatchEvent(new Event("input", {
        bubbles: true
    }));
};
const $8a6af5bb762aa044$var$timesheets = {
    id: "timesheets",
    title: "Timesheets & Time Clock",
    icon: "\u23F1\uFE0F",
    hero: "\u23F1\uFE0F",
    description: "Hands-on with a practice team: fix a missed clock-out, approve requests, set up the time clock.",
    can: (api)=>api.can("manage_pay") || api.can("manage_staff"),
    resumable: false,
    onStart: (api)=>api.practice.startTimesheets(),
    onEnd: (api)=>api.practice.end(),
    isOpen: $8a6af5bb762aa044$var$panelOpen("timesheetPanel"),
    open: (api)=>api.open.timesheets(),
    helpAnchors: [
        {
            selector: "#timesheetPanel .cashflow-title"
        }
    ],
    steps: [
        {
            id: "welcome",
            welcome: true,
            title: "Meet the Bunny Caf\xe9 team",
            body: `<p>Maya, Jon and Ana worked last week. You'll fix a forgotten clock-out, approve a correction and a day off, and see how the Time Clock works.</p>`,
            tip: (api)=>`This is <strong>practice data</strong>. Your real timesheets are untouched and come back when you finish or close this tutorial.${api.isLocked("timesheets") ? " Timesheets is part of Pointbunny Pro." : ""}`,
            nextLabel: "Let's go"
        },
        {
            id: "stats",
            target: "#timesheetContent .ts-stat-strip",
            title: "The week at a glance",
            body: "<p>Total hours, shifts worked, and the average shift length for everyone on the team.</p>"
        },
        {
            id: "open-jon",
            target: `#timesheetContent [data-staff-toggle][data-staff-id="${(0, $b10fec56003d56fb$export$bba2591dc30e4a13).jon}"]`,
            mode: "click",
            title: "Open Jon's week",
            body: "<p>Everyone gets a card with their total hours. Tap <strong>Jon Reyes</strong>.</p>"
        },
        {
            id: "edit-open",
            target: `#timesheetContent .payroll-edit-btn[data-id="${(0, $b10fec56003d56fb$export$bba2591dc30e4a13).jonOpenShift}"]`,
            mode: "click",
            title: "Jon forgot to clock out",
            body: `<p>Thursday's shift has no end time, so it still says <strong>Active</strong> and doesn't count toward his hours.</p>
             <p>Tap <strong>Edit</strong> to fix it.</p>`
        },
        {
            id: "save-shift",
            target: "#shiftEditModal .cashier-picker-card",
            mode: "wait",
            signal: "shift-saved",
            waitHint: "Set the clock-out, then tap Save",
            placement: "right",
            title: "Add the clock-out time",
            body: "<p>Jon left at 8:00 PM. Set <strong>Clock Out</strong>, then tap <strong>Save</strong>. Every edit is labeled with who made it.</p>",
            action: {
                label: "Fill in 8:00 PM for me",
                run: ()=>$8a6af5bb762aa044$var$fillClockOut()
            }
        },
        {
            id: "corrections-tab",
            target: '#timesheetSidebar .ts-tab[data-section="corrections"]',
            mode: "click",
            placement: "right",
            title: "Staff can fix their own mistakes",
            body: "<p>When someone forgets to clock in or out, they can request a fix from the Time Clock. Those requests land here. Tap <strong>Corrections</strong>.</p>"
        },
        {
            id: "correction",
            target: "#timesheetContent .ser-req",
            mode: "wait",
            signal: "correction-reviewed",
            waitHint: "Approve or reject to continue",
            title: "Ana's correction",
            body: `<p>She says she started at 9:00, not 9:20. <strong>Approve</strong> applies the new time to her shift. <strong>Reject</strong> keeps it as it was.</p>`
        },
        {
            id: "leave-tab",
            target: '#timesheetSidebar .ts-tab[data-section="leave"]',
            mode: "click",
            placement: "right",
            title: "Days off",
            body: "<p>Vacation and sick-day requests come in here too. Tap <strong>Leave</strong>.</p>"
        },
        {
            id: "leave",
            target: "#timesheetContent .ts-lv-card",
            mode: "wait",
            signal: "leave-reviewed",
            waitHint: "Approve or reject to continue",
            title: "Jon wants next Friday off",
            body: "<p>Approve it and it moves to <strong>Upcoming</strong>, so you can plan the week around it.</p>"
        },
        {
            id: "timeclock-tab",
            target: '#timesheetSidebar .ts-tab[data-section="timeclock"]',
            mode: "click",
            placement: "right",
            title: "Where hours come from",
            body: "<p>Tap <strong>Time Clock</strong>.</p>"
        },
        {
            id: "timeclock",
            target: "#timesheetContent",
            placement: "left",
            title: "Set up a Time Clock",
            body: `<p>Put a tablet by the door and open the <strong>Time Clock</strong> on it (Time Clock in the side menu). Generate a code here, enter it on the tablet once, and it's ready.</p>
             <p>Staff then clock in, take breaks and clock out with their PIN, and request corrections or days off from the same screen.</p>`,
            tip: "Every device you set up is listed here, so a lost tablet can be removed in one tap."
        },
        {
            id: "back",
            target: '#timesheetSidebar .ts-tab[data-section="timesheets"]',
            mode: "click",
            placement: "right",
            title: "Back to the hours",
            body: "<p>Tap <strong>Timesheets</strong>.</p>"
        },
        {
            id: "export",
            target: "#payrollExportToggle",
            title: "Payroll time",
            body: "<p>Export the period as a PDF or CSV for payroll. Switch between week, month or a custom range at the top.</p>"
        },
        {
            id: "finish",
            title: "Ready for payroll",
            body: `<p>Set up a Time Clock device, give your team their PINs from <strong>Staff</strong>, and their hours land here on their own.</p>`,
            tip: "Your real timesheets come back as soon as you tap Finish.",
            nextLabel: "Finish"
        }
    ]
};
const $8a6af5bb762aa044$var$reports = $8a6af5bb762aa044$var$panelTour({
    id: "reports",
    panel: "reportsPanel",
    open: "reports",
    perm: "view_reports",
    title: "Reports",
    icon: "\uD83D\uDCCA",
    description: "Sales trends, best sellers, busy hours and serving times.",
    steps: [
        {
            id: "period",
            target: "#reportsTabs",
            title: "Pick a period",
            body: (api)=>`<p>Switch between today, this week, month, year or a custom range.</p>${$8a6af5bb762aa044$var$proNote(api, "reports", "Reports beyond today")}`
        },
        {
            id: "sections",
            target: "#reportsPanel .rp-sidebar",
            placement: "right",
            title: "Dig into the numbers",
            body: "<p><strong>Overview</strong> for the big picture, <strong>Sales</strong> for best sellers, <strong>Traffic</strong> for busy hours, <strong>Kitchen</strong> for serving times, <strong>Channels</strong> for order types and payment methods.</p>"
        },
        {
            id: "compare",
            target: "#reportsCompareBtn",
            title: "Compare periods",
            body: "<p>Put this week next to last week, or this month next to the same month last year.</p>"
        },
        {
            id: "export",
            target: "#reportsExportBtn",
            title: "Take it with you",
            body: "<p>Export to CSV for spreadsheets, or PDF to share.</p>"
        }
    ]
});
const $8a6af5bb762aa044$var$cashflow = $8a6af5bb762aa044$var$panelTour({
    id: "cashflow",
    panel: "cashflowPanel",
    open: "cashflow",
    perm: "manage_cashflow",
    title: "Sales & expenses",
    icon: "\uD83D\uDCB0",
    description: "Every transaction, reprints, voids and expenses.",
    steps: [
        {
            id: "tabs",
            target: "#cashflowPanel .cashflow-tabs",
            title: "Sales, expenses, voided",
            body: "<p>Every sale is saved here, whether or not a receipt was printed. Expenses and voided sales have their own tabs.</p>"
        },
        {
            id: "sale",
            target: "#cashflowSalesList",
            title: "Tap a sale",
            body: "<p>See its receipt, <strong>reprint</strong> it, or <strong>void</strong> it if it was a mistake. Voided sales keep their invoice number so your records stay complete.</p>"
        },
        {
            id: "expense",
            target: "#addExpenseBtn",
            title: "Log expenses",
            body: "<p>Record money going out, like supplies or rent, to see your real net for the day.</p>"
        },
        {
            id: "export",
            target: "#exportCsvBtn",
            title: "Export",
            body: "<p>Download what you're looking at as a CSV for your accountant.</p>"
        }
    ]
});
const $8a6af5bb762aa044$var$screens = {
    id: "screens",
    title: "Screens & terminals",
    icon: "\uD83D\uDDA5\uFE0F",
    description: "Customer, queue and pickup screens, plus pairing devices.",
    can: ()=>true,
    steps: [
        {
            id: "screens",
            target: "#displayDropdownToggle",
            title: "Three extra screens",
            body: `<p><strong>Customer Screen</strong> shows the order and total as you ring it up.<br>
             <strong>Queue Screen</strong> is for the kitchen or prep area.<br>
             <strong>Pickup Screen</strong> is a board customers watch for their number.</p>`
        },
        {
            id: "terminal",
            target: "#terminalToggle",
            title: "Pair the right devices",
            body: "<p>If you run more than one register, give each a terminal number. Set a customer screen to the same number so it only shows that register's orders.</p>"
        },
        {
            id: "settings",
            target: [
                "#settingsBtn",
                "#navProfileBtn"
            ],
            title: "Make them yours",
            body: "<p><strong>Settings \u203A Displays</strong> (in your profile menu, top right) lets you add a promo image to the customer and pickup screens, upload a payment QR code, and set window sizes.</p>"
        }
    ]
};
const $8a6af5bb762aa044$export$7a357837346c6789 = [
    $8a6af5bb762aa044$var$firstSale,
    $8a6af5bb762aa044$var$catalogue,
    $8a6af5bb762aa044$var$inventory,
    $8a6af5bb762aa044$var$discounts,
    $8a6af5bb762aa044$var$promos,
    $8a6af5bb762aa044$var$loyalty,
    $8a6af5bb762aa044$var$staff,
    $8a6af5bb762aa044$var$timesheets,
    $8a6af5bb762aa044$var$schedule,
    $8a6af5bb762aa044$var$reports,
    $8a6af5bb762aa044$var$cashflow,
    $8a6af5bb762aa044$var$screens
];


// Tutorial practice data in effect, or null. See "Tutorial practice data"
// below - declared up here because the background refreshers check it.
let $1d9fcaa0a6035698$var$_practice = null; // { kind: 'inventory' | 'timesheets', saved, data, poSeq, saleSeq }
const $1d9fcaa0a6035698$var$modelState = $1e7ab04ca7920cff$export$ca000e230c0caa3e;
let $1d9fcaa0a6035698$var$item;
const $1d9fcaa0a6035698$var$_randomUUID = ()=>{
    if (typeof crypto?.randomUUID === 'function') return crypto.randomUUID();
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
};
// ── Toast notifications ───────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$showToast = function(message, type = 'error', duration = 3500) {
    const toast = document.createElement('div');
    toast.className = `toast toast--${type}`;
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(()=>toast.classList.add('toast--visible'));
    setTimeout(()=>{
        toast.classList.remove('toast--visible');
        toast.addEventListener('transitionend', ()=>toast.remove(), {
            once: true
        });
    }, duration);
};
// ── Offline awareness ─────────────────────────────────────────────────────────
// Sales can't be recorded without the internet yet (offline selling is planned,
// see pointbunny-app-todos.md "Offline selling"). Until then the cashier must
// always know: a banner while offline, and a plain message if a sale fails on
// the network instead of the raw fetch error.
const $1d9fcaa0a6035698$var$_isNetworkError = (err)=>!navigator.onLine || /failed to fetch|networkerror|load failed|network request failed/i.test(String(err?.message ?? err ?? ''));
const $1d9fcaa0a6035698$var$_syncOfflineBanner = function() {
    const offline = !navigator.onLine;
    document.body.classList.toggle('is-offline', offline);
    let el = document.getElementById('offlineBanner');
    if (!offline) {
        el?.remove();
        return;
    }
    if (el) return;
    el = document.createElement('div');
    el.id = 'offlineBanner';
    el.className = 'offline-banner';
    el.setAttribute('role', 'status');
    el.innerHTML = `<span class="offline-banner-dot" aria-hidden="true"></span><span><strong>You're offline.</strong> Sales can't be recorded until the internet is back.</span>`;
    document.body.appendChild(el);
};
window.addEventListener('offline', $1d9fcaa0a6035698$var$_syncOfflineBanner);
window.addEventListener('online', ()=>{
    const wasOffline = !!document.getElementById('offlineBanner');
    $1d9fcaa0a6035698$var$_syncOfflineBanner();
    if (wasOffline) $1d9fcaa0a6035698$var$showToast("You're back online.", 'success');
});
$1d9fcaa0a6035698$var$_syncOfflineBanner();
// ── App loading overlay ───────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$_appLoadingEl = document.getElementById('appLoadingOverlay');
const $1d9fcaa0a6035698$var$showLoadingScreen = function() {
    $1d9fcaa0a6035698$var$_appLoadingEl?.classList.remove('hidden');
};
const $1d9fcaa0a6035698$var$hideLoadingScreen = function() {
    $1d9fcaa0a6035698$var$_appLoadingEl?.classList.add('hidden');
};
//adding/displaying menu list
//to add edit/delete option
const $1d9fcaa0a6035698$var$controlMenuList = async function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_menu')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to the catalogue.", 'error');
        return;
    }
    try {
        const state = $1e7ab04ca7920cff$export$ca000e230c0caa3e;
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._categoriesOpen = false; // always open the catalogue collapsed/focused on items
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._selectMode = false; // always open out of bulk-select mode
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._selectedIds.clear();
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039).render(state);
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._addHandlerCloseModal();
        (0, $0540865b060d0b60$export$2e2bcd8739ae039)._mapMenuCategoriesMarkUp(state.menuCategories);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
// First-run prompt on the home page: show "Set up your menu" only when the
// catalogue is empty AND this user can manage the menu. Re-run on load and after
// any add/import/delete so it appears/disappears live.
const $1d9fcaa0a6035698$var$_updateMenuSetupBanner = function() {
    if ($1d9fcaa0a6035698$var$_practice) return; // practice menu items must not drive the real setup prompts
    const banner = document.getElementById('menuSetupBanner');
    if (!banner) return;
    const empty = ($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems?.length ?? 0) === 0;
    // The Getting Started card contains this same prompt as its first step
    // (identical banner styling), so the standalone banner yields while the
    // card is active - it still covers manage_menu users who can't see the
    // card, and returns if the catalogue empties after the card retires.
    const gs = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings;
    const checklistActive = !gs.gettingStartedDismissed && !gs.gettingStartedCompleted && $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business');
    banner.classList.toggle('hidden', !(empty && $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_menu') && !checklistActive));
    // Menu mutations also move the checklist's "Add your first items" step.
    $1d9fcaa0a6035698$var$_updateGettingStarted();
};
// ── Getting Started checklist ────────────────────────────────────────────────
// Live onboarding steps computed from state; every row deep-links to the panel
// where the step gets done. Shown only to manage_business holders while the
// business is neither dismissed (the x, gettingStartedDismissed) nor completed
// (gettingStartedCompleted - written once every step is done). Deliberately
// independent of the menu setup banner above, which ALWAYS returns while the
// catalogue is empty. Phase 2 (todos): an activity feed replaces this card.
let $1d9fcaa0a6035698$var$_gsHasSale = false; // sticky once true (a sale can't un-happen)
let $1d9fcaa0a6035698$var$_gsSalePromise = null; // de-dupes the one-time has-any-sale DB check
let $1d9fcaa0a6035698$var$_gsShownIncomplete = false; // celebrate only if the user watched it finish
let $1d9fcaa0a6035698$var$_gsFinishing = false;
const $1d9fcaa0a6035698$var$_gettingStartedSteps = function() {
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e;
    return [
        {
            id: 'items',
            label: 'Add your first items',
            done: (s.menuItems?.length ?? 0) > 0
        },
        // Deliberately NOT keyed on "an adjustment exists": onboarding's tax
        // suggestion can create one before the owner has ever seen the panel.
        // The step is about actually reviewing your tax setup, so it checks off
        // when the Receipt Adjustments panel is opened (write-once flag below).
        {
            id: 'taxes',
            label: 'Set up taxes & fees',
            done: !!s.settings.taxSetupSeen
        },
        {
            id: 'inventory',
            label: 'Set up inventory',
            done: !!s.settings.inventorySetupSeen
        },
        {
            id: 'receipt',
            label: 'Set up your receipt',
            done: !!s.settings.receiptSetupSeen
        },
        // Also view-based, NOT "a second staff row exists": staff invitations may
        // become a paid-tier feature, so the checklist must never require one.
        {
            id: 'team',
            label: 'Set up your team',
            done: !!s.settings.teamSetupSeen
        },
        {
            id: 'sale',
            label: 'Make your first sale',
            done: $1d9fcaa0a6035698$var$_gsHasSale
        }
    ];
};
// ── Home activity feed ───────────────────────────────────────────────────────
// Real events (model.fetchActivityFeed) take over the Getting Started card once
// the checklist retires. Fetches are debounced + rate-limited and never join
// the boot Promise.all; while the tab is hidden refreshes collapse into one
// catch-up fetch on refocus (same pattern as the on-shift poll).
let $1d9fcaa0a6035698$var$_activityEvents = []; // last fetched events (payloads power click-through)
let $1d9fcaa0a6035698$var$_activityLoaded = false; // distinguishes "still fetching" from "genuinely empty"
let $1d9fcaa0a6035698$var$_activityDebounce = null;
let $1d9fcaa0a6035698$var$_activityLastFetch = 0;
let $1d9fcaa0a6035698$var$_activityInflight = false;
let $1d9fcaa0a6035698$var$_activityDirty = false; // a refresh was requested while hidden/inflight
const $1d9fcaa0a6035698$var$_canSeeActivityFeed = ()=>$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business') || $1e7ab04ca7920cff$export$b325ec6732b039cf('view_activity_log');
const $1d9fcaa0a6035698$var$_activityFeedActive = function() {
    const gs = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings;
    return $1d9fcaa0a6035698$var$_canSeeActivityFeed() && (gs.gettingStartedDismissed || gs.gettingStartedCompleted);
};
// A row is clickable when the user can reach its drill-down target: the
// sale-receipt modal needs nothing extra (everyone who can see the feed can
// open a receipt), the rest map to the target panel's own permission gate.
const $1d9fcaa0a6035698$var$_activityClickable = function(type) {
    if (type === 'sale' || type === 'void') return true;
    if (type === 'clock_in' || type === 'clock_out') return $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay') || $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_staff');
    if (type === 'expense') return $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_cashflow');
    if (type === 'customer_enrolled') return $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_loyalty');
    return $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_inventory'); // stock_adjust / low_stock / out_of_stock / po_received
};
const $1d9fcaa0a6035698$var$_activityDisplayEntries = ()=>$1d9fcaa0a6035698$var$_activityEvents.map((ev)=>({
            ...ev,
            clickable: $1d9fcaa0a6035698$var$_activityClickable(ev.type)
        }));
const $1d9fcaa0a6035698$var$_renderActivityFeed = function() {
    (0, $8f20510e9e5c6549$export$2e2bcd8739ae039).renderActivityFeed($1d9fcaa0a6035698$var$_activityDisplayEntries(), {
        loaded: $1d9fcaa0a6035698$var$_activityLoaded
    });
    if ((0, $8f20510e9e5c6549$export$2e2bcd8739ae039).isActivityModalOpen()) (0, $8f20510e9e5c6549$export$2e2bcd8739ae039).renderActivityModalList($1d9fcaa0a6035698$var$_activityDisplayEntries());
};
const $1d9fcaa0a6035698$var$_fetchActivityNow = async function() {
    if ($1d9fcaa0a6035698$var$_practice) return; // would read practice stock levels; refreshed when the tour ends
    if ($1d9fcaa0a6035698$var$_activityInflight) {
        $1d9fcaa0a6035698$var$_activityDirty = true;
        return;
    }
    $1d9fcaa0a6035698$var$_activityInflight = true;
    $1d9fcaa0a6035698$var$_activityLastFetch = Date.now();
    try {
        $1d9fcaa0a6035698$var$_activityEvents = await $1e7ab04ca7920cff$export$967c92ed76f908b6();
        $1d9fcaa0a6035698$var$_activityLoaded = true;
        $1d9fcaa0a6035698$var$_renderActivityFeed();
    } catch  {}
    $1d9fcaa0a6035698$var$_activityInflight = false;
    if ($1d9fcaa0a6035698$var$_activityDirty) {
        $1d9fcaa0a6035698$var$_activityDirty = false;
        $1d9fcaa0a6035698$var$_requestActivityRefresh();
    }
};
// Debounced (a burst of sales = one round of queries) + min 5s between fetches.
const $1d9fcaa0a6035698$var$_requestActivityRefresh = function() {
    if (!$1d9fcaa0a6035698$var$_activityFeedActive()) return;
    if (document.hidden) {
        $1d9fcaa0a6035698$var$_activityDirty = true;
        return;
    }
    clearTimeout($1d9fcaa0a6035698$var$_activityDebounce);
    const wait = Math.max(1200, $1d9fcaa0a6035698$var$_activityLastFetch + 5000 - Date.now());
    $1d9fcaa0a6035698$var$_activityDebounce = setTimeout($1d9fcaa0a6035698$var$_fetchActivityNow, wait);
};
document.addEventListener('visibilitychange', ()=>{
    if (!document.hidden && $1d9fcaa0a6035698$var$_activityDirty) {
        $1d9fcaa0a6035698$var$_activityDirty = false;
        $1d9fcaa0a6035698$var$_requestActivityRefresh();
    }
});
// Relative labels ("Just now" -> "1m ago") age at render time, so tick a pure
// re-render of the cached events every minute - no queries, and the card has
// no entrance animation so the innerHTML swap can't blink.
setInterval(()=>{
    if (!document.hidden && $1d9fcaa0a6035698$var$_activityLoaded && $1d9fcaa0a6035698$var$_activityFeedActive()) $1d9fcaa0a6035698$var$_renderActivityFeed();
}, 60000);
// ── Navbar notification bell ─────────────────────────────────────────────────
// Draft POs / pending shift corrections / pending leave requests - three
// "needs a manager's decision" queues - plus a fourth, non-actionable category:
// leave starting soon (a 7-day and 1-day-out reminder nudge, not a review
// queue). Since 2026-10-17 also shift swaps/pickups waiting for a manager
// (manage_schedule). Gated on the SIGNED-IN account's own capabilities: hasPermission()
// reads state.currentStaff's role (model.js) and is never touched by Quick
// Switch Cashier, which only reassigns state.currentCashier - so switching to
// a manager cashier mid-shift can never reveal this to a non-manager account.
let $1d9fcaa0a6035698$var$_notifData = {
    pos: [],
    corrections: [],
    leave: [],
    leaveUpcoming: [],
    shiftRequests: []
};
let $1d9fcaa0a6035698$var$_notifLastFetch = 0;
let $1d9fcaa0a6035698$var$_notifCanPOs = false;
let $1d9fcaa0a6035698$var$_notifCanPay = false;
let $1d9fcaa0a6035698$var$_notifCanSchedule = false;
let $1d9fcaa0a6035698$var$_closeNotifMenu = ()=>{}; // set once the dropdown is wired, see _addHandlers
// Days from the cafe's today (business timezone) to a 'YYYY-MM-DD' calendar date.
const $1d9fcaa0a6035698$var$_daysUntil = function(dateStr) {
    const today = (0, $lDSCx.todayIn)($1d9fcaa0a6035698$var$_bizTz());
    return Math.round((Date.parse(dateStr + 'T00:00:00Z') - Date.parse(today + 'T00:00:00Z')) / 86400000);
};
// Upcoming-leave reminders have no review action to resolve them (unlike POs/
// corrections/pending-leave, which drop out of the badge the moment they're
// approved/rejected) - without this they'd sit in the unread count for the
// entire day they're active, even right after being seen. Keyed by
// `${id}:${days}` so the 7-day and 1-day nudges for the same leave request
// are tracked - and can be "unseen" again - independently.
const $1d9fcaa0a6035698$var$LEAVE_SEEN_KEY = 'pointbunny_seen_leave_reminders';
const $1d9fcaa0a6035698$var$_leaveReminderKey = (r)=>`${r.id}:${$1d9fcaa0a6035698$var$_daysUntil(r.startDate)}`;
let $1d9fcaa0a6035698$var$_seenLeaveReminders = (()=>{
    try {
        return new Set(JSON.parse(localStorage.getItem($1d9fcaa0a6035698$var$LEAVE_SEEN_KEY)) || []);
    } catch  {
        return new Set();
    }
})();
const $1d9fcaa0a6035698$var$_saveSeenLeaveReminders = function() {
    try {
        localStorage.setItem($1d9fcaa0a6035698$var$LEAVE_SEEN_KEY, JSON.stringify([
            ...$1d9fcaa0a6035698$var$_seenLeaveReminders
        ]));
    } catch  {}
};
const $1d9fcaa0a6035698$var$_refreshNotifications = async function() {
    if ($1d9fcaa0a6035698$var$_practice) return; // would reload real POs over the practice ones; refreshed when the tour ends
    const canPOs = $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_inventory');
    const canPay = $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay');
    const canSchedule = $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_schedule');
    if (!canPOs && !canPay && !canSchedule) return; // stays hidden - never shown via currentCashier
    $1d9fcaa0a6035698$var$_notifLastFetch = Date.now();
    $1d9fcaa0a6035698$var$_notifCanPOs = canPOs;
    $1d9fcaa0a6035698$var$_notifCanPay = canPay;
    $1d9fcaa0a6035698$var$_notifCanSchedule = canSchedule;
    try {
        const [pos, allLeave, corrections, shiftRequests] = await Promise.all([
            canPOs ? $1e7ab04ca7920cff$export$4faf3f9b9ffc9853().then(()=>$1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders.filter((p)=>p.status === 'draft')) : Promise.resolve([]),
            canPay ? $1e7ab04ca7920cff$export$dd48584891564f37() : Promise.resolve([]),
            canPay ? $1e7ab04ca7920cff$export$b910b0e182c20503() : Promise.resolve([]),
            // Swaps/pickups waiting for a manager (phase 3). Best-effort: [] if the
            // 2026-10-17 migration isn't run yet.
            canSchedule ? $1e7ab04ca7920cff$export$8050acf0b604c9e().then((all)=>all.filter((r)=>r.status === 'pending')).catch(()=>[]) : Promise.resolve([])
        ]);
        const leave = allLeave.filter((r)=>r.status === 'pending');
        // Reminder nudge, not a review queue: approved leave starting in exactly
        // 7 or 1 days. Fires whenever this account has the app open on that day -
        // no scheduled job, matches the poll-while-visible pattern the rest of
        // this bell already uses.
        const leaveUpcoming = allLeave.filter((r)=>{
            if (r.status !== 'approved') return false;
            const days = $1d9fcaa0a6035698$var$_daysUntil(r.startDate);
            return days === 7 || days === 1;
        });
        // Garbage-collect: drop any seen key that isn't one of today's reminders
        // (the leave got reviewed/passed, or the day rolled past 7/1) so the set
        // can't grow forever.
        const liveKeys = new Set(leaveUpcoming.map($1d9fcaa0a6035698$var$_leaveReminderKey));
        $1d9fcaa0a6035698$var$_seenLeaveReminders = new Set([
            ...$1d9fcaa0a6035698$var$_seenLeaveReminders
        ].filter((k)=>liveKeys.has(k)));
        $1d9fcaa0a6035698$var$_saveSeenLeaveReminders();
        $1d9fcaa0a6035698$var$_notifData = {
            pos: pos,
            corrections: corrections,
            leave: leave,
            leaveUpcoming: leaveUpcoming,
            shiftRequests: shiftRequests
        };
        (0, $9e6597a253ab6810$export$2e2bcd8739ae039).reveal();
        (0, $9e6597a253ab6810$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_notifData, {
            canPOs: canPOs,
            canPay: canPay,
            canSchedule: canSchedule,
            leaveUpcomingUnseen: $1d9fcaa0a6035698$var$_unseenLeaveCount()
        });
        $1d9fcaa0a6035698$var$_renderHomeCards(); // Needs your OK / Purchase orders / To review
    } catch  {}
};
const $1d9fcaa0a6035698$var$_unseenLeaveCount = function() {
    return $1d9fcaa0a6035698$var$_notifData.leaveUpcoming.filter((r)=>!$1d9fcaa0a6035698$var$_seenLeaveReminders.has($1d9fcaa0a6035698$var$_leaveReminderKey(r))).length;
};
// Called when the bell dropdown opens: marks every reminder currently shown
// as seen and re-renders immediately (no network round-trip) so the badge
// clears right away rather than waiting for the next 60s poll.
const $1d9fcaa0a6035698$var$_markLeaveRemindersSeen = function() {
    if (!$1d9fcaa0a6035698$var$_notifData.leaveUpcoming.length) return;
    $1d9fcaa0a6035698$var$_notifData.leaveUpcoming.forEach((r)=>$1d9fcaa0a6035698$var$_seenLeaveReminders.add($1d9fcaa0a6035698$var$_leaveReminderKey(r)));
    $1d9fcaa0a6035698$var$_saveSeenLeaveReminders();
    (0, $9e6597a253ab6810$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_notifData, {
        canPOs: $1d9fcaa0a6035698$var$_notifCanPOs,
        canPay: $1d9fcaa0a6035698$var$_notifCanPay,
        canSchedule: $1d9fcaa0a6035698$var$_notifCanSchedule,
        leaveUpcomingUnseen: $1d9fcaa0a6035698$var$_unseenLeaveCount()
    });
};
// Throttled refetch for the bell-open click - avoids double-fetching right
// after the boot fetch or on a rapid double-toggle.
const $1d9fcaa0a6035698$var$_requestNotifRefresh = function() {
    if (document.hidden) return;
    if (Date.now() - $1d9fcaa0a6035698$var$_notifLastFetch < 20000) return;
    $1d9fcaa0a6035698$var$_refreshNotifications();
};
// No realtime push for corrections/leave today (see the plan doc); a light
// poll covers all three, paused while the tab is hidden like the on-shift poll.
setInterval(()=>{
    if (!document.hidden) $1d9fcaa0a6035698$var$_refreshNotifications();
}, 60000);
const $1d9fcaa0a6035698$var$controlNotifOpenCategory = async function(cat) {
    $1d9fcaa0a6035698$var$_closeNotifMenu();
    if (cat === 'po') {
        await $1d9fcaa0a6035698$var$controlOpenInventory();
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).showDraftPOs();
    } else if (cat === 'corrections') {
        (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).setSection('corrections');
        await $1d9fcaa0a6035698$var$controlOpenTimesheets();
    } else if (cat === 'leave' || cat === 'leaveUpcoming') {
        (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).setSection('leave');
        await $1d9fcaa0a6035698$var$controlOpenTimesheets();
    } else if (cat === 'shiftRequests') {
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).setSection('requests');
        await $1d9fcaa0a6035698$var$controlOpenSchedule();
    }
};
const $1d9fcaa0a6035698$var$controlNotifOpenItem = async function(cat, id) {
    $1d9fcaa0a6035698$var$_closeNotifMenu();
    if (cat === 'po') {
        await $1d9fcaa0a6035698$var$controlOpenInventory();
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).focusPO(id);
    } else if (cat === 'corrections') {
        (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).setSection('corrections');
        await $1d9fcaa0a6035698$var$controlOpenTimesheets();
        (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).focusCorrection(id);
    } else if (cat === 'leave' || cat === 'leaveUpcoming') {
        (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).setSection('leave');
        await $1d9fcaa0a6035698$var$controlOpenTimesheets();
        (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).focusLeaveRequest(id);
    } else if (cat === 'shiftRequests') {
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).setSection('requests');
        await $1d9fcaa0a6035698$var$controlOpenSchedule();
    }
};
const $1d9fcaa0a6035698$var$controlActivityClick = function(evtId) {
    const ev = $1d9fcaa0a6035698$var$_activityEvents.find((e)=>e.id === evtId);
    if (!ev || !$1d9fcaa0a6035698$var$_activityClickable(ev.type)) return;
    // Drill-down replaces the list modal (panels sit below the modal backdrop).
    (0, $8f20510e9e5c6549$export$2e2bcd8739ae039).closeActivityModal();
    if (ev.type === 'sale' || ev.type === 'void') // Payload is the full sales row, so this works straight from the home page;
    // showSaleReceipt itself shows the VOIDED banner and hides Reprint for voids.
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).showSaleReceipt(ev.payload, ()=>$1d9fcaa0a6035698$var$controlReprintSale(ev.payload));
    else if (ev.type === 'clock_in' || ev.type === 'clock_out') $1d9fcaa0a6035698$var$controlOpenTimesheets();
    else if (ev.type === 'expense') $1d9fcaa0a6035698$var$controlOpenCashflow();
    else if (ev.type === 'customer_enrolled') $1d9fcaa0a6035698$var$controlOpenLoyalty();
    else $1d9fcaa0a6035698$var$controlOpenInventory();
};
const $1d9fcaa0a6035698$var$_updateGettingStarted = async function() {
    // Practice data must never tick (and persist) a real Getting Started step.
    if ($1d9fcaa0a6035698$var$_practice) return;
    const canManage = $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business');
    if (!canManage && !$1d9fcaa0a6035698$var$_canSeeActivityFeed()) {
        (0, $8f20510e9e5c6549$export$2e2bcd8739ae039).hide();
        $1d9fcaa0a6035698$var$_showMyShift();
        return;
    }
    const { gettingStartedDismissed: gettingStartedDismissed, gettingStartedCompleted: gettingStartedCompleted } = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings;
    if (gettingStartedDismissed || gettingStartedCompleted) {
        $1d9fcaa0a6035698$var$_hideMyShift();
        // Checklist retired (done or x-ed) - the card becomes the activity feed.
        $1d9fcaa0a6035698$var$_renderActivityFeed();
        $1d9fcaa0a6035698$var$_requestActivityRefresh();
        return;
    }
    if (!canManage) {
        // Onboarding checklist itself is owner-only; a view_activity_log-only
        // holder has nothing to see until it retires into the feed above.
        (0, $8f20510e9e5c6549$export$2e2bcd8739ae039).hide();
        $1d9fcaa0a6035698$var$_showMyShift();
        return;
    }
    if (!$1d9fcaa0a6035698$var$_gsHasSale) {
        if ($1d9fcaa0a6035698$var$_todayTransactionCount > 0) $1d9fcaa0a6035698$var$_gsHasSale = true;
        else {
            $1d9fcaa0a6035698$var$_gsSalePromise ??= $1e7ab04ca7920cff$export$7274521d86e2ed95().catch(()=>false);
            $1d9fcaa0a6035698$var$_gsHasSale = await $1d9fcaa0a6035698$var$_gsSalePromise;
        }
    }
    $1d9fcaa0a6035698$var$_hideMyShift();
    const steps = $1d9fcaa0a6035698$var$_gettingStartedSteps();
    if (!steps.every((st)=>st.done)) {
        $1d9fcaa0a6035698$var$_gsShownIncomplete = true;
        (0, $8f20510e9e5c6549$export$2e2bcd8739ae039).render(steps);
        return;
    }
    if ($1d9fcaa0a6035698$var$_gsFinishing) return;
    $1d9fcaa0a6035698$var$_gsFinishing = true;
    $1e7ab04ca7920cff$export$680c723e3a62d1c3('gettingStartedCompleted', true);
    if ($1d9fcaa0a6035698$var$_gsShownIncomplete) {
        // The user watched the last step finish - celebrate briefly, then the
        // activity feed takes over the card.
        (0, $8f20510e9e5c6549$export$2e2bcd8739ae039).renderCelebrate(steps.length);
        setTimeout(()=>{
            $1d9fcaa0a6035698$var$_renderActivityFeed();
            $1d9fcaa0a6035698$var$_requestActivityRefresh();
        }, 6000);
    } else {
        // Everything was already done before first paint - straight to the feed.
        $1d9fcaa0a6035698$var$_renderActivityFeed();
        $1d9fcaa0a6035698$var$_requestActivityRefresh();
    }
};
const $1d9fcaa0a6035698$var$_wireGettingStarted = function() {
    (0, $8f20510e9e5c6549$export$2e2bcd8739ae039)._addHandlerDismiss(()=>{
        $1e7ab04ca7920cff$export$680c723e3a62d1c3('gettingStartedDismissed', true);
        // The x retires the CHECKLIST; the activity feed still gets the spot
        // (rendered by the banner updater below via _updateGettingStarted).
        $1d9fcaa0a6035698$var$_updateMenuSetupBanner(); // the standalone catalogue banner may take back over
    });
    (0, $8f20510e9e5c6549$export$2e2bcd8739ae039)._addHandlerViewAll(()=>(0, $8f20510e9e5c6549$export$2e2bcd8739ae039).showActivityModal($1d9fcaa0a6035698$var$_activityDisplayEntries()));
    (0, $8f20510e9e5c6549$export$2e2bcd8739ae039)._addHandlerActivityClick($1d9fcaa0a6035698$var$controlActivityClick);
    (0, $8f20510e9e5c6549$export$2e2bcd8739ae039)._addHandlerStep((step)=>{
        if (step === 'items') $1d9fcaa0a6035698$var$controlMenuList();
        else if (step === 'taxes') $1d9fcaa0a6035698$var$controlOpenDiscounts();
        else if (step === 'inventory') $1d9fcaa0a6035698$var$controlOpenInventory();
        else if (step === 'receipt') {
            (0, $6e66866c6dedb838$export$2e2bcd8739ae039).open();
            $1d9fcaa0a6035698$var$controlOpenSettings();
            (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._switchTab('pos');
        } else if (step === 'team') $1d9fcaa0a6035698$var$controlOpenStaff();
        else if (step === 'sale') $1d9fcaa0a6035698$var$controlNewOrder();
    });
    // "Set up your receipt" checks off when a manage_business holder actually
    // views Settings > POS (where the receipt toggles live) - write-once.
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._onTabView = (tab)=>{
        if (tab !== 'pos' || $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.receiptSetupSeen || !$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business')) return;
        $1e7ab04ca7920cff$export$680c723e3a62d1c3('receiptSetupSeen', true);
        $1d9fcaa0a6035698$var$_updateGettingStarted();
    };
};
// Bulk CSV menu import. Opens the import modal; the view handles parsing the
// file + assembling/previewing items, and calls back here on Confirm. We pass
// the current catalogue (names + categories, lowercased) so the preview can flag
// duplicates and brand-new categories. The actual write is one batched insert.
const $1d9fcaa0a6035698$var$controlUploadMenuCsv = function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_menu')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to the catalogue.", 'error');
        return;
    }
    const ctx = {
        existingNames: new Set($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.map((i)=>i.itemName.toLowerCase())),
        existingCategories: new Set($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories.map((c)=>c.toLowerCase()))
    };
    (0, $fed4c07c736ba70c$export$2e2bcd8739ae039).open(ctx, async (items, newCategories)=>{
        const { added: added } = await $1e7ab04ca7920cff$export$2895598b9aab0df3(items, newCategories);
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039).refresh($1e7ab04ca7920cff$export$ca000e230c0caa3e);
        (0, $0540865b060d0b60$export$2e2bcd8739ae039)._mapMenuCategoriesMarkUp($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories);
        $1d9fcaa0a6035698$var$_updateMenuSetupBanner();
        $1d9fcaa0a6035698$var$showToast(`Imported ${added} item${added === 1 ? '' : 's'}.`, 'success');
        if (added > 0) (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal('item-added');
    });
};
const $1d9fcaa0a6035698$var$controlBulkSetStatus = async function(status, ids) {
    if (!ids.length) {
        $1d9fcaa0a6035698$var$showToast('Select at least one item first.', 'info');
        return;
    }
    try {
        await $1e7ab04ca7920cff$export$85569b4184b1a334(ids, status);
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._exitSelectMode();
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039).refresh($1e7ab04ca7920cff$export$ca000e230c0caa3e);
        $1d9fcaa0a6035698$var$showToast(`${ids.length} item${ids.length > 1 ? 's' : ''} set to ${status}.`, 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlBulkDelete = async function(ids) {
    if (!ids.length) {
        $1d9fcaa0a6035698$var$showToast('Select at least one item first.', 'info');
        return;
    }
    const n = ids.length;
    if (!confirm(`Delete ${n} item${n > 1 ? 's' : ''}? They will be removed from your catalogue but kept in past sales and reports (shown as "deleted").`)) return;
    try {
        await $1e7ab04ca7920cff$export$690ddbe1f36836(ids);
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._exitSelectMode();
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039).refresh($1e7ab04ca7920cff$export$ca000e230c0caa3e);
        $1d9fcaa0a6035698$var$_updateMenuSetupBanner();
        $1d9fcaa0a6035698$var$showToast(`${n} item${n > 1 ? 's' : ''} deleted.`, 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlDeleteMenuItem = async function(id) {
    try {
        await $1e7ab04ca7920cff$export$7c4266df864b51c1(id);
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039).refresh($1e7ab04ca7920cff$export$ca000e230c0caa3e);
        $1d9fcaa0a6035698$var$_updateMenuSetupBanner();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlShowEditMenu = async function(id) {
    try {
        $1d9fcaa0a6035698$var$item = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.find((item)=>item._id === id);
        const categories = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories;
        // NOTE: don't call MenuEditView._clear() here - its _parentElement is
        // .modal-parent (the catalogue), so clearing it would delete the catalogue
        // behind the edit modal and you'd land on the home page on close. The edit
        // form lives in .edit-form-parent, which _insertEditMenuMarkup clears itself.
        const invCtx = $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_inventory') ? {
            canManage: true,
            items: $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems,
            links: $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks.filter((l)=>l.menuItemId === id),
            autoItem: $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.find((i)=>i.linkedMenuItemId === id) ?? null,
            itemVariants: $1d9fcaa0a6035698$var$item.variants ?? []
        } : null;
        // Tax status is shown whenever the business charges tax (included in
        // prices, or added at checkout) - inert/confusing with "No tax".
        const taxCtx = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxMode !== 'none' ? {
            enabled: true,
            exemptLabel: (0, $ff150a18d4a6f5bb$export$d9b10f19e66f377b)()
        } : {
            enabled: false
        };
        (0, $24a84838d36102df$export$2e2bcd8739ae039)._insertEditMenuMarkup($1d9fcaa0a6035698$var$item, invCtx, taxCtx);
        (0, $24a84838d36102df$export$2e2bcd8739ae039)._mapMenuCategoriesMarkUp(categories, $1d9fcaa0a6035698$var$item.category);
        (0, $24a84838d36102df$export$2e2bcd8739ae039)._newEditCategoryToggle(async (name)=>{
            try {
                await $1e7ab04ca7920cff$export$33005c1ca00aaa85(name);
                (0, $0540865b060d0b60$export$2e2bcd8739ae039)._mapMenuCategoriesMarkUp($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories);
                (0, $24a84838d36102df$export$2e2bcd8739ae039)._mapMenuCategoriesMarkUp($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories, name);
            } catch (err) {
                $1d9fcaa0a6035698$var$showToast(err.message ?? err);
            }
        });
        (0, $24a84838d36102df$export$2e2bcd8739ae039)._updateItemData(async (data)=>{
            if (data.category === "new-category") data.category = $1d9fcaa0a6035698$var$item.category;
            // Read the inventory section synchronously - the submit handler removes
            // the modal from the DOM right after this callback is invoked.
            const invCfg = (0, $24a84838d36102df$export$2e2bcd8739ae039).getInventoryConfig();
            try {
                await $1e7ab04ca7920cff$export$1b26cd8f03c7cf23($1d9fcaa0a6035698$var$item._id, data);
                (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039).refresh($1e7ab04ca7920cff$export$ca000e230c0caa3e); // refresh the catalogue behind the edit modal
                $1d9fcaa0a6035698$var$showToast("Menu item updated.", "success");
            } catch (err) {
                $1d9fcaa0a6035698$var$showToast(err.message ?? err);
                return;
            }
            // Inventory config saves after the item itself; a failure here must not
            // roll back the item save - it just toasts.
            if (invCfg) try {
                await $1e7ab04ca7920cff$export$af015f07d23b3a4b($1d9fcaa0a6035698$var$item._id, invCfg);
                (0, $472fec5536166250$export$2e2bcd8739ae039).updateStockBadges?.($1e7ab04ca7920cff$export$916349a6610ebe78());
                (0, $boau7.default).postMessage({
                    type: (0, $boau7.MSG).INVENTORY_SYNC
                });
            } catch (err) {
                $1d9fcaa0a6035698$var$showToast(`Item saved, but stock tracking failed: ${err.message ?? err}`);
            }
            const modal = document.querySelector(".item-modal-overlay");
            if (!modal.classList.contains("hidden") && (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._basket?.id === $1d9fcaa0a6035698$var$item._id) {
                const imgEl = modal.querySelector(".item-image");
                const updatedItem = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.find((i)=>i._id === $1d9fcaa0a6035698$var$item._id);
                if (imgEl) {
                    imgEl.style.transition = "opacity 0.3s ease";
                    imgEl.style.opacity = 0;
                    setTimeout(()=>{
                        imgEl.src = (0, $69bdae3851aa6802$export$56b52f8eeffda3e5)(updatedItem);
                        imgEl.style.opacity = 1;
                    }, 100);
                }
            }
        });
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
//adding new menu category
const $1d9fcaa0a6035698$var$controlAddNewCategory = async function(data) {
    try {
        await $1e7ab04ca7920cff$export$33005c1ca00aaa85(data);
        (0, $0540865b060d0b60$export$2e2bcd8739ae039)._mapMenuCategoriesMarkUp($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories);
        const newCategory = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories[$1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories.length - 1];
        const categorySelect = document.getElementById('categorySelect');
        if (categorySelect) categorySelect.value = newCategory;
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
//listening for buttons to close/open new menu item
const $1d9fcaa0a6035698$var$controlNewMenuButtonToggle = function() {
    (0, $0540865b060d0b60$export$2e2bcd8739ae039)._toggleModalClose();
    (0, $0540865b060d0b60$export$2e2bcd8739ae039)._toggleModalOpen();
};
//listens to uploadItem form button
const $1d9fcaa0a6035698$var$controlUploadItem = async function(data) {
    const invalidCategories = [
        "Select category",
        "new-category"
    ];
    const categoryMissing = !data.category || invalidCategories.includes(data.category);
    if (categoryMissing) {
        if (data.newCategory?.trim()) data.category = data.newCategory.trim();
        else data.category = "uncategorized";
    }
    try {
        data.variants = (0, $0540865b060d0b60$export$2e2bcd8739ae039)._addedVariants;
        await $1e7ab04ca7920cff$export$42fa452647465c30(data);
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039).refresh($1e7ab04ca7920cff$export$ca000e230c0caa3e);
        $1d9fcaa0a6035698$var$_updateMenuSetupBanner();
        (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal('item-added');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
//listens to new order button and renders the markup
const $1d9fcaa0a6035698$var$controlNewOrder = async function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('take_orders')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to take orders.", 'error');
        return;
    }
    try {
        (0, $472fec5536166250$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$modelState);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
//finds tbe item ID & fills in data according to the ID found
const $1d9fcaa0a6035698$var$controlDisplayMenuItem = function(id) {
    const item = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.find((item)=>item._id === id);
    if (!item) return;
    (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._itemModalContentUpdate(item);
};
const $1d9fcaa0a6035698$var$controlPushToModelCart = function() {
    if ((0, $a8fc36c39779922a$export$2e2bcd8739ae039)._basket.length <= 0) throw "No item selected yet";
    (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._basket.quantity = (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._qty;
    (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._basket.selectedVariants = (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._variants;
    const basePrice = Number((0, $a8fc36c39779922a$export$2e2bcd8739ae039)._basket.price);
    const variantsTotal = (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._basket.selectedVariants.reduce((acc, variant)=>acc + Number(variant.variantPrice), 0);
    const quantity = Number((0, $a8fc36c39779922a$export$2e2bcd8739ae039)._basket.quantity);
    (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._basket.totalPrice = (basePrice + variantsTotal) * quantity;
    // Stable per-line identity - cart items otherwise carry only the menu item's
    // id, which two lines of the same product (or same product/different
    // variants) would share. Loyalty reward redemptions key off this.
    (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._basket.lineId = $1d9fcaa0a6035698$var$_randomUUID();
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.push((0, $a8fc36c39779922a$export$2e2bcd8739ae039)._basket);
    $1d9fcaa0a6035698$var$_broadcastCart();
    // Surgical cart patch (list + total + header pill, new row slides in) - the
    // rest of the POS screen stays put, so no full-screen re-render "blink" and
    // the active category tab survives.
    if (!(0, $472fec5536166250$export$2e2bcd8739ae039).updateCart({
        added: true
    })) (0, $472fec5536166250$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$modelState);
    // Out-of-stock is a heads-up modal, never a block (counts drift; the sale
    // is real). The item is already in the cart; Continue just dismisses.
    const stockSt = $1e7ab04ca7920cff$export$d8155182f70d6438((0, $a8fc36c39779922a$export$2e2bcd8739ae039)._basket.id);
    if (stockSt.state === 'out') (0, $472fec5536166250$export$2e2bcd8739ae039).showStockNotice(stockSt.out);
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal('cart-add');
};
//Listents to "checkout event" and wraps up transaction
const $1d9fcaa0a6035698$var$controlOrderCheckout = function() {
    // Adding to a table tab: "Send to kitchen" instead of checkout.
    if ($1d9fcaa0a6035698$var$_tabOrder) {
        $1d9fcaa0a6035698$var$controlSendTabOrder(true);
        return;
    }
    try {
        if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.length === 0) throw `You must add an item to the cart`;
        const subtotal = $1d9fcaa0a6035698$var$modelState.cart.reduce((acc, item)=>acc + item.totalPrice, 0);
        $1e7ab04ca7920cff$export$aadd592960d1dd11();
        const adjResult = $1e7ab04ca7920cff$export$1e7528f2cdbb9715(subtotal, $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments, $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart);
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._subtotal = subtotal;
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._adjResult = adjResult;
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._totalPrice = adjResult.finalTotal;
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._orderType = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.orderTypeEnabled || $1d9fcaa0a6035698$var$_tabPay ? 'dine-in' : null;
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._paymentMethod = 'cash';
        // Tables: the picker (table service on) or the tab being paid.
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._tabPay = $1d9fcaa0a6035698$var$_tabPay ? {
            tableName: $1d9fcaa0a6035698$var$_tabPay.tableName,
            split: !!$1d9fcaa0a6035698$var$_tabPay.lineIds
        } : null;
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._tables = $1e7ab04ca7920cff$export$ca000e230c0caa3e.diningTables.map((t)=>({
                id: t.id,
                name: t.name,
                busy: $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs.some((x)=>x.tableId === t.id)
            }));
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._table = null;
        // Every checkout starts with no tip (and no tip prompt left on the display).
        $1d9fcaa0a6035698$var$_closeCFDTip();
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._tipAsking = false;
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._tip = {
            mode: 'none'
        };
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._tipCustomOpen = false;
        // Extras card opens on Discount, showing this checkout's promo / linked
        // customer (e.g. kept from before the cashier went Back to the order).
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._extrasTab = 'promo';
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._promoCode = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentPromoCode ?? null;
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._loyalty = {
            customer: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyCustomer,
            redemption: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyRedemption,
            rewardRedemptions: $1d9fcaa0a6035698$var$_loyaltyRewardRedemptions()
        };
        // Checkout loyalty is its own toggleable capability (use_loyalty) - the
        // section renders only for holders (RLS enforces the same server-side).
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._canUseLoyalty = $1e7ab04ca7920cff$export$b325ec6732b039cf('use_loyalty');
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$modelState);
        // Forward step: checkout slides in from the right
        document.querySelector('.modal-parent .pos-screen')?.classList.add('pos-screen--slide-fwd');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
// Cart -> RPC item-line shape. Only cosmetic fields (line id, date) and the
// selection intent (item id, quantity, variant names) travel to the server -
// all pricing is recomputed there from the real menu_items/variants rows, so
// a tampered client-side price/totalPrice is never trusted.
const $1d9fcaa0a6035698$var$_toRpcItems = (cart)=>cart.map((it)=>({
            item_id: it.id,
            quantity: it.quantity,
            selected_variants: (it.selectedVariants ?? []).map((v)=>({
                    variant_name: v.variantName
                })),
            line_id: it.lineId,
            date: it.date
        }));
// Splits the checkout's live adjustment list by source for record_sale():
// auto (business template refs - value override trusted, name/type/calc
// re-fetched server-side by id) and manual (fully trusted ad hoc entries -
// managerial discretion, out of scope for $ verification) travel as adjustment
// refs; loyalty_reward entries travel as cart-line references so the RPC can
// look up the server-recomputed line total to comp. Promo code and the $-off
// loyalty redemption are NOT sent as adjustment refs - the RPC recomputes
// both fresh from state (discount_codes / loyalty settings + balance) so
// their value can never be client-supplied.
const $1d9fcaa0a6035698$var$_splitAdjustmentsForRpc = function(adjustments) {
    const active = (adjustments ?? []).filter((a)=>!a.removed);
    return {
        adjustmentTemplates: active.filter((a)=>a.source === 'auto').map((a)=>({
                id: a.id,
                applied_value: a.appliedValue
            })),
        manualAdjustments: active.filter((a)=>a.source === 'manual').map((a)=>({
                name: a.name,
                type: a.type,
                calculation: a.calculation,
                value: a.value,
                applied_value: a.appliedValue,
                approved_by: a.approvedBy ?? null
            })),
        loyaltyRewards: active.filter((a)=>a.source === 'loyalty_reward').map((a)=>({
                reward_id: a.rewardId,
                cart_line_id: a.cartItemLineId
            }))
    };
};
const $1d9fcaa0a6035698$var$_buildSale = function() {
    const cashierName = $1d9fcaa0a6035698$var$_cashierDisplayName($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier) || $1e7ab04ca7920cff$export$ca000e230c0caa3e.username || '';
    const loggedInCashier = $1e7ab04ca7920cff$export$ca000e230c0caa3e.username || '';
    return {
        id: $1d9fcaa0a6035698$var$_randomUUID(),
        // Stamp each item's CURRENT tax class onto the sale record now, so a later
        // edit to the menu item's tax class never retroactively changes this receipt
        // (same reasoning as taxInclusiveRate below).
        items: $1d9fcaa0a6035698$var$modelState.cart.map((it)=>({
                ...it,
                taxClass: $1e7ab04ca7920cff$export$83f9fbc1f115c860(it.id)
            })),
        subtotal: (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._subtotal ?? (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._totalPrice,
        adjustments: (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._adjResult?.lineItems ?? [],
        removedAdjustments: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.filter((a)=>a.removed),
        showRemovedAdjustments: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showRemovedAdjustments,
        totalPrice: (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._totalPrice,
        // Never part of totalPrice (sales.tip_amount, never taxed). customerPayment
        // covers sale + tip.
        tipAmount: (0, $6724f76d0010cf48$export$2e2bcd8739ae039).tipAmount(),
        customerPayment: (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._customerPayment,
        customerChange: (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._customerChange,
        promoCode: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentPromoCode ?? null,
        storeName: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessName ?? $1e7ab04ca7920cff$export$ca000e230c0caa3e.username,
        businessPhone: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessPhone ?? null,
        addressStreet: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressStreet ?? null,
        addressCity: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCity ?? null,
        addressProvince: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressProvince ?? null,
        addressZip: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressZip ?? null,
        addressCountry: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCountry ?? null,
        cashierName: cashierName,
        loggedInCashier: loggedInCashier,
        showCashier: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showCashierName !== false,
        showInvoiceNumber: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showInvoiceNumber !== false,
        showTicketNumber: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showTicketNumber !== false,
        showBusinessPhone: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showBusinessPhone !== false,
        receiptFooter: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.receiptFooter || '',
        receiptQrUrl: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.receiptQrUrl || '',
        taxInclusiveRate: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxInclusive ? $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxInclusiveRate : null,
        orderType: (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._orderType ?? 'dine-in',
        paymentMethod: (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._paymentMethod ?? 'cash',
        tableId: $1d9fcaa0a6035698$var$_tabPay ? $1d9fcaa0a6035698$var$_tabPay.tableId : (0, $6724f76d0010cf48$export$2e2bcd8739ae039).pickedTable()?.id ?? null,
        tableName: $1d9fcaa0a6035698$var$_tabPay ? $1d9fcaa0a6035698$var$_tabPay.tableName : (0, $6724f76d0010cf48$export$2e2bcd8739ae039).pickedTable()?.name ?? null,
        customerId: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyCustomer?.id ?? null,
        loyaltyRedeemedPoints: $1e7ab04ca7920cff$export$a49edc57bdd065a5(),
        date: Date.now(),
        isFreePlan: !$1e7ab04ca7920cff$export$9e608bbc985290d4()
    };
};
// ── Order Queue (KDS) ─────────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$_generateTicketNumber = function() {
    const active = new Set($1d9fcaa0a6035698$var$modelState.orderQueue.map((o)=>o.ticketNumber).filter(Boolean));
    let n;
    do n = Math.floor(Math.random() * 999) + 1;
    while (active.has(n));
    return n;
};
let $1d9fcaa0a6035698$var$_kdsInterval = null;
const $1d9fcaa0a6035698$var$_ensureKDSTick = function() {
    if ($1d9fcaa0a6035698$var$_kdsInterval) return;
    $1d9fcaa0a6035698$var$_kdsInterval = setInterval($1d9fcaa0a6035698$var$_tickKDS, 1000);
};
const $1d9fcaa0a6035698$var$_stopKDSTick = function() {
    clearInterval($1d9fcaa0a6035698$var$_kdsInterval);
    $1d9fcaa0a6035698$var$_kdsInterval = null;
};
const $1d9fcaa0a6035698$var$_tickKDS = function() {
    if ($1d9fcaa0a6035698$var$modelState.orderQueue.length === 0) {
        $1d9fcaa0a6035698$var$_stopKDSTick();
        return;
    }
    const now = Date.now();
    const { kdsYellowThreshold: kdsYellowThreshold, kdsRedThreshold: kdsRedThreshold, kdsAutoCompleteThreshold: kdsAutoCompleteThreshold } = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings;
    const autoThreshold = kdsAutoCompleteThreshold > 0 ? kdsAutoCompleteThreshold : Infinity;
    const expired = $1d9fcaa0a6035698$var$modelState.orderQueue.filter((o)=>Math.floor((now - o.startedAt) / 1000) >= autoThreshold);
    expired.forEach((o)=>$1d9fcaa0a6035698$var$controlMarkOrderDone(o.id, true));
    if (expired.length === 0) (0, $f3651885b15417e3$export$2e2bcd8739ae039).updateTimers($1d9fcaa0a6035698$var$modelState.orderQueue, now, kdsYellowThreshold, kdsRedThreshold);
};
// ── Undo "done" window ────────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$UNDO_WINDOW_MS = 10000;
const $1d9fcaa0a6035698$var$_pendingDone = new Map(); // id → { timer, order, idx, timedOut, dismissToast }
// The queue as other screens/devices should see it. Practice orders (the
// first-sale tutorial's pretend sale) exist only in this window - never
// broadcast to the KDS/pickup popups or other terminals, never written to the DB.
const $1d9fcaa0a6035698$var$_queueForBroadcast = ()=>$1d9fcaa0a6035698$var$modelState.orderQueue.filter((o)=>!o.practice);
const $1d9fcaa0a6035698$var$_undoMarkDone = function(id) {
    const pending = $1d9fcaa0a6035698$var$_pendingDone.get(id);
    if (!pending) return;
    clearTimeout(pending.timer);
    pending.dismissToast();
    $1d9fcaa0a6035698$var$_pendingDone.delete(id);
    const insertIdx = Math.min(pending.idx, $1d9fcaa0a6035698$var$modelState.orderQueue.length);
    $1d9fcaa0a6035698$var$modelState.orderQueue.splice(insertIdx, 0, pending.order);
    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
    $1d9fcaa0a6035698$var$_ensureKDSTick();
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).KDS_QUEUE_SYNC,
        queue: $1d9fcaa0a6035698$var$_queueForBroadcast(),
        thresholds: {
            yellow: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsYellowThreshold,
            red: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsRedThreshold
        }
    });
};
const $1d9fcaa0a6035698$var$controlMarkOrderDone = function(id, timedOut = false) {
    const idx = $1d9fcaa0a6035698$var$modelState.orderQueue.findIndex((o)=>o.id === id);
    if (idx === -1 || $1d9fcaa0a6035698$var$_pendingDone.has(id)) return;
    const order = $1d9fcaa0a6035698$var$modelState.orderQueue[idx];
    $1d9fcaa0a6035698$var$modelState.orderQueue.splice(idx, 1);
    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
    if ($1d9fcaa0a6035698$var$modelState.orderQueue.length === 0) $1d9fcaa0a6035698$var$_stopKDSTick();
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).KDS_QUEUE_SYNC,
        queue: $1d9fcaa0a6035698$var$_queueForBroadcast(),
        thresholds: {
            yellow: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsYellowThreshold,
            red: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsRedThreshold
        }
    });
    const dismissToast = (0, $f3651885b15417e3$export$2e2bcd8739ae039).showUndoToast(order, ()=>$1d9fcaa0a6035698$var$_undoMarkDone(id), $1d9fcaa0a6035698$var$UNDO_WINDOW_MS);
    const timer = setTimeout(async ()=>{
        $1d9fcaa0a6035698$var$_pendingDone.delete(id);
        dismissToast();
        if (order.practice) return;
        try {
            await $1e7ab04ca7920cff$export$e0bf0609ec0e8d2f(id, timedOut);
            $1d9fcaa0a6035698$var$_loadServingComparison();
        } catch (_) {}
    }, $1d9fcaa0a6035698$var$UNDO_WINDOW_MS);
    $1d9fcaa0a6035698$var$_pendingDone.set(id, {
        timer: timer,
        order: order,
        idx: idx,
        timedOut: timedOut,
        dismissToast: dismissToast
    });
    if (!timedOut) (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal('order-done');
};
// Marks an order Ready for Pickup - it stays in the queue (only Mark Done
// removes it), so this is a simple immediate flip, no undo window needed.
const $1d9fcaa0a6035698$var$controlMarkOrderReady = function(id) {
    const order = $1d9fcaa0a6035698$var$modelState.orderQueue.find((o)=>o.id === id);
    if (!order || order.readyAt) return;
    order.readyAt = Date.now();
    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal('order-ready');
    if (order.practice) return;
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).KDS_ORDER_READY,
        id: id,
        readyAt: order.readyAt
    });
    $1e7ab04ca7920cff$export$9f42bbb612dd81aa(id).catch(()=>{});
};
// Cashier-side revert for a mistaken Ready: sends the order back to Preparing
// on every screen (readyAt: null rides the same KDS_ORDER_READY message).
const $1d9fcaa0a6035698$var$controlUnmarkOrderReady = function(id) {
    const order = $1d9fcaa0a6035698$var$modelState.orderQueue.find((o)=>o.id === id);
    if (!order || !order.readyAt) return;
    order.readyAt = null;
    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
    if (order.practice) return;
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).KDS_ORDER_READY,
        id: id,
        readyAt: null
    });
    $1e7ab04ca7920cff$export$b53689804608fa5b(id).catch(()=>{});
};
const $1d9fcaa0a6035698$var$controlOpenKDSWindow = function() {
    const { width: width, height: height } = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsWindowSize;
    const win = window.open('kds-display.html', 'pointbunny-kds', `width=${width},height=${height},menubar=no,toolbar=no,location=no`);
    if (!win) $1d9fcaa0a6035698$var$showToast('Popup was blocked. Allow popups for this site to open the Queue Display.', 'error');
    else win.focus();
};
const $1d9fcaa0a6035698$var$controlOpenCFDWindow = function() {
    const { width: width, height: height } = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.cfdWindowSize;
    const win = window.open('customer-display.html', 'pointbunny-cfd', `width=${width},height=${height},menubar=no,toolbar=no,location=no`);
    if (!win) $1d9fcaa0a6035698$var$showToast('Popup was blocked. Allow popups for this site to open the Customer Display.', 'error');
    else win.focus();
};
const $1d9fcaa0a6035698$var$controlOpenPickupWindow = function() {
    // Customer-facing pickup board - meant for a big screen, so no per-size
    // setting yet; it lays out fluidly at any window size.
    const win = window.open('pickup-display.html', 'pointbunny-pickup', 'width=1100,height=700,menubar=no,toolbar=no,location=no');
    if (!win) $1d9fcaa0a6035698$var$showToast('Popup was blocked. Allow popups for this site to open the Pickup Screen.', 'error');
    else win.focus();
};
// This POS device's terminal number (per-device, persisted). Stamped on every CFD
// broadcast so a customer display set to the same number renders only this terminal.
const $1d9fcaa0a6035698$var$_terminalNumber = ()=>localStorage.getItem('pointbunny_terminal_number') || '1';
// Sizes the terminal grid to the team (one terminal per person: owner + staff).
// Clamps a stale saved value down if the team shrank. Shared shape with the CFD.
const $1d9fcaa0a6035698$var$_populateTerminalOptions = async function(gridEl, valueEl) {
    let count = 1;
    try {
        count = await $1e7ab04ca7920cff$export$f0ef15b003d69c13();
    } catch  {}
    let saved = Number($1d9fcaa0a6035698$var$_terminalNumber()) || 1;
    if (saved > count) {
        saved = count;
        localStorage.setItem('pointbunny_terminal_number', String(count));
    }
    gridEl.innerHTML = Array.from({
        length: count
    }, (_, i)=>{
        const n = i + 1;
        return `<button class="nav-terminal-chip${n === saved ? ' nav-terminal-chip--active' : ''}" type="button" data-value="${n}">${n}</button>`;
    }).join('');
    valueEl.textContent = String(saved);
};
const $1d9fcaa0a6035698$var$_broadcastCart = function() {
    const cart = $1d9fcaa0a6035698$var$modelState.cart;
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).CFD_CART_UPDATE,
        terminalNumber: $1d9fcaa0a6035698$var$_terminalNumber(),
        cart: cart,
        total: cart.reduce((s, i)=>s + i.totalPrice, 0)
    });
};
// Selecting QR at checkout flashes the merchant QR full-screen on the customer
// display so the customer can scan it; switching back to Cash/Card hides it and
// reveals the cart again. Stamped with the terminal so only the paired CFD reacts.
const $1d9fcaa0a6035698$var$controlSetPaymentMethod = function(method) {
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).CFD_SHOW_QR,
        terminalNumber: $1d9fcaa0a6035698$var$_terminalNumber(),
        show: method === 'qr',
        total: (0, $6724f76d0010cf48$export$2e2bcd8739ae039).chargeTotal()
    });
};
// Force-hide the customer display's QR overlay (used when leaving the checkout/payment
// step by any path other than completing a QR sale - Back, or abandon/discard - so the
// QR doesn't linger on the display).
const $1d9fcaa0a6035698$var$_hideCFDQr = function() {
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).CFD_SHOW_QR,
        terminalNumber: $1d9fcaa0a6035698$var$_terminalNumber(),
        show: false
    });
    $1d9fcaa0a6035698$var$_closeCFDTip(); // every "leaving checkout" path calls this - close a tip prompt too
};
// ── Tips (2026-10-10) ─────────────────────────────────────────────────────────
// The cashier picks the tip at checkout, or hands the choice to the customer:
// "Let the customer choose" puts an "Add a tip?" screen on the paired customer
// display (CFD_TIP_REQUEST) and the display answers with CFD_TIP_SELECTED,
// echoing the request id so a stale or stray answer is ignored. The register
// always re-derives the amount from its own total, and the cashier can still
// change it afterwards. The tip is recorded by record_sale (sales.tip_amount).
let $1d9fcaa0a6035698$var$_tipRequestId = null; // set while waiting for the customer to choose
const $1d9fcaa0a6035698$var$_sendTipRequest = function() {
    if (!$1d9fcaa0a6035698$var$_tipRequestId) return;
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).CFD_TIP_REQUEST,
        terminalNumber: $1d9fcaa0a6035698$var$_terminalNumber(),
        requestId: $1d9fcaa0a6035698$var$_tipRequestId,
        show: true,
        total: (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._totalPrice ?? 0,
        presets: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipPresets ?? []
    });
};
// Close the customer display's tip screen (no-op if it isn't up).
const $1d9fcaa0a6035698$var$_closeCFDTip = function() {
    if (!$1d9fcaa0a6035698$var$_tipRequestId) return;
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).CFD_TIP_REQUEST,
        terminalNumber: $1d9fcaa0a6035698$var$_terminalNumber(),
        requestId: $1d9fcaa0a6035698$var$_tipRequestId,
        show: false
    });
    $1d9fcaa0a6035698$var$_tipRequestId = null;
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._tipAsking = false;
};
// The paid amount follows the tip, so the scan-to-pay QR does too.
const $1d9fcaa0a6035698$var$_afterTipChange = function() {
    if ((0, $6724f76d0010cf48$export$2e2bcd8739ae039)._paymentMethod === 'qr') $1d9fcaa0a6035698$var$controlSetPaymentMethod('qr');
};
const $1d9fcaa0a6035698$var$controlSelectTip = function(tip) {
    if ($1d9fcaa0a6035698$var$_tipRequestId) $1d9fcaa0a6035698$var$_closeCFDTip();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._tipAsking = false;
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).setTip(tip);
    $1d9fcaa0a6035698$var$_afterTipChange();
};
const $1d9fcaa0a6035698$var$controlAskCustomerTip = function() {
    $1d9fcaa0a6035698$var$_tipRequestId = $1d9fcaa0a6035698$var$_randomUUID();
    $1d9fcaa0a6035698$var$_sendTipRequest();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).setTipAsking(true);
};
const $1d9fcaa0a6035698$var$controlCancelTipAsk = function() {
    $1d9fcaa0a6035698$var$_closeCFDTip();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).setTipAsking(false);
};
// Answer from the customer display. Only the choice is trusted, never an
// amount for a preset: a percentage must be one of this business's presets.
const $1d9fcaa0a6035698$var$_onCustomerTipSelected = function(data) {
    if (!$1d9fcaa0a6035698$var$_tipRequestId || data.requestId !== $1d9fcaa0a6035698$var$_tipRequestId) return;
    const presets = ($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipPresets ?? []).map(Number);
    let tip = null;
    if (data.mode === 'percent' && presets.includes(Number(data.percent))) tip = {
        mode: 'percent',
        percent: Number(data.percent)
    };
    else if (data.mode === 'custom' && Number.isFinite(Number(data.amount)) && Number(data.amount) >= 0) {
        const amount = (0, $abGsl.roundCents)(data.amount);
        tip = amount > 0 ? {
            mode: 'custom',
            amount: amount
        } : {
            mode: 'none'
        };
    } else if (data.mode === 'none' || data.mode === 'qr') tip = {
        mode: data.mode
    };
    if (!tip) return;
    $1d9fcaa0a6035698$var$_tipRequestId = null;
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._tipAsking = false;
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).setTip(tip);
    $1d9fcaa0a6035698$var$_afterTipChange();
    const amount = (0, $6724f76d0010cf48$export$2e2bcd8739ae039).tipAmount();
    $1d9fcaa0a6035698$var$showToast(tip.mode === 'qr' ? 'The customer tipped with your tip QR.' : amount > 0 ? `The customer added a ${(0, $coRoT.formatMoney)(amount)} tip.` : 'The customer chose no tip.', 'info');
};
const $1d9fcaa0a6035698$var$controlSaveKDSWindowSize = function(size) {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsWindowSize = size;
    localStorage.setItem('pointbunny_kds_window_size', JSON.stringify(size));
};
const $1d9fcaa0a6035698$var$controlSaveCFDWindowSize = function(size) {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.cfdWindowSize = size;
    localStorage.setItem('pointbunny_cfd_window_size', JSON.stringify(size));
};
// CFD ad / Pickup ad / payment QR: the file uploads right away (needed to
// preview it), but the resulting URL is only STAGED - same deferred-save flow
// as every other Displays/POS setting - so it's not live until Save Changes.
const $1d9fcaa0a6035698$var$controlUploadCFDAd = async function(file) {
    if (!$1e7ab04ca7920cff$export$9e608bbc985290d4()) {
        $1d9fcaa0a6035698$var$showToast("Custom ads are a Pro feature - upgrade to run your own ad on the customer display.", 'error');
        return;
    }
    try {
        const url = await $1e7ab04ca7920cff$export$6ee9e1291268daa7(file);
        $1d9fcaa0a6035698$var$_stageSetting('cfdAdUrl', url);
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showCFDAdPreview(url);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlRemoveCFDAd = function() {
    $1d9fcaa0a6035698$var$_stageSetting('cfdAdUrl', null);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showCFDAdPreview(null);
};
const $1d9fcaa0a6035698$var$controlUploadPickupAd = async function(file) {
    if (!$1e7ab04ca7920cff$export$9e608bbc985290d4()) {
        $1d9fcaa0a6035698$var$showToast("Custom ads are a Pro feature - upgrade to run your own ad on the Pickup Screen.", 'error');
        return;
    }
    try {
        const url = await $1e7ab04ca7920cff$export$22dc23743dad2d5b(file);
        $1d9fcaa0a6035698$var$_stageSetting('pickupAdUrl', url);
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showPickupAdPreview(url);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlRemovePickupAd = function() {
    $1d9fcaa0a6035698$var$_stageSetting('pickupAdUrl', null);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showPickupAdPreview(null);
};
const $1d9fcaa0a6035698$var$controlUploadCFDQR = async function(file) {
    try {
        const url = await $1e7ab04ca7920cff$export$a88c3ce76caa82f4(file);
        $1d9fcaa0a6035698$var$_stageSetting('cfdQrUrl', url);
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showCFDQRPreview(url);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlRemoveCFDQR = function() {
    $1d9fcaa0a6035698$var$_stageSetting('cfdQrUrl', null);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showCFDQRPreview(null);
};
// ── Deferred settings draft (POS toggles + KDS thresholds) ────────────────────
// These have no Edit gate - any change stages immediately (state + local UI
// update right away, so the app behaves live) but the actual Supabase write
// waits for the shared footer's Save Changes, same as Profile/Business.
let $1d9fcaa0a6035698$var$_settingsDraftOriginal = null; // snapshot taken on the first unsaved change
const $1d9fcaa0a6035698$var$_stageSetting = function(key, value) {
    if (!$1d9fcaa0a6035698$var$_settingsDraftOriginal) $1d9fcaa0a6035698$var$_settingsDraftOriginal = $1e7ab04ca7920cff$export$669c05a58e9cc73a();
    $1e7ab04ca7920cff$export$233f02b89678da4f(key, value);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showSettingsDirty();
};
const $1d9fcaa0a6035698$var$controlSaveSettingsDraft = async function() {
    // Paper, print method + position have no server component - they're the staged
    // "settings" that don't live in model.snapshotBusinessSettings()/persistBusinessSettings().
    if ($1d9fcaa0a6035698$var$_pendingPaperWidth != null) {
        $e289654e8a722fd2$export$f68c9870378c39e3($1d9fcaa0a6035698$var$_pendingPaperWidth);
        $1d9fcaa0a6035698$var$_pendingPaperWidth = null;
    }
    if ($1d9fcaa0a6035698$var$_pendingPrintMethod != null) {
        $e289654e8a722fd2$export$8c6ecab5174b959($1d9fcaa0a6035698$var$_pendingPrintMethod);
        $1d9fcaa0a6035698$var$_pendingPrintMethod = null;
    }
    if ($1d9fcaa0a6035698$var$_pendingPosition != null) {
        $e289654e8a722fd2$export$f9b088a47202d605($1d9fcaa0a6035698$var$_pendingPosition);
        $1d9fcaa0a6035698$var$_pendingPosition = null;
    }
    // The owner's type of place also updates business_type / business_industry
    // (the admin panel reads them). Staff saves only touch settings (RLS).
    const placeType = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.placeType;
    if (placeType && placeType !== $1d9fcaa0a6035698$var$_settingsDraftOriginal?.placeType && $1e7ab04ca7920cff$export$ca000e230c0caa3e.userId === $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId) {
        const kept = $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessType && $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessType !== 'food_beverage' ? $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessType : 'other';
        $1e7ab04ca7920cff$export$ac06a0bc59be6d27({
            businessType: placeType === 'other' ? kept : 'food_beverage',
            industry: placeType
        }).catch((err)=>console.error('[pointbunny] failed to save type of place:', err.message));
    }
    await $1e7ab04ca7920cff$export$15e1db8a90fc192d();
    $1d9fcaa0a6035698$var$_settingsDraftOriginal = null;
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).hideSettingsDirty();
    $1d9fcaa0a6035698$var$showToast('Settings saved', 'success');
};
const $1d9fcaa0a6035698$var$controlDiscardSettingsDraft = function() {
    if ($1d9fcaa0a6035698$var$_settingsDraftOriginal) {
        $1e7ab04ca7920cff$export$cc098d721f95fe39($1d9fcaa0a6035698$var$_settingsDraftOriginal);
        $1d9fcaa0a6035698$var$_applyHomeStatsVisibility();
        $1d9fcaa0a6035698$var$_applyHomeLayout();
    }
    $1d9fcaa0a6035698$var$_settingsDraftOriginal = null;
    $1d9fcaa0a6035698$var$_pendingPaperWidth = null;
    $1d9fcaa0a6035698$var$_pendingPrintMethod = null;
    $1d9fcaa0a6035698$var$_pendingPosition = null;
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).hideSettingsDirty();
    $1d9fcaa0a6035698$var$_syncAllSettingsToggles();
    $1d9fcaa0a6035698$var$_syncPrinterUI();
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncDisplaySizes($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsWindowSize, $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.cfdWindowSize);
};
const $1d9fcaa0a6035698$var$controlSaveKDSThresholds = function({ yellow: yellow, red: red, auto: auto }) {
    $1d9fcaa0a6035698$var$_stageSetting('kdsYellowThreshold', yellow);
    $1d9fcaa0a6035698$var$_stageSetting('kdsRedThreshold', red);
    $1d9fcaa0a6035698$var$_stageSetting('kdsAutoCompleteThreshold', auto);
};
// ── Sale finalisation ─────────────────────────────────────────────────────────
// Records the sale via the server-side validating RPC (record_sale) and runs
// every post-sale side effect (queue, broadcasts, cart clear, counters). Item
// prices, promo code redemption, and loyalty point affordability are all
// recomputed/enforced INSIDE the RPC from real DB rows - see model.recordSale.
// The DB trigger still assigns the gapless per-business invoice number on
// insert; we read it back onto `sale.receiptNumber` so the receipt can be
// printed WITH the number afterwards. Does not print or show the success
// screen - the caller handles those once the number exists.
const $1d9fcaa0a6035698$var$_recordSale = async function(sale) {
    const { adjustmentTemplates: adjustmentTemplates, manualAdjustments: manualAdjustments, loyaltyRewards: loyaltyRewards } = $1d9fcaa0a6035698$var$_splitAdjustmentsForRpc($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments);
    let result;
    try {
        result = await $1e7ab04ca7920cff$export$cf49a3abf54dee13({
            items: $1d9fcaa0a6035698$var$_toRpcItems($1d9fcaa0a6035698$var$modelState.cart),
            adjustmentTemplates: adjustmentTemplates,
            manualAdjustments: manualAdjustments,
            promoCode: sale.promoCode?.code ?? null,
            loyaltyRedeemIncrements: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyRedemption?.increments ?? 0,
            loyaltyRewards: loyaltyRewards,
            customerId: sale.customerId,
            orderType: sale.orderType,
            paymentMethod: sale.paymentMethod,
            ticketNumber: sale.ticketNumber,
            customerPayment: sale.customerPayment,
            customerChange: sale.customerChange,
            cashierName: sale.cashierName,
            loggedInCashier: sale.loggedInCashier,
            date: sale.date,
            tipAmount: sale.tipAmount ?? 0,
            tableId: sale.tableId,
            tableName: sale.tableName,
            tabId: $1d9fcaa0a6035698$var$_tabPay?.tabId ?? null,
            tabLineIds: $1d9fcaa0a6035698$var$_tabPay?.lineIds ?? null
        });
    } catch (recordError) {
        if (recordError.code === '22003' || recordError.message?.includes('numeric field overflow')) throw new Error("That number doesn't look right. Check the payment amount and try again.");
        // Also covers RPC-raised messages ("Invalid promo code", "This promo code
        // has reached its usage limit", "Not enough loyalty points for this
        // redemption", "Item no longer available", "Invalid variant...", etc.).
        // Nothing was committed, so the cart and checkout adjustments are
        // untouched - the cashier can fix the issue and hit Confirm again.
        throw recordError;
    }
    // Reconcile the local `sale` object with server-authoritative numbers -
    // everything printed/queued/broadcast from here on uses what was actually
    // stored, never the pre-commit client guess.
    sale.id = result.id;
    sale.receiptNumber = result.receiptNumber;
    sale.subtotal = result.subtotal;
    sale.totalPrice = result.totalPrice;
    sale.items = result.items;
    sale.adjustments = result.adjustments;
    sale.taxInclusiveRate = result.taxInclusiveRate;
    sale.tipAmount = result.tipAmount;
    sale.tableName = result.tableName ?? sale.tableName ?? null;
    $1d9fcaa0a6035698$var$modelState.salesBasket.push(sale); // only sales that actually recorded
    // Keep the Promo panel's live usage count in sync without a refetch (the
    // RPC already redeemed it atomically server-side).
    if (sale.promoCode) {
        const dc = $1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes.find((d)=>d.id === sale.promoCode.discountCodeId);
        if (dc) dc.usageCount += 1;
    }
    // Inventory consumption: unchanged mechanism, still fire-and-forget (a
    // stock failure must NEVER fail or delay the sale, same principle as
    // printing) - now computed from the SERVER-CORRECTED items for fidelity.
    // Skipped entirely while inventory tracking is off (master toggle).
    const invLines = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.inventoryEnabled === false ? [] : $1e7ab04ca7920cff$export$3dc5f05489d7fdb1(sale.items);
    if (invLines.length) {
        $1e7ab04ca7920cff$export$1435266333031a63(invLines);
        (0, $472fec5536166250$export$2e2bcd8739ae039).updateStockBadges($1e7ab04ca7920cff$export$916349a6610ebe78());
        $1e7ab04ca7920cff$export$48ee852592997bc7(sale.id, invLines, sale.cashierName).then(()=>(0, $boau7.default).postMessage({
                type: (0, $boau7.MSG).INVENTORY_SYNC
            })).catch(()=>{}); // sale already committed; drift is corrected manually
    }
    // NOTE: promo code redemption and loyalty earn/redeem are now validated and
    // applied INSIDE record_sale (atomically, pre-commit) - the separate
    // model.redeemDiscountCode / model.recordLoyaltyForSale calls that used to
    // live here are gone; loyalty balance changes reflect via the usual
    // realtime/refetch paths, same as any other server-side ledger write.
    // A paid tab never joins the queue (its items were sent as tickets).
    const paidTab = $1d9fcaa0a6035698$var$_tabPay;
    if (paidTab) {
        $1d9fcaa0a6035698$var$_tabPay = null;
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._tabPay = null;
        $1e7ab04ca7920cff$export$1dd25893a10c6b3f().then(()=>{
            (0, $boau7.default).postMessage({
                type: (0, $boau7.MSG).TABLES_SYNC
            });
            // Paying the last items closes the tab: its kitchen tickets are done too.
            if (!$1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs.some((t)=>t.id === paidTab.tabId)) $1d9fcaa0a6035698$var$_clearTabTickets(paidTab.tabId);
        }).catch(()=>{});
    }
    if (!paidTab) $1d9fcaa0a6035698$var$modelState.orderQueue.push({
        id: sale.id,
        saleDate: new Date(sale.date).toISOString(),
        items: sale.items,
        startedAt: sale.date,
        totalPrice: sale.totalPrice,
        orderType: sale.orderType ?? 'dine-in',
        ticketNumber: sale.ticketNumber ?? null,
        tableName: sale.tableName ?? null,
        receiptNumber: sale.receiptNumber,
        readyAt: null
    });
    if (!paidTab) $1d9fcaa0a6035698$var$_ensureKDSTick();
    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
    if (!paidTab) (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).KDS_QUEUE_SYNC,
        queue: $1d9fcaa0a6035698$var$_queueForBroadcast(),
        thresholds: {
            yellow: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsYellowThreshold,
            red: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsRedThreshold
        }
    });
    $1d9fcaa0a6035698$var$clearCart();
    $1d9fcaa0a6035698$var$_closeCFDTip();
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).CFD_SALE_COMPLETE,
        terminalNumber: $1d9fcaa0a6035698$var$_terminalNumber()
    });
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).SALE_RECORDED,
        id: sale.id
    });
    $1e7ab04ca7920cff$export$34e40abced25fa5e();
    $1d9fcaa0a6035698$var$_clearCashflowCache(); // new sale invalidates all cached periods
    // NOTE: the Today's Sales refresh is intentionally NOT called here. It is
    // fired from _showSaleSuccess instead, immediately before the success overlay
    // is shown, so its async DB await resolves with the overlay present and the
    // count-up animation + "vs yesterday" badge land when the dashboard is
    // revealed. Calling it here (record-then-print runs this well before the
    // overlay exists) made the animation play invisibly behind the checkout modal.
    // Bump the in-memory count now; the animation is enqueued from _showSaleSuccess
    // (after the sales card) so the two cards reveal one at a time, Sales first.
    if ($1d9fcaa0a6035698$var$_todayTransactionCount !== null) $1d9fcaa0a6035698$var$_todayTransactionCount++;
};
// Tutorial-only stand-in for _recordSale: the order joins the local Active
// Queue (flagged practice, see _queueForBroadcast) so the tour can walk
// through Ready / Done, but nothing touches the DB, stats, inventory,
// loyalty or promo usage. Cleared when the tutorial ends (_tourApi.clearPractice).
const $1d9fcaa0a6035698$var$_recordPracticeSale = function(sale) {
    $1d9fcaa0a6035698$var$modelState.orderQueue.push({
        id: `practice-${Date.now()}`,
        practice: true,
        saleDate: new Date(sale.date).toISOString(),
        items: sale.items,
        startedAt: sale.date,
        totalPrice: sale.totalPrice,
        orderType: sale.orderType ?? 'dine-in',
        ticketNumber: sale.ticketNumber ?? null,
        receiptNumber: null,
        readyAt: null
    });
    $1d9fcaa0a6035698$var$_ensureKDSTick();
    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
    $1d9fcaa0a6035698$var$clearCart();
    $1d9fcaa0a6035698$var$_closeCFDTip();
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).CFD_SALE_COMPLETE,
        terminalNumber: $1d9fcaa0a6035698$var$_terminalNumber()
    });
    $1e7ab04ca7920cff$export$34e40abced25fa5e();
    $1d9fcaa0a6035698$var$_showSaleSuccess('Practice sale complete. Nothing was saved or printed, and this order disappears when the tutorial ends.', {
        practice: true
    });
};
// A practice checkout outlived its tutorial (paused / skipped with the confirm
// screen open). Throw the practice order away exactly like closing an order
// with items in it, and say so - the cashier can ring it up again for real.
const $1d9fcaa0a6035698$var$_cancelEndedPracticeSale = function() {
    $1d9fcaa0a6035698$var$clearCart();
    $1d9fcaa0a6035698$var$_broadcastCart();
    $1d9fcaa0a6035698$var$_hideCFDQr();
    $1e7ab04ca7920cff$export$34e40abced25fa5e();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).closeRedeemModal();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._hideModal();
    $1d9fcaa0a6035698$var$showToast('The tutorial ended, so this practice sale was cancelled. Nothing was saved or printed.', 'info');
};
// Shows the animated success screen and auto-closes the checkout modal. The
// success chime plays here (not at record time) so it lands with the modal -
// checkout is now record-then-print, so _recordSale fires the moment Print is
// clicked, well before this.
const $1d9fcaa0a6035698$var$_showSaleSuccess = function(note = null, { practice: practice = false } = {}) {
    (0, $f3651885b15417e3$export$2e2bcd8739ae039).playNewOrderSound();
    // Start the dashboard refresh BEFORE showing the overlay. refreshTodaySalesDisplay
    // is async and yields at its DB await, so the overlay below is created first;
    // when the await resolves it sees the overlay and defers the count-up animation
    // (and the % roll) until the overlay closes and the dashboard is revealed.
    // Sales first, then Transactions - serialized so only one card moves at a time.
    // A tutorial practice sale changes none of the real numbers.
    if (!practice) {
        $1d9fcaa0a6035698$var$refreshTodaySalesDisplay();
        $1d9fcaa0a6035698$var$_updateTransactionBadge();
        $1d9fcaa0a6035698$var$_gsHasSale = true; // "Make your first sale" step
        $1d9fcaa0a6035698$var$_updateGettingStarted(); // also refreshes the activity feed once retired
    }
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._showSuccess(note);
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal('sale-done');
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).closeRedeemModal(); // top-level modal, outside .modal-parent - doesn't auto-clear
    const successOverlay = document.querySelector('.success-overlay');
    const autoCloseTimer = setTimeout(()=>{
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._hideModal();
        successOverlay?.remove();
    }, 3500);
    const successCloseBtn = successOverlay?.querySelector('.modal-close');
    if (successCloseBtn) successCloseBtn.addEventListener('click', ()=>{
        clearTimeout(autoCloseTimer);
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._hideModal();
        successOverlay.remove();
    });
};
// Streams the receipt to the connected Bluetooth thermal printer as ESC/POS
// bytes. A failure is surfaced as a toast but never throws - the sale is
// already recorded and can be reprinted from Sales history.
const $1d9fcaa0a6035698$var$_printToBluetooth = async function(sale) {
    try {
        const bytes = (0, $9b70c844273b1ba0$export$3a40b3618ea1d38a)(sale, {
            width: (0, $fbad918341d4cd38$export$2e2bcd8739ae039).paperWidth()
        });
        await (0, $fbad918341d4cd38$export$2e2bcd8739ae039).print(bytes);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast('Bluetooth print failed: ' + (err.message ?? err) + ' Reprint from Sales history if needed.', 'error');
    }
};
// Prints the receipt through this device's chosen print method (Settings >
// POS > Printer; unset = Bluetooth when connected, else the system dialog - see
// printSettings.js). Returns a promise. Paper size is ONE device setting
// shared by both paths.
const $1d9fcaa0a6035698$var$_printReceipt = function(sale) {
    if ($e289654e8a722fd2$export$bc2db93af29ea4e2() === 'bluetooth') return $1d9fcaa0a6035698$var$_printToBluetooth(sale);
    return (0, $9d7a2f48e7d0ba3e$export$2e2bcd8739ae039).print(sale, {
        width: $e289654e8a722fd2$export$f12273f2d5c5a16b()
    });
};
// "Did it print?" confirmation. The sale is ALREADY recorded by this point, so a
// print failure never undoes it - the only action offered is a reprint (which
// reuses the same invoice number and does not create a duplicate sale). A true
// cancellation is a separate Void from Sales history.
const $1d9fcaa0a6035698$var$_askPrintConfirm = function(sale) {
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).showConfirmModal({
        message: 'Did the receipt print successfully?',
        note: 'The sale is already recorded. If it did not print, tap Reprint - this will not duplicate the sale. You can turn this prompt off in Settings.',
        confirmLabel: 'Yes, Done',
        cancelLabel: 'No, Reprint',
        onConfirm: ()=>{
            $1d9fcaa0a6035698$var$_showSaleSuccess();
        },
        onCancel: ()=>{
            const ok = $1d9fcaa0a6035698$var$_printReceipt(sale);
            if (!ok) $1d9fcaa0a6035698$var$showToast('Popup was blocked. Allow popups for this site and try again.', 'error');
            $1d9fcaa0a6035698$var$_askPrintConfirm(sale);
        }
    });
};
// The actual commit: record (assigns the invoice number), print, then the optional
// "did it print?" check. Split out from the review step below so nothing is written
// to the DB until the cashier confirms.
// `practicePreview`: the confirm screen was shown as a practice sale. Decided
// when the preview opened, not on click - otherwise pausing the tutorial with
// the preview up would turn its "Confirm practice sale" button into a real,
// recorded and printed sale.
const $1d9fcaa0a6035698$var$_finalizeTransaction = async function({ practicePreview: practicePreview = false } = {}) {
    const printBtn = document.getElementById('printReceiptBtn');
    if (printBtn) printBtn.disabled = true;
    try {
        if ($1d9fcaa0a6035698$var$modelState.cart.length <= 0) throw 'Cart is empty!';
        // The tutorial ended while its practice preview was open: record nothing.
        if (practicePreview && !(0, $399d412ac621ced9$export$2e2bcd8739ae039).practiceMode()) {
            $1d9fcaa0a6035698$var$_cancelEndedPracticeSale();
            return;
        }
        const sale = $1d9fcaa0a6035698$var$_buildSale();
        // A tab's food already went to the kitchen; its bill needs no ticket.
        sale.ticketNumber = $1d9fcaa0a6035698$var$_tabPay ? null : $1d9fcaa0a6035698$var$_generateTicketNumber();
        // First-sale tutorial: a pretend sale. Nothing is recorded or printed.
        if ((0, $399d412ac621ced9$export$2e2bcd8739ae039).practiceMode()) {
            $1d9fcaa0a6035698$var$_recordPracticeSale(sale);
            return;
        }
        // 1. Record first so the sale gets its gapless invoice number, which we then
        //    print on the receipt. Once this succeeds the sale is committed; the
        //    charge button stays disabled so it can't be re-submitted.
        await $1d9fcaa0a6035698$var$_recordSale(sale);
        // 2. Printing turned off - just confirm the sale saved.
        if (!$1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.printingEnabled) {
            $1d9fcaa0a6035698$var$_showSaleSuccess('Transaction saved. No receipt was printed. You can enable printing in Settings.');
            return;
        }
        // 3. Print the receipt (now carrying the invoice number). A blocked popup is
        //    not a sale failure - the sale is already safely recorded.
        const printPromise = $1d9fcaa0a6035698$var$_printReceipt(sale);
        if (!printPromise) {
            $1d9fcaa0a6035698$var$showToast('Sale recorded, but the receipt popup was blocked. Allow popups, then reprint from Sales history.', 'error');
            $1d9fcaa0a6035698$var$_showSaleSuccess('Sale recorded. The receipt could not open - allow popups, then reprint it from Sales history.');
            return;
        }
        await printPromise;
        // 4. Optional reprint check (never undoes the sale).
        if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.confirmPrint) $1d9fcaa0a6035698$var$_askPrintConfirm(sale);
        else $1d9fcaa0a6035698$var$_showSaleSuccess();
    } catch (err) {
        // The sale never reached the server, so nothing was recorded or printed.
        if ($1d9fcaa0a6035698$var$_isNetworkError(err)) $1d9fcaa0a6035698$var$showToast('No internet. This sale was NOT recorded or printed. The order is still here: reconnect and try again.', 'error', 9000);
        else $1d9fcaa0a6035698$var$showToast(err.message ?? err);
        if (printBtn) printBtn.disabled = false;
    }
};
// Pre-commit review. Clicking Print/Record shows a preview of the exact receipt that
// will print so the cashier can go back and change the order BEFORE anything is
// recorded. "Go Back" just closes it (nothing is written); "Confirm" runs the commit.
// The preview sale has no invoice/ticket number yet - those are assigned on record.
const $1d9fcaa0a6035698$var$controlConcludeTransaction = function() {
    if ($1d9fcaa0a6035698$var$modelState.cart.length <= 0) {
        $1d9fcaa0a6035698$var$showToast('Cart is empty!');
        return;
    }
    const printing = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.printingEnabled;
    const previewSale = $1d9fcaa0a6035698$var$_buildSale();
    const html = (0, $9d7a2f48e7d0ba3e$export$2e2bcd8739ae039).previewMarkup(previewSale, {
        width: $e289654e8a722fd2$export$f12273f2d5c5a16b()
    });
    // Reassure the cashier that the numbers fill in on confirm - but only mention the
    // ones actually enabled, so a business that hides invoice numbers never sees them
    // referenced here.
    const showInv = previewSale.showInvoiceNumber;
    const showTkt = previewSale.showTicketNumber;
    let note = null;
    if (showInv && showTkt) note = 'Your invoice and ticket numbers are filled in automatically once you confirm.';
    else if (showInv) note = 'Your invoice number is filled in automatically once you confirm.';
    else if (showTkt) note = 'Your ticket number is filled in automatically once you confirm.';
    // Tutorial practice sale: nothing records or prints, so the labels say so.
    const practice = (0, $399d412ac621ced9$export$2e2bcd8739ae039).practiceMode();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).showReceiptPreview({
        html: html,
        title: practice ? 'Finish this practice sale?' : undefined,
        confirmLabel: practice ? 'Confirm practice sale' : printing ? 'Confirm & Print' : 'Confirm & Record',
        note: note,
        onConfirm: ()=>{
            $1d9fcaa0a6035698$var$_finalizeTransaction({
                practicePreview: practice
            });
        }
    });
};
const $1d9fcaa0a6035698$var$clearCart = function() {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart = [];
    document.querySelector('.confirm-overlay')?.remove();
};
const $1d9fcaa0a6035698$var$controlCloseOrderModal = function(close) {
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).closeRedeemModal(); // top-level modal, outside .modal-parent - doesn't auto-clear
    // Paying a tab: the items stay on the tab, so just leave.
    if ($1d9fcaa0a6035698$var$_tabPay) {
        const tableId = $1d9fcaa0a6035698$var$_tabPay.tableId;
        $1d9fcaa0a6035698$var$clearCart();
        $1d9fcaa0a6035698$var$_broadcastCart();
        $1d9fcaa0a6035698$var$_hideCFDQr();
        close();
        $1d9fcaa0a6035698$var$_backToTables(tableId);
        return;
    }
    if ($1d9fcaa0a6035698$var$_tabOrder) {
        const tableId = $1d9fcaa0a6035698$var$_tabOrder.tableId;
        const leave = ()=>{
            $1d9fcaa0a6035698$var$clearCart();
            $1d9fcaa0a6035698$var$_broadcastCart();
            close();
            $1d9fcaa0a6035698$var$_backToTables(tableId);
        };
        if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.length === 0) {
            leave();
            return;
        }
        (0, $472fec5536166250$export$2e2bcd8739ae039).showConfirmModal({
            message: "These items aren't on the tab yet. Close and discard them?",
            onConfirm: leave
        });
        return;
    }
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.length === 0) {
        close();
        return;
    }
    (0, $472fec5536166250$export$2e2bcd8739ae039).showConfirmModal({
        message: 'You have items in your cart. Close and discard them?',
        // Broadcast the now-empty cart so the customer display clears too - otherwise
        // the abandoned items linger on the CFD until the next transaction. Also hide
        // the QR overlay in case QR was the selected method when the order was abandoned.
        onConfirm: ()=>{
            $1d9fcaa0a6035698$var$clearCart();
            $1d9fcaa0a6035698$var$_broadcastCart();
            $1d9fcaa0a6035698$var$_hideCFDQr();
            close();
        }
    });
};
// ── Settings ──────────────────────────────────────────────────────────────────
// ── Help & Support ────────────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$controlOpenSupport = async function() {
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).open();
    try {
        await $1e7ab04ca7920cff$export$6d18979955267451();
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).renderTicketList($1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets);
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).syncUnreadBadge($1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not load tickets.');
    }
};
const $1d9fcaa0a6035698$var$controlOpenTicket = async function(ticketId) {
    const ticket = $1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets.find((t)=>t.id === ticketId);
    if (!ticket) return;
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).setCurrentTicket(ticketId);
    try {
        const replies = await $1e7ab04ca7920cff$export$4f9d37a936b07b92(ticketId);
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).renderThread(ticket, replies);
        if (ticket.has_unread_reply) {
            await $1e7ab04ca7920cff$export$790f38d70663fe33(ticketId);
            (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).syncUnreadBadge($1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets);
        }
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not load ticket.');
    }
};
const $1d9fcaa0a6035698$var$controlMarkTicketSolved = async function(ticketId) {
    if (!ticketId) return;
    const confirmed = confirm('Mark this ticket as solved?\n\nOnce solved it cannot be reopened. If the issue comes back you\'ll need to submit a new ticket.');
    if (!confirmed) return;
    try {
        await $1e7ab04ca7920cff$export$21f448eee9ae750e(ticketId);
        const ticket = $1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets.find((t)=>t.id === ticketId);
        const replies = await $1e7ab04ca7920cff$export$4f9d37a936b07b92(ticketId);
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).renderThread(ticket, replies);
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).renderTicketList($1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not update ticket.');
    }
};
// One click on an emoji sends the rating right away (no Submit button). The UI
// flips to the thank-you optimistically; on failure it rolls back to the emojis.
const $1d9fcaa0a6035698$var$controlSubmitRating = async function() {
    const ticketId = (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._currentTicketId;
    const rating = (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._selectedRating;
    if (!ticketId || !rating) return;
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).showRatingThanks(rating);
    try {
        await $1e7ab04ca7920cff$export$5aadd1b5880603ab(ticketId, rating, '');
    } catch (err) {
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).revertRating();
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not submit rating.');
    }
};
// Optional follow-up: patches the comment onto the already-sent rating.
const $1d9fcaa0a6035698$var$controlSubmitRatingComment = async function() {
    const ticketId = (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._currentTicketId;
    const rating = (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._selectedRating;
    const comment = (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).getRatingComment();
    if (!ticketId || !rating || !comment) return;
    try {
        await $1e7ab04ca7920cff$export$5aadd1b5880603ab(ticketId, rating, comment);
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).showCommentSaved();
        $1d9fcaa0a6035698$var$showToast('Thanks for the extra detail!');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not save your comment.');
    }
};
const $1d9fcaa0a6035698$var$controlSendReply = async function() {
    const ticketId = (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._currentTicketId;
    const message = (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._getReplyText();
    if (!ticketId || !message) return;
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).setReplySending(true);
    try {
        await $1e7ab04ca7920cff$export$c42add300c9dd96f(ticketId, message);
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).clearReplyInput();
        const ticket = $1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets.find((t)=>t.id === ticketId);
        const replies = await $1e7ab04ca7920cff$export$4f9d37a936b07b92(ticketId);
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).renderThread(ticket, replies);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not send reply.');
    } finally{
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).setReplySending(false);
    }
};
const $1d9fcaa0a6035698$var$controlSubmitTicket = async function() {
    const { category: category, subject: subject, message: message, files: files } = (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._getTicketFormData();
    if (!category) {
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).showTicketResult(false, 'Please select a category.');
        return;
    }
    if (!subject) {
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).showTicketResult(false, 'Please enter a subject.');
        return;
    }
    if (!message) {
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).showTicketResult(false, 'Please enter a message.');
        return;
    }
    // Size/type are enforced + auto-downscaled centrally in model.submitTicket
    // (via prepareImageForUpload), so no inline size cap is needed here.
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).setTicketSubmitting(true);
    try {
        await $1e7ab04ca7920cff$export$1337d39a272fd051({
            category: category,
            subject: subject,
            message: message,
            files: files
        });
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).resetTicketForm();
        await $1e7ab04ca7920cff$export$6d18979955267451();
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).renderTicketList($1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets);
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).syncUnreadBadge($1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets);
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).showSuccessPanel();
        setTimeout(()=>(0, $5d00d49bfb2356db$export$2e2bcd8739ae039).showListPanel(), 2500);
    } catch (err) {
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).showTicketResult(false, err.message ?? 'Something went wrong. Please try again.');
    } finally{
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).setTicketSubmitting(false);
    }
};
const $1d9fcaa0a6035698$var$controlGenerateTimeclockToken = async function() {
    const btn = document.getElementById('payrollGenTokenBtn');
    const prevText = btn?.textContent;
    if (btn) {
        btn.disabled = true;
        btn.textContent = "Generating\u2026";
    }
    try {
        const token = await $1e7ab04ca7920cff$export$3ed0752aa616e897();
        (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).showTimeclockToken(token);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast('Failed to generate code', 'error');
        if (btn) btn.textContent = prevText ?? 'Generate Code';
    } finally{
        if (btn) btn.disabled = false;
    }
};
// Business Details changes are compliance-sensitive (address/tax jurisdiction),
// so those still require email OTP verification. Profile (name) changes don't -
// see controlSaveProfile below.
const $1d9fcaa0a6035698$var$controlSaveBusinessInfo = async function(data) {
    $1d9fcaa0a6035698$var$_settingsOTPData = data;
    const btn = document.getElementById('saveBusinessInfoBtn');
    if (btn) {
        btn.disabled = true;
        btn.textContent = "Sending code\u2026";
    }
    try {
        const captchaToken = await (0, $3kKUy.getTokenInteractive)();
        $1d9fcaa0a6035698$var$_settingsOTPEmail = await $1e7ab04ca7920cff$export$dd45956530337cf5(captchaToken);
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showOTPModal($1d9fcaa0a6035698$var$_settingsOTPEmail);
    } catch (err) {
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showBusinessSaveStatus(false, err.message ?? 'Failed to send verification code');
    } finally{
        if (btn) {
            btn.disabled = false;
            btn.textContent = 'Save Changes';
        }
    }
};
const $1d9fcaa0a6035698$var$controlSaveProfile = async function({ firstName: firstName, lastName: lastName }) {
    const btn = document.getElementById('saveProfileBtn');
    if (btn) {
        btn.disabled = true;
        btn.textContent = "Saving\u2026";
    }
    try {
        await $1e7ab04ca7920cff$export$135c88fe76d8e545({
            firstName: firstName,
            lastName: lastName
        });
        $1d9fcaa0a6035698$var$_updateCashierDisplay();
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).exitProfileEditMode(false);
        $1d9fcaa0a6035698$var$showToast('Profile updated', 'success');
    } catch (err) {
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showProfileSaveStatus(false, err.message ?? 'Failed to save profile');
    } finally{
        if (btn) {
            btn.disabled = false;
            btn.textContent = 'Save Changes';
        }
    }
};
const $1d9fcaa0a6035698$var$controlEditProfile = ()=>(0, $6e66866c6dedb838$export$2e2bcd8739ae039).enterProfileEditMode();
const $1d9fcaa0a6035698$var$controlCancelProfile = ()=>(0, $6e66866c6dedb838$export$2e2bcd8739ae039).exitProfileEditMode(true);
const $1d9fcaa0a6035698$var$controlEditBusiness = ()=>(0, $6e66866c6dedb838$export$2e2bcd8739ae039).enterBusinessEditMode();
const $1d9fcaa0a6035698$var$controlCancelBusiness = ()=>(0, $6e66866c6dedb838$export$2e2bcd8739ae039).exitBusinessEditMode(true);
// Only Business Details routes through OTP now (see controlSaveBusinessInfo /
// controlSaveProfile above), so this always finalizes a business save.
const $1d9fcaa0a6035698$var$controlVerifySettingsOTP = async function(token) {
    try {
        await $1e7ab04ca7920cff$export$d0bf361f2f356611($1d9fcaa0a6035698$var$_settingsOTPEmail, token);
        // verifyOtp swaps in a fresh code-only (aal1) session. With 2FA on, the database
        // refuses aal1, so the owner must pass their authenticator code again before saving.
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).hideOTPModal();
        if (!await $1d9fcaa0a6035698$var$_enforceMFA()) {
            await (0, $asfCf.supabase).auth.signOut({
                scope: 'local'
            });
            location.reload();
            return;
        }
        const { name: name, email: email, phone: phone, timezone: timezone, address: address, city: city, state: stateVal, zip: zip } = $1d9fcaa0a6035698$var$_settingsOTPData;
        const prevProvince = $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressProvince ?? '';
        const country = $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCountry;
        try {
            await $1e7ab04ca7920cff$export$e2fc50026c086c51({
                name: name,
                email: email,
                phone: phone,
                timezone: timezone,
                addressStreet: address,
                addressCity: city,
                addressProvince: stateVal,
                addressZip: zip
            });
        } catch (err) {
            $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not save business info.', 'error');
            return;
        }
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).exitBusinessEditMode(false);
        $1d9fcaa0a6035698$var$showToast('Business info saved', 'success');
        // If the province/state changed, remind the owner to review their tax rate.
        const changed = (stateVal ?? '').trim().toLowerCase() !== prevProvince.trim().toLowerCase();
        if (changed && (stateVal ?? '').trim()) {
            const suggestion = (0, $0dd9374d56731bb4$export$2956ce99ebefe226)({
                country: country,
                province: stateVal
            });
            const msg = suggestion ? `Your business location changed. The typical rate for ${suggestion.label} is ${suggestion.rate}% - review your tax rate in Receipt & Tax.` : 'Your business location changed. Your tax rate may be different now - review it in Receipt & Tax.';
            (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showTaxReminder(msg);
        }
        $1d9fcaa0a6035698$var$_settingsOTPEmail = null;
        $1d9fcaa0a6035698$var$_settingsOTPData = null;
    } catch (err) {
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showOTPModalError(err.message ?? 'Verification failed. Try again.');
    }
};
const $1d9fcaa0a6035698$var$controlCancelSettingsOTP = function() {
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).hideOTPModal();
    $1d9fcaa0a6035698$var$_settingsOTPEmail = null;
    $1d9fcaa0a6035698$var$_settingsOTPData = null;
};
// Re-populates every POS/KDS control from state.settings - used on open and
// after discarding a settings draft.
const $1d9fcaa0a6035698$var$_syncAllSettingsToggles = function() {
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncPrintingToggle($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.printingEnabled);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncConfirmPrintToggle($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.confirmPrint);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncShowCashierToggle($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showCashierName);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncHideStatsToggle($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.hideStatsFromStaff);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncOrderTypeToggle($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.orderTypeEnabled);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncInvoiceNumberToggle($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showInvoiceNumber);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncTicketNumberToggle($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showTicketNumber);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncShowPhoneToggle($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showBusinessPhone);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncReceiptFooter({
        footer: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.receiptFooter,
        qrUrl: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.receiptQrUrl,
        locked: !$1e7ab04ca7920cff$export$9e608bbc985290d4()
    });
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncTips({
        enabled: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipsEnabled,
        presets: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipPresets,
        qrUrl: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipQrUrl
    });
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncKDSThresholds($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsYellowThreshold, $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsRedThreshold, $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsAutoCompleteThreshold);
    $1d9fcaa0a6035698$var$_renderHomeTab();
};
// ── Settings > Home screen ────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$_renderHomeTab = function() {
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings;
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).renderHomeTab({
        ...s,
        hidden: s.homeHidden ?? [],
        planLocked: !$1e7ab04ca7920cff$export$9e608bbc985290d4(),
        homeCards: {
            cards: $1d9fcaa0a6035698$var$_homeShown.cards,
            tiles: $1d9fcaa0a6035698$var$_homeShown.tiles,
            cardOptions: $1d9fcaa0a6035698$var$_homeCardOptions(null),
            tileOptions: $1d9fcaa0a6035698$var$_homeTileOptions(null)
        }
    });
};
const $1d9fcaa0a6035698$var$_afterHomeChange = function() {
    $1d9fcaa0a6035698$var$_applyHomeLayout();
    $1d9fcaa0a6035698$var$_renderHomeTab();
};
const $1d9fcaa0a6035698$var$controlHomeShown = function(key, shown) {
    const hidden = new Set($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.homeHidden ?? []);
    if (shown) hidden.delete(key);
    else hidden.add(key);
    $1d9fcaa0a6035698$var$_stageSetting('homeHidden', [
        ...hidden
    ]);
    $1d9fcaa0a6035698$var$_afterHomeChange();
};
// A checkout switch or the table level. Dine in / Takeout and Tips also live
// on the POS tab, so keep those controls in step.
const $1d9fcaa0a6035698$var$controlHomeSet = function(key, value) {
    $1d9fcaa0a6035698$var$_stageSetting(key, value);
    if (key === 'orderTypeEnabled') (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncOrderTypeToggle(value);
    if (key === 'tipsEnabled') (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncTips({
        enabled: value,
        presets: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipPresets,
        qrUrl: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipQrUrl
    });
    $1d9fcaa0a6035698$var$_afterHomeChange();
};
const $1d9fcaa0a6035698$var$controlHomePlace = function(placeType) {
    $1d9fcaa0a6035698$var$_stageSetting('placeType', placeType);
    $1d9fcaa0a6035698$var$_renderHomeTab();
};
const $1d9fcaa0a6035698$var$controlHomeSuggested = function() {
    const placeType = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.placeType;
    if (!placeType) return;
    for (const [key, value] of Object.entries((0, $aa52f24595bb637d$export$1df807e10c721ac1)(placeType)))$1d9fcaa0a6035698$var$_stageSetting(key, value);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncOrderTypeToggle($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.orderTypeEnabled);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncTips({
        enabled: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipsEnabled,
        presets: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipPresets,
        qrUrl: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipQrUrl
    });
    $1d9fcaa0a6035698$var$_afterHomeChange();
    $1d9fcaa0a6035698$var$showToast(`Suggested setup for a ${(0, $aa52f24595bb637d$export$eceaf1f7147b66ff)(placeType).split(' /')[0].toLowerCase()}. Save Changes to keep it.`, 'info');
};
const $1d9fcaa0a6035698$var$controlOpenSettings = function() {
    $1d9fcaa0a6035698$var$_settingsOTPEmail = null;
    $1d9fcaa0a6035698$var$_settingsOTPData = null;
    $1d9fcaa0a6035698$var$_settingsDraftOriginal = null;
    $1d9fcaa0a6035698$var$_pendingPaperWidth = null;
    $1d9fcaa0a6035698$var$_pendingPrintMethod = null;
    $1d9fcaa0a6035698$var$_pendingPosition = null;
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).openWithRole($1e7ab04ca7920cff$export$ca000e230c0caa3e.role);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncProfileInfo({
        firstName: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.firstName ?? '',
        lastName: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.lastName ?? '',
        email: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.email ?? $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessEmail ?? ''
    });
    if ($1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business')) {
        const isOwner = $1e7ab04ca7920cff$export$ca000e230c0caa3e.userId === $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId;
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncBusinessInfo({
            name: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessName ?? '',
            email: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessEmail ?? $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.email ?? '',
            phone: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessPhone ?? '',
            timezone: $1e7ab04ca7920cff$export$74881ed03683ce30(),
            address: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressStreet ?? '',
            city: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCity ?? '',
            state: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressProvince ?? '',
            zip: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressZip ?? '',
            country: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCountry ?? '',
            isOwner: isOwner
        });
    }
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncShowRemovedToggle($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showRemovedAdjustments);
    $1d9fcaa0a6035698$var$_syncAllSettingsToggles();
    $1d9fcaa0a6035698$var$_syncPrinterUI();
    // Best-effort: get a previously-paired printer ready before Test print is clicked.
    (0, $fbad918341d4cd38$export$2e2bcd8739ae039).reconnect().catch(()=>{});
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncDisplaySizes($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsWindowSize, $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.cfdWindowSize);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).render2FA(false); // optimistic default; corrected by the async check
    $1d9fcaa0a6035698$var$_refresh2FA();
};
const $1d9fcaa0a6035698$var$controlTogglePrinting = function(value) {
    $1d9fcaa0a6035698$var$_stageSetting('printingEnabled', value);
};
const $1d9fcaa0a6035698$var$controlToggleConfirmPrint = function(value) {
    $1d9fcaa0a6035698$var$_stageSetting('confirmPrint', value);
};
const $1d9fcaa0a6035698$var$controlToggleShowCashier = function(value) {
    $1d9fcaa0a6035698$var$_stageSetting('showCashierName', value);
};
// Home screen (homeLayout.js): which Manage / Screens shortcuts show. Re-run
// after any change to homeHidden or tableService (Settings, Customize, onboarding).
const $1d9fcaa0a6035698$var$_applyHomeLayout = function() {
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings;
    (0, $f850a85e1d95a80e$export$2e2bcd8739ae039).apply({
        hidden: s.homeHidden ?? [],
        tablesOn: (s.tableService ?? 'off') !== 'off'
    });
    const desc = document.getElementById('homeTablesDesc');
    if (desc) desc.textContent = s.tableService === 'full' ? 'Floor plan, tabs & waitlist' : 'Table names for checkout';
    // Table service on: load the list the checkout picker needs.
    if ((s.tableService ?? 'off') !== 'off' && $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId && !$1e7ab04ca7920cff$export$ca000e230c0caa3e.diningTables.length) $1e7ab04ca7920cff$export$1dd25893a10c6b3f().catch(()=>{});
    // Table service / waitlist / reservations / plan decide which cards can show.
    $1d9fcaa0a6035698$var$_applyHomeCards();
};
// Customize mode's Done on the Manage menu saves right away (not a Settings draft).
const $1d9fcaa0a6035698$var$controlSaveHomeHidden = function(hidden) {
    $1e7ab04ca7920cff$export$680c723e3a62d1c3('homeHidden', hidden);
    $1d9fcaa0a6035698$var$_applyHomeLayout();
    $1d9fcaa0a6035698$var$showToast('Menu updated', 'success');
};
// ── Swappable home cards + stat tiles (homeCards.js, homeCardsView.js) ───────
// Saved per device; anyone can swap. The first-sale tutorial puts the default
// layout back while it runs, because it spotlights the Active Queue.
let $1d9fcaa0a6035698$var$_homeCardPrefs = $3aa6878d3c2fc9b3$export$11e63f7b0f3d9900();
let $1d9fcaa0a6035698$var$_homeTourDefaults = false;
let $1d9fcaa0a6035698$var$_homeShown = {
    cards: $3aa6878d3c2fc9b3$export$65e7841ac6ed0223,
    tiles: $3aa6878d3c2fc9b3$export$f38b4fdd358d10bf
};
let $1d9fcaa0a6035698$var$_homeSnap = null; // fetchTodaySnapshot(): tips, items sold, top sellers
let $1d9fcaa0a6035698$var$_homeSnapAt = 0;
let $1d9fcaa0a6035698$var$_homeTotals = null; // { today, lastWeek } fetchPeriodTotals for avg order / vs last week
let $1d9fcaa0a6035698$var$_homeTotalsAt = 0;
let $1d9fcaa0a6035698$var$_homeSalesStale = false;
let $1d9fcaa0a6035698$var$_homeTablesLoaded = false;
let $1d9fcaa0a6035698$var$_homeCardsTimer = null;
let $1d9fcaa0a6035698$var$_homeCardsDebounce = null;
let $1d9fcaa0a6035698$var$_homeSalesTimes = null; // fetchSalesTimes() rows for the last 14 days
let $1d9fcaa0a6035698$var$_homeSalesTimesAt = 0;
let $1d9fcaa0a6035698$var$_homeSchedule = null; // { shifts, stations } published today
let $1d9fcaa0a6035698$var$_homeScheduleAt = 0;
let $1d9fcaa0a6035698$var$_homeExpenses = null; // today's expenses total
let $1d9fcaa0a6035698$var$_homeExpensesAt = 0;
const $1d9fcaa0a6035698$var$HOME_TABLE_KEYS = new Set([
    'tables',
    'reservations',
    'waitlist',
    'freeTables',
    'openTabs',
    'nextBooking'
]);
const $1d9fcaa0a6035698$var$HOME_STATIC_TILES = new Set([
    'sales',
    'txns',
    'serving'
]);
const $1d9fcaa0a6035698$var$_homeIsManager = ()=>[
        'manage_inventory',
        'manage_pay',
        'manage_schedule'
    ].some((p)=>$1e7ab04ca7920cff$export$b325ec6732b039cf(p));
const $1d9fcaa0a6035698$var$_homeInventoryOn = ()=>!$1e7ab04ca7920cff$export$57b484963858c9a0('inventory') && $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.inventoryEnabled !== false;
// Why a card or tile can't show on this device right now, or null if it can.
// { tag, desc } feeds the picker's greyed-out row.
const $1d9fcaa0a6035698$var$_homeBlock = (key)=>{
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings;
    const full = s.tableService === 'full';
    const off = {
        tag: 'Off',
        desc: $1d9fcaa0a6035698$var$_homeOffHint()
    };
    const pro = {
        tag: 'Pro',
        desc: 'Part of the Pro plan'
    };
    if ([
        'tables',
        'freeTables',
        'openTabs'
    ].includes(key)) return full ? null : off;
    if (key === 'reservations' || key === 'nextBooking') return full && s.reservationsEnabled === true ? null : off;
    if (key === 'waitlist') return full && s.waitlistEnabled === true ? null : off;
    if (key === 'lowStock' || key === 'lowItems') {
        if ($1e7ab04ca7920cff$export$57b484963858c9a0('inventory')) return pro;
        return s.inventoryEnabled === false ? off : null;
    }
    if (key === 'purchaseOrders') {
        if ($1e7ab04ca7920cff$export$57b484963858c9a0('inventory')) return pro;
        if (s.inventoryEnabled === false) return off;
        return $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_inventory') ? null : {
            tag: '',
            desc: 'For people who manage inventory'
        };
    }
    if (key === 'inbox' || key === 'requests') return $1d9fcaa0a6035698$var$_homeIsManager() ? null : {
        tag: '',
        desc: 'For managers'
    };
    if ((key === 'salesToday' || key === 'salesWeek') && document.body.classList.contains('hide-home-stats')) return {
        tag: '',
        desc: 'Sales figures are hidden from staff'
    };
    return null;
};
const $1d9fcaa0a6035698$var$_homeCardAvail = (key)=>!$1d9fcaa0a6035698$var$_homeBlock(key);
const $1d9fcaa0a6035698$var$_homeTileAvail = (key)=>!$1d9fcaa0a6035698$var$_homeBlock(key);
// The left spot's own card goes by what it is showing this user right now.
const $1d9fcaa0a6035698$var$_homeMainLabel = ()=>{
    if ($1d9fcaa0a6035698$var$_activityFeedActive()) return {
        label: 'Activity',
        desc: 'Sales, clock-ins and stock alerts'
    };
    if ($1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business')) return {
        label: 'Getting started',
        desc: 'Your setup checklist, then your activity'
    };
    return {
        label: 'My shift',
        desc: 'Your clock status and hours this week'
    };
};
const $1d9fcaa0a6035698$var$_applyHomeCards = function() {
    const prefs = $1d9fcaa0a6035698$var$_homeTourDefaults ? {
        cards: $3aa6878d3c2fc9b3$export$65e7841ac6ed0223,
        tiles: $3aa6878d3c2fc9b3$export$f38b4fdd358d10bf
    } : $1d9fcaa0a6035698$var$_homeCardPrefs;
    $1d9fcaa0a6035698$var$_homeShown = {
        cards: $3aa6878d3c2fc9b3$export$f7ad0328861e2f03(prefs.cards, $3aa6878d3c2fc9b3$export$65e7841ac6ed0223, $1d9fcaa0a6035698$var$_homeCardAvail, $3aa6878d3c2fc9b3$export$33e05acb58ff054f),
        tiles: $3aa6878d3c2fc9b3$export$f7ad0328861e2f03(prefs.tiles, $3aa6878d3c2fc9b3$export$f38b4fdd358d10bf, $1d9fcaa0a6035698$var$_homeTileAvail, $3aa6878d3c2fc9b3$export$6c988621b2141f2e)
    };
    (0, $717baed02964aa54$export$2e2bcd8739ae039).apply($1d9fcaa0a6035698$var$_homeShown);
    clearInterval($1d9fcaa0a6035698$var$_homeCardsTimer);
    $1d9fcaa0a6035698$var$_homeCardsTimer = null;
    const custom = (0, $717baed02964aa54$export$2e2bcd8739ae039).customCards().length || $1d9fcaa0a6035698$var$_homeShown.tiles.some((k)=>!$1d9fcaa0a6035698$var$HOME_STATIC_TILES.has(k));
    if (!custom) return;
    $1d9fcaa0a6035698$var$_refreshHomeCards();
    // Seated times and waits tick; other terminals' changes land even if a
    // broadcast was missed. Sales figures refetch at most every 2 minutes.
    $1d9fcaa0a6035698$var$_homeCardsTimer = setInterval(()=>{
        if (!document.hidden) $1d9fcaa0a6035698$var$_refreshHomeCards();
    }, 30000);
};
// sales: a sale or void just happened, so the sales figures refetch now.
const $1d9fcaa0a6035698$var$_refreshHomeCards = function({ sales: sales = false } = {}) {
    if (sales) $1d9fcaa0a6035698$var$_homeSalesStale = true;
    clearTimeout($1d9fcaa0a6035698$var$_homeCardsDebounce);
    $1d9fcaa0a6035698$var$_homeCardsDebounce = setTimeout($1d9fcaa0a6035698$var$_refreshHomeCardsNow, 400);
};
const $1d9fcaa0a6035698$var$_refreshHomeCardsNow = async function() {
    if (!$1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId) return;
    const shown = [
        ...(0, $717baed02964aa54$export$2e2bcd8739ae039).customCards(),
        ...$1d9fcaa0a6035698$var$_homeShown.tiles
    ];
    const needs = (...keys)=>keys.some((k)=>shown.includes(k));
    const fresh = (at)=>!$1d9fcaa0a6035698$var$_homeSalesStale && Date.now() - at < 120000;
    const jobs = [];
    if ($1d9fcaa0a6035698$var$_tablesOn() && shown.some((k)=>$1d9fcaa0a6035698$var$HOME_TABLE_KEYS.has(k))) jobs.push($1d9fcaa0a6035698$var$_loadTablesAll().then(()=>{
        $1d9fcaa0a6035698$var$_homeTablesLoaded = true;
    }).catch(()=>{}));
    const { start: start, end: end } = $1d9fcaa0a6035698$var$_getBizDayBounds();
    if (needs('topSellers', 'tips', 'itemsSold') && !($1d9fcaa0a6035698$var$_homeSnap && fresh($1d9fcaa0a6035698$var$_homeSnapAt))) jobs.push($1e7ab04ca7920cff$export$f25734b7deb6ab90(start.toISOString(), end.toISOString()).then((snap)=>{
        $1d9fcaa0a6035698$var$_homeSnap = snap;
        $1d9fcaa0a6035698$var$_homeSnapAt = Date.now();
    }).catch(()=>{}));
    if (needs('salesToday', 'salesWeek') && !($1d9fcaa0a6035698$var$_homeSalesTimes && fresh($1d9fcaa0a6035698$var$_homeSalesTimesAt))) {
        const from = $1d9fcaa0a6035698$var$_getBizDayBounds(new Date(Date.now() - 1123200000)).start;
        jobs.push($1e7ab04ca7920cff$export$b3700a60d4c9ee6e(from.toISOString(), end.toISOString()).then((rows)=>{
            $1d9fcaa0a6035698$var$_homeSalesTimes = rows;
            $1d9fcaa0a6035698$var$_homeSalesTimesAt = Date.now();
        }).catch(()=>{}));
    }
    if (needs('schedule') && !($1d9fcaa0a6035698$var$_homeSchedule && Date.now() - $1d9fcaa0a6035698$var$_homeScheduleAt < 60000)) jobs.push($1e7ab04ca7920cff$export$f3f832aa56d8a437(start.toISOString(), end.toISOString()).then((sch)=>{
        $1d9fcaa0a6035698$var$_homeSchedule = sch;
        $1d9fcaa0a6035698$var$_homeScheduleAt = Date.now();
    }).catch(()=>{}));
    if (needs('expenses') && !($1d9fcaa0a6035698$var$_homeExpenses != null && fresh($1d9fcaa0a6035698$var$_homeExpensesAt))) jobs.push($1e7ab04ca7920cff$export$d26986fd4f5259c1().then((n)=>{
        $1d9fcaa0a6035698$var$_homeExpenses = n;
        $1d9fcaa0a6035698$var$_homeExpensesAt = Date.now();
    }).catch(()=>{}));
    if (needs('avgOrder', 'lastWeek') && !($1d9fcaa0a6035698$var$_homeTotals && fresh($1d9fcaa0a6035698$var$_homeTotalsAt))) {
        const weekAgo = Date.now() - 604800000;
        const lastWeekStart = $1d9fcaa0a6035698$var$_getBizDayBounds(new Date(weekAgo)).start;
        jobs.push(Promise.all([
            $1e7ab04ca7920cff$export$2614d9fab0c6cda6(start.toISOString(), end.toISOString()),
            $1e7ab04ca7920cff$export$2614d9fab0c6cda6(lastWeekStart.toISOString(), new Date(weekAgo).toISOString())
        ]).then(([today, lastWeek])=>{
            $1d9fcaa0a6035698$var$_homeTotals = {
                today: today,
                lastWeek: lastWeek
            };
            $1d9fcaa0a6035698$var$_homeTotalsAt = Date.now();
        }).catch(()=>{}));
    }
    $1d9fcaa0a6035698$var$_homeSalesStale = false;
    $1d9fcaa0a6035698$var$_renderHomeCards(); // what's already in memory (team, queue) paints now
    if (jobs.length) {
        await Promise.all(jobs);
        $1d9fcaa0a6035698$var$_renderHomeCards();
    }
};
const $1d9fcaa0a6035698$var$_homeTablesData = (now)=>$1d9fcaa0a6035698$var$_homeTablesLoaded && $1d9fcaa0a6035698$var$_tablesOn() ? {
        tables: $1e7ab04ca7920cff$export$ca000e230c0caa3e.diningTables,
        tabs: $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs,
        reservations: $1d9fcaa0a6035698$var$_resToday,
        waitlist: $1e7ab04ca7920cff$export$ca000e230c0caa3e.waitlist,
        now: now
    } : null;
const $1d9fcaa0a6035698$var$_homeTime = (iso)=>new Date(iso).toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
        timeZone: $1d9fcaa0a6035698$var$_bizTz()
    });
const $1d9fcaa0a6035698$var$_bizHour = (ms)=>(0, $lDSCx.zonedParts)(new Date(ms), $1d9fcaa0a6035698$var$_bizTz()).h;
const $1d9fcaa0a6035698$var$_homeTileValues = function(td, now) {
    const v = {};
    if ($1d9fcaa0a6035698$var$_homeTotals) {
        const { today: today, lastWeek: lastWeek } = $1d9fcaa0a6035698$var$_homeTotals;
        v.avgOrder = today.transactions ? {
            value: (0, $coRoT.formatMoney)(today.avgOrder),
            sub: `across ${today.transactions} ${today.transactions === 1 ? 'sale' : 'sales'}`
        } : {
            value: "\u2014",
            sub: 'No sales yet today'
        };
        if (lastWeek.revenue > 0) {
            const pct = Math.round((today.revenue - lastWeek.revenue) / lastWeek.revenue * 100);
            v.lastWeek = {
                value: `${pct >= 0 ? '+' : ''}${pct}%`,
                sub: `vs ${$1d9fcaa0a6035698$var$_fmtMoneyShort(lastWeek.revenue)} last week`
            };
        } else v.lastWeek = {
            value: "\u2014",
            sub: 'No sales by now last week'
        };
    }
    if ($1d9fcaa0a6035698$var$_homeSnap) {
        v.tips = {
            value: (0, $coRoT.formatMoney)($1d9fcaa0a6035698$var$_homeSnap.tips),
            sub: $1d9fcaa0a6035698$var$_homeSnap.tipped ? `${$1d9fcaa0a6035698$var$_homeSnap.tipped} ${$1d9fcaa0a6035698$var$_homeSnap.tipped === 1 ? 'sale' : 'sales'} with a tip` : 'No tips yet today'
        };
        v.itemsSold = {
            value: String($1d9fcaa0a6035698$var$_homeSnap.itemsSold),
            sub: $1d9fcaa0a6035698$var$_homeSnap.top[0] ? `Most: ${$1d9fcaa0a6035698$var$_markDeletedName($1d9fcaa0a6035698$var$_homeSnap.top[0].name)}` : 'No sales yet today'
        };
    }
    const queue = $1e7ab04ca7920cff$export$ca000e230c0caa3e.orderQueue.filter((o)=>!o.practice);
    const oldest = queue.reduce((m, o)=>Math.min(m, new Date(o.saleDate).getTime() || m), now);
    v.waiting = {
        value: String(queue.length),
        sub: queue.length ? `Oldest ${Math.max(0, Math.floor((now - oldest) / 60000))} min` : 'All caught up'
    };
    if ($1d9fcaa0a6035698$var$_lastOnShiftList) {
        const n = $1d9fcaa0a6035698$var$_lastOnShiftList.length;
        const breaks = $1d9fcaa0a6035698$var$_lastOnShiftList.filter((p)=>p.onBreak).length;
        v.onShift = {
            value: `${n} ${n === 1 ? 'person' : 'people'}`,
            sub: breaks ? `${breaks} on break` : n ? 'Working now' : 'Nobody clocked in'
        };
    }
    if ($1d9fcaa0a6035698$var$_homeExpenses != null) v.expenses = {
        value: (0, $coRoT.formatMoney)($1d9fcaa0a6035698$var$_homeExpenses),
        sub: $1d9fcaa0a6035698$var$_homeExpenses > 0 ? 'Logged today' : 'None logged yet'
    };
    const inbox = $1d9fcaa0a6035698$var$_homeInboxData();
    if (inbox) {
        const n = inbox.reduce((s, r)=>s + r.count, 0);
        v.requests = {
            value: String(n),
            sub: n ? inbox.filter((r)=>r.count).map((r)=>$1d9fcaa0a6035698$var$HOME_INBOX_SHORT[r.cat]).join(', ').replace(/^./, (c)=>c.toUpperCase()) : 'Nothing waiting'
        };
    }
    if (!$1d9fcaa0a6035698$var$_practice) {
        const inv = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.inventoryEnabled === false ? [] : $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems;
        const out = inv.filter((i)=>i.quantity <= 0).length;
        const low = inv.filter((i)=>i.quantity > 0 && i.lowStockThreshold != null && i.quantity <= i.lowStockThreshold).length;
        v.lowItems = {
            value: String(out + low),
            sub: out ? `${out} out of stock` : low ? 'Running low' : 'All stocked'
        };
    }
    if (td) {
        const status = td.tables.map((t)=>(0, $ab39ca298e181461$export$49881d192203ad4a)(t, td.tabs.find((x)=>x.tableId === t.id), td.reservations, now));
        const dirty = status.filter((s)=>s === 'dirty').length;
        const guests = td.tabs.reduce((s, t)=>s + (t.guests || 0), 0);
        v.freeTables = {
            value: `${status.filter((s)=>s === 'free').length} of ${td.tables.length}`,
            sub: dirty ? `${dirty} need cleaning` : ''
        };
        v.openTabs = {
            value: String(td.tabs.length),
            sub: td.tabs.length ? `${guests} ${guests === 1 ? 'guest' : 'guests'} seated` : 'No open tabs'
        };
        const next = td.reservations.filter((r)=>r.status === 'booked' && new Date(r.startsAt).getTime() > now - 1800000).sort((a, b)=>new Date(a.startsAt) - new Date(b.startsAt))[0];
        v.nextBooking = next ? {
            value: $1d9fcaa0a6035698$var$_homeTime(next.startsAt),
            sub: `${next.name}, ${next.partySize}`
        } : {
            value: "\u2014",
            sub: 'No more bookings today'
        };
    }
    return v;
};
const $1d9fcaa0a6035698$var$_homeSum = (rows)=>rows.reduce((s, r)=>s + r.total, 0);
// Sales today by hour (next to yesterday) and the last 7 days (next to the 7
// before), from the one 14-day fetch.
const $1d9fcaa0a6035698$var$_homeSalesTrend = function(now) {
    if (!$1d9fcaa0a6035698$var$_homeSalesTimes) return null;
    const todayStart = $1d9fcaa0a6035698$var$_getBizDayBounds(new Date(now)).start.getTime();
    const ydayStart = $1d9fcaa0a6035698$var$_getBizDayBounds(new Date(now - 86400000)).start.getTime();
    const todayRows = $1d9fcaa0a6035698$var$_homeSalesTimes.filter((r)=>r.at >= todayStart);
    const ydayRows = $1d9fcaa0a6035698$var$_homeSalesTimes.filter((r)=>r.at >= ydayStart && r.at < todayStart);
    const byHour = (rows)=>{
        const a = Array(24).fill(0);
        rows.forEach((r)=>{
            a[$1d9fcaa0a6035698$var$_bizHour(r.at)] += r.total;
        });
        return a;
    };
    const th = byHour(todayRows), yh = byHour(ydayRows);
    const nowH = $1d9fcaa0a6035698$var$_bizHour(now);
    // Only the hours this shop trades, at least 8 wide.
    const active = th.map((v, h)=>v || yh[h] ? h : null).filter((h)=>h !== null);
    let lo = Math.min(nowH, ...active), hi = Math.max(nowH, ...active);
    while(hi - lo < 7 && (lo > 0 || hi < 23)){
        if (lo > 0) lo--;
        if (hi - lo < 7 && hi < 23) hi++;
    }
    const step = hi - lo > 12 ? 3 : 2;
    const label = (h)=>`${h % 12 || 12}${h < 12 ? 'am' : 'pm'}`;
    const hours = [];
    for(let h = lo; h <= hi; h++)hours.push({
        h: h,
        label: label(h),
        today: th[h],
        yday: yh[h],
        now: h === nowH,
        future: h > nowH,
        showLabel: (h - lo) % step === 0
    });
    const sinceStart = now - todayStart;
    const days = [];
    for(let i = 6; i >= 0; i--){
        const b = $1d9fcaa0a6035698$var$_getBizDayBounds(new Date(now - i * 86400000));
        const s = b.start.getTime(), e = b.end.getTime();
        const ps = s - 604800000, pe = e - 604800000;
        const date = new Date(s);
        days.push({
            short: i === 0 ? 'Today' : date.toLocaleDateString([], {
                weekday: 'short',
                timeZone: $1d9fcaa0a6035698$var$_bizTz()
            }),
            label: date.toLocaleDateString([], {
                weekday: 'long',
                month: 'short',
                day: 'numeric',
                timeZone: $1d9fcaa0a6035698$var$_bizTz()
            }),
            value: $1d9fcaa0a6035698$var$_homeSum($1d9fcaa0a6035698$var$_homeSalesTimes.filter((r)=>r.at >= s && r.at <= e)),
            prev: $1d9fcaa0a6035698$var$_homeSum($1d9fcaa0a6035698$var$_homeSalesTimes.filter((r)=>r.at >= ps && r.at <= pe)),
            today: i === 0
        });
    }
    return {
        hours: hours,
        total: $1d9fcaa0a6035698$var$_homeSum(todayRows),
        ydaySoFar: $1d9fcaa0a6035698$var$_homeSum(ydayRows.filter((r)=>r.at - ydayStart <= sinceStart)),
        days: days,
        weekTotal: days.reduce((s, d)=>s + d.value, 0),
        prevWeekTotal: days.reduce((s, d)=>s + d.prev, 0)
    };
};
const $1d9fcaa0a6035698$var$_homeScheduleData = function(now) {
    if (!$1d9fcaa0a6035698$var$_homeSchedule) return null;
    const stations = new Map($1d9fcaa0a6035698$var$_homeSchedule.stations.map((s)=>[
            s.id,
            s
        ]));
    const onShift = new Map(($1d9fcaa0a6035698$var$_lastOnShiftList ?? []).map((p)=>[
            p.staffId,
            p
        ]));
    // "Not in yet" when the person's role clocks in on the Time Clock (from the
    // shift query); otherwise a started shift just reads "On now".
    const nameOf = (sh)=>{
        if (sh.staffName) return sh.staffName;
        const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.find((x)=>x.id === sh.staffId);
        return s ? `${s.firstName ?? ''} ${s.lastName ?? ''}`.trim() || 'Teammate' : 'Teammate';
    };
    const order = {
        working: 0,
        break: 0,
        late: 1,
        now: 1,
        upcoming: 2,
        open: 2,
        done: 3
    };
    const rows = $1d9fcaa0a6035698$var$_homeSchedule.shifts.map((sh)=>{
        const start = new Date(sh.startsAt).getTime(), end = new Date(sh.endsAt).getTime();
        const p = sh.staffId ? onShift.get(sh.staffId) : null;
        let state;
        if (!sh.staffId) state = 'open';
        else if (p) state = p.onBreak ? 'break' : 'working';
        else if (now >= end) state = 'done';
        else if (now >= start + 300000) state = sh.usesClock ? 'late' : 'now';
        else state = 'upcoming';
        const mins = Math.round((start - now) / 60000);
        return {
            name: sh.staffId ? nameOf(sh) : '',
            open: !sh.staffId,
            color: stations.get(sh.stationId)?.color ?? null,
            station: stations.get(sh.stationId)?.name ?? '',
            time: `${$1d9fcaa0a6035698$var$_homeTime(sh.startsAt)} - ${$1d9fcaa0a6035698$var$_homeTime(sh.endsAt)}`,
            state: state,
            startsIn: state === 'now' ? 'On now' : mins < 60 ? `In ${Math.max(0, mins)} min` : `At ${$1d9fcaa0a6035698$var$_homeTime(sh.startsAt)}`,
            start: start
        };
    }).sort((a, b)=>order[a.state] - order[b.state] || a.start - b.start);
    return {
        rows: rows,
        canOpen: $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_schedule')
    };
};
const $1d9fcaa0a6035698$var$HOME_INBOX_ICONS = {
    shiftRequests: '<path d="M7 16V4m0 0L3 8m4-4 4 4"/><path d="M17 8v12m0 0 4-4m-4 4-4-4"/>',
    leave: '<path d="M2 12h20"/><path d="M12 2a15 15 0 0 1 0 20"/><path d="M12 2a15 15 0 0 0 0 20"/><circle cx="12" cy="12" r="10"/>',
    corrections: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    po: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/>'
};
const $1d9fcaa0a6035698$var$HOME_INBOX_SHORT = {
    shiftRequests: 'swaps',
    leave: 'time off',
    corrections: 'corrections',
    po: 'orders'
};
// From the bell's data (_refreshNotifications), so no extra queries.
const $1d9fcaa0a6035698$var$_homeInboxData = function() {
    if (!$1d9fcaa0a6035698$var$_notifLastFetch) return null;
    const d = $1d9fcaa0a6035698$var$_notifData;
    const row = (cat, count, label, sub)=>({
            cat: cat,
            count: count,
            label: label,
            sub: sub,
            icon: $1d9fcaa0a6035698$var$HOME_INBOX_ICONS[cat]
        });
    return [
        $1d9fcaa0a6035698$var$_notifCanSchedule && row('shiftRequests', d.shiftRequests.length, 'Shift swaps and pickups', 'Approve them in Schedule'),
        $1d9fcaa0a6035698$var$_notifCanPay && row('leave', d.leave.length, 'Time off requests', 'Review them in Timesheets'),
        $1d9fcaa0a6035698$var$_notifCanPay && row('corrections', d.corrections.length, 'Time corrections', 'Missed or wrong clock-ins'),
        $1d9fcaa0a6035698$var$_notifCanPOs && row('po', d.pos.length, 'Draft purchase orders', 'Ready to send to suppliers')
    ].filter(Boolean);
};
const $1d9fcaa0a6035698$var$_homePosData = function() {
    if ($1d9fcaa0a6035698$var$_practice || !$1d9fcaa0a6035698$var$_notifLastFetch || !$1d9fcaa0a6035698$var$_notifCanPOs) return null;
    const all = $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders ?? [];
    const open = all.filter((p)=>p.status === 'sent').map((p)=>{
        const days = p.expectedDate ? $1d9fcaa0a6035698$var$_daysUntil(p.expectedDate) : null;
        const when = days == null ? 'Sent' : days < 0 ? `Overdue ${-days} ${days === -1 ? 'day' : 'days'}` : days === 0 ? 'Due today' : days === 1 ? 'Due tomorrow' : `Due ${new Date(p.expectedDate + 'T00:00:00').toLocaleDateString([], {
            weekday: 'short',
            month: 'short',
            day: 'numeric'
        })}`;
        const total = p.lines.reduce((s, l)=>s + l.qty * (l.unitCost ?? 0), 0) + (p.shipping ?? 0) + (p.tax ?? 0);
        return {
            id: p.id,
            label: $1d9fcaa0a6035698$var$_poLabel(p.poNumber),
            supplier: p.supplierName,
            lines: p.lines.length,
            total: total,
            when: when,
            overdue: days != null && days < 0,
            sortKey: days ?? 999
        };
    }).sort((a, b)=>a.sortKey - b.sortKey);
    return {
        open: open,
        drafts: all.filter((p)=>p.status === 'draft').length
    };
};
const $1d9fcaa0a6035698$var$_renderHomeCards = function() {
    const now = Date.now();
    const td = $1d9fcaa0a6035698$var$_homeTablesData(now);
    const inv = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.inventoryEnabled === false ? [] : $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems;
    // Practice tutorial stock must never show on the real home screen.
    const lowStock = $1d9fcaa0a6035698$var$_practice ? null : inv.filter((i)=>i.quantity <= 0 || i.lowStockThreshold != null && i.quantity <= i.lowStockThreshold).map((i)=>({
            id: i.id,
            name: i.name,
            quantity: i.quantity,
            unit: i.unit,
            out: i.quantity <= 0
        })).sort((a, b)=>Number(b.out) - Number(a.out) || a.name.localeCompare(b.name));
    (0, $717baed02964aa54$export$2e2bcd8739ae039).renderCards({
        tables: td,
        tz: $1d9fcaa0a6035698$var$_bizTz(),
        now: now,
        onShift: $1d9fcaa0a6035698$var$_lastOnShiftList,
        top: $1d9fcaa0a6035698$var$_homeSnap ? $1d9fcaa0a6035698$var$_homeSnap.top.map((t)=>({
                ...t,
                name: $1d9fcaa0a6035698$var$_markDeletedName(t.name)
            })) : null,
        lowStock: lowStock,
        canInventory: $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_inventory'),
        salesTrend: $1d9fcaa0a6035698$var$_homeSalesTrend(now),
        schedule: $1d9fcaa0a6035698$var$_homeScheduleData(now),
        inbox: $1d9fcaa0a6035698$var$_homeInboxData(),
        pos: $1d9fcaa0a6035698$var$_homePosData()
    });
    (0, $717baed02964aa54$export$2e2bcd8739ae039).renderTiles($1d9fcaa0a6035698$var$_homeTileValues(td, now));
};
const $1d9fcaa0a6035698$var$_saveHomeCards = function(prefs) {
    $1d9fcaa0a6035698$var$_homeCardPrefs = prefs;
    $3aa6878d3c2fc9b3$export$a1544dad697b423d(prefs);
    $1d9fcaa0a6035698$var$_applyHomeCards();
    $1d9fcaa0a6035698$var$_renderHomeTab();
};
const $1d9fcaa0a6035698$var$_homeOffHint = ()=>$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business') ? 'Off, turn it on in Settings' : 'Off, ask the owner to turn it on';
const $1d9fcaa0a6035698$var$_homeCardOptions = function(current) {
    const main = $1d9fcaa0a6035698$var$_homeMainLabel();
    return $3aa6878d3c2fc9b3$export$5f768699f44cc740.map((c)=>{
        const block = $1d9fcaa0a6035698$var$_homeBlock(c.key);
        const elsewhere = $1d9fcaa0a6035698$var$_homeShown.cards.indexOf(c.key);
        return {
            key: c.key,
            group: c.group,
            label: c.key === 'main' ? main.label : c.label,
            desc: block ? block.desc : c.key === 'main' ? main.desc : c.desc,
            selected: c.key === current,
            disabled: !!block,
            tag: block ? block.tag : elsewhere !== -1 && c.key !== current ? elsewhere === 0 ? 'On the left' : 'On the right' : ''
        };
    });
};
const $1d9fcaa0a6035698$var$_homeTileOptions = function(current) {
    const values = $1d9fcaa0a6035698$var$_homeTileValues($1d9fcaa0a6035698$var$_homeTablesData(Date.now()), Date.now());
    const shownText = (id)=>document.getElementById(id)?.textContent?.trim() || null;
    values.sales = {
        value: shownText('totalStr')
    };
    values.txns = {
        value: shownText('basketCountStr')
    };
    values.serving = {
        value: shownText('homeAvgServing')
    };
    return $3aa6878d3c2fc9b3$export$34ddeca23ac38a20.map((t)=>{
        const block = $1d9fcaa0a6035698$var$_homeBlock(t.key);
        return {
            key: t.key,
            group: t.group,
            label: t.label,
            value: block ? null : values[t.key]?.value ?? null,
            desc: block ? block.desc : null,
            selected: t.key === current,
            disabled: !!block,
            tag: block ? block.tag : $1d9fcaa0a6035698$var$_homeShown.tiles.includes(t.key) && t.key !== current ? 'Showing' : ''
        };
    });
};
const $1d9fcaa0a6035698$var$controlSwapHomeCard = function(key, anchor) {
    const slot = $1d9fcaa0a6035698$var$_homeShown.cards.indexOf(key);
    if (slot === -1) return;
    (0, $717baed02964aa54$export$2e2bcd8739ae039).openPicker({
        anchor: anchor,
        kind: 'card',
        title: 'Show in this spot',
        sub: `${slot === 0 ? 'Left' : 'Right'} card on this device`,
        options: $1d9fcaa0a6035698$var$_homeCardOptions(key),
        onPick: (k)=>$1d9fcaa0a6035698$var$_saveHomeCards({
                ...$1d9fcaa0a6035698$var$_homeCardPrefs,
                cards: $3aa6878d3c2fc9b3$export$357523c63a2253b9($1d9fcaa0a6035698$var$_homeShown.cards, slot, k)
            }),
        onSuggested: ()=>$1d9fcaa0a6035698$var$controlHomeCardsSuggested()
    });
};
const $1d9fcaa0a6035698$var$controlSwapHomeTile = function(key, anchor) {
    const slot = $1d9fcaa0a6035698$var$_homeShown.tiles.indexOf(key);
    if (slot === -1) return;
    (0, $717baed02964aa54$export$2e2bcd8739ae039).openPicker({
        anchor: anchor,
        kind: 'tile',
        title: 'Show in this tile',
        sub: `${[
            'First',
            'Middle',
            'Last'
        ][slot]} tile on this device \xb7 numbers are today's`,
        options: $1d9fcaa0a6035698$var$_homeTileOptions(key),
        onPick: (k)=>$1d9fcaa0a6035698$var$_saveHomeCards({
                ...$1d9fcaa0a6035698$var$_homeCardPrefs,
                tiles: $3aa6878d3c2fc9b3$export$357523c63a2253b9($1d9fcaa0a6035698$var$_homeShown.tiles, slot, k)
            }),
        onSuggested: ()=>$1d9fcaa0a6035698$var$controlHomeCardsSuggested()
    });
};
const $1d9fcaa0a6035698$var$controlHomeCardsSuggested = function() {
    $1d9fcaa0a6035698$var$_saveHomeCards($3aa6878d3c2fc9b3$export$eb578a3e3b5009bd($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.placeType));
    $1d9fcaa0a6035698$var$showToast('Home screen set to the suggested cards', 'success');
};
// From Settings > Home screen: slot is 'card0', 'card1', 'tile0', 'tile1' or 'tile2'.
const $1d9fcaa0a6035698$var$controlHomeCardSlot = function(slot, key) {
    const i = Number(slot.slice(-1));
    if (slot.startsWith('card')) $1d9fcaa0a6035698$var$_saveHomeCards({
        ...$1d9fcaa0a6035698$var$_homeCardPrefs,
        cards: $3aa6878d3c2fc9b3$export$357523c63a2253b9($1d9fcaa0a6035698$var$_homeShown.cards, i, key)
    });
    else $1d9fcaa0a6035698$var$_saveHomeCards({
        ...$1d9fcaa0a6035698$var$_homeCardPrefs,
        tiles: $3aa6878d3c2fc9b3$export$357523c63a2253b9($1d9fcaa0a6035698$var$_homeShown.tiles, i, key)
    });
};
const $1d9fcaa0a6035698$var$_canUseTables = ()=>$1e7ab04ca7920cff$export$b325ec6732b039cf('take_orders') || $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business');
const $1d9fcaa0a6035698$var$controlHomeTile = function(key) {
    if ([
        'avgOrder',
        'tips',
        'itemsSold',
        'lastWeek'
    ].includes(key)) {
        if ($1e7ab04ca7920cff$export$b325ec6732b039cf('view_reports')) $1d9fcaa0a6035698$var$controlOpenReports('sales');
        else $1d9fcaa0a6035698$var$showToast("You don't have access to reports.", 'error');
    } else if (key === 'waiting') document.getElementById('openOrdersExpandBtn')?.click();
    else if (key === 'onShift') {
        if ($1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay') || $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_staff')) $1d9fcaa0a6035698$var$controlOpenTimesheets();
        else $1d9fcaa0a6035698$var$showToast("You don't have access to timesheets.", 'error');
    } else if (key === 'expenses') $1d9fcaa0a6035698$var$controlOpenCashflow();
    else if (key === 'lowItems') $1d9fcaa0a6035698$var$controlOpenInventory();
    else if (key === 'requests') {
        const first = ($1d9fcaa0a6035698$var$_homeInboxData() ?? []).find((r)=>r.count);
        if (first) $1d9fcaa0a6035698$var$controlNotifOpenCategory(first.cat);
        else $1d9fcaa0a6035698$var$showToast('Nothing is waiting for you.', 'info');
    } else if (key === 'nextBooking') {
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).showSection('reservations');
        $1d9fcaa0a6035698$var$controlOpenTables();
    } else if (key === 'freeTables' || key === 'openTabs') {
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).showSection('floor');
        $1d9fcaa0a6035698$var$controlOpenTables();
    }
};
const $1d9fcaa0a6035698$var$controlHomeCardAction = async function(act, ds) {
    if (act === 'rerender') return $1d9fcaa0a6035698$var$_renderHomeCards();
    if (act === 'inventory') return $1d9fcaa0a6035698$var$controlOpenInventory();
    if (act === 'reports') {
        if ($1e7ab04ca7920cff$export$b325ec6732b039cf('view_reports')) return $1d9fcaa0a6035698$var$controlOpenReports('sales');
        return $1d9fcaa0a6035698$var$showToast("You don't have access to reports.", 'error');
    }
    if (act === 'schedule') return $1d9fcaa0a6035698$var$controlOpenSchedule();
    if (act === 'inbox') return $1d9fcaa0a6035698$var$controlNotifOpenCategory(ds.cat);
    if (act === 'po') return $1d9fcaa0a6035698$var$controlNotifOpenItem('po', ds.id);
    if (act === 'open-tables') {
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).showSection('floor');
        return $1d9fcaa0a6035698$var$controlOpenTables();
    }
    if (act === 'table') {
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).select(ds.id);
        return $1d9fcaa0a6035698$var$controlOpenTables();
    }
    if (act === 'open-section') {
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).showSection(ds.section);
        return $1d9fcaa0a6035698$var$controlOpenTables();
    }
    if (act === 'open-res') {
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).showSection('reservations');
        return $1d9fcaa0a6035698$var$controlOpenTables();
    }
    if (!$1d9fcaa0a6035698$var$_canUseTables()) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to tables.", 'error');
        return;
    }
    if (act === 'seat-res') await $1d9fcaa0a6035698$var$controlSeatReservation(ds.id);
    else if (act === 'seat-wait') await $1d9fcaa0a6035698$var$controlSeatWaitlist(ds.id, ds.table);
    $1d9fcaa0a6035698$var$_renderHomeCards();
};
// Hide home sales figures from staff without report access. The setting is
// business-level; who it hides FROM is permission-based (view_reports holders
// - incl. the owner - always see their numbers).
const $1d9fcaa0a6035698$var$_applyHomeStatsVisibility = function() {
    const hide = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.hideStatsFromStaff === true && !$1e7ab04ca7920cff$export$b325ec6732b039cf('view_reports');
    document.body.classList.toggle('hide-home-stats', hide);
};
const $1d9fcaa0a6035698$var$controlToggleHideStats = function(value) {
    $1d9fcaa0a6035698$var$_stageSetting('hideStatsFromStaff', value);
    $1d9fcaa0a6035698$var$_applyHomeStatsVisibility();
};
const $1d9fcaa0a6035698$var$controlToggleOrderType = function(value) {
    $1d9fcaa0a6035698$var$_stageSetting('orderTypeEnabled', value);
    $1d9fcaa0a6035698$var$_renderHomeTab();
};
const $1d9fcaa0a6035698$var$controlToggleShowInvoiceNumber = function(value) {
    $1d9fcaa0a6035698$var$_stageSetting('showInvoiceNumber', value);
};
const $1d9fcaa0a6035698$var$controlToggleShowTicketNumber = function(value) {
    $1d9fcaa0a6035698$var$_stageSetting('showTicketNumber', value);
};
const $1d9fcaa0a6035698$var$controlToggleShowPhone = function(value) {
    $1d9fcaa0a6035698$var$_stageSetting('showBusinessPhone', value);
};
// Pro-only (the view disables the fields on the free plan; receipts ignore
// both on the free plan anyway).
const $1d9fcaa0a6035698$var$controlSetReceiptFooter = function(value) {
    if (!$1e7ab04ca7920cff$export$9e608bbc985290d4()) return;
    $1d9fcaa0a6035698$var$_stageSetting('receiptFooter', String(value ?? '').slice(0, 120));
};
const $1d9fcaa0a6035698$var$controlSetReceiptQrUrl = function(value) {
    if (!$1e7ab04ca7920cff$export$9e608bbc985290d4()) return;
    if (value && !(0, $9db03be56d1ffd3b$export$5a9e70c95c4f2bbb)(value)) return;
    $1d9fcaa0a6035698$var$_stageSetting('receiptQrUrl', value || '');
};
// Tips (all plans). The QR image uploads right away for the preview but, like
// the payment QR, is only staged until Save Changes.
const $1d9fcaa0a6035698$var$controlToggleTips = function(value) {
    $1d9fcaa0a6035698$var$_stageSetting('tipsEnabled', value === true);
    $1d9fcaa0a6035698$var$_renderHomeTab();
};
const $1d9fcaa0a6035698$var$controlSetTipPresets = function(presets) {
    $1d9fcaa0a6035698$var$_stageSetting('tipPresets', presets);
};
const $1d9fcaa0a6035698$var$controlUploadTipQR = async function(file) {
    try {
        const url = await $1e7ab04ca7920cff$export$b6f89c1e0645de4e(file);
        $1d9fcaa0a6035698$var$_stageSetting('tipQrUrl', url);
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showTipQRPreview(url);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlRemoveTipQR = function() {
    $1d9fcaa0a6035698$var$_stageSetting('tipQrUrl', null);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showTipQRPreview(null);
};
const $1d9fcaa0a6035698$var$_hasTaxLikeFeeAdjustment = function() {
    return ($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.adjustments || []).some((a)=>a.type === 'fee' && /tax|vat|gst/i.test(a.name || ''));
};
// ── Tax Settings draft (mode + rate + name) ────────────────────────────────
// Same deferred-draft pattern as the Settings modal's POS/KDS toggles
// (CLAUDE.md "Deferred settings draft"): a change applies to state + local
// UI immediately (so the app keeps behaving live) but the Supabase write
// waits for the sticky footer's Save Tax Settings. Automatic Receipt
// Adjustments and the Tax-Exempt picker are NOT part of this draft - they
// keep their own existing save flows (instant per-item / own modal Save).
let $1d9fcaa0a6035698$var$_taxSettingsDraftOriginal = null; // snapshot taken on the first unsaved change
const $1d9fcaa0a6035698$var$_stageTaxSetting = function(key, value) {
    if (!$1d9fcaa0a6035698$var$_taxSettingsDraftOriginal) $1d9fcaa0a6035698$var$_taxSettingsDraftOriginal = $1e7ab04ca7920cff$export$669c05a58e9cc73a();
    $1e7ab04ca7920cff$export$233f02b89678da4f(key, value);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039).showTaxSettingsDirty();
};
// taxMode ('none' | 'exclusive' | 'inclusive') is the source of truth; taxInclusive
// is kept in sync (== taxMode === 'inclusive') so every existing consumer that
// already checks the boolean (receiptView, escpos, cashflowView, orderCheckoutView,
// menuEditView, discountView) keeps working unchanged.
const $1d9fcaa0a6035698$var$controlSetTaxMode = function(mode) {
    $1d9fcaa0a6035698$var$_stageTaxSetting('taxMode', mode);
    $1d9fcaa0a6035698$var$_stageTaxSetting('taxInclusive', mode === 'inclusive');
    // Picking the recommended option fills in the recommended rate, unless the
    // owner already set their own (12 is only the untouched default).
    const rec = $1d9fcaa0a6035698$var$_recommendedTaxMode();
    if (rec?.rate && rec.mode === mode && Number($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxInclusiveRate) === 12 && rec.rate !== 12) {
        $1d9fcaa0a6035698$var$_stageTaxSetting('taxInclusiveRate', rec.rate);
        (0, $c3680931ad48d154$export$2e2bcd8739ae039).setTaxRate(rec.rate);
    }
    // Double-count / contradiction guards - both just warn, never block.
    if (mode === 'inclusive' && $1d9fcaa0a6035698$var$_hasTaxLikeFeeAdjustment()) $1d9fcaa0a6035698$var$showToast('Heads up: you also have a tax added on top below. Remove it so tax is not counted twice.', 'error');
    else if (mode === 'none' && $1d9fcaa0a6035698$var$_hasTaxLikeFeeAdjustment()) $1d9fcaa0a6035698$var$showToast("Heads up: you have a tax-like fee added below, but Tax Settings says you don't charge tax. Remove it or switch modes so it isn't applied by mistake.", 'error');
};
const $1d9fcaa0a6035698$var$controlSetTaxRate = function(value) {
    // Backstop for the view's change-event validation: never stage a nonsense rate.
    const val = Number(value);
    if (!Number.isFinite(val) || val <= 0 || val > 50) return;
    $1d9fcaa0a6035698$var$_stageTaxSetting('taxInclusiveRate', Math.round(val * 100) / 100);
};
const $1d9fcaa0a6035698$var$controlSetTaxExemptLabel = function(value) {
    $1d9fcaa0a6035698$var$_stageTaxSetting('taxExemptLabel', value);
};
const $1d9fcaa0a6035698$var$controlSetTaxLabel = function(value) {
    $1d9fcaa0a6035698$var$_stageTaxSetting('taxInclusiveLabel', value);
};
const $1d9fcaa0a6035698$var$controlSaveTaxSettingsDraft = async function() {
    await $1e7ab04ca7920cff$export$15e1db8a90fc192d();
    $1d9fcaa0a6035698$var$_taxSettingsDraftOriginal = null;
    (0, $c3680931ad48d154$export$2e2bcd8739ae039).hideTaxSettingsDirty();
    $1d9fcaa0a6035698$var$showToast('Tax settings saved', 'success');
};
const $1d9fcaa0a6035698$var$controlDiscardTaxSettingsDraft = function() {
    if ($1d9fcaa0a6035698$var$_taxSettingsDraftOriginal) $1e7ab04ca7920cff$export$cc098d721f95fe39($1d9fcaa0a6035698$var$_taxSettingsDraftOriginal);
    $1d9fcaa0a6035698$var$_taxSettingsDraftOriginal = null;
    (0, $c3680931ad48d154$export$2e2bcd8739ae039).hideTaxSettingsDirty();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039).syncTaxMode($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxMode, $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxInclusiveRate, $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxInclusiveLabel, $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxExemptLabel, $1d9fcaa0a6035698$var$_recommendedTaxMode());
};
// ── Receipt printer (Settings > POS > Printer) ────────────────────────────────
// Device-level: print method (system dialog vs Bluetooth), paper size and
// receipt position, all in printSettings.js. The UI asks "What kind of
// printer?" instead of exposing method + paper directly (owners didn't know a
// Bluetooth printer paired in Windows is NOT the "Bluetooth" method):
//   Receipt printer         = system dialog + 58/80mm roll
//   Bluetooth, connect here = Web Bluetooth + 58/80mm roll
//   Regular printer         = system dialog + 'full' page
// The card marks a suggested kind for this device but the owner can always
// pick another. Bluetooth still shows no live "connected" status (Web
// Bluetooth's reporting proved unreliable - see SYSTEM.md); Pair / Disconnect /
// Test just act and report via toast.
let $1d9fcaa0a6035698$var$_pendingPaperWidth = null;
let $1d9fcaa0a6035698$var$_pendingPrintMethod = null;
let $1d9fcaa0a6035698$var$_pendingPosition = null;
const $1d9fcaa0a6035698$var$_printerDraft = async function() {
    const suggested = await $e289654e8a722fd2$export$be42772b78d4d1ee();
    return {
        method: $1d9fcaa0a6035698$var$_pendingPrintMethod ?? $e289654e8a722fd2$export$8793fab959da70d1() ?? suggested,
        suggested: suggested,
        paper: $1d9fcaa0a6035698$var$_pendingPaperWidth ?? $e289654e8a722fd2$export$f12273f2d5c5a16b(),
        position: $1d9fcaa0a6035698$var$_pendingPosition ?? $e289654e8a722fd2$export$1690e12b840569b9()
    };
};
const $1d9fcaa0a6035698$var$_syncPrinterUI = async function() {
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).syncPrinter({
        ...await $1d9fcaa0a6035698$var$_printerDraft(),
        btSupported: (0, $fbad918341d4cd38$export$2e2bcd8739ae039).isSupported()
    });
};
const $1d9fcaa0a6035698$var$controlStagePrintKind = async function(kind) {
    const { paper: paper } = await $1d9fcaa0a6035698$var$_printerDraft();
    const roll = paper === 'full' ? 80 : paper;
    $1d9fcaa0a6035698$var$_pendingPrintMethod = kind === 'bluetooth' ? 'bluetooth' : 'system';
    $1d9fcaa0a6035698$var$_pendingPaperWidth = kind === 'sheet' ? 'full' : roll;
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showSettingsDirty();
    $1d9fcaa0a6035698$var$_syncPrinterUI();
};
const $1d9fcaa0a6035698$var$controlStagePrintPosition = function(value) {
    $1d9fcaa0a6035698$var$_pendingPosition = $e289654e8a722fd2$export$24d4c6cf79ebd2a8(value);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showSettingsDirty();
    $1d9fcaa0a6035698$var$_syncPrinterUI();
};
// Paper size goes through the shared footer's Save/Discard like everything
// else in Settings - the click only stages the value; the write happens in
// controlSaveSettingsDraft.
const $1d9fcaa0a6035698$var$controlStagePaperWidth = function(value) {
    $1d9fcaa0a6035698$var$_pendingPaperWidth = $e289654e8a722fd2$export$ec79c309e9a44c11(value);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showSettingsDirty();
    $1d9fcaa0a6035698$var$_syncPrinterUI();
};
// Opens the browser's Bluetooth device chooser - must run straight from the
// click (user gesture), so nothing is awaited before connect().
const $1d9fcaa0a6035698$var$controlPairBtPrinter = async function() {
    try {
        const name = await (0, $fbad918341d4cd38$export$2e2bcd8739ae039).connect();
        $1d9fcaa0a6035698$var$showToast(`Paired with ${name}.`, 'success');
    } catch (err) {
        if (err?.name === 'NotFoundError') return; // chooser cancelled
        $1d9fcaa0a6035698$var$showToast('Could not pair: ' + (err.message ?? err), 'error');
    }
};
const $1d9fcaa0a6035698$var$controlDisconnectBtPrinter = async function() {
    await (0, $fbad918341d4cd38$export$2e2bcd8739ae039).disconnect();
    $1d9fcaa0a6035698$var$showToast('Bluetooth printer disconnected.', 'success');
};
// Test print goes through the CURRENTLY SELECTED method and paper, staged or
// not - otherwise it would silently test the old saved choice until Save
// Changes is clicked, which looked like "the setting does nothing".
const $1d9fcaa0a6035698$var$controlTestPrint = async function() {
    const sample = {
        date: new Date().toISOString(),
        storeName: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessName ?? $1e7ab04ca7920cff$export$ca000e230c0caa3e.username ?? 'Pointbunny',
        items: [
            {
                itemName: 'Test Item',
                quantity: 1,
                totalPrice: 1,
                selectedVariants: []
            },
            {
                itemName: 'Another Test Item',
                quantity: 2,
                totalPrice: 2,
                selectedVariants: []
            }
        ],
        subtotal: 3,
        totalPrice: 3,
        paymentMethod: 'cash',
        customerPayment: 5,
        customerChange: 2,
        adjustments: [],
        showInvoiceNumber: false,
        showTicketNumber: false,
        showCashier: false,
        businessPhone: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessPhone ?? null,
        showBusinessPhone: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showBusinessPhone !== false,
        receiptFooter: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.receiptFooter || '',
        receiptQrUrl: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.receiptQrUrl || '',
        addressStreet: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressStreet ?? null,
        addressCity: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCity ?? null,
        addressProvince: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressProvince ?? null,
        addressZip: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressZip ?? null,
        addressCountry: $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCountry ?? null,
        isFreePlan: !$1e7ab04ca7920cff$export$9e608bbc985290d4()
    };
    const paper = $1d9fcaa0a6035698$var$_pendingPaperWidth ?? $e289654e8a722fd2$export$f12273f2d5c5a16b();
    const method = $e289654e8a722fd2$export$bc2db93af29ea4e2($1d9fcaa0a6035698$var$_pendingPrintMethod ?? $e289654e8a722fd2$export$8793fab959da70d1());
    if (method === 'bluetooth') {
        try {
            await (0, $fbad918341d4cd38$export$2e2bcd8739ae039).print((0, $9b70c844273b1ba0$export$3a40b3618ea1d38a)(sample, {
                width: paper === 58 ? 58 : 80
            }));
            $1d9fcaa0a6035698$var$showToast('Test sent to printer.', 'success');
        } catch (err) {
            $1d9fcaa0a6035698$var$showToast('Test print failed: ' + (err.message ?? err) + ' Use Pair printer if this is a new printer.', 'error');
        }
        return;
    }
    await (0, $9d7a2f48e7d0ba3e$export$2e2bcd8739ae039).print(sample, {
        width: paper,
        position: $1d9fcaa0a6035698$var$_pendingPosition ?? $e289654e8a722fd2$export$1690e12b840569b9()
    });
};
const $1d9fcaa0a6035698$var$_refreshCategoryDropdowns = function() {
    (0, $0540865b060d0b60$export$2e2bcd8739ae039)._mapMenuCategoriesMarkUp($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories);
    if (document.querySelector(".edit-field-select")) (0, $24a84838d36102df$export$2e2bcd8739ae039)._mapMenuCategoriesMarkUp($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories, "");
};
const $1d9fcaa0a6035698$var$controlAddCategoryFromSettings = async function(name) {
    try {
        await $1e7ab04ca7920cff$export$33005c1ca00aaa85(name);
        // Only update the chips strip — no full re-render, no flash
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._updateChips($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories, name);
        $1d9fcaa0a6035698$var$_refreshCategoryDropdowns();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlDeleteCategory = async function(name) {
    const itemsInCategory = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.filter((item)=>item.category === name);
    if (itemsInCategory.length > 0 && !confirm(`"${name}" has ${itemsInCategory.length} menu item(s). Delete it anyway?`)) return;
    try {
        await $1e7ab04ca7920cff$export$c0a90379dccf4f2f(name);
        // Soft in-place refresh: chips + item groups update with a content slide
        // instead of the whole modal replaying its entrance animation.
        (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039).refresh($1e7ab04ca7920cff$export$ca000e230c0caa3e);
        $1d9fcaa0a6035698$var$_refreshCategoryDropdowns();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$_renderAllAdjustments = function() {
    (0, $c3680931ad48d154$export$2e2bcd8739ae039).renderAdjustments($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.adjustments);
};
const $1d9fcaa0a6035698$var$controlSaveAdjustment = async function(data) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_adjustments')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to manage adjustments.", 'error');
        return;
    }
    try {
        if (data.id) await $1e7ab04ca7920cff$export$df7cef76f1f98a4d(data.id, data);
        else await $1e7ab04ca7920cff$export$1cbf40eefc54bd16(data);
        $1d9fcaa0a6035698$var$_renderAllAdjustments();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
// Edit triggered from the Receipt Adjustments panel
const $1d9fcaa0a6035698$var$controlEditAdjFromPanel = function(id) {
    const adj = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.adjustments.find((a)=>a.id === id);
    if (!adj) return;
    (0, $c3680931ad48d154$export$2e2bcd8739ae039).showAdjustmentForm(adj);
};
const $1d9fcaa0a6035698$var$controlDeleteAdjustment = async function(id) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_adjustments')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to manage adjustments.", 'error');
        return;
    }
    try {
        await $1e7ab04ca7920cff$export$d38a9df9a4968bac(id);
        $1d9fcaa0a6035698$var$_renderAllAdjustments();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlToggleAdjustment = async function(id) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_adjustments')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to manage adjustments.", 'error');
        return;
    }
    try {
        await $1e7ab04ca7920cff$export$4b286ed06cf9768(id);
        $1d9fcaa0a6035698$var$_renderAllAdjustments();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlShowRemoved = function(value) {
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showRemovedAdjustments = value;
};
// ── Per-receipt adjustment controls ───────────────────────────────────────────
// Context the checkout view needs to decide which cart lines show a "Redeem
// free" pill and in what state - rebuilt fresh on every refresh since
// OrderCheckOutView._data is only re-set on a full render(), not on the
// in-place refreshes used throughout checkout.
const $1d9fcaa0a6035698$var$_loyaltyCartCtx = function() {
    const rewardsByItemId = new Map($1e7ab04ca7920cff$export$ca000e230c0caa3e.loyaltyRewards.map((r)=>[
            r.itemId,
            r
        ]));
    const activeRewardAdj = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.filter((a)=>!a.removed && a.source === 'loyalty_reward');
    const redeemedLineIds = new Set(activeRewardAdj.map((a)=>a.cartItemLineId));
    // rewardId -> cartItemLineId for the Redeem modal's Remove button (the
    // modal lists the whole catalog by reward, not by an existing cart line).
    const redemptionByRewardId = new Map(activeRewardAdj.map((a)=>[
            a.rewardId,
            a.cartItemLineId
        ]));
    return {
        rewardsByItemId: rewardsByItemId,
        redeemedLineIds: redeemedLineIds,
        redemptionByRewardId: redemptionByRewardId,
        customer: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyCustomer,
        canRedeem: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.loyaltyEnabled && $1e7ab04ca7920cff$export$b325ec6732b039cf('use_loyalty'),
        reservedPoints: $1e7ab04ca7920cff$export$a49edc57bdd065a5()
    };
};
// Active free-item reward redemptions, for the checkout section's applied
// summary. `name` reuses the friendly string model.js already stamped on the
// adjustment ("Free Espresso (Reward)") so there's no second source of truth.
const $1d9fcaa0a6035698$var$_loyaltyRewardRedemptions = function() {
    return $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.filter((a)=>!a.removed && a.source === 'loyalty_reward').map((a)=>({
            cartItemLineId: a.cartItemLineId,
            name: a.name
        }));
};
const $1d9fcaa0a6035698$var$_refreshCheckoutAdj = function() {
    const adjResult = $1e7ab04ca7920cff$export$1e7528f2cdbb9715((0, $6724f76d0010cf48$export$2e2bcd8739ae039)._subtotal, $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments, $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._refreshAdjustments((0, $6724f76d0010cf48$export$2e2bcd8739ae039)._subtotal, $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments, adjResult, $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.showRemovedAdjustments, $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentPromoCode, {
        customer: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyCustomer,
        redemption: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyRedemption,
        rewardRedemptions: $1d9fcaa0a6035698$var$_loyaltyRewardRedemptions()
    });
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._refreshCartItems($1e7ab04ca7920cff$export$ca000e230c0caa3e.cart, $1d9fcaa0a6035698$var$_loyaltyCartCtx());
    // Keep the customer display's scan-to-pay amount in sync when the total changes
    // while QR is the active method (otherwise it shows the pre-adjustment total).
    if ((0, $6724f76d0010cf48$export$2e2bcd8739ae039)._paymentMethod === 'qr') $1d9fcaa0a6035698$var$controlSetPaymentMethod('qr');
    // A tip screen that's up shows the new total's amounts.
    $1d9fcaa0a6035698$var$_sendTipRequest();
};
const $1d9fcaa0a6035698$var$_canAdjustReceipt = ()=>$1e7ab04ca7920cff$export$b325ec6732b039cf('apply_receipt_adjustment');
const $1d9fcaa0a6035698$var$_denyReceiptAdj = ()=>$1d9fcaa0a6035698$var$showToast("You don't have access to adjust receipts.", 'error');
// Name of the manager/admin who authorized the current one-off adjustment via
// override (null when the cashier did it themselves). Consumed on save.
let $1d9fcaa0a6035698$var$_receiptAdjApprover = null;
// Reusable "manager override" prompt. Builds its own overlay (so it works on top of
// any modal), verifies the entered account holds `requiredCap` (or is the owner),
// and calls onApproved(approverName). Mirrors the void override.
const $1d9fcaa0a6035698$var$_promptManagerOverride = function({ requiredCap: requiredCap, onApproved: onApproved }) {
    const modal = document.createElement('div');
    modal.className = 'cashflow-override-overlay';
    modal.style.zIndex = '100000';
    modal.innerHTML = `
    <div class="cashflow-override-card">
      <h3 class="cashflow-override-title">Manager Override Required</h3>
      <p class="cashflow-override-desc">Enter a manager or admin account to authorize this action.</p>
      <form autocomplete="off">
        <div class="cashflow-override-field">
          <label>Email</label>
          <input type="email" data-ov="email" placeholder="manager@email.com" required />
        </div>
        <div class="cashflow-override-field">
          <label>Password</label>
          <input type="password" data-ov="password" placeholder="\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}" required />
        </div>
        <div class="cashflow-override-field hidden" data-ov="mfa-field">
          <label>Authenticator code</label>
          <input type="text" data-ov="mfa" inputmode="numeric" maxlength="6" placeholder="000000" autocomplete="one-time-code" />
        </div>
        <p class="cashflow-override-error hidden" data-ov="error"></p>
        <div class="cashflow-override-actions">
          <button type="button" class="btn" data-ov="cancel">Cancel</button>
          <button type="submit" class="btn primary" data-ov="submit">Authorize</button>
        </div>
      </form>
    </div>`;
    document.body.appendChild(modal);
    const close = ()=>modal.remove();
    const errEl = modal.querySelector('[data-ov="error"]');
    const submitBtn = modal.querySelector('[data-ov="submit"]');
    modal.querySelector('[data-ov="cancel"]').addEventListener('click', close);
    modal.addEventListener('click', (e)=>{
        if (e.target === modal) close();
    });
    modal.querySelector('[data-ov="email"]').focus();
    modal.querySelector('form').addEventListener('submit', async (e)=>{
        e.preventDefault();
        const email = modal.querySelector('[data-ov="email"]').value.trim();
        const password = modal.querySelector('[data-ov="password"]').value;
        const mfaCode = modal.querySelector('[data-ov="mfa"]').value.trim() || undefined;
        errEl.classList.add('hidden');
        submitBtn.disabled = true;
        submitBtn.textContent = "Verifying\u2026";
        try {
            // Project-wide CAPTCHA means this re-auth needs a token too (managed widget,
            // mostly invisible). Fetched per attempt - tokens are single-use.
            const captchaToken = await (0, $3kKUy.getTokenInteractive)();
            const approver = await $1e7ab04ca7920cff$export$b1d9775b76ee4d04(email, password, requiredCap, captchaToken, mfaCode);
            close();
            onApproved(approver);
        } catch (err) {
            if (err.code === 'MFA_REQUIRED') {
                modal.querySelector('[data-ov="mfa-field"]').classList.remove('hidden');
                modal.querySelector('[data-ov="mfa"]').focus();
            }
            errEl.textContent = err.message ?? 'Authorization failed.';
            errEl.classList.remove('hidden');
            submitBtn.disabled = false;
            submitBtn.textContent = 'Authorize';
        }
    });
};
const $1d9fcaa0a6035698$var$controlReceiptEdit = function(id) {
    if (!$1d9fcaa0a6035698$var$_canAdjustReceipt()) return $1d9fcaa0a6035698$var$_denyReceiptAdj();
    const adj = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments.find((a)=>a.id === id);
    if (!adj) return;
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._showReceiptEditForm(adj);
};
const $1d9fcaa0a6035698$var$controlSaveReceiptOverride = function({ id: id, value: value }) {
    if (!$1d9fcaa0a6035698$var$_canAdjustReceipt()) return $1d9fcaa0a6035698$var$_denyReceiptAdj();
    $1e7ab04ca7920cff$export$4f757b03a3544c72(id, value);
    $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
};
const $1d9fcaa0a6035698$var$controlRemoveReceiptAdj = function(id) {
    if (!$1d9fcaa0a6035698$var$_canAdjustReceipt()) return $1d9fcaa0a6035698$var$_denyReceiptAdj();
    $1e7ab04ca7920cff$export$f2cecf21ffa2f3f3(id);
    $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
};
const $1d9fcaa0a6035698$var$controlShowReceiptAddManualForm = function() {
    if ($1d9fcaa0a6035698$var$_canAdjustReceipt()) {
        $1d9fcaa0a6035698$var$_receiptAdjApprover = null;
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._showReceiptAddManualForm();
        return;
    }
    // Cashier lacks the capability - require a manager/admin to authorize. The
    // approver (who must hold apply_receipt_adjustment) is recorded on the adjustment.
    $1d9fcaa0a6035698$var$_promptManagerOverride({
        requiredCap: 'apply_receipt_adjustment',
        onApproved: (approver)=>{
            $1d9fcaa0a6035698$var$_receiptAdjApprover = approver;
            (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._showReceiptAddManualForm();
        }
    });
};
const $1d9fcaa0a6035698$var$controlSaveManualReceiptAdj = function(data) {
    if (!$1d9fcaa0a6035698$var$_canAdjustReceipt() && !$1d9fcaa0a6035698$var$_receiptAdjApprover) return $1d9fcaa0a6035698$var$_denyReceiptAdj();
    $1e7ab04ca7920cff$export$907cf8608154bbcb({
        ...data,
        approvedBy: $1d9fcaa0a6035698$var$_receiptAdjApprover
    });
    if ($1d9fcaa0a6035698$var$_receiptAdjApprover) $1d9fcaa0a6035698$var$showToast(`One-off adjustment approved by ${$1d9fcaa0a6035698$var$_receiptAdjApprover}.`, 'success');
    $1d9fcaa0a6035698$var$_receiptAdjApprover = null;
    $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
};
// ── Cart item deletion ────────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$controlGoBackToOrder = function() {
    $1d9fcaa0a6035698$var$_hideCFDQr(); // leaving checkout - don't leave the QR up on the customer display
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).closeRedeemModal(); // top-level modal, outside .modal-parent - doesn't auto-clear
    // Paying a tab: Back returns to the table (the items live on the tab).
    if ($1d9fcaa0a6035698$var$_tabPay) {
        const tableId = $1d9fcaa0a6035698$var$_tabPay.tableId;
        $1d9fcaa0a6035698$var$clearCart();
        $1d9fcaa0a6035698$var$_broadcastCart();
        (0, $472fec5536166250$export$2e2bcd8739ae039).closeNow();
        $1d9fcaa0a6035698$var$_backToTables(tableId);
        return;
    }
    (0, $472fec5536166250$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$modelState);
    // Backward step: the order screen slides in from the left
    document.querySelector('.modal-parent .pos-screen')?.classList.add('pos-screen--slide-back');
};
const $1d9fcaa0a6035698$var$controlDeleteCartItemInOrder = async function(index) {
    // Slide the row out, then patch only the cart column (no full-screen re-render).
    await (0, $472fec5536166250$export$2e2bcd8739ae039).animateCartRowOut(index);
    $1e7ab04ca7920cff$export$bda304d41bed1943(index);
    $1d9fcaa0a6035698$var$_broadcastCart();
    if (!(0, $472fec5536166250$export$2e2bcd8739ae039).updateCart()) (0, $472fec5536166250$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$modelState);
};
const $1d9fcaa0a6035698$var$controlDeleteCartItemInCheckout = function(index) {
    if ($1d9fcaa0a6035698$var$_tabPay) {
        $1d9fcaa0a6035698$var$showToast('To change the bill, edit the tab in Tables.', 'info');
        return;
    }
    // A deleted line can't keep a dangling free-item redemption - strip it
    // before the line itself is gone.
    const removedLineId = $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart[index]?.lineId;
    $1e7ab04ca7920cff$export$bda304d41bed1943(index);
    if (removedLineId) $1e7ab04ca7920cff$export$f46e9f68198f57f(removedLineId);
    $1d9fcaa0a6035698$var$_broadcastCart();
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.length === 0) {
        // Last item removed at checkout: slide back to the (now empty) order screen
        (0, $472fec5536166250$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$modelState);
        document.querySelector('.modal-parent .pos-screen')?.classList.add('pos-screen--slide-back');
        return;
    }
    // Route through _refreshCheckoutAdj (rather than a second hand-rolled copy
    // of the same recompute) so promoCode/loyalty context and cart-line reward
    // pills stay in sync - a prior version of this function skipped both.
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._subtotal = $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.reduce((acc, item)=>acc + item.totalPrice, 0);
    $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
};
//listens to modal close button
const $1d9fcaa0a6035698$var$controlNewOrderModals = async function() {
    (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._closeItemModal();
    (0, $472fec5536166250$export$2e2bcd8739ae039)._addHandlerCloseModal($1d9fcaa0a6035698$var$controlCloseOrderModal);
};
const $1d9fcaa0a6035698$var$_animateSalesTotal = function(el, fromVal, toVal, onDone) {
    const fmt = (n)=>(0, $coRoT.formatMoney)(n);
    const card = el.closest(".stat-card");
    if (card) {
        card.classList.remove("stat-card--updating");
        card.offsetWidth;
        card.classList.add("stat-card--updating");
        card.addEventListener("animationend", ()=>card.classList.remove("stat-card--updating"), {
            once: true
        });
    }
    // Hidden tab: settle instantly (see _animateNumber).
    if (document.hidden) {
        el.textContent = fmt(toVal);
        if (onDone) onDone();
        return;
    }
    const duration = 700;
    const start = performance.now();
    const easeOut = (t)=>1 - Math.pow(1 - t, 3);
    const tick = (now)=>{
        const progress = Math.min((now - start) / duration, 1);
        el.textContent = fmt(fromVal + (toVal - fromVal) * easeOut(progress));
        if (progress < 1) requestAnimationFrame(tick);
        else if (onDone) onDone();
    };
    requestAnimationFrame(tick);
};
// Generic count-up for the integer (Transactions) and duration (Avg Serving)
// dash numbers, mirroring _animateSalesTotal. `fmt` formats each interpolated
// value; `onDone` fires once when the number settles at toVal.
const $1d9fcaa0a6035698$var$_animateNumber = function(el, fromVal, toVal, fmt, onDone) {
    // Hidden tab: browsers pause requestAnimationFrame, which would freeze the number
    // mid-count (and stall the dash queue) until the tab is shown - settle instantly.
    if (document.hidden) {
        el.textContent = fmt(toVal);
        if (onDone) onDone();
        return;
    }
    const duration = 700;
    const start = performance.now();
    const easeOut = (t)=>1 - Math.pow(1 - t, 3);
    const tick = (now)=>{
        const progress = Math.min((now - start) / duration, 1);
        el.textContent = fmt(fromVal + (toVal - fromVal) * easeOut(progress));
        if (progress < 1) requestAnimationFrame(tick);
        else if (onDone) onDone();
    };
    requestAnimationFrame(tick);
};
// ── Dashboard card reveals: serialized count-up + odometer roll ──────────────
// The three home dash cards (Sales -> Transactions -> Avg Serving) reveal ONE AT
// A TIME so only a single thing ever moves: each card counts its number up, then
// rolls its "vs yesterday" % into place like a mechanical counter, and only then
// does the next card start. _enqueueDashAnim chains the steps; each resolves when
// its card has fully animated.
let $1d9fcaa0a6035698$var$_dashAnimChain = Promise.resolve();
const $1d9fcaa0a6035698$var$_enqueueDashAnim = (step)=>{
    const run = $1d9fcaa0a6035698$var$_dashAnimChain.then(step, step);
    $1d9fcaa0a6035698$var$_dashAnimChain = run.then(()=>{}, ()=>{});
    return run;
};
// On a new sale the dashboard sits behind the success overlay - hold each card's
// animation until that overlay is gone so the count-up/roll is actually seen.
const $1d9fcaa0a6035698$var$_waitForSuccessOverlayGone = ()=>new Promise((resolve)=>{
        if (!document.querySelector('.success-overlay')) {
            resolve();
            return;
        }
        const obs = new MutationObserver(()=>{
            if (!document.querySelector('.success-overlay')) {
                obs.disconnect();
                resolve();
            }
        });
        obs.observe(document.body, {
            childList: true,
            subtree: true
        });
        setTimeout(()=>{
            obs.disconnect();
            resolve();
        }, 10000);
    });
// Sets a trend badge's final markup but holds it hidden (opacity 0) so it does
// not flash in place while the number above it is still counting up. Empty
// badges (no baseline) render nothing.
const $1d9fcaa0a6035698$var$_armBadge = (el, badge)=>{
    if (!el) return;
    if (!badge || badge.empty) {
        if (badge?.className) el.className = badge.className;
        el.innerHTML = '';
        el.classList.remove('svs--pending');
        return;
    }
    el.className = badge.className;
    el.innerHTML = badge.html;
    el.classList.add('svs--pending');
};
// Reveals an armed badge by rolling each of its digits up into place (odometer).
// Non-digit characters (arrow, %, "m"/"s", "$", spaces) stay put. Resolves when
// the roll finishes; honors prefers-reduced-motion by just showing the value.
const $1d9fcaa0a6035698$var$_DIGITS = '0123456789';
const $1d9fcaa0a6035698$var$_rollBadgeIn = (el)=>new Promise((resolve)=>{
        if (!el) {
            resolve();
            return;
        }
        el.classList.remove('svs--pending');
        if (!el.innerHTML.trim()) {
            resolve();
            return;
        }
        if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
            resolve();
            return;
        }
        const reels = [];
        const textNodes = [];
        const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
        while(walker.nextNode())textNodes.push(walker.currentNode);
        for (const node of textNodes){
            if (!/\d/.test(node.nodeValue)) continue;
            const frag = document.createDocumentFragment();
            for (const ch of node.nodeValue)if (ch >= '0' && ch <= '9') {
                const reel = document.createElement('span');
                reel.className = 'odo-reel';
                const col = document.createElement('span');
                col.className = 'odo-col';
                for (const d of $1d9fcaa0a6035698$var$_DIGITS){
                    const dg = document.createElement('span');
                    dg.className = 'odo-d';
                    dg.textContent = d;
                    col.appendChild(dg);
                }
                reel.appendChild(col);
                frag.appendChild(reel);
                reels.push({
                    col: col,
                    target: Number(ch)
                });
            } else frag.appendChild(document.createTextNode(ch));
            node.parentNode.replaceChild(frag, node);
        }
        if (reels.length === 0) {
            resolve();
            return;
        }
        el.offsetWidth; // reflow so reels paint at digit 0 before rolling
        const stagger = 55;
        reels.forEach(({ col: col, target: target }, i)=>{
            col.style.transitionDelay = `${i * stagger}ms`;
            col.style.transform = `translateY(-${target}em)`;
        });
        setTimeout(resolve, (reels.length - 1) * stagger + 600);
    });
const $1d9fcaa0a6035698$var$_countUpNumber = (el, fromVal, toVal, fmt)=>new Promise((resolve)=>{
        if (!el || fromVal === toVal) {
            if (el) el.textContent = fmt(toVal);
            resolve();
            return;
        }
        $1d9fcaa0a6035698$var$_animateNumber(el, fromVal, toVal, fmt, resolve);
    });
const $1d9fcaa0a6035698$var$_countUpMoney = (el, fromVal, toVal)=>new Promise((resolve)=>{
        const fmt = (n)=>(0, $coRoT.formatMoney)(n);
        if (!el || fromVal === toVal) {
            if (el) el.textContent = fmt(toVal);
            resolve();
            return;
        }
        $1d9fcaa0a6035698$var$_animateSalesTotal(el, fromVal, toVal, resolve);
    });
let $1d9fcaa0a6035698$var$_lastServingMins = null;
const $1d9fcaa0a6035698$var$_cashierDisplayName = (c)=>{
    if (!c) return null;
    return `${c.firstName ?? ''} ${c.lastName ?? ''}`.trim() || null;
};
// Top bar profile button: the SIGNED-IN account (currentStaff), not the
// switchable cashier - that one is shown on the home card (#shiftStr).
const $1d9fcaa0a6035698$var$_updateNavProfile = function() {
    const staff = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff;
    const name = $1d9fcaa0a6035698$var$_cashierDisplayName(staff) || $1e7ab04ca7920cff$export$ca000e230c0caa3e.username || 'Account';
    const initials = name.split(/s+/).map((w)=>w[0]).filter(Boolean).slice(0, 2).join('').toUpperCase() || '?';
    const role = $1e7ab04ca7920cff$export$ca000e230c0caa3e.role || '';
    const set = (id, v)=>{
        const n = document.getElementById(id);
        if (n) n.textContent = v;
    };
    set('navProfileName', name);
    set('navProfileRole', role);
    set('navProfileAvatar', initials);
};
const $1d9fcaa0a6035698$var$_updateCashierDisplay = function() {
    $1d9fcaa0a6035698$var$_updateNavProfile();
    const el = document.getElementById('shiftStr');
    if (!el) return;
    const name = $1d9fcaa0a6035698$var$_cashierDisplayName($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier) || $1e7ab04ca7920cff$export$ca000e230c0caa3e.username || "\u2014";
    el.textContent = name.split(' ')[0];
    $1d9fcaa0a6035698$var$_updateCashierShiftStatus();
};
const $1d9fcaa0a6035698$var$controlSwitchCashier = async function() {
    const existing = document.getElementById('cashierPickerOverlay');
    if (existing) {
        existing.remove();
        return;
    }
    // Open the modal IMMEDIATELY with a spinner - the staff + on-shift fetches
    // used to run before anything appeared, which read as a dead button for a
    // few seconds on slow connections.
    const el = document.createElement('div');
    el.id = 'cashierPickerOverlay';
    el.className = 'cashier-picker-overlay';
    const card = document.createElement('div');
    card.className = 'cashier-picker-card';
    card.innerHTML = `
    <div class="cashier-picker-header">
      <div>
        <h3 class="cashier-picker-title">Switch Cashier</h3>
        <p class="cashier-picker-subtitle">Who's at the register right now?</p>
      </div>
      <button class="modal-close-btn" id="cashierPickerCloseBtn" type="button">&times;</button>
    </div>
    <div class="cashier-picker-loading" role="status" aria-label="Loading staff"><span class="cashier-picker-spinner"></span></div>
  `;
    el.appendChild(card);
    document.body.appendChild(el);
    el.addEventListener('click', (e)=>{
        if (e.target === el) el.remove();
    });
    card.querySelector('#cashierPickerCloseBtn')?.addEventListener('click', ()=>el.remove());
    // Everyone active is LISTED, but only staff who are currently clocked in can be
    // switched to (plus the owner, who runs the POS without clocking in - prevents a
    // no-cashier lockout). Off-shift staff are greyed out with a "Not clocked in"
    // badge. If the on-shift lookup fails (e.g. offline), treat everyone as on shift
    // rather than block. Fetches run in PARALLEL (they used to be sequential).
    let onShiftIds = null;
    await Promise.all([
        $1e7ab04ca7920cff$export$34ce29dd271bbc01().catch(()=>{}),
        $1e7ab04ca7920cff$export$da55ffa46e74c271().then((list)=>{
            onShiftIds = new Set(list.map((s)=>s.staffId));
        }).catch(()=>{})
    ]);
    if (!document.body.contains(el)) return; // closed while loading
    const isOffShift = (s)=>onShiftIds !== null && !s.isOwner && !onShiftIds.has(s.id);
    const activeStaff = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.filter((s)=>s.isActive).sort((a, b)=>isOffShift(a) - isOffShift(b));
    const AVATAR_COLORS = [
        '#22c55e',
        '#3b82f6',
        '#f59e0b',
        '#ec4899',
        '#8b5cf6',
        '#06b6d4'
    ];
    const staffMeta = (s, i)=>{
        const fullName = $1d9fcaa0a6035698$var$_cashierDisplayName(s);
        const displayName = fullName || (s.email ? s.email.split('@')[0] : '?');
        const initials = fullName ? fullName.split(' ').map((w)=>w[0]).slice(0, 2).join('').toUpperCase() : displayName.slice(0, 2).toUpperCase();
        return {
            displayName: displayName,
            initials: initials,
            color: AVATAR_COLORS[i % AVATAR_COLORS.length]
        };
    };
    const renderStaffList = ()=>{
        card.innerHTML = `
      <div class="cashier-picker-header">
        <div>
          <h3 class="cashier-picker-title">Switch Cashier</h3>
          <p class="cashier-picker-subtitle">Who's at the register right now?</p>
        </div>
        <button class="modal-close-btn" id="cashierPickerCloseBtn" type="button">&times;</button>
      </div>
      <ul class="cashier-picker-list">
        ${activeStaff.length ? activeStaff.map((s, i)=>{
            const { displayName: displayName, initials: initials, color: color } = staffMeta(s, i);
            const isActive = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier?.id === s.id;
            const offShift = isOffShift(s);
            return `
            <li class="cashier-picker-item${isActive ? ' cashier-picker-item--active' : ''}${!s.hasPin || offShift ? ' cashier-picker-item--disabled' : ''}"
                data-id="${s.id}" data-idx="${i}" role="button" tabindex="0">
              <div class="cashier-picker-avatar" style="background:${color}">${(0, $cnCXJ.esc)(initials)}</div>
              <div class="cashier-picker-info">
                <span class="cashier-picker-name">${(0, $cnCXJ.esc)(displayName)}</span>
                <span class="cashier-picker-role">${(0, $cnCXJ.esc)(s.role)}${s.hasPin ? '' : ' &middot; <em class="cashier-no-pin">PIN not set</em>'}</span>
              </div>
              ${offShift ? '<span class="cashier-offshift-badge">Not clocked in</span>' : ''}
              ${isActive ? `<div class="cashier-picker-check"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div>` : ''}
            </li>`;
        }).join('') : '<li class="cashier-picker-empty">No active staff found.</li>'}
      </ul>
    `;
        card.querySelector('#cashierPickerCloseBtn')?.addEventListener('click', ()=>el.remove());
        card.querySelector('.cashier-picker-list')?.addEventListener('click', (e)=>{
            const item = e.target.closest('.cashier-picker-item[data-id]');
            if (!item || item.classList.contains('cashier-picker-item--disabled')) return;
            const chosen = activeStaff.find((s)=>s.id === item.dataset.id);
            if (chosen) renderPinScreen(chosen, parseInt(item.dataset.idx));
        });
    };
    const renderPinScreen = (chosen, idx)=>{
        const { displayName: displayName, initials: initials, color: color } = staffMeta(chosen, idx);
        if (!chosen.hasPin) {
            $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier = chosen;
            $1d9fcaa0a6035698$var$_updateCashierDisplay();
            $1d9fcaa0a6035698$var$showToast(`Switched to ${displayName}. Set a PIN in Staff settings.`, 'success');
            el.remove();
            return;
        }
        card.innerHTML = `
      <div class="cashier-picker-header">
        <div>
          <h3 class="cashier-picker-title">Enter PIN</h3>
          <p class="cashier-picker-subtitle">Switching to ${(0, $cnCXJ.esc)(displayName)}</p>
        </div>
        <button class="modal-close-btn" id="cashierPinCloseBtn" type="button">&times;</button>
      </div>
      <div class="cashier-pin-screen">
        <div class="cashier-picker-avatar cashier-pin-avatar" style="background:${color}">${(0, $cnCXJ.esc)(initials)}</div>
        <p class="cashier-pin-name">${(0, $cnCXJ.esc)(displayName)}</p>
        <p class="cashier-pin-role">${(0, $cnCXJ.esc)(chosen.role)}</p>
        <div class="cashier-pin-dots" id="cashierPinDots">
          <span class="cashier-pin-dot"></span>
          <span class="cashier-pin-dot"></span>
          <span class="cashier-pin-dot"></span>
          <span class="cashier-pin-dot"></span>
          <span class="cashier-pin-dot"></span>
          <span class="cashier-pin-dot"></span>
        </div>
        <p class="cashier-pin-error hidden" id="cashierPinError">Incorrect PIN. Try again.</p>
        <div class="cashier-numpad">
          ${[
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].map((n)=>`<button class="cashier-numpad-btn" data-key="${n}">${n}</button>`).join('')}
          <button class="cashier-numpad-btn cashier-numpad-nav" data-key="back" aria-label="Back">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            Back
          </button>
          <button class="cashier-numpad-btn" data-key="0">0</button>
          <button class="cashier-numpad-btn cashier-numpad-nav" data-key="del" aria-label="Delete digit">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/><line x1="18" y1="9" x2="12" y2="15"/><line x1="12" y1="9" x2="18" y2="15"/></svg>
          </button>
        </div>
        <button class="cashier-pin-forgot" id="cashierPinForgotBtn" type="button">Forgot PIN?</button>
      </div>
    `;
        let enteredPin = '';
        const updateDots = ()=>{
            card.querySelectorAll('.cashier-pin-dot').forEach((d, i)=>{
                d.classList.toggle('cashier-pin-dot--filled', i < enteredPin.length);
            });
        };
        const shakeAndClear = ()=>{
            const dotsEl = card.querySelector('#cashierPinDots');
            const errEl = card.querySelector('#cashierPinError');
            dotsEl?.classList.add('cashier-pin-shake');
            errEl?.classList.remove('hidden');
            setTimeout(()=>{
                dotsEl?.classList.remove('cashier-pin-shake');
                enteredPin = '';
                updateDots();
            }, 600);
        };
        card.querySelector('#cashierPinCloseBtn')?.addEventListener('click', ()=>el.remove());
        card.querySelector('#cashierPinForgotBtn')?.addEventListener('click', ()=>renderForgotPin(chosen, idx));
        card.querySelector('.cashier-numpad')?.addEventListener('click', (e)=>{
            const key = e.target.closest('.cashier-numpad-btn')?.dataset.key;
            if (!key) return;
            if (key === 'back') {
                renderStaffList();
                return;
            }
            if (key === 'del') {
                enteredPin = enteredPin.slice(0, -1);
                updateDots();
                return;
            }
            if (enteredPin.length >= 6) return;
            enteredPin += key;
            updateDots();
            if (enteredPin.length === 6) {
                if (enteredPin === chosen.pin) {
                    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier = chosen;
                    $1d9fcaa0a6035698$var$_updateCashierDisplay();
                    $1d9fcaa0a6035698$var$showToast(`Switched to ${displayName}`, 'success');
                    el.remove();
                } else shakeAndClear();
            }
        });
    };
    // Forgot PIN: the staff member proves identity with their OWN account password
    // (verified on an isolated client - the POS session is untouched), then sets a
    // new 6-digit PIN and is switched in immediately.
    const renderForgotPin = (chosen, idx)=>{
        const { displayName: displayName, initials: initials, color: color } = staffMeta(chosen, idx);
        card.innerHTML = `
      <div class="cashier-picker-header">
        <div>
          <h3 class="cashier-picker-title">Reset PIN</h3>
          <p class="cashier-picker-subtitle">Verify it's you, ${(0, $cnCXJ.esc)(displayName)}</p>
        </div>
        <button class="modal-close-btn" id="cashierForgotCloseBtn" type="button">&times;</button>
      </div>
      <div class="cashier-forgot-body">
        <div class="cashier-picker-avatar cashier-pin-avatar" style="background:${color}">${(0, $cnCXJ.esc)(initials)}</div>
        <div class="edit-field" style="margin-top:12px">
          <label for="cashierForgotEmail">Your email</label>
          <input type="email" id="cashierForgotEmail" class="settings-input" value="${(0, $cnCXJ.esc)(chosen.email ?? '')}" readonly />
        </div>
        <div class="edit-field" style="margin-top:10px">
          <label for="cashierForgotPassword">Your account password</label>
          <input type="password" id="cashierForgotPassword" class="settings-input" placeholder="\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}" autocomplete="current-password" />
        </div>
        <div class="edit-field" style="margin-top:10px">
          <label for="cashierForgotNewPin">New 6-digit PIN</label>
          <input type="text" id="cashierForgotNewPin" class="settings-input pin-input" inputmode="numeric" maxlength="6" placeholder="\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}" autocomplete="off" />
        </div>
        <div class="edit-field hidden" id="cashierForgotMfaField" style="margin-top:10px">
          <label for="cashierForgotMfa">Authenticator code</label>
          <input type="text" id="cashierForgotMfa" class="settings-input" inputmode="numeric" maxlength="6" placeholder="000000" autocomplete="one-time-code" />
        </div>
        <p class="cashier-pin-error hidden" id="cashierForgotError"></p>
        <div class="adj-form-actions" style="margin-top:16px">
          <button type="button" class="btn" id="cashierForgotBackBtn">Back</button>
          <button type="button" class="btn primary" id="cashierForgotSaveBtn">Verify &amp; Save PIN</button>
        </div>
      </div>
    `;
        const errEl = card.querySelector('#cashierForgotError');
        const fail = (msg)=>{
            errEl.textContent = msg;
            errEl.classList.remove('hidden');
        };
        card.querySelector('#cashierForgotCloseBtn')?.addEventListener('click', ()=>el.remove());
        card.querySelector('#cashierForgotBackBtn')?.addEventListener('click', ()=>renderPinScreen(chosen, idx));
        card.querySelector('#cashierForgotSaveBtn')?.addEventListener('click', async ()=>{
            errEl.classList.add('hidden');
            const password = card.querySelector('#cashierForgotPassword')?.value;
            const newPin = card.querySelector('#cashierForgotNewPin')?.value.trim();
            if (!password) return fail('Enter your account password.');
            if (!/^\d{6}$/.test(newPin)) return fail('The new PIN must be exactly 6 digits.');
            const btn = card.querySelector('#cashierForgotSaveBtn');
            btn.disabled = true;
            btn.textContent = "Verifying\u2026";
            try {
                const captchaToken = await (0, $3kKUy.getTokenInteractive)();
                const mfaCode = card.querySelector('#cashierForgotMfa')?.value.trim() || undefined;
                await $1e7ab04ca7920cff$export$62c57b495cbdd512({
                    email: chosen.email,
                    password: password,
                    staffId: chosen.id,
                    newPin: newPin,
                    captchaToken: captchaToken,
                    mfaCode: mfaCode
                });
                $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier = chosen;
                $1d9fcaa0a6035698$var$_updateCashierDisplay();
                $1d9fcaa0a6035698$var$showToast(`PIN updated. Switched to ${displayName}.`, 'success');
                el.remove();
            } catch (err) {
                btn.disabled = false;
                btn.textContent = 'Verify & Save PIN';
                if (err.code === 'MFA_REQUIRED') {
                    card.querySelector('#cashierForgotMfaField')?.classList.remove('hidden');
                    card.querySelector('#cashierForgotMfa')?.focus();
                }
                fail(err.message ?? 'Could not reset the PIN.');
            }
        });
        card.querySelector('#cashierForgotPassword')?.focus();
    };
    renderStaffList();
};
// Enqueues the Today's Sales card reveal (count-up then % roll). Used standalone
// on a new sale and on void; the initial dashboard load goes through
// _revealDashboardCards so all three cards stay in a fixed Sales->Txns->Serving
// order. Returns the chain promise so callers can sequence after it if needed.
const $1d9fcaa0a6035698$var$refreshTodaySalesDisplay = function() {
    const dataP = Promise.all([
        $1e7ab04ca7920cff$export$324a1aa31eacd016(),
        $1e7ab04ca7920cff$export$ec944a5e9be9dae8()
    ]).catch(()=>null);
    $1d9fcaa0a6035698$var$_refreshHomeCards({
        sales: true
    }); // tips / items sold / top sellers tiles and card
    return $1d9fcaa0a6035698$var$_enqueueDashAnim(()=>$1d9fcaa0a6035698$var$_animateSalesStep(dataP));
};
const $1d9fcaa0a6035698$var$initApp = async function(user, { isInviteAcceptance: isInviteAcceptance = false } = {}) {
    // Session confirmed: release the pre-boot anti-home-flash guard (a signed-in
    // load never sets it, but a stale/edge-case token check must not leave the
    // app chrome hidden).
    document.documentElement.classList.remove('boot-auth');
    await $1e7ab04ca7920cff$export$321bb7db07b616e1(user, {
        isInviteAcceptance: isInviteAcceptance
    });
    $1d9fcaa0a6035698$var$_bizTz(); // views read the business zone from here on
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff;
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.username = (s ? `${s.firstName ?? ''} ${s.lastName ?? ''}`.trim() : null) || user.user_metadata?.display_name || user.email;
    const companyNameEl = document.querySelector('.company-name');
    if (companyNameEl) companyNameEl.textContent = $1e7ab04ca7920cff$export$ca000e230c0caa3e.username;
    localStorage.setItem('pointbunny_store_name', $1e7ab04ca7920cff$export$ca000e230c0caa3e.username);
    localStorage.setItem('pointbunny_business_id', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    // Stash the business country so every window (POS views + KDS/CFD popups) can
    // localize the order-type label (Takeout vs Takeaway) without extra plumbing.
    localStorage.setItem('pointbunny_business_country', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCountry ?? '');
    // Concurrent-session cap (Free = 1, Pro = 4) - throws SESSION_LIMIT_REACHED if
    // this business is already at its tier's cap, caught by both initApp() callers
    // which sign back out and show the named "X is currently signed in" message.
    // Re-claiming on a reload of the same tab just refreshes the existing slot.
    await $1e7ab04ca7920cff$export$71e40b4acba264d1($1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId, $1e7ab04ca7920cff$export$ca000e230c0caa3e.username, 'pos');
    $1e7ab04ca7920cff$export$abf150cd98793bd7($1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    $1e7ab04ca7920cff$export$7573d0868ee8d901($1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    // Bind the realtime broadcast channel to THIS business so KDS / customer-display
    // sync never crosses tenants. Must happen before any postMessage below.
    (0, $boau7.default).init($1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    // Best-effort silent reconnect to a previously-paired Bluetooth printer so it
    // is ready at checkout without reopening Settings. No-op on iOS/unsupported.
    (0, $fbad918341d4cd38$export$2e2bcd8739ae039).reconnect().catch(()=>{});
    $1d9fcaa0a6035698$var$_applyPermissionGates();
    $1d9fcaa0a6035698$var$_applyPlanGateUI();
    // Live-updates the plan gate if the admin panel flips subscription_status while
    // this session is open, no logout/login needed (closes the long-standing
    // "Subscription Status - Realtime Sync Needed" todo).
    $1e7ab04ca7920cff$export$fc852ad46d64cd99($1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId, ({ becamePaid: becamePaid })=>{
        $1d9fcaa0a6035698$var$_applyPlanGateUI();
        if (becamePaid) $1d9fcaa0a6035698$var$_celebrateUpgrade();
    });
    if (sessionStorage.getItem('pointbunny_role_changed')) {
        sessionStorage.removeItem('pointbunny_role_changed');
        setTimeout(()=>$1d9fcaa0a6035698$var$showToast(`Your role is now ${$1e7ab04ca7920cff$export$ca000e230c0caa3e.role}.`, 'info'), 600);
    }
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff) $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff;
    $1d9fcaa0a6035698$var$_updateCashierDisplay();
    if ($1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business')) $1e7ab04ca7920cff$export$55344c3a5ee790ee().catch(()=>{});
    // All queries are independent after businessId is set — run in parallel
    // instead of 7 sequential round trips (was ~1.4s, now takes as long as the slowest one)
    await Promise.all([
        $1e7ab04ca7920cff$export$88b1d98240dfcff5(),
        $1e7ab04ca7920cff$export$d79f3d7dd8af2e54(),
        $1e7ab04ca7920cff$export$2b6317b6fe55adc(),
        $1e7ab04ca7920cff$export$99071deb5c3e11b(),
        $1e7ab04ca7920cff$export$e36954363574ccbc(),
        $1e7ab04ca7920cff$export$25a663fe967004b4(),
        // Inventory loads with everything else so the order screen can badge
        // out-of-stock items and checkout can compute consumption with no extra
        // fetch. Tolerant of the un-migrated case - inventory is opt-in.
        $1e7ab04ca7920cff$export$45aba0c57314d190().catch(()=>{}),
        // Reward catalog loads eagerly too - checkout needs it (use_loyalty) even
        // for staff who can never open the manage_loyalty-gated Loyalty panel.
        // Tolerant of the un-migrated case, same as inventory.
        $1e7ab04ca7920cff$export$326e3b762d83929b().catch(()=>{})
    ]);
    $1d9fcaa0a6035698$var$_updateMenuSetupBanner(); // also runs _updateGettingStarted()
    $1d9fcaa0a6035698$var$_applyHomeStatsVisibility();
    $1d9fcaa0a6035698$var$_applyHomeLayout();
    $1d9fcaa0a6035698$var$_startOnShiftIndicator();
    $1d9fcaa0a6035698$var$_refreshHomeExpensesToday();
    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
    if ($1d9fcaa0a6035698$var$modelState.orderQueue.length > 0) $1d9fcaa0a6035698$var$_ensureKDSTick();
    // Push queue to any KDS/CFD windows already open when the main app finishes loading
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).KDS_QUEUE_SYNC,
        queue: $1d9fcaa0a6035698$var$_queueForBroadcast(),
        thresholds: {
            yellow: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsYellowThreshold,
            red: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsRedThreshold
        }
    });
    $1e7ab04ca7920cff$export$2f466d5f5f216986($1d9fcaa0a6035698$var$_handleStaffDeactivated, $1d9fcaa0a6035698$var$_handleStaffRoleChanged);
    $1d9fcaa0a6035698$var$_revealDashboardCards();
    $1e7ab04ca7920cff$export$6d18979955267451().then(()=>(0, $5d00d49bfb2356db$export$2e2bcd8739ae039).syncUnreadBadge($1e7ab04ca7920cff$export$ca000e230c0caa3e.tickets)).catch(()=>{});
    $1d9fcaa0a6035698$var$_refreshNotifications();
    $1d9fcaa0a6035698$var$_initTours(user);
};
// ── Tutorial practice data ───────────────────────────────────────────────────
// Hands-on tours (Inventory, Timesheets) swap a pretend café into memory
// (practiceData.js) and put the business's real data back when the tour ends.
// Safety model - nothing practice-related can reach Supabase:
//  1. Every write handler of those two panels is wrapped at wiring time by
//     _practiceGuard: while practice data is loaded a click either runs a
//     memory-only stand-in (_practiceCreatePo etc.) or is refused with a toast.
//  2. Background refreshers that would reload or read real rows (notification
//     bell, activity feed, INVENTORY_SYNC, Getting Started) stand down until
//     the tour ends, then catch up.
//  3. The tour spotlight only lets the user click what's being taught.
const $1d9fcaa0a6035698$var$_practiceOn = (kind)=>!!$1d9fcaa0a6035698$var$_practice && (!kind || $1d9fcaa0a6035698$var$_practice.kind === kind);
const $1d9fcaa0a6035698$var$_practiceBlocked = ()=>$1d9fcaa0a6035698$var$showToast("That's off while you're practicing. Finish or close the tutorial to use it for real.", 'info');
const $1d9fcaa0a6035698$var$_practiceGuard = (kind, fn, practiceFn = null)=>(...args)=>{
        if ($1d9fcaa0a6035698$var$_practiceOn(kind)) return practiceFn ? practiceFn(...args) : $1d9fcaa0a6035698$var$_practiceBlocked();
        return fn(...args);
    };
const $1d9fcaa0a6035698$var$_practiceActor = ()=>{
    const who = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier ?? $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff;
    return [
        who?.firstName,
        who?.lastName
    ].filter(Boolean).join(' ') || 'You';
};
const $1d9fcaa0a6035698$var$_poLabel = (n)=>`PO-${String(n ?? 0).padStart(3, '0')}`;
// State slices the inventory practice replaces (cart too: New Order shows the
// practice menu, and a real in-progress order must survive the tour).
const $1d9fcaa0a6035698$var$_PRACTICE_INV_KEYS = [
    'inventoryItems',
    'inventoryLinks',
    'inventoryAdjustments',
    'suppliers',
    'itemSuppliers',
    'purchaseOrders',
    'menuItems',
    'menuCategories',
    'cart'
];
const $1d9fcaa0a6035698$var$_startInventoryPractice = function() {
    $1d9fcaa0a6035698$var$_endPractice();
    const demo = (0, $b10fec56003d56fb$export$c139289dfab6026)();
    const saved = {
        inventoryEnabled: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.inventoryEnabled
    };
    $1d9fcaa0a6035698$var$_PRACTICE_INV_KEYS.forEach((k)=>{
        saved[k] = $1e7ab04ca7920cff$export$ca000e230c0caa3e[k];
    });
    $1d9fcaa0a6035698$var$_practice = {
        kind: 'inventory',
        saved: saved,
        poSeq: demo.nextPoNumber,
        saleSeq: demo.nextReceipt
    };
    Object.assign($1e7ab04ca7920cff$export$ca000e230c0caa3e, {
        inventoryItems: demo.items,
        inventoryLinks: demo.links,
        inventoryAdjustments: demo.adjustments,
        suppliers: demo.suppliers,
        itemSuppliers: demo.itemSuppliers,
        purchaseOrders: demo.purchaseOrders,
        menuItems: demo.menuItems,
        menuCategories: demo.menuCategories,
        cart: []
    });
    // In memory only - never persisted: any settings save during the tour sends
    // the real value instead (see model.setSettingsPersistOverrides).
    $1e7ab04ca7920cff$export$f4a68e8bb3666000({
        inventoryEnabled: saved.inventoryEnabled
    });
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.inventoryEnabled = true;
    $1d9fcaa0a6035698$var$_inventoryHistoryFilter = null;
    (0, $b0886db79b2df847$export$2e2bcd8739ae039).resetView();
    if ((0, $b0886db79b2df847$export$2e2bcd8739ae039).isOpen()) (0, $b0886db79b2df847$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_inventorySnapshot());
};
const $1d9fcaa0a6035698$var$_practiceInventoryOpen = function() {
    $1d9fcaa0a6035698$var$_inventoryHistoryFilter = null;
    (0, $b0886db79b2df847$export$2e2bcd8739ae039).open();
    (0, $b0886db79b2df847$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_inventorySnapshot());
};
// "A busy morning": rings up the practice lattes as separate sales, one
// adjustment row per sale per supply - the same shape real sales log.
const $1d9fcaa0a6035698$var$_practiceSellLattes = function() {
    if (!$1d9fcaa0a6035698$var$_practiceOn('inventory')) return;
    const { lattes: lattes, perSale: perSale } = (0, $b10fec56003d56fb$export$43d9f4e1cc9f3778);
    const links = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryLinks.filter((l)=>l.menuItemId === (0, $b10fec56003d56fb$export$bba2591dc30e4a13).latte);
    const actor = $1d9fcaa0a6035698$var$_practiceActor();
    const sales = Math.ceil(lattes / perSale);
    for(let i = 0; i < sales; i++){
        const when = new Date(Date.now() - (sales - i) * 360000).toISOString();
        const receiptNumber = $1d9fcaa0a6035698$var$_practice.saleSeq++;
        links.forEach((l)=>{
            const item = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.find((it)=>it.id === l.inventoryItemId);
            if (!item) return;
            const used = l.qty * perSale;
            item.quantity = Math.max(0, item.quantity - used);
            item.updatedAt = when;
            $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryAdjustments.unshift({
                id: `practice-adj-sale-${receiptNumber}-${item.id}`,
                inventoryItemId: item.id,
                delta: -used,
                kind: 'sale',
                note: null,
                saleId: `practice-sale-${receiptNumber}`,
                receiptNumber: receiptNumber,
                saleDate: when,
                staffName: actor,
                createdAt: when
            });
        });
    }
    (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
    $1d9fcaa0a6035698$var$showToast(`Sold ${lattes} lattes. The supplies went down by themselves.`, 'success');
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal('practice-sold');
};
const $1d9fcaa0a6035698$var$_practiceCreatePo = function(data) {
    const now = new Date().toISOString();
    const items = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems;
    const num = (v)=>v == null || v === '' ? null : Number(v) || 0;
    const po = {
        id: `practice-po-${Date.now()}`,
        poNumber: $1d9fcaa0a6035698$var$_practice.poSeq++,
        supplierId: data.supplierId || null,
        supplierName: $1e7ab04ca7920cff$export$ca000e230c0caa3e.suppliers.find((sp)=>sp.id === data.supplierId)?.name ?? null,
        status: 'draft',
        expectedDate: data.expectedDate || null,
        notes: (data.notes ?? '').trim() || null,
        shipping: num(data.shipping),
        tax: num(data.tax),
        createdByName: $1d9fcaa0a6035698$var$_practiceActor(),
        receiptUrl: null,
        createdAt: now,
        sentAt: null,
        receivedAt: null,
        cancelledAt: null,
        lines: (data.lines ?? []).map((l, i)=>{
            const item = items.find((it)=>it.id === l.inventoryItemId);
            return {
                id: `practice-pol-${Date.now()}-${i}`,
                inventoryItemId: l.inventoryItemId,
                itemName: item?.name ?? 'Item',
                unit: item?.unit ?? 'unit',
                qty: Number(l.qty),
                unitCost: l.unitCost ?? null,
                createdAt: now
            };
        })
    };
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders = [
        po,
        ...$1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders
    ];
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal('po-created');
    if (data.initialStatus === 'received') {
        $1d9fcaa0a6035698$var$_practiceReceivePo(po.id);
        return;
    }
    if (data.initialStatus === 'sent') {
        po.status = 'sent';
        po.sentAt = now;
    }
    (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
    $1d9fcaa0a6035698$var$showToast(`${$1d9fcaa0a6035698$var$_poLabel(po.poNumber)} saved - ${po.status === 'sent' ? 'waiting for delivery' : 'for approval'}.`, 'success');
};
const $1d9fcaa0a6035698$var$_practiceSetPoStatus = function(id, status) {
    const po = $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders.find((x)=>x.id === id);
    if (!po) return;
    const now = new Date().toISOString();
    po.status = status;
    if (status === 'sent') po.sentAt = now;
    if (status === 'cancelled') po.cancelledAt = now;
    (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
    if (status === 'sent') $1d9fcaa0a6035698$var$showToast('Order approved - waiting for delivery.', 'success');
    if (status === 'cancelled') $1d9fcaa0a6035698$var$showToast('Purchase order cancelled.', 'success');
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal(status === 'sent' ? 'po-approved' : 'po-cancelled');
};
// Mirrors receive_purchase_order: every line adds to stock, last cost wins,
// one 'po' history row per line.
const $1d9fcaa0a6035698$var$_practiceReceivePo = function(id) {
    const po = $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders.find((x)=>x.id === id);
    if (!po || po.status === 'received') return;
    const now = new Date().toISOString();
    const actor = $1d9fcaa0a6035698$var$_practiceActor();
    po.lines.forEach((l)=>{
        const item = $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryItems.find((it)=>it.id === l.inventoryItemId);
        if (!item || !(l.qty > 0)) return;
        item.quantity += l.qty;
        if (l.unitCost != null) item.unitCost = l.unitCost;
        item.updatedAt = now;
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.inventoryAdjustments.unshift({
            id: `practice-adj-po-${l.id}`,
            inventoryItemId: item.id,
            delta: l.qty,
            kind: 'po',
            note: null,
            saleId: null,
            receiptNumber: null,
            saleDate: null,
            staffName: actor,
            createdAt: now
        });
    });
    po.status = 'received';
    po.receivedAt = now;
    (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
    (0, $472fec5536166250$export$2e2bcd8739ae039).updateStockBadges($1e7ab04ca7920cff$export$916349a6610ebe78());
    $1d9fcaa0a6035698$var$showToast(`${$1d9fcaa0a6035698$var$_poLabel(po.poNumber)} received. Stock updated.`, 'success');
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal('po-received');
};
const $1d9fcaa0a6035698$var$_timesheetPanelOpen = ()=>!document.getElementById('timesheetPanel')?.classList.contains('hidden');
const $1d9fcaa0a6035698$var$_startTimesheetPractice = function() {
    $1d9fcaa0a6035698$var$_endPractice();
    $1d9fcaa0a6035698$var$_practice = {
        kind: 'timesheets',
        data: (0, $b10fec56003d56fb$export$7b6472890327bb48)()
    };
    if ($1d9fcaa0a6035698$var$_timesheetPanelOpen()) $1d9fcaa0a6035698$var$_practiceTimesheetsRender();
};
const $1d9fcaa0a6035698$var$_practiceTimesheetsRender = function() {
    const d = $1d9fcaa0a6035698$var$_practice.data;
    // Practice shifts never mix with the business's real tips.
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).setTipsData({
        tips: []
    });
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).renderTimesheets(d.shifts, d.staff, true, d.periodMeta, d.editRequests, d.deletedShifts, d.devices, d.leaveRequests, d.onShift);
};
const $1d9fcaa0a6035698$var$_practiceTimesheetsOpen = function() {
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).open();
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).setSection('timesheets');
    $1d9fcaa0a6035698$var$_practiceTimesheetsRender();
};
const $1d9fcaa0a6035698$var$_practiceSaveShift = function(data) {
    const d = $1d9fcaa0a6035698$var$_practice.data;
    const actor = $1d9fcaa0a6035698$var$_practiceActor();
    const sh = data.id ? d.shifts.find((x)=>x.id === data.id) : null;
    if (sh) Object.assign(sh, {
        staffId: data.staffId || sh.staffId,
        clockedInAt: data.clockedInAt,
        clockedOutAt: data.clockedOutAt,
        note: data.note ?? '',
        editedBy: actor
    });
    else {
        const member = d.staff.find((m)=>m.id === data.staffId);
        d.shifts.push({
            id: `practice-shift-new-${Date.now()}`,
            staffId: data.staffId,
            staffName: member ? `${member.firstName} ${member.lastName}` : 'Staff',
            hourlyRate: null,
            clockedInAt: data.clockedInAt,
            clockedOutAt: data.clockedOutAt,
            note: data.note ?? '',
            source: 'manual',
            editedBy: actor,
            approvedBy: null,
            breaks: []
        });
    }
    d.shifts.sort((a, b)=>new Date(a.clockedInAt) - new Date(b.clockedInAt));
    $1d9fcaa0a6035698$var$_practiceTimesheetsRender();
    $1d9fcaa0a6035698$var$showToast('Shift saved.', 'success');
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal('shift-saved');
};
const $1d9fcaa0a6035698$var$_practiceReviewRequest = function(id, decision) {
    const d = $1d9fcaa0a6035698$var$_practice.data;
    const req = d.editRequests.find((r)=>r.id === id);
    if (!req) return;
    if (decision === 'approved') {
        const sh = d.shifts.find((x)=>x.id === req.shiftId);
        if (sh) Object.assign(sh, {
            clockedInAt: req.proposedIn ?? sh.clockedInAt,
            clockedOutAt: req.proposedOut ?? sh.clockedOutAt,
            source: 'request',
            approvedBy: $1d9fcaa0a6035698$var$_practiceActor()
        });
        $1d9fcaa0a6035698$var$showToast('Correction applied.', 'success');
    } else $1d9fcaa0a6035698$var$showToast('Correction rejected.');
    d.editRequests = d.editRequests.filter((r)=>r.id !== id);
    $1d9fcaa0a6035698$var$_practiceTimesheetsRender();
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal('correction-reviewed');
};
const $1d9fcaa0a6035698$var$_practiceReviewLeave = function(id, decision) {
    const req = $1d9fcaa0a6035698$var$_practice.data.leaveRequests.find((r)=>r.id === id);
    if (!req) return;
    Object.assign(req, {
        status: decision,
        reviewedByName: $1d9fcaa0a6035698$var$_practiceActor(),
        reviewedAt: new Date().toISOString()
    });
    $1d9fcaa0a6035698$var$_practiceTimesheetsRender();
    $1d9fcaa0a6035698$var$showToast(decision === 'approved' ? 'Leave approved.' : 'Leave request rejected.', decision === 'approved' ? 'success' : undefined);
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).signal('leave-reviewed');
};
// Puts the real data back however the tour ended (finished, skipped, closed,
// replaced by another tour, signed out). Safe to call when nothing is active.
const $1d9fcaa0a6035698$var$_endPractice = function() {
    if (!$1d9fcaa0a6035698$var$_practice) return;
    const { kind: kind, saved: saved } = $1d9fcaa0a6035698$var$_practice;
    $1d9fcaa0a6035698$var$_practice = null;
    // Practice-only dialogs (PO form, confirm prompts, shift editor) must not
    // outlive the practice data: a click after the restore would hit the real
    // handlers with practice ids.
    document.querySelectorAll('body > .modal-overlay-form:not(.hidden), #shiftEditModal').forEach((el)=>el.remove());
    if (kind === 'inventory') {
        $1d9fcaa0a6035698$var$_PRACTICE_INV_KEYS.forEach((k)=>{
            $1e7ab04ca7920cff$export$ca000e230c0caa3e[k] = saved[k];
        });
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.inventoryEnabled = saved.inventoryEnabled;
        $1e7ab04ca7920cff$export$f4a68e8bb3666000(null);
        $1d9fcaa0a6035698$var$_inventoryHistoryFilter = null;
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).resetView();
        if ((0, $b0886db79b2df847$export$2e2bcd8739ae039).isOpen()) {
            if ($1e7ab04ca7920cff$export$57b484963858c9a0('inventory')) (0, $b0886db79b2df847$export$2e2bcd8739ae039).renderLockedTeaser($1d9fcaa0a6035698$var$_inventorySnapshot());
            else (0, $b0886db79b2df847$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_inventorySnapshot());
        }
        if (document.querySelector('#newOrderModal .pos-items-area, #newOrderModal .pos-empty')) (0, $472fec5536166250$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$modelState);
        // Catch up on anything another terminal changed while the tour ran.
        Promise.all([
            $1e7ab04ca7920cff$export$45aba0c57314d190(),
            $1e7ab04ca7920cff$export$2e183382b4951272().catch(()=>[]),
            $1e7ab04ca7920cff$export$9299725340e97fc6().catch(()=>[]),
            $1e7ab04ca7920cff$export$4faf3f9b9ffc9853().catch(()=>[])
        ]).then(()=>{
            if ($1d9fcaa0a6035698$var$_practice) return;
            if (!$1e7ab04ca7920cff$export$57b484963858c9a0('inventory')) (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
            (0, $472fec5536166250$export$2e2bcd8739ae039).updateStockBadges($1e7ab04ca7920cff$export$916349a6610ebe78());
        }).catch(()=>{});
    } else if (kind === 'timesheets' && $1d9fcaa0a6035698$var$_timesheetPanelOpen()) $1d9fcaa0a6035698$var$controlOpenTimesheets();
    $1d9fcaa0a6035698$var$_updateMenuSetupBanner();
    $1d9fcaa0a6035698$var$_requestActivityRefresh();
    $1d9fcaa0a6035698$var$_refreshNotifications();
};
// ── Guided tutorials ─────────────────────────────────────────────────────────
// tour.js is the engine, tours.js the content. The content only sees this api
// (permission/plan checks, a few counts, panel openers), never the model.
const $1d9fcaa0a6035698$var$_tourApi = {
    can: (perm)=>$1e7ab04ca7920cff$export$b325ec6732b039cf(perm),
    isLocked: (feature)=>$1e7ab04ca7920cff$export$57b484963858c9a0(feature),
    // Sellable items only: inactive ones are hidden from New Order, so a
    // catalogue of only inactive items can't be used for the practice sale.
    hasItems: ()=>($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems ?? []).some((i)=>i.status !== 'inactive'),
    cartCount: ()=>$1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.length,
    queueCount: ()=>$1e7ab04ca7920cff$export$ca000e230c0caa3e.orderQueue.length,
    printingOn: ()=>!!$1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.printingEnabled,
    openCustomerDisplay: ()=>$1d9fcaa0a6035698$var$controlOpenCFDWindow(),
    openPickupDisplay: ()=>$1d9fcaa0a6035698$var$controlOpenPickupWindow(),
    toast: (msg, type)=>$1d9fcaa0a6035698$var$showToast(msg, type),
    // The first-sale tour spotlights the Active Queue, so the default home
    // cards come back while it runs (this device's own choice returns after).
    homeDefaults: (on)=>{
        $1d9fcaa0a6035698$var$_homeTourDefaults = on;
        $1d9fcaa0a6035698$var$_applyHomeCards();
    },
    // Drops the tutorial's practice order(s) from the Active Queue.
    clearPractice: ()=>{
        // A practice order marked Done is sitting in its 10s undo window - cancel
        // it so Undo can't bring the order back after the tutorial ends.
        $1d9fcaa0a6035698$var$_pendingDone.forEach((pending, id)=>{
            if (!pending.order.practice) return;
            clearTimeout(pending.timer);
            pending.dismissToast();
            $1d9fcaa0a6035698$var$_pendingDone.delete(id);
        });
        const before = $1d9fcaa0a6035698$var$modelState.orderQueue.length;
        $1d9fcaa0a6035698$var$modelState.orderQueue = $1d9fcaa0a6035698$var$modelState.orderQueue.filter((o)=>!o.practice);
        if ($1d9fcaa0a6035698$var$modelState.orderQueue.length === before) return;
        (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
        if ($1d9fcaa0a6035698$var$modelState.orderQueue.length === 0) $1d9fcaa0a6035698$var$_stopKDSTick();
    },
    // "Nothing else is asking for the user's attention" - gates the first-run offer.
    isIdle: ()=>{
        const shown = (el)=>el.getClientRects().length > 0 && !el.closest('.hidden');
        const blockers = ".modal-parent > *, .cashier-picker-overlay, .confirm-overlay, .success-overlay, .app-exit-sweep, .modal-backdrop, .modal-overlay-form, .cashflow-panel, .rp-panel, #onboardingOverlay, #taxSuggestOverlay";
        if ([
            ...document.querySelectorAll(blockers)
        ].some(shown)) return false;
        // Wait for the dashboard to be fully revealed so the welcome card never
        // lands on a blank or half-faded-in home screen: the .fade-up shells must
        // have their .visible class AND be fully opaque, and no finite entrance
        // animation may still be running. Infinite ones (queue empty-state bunny,
        // particles) never finish, so they don't count.
        const revealed = [
            '.navbar',
            '.home-layout'
        ].every((sel)=>{
            const el = document.querySelector(sel);
            return el && (!el.classList.contains('fade-up') || el.classList.contains('visible')) && getComputedStyle(el).opacity === '1';
        });
        if (!revealed) return false;
        return !document.getAnimations?.().some((a)=>a.playState === 'running' && a.effect?.getTiming?.().iterations !== Infinity && a.effect?.target?.closest?.('header, main'));
    },
    practice: {
        startInventory: ()=>$1d9fcaa0a6035698$var$_startInventoryPractice(),
        startTimesheets: ()=>$1d9fcaa0a6035698$var$_startTimesheetPractice(),
        end: ()=>$1d9fcaa0a6035698$var$_endPractice(),
        sellLattes: ()=>$1d9fcaa0a6035698$var$_practiceSellLattes(),
        inventorySection: (id)=>(0, $b0886db79b2df847$export$2e2bcd8739ae039).showSection(id),
        // The PO the user just created (newest practice order).
        focusNewestPo: ()=>{
            const po = $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders.find((x)=>x.id.startsWith('practice-po-') && x.id !== 'practice-po-1');
            if (po) (0, $b0886db79b2df847$export$2e2bcd8739ae039).focusPO(po.id, 'all');
        },
        // Hop from Inventory to New Order (to see the low-stock badge) and back.
        showNewOrder: ()=>{
            if ((0, $b0886db79b2df847$export$2e2bcd8739ae039).isOpen()) (0, $b0886db79b2df847$export$2e2bcd8739ae039).close();
            $1d9fcaa0a6035698$var$controlNewOrder();
        },
        showInventory: ()=>{
            document.querySelector('#newOrderModal .pos-close-btn')?.click();
            setTimeout(()=>$1d9fcaa0a6035698$var$controlOpenInventory(), 260);
        },
        ids: (0, $b10fec56003d56fb$export$bba2591dc30e4a13)
    },
    open: {
        catalogue: ()=>$1d9fcaa0a6035698$var$controlMenuList(),
        inventory: ()=>$1d9fcaa0a6035698$var$controlOpenInventory(),
        discounts: ()=>$1d9fcaa0a6035698$var$controlOpenDiscounts(),
        promos: ()=>$1d9fcaa0a6035698$var$controlOpenPromos(),
        loyalty: ()=>$1d9fcaa0a6035698$var$controlOpenLoyalty(),
        staff: ()=>$1d9fcaa0a6035698$var$controlOpenStaff(),
        timesheets: ()=>$1d9fcaa0a6035698$var$controlOpenTimesheets(),
        schedule: ()=>$1d9fcaa0a6035698$var$controlOpenSchedule(),
        reports: ()=>$1d9fcaa0a6035698$var$controlOpenReports(),
        cashflow: ()=>$1d9fcaa0a6035698$var$controlOpenCashflow()
    }
};
const $1d9fcaa0a6035698$var$_initTours = async function(user) {
    // Progress lives in the account (synced across devices), not just this
    // browser. Fetched fresh rather than read off `user`, which can be a cached
    // session from before the tour was finished on another device.
    let remote = user.user_metadata?.pb_tours ?? null;
    try {
        remote = await $1e7ab04ca7920cff$export$8a0192bc90e542c4();
    } catch  {}
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).init({
        tours: (0, $8a6af5bb762aa044$export$7a357837346c6789),
        api: $1d9fcaa0a6035698$var$_tourApi,
        userId: user.id,
        remote: remote,
        persist: $1e7ab04ca7920cff$export$e37b02cc1b8f7cdf
    });
    // First-run offer, once per user: waits until onboarding / PIN setup / any
    // open modal is out of the way before showing the welcome card.
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).offer('first-sale');
};
let $1d9fcaa0a6035698$var$_yesterdayTotal = null;
let $1d9fcaa0a6035698$var$_todayTransactionCount = null;
let $1d9fcaa0a6035698$var$_yesterdayTransactionCount = null;
let $1d9fcaa0a6035698$var$_settingsOTPEmail = null;
let $1d9fcaa0a6035698$var$_settingsOTPData = null;
// Shared trend arrows for the dashboard badges (color comes from the svs-- class).
const $1d9fcaa0a6035698$var$_ARROW_UP = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>`;
const $1d9fcaa0a6035698$var$_ARROW_DOWN = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 17 13.5 8.5 8.5 13.5 2 7"/><polyline points="16 17 22 17 22 11"/></svg>`;
// "vs yesterday" trend badge. When today has no sales yet, showing a red "100%
// down" against yesterday reads as a decline rather than "the day just hasn't
// started" - so today = 0 always renders as a neutral empty state instead, no
// matter what yesterday was. When yesterday is $0 (and today has sales) it
// reads "from $0 yesterday" (up).
// Compact money for the "vs ... yesterday" caption (whole dollars + commas).
const $1d9fcaa0a6035698$var$_fmtMoneyShort = (n)=>(0, $coRoT.currencySymbol)() + Math.round(Number(n) || 0).toLocaleString('en-US');
// Smaller arrows for the serving badge (matches the original 11px inline icons).
const $1d9fcaa0a6035698$var$_SERV_ARROW_UP = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>`;
const $1d9fcaa0a6035698$var$_SERV_ARROW_DOWN = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 17 13.5 8.5 8.5 13.5 2 7"/><polyline points="16 17 22 17 22 11"/></svg>`;
const $1d9fcaa0a6035698$var$_fmtServing = (mins)=>{
    const t = Math.round(mins * 60);
    const m = Math.floor(t / 60);
    const s = t % 60;
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
};
// ── Pure badge builders: same data/maths as before, but they only COMPUTE the
// markup ({ className, html, baseText } or { empty:true }). The animation steps
// decide when to paint and roll them. This keeps the data path identical. ──────
const $1d9fcaa0a6035698$var$_salesBadge = (todayTotal)=>{
    if ($1d9fcaa0a6035698$var$_yesterdayTotal === null) return {
        empty: true,
        className: 'sales-vs-yesterday',
        baseText: ''
    };
    if (todayTotal === 0) return {
        empty: true,
        className: 'sales-vs-yesterday svs--flat',
        baseText: 'No sales yet today'
    };
    if ($1d9fcaa0a6035698$var$_yesterdayTotal === 0) return {
        className: 'sales-vs-yesterday svs--up',
        html: `${$1d9fcaa0a6035698$var$_ARROW_UP}<span>from ${(0, $coRoT.currencySymbol)()}0</span>`,
        baseText: 'No sales yesterday'
    };
    const pct = Math.round((todayTotal - $1d9fcaa0a6035698$var$_yesterdayTotal) / $1d9fcaa0a6035698$var$_yesterdayTotal * 100);
    const isUp = pct >= 0;
    return {
        className: `sales-vs-yesterday ${isUp ? 'svs--up' : 'svs--down'}`,
        html: `${isUp ? $1d9fcaa0a6035698$var$_ARROW_UP : $1d9fcaa0a6035698$var$_ARROW_DOWN}<span>${Math.abs(pct)}%</span>`,
        baseText: `vs ${$1d9fcaa0a6035698$var$_fmtMoneyShort($1d9fcaa0a6035698$var$_yesterdayTotal)} yesterday`
    };
};
const $1d9fcaa0a6035698$var$_txnsBadge = ()=>{
    if ($1d9fcaa0a6035698$var$_yesterdayTransactionCount === null) return {
        empty: true,
        className: 'sales-vs-yesterday',
        baseText: ''
    };
    if ($1d9fcaa0a6035698$var$_todayTransactionCount === 0) return {
        empty: true,
        className: 'sales-vs-yesterday svs--flat',
        baseText: 'No sales yet today'
    };
    if ($1d9fcaa0a6035698$var$_yesterdayTransactionCount === 0) return {
        className: 'sales-vs-yesterday svs--up',
        html: `${$1d9fcaa0a6035698$var$_ARROW_UP}<span>from 0</span>`,
        baseText: 'None yesterday'
    };
    const pct = Math.round(($1d9fcaa0a6035698$var$_todayTransactionCount - $1d9fcaa0a6035698$var$_yesterdayTransactionCount) / $1d9fcaa0a6035698$var$_yesterdayTransactionCount * 100);
    const isUp = pct >= 0;
    const yc = $1d9fcaa0a6035698$var$_yesterdayTransactionCount;
    return {
        className: `sales-vs-yesterday ${isUp ? 'svs--up' : 'svs--down'}`,
        html: `${isUp ? $1d9fcaa0a6035698$var$_ARROW_UP : $1d9fcaa0a6035698$var$_ARROW_DOWN}<span>${Math.abs(pct)}%</span>`,
        baseText: `vs ${yc} ${yc === 1 ? 'sale' : 'sales'} yesterday`
    };
};
const $1d9fcaa0a6035698$var$_servingBadge = (todayMins, yestMins)=>{
    if (yestMins === null || yestMins === 0) return {
        empty: true,
        className: 'home-dash-serving-vs',
        baseText: 'No data yesterday'
    };
    const diffSecs = Math.round((yestMins - todayMins) * 60); // positive = faster today
    const absSecs = Math.abs(diffSecs);
    const absFmt = absSecs >= 60 ? `${Math.floor(absSecs / 60)}m ${absSecs % 60}s` : `${absSecs}s`;
    const baseText = `vs ${$1d9fcaa0a6035698$var$_fmtServing(yestMins)} yesterday`;
    if (diffSecs > 0) return {
        className: 'home-dash-serving-vs svs--up',
        html: `${$1d9fcaa0a6035698$var$_SERV_ARROW_UP}<span>${absFmt} faster</span>`,
        baseText: baseText
    };
    if (diffSecs < 0) return {
        className: 'home-dash-serving-vs svs--down',
        html: `${$1d9fcaa0a6035698$var$_SERV_ARROW_DOWN}<span>${absFmt} slower</span>`,
        baseText: baseText
    };
    return {
        className: 'home-dash-serving-vs svs--flat',
        html: '<span>No change</span>',
        baseText: baseText
    };
};
const $1d9fcaa0a6035698$var$_fetchServingTotals = ()=>{
    const { start: ts, end: te } = $1d9fcaa0a6035698$var$_getBizDayBounds();
    const { start: ys, end: ye } = $1d9fcaa0a6035698$var$_getBizDayBounds(new Date(Date.now() - 86400000));
    return Promise.all([
        $1e7ab04ca7920cff$export$2614d9fab0c6cda6(ts.toISOString(), te.toISOString()),
        $1e7ab04ca7920cff$export$2614d9fab0c6cda6(ys.toISOString(), ye.toISOString())
    ]).then(([today, yesterday])=>{
        // Same query feeds the Active Queue empty state's "Today so far" stats.
        (0, $f3651885b15417e3$export$2e2bcd8739ae039).setTodayStats(today);
        return {
            today: today,
            yesterday: yesterday
        };
    });
};
// ── Per-card animation steps (run serialized via _enqueueDashAnim). Each waits
// for the success overlay to clear, counts its number up, then rolls its badge. ─
const $1d9fcaa0a6035698$var$_animateSalesStep = async (dataP)=>{
    const el = document.getElementById('totalStr');
    if (!el) return;
    await $1d9fcaa0a6035698$var$_waitForSuccessOverlayGone();
    let todayTotal;
    try {
        const d = await dataP;
        if (d) {
            $1d9fcaa0a6035698$var$_yesterdayTotal = d[0];
            todayTotal = d[1];
        }
    } catch (_) {}
    if (todayTotal === undefined) try {
        todayTotal = await $1e7ab04ca7920cff$export$ec944a5e9be9dae8();
    } catch (_) {
        return;
    }
    const currentVal = parseFloat(el.textContent.replace(/[$,]/g, '')) || 0;
    const badge = $1d9fcaa0a6035698$var$_salesBadge(todayTotal);
    const baseEl = document.getElementById('salesBaseStr');
    if (baseEl) baseEl.textContent = badge.baseText ?? '';
    const badgeEl = document.getElementById('salesVsYesterday');
    $1d9fcaa0a6035698$var$_armBadge(badgeEl, badge);
    await $1d9fcaa0a6035698$var$_countUpMoney(el, currentVal, todayTotal);
    await $1d9fcaa0a6035698$var$_rollBadgeIn(badgeEl);
};
const $1d9fcaa0a6035698$var$_animateTxnsStep = async (dataP)=>{
    const countEl = document.getElementById('basketCountStr');
    if (!countEl) return;
    await $1d9fcaa0a6035698$var$_waitForSuccessOverlayGone();
    if (dataP) try {
        const d = await dataP;
        if (d) {
            $1d9fcaa0a6035698$var$_todayTransactionCount = d.today;
            $1d9fcaa0a6035698$var$_yesterdayTransactionCount = d.yesterday;
        }
    } catch (_) {}
    if ($1d9fcaa0a6035698$var$_todayTransactionCount === null) return;
    const parsed = parseInt(String(countEl.textContent).replace(/[^\d-]/g, ''), 10);
    const fromVal = Number.isFinite(parsed) ? parsed : 0; // "—" on first load -> count up from 0
    const badge = $1d9fcaa0a6035698$var$_txnsBadge();
    const baseEl = document.getElementById('basketsBaseStr');
    if (baseEl) baseEl.textContent = badge.baseText ?? '';
    const badgeEl = document.getElementById('basketsVsYesterday');
    $1d9fcaa0a6035698$var$_armBadge(badgeEl, badge);
    await $1d9fcaa0a6035698$var$_countUpNumber(countEl, fromVal, $1d9fcaa0a6035698$var$_todayTransactionCount, (n)=>String(Math.round(n)));
    await $1d9fcaa0a6035698$var$_rollBadgeIn(badgeEl);
};
const $1d9fcaa0a6035698$var$_animateServingStep = async (dataP)=>{
    const valEl = document.getElementById('homeAvgServing');
    if (!valEl) return;
    await $1d9fcaa0a6035698$var$_waitForSuccessOverlayGone();
    let data;
    try {
        data = await dataP;
    } catch (_) {}
    if (!data) try {
        data = await $1d9fcaa0a6035698$var$_fetchServingTotals();
    } catch (_) {
        return;
    }
    const baseEl = document.getElementById('servingBaseStr');
    const badgeEl = document.getElementById('homeServingVs');
    const todayMins = data.today.avgServingMinutes;
    if (todayMins === null) {
        valEl.textContent = "\u2014";
        $1d9fcaa0a6035698$var$_armBadge(badgeEl, {
            empty: true,
            className: 'home-dash-serving-vs'
        });
        if (baseEl) baseEl.textContent = '';
        $1d9fcaa0a6035698$var$_lastServingMins = null;
        return;
    }
    const fromMins = $1d9fcaa0a6035698$var$_lastServingMins ?? 0; // count from the previously shown value (0 on first load)
    $1d9fcaa0a6035698$var$_lastServingMins = todayMins;
    const badge = $1d9fcaa0a6035698$var$_servingBadge(todayMins, data.yesterday.avgServingMinutes);
    if (baseEl) baseEl.textContent = badge.baseText ?? '';
    $1d9fcaa0a6035698$var$_armBadge(badgeEl, badge);
    await $1d9fcaa0a6035698$var$_countUpNumber(valEl, fromMins, todayMins, $1d9fcaa0a6035698$var$_fmtServing);
    await $1d9fcaa0a6035698$var$_rollBadgeIn(badgeEl);
};
// Standalone enqueuers (one card at a time). Transactions uses the in-memory
// counts (already incremented on a sale / decremented on a void); pass them in
// at trigger sites in Sales-before-Transactions order.
const $1d9fcaa0a6035698$var$_updateTransactionBadge = function() {
    return $1d9fcaa0a6035698$var$_enqueueDashAnim(()=>$1d9fcaa0a6035698$var$_animateTxnsStep(null));
};
const $1d9fcaa0a6035698$var$_loadServingComparison = function() {
    const dataP = $1d9fcaa0a6035698$var$_fetchServingTotals().catch(()=>null);
    return $1d9fcaa0a6035698$var$_enqueueDashAnim(()=>$1d9fcaa0a6035698$var$_animateServingStep(dataP));
};
// Initial dashboard reveal: fetch all three cards' data in parallel, then queue
// their animations in a fixed Sales -> Transactions -> Avg Serving order so only
// one card moves at a time regardless of which fetch resolves first.
const $1d9fcaa0a6035698$var$_revealDashboardCards = function() {
    const salesP = Promise.all([
        $1e7ab04ca7920cff$export$324a1aa31eacd016(),
        $1e7ab04ca7920cff$export$ec944a5e9be9dae8()
    ]).catch(()=>null);
    const txnsP = $1e7ab04ca7920cff$export$54cb0d704712bfd().catch(()=>null);
    const servingP = $1d9fcaa0a6035698$var$_fetchServingTotals().catch(()=>null);
    $1d9fcaa0a6035698$var$_enqueueDashAnim(()=>$1d9fcaa0a6035698$var$_animateSalesStep(salesP));
    $1d9fcaa0a6035698$var$_enqueueDashAnim(()=>$1d9fcaa0a6035698$var$_animateTxnsStep(txnsP));
    $1d9fcaa0a6035698$var$_enqueueDashAnim(()=>$1d9fcaa0a6035698$var$_animateServingStep(servingP));
};
// Post-launch prompts must be sequenced, not stacked: the PIN setup overlay sits at
// z-index 99999 and would cover the onboarding form. So show onboarding first when it's
// needed and defer the PIN prompt until onboarding is dismissed (controlOnboardingSubmit);
// otherwise show the PIN prompt right away.
const $1d9fcaa0a6035698$var$_showLaunchPrompts = function() {
    // If they got in via a recovery code, their 2FA was removed - nudge a re-enroll.
    if (sessionStorage.getItem('pointbunny_2fa_recovered')) {
        sessionStorage.removeItem('pointbunny_2fa_recovered');
        $1d9fcaa0a6035698$var$showToast('You signed in with a recovery code, so two-factor was turned off. Re-enable it in Settings to stay protected.', 'info');
    }
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.needsOnboarding) (0, $e03adf9eaa390216$export$2e2bcd8739ae039).show();
    else $1d9fcaa0a6035698$var$_maybeShowPinSetup();
};
let $1d9fcaa0a6035698$var$_onboardingCountry = null; // kept for the tax prompt after the "all set" screen
const $1d9fcaa0a6035698$var$controlOnboardingSubmit = async function({ businessName: businessName, businessType: businessType, industry: industry, setup: setup, phone: phone, street: street, city: city, province: province, zip: zip, country: country }) {
    (0, $e03adf9eaa390216$export$2e2bcd8739ae039).setLoading(true);
    try {
        await $1e7ab04ca7920cff$export$fb32ac73157105c7({
            businessName: businessName,
            businessType: businessType,
            industry: industry,
            phone: phone,
            street: street,
            city: city,
            province: province,
            zip: zip,
            country: country
        });
        const companyNameEl = document.querySelector('.company-name');
        if (companyNameEl) companyNameEl.textContent = businessName;
        localStorage.setItem('pointbunny_store_name', businessName);
        localStorage.setItem('pointbunny_business_country', country ?? '');
        // Step 3's choices (type of place, checkout steps, what the menus show).
        // Every key is set both ways so nothing is inherited from a business
        // onboarded earlier in the same browser.
        for (const [key, value] of Object.entries(setup ?? {}))$1e7ab04ca7920cff$export$233f02b89678da4f(key, value);
        await $1e7ab04ca7920cff$export$15e1db8a90fc192d();
        $1d9fcaa0a6035698$var$_applyHomeLayout();
        $1d9fcaa0a6035698$var$_onboardingCountry = {
            country: country,
            province: province
        };
        (0, $e03adf9eaa390216$export$2e2bcd8739ae039).showDone();
    } catch (err) {
        (0, $e03adf9eaa390216$export$2e2bcd8739ae039).showError(err.message ?? 'Something went wrong. Please try again.');
    } finally{
        (0, $e03adf9eaa390216$export$2e2bcd8739ae039).setLoading(false);
    }
};
// "Start using Pointbunny" on the all-set screen: then the tax prompt (when a
// rate is known for the location) or straight to the deferred PIN setup.
const $1d9fcaa0a6035698$var$controlOnboardingDone = function() {
    (0, $e03adf9eaa390216$export$2e2bcd8739ae039).hide();
    $1d9fcaa0a6035698$var$showToast('Business profile saved!', 'success');
    if (!$1d9fcaa0a6035698$var$_maybeShowTaxSuggestion($1d9fcaa0a6035698$var$_onboardingCountry ?? {})) $1d9fcaa0a6035698$var$_maybeShowPinSetup();
    $1d9fcaa0a6035698$var$_onboardingCountry = null;
};
// Holds the suggestion currently shown in the tax prompt so the Add handler can use it.
let $1d9fcaa0a6035698$var$_pendingTaxSuggestion = null;
// Shows the tax-suggestion prompt and returns true if it was shown, false otherwise.
// Skips silently when no rate is known for the location or tax is already set up.
const $1d9fcaa0a6035698$var$_maybeShowTaxSuggestion = function({ country: country, province: province }) {
    const suggestion = (0, $0dd9374d56731bb4$export$2956ce99ebefe226)({
        country: country,
        province: province
    });
    const rec = (0, $0dd9374d56731bb4$export$5fe3d459d71f1719)({
        country: country,
        province: province
    });
    if (!suggestion || !rec || rec.mode === 'none') return false;
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxMode !== 'none' || $1d9fcaa0a6035698$var$_hasTaxLikeFeeAdjustment()) return false;
    $1d9fcaa0a6035698$var$_pendingTaxSuggestion = {
        ...suggestion,
        mode: rec.mode
    };
    (0, $e03adf9eaa390216$export$2e2bcd8739ae039).showTaxPrompt(suggestion);
    return true;
};
// Location-based recommendation for Tax Settings: which option (badge on the
// option card) and, when we know one, the rate (chip above the rate field).
// US rates are the state base only, so the chip says to add local rates.
const $1d9fcaa0a6035698$var$_recommendedTaxMode = ()=>{
    const country = $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressCountry || localStorage.getItem('pointbunny_business_country');
    const province = $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessAddressProvince;
    const rec = (0, $0dd9374d56731bb4$export$5fe3d459d71f1719)({
        country: country,
        province: province
    });
    if (!rec) return null;
    const suggestion = rec.mode === 'none' ? null : (0, $0dd9374d56731bb4$export$2956ce99ebefe226)({
        country: country,
        province: province
    });
    return {
        ...rec,
        rate: suggestion?.rate ?? null,
        note: String(country).toUpperCase() === 'US' && suggestion ? 'This is the state rate. If your county or city adds sales tax, enter the combined rate.' : null
    };
};
const $1d9fcaa0a6035698$var$controlAddSuggestedTax = async function() {
    if (!$1d9fcaa0a6035698$var$_pendingTaxSuggestion) {
        (0, $e03adf9eaa390216$export$2e2bcd8739ae039).hideTaxPrompt();
        $1d9fcaa0a6035698$var$_maybeShowPinSetup();
        return;
    }
    (0, $e03adf9eaa390216$export$2e2bcd8739ae039).setTaxLoading(true);
    try {
        // Fills Tax Settings (Receipt & Tax) - tax is no longer an adjustment.
        const { mode: mode, rate: rate, name: name } = $1d9fcaa0a6035698$var$_pendingTaxSuggestion;
        $1e7ab04ca7920cff$export$233f02b89678da4f('taxMode', mode);
        $1e7ab04ca7920cff$export$233f02b89678da4f('taxInclusive', mode === 'inclusive');
        $1e7ab04ca7920cff$export$233f02b89678da4f('taxInclusiveRate', rate);
        $1e7ab04ca7920cff$export$233f02b89678da4f('taxInclusiveLabel', name);
        await $1e7ab04ca7920cff$export$15e1db8a90fc192d();
        $1d9fcaa0a6035698$var$showToast(`${name} (${rate}%) set up. You can change it in Receipt & Tax.`, 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not add tax. You can add it in Settings.', 'error');
    } finally{
        (0, $e03adf9eaa390216$export$2e2bcd8739ae039).setTaxLoading(false);
        (0, $e03adf9eaa390216$export$2e2bcd8739ae039).hideTaxPrompt();
        $1d9fcaa0a6035698$var$_pendingTaxSuggestion = null;
        $1d9fcaa0a6035698$var$_maybeShowPinSetup();
    }
};
const $1d9fcaa0a6035698$var$controlSkipSuggestedTax = function() {
    (0, $e03adf9eaa390216$export$2e2bcd8739ae039).hideTaxPrompt();
    $1d9fcaa0a6035698$var$_pendingTaxSuggestion = null;
    $1d9fcaa0a6035698$var$_maybeShowPinSetup();
};
const $1d9fcaa0a6035698$var$controlAcceptInvite = async function({ password: password, pin: pin }) {
    try {
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setInviteLoading(true);
        try {
            await $1e7ab04ca7920cff$export$e2853351e15b7895(password);
        } catch (pwErr) {
            // On a retry after a partial acceptance the password may already be set to this
            // value, so Supabase rejects it as "same as the old password". That is not a real
            // failure on an invite - the account only needs its staff row claimed below. Any
            // other error (weak password, etc.) is still surfaced.
            if (!/different from the old|should be different|same.*password/i.test(pwErr.message ?? '')) throw pwErr;
        }
        const { data: { user: user } } = await (0, $asfCf.supabase).auth.getUser();
        $1d9fcaa0a6035698$var$showLoadingScreen();
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).hide();
        await $1d9fcaa0a6035698$var$initApp(user, {
            isInviteAcceptance: true
        });
        $1d9fcaa0a6035698$var$hideLoadingScreen();
        if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff) try {
            await $1e7ab04ca7920cff$export$feecad064ee6d298($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.id, pin);
            $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.hasPin = true;
            if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier?.id === $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.id) $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier.hasPin = true;
        } catch (pinErr) {
            console.error('PIN save failed during invite acceptance:', pinErr);
        }
        $1d9fcaa0a6035698$var$_wireApp();
        $1d9fcaa0a6035698$var$_showLaunchPrompts();
    } catch (err) {
        console.error('invite accept failed:', err);
        $1d9fcaa0a6035698$var$hideLoadingScreen();
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).show();
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showInviteError(err.message ?? 'Something went wrong. Please contact your manager.');
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setInviteLoading(false);
    }
};
// The signed-in account has a pending invite (surfaced by loadBusinessContext) and chose
// to accept it. Claim the row, then launch the app as that business's staff member.
const $1d9fcaa0a6035698$var$controlAcceptPendingInvite = async function(staffId) {
    try {
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setJoinLoading(true);
        const user = await $1e7ab04ca7920cff$export$52ce019d07b456a7(staffId);
        $1d9fcaa0a6035698$var$showLoadingScreen();
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).hide();
        await $1d9fcaa0a6035698$var$initApp(user);
        $1d9fcaa0a6035698$var$hideLoadingScreen();
        $1d9fcaa0a6035698$var$_wireApp();
        $1d9fcaa0a6035698$var$_showLaunchPrompts();
    } catch (err) {
        console.error('accept pending invite failed:', err);
        $1d9fcaa0a6035698$var$hideLoadingScreen();
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setJoinLoading(false);
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).show();
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showJoinError(err.message ?? 'Could not join the team. Please try again.');
    }
};
// Declining leaves the pending invite in place (the owner can still see it and the person
// can accept later); we just sign out and return to the login screen.
const $1d9fcaa0a6035698$var$controlDeclinePendingInvite = async function() {
    $1e7ab04ca7920cff$export$cdd63fa2413668d();
    await (0, $asfCf.supabase).auth.signOut({
        scope: 'local'
    });
    window.location.reload();
};
const $1d9fcaa0a6035698$var$_isInAppBrowser = ()=>{
    const ua = navigator.userAgent || '';
    if (/FBAN|FBAV|Instagram|Twitter|Line|MicroMessenger|Snapchat|TikTok/.test(ua)) return true;
    if (/iphone|ipad|ipod/i.test(ua) && !/safari/i.test(ua)) return true;
    if (/android/i.test(ua) && /wv/.test(ua)) return true;
    return false;
};
const $1d9fcaa0a6035698$var$controlGoogleSignIn = async function() {
    if ($1d9fcaa0a6035698$var$_isInAppBrowser()) {
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showGoogleInAppError(window.location.href);
        return;
    }
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setGoogleLoading(true);
    const { error: error } = await (0, $asfCf.supabase).auth.signInWithOAuth({
        provider: 'google',
        options: {
            redirectTo: window.location.origin + window.location.pathname
        }
    });
    if (error) {
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setGoogleLoading(false);
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showError(error.message);
    }
// On success, Supabase redirects the browser — no further code runs here.
};
// ── Two-Factor Authentication ─────────────────────────────────────────────────
let $1d9fcaa0a6035698$var$_enrollFactorId = null;
// Login gate. Returns true if it's OK to proceed (no 2FA on this account, or the
// code was verified), false if the user cancelled the prompt. Fails OPEN on an
// unexpected MFA-API error so a transient hiccup can't lock everyone out (2FA is
// opt-in - the security floor here is the password, which already passed).
const $1d9fcaa0a6035698$var$_enforceMFA = async function() {
    let aal;
    try {
        aal = await $1e7ab04ca7920cff$export$53fefec4c12ed9da();
    } catch  {
        return true;
    }
    // Only challenge when the session is password-only but a verified factor exists.
    if (!(aal?.currentLevel === 'aal1' && aal?.nextLevel === 'aal2')) return true;
    let factorId;
    try {
        ({ factorId: factorId } = await $1e7ab04ca7920cff$export$314505446d7496ac());
    } catch  {
        return true;
    }
    if (!factorId) return true;
    let error = null;
    let mode = 'totp';
    while(true){
        const res = await (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).promptMFACode({
            error: error,
            mode: mode
        });
        if (res === null) return false; // cancelled
        mode = res.type; // a failed attempt re-prompts in the SAME mode (recovery stays recovery)
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setMFALoading(true); // verify/redeem runs in the background - show it's working
        try {
            if (res.type === 'recovery') {
                // Burns the code + removes the lost factor server-side; the session is then
                // effectively 2FA-off, so the gate passes. Flag it so we can nudge a re-enroll.
                await $1e7ab04ca7920cff$export$bf9fe75a401bb30a(res.code);
                sessionStorage.setItem('pointbunny_2fa_recovered', '1');
            } else await $1e7ab04ca7920cff$export$71e1a6097078ed6f(factorId, res.code);
            (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).hideMFAPrompt();
            return true;
        } catch (err) {
            error = res.type === 'recovery' ? err?.message ?? "That recovery code didn't work. Check it and try again." : 'Incorrect or expired code. Try again.';
        }
    }
};
const $1d9fcaa0a6035698$var$_refresh2FA = async function() {
    try {
        const { enabled: enabled } = await $1e7ab04ca7920cff$export$314505446d7496ac();
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).render2FA(enabled);
    } catch  {
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).render2FA(false);
    }
};
const $1d9fcaa0a6035698$var$controlEnable2FA = async function() {
    try {
        const { factorId: factorId, qr: qr, secret: secret } = await $1e7ab04ca7920cff$export$da426774c04c0c7b();
        $1d9fcaa0a6035698$var$_enrollFactorId = factorId;
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).show2FAEnroll({
            qr: qr,
            secret: secret
        });
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not start two-factor setup.', 'error');
    }
};
const $1d9fcaa0a6035698$var$controlConfirm2FAEnroll = async function(code) {
    try {
        await $1e7ab04ca7920cff$export$1f3ea161e23a0000($1d9fcaa0a6035698$var$_enrollFactorId, code);
        $1d9fcaa0a6035698$var$_enrollFactorId = null;
        await $1d9fcaa0a6035698$var$_refresh2FA();
        // Recovery codes need a server round-trip. Keep the enroll modal up with a
        // spinner until they're ready so the user knows setup isn't finished and can't
        // wander off before the codes modal appears. If generation fails, 2FA is still
        // on - the user can regenerate by toggling off/on; surface the error either way.
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).set2FAEnrollBusy("Generating recovery codes\u2026");
        try {
            const codes = await $1e7ab04ca7920cff$export$f3bcad708b8fc74b();
            (0, $6e66866c6dedb838$export$2e2bcd8739ae039).hide2FAEnroll();
            (0, $6e66866c6dedb838$export$2e2bcd8739ae039).showRecoveryCodes(codes);
        } catch  {
            (0, $6e66866c6dedb838$export$2e2bcd8739ae039).hide2FAEnroll();
            $1d9fcaa0a6035698$var$showToast('Two-factor authentication enabled, but we could not generate recovery codes. Turn it off and on again to retry.', 'error');
        }
    } catch  {
        (0, $6e66866c6dedb838$export$2e2bcd8739ae039).set2FAEnrollError('Incorrect or expired code. Try again.');
    }
};
const $1d9fcaa0a6035698$var$controlDisable2FA = async function() {
    if (!confirm('Turn off two-factor authentication? Your account will no longer ask for a code at sign-in.')) return;
    try {
        const { factorId: factorId } = await $1e7ab04ca7920cff$export$314505446d7496ac();
        if (factorId) await $1e7ab04ca7920cff$export$c59e4b5a00864db6(factorId);
        await $1e7ab04ca7920cff$export$51dfe949467852e0();
        $1d9fcaa0a6035698$var$showToast('Two-factor authentication turned off.', 'success');
        await $1d9fcaa0a6035698$var$_refresh2FA();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not turn off two-factor authentication.', 'error');
    }
};
const $1d9fcaa0a6035698$var$controlSignIn = async function(email, password, captchaToken) {
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setLoading(true);
    const { data: data, error: error } = await (0, $asfCf.supabase).auth.signInWithPassword({
        email: email,
        password: password,
        options: {
            captchaToken: captchaToken
        }
    });
    if (error) {
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setLoading(false);
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showError(error.message);
        return;
    }
    // 2FA gate: if this account has two-factor on, require a valid code before we
    // load the app. Cancelling signs back out.
    const mfaOk = await $1d9fcaa0a6035698$var$_enforceMFA();
    if (!mfaOk) {
        await (0, $asfCf.supabase).auth.signOut({
            scope: 'local'
        });
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setLoading(false);
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showError('Two-factor verification was cancelled.');
        return;
    }
    await (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).playSignInSuccess();
    $1d9fcaa0a6035698$var$showLoadingScreen();
    try {
        await $1d9fcaa0a6035698$var$initApp(data.user);
    } catch (err) {
        if (err.code === 'PENDING_INVITE_CONSENT') {
            $1d9fcaa0a6035698$var$hideLoadingScreen();
            (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).show();
            (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showJoinTeam($1e7ab04ca7920cff$export$ca000e230c0caa3e.pendingInvites);
            return;
        }
        console.error('initApp failed:', err);
        $1d9fcaa0a6035698$var$hideLoadingScreen();
        await (0, $asfCf.supabase).auth.signOut({
            scope: 'local'
        });
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).show();
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showError([
            'STAFF_DEACTIVATED',
            'ADMIN_ACCOUNT',
            'SESSION_LIMIT_REACHED'
        ].includes(err.code) ? err.message : 'Something went wrong loading the app. Please try again.');
        return;
    }
    $1d9fcaa0a6035698$var$hideLoadingScreen();
    $1d9fcaa0a6035698$var$_wireApp();
    $1d9fcaa0a6035698$var$_showLaunchPrompts();
};
const $1d9fcaa0a6035698$var$controlSignUp = async function({ firstName: firstName, lastName: lastName, email: email, password: password, captchaToken: captchaToken }) {
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setSignUpLoading(true);
    // Carried in auth user_metadata (not read back until this user's first login, which may
    // happen on a different device once they confirm their email) - see sourceTracking.js.
    const storedSource = $924b6f34e17f8cba$export$fc9166d79258e815();
    const { data: data, error: error } = await (0, $asfCf.supabase).auth.signUp({
        email: email,
        password: password,
        options: {
            captchaToken: captchaToken,
            // Without this, Supabase falls back to the dashboard Site URL (app.pointbunny.com)
            // for the confirmation link regardless of where signup happened - which sent local
            // testing straight to production and skipped whatever code is only running locally.
            // Origin-relative, same pattern as resetClient.js's redirectTo and Google OAuth.
            emailRedirectTo: window.location.origin,
            data: {
                first_name: firstName,
                last_name: lastName,
                display_name: `${firstName} ${lastName}`,
                role: 'owner',
                source: storedSource?.source ?? null
            }
        }
    });
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setSignUpLoading(false);
    if (error) {
        const msg = /character of each|abcdefghijk/i.test(error.message) ? 'Password must include uppercase, lowercase, a number, and a special character.' : error.message;
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showSignUpError(msg);
        return;
    }
    // Supabase returns identities: [] (empty) when the email is already registered.
    // No error is thrown and no confirmation email is sent, leaving the user confused.
    if (data.user?.identities?.length === 0) {
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showSignUpError('An account with this email already exists. Please sign in instead.');
        return;
    }
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showCheckEmail(email);
};
// Source-tracking funnel: fired once, the first time the visitor types into the sign-up
// form. A no-op when there's no tracked source (organic signup - nothing to attribute).
const $1d9fcaa0a6035698$var$controlSourceFormStarted = function() {
    const stored = $924b6f34e17f8cba$export$fc9166d79258e815();
    if (!stored || $924b6f34e17f8cba$export$1b4002943059c46('form_started')) return;
    $924b6f34e17f8cba$export$9d8e583f7a5c46b6('form_started');
    $1e7ab04ca7920cff$export$bfea9f214c7ec36('form_started', {
        sourceId: stored.source,
        sessionId: $924b6f34e17f8cba$export$d7660cd936a72b71()
    });
};
const $1d9fcaa0a6035698$var$_handleStaffDeactivated = async function() {
    // Flag survives the reload so the login screen can explain why they were kicked out
    sessionStorage.setItem('pointbunny_deactivated', '1');
    await $1e7ab04ca7920cff$export$e0703741ca0737e0($1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    await (0, $asfCf.supabase).auth.signOut({
        scope: 'local'
    });
    window.location.reload();
};
// An owner changed this logged-in user's role. We keep them signed in but force a
// clean reload so initApp re-reads the new role and re-applies permission gating
// (hot-swapping role in already-rendered UI is error-prone). The flag lets us
// confirm with a toast after the reload.
let $1d9fcaa0a6035698$var$_roleChangeReloadPending = false;
const $1d9fcaa0a6035698$var$_handleStaffRoleChanged = function() {
    if ($1d9fcaa0a6035698$var$_roleChangeReloadPending) return;
    $1d9fcaa0a6035698$var$_roleChangeReloadPending = true;
    sessionStorage.setItem('pointbunny_role_changed', '1');
    $1d9fcaa0a6035698$var$showToast("Your access level was updated. Reloading\u2026", 'info');
    setTimeout(()=>window.location.reload(), 1400);
};
const $1d9fcaa0a6035698$var$controlSignOut = async function() {
    (0, $399d412ac621ced9$export$2e2bcd8739ae039).stop();
    const sweepEl = document.createElement('div');
    sweepEl.className = 'app-exit-sweep';
    sweepEl.innerHTML = '<span class="app-exit-label">Signing out\u2026</span>';
    document.body.appendChild(sweepEl);
    $1e7ab04ca7920cff$export$fe2712503435365b();
    // Free this tab's session slot immediately rather than waiting for the 3-minute
    // stale sweep, so the seat is available again right away.
    await $1e7ab04ca7920cff$export$e0703741ca0737e0($1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    // 'local' = this device only. supabase-js defaults to 'global', which revokes the
    // account's sessions on EVERY device - the other registers keep working until
    // their access token expires (~1h), then fail mid-shift ("permission denied for
    // function record_sale") and land on the login screen (2026-10-15).
    await (0, $asfCf.supabase).auth.signOut({
        scope: 'local'
    });
    setTimeout(()=>window.location.reload(), 500);
};
const $1d9fcaa0a6035698$var$controlForgotPassword = async function(email, captchaToken) {
    try {
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setForgotLoading(true);
        await $1e7ab04ca7920cff$export$ac9a70e2b35d6a5f(email, captchaToken);
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showForgotSent(email);
    } catch (err) {
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showForgotError(err.message ?? 'Something went wrong. Please try again.');
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).setForgotLoading(false);
    }
};
// Password reset is handled entirely on the standalone reset.html page (PKCE flow);
// the main app no longer has an in-SPA reset form or controller. See reset.js.
// ── Cashflow ──────────────────────────────────────────────────────────────────
// Business-day ranges (2026-10-25): "today", "this week", a month or a year are the CAFE's
// calendar days in the business timezone, not the device's. A device set to another zone
// (an owner's laptop in Manila) used to label Activity "Oct 26" and pull the wrong week.
// Calendar days are plain "YYYY-MM-DD" strings (scheduleTime.js helpers).
const $1d9fcaa0a6035698$var$_bizDateRange = function(fromStr, toStr) {
    const tz = $1d9fcaa0a6035698$var$_bizTz();
    const start = (0, $lDSCx.zonedToDate)(fromStr, '00:00', tz);
    const end = new Date((0, $lDSCx.zonedToDate)((0, $lDSCx.addDays)(toStr, 1), '00:00', tz).getTime() - 1);
    return {
        startISO: start.toISOString(),
        endISO: end.toISOString()
    };
};
// Label for a calendar day string, the same on every device.
const $1d9fcaa0a6035698$var$_dayStrLabel = (ds, opts)=>new Date(ds + 'T12:00:00Z').toLocaleDateString('en-US', {
        ...opts,
        timeZone: 'UTC'
    });
// First and last calendar day of month m (1-12; overflow rolls into the next/previous year).
const $1d9fcaa0a6035698$var$_monthBounds = function(y, m) {
    const ds = (d)=>d.toISOString().slice(0, 10);
    return {
        first: ds(new Date(Date.UTC(y, m - 1, 1))),
        last: (0, $lDSCx.addDays)(ds(new Date(Date.UTC(y, m, 1))), -1)
    };
};
// `offset` steps a Today / Week / Month / Year period back (-1, -2, ...) from
// the current one - the ‹ › arrows on Activity and Reports. 0 = current.
const $1d9fcaa0a6035698$var$_getCashflowRange = function(period, from, to, offset = 0) {
    const today = (0, $lDSCx.todayIn)($1d9fcaa0a6035698$var$_bizTz());
    const full = {
        month: "short",
        day: "numeric",
        year: "numeric"
    };
    const fmt = (ds)=>$1d9fcaa0a6035698$var$_dayStrLabel(ds, full);
    if (period === "today") {
        const day = (0, $lDSCx.addDays)(today, offset);
        const label = offset === 0 ? fmt(day) : offset === -1 ? `Yesterday \xb7 ${fmt(day)}` : fmt(day);
        return {
            ...$1d9fcaa0a6035698$var$_bizDateRange(day, day),
            label: label
        };
    }
    if (period === "yesterday") {
        const day = (0, $lDSCx.addDays)(today, -1);
        return {
            ...$1d9fcaa0a6035698$var$_bizDateRange(day, day),
            label: `Yesterday \xb7 ${fmt(day)}`
        };
    }
    if (period === "week") {
        const monday = (0, $lDSCx.addDays)((0, $lDSCx.mondayOf)(today), offset * 7);
        const sunday = (0, $lDSCx.addDays)(monday, 6);
        return {
            ...$1d9fcaa0a6035698$var$_bizDateRange(monday, sunday),
            label: `${fmt(monday)} \u{2013} ${fmt(sunday)}`
        };
    }
    if (period === "month") {
        const [y, m] = today.split("-").map(Number);
        const { first: first, last: last } = $1d9fcaa0a6035698$var$_monthBounds(y, m + offset);
        return {
            ...$1d9fcaa0a6035698$var$_bizDateRange(first, last),
            label: $1d9fcaa0a6035698$var$_dayStrLabel(first, {
                month: "long",
                year: "numeric"
            })
        };
    }
    if (period === "year") {
        const year = Number(today.slice(0, 4)) + offset;
        return {
            ...$1d9fcaa0a6035698$var$_bizDateRange(`${year}-01-01`, `${year}-12-31`),
            label: String(year)
        };
    }
    // custom: the picked calendar days, at the cafe.
    return {
        ...$1d9fcaa0a6035698$var$_bizDateRange(from, to),
        label: `${fmt(from)} \u{2013} ${fmt(to)}`
    };
};
const $1d9fcaa0a6035698$var$_cashflowSummary = ()=>{
    const gross = $1d9fcaa0a6035698$var$modelState.cashflowSales.reduce((s, r)=>s + Number(r.total_price), 0);
    const expenses = $1d9fcaa0a6035698$var$modelState.expenses.reduce((s, e)=>s + e.amount, 0);
    // Tips are owed to staff, so they're shown on their own and never counted
    // in revenue or net income. The card shows while tips are on, or whenever
    // the period has any (tips turned off later still show their history).
    const tips = $1d9fcaa0a6035698$var$modelState.cashflowSales.reduce((s, r)=>s + Number(r.tip_amount ?? 0), 0);
    const showTips = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipsEnabled === true || tips > 0;
    return {
        gross: gross,
        expenses: expenses,
        net: gross - expenses,
        tips: tips,
        showTips: showTips
    };
};
const $1d9fcaa0a6035698$var$_cashflowCanEdit = ()=>$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_cashflow');
// ── Cashflow period cache ─────────────────────────────────────────────────────
// Stores fetched results per period key so switching periods doesn't re-fetch.
// 'today' is intentionally never cached — it changes throughout the day.
// The entire cache is cleared on any data mutation (new sale, void, expense).
const $1d9fcaa0a6035698$var$_cashflowCache = new Map();
const $1d9fcaa0a6035698$var$_cfCacheKey = (period, from, to, offset = 0)=>period === 'custom' ? `custom:${from}:${to}` : `${period}:${offset}`;
const $1d9fcaa0a6035698$var$_clearCashflowCache = ()=>$1d9fcaa0a6035698$var$_cashflowCache.clear();
const $1d9fcaa0a6035698$var$_staffCanManage = ()=>$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_staff');
// Applies role-based gating to the static DOM after login. Two mechanisms:
//   [data-perm="key"]         → hidden entirely when the role lacks the capability
//                               (nav into areas the role can't enter)
//   [data-perm-disable="key"] → kept visible but disabled + a "no access" title
//                               (controls inside a panel the role can partly use)
// This is cosmetic UX only; every open handler re-checks hasPermission and RLS
// enforces at the database. Re-run after injecting gated markup at runtime.
const $1d9fcaa0a6035698$var$_ROLE_RANK = {
    Cashier: 1,
    Manager: 2,
    Admin: 3
};
const $1d9fcaa0a6035698$var$_applyPermissionGates = function(root = document) {
    root.querySelectorAll('[data-perm]').forEach((el)=>{
        el.classList.toggle('perm-hidden', !$1e7ab04ca7920cff$export$b325ec6732b039cf(el.dataset.perm));
    });
    // Legacy tier gate for the few settings/display toggles that don't map to a named
    // capability (e.g. the customer-display ad image, manager+). Hidden when the
    // current role ranks below the element's minimum role.
    root.querySelectorAll('[data-min-role]').forEach((el)=>{
        const need = $1d9fcaa0a6035698$var$_ROLE_RANK[el.dataset.minRole.charAt(0).toUpperCase() + el.dataset.minRole.slice(1)] ?? 99;
        const have = $1d9fcaa0a6035698$var$_ROLE_RANK[$1e7ab04ca7920cff$export$ca000e230c0caa3e.role] ?? 0;
        el.classList.toggle('perm-hidden', have < need);
    });
    root.querySelectorAll('[data-perm-disable]').forEach((el)=>{
        const denied = !$1e7ab04ca7920cff$export$b325ec6732b039cf(el.dataset.permDisable);
        el.classList.toggle('perm-disabled', denied);
        el.setAttribute('aria-disabled', String(denied));
        if (el.matches('button, input, select, textarea, fieldset')) el.disabled = denied;
        if (denied && el.dataset.permMsg) el.title = el.dataset.permMsg;
    });
    // Elements that stay visible but lose their click-through action without the
    // capability (e.g. dashboard stat cards that shortcut into Reports). We strip the
    // interactive affordance so they no longer look clickable; the bound listener is
    // already a no-op without the permission.
    root.querySelectorAll('[data-perm-action]').forEach((el)=>{
        const denied = !$1e7ab04ca7920cff$export$b325ec6732b039cf(el.dataset.permAction);
        el.classList.toggle('perm-inert', denied);
        if (denied) {
            el.removeAttribute('role');
            el.removeAttribute('tabindex');
            el.removeAttribute('title');
        } else {
            el.setAttribute('role', 'button');
            el.setAttribute('tabindex', '0');
        }
    });
};
// Toggles the "PRO" badge on any nav item marked [data-plan-badge="<feature>"]
// (see model.PLAN_GATED_FEATURES for valid keys). Re-run on boot and whenever
// the realtime plan-change listener fires, so an admin override flips this live.
const $1d9fcaa0a6035698$var$_applyPlanGateUI = function(root = document) {
    const paid = $1e7ab04ca7920cff$export$9e608bbc985290d4(); // unlocked: real paid OR an active trial/grant
    const isRealPaid = $1e7ab04ca7920cff$export$ca000e230c0caa3e.subscriptionStatus === 'paid';
    const trialActive = $1e7ab04ca7920cff$export$8e5b3aa3ef378964();
    document.body.classList.toggle('plan-free', !paid);
    root.querySelectorAll('[data-plan-badge]').forEach((el)=>{
        el.hidden = !$1e7ab04ca7920cff$export$57b484963858c9a0(el.dataset.planBadge);
    });
    const pill = document.querySelector('#settingsPlanPill');
    if (pill) {
        pill.classList.remove('plan-pill--paid', 'plan-pill--trial', 'plan-pill--extended');
        if (isRealPaid) {
            pill.textContent = 'Paid';
            pill.classList.add('plan-pill--paid');
        } else if (trialActive && $1e7ab04ca7920cff$export$ca000e230c0caa3e.trialGrantedBy) {
            pill.textContent = 'Extended Access';
            pill.classList.add('plan-pill--extended');
        } else if (trialActive) {
            pill.textContent = 'Free Trial';
            pill.classList.add('plan-pill--trial');
        } else pill.textContent = 'Free';
    }
    const hint = document.querySelector('#settingsPlanHint');
    if (hint) {
        if (isRealPaid) hint.textContent = "You're on Pointbunny Pro. Thanks for supporting us!";
        else if (trialActive) {
            const daysLeft = Math.max(1, Math.ceil((new Date($1e7ab04ca7920cff$export$ca000e230c0caa3e.trialEndsAt) - new Date()) / 86400000));
            const dayWord = daysLeft === 1 ? 'day' : 'days';
            // Checkout bills immediately and unused trial days don't carry over (the
            // trial is ours, card-free, not a Lemon Squeezy trial), so gently suggest
            // waiting - without blocking anyone who wants to upgrade now.
            hint.textContent = $1e7ab04ca7920cff$export$ca000e230c0caa3e.trialGrantedBy ? `You have ${daysLeft} ${dayWord} left of extended access to every feature. Billing starts the day you upgrade and unused days don't carry over, so we suggest waiting until it ends. It's totally up to you.` : `You have ${daysLeft} ${dayWord} left in your free trial of every feature. Billing starts the day you upgrade and unused trial days don't carry over, so we suggest waiting until it ends. It's totally up to you.`;
        } else hint.textContent = "Inventory, Timesheets, Loyalty, and full Reports are unlocked on the paid plan.";
    }
    // The upgrade CTA stays visible through an active trial/grant (not just when
    // locked) so someone can convert early before it expires - only a REAL paid
    // subscription hides it. Same rule for the navbar CTA below.
    document.querySelector('#settingsPlanUpgradeBtn')?.classList.toggle('hidden', isRealPaid);
    const navUpgradeBtn = document.querySelector('#navUpgradeBtn');
    if (navUpgradeBtn) {
        navUpgradeBtn.classList.toggle('hidden', isRealPaid);
        navUpgradeBtn.title = trialActive ? "Upgrade to Pointbunny Pro - billing starts today and unused trial days don't carry over" : 'Upgrade to Pointbunny Pro';
    }
    // Real-paid-only confirmation card (replaces the old always-"Coming soon"
    // placeholder - see index.html comment). Free/trial show nothing here.
    document.querySelector('#settingsPaymentConfirmed')?.classList.toggle('hidden', !isRealPaid);
    const renewalHint = document.querySelector('#settingsPlanRenewalHint');
    if (renewalHint) {
        const renewsAt = isRealPaid ? $1e7ab04ca7920cff$export$ca000e230c0caa3e.subscriptionRenewsAt : null;
        if (renewsAt) {
            const formatted = new Date(renewsAt).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
            renewalHint.textContent = `Renews ${formatted}`;
            renewalHint.classList.remove('hidden');
        } else renewalHint.classList.add('hidden');
    }
    const portalLink = document.querySelector('#settingsPlanPortalLink');
    if (portalLink) {
        const portalUrl = $1e7ab04ca7920cff$export$ca000e230c0caa3e.subscriptionPortalUrl;
        portalLink.href = portalUrl ?? '#';
        portalLink.classList.toggle('hidden', !portalUrl);
    }
};
// ── Upgrade celebration ──────────────────────────────────────────────────────
// Fired once by subscribeToPlanChanges' realtime listener the moment a real
// upgrade lands. The checkout happens in a NEW tab (see controlUpgradeClick) -
// this original tab is typically hidden/backgrounded while that's happening, so
// showing the celebration the instant the webhook event arrives would play it
// to an empty screen. Same deferred-while-hidden pattern as the activity feed
// above (_activityDirty): stash a pending flag if hidden, and the shared
// visibilitychange listener fires it the moment the owner actually looks back
// at this tab - never on the checkout tab, never mid-purchase.
let $1d9fcaa0a6035698$var$_upgradeCelebrationPending = false;
// Small vanilla-canvas confetti burst - no library needed for a one-off effect
// like this. Skipped entirely under prefers-reduced-motion (same convention as
// the roll-up animation above). Canvas removes itself once every piece has
// fallen off-screen or faded out.
const $1d9fcaa0a6035698$var$_fireConfetti = function() {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    const canvas = document.createElement('canvas');
    canvas.className = 'upgrade-confetti-canvas';
    const dpr = window.devicePixelRatio || 1;
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    document.body.appendChild(canvas);
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    const COLORS = [
        '#7C3AED',
        '#A855F7',
        '#C084FC',
        '#F472B6',
        '#FBBF24',
        '#34D399'
    ];
    const pieces = Array.from({
        length: 140
    }, ()=>({
            x: window.innerWidth / 2 + (Math.random() - 0.5) * 120,
            y: 100 + (Math.random() - 0.5) * 20,
            vx: (Math.random() - 0.5) * 9,
            vy: -(Math.random() * 9 + 4),
            size: Math.random() * 7 + 4,
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
            rotation: Math.random() * 360,
            spin: (Math.random() - 0.5) * 14,
            shape: Math.random() < 0.5 ? 'rect' : 'circle'
        }));
    const gravity = 0.28;
    const drag = 0.992;
    const startedAt = performance.now();
    const tick = (now)=>{
        const elapsed = now - startedAt;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        let anyAlive = false;
        for (const p of pieces){
            p.vx *= drag;
            p.vy = p.vy * drag + gravity;
            p.x += p.vx;
            p.y += p.vy;
            p.rotation += p.spin;
            const fadeStart = 2200;
            const opacity = elapsed < fadeStart ? 1 : Math.max(0, 1 - (elapsed - fadeStart) / 900);
            if (p.y > window.innerHeight + 20 || opacity <= 0) continue;
            anyAlive = true;
            ctx.save();
            ctx.globalAlpha = opacity;
            ctx.translate(p.x, p.y);
            ctx.rotate(p.rotation * Math.PI / 180);
            ctx.fillStyle = p.color;
            if (p.shape === 'rect') ctx.fillRect(-p.size / 2, -p.size / 3, p.size, p.size * 0.6);
            else {
                ctx.beginPath();
                ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
                ctx.fill();
            }
            ctx.restore();
        }
        if (anyAlive) requestAnimationFrame(tick);
        else canvas.remove();
    };
    requestAnimationFrame(tick);
};
const $1d9fcaa0a6035698$var$_showUpgradeCelebration = function() {
    const el = document.createElement('div');
    el.className = 'upgrade-celebration';
    el.innerHTML = `
    <button class="upgrade-celebration-close" type="button" aria-label="Dismiss">&times;</button>
    <span class="upgrade-celebration-icon" aria-hidden="true">\u{1F389}</span>
    <div class="upgrade-celebration-text">
      <p class="upgrade-celebration-title">You're on Pointbunny Pro!</p>
      <p class="upgrade-celebration-sub">Here's to your best sales yet.</p>
    </div>`;
    document.body.appendChild(el);
    const dismiss = ()=>{
        el.classList.remove('upgrade-celebration--visible');
        el.addEventListener('transitionend', ()=>el.remove(), {
            once: true
        });
    };
    el.querySelector('.upgrade-celebration-close').addEventListener('click', dismiss);
    requestAnimationFrame(()=>el.classList.add('upgrade-celebration--visible'));
    $1d9fcaa0a6035698$var$_fireConfetti();
    setTimeout(dismiss, 6000);
};
const $1d9fcaa0a6035698$var$_celebrateUpgrade = function() {
    if (document.hidden) {
        $1d9fcaa0a6035698$var$_upgradeCelebrationPending = true;
        return;
    }
    $1d9fcaa0a6035698$var$_showUpgradeCelebration();
};
document.addEventListener('visibilitychange', ()=>{
    if (!document.hidden && $1d9fcaa0a6035698$var$_upgradeCelebrationPending) {
        $1d9fcaa0a6035698$var$_upgradeCelebrationPending = false;
        $1d9fcaa0a6035698$var$_showUpgradeCelebration();
    }
});
// Opens Lemon Squeezy checkout in a new tab (Merchant of Record - handles global
// card processing + tax so the business's own PH residency is irrelevant). The
// client never marks itself as paid; the lemonsqueezy-webhook Edge Function is the
// only writer of businesses.subscription_status, driven by a real payment event.
// The original tab isn't navigated away from mid-shift - subscribeToPlanChanges'
// realtime listener flips the UI live here the moment the webhook lands, so the
// new tab's post-checkout redirect back to "/" is a nice landing page, not load-
// bearing. Blank env var (local dev / pre-launch) falls back to the old placeholder
// toast - same graceful no-op posture as turnstile.js's SITE_KEY.
const $1d9fcaa0a6035698$var$controlUpgradeClick = function(feature) {
    const base = "https://pointbunny.lemonsqueezy.com/checkout/buy/97762668-edd5-4b9a-8e0e-a4546e0691de";
    if (!base) {
        $1d9fcaa0a6035698$var$showToast("Upgrades aren't live yet - we'll let you know the moment they are!", 'info');
        return;
    }
    const url = new URL(base);
    url.searchParams.set('checkout[custom][business_id]', $1e7ab04ca7920cff$export$ca000e230c0caa3e.businessId);
    url.searchParams.set('checkout[email]', $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.email ?? '');
    url.searchParams.set('checkout[redirect_url]', window.location.origin + '/');
    window.open(url.toString(), '_blank', 'noopener');
};
let $1d9fcaa0a6035698$var$_currentReportsPeriod = {
    period: 'today'
};
let $1d9fcaa0a6035698$var$_currentPrevTotals = null;
let $1d9fcaa0a6035698$var$_selectedOverviewMetrics = new Set();
let $1d9fcaa0a6035698$var$_overviewTimeSeries = null;
const $1d9fcaa0a6035698$var$METRIC_COLORS = {
    revenue: '#22c55e',
    expenses: '#ef4444',
    net: '#3b82f6',
    transactions: '#8b5cf6',
    avgOrder: '#f59e0b'
};
const $1d9fcaa0a6035698$var$METRIC_LABELS = {
    revenue: 'Gross Income',
    expenses: 'Expenses',
    net: 'Net Income',
    transactions: 'Transactions',
    avgOrder: 'Avg. Order'
};
const $1d9fcaa0a6035698$var$_reportsExpenseSummary = ()=>{
    const gross = ($1d9fcaa0a6035698$var$modelState.cashflowSales ?? []).reduce((s, r)=>s + Number(r.total_price), 0);
    const expenses = ($1d9fcaa0a6035698$var$modelState.expenses ?? []).reduce((s, e)=>s + e.amount, 0);
    return {
        gross: gross,
        expenses: expenses,
        net: gross - expenses
    };
};
let $1d9fcaa0a6035698$var$_currentCashflowPeriod = {
    period: "today"
};
const $1d9fcaa0a6035698$var$_renderCashflowLists = ()=>{
    const canEdit = $1d9fcaa0a6035698$var$_cashflowCanEdit();
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderSalesList($1d9fcaa0a6035698$var$modelState.cashflowSales, canEdit);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderExpensesList($1d9fcaa0a6035698$var$modelState.expenses, canEdit);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderVoidedList($1d9fcaa0a6035698$var$modelState.voidedSales, canEdit);
};
const $1d9fcaa0a6035698$var$controlOpenCashflow = async function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_cashflow')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to activity.", 'error');
        return;
    }
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).open($1d9fcaa0a6035698$var$_cashflowCanEdit());
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderLoading();
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).setLoading(true);
    try {
        $1d9fcaa0a6035698$var$_currentCashflowPeriod = {
            period: "today",
            offset: 0
        };
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).setStepper("today", 0);
        const { startISO: startISO, endISO: endISO, label: label } = $1d9fcaa0a6035698$var$_getCashflowRange("today");
        await $1e7ab04ca7920cff$export$4f704ada9f12295b(startISO, endISO);
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).setPeriodLabel(label);
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderSummary($1d9fcaa0a6035698$var$_cashflowSummary());
        $1d9fcaa0a6035698$var$_renderCashflowLists();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    } finally{
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).setLoading(false);
    }
};
// Another terminal recorded or voided a sale: refetch this terminal's revenue
// views - the home Sales + Transactions cards, and the Cashflow panel if open.
// Without this they stayed at the old totals until a reload (2026-10-15).
const $1d9fcaa0a6035698$var$_syncRevenueFromOtherTerminal = function() {
    $1d9fcaa0a6035698$var$_clearCashflowCache();
    $1d9fcaa0a6035698$var$refreshTodaySalesDisplay();
    const txnsP = $1e7ab04ca7920cff$export$54cb0d704712bfd().catch(()=>null);
    $1d9fcaa0a6035698$var$_enqueueDashAnim(()=>$1d9fcaa0a6035698$var$_animateTxnsStep(txnsP));
    $1d9fcaa0a6035698$var$_refreshOpenCashflow();
};
// Quietly re-fetch the period the open Cashflow panel shows (no loading skeleton,
// so it doesn't blink). If the user switched periods mid-fetch, the shared
// cashflow state may now hold this stale fetch - reload their selection instead.
const $1d9fcaa0a6035698$var$_refreshOpenCashflow = async function() {
    if (document.getElementById('cashflowPanel')?.classList.contains('hidden')) return;
    const p = $1d9fcaa0a6035698$var$_currentCashflowPeriod;
    const { startISO: startISO, endISO: endISO } = $1d9fcaa0a6035698$var$_getCashflowRange(p.period, p.from, p.to, p.offset ?? 0);
    try {
        await $1e7ab04ca7920cff$export$4f704ada9f12295b(startISO, endISO);
    } catch  {
        return;
    }
    if ($1d9fcaa0a6035698$var$_currentCashflowPeriod !== p) {
        $1d9fcaa0a6035698$var$controlChangePeriod($1d9fcaa0a6035698$var$_currentCashflowPeriod);
        return;
    }
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderSummary($1d9fcaa0a6035698$var$_cashflowSummary());
    $1d9fcaa0a6035698$var$_renderCashflowLists();
};
const $1d9fcaa0a6035698$var$controlCloseCashflow = function() {
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).close();
};
let $1d9fcaa0a6035698$var$_cashflowReq = 0; // newest Activity range request; older answers are dropped
const $1d9fcaa0a6035698$var$controlChangePeriod = async function({ period: period, from: from, to: to, offset: offset = 0 }) {
    $1d9fcaa0a6035698$var$_currentCashflowPeriod = {
        period: period,
        from: from,
        to: to,
        offset: offset
    };
    const { startISO: startISO, endISO: endISO, label: label } = $1d9fcaa0a6035698$var$_getCashflowRange(period, from, to, offset);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).setActivePeriod(period);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).setStepper(period, offset);
    // Cache hit — restore instantly from memory, no network round-trip
    // The current period is always re-fetched (live data changes throughout the
    // day); a past day/week/month/year is cached.
    const live = offset === 0 && period !== 'custom';
    const key = $1d9fcaa0a6035698$var$_cfCacheKey(period, from, to, offset);
    const cached = !live ? $1d9fcaa0a6035698$var$_cashflowCache.get(key) : null;
    if (cached) {
        $1d9fcaa0a6035698$var$modelState.cashflowSales = cached.sales;
        $1d9fcaa0a6035698$var$modelState.expenses = cached.expenses;
        $1d9fcaa0a6035698$var$modelState.voidedSales = cached.voidedSales;
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).setPeriodLabel(label);
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderSummary($1d9fcaa0a6035698$var$_cashflowSummary());
        $1d9fcaa0a6035698$var$_renderCashflowLists();
        return;
    }
    // Cache miss — fetch from Supabase. The new label shows right away and the totals dim
    // while loading, so the old period's numbers never pass for the new one (2026-10-25).
    const isHeavy = period === 'year';
    const req = ++$1d9fcaa0a6035698$var$_cashflowReq;
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).setPeriodLabel(label);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderLoading();
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).setLoading(true);
    if (isHeavy) (0, $1d1221278b545f23$export$2e2bcd8739ae039).setHeavyLoadNotice(true);
    try {
        await $1e7ab04ca7920cff$export$4f704ada9f12295b(startISO, endISO);
        if (req !== $1d9fcaa0a6035698$var$_cashflowReq) return; // a newer range was picked while this one loaded
        // Store in cache (never the current period - it changes with every new sale)
        if (!live) $1d9fcaa0a6035698$var$_cashflowCache.set(key, {
            sales: $1d9fcaa0a6035698$var$modelState.cashflowSales,
            expenses: $1d9fcaa0a6035698$var$modelState.expenses,
            voidedSales: $1d9fcaa0a6035698$var$modelState.voidedSales
        });
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).setPeriodLabel(label);
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderSummary($1d9fcaa0a6035698$var$_cashflowSummary());
        $1d9fcaa0a6035698$var$_renderCashflowLists();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
        if (req === $1d9fcaa0a6035698$var$_cashflowReq) (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderSummary($1d9fcaa0a6035698$var$_cashflowSummary()); // undim
    } finally{
        if (req === $1d9fcaa0a6035698$var$_cashflowReq) {
            (0, $1d1221278b545f23$export$2e2bcd8739ae039).setLoading(false);
            if (isHeavy) (0, $1d1221278b545f23$export$2e2bcd8739ae039).setHeavyLoadNotice(false);
        }
    }
};
const $1d9fcaa0a6035698$var$_refreshReportsExpenses = ()=>{
    if (document.getElementById("reportsPanel")?.classList.contains("hidden")) return;
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderExpenseKpis($1d9fcaa0a6035698$var$_reportsExpenseSummary());
};
const $1d9fcaa0a6035698$var$controlAddExpense = async function(data) {
    try {
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).setSubmitting(true);
        await $1e7ab04ca7920cff$export$6ca62e590a866144(data);
        $1d9fcaa0a6035698$var$_clearCashflowCache();
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).hideExpenseModal();
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderSummary($1d9fcaa0a6035698$var$_cashflowSummary());
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderExpensesList($1d9fcaa0a6035698$var$modelState.expenses, $1d9fcaa0a6035698$var$_cashflowCanEdit());
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).scrollExpensesToTop();
        $1d9fcaa0a6035698$var$_refreshReportsExpenses();
        $1d9fcaa0a6035698$var$_refreshHomeExpensesToday();
        $1d9fcaa0a6035698$var$_requestActivityRefresh();
        $1d9fcaa0a6035698$var$showToast("Expense added.", "success");
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    } finally{
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).setSubmitting(false);
    }
};
// ── Timezone-aware date helpers ───────────────────────────────────────────────
// Returns { start: Date, end: Date } for the calendar day that contains `date`
// in the business's configured IANA timezone (falls back to browser timezone).
const $1d9fcaa0a6035698$var$_dayBoundsInTz = function(date, tz) {
    // Format the date as "YYYY-MM-DD HH:mm:ss" in the target timezone (sv-SE gives ISO-style output)
    const dtStr = new Intl.DateTimeFormat('sv-SE', {
        timeZone: tz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).format(date).replace(' ', 'T');
    // Compute UTC offset by comparing tz-local time (treated as UTC) vs actual UTC ms
    const offsetMs = date.getTime() - new Date(dtStr + 'Z').getTime();
    const dayStr = dtStr.slice(0, 10); // "YYYY-MM-DD"
    const startMs = new Date(dayStr + 'T00:00:00Z').getTime() + offsetMs;
    return {
        start: new Date(startMs),
        end: new Date(startMs + 86400000 - 1)
    };
};
const $1d9fcaa0a6035698$var$_getBizDayBounds = function(date = new Date()) {
    const tz = $1e7ab04ca7920cff$export$74881ed03683ce30();
    return $1d9fcaa0a6035698$var$_dayBoundsInTz(date, tz);
};
const $1d9fcaa0a6035698$var$_isToday = (isoStr)=>{
    const d = new Date(isoStr);
    const { start: start, end: end } = $1d9fcaa0a6035698$var$_getBizDayBounds();
    return d >= start && d <= end;
};
// `client`: the approver's session for an override void (see model.voidSale).
const $1d9fcaa0a6035698$var$_executeVoid = async function(id, voidedBy, client) {
    const { wasInQueue: wasInQueue } = await $1e7ab04ca7920cff$export$14a211d2708579d7(id, voidedBy, client);
    // Restore the stock this sale consumed by replaying its own adjustment log
    // rows (exact even if the recipe changed since; no-op for pre-inventory
    // sales). Fire-and-forget - the void itself is already committed.
    $1e7ab04ca7920cff$export$d49903b08baa44e3(id, voidedBy).then(()=>$1e7ab04ca7920cff$export$45aba0c57314d190()).then(()=>{
        (0, $472fec5536166250$export$2e2bcd8739ae039).updateStockBadges($1e7ab04ca7920cff$export$916349a6610ebe78());
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).INVENTORY_SYNC
        });
    }).catch(()=>{});
    // Return the sale's loyalty points (earned taken back, redeemed refunded) by
    // replaying its own ledger rows. Server-side no-op for sales without loyalty
    // rows, so this is safe to call unconditionally. Fire-and-forget.
    $1e7ab04ca7920cff$export$b2d79cd72ab37b14(id).catch(()=>{});
    $1d9fcaa0a6035698$var$_clearCashflowCache();
    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).KDS_ORDER_VOIDED,
        id: id
    });
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderSummary($1d9fcaa0a6035698$var$_cashflowSummary());
    $1d9fcaa0a6035698$var$_renderCashflowLists();
    const voided = $1d9fcaa0a6035698$var$modelState.voidedSales.find((s)=>s.id === id);
    if (voided && $1d9fcaa0a6035698$var$_isToday(voided.sale_date)) {
        $1d9fcaa0a6035698$var$refreshTodaySalesDisplay();
        if (wasInQueue && $1d9fcaa0a6035698$var$_todayTransactionCount !== null) {
            $1d9fcaa0a6035698$var$_todayTransactionCount = Math.max(0, $1d9fcaa0a6035698$var$_todayTransactionCount - 1);
            $1d9fcaa0a6035698$var$_updateTransactionBadge();
        }
    }
    $1d9fcaa0a6035698$var$_requestActivityRefresh();
    $1d9fcaa0a6035698$var$showToast('Transaction voided.', 'success');
};
const $1d9fcaa0a6035698$var$controlVoidTransaction = function(id) {
    const doVoid = async (voidedBy)=>{
        try {
            await $1d9fcaa0a6035698$var$_executeVoid(id, voidedBy);
        } catch (err) {
            $1d9fcaa0a6035698$var$showToast(err.message ?? err);
        }
    };
    if ($1e7ab04ca7920cff$export$b325ec6732b039cf('void_sale')) (0, $1d1221278b545f23$export$2e2bcd8739ae039).showConfirmModal({
        message: 'Void this transaction? It will be removed from reports and the active queue. This cannot be undone.',
        confirmLabel: 'Void',
        cancelLabel: 'Cancel',
        onConfirm: ()=>doVoid([
                $1d9fcaa0a6035698$var$modelState.currentStaff?.firstName,
                $1d9fcaa0a6035698$var$modelState.currentStaff?.lastName
            ].filter(Boolean).join(' ') || 'Admin')
    });
    else (0, $1d1221278b545f23$export$2e2bcd8739ae039).showOverrideModal(async (email, password, mfaCode)=>{
        try {
            const captchaToken = await (0, $3kKUy.getTokenInteractive)();
            // The void is written under the approver's login (the database only takes a
            // void from an account that may void), then the rest runs as usual.
            await $1e7ab04ca7920cff$export$b1d9775b76ee4d04(email, password, 'void_sale', captchaToken, mfaCode, (approverClient, staffName)=>$1d9fcaa0a6035698$var$_executeVoid(id, staffName, approverClient));
            (0, $1d1221278b545f23$export$2e2bcd8739ae039).hideOverrideModal();
        } catch (err) {
            if (err.code === 'MFA_REQUIRED') (0, $1d1221278b545f23$export$2e2bcd8739ae039).showOverrideMfa();
            (0, $1d1221278b545f23$export$2e2bcd8739ae039).setOverrideError(err.message ?? 'Authorization failed.');
        }
    });
};
const $1d9fcaa0a6035698$var$_generateAndDownloadCSV = function() {
    const periodLabel = document.querySelector("#cashflowPeriodLabel")?.textContent ?? "cashflow";
    const safeLabel = periodLabel.replace(/[^a-z0-9]/gi, "-").toLowerCase();
    const fmtDate = (iso)=>new Date(iso).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            timeZone: $1d9fcaa0a6035698$var$_bizTz()
        });
    const fmtTime = (iso)=>new Date(iso).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            timeZone: $1d9fcaa0a6035698$var$_bizTz()
        });
    // A cell starting with = + - @ (or a tab/CR) is a live formula to Excel/Sheets
    // even inside quotes - prefix with ' so a malicious item/customer name (e.g.
    // from CSV import) can't execute as a formula when this export is reopened.
    const escape = (val)=>{
        let s = String(val ?? "");
        // A real signed amount ("+123.45"/"-25.00") must stay a plain number so
        // Excel/Sheets can still sum the column - only guard non-numeric formula shapes.
        if (/^[=+\-@\t\r]/.test(s) && !Number.isFinite(Number(s))) s = `'${s}`;
        return `"${s.replace(/"/g, '""')}"`;
    };
    const salesRows = ($1d9fcaa0a6035698$var$modelState.cashflowSales ?? []).map((s)=>({
            date: s.sale_date,
            row: [
                fmtDate(s.sale_date),
                fmtTime(s.sale_date),
                "Sale",
                (s.items ?? []).map((i)=>`${i.itemName} x${i.quantity}`).join("; "),
                "",
                `+${Number(s.total_price).toFixed(2)}`,
                Number(s.tip_amount ?? 0).toFixed(2),
                s.is_manual ? "Yes" : "No",
                s.added_by ?? ""
            ]
        }));
    const expenseRows = ($1d9fcaa0a6035698$var$modelState.expenses ?? []).map((e)=>({
            date: e.expenseDate,
            row: [
                fmtDate(e.expenseDate),
                fmtTime(e.expenseDate),
                "Expense",
                e.description,
                e.category ?? "",
                `-${e.amount.toFixed(2)}`,
                "",
                "No",
                e.createdBy
            ]
        }));
    const allRows = [
        ...salesRows,
        ...expenseRows
    ].sort((a, b)=>new Date(a.date) - new Date(b.date)).map((r)=>r.row);
    const header = [
        "Date",
        "Time",
        "Type",
        "Description",
        "Category",
        "Amount",
        "Tip",
        "Manual Entry",
        "Added By"
    ];
    const csv = [
        header,
        ...allRows
    ].map((row)=>row.map(escape).join(",")).join("\n");
    const blob = new Blob([
        "\uFEFF" + csv
    ], {
        type: "text/csv;charset=utf-8;"
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `cashflow-${safeLabel}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};
const $1d9fcaa0a6035698$var$controlExportCSV = function() {
    const sales = $1d9fcaa0a6035698$var$modelState.cashflowSales ?? [];
    const expenses = $1d9fcaa0a6035698$var$modelState.expenses ?? [];
    const periodLabel = document.querySelector("#cashflowPeriodLabel")?.textContent ?? "this period";
    if (!sales.length && !expenses.length) {
        $1d9fcaa0a6035698$var$showToast("No data to export for this period.", "info");
        return;
    }
    const salesLine = sales.length ? `${sales.length} sale${sales.length !== 1 ? "s" : ""}` : "";
    const expenseLine = expenses.length ? `${expenses.length} expense${expenses.length !== 1 ? "s" : ""}` : "";
    const summary = [
        salesLine,
        expenseLine
    ].filter(Boolean).join(" and ");
    (0, $1d1221278b545f23$export$2e2bcd8739ae039).showConfirmModal({
        message: `Export ${summary} for "${periodLabel}" as a CSV file?`,
        confirmLabel: "Download CSV",
        cancelLabel: "Cancel",
        onConfirm: $1d9fcaa0a6035698$var$_generateAndDownloadCSV
    });
};
const $1d9fcaa0a6035698$var$controlReprintSale = async function(sale) {
    const mapped = {
        date: sale.sale_date,
        receiptNumber: sale.receipt_number ?? null,
        showInvoiceNumber: $1d9fcaa0a6035698$var$modelState.settings.showInvoiceNumber !== false,
        ticketNumber: sale.ticket_number ?? null,
        showTicketNumber: $1d9fcaa0a6035698$var$modelState.settings.showTicketNumber !== false,
        showBusinessPhone: $1d9fcaa0a6035698$var$modelState.settings.showBusinessPhone !== false,
        receiptFooter: $1d9fcaa0a6035698$var$modelState.settings.receiptFooter || '',
        receiptQrUrl: $1d9fcaa0a6035698$var$modelState.settings.receiptQrUrl || '',
        taxInclusiveRate: sale.tax_inclusive_rate ?? null,
        orderType: sale.order_type ?? null,
        items: sale.items ?? [],
        adjustments: (sale.adjustments ?? []).filter((a)=>!a.removed).map((a)=>({
                ...a,
                computedAmount: a.computedAmount ?? a.computed_amount
            })),
        totalPrice: sale.total_price,
        tipAmount: Number(sale.tip_amount ?? 0),
        customerPayment: sale.customer_payment,
        customerChange: sale.customer_change,
        paymentMethod: sale.payment_method ?? 'cash',
        subtotal: sale.subtotal,
        storeName: $1d9fcaa0a6035698$var$modelState.businessName ?? $1d9fcaa0a6035698$var$modelState.username,
        businessPhone: $1d9fcaa0a6035698$var$modelState.businessPhone ?? null,
        addressStreet: $1d9fcaa0a6035698$var$modelState.businessAddressStreet ?? null,
        addressCity: $1d9fcaa0a6035698$var$modelState.businessAddressCity ?? null,
        addressProvince: $1d9fcaa0a6035698$var$modelState.businessAddressProvince ?? null,
        addressZip: $1d9fcaa0a6035698$var$modelState.businessAddressZip ?? null,
        addressCountry: $1d9fcaa0a6035698$var$modelState.businessAddressCountry ?? null,
        cashierName: sale.added_by,
        showCashier: $1d9fcaa0a6035698$var$modelState.settings.showCashierName !== false,
        showRemovedAdjustments: false,
        removedAdjustments: [],
        isFreePlan: !$1e7ab04ca7920cff$export$9e608bbc985290d4()
    };
    $1d9fcaa0a6035698$var$_printReceipt(mapped);
};
const $1d9fcaa0a6035698$var$controlOpenSaleReceipt = function(id) {
    const sale = $1d9fcaa0a6035698$var$modelState.cashflowSales.find((s)=>s.id === id) ?? $1d9fcaa0a6035698$var$modelState.voidedSales.find((s)=>s.id === id);
    if (sale) (0, $1d1221278b545f23$export$2e2bcd8739ae039).showSaleReceipt(sale, ()=>$1d9fcaa0a6035698$var$controlReprintSale(sale));
};
const $1d9fcaa0a6035698$var$controlDeleteExpense = async function(id) {
    try {
        await $1e7ab04ca7920cff$export$f82302593dfecf81(id);
        $1d9fcaa0a6035698$var$_clearCashflowCache();
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderSummary($1d9fcaa0a6035698$var$_cashflowSummary());
        (0, $1d1221278b545f23$export$2e2bcd8739ae039).renderExpensesList($1d9fcaa0a6035698$var$modelState.expenses, $1d9fcaa0a6035698$var$_cashflowCanEdit());
        $1d9fcaa0a6035698$var$_refreshReportsExpenses();
        $1d9fcaa0a6035698$var$_refreshHomeExpensesToday();
        $1d9fcaa0a6035698$var$_requestActivityRefresh();
        $1d9fcaa0a6035698$var$showToast("Expense deleted.", "success");
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
// ── Discounts ─────────────────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$controlOpenDiscounts = function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_adjustments')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to Receipt & Tax.", 'error');
        return;
    }
    (0, $c3680931ad48d154$export$2e2bcd8739ae039).open();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039).renderAdjustments($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.adjustments);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039).syncTaxMode($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxMode, $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxInclusiveRate, $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxInclusiveLabel, $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxExemptLabel, $1d9fcaa0a6035698$var$_recommendedTaxMode());
    (0, $c3680931ad48d154$export$2e2bcd8739ae039).renderExemptProducts($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems, $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories);
    // "Set up taxes & fees" (Getting Started) checks off when the owner
    // actually opens this panel - write-once.
    if ($1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business') && !$1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.taxSetupSeen) {
        $1e7ab04ca7920cff$export$680c723e3a62d1c3('taxSetupSeen', true);
        $1d9fcaa0a6035698$var$_updateGettingStarted();
    }
};
// Warn before closing with an unsaved Tax Settings draft so the back arrow
// can't silently throw away a half-finished mode/rate/name change - mirrors
// the Settings modal's own unsaved-changes exit guard.
const $1d9fcaa0a6035698$var$controlCloseDiscounts = function() {
    if (!$1d9fcaa0a6035698$var$_taxSettingsDraftOriginal) {
        (0, $c3680931ad48d154$export$2e2bcd8739ae039).close();
        return;
    }
    (0, $c3680931ad48d154$export$2e2bcd8739ae039).showConfirmModal({
        message: 'You have unsaved tax settings.',
        note: 'If you leave now, your changes will be discarded.',
        confirmLabel: 'Discard & Close',
        cancelLabel: 'Keep Editing',
        onConfirm: ()=>{
            $1d9fcaa0a6035698$var$controlDiscardTaxSettingsDraft();
            (0, $c3680931ad48d154$export$2e2bcd8739ae039).close();
        }
    });
};
// Deep link from the Edit Item modal's read-only Tax section - exemption is
// now selected centrally here instead of per-item.
const $1d9fcaa0a6035698$var$controlManageItemTax = function(itemId) {
    $1d9fcaa0a6035698$var$controlOpenDiscounts();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039).focusExemptProduct(itemId);
};
// Diffs the picker's checked set against current tax_class so Save only
// writes products that actually changed.
const $1d9fcaa0a6035698$var$controlSaveExemptProducts = async function(exemptIds) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_adjustments')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to Receipt & Tax.", 'error');
        return;
    }
    const exemptSet = new Set(exemptIds);
    const toExempt = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.filter((i)=>exemptSet.has(i._id) && i.taxClass !== 'exempt').map((i)=>i._id);
    const toStandard = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.filter((i)=>!exemptSet.has(i._id) && i.taxClass === 'exempt').map((i)=>i._id);
    if (!toExempt.length && !toStandard.length) {
        $1d9fcaa0a6035698$var$showToast('No changes to save.', 'info');
        return;
    }
    try {
        await Promise.all([
            toExempt.length ? $1e7ab04ca7920cff$export$fbe83f1638aa6a6(toExempt, 'exempt') : Promise.resolve(),
            toStandard.length ? $1e7ab04ca7920cff$export$fbe83f1638aa6a6(toStandard, 'standard') : Promise.resolve()
        ]);
        (0, $c3680931ad48d154$export$2e2bcd8739ae039).renderExemptProducts($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems, $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuCategories);
        const n = toExempt.length + toStandard.length;
        $1d9fcaa0a6035698$var$showToast(`Updated ${n} product${n === 1 ? '' : 's'}.`, 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
// ── Promos panel ──────────────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$controlOpenPromos = function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_discounts')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to promo codes.", 'error');
        return;
    }
    (0, $066a3d689044816f$export$2e2bcd8739ae039).open();
    (0, $066a3d689044816f$export$2e2bcd8739ae039).render($1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes);
};
const $1d9fcaa0a6035698$var$controlClosePromos = function() {
    (0, $066a3d689044816f$export$2e2bcd8739ae039).close();
};
// ── Loyalty panel ─────────────────────────────────────────────────────────────
// Cached per panel open: the customer list and each customer's streak result
// (computed from their non-voided sale dates in the business's timezone).
let $1d9fcaa0a6035698$var$_loyaltyCustomers = [];
let $1d9fcaa0a6035698$var$_loyaltyStreaks = new Map();
const $1d9fcaa0a6035698$var$_loyaltyTz = ()=>$1e7ab04ca7920cff$export$74881ed03683ce30();
const $1d9fcaa0a6035698$var$_computeLoyaltyStreaks = function(customers, saleDatesByCustomer) {
    const tz = $1d9fcaa0a6035698$var$_loyaltyTz();
    const map = new Map();
    for (const c of customers)map.set(c.id, (0, $dv0h8.computeAllStreaks)(saleDatesByCustomer.get(c.id) ?? [], tz));
    return map;
};
const $1d9fcaa0a6035698$var$_renderLoyaltyPanel = function() {
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039).renderStats($1d9fcaa0a6035698$var$_loyaltyCustomers, $1d9fcaa0a6035698$var$_loyaltyStreaks);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039).renderCustomers($1d9fcaa0a6035698$var$_loyaltyCustomers, $1d9fcaa0a6035698$var$_loyaltyStreaks);
};
const $1d9fcaa0a6035698$var$_reloadLoyaltyCustomers = async function() {
    const [customers, saleDates] = await Promise.all([
        $1e7ab04ca7920cff$export$5214e286120564d8(),
        $1e7ab04ca7920cff$export$c246655a1578f63f()
    ]);
    $1d9fcaa0a6035698$var$_loyaltyCustomers = customers;
    $1d9fcaa0a6035698$var$_loyaltyStreaks = $1d9fcaa0a6035698$var$_computeLoyaltyStreaks(customers, saleDates);
    $1d9fcaa0a6035698$var$_renderLoyaltyPanel();
};
// Rewards are loaded eagerly at bootstrap (checkout needs them regardless of
// manage_loyalty), so opening the panel just re-renders from state - no fetch.
const $1d9fcaa0a6035698$var$_renderLoyaltyRewards = function() {
    const menuItemsById = new Map($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.map((i)=>[
            i._id,
            i
        ]));
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039).renderRewards($1e7ab04ca7920cff$export$ca000e230c0caa3e.loyaltyRewards, menuItemsById);
};
const $1d9fcaa0a6035698$var$controlOpenLoyalty = async function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_loyalty')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to the loyalty program.", 'error');
        return;
    }
    if ($1e7ab04ca7920cff$export$57b484963858c9a0('loyalty')) {
        (0, $cc836a0573c6004c$export$2e2bcd8739ae039).open();
        try {
            const [customers, saleDates] = await Promise.all([
                $1e7ab04ca7920cff$export$5214e286120564d8(),
                $1e7ab04ca7920cff$export$c246655a1578f63f()
            ]);
            (0, $cc836a0573c6004c$export$2e2bcd8739ae039).renderLockedTeaser(customers, $1d9fcaa0a6035698$var$_computeLoyaltyStreaks(customers, saleDates));
        } catch (err) {
            (0, $cc836a0573c6004c$export$2e2bcd8739ae039).renderLockedTeaser([], new Map());
        }
        return;
    }
    try {
        (0, $cc836a0573c6004c$export$2e2bcd8739ae039).open();
        (0, $cc836a0573c6004c$export$2e2bcd8739ae039).syncSettings($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings);
        $1d9fcaa0a6035698$var$_renderLoyaltyRewards();
        await $1d9fcaa0a6035698$var$_reloadLoyaltyCustomers();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlCloseLoyalty = function() {
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039).close();
};
const $1d9fcaa0a6035698$var$controlSaveLoyaltySettings = async function(values) {
    try {
        for (const [key, value] of Object.entries(values))$1e7ab04ca7920cff$export$233f02b89678da4f(key, value);
        await $1e7ab04ca7920cff$export$15e1db8a90fc192d();
        (0, $cc836a0573c6004c$export$2e2bcd8739ae039).syncSettings($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings);
        await $1d9fcaa0a6035698$var$_reloadLoyaltyCustomers();
        $1d9fcaa0a6035698$var$showToast('Loyalty settings saved.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlDiscardLoyaltySettings = function() {
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039).syncSettings($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings);
};
const $1d9fcaa0a6035698$var$controlLoyaltySearch = function(query) {
    const q = query.toLowerCase();
    const digits = query.replace(/\D/g, "");
    const filtered = !q ? $1d9fcaa0a6035698$var$_loyaltyCustomers : $1d9fcaa0a6035698$var$_loyaltyCustomers.filter((c)=>(c.name ?? "").toLowerCase().includes(q) || digits && c.phone.includes(digits));
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039).renderCustomers(filtered, $1d9fcaa0a6035698$var$_loyaltyStreaks);
};
const $1d9fcaa0a6035698$var$controlOpenLoyaltyCustomer = async function(id) {
    try {
        const customer = $1d9fcaa0a6035698$var$_loyaltyCustomers.find((c)=>c.id === id);
        if (!customer) return;
        const ledger = await $1e7ab04ca7920cff$export$977fa7a8d3466b4f(id);
        // All-time cumulative points = every 'earn' row, excluding sales that were
        // later voided (their earn was taken back by a void_reversal).
        const voidedSales = new Set(ledger.filter((t)=>t.kind === 'void_reversal').map((t)=>t.sale_id));
        const allTimePoints = ledger.filter((t)=>t.kind === 'earn' && !voidedSales.has(t.sale_id)).reduce((sum, t)=>sum + t.points, 0);
        (0, $cc836a0573c6004c$export$2e2bcd8739ae039).showDetail(customer, ledger, $1d9fcaa0a6035698$var$_loyaltyStreaks.get(id), allTimePoints);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlLoyaltyShowAddForm = function() {
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039).showAddForm();
};
const $1d9fcaa0a6035698$var$controlLoyaltyEditCustomer = function(id) {
    const customer = $1d9fcaa0a6035698$var$_loyaltyCustomers.find((c)=>c.id === id);
    if (customer) (0, $cc836a0573c6004c$export$2e2bcd8739ae039).showAddForm(customer);
};
// Shared save for the Add/Edit Customer form. data.id present = edit
// (profile fields only - phone is the identity key and stays fixed).
const $1d9fcaa0a6035698$var$controlLoyaltyAddCustomer = async function(data) {
    try {
        const extras = {
            email: data.email,
            birthdayMonth: data.birthdayMonth,
            birthdayDay: data.birthdayDay,
            note: data.note
        };
        if (data.id) await $1e7ab04ca7920cff$export$bef73de7c08bced2(data.id, {
            name: data.name,
            ...extras
        });
        else {
            await $1e7ab04ca7920cff$export$ff11d013c2c70fac(data.phone, data.name, extras, {
                strict: true
            });
            // Panel enrollment must not leave a customer linked to the NEXT checkout.
            $1e7ab04ca7920cff$export$90bd2ffe141ff8ad();
        }
        (0, $cc836a0573c6004c$export$2e2bcd8739ae039).closeAddForm();
        await $1d9fcaa0a6035698$var$_reloadLoyaltyCustomers();
        if (!data.id) $1d9fcaa0a6035698$var$_requestActivityRefresh(); // new-member feed event
        $1d9fcaa0a6035698$var$showToast(data.id ? 'Customer updated.' : 'Customer added to the loyalty program.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
// ── Rewards card (panel) ──────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$controlLoyaltyRewardSearch = function(query) {
    const excludedItemIds = new Set($1e7ab04ca7920cff$export$ca000e230c0caa3e.loyaltyRewards.map((r)=>r.itemId));
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._renderRewardSearchResults(query, $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems, excludedItemIds);
};
const $1d9fcaa0a6035698$var$controlLoyaltyRewardPick = function(itemId, itemName) {
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039).showRewardPicked(itemId, itemName);
};
const $1d9fcaa0a6035698$var$controlLoyaltyRewardCancelPick = function() {
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039).hideRewardPicked();
};
const $1d9fcaa0a6035698$var$controlAddLoyaltyReward = async function(itemId, pointsCost) {
    try {
        await $1e7ab04ca7920cff$export$6a18dd8bacc8cba7(itemId, pointsCost);
        (0, $cc836a0573c6004c$export$2e2bcd8739ae039).hideRewardPicked();
        $1d9fcaa0a6035698$var$_renderLoyaltyRewards();
        $1d9fcaa0a6035698$var$showToast('Reward added.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlToggleLoyaltyReward = async function(id) {
    try {
        await $1e7ab04ca7920cff$export$68b2763a19fc97ac(id);
        $1d9fcaa0a6035698$var$_renderLoyaltyRewards();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlDeleteLoyaltyReward = async function(id) {
    try {
        await $1e7ab04ca7920cff$export$ca0ad922ea11f11c(id);
        $1d9fcaa0a6035698$var$_renderLoyaltyRewards();
        $1d9fcaa0a6035698$var$showToast('Reward removed.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlNewDiscountCode = function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_discounts')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to discount codes.", 'error');
        return;
    }
    (0, $066a3d689044816f$export$2e2bcd8739ae039).showForm();
};
const $1d9fcaa0a6035698$var$controlSaveDiscountCode = async function(data) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_discounts')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to discount codes.", 'error');
        return;
    }
    try {
        if (data.id) await $1e7ab04ca7920cff$export$51125fa74adfef58(data.id, data);
        else await $1e7ab04ca7920cff$export$213c8a208a34f60d(data);
        (0, $066a3d689044816f$export$2e2bcd8739ae039).closeForm();
        (0, $066a3d689044816f$export$2e2bcd8739ae039).render($1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes);
        $1d9fcaa0a6035698$var$showToast(data.id ? "Code updated." : "Code created.", "success");
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlEditDiscountCode = function(id) {
    const dc = $1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes.find((d)=>d.id === id);
    if (!dc) return;
    (0, $066a3d689044816f$export$2e2bcd8739ae039).showForm(dc);
};
const $1d9fcaa0a6035698$var$controlDeleteDiscountCode = async function(id) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_discounts')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to discount codes.", 'error');
        return;
    }
    if (!confirm("Delete this promo code? This cannot be undone.")) return;
    try {
        await $1e7ab04ca7920cff$export$8e82bacc77a2ed5(id);
        (0, $066a3d689044816f$export$2e2bcd8739ae039).render($1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes);
        $1d9fcaa0a6035698$var$showToast("Code deleted.", "success");
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlToggleDiscountStatus = async function(id) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_discounts')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to discount codes.", 'error');
        return;
    }
    try {
        await $1e7ab04ca7920cff$export$bd5aeb75f2cd95de(id);
        (0, $066a3d689044816f$export$2e2bcd8739ae039).render($1e7ab04ca7920cff$export$ca000e230c0caa3e.discountCodes);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
// ── Promo code at checkout ────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$controlApplyPromoCode = function(code) {
    try {
        if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentPromoCode) $1e7ab04ca7920cff$export$d994b63208696464();
        const dc = $1e7ab04ca7920cff$export$69d9d60ced6371b7(code);
        $1e7ab04ca7920cff$export$c468eb2bf8375cfd(dc);
        $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, "error");
    }
};
const $1d9fcaa0a6035698$var$controlRemovePromoCode = function() {
    $1e7ab04ca7920cff$export$d994b63208696464();
    $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
};
// ── Loyalty at checkout ───────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$_denyLoyalty = ()=>$1d9fcaa0a6035698$var$showToast("You don't have access to loyalty.", "error");
const $1d9fcaa0a6035698$var$controlLoyaltyLookup = async function(phone) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('use_loyalty')) {
        $1d9fcaa0a6035698$var$_denyLoyalty();
        return;
    }
    try {
        const customer = await $1e7ab04ca7920cff$export$6f115fe55d0ffa50(phone);
        if (customer) $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
        else // Unknown phone: offer inline enrollment (keeps the normalized digits).
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039).showLoyaltyEnroll(phone);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, "error");
    }
};
const $1d9fcaa0a6035698$var$controlLoyaltyEnroll = async function(phone, name) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('use_loyalty')) {
        $1d9fcaa0a6035698$var$_denyLoyalty();
        return;
    }
    try {
        await $1e7ab04ca7920cff$export$ff11d013c2c70fac(phone, name);
        $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
        $1d9fcaa0a6035698$var$_requestActivityRefresh(); // "X joined the loyalty program" feed event
        $1d9fcaa0a6035698$var$showToast("Customer enrolled in the loyalty program.", "success");
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, "error");
    }
};
const $1d9fcaa0a6035698$var$controlLoyaltyEnrollCancel = function() {
    $1d9fcaa0a6035698$var$_refreshCheckoutAdj(); // re-renders the idle loyalty section
};
// Everything the Redeem modal needs in one place: customer, streak, points
// balance/reserved, the FULL reward catalog (not just cart-matching items -
// 2026-07-27, Kelly's ask: show every configured reward, greyed out if
// unaffordable, since redeeming now adds the item rather than requiring it
// already be in the cart), and the totals the points-off stepper caps against.
const $1d9fcaa0a6035698$var$_buildRedeemModalPayload = function() {
    const ctx = $1d9fcaa0a6035698$var$_loyaltyCartCtx();
    const settings = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings;
    const tz = $1e7ab04ca7920cff$export$74881ed03683ce30();
    const adjResult = $1e7ab04ca7920cff$export$1e7528f2cdbb9715((0, $6724f76d0010cf48$export$2e2bcd8739ae039)._subtotal, $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentReceiptAdjustments, $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart);
    const rewards = $1e7ab04ca7920cff$export$ca000e230c0caa3e.loyaltyRewards.filter((r)=>r.active).map((r)=>({
            id: r.id,
            pointsCost: r.pointsCost,
            itemName: $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.find((mi)=>mi._id === r.itemId)?.itemName ?? '(item removed)'
        }));
    return {
        customer: ctx.customer,
        streak: (0, $dv0h8.computeStreak)(ctx.customer?.saleDates ?? [], 'day', tz),
        rewards: rewards,
        redemptionByRewardId: ctx.redemptionByRewardId,
        reservedPoints: ctx.reservedPoints,
        redeemPoints: settings.loyaltyRedeemPoints || 100,
        redeemValue: settings.loyaltyRedeemValue || 5,
        redemption: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyRedemption,
        finalTotal: adjResult.finalTotal,
        tz: tz
    };
};
// Redeem/remove actions can happen while the modal is open (that's the whole
// point) - re-render it in place so its own points/eligible-item list stays
// live, on top of the checkout section refresh every mutating action already does.
const $1d9fcaa0a6035698$var$_refreshRedeemModalIfOpen = function() {
    if (!(0, $6724f76d0010cf48$export$2e2bcd8739ae039).isRedeemModalOpen()) return;
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).showRedeemModal($1d9fcaa0a6035698$var$_buildRedeemModalPayload());
};
const $1d9fcaa0a6035698$var$controlOpenLoyaltyRedeemModal = function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('use_loyalty')) {
        $1d9fcaa0a6035698$var$_denyLoyalty();
        return;
    }
    if (!$1e7ab04ca7920cff$export$ca000e230c0caa3e.currentLoyaltyCustomer) return;
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).showRedeemModal($1d9fcaa0a6035698$var$_buildRedeemModalPayload());
};
const $1d9fcaa0a6035698$var$controlLoyaltyApplyRedemption = function(increments) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('use_loyalty')) {
        $1d9fcaa0a6035698$var$_denyLoyalty();
        return;
    }
    try {
        $1e7ab04ca7920cff$export$96221fd73c9bfdd6(increments);
        $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
        $1d9fcaa0a6035698$var$_refreshRedeemModalIfOpen();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, "error");
    }
};
const $1d9fcaa0a6035698$var$controlLoyaltyRemoveRedemption = function() {
    $1e7ab04ca7920cff$export$8f8f3a01cb0b2825();
    $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
    $1d9fcaa0a6035698$var$_refreshRedeemModalIfOpen();
};
const $1d9fcaa0a6035698$var$controlLoyaltyUnlink = function() {
    $1e7ab04ca7920cff$export$90bd2ffe141ff8ad();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039).closeRedeemModal();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._subtotal = $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.reduce((acc, item)=>acc + item.totalPrice, 0);
    $1d9fcaa0a6035698$var$_broadcastCart();
    $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
};
// rewardId, not a cart line - redeeming now mints its OWN cart line (see
// model.applyLoyaltyRewardRedemption), so the subtotal genuinely changes and
// the cart needs to be re-broadcast to the customer display too.
const $1d9fcaa0a6035698$var$controlApplyLoyaltyRewardRedemption = function(rewardId) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('use_loyalty')) {
        $1d9fcaa0a6035698$var$_denyLoyalty();
        return;
    }
    try {
        $1e7ab04ca7920cff$export$4a6125c257304688(rewardId);
        (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._subtotal = $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.reduce((acc, item)=>acc + item.totalPrice, 0);
        $1d9fcaa0a6035698$var$_broadcastCart();
        $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
        $1d9fcaa0a6035698$var$_refreshRedeemModalIfOpen();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, "error");
    }
};
const $1d9fcaa0a6035698$var$controlRemoveLoyaltyRewardRedemption = function(cartItemLineId) {
    $1e7ab04ca7920cff$export$f46e9f68198f57f(cartItemLineId);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._subtotal = $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.reduce((acc, item)=>acc + item.totalPrice, 0);
    $1d9fcaa0a6035698$var$_broadcastCart();
    $1d9fcaa0a6035698$var$_refreshCheckoutAdj();
    $1d9fcaa0a6035698$var$_refreshRedeemModalIfOpen();
};
// ── Staff ─────────────────────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$controlOpenStaff = async function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_staff')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to staff.", 'error');
        return;
    }
    try {
        (0, $ad4542f6315399f1$export$2e2bcd8739ae039).canResetMFA = $1e7ab04ca7920cff$export$b325ec6732b039cf('reset_staff_mfa');
        (0, $ad4542f6315399f1$export$2e2bcd8739ae039).open($1d9fcaa0a6035698$var$_staffCanManage());
        // "Set up your team" (Getting Started) checks off when the owner opens
        // this panel - write-once, and deliberately not tied to an invite
        // actually happening (invites may become a paid-tier feature).
        if ($1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business') && !$1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.teamSetupSeen) {
            $1e7ab04ca7920cff$export$680c723e3a62d1c3('teamSetupSeen', true);
            $1d9fcaa0a6035698$var$_updateGettingStarted();
        }
        await Promise.all([
            $1e7ab04ca7920cff$export$34ce29dd271bbc01(),
            $1e7ab04ca7920cff$export$c0334f52bda8729d()
        ]);
        (0, $ad4542f6315399f1$export$2e2bcd8739ae039).render($1e7ab04ca7920cff$export$ca000e230c0caa3e.staff, $1d9fcaa0a6035698$var$_staffCanManage(), $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles);
        $1d9fcaa0a6035698$var$_renderRolesTab();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
// Re-renders the Roles tab with the current user's management context.
const $1d9fcaa0a6035698$var$_renderRolesTab = function() {
    const counts = {};
    for (const s of $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff)if (s.roleId && s.isActive !== false) counts[s.roleId] = (counts[s.roleId] ?? 0) + 1;
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039).renderRoles($1e7ab04ca7920cff$export$ca000e230c0caa3e.roles, {
        canManage: $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_roles'),
        ownRoleId: $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.roleId ?? null,
        labels: $1e7ab04ca7920cff$export$b2b8d7ade24d9564,
        totalCaps: $1e7ab04ca7920cff$export$e41c6d066ef1eec8.length,
        counts: counts
    });
};
// Create / edit / delete a role from the Roles tab editor. Guardrails: requires
// manage_roles; the Admin role is locked; you can't edit the role you're assigned
// to; and the editor only lets you grant capabilities you hold yourself (enforced
// in the view by disabling non-grantable boxes, and again in the model).
const $1d9fcaa0a6035698$var$controlRoleAction = async function(action, roleId) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_roles')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to manage roles.", 'error');
        return;
    }
    const grantableCaps = $1e7ab04ca7920cff$export$e41c6d066ef1eec8.filter((k)=>$1e7ab04ca7920cff$export$b325ec6732b039cf(k));
    const editorCtx = {
        allPermissions: $1e7ab04ca7920cff$export$e41c6d066ef1eec8,
        labels: $1e7ab04ca7920cff$export$b2b8d7ade24d9564,
        descriptions: $1e7ab04ca7920cff$export$62f846a6201d7c64,
        groups: $1e7ab04ca7920cff$export$40d95c19a7e19d13,
        grantableCaps: grantableCaps
    };
    if (action === 'create') {
        const { onSave: onSave } = (0, $ad4542f6315399f1$export$2e2bcd8739ae039).showRoleEditor({
            role: null,
            isNew: true,
            ...editorCtx
        });
        onSave(async (name, caps, close, meta)=>{
            if (!name) {
                $1d9fcaa0a6035698$var$showToast('Enter a role name.', 'error');
                return;
            }
            try {
                await $1e7ab04ca7920cff$export$987e0c664048adac(name, caps, meta?.description, meta?.icon);
                close();
                $1d9fcaa0a6035698$var$_renderRolesTab();
                $1d9fcaa0a6035698$var$showToast('Role created.', 'success');
            } catch (err) {
                $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not create role.');
            }
        });
        return;
    }
    const role = $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles.find((r)=>r.id === roleId);
    if (!role) return;
    if (action === 'edit') {
        if (role.locked) {
            $1d9fcaa0a6035698$var$showToast('The Admin role always has full access and cannot be edited.', 'error');
            return;
        }
        if (roleId === $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.roleId) {
            $1d9fcaa0a6035698$var$showToast("You can't edit the role you're currently assigned to.", 'error');
            return;
        }
        const members = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.filter((s)=>s.roleId === roleId && s.isActive !== false);
        const { onSave: onSave } = (0, $ad4542f6315399f1$export$2e2bcd8739ae039).showRoleEditor({
            role: role,
            isNew: false,
            members: members,
            ...editorCtx
        });
        onSave(async (name, caps, close, meta)=>{
            if (!name) {
                $1d9fcaa0a6035698$var$showToast('Enter a role name.', 'error');
                return;
            }
            try {
                if (name !== role.name) await $1e7ab04ca7920cff$export$68844ec44941e4f(roleId, name);
                await $1e7ab04ca7920cff$export$6897c8a16b8636d1(roleId, meta ?? {});
                await $1e7ab04ca7920cff$export$21ea4d9b2e178e02(roleId, caps);
                close();
                $1d9fcaa0a6035698$var$_renderRolesTab();
                $1d9fcaa0a6035698$var$showToast('Role updated.', 'success');
            } catch (err) {
                $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not update role.');
            }
        });
        return;
    }
    if (action === 'delete') {
        if (role.locked) {
            $1d9fcaa0a6035698$var$showToast('The Admin role cannot be deleted.', 'error');
            return;
        }
        if (!confirm(`Delete the "${role.name}" role? Staff assigned to it must be reassigned first.`)) return;
        try {
            await $1e7ab04ca7920cff$export$a7396bae498de6f1(roleId);
            $1d9fcaa0a6035698$var$_renderRolesTab();
            $1d9fcaa0a6035698$var$showToast('Role deleted.', 'success');
        } catch (err) {
            $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not delete role.');
        }
    }
};
const $1d9fcaa0a6035698$var$controlCloseStaff = function() {
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039).close();
};
// ── Timesheets (top-level panel; formerly the Staff panel's Payroll tab) ──────
const $1d9fcaa0a6035698$var$controlOpenTimesheets = async function() {
    // manage_pay holders run payroll; manage_staff holders kept their access from
    // when this lived inside the Staff panel. Everyone else is view-blocked (staff
    // see their own hours on the time clock's My Timesheet instead).
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay') && !$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_staff')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to timesheets.", 'error');
        return;
    }
    if ($1d9fcaa0a6035698$var$_practiceOn('timesheets')) {
        $1d9fcaa0a6035698$var$_practiceTimesheetsOpen();
        return;
    }
    if ($1e7ab04ca7920cff$export$57b484963858c9a0('timesheets')) {
        (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).open();
        const canEdit = $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay');
        try {
            const monStr = (0, $lDSCx.mondayOf)((0, $lDSCx.todayIn)($1d9fcaa0a6035698$var$_bizTz()));
            const monday = (0, $lDSCx.zonedToDate)(monStr, '00:00', $1d9fcaa0a6035698$var$_bizTz());
            const nextMonday = (0, $lDSCx.zonedToDate)((0, $lDSCx.addDays)(monStr, 7), '00:00', $1d9fcaa0a6035698$var$_bizTz());
            const [onShiftStaff, corrections, leave] = await Promise.all([
                $1e7ab04ca7920cff$export$da55ffa46e74c271().catch(()=>[]),
                canEdit ? $1e7ab04ca7920cff$export$b910b0e182c20503().catch(()=>[]) : Promise.resolve([]),
                $1e7ab04ca7920cff$export$dd48584891564f37().catch(()=>[])
            ]);
            await $1e7ab04ca7920cff$export$386807069bdcb35d(monday.toISOString(), nextMonday.toISOString()).catch(()=>{});
            (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).renderLockedTeaser({
                onShiftCount: onShiftStaff.length,
                weekShifts: $1e7ab04ca7920cff$export$ca000e230c0caa3e.shifts,
                pendingCount: corrections.length + leave.filter((r)=>r.status === 'pending').length,
                canEdit: canEdit,
                editRequests: corrections,
                leaveRequests: leave
            });
        } catch (err) {
            (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).renderLockedTeaser({
                onShiftCount: 0,
                weekShifts: [],
                pendingCount: 0,
                canEdit: canEdit
            });
        }
        return;
    }
    try {
        (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).open();
        try {
            await $1e7ab04ca7920cff$export$34ce29dd271bbc01();
        } catch (_) {}
        await $1d9fcaa0a6035698$var$controlFetchTimesheets('week', (0, $lDSCx.todayIn)($1d9fcaa0a6035698$var$_bizTz())); // this week at the cafe
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlCloseTimesheets = function() {
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).close();
};
// ── Schedule (2026-10-15, free on every plan) ─────────────────────────────────
// Week shift builder + stations. Needs manage_schedule (RLS enforces the same).
// Weeks start Monday in the BUSINESS timezone. See SYSTEM.md "Shift Schedule".
let $1d9fcaa0a6035698$var$_scheduleMonday = null;
// Also hands the zone to views (scheduleTime.setBusinessZone), so it stays current after an
// address change.
const $1d9fcaa0a6035698$var$_bizTz = ()=>{
    const tz = $1e7ab04ca7920cff$export$74881ed03683ce30();
    (0, $lDSCx.setBusinessZone)(tz);
    return tz;
};
const $1d9fcaa0a6035698$var$_scheduleData = ()=>({
        monday: $1d9fcaa0a6035698$var$_scheduleMonday,
        tz: $1d9fcaa0a6035698$var$_bizTz(),
        staff: $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff,
        stations: $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleStations,
        shifts: $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduledShifts,
        series: $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleSeries,
        availability: $1e7ab04ca7920cff$export$ca000e230c0caa3e.staffAvailability,
        leave: $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleLeave,
        requests: $1e7ab04ca7920cff$export$ca000e230c0caa3e.shiftRequests
    });
const $1d9fcaa0a6035698$var$_weekRangeISO = (monday)=>{
    const tz = $1d9fcaa0a6035698$var$_bizTz();
    return [
        (0, $lDSCx.zonedToDate)(monday, '00:00', tz).toISOString(),
        (0, $lDSCx.zonedToDate)((0, $lDSCx.addDays)(monday, 7), '00:00', tz).toISOString()
    ];
};
// Repeats are generated a few weeks ahead: at least 8 weeks from today, and
// always through the week on screen. Best-effort - a failure just means the
// week shows what already exists.
const $1d9fcaa0a6035698$var$_extendRepeats = (monday = $1d9fcaa0a6035698$var$_scheduleMonday)=>{
    const today = (0, $lDSCx.todayIn)($1d9fcaa0a6035698$var$_bizTz());
    const through = [
        (0, $lDSCx.addDays)(monday, 6),
        (0, $lDSCx.addDays)(today, 56)
    ].sort().pop();
    return $1e7ab04ca7920cff$export$a47b2858d875c10d(through).catch(()=>0);
};
const $1d9fcaa0a6035698$var$_loadScheduleWeek = async ()=>{
    await $1d9fcaa0a6035698$var$_extendRepeats();
    await Promise.all([
        $1e7ab04ca7920cff$export$145b6d72ee5a6844(...$1d9fcaa0a6035698$var$_weekRangeISO($1d9fcaa0a6035698$var$_scheduleMonday)),
        $1e7ab04ca7920cff$export$d50ed07265d34ff4(),
        $1d9fcaa0a6035698$var$_loadScheduleExtras()
    ]);
};
// Phase 2-3 data: leave (the week on screen + the next 10 weeks, which covers
// any request's shift), availability and swap/pickup requests. Best-effort, so
// the week still loads if one of them fails.
const $1d9fcaa0a6035698$var$_loadScheduleExtras = ()=>{
    const today = (0, $lDSCx.todayIn)($1d9fcaa0a6035698$var$_bizTz());
    const from = [
        $1d9fcaa0a6035698$var$_scheduleMonday,
        today
    ].sort()[0];
    const to = [
        (0, $lDSCx.addDays)($1d9fcaa0a6035698$var$_scheduleMonday, 6),
        (0, $lDSCx.addDays)(today, 70)
    ].sort().pop();
    return Promise.all([
        $1e7ab04ca7920cff$export$f82428e4c88f3cfb(from, to).catch(()=>{
            $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleLeave = [];
        }),
        $1e7ab04ca7920cff$export$73e0853afeef3370().catch(()=>{
            $1e7ab04ca7920cff$export$ca000e230c0caa3e.staffAvailability = [];
        }),
        $1e7ab04ca7920cff$export$8050acf0b604c9e().catch(()=>{
            $1e7ab04ca7920cff$export$ca000e230c0caa3e.shiftRequests = [];
        })
    ]);
};
// ── Tables (2026-10-22) ───────────────────────────────────────────────────────
// Table numbers mode only needs the list (checkout picker). Full service adds
// the live floor, open tabs (items go to the kitchen as tickets, the bill is
// paid at the end), reservations and the waitlist. See tablesView.js.
let $1d9fcaa0a6035698$var$_tabOrder = null; // { tabId, tableId, tableName } while adding items to a tab
let $1d9fcaa0a6035698$var$_tabPay = null; // { tabId, tableId, tableName, lineIds } while paying a tab
let $1d9fcaa0a6035698$var$_resDay = null; // business-calendar day ("YYYY-MM-DD") open in Reservations
let $1d9fcaa0a6035698$var$_resToday = []; // today's bookings (floor status)
let $1d9fcaa0a6035698$var$_resForDay = []; // bookings for _resDay
let $1d9fcaa0a6035698$var$_tablesTimer = null;
const $1d9fcaa0a6035698$var$_tablesOn = ()=>($1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tableService ?? 'off') !== 'off';
// Tables run on the BUSINESS's calendar, not the device's: a tablet whose
// clock is in another zone (or set to UTC) must still see the cafe's today.
const $1d9fcaa0a6035698$var$_bizToday = ()=>(0, $lDSCx.todayIn)($1d9fcaa0a6035698$var$_bizTz());
const $1d9fcaa0a6035698$var$_dayRange = (dateStr)=>{
    const tz = $1d9fcaa0a6035698$var$_bizTz();
    return [
        (0, $lDSCx.zonedToDate)(dateStr, '00:00', tz).toISOString(),
        (0, $lDSCx.zonedToDate)((0, $lDSCx.addDays)(dateStr, 1), '00:00', tz).toISOString()
    ];
};
const $1d9fcaa0a6035698$var$_staffNameForTabs = ()=>$1d9fcaa0a6035698$var$_cashierDisplayName($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier) || $1e7ab04ca7920cff$export$ca000e230c0caa3e.username || null;
const $1d9fcaa0a6035698$var$_tablesData = ()=>{
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings;
    return {
        mode: s.tableService === 'full' ? 'full' : 'numbers',
        tables: $1e7ab04ca7920cff$export$ca000e230c0caa3e.diningTables,
        tabs: $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs,
        reservations: $1d9fcaa0a6035698$var$_resToday,
        dayReservations: $1d9fcaa0a6035698$var$_resForDay,
        day: $1d9fcaa0a6035698$var$_resDay ?? $1d9fcaa0a6035698$var$_bizToday(),
        tz: $1d9fcaa0a6035698$var$_bizTz(),
        waitlist: $1e7ab04ca7920cff$export$ca000e230c0caa3e.waitlist,
        waitlistOn: s.tableService === 'full' && s.waitlistEnabled === true,
        reservationsOn: s.tableService === 'full' && s.reservationsEnabled === true,
        canEditLayout: $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business'),
        bookingRules: s.bookingRules,
        waitlistQuotes: s.waitlistQuotes,
        now: Date.now()
    };
};
const $1d9fcaa0a6035698$var$_loadTablesAll = async function() {
    const s = $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings;
    const full = s.tableService === 'full';
    await Promise.all([
        $1e7ab04ca7920cff$export$1dd25893a10c6b3f(),
        full && s.waitlistEnabled ? $1e7ab04ca7920cff$export$efe8831a8901fd7f() : null
    ]);
    if (full && s.reservationsEnabled) {
        const today = $1d9fcaa0a6035698$var$_bizToday();
        $1d9fcaa0a6035698$var$_resToday = [
            ...await $1e7ab04ca7920cff$export$968e31c3f3742111(...$1d9fcaa0a6035698$var$_dayRange(today))
        ];
        const day = $1d9fcaa0a6035698$var$_resDay ?? today;
        $1d9fcaa0a6035698$var$_resForDay = day === today ? $1d9fcaa0a6035698$var$_resToday : [
            ...await $1e7ab04ca7920cff$export$968e31c3f3742111(...$1d9fcaa0a6035698$var$_dayRange(day))
        ];
    } else {
        $1d9fcaa0a6035698$var$_resToday = [];
        $1d9fcaa0a6035698$var$_resForDay = [];
    }
};
const $1d9fcaa0a6035698$var$_renderTables = ()=>{
    if ((0, $ab39ca298e181461$export$2e2bcd8739ae039).isOpen()) (0, $ab39ca298e181461$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_tablesData());
};
// After any change: tell the other terminals, then redraw here.
const $1d9fcaa0a6035698$var$_tablesChanged = function() {
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).TABLES_SYNC
    });
    $1d9fcaa0a6035698$var$_renderTables();
    $1d9fcaa0a6035698$var$_renderHomeCards();
};
const $1d9fcaa0a6035698$var$_tablesError = (err, fallback)=>{
    const msg = err?.code === '42P01' || /relation .* does not exist|schema cache/i.test(err?.message ?? '') ? 'Tables need a one-time database update. Ask the account owner to run it.' : err?.message ?? fallback;
    $1d9fcaa0a6035698$var$showToast(msg, 'error');
};
const $1d9fcaa0a6035698$var$controlOpenTables = async function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('take_orders') && !$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to tables.", 'error');
        return;
    }
    if (!$1d9fcaa0a6035698$var$_tablesOn()) {
        $1d9fcaa0a6035698$var$showToast('Turn on table service in Settings > Home screen.', 'info');
        return;
    }
    (0, $ab39ca298e181461$export$2e2bcd8739ae039).open();
    (0, $ab39ca298e181461$export$2e2bcd8739ae039).renderLoading();
    try {
        await $1d9fcaa0a6035698$var$_loadTablesAll();
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_tablesData());
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not load tables.');
    }
    // Seated times tick, and other terminals' changes land even if a broadcast
    // was missed.
    clearInterval($1d9fcaa0a6035698$var$_tablesTimer);
    $1d9fcaa0a6035698$var$_tablesTimer = setInterval(()=>{
        if (!(0, $ab39ca298e181461$export$2e2bcd8739ae039).isOpen()) return;
        $1d9fcaa0a6035698$var$_loadTablesAll().then($1d9fcaa0a6035698$var$_renderTables).catch(()=>{});
    }, 30000);
};
const $1d9fcaa0a6035698$var$controlCloseTables = function() {
    clearInterval($1d9fcaa0a6035698$var$_tablesTimer);
    $1d9fcaa0a6035698$var$_tablesTimer = null;
    (0, $ab39ca298e181461$export$2e2bcd8739ae039).close();
};
const $1d9fcaa0a6035698$var$_tableName = (tableId)=>$1e7ab04ca7920cff$export$ca000e230c0caa3e.diningTables.find((t)=>t.id === tableId)?.name ?? '';
const $1d9fcaa0a6035698$var$controlSeatTable = async function(tableId, guests) {
    try {
        await $1e7ab04ca7920cff$export$dce0c365d72e5017(tableId, guests, $1d9fcaa0a6035698$var$_staffNameForTabs());
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).select(tableId);
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not seat this table.');
        $1d9fcaa0a6035698$var$_loadTablesAll().then($1d9fcaa0a6035698$var$_renderTables).catch(()=>{});
    }
};
const $1d9fcaa0a6035698$var$controlSeatReservation = async function(resId) {
    const r = [
        ...$1d9fcaa0a6035698$var$_resToday,
        ...$1d9fcaa0a6035698$var$_resForDay
    ].find((x)=>x.id === resId);
    if (!r?.tableId) {
        $1d9fcaa0a6035698$var$showToast('Pick a table for this booking first.', 'error');
        return;
    }
    try {
        const tab = await $1e7ab04ca7920cff$export$dce0c365d72e5017(r.tableId, r.partySize, $1d9fcaa0a6035698$var$_staffNameForTabs());
        await $1e7ab04ca7920cff$export$50ccea48c85bc751(r.id, 'seated', tab?.id);
        await $1d9fcaa0a6035698$var$_loadTablesAll();
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).select(r.tableId);
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not seat this booking.');
    }
};
const $1d9fcaa0a6035698$var$controlSeatWaitlist = async function(entryId, tableId) {
    const w = $1e7ab04ca7920cff$export$ca000e230c0caa3e.waitlist.find((x)=>x.id === entryId);
    if (!w || !tableId) return;
    try {
        await $1e7ab04ca7920cff$export$dce0c365d72e5017(tableId, w.partySize, $1d9fcaa0a6035698$var$_staffNameForTabs());
        await $1e7ab04ca7920cff$export$b00468b00729f211(w.id, {
            status: 'seated',
            tableId: tableId
        });
        await $1d9fcaa0a6035698$var$_loadTablesAll();
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).select(tableId);
        $1d9fcaa0a6035698$var$showToast(`${w.name} seated at table ${$1d9fcaa0a6035698$var$_tableName(tableId)}`, 'success');
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not seat this party.');
    }
};
const $1d9fcaa0a6035698$var$controlCleanTable = async function(tableId) {
    try {
        await $1e7ab04ca7920cff$export$49b2c708e2ed8edd(tableId, false);
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not update the table.');
    }
};
// "Add items": the normal order screen, but the cart holds only the new items
// and Checkout becomes Send to kitchen / Save to tab.
const $1d9fcaa0a6035698$var$controlTabAddItems = function(tabId) {
    const tab = $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs.find((t)=>t.id === tabId);
    if (!tab) return;
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.length) {
        $1d9fcaa0a6035698$var$showToast('Finish or clear the order in progress first.', 'error');
        return;
    }
    $1d9fcaa0a6035698$var$_tabOrder = {
        tabId: tabId,
        tableId: tab.tableId,
        tableName: $1d9fcaa0a6035698$var$_tableName(tab.tableId)
    };
    const tabTotal = tab.items.filter((l)=>!l.paidSaleId).reduce((s, l)=>s + l.unitPrice * l.quantity, 0);
    (0, $472fec5536166250$export$2e2bcd8739ae039)._tabOrder = {
        tableName: $1d9fcaa0a6035698$var$_tabOrder.tableName,
        tabTotal: tabTotal
    };
    $1d9fcaa0a6035698$var$controlCloseTables();
    $1d9fcaa0a6035698$var$controlNewOrder();
};
const $1d9fcaa0a6035698$var$_queueTicket = function(item) {
    if (!item) return;
    $1d9fcaa0a6035698$var$modelState.orderQueue.push(item);
    $1d9fcaa0a6035698$var$_ensureKDSTick();
    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).KDS_QUEUE_SYNC,
        queue: $1d9fcaa0a6035698$var$_queueForBroadcast(),
        thresholds: {
            yellow: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsYellowThreshold,
            red: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsRedThreshold
        }
    });
};
// Another device paid (or closed) the tab this checkout is paying: say so and
// leave, instead of leaving a checkout open for items that are already paid
// (team test 2026-10-24 - the server never charged twice, but the second
// screen gave no sign).
const $1d9fcaa0a6035698$var$_checkTabPayStillOpen = function() {
    if (!$1d9fcaa0a6035698$var$_tabPay) return;
    const tab = $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs.find((t)=>t.id === $1d9fcaa0a6035698$var$_tabPay.tabId);
    const unpaid = (tab?.items ?? []).filter((l)=>!l.paidSaleId);
    const stillDue = $1d9fcaa0a6035698$var$_tabPay.lineIds ? unpaid.filter((l)=>$1d9fcaa0a6035698$var$_tabPay.lineIds.includes(l.lid)) : unpaid;
    if (stillDue.length) return;
    $1d9fcaa0a6035698$var$showToast($1d9fcaa0a6035698$var$_tabPay.tableName ? `Table ${$1d9fcaa0a6035698$var$_tabPay.tableName} was already paid on another device.` : 'This tab was already paid on another device.', 'error');
    $1d9fcaa0a6035698$var$controlGoBackToOrder();
};
// Leaves the order screen / checkout and goes back to the tab's table.
const $1d9fcaa0a6035698$var$_backToTables = function(tableId) {
    $1d9fcaa0a6035698$var$_tabOrder = null;
    $1d9fcaa0a6035698$var$_tabPay = null;
    (0, $472fec5536166250$export$2e2bcd8739ae039)._tabOrder = null;
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._tabPay = null;
    $1d9fcaa0a6035698$var$controlOpenTables().then(()=>{
        if (tableId) {
            (0, $ab39ca298e181461$export$2e2bcd8739ae039).select(tableId);
            $1d9fcaa0a6035698$var$_renderTables();
        }
    });
};
const $1d9fcaa0a6035698$var$controlSendTabOrder = async function(send) {
    const ctx = $1d9fcaa0a6035698$var$_tabOrder;
    if (!ctx) return;
    if (!$1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.length) {
        $1d9fcaa0a6035698$var$showToast('Add items first.', 'error');
        return;
    }
    try {
        await $1e7ab04ca7920cff$export$d9bb1d157dd4e9e1(ctx.tabId, $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart);
        if (send) $1d9fcaa0a6035698$var$_queueTicket(await $1e7ab04ca7920cff$export$8bd78f925d7fa1dd(ctx.tabId, $1d9fcaa0a6035698$var$_staffNameForTabs()));
        $1d9fcaa0a6035698$var$clearCart();
        $1d9fcaa0a6035698$var$_broadcastCart();
        (0, $472fec5536166250$export$2e2bcd8739ae039).closeNow();
        $1d9fcaa0a6035698$var$showToast(send ? `Sent to the kitchen for table ${ctx.tableName}` : `Saved to table ${ctx.tableName}`, 'success');
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).TABLES_SYNC
        });
        $1d9fcaa0a6035698$var$_backToTables(ctx.tableId);
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not add to the tab.');
    }
};
const $1d9fcaa0a6035698$var$controlTabSend = async function(tabId) {
    try {
        $1d9fcaa0a6035698$var$_queueTicket(await $1e7ab04ca7920cff$export$8bd78f925d7fa1dd(tabId, $1d9fcaa0a6035698$var$_staffNameForTabs()));
        $1d9fcaa0a6035698$var$showToast('Sent to the kitchen', 'success');
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not send to the kitchen.');
    }
};
const $1d9fcaa0a6035698$var$controlTabRemoveLine = async function(tabId, lid) {
    try {
        await $1e7ab04ca7920cff$export$b50b05985e2bcf1e(tabId, lid);
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not remove that item.');
    }
};
const $1d9fcaa0a6035698$var$controlTabUpdate = async function(tabId, patch) {
    try {
        await $1e7ab04ca7920cff$export$55a955c15093a2a1(tabId, patch);
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not update the tab.');
    }
};
// Tab lines -> cart items priced like the server will price them.
const $1d9fcaa0a6035698$var$_tabLinesToCart = (lines)=>lines.map((l)=>{
        const item = $1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.find((m)=>m._id === l.itemId);
        const options = (item?.variants ?? []).flatMap((g)=>g.options ?? []);
        const selectedVariants = l.selectedVariants.map((v)=>({
                variantName: v.variantName,
                variantPrice: Number(options.find((o)=>o.optionName === v.variantName)?.optionPrice ?? 0)
            }));
        const unit = item ? Number(item.price) + selectedVariants.reduce((s, v)=>s + v.variantPrice, 0) : l.unitPrice;
        return {
            itemName: item?.itemName ?? l.itemName,
            price: item ? Number(item.price) : l.unitPrice,
            imageURL: item?.imageURL ?? null,
            selectedVariants: selectedVariants,
            id: l.itemId,
            date: Date.now(),
            quantity: l.quantity,
            totalPrice: unit * l.quantity,
            lineId: l.lid
        };
    });
// Pay the whole tab (lineIds null) or the picked lines (split bill).
const $1d9fcaa0a6035698$var$controlTabPay = function(tabId, lineIds) {
    const tab = $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs.find((t)=>t.id === tabId);
    if (!tab) return;
    if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.length) {
        $1d9fcaa0a6035698$var$showToast('Finish or clear the order in progress first.', 'error');
        return;
    }
    const pick = lineIds ? new Set(lineIds) : null;
    const lines = tab.items.filter((l)=>!l.paidSaleId && (!pick || pick.has(l.lid)));
    if (!lines.length) return;
    $1d9fcaa0a6035698$var$_tabPay = {
        tabId: tabId,
        tableId: tab.tableId,
        tableName: $1d9fcaa0a6035698$var$_tableName(tab.tableId),
        lineIds: lineIds ?? null
    };
    $1e7ab04ca7920cff$export$ca000e230c0caa3e.cart.push(...$1d9fcaa0a6035698$var$_tabLinesToCart(lines));
    $1d9fcaa0a6035698$var$_broadcastCart();
    $1d9fcaa0a6035698$var$controlCloseTables();
    (0, $ab39ca298e181461$export$2e2bcd8739ae039).clearSplit();
    $1d9fcaa0a6035698$var$controlOrderCheckout();
};
const $1d9fcaa0a6035698$var$controlTabMove = async function(tabId, tableId) {
    try {
        await $1e7ab04ca7920cff$export$eb5a85854169158b(tabId, tableId);
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).select(tableId);
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not move the tab.');
    }
};
const $1d9fcaa0a6035698$var$controlTabMerge = async function(fromTabId, intoTabId) {
    try {
        await $1e7ab04ca7920cff$export$86903287c9411571(fromTabId, intoTabId);
        $1d9fcaa0a6035698$var$showToast('Tables joined', 'success');
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not join the tables.');
    }
};
// A closed tab's kitchen tickets leave the queue (team test 2026-10-24: they
// stayed on the home queue after the table was free). Marked done in the DB
// and on every screen, no undo window - the table is already cleared.
const $1d9fcaa0a6035698$var$_clearTabTickets = function(tabId) {
    const tickets = $1d9fcaa0a6035698$var$modelState.orderQueue.filter((o)=>o.fromTab && o.tabId === tabId);
    if (!tickets.length) return;
    $1d9fcaa0a6035698$var$modelState.orderQueue = $1d9fcaa0a6035698$var$modelState.orderQueue.filter((o)=>!tickets.includes(o));
    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
    if ($1d9fcaa0a6035698$var$modelState.orderQueue.length === 0) $1d9fcaa0a6035698$var$_stopKDSTick();
    tickets.forEach((t)=>{
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).KDS_ORDER_DONE,
            id: t.id
        });
        $1e7ab04ca7920cff$export$e0bf0609ec0e8d2f(t.id, false).catch(()=>{});
    });
};
const $1d9fcaa0a6035698$var$controlTabClose = function(tabId) {
    const tab = $1e7ab04ca7920cff$export$ca000e230c0caa3e.openTabs.find((t)=>t.id === tabId);
    if (!tab) return;
    const unpaidCount = tab.items.filter((l)=>!l.paidSaleId).length;
    (0, $472fec5536166250$export$2e2bcd8739ae039).showConfirmModal({
        message: unpaidCount ? `Close this tab with ${unpaidCount} unpaid item${unpaidCount === 1 ? '' : 's'}?` : 'Close this tab?',
        note: unpaidCount ? 'Nothing is charged. Only a manager who can void sales can do this.' : null,
        confirmLabel: 'Close tab',
        cancelLabel: 'Keep it open',
        onConfirm: async ()=>{
            try {
                await $1e7ab04ca7920cff$export$ca50a360e53500d1(tabId);
                $1d9fcaa0a6035698$var$_clearTabTickets(tabId);
                $1d9fcaa0a6035698$var$_tablesChanged();
            } catch (err) {
                $1d9fcaa0a6035698$var$_tablesError(err, 'Could not close the tab.');
            }
        }
    });
};
const $1d9fcaa0a6035698$var$controlReservationDay = async function(delta) {
    const base = $1d9fcaa0a6035698$var$_resDay ?? $1d9fcaa0a6035698$var$_bizToday();
    if (delta === 0) $1d9fcaa0a6035698$var$_resDay = $1d9fcaa0a6035698$var$_bizToday();
    else $1d9fcaa0a6035698$var$_resDay = (0, $lDSCx.addDays)(base, delta);
    try {
        $1d9fcaa0a6035698$var$_resForDay = [
            ...await $1e7ab04ca7920cff$export$968e31c3f3742111(...$1d9fcaa0a6035698$var$_dayRange($1d9fcaa0a6035698$var$_resDay))
        ];
        $1d9fcaa0a6035698$var$_renderTables();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not load that day.');
    }
};
const $1d9fcaa0a6035698$var$controlSaveReservation = async function(data) {
    try {
        await $1e7ab04ca7920cff$export$de770b4ae1a17f4c(data);
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).afterReservationSaved();
        await $1d9fcaa0a6035698$var$_loadTablesAll();
        $1d9fcaa0a6035698$var$showToast(`Booked ${data.name}, ${data.partySize}`, 'success');
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not save the booking.');
    }
};
const $1d9fcaa0a6035698$var$controlReservationStatus = async function(id, status) {
    try {
        await $1e7ab04ca7920cff$export$50ccea48c85bc751(id, status);
        await $1d9fcaa0a6035698$var$_loadTablesAll();
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not update the booking.');
    }
};
const $1d9fcaa0a6035698$var$controlAddWaitlist = async function(data) {
    try {
        await $1e7ab04ca7920cff$export$d36ad63dc1382c11(data);
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).afterWaitlistAdded();
        await $1e7ab04ca7920cff$export$efe8831a8901fd7f();
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not add the party.');
    }
};
const $1d9fcaa0a6035698$var$controlWaitlistStatus = async function(id, status) {
    try {
        await $1e7ab04ca7920cff$export$b00468b00729f211(id, {
            status: status
        });
        await $1e7ab04ca7920cff$export$efe8831a8901fd7f();
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not update the waitlist.');
    }
};
const $1d9fcaa0a6035698$var$controlSaveTableLayout = async function(tables, removedIds) {
    try {
        await $1e7ab04ca7920cff$export$93bcd8ea4d83f513(tables, removedIds);
        (0, $ab39ca298e181461$export$2e2bcd8739ae039).afterLayoutSaved();
        $1d9fcaa0a6035698$var$showToast('Tables saved', 'success');
        $1d9fcaa0a6035698$var$_tablesChanged();
    } catch (err) {
        $1d9fcaa0a6035698$var$_tablesError(err, 'Could not save the tables.');
    }
};
const $1d9fcaa0a6035698$var$controlOpenSchedule = async function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_schedule')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to the schedule.", 'error');
        return;
    }
    $1d9fcaa0a6035698$var$_scheduleMonday = (0, $lDSCx.mondayOf)((0, $lDSCx.todayIn)($1d9fcaa0a6035698$var$_bizTz()));
    (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).open();
    (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).renderLoading();
    try {
        await Promise.all([
            $1e7ab04ca7920cff$export$34ce29dd271bbc01().catch(()=>{}),
            $1e7ab04ca7920cff$export$84a0e7efcf44c962()
        ]);
        await $1d9fcaa0a6035698$var$_loadScheduleWeek();
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_scheduleData());
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not load the schedule.', 'error');
    }
};
const $1d9fcaa0a6035698$var$controlScheduleWeek = async function(delta) {
    $1d9fcaa0a6035698$var$_scheduleMonday = delta === 0 ? (0, $lDSCx.mondayOf)((0, $lDSCx.todayIn)($1d9fcaa0a6035698$var$_bizTz())) : (0, $lDSCx.addDays)($1d9fcaa0a6035698$var$_scheduleMonday, 7 * delta);
    (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).renderLoading();
    try {
        await $1d9fcaa0a6035698$var$_loadScheduleWeek();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not load that week.', 'error');
    }
    (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_scheduleData());
};
const $1d9fcaa0a6035698$var$_shiftTimes = (day, startTime, endTime)=>{
    const tz = $1d9fcaa0a6035698$var$_bizTz();
    return {
        startsAt: (0, $lDSCx.zonedToDate)(day, startTime, tz).toISOString(),
        endsAt: (0, $lDSCx.zonedToDate)(endTime > startTime ? day : (0, $lDSCx.addDays)(day, 1), endTime, tz).toISOString()
    };
};
const $1d9fcaa0a6035698$var$_plural = (n, one, many = `${one}s`)=>`${n} ${n === 1 ? one : many}`;
// "This shift / This and following / All upcoming" for a repeat. Resolves
// { value, checked } or null if cancelled. `checked` = also change shifts that
// were edited on their own (Kelly: keep one-off changes unless asked).
const $1d9fcaa0a6035698$var$_askRepeatScope = (verb)=>(0, $27809bb01dc8a27e$export$2e2bcd8739ae039).askChoice({
        title: verb === 'delete' ? 'Delete repeating shift' : 'Change repeating shift',
        options: [
            {
                value: 'this',
                label: 'This shift',
                hint: 'Only this day. The rest of the repeat stays as it is.'
            },
            {
                value: 'following',
                label: 'This and following shifts',
                hint: 'From this day on. Earlier weeks stay as they were.'
            },
            {
                value: 'all',
                label: 'All upcoming shifts',
                hint: 'Every shift in this repeat from today on. Past shifts are kept.'
            }
        ],
        checkbox: {
            label: `Also ${verb === 'delete' ? 'delete' : 'change'} shifts in this repeat that you edited one by one`,
            showFor: [
                'following',
                'all'
            ]
        },
        confirmLabel: verb === 'delete' ? 'Delete' : 'Save',
        danger: verb === 'delete'
    });
const $1d9fcaa0a6035698$var$_afterScheduleChange = async (message)=>{
    await $1d9fcaa0a6035698$var$_loadScheduleWeek();
    (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).closeDialog();
    (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_scheduleData());
    $1d9fcaa0a6035698$var$showToast(message, 'success');
};
// payload: { shift (null = new), staffId, stationId, days[], weekdays[], startTime,
// endTime, repeat, untilDate, note }
const $1d9fcaa0a6035698$var$controlSaveScheduledShift = async function(p) {
    const def = {
        staffId: p.staffId,
        stationId: p.stationId,
        weekdays: p.weekdays,
        startTime: p.startTime,
        endTime: p.endTime,
        untilDate: p.untilDate,
        note: p.note
    };
    const shift = p.shift;
    try {
        // ── An existing shift that belongs to a repeat ──
        if (shift?.seriesId) {
            const scope = await $1d9fcaa0a6035698$var$_askRepeatScope('change');
            if (!scope) return;
            (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).setDialogBusy(true);
            const day = shift.seriesDate;
            if (scope.value === 'this') {
                await $1e7ab04ca7920cff$export$e9ee2cce7ad81ff8({
                    id: shift.id,
                    staffId: p.staffId,
                    stationId: p.stationId,
                    note: p.note,
                    isException: true,
                    ...$1d9fcaa0a6035698$var$_shiftTimes(day, p.startTime, p.endTime)
                });
                return $1d9fcaa0a6035698$var$_afterScheduleChange('Shift saved. The rest of the repeat is unchanged.');
            }
            if (!p.repeat) {
                // Turned the repeat off: end it here and keep this day as a single shift.
                await $1e7ab04ca7920cff$export$a9a155f5986d513d(shift.seriesId, day, scope.value, scope.checked);
                await $1e7ab04ca7920cff$export$59501082074c9b7b([
                    {
                        staffId: p.staffId,
                        stationId: p.stationId,
                        note: p.note,
                        ...$1d9fcaa0a6035698$var$_shiftTimes(day, p.startTime, p.endTime)
                    }
                ]);
                return $1d9fcaa0a6035698$var$_afterScheduleChange('The repeat now ends here. This day is kept as a single shift.');
            }
            await $1e7ab04ca7920cff$export$2d5950d64d542cba(shift.seriesId, day, scope.value, def, scope.checked);
            return $1d9fcaa0a6035698$var$_afterScheduleChange(scope.value === 'all' ? 'All upcoming shifts in this repeat are updated.' : 'This and following shifts are updated.');
        }
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).setDialogBusy(true);
        // ── New repeat, or a one-off turned into a repeat ──
        if (p.repeat) {
            const startDate = [
                ...p.days
            ].sort()[0];
            if (p.untilDate && p.untilDate < startDate) throw new Error('The last day is before the first shift.');
            await $1e7ab04ca7920cff$export$74e3ef02ea17ad1a({
                ...def,
                startDate: startDate
            });
            if (shift) await $1e7ab04ca7920cff$export$693657b09f3a8cd9(shift.id);
            return $1d9fcaa0a6035698$var$_afterScheduleChange(shift ? 'This shift now repeats every week.' : 'Repeating shift added as a draft. Publish the week when ready.');
        }
        // ── Edit one single shift ──
        if (shift) {
            await $1e7ab04ca7920cff$export$e9ee2cce7ad81ff8({
                id: shift.id,
                staffId: p.staffId,
                stationId: p.stationId,
                note: p.note,
                ...$1d9fcaa0a6035698$var$_shiftTimes(p.days[0], p.startTime, p.endTime)
            });
            return $1d9fcaa0a6035698$var$_afterScheduleChange('Shift saved.');
        }
        // ── New single shift(s): one per chosen day ──
        const n = await $1e7ab04ca7920cff$export$59501082074c9b7b(p.days.map((d)=>({
                staffId: p.staffId,
                stationId: p.stationId,
                note: p.note,
                ...$1d9fcaa0a6035698$var$_shiftTimes(d, p.startTime, p.endTime)
            })));
        return $1d9fcaa0a6035698$var$_afterScheduleChange(n > 1 ? `${$1d9fcaa0a6035698$var$_plural(n, 'shift')} added as drafts.` : 'Shift added as a draft.');
    } catch (err) {
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).setDialogBusy(false);
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not save the shift.', 'error');
    }
};
const $1d9fcaa0a6035698$var$controlDeleteScheduledShift = async function(shift) {
    try {
        if (shift.seriesId) {
            const scope = await $1d9fcaa0a6035698$var$_askRepeatScope('delete');
            if (!scope) return;
            (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).setDialogBusy(true);
            await $1e7ab04ca7920cff$export$a9a155f5986d513d(shift.seriesId, shift.seriesDate, scope.value, scope.checked);
            return $1d9fcaa0a6035698$var$_afterScheduleChange(scope.value === 'this' ? 'Shift deleted. The rest of the repeat is unchanged.' : 'Repeating shifts deleted.');
        }
        if (shift.publishedAt && !confirm('This shift is published, so your team can already see it. Delete it anyway?')) return;
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).setDialogBusy(true);
        await $1e7ab04ca7920cff$export$693657b09f3a8cd9(shift.id);
        return $1d9fcaa0a6035698$var$_afterScheduleChange('Shift deleted.');
    } catch (err) {
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).setDialogBusy(false);
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not delete the shift.', 'error');
    }
};
// Copies last week's single shifts into this week as drafts, keeping each one's
// local weekday and clock times (so a daylight-saving change can't move them an
// hour). Repeating shifts are skipped: they fill in this week on their own.
const $1d9fcaa0a6035698$var$controlCopyLastWeek = async function() {
    const tz = $1d9fcaa0a6035698$var$_bizTz();
    const prevMonday = (0, $lDSCx.addDays)($1d9fcaa0a6035698$var$_scheduleMonday, -7);
    const current = [
        ...$1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduledShifts
    ];
    try {
        const prevAll = await $1e7ab04ca7920cff$export$145b6d72ee5a6844(...$1d9fcaa0a6035698$var$_weekRangeISO(prevMonday));
        $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduledShifts = current;
        const prev = prevAll.filter((s)=>!s.seriesId);
        if (!prev.length) {
            $1d9fcaa0a6035698$var$showToast(prevAll.length ? "Last week only had repeating shifts, and those are already on this week." : 'Last week has no shifts to copy.', 'error');
            return;
        }
        if (current.length && !confirm(`This week already has ${$1d9fcaa0a6035698$var$_plural(current.length, 'shift')}. Add last week's ${prev.length} single ${prev.length === 1 ? 'shift' : 'shifts'} on top as drafts?`)) return;
        const shiftForward = (iso)=>{
            const p = (0, $lDSCx.zonedParts)(new Date(iso), tz);
            return (0, $lDSCx.zonedToDate)((0, $lDSCx.addDays)(p.dateStr, 7), p.timeStr, tz).toISOString();
        };
        const n = await $1e7ab04ca7920cff$export$59501082074c9b7b(prev.map((s)=>({
                ...s,
                startsAt: shiftForward(s.startsAt),
                endsAt: shiftForward(s.endsAt)
            })));
        await $1d9fcaa0a6035698$var$_loadScheduleWeek();
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_scheduleData());
        $1d9fcaa0a6035698$var$showToast(`Copied ${$1d9fcaa0a6035698$var$_plural(n, 'shift')} as drafts. Publish when you're ready.`, 'success');
    } catch (err) {
        await $1d9fcaa0a6035698$var$_loadScheduleWeek().catch(()=>{});
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_scheduleData());
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not copy last week.', 'error');
    }
};
// Publishing a week with repeats asks whether their future weeks should go live
// on their own from now on (Kelly: ask first, don't assume).
const $1d9fcaa0a6035698$var$controlPublishSchedule = async function() {
    const drafts = $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduledShifts.filter((s)=>!s.publishedAt);
    if (!drafts.length) return;
    const repeatIds = [
        ...new Set(drafts.map((s)=>s.seriesId).filter(Boolean))
    ].filter((id)=>!$1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleSeries.find((x)=>x.id === id)?.autoPublish);
    let keepLive = false;
    if (repeatIds.length) {
        const choice = await (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).askChoice({
            title: `Publish ${(0, $lDSCx.weekLabel)($1d9fcaa0a6035698$var$_scheduleMonday)}`,
            body: `${$1d9fcaa0a6035698$var$_plural(drafts.length, 'shift')} will go to your team. ${repeatIds.length === 1 ? 'One of them repeats' : `${repeatIds.length} of them repeat`} every week.`,
            options: [
                {
                    value: 'live',
                    label: 'Publish and keep future weeks live',
                    hint: 'Repeating shifts show up for staff automatically every week from now on.'
                },
                {
                    value: 'week',
                    label: 'Publish this week only',
                    hint: "Next week's repeats stay drafts until you publish that week."
                }
            ],
            confirmLabel: 'Publish'
        });
        if (!choice) return;
        keepLive = choice.value === 'live';
    } else if (!confirm(`Publish ${$1d9fcaa0a6035698$var$_plural(drafts.length, 'shift')} for ${(0, $lDSCx.weekLabel)($1d9fcaa0a6035698$var$_scheduleMonday)}? Your team will see them on the Time Clock.`)) return;
    try {
        const n = await $1e7ab04ca7920cff$export$3d3d5096f6870cdc($1d9fcaa0a6035698$var$_scheduleMonday);
        if (keepLive) await $1e7ab04ca7920cff$export$d74f48f814b01409(repeatIds, $1d9fcaa0a6035698$var$_weekRangeISO($1d9fcaa0a6035698$var$_scheduleMonday)[0]);
        await $1d9fcaa0a6035698$var$_loadScheduleWeek();
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_scheduleData());
        $1d9fcaa0a6035698$var$showToast(`Published ${$1d9fcaa0a6035698$var$_plural(n, 'shift')}.${keepLive ? ' Repeating shifts will stay live in future weeks.' : ''} Your team can see them now.`, 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not publish the schedule.', 'error');
    }
};
// Opening Requests or Availability refetches, so a request filed on the Time
// Clock a minute ago shows up without reopening the panel.
const $1d9fcaa0a6035698$var$controlScheduleSection = async function(section) {
    if (section !== 'requests' && section !== 'availability') return;
    await $1d9fcaa0a6035698$var$_loadScheduleExtras();
    if ((0, $27809bb01dc8a27e$export$2e2bcd8739ae039).isOpen()) (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_scheduleData());
};
const $1d9fcaa0a6035698$var$controlReviewShiftRequest = async function(req, decision) {
    const who = req.kind === 'pickup' ? req.requesterName : req.targetName;
    if (decision === 'reject' && !confirm(`Decline this ${req.kind === 'pickup' ? 'pickup' : 'swap'} request? ${req.requesterName || 'They'} will see it was declined.`)) return;
    try {
        const result = await $1e7ab04ca7920cff$export$696a4d1ce6cff00e(req.id, decision, null);
        await $1d9fcaa0a6035698$var$_loadScheduleWeek();
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_scheduleData());
        $1d9fcaa0a6035698$var$_refreshNotifications();
        if (result === 'stale') $1d9fcaa0a6035698$var$showToast('That shift changed since they asked (someone else has it now, or it already started), so the request was closed.', 'error');
        else if (result === 'approved') $1d9fcaa0a6035698$var$showToast(req.kind === 'pickup' ? `Approved. The shift is ${who || 'theirs'} now.` : 'Approved. The schedule is updated.', 'success');
        else $1d9fcaa0a6035698$var$showToast('Request declined.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not update the request.', 'error');
    }
};
const $1d9fcaa0a6035698$var$controlSaveAvailability = async function(staffId, days) {
    try {
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).setDialogBusy(true);
        await $1e7ab04ca7920cff$export$9823a39c30c0077(staffId, days);
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).closeDialog();
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_scheduleData());
        $1d9fcaa0a6035698$var$showToast('Availability saved.', 'success');
    } catch (err) {
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).setDialogBusy(false);
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not save availability.', 'error');
    }
};
const $1d9fcaa0a6035698$var$controlAddStation = async function(station) {
    try {
        await $1e7ab04ca7920cff$export$8af991e8865719ed(station);
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_scheduleData());
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not add the station.', 'error');
    }
};
// Name/color edits save in place without a re-render (keeps focus where it is).
const $1d9fcaa0a6035698$var$controlUpdateStation = async function(id, patch) {
    try {
        await $1e7ab04ca7920cff$export$c8be5d7f24976a48(id, patch);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not save the station.', 'error');
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_scheduleData());
    }
};
const $1d9fcaa0a6035698$var$controlArchiveStation = async function(id) {
    const st = $1e7ab04ca7920cff$export$ca000e230c0caa3e.scheduleStations.find((s)=>s.id === id);
    if (!st || !confirm(`Remove "${st.name}"? Shifts that already use it keep the label.`)) return;
    try {
        await $1e7ab04ca7920cff$export$ccff87b35acb3892(id);
        (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_scheduleData());
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not remove the station.', 'error');
    }
};
// ── Inventory ─────────────────────────────────────────────────────────────────
let $1d9fcaa0a6035698$var$_inventoryHistoryFilter = null;
// One snapshot shape shared by every Inventory render/refresh path.
const $1d9fcaa0a6035698$var$_inventorySnapshot = function() {
    return {
        items: $1d9fcaa0a6035698$var$modelState.inventoryItems,
        links: $1d9fcaa0a6035698$var$modelState.inventoryLinks,
        adjustments: $1d9fcaa0a6035698$var$modelState.inventoryAdjustments,
        menuItems: $1d9fcaa0a6035698$var$modelState.menuItems,
        suppliers: $1d9fcaa0a6035698$var$modelState.suppliers,
        itemSuppliers: $1d9fcaa0a6035698$var$modelState.itemSuppliers,
        purchaseOrders: $1d9fcaa0a6035698$var$modelState.purchaseOrders,
        inventoryEnabled: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.inventoryEnabled !== false,
        historyFilter: $1d9fcaa0a6035698$var$_inventoryHistoryFilter,
        invoiceLabelFor: (adj)=>(0, $78df0284a57ee0dd$export$1fa50150e73e75ba)(adj.receiptNumber, adj.saleDate)
    };
};
const $1d9fcaa0a6035698$var$controlOpenInventory = async function() {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_inventory')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to inventory.", 'error');
        return;
    }
    if ($1d9fcaa0a6035698$var$_practiceOn('inventory')) {
        $1d9fcaa0a6035698$var$_practiceInventoryOpen();
        return;
    }
    if ($1e7ab04ca7920cff$export$57b484963858c9a0('inventory')) {
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).open();
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).renderLockedTeaser($1d9fcaa0a6035698$var$_inventorySnapshot());
        return;
    }
    try {
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).open();
        // "Set up inventory" (Getting Started) checks off when the owner opens
        // this panel - write-once, view-based like the taxes/receipt/team steps.
        if ($1e7ab04ca7920cff$export$b325ec6732b039cf('manage_business') && !$1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.inventorySetupSeen) {
            $1e7ab04ca7920cff$export$680c723e3a62d1c3('inventorySetupSeen', true);
            $1d9fcaa0a6035698$var$_updateGettingStarted();
        }
        $1d9fcaa0a6035698$var$_inventoryHistoryFilter = null;
        await Promise.all([
            $1e7ab04ca7920cff$export$45aba0c57314d190(),
            $1e7ab04ca7920cff$export$2e183382b4951272().catch(()=>[]),
            $1e7ab04ca7920cff$export$9299725340e97fc6().catch(()=>[]),
            $1e7ab04ca7920cff$export$4faf3f9b9ffc9853().catch(()=>[])
        ]);
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_inventorySnapshot());
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlCloseInventory = function() {
    (0, $b0886db79b2df847$export$2e2bcd8739ae039).close();
};
const $1d9fcaa0a6035698$var$controlAdjustStock = async function(itemId, delta, note) {
    try {
        const item = await $1e7ab04ca7920cff$export$e4498848cc4f0958(itemId, delta, note);
        if (item) (0, $b0886db79b2df847$export$2e2bcd8739ae039).patchItemRow(item);
        // History (and other terminals) refresh from the DB, not from guesswork.
        $1e7ab04ca7920cff$export$2e183382b4951272($1d9fcaa0a6035698$var$_inventoryHistoryFilter).then(()=>{
            (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
        }).catch(()=>{});
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).INVENTORY_SYNC
        });
        $1d9fcaa0a6035698$var$_requestActivityRefresh();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
// onSaved: optional callback with the created item - the PO form's quick-add
// uses it to select the new item in place (after the panel re-render, so the
// fresh item list is already in the view's snapshot).
const $1d9fcaa0a6035698$var$controlCreateInventoryItem = async function(data, onSaved) {
    try {
        const item = await $1e7ab04ca7920cff$export$9bccf79e85d1f187(data);
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_inventorySnapshot());
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).INVENTORY_SYNC
        });
        $1d9fcaa0a6035698$var$showToast('Inventory item added.', 'success');
        onSaved?.(item);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlUpdateInventoryItem = async function(id, data) {
    try {
        await $1e7ab04ca7920cff$export$3047042a7e84a73f(id, data);
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_inventorySnapshot());
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).INVENTORY_SYNC
        });
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlDeleteInventoryItem = async function(id) {
    try {
        await $1e7ab04ca7920cff$export$be780bf73aedfa4e(id);
        // Removing an item can change which products count as out of stock.
        $1e7ab04ca7920cff$export$2e183382b4951272($1d9fcaa0a6035698$var$_inventoryHistoryFilter).catch(()=>{});
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_inventorySnapshot());
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).INVENTORY_SYNC
        });
        $1d9fcaa0a6035698$var$showToast('Inventory item deleted.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlInventoryHistoryFilter = async function(itemId) {
    $1d9fcaa0a6035698$var$_inventoryHistoryFilter = itemId;
    try {
        await $1e7ab04ca7920cff$export$2e183382b4951272(itemId);
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).render($1d9fcaa0a6035698$var$_inventorySnapshot());
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
// ── Inventory: master on/off toggle ───────────────────────────────────────────
// Business-level (server-authoritative). Off = sales stop deducting stock and
// every low/out-of-stock signal is muted (order chips, heads-up modal,
// activity feed). Data and history are untouched. Persists instantly - an
// explicit switch, not a passive settings draft.
const $1d9fcaa0a6035698$var$controlToggleInventoryEnabled = function(enabled) {
    $1e7ab04ca7920cff$export$680c723e3a62d1c3('inventoryEnabled', enabled);
    (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
    (0, $472fec5536166250$export$2e2bcd8739ae039).updateStockBadges($1e7ab04ca7920cff$export$916349a6610ebe78());
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).INVENTORY_SYNC
    });
    $1d9fcaa0a6035698$var$showToast(enabled ? 'Inventory tracking is on.' : 'Inventory tracking is off. Sales will not lower stock.', 'success');
};
// ── Inventory: product links from the item drawer ("Used by") ────────────────
const $1d9fcaa0a6035698$var$_afterLinkChange = function() {
    (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
    (0, $472fec5536166250$export$2e2bcd8739ae039).updateStockBadges($1e7ab04ca7920cff$export$916349a6610ebe78());
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).INVENTORY_SYNC
    });
};
const $1d9fcaa0a6035698$var$controlAddProductLink = async function(menuItemId, inventoryItemId, qty, overrides = []) {
    try {
        await $1e7ab04ca7920cff$export$9ce3becf58294930(menuItemId, inventoryItemId, qty, overrides);
        $1d9fcaa0a6035698$var$_afterLinkChange();
        $1d9fcaa0a6035698$var$showToast(overrides.length ? 'Product connected with per-variant amounts.' : 'Product connected.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlUpdateProductLink = async function(linkId, qty) {
    try {
        await $1e7ab04ca7920cff$export$45217375fd184b3b(linkId, qty);
        $1d9fcaa0a6035698$var$_afterLinkChange();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlRemoveProductLink = async function(linkId) {
    try {
        await $1e7ab04ca7920cff$export$f2e9359823a750d0(linkId);
        $1d9fcaa0a6035698$var$_afterLinkChange();
        $1d9fcaa0a6035698$var$showToast('Product unlinked.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
// Variant overrides are edited in the product editor - deep-link there
// (catalogue opens over the inventory panel; closing it returns here).
const $1d9fcaa0a6035698$var$controlEditLinkedProduct = function(menuItemId) {
    $1d9fcaa0a6035698$var$controlMenuList();
    $1d9fcaa0a6035698$var$controlShowEditMenu(menuItemId);
};
// ── Item <-> supplier price list (edited from BOTH the item drawer and the
//    supplier drawer - one table underneath, always in sync) ─────────────────
const $1d9fcaa0a6035698$var$_afterItemSupplierChange = function() {
    (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
    (0, $boau7.default).postMessage({
        type: (0, $boau7.MSG).INVENTORY_SYNC
    });
};
const $1d9fcaa0a6035698$var$controlAddItemSupplier = async function(itemId, supplierId, unitCost) {
    try {
        await $1e7ab04ca7920cff$export$9fc09e523947782f(itemId, supplierId, unitCost);
        $1d9fcaa0a6035698$var$_afterItemSupplierChange();
        $1d9fcaa0a6035698$var$showToast('Supplier linked.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlSetPreferredSupplier = async function(rowId) {
    try {
        await $1e7ab04ca7920cff$export$27c16f7c55c179b8(rowId);
        $1d9fcaa0a6035698$var$_afterItemSupplierChange();
        $1d9fcaa0a6035698$var$showToast('Preferred supplier updated.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlUpdateSupplierCost = async function(rowId, unitCost) {
    try {
        await $1e7ab04ca7920cff$export$79948de40748f795(rowId, unitCost);
        $1d9fcaa0a6035698$var$_afterItemSupplierChange();
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlRemoveItemSupplier = async function(rowId) {
    try {
        await $1e7ab04ca7920cff$export$c9cb699daae954f0(rowId);
        $1d9fcaa0a6035698$var$_afterItemSupplierChange();
        $1d9fcaa0a6035698$var$showToast('Supplier unlinked.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
// ── Suppliers ─────────────────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$controlSaveSupplier = async function(id, data) {
    try {
        const supplier = id ? await $1e7ab04ca7920cff$export$34a6a6061705c148(id, data) : await $1e7ab04ca7920cff$export$34282235f203c059(data);
        // Reconcile the form's "items they supply" rows against the shared
        // item<->supplier price list: remove unlisted, update changed prices,
        // add new (preferred/promote logic lives in the model).
        if (Array.isArray(data.supplyItems)) {
            const desired = new Map(data.supplyItems.map((r)=>[
                    r.inventoryItemId,
                    r.unitCost
                ]));
            const existing = [
                ...$1e7ab04ca7920cff$export$ca000e230c0caa3e.itemSuppliers.filter((r)=>r.supplierId === supplier.id)
            ];
            for (const row of existing)if (!desired.has(row.inventoryItemId)) await $1e7ab04ca7920cff$export$c9cb699daae954f0(row.id);
            else {
                const raw = desired.get(row.inventoryItemId);
                const parsed = raw === '' || raw == null || isNaN(Number(raw)) ? null : Number(raw);
                if (parsed !== row.unitCost) await $1e7ab04ca7920cff$export$79948de40748f795(row.id, raw);
                desired.delete(row.inventoryItemId);
            }
            for (const [itemId, cost] of desired)await $1e7ab04ca7920cff$export$9fc09e523947782f(itemId, supplier.id, cost);
        }
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).INVENTORY_SYNC
        });
        $1d9fcaa0a6035698$var$showToast(id ? 'Supplier updated.' : 'Supplier added.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlDeleteSupplier = async function(id) {
    try {
        await $1e7ab04ca7920cff$export$a722dd3aa9fcbcf9(id);
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).INVENTORY_SYNC
        });
        $1d9fcaa0a6035698$var$showToast('Supplier deleted. Items keep their history.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
// ── Purchase orders ───────────────────────────────────────────────────────────
// Optional receipt photo: upload first (5 MB guarded pipeline) so the PO row
// is written with its URL. An upload failure aborts with a clear toast - the
// user can retry or remove the file.
const $1d9fcaa0a6035698$var$_resolvePoReceipt = async function(data) {
    if (!data.receiptFile) return data;
    const receiptUrl = await $1e7ab04ca7920cff$export$e1b5b8709c4dd3ea(data.receiptFile);
    return {
        ...data,
        receiptUrl: receiptUrl
    };
};
const $1d9fcaa0a6035698$var$controlCreatePurchaseOrder = async function(data) {
    try {
        data = await $1d9fcaa0a6035698$var$_resolvePoReceipt(data);
        const po = await $1e7ab04ca7920cff$export$64c098ad61acc713(data);
        const label = `PO-${String(po.poNumber).padStart(3, '0')}`;
        // Where the order already is: draft (default), sent (awaiting delivery),
        // or received (log-after-the-fact - stock goes up right away).
        if (data.initialStatus === 'sent') {
            await $1e7ab04ca7920cff$export$8f7ddc9b24ef771e(po.id, 'sent');
            (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
            (0, $boau7.default).postMessage({
                type: (0, $boau7.MSG).INVENTORY_SYNC
            });
            $1d9fcaa0a6035698$var$showToast(`${label} created - waiting for delivery.`, 'success');
        } else if (data.initialStatus === 'received') await $1d9fcaa0a6035698$var$controlReceivePurchaseOrder(po.id); // handles reloads, badges, toast
        else {
            (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
            (0, $boau7.default).postMessage({
                type: (0, $boau7.MSG).INVENTORY_SYNC
            });
            $1d9fcaa0a6035698$var$showToast(`${label} saved - for approval.`, 'success');
        }
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlUpdatePurchaseOrder = async function(id, data) {
    try {
        data = await $1d9fcaa0a6035698$var$_resolvePoReceipt(data);
        await $1e7ab04ca7920cff$export$3f84ff93b90500e1(id, data);
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).INVENTORY_SYNC
        });
        $1d9fcaa0a6035698$var$showToast('Purchase order updated.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
const $1d9fcaa0a6035698$var$controlSetPoStatus = async function(id, status) {
    try {
        await $1e7ab04ca7920cff$export$8f7ddc9b24ef771e(id, status);
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).INVENTORY_SYNC
        });
        if (status === 'sent') $1d9fcaa0a6035698$var$showToast('Order approved - waiting for delivery. Order it with your supplier however you normally do.', 'success');
        if (status === 'cancelled') $1d9fcaa0a6035698$var$showToast('Purchase order cancelled.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
// Whole-PO receive: RPC adds every line to stock atomically, then everything
// that shows stock refreshes (panel, order-screen badges, other terminals,
// activity feed).
const $1d9fcaa0a6035698$var$controlReceivePurchaseOrder = async function(id) {
    try {
        await $1e7ab04ca7920cff$export$172252b276419be8(id);
        await Promise.all([
            $1e7ab04ca7920cff$export$45aba0c57314d190(),
            $1e7ab04ca7920cff$export$4faf3f9b9ffc9853(),
            $1e7ab04ca7920cff$export$2e183382b4951272($1d9fcaa0a6035698$var$_inventoryHistoryFilter).catch(()=>[])
        ]);
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
        (0, $472fec5536166250$export$2e2bcd8739ae039).updateStockBadges($1e7ab04ca7920cff$export$916349a6610ebe78());
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).INVENTORY_SYNC
        });
        $1d9fcaa0a6035698$var$_requestActivityRefresh();
        const po = $1e7ab04ca7920cff$export$ca000e230c0caa3e.purchaseOrders.find((p)=>p.id === id);
        $1d9fcaa0a6035698$var$showToast(`PO-${String(po?.poNumber ?? 0).padStart(3, '0')} received. Stock updated.`, 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
// ── Stock counts ──────────────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$controlApplyStockCount = async function(lines) {
    try {
        await $1e7ab04ca7920cff$export$67926c1266cf291c(lines);
        await Promise.all([
            $1e7ab04ca7920cff$export$45aba0c57314d190(),
            $1e7ab04ca7920cff$export$2e183382b4951272($1d9fcaa0a6035698$var$_inventoryHistoryFilter).catch(()=>[])
        ]);
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
        (0, $472fec5536166250$export$2e2bcd8739ae039).updateStockBadges($1e7ab04ca7920cff$export$916349a6610ebe78());
        (0, $boau7.default).postMessage({
            type: (0, $boau7.MSG).INVENTORY_SYNC
        });
        $1d9fcaa0a6035698$var$_requestActivityRefresh();
        $1d9fcaa0a6035698$var$showToast(`Stock count applied. ${lines.length} item${lines.length === 1 ? '' : 's'} updated.`, 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err, 'error');
    }
};
// Home sidebar "Time Clock" shortcut: managers land on the Timesheets panel's
// Time Clock section (device setup, kiosk link, how-it-works, who's timed in).
// Staff without panel access just get the kiosk page itself.
const $1d9fcaa0a6035698$var$controlOpenTimeclockHub = function() {
    if ($1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay') || $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_staff')) {
        (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).setSection('timeclock');
        $1d9fcaa0a6035698$var$controlOpenTimesheets();
    } else // Clean /timeclock URL via the Netlify rewrite; the dev server has no
    // rewrites, so localhost opens the .html directly.
    window.open(location.hostname === 'localhost' ? 'timeclock.html' : '/timeclock', '_blank');
};
const $1d9fcaa0a6035698$var$_maybeShowPinSetup = function() {
    if (!$1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff || $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.hasPin) return;
    const name = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.firstName || 'there';
    const el = document.createElement('div');
    el.className = 'cashier-picker-overlay';
    el.style.zIndex = '99999';
    const card = document.createElement('div');
    card.className = 'cashier-picker-card';
    card.style.maxWidth = '340px';
    el.appendChild(card);
    document.body.appendChild(el);
    const renderCreate = ()=>{
        card.innerHTML = `
      <div class="cashier-picker-header" style="border-bottom:none;padding-bottom:0">
        <div>
          <h3 class="cashier-picker-title">Set Your PIN</h3>
          <p class="cashier-picker-subtitle">Hi ${(0, $cnCXJ.esc)(name)}! Create a 6-digit PIN to use at the register.</p>
        </div>
      </div>
      <div class="cashier-pin-screen">
        <div class="cashier-pin-dots" id="pinSetupDots">
          ${'<span class="cashier-pin-dot"></span>'.repeat(6)}
        </div>
        <p class="cashier-pin-error hidden" id="pinSetupError">PINs don't match. Try again.</p>
        <div class="cashier-numpad">
          ${[
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].map((n)=>`<button class="cashier-numpad-btn" data-key="${n}">${n}</button>`).join('')}
          <div></div>
          <button class="cashier-numpad-btn" data-key="0">0</button>
          <button class="cashier-numpad-btn cashier-numpad-nav" data-key="del" aria-label="Delete digit">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/><line x1="18" y1="9" x2="12" y2="15"/><line x1="12" y1="9" x2="18" y2="15"/></svg>
          </button>
        </div>
      </div>
    `;
        let entered = '';
        const updateDots = ()=>card.querySelectorAll('.cashier-pin-dot').forEach((d, i)=>d.classList.toggle('cashier-pin-dot--filled', i < entered.length));
        card.querySelector('.cashier-numpad')?.addEventListener('click', (e)=>{
            const key = e.target.closest('.cashier-numpad-btn')?.dataset.key;
            if (!key) return;
            if (key === 'del') {
                entered = entered.slice(0, -1);
                updateDots();
                return;
            }
            if (entered.length >= 6) return;
            entered += key;
            updateDots();
            if (entered.length === 6) renderConfirm(entered);
        });
    };
    const renderConfirm = (firstPin)=>{
        card.innerHTML = `
      <div class="cashier-picker-header" style="border-bottom:none;padding-bottom:0">
        <div>
          <h3 class="cashier-picker-title">Confirm PIN</h3>
          <p class="cashier-picker-subtitle">Enter your PIN one more time.</p>
        </div>
      </div>
      <div class="cashier-pin-screen">
        <div class="cashier-pin-dots" id="pinSetupDots">
          ${'<span class="cashier-pin-dot"></span>'.repeat(6)}
        </div>
        <p class="cashier-pin-error hidden" id="pinSetupError">PINs don't match. Try again.</p>
        <div class="cashier-numpad">
          ${[
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].map((n)=>`<button class="cashier-numpad-btn" data-key="${n}">${n}</button>`).join('')}
          <button class="cashier-numpad-btn cashier-numpad-nav" data-key="back" aria-label="Back">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            Back
          </button>
          <button class="cashier-numpad-btn" data-key="0">0</button>
          <button class="cashier-numpad-btn cashier-numpad-nav" data-key="del" aria-label="Delete digit">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/><line x1="18" y1="9" x2="12" y2="15"/><line x1="12" y1="9" x2="18" y2="15"/></svg>
          </button>
        </div>
      </div>
    `;
        let entered = '';
        const updateDots = ()=>card.querySelectorAll('.cashier-pin-dot').forEach((d, i)=>d.classList.toggle('cashier-pin-dot--filled', i < entered.length));
        const shakeAndRetry = ()=>{
            const dotsEl = card.querySelector('#pinSetupDots');
            const errEl = card.querySelector('#pinSetupError');
            dotsEl?.classList.add('cashier-pin-shake');
            errEl?.classList.remove('hidden');
            setTimeout(()=>{
                dotsEl?.classList.remove('cashier-pin-shake');
                renderCreate();
            }, 800);
        };
        card.querySelector('.cashier-numpad')?.addEventListener('click', async (e)=>{
            const key = e.target.closest('.cashier-numpad-btn')?.dataset.key;
            if (!key) return;
            if (key === 'back') {
                renderCreate();
                return;
            }
            if (key === 'del') {
                entered = entered.slice(0, -1);
                updateDots();
                return;
            }
            if (entered.length >= 6) return;
            entered += key;
            updateDots();
            if (entered.length === 6) {
                if (entered === firstPin) try {
                    await $1e7ab04ca7920cff$export$feecad064ee6d298($1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff.id, entered);
                    $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff;
                    el.remove();
                    $1d9fcaa0a6035698$var$showToast('PIN set! You\'re all set.', 'success');
                } catch (err) {
                    $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not save PIN. Try again.');
                    el.remove();
                }
                else shakeAndRetry();
            }
        });
    };
    renderCreate();
};
const $1d9fcaa0a6035698$var$controlEditStaffRole = function(staffId) {
    const staff = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.find((s)=>s.id === staffId);
    if (!staff) return;
    const { onSave: onSave } = (0, $ad4542f6315399f1$export$2e2bcd8739ae039).showEditRoleModal(staff, $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles);
    onSave(async (roleId)=>{
        try {
            await $1e7ab04ca7920cff$export$c2e97a27e26e6474(staffId, roleId);
            (0, $ad4542f6315399f1$export$2e2bcd8739ae039).render($1e7ab04ca7920cff$export$ca000e230c0caa3e.staff, $1d9fcaa0a6035698$var$_staffCanManage(), $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles);
            $1d9fcaa0a6035698$var$showToast('Staff updated.', 'success');
        } catch (err) {
            $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not update staff.');
        }
    });
};
const $1d9fcaa0a6035698$var$controlSetStaffPin = async function(staffId, pin) {
    try {
        await $1e7ab04ca7920cff$export$feecad064ee6d298(staffId, pin);
        (0, $ad4542f6315399f1$export$2e2bcd8739ae039).render($1e7ab04ca7920cff$export$ca000e230c0caa3e.staff, $1d9fcaa0a6035698$var$_staffCanManage(), $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles);
        $1d9fcaa0a6035698$var$showToast('PIN updated.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not update PIN.');
    }
};
const $1d9fcaa0a6035698$var$controlShowInviteForm = function() {
    // Only the roles this user may hand out (owner: all; Admin only by an Admin).
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039).showInviteForm($1e7ab04ca7920cff$export$ca000e230c0caa3e.roles.filter((r)=>$1e7ab04ca7920cff$export$2b7797bcbce66bd0(r)));
};
const $1d9fcaa0a6035698$var$controlInviteStaff = async function(data) {
    const email = data.email.toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        $1d9fcaa0a6035698$var$showToast('Please enter a valid email address.', 'error');
        return;
    }
    if (email === $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.email?.toLowerCase()) {
        $1d9fcaa0a6035698$var$showToast("You can't invite yourself.", 'error');
        return;
    }
    const alreadyOnTeam = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.some((s)=>s.email.toLowerCase() === email);
    if (alreadyOnTeam) {
        $1d9fcaa0a6035698$var$showToast('This email is already on your staff list.', 'error');
        return;
    }
    try {
        const { reactivated: reactivated, existingAccount: existingAccount } = await $1e7ab04ca7920cff$export$f928650dee510357(data);
        (0, $ad4542f6315399f1$export$2e2bcd8739ae039).closeForm();
        (0, $ad4542f6315399f1$export$2e2bcd8739ae039).render($1e7ab04ca7920cff$export$ca000e230c0caa3e.staff, $1d9fcaa0a6035698$var$_staffCanManage(), $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles);
        $1d9fcaa0a6035698$var$showToast(reactivated ? 'Staff member reactivated. They can sign in with their existing account.' : existingAccount ? 'This email already has a Pointbunny account. They will be asked to join your team the next time they sign in.' : 'Invite sent!', 'success');
    } catch (err) {
        // Server-side guard (staff_pending_invite_unique): a duplicate pending invite
        // is rejected by the DB with Postgres code 23505 (unique_violation).
        if (err?.code === '23505' || /duplicate key|unique constraint/i.test(err?.message ?? '')) $1d9fcaa0a6035698$var$showToast('That person already has a pending invite.', 'error');
        else $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlRemoveStaff = async function(id) {
    if (!confirm('Remove this staff member? They will lose access to the system.')) return;
    try {
        await $1e7ab04ca7920cff$export$979c67ac13627319(id);
        (0, $ad4542f6315399f1$export$2e2bcd8739ae039).render($1e7ab04ca7920cff$export$ca000e230c0caa3e.staff, $1d9fcaa0a6035698$var$_staffCanManage(), $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles);
        $1d9fcaa0a6035698$var$showToast('Staff member removed.', 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
// Last resort for a staff member locked out of both their authenticator AND their
// recovery codes - reset_staff_mfa can strip the factor here instead of needing
// Supabase Dashboard access. The owner's own 2FA is out of scope (support-only).
const $1d9fcaa0a6035698$var$controlRemoveStaffMFA = async function(id) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('reset_staff_mfa')) {
        $1d9fcaa0a6035698$var$showToast("You don't have permission to remove staff 2FA.", 'error');
        return;
    }
    const member = $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff.find((s)=>s.id === id);
    const name = member ? `${member.firstName} ${member.lastName}`.trim() : 'this staff member';
    if (!confirm(`Remove two-factor authentication for ${name}? They'll be able to sign in with just their password until they set it up again.`)) return;
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039).setRemoveMFALoading(id, true);
    try {
        const { hadFactor: hadFactor } = await $1e7ab04ca7920cff$export$d33e2ce4efa57b9e(id);
        $1d9fcaa0a6035698$var$showToast(hadFactor ? `Two-factor authentication removed for ${name}.` : `${name} didn't have two-factor authentication enabled.`, 'success');
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    } finally{
        (0, $ad4542f6315399f1$export$2e2bcd8739ae039).setRemoveMFALoading(id, false);
    }
};
// ── Payroll / Timesheets ──────────────────────────────────────────────────────
let $1d9fcaa0a6035698$var$_tsType = 'week';
let $1d9fcaa0a6035698$var$_tsValue = null;
const $1d9fcaa0a6035698$var$controlFetchTimesheets = async function(type, value) {
    try {
        let startISO, endISO, label, resolvedValue;
        if (type === 'custom') {
            ({ startISO: startISO, endISO: endISO } = $1d9fcaa0a6035698$var$_bizDateRange(value.from, value.to));
            label = `${$1d9fcaa0a6035698$var$_dayStrLabel(value.from, {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            })} \u{2013} ${$1d9fcaa0a6035698$var$_dayStrLabel(value.to, {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            })}`;
            resolvedValue = value;
        } else {
            const range = $1d9fcaa0a6035698$var$_getRangeFromValue(type, value);
            ({ startISO: startISO, endISO: endISO, label: label } = range);
            if (type === 'week') resolvedValue = range.monday;
            else resolvedValue = value;
        }
        $1d9fcaa0a6035698$var$_tsType = type;
        $1d9fcaa0a6035698$var$_tsValue = resolvedValue;
        const canEdit = $1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay');
        // Reviewers also load the pending correction requests, the deleted-shifts log,
        // and the registered time-clock devices. The purge (hard-delete of soft-deleted
        // shifts past their 7-day restore window) runs lazily here, before the log is
        // fetched, so expired entries never appear; best-effort - a failure (e.g. the
        // RPC not migrated yet) must not break the view.
        const [, , deletedShifts, devices, leaveRequests, onShift] = await Promise.all([
            $1e7ab04ca7920cff$export$386807069bdcb35d(startISO, endISO),
            canEdit ? $1e7ab04ca7920cff$export$b910b0e182c20503() : Promise.resolve(),
            canEdit ? $1e7ab04ca7920cff$export$dc1ed30e5f5c4359().catch(()=>{}).then(()=>$1e7ab04ca7920cff$export$edd624e74df161b3()) : Promise.resolve([]),
            canEdit ? $1e7ab04ca7920cff$export$5df1640f4b5631ad().catch(()=>[]) : Promise.resolve([]),
            // .catch keeps the panel alive if the leave_requests migration hasn't run yet.
            $1e7ab04ca7920cff$export$dd48584891564f37().catch(()=>[]),
            // "Currently timed in" list in the Time Clock section; best-effort.
            $1e7ab04ca7920cff$export$da55ffa46e74c271().catch(()=>[])
        ]);
        // Tips section (manage_pay): the period's tips + roles for "Who shares
        // tips". Best-effort: before the tips migration, tip_amount doesn't exist.
        if (canEdit) {
            const [tips] = await Promise.all([
                $1e7ab04ca7920cff$export$3d90d87a5b17e4b8(startISO, endISO).catch(()=>[]),
                $1e7ab04ca7920cff$export$ca000e230c0caa3e.roles?.length ? Promise.resolve() : $1e7ab04ca7920cff$export$c0334f52bda8729d().catch(()=>{})
            ]);
            $1d9fcaa0a6035698$var$_setTimesheetTipsData(tips);
        }
        (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).renderTimesheets($1e7ab04ca7920cff$export$ca000e230c0caa3e.shifts, $1e7ab04ca7920cff$export$ca000e230c0caa3e.staff, canEdit, {
            type: type,
            value: resolvedValue,
            label: label
        }, canEdit ? $1e7ab04ca7920cff$export$ca000e230c0caa3e.shiftEditRequests : [], deletedShifts ?? [], devices ?? [], leaveRequests ?? [], onShift ?? []);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Failed to load timesheets');
    }
};
const $1d9fcaa0a6035698$var$_setTimesheetTipsData = function(tips) {
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039).setTipsData({
        ...tips ? {
            tips: tips
        } : {},
        roles: ($1e7ab04ca7920cff$export$ca000e230c0caa3e.roles ?? []).map((r)=>({
                id: r.id,
                name: r.name
            })),
        poolRoleIds: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipPoolRoleIds ?? null,
        tipsEnabled: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipsEnabled === true
    });
};
// Timesheets > Tips: which roles share the tip pool (manage_pay; the server
// enforces it too). Saves straight away - there's no draft on this panel.
const $1d9fcaa0a6035698$var$controlSetTipPoolRoles = function(roleIds) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to change who shares tips.", 'error');
        return;
    }
    $1e7ab04ca7920cff$export$680c723e3a62d1c3('tipPoolRoleIds', roleIds);
    $1d9fcaa0a6035698$var$_setTimesheetTipsData();
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039)._render();
};
// Soft-delete shifts (a single day entry or a staff member's whole visible week).
// Week view only - month/year are too coarse for bulk deletion by design.
const $1d9fcaa0a6035698$var$controlDeleteShifts = async function(ids, describe) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to delete shifts.", 'error');
        return;
    }
    if (!ids?.length) return;
    if (!window.confirm(`Delete ${describe}? It will move to the Deleted shifts list below, where you can restore it.`)) return;
    try {
        await $1e7ab04ca7920cff$export$14aa8954e02d8449(ids, true);
        $1d9fcaa0a6035698$var$showToast(ids.length === 1 ? 'Shift deleted.' : `${ids.length} shifts deleted.`, 'success');
        await $1d9fcaa0a6035698$var$controlFetchTimesheets($1d9fcaa0a6035698$var$_tsType, $1d9fcaa0a6035698$var$_tsValue ?? null);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not delete the shift.', 'error');
    }
};
const $1d9fcaa0a6035698$var$controlRestoreShift = async function(id) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay')) return;
    try {
        await $1e7ab04ca7920cff$export$14aa8954e02d8449([
            id
        ], false);
        $1d9fcaa0a6035698$var$showToast('Shift restored.', 'success');
        await $1d9fcaa0a6035698$var$controlFetchTimesheets($1d9fcaa0a6035698$var$_tsType, $1d9fcaa0a6035698$var$_tsValue ?? null);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not restore the shift.', 'error');
    }
};
// ── On-shift indicator (home page floating circle) ────────────────────────────
// Polls who's currently clocked in (60s - shift state changes slowly) and renders
// the lower-right bubble. Errors are swallowed: the indicator is best-effort and
// must never break the app (e.g. before the get_on_shift_staff migration runs).
let $1d9fcaa0a6035698$var$_onShiftTimer = null;
// Cashier card status line ("On shift since X" / "On break" / "Not clocked in").
// Fed by the same on-shift list as the bubble; cached so a cashier switch can
// restamp the line without refetching.
let $1d9fcaa0a6035698$var$_lastOnShiftList = null;
const $1d9fcaa0a6035698$var$_updateCashierShiftStatus = function(list = $1d9fcaa0a6035698$var$_lastOnShiftList) {
    const el = document.getElementById('cashierShiftStatus');
    if (!el) return;
    const cashier = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentCashier;
    if (!cashier || list === null) {
        el.innerHTML = '';
        return;
    }
    if (cashier.isOwner) {
        el.innerHTML = '<span class="home-action-dot home-action-dot--on"></span>Owner';
        return;
    }
    const entry = list.find((s)=>s.staffId === cashier.id);
    if (!entry) el.innerHTML = '<span class="home-action-dot"></span>Not clocked in';
    else if (entry.onBreak) el.innerHTML = '<span class="home-action-dot home-action-dot--break"></span>On break';
    else {
        const since = new Date(entry.clockedInAt).toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit'
        });
        el.innerHTML = `On shift since ${since}`;
    }
};
// Today's expenses total on the Sales & Expenses card - the one money number
// the dash cards don't already show. Best-effort; refreshed after add/delete.
const $1d9fcaa0a6035698$var$_refreshHomeExpensesToday = async function() {
    // The Expenses today tile reads its own copy: an expense was just added or
    // deleted, so refetch it too (it showed $0.00 until a reload).
    $1d9fcaa0a6035698$var$_homeExpensesAt = 0;
    $1d9fcaa0a6035698$var$_refreshHomeCards();
    const el = document.getElementById('homeExpensesToday');
    if (!el) return;
    // Don't bother fetching when the figures are hidden from this user anyway
    if (document.body.classList.contains('hide-home-stats')) return;
    try {
        const total = await $1e7ab04ca7920cff$export$d26986fd4f5259c1();
        el.textContent = total > 0 ? `${(0, $coRoT.formatMoney)(total)} in expenses today` : 'No expenses today';
    } catch (_) {}
};
// Home "My shift" card (staff without the Getting Started / Activity card).
// _updateGettingStarted runs often, so shifts are fetched once and then only
// refetched when this person's on-shift state changes (clock in/out, break)
// or on the 5-minute catch-up; the card ticks worked time locally in between.
let $1d9fcaa0a6035698$var$_myShiftActive = false;
let $1d9fcaa0a6035698$var$_myShiftLoadedAt = 0;
let $1d9fcaa0a6035698$var$_myShiftSig = null;
let $1d9fcaa0a6035698$var$_myShiftStaffId = null; // cache is per person: a different sign-in always refetches
const $1d9fcaa0a6035698$var$_myShiftSignature = (list)=>{
    const me = (list ?? []).find((s)=>s.staffId === $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff?.id);
    return me ? `${me.clockedInAt}|${me.onBreak}` : 'off';
};
const $1d9fcaa0a6035698$var$_showMyShift = async function({ force: force = false } = {}) {
    $1d9fcaa0a6035698$var$_myShiftActive = true;
    const staff = $1e7ab04ca7920cff$export$ca000e230c0caa3e.currentStaff;
    const base = {
        name: staff ? `${staff.firstName ?? ''} ${staff.lastName ?? ''}`.trim() : '',
        roleName: $1e7ab04ca7920cff$export$ca000e230c0caa3e.role ?? '',
        timeTracking: $1e7ab04ca7920cff$export$b325ec6732b039cf('use_timeclock')
    };
    if (!base.timeTracking) {
        (0, $e33f5b9e7cf6b9c8$export$2e2bcd8739ae039).render({
            ...base,
            shifts: []
        });
        return;
    }
    if (staff?.id !== $1d9fcaa0a6035698$var$_myShiftStaffId) {
        force = true;
        $1d9fcaa0a6035698$var$_myShiftStaffId = staff?.id ?? null;
    }
    if (!force && $1d9fcaa0a6035698$var$_myShiftLoadedAt && Date.now() - $1d9fcaa0a6035698$var$_myShiftLoadedAt < 300000) return;
    $1d9fcaa0a6035698$var$_myShiftLoadedAt = Date.now();
    if ($1d9fcaa0a6035698$var$_lastOnShiftList) $1d9fcaa0a6035698$var$_myShiftSig = $1d9fcaa0a6035698$var$_myShiftSignature($1d9fcaa0a6035698$var$_lastOnShiftList);
    try {
        const [shifts, upcoming, swapAsks] = await Promise.all([
            $1e7ab04ca7920cff$export$b7cc9474dd2513e9((0, $e33f5b9e7cf6b9c8$export$a82ba44f2bc80e0d)().toISOString()),
            $1e7ab04ca7920cff$export$4d7a10e100aecbb4(14).catch(()=>[]),
            $1e7ab04ca7920cff$export$87044e927d8b1c21().catch(()=>0)
        ]);
        if ($1d9fcaa0a6035698$var$_myShiftActive) (0, $e33f5b9e7cf6b9c8$export$2e2bcd8739ae039).render({
            ...base,
            shifts: shifts,
            nextShift: upcoming[0] ?? null,
            tz: $1d9fcaa0a6035698$var$_bizTz(),
            swapAsks: swapAsks
        });
    } catch (_) {
        $1d9fcaa0a6035698$var$_myShiftLoadedAt = 0; // best-effort: retry on the next trigger
    }
};
const $1d9fcaa0a6035698$var$_hideMyShift = function() {
    $1d9fcaa0a6035698$var$_myShiftActive = false;
    (0, $e33f5b9e7cf6b9c8$export$2e2bcd8739ae039).hide();
};
const $1d9fcaa0a6035698$var$_refreshOnShift = async function() {
    try {
        const list = await $1e7ab04ca7920cff$export$da55ffa46e74c271();
        $1d9fcaa0a6035698$var$_lastOnShiftList = list;
        (0, $c5fa03bf5fec6559$export$2e2bcd8739ae039).render(list);
        $1d9fcaa0a6035698$var$_updateCashierShiftStatus(list);
        $1d9fcaa0a6035698$var$_renderHomeCards(); // Who's working card / On shift tile
        if ($1d9fcaa0a6035698$var$_myShiftActive) {
            const sig = $1d9fcaa0a6035698$var$_myShiftSignature(list);
            const changed = sig !== $1d9fcaa0a6035698$var$_myShiftSig;
            $1d9fcaa0a6035698$var$_myShiftSig = sig;
            $1d9fcaa0a6035698$var$_showMyShift({
                force: changed
            });
        }
    } catch (_) {}
};
const $1d9fcaa0a6035698$var$_startOnShiftIndicator = function() {
    clearInterval($1d9fcaa0a6035698$var$_onShiftTimer);
    $1d9fcaa0a6035698$var$_refreshOnShift();
    // Fallback poll behind the SHIFT_SYNC live broadcasts. Skipped while the tab
    // is hidden (a background POS tab doesn't need fresh on-shift data); one
    // catch-up refresh fires when the tab becomes visible again.
    $1d9fcaa0a6035698$var$_onShiftTimer = setInterval(()=>{
        if (!document.hidden) $1d9fcaa0a6035698$var$_refreshOnShift();
    }, 60000);
    if (!$1d9fcaa0a6035698$var$_onShiftVisibilityHooked) {
        $1d9fcaa0a6035698$var$_onShiftVisibilityHooked = true;
        document.addEventListener('visibilitychange', ()=>{
            if (!document.hidden && $1d9fcaa0a6035698$var$_onShiftTimer) $1d9fcaa0a6035698$var$_refreshOnShift();
        });
    }
};
let $1d9fcaa0a6035698$var$_onShiftVisibilityHooked = false;
// Revoke a registered time-clock device. The device shows the activation screen
// again on its next load.
const $1d9fcaa0a6035698$var$controlRevokeDevice = async function(id, label) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay')) return;
    if (!window.confirm(`Remove "${label}"? That device will need a new activation code to be used again.`)) return;
    try {
        await $1e7ab04ca7920cff$export$f5a99e271127a154(id);
        $1d9fcaa0a6035698$var$showToast('Device removed.', 'success');
        await $1d9fcaa0a6035698$var$controlFetchTimesheets($1d9fcaa0a6035698$var$_tsType, $1d9fcaa0a6035698$var$_tsValue ?? null);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not remove the device.', 'error');
    }
};
// Approve/reject a shift-correction request from the Payroll inbox (manage_pay only).
const $1d9fcaa0a6035698$var$controlReviewRequest = async function(id, decision) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to review time corrections.", 'error');
        return;
    }
    const req = $1e7ab04ca7920cff$export$ca000e230c0caa3e.shiftEditRequests.find((r)=>r.id === id);
    if (!req) return;
    try {
        if (decision === 'approved') {
            await $1e7ab04ca7920cff$export$aa47a779ea9a774(id, 'approved', {
                clockIn: req.proposedIn,
                clockOut: req.proposedOut,
                breaks: req.proposedBreaks
            });
            $1d9fcaa0a6035698$var$showToast('Correction applied.', 'success');
        } else {
            const note = window.prompt('Reason for rejecting this correction? (optional)') ?? '';
            await $1e7ab04ca7920cff$export$aa47a779ea9a774(id, 'rejected', {
                note: note.trim() || null
            });
            $1d9fcaa0a6035698$var$showToast('Correction rejected.');
        }
        // Refresh the current timesheet view (shows the applied change + drops the request).
        await $1d9fcaa0a6035698$var$controlFetchTimesheets($1d9fcaa0a6035698$var$_tsType, $1d9fcaa0a6035698$var$_tsValue ?? null);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not update the request.', 'error');
    }
};
// Approve/reject a leave request from the Timesheets Leave section (manage_pay only).
const $1d9fcaa0a6035698$var$controlReviewLeave = async function(id, decision) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to review leave requests.", 'error');
        return;
    }
    try {
        if (decision === 'approved') {
            await $1e7ab04ca7920cff$export$caf3bff4c0484df1(id, 'approved');
            $1d9fcaa0a6035698$var$showToast('Leave approved.', 'success');
        } else {
            const note = window.prompt('Reason for rejecting this leave request? (optional)') ?? '';
            await $1e7ab04ca7920cff$export$caf3bff4c0484df1(id, 'rejected', note.trim() || null);
            $1d9fcaa0a6035698$var$showToast('Leave request rejected.');
        }
        await $1d9fcaa0a6035698$var$controlFetchTimesheets($1d9fcaa0a6035698$var$_tsType, $1d9fcaa0a6035698$var$_tsValue ?? null);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Could not update the leave request.', 'error');
    }
};
const $1d9fcaa0a6035698$var$controlSaveShift = async function(data) {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('manage_pay')) {
        $1d9fcaa0a6035698$var$showToast('Only admins can edit shifts.', 'error');
        return;
    }
    try {
        if (data.id) await $1e7ab04ca7920cff$export$b9feece4954201d8(data);
        else await $1e7ab04ca7920cff$export$5dd0c4b97398fddb(data);
        $1d9fcaa0a6035698$var$showToast('Shift saved.', 'success');
        await $1d9fcaa0a6035698$var$controlFetchTimesheets($1d9fcaa0a6035698$var$_tsType, $1d9fcaa0a6035698$var$_tsValue);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? 'Failed to save shift');
    }
};
// ── Reports ───────────────────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$_computeReportsSummary = function() {
    const sales = $1d9fcaa0a6035698$var$modelState.reportsSales;
    const revenue = sales.reduce((s, r)=>s + Number(r.total_price), 0);
    const transactions = sales.length;
    const avgOrder = transactions > 0 ? revenue / transactions : 0;
    const avgServingMinutes = $1d9fcaa0a6035698$var$_computeServingTimeStats()?.avgMinutes ?? null;
    return {
        revenue: revenue,
        transactions: transactions,
        avgOrder: avgOrder,
        avgServingMinutes: avgServingMinutes
    };
};
let $1d9fcaa0a6035698$var$_topItemsSortKey = "quantity";
// A soft-deleted item still appears in historical sales; tag it "(deleted)" so
// it's clear in Reports it's no longer in the live catalogue. Only flag names
// that belong to a deleted item AND aren't a current live item (so a rename
// doesn't get mislabeled).
const $1d9fcaa0a6035698$var$_markDeletedName = function(name) {
    const deleted = new Set(($1e7ab04ca7920cff$export$ca000e230c0caa3e.deletedItems ?? []).map((d)=>d.name));
    const live = new Set($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.map((i)=>i.itemName));
    return deleted.has(name) && !live.has(name) ? `${name} (deleted)` : name;
};
const $1d9fcaa0a6035698$var$_computeTopItems = function(limit = 10, sortKey = $1d9fcaa0a6035698$var$_topItemsSortKey) {
    const map = new Map();
    for (const sale of $1d9fcaa0a6035698$var$modelState.reportsSales)for (const item of sale.items ?? []){
        const key = item.itemName;
        const existing = map.get(key) ?? {
            name: key,
            quantity: 0,
            revenue: 0
        };
        existing.quantity += Number(item.quantity ?? 1);
        existing.revenue += Number(item.totalPrice ?? 0);
        map.set(key, existing);
    }
    return [
        ...map.values()
    ].sort((a, b)=>b[sortKey] - a[sortKey]).slice(0, limit).map((it)=>({
            ...it,
            name: $1d9fcaa0a6035698$var$_markDeletedName(it.name)
        }));
};
const $1d9fcaa0a6035698$var$controlSortTopItems = function(key) {
    $1d9fcaa0a6035698$var$_topItemsSortKey = key;
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).setTopItemsSort(key);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderTopItems($1d9fcaa0a6035698$var$_computeTopItems(), key);
};
const $1d9fcaa0a6035698$var$_computeCategoryMix = function() {
    const itemCatMap = new Map($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.map((i)=>[
            i.itemName,
            i.category
        ]));
    const map = new Map();
    for (const sale of $1d9fcaa0a6035698$var$modelState.reportsSales)for (const item of sale.items ?? []){
        const cat = itemCatMap.get(item.itemName) ?? "Other";
        map.set(cat, (map.get(cat) ?? 0) + Number(item.totalPrice ?? 0));
    }
    return [
        ...map.entries()
    ].sort((a, b)=>b[1] - a[1]).map(([label, value])=>({
            label: label,
            value: value
        }));
};
// Chart buckets in the business timezone (2026-10-25): a sale counts toward the cafe's hour and
// calendar day, whatever zone the viewing device is set to.
const $1d9fcaa0a6035698$var$_bizDayKey = (iso)=>(0, $lDSCx.zonedParts)(new Date(iso), $1d9fcaa0a6035698$var$_bizTz()).dateStr;
const $1d9fcaa0a6035698$var$_bizHourOf = (iso)=>(0, $lDSCx.zonedParts)(new Date(iso), $1d9fcaa0a6035698$var$_bizTz()).h;
const $1d9fcaa0a6035698$var$_bizDayList = function(startISO, endISO) {
    const days = [];
    const last = $1d9fcaa0a6035698$var$_bizDayKey(endISO);
    for(let d = $1d9fcaa0a6035698$var$_bizDayKey(startISO); d <= last && days.length < 400; d = (0, $lDSCx.addDays)(d, 1))days.push(d);
    return days;
};
const $1d9fcaa0a6035698$var$_dayOfWeek = (ds)=>new Date(ds + 'T12:00:00Z').getUTCDay(); // 0 = Sunday
const $1d9fcaa0a6035698$var$_md = (ds)=>`${+ds.slice(5, 7)}/${+ds.slice(8, 10)}`;
const $1d9fcaa0a6035698$var$_computeRevenueOverTime = function(period, startISO, endISO) {
    const sales = $1d9fcaa0a6035698$var$modelState.reportsSales;
    const MONTHS = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    const DAYS = [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ];
    const fmtHour = (i)=>i === 0 ? "12am" : i < 12 ? `${i}am` : i === 12 ? "12pm" : `${i - 12}pm`;
    if (period === "today") {
        const hours = Array(24).fill(0);
        for (const s of sales)hours[$1d9fcaa0a6035698$var$_bizHourOf(s.sale_date)] += Number(s.total_price);
        return {
            labels: Array.from({
                length: 24
            }, (_, i)=>fmtHour(i)),
            data: hours
        };
    }
    if (period === "year") {
        const year = +$1d9fcaa0a6035698$var$_bizDayKey(startISO).slice(0, 4);
        const mmap = new Map();
        for (const s of sales){
            const m = $1d9fcaa0a6035698$var$_bizDayKey(s.sale_date).slice(0, 7);
            mmap.set(m, (mmap.get(m) ?? 0) + Number(s.total_price));
        }
        return {
            labels: MONTHS,
            data: MONTHS.map((_, i)=>mmap.get(`${year}-${String(i + 1).padStart(2, "0")}`) ?? 0)
        };
    }
    // week / month / custom → daily, by the cafe's calendar day
    const dmap = new Map();
    for (const s of sales){
        const d = $1d9fcaa0a6035698$var$_bizDayKey(s.sale_date);
        dmap.set(d, (dmap.get(d) ?? 0) + Number(s.total_price));
    }
    const days = $1d9fcaa0a6035698$var$_bizDayList(startISO, endISO);
    return {
        labels: days.map((d)=>period === "week" ? DAYS[$1d9fcaa0a6035698$var$_dayOfWeek(d)] : $1d9fcaa0a6035698$var$_md(d)),
        data: days.map((d)=>dmap.get(d) ?? 0)
    };
};
const $1d9fcaa0a6035698$var$_computeAllTimeSeries = function(period, startISO, endISO) {
    const sales = $1d9fcaa0a6035698$var$modelState.reportsSales;
    const expenses = $1d9fcaa0a6035698$var$modelState.expenses ?? [];
    const MONTHS = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    const DAYS = [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ];
    const fmtHour = (i)=>i === 0 ? "12am" : i < 12 ? `${i}am` : i === 12 ? "12pm" : `${i - 12}pm`;
    let labels, n, saleKeyFn, expKeyFn;
    if (period === "today") {
        labels = Array.from({
            length: 24
        }, (_, i)=>fmtHour(i));
        n = 24;
        saleKeyFn = (s)=>$1d9fcaa0a6035698$var$_bizHourOf(s.sale_date);
        expKeyFn = (e)=>e.expenseDate ? $1d9fcaa0a6035698$var$_bizHourOf(e.expenseDate) : -1;
    } else if (period === "year") {
        const year = +$1d9fcaa0a6035698$var$_bizDayKey(startISO).slice(0, 4);
        labels = MONTHS;
        n = 12;
        const mKey = (str)=>{
            const yr = parseInt(str.slice(0, 4));
            const mo = parseInt(str.slice(5, 7)) - 1;
            return yr === year ? mo : -1;
        };
        saleKeyFn = (s)=>mKey($1d9fcaa0a6035698$var$_bizDayKey(s.sale_date));
        expKeyFn = (e)=>e.expenseDate ? mKey($1d9fcaa0a6035698$var$_bizDayKey(e.expenseDate)) : -1;
    } else {
        // The cafe's calendar days in the range (business timezone).
        const dateStrs = $1d9fcaa0a6035698$var$_bizDayList(startISO, endISO);
        labels = dateStrs.map((d)=>period === "week" ? [
                DAYS[$1d9fcaa0a6035698$var$_dayOfWeek(d)],
                `${d.slice(5, 7)}/${d.slice(8, 10)}`
            ] // two-line: "Mon" + "05/12"
             : $1d9fcaa0a6035698$var$_md(d));
        n = labels.length;
        const dmap = new Map(dateStrs.map((d, i)=>[
                d,
                i
            ]));
        saleKeyFn = (s)=>dmap.get($1d9fcaa0a6035698$var$_bizDayKey(s.sale_date)) ?? -1;
        expKeyFn = (e)=>e.expenseDate ? dmap.get($1d9fcaa0a6035698$var$_bizDayKey(e.expenseDate)) ?? -1 : -1;
    }
    const revArr = Array(n).fill(0);
    const tipArr = Array(n).fill(0);
    const expArr = Array(n).fill(0);
    const txArr = Array(n).fill(0);
    const svcSum = Array(n).fill(0);
    const svcCnt = Array(n).fill(0);
    for (const s of sales){
        const i = saleKeyFn(s);
        if (i < 0 || i >= n) continue;
        revArr[i] += Number(s.total_price);
        tipArr[i] += Number(s.tip_amount ?? 0);
        txArr[i]++;
        if (s.prepared_at) {
            const mins = (new Date(s.prepared_at) - new Date(s.sale_date)) / 60000;
            if (mins >= 0 && mins <= 120) {
                svcSum[i] += mins;
                svcCnt[i]++;
            }
        }
    }
    for (const e of expenses){
        const i = expKeyFn(e);
        if (i < 0 || i >= n) continue;
        expArr[i] += e.amount;
    }
    return {
        labels: labels,
        series: {
            revenue: revArr,
            expenses: expArr,
            net: revArr.map((r, i)=>r - expArr[i]),
            transactions: txArr,
            avgOrder: revArr.map((r, i)=>txArr[i] > 0 ? r / txArr[i] : 0),
            avgServing: svcSum.map((s, i)=>svcCnt[i] > 0 ? +(s / svcCnt[i]).toFixed(1) : 0),
            tips: tipArr.map((t)=>Math.round(t * 100) / 100)
        }
    };
};
// Sales section "Tips Over Time" card, on the same time buckets as the
// Overview chart. Tips are never part of Gross Income.
const $1d9fcaa0a6035698$var$_renderReportsTips = function() {
    const sales = $1d9fcaa0a6035698$var$modelState.reportsSales ?? [];
    const total = sales.reduce((s, r)=>s + Number(r.tip_amount ?? 0), 0);
    // Week labels are two-line arrays ("Mon", "10/12"); the tips chart is
    // shorter, so flatten them to one line.
    const labels = ($1d9fcaa0a6035698$var$_overviewTimeSeries?.labels ?? []).map((l)=>Array.isArray(l) ? l.join(' ') : l);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderTips({
        show: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.tipsEnabled === true || total > 0,
        labels: labels,
        data: $1d9fcaa0a6035698$var$_overviewTimeSeries?.series.tips ?? [],
        total: total,
        gross: sales.reduce((s, r)=>s + Number(r.total_price), 0),
        tippedCount: sales.filter((r)=>Number(r.tip_amount ?? 0) > 0).length,
        txCount: sales.length
    });
};
const $1d9fcaa0a6035698$var$_buildOverviewDatasets = function() {
    if (!$1d9fcaa0a6035698$var$_overviewTimeSeries) return {
        labels: [],
        datasets: []
    };
    const { labels: labels, series: series } = $1d9fcaa0a6035698$var$_overviewTimeSeries;
    const datasets = [
        ...$1d9fcaa0a6035698$var$_selectedOverviewMetrics
    ].map((metric)=>{
        const color = $1d9fcaa0a6035698$var$METRIC_COLORS[metric];
        return {
            label: $1d9fcaa0a6035698$var$METRIC_LABELS[metric],
            data: series[metric] ?? [],
            borderColor: color,
            backgroundColor: color + '22',
            fill: 'origin',
            tension: 0.4,
            pointRadius: 3,
            pointHoverRadius: 7,
            borderWidth: 2.5,
            _metric: metric
        };
    });
    return {
        labels: labels,
        datasets: datasets
    };
};
const $1d9fcaa0a6035698$var$_renderOverviewChart = async function() {
    const { labels: labels, datasets: datasets } = $1d9fcaa0a6035698$var$_buildOverviewDatasets();
    await (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderOverviewChart({
        labels: labels,
        datasets: datasets
    });
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).setSelectedMetrics($1d9fcaa0a6035698$var$_selectedOverviewMetrics);
};
const $1d9fcaa0a6035698$var$controlToggleMetric = function(metric) {
    if (!$1d9fcaa0a6035698$var$METRIC_COLORS[metric]) return;
    if ($1d9fcaa0a6035698$var$_selectedOverviewMetrics.has(metric)) $1d9fcaa0a6035698$var$_selectedOverviewMetrics.delete(metric);
    else $1d9fcaa0a6035698$var$_selectedOverviewMetrics.add(metric);
    $1d9fcaa0a6035698$var$_renderOverviewChart();
};
const $1d9fcaa0a6035698$var$_computeTrafficPeaks = function(period, startISO, endISO) {
    const sales = $1d9fcaa0a6035698$var$modelState.reportsSales;
    const fmtHour = (i)=>i === 0 ? '12am' : i < 12 ? `${i}am` : i === 12 ? '12pm' : `${i - 12}pm`;
    const FULLDAY = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
    ];
    const hourCounts = Array(24).fill(0);
    for (const s of sales)hourCounts[$1d9fcaa0a6035698$var$_bizHourOf(s.sale_date)]++;
    const maxHour = Math.max(...hourCounts);
    const peakHourIdx = maxHour > 0 ? hourCounts.indexOf(maxHour) : -1;
    const dayCounts = Array(7).fill(0);
    for (const s of sales){
        const d = $1d9fcaa0a6035698$var$_dayOfWeek($1d9fcaa0a6035698$var$_bizDayKey(s.sale_date));
        dayCounts[d === 0 ? 6 : d - 1]++;
    }
    const maxDay = Math.max(...dayCounts);
    const peakDayIdx = maxDay > 0 ? dayCounts.indexOf(maxDay) : -1;
    const days = Math.max(1, Math.round((new Date(endISO) - new Date(startISO)) / 86400000));
    const avgDaily = sales.length > 0 ? sales.length / days : 0;
    return {
        peakHour: peakHourIdx >= 0 ? {
            label: fmtHour(peakHourIdx),
            count: maxHour
        } : null,
        peakDay: period !== 'today' && peakDayIdx >= 0 ? {
            label: FULLDAY[peakDayIdx],
            count: maxDay
        } : null,
        total: sales.length,
        avgDaily: avgDaily
    };
};
const $1d9fcaa0a6035698$var$_computeHourlyBreakdown = function() {
    const hours = Array(24).fill(0);
    for (const s of $1d9fcaa0a6035698$var$modelState.reportsSales)hours[$1d9fcaa0a6035698$var$_bizHourOf(s.sale_date)]++;
    const fmtHour = (i)=>i === 0 ? "12am" : i < 12 ? `${i}am` : i === 12 ? "12pm" : `${i - 12}pm`;
    return {
        labels: Array.from({
            length: 24
        }, (_, i)=>fmtHour(i)),
        data: hours
    };
};
const $1d9fcaa0a6035698$var$_computeDayOfWeek = function(period) {
    if (period === "today") return {
        labels: [],
        data: [],
        isEmpty: true
    };
    const MON = [
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
        "Sun"
    ];
    const totals = Array(7).fill(0);
    for (const s of $1d9fcaa0a6035698$var$modelState.reportsSales){
        const d = $1d9fcaa0a6035698$var$_dayOfWeek($1d9fcaa0a6035698$var$_bizDayKey(s.sale_date)); // 0=Sun
        const idx = d === 0 ? 6 : d - 1; // shift to Mon=0
        totals[idx]++;
    }
    return {
        labels: MON,
        data: totals,
        isEmpty: false
    };
};
// Shared binning logic for any "minutes between two timestamps on a sale" metric -
// overall serving time, kitchen-only, and pickup-wait all bucket the same way, just
// with a different pair of timestamps (see _computeServingTimeStats below).
const $1d9fcaa0a6035698$var$_bucketizeServingTimes = function(sales, minsFn) {
    const fmtHour = (i)=>i === 0 ? "12am" : i < 12 ? `${i}am` : i === 12 ? "12pm" : `${i - 12}pm`;
    const MON = [
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
        "Sun"
    ];
    const hourCounts = Array(24).fill(0), hourTotals = Array(24).fill(0);
    const dayCounts = Array(7).fill(0), dayTotals = Array(7).fill(0);
    let totalMins = 0, totalCount = 0;
    for (const s of sales){
        const mins = minsFn(s);
        if (mins == null || mins < 0 || mins > 120) continue;
        const h = $1d9fcaa0a6035698$var$_bizHourOf(s.sale_date);
        hourCounts[h]++;
        hourTotals[h] += mins;
        const d = $1d9fcaa0a6035698$var$_dayOfWeek($1d9fcaa0a6035698$var$_bizDayKey(s.sale_date));
        const idx = d === 0 ? 6 : d - 1;
        dayCounts[idx]++;
        dayTotals[idx] += mins;
        totalMins += mins;
        totalCount++;
    }
    if (!totalCount) return null;
    return {
        avgMinutes: totalMins / totalCount,
        byHour: {
            labels: Array.from({
                length: 24
            }, (_, i)=>fmtHour(i)),
            data: hourCounts.map((c, i)=>c > 0 ? hourTotals[i] / c : 0)
        },
        byDay: {
            labels: MON,
            data: dayCounts.map((c, i)=>c > 0 ? dayTotals[i] / c : 0)
        }
    };
};
// Three cohorts, all derived from the same sales rows (2026-08-27):
//   overall (unchanged) - order placed -> Done, every completed order
//   kitchen  - order placed -> Ready for Pickup
//   pickup   - Ready for Pickup -> Done
// kitchen/pickup only cover orders that were actually marked Ready (that step is
// optional - see CLAUDE.md "Active Queue Section"), so they're computed over a
// narrower subset than the overall figure; readyShare tells the view what fraction
// of orders that subset represents.
const $1d9fcaa0a6035698$var$_computeServingTimeStats = function() {
    const sales = $1d9fcaa0a6035698$var$modelState.reportsSales.filter((s)=>s.prepared_at);
    if (!sales.length) return null;
    const overall = $1d9fcaa0a6035698$var$_bucketizeServingTimes(sales, (s)=>(new Date(s.prepared_at) - new Date(s.sale_date)) / 60000);
    if (!overall) return null;
    const readySales = sales.filter((s)=>s.ready_at);
    const kitchen = readySales.length ? $1d9fcaa0a6035698$var$_bucketizeServingTimes(readySales, (s)=>(new Date(s.ready_at) - new Date(s.sale_date)) / 60000) : null;
    const pickup = readySales.length ? $1d9fcaa0a6035698$var$_bucketizeServingTimes(readySales, (s)=>(new Date(s.prepared_at) - new Date(s.ready_at)) / 60000) : null;
    return {
        ...overall,
        preparedCount: sales.length,
        readyCount: readySales.length,
        readyShare: sales.length ? readySales.length / sales.length : 0,
        kitchen: kitchen,
        pickup: pickup
    };
};
// Speed of Service (Reports Kitchen): done-order serving minutes (Placed ->
// Done) bucketed by the queue timer settings, the same split as the Active
// Queue empty state's tiles. No 2h outlier cap here - a 3h order is Delayed.
const $1d9fcaa0a6035698$var$_computeSpeedOfService = function(minutesList) {
    const yellow = $1d9fcaa0a6035698$var$modelState.settings?.kdsYellowThreshold ?? 600;
    const red = $1d9fcaa0a6035698$var$modelState.settings?.kdsRedThreshold ?? 900;
    let onTime = 0, slow = 0, delayed = 0;
    for (const m of minutesList ?? []){
        const secs = m * 60;
        if (secs < yellow) onTime++;
        else if (secs < red) slow++;
        else delayed++;
    }
    const total = onTime + slow + delayed;
    return total ? {
        onTime: onTime,
        slow: slow,
        delayed: delayed,
        total: total,
        yellow: yellow,
        red: red
    } : null;
};
// Order Type (Dine In / Takeout) revenue + count + avg order + avg serving time
// (Placed -> Done), for the Reports "Channels" tab. Orders recorded while
// orderTypeEnabled was off carry order_type = null and are grouped as
// 'unspecified' - the view filters those out when the setting is off.
const $1d9fcaa0a6035698$var$_computeChannelMix = function() {
    const sales = $1d9fcaa0a6035698$var$modelState.reportsSales;
    if (!sales.length) return [];
    const map = new Map();
    for (const s of sales){
        const key = s.order_type ?? 'unspecified';
        const e = map.get(key) ?? {
            type: key,
            revenue: 0,
            count: 0,
            servTotal: 0,
            servCount: 0
        };
        e.revenue += Number(s.total_price);
        e.count++;
        if (s.prepared_at) {
            const mins = (new Date(s.prepared_at) - new Date(s.sale_date)) / 60000;
            if (mins >= 0 && mins <= 120) {
                e.servTotal += mins;
                e.servCount++;
            }
        }
        map.set(key, e);
    }
    const totalRevenue = sales.reduce((sum, s)=>sum + Number(s.total_price), 0);
    return [
        ...map.values()
    ].map((e)=>({
            type: e.type,
            label: e.type === 'unspecified' ? 'Unspecified' : (0, $cggJi.orderTypeLabel)(e.type),
            revenue: e.revenue,
            count: e.count,
            avgOrder: e.count ? e.revenue / e.count : 0,
            share: totalRevenue > 0 ? e.revenue / totalRevenue : 0,
            countShare: sales.length > 0 ? e.count / sales.length : 0,
            avgServingMinutes: e.servCount ? e.servTotal / e.servCount : null
        })).sort((a, b)=>b.revenue - a.revenue);
};
// Payment method (Cash / Card / QR) revenue + count, for the Reports "Channels" tab.
const $1d9fcaa0a6035698$var$_computePaymentMethodMix = function() {
    const sales = $1d9fcaa0a6035698$var$modelState.reportsSales;
    if (!sales.length) return [];
    const LABELS = {
        cash: 'Cash',
        card: 'Card',
        qr: 'QR'
    };
    const map = new Map();
    for (const s of sales){
        const key = s.payment_method ?? 'cash';
        const e = map.get(key) ?? {
            method: key,
            revenue: 0,
            count: 0
        };
        e.revenue += Number(s.total_price);
        e.count++;
        map.set(key, e);
    }
    const totalRevenue = sales.reduce((sum, s)=>sum + Number(s.total_price), 0);
    return [
        ...map.values()
    ].map((e)=>({
            method: e.method,
            label: LABELS[e.method] ?? e.method,
            revenue: e.revenue,
            count: e.count,
            share: totalRevenue > 0 ? e.revenue / totalRevenue : 0,
            countShare: sales.length > 0 ? e.count / sales.length : 0
        })).sort((a, b)=>b.revenue - a.revenue);
};
const $1d9fcaa0a6035698$var$_getPreviousPeriodRange = function(period, startISO, endISO, from, to, offset = 0) {
    const start = new Date(startISO);
    const end = new Date(endISO);
    // Stepped back with the arrows: "yesterday" / "last week" would be wrong.
    if (offset !== 0 && period !== 'custom') {
        const r = $1d9fcaa0a6035698$var$_getCashflowRange(period, from, to, offset - 1);
        const unit = {
            today: 'day',
            week: 'week',
            month: 'month',
            year: 'year'
        }[period] ?? 'period';
        return {
            prevStart: r.startISO,
            prevEnd: r.endISO,
            vsLabel: `previous ${unit}`
        };
    }
    if (period === "today" || period === "week" || period === "month" || period === "year") {
        const r = $1d9fcaa0a6035698$var$_getCashflowRange(period, from, to, -1);
        const vsLabel = {
            today: "yesterday",
            week: "last week",
            month: "last month",
            year: "last year"
        }[period];
        return {
            prevStart: r.startISO,
            prevEnd: r.endISO,
            vsLabel: vsLabel
        };
    }
    // custom — same duration shifted back
    const ms = end - start;
    const e = new Date(start.getTime() - 1);
    const s = new Date(e.getTime() - ms);
    return {
        prevStart: s.toISOString(),
        prevEnd: e.toISOString(),
        vsLabel: "previous period"
    };
};
// ── Compare helpers ───────────────────────────────────────────────────────────
const $1d9fcaa0a6035698$var$_computeSummaryFromSales = function(sales) {
    const revenue = sales.reduce((s, r)=>s + Number(r.total_price), 0);
    const transactions = sales.length;
    const avgOrder = transactions > 0 ? revenue / transactions : 0;
    let servTotal = 0, servCount = 0;
    for (const s of sales){
        if (!s.prepared_at) continue;
        const mins = (new Date(s.prepared_at) - new Date(s.sale_date)) / 60000;
        if (mins < 0 || mins > 120) continue;
        servTotal += mins;
        servCount++;
    }
    return {
        revenue: revenue,
        transactions: transactions,
        avgOrder: avgOrder,
        avgServingMinutes: servCount > 0 ? servTotal / servCount : null
    };
};
const $1d9fcaa0a6035698$var$_computeTopItemsFromSales = function(sales, limit = 5, sortKey = "quantity") {
    const map = new Map();
    for (const sale of sales)for (const item of sale.items ?? []){
        const key = item.itemName;
        const existing = map.get(key) ?? {
            name: key,
            quantity: 0,
            revenue: 0
        };
        existing.quantity += Number(item.quantity ?? 1);
        existing.revenue += Number(item.totalPrice ?? 0);
        map.set(key, existing);
    }
    return [
        ...map.values()
    ].sort((a, b)=>b[sortKey] - a[sortKey]).slice(0, limit).map((it)=>({
            ...it,
            name: $1d9fcaa0a6035698$var$_markDeletedName(it.name)
        }));
};
const $1d9fcaa0a6035698$var$_computeCompareRevenue = function(sales, type, startISO, endISO) {
    const MONTHS = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    const DAYS = [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ];
    const fmtHour = (i)=>i === 0 ? "12am" : i < 12 ? `${i}am` : i === 12 ? "12pm" : `${i - 12}pm`;
    if (type === "today" || type === "yesterday" || type === "day") {
        const hours = Array(24).fill(0);
        for (const s of sales)hours[$1d9fcaa0a6035698$var$_bizHourOf(s.sale_date)] += Number(s.total_price);
        return {
            labels: Array.from({
                length: 24
            }, (_, i)=>fmtHour(i)),
            data: hours
        };
    }
    if (type === "year") {
        const year = +$1d9fcaa0a6035698$var$_bizDayKey(startISO).slice(0, 4);
        const mmap = new Map();
        for (const s of sales){
            const m = $1d9fcaa0a6035698$var$_bizDayKey(s.sale_date).slice(0, 7);
            mmap.set(m, (mmap.get(m) ?? 0) + Number(s.total_price));
        }
        return {
            labels: MONTHS,
            data: MONTHS.map((_, i)=>mmap.get(`${year}-${String(i + 1).padStart(2, "0")}`) ?? 0)
        };
    }
    // week / month / custom → daily, by the cafe's calendar day
    const dmap = new Map();
    for (const s of sales){
        const d = $1d9fcaa0a6035698$var$_bizDayKey(s.sale_date);
        dmap.set(d, (dmap.get(d) ?? 0) + Number(s.total_price));
    }
    const days = $1d9fcaa0a6035698$var$_bizDayList(startISO, endISO);
    return {
        labels: days.map((d)=>type === "week" ? DAYS[$1d9fcaa0a6035698$var$_dayOfWeek(d)] : $1d9fcaa0a6035698$var$_md(d)),
        data: days.map((d)=>dmap.get(d) ?? 0)
    };
};
// ── Per-sales-array helpers (used by compare mode for both periods) ────────────
const $1d9fcaa0a6035698$var$_computeCategoryMixFromSales = function(sales) {
    const itemCatMap = new Map($1e7ab04ca7920cff$export$ca000e230c0caa3e.menuItems.map((i)=>[
            i.itemName,
            i.category
        ]));
    const map = new Map();
    for (const sale of sales)for (const item of sale.items ?? []){
        const cat = itemCatMap.get(item.itemName) ?? "Other";
        map.set(cat, (map.get(cat) ?? 0) + Number(item.totalPrice ?? 0));
    }
    return [
        ...map.entries()
    ].sort((a, b)=>b[1] - a[1]).map(([label, value])=>({
            label: label,
            value: value
        }));
};
const $1d9fcaa0a6035698$var$_computeStaffFromSales = function(sales) {
    const map = new Map();
    for (const sale of sales){
        const name = sale.added_by || "Unknown";
        const e = map.get(name) ?? {
            name: name,
            transactions: 0,
            revenue: 0
        };
        e.transactions++;
        e.revenue += Number(sale.total_price);
        map.set(name, e);
    }
    return [
        ...map.values()
    ].sort((a, b)=>b.revenue - a.revenue);
};
const $1d9fcaa0a6035698$var$_computeHourlyFromSales = function(sales) {
    const fmtHour = (i)=>i === 0 ? "12am" : i < 12 ? `${i}am` : i === 12 ? "12pm" : `${i - 12}pm`;
    const hours = Array(24).fill(0);
    for (const s of sales)hours[$1d9fcaa0a6035698$var$_bizHourOf(s.sale_date)]++;
    return {
        labels: Array.from({
            length: 24
        }, (_, i)=>fmtHour(i)),
        data: hours
    };
};
const $1d9fcaa0a6035698$var$_computeDowFromSales = function(sales) {
    const MON = [
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
        "Sun"
    ];
    const totals = Array(7).fill(0);
    for (const s of sales){
        const d = $1d9fcaa0a6035698$var$_dayOfWeek($1d9fcaa0a6035698$var$_bizDayKey(s.sale_date));
        totals[d === 0 ? 6 : d - 1]++;
    }
    return {
        labels: MON,
        data: totals
    };
};
const $1d9fcaa0a6035698$var$_computeServingFromSales = function(sales) {
    const fmtHour = (i)=>i === 0 ? "12am" : i < 12 ? `${i}am` : i === 12 ? "12pm" : `${i - 12}pm`;
    const MON = [
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
        "Sun"
    ];
    const filtered = sales.filter((s)=>s.prepared_at);
    if (!filtered.length) return null;
    const hourC = Array(24).fill(0), hourT = Array(24).fill(0);
    const dayC = Array(7).fill(0), dayT = Array(7).fill(0);
    let totalMins = 0, totalCount = 0;
    for (const s of filtered){
        const mins = (new Date(s.prepared_at) - new Date(s.sale_date)) / 60000;
        if (mins < 0 || mins > 120) continue;
        const h = $1d9fcaa0a6035698$var$_bizHourOf(s.sale_date);
        hourC[h]++;
        hourT[h] += mins;
        const d = $1d9fcaa0a6035698$var$_dayOfWeek($1d9fcaa0a6035698$var$_bizDayKey(s.sale_date));
        const idx = d === 0 ? 6 : d - 1;
        dayC[idx]++;
        dayT[idx] += mins;
        totalMins += mins;
        totalCount++;
    }
    if (!totalCount) return null;
    return {
        avgMinutes: totalMins / totalCount,
        byHour: {
            labels: Array.from({
                length: 24
            }, (_, i)=>fmtHour(i)),
            data: hourC.map((c, i)=>c > 0 ? hourT[i] / c : 0)
        },
        byDay: {
            labels: MON,
            data: dayC.map((c, i)=>c > 0 ? dayT[i] / c : 0)
        }
    };
};
const $1d9fcaa0a6035698$var$_computeTrafficPeaksFromSales = function(sales) {
    const fmtHour = (i)=>i === 0 ? "12am" : i < 12 ? `${i}am` : i === 12 ? "12pm" : `${i - 12}pm`;
    const FULLDAY = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
    ];
    const hourC = Array(24).fill(0);
    for (const s of sales)hourC[$1d9fcaa0a6035698$var$_bizHourOf(s.sale_date)]++;
    const maxH = Math.max(...hourC);
    const dayC = Array(7).fill(0);
    for (const s of sales){
        const d = $1d9fcaa0a6035698$var$_dayOfWeek($1d9fcaa0a6035698$var$_bizDayKey(s.sale_date));
        dayC[d === 0 ? 6 : d - 1]++;
    }
    const maxD = Math.max(...dayC);
    return {
        peakHour: maxH > 0 ? fmtHour(hourC.indexOf(maxH)) : "\u2014",
        peakHourCount: maxH,
        peakDay: maxD > 0 ? FULLDAY[dayC.indexOf(maxD)] : "\u2014",
        peakDayCount: maxD
    };
};
// ─────────────────────────────────────────────────────────────────────────────
let $1d9fcaa0a6035698$var$_compareModeActive = false;
let $1d9fcaa0a6035698$var$_cmpSalesA = null, $1d9fcaa0a6035698$var$_cmpSalesB = null, $1d9fcaa0a6035698$var$_cmpRangeA = null, $1d9fcaa0a6035698$var$_cmpRangeB = null;
let $1d9fcaa0a6035698$var$_cmpTopItemsSortKey = "quantity";
const $1d9fcaa0a6035698$var$_getRangeFromValue = function(type, value) {
    const fmtShort = (ds)=>$1d9fcaa0a6035698$var$_dayStrLabel(ds, {
            month: "short",
            day: "numeric"
        });
    if (type === "day") return {
        ...$1d9fcaa0a6035698$var$_bizDateRange(value, value),
        label: $1d9fcaa0a6035698$var$_dayStrLabel(value, {
            month: "short",
            day: "numeric",
            year: "numeric"
        })
    };
    if (type === "week") {
        const monday = (0, $lDSCx.mondayOf)(value);
        const sunday = (0, $lDSCx.addDays)(monday, 6);
        return {
            ...$1d9fcaa0a6035698$var$_bizDateRange(monday, sunday),
            label: `${fmtShort(monday)} \u{2013} ${fmtShort(sunday)}`,
            monday: monday
        };
    }
    if (type === "month") {
        const [year, month] = value.split("-").map(Number);
        const { first: first, last: last } = $1d9fcaa0a6035698$var$_monthBounds(year, month);
        return {
            ...$1d9fcaa0a6035698$var$_bizDateRange(first, last),
            label: $1d9fcaa0a6035698$var$_dayStrLabel(first, {
                month: "long",
                year: "numeric"
            })
        };
    }
    if (type === "quarter") {
        const [year, q] = value.split("-Q").map(Number);
        const startMonth = (q - 1) * 3 + 1;
        const first = $1d9fcaa0a6035698$var$_monthBounds(year, startMonth).first;
        const last = $1d9fcaa0a6035698$var$_monthBounds(year, startMonth + 2).last;
        return {
            ...$1d9fcaa0a6035698$var$_bizDateRange(first, last),
            label: `Q${q} ${year}`
        };
    }
    if (type === "year") {
        const year = parseInt(value);
        return {
            ...$1d9fcaa0a6035698$var$_bizDateRange(`${year}-01-01`, `${year}-12-31`),
            label: String(year)
        };
    }
    return null;
};
const $1d9fcaa0a6035698$var$controlToggleCompare = function() {
    if (!$1d9fcaa0a6035698$var$_compareModeActive && $1e7ab04ca7920cff$export$57b484963858c9a0('reports')) {
        $1d9fcaa0a6035698$var$showToast("Compare periods is a paid feature. Upgrade to unlock - $19/mo.", 'error');
        return;
    }
    $1d9fcaa0a6035698$var$_compareModeActive = !$1d9fcaa0a6035698$var$_compareModeActive;
    if ($1d9fcaa0a6035698$var$_compareModeActive) (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).enterCompareMode();
    else (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).exitCompareMode();
};
const $1d9fcaa0a6035698$var$controlCmpSortTopItems = function(key) {
    $1d9fcaa0a6035698$var$_cmpTopItemsSortKey = key;
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).setCmpTopItemsSort(key);
    if ($1d9fcaa0a6035698$var$_cmpSalesA && $1d9fcaa0a6035698$var$_cmpSalesB) (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderCmpTopItems($1d9fcaa0a6035698$var$_computeTopItemsFromSales($1d9fcaa0a6035698$var$_cmpSalesA, 5, key), $1d9fcaa0a6035698$var$_computeTopItemsFromSales($1d9fcaa0a6035698$var$_cmpSalesB, 5, key));
};
const $1d9fcaa0a6035698$var$controlRunComparison = async function({ type: type, aValue: aValue, bValue: bValue, fromA: fromA, toA: toA, fromB: fromB, toB: toB }) {
    try {
        $1d9fcaa0a6035698$var$_cmpRangeA = type === "custom" ? $1d9fcaa0a6035698$var$_getCashflowRange("custom", fromA, toA) : $1d9fcaa0a6035698$var$_getRangeFromValue(type, aValue);
        $1d9fcaa0a6035698$var$_cmpRangeB = type === "custom" ? $1d9fcaa0a6035698$var$_getCashflowRange("custom", fromB, toB) : $1d9fcaa0a6035698$var$_getRangeFromValue(type, bValue);
        $1d9fcaa0a6035698$var$_cmpTopItemsSortKey = "quantity";
        (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).setCmpTopItemsSort("quantity");
        const [salesA, salesB] = await Promise.all([
            (0, $1e7ab04ca7920cff$export$61f47d989fe77545)($1d9fcaa0a6035698$var$_cmpRangeA.startISO, $1d9fcaa0a6035698$var$_cmpRangeA.endISO),
            (0, $1e7ab04ca7920cff$export$61f47d989fe77545)($1d9fcaa0a6035698$var$_cmpRangeB.startISO, $1d9fcaa0a6035698$var$_cmpRangeB.endISO)
        ]);
        $1d9fcaa0a6035698$var$_cmpSalesA = salesA;
        $1d9fcaa0a6035698$var$_cmpSalesB = salesB;
        const labelA = $1d9fcaa0a6035698$var$_cmpRangeA.label;
        const labelB = $1d9fcaa0a6035698$var$_cmpRangeB.label;
        // Revenue over time (existing)
        const revA = $1d9fcaa0a6035698$var$_computeCompareRevenue(salesA, type, $1d9fcaa0a6035698$var$_cmpRangeA.startISO, $1d9fcaa0a6035698$var$_cmpRangeA.endISO);
        const revB = $1d9fcaa0a6035698$var$_computeCompareRevenue(salesB, type, $1d9fcaa0a6035698$var$_cmpRangeB.startISO, $1d9fcaa0a6035698$var$_cmpRangeB.endISO);
        const maxLen = Math.max(revA.labels.length, revB.labels.length);
        const revLabels = revA.labels.length >= revB.labels.length ? revA.labels : revB.labels;
        const dataA = revA.data.concat(Array(maxLen - revA.data.length).fill(0));
        const dataB = revB.data.concat(Array(maxLen - revB.data.length).fill(0));
        // All additional metrics
        const categoryA = $1d9fcaa0a6035698$var$_computeCategoryMixFromSales(salesA);
        const categoryB = $1d9fcaa0a6035698$var$_computeCategoryMixFromSales(salesB);
        const itemMixA = $1d9fcaa0a6035698$var$_computeTopItemsFromSales(salesA, 8, "quantity");
        const itemMixB = $1d9fcaa0a6035698$var$_computeTopItemsFromSales(salesB, 8, "quantity");
        const staffA = $1d9fcaa0a6035698$var$_computeStaffFromSales(salesA);
        const staffB = $1d9fcaa0a6035698$var$_computeStaffFromSales(salesB);
        const hourlyA = $1d9fcaa0a6035698$var$_computeHourlyFromSales(salesA);
        const hourlyB = $1d9fcaa0a6035698$var$_computeHourlyFromSales(salesB);
        const dowA = $1d9fcaa0a6035698$var$_computeDowFromSales(salesA);
        const dowB = $1d9fcaa0a6035698$var$_computeDowFromSales(salesB);
        const servingA = $1d9fcaa0a6035698$var$_computeServingFromSales(salesA);
        const servingB = $1d9fcaa0a6035698$var$_computeServingFromSales(salesB);
        const tPeaksA = $1d9fcaa0a6035698$var$_computeTrafficPeaksFromSales(salesA);
        const tPeaksB = $1d9fcaa0a6035698$var$_computeTrafficPeaksFromSales(salesB);
        const topItemsA1 = $1d9fcaa0a6035698$var$_computeTopItemsFromSales(salesA, 1, "quantity")[0];
        const topItemsB1 = $1d9fcaa0a6035698$var$_computeTopItemsFromSales(salesB, 1, "quantity")[0];
        const fmt = (v)=>(0, $coRoT.formatMoney)(v);
        const salesPeaksA = {
            bestSeller: topItemsA1?.name ?? "\u2014",
            bestSellerSub: topItemsA1 ? `${topItemsA1.quantity} sold` : "",
            topCategory: categoryA[0]?.label ?? "\u2014",
            topCategorySub: categoryA[0] ? fmt(categoryA[0].value) : "",
            topStaff: staffA[0]?.name ?? "\u2014",
            topStaffSub: staffA[0] ? fmt(staffA[0].revenue) : ""
        };
        const salesPeaksB = {
            bestSeller: topItemsB1?.name ?? "\u2014",
            bestSellerSub: topItemsB1 ? `${topItemsB1.quantity} sold` : "",
            topCategory: categoryB[0]?.label ?? "\u2014",
            topCategorySub: categoryB[0] ? fmt(categoryB[0].value) : "",
            topStaff: staffB[0]?.name ?? "\u2014",
            topStaffSub: staffB[0] ? fmt(staffB[0].revenue) : ""
        };
        // Render all
        (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderCompareResults({
            labelA: labelA,
            labelB: labelB,
            summaryA: $1d9fcaa0a6035698$var$_computeSummaryFromSales(salesA),
            summaryB: $1d9fcaa0a6035698$var$_computeSummaryFromSales(salesB),
            topItemsA: $1d9fcaa0a6035698$var$_computeTopItemsFromSales(salesA, 5, "quantity"),
            topItemsB: $1d9fcaa0a6035698$var$_computeTopItemsFromSales(salesB, 5, "quantity")
        });
        (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderCmpPeakStats({
            salesPeaksA: salesPeaksA,
            salesPeaksB: salesPeaksB,
            tPeaksA: tPeaksA,
            tPeaksB: tPeaksB
        });
        await Promise.all([
            (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderCompareChart({
                labelA: labelA,
                labelB: labelB,
                labels: revLabels,
                dataA: dataA,
                dataB: dataB
            }),
            (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderCmpSalesCharts({
                categoryA: categoryA,
                categoryB: categoryB,
                itemMixA: itemMixA,
                itemMixB: itemMixB,
                labelA: labelA,
                labelB: labelB
            }),
            (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderCmpStaff({
                staffA: staffA,
                staffB: staffB
            }),
            (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderCmpTrafficCharts({
                hourlyA: hourlyA,
                hourlyB: hourlyB,
                dowA: dowA,
                dowB: dowB,
                labelA: labelA,
                labelB: labelB
            }),
            (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderCmpKitchenCharts({
                servingA: servingA,
                servingB: servingB,
                labelA: labelA,
                labelB: labelB
            })
        ]);
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$_getAvgDivisor = function(period, startISO, endISO) {
    const now = new Date();
    const end = new Date(endISO);
    const isCurrentPeriod = end >= now;
    if (period === 'today') {
        if (isCurrentPeriod) {
            const p = (0, $lDSCx.zonedParts)(now, $1d9fcaa0a6035698$var$_bizTz());
            return Math.max(1, p.h + p.mi / 60);
        }
        return 24;
    }
    if (period === 'week') {
        if (isCurrentPeriod) {
            const start = new Date(startISO);
            return Math.max(1, Math.min(7, Math.ceil((now - start) / 86400000)));
        }
        return 7;
    }
    if (period === 'month') {
        if (isCurrentPeriod) return Math.max(1, (0, $lDSCx.zonedParts)(now, $1d9fcaa0a6035698$var$_bizTz()).d / 7);
        const [y, m] = $1d9fcaa0a6035698$var$_bizDayKey(startISO).split('-').map(Number);
        return new Date(Date.UTC(y, m, 0)).getUTCDate() / 7;
    }
    if (period === 'year') {
        if (isCurrentPeriod) return Math.max(1, (0, $lDSCx.zonedParts)(now, $1d9fcaa0a6035698$var$_bizTz()).m);
        return 12;
    }
    // custom: days in range
    const start = new Date(startISO);
    return Math.max(1, Math.round((end - start) / 86400000));
};
const $1d9fcaa0a6035698$var$_getAvgUnitSuffix = function(period) {
    if (period === 'today') return '/ Hr';
    if (period === 'week') return '/ Day';
    if (period === 'month') return '/ Wk';
    if (period === 'year') return '/ Mo';
    return '/ Day';
};
const $1d9fcaa0a6035698$var$_getAvgTooltip = function(period, divisor) {
    const d = parseFloat(divisor.toFixed(1));
    if (period === 'today') return `Divided by hours elapsed today (not always 24, currently ${d} hrs)`;
    if (period === 'week') return `Divided by days elapsed this week (not always 7, currently ${d} days)`;
    if (period === 'month') return `Divided by weeks elapsed this month (currently ${d} wks)`;
    if (period === 'year') return `Divided by months elapsed this year (currently ${d} months)`;
    return `Divided by days in this range (${d} days)`;
};
let $1d9fcaa0a6035698$var$_staffSortKey = "revenue";
const $1d9fcaa0a6035698$var$_computeStaffPerformance = function(sortKey = $1d9fcaa0a6035698$var$_staffSortKey) {
    const map = new Map();
    for (const sale of $1d9fcaa0a6035698$var$modelState.reportsSales){
        const name = sale.added_by || "Unknown";
        const existing = map.get(name) ?? {
            name: name,
            transactions: 0,
            revenue: 0,
            tips: 0
        };
        existing.transactions++;
        existing.revenue += Number(sale.total_price);
        existing.tips += Number(sale.tip_amount ?? 0); // kept apart from revenue
        map.set(name, existing);
    }
    const sorter = sortKey === "quantity" ? (a, b)=>b.transactions - a.transactions : (a, b)=>b.revenue - a.revenue;
    return [
        ...map.values()
    ].sort(sorter);
};
const $1d9fcaa0a6035698$var$controlSortStaff = function(key) {
    $1d9fcaa0a6035698$var$_staffSortKey = key;
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).setStaffSort(key);
    const staff = $1d9fcaa0a6035698$var$_computeStaffPerformance(key);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderStaff(staff, key);
};
let $1d9fcaa0a6035698$var$_reportSnapshot = null;
const $1d9fcaa0a6035698$var$controlExportReports = function() {
    if (!$1d9fcaa0a6035698$var$_reportSnapshot) {
        $1d9fcaa0a6035698$var$showToast("No data to export for this period.", "info");
        return;
    }
    const { sales: sales, staff: staff, periodLabel: periodLabel } = $1d9fcaa0a6035698$var$_reportSnapshot;
    if (!sales.length) {
        $1d9fcaa0a6035698$var$showToast("No data to export for this period.", "info");
        return;
    }
    const safeLabel = periodLabel.replace(/[^a-z0-9]/gi, "-").toLowerCase();
    const fmtDate = (iso)=>new Date(iso).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            timeZone: $1d9fcaa0a6035698$var$_bizTz()
        });
    const fmtTime = (iso)=>new Date(iso).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            timeZone: $1d9fcaa0a6035698$var$_bizTz()
        });
    // See _generateAndDownloadCSV's escape() for why the leading-character check exists.
    const escape = (val)=>{
        let s = String(val ?? "");
        // A real signed amount ("+123.45"/"-25.00") must stay a plain number so
        // Excel/Sheets can still sum the column - only guard non-numeric formula shapes.
        if (/^[=+\-@\t\r]/.test(s) && !Number.isFinite(Number(s))) s = `'${s}`;
        return `"${s.replace(/"/g, '""')}"`;
    };
    const salesRows = sales.map((s)=>[
            fmtDate(s.sale_date),
            fmtTime(s.sale_date),
            (s.items ?? []).map((i)=>`${i.itemName} x${i.quantity}`).join("; "),
            `+${Number(s.total_price).toFixed(2)}`,
            s.order_type ?? "",
            s.added_by ?? ""
        ]);
    const staffRows = staff.map((p)=>[
            "",
            "",
            `[Staff] ${p.name}`,
            p.revenue.toFixed(2),
            "",
            `${p.transactions} transaction${p.transactions !== 1 ? "s" : ""}` + (p.tips > 0 ? `; ${p.tips.toFixed(2)} in tips` : "")
        ]);
    const header = [
        "Date",
        "Time",
        "Description",
        "Amount",
        "Order Type",
        "Staff / Notes"
    ];
    const sep = [
        [
            ""
        ],
        [
            "--- Staff Summary ---"
        ],
        ...staffRows.map((r)=>r)
    ];
    const csv = [
        header,
        ...salesRows,
        [],
        ...sep
    ].map((row)=>Array.isArray(row) ? row.map(escape).join(",") : "").join("\n");
    const blob = new Blob([
        "\uFEFF" + csv
    ], {
        type: "text/csv;charset=utf-8;"
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `reports-${safeLabel}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    $1d9fcaa0a6035698$var$showToast("CSV downloaded.", "success");
};
const $1d9fcaa0a6035698$var$controlExportReportsPDF = function() {
    if (!$1d9fcaa0a6035698$var$_reportSnapshot) {
        $1d9fcaa0a6035698$var$showToast("No data to export for this period.", "info");
        return;
    }
    const { sales: sales, staff: staff, periodLabel: periodLabel } = $1d9fcaa0a6035698$var$_reportSnapshot;
    if (!sales.length) {
        $1d9fcaa0a6035698$var$showToast("No data to export for this period.", "info");
        return;
    }
    const summary = $1d9fcaa0a6035698$var$_computeReportsSummary();
    const topItems = $1d9fcaa0a6035698$var$_computeTopItems(10);
    const fmt = (n)=>(0, $coRoT.formatMoney)(n);
    const fmtServ = (v)=>{
        if (v == null) return "\u2014";
        const m = Math.floor(v), s = Math.round((v - m) * 60);
        return s > 0 ? `${m}m ${s}s` : `${m}m`;
    };
    const fmtDate = (iso)=>new Date(iso).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            timeZone: $1d9fcaa0a6035698$var$_bizTz()
        });
    const fmtTime = (iso)=>new Date(iso).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            timeZone: $1d9fcaa0a6035698$var$_bizTz()
        });
    const captureChart = (wrapId, canvasId)=>{
        const wrap = document.querySelector(`#${wrapId}`);
        if (!wrap || wrap.classList.contains("hidden")) return null;
        const canvas = document.querySelector(`#${canvasId}`);
        if (!canvas || canvas.style.display === "none") return null;
        try {
            return canvas.toDataURL("image/png");
        } catch  {
            return null;
        }
    };
    const charts = {
        revenue: captureChart("rpRevenueWrap", "rpRevenueCanvas"),
        category: captureChart("rpCategoryWrap", "rpCategoryCanvas"),
        hourly: captureChart("rpHourlyWrap", "rpHourlyCanvas"),
        dow: captureChart("rpDowWrap", "rpDowCanvas"),
        servHour: captureChart("rpServingHourWrap", "rpServingHourCanvas"),
        servDay: captureChart("rpServingDayWrap", "rpServingDayCanvas")
    };
    // ── Compare mode PDF ──────────────────────────────────────────────────
    if ($1d9fcaa0a6035698$var$_compareModeActive && $1d9fcaa0a6035698$var$_cmpSalesA && $1d9fcaa0a6035698$var$_cmpSalesB) {
        const sA = $1d9fcaa0a6035698$var$_computeSummaryFromSales($1d9fcaa0a6035698$var$_cmpSalesA);
        const sB = $1d9fcaa0a6035698$var$_computeSummaryFromSales($1d9fcaa0a6035698$var$_cmpSalesB);
        const labelA = $1d9fcaa0a6035698$var$_cmpRangeA?.label ?? "Period A";
        const labelB = $1d9fcaa0a6035698$var$_cmpRangeB?.label ?? "Period B";
        const topA = $1d9fcaa0a6035698$var$_computeTopItemsFromSales($1d9fcaa0a6035698$var$_cmpSalesA, 8, "revenue");
        const topB = $1d9fcaa0a6035698$var$_computeTopItemsFromSales($1d9fcaa0a6035698$var$_cmpSalesB, 8, "revenue");
        const cmpChart = captureChart("rpCompareResults", "rpCmpRevenueCanvas");
        const now2 = new Date();
        const eDate = now2.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric"
        });
        const eTime = now2.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit"
        });
        const deltaCell = (a, b, invert = false)=>{
            if (a == null || b == null || b === 0) return `<td class="td-num td-muted">\u{2014}</td>`;
            const pct = Math.round((a - b) / b * 100);
            const good = invert ? pct <= 0 : pct >= 0;
            const arrow = pct >= 0 ? "\u2191" : "\u2193";
            const col = good ? "#16a34a" : "#dc2626";
            return `<td class="td-num" style="color:${col};font-weight:600">${arrow} ${Math.abs(pct)}%</td>`;
        };
        const kpiCard = (label, rawA, rawB, fmtA, fmtB, invert = false)=>{
            let aWins = false, bWins = false;
            if (rawA != null && rawB != null) {
                aWins = invert ? rawA < rawB : rawA > rawB;
                bWins = invert ? rawB < rawA : rawB > rawA;
            }
            let badge = "";
            if (rawA != null && rawB != null && rawB !== 0) {
                const pct = Math.round((rawA - rawB) / rawB * 100);
                const good = invert ? pct <= 0 : pct >= 0;
                const arrow = pct >= 0 ? "\u2191" : "\u2193";
                badge = `<span class="delta-pill ${good ? "delta-up" : "delta-dn"}">${arrow} ${Math.abs(pct)}%</span>`;
            }
            const bCls = bWins ? "kv-b kv-b--win" : rawA != null && rawB != null && rawA !== rawB ? "kv-b kv-b--lose" : "kv-b kv-b--tie";
            return `<div class="kpi-card">
        <div class="kpi-lbl">${label}</div>
        <div class="kpi-row"><span class="dot-a"></span><span class="kv-a">${fmtA}</span>${badge}</div>
        <div class="kpi-row" style="margin-top:5px"><span class="dot-b"></span><span class="${bCls}">${fmtB}</span></div>
      </div>`;
        };
        const cmpHtml = `<!DOCTYPE html>
<html lang="en"><head><meta charset="utf-8"/>
<title>Pointbunny Comparison: ${(0, $cnCXJ.esc)(labelA)} vs ${(0, $cnCXJ.esc)(labelB)}</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;background:#fff;color:#111827;font-size:10.5pt;line-height:1.5;-webkit-print-color-adjust:exact;print-color-adjust:exact}
@page{size:A4;margin:13mm 16mm}
.pdf-header{background:#22c55e;border-radius:14px;padding:20px 24px;color:#fff;display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:18px;-webkit-print-color-adjust:exact;print-color-adjust:exact}
.pdf-logo{font-size:20pt;font-weight:800;letter-spacing:-0.02em}
.pdf-period{font-size:10pt;opacity:.85;margin-top:3px}
.pdf-meta{text-align:right;font-size:8.5pt;opacity:.8;line-height:1.7}
.section-heading{font-size:7.5pt;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#22c55e;margin:0 0 10px;padding-bottom:6px;border-bottom:2px solid #dcfce7}
.table-wrap{border:1.5px solid #e5e7eb;border-radius:12px;overflow:hidden;margin-bottom:18px;break-inside:avoid}
table{width:100%;border-collapse:collapse;font-size:8.5pt}
th{background:#f9fafb;padding:8px 10px;text-align:left;font-size:7pt;font-weight:700;text-transform:uppercase;letter-spacing:.05em;color:#6b7280;border-bottom:1.5px solid #e5e7eb}
td{padding:8px 10px;border-bottom:1px solid #f3f4f6;color:#374151}
tr:last-child td{border-bottom:none}
.td-num{text-align:right;font-variant-numeric:tabular-nums}
.td-muted{color:#9ca3af}
.td-metric{font-weight:600;color:#111827;width:110px}
.dot-a{display:inline-block;width:9px;height:9px;border-radius:50%;background:#22c55e;flex-shrink:0}
.dot-b{display:inline-block;width:9px;height:9px;border-radius:50%;background:#3b82f6;flex-shrink:0}
.kpi-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:10px;margin-bottom:18px}
.kpi-card{border:1.5px solid #e5e7eb;border-radius:12px;padding:14px 16px;break-inside:avoid}
.kpi-lbl{font-size:7pt;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#6b7280;margin-bottom:10px}
.kpi-row{display:flex;align-items:center;gap:8px}
.kv-a{font-size:14pt;font-weight:700;line-height:1;color:#16a34a;font-variant-numeric:tabular-nums}
.kv-b{font-size:13pt;font-weight:700;line-height:1;font-variant-numeric:tabular-nums}
.kv-b--win{color:#16a34a}.kv-b--lose{color:#dc2626}.kv-b--tie{color:#6b7280}
.delta-pill{display:inline-flex;align-items:center;gap:2px;font-size:7.5pt;font-weight:700;padding:2px 7px;border-radius:6px;line-height:1.5}
.delta-up{background:#dcfce7;color:#16a34a}
.delta-dn{background:#fee2e2;color:#dc2626}
.chart-wrap{border:1.5px solid #e5e7eb;border-radius:12px;overflow:hidden;margin-bottom:18px}
.chart-label{padding:9px 13px;border-bottom:1px solid #f3f4f6;font-size:8pt;font-weight:600;color:#374151;background:#f9fafb}
.chart-wrap img{width:100%;display:block}
.top-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:18px}
.top-card{border:1.5px solid #e5e7eb;border-radius:12px;overflow:hidden}
.top-card th,.top-card td{padding:7px 10px}
.pdf-footer{margin-top:14px;padding-top:10px;border-top:1px solid #e5e7eb;font-size:7.5pt;color:#9ca3af;text-align:center}
.period-legend{display:flex;align-items:center;gap:10px;margin-bottom:18px;padding:9px 14px;border:1.5px solid #e5e7eb;border-radius:10px;font-size:8.5pt;color:#374151;background:#f9fafb}
.period-lbl{font-weight:600;color:#374151}
.period-sep{color:#9ca3af;margin:0 4px}
.period-tag{font-size:6.5pt;font-weight:700;text-transform:uppercase;letter-spacing:.04em;padding:1px 6px;border-radius:4px;line-height:1.6}
.period-tag-a{background:#dcfce7;color:#16a34a}
.period-tag-b{background:#dbeafe;color:#2563eb}
</style></head><body>

<div class="pdf-header">
  <div>
    <div class="pdf-logo">Pointbunny</div>
    <div class="pdf-period">Comparison Report</div>
  </div>
  <div class="pdf-meta"><div>${eDate}</div><div>${eTime}</div></div>
</div>

<div class="period-legend">
  <span class="dot-a"></span><span class="period-tag period-tag-a">A</span><span class="period-lbl">${(0, $cnCXJ.esc)(labelA)}</span>
  <span class="period-sep">vs</span>
  <span class="dot-b"></span><span class="period-tag period-tag-b">B</span><span class="period-lbl">${(0, $cnCXJ.esc)(labelB)}</span>
</div>

<div class="section-heading">KPI Summary</div>
<div class="kpi-grid">
  ${kpiCard("Gross Income", sA.revenue, sB.revenue, fmt(sA.revenue), fmt(sB.revenue))}
  ${kpiCard("Transactions", sA.transactions, sB.transactions, String(sA.transactions), String(sB.transactions))}
  ${kpiCard("Avg. Order", sA.avgOrder, sB.avgOrder, fmt(sA.avgOrder), fmt(sB.avgOrder))}
  ${kpiCard("Avg. Serving", sA.avgServingMinutes, sB.avgServingMinutes, fmtServ(sA.avgServingMinutes), fmtServ(sB.avgServingMinutes), true)}
</div>

${cmpChart ? `<div class="section-heading">Gross Income Over Time</div>
<div class="chart-wrap"><div class="chart-label">${(0, $cnCXJ.esc)(labelA)} vs ${(0, $cnCXJ.esc)(labelB)}</div><img src="${cmpChart}" alt="Compare chart"/></div>` : ""}

<div class="section-heading">Top Items by Gross Income</div>
<div class="top-grid">
  <div class="top-card"><table>
    <thead><tr><th><span class="dot-a"></span>${(0, $cnCXJ.esc)(labelA)}</th><th class="td-num">Gross Income</th></tr></thead>
    <tbody>${topA.map((i)=>`<tr><td>${(0, $cnCXJ.esc)(i.name)}</td><td class="td-num">${fmt(i.revenue)}</td></tr>`).join("") || '<tr><td colspan="2" class="td-muted" style="text-align:center;padding:14px">No data</td></tr>'}</tbody>
  </table></div>
  <div class="top-card"><table>
    <thead><tr><th><span class="dot-b"></span>${(0, $cnCXJ.esc)(labelB)}</th><th class="td-num">Gross Income</th></tr></thead>
    <tbody>${topB.map((i)=>`<tr><td>${(0, $cnCXJ.esc)(i.name)}</td><td class="td-num">${fmt(i.revenue)}</td></tr>`).join("") || '<tr><td colspan="2" class="td-muted" style="text-align:center;padding:14px">No data</td></tr>'}</tbody>
  </table></div>
</div>

<div class="pdf-footer">Pointbunny POS &nbsp;\xb7&nbsp; ${(0, $cnCXJ.esc)(labelA)} vs ${(0, $cnCXJ.esc)(labelB)} &nbsp;\xb7&nbsp; Exported ${eDate} at ${eTime}</div>
</body></html>`;
        const pop = window.open("", "pointbunny-pdf-report", "width=960,height=720");
        if (!pop) {
            $1d9fcaa0a6035698$var$showToast("Pop-up blocked. Allow pop-ups for this site to export PDF.", "error");
            return;
        }
        pop.document.write(cmpHtml);
        pop.document.close();
        pop.focus();
        setTimeout(()=>pop.print(), 700);
        return;
    }
    // ── Regular mode PDF ──────────────────────────────────────────────────
    const chartBlock = (img, label, full = false)=>!img ? "" : `
    <div class="chart-block${full ? " chart-block--full" : ""}">
      <div class="chart-label">${label}</div>
      <img src="${img}" alt="${label}"/>
    </div>`;
    const topItemsRows = topItems.map((item, i)=>`
    <tr>
      <td class="td-rank">${i + 1}</td>
      <td>${(0, $cnCXJ.esc)(item.name)}</td>
      <td class="td-num">${item.quantity}</td>
      <td class="td-num">${fmt(item.revenue)}</td>
    </tr>`).join("");
    const anyTips = staff.some((p)=>p.tips > 0);
    const staffRows = staff.map((p)=>`
    <tr>
      <td>${(0, $cnCXJ.esc)(p.name)}</td>
      <td class="td-num">${p.transactions}</td>
      <td class="td-num">${fmt(p.revenue)}</td>
      <td class="td-num">${fmt(p.transactions > 0 ? p.revenue / p.transactions : 0)}</td>
      ${anyTips ? `<td class="td-num">${fmt(p.tips)}</td>` : ""}
    </tr>`).join("");
    const salesRows = sales.slice(0, 50).map((s)=>`
    <tr>
      <td>${(0, $cnCXJ.esc)(fmtDate(s.sale_date))}</td>
      <td>${(0, $cnCXJ.esc)(fmtTime(s.sale_date))}</td>
      <td>${(0, $cnCXJ.esc)((s.items ?? []).map((i)=>`${i.itemName} \xd7${i.quantity}`).join(", "))}</td>
      <td class="td-num">${fmt(s.total_price)}</td>
      <td>${(0, $cnCXJ.esc)(s.order_type ?? "\u2014")}</td>
      <td>${(0, $cnCXJ.esc)(s.added_by ?? "\u2014")}</td>
    </tr>`).join("");
    const now = new Date();
    const exportDate = now.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric"
    });
    const exportTime = now.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit"
    });
    const html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="utf-8"/>
<title>Pointbunny Report: ${(0, $cnCXJ.esc)(periodLabel)}</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;background:#fff;color:#111827;font-size:10.5pt;line-height:1.5;-webkit-print-color-adjust:exact;print-color-adjust:exact}
@page{size:A4;margin:13mm 16mm}
.pdf-header{background:#22c55e;border-radius:14px;padding:20px 24px;color:#fff;display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:18px;-webkit-print-color-adjust:exact;print-color-adjust:exact}
.pdf-logo{font-size:20pt;font-weight:800;letter-spacing:-0.02em}
.pdf-period{font-size:10pt;opacity:.85;margin-top:3px}
.pdf-meta{text-align:right;font-size:8.5pt;opacity:.8;line-height:1.7}
.kpi-strip{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-bottom:18px}
.kpi-card{border:1.5px solid #e5e7eb;border-radius:12px;padding:13px 15px}
.kpi-label{font-size:7pt;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#6b7280;margin-bottom:6px}
.kpi-val{font-size:15pt;font-weight:700;color:#111827;line-height:1;font-variant-numeric:tabular-nums}
.section-heading{font-size:7.5pt;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#22c55e;margin:0 0 10px;padding-bottom:6px;border-bottom:2px solid #dcfce7}
.charts-area{margin-bottom:18px}
.charts-row{display:grid;gap:10px;margin-bottom:10px}
.charts-row--2{grid-template-columns:1fr 1fr}
.charts-row--1{grid-template-columns:1fr}
.chart-block{border:1.5px solid #e5e7eb;border-radius:12px;overflow:hidden;break-inside:avoid}
.chart-label{padding:8px 13px;border-bottom:1px solid #f3f4f6;font-size:8pt;font-weight:600;color:#374151;background:#f9fafb}
.chart-block img{width:100%;display:block}
.table-wrap{border:1.5px solid #e5e7eb;border-radius:12px;overflow:hidden;margin-bottom:18px;break-inside:avoid}
table{width:100%;border-collapse:collapse;font-size:8.5pt}
th{background:#f9fafb;padding:8px 10px;text-align:left;font-size:7pt;font-weight:700;text-transform:uppercase;letter-spacing:.05em;color:#6b7280;border-bottom:1.5px solid #e5e7eb}
td{padding:7px 10px;border-bottom:1px solid #f3f4f6;color:#374151}
tr:last-child td{border-bottom:none}
.td-num{text-align:right;font-variant-numeric:tabular-nums}
.td-rank{color:#9ca3af;font-weight:600;width:28px}
.pdf-footer{margin-top:14px;padding-top:10px;border-top:1px solid #e5e7eb;font-size:7.5pt;color:#9ca3af;text-align:center}
</style>
</head>
<body>

<div class="pdf-header">
  <div>
    <div class="pdf-logo">Pointbunny</div>
    <div class="pdf-period">${(0, $cnCXJ.esc)(periodLabel)}</div>
  </div>
  <div class="pdf-meta">
    <div>${exportDate}</div>
    <div>${exportTime}</div>
  </div>
</div>

<div class="kpi-strip">
  <div class="kpi-card"><div class="kpi-label">Gross Income</div><div class="kpi-val">${fmt(summary.revenue)}</div></div>
  <div class="kpi-card"><div class="kpi-label">Transactions</div><div class="kpi-val">${summary.transactions}</div></div>
  <div class="kpi-card"><div class="kpi-label">Avg. Order</div><div class="kpi-val">${fmt(summary.avgOrder)}</div></div>
  <div class="kpi-card"><div class="kpi-label">Avg. Serving</div><div class="kpi-val">${fmtServ(summary.avgServingMinutes)}</div></div>
</div>

${charts.revenue ? `<div class="section-heading">Charts</div><div class="charts-area">
  <div class="charts-row charts-row--1">${chartBlock(charts.revenue, "Gross Income Over Time")}</div>
  <div class="charts-row charts-row--2">${chartBlock(charts.category, "Category Mix")}${chartBlock(charts.hourly, "Hourly Breakdown")}</div>
  ${charts.dow || charts.servHour || charts.servDay ? `<div class="charts-row charts-row--2">${chartBlock(charts.dow, "Day of Week")}${chartBlock(charts.servHour, "Avg. Serving by Hour")}</div>` : ""}
  ${charts.servDay ? `<div class="charts-row charts-row--1">${chartBlock(charts.servDay, "Avg. Serving by Day")}</div>` : ""}
</div>` : ""}

<div class="section-heading">Top Items</div>
<div class="table-wrap">
  <table>
    <thead><tr><th>#</th><th>Item</th><th class="td-num">Qty Sold</th><th class="td-num">Gross Income</th></tr></thead>
    <tbody>${topItemsRows || '<tr><td colspan="4" style="color:#9ca3af;text-align:center;padding:16px">No item data</td></tr>'}</tbody>
  </table>
</div>

${staff.length ? `<div class="section-heading">Staff Performance</div>
<div class="table-wrap">
  <table>
    <thead><tr><th>Cashier</th><th class="td-num">Transactions</th><th class="td-num">Gross Income</th><th class="td-num">Avg. Order</th>${anyTips ? '<th class="td-num">Tips</th>' : ""}</tr></thead>
    <tbody>${staffRows}</tbody>
  </table>
</div>` : ""}

<div class="section-heading">Transactions ${sales.length > 50 ? "(showing first 50)" : ""}</div>
<div class="table-wrap">
  <table>
    <thead><tr><th>Date</th><th>Time</th><th>Items</th><th class="td-num">Total</th><th>Type</th><th>Cashier</th></tr></thead>
    <tbody>${salesRows}</tbody>
  </table>
</div>

<div class="pdf-footer">Pointbunny POS &nbsp;\xb7&nbsp; ${(0, $cnCXJ.esc)(periodLabel)} &nbsp;\xb7&nbsp; Exported ${exportDate} at ${exportTime}</div>

</body>
</html>`;
    const popup = window.open("", "pointbunny-pdf-report", "width=960,height=720");
    if (!popup) {
        $1d9fcaa0a6035698$var$showToast("Pop-up blocked. Allow pop-ups for this site to export PDF.", "error");
        return;
    }
    popup.document.write(html);
    popup.document.close();
    popup.focus();
    setTimeout(()=>popup.print(), 700);
};
const $1d9fcaa0a6035698$var$_renderReportsData = async function(period, startISO, endISO, label, prevTotals, vsLabel) {
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).setPeriodLabel(label);
    const expSummary = $1d9fcaa0a6035698$var$_reportsExpenseSummary();
    const summary = {
        ...$1d9fcaa0a6035698$var$_computeReportsSummary(),
        net: expSummary.net,
        expenses: expSummary.expenses
    };
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderSummary(summary);
    if (prevTotals) (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderComparison(summary, prevTotals, vsLabel);
    // The chosen Overview cards stay selected across period changes (the ‹ ›
    // arrows would otherwise clear them on every step) - reset only on open.
    $1d9fcaa0a6035698$var$_overviewTimeSeries = $1d9fcaa0a6035698$var$_computeAllTimeSeries(period, startISO, endISO);
    await $1d9fcaa0a6035698$var$_renderOverviewChart();
    $1d9fcaa0a6035698$var$_renderReportsTips();
    // renderExpenseKpis sets Overview's real Expenses/Net Income (reportsExpenses/
    // reportsNetIncome) as well as the Sales tab's own Gross/Net/Avg cards
    // (salesNetIncome/salesAvgGross/salesAvgNet) in one call - always run it so
    // Overview's own numbers are never stuck on the loading skeleton. The Sales
    // tab values this also writes aren't a new leak on a free plan: they're the
    // exact same Today totals (or an average derived from them) already visible
    // for real on Overview - see model.isPaidPlan() gate below for what's
    // actually withheld.
    const avgDivisor = $1d9fcaa0a6035698$var$_getAvgDivisor(period, startISO, endISO);
    const avgSuffix = $1d9fcaa0a6035698$var$_getAvgUnitSuffix(period);
    const avgTooltip = $1d9fcaa0a6035698$var$_getAvgTooltip(period, avgDivisor);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderExpenseKpis({
        ...expSummary,
        avgGross: expSummary.gross / avgDivisor,
        avgNet: expSummary.net / avgDivisor,
        avgSuffix: avgSuffix,
        avgTooltip: avgTooltip
    });
    // Sales/Traffic/Queue/Channels are paid-only surfaces - a free plan never
    // computes or writes their real numbers into the DOM, so those sections
    // stay in whatever skeleton state renderLoading() already put them in.
    // That's the actual guardrail (not just CSS blur): there's no real data to
    // reveal even if the blur/overlay were defeated in devtools.
    if (!$1e7ab04ca7920cff$export$9e608bbc985290d4()) {
        $1d9fcaa0a6035698$var$_reportSnapshot = {
            sales: $1d9fcaa0a6035698$var$modelState.reportsSales,
            staff: [],
            periodLabel: label
        };
        return;
    }
    const topItems = $1d9fcaa0a6035698$var$_computeTopItems();
    const categoryMix = $1d9fcaa0a6035698$var$_computeCategoryMix();
    const staff = $1d9fcaa0a6035698$var$_computeStaffPerformance();
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderTopItems(topItems, $1d9fcaa0a6035698$var$_topItemsSortKey);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderStaff(staff, $1d9fcaa0a6035698$var$_staffSortKey);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderSalesKpis({
        bestSeller: topItems[0] ?? null,
        topCategory: categoryMix[0] ?? null,
        topStaff: staff[0] ?? null
    });
    $1d9fcaa0a6035698$var$_reportSnapshot = {
        sales: $1d9fcaa0a6035698$var$modelState.reportsSales,
        staff: staff,
        periodLabel: label
    };
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderTrafficKpis($1d9fcaa0a6035698$var$_computeTrafficPeaks(period, startISO, endISO));
    const servingTime = $1d9fcaa0a6035698$var$_computeServingTimeStats();
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderKitchenBreakdown(servingTime);
    const doneMinutes = $1d9fcaa0a6035698$var$modelState.reportsSales.filter((s)=>s.prepared_at).map((s)=>(new Date(s.prepared_at) - new Date(s.sale_date)) / 60000).filter((m)=>m >= 0);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderSpeedOfService($1d9fcaa0a6035698$var$_computeSpeedOfService(doneMinutes), prevTotals ? $1d9fcaa0a6035698$var$_computeSpeedOfService(prevTotals.servingMinutes) : null, vsLabel);
    await (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderChannels({
        channelMix: $1d9fcaa0a6035698$var$_computeChannelMix(),
        paymentMix: $1d9fcaa0a6035698$var$_computePaymentMethodMix(),
        orderTypeEnabled: !!$1d9fcaa0a6035698$var$modelState.settings?.orderTypeEnabled
    });
    await (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderCharts({
        categoryMix: categoryMix,
        itemMix: topItems,
        hourlyBreakdown: $1d9fcaa0a6035698$var$_computeHourlyBreakdown(),
        dayOfWeek: $1d9fcaa0a6035698$var$_computeDayOfWeek(period),
        servingTime: servingTime
    });
};
// Free plan: only the Overview tab, only with Today selected, is real - the
// Today fetch/render below always runs (cheap, same query as the home
// dashboard's own stats already run at boot). Switching to Week/Month/Year/
// Custom, or into Sales/Traffic/Queue/Channels, is gated at the point the
// user tries it (controlReportsPeriodChange / ReportsView's section-switch
// callback / controlToggleCompare) rather than blocked here.
const $1d9fcaa0a6035698$var$controlOpenReports = async function(section = "overview") {
    if (!$1e7ab04ca7920cff$export$b325ec6732b039cf('view_reports')) {
        $1d9fcaa0a6035698$var$showToast("You don't have access to reports.", 'error');
        return;
    }
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).open();
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).preloadChart(); // eagerly start compiling the chart.js chunk while data fetches
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderLoading();
    $1d9fcaa0a6035698$var$_currentReportsPeriod = {
        period: "today",
        offset: 0
    };
    $1d9fcaa0a6035698$var$_selectedOverviewMetrics = new Set();
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).setStepper("today", 0);
    try {
        const { startISO: startISO, endISO: endISO, label: label } = $1d9fcaa0a6035698$var$_getCashflowRange("today");
        const { prevStart: prevStart, prevEnd: prevEnd, vsLabel: vsLabel } = $1d9fcaa0a6035698$var$_getPreviousPeriodRange("today", startISO, endISO);
        const [, , prevExpenses] = await Promise.all([
            $1e7ab04ca7920cff$export$993437c9947c004b(startISO, endISO),
            $1e7ab04ca7920cff$export$2614d9fab0c6cda6(prevStart, prevEnd).then((pt)=>{
                $1d9fcaa0a6035698$var$_currentPrevTotals = pt;
            }),
            $1e7ab04ca7920cff$export$ba65f3bfbeeb19bf(prevStart, prevEnd),
            $1e7ab04ca7920cff$export$4f704ada9f12295b(startISO, endISO)
        ]);
        $1d9fcaa0a6035698$var$_currentPrevTotals = {
            ...$1d9fcaa0a6035698$var$_currentPrevTotals,
            expenses: prevExpenses,
            net: $1d9fcaa0a6035698$var$_currentPrevTotals.revenue - prevExpenses
        };
        await $1d9fcaa0a6035698$var$_renderReportsData("today", startISO, endISO, label, $1d9fcaa0a6035698$var$_currentPrevTotals, vsLabel);
        if (section !== "overview") (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._switchSection(section, $1e7ab04ca7920cff$export$57b484963858c9a0('reports'));
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$controlCloseReports = function() {
    if ($1d9fcaa0a6035698$var$_compareModeActive) {
        $1d9fcaa0a6035698$var$_compareModeActive = false;
        (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).exitCompareMode();
    }
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).close();
};
const $1d9fcaa0a6035698$var$controlReportsPeriodChange = async function({ period: period, from: from, to: to, offset: offset = 0 }) {
    const planLocked = $1e7ab04ca7920cff$export$57b484963858c9a0('reports');
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).setActivePeriod(period);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).setStepper(period, offset);
    if (planLocked && (period !== "today" || offset !== 0)) {
        // No real fetch for a locked period - just show the one generic locked
        // preview (same for every period/section, by design - see planGate.js).
        $1d9fcaa0a6035698$var$_currentReportsPeriod = {
            period: period,
            from: from,
            to: to,
            offset: offset
        };
        (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).setPeriodLabel($1d9fcaa0a6035698$var$_getCashflowRange(period, from, to, offset).label);
        (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).setSectionLocked(true);
        return;
    }
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).renderLoading();
    $1d9fcaa0a6035698$var$_currentReportsPeriod = {
        period: period,
        from: from,
        to: to,
        offset: offset
    };
    try {
        const { startISO: startISO, endISO: endISO, label: label } = $1d9fcaa0a6035698$var$_getCashflowRange(period, from, to, offset);
        const { prevStart: prevStart, prevEnd: prevEnd, vsLabel: vsLabel } = $1d9fcaa0a6035698$var$_getPreviousPeriodRange(period, startISO, endISO, from, to, offset);
        const [, , prevExpenses] = await Promise.all([
            $1e7ab04ca7920cff$export$993437c9947c004b(startISO, endISO),
            $1e7ab04ca7920cff$export$2614d9fab0c6cda6(prevStart, prevEnd).then((pt)=>{
                $1d9fcaa0a6035698$var$_currentPrevTotals = pt;
            }),
            $1e7ab04ca7920cff$export$ba65f3bfbeeb19bf(prevStart, prevEnd),
            $1e7ab04ca7920cff$export$4f704ada9f12295b(startISO, endISO)
        ]);
        $1d9fcaa0a6035698$var$_currentPrevTotals = {
            ...$1d9fcaa0a6035698$var$_currentPrevTotals,
            expenses: prevExpenses,
            net: $1d9fcaa0a6035698$var$_currentPrevTotals.revenue - prevExpenses
        };
        await $1d9fcaa0a6035698$var$_renderReportsData(period, startISO, endISO, label, $1d9fcaa0a6035698$var$_currentPrevTotals, vsLabel);
        // Today is real again, but the active SECTION may still be a locked one
        // (Sales/Traffic/Queue/Channels are always locked on a free plan,
        // regardless of period) - re-apply that independently of the period lock.
        (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).setSectionLocked(planLocked && (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._activeSection !== "overview");
        (0, $d94c521226fbc9fa$export$2e2bcd8739ae039).replayActiveSection(); // re-run the entrance so charts/cards animate on every period change
    } catch (err) {
        $1d9fcaa0a6035698$var$showToast(err.message ?? err);
    }
};
const $1d9fcaa0a6035698$var$_wireApp = function() {
    //MenuList
    (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._addHandlerShowModal($1d9fcaa0a6035698$var$controlMenuList);
    document.getElementById('menuSetupCta')?.addEventListener('click', $1d9fcaa0a6035698$var$controlMenuList);
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._showEditMenuForm($1d9fcaa0a6035698$var$controlShowEditMenu);
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._deleteVariant();
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._closeModal();
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._deleteOption();
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._addVariantGroup();
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._addOption();
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._updateImagePreview();
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._addPhotoDropZone();
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._wireVisualPicker();
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._addHandlerHasVariantsToggle();
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._addHandlerInventorySection();
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._addHandlerDeleteItem($1d9fcaa0a6035698$var$controlDeleteMenuItem);
    (0, $24a84838d36102df$export$2e2bcd8739ae039)._addHandlerManageTax($1d9fcaa0a6035698$var$controlManageItemTax);
    //Adding New Menu
    (0, $0540865b060d0b60$export$2e2bcd8739ae039)._uploadItem($1d9fcaa0a6035698$var$controlUploadItem);
    (0, $0540865b060d0b60$export$2e2bcd8739ae039)._newMenuCategory();
    (0, $0540865b060d0b60$export$2e2bcd8739ae039)._addHandlerAddMenuCategory($1d9fcaa0a6035698$var$controlAddNewCategory);
    (0, $0540865b060d0b60$export$2e2bcd8739ae039)._itemVariantsToggle();
    (0, $0540865b060d0b60$export$2e2bcd8739ae039)._addVariantOption();
    $1d9fcaa0a6035698$var$controlNewMenuButtonToggle();
    // Settings
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerOpen($1d9fcaa0a6035698$var$controlOpenSettings);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerClose();
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerNavTabs();
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerMobileNav();
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerEditProfile($1d9fcaa0a6035698$var$controlEditProfile);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerCancelProfile($1d9fcaa0a6035698$var$controlCancelProfile);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerSaveProfile($1d9fcaa0a6035698$var$controlSaveProfile);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerEditBusiness($1d9fcaa0a6035698$var$controlEditBusiness);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerCancelBusiness($1d9fcaa0a6035698$var$controlCancelBusiness);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerSaveBusinessInfo($1d9fcaa0a6035698$var$controlSaveBusinessInfo);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerVerifyOTP($1d9fcaa0a6035698$var$controlVerifySettingsOTP);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerCancelOTP($1d9fcaa0a6035698$var$controlCancelSettingsOTP);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandler2FAEnable($1d9fcaa0a6035698$var$controlEnable2FA);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandler2FADisable($1d9fcaa0a6035698$var$controlDisable2FA);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandler2FAVerifyEnroll($1d9fcaa0a6035698$var$controlConfirm2FAEnroll);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandler2FACancelEnroll();
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandler2FACodes(()=>$1d9fcaa0a6035698$var$showToast('Two-factor authentication enabled.', 'success'), ()=>$1d9fcaa0a6035698$var$showToast('Please tick the box to confirm you have saved your recovery codes first.', 'error'));
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerTaxReminderClose();
    (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._addHandlerAddCategory($1d9fcaa0a6035698$var$controlAddCategoryFromSettings);
    (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._addHandlerDeleteCategory($1d9fcaa0a6035698$var$controlDeleteCategory);
    (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._addHandlerToggleCategories();
    (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._addHandlerUploadCsv($1d9fcaa0a6035698$var$controlUploadMenuCsv);
    (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._addHandlerToggleSelectMode();
    (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._addHandlerCardSelect();
    (0, $7085f2b0e4c3ca9d$export$2e2bcd8739ae039)._addHandlerSelectBar({
        onSetStatus: $1d9fcaa0a6035698$var$controlBulkSetStatus,
        onDelete: $1d9fcaa0a6035698$var$controlBulkDelete
    });
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerShowRemoved($1d9fcaa0a6035698$var$controlShowRemoved);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerTogglePrinting($1d9fcaa0a6035698$var$controlTogglePrinting);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerToggleConfirmPrint($1d9fcaa0a6035698$var$controlToggleConfirmPrint);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerToggleShowCashier($1d9fcaa0a6035698$var$controlToggleShowCashier);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerToggleHideStats($1d9fcaa0a6035698$var$controlToggleHideStats);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerToggleOrderType($1d9fcaa0a6035698$var$controlToggleOrderType);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerToggleInvoiceNumber($1d9fcaa0a6035698$var$controlToggleShowInvoiceNumber);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerToggleShowPhone($1d9fcaa0a6035698$var$controlToggleShowPhone);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerReceiptFooter($1d9fcaa0a6035698$var$controlSetReceiptFooter, $1d9fcaa0a6035698$var$controlSetReceiptQrUrl, (0, $9db03be56d1ffd3b$export$5a9e70c95c4f2bbb));
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerTips({
        onToggle: $1d9fcaa0a6035698$var$controlToggleTips,
        onPresets: $1d9fcaa0a6035698$var$controlSetTipPresets,
        onQrUpload: $1d9fcaa0a6035698$var$controlUploadTipQR,
        onQrRemove: $1d9fcaa0a6035698$var$controlRemoveTipQR
    });
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerToggleTicketNumber($1d9fcaa0a6035698$var$controlToggleShowTicketNumber);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerPrintKind($1d9fcaa0a6035698$var$controlStagePrintKind);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerPrintPosition($1d9fcaa0a6035698$var$controlStagePrintPosition);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerBtPair($1d9fcaa0a6035698$var$controlPairBtPrinter);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerBtDisconnect($1d9fcaa0a6035698$var$controlDisconnectBtPrinter);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerBtTest($1d9fcaa0a6035698$var$controlTestPrint);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerBtPaperWidth($1d9fcaa0a6035698$var$controlStagePaperWidth);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerSaveSettingsDraft($1d9fcaa0a6035698$var$controlSaveSettingsDraft);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerDiscardSettingsDraft($1d9fcaa0a6035698$var$controlDiscardSettingsDraft);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerDiscardSettingsDraftOnClose($1d9fcaa0a6035698$var$controlDiscardSettingsDraft);
    //NewOrder
    (0, $472fec5536166250$export$2e2bcd8739ae039)._addHandlerShowMenuModal($1d9fcaa0a6035698$var$controlNewOrder);
    (0, $472fec5536166250$export$2e2bcd8739ae039)._addHandlerEmptyAddItems($1d9fcaa0a6035698$var$controlMenuList);
    (0, $472fec5536166250$export$2e2bcd8739ae039)._addHandlerCategoryTabs();
    (0, $472fec5536166250$export$2e2bcd8739ae039)._addHandlerStockChip();
    (0, $472fec5536166250$export$2e2bcd8739ae039)._addHandlerToggleVisualMode();
    (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._addHandlerShowItemModal($1d9fcaa0a6035698$var$controlDisplayMenuItem);
    $1d9fcaa0a6035698$var$controlNewOrderModals();
    (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._pushToCart($1d9fcaa0a6035698$var$controlPushToModelCart);
    (0, $a8fc36c39779922a$export$2e2bcd8739ae039)._adjustQuantity();
    (0, $472fec5536166250$export$2e2bcd8739ae039)._addHandlerDeleteCartItem($1d9fcaa0a6035698$var$controlDeleteCartItemInOrder);
    // Cashflow
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerOpen($1d9fcaa0a6035698$var$controlOpenCashflow);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerClose($1d9fcaa0a6035698$var$controlCloseCashflow);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerPeriodChange($1d9fcaa0a6035698$var$controlChangePeriod);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerStep((delta)=>{
        const p = $1d9fcaa0a6035698$var$_currentCashflowPeriod;
        if (p.period === 'custom') return;
        $1d9fcaa0a6035698$var$controlChangePeriod({
            period: p.period,
            offset: delta === 0 ? 0 : Math.min(0, (p.offset ?? 0) + delta)
        });
    });
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerCustomRange($1d9fcaa0a6035698$var$controlChangePeriod);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerOpenAddExpense();
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerSubmitExpense($1d9fcaa0a6035698$var$controlAddExpense);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerDeleteExpense($1d9fcaa0a6035698$var$controlDeleteExpense);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerOpenSaleReceipt($1d9fcaa0a6035698$var$controlOpenSaleReceipt);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerExport($1d9fcaa0a6035698$var$controlExportCSV);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerVoid($1d9fcaa0a6035698$var$controlVoidTransaction);
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerTabChange();
    (0, $1d1221278b545f23$export$2e2bcd8739ae039)._addHandlerOverrideModal();
    //New Order Check Out
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerShowCheckout($1d9fcaa0a6035698$var$controlOrderCheckout);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerDeleteCartItem($1d9fcaa0a6035698$var$controlDeleteCartItemInCheckout);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerBack($1d9fcaa0a6035698$var$controlGoBackToOrder);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._subtractChange();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._wireOrderType();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._wireExtras();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerPaymentMethod($1d9fcaa0a6035698$var$controlSetPaymentMethod);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerTip({
        onSelect: $1d9fcaa0a6035698$var$controlSelectTip,
        onAsk: $1d9fcaa0a6035698$var$controlAskCustomerTip,
        onCancelAsk: $1d9fcaa0a6035698$var$controlCancelTipAsk
    });
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerPrintReceipt($1d9fcaa0a6035698$var$controlConcludeTransaction);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerReceiptEdit($1d9fcaa0a6035698$var$controlReceiptEdit);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerReceiptRemove($1d9fcaa0a6035698$var$controlRemoveReceiptAdj);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerReceiptAddManual($1d9fcaa0a6035698$var$controlShowReceiptAddManualForm);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerReceiptSaveOverride($1d9fcaa0a6035698$var$controlSaveReceiptOverride);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerReceiptSaveManual($1d9fcaa0a6035698$var$controlSaveManualReceiptAdj);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerApplyPromo($1d9fcaa0a6035698$var$controlApplyPromoCode);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerRemovePromo($1d9fcaa0a6035698$var$controlRemovePromoCode);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerLoyaltyLookup($1d9fcaa0a6035698$var$controlLoyaltyLookup);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerLoyaltyEnroll($1d9fcaa0a6035698$var$controlLoyaltyEnroll);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerLoyaltyEnrollCancel($1d9fcaa0a6035698$var$controlLoyaltyEnrollCancel);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._wireLoyaltyStepper();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._wireLoyaltyInputs();
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerLoyaltyRedeem($1d9fcaa0a6035698$var$controlLoyaltyApplyRedemption);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerLoyaltyRemoveRedeem($1d9fcaa0a6035698$var$controlLoyaltyRemoveRedemption);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerLoyaltyUnlink($1d9fcaa0a6035698$var$controlLoyaltyUnlink);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerLoyaltyRewardRedeem($1d9fcaa0a6035698$var$controlApplyLoyaltyRewardRedemption);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerLoyaltyRewardRemove($1d9fcaa0a6035698$var$controlRemoveLoyaltyRewardRedemption);
    (0, $6724f76d0010cf48$export$2e2bcd8739ae039)._addHandlerLoyaltyRedeemOpen($1d9fcaa0a6035698$var$controlOpenLoyaltyRedeemModal);
    // Order Queue (KDS)
    (0, $f3651885b15417e3$export$2e2bcd8739ae039)._addHandlerViewAll();
    (0, $f3651885b15417e3$export$2e2bcd8739ae039)._addHandlerActions($1d9fcaa0a6035698$var$controlMarkOrderDone, $1d9fcaa0a6035698$var$controlMarkOrderReady, $1d9fcaa0a6035698$var$controlUnmarkOrderReady);
    (0, $f3651885b15417e3$export$2e2bcd8739ae039)._addHandlerOpenModal(()=>$1d9fcaa0a6035698$var$modelState.orderQueue);
    (0, $f3651885b15417e3$export$2e2bcd8739ae039)._addHandlerModalClose();
    (0, $f3651885b15417e3$export$2e2bcd8739ae039)._addHandlerModalActions($1d9fcaa0a6035698$var$controlMarkOrderDone, $1d9fcaa0a6035698$var$controlMarkOrderReady, $1d9fcaa0a6035698$var$controlUnmarkOrderReady);
    (0, $f3651885b15417e3$export$2e2bcd8739ae039)._addHandlerChooserDismiss();
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerKDSThresholds($1d9fcaa0a6035698$var$controlSaveKDSThresholds);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerDisplaySizes($1d9fcaa0a6035698$var$controlSaveKDSWindowSize, $1d9fcaa0a6035698$var$controlSaveCFDWindowSize);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerCFDAdUpload($1d9fcaa0a6035698$var$controlUploadCFDAd);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerCFDAdRemove($1d9fcaa0a6035698$var$controlRemoveCFDAd);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerPickupAdUpload($1d9fcaa0a6035698$var$controlUploadPickupAd);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerPickupAdRemove($1d9fcaa0a6035698$var$controlRemovePickupAd);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerCFDQRUpload($1d9fcaa0a6035698$var$controlUploadCFDQR);
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerCFDQRRemove($1d9fcaa0a6035698$var$controlRemoveCFDQR);
    // Support
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._addHandlerOpen($1d9fcaa0a6035698$var$controlOpenSupport);
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._addHandlerClose();
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._addHandlerNewTicket(()=>(0, $5d00d49bfb2356db$export$2e2bcd8739ae039).showNewTicketPanel());
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._addHandlerCloseNewTicket(()=>{
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).closeNewTicketModal();
        (0, $5d00d49bfb2356db$export$2e2bcd8739ae039).resetTicketForm();
    });
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._addHandlerBackToList(()=>(0, $5d00d49bfb2356db$export$2e2bcd8739ae039).showListPanel());
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._addHandlerTicketClick($1d9fcaa0a6035698$var$controlOpenTicket);
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._addHandlerMarkSolved($1d9fcaa0a6035698$var$controlMarkTicketSolved);
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._addHandlerSubmitTicket($1d9fcaa0a6035698$var$controlSubmitTicket);
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._addHandlerSendReply($1d9fcaa0a6035698$var$controlSendReply);
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._addHandlerRating($1d9fcaa0a6035698$var$controlSubmitRating);
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._addHandlerRatingComment($1d9fcaa0a6035698$var$controlSubmitRatingComment);
    (0, $5d00d49bfb2356db$export$2e2bcd8739ae039)._addHandlerTicketFiles();
    // Top-bar dropdowns (Screens, Terminal, bell, profile) are mutually
    // exclusive: each registers its closer here and closes the others when it
    // opens. (Each toggle stops propagation, so the others' outside-click
    // listeners never fired and several menus could be open at once.)
    const navMenuClosers = new Set();
    const closeOtherNavMenus = (keep)=>navMenuClosers.forEach((fn)=>{
            if (fn !== keep) fn();
        });
    // Queue/Customer/Pickup screen launchers - collapsed into a single
    // "Screens" dropdown (2026-08-26, Kelly's ask - matches the Terminal
    // picker's toggle+dropdown pattern instead of three separate buttons).
    const displayDropdown = document.getElementById('displayDropdown');
    const displayDropdownBtn = document.getElementById('displayDropdownToggle');
    const displayDropdownMenu = document.getElementById('displayDropdownMenu');
    const kdsWindowBtn = document.getElementById('kdsWindowBtn');
    const cfdWindowBtn = document.getElementById('cfdWindowBtn');
    const pickupWindowBtn = document.getElementById('pickupWindowBtn');
    if (displayDropdown && displayDropdownBtn && displayDropdownMenu) {
        displayDropdown.classList.remove('hidden');
        const closeDisplayMenu = ()=>{
            displayDropdownMenu.classList.add('hidden');
            displayDropdownBtn.classList.remove('nav-terminal-btn--open');
            displayDropdownBtn.setAttribute('aria-expanded', 'false');
        };
        navMenuClosers.add(closeDisplayMenu);
        displayDropdownBtn.addEventListener('click', (e)=>{
            e.stopPropagation();
            const opening = displayDropdownMenu.classList.contains('hidden');
            if (opening) closeOtherNavMenus(closeDisplayMenu);
            displayDropdownMenu.classList.toggle('hidden');
            displayDropdownBtn.classList.toggle('nav-terminal-btn--open', opening);
            displayDropdownBtn.setAttribute('aria-expanded', String(opening));
            if (opening) setTimeout(()=>document.addEventListener('click', closeDisplayMenu, {
                    once: true
                }), 0);
        });
        kdsWindowBtn?.addEventListener('click', ()=>{
            closeDisplayMenu();
            $1d9fcaa0a6035698$var$controlOpenKDSWindow();
        });
        cfdWindowBtn?.addEventListener('click', ()=>{
            closeDisplayMenu();
            $1d9fcaa0a6035698$var$controlOpenCFDWindow();
        });
        pickupWindowBtn?.addEventListener('click', ()=>{
            closeDisplayMenu();
            $1d9fcaa0a6035698$var$controlOpenPickupWindow();
        });
    }
    // Terminal number: identifies this POS device and pairs it to its customer
    // display (the CFD only renders cart updates carrying its matching number).
    const terminalControl = document.getElementById('terminalControl');
    const terminalToggle = document.getElementById('terminalToggle');
    const terminalDropdown = document.getElementById('terminalDropdown');
    const terminalGrid = document.getElementById('terminalGrid');
    const terminalValueEl = document.getElementById('terminalValueLabel');
    if (terminalControl && terminalToggle && terminalDropdown && terminalGrid && terminalValueEl) {
        terminalControl.classList.remove('hidden');
        $1d9fcaa0a6035698$var$_populateTerminalOptions(terminalGrid, terminalValueEl); // async; sizes the grid to the team
        const closeTerminalMenu = ()=>{
            terminalDropdown.classList.add('hidden');
            terminalToggle.classList.remove('nav-terminal-btn--open');
            terminalToggle.setAttribute('aria-expanded', 'false');
        };
        navMenuClosers.add(closeTerminalMenu);
        terminalToggle.addEventListener('click', (e)=>{
            e.stopPropagation();
            const opening = terminalDropdown.classList.contains('hidden');
            if (opening) closeOtherNavMenus(closeTerminalMenu);
            terminalDropdown.classList.toggle('hidden');
            terminalToggle.classList.toggle('nav-terminal-btn--open', opening);
            terminalToggle.setAttribute('aria-expanded', String(opening));
            if (opening) setTimeout(()=>document.addEventListener('click', closeTerminalMenu, {
                    once: true
                }), 0);
        });
        terminalGrid.addEventListener('click', (e)=>{
            const chip = e.target.closest('.nav-terminal-chip');
            if (!chip) return;
            e.stopPropagation();
            const value = chip.dataset.value;
            localStorage.setItem('pointbunny_terminal_number', value);
            terminalValueEl.textContent = value;
            terminalGrid.querySelectorAll('.nav-terminal-chip').forEach((c)=>c.classList.toggle('nav-terminal-chip--active', c.dataset.value === value));
            closeTerminalMenu();
            $1d9fcaa0a6035698$var$_broadcastCart(); // re-sync the now-matching customer display with the live cart
        });
    }
    // Navbar notification bell: draft POs / pending shift corrections / pending
    // leave requests. Reuses the Terminal/Screens dropdown chrome (same open/
    // close/outside-click pattern). Stays hidden until _refreshNotifications()
    // reveals it for an account that can see at least one category.
    const notifControl = document.getElementById('notifControl');
    const notifToggle = document.getElementById('notifToggle');
    const notifDropdown = document.getElementById('notifDropdown');
    if (notifControl && notifToggle && notifDropdown) {
        const closeNotifMenu = ()=>{
            notifDropdown.classList.add('hidden');
            notifToggle.classList.remove('nav-terminal-btn--open');
            notifToggle.setAttribute('aria-expanded', 'false');
        };
        $1d9fcaa0a6035698$var$_closeNotifMenu = closeNotifMenu;
        navMenuClosers.add(closeNotifMenu);
        notifToggle.addEventListener('click', (e)=>{
            e.stopPropagation();
            const opening = notifDropdown.classList.contains('hidden');
            if (opening) closeOtherNavMenus(closeNotifMenu);
            notifDropdown.classList.toggle('hidden');
            notifToggle.classList.toggle('nav-terminal-btn--open', opening);
            notifToggle.setAttribute('aria-expanded', String(opening));
            if (opening) {
                $1d9fcaa0a6035698$var$_requestNotifRefresh();
                $1d9fcaa0a6035698$var$_markLeaveRemindersSeen();
                setTimeout(()=>document.addEventListener('click', closeNotifMenu, {
                        once: true
                    }), 0);
            }
        });
    }
    // Profile menu (top bar redesign, 2026-10-03): Settings / Tutorials / theme
    // / Log out live in a dropdown under the signed-in user. Same open/close/
    // outside-click pattern as the dropdowns above. Theme clicks keep it open
    // (so you see the switch take effect); Settings, Tutorials and Log out
    // close it. On phones the menu is display:contents inside the hamburger
    // drawer, so none of this toggling is visible there.
    const profile = document.getElementById('navProfile');
    const profileBtn = document.getElementById('navProfileBtn');
    if (profile && profileBtn) {
        const closeProfileMenu = ()=>{
            profile.classList.remove('nav-profile--open');
            profileBtn.setAttribute('aria-expanded', 'false');
            document.removeEventListener('click', onOutside);
        };
        const onOutside = (e)=>{
            if (!profile.contains(e.target)) closeProfileMenu();
        };
        navMenuClosers.add(closeProfileMenu);
        profileBtn.addEventListener('click', (e)=>{
            e.stopPropagation();
            const opening = !profile.classList.contains('nav-profile--open');
            if (!opening) return closeProfileMenu();
            closeOtherNavMenus(closeProfileMenu);
            profile.classList.add('nav-profile--open');
            profileBtn.setAttribute('aria-expanded', 'true');
            setTimeout(()=>document.addEventListener('click', onOutside), 0);
        });
        document.getElementById('navProfileMenu')?.addEventListener('click', (e)=>{
            if (e.target.closest('#settingsBtn, #tourHubBtn, #navLogoutBtn')) closeProfileMenu();
        });
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape' && profile.classList.contains('nav-profile--open')) closeProfileMenu();
        });
    }
    (0, $9e6597a253ab6810$export$2e2bcd8739ae039)._addHandlerCategoryClick($1d9fcaa0a6035698$var$controlNotifOpenCategory);
    (0, $9e6597a253ab6810$export$2e2bcd8739ae039)._addHandlerItemClick($1d9fcaa0a6035698$var$controlNotifOpenItem);
    // Free vs. paid plan gate - one shared handler for every "Upgrade" CTA
    (0, $ad2a264c69d845ec$export$f537ff4f9eaa5ce8)($1d9fcaa0a6035698$var$controlUpgradeClick);
    // Receipt Adjustments Panel
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerOpen($1d9fcaa0a6035698$var$controlOpenDiscounts);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerClose($1d9fcaa0a6035698$var$controlCloseDiscounts);
    // Loyalty panel
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerOpen($1d9fcaa0a6035698$var$controlOpenLoyalty);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerClose($1d9fcaa0a6035698$var$controlCloseLoyalty);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerSettingsAccordion();
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerSettingsChange();
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerSettingsSave($1d9fcaa0a6035698$var$controlSaveLoyaltySettings);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerSettingsDiscard($1d9fcaa0a6035698$var$controlDiscardLoyaltySettings);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerDiscountRewardEdit();
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerDiscountRewardCancel();
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerDiscountRewardSave($1d9fcaa0a6035698$var$controlSaveLoyaltySettings);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerSearch($1d9fcaa0a6035698$var$controlLoyaltySearch);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerCustomerClick($1d9fcaa0a6035698$var$controlOpenLoyaltyCustomer);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerAddCustomer($1d9fcaa0a6035698$var$controlLoyaltyShowAddForm);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerAddCustomerSave($1d9fcaa0a6035698$var$controlLoyaltyAddCustomer);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerEditCustomer($1d9fcaa0a6035698$var$controlLoyaltyEditCustomer);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerRewardSearch($1d9fcaa0a6035698$var$controlLoyaltyRewardSearch);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerRewardPick($1d9fcaa0a6035698$var$controlLoyaltyRewardPick);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerRewardCancelPick($1d9fcaa0a6035698$var$controlLoyaltyRewardCancelPick);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerRewardAdd($1d9fcaa0a6035698$var$controlAddLoyaltyReward);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerRewardToggle($1d9fcaa0a6035698$var$controlToggleLoyaltyReward);
    (0, $cc836a0573c6004c$export$2e2bcd8739ae039)._addHandlerRewardDelete($1d9fcaa0a6035698$var$controlDeleteLoyaltyReward);
    // Promos panel
    (0, $066a3d689044816f$export$2e2bcd8739ae039)._addHandlerOpen($1d9fcaa0a6035698$var$controlOpenPromos);
    (0, $066a3d689044816f$export$2e2bcd8739ae039)._addHandlerClose($1d9fcaa0a6035698$var$controlClosePromos);
    (0, $066a3d689044816f$export$2e2bcd8739ae039)._addHandlerNewCode($1d9fcaa0a6035698$var$controlNewDiscountCode);
    (0, $066a3d689044816f$export$2e2bcd8739ae039)._addHandlerSave($1d9fcaa0a6035698$var$controlSaveDiscountCode);
    (0, $066a3d689044816f$export$2e2bcd8739ae039)._addHandlerEdit($1d9fcaa0a6035698$var$controlEditDiscountCode);
    (0, $066a3d689044816f$export$2e2bcd8739ae039)._addHandlerDelete($1d9fcaa0a6035698$var$controlDeleteDiscountCode);
    (0, $066a3d689044816f$export$2e2bcd8739ae039)._addHandlerToggleStatus($1d9fcaa0a6035698$var$controlToggleDiscountStatus);
    // Tax Settings + Tax-Exempt Products
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerSelectTaxMode($1d9fcaa0a6035698$var$controlSetTaxMode);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerSetTaxRate($1d9fcaa0a6035698$var$controlSetTaxRate);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerSetTaxLabel($1d9fcaa0a6035698$var$controlSetTaxLabel);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerSetExemptLabel($1d9fcaa0a6035698$var$controlSetTaxExemptLabel);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerSaveTaxSettings($1d9fcaa0a6035698$var$controlSaveTaxSettingsDraft);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerDiscardTaxSettings($1d9fcaa0a6035698$var$controlDiscardTaxSettingsDraft);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerUseRecommendedRate($1d9fcaa0a6035698$var$controlSetTaxRate);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerOpenExemptModal();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerCloseExemptModal();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerExemptMethodToggle();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerExemptSearch();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerExemptSearchPick();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerExemptAutoSelect();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerExemptCategorySelect();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerExemptRemove();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerExemptClear();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerExemptSave($1d9fcaa0a6035698$var$controlSaveExemptProducts);
    // Automatic Receipt Adjustments
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerAdjAdd();
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerAdjSave($1d9fcaa0a6035698$var$controlSaveAdjustment);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerAdjEdit($1d9fcaa0a6035698$var$controlEditAdjFromPanel);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerAdjDelete($1d9fcaa0a6035698$var$controlDeleteAdjustment);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerAdjToggle($1d9fcaa0a6035698$var$controlToggleAdjustment);
    (0, $c3680931ad48d154$export$2e2bcd8739ae039)._addHandlerAdjMoreToggle();
    // Dashboard stat cards double as Reports shortcuts. The number stays visible to
    // everyone; clicking through to Reports shows a "no access" message for anyone
    // without view_reports (controlOpenReports also enforces this as a backstop).
    const _openReportsIfAllowed = (section)=>{
        if ($1e7ab04ca7920cff$export$b325ec6732b039cf('view_reports')) $1d9fcaa0a6035698$var$controlOpenReports(section);
        else $1d9fcaa0a6035698$var$showToast("You don't have access to reports.", 'error');
    };
    // Active Queue empty state "Today so far" tiles → Reports (Kitchen / Traffic)
    (0, $f3651885b15417e3$export$2e2bcd8739ae039)._addHandlerTodayStats(_openReportsIfAllowed);
    // Today's Sales stat card → open Reports on Sales section
    const salesStatCard = document.querySelector(".home-sales-stat");
    if (salesStatCard) {
        salesStatCard.addEventListener("click", ()=>_openReportsIfAllowed("sales"));
        salesStatCard.addEventListener("keydown", (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                _openReportsIfAllowed("sales");
            }
        });
    }
    // Transactions stat card → open Reports on Traffic section
    const transactionsCard = document.querySelector("#transactionsCard");
    if (transactionsCard) {
        transactionsCard.addEventListener("click", ()=>_openReportsIfAllowed("traffic"));
        transactionsCard.addEventListener("keydown", (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                _openReportsIfAllowed("traffic");
            }
        });
    }
    // Avg. Serving stat → open Reports on Kitchen section
    const servingStatEl = document.querySelector(".home-dash-stat--serving");
    if (servingStatEl) {
        servingStatEl.addEventListener("click", ()=>_openReportsIfAllowed("kitchen"));
        servingStatEl.addEventListener("keydown", (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                _openReportsIfAllowed("kitchen");
            }
        });
    }
    // Reports
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerOpen($1d9fcaa0a6035698$var$controlOpenReports);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerClose($1d9fcaa0a6035698$var$controlCloseReports);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerPeriodChange($1d9fcaa0a6035698$var$controlReportsPeriodChange);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerStep((delta)=>{
        const p = $1d9fcaa0a6035698$var$_currentReportsPeriod;
        if (p.period === 'custom') return;
        $1d9fcaa0a6035698$var$controlReportsPeriodChange({
            period: p.period,
            offset: delta === 0 ? 0 : Math.min(0, (p.offset ?? 0) + delta)
        });
    });
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerCustomRange($1d9fcaa0a6035698$var$controlReportsPeriodChange);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerExport($1d9fcaa0a6035698$var$controlExportReports, $1d9fcaa0a6035698$var$controlExportReportsPDF);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerCompareToggle($1d9fcaa0a6035698$var$controlToggleCompare);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerRunComparison($1d9fcaa0a6035698$var$controlRunComparison);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerCmpTopItemsSort($1d9fcaa0a6035698$var$controlCmpSortTopItems);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerTopItemsSort($1d9fcaa0a6035698$var$controlSortTopItems);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerStaffSort($1d9fcaa0a6035698$var$controlSortStaff);
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerInfoTooltips();
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerServingMetricToggle();
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerChannelSort();
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerSections((section)=>$1e7ab04ca7920cff$export$57b484963858c9a0('reports') && (section !== 'overview' || $1d9fcaa0a6035698$var$_currentReportsPeriod.period !== 'today' || ($1d9fcaa0a6035698$var$_currentReportsPeriod.offset ?? 0) !== 0));
    (0, $d94c521226fbc9fa$export$2e2bcd8739ae039)._addHandlerKpiToggle($1d9fcaa0a6035698$var$controlToggleMetric);
    // Cashier switcher
    document.getElementById('cashierCard')?.addEventListener('click', $1d9fcaa0a6035698$var$controlSwitchCashier);
    // Staff
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039)._addHandlerOpen($1d9fcaa0a6035698$var$controlOpenStaff);
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039)._addHandlerClose($1d9fcaa0a6035698$var$controlCloseStaff);
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039)._addHandlerInvite($1d9fcaa0a6035698$var$controlShowInviteForm);
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039)._addHandlerSaveInvite($1d9fcaa0a6035698$var$controlInviteStaff);
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039)._addHandlerRemove($1d9fcaa0a6035698$var$controlRemoveStaff);
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039)._addHandlerRemoveMFA($1d9fcaa0a6035698$var$controlRemoveStaffMFA);
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039)._addHandlerEditRole($1d9fcaa0a6035698$var$controlEditStaffRole);
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039)._addHandlerRoleAction($1d9fcaa0a6035698$var$controlRoleAction);
    (0, $ad4542f6315399f1$export$2e2bcd8739ae039)._addHandlerSetPin($1d9fcaa0a6035698$var$controlSetStaffPin);
    // Timesheets (own top-level panel)
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039)._addHandlerOpen($1d9fcaa0a6035698$var$controlOpenTimesheets);
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039)._addHandlerClose($1d9fcaa0a6035698$var$controlCloseTimesheets);
    (0, $27809bb01dc8a27e$export$2e2bcd8739ae039).bind({
        onOpen: $1d9fcaa0a6035698$var$controlOpenSchedule,
        onClose: ()=>(0, $27809bb01dc8a27e$export$2e2bcd8739ae039).close(),
        onWeek: $1d9fcaa0a6035698$var$controlScheduleWeek,
        onSaveShift: $1d9fcaa0a6035698$var$controlSaveScheduledShift,
        onDeleteShift: $1d9fcaa0a6035698$var$controlDeleteScheduledShift,
        onCopyLastWeek: $1d9fcaa0a6035698$var$controlCopyLastWeek,
        onPublish: $1d9fcaa0a6035698$var$controlPublishSchedule,
        onAddStation: $1d9fcaa0a6035698$var$controlAddStation,
        onUpdateStation: $1d9fcaa0a6035698$var$controlUpdateStation,
        onArchiveStation: $1d9fcaa0a6035698$var$controlArchiveStation,
        onSection: $1d9fcaa0a6035698$var$controlScheduleSection,
        onReviewRequest: $1d9fcaa0a6035698$var$controlReviewShiftRequest,
        onSaveAvailability: $1d9fcaa0a6035698$var$controlSaveAvailability
    });
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039)._addHandlerTimesheetPeriod($1d9fcaa0a6035698$var$_practiceGuard('timesheets', $1d9fcaa0a6035698$var$controlFetchTimesheets, ()=>$1d9fcaa0a6035698$var$showToast('The practice team only has one week of shifts.', 'info')));
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039)._addHandlerGenerateTimeclockToken($1d9fcaa0a6035698$var$_practiceGuard('timesheets', $1d9fcaa0a6035698$var$controlGenerateTimeclockToken));
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039)._addHandlerReviewRequest($1d9fcaa0a6035698$var$_practiceGuard('timesheets', $1d9fcaa0a6035698$var$controlReviewRequest, $1d9fcaa0a6035698$var$_practiceReviewRequest));
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039)._addHandlerReviewLeave($1d9fcaa0a6035698$var$_practiceGuard('timesheets', $1d9fcaa0a6035698$var$controlReviewLeave, $1d9fcaa0a6035698$var$_practiceReviewLeave));
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039)._addHandlerDeleteShifts($1d9fcaa0a6035698$var$_practiceGuard('timesheets', $1d9fcaa0a6035698$var$controlDeleteShifts));
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039)._addHandlerTipPoolRoles($1d9fcaa0a6035698$var$_practiceGuard('timesheets', $1d9fcaa0a6035698$var$controlSetTipPoolRoles));
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039)._addHandlerRestoreShift($1d9fcaa0a6035698$var$_practiceGuard('timesheets', $1d9fcaa0a6035698$var$controlRestoreShift));
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039)._addHandlerRevokeDevice($1d9fcaa0a6035698$var$_practiceGuard('timesheets', $1d9fcaa0a6035698$var$controlRevokeDevice));
    (0, $a1ae7cc9759c5490$export$2e2bcd8739ae039)._addHandlerSaveShift($1d9fcaa0a6035698$var$_practiceGuard('timesheets', $1d9fcaa0a6035698$var$controlSaveShift, $1d9fcaa0a6035698$var$_practiceSaveShift));
    // Inventory (own top-level panel)
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerOpen($1d9fcaa0a6035698$var$controlOpenInventory);
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerClose($1d9fcaa0a6035698$var$controlCloseInventory);
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerAdjust($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlAdjustStock));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerNewItem($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlCreateInventoryItem));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerEditItem($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlUpdateInventoryItem));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerDeleteItem($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlDeleteInventoryItem));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerHistoryFilter($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlInventoryHistoryFilter));
    // Blocked during practice: re-render so the switch + card snap back.
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerToggleEnabled($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlToggleInventoryEnabled, ()=>{
        $1d9fcaa0a6035698$var$_practiceBlocked();
        (0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot());
    }));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerAddItemSupplier($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlAddItemSupplier));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerPreferSupplier($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlSetPreferredSupplier));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerSupplierCost($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlUpdateSupplierCost));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerRemoveItemSupplier($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlRemoveItemSupplier));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerAddLink($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlAddProductLink));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerUpdateLink($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlUpdateProductLink));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerRemoveLink($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlRemoveProductLink));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerEditProduct($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlEditLinkedProduct));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerSaveSupplier($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlSaveSupplier));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerDeleteSupplier($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlDeleteSupplier));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerCreatePo($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlCreatePurchaseOrder, $1d9fcaa0a6035698$var$_practiceCreatePo));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerUpdatePo($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlUpdatePurchaseOrder));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerPoStatus($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlSetPoStatus, $1d9fcaa0a6035698$var$_practiceSetPoStatus));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerReceivePo($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlReceivePurchaseOrder, $1d9fcaa0a6035698$var$_practiceReceivePo));
    (0, $b0886db79b2df847$export$2e2bcd8739ae039)._addHandlerApplyCount($1d9fcaa0a6035698$var$_practiceGuard('inventory', $1d9fcaa0a6035698$var$controlApplyStockCount));
    // Home sidebar Time Clock shortcut → Time Clock hub (or the kiosk for staff)
    document.getElementById('homeSideNavTimeclock')?.addEventListener('click', $1d9fcaa0a6035698$var$controlOpenTimeclockHub);
    // Getting Started card: one-time dismiss (business-level)
    $1d9fcaa0a6035698$var$_wireGettingStarted();
};
// Wait for supabase-js to establish the session from an OAuth redirect URL (implicit
// token in the hash, or a PKCE ?code=) before we read or strip it. supabase processes
// the URL asynchronously, so reading getSession() too early returns null and bounces
// the user back to the login screen. Resolves on the SIGNED_IN event, or as soon as a
// session exists, or after a short fallback so it can never hang.
const $1d9fcaa0a6035698$var$_awaitOAuthSession = ()=>new Promise((resolve)=>{
        let settled = false;
        let sub = null;
        const finish = ()=>{
            if (settled) return;
            settled = true;
            try {
                sub?.subscription?.unsubscribe();
            } catch  {}
            resolve();
        };
        ({ data: sub } = (0, $asfCf.supabase).auth.onAuthStateChange((event)=>{
            if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') finish();
        }));
        (0, $asfCf.supabase).auth.getSession().then(({ data: data })=>{
            if (data?.session) finish();
        });
        setTimeout(finish, 4000);
    });
const $1d9fcaa0a6035698$var$initAuth = async function() {
    // Capture ?source=<slug> off a tracking link before anything below strips the query
    // string. Best-effort/localStorage-only (see sourceTracking.js) - never throws.
    const urlSource = $924b6f34e17f8cba$export$12d7f2ec382a9c4f();
    if (urlSource) history.replaceState(null, '', window.location.pathname + window.location.hash);
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039)._addHandlerSignIn($1d9fcaa0a6035698$var$controlSignIn);
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039)._addHandlerSignUp($1d9fcaa0a6035698$var$controlSignUp);
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039)._addHandlerFormStarted($1d9fcaa0a6035698$var$controlSourceFormStarted);
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039)._addHandlerForgotPassword($1d9fcaa0a6035698$var$controlForgotPassword);
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039)._addHandlerAcceptInvite($1d9fcaa0a6035698$var$controlAcceptInvite);
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039)._addHandlerAcceptJoin($1d9fcaa0a6035698$var$controlAcceptPendingInvite);
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039)._addHandlerDeclineJoin($1d9fcaa0a6035698$var$controlDeclinePendingInvite);
    (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039)._addHandlerGoogleSignIn($1d9fcaa0a6035698$var$controlGoogleSignIn);
    (0, $e03adf9eaa390216$export$2e2bcd8739ae039)._addHandlerSubmit($1d9fcaa0a6035698$var$controlOnboardingSubmit);
    (0, $e03adf9eaa390216$export$2e2bcd8739ae039)._addHandlerDone($1d9fcaa0a6035698$var$controlOnboardingDone);
    (0, $f850a85e1d95a80e$export$2e2bcd8739ae039)._addHandlerCustomize($1d9fcaa0a6035698$var$controlSaveHomeHidden);
    (0, $472fec5536166250$export$2e2bcd8739ae039)._addHandlerSaveToTab(()=>$1d9fcaa0a6035698$var$controlSendTabOrder(false));
    (0, $ab39ca298e181461$export$2e2bcd8739ae039).bind({
        onOpen: $1d9fcaa0a6035698$var$controlOpenTables,
        onClose: $1d9fcaa0a6035698$var$controlCloseTables,
        onSeat: $1d9fcaa0a6035698$var$controlSeatTable,
        onSeatReservation: $1d9fcaa0a6035698$var$controlSeatReservation,
        onSeatWaitlist: $1d9fcaa0a6035698$var$controlSeatWaitlist,
        onClean: $1d9fcaa0a6035698$var$controlCleanTable,
        onAddItems: $1d9fcaa0a6035698$var$controlTabAddItems,
        onSend: $1d9fcaa0a6035698$var$controlTabSend,
        onRemoveLine: $1d9fcaa0a6035698$var$controlTabRemoveLine,
        onGuests: (tabId, guests)=>$1d9fcaa0a6035698$var$controlTabUpdate(tabId, {
                guests: guests
            }),
        onBill: (tabId, on)=>$1d9fcaa0a6035698$var$controlTabUpdate(tabId, {
                billRequested: on
            }),
        onPay: $1d9fcaa0a6035698$var$controlTabPay,
        onMove: $1d9fcaa0a6035698$var$controlTabMove,
        onMerge: $1d9fcaa0a6035698$var$controlTabMerge,
        onCloseTab: $1d9fcaa0a6035698$var$controlTabClose,
        onDay: $1d9fcaa0a6035698$var$controlReservationDay,
        onSaveReservation: $1d9fcaa0a6035698$var$controlSaveReservation,
        onReservationStatus: $1d9fcaa0a6035698$var$controlReservationStatus,
        onAddWaitlist: $1d9fcaa0a6035698$var$controlAddWaitlist,
        onWaitlistStatus: $1d9fcaa0a6035698$var$controlWaitlistStatus,
        onSaveLayout: $1d9fcaa0a6035698$var$controlSaveTableLayout,
        onToast: (msg)=>$1d9fcaa0a6035698$var$showToast(msg, 'info')
    });
    (0, $6e66866c6dedb838$export$2e2bcd8739ae039)._addHandlerHomeTab({
        onShown: $1d9fcaa0a6035698$var$controlHomeShown,
        onSet: $1d9fcaa0a6035698$var$controlHomeSet,
        onPlace: $1d9fcaa0a6035698$var$controlHomePlace,
        onSuggested: $1d9fcaa0a6035698$var$controlHomeSuggested,
        onCardSlot: $1d9fcaa0a6035698$var$controlHomeCardSlot,
        onCardsSuggested: $1d9fcaa0a6035698$var$controlHomeCardsSuggested
    });
    (0, $717baed02964aa54$export$2e2bcd8739ae039).init({
        onSwapCard: $1d9fcaa0a6035698$var$controlSwapHomeCard,
        onSwapTile: $1d9fcaa0a6035698$var$controlSwapHomeTile,
        onTile: $1d9fcaa0a6035698$var$controlHomeTile,
        onAction: $1d9fcaa0a6035698$var$controlHomeCardAction
    });
    (0, $e03adf9eaa390216$export$2e2bcd8739ae039)._addHandlerTaxPrompt($1d9fcaa0a6035698$var$controlAddSuggestedTax, $1d9fcaa0a6035698$var$controlSkipSuggestedTax);
    (0, $e03adf9eaa390216$export$2e2bcd8739ae039)._addHandlerExit(async ()=>{
        await (0, $asfCf.supabase).auth.signOut({
            scope: 'local'
        });
        (0, $e03adf9eaa390216$export$2e2bcd8739ae039).hide();
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).show();
    });
    document.getElementById('logoutBtn').addEventListener('click', $1d9fcaa0a6035698$var$controlSignOut);
    document.getElementById('navLogoutBtn')?.addEventListener('click', $1d9fcaa0a6035698$var$controlSignOut);
    // Auth-aware Back/forward guard: the session is the source of truth, not the URL.
    // Like mainstream apps, navigating back/forward to a stale auth URL resolves by
    // session - signed in stays in the app (and the URL is cleaned), signed out shows
    // the sign-in screen. This is what keeps a "Back" from re-surfacing token hashes.
    window.addEventListener('popstate', async ()=>{
        if (window.location.hash) history.replaceState(null, '', window.location.pathname);
        const { data: { session: s } } = await (0, $asfCf.supabase).auth.getSession();
        if (s) (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).hide();
        else (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).show();
    });
    // Capture any auth params from the URL hash, then immediately clean the URL so
    // session tokens (access_token / refresh_token) never linger in the address bar or
    // browser history. supabase-js has already parsed the hash into a session by the
    // time this runs, so these are just flags now - safe to strip.
    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    const authError = hashParams.get('error');
    const errorDesc = decodeURIComponent((hashParams.get('error_description') || '').replace(/\+/g, ' '));
    const isInvite = window.location.hash.includes('type=invite');
    // (Password-reset links no longer land here - they go to the standalone reset.html
    // page. That removed the recovery race-handling that used to sit at the top of this
    // function.)
    // Returning from a Google/OAuth redirect: wait for supabase to finish reading the
    // session out of the URL BEFORE we strip the URL or call getSession() below, so the
    // sign-in doesn't silently bounce back to the login screen.
    const isOAuthReturn = window.location.hash.includes('access_token') || /[?&]code=/.test(window.location.search);
    if (isOAuthReturn && !authError) await $1d9fcaa0a6035698$var$_awaitOAuthSession();
    if (window.location.hash) history.replaceState(null, '', window.location.pathname);
    if (/[?&]code=/.test(window.location.search)) history.replaceState(null, '', window.location.pathname);
    // OAuth error callback: Supabase redirects back with #error=... on failure
    if (authError) {
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).show();
        const isEmailConflict = /already registered|already exists/i.test(errorDesc);
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showError(isEmailConflict ? 'An account with this email already exists. Please sign in with your email and password.' : errorDesc || 'Sign-in failed. Please try again.');
        return;
    }
    // Invite acceptance: staff clicking their invite email link
    if (isInvite) {
        const { data: { session: session } } = await (0, $asfCf.supabase).auth.getSession();
        if (session) {
            (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).show();
            (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showInviteForm(session.user.user_metadata?.first_name);
            return;
        }
    }
    const { data: { session: session } } = await (0, $asfCf.supabase).auth.getSession();
    if (session) {
        // 2FA gate for restored sessions still at aal1 (a code was never entered).
        // A fully-verified session is already aal2, so this returns immediately.
        const mfaOk = await $1d9fcaa0a6035698$var$_enforceMFA();
        if (!mfaOk) {
            await (0, $asfCf.supabase).auth.signOut({
                scope: 'local'
            });
            (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).show();
            (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showError('Two-factor verification is required to sign in.');
            return;
        }
        $1d9fcaa0a6035698$var$showLoadingScreen();
        try {
            await $1d9fcaa0a6035698$var$initApp(session.user);
        } catch (err) {
            if (err.code === 'PENDING_INVITE_CONSENT') {
                $1d9fcaa0a6035698$var$hideLoadingScreen();
                (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).show();
                (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showJoinTeam($1e7ab04ca7920cff$export$ca000e230c0caa3e.pendingInvites);
                return;
            }
            console.error('initApp failed:', err);
            $1d9fcaa0a6035698$var$hideLoadingScreen();
            await (0, $asfCf.supabase).auth.signOut({
                scope: 'local'
            });
            (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).show();
            (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showError([
                'STAFF_DEACTIVATED',
                'ADMIN_ACCOUNT',
                'SESSION_LIMIT_REACHED'
            ].includes(err.code) ? err.message : 'Something went wrong. Please sign in again.');
            return;
        }
        $1d9fcaa0a6035698$var$hideLoadingScreen();
        $1d9fcaa0a6035698$var$_wireApp();
        $1d9fcaa0a6035698$var$_showLaunchPrompts();
    } else {
        (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).show();
        if (sessionStorage.getItem('pointbunny_deactivated')) {
            sessionStorage.removeItem('pointbunny_deactivated');
            (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showError('Your account has been deactivated. Please contact your business owner.');
        } else if (urlSource) {
            // Arrived via a tracking link (this load's URL, not just a stale stored one) -
            // jump straight to sign-up instead of making them click through from login.
            const stored = $924b6f34e17f8cba$export$fc9166d79258e815();
            const sessionId = $924b6f34e17f8cba$export$d7660cd936a72b71();
            if (stored && !$924b6f34e17f8cba$export$1b4002943059c46('link_opened')) {
                $924b6f34e17f8cba$export$9d8e583f7a5c46b6('link_opened');
                $1e7ab04ca7920cff$export$bfea9f214c7ec36('link_opened', {
                    sourceId: stored.source,
                    sessionId: sessionId
                });
            }
            (0, $2ca0d4bdc02a1fa2$export$2e2bcd8739ae039).showSignUp();
            if (stored && !$924b6f34e17f8cba$export$1b4002943059c46('form_viewed')) {
                $924b6f34e17f8cba$export$9d8e583f7a5c46b6('form_viewed');
                $1e7ab04ca7920cff$export$bfea9f214c7ec36('form_viewed', {
                    sourceId: stored.source,
                    sessionId: sessionId
                });
            }
        }
    }
};
// ── BroadcastChannel incoming messages ────────────────────────────────────────
(0, $boau7.default).onmessage = function({ data: data }) {
    switch(data.type){
        case (0, $boau7.MSG).KDS_REQUEST_SYNC:
            (0, $boau7.default).postMessage({
                type: (0, $boau7.MSG).KDS_QUEUE_SYNC,
                queue: $1d9fcaa0a6035698$var$_queueForBroadcast(),
                thresholds: {
                    yellow: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsYellowThreshold,
                    red: $1e7ab04ca7920cff$export$ca000e230c0caa3e.settings.kdsRedThreshold
                }
            });
            break;
        case (0, $boau7.MSG).KDS_ORDER_DONE:
            {
                // A KDS popup finished this order and already persisted it (wrote prepared_at);
                // just mirror the removal in the home Active Queue - don't re-write the DB or
                // start another undo window here.
                const i = $1d9fcaa0a6035698$var$modelState.orderQueue.findIndex((o)=>o.id === data.id);
                if (i !== -1) {
                    $1d9fcaa0a6035698$var$modelState.orderQueue.splice(i, 1);
                    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
                    if ($1d9fcaa0a6035698$var$modelState.orderQueue.length === 0) $1d9fcaa0a6035698$var$_stopKDSTick();
                }
                break;
            }
        case (0, $boau7.MSG).KDS_ORDER_VOIDED:
            {
                // Another terminal voided a sale (it already wrote voided_at). Drop it from
                // this terminal's queue too - otherwise the next KDS_QUEUE_SYNC this
                // terminal broadcasts (e.g. when a display opens and asks for a sync) puts
                // the voided ticket back on the kitchen and pickup screens (2026-10-15).
                const i = $1d9fcaa0a6035698$var$modelState.orderQueue.findIndex((o)=>o.id === data.id);
                if (i !== -1) {
                    $1d9fcaa0a6035698$var$modelState.orderQueue.splice(i, 1);
                    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
                    if ($1d9fcaa0a6035698$var$modelState.orderQueue.length === 0) $1d9fcaa0a6035698$var$_stopKDSTick();
                }
                $1d9fcaa0a6035698$var$_syncRevenueFromOtherTerminal();
                $1d9fcaa0a6035698$var$_requestActivityRefresh();
                break;
            }
        case (0, $boau7.MSG).SALE_RECORDED:
            // The queue + activity feed already update via KDS_QUEUE_SYNC; this is
            // for revenue, which nothing else refreshed (2026-10-15).
            $1d9fcaa0a6035698$var$_syncRevenueFromOtherTerminal();
            break;
        case (0, $boau7.MSG).KDS_ORDER_READY:
            {
                // A sibling screen marked this order ready for pickup - or reverted it
                // back to Preparing (readyAt: null) - and already persisted it; just
                // mirror the status locally.
                const order = $1d9fcaa0a6035698$var$modelState.orderQueue.find((o)=>o.id === data.id);
                if (order) {
                    order.readyAt = data.readyAt ?? null;
                    (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1d9fcaa0a6035698$var$modelState.orderQueue);
                }
                break;
            }
        case (0, $boau7.MSG).KDS_QUEUE_SYNC:
            // Senders never include practice orders (_queueForBroadcast), so keep
            // this terminal's own: a sale on another terminal mid-tutorial must not
            // pull the practice order out from under the Ready / Done steps.
            $1e7ab04ca7920cff$export$ca000e230c0caa3e.orderQueue = [
                ...data.queue,
                ...$1e7ab04ca7920cff$export$ca000e230c0caa3e.orderQueue.filter((o)=>o.practice)
            ];
            (0, $f3651885b15417e3$export$2e2bcd8739ae039).renderQueue($1e7ab04ca7920cff$export$ca000e230c0caa3e.orderQueue);
            if ($1e7ab04ca7920cff$export$ca000e230c0caa3e.orderQueue.length === 0) $1d9fcaa0a6035698$var$_stopKDSTick();
            else $1d9fcaa0a6035698$var$_ensureKDSTick();
            $1d9fcaa0a6035698$var$_requestActivityRefresh(); // a sale on another terminal is a feed event
            break;
        case (0, $boau7.MSG).CFD_REQUEST_SYNC:
            (0, $boau7.default).postMessage({
                type: (0, $boau7.MSG).CFD_CART_UPDATE,
                terminalNumber: $1d9fcaa0a6035698$var$_terminalNumber(),
                cart: $1d9fcaa0a6035698$var$modelState.cart,
                total: $1d9fcaa0a6035698$var$modelState.cart.reduce((s, i)=>s + i.totalPrice, 0)
            });
            $1d9fcaa0a6035698$var$_sendTipRequest(); // a display opened mid-prompt gets the tip screen too
            break;
        case (0, $boau7.MSG).CFD_TIP_SELECTED:
            if (String(data.terminalNumber) !== String($1d9fcaa0a6035698$var$_terminalNumber())) break;
            $1d9fcaa0a6035698$var$_onCustomerTipSelected(data);
            break;
        case (0, $boau7.MSG).SHIFT_SYNC:
            // A time-clock device reported a clock in/out or break change - refresh the
            // on-shift bubble now rather than waiting for the next 60s poll.
            $1d9fcaa0a6035698$var$_refreshOnShift();
            $1d9fcaa0a6035698$var$_requestActivityRefresh();
            break;
        case (0, $boau7.MSG).TABLES_SYNC:
            // Another terminal seated, ordered, paid or edited tables: refetch so
            // the floor and the checkout picker stay current.
            if (!$1d9fcaa0a6035698$var$_tablesOn()) break;
            $1d9fcaa0a6035698$var$_loadTablesAll().then(()=>{
                $1d9fcaa0a6035698$var$_renderTables();
                $1d9fcaa0a6035698$var$_renderHomeCards();
                $1d9fcaa0a6035698$var$_checkTabPayStillOpen();
            }).catch(()=>{});
            break;
        case (0, $boau7.MSG).INVENTORY_SYNC:
            // Another terminal changed stock (sale, void, restock, link edit). Refetch
            // and patch in place - order-screen badges and the panel, no re-renders
            // that would blink. Skipped during a practice tour (it would overwrite the
            // practice data); _endPractice reloads everything when the tour ends.
            if ($1d9fcaa0a6035698$var$_practice) break;
            $1e7ab04ca7920cff$export$45aba0c57314d190().then(()=>{
                (0, $472fec5536166250$export$2e2bcd8739ae039).updateStockBadges?.($1e7ab04ca7920cff$export$916349a6610ebe78());
                $1d9fcaa0a6035698$var$_renderHomeCards(); // Low stock card
                if ((0, $b0886db79b2df847$export$2e2bcd8739ae039).isOpen()) Promise.all([
                    $1e7ab04ca7920cff$export$2e183382b4951272($1d9fcaa0a6035698$var$_inventoryHistoryFilter).catch(()=>[]),
                    $1e7ab04ca7920cff$export$9299725340e97fc6().catch(()=>[]),
                    $1e7ab04ca7920cff$export$4faf3f9b9ffc9853().catch(()=>[])
                ]).then(()=>(0, $b0886db79b2df847$export$2e2bcd8739ae039).refreshIfOpen($1d9fcaa0a6035698$var$_inventorySnapshot()));
                $1d9fcaa0a6035698$var$_requestActivityRefresh(); // after the refetch so low-stock rows see fresh quantities
                $1d9fcaa0a6035698$var$_refreshNotifications(); // another terminal may have drafted/approved a PO
            }).catch(()=>{});
            break;
    }
};
$1d9fcaa0a6035698$var$initAuth();


//# sourceMappingURL=repo.edee3f9c.js.map
